import { type OverrideTypes } from '@omnea-app/packages/universal/hasura/schema-overrides'
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  _uuid: { input: string; output: string; }
  address: { input: OverrideTypes["Address"]; output: OverrideTypes["Address"]; }
  agreementTermType: { input: OverrideTypes["AgreementTermType"]; output: OverrideTypes["AgreementTermType"]; }
  availableDateFormat: { input: OverrideTypes["AvailableDateFormat"]; output: OverrideTypes["AvailableDateFormat"]; }
  availableLocale: { input: OverrideTypes["AvailableLocale"]; output: OverrideTypes["AvailableLocale"]; }
  budgetStatus: { input: OverrideTypes["BudgetStatus"]; output: OverrideTypes["BudgetStatus"]; }
  currencyCode: { input: OverrideTypes["CurrencyCode"]; output: OverrideTypes["CurrencyCode"]; }
  customFieldsCoreDataExternalSourceType: { input: OverrideTypes["CustomFieldCoreDataSourceType"]; output: OverrideTypes["CustomFieldCoreDataSourceType"]; }
  customFieldsEntityType: { input: OverrideTypes["CustomFieldsEntityType"]; output: OverrideTypes["CustomFieldsEntityType"]; }
  customFieldsType: { input: OverrideTypes["CustomFieldsType"]; output: OverrideTypes["CustomFieldsType"]; }
  date: { input: any; output: any; }
  filterModel: { input: OverrideTypes["FilterModel"]; output: OverrideTypes["FilterModel"]; }
  float8: { input: number; output: number; }
  formConfig: { input: OverrideTypes["FormConfig"]; output: OverrideTypes["FormConfig"]; }
  globalIntegration: { input: OverrideTypes["GlobalIntegration"]; output: OverrideTypes["GlobalIntegration"]; }
  integration: { input: OverrideTypes["Integration"]; output: OverrideTypes["Integration"]; }
  internalContactsRole: { input: OverrideTypes["InternalContactRole"]; output: OverrideTypes["InternalContactRole"]; }
  interval: { input: string; output: string; }
  jsonb: { input: any; output: any; }
  kebabCoreDataType: { input: OverrideTypes["KebabCoreDataType"]; output: OverrideTypes["KebabCoreDataType"]; }
  kebabDependencyType: { input: OverrideTypes["KebabDependencyType"]; output: OverrideTypes["KebabDependencyType"]; }
  kebabSyncStatusType: { input: OverrideTypes["KebabSyncStatusType"]; output: OverrideTypes["KebabSyncStatusType"]; }
  lquery: { input: string; output: string; }
  ltree: { input: string; output: string; }
  ltxtquery: { input: string; output: string; }
  numeric: { input: number | string; output: number; }
  organisationFxRateCode: { input: OverrideTypes["CurrencyCode"]; output: OverrideTypes["CurrencyCode"]; }
  requestDocumentSource: { input: OverrideTypes["RequestDocumentSource"]; output: OverrideTypes["RequestDocumentSource"]; }
  requestFormSubmissionResponse: { input: OverrideTypes["FormResponsePayload"]; output: OverrideTypes["FormResponsePayload"]; }
  requestModel: { input: OverrideTypes["RequestModel"]; output: OverrideTypes["RequestModel"]; }
  requestStepGraphNode: { input: OverrideTypes["RequestStepGraphNode"]; output: OverrideTypes["RequestStepGraphNode"]; }
  riskScoreMethodology: { input: OverrideTypes["RiskScoreMethodology"]; output: OverrideTypes["RiskScoreMethodology"]; }
  submissionSource: { input: OverrideTypes["SubmissionSource"]; output: OverrideTypes["SubmissionSource"]; }
  timestamptz: { input: string; output: string; }
  uploadedFileItem: { input: OverrideTypes["UploadedFileItem"]; output: OverrideTypes["UploadedFileItem"]; }
  uuid: { input: string; output: string; }
  vector: { input: string; output: string; }
  workflowCanvasModel: { input: OverrideTypes["WorkflowCanvasModel"]; output: OverrideTypes["WorkflowCanvasModel"]; }
  workflowConditionGroupsCondition: { input: OverrideTypes["WorkflowConditionGroupCondition"]; output: OverrideTypes["WorkflowConditionGroupCondition"]; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringArrayComparisonExp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "addresses" */
export type Addresses = {
  __typename?: 'addresses';
  addressLine1: Maybe<Scalars['String']['output']>;
  addressLine2: Maybe<Scalars['String']['output']>;
  archivedBy: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  bank_details: Array<BankDetails>;
  /** An aggregate relationship */
  bank_details_aggregate: BankDetailsAggregate;
  city: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  country: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['uuid']['output'];
  postalCode: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "addresses" */
export type AddressesBankDetailsArgs = {
  distinct_on: InputMaybe<Array<BankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BankDetailsOrderBy>>;
  where: InputMaybe<BankDetailsBoolExp>;
};


/** columns and relationships of "addresses" */
export type AddressesBankDetailsAggregateArgs = {
  distinct_on: InputMaybe<Array<BankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BankDetailsOrderBy>>;
  where: InputMaybe<BankDetailsBoolExp>;
};

/** aggregated selection of "addresses" */
export type AddressesAggregate = {
  __typename?: 'addresses_aggregate';
  aggregate: Maybe<AddressesAggregateFields>;
  nodes: Array<Addresses>;
};

/** aggregate fields of "addresses" */
export type AddressesAggregateFields = {
  __typename?: 'addresses_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<AddressesMaxFields>;
  min: Maybe<AddressesMinFields>;
};


/** aggregate fields of "addresses" */
export type AddressesAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<AddressesSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "addresses". All fields are combined with a logical 'AND'. */
export type AddressesBoolExp = {
  _and?: InputMaybe<Array<AddressesBoolExp>>;
  _not?: InputMaybe<AddressesBoolExp>;
  _or?: InputMaybe<Array<AddressesBoolExp>>;
  addressLine1?: InputMaybe<StringComparisonExp>;
  addressLine2?: InputMaybe<StringComparisonExp>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  bank_details?: InputMaybe<BankDetailsBoolExp>;
  bank_details_aggregate?: InputMaybe<BankDetailsAggregateBoolExp>;
  city?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  county?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  postalCode?: InputMaybe<StringComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  state?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "addresses" */
export enum AddressesConstraint {
  /** unique or primary key constraint on columns "id" */
  ADDRESSES_PKEY = 'addresses_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  ADDRESSES_REMOTE_ID_ORGANISATION_ID_KEY = 'addresses_remote_id_organisation_id_key'
}

/** input type for inserting data into table "addresses" */
export type AddressesInsertInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  bank_details?: InputMaybe<BankDetailsArrRelInsertInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AddressesMaxFields = {
  __typename?: 'addresses_max_fields';
  addressLine1: Maybe<Scalars['String']['output']>;
  addressLine2: Maybe<Scalars['String']['output']>;
  archivedBy: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  country: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type AddressesMinFields = {
  __typename?: 'addresses_min_fields';
  addressLine1: Maybe<Scalars['String']['output']>;
  addressLine2: Maybe<Scalars['String']['output']>;
  archivedBy: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  country: Maybe<Scalars['String']['output']>;
  county: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "addresses" */
export type AddressesMutationResponse = {
  __typename?: 'addresses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Addresses>;
};

/** input type for inserting object relation for remote table "addresses" */
export type AddressesObjRelInsertInput = {
  data: AddressesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AddressesOnConflict>;
};

/** on_conflict condition type for table "addresses" */
export type AddressesOnConflict = {
  constraint: AddressesConstraint;
  update_columns: Array<AddressesUpdateColumn>;
  where?: InputMaybe<AddressesBoolExp>;
};

/** Ordering options when selecting data from "addresses". */
export type AddressesOrderBy = {
  addressLine1?: InputMaybe<OrderBy>;
  addressLine2?: InputMaybe<OrderBy>;
  archivedBy?: InputMaybe<OrderBy>;
  bank_details_aggregate?: InputMaybe<BankDetailsAggregateOrderBy>;
  city?: InputMaybe<OrderBy>;
  coreData?: InputMaybe<CoreDataOrderBy>;
  coreDataId?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  county?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  postalCode?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: addresses */
export type AddressesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "addresses" */
export enum AddressesSelectColumn {
  /** column name */
  ADDRESSLINE1 = 'addressLine1',
  /** column name */
  ADDRESSLINE2 = 'addressLine2',
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CITY = 'city',
  /** column name */
  COREDATAID = 'coreDataId',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  COUNTY = 'county',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  POSTALCODE = 'postalCode',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  STATE = 'state',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "addresses" */
export type AddressesSetInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "addresses" */
export type AddressesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AddressesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AddressesStreamCursorValueInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  coreDataId?: InputMaybe<Scalars['uuid']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "addresses" */
export enum AddressesUpdateColumn {
  /** column name */
  ADDRESSLINE1 = 'addressLine1',
  /** column name */
  ADDRESSLINE2 = 'addressLine2',
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CITY = 'city',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  COUNTY = 'county',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  POSTALCODE = 'postalCode',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  STATE = 'state'
}

export type AddressesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AddressesSetInput>;
  /** filter the rows which have to be updated */
  where: AddressesBoolExp;
};

/** columns and relationships of "agreement_additional_owners" */
export type AgreementAdditionalOwners = {
  __typename?: 'agreement_additional_owners';
  /** An object relationship */
  agreement: Agreements;
  agreementId: Scalars['uuid']['output'];
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "agreement_additional_owners" */
export type AgreementAdditionalOwnersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AgreementAdditionalOwnersMaxOrderBy>;
  min?: InputMaybe<AgreementAdditionalOwnersMinOrderBy>;
};

/** input type for inserting array relation for remote table "agreement_additional_owners" */
export type AgreementAdditionalOwnersArrRelInsertInput = {
  data: Array<AgreementAdditionalOwnersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementAdditionalOwnersOnConflict>;
};

/** Boolean expression to filter rows from the table "agreement_additional_owners". All fields are combined with a logical 'AND'. */
export type AgreementAdditionalOwnersBoolExp = {
  _and?: InputMaybe<Array<AgreementAdditionalOwnersBoolExp>>;
  _not?: InputMaybe<AgreementAdditionalOwnersBoolExp>;
  _or?: InputMaybe<Array<AgreementAdditionalOwnersBoolExp>>;
  agreement?: InputMaybe<AgreementsBoolExp>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "agreement_additional_owners" */
export enum AgreementAdditionalOwnersConstraint {
  /** unique or primary key constraint on columns "id" */
  AGREEMENT_ADDITIONAL_OWNERS_PKEY = 'agreement_additional_owners_pkey',
  /** unique or primary key constraint on columns "user_id", "agreement_id" */
  AGREEMENT_ID_USER_ID_KEY = 'agreement_id_user_id_key'
}

/** input type for inserting data into table "agreement_additional_owners" */
export type AgreementAdditionalOwnersInsertInput = {
  agreement?: InputMaybe<AgreementsObjRelInsertInput>;
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "agreement_additional_owners" */
export type AgreementAdditionalOwnersMaxOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "agreement_additional_owners" */
export type AgreementAdditionalOwnersMinOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "agreement_additional_owners" */
export type AgreementAdditionalOwnersMutationResponse = {
  __typename?: 'agreement_additional_owners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AgreementAdditionalOwners>;
};

/** on_conflict condition type for table "agreement_additional_owners" */
export type AgreementAdditionalOwnersOnConflict = {
  constraint: AgreementAdditionalOwnersConstraint;
  update_columns: Array<AgreementAdditionalOwnersUpdateColumn>;
  where?: InputMaybe<AgreementAdditionalOwnersBoolExp>;
};

/** Ordering options when selecting data from "agreement_additional_owners". */
export type AgreementAdditionalOwnersOrderBy = {
  agreement?: InputMaybe<AgreementsOrderBy>;
  agreementId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: agreement_additional_owners */
export type AgreementAdditionalOwnersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "agreement_additional_owners" */
export enum AgreementAdditionalOwnersSelectColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "agreement_additional_owners" */
export type AgreementAdditionalOwnersSetInput = {
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "agreement_additional_owners" */
export enum AgreementAdditionalOwnersUpdateColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

export type AgreementAdditionalOwnersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AgreementAdditionalOwnersSetInput>;
  /** filter the rows which have to be updated */
  where: AgreementAdditionalOwnersBoolExp;
};

/** Pivot table connecting agreements and documents */
export type AgreementDocuments = {
  __typename?: 'agreement_documents';
  /** An object relationship */
  agreement: Agreements;
  agreementId: Scalars['uuid']['output'];
  agreementTermId: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  document: Documents;
  documentId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "agreement_documents" */
export type AgreementDocumentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AgreementDocumentsMaxOrderBy>;
  min?: InputMaybe<AgreementDocumentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "agreement_documents" */
export type AgreementDocumentsArrRelInsertInput = {
  data: Array<AgreementDocumentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementDocumentsOnConflict>;
};

/** Boolean expression to filter rows from the table "agreement_documents". All fields are combined with a logical 'AND'. */
export type AgreementDocumentsBoolExp = {
  _and?: InputMaybe<Array<AgreementDocumentsBoolExp>>;
  _not?: InputMaybe<AgreementDocumentsBoolExp>;
  _or?: InputMaybe<Array<AgreementDocumentsBoolExp>>;
  agreement?: InputMaybe<AgreementsBoolExp>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  agreementTermId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  document?: InputMaybe<DocumentsBoolExp>;
  documentId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "agreement_documents" */
export enum AgreementDocumentsConstraint {
  /** unique or primary key constraint on columns "agreement_id", "document_id", "agreement_term_id" */
  AGREEMENT_DOCUMENTS_DOCUMENT_ID_AGREEMENT_ID_AGREEMENT_TERM_KEY = 'agreement_documents_document_id_agreement_id_agreement_term_key',
  /** unique or primary key constraint on columns "id" */
  AGREEMENT_DOCUMENTS_PKEY = 'agreement_documents_pkey'
}

/** input type for inserting data into table "agreement_documents" */
export type AgreementDocumentsInsertInput = {
  agreement?: InputMaybe<AgreementsObjRelInsertInput>;
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  agreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  document?: InputMaybe<DocumentsObjRelInsertInput>;
  documentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "agreement_documents" */
export type AgreementDocumentsMaxOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  agreementTermId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  documentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "agreement_documents" */
export type AgreementDocumentsMinOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  agreementTermId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  documentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "agreement_documents" */
export type AgreementDocumentsMutationResponse = {
  __typename?: 'agreement_documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AgreementDocuments>;
};

/** on_conflict condition type for table "agreement_documents" */
export type AgreementDocumentsOnConflict = {
  constraint: AgreementDocumentsConstraint;
  update_columns: Array<AgreementDocumentsUpdateColumn>;
  where?: InputMaybe<AgreementDocumentsBoolExp>;
};

/** Ordering options when selecting data from "agreement_documents". */
export type AgreementDocumentsOrderBy = {
  agreement?: InputMaybe<AgreementsOrderBy>;
  agreementId?: InputMaybe<OrderBy>;
  agreementTermId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  document?: InputMaybe<DocumentsOrderBy>;
  documentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: agreement_documents */
export type AgreementDocumentsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "agreement_documents" */
export enum AgreementDocumentsSelectColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  AGREEMENTTERMID = 'agreementTermId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DOCUMENTID = 'documentId',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "agreement_documents" */
export type AgreementDocumentsSetInput = {
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  agreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  documentId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "agreement_documents" */
export type AgreementDocumentsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgreementDocumentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgreementDocumentsStreamCursorValueInput = {
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  agreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  documentId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "agreement_documents" */
export enum AgreementDocumentsUpdateColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  AGREEMENTTERMID = 'agreementTermId',
  /** column name */
  DOCUMENTID = 'documentId'
}

export type AgreementDocumentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AgreementDocumentsSetInput>;
  /** filter the rows which have to be updated */
  where: AgreementDocumentsBoolExp;
};

/** Tags for Agreements */
export type AgreementTags = {
  __typename?: 'agreement_tags';
  /** An object relationship */
  agreement: Agreements;
  agreementId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  tag: Tags;
  tagId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "agreement_tags" */
export type AgreementTagsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AgreementTagsMaxOrderBy>;
  min?: InputMaybe<AgreementTagsMinOrderBy>;
};

/** input type for inserting array relation for remote table "agreement_tags" */
export type AgreementTagsArrRelInsertInput = {
  data: Array<AgreementTagsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementTagsOnConflict>;
};

/** Boolean expression to filter rows from the table "agreement_tags". All fields are combined with a logical 'AND'. */
export type AgreementTagsBoolExp = {
  _and?: InputMaybe<Array<AgreementTagsBoolExp>>;
  _not?: InputMaybe<AgreementTagsBoolExp>;
  _or?: InputMaybe<Array<AgreementTagsBoolExp>>;
  agreement?: InputMaybe<AgreementsBoolExp>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  tag?: InputMaybe<TagsBoolExp>;
  tagId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "agreement_tags" */
export enum AgreementTagsConstraint {
  /** unique or primary key constraint on columns "agreement_id", "tag_id" */
  AGREEMENT_TAGS_AGREEMENT_ID_TAG_ID_KEY = 'agreement_tags_agreement_id_tag_id_key',
  /** unique or primary key constraint on columns "id" */
  AGREEMENT_TAGS_PKEY = 'agreement_tags_pkey'
}

/** input type for inserting data into table "agreement_tags" */
export type AgreementTagsInsertInput = {
  agreement?: InputMaybe<AgreementsObjRelInsertInput>;
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  tag?: InputMaybe<TagsObjRelInsertInput>;
  tagId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "agreement_tags" */
export type AgreementTagsMaxOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "agreement_tags" */
export type AgreementTagsMinOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "agreement_tags" */
export type AgreementTagsMutationResponse = {
  __typename?: 'agreement_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AgreementTags>;
};

/** on_conflict condition type for table "agreement_tags" */
export type AgreementTagsOnConflict = {
  constraint: AgreementTagsConstraint;
  update_columns: Array<AgreementTagsUpdateColumn>;
  where?: InputMaybe<AgreementTagsBoolExp>;
};

/** Ordering options when selecting data from "agreement_tags". */
export type AgreementTagsOrderBy = {
  agreement?: InputMaybe<AgreementsOrderBy>;
  agreementId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  tag?: InputMaybe<TagsOrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: agreement_tags */
export type AgreementTagsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "agreement_tags" */
export enum AgreementTagsSelectColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  TAGID = 'tagId'
}

/** input type for updating data in table "agreement_tags" */
export type AgreementTagsSetInput = {
  tagId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "agreement_tags" */
export type AgreementTagsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgreementTagsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgreementTagsStreamCursorValueInput = {
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  tagId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "agreement_tags" */
export enum AgreementTagsUpdateColumn {
  /** column name */
  TAGID = 'tagId'
}

export type AgreementTagsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AgreementTagsSetInput>;
  /** filter the rows which have to be updated */
  where: AgreementTagsBoolExp;
};

/** Link table between agreement terms and organisation products */
export type AgreementTermProducts = {
  __typename?: 'agreement_term_products';
  agreementTermId: Scalars['uuid']['output'];
  /** An object relationship */
  agreement_term: AgreementTerms;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  organisationProductId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_products_and_service: OrganisationProductsAndServices;
};

/** order by aggregate values of table "agreement_term_products" */
export type AgreementTermProductsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AgreementTermProductsMaxOrderBy>;
  min?: InputMaybe<AgreementTermProductsMinOrderBy>;
};

/** input type for inserting array relation for remote table "agreement_term_products" */
export type AgreementTermProductsArrRelInsertInput = {
  data: Array<AgreementTermProductsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementTermProductsOnConflict>;
};

/** Boolean expression to filter rows from the table "agreement_term_products". All fields are combined with a logical 'AND'. */
export type AgreementTermProductsBoolExp = {
  _and?: InputMaybe<Array<AgreementTermProductsBoolExp>>;
  _not?: InputMaybe<AgreementTermProductsBoolExp>;
  _or?: InputMaybe<Array<AgreementTermProductsBoolExp>>;
  agreementTermId?: InputMaybe<UuidComparisonExp>;
  agreement_term?: InputMaybe<AgreementTermsBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationProductId?: InputMaybe<UuidComparisonExp>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};

/** unique or primary key constraints on table "agreement_term_products" */
export enum AgreementTermProductsConstraint {
  /** unique or primary key constraint on columns "id" */
  AGREEMENT_TERM_PRODUCTS_PKEY = 'agreement_term_products_pkey',
  /** unique or primary key constraint on columns "deleted_at", "organisation_product_id", "agreement_term_id" */
  UNIQUE_PER_TERM_PRODUCT_DELETED_AT = 'unique_per_term_product_deleted_at'
}

/** input type for inserting data into table "agreement_term_products" */
export type AgreementTermProductsInsertInput = {
  agreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  agreement_term?: InputMaybe<AgreementTermsObjRelInsertInput>;
  organisationProductId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
};

/** order by max() on columns of table "agreement_term_products" */
export type AgreementTermProductsMaxOrderBy = {
  agreementTermId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "agreement_term_products" */
export type AgreementTermProductsMinOrderBy = {
  agreementTermId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "agreement_term_products" */
export type AgreementTermProductsMutationResponse = {
  __typename?: 'agreement_term_products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AgreementTermProducts>;
};

/** on_conflict condition type for table "agreement_term_products" */
export type AgreementTermProductsOnConflict = {
  constraint: AgreementTermProductsConstraint;
  update_columns: Array<AgreementTermProductsUpdateColumn>;
  where?: InputMaybe<AgreementTermProductsBoolExp>;
};

/** Ordering options when selecting data from "agreement_term_products". */
export type AgreementTermProductsOrderBy = {
  agreementTermId?: InputMaybe<OrderBy>;
  agreement_term?: InputMaybe<AgreementTermsOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesOrderBy>;
};

/** primary key columns input for table: agreement_term_products */
export type AgreementTermProductsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "agreement_term_products" */
export enum AgreementTermProductsSelectColumn {
  /** column name */
  AGREEMENTTERMID = 'agreementTermId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId'
}

/** input type for updating data in table "agreement_term_products" */
export type AgreementTermProductsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "agreement_term_products" */
export type AgreementTermProductsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgreementTermProductsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgreementTermProductsStreamCursorValueInput = {
  agreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  organisationProductId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "agreement_term_products" */
export enum AgreementTermProductsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt'
}

export type AgreementTermProductsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AgreementTermProductsSetInput>;
  /** filter the rows which have to be updated */
  where: AgreementTermProductsBoolExp;
};

/** columns and relationships of "agreement_term_revisions" */
export type AgreementTermRevisions = {
  __typename?: 'agreement_term_revisions';
  /** An object relationship */
  agreementTerm: AgreementTerms;
  agreementTermId: Scalars['uuid']['output'];
  config: Maybe<Scalars['formConfig']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  requestFormSubmission: Maybe<RequestFormSubmissions>;
  requestFormSubmissionId: Maybe<Scalars['uuid']['output']>;
  response: Maybe<Scalars['requestFormSubmissionResponse']['output']>;
  submissionSource: Maybe<Scalars['submissionSource']['output']>;
  submittedBy: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Maybe<Users>;
};

/** order by aggregate values of table "agreement_term_revisions" */
export type AgreementTermRevisionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AgreementTermRevisionsMaxOrderBy>;
  min?: InputMaybe<AgreementTermRevisionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "agreement_term_revisions" */
export type AgreementTermRevisionsArrRelInsertInput = {
  data: Array<AgreementTermRevisionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementTermRevisionsOnConflict>;
};

/** Boolean expression to filter rows from the table "agreement_term_revisions". All fields are combined with a logical 'AND'. */
export type AgreementTermRevisionsBoolExp = {
  _and?: InputMaybe<Array<AgreementTermRevisionsBoolExp>>;
  _not?: InputMaybe<AgreementTermRevisionsBoolExp>;
  _or?: InputMaybe<Array<AgreementTermRevisionsBoolExp>>;
  agreementTerm?: InputMaybe<AgreementTermsBoolExp>;
  agreementTermId?: InputMaybe<UuidComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestFormSubmission?: InputMaybe<RequestFormSubmissionsBoolExp>;
  requestFormSubmissionId?: InputMaybe<UuidComparisonExp>;
  response?: InputMaybe<JsonbComparisonExp>;
  submissionSource?: InputMaybe<StringComparisonExp>;
  submittedBy?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "agreement_term_revisions" */
export enum AgreementTermRevisionsConstraint {
  /** unique or primary key constraint on columns "id" */
  AGREEMENT_TERM_REVISIONS_PKEY = 'agreement_term_revisions_pkey'
}

/** input type for inserting data into table "agreement_term_revisions" */
export type AgreementTermRevisionsInsertInput = {
  agreementTerm?: InputMaybe<AgreementTermsObjRelInsertInput>;
  agreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  config?: InputMaybe<Scalars['jsonb']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestFormSubmission?: InputMaybe<RequestFormSubmissionsObjRelInsertInput>;
  requestFormSubmissionId?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
  submissionSource?: InputMaybe<Scalars['String']['input']>;
  submittedBy?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** order by max() on columns of table "agreement_term_revisions" */
export type AgreementTermRevisionsMaxOrderBy = {
  agreementTermId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestFormSubmissionId?: InputMaybe<OrderBy>;
  submissionSource?: InputMaybe<OrderBy>;
  submittedBy?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "agreement_term_revisions" */
export type AgreementTermRevisionsMinOrderBy = {
  agreementTermId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestFormSubmissionId?: InputMaybe<OrderBy>;
  submissionSource?: InputMaybe<OrderBy>;
  submittedBy?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "agreement_term_revisions" */
export type AgreementTermRevisionsMutationResponse = {
  __typename?: 'agreement_term_revisions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AgreementTermRevisions>;
};

/** on_conflict condition type for table "agreement_term_revisions" */
export type AgreementTermRevisionsOnConflict = {
  constraint: AgreementTermRevisionsConstraint;
  update_columns: Array<AgreementTermRevisionsUpdateColumn>;
  where?: InputMaybe<AgreementTermRevisionsBoolExp>;
};

/** Ordering options when selecting data from "agreement_term_revisions". */
export type AgreementTermRevisionsOrderBy = {
  agreementTerm?: InputMaybe<AgreementTermsOrderBy>;
  agreementTermId?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestFormSubmission?: InputMaybe<RequestFormSubmissionsOrderBy>;
  requestFormSubmissionId?: InputMaybe<OrderBy>;
  response?: InputMaybe<OrderBy>;
  submissionSource?: InputMaybe<OrderBy>;
  submittedBy?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: agreement_term_revisions */
export type AgreementTermRevisionsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "agreement_term_revisions" */
export enum AgreementTermRevisionsSelectColumn {
  /** column name */
  AGREEMENTTERMID = 'agreementTermId',
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTFORMSUBMISSIONID = 'requestFormSubmissionId',
  /** column name */
  RESPONSE = 'response',
  /** column name */
  SUBMISSIONSOURCE = 'submissionSource',
  /** column name */
  SUBMITTEDBY = 'submittedBy',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "agreement_term_revisions" */
export type AgreementTermRevisionsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "agreement_term_revisions" */
export type AgreementTermRevisionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgreementTermRevisionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgreementTermRevisionsStreamCursorValueInput = {
  agreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  requestFormSubmissionId?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
  submissionSource?: InputMaybe<Scalars['String']['input']>;
  submittedBy?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "agreement_term_revisions" */
export enum AgreementTermRevisionsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt'
}

export type AgreementTermRevisionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AgreementTermRevisionsSetInput>;
  /** filter the rows which have to be updated */
  where: AgreementTermRevisionsBoolExp;
};

/** For tracking granular spend lines on agreement terms */
export type AgreementTermSpendItems = {
  __typename?: 'agreement_term_spend_items';
  /** An object relationship */
  agreementTerm: AgreementTerms;
  agreementTermId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  currencyCode: Scalars['currencyCode']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  endDate: Maybe<Scalars['date']['output']>;
  frequency: PaymentIntervalEnum;
  fxRate: Scalars['numeric']['output'];
  fxTime: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  paymentInterval: PaymentInterval;
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  quantity: Scalars['numeric']['output'];
  rate: Scalars['numeric']['output'];
  startDate: Scalars['date']['output'];
  totalAmount: Scalars['numeric']['output'];
  totalAmountInDefaultCurrency: Maybe<Scalars['numeric']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "agreement_term_spend_items" */
export type AgreementTermSpendItemsAggregateOrderBy = {
  avg?: InputMaybe<AgreementTermSpendItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AgreementTermSpendItemsMaxOrderBy>;
  min?: InputMaybe<AgreementTermSpendItemsMinOrderBy>;
  stddev?: InputMaybe<AgreementTermSpendItemsStddevOrderBy>;
  stddev_pop?: InputMaybe<AgreementTermSpendItemsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AgreementTermSpendItemsStddevSampOrderBy>;
  sum?: InputMaybe<AgreementTermSpendItemsSumOrderBy>;
  var_pop?: InputMaybe<AgreementTermSpendItemsVarPopOrderBy>;
  var_samp?: InputMaybe<AgreementTermSpendItemsVarSampOrderBy>;
  variance?: InputMaybe<AgreementTermSpendItemsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "agreement_term_spend_items" */
export type AgreementTermSpendItemsArrRelInsertInput = {
  data: Array<AgreementTermSpendItemsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementTermSpendItemsOnConflict>;
};

/** order by avg() on columns of table "agreement_term_spend_items" */
export type AgreementTermSpendItemsAvgOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "agreement_term_spend_items". All fields are combined with a logical 'AND'. */
export type AgreementTermSpendItemsBoolExp = {
  _and?: InputMaybe<Array<AgreementTermSpendItemsBoolExp>>;
  _not?: InputMaybe<AgreementTermSpendItemsBoolExp>;
  _or?: InputMaybe<Array<AgreementTermSpendItemsBoolExp>>;
  agreementTerm?: InputMaybe<AgreementTermsBoolExp>;
  agreementTermId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currencyCode?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  endDate?: InputMaybe<DateComparisonExp>;
  frequency?: InputMaybe<PaymentIntervalEnumComparisonExp>;
  fxRate?: InputMaybe<NumericComparisonExp>;
  fxTime?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  paymentInterval?: InputMaybe<PaymentIntervalBoolExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentMethodId?: InputMaybe<UuidComparisonExp>;
  quantity?: InputMaybe<NumericComparisonExp>;
  rate?: InputMaybe<NumericComparisonExp>;
  startDate?: InputMaybe<DateComparisonExp>;
  totalAmount?: InputMaybe<NumericComparisonExp>;
  totalAmountInDefaultCurrency?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "agreement_term_spend_items" */
export enum AgreementTermSpendItemsConstraint {
  /** unique or primary key constraint on columns "id" */
  AGREEMENT_TERM_SPEND_ITEMS_PKEY = 'agreement_term_spend_items_pkey'
}

/** input type for incrementing numeric columns in table "agreement_term_spend_items" */
export type AgreementTermSpendItemsIncInput = {
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  totalAmount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "agreement_term_spend_items" */
export type AgreementTermSpendItemsInsertInput = {
  agreementTerm?: InputMaybe<AgreementTermsObjRelInsertInput>;
  agreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  currencyCode: Scalars['currencyCode']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  frequency?: InputMaybe<PaymentIntervalEnum>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  fxTime?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodsObjRelInsertInput>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  totalAmount?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by max() on columns of table "agreement_term_spend_items" */
export type AgreementTermSpendItemsMaxOrderBy = {
  agreementTermId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyCode?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  fxTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "agreement_term_spend_items" */
export type AgreementTermSpendItemsMinOrderBy = {
  agreementTermId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyCode?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  fxTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "agreement_term_spend_items" */
export type AgreementTermSpendItemsMutationResponse = {
  __typename?: 'agreement_term_spend_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AgreementTermSpendItems>;
};

/** on_conflict condition type for table "agreement_term_spend_items" */
export type AgreementTermSpendItemsOnConflict = {
  constraint: AgreementTermSpendItemsConstraint;
  update_columns: Array<AgreementTermSpendItemsUpdateColumn>;
  where?: InputMaybe<AgreementTermSpendItemsBoolExp>;
};

/** Ordering options when selecting data from "agreement_term_spend_items". */
export type AgreementTermSpendItemsOrderBy = {
  agreementTerm?: InputMaybe<AgreementTermsOrderBy>;
  agreementTermId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyCode?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  frequency?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  fxTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  paymentInterval?: InputMaybe<PaymentIntervalOrderBy>;
  paymentMethod?: InputMaybe<PaymentMethodsOrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: agreement_term_spend_items */
export type AgreementTermSpendItemsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "agreement_term_spend_items" */
export enum AgreementTermSpendItemsSelectColumn {
  /** column name */
  AGREEMENTTERMID = 'agreementTermId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CURRENCYCODE = 'currencyCode',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ENDDATE = 'endDate',
  /** column name */
  FREQUENCY = 'frequency',
  /** column name */
  FXRATE = 'fxRate',
  /** column name */
  FXTIME = 'fxTime',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  QUANTITY = 'quantity',
  /** column name */
  RATE = 'rate',
  /** column name */
  STARTDATE = 'startDate',
  /** column name */
  TOTALAMOUNT = 'totalAmount',
  /** column name */
  TOTALAMOUNTINDEFAULTCURRENCY = 'totalAmountInDefaultCurrency',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "agreement_term_spend_items" */
export type AgreementTermSpendItemsSetInput = {
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  frequency?: InputMaybe<PaymentIntervalEnum>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  fxTime?: InputMaybe<Scalars['timestamptz']['input']>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  totalAmount?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by stddev() on columns of table "agreement_term_spend_items" */
export type AgreementTermSpendItemsStddevOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "agreement_term_spend_items" */
export type AgreementTermSpendItemsStddevPopOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "agreement_term_spend_items" */
export type AgreementTermSpendItemsStddevSampOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "agreement_term_spend_items" */
export type AgreementTermSpendItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgreementTermSpendItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgreementTermSpendItemsStreamCursorValueInput = {
  agreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  frequency?: InputMaybe<PaymentIntervalEnum>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  fxTime?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  totalAmount?: InputMaybe<Scalars['numeric']['input']>;
  totalAmountInDefaultCurrency?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "agreement_term_spend_items" */
export type AgreementTermSpendItemsSumOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** update columns of table "agreement_term_spend_items" */
export enum AgreementTermSpendItemsUpdateColumn {
  /** column name */
  CURRENCYCODE = 'currencyCode',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ENDDATE = 'endDate',
  /** column name */
  FREQUENCY = 'frequency',
  /** column name */
  FXRATE = 'fxRate',
  /** column name */
  FXTIME = 'fxTime',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  QUANTITY = 'quantity',
  /** column name */
  RATE = 'rate',
  /** column name */
  STARTDATE = 'startDate',
  /** column name */
  TOTALAMOUNT = 'totalAmount'
}

export type AgreementTermSpendItemsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AgreementTermSpendItemsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AgreementTermSpendItemsSetInput>;
  /** filter the rows which have to be updated */
  where: AgreementTermSpendItemsBoolExp;
};

/** order by var_pop() on columns of table "agreement_term_spend_items" */
export type AgreementTermSpendItemsVarPopOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "agreement_term_spend_items" */
export type AgreementTermSpendItemsVarSampOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "agreement_term_spend_items" */
export type AgreementTermSpendItemsVarianceOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  rate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** columns and relationships of "agreement_terms" */
export type AgreementTerms = {
  __typename?: 'agreement_terms';
  /** An object relationship */
  agreement: Agreements;
  agreementId: Scalars['uuid']['output'];
  /** An array relationship */
  agreement_term_revisions: Array<AgreementTermRevisions>;
  autoRenew: Scalars['Boolean']['output'];
  cancelByDate: Maybe<Scalars['date']['output']>;
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  cancelledAt: Maybe<Scalars['date']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  currencyCode: Maybe<Scalars['currencyCode']['output']>;
  /** An array relationship */
  custom_field_values: Array<CustomFieldValues>;
  /** An aggregate relationship */
  custom_field_values_aggregate: CustomFieldValuesAggregate;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  endDate: Maybe<Scalars['date']['output']>;
  /** An array relationship */
  futureRenewal: Array<Renewals>;
  /** An aggregate relationship */
  futureRenewal_aggregate: RenewalsAggregate;
  fxRate: Maybe<Scalars['numeric']['output']>;
  fxTime: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An array relationship */
  originRenewal: Array<Renewals>;
  /** An aggregate relationship */
  originRenewal_aggregate: RenewalsAggregate;
  /** An object relationship */
  primaryDepartment: Maybe<Departments>;
  primaryDepartmentId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  products: Array<AgreementTermProducts>;
  /** An array relationship */
  spendItems: Array<AgreementTermSpendItems>;
  startDate: Scalars['date']['output'];
  termType: Scalars['agreementTermType']['output'];
  totalAmount: Maybe<Scalars['numeric']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['numeric']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "agreement_terms" */
export type AgreementTermsAgreementTermRevisionsArgs = {
  distinct_on: InputMaybe<Array<AgreementTermRevisionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermRevisionsOrderBy>>;
  where: InputMaybe<AgreementTermRevisionsBoolExp>;
};


/** columns and relationships of "agreement_terms" */
export type AgreementTermsCustomFieldValuesArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** columns and relationships of "agreement_terms" */
export type AgreementTermsCustomFieldValuesAggregateArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** columns and relationships of "agreement_terms" */
export type AgreementTermsFutureRenewalArgs = {
  distinct_on: InputMaybe<Array<RenewalsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalsOrderBy>>;
  where: InputMaybe<RenewalsBoolExp>;
};


/** columns and relationships of "agreement_terms" */
export type AgreementTermsFutureRenewalAggregateArgs = {
  distinct_on: InputMaybe<Array<RenewalsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalsOrderBy>>;
  where: InputMaybe<RenewalsBoolExp>;
};


/** columns and relationships of "agreement_terms" */
export type AgreementTermsOriginRenewalArgs = {
  distinct_on: InputMaybe<Array<RenewalsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalsOrderBy>>;
  where: InputMaybe<RenewalsBoolExp>;
};


/** columns and relationships of "agreement_terms" */
export type AgreementTermsOriginRenewalAggregateArgs = {
  distinct_on: InputMaybe<Array<RenewalsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalsOrderBy>>;
  where: InputMaybe<RenewalsBoolExp>;
};


/** columns and relationships of "agreement_terms" */
export type AgreementTermsProductsArgs = {
  distinct_on: InputMaybe<Array<AgreementTermProductsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermProductsOrderBy>>;
  where: InputMaybe<AgreementTermProductsBoolExp>;
};


/** columns and relationships of "agreement_terms" */
export type AgreementTermsSpendItemsArgs = {
  distinct_on: InputMaybe<Array<AgreementTermSpendItemsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermSpendItemsOrderBy>>;
  where: InputMaybe<AgreementTermSpendItemsBoolExp>;
};

/** aggregated selection of "agreement_terms" */
export type AgreementTermsAggregate = {
  __typename?: 'agreement_terms_aggregate';
  aggregate: Maybe<AgreementTermsAggregateFields>;
  nodes: Array<AgreementTerms>;
};

export type AgreementTermsAggregateBoolExp = {
  bool_and?: InputMaybe<AgreementTermsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AgreementTermsAggregateBoolExpBoolOr>;
  count?: InputMaybe<AgreementTermsAggregateBoolExpCount>;
};

export type AgreementTermsAggregateBoolExpBoolAnd = {
  arguments: AgreementTermsSelectColumnAgreementTermsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AgreementTermsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AgreementTermsAggregateBoolExpBoolOr = {
  arguments: AgreementTermsSelectColumnAgreementTermsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AgreementTermsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AgreementTermsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AgreementTermsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AgreementTermsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "agreement_terms" */
export type AgreementTermsAggregateFields = {
  __typename?: 'agreement_terms_aggregate_fields';
  avg: Maybe<AgreementTermsAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<AgreementTermsMaxFields>;
  min: Maybe<AgreementTermsMinFields>;
  stddev: Maybe<AgreementTermsStddevFields>;
  stddev_pop: Maybe<AgreementTermsStddevPopFields>;
  stddev_samp: Maybe<AgreementTermsStddevSampFields>;
  sum: Maybe<AgreementTermsSumFields>;
  var_pop: Maybe<AgreementTermsVarPopFields>;
  var_samp: Maybe<AgreementTermsVarSampFields>;
  variance: Maybe<AgreementTermsVarianceFields>;
};


/** aggregate fields of "agreement_terms" */
export type AgreementTermsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<AgreementTermsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "agreement_terms" */
export type AgreementTermsAggregateOrderBy = {
  avg?: InputMaybe<AgreementTermsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AgreementTermsMaxOrderBy>;
  min?: InputMaybe<AgreementTermsMinOrderBy>;
  stddev?: InputMaybe<AgreementTermsStddevOrderBy>;
  stddev_pop?: InputMaybe<AgreementTermsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AgreementTermsStddevSampOrderBy>;
  sum?: InputMaybe<AgreementTermsSumOrderBy>;
  var_pop?: InputMaybe<AgreementTermsVarPopOrderBy>;
  var_samp?: InputMaybe<AgreementTermsVarSampOrderBy>;
  variance?: InputMaybe<AgreementTermsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "agreement_terms" */
export type AgreementTermsArrRelInsertInput = {
  data: Array<AgreementTermsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementTermsOnConflict>;
};

/** aggregate avg on columns */
export type AgreementTermsAvgFields = {
  __typename?: 'agreement_terms_avg_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  fxRate: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "agreement_terms" */
export type AgreementTermsAvgOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "agreement_terms". All fields are combined with a logical 'AND'. */
export type AgreementTermsBoolExp = {
  _and?: InputMaybe<Array<AgreementTermsBoolExp>>;
  _not?: InputMaybe<AgreementTermsBoolExp>;
  _or?: InputMaybe<Array<AgreementTermsBoolExp>>;
  agreement?: InputMaybe<AgreementsBoolExp>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  agreement_term_revisions?: InputMaybe<AgreementTermRevisionsBoolExp>;
  autoRenew?: InputMaybe<BooleanComparisonExp>;
  cancelByDate?: InputMaybe<DateComparisonExp>;
  cancellationNoticeDayCount?: InputMaybe<IntComparisonExp>;
  cancelledAt?: InputMaybe<DateComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currencyCode?: InputMaybe<StringComparisonExp>;
  custom_field_values?: InputMaybe<CustomFieldValuesBoolExp>;
  custom_field_values_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  endDate?: InputMaybe<DateComparisonExp>;
  futureRenewal?: InputMaybe<RenewalsBoolExp>;
  futureRenewal_aggregate?: InputMaybe<RenewalsAggregateBoolExp>;
  fxRate?: InputMaybe<NumericComparisonExp>;
  fxTime?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  originRenewal?: InputMaybe<RenewalsBoolExp>;
  originRenewal_aggregate?: InputMaybe<RenewalsAggregateBoolExp>;
  primaryDepartment?: InputMaybe<DepartmentsBoolExp>;
  primaryDepartmentId?: InputMaybe<UuidComparisonExp>;
  products?: InputMaybe<AgreementTermProductsBoolExp>;
  spendItems?: InputMaybe<AgreementTermSpendItemsBoolExp>;
  startDate?: InputMaybe<DateComparisonExp>;
  termType?: InputMaybe<StringComparisonExp>;
  totalAmount?: InputMaybe<NumericComparisonExp>;
  totalAmountInDefaultCurrency?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "agreement_terms" */
export enum AgreementTermsConstraint {
  /** unique or primary key constraint on columns "id" */
  AGREEMENT_TERMS_PKEY = 'agreement_terms_pkey'
}

/** input type for incrementing numeric columns in table "agreement_terms" */
export type AgreementTermsIncInput = {
  cancellationNoticeDayCount?: InputMaybe<Scalars['Int']['input']>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  totalAmount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "agreement_terms" */
export type AgreementTermsInsertInput = {
  agreement?: InputMaybe<AgreementsObjRelInsertInput>;
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  agreement_term_revisions?: InputMaybe<AgreementTermRevisionsArrRelInsertInput>;
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationNoticeDayCount?: InputMaybe<Scalars['Int']['input']>;
  cancelledAt?: InputMaybe<Scalars['date']['input']>;
  currencyCode?: InputMaybe<Scalars['currencyCode']['input']>;
  custom_field_values?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  futureRenewal?: InputMaybe<RenewalsArrRelInsertInput>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  fxTime?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originRenewal?: InputMaybe<RenewalsArrRelInsertInput>;
  primaryDepartment?: InputMaybe<DepartmentsObjRelInsertInput>;
  primaryDepartmentId?: InputMaybe<Scalars['uuid']['input']>;
  products?: InputMaybe<AgreementTermProductsArrRelInsertInput>;
  spendItems?: InputMaybe<AgreementTermSpendItemsArrRelInsertInput>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  termType: Scalars['agreementTermType']['input'];
  totalAmount?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type AgreementTermsMaxFields = {
  __typename?: 'agreement_terms_max_fields';
  agreementId: Maybe<Scalars['uuid']['output']>;
  cancelByDate: Maybe<Scalars['date']['output']>;
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  cancelledAt: Maybe<Scalars['date']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  currencyCode: Maybe<Scalars['String']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  endDate: Maybe<Scalars['date']['output']>;
  fxRate: Maybe<Scalars['numeric']['output']>;
  fxTime: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  primaryDepartmentId: Maybe<Scalars['uuid']['output']>;
  startDate: Maybe<Scalars['date']['output']>;
  termType: Maybe<Scalars['String']['output']>;
  totalAmount: Maybe<Scalars['numeric']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['numeric']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "agreement_terms" */
export type AgreementTermsMaxOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  cancelByDate?: InputMaybe<OrderBy>;
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  cancelledAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyCode?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  fxTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  primaryDepartmentId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  termType?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AgreementTermsMinFields = {
  __typename?: 'agreement_terms_min_fields';
  agreementId: Maybe<Scalars['uuid']['output']>;
  cancelByDate: Maybe<Scalars['date']['output']>;
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  cancelledAt: Maybe<Scalars['date']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  currencyCode: Maybe<Scalars['String']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  endDate: Maybe<Scalars['date']['output']>;
  fxRate: Maybe<Scalars['numeric']['output']>;
  fxTime: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  primaryDepartmentId: Maybe<Scalars['uuid']['output']>;
  startDate: Maybe<Scalars['date']['output']>;
  termType: Maybe<Scalars['String']['output']>;
  totalAmount: Maybe<Scalars['numeric']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['numeric']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "agreement_terms" */
export type AgreementTermsMinOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  cancelByDate?: InputMaybe<OrderBy>;
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  cancelledAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyCode?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  fxTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  primaryDepartmentId?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  termType?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "agreement_terms" */
export type AgreementTermsMutationResponse = {
  __typename?: 'agreement_terms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AgreementTerms>;
};

/** input type for inserting object relation for remote table "agreement_terms" */
export type AgreementTermsObjRelInsertInput = {
  data: AgreementTermsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementTermsOnConflict>;
};

/** on_conflict condition type for table "agreement_terms" */
export type AgreementTermsOnConflict = {
  constraint: AgreementTermsConstraint;
  update_columns: Array<AgreementTermsUpdateColumn>;
  where?: InputMaybe<AgreementTermsBoolExp>;
};

/** Ordering options when selecting data from "agreement_terms". */
export type AgreementTermsOrderBy = {
  agreement?: InputMaybe<AgreementsOrderBy>;
  agreementId?: InputMaybe<OrderBy>;
  agreement_term_revisions_aggregate?: InputMaybe<AgreementTermRevisionsAggregateOrderBy>;
  autoRenew?: InputMaybe<OrderBy>;
  cancelByDate?: InputMaybe<OrderBy>;
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  cancelledAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyCode?: InputMaybe<OrderBy>;
  custom_field_values_aggregate?: InputMaybe<CustomFieldValuesAggregateOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  futureRenewal_aggregate?: InputMaybe<RenewalsAggregateOrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  fxTime?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  originRenewal_aggregate?: InputMaybe<RenewalsAggregateOrderBy>;
  primaryDepartment?: InputMaybe<DepartmentsOrderBy>;
  primaryDepartmentId?: InputMaybe<OrderBy>;
  products_aggregate?: InputMaybe<AgreementTermProductsAggregateOrderBy>;
  spendItems_aggregate?: InputMaybe<AgreementTermSpendItemsAggregateOrderBy>;
  startDate?: InputMaybe<OrderBy>;
  termType?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: agreement_terms */
export type AgreementTermsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "agreement_terms" */
export enum AgreementTermsSelectColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  AUTORENEW = 'autoRenew',
  /** column name */
  CANCELBYDATE = 'cancelByDate',
  /** column name */
  CANCELLATIONNOTICEDAYCOUNT = 'cancellationNoticeDayCount',
  /** column name */
  CANCELLEDAT = 'cancelledAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CURRENCYCODE = 'currencyCode',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ENDDATE = 'endDate',
  /** column name */
  FXRATE = 'fxRate',
  /** column name */
  FXTIME = 'fxTime',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  PRIMARYDEPARTMENTID = 'primaryDepartmentId',
  /** column name */
  STARTDATE = 'startDate',
  /** column name */
  TERMTYPE = 'termType',
  /** column name */
  TOTALAMOUNT = 'totalAmount',
  /** column name */
  TOTALAMOUNTINDEFAULTCURRENCY = 'totalAmountInDefaultCurrency',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "agreement_terms_aggregate_bool_exp_bool_and_arguments_columns" columns of table "agreement_terms" */
export enum AgreementTermsSelectColumnAgreementTermsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  AUTORENEW = 'autoRenew'
}

/** select "agreement_terms_aggregate_bool_exp_bool_or_arguments_columns" columns of table "agreement_terms" */
export enum AgreementTermsSelectColumnAgreementTermsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  AUTORENEW = 'autoRenew'
}

/** input type for updating data in table "agreement_terms" */
export type AgreementTermsSetInput = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationNoticeDayCount?: InputMaybe<Scalars['Int']['input']>;
  cancelledAt?: InputMaybe<Scalars['date']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  fxTime?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryDepartmentId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  termType?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type AgreementTermsStddevFields = {
  __typename?: 'agreement_terms_stddev_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  fxRate: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "agreement_terms" */
export type AgreementTermsStddevOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AgreementTermsStddevPopFields = {
  __typename?: 'agreement_terms_stddev_pop_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  fxRate: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "agreement_terms" */
export type AgreementTermsStddevPopOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AgreementTermsStddevSampFields = {
  __typename?: 'agreement_terms_stddev_samp_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  fxRate: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "agreement_terms" */
export type AgreementTermsStddevSampOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "agreement_terms" */
export type AgreementTermsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AgreementTermsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AgreementTermsStreamCursorValueInput = {
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  cancelByDate?: InputMaybe<Scalars['date']['input']>;
  cancellationNoticeDayCount?: InputMaybe<Scalars['Int']['input']>;
  cancelledAt?: InputMaybe<Scalars['date']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  fxTime?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  primaryDepartmentId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  termType?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['numeric']['input']>;
  totalAmountInDefaultCurrency?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type AgreementTermsSumFields = {
  __typename?: 'agreement_terms_sum_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  fxRate: Maybe<Scalars['numeric']['output']>;
  totalAmount: Maybe<Scalars['numeric']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "agreement_terms" */
export type AgreementTermsSumOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** update columns of table "agreement_terms" */
export enum AgreementTermsUpdateColumn {
  /** column name */
  AUTORENEW = 'autoRenew',
  /** column name */
  CANCELLATIONNOTICEDAYCOUNT = 'cancellationNoticeDayCount',
  /** column name */
  CANCELLEDAT = 'cancelledAt',
  /** column name */
  CURRENCYCODE = 'currencyCode',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ENDDATE = 'endDate',
  /** column name */
  FXRATE = 'fxRate',
  /** column name */
  FXTIME = 'fxTime',
  /** column name */
  NAME = 'name',
  /** column name */
  PRIMARYDEPARTMENTID = 'primaryDepartmentId',
  /** column name */
  STARTDATE = 'startDate',
  /** column name */
  TERMTYPE = 'termType',
  /** column name */
  TOTALAMOUNT = 'totalAmount'
}

export type AgreementTermsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AgreementTermsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AgreementTermsSetInput>;
  /** filter the rows which have to be updated */
  where: AgreementTermsBoolExp;
};

/** aggregate var_pop on columns */
export type AgreementTermsVarPopFields = {
  __typename?: 'agreement_terms_var_pop_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  fxRate: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "agreement_terms" */
export type AgreementTermsVarPopOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AgreementTermsVarSampFields = {
  __typename?: 'agreement_terms_var_samp_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  fxRate: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "agreement_terms" */
export type AgreementTermsVarSampOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AgreementTermsVarianceFields = {
  __typename?: 'agreement_terms_variance_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  fxRate: Maybe<Scalars['Float']['output']>;
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalAmountInDefaultCurrency: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "agreement_terms" */
export type AgreementTermsVarianceOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  totalAmount?: InputMaybe<OrderBy>;
  totalAmountInDefaultCurrency?: InputMaybe<OrderBy>;
};

/** columns and relationships of "agreements" */
export type Agreements = {
  __typename?: 'agreements';
  /** An array relationship */
  additionalOwners: Array<AgreementAdditionalOwners>;
  /** An array relationship */
  agreement_documents: Array<AgreementDocuments>;
  /** An array relationship */
  agreement_terms: Array<AgreementTerms>;
  /** An aggregate relationship */
  agreement_terms_aggregate: AgreementTermsAggregate;
  /** An array relationship */
  children: Array<Agreements>;
  /** An aggregate relationship */
  children_aggregate: AgreementsAggregate;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** A description of the agreement */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  owner: Maybe<Users>;
  ownerId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  parent: Maybe<Agreements>;
  parentId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  paymentTerm: Maybe<PaymentTerms>;
  paymentTermId: Maybe<Scalars['uuid']['output']>;
  publicId: Scalars['Int']['output'];
  refreshPricesAt: Maybe<Scalars['timestamptz']['output']>;
  /** Any ID or reference from external systems */
  remoteId: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  subsidiary: Maybe<Subsidiaries>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  supplier: OrganisationSuppliers;
  supplierId: Scalars['uuid']['output'];
  /** An array relationship */
  tags: Array<AgreementTags>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "agreements" */
export type AgreementsAdditionalOwnersArgs = {
  distinct_on: InputMaybe<Array<AgreementAdditionalOwnersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementAdditionalOwnersOrderBy>>;
  where: InputMaybe<AgreementAdditionalOwnersBoolExp>;
};


/** columns and relationships of "agreements" */
export type AgreementsAgreementDocumentsArgs = {
  distinct_on: InputMaybe<Array<AgreementDocumentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementDocumentsOrderBy>>;
  where: InputMaybe<AgreementDocumentsBoolExp>;
};


/** columns and relationships of "agreements" */
export type AgreementsAgreementTermsArgs = {
  distinct_on: InputMaybe<Array<AgreementTermsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermsOrderBy>>;
  where: InputMaybe<AgreementTermsBoolExp>;
};


/** columns and relationships of "agreements" */
export type AgreementsAgreementTermsAggregateArgs = {
  distinct_on: InputMaybe<Array<AgreementTermsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermsOrderBy>>;
  where: InputMaybe<AgreementTermsBoolExp>;
};


/** columns and relationships of "agreements" */
export type AgreementsChildrenArgs = {
  distinct_on: InputMaybe<Array<AgreementsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementsOrderBy>>;
  where: InputMaybe<AgreementsBoolExp>;
};


/** columns and relationships of "agreements" */
export type AgreementsChildrenAggregateArgs = {
  distinct_on: InputMaybe<Array<AgreementsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementsOrderBy>>;
  where: InputMaybe<AgreementsBoolExp>;
};


/** columns and relationships of "agreements" */
export type AgreementsTagsArgs = {
  distinct_on: InputMaybe<Array<AgreementTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTagsOrderBy>>;
  where: InputMaybe<AgreementTagsBoolExp>;
};

/** aggregated selection of "agreements" */
export type AgreementsAggregate = {
  __typename?: 'agreements_aggregate';
  aggregate: Maybe<AgreementsAggregateFields>;
  nodes: Array<Agreements>;
};

export type AgreementsAggregateBoolExp = {
  count?: InputMaybe<AgreementsAggregateBoolExpCount>;
};

export type AgreementsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AgreementsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AgreementsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "agreements" */
export type AgreementsAggregateFields = {
  __typename?: 'agreements_aggregate_fields';
  avg: Maybe<AgreementsAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<AgreementsMaxFields>;
  min: Maybe<AgreementsMinFields>;
  stddev: Maybe<AgreementsStddevFields>;
  stddev_pop: Maybe<AgreementsStddevPopFields>;
  stddev_samp: Maybe<AgreementsStddevSampFields>;
  sum: Maybe<AgreementsSumFields>;
  var_pop: Maybe<AgreementsVarPopFields>;
  var_samp: Maybe<AgreementsVarSampFields>;
  variance: Maybe<AgreementsVarianceFields>;
};


/** aggregate fields of "agreements" */
export type AgreementsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<AgreementsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "agreements" */
export type AgreementsAggregateOrderBy = {
  avg?: InputMaybe<AgreementsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AgreementsMaxOrderBy>;
  min?: InputMaybe<AgreementsMinOrderBy>;
  stddev?: InputMaybe<AgreementsStddevOrderBy>;
  stddev_pop?: InputMaybe<AgreementsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<AgreementsStddevSampOrderBy>;
  sum?: InputMaybe<AgreementsSumOrderBy>;
  var_pop?: InputMaybe<AgreementsVarPopOrderBy>;
  var_samp?: InputMaybe<AgreementsVarSampOrderBy>;
  variance?: InputMaybe<AgreementsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "agreements" */
export type AgreementsArrRelInsertInput = {
  data: Array<AgreementsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementsOnConflict>;
};

/** aggregate avg on columns */
export type AgreementsAvgFields = {
  __typename?: 'agreements_avg_fields';
  publicId: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "agreements" */
export type AgreementsAvgOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "agreements". All fields are combined with a logical 'AND'. */
export type AgreementsBoolExp = {
  _and?: InputMaybe<Array<AgreementsBoolExp>>;
  _not?: InputMaybe<AgreementsBoolExp>;
  _or?: InputMaybe<Array<AgreementsBoolExp>>;
  additionalOwners?: InputMaybe<AgreementAdditionalOwnersBoolExp>;
  agreement_documents?: InputMaybe<AgreementDocumentsBoolExp>;
  agreement_terms?: InputMaybe<AgreementTermsBoolExp>;
  agreement_terms_aggregate?: InputMaybe<AgreementTermsAggregateBoolExp>;
  children?: InputMaybe<AgreementsBoolExp>;
  children_aggregate?: InputMaybe<AgreementsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  owner?: InputMaybe<UsersBoolExp>;
  ownerId?: InputMaybe<UuidComparisonExp>;
  parent?: InputMaybe<AgreementsBoolExp>;
  parentId?: InputMaybe<UuidComparisonExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentMethodId?: InputMaybe<UuidComparisonExp>;
  paymentTerm?: InputMaybe<PaymentTermsBoolExp>;
  paymentTermId?: InputMaybe<UuidComparisonExp>;
  publicId?: InputMaybe<IntComparisonExp>;
  refreshPricesAt?: InputMaybe<TimestamptzComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  subsidiaryId?: InputMaybe<UuidComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  tags?: InputMaybe<AgreementTagsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "agreements" */
export enum AgreementsConstraint {
  /** unique or primary key constraint on columns "id" */
  AGREEMENTS_PKEY = 'agreements_pkey',
  /** unique or primary key constraint on columns "organisation_id", "public_id" */
  AGREEMENTS_PUBLIC_ID_ORGANISATION_ID_KEY = 'agreements_public_id_organisation_id_key',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  AGREEMENTS_REMOTE_ID_ORGANISATION_ID_ACTIVE_UNIQUE = 'agreements_remote_id_organisation_id_active_unique'
}

/** input type for inserting data into table "agreements" */
export type AgreementsInsertInput = {
  additionalOwners?: InputMaybe<AgreementAdditionalOwnersArrRelInsertInput>;
  agreement_documents?: InputMaybe<AgreementDocumentsArrRelInsertInput>;
  agreement_terms?: InputMaybe<AgreementTermsArrRelInsertInput>;
  children?: InputMaybe<AgreementsArrRelInsertInput>;
  /** A description of the agreement */
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<UsersObjRelInsertInput>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  parent?: InputMaybe<AgreementsObjRelInsertInput>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodsObjRelInsertInput>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentTerm?: InputMaybe<PaymentTermsObjRelInsertInput>;
  paymentTermId?: InputMaybe<Scalars['uuid']['input']>;
  refreshPricesAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Any ID or reference from external systems */
  remoteId?: InputMaybe<Scalars['String']['input']>;
  subsidiary?: InputMaybe<SubsidiariesObjRelInsertInput>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  tags?: InputMaybe<AgreementTagsArrRelInsertInput>;
};

/** aggregate max on columns */
export type AgreementsMaxFields = {
  __typename?: 'agreements_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** A description of the agreement */
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  ownerId: Maybe<Scalars['uuid']['output']>;
  parentId: Maybe<Scalars['uuid']['output']>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  paymentTermId: Maybe<Scalars['uuid']['output']>;
  publicId: Maybe<Scalars['Int']['output']>;
  refreshPricesAt: Maybe<Scalars['timestamptz']['output']>;
  /** Any ID or reference from external systems */
  remoteId: Maybe<Scalars['String']['output']>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "agreements" */
export type AgreementsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  /** A description of the agreement */
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  paymentTermId?: InputMaybe<OrderBy>;
  publicId?: InputMaybe<OrderBy>;
  refreshPricesAt?: InputMaybe<OrderBy>;
  /** Any ID or reference from external systems */
  remoteId?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AgreementsMinFields = {
  __typename?: 'agreements_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** A description of the agreement */
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  ownerId: Maybe<Scalars['uuid']['output']>;
  parentId: Maybe<Scalars['uuid']['output']>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  paymentTermId: Maybe<Scalars['uuid']['output']>;
  publicId: Maybe<Scalars['Int']['output']>;
  refreshPricesAt: Maybe<Scalars['timestamptz']['output']>;
  /** Any ID or reference from external systems */
  remoteId: Maybe<Scalars['String']['output']>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "agreements" */
export type AgreementsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  /** A description of the agreement */
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  paymentTermId?: InputMaybe<OrderBy>;
  publicId?: InputMaybe<OrderBy>;
  refreshPricesAt?: InputMaybe<OrderBy>;
  /** Any ID or reference from external systems */
  remoteId?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "agreements" */
export type AgreementsMutationResponse = {
  __typename?: 'agreements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Agreements>;
};

/** input type for inserting object relation for remote table "agreements" */
export type AgreementsObjRelInsertInput = {
  data: AgreementsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AgreementsOnConflict>;
};

/** on_conflict condition type for table "agreements" */
export type AgreementsOnConflict = {
  constraint: AgreementsConstraint;
  update_columns: Array<AgreementsUpdateColumn>;
  where?: InputMaybe<AgreementsBoolExp>;
};

/** Ordering options when selecting data from "agreements". */
export type AgreementsOrderBy = {
  additionalOwners_aggregate?: InputMaybe<AgreementAdditionalOwnersAggregateOrderBy>;
  agreement_documents_aggregate?: InputMaybe<AgreementDocumentsAggregateOrderBy>;
  agreement_terms_aggregate?: InputMaybe<AgreementTermsAggregateOrderBy>;
  children_aggregate?: InputMaybe<AgreementsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  owner?: InputMaybe<UsersOrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  parent?: InputMaybe<AgreementsOrderBy>;
  parentId?: InputMaybe<OrderBy>;
  paymentMethod?: InputMaybe<PaymentMethodsOrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  paymentTerm?: InputMaybe<PaymentTermsOrderBy>;
  paymentTermId?: InputMaybe<OrderBy>;
  publicId?: InputMaybe<OrderBy>;
  refreshPricesAt?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  subsidiary?: InputMaybe<SubsidiariesOrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  tags_aggregate?: InputMaybe<AgreementTagsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: agreements */
export type AgreementsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "agreements" */
export enum AgreementsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  OWNERID = 'ownerId',
  /** column name */
  PARENTID = 'parentId',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTERMID = 'paymentTermId',
  /** column name */
  PUBLICID = 'publicId',
  /** column name */
  REFRESHPRICESAT = 'refreshPricesAt',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "agreements" */
export type AgreementsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** A description of the agreement */
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentTermId?: InputMaybe<Scalars['uuid']['input']>;
  refreshPricesAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Any ID or reference from external systems */
  remoteId?: InputMaybe<Scalars['String']['input']>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type AgreementsStddevFields = {
  __typename?: 'agreements_stddev_fields';
  publicId: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "agreements" */
export type AgreementsStddevOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AgreementsStddevPopFields = {
  __typename?: 'agreements_stddev_pop_fields';
  publicId: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "agreements" */
export type AgreementsStddevPopOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AgreementsStddevSampFields = {
  __typename?: 'agreements_stddev_samp_fields';
  publicId: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "agreements" */
export type AgreementsStddevSampOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type AgreementsSumFields = {
  __typename?: 'agreements_sum_fields';
  publicId: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "agreements" */
export type AgreementsSumOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** update columns of table "agreements" */
export enum AgreementsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name',
  /** column name */
  OWNERID = 'ownerId',
  /** column name */
  PARENTID = 'parentId',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTERMID = 'paymentTermId',
  /** column name */
  REFRESHPRICESAT = 'refreshPricesAt',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  SUPPLIERID = 'supplierId'
}

export type AgreementsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AgreementsSetInput>;
  /** filter the rows which have to be updated */
  where: AgreementsBoolExp;
};

/** aggregate var_pop on columns */
export type AgreementsVarPopFields = {
  __typename?: 'agreements_var_pop_fields';
  publicId: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "agreements" */
export type AgreementsVarPopOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AgreementsVarSampFields = {
  __typename?: 'agreements_var_samp_fields';
  publicId: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "agreements" */
export type AgreementsVarSampOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type AgreementsVarianceFields = {
  __typename?: 'agreements_variance_fields';
  publicId: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "agreements" */
export type AgreementsVarianceOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** Store group respondents for assessments */
export type AssessmentAdditionalGroups = {
  __typename?: 'assessment_additional_groups';
  /** An object relationship */
  assessment: Assessments;
  assessmentId: Scalars['uuid']['output'];
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by aggregate values of table "assessment_additional_groups" */
export type AssessmentAdditionalGroupsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AssessmentAdditionalGroupsMaxOrderBy>;
  min?: InputMaybe<AssessmentAdditionalGroupsMinOrderBy>;
};

/** input type for inserting array relation for remote table "assessment_additional_groups" */
export type AssessmentAdditionalGroupsArrRelInsertInput = {
  data: Array<AssessmentAdditionalGroupsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AssessmentAdditionalGroupsOnConflict>;
};

/** Boolean expression to filter rows from the table "assessment_additional_groups". All fields are combined with a logical 'AND'. */
export type AssessmentAdditionalGroupsBoolExp = {
  _and?: InputMaybe<Array<AssessmentAdditionalGroupsBoolExp>>;
  _not?: InputMaybe<AssessmentAdditionalGroupsBoolExp>;
  _or?: InputMaybe<Array<AssessmentAdditionalGroupsBoolExp>>;
  assessment?: InputMaybe<AssessmentsBoolExp>;
  assessmentId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "assessment_additional_groups" */
export enum AssessmentAdditionalGroupsConstraint {
  /** unique or primary key constraint on columns "assessment_id", "group_id" */
  ASSESSMENT_ADDITIONAL_GROUPS_GROUP_ID_ASSESSMENT_ID_KEY = 'assessment_additional_groups_group_id_assessment_id_key',
  /** unique or primary key constraint on columns "id" */
  ASSESSMENT_ADDITIONAL_GROUPS_PKEY = 'assessment_additional_groups_pkey'
}

/** input type for inserting data into table "assessment_additional_groups" */
export type AssessmentAdditionalGroupsInsertInput = {
  assessment?: InputMaybe<AssessmentsObjRelInsertInput>;
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "assessment_additional_groups" */
export type AssessmentAdditionalGroupsMaxOrderBy = {
  assessmentId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "assessment_additional_groups" */
export type AssessmentAdditionalGroupsMinOrderBy = {
  assessmentId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "assessment_additional_groups" */
export type AssessmentAdditionalGroupsMutationResponse = {
  __typename?: 'assessment_additional_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AssessmentAdditionalGroups>;
};

/** on_conflict condition type for table "assessment_additional_groups" */
export type AssessmentAdditionalGroupsOnConflict = {
  constraint: AssessmentAdditionalGroupsConstraint;
  update_columns: Array<AssessmentAdditionalGroupsUpdateColumn>;
  where?: InputMaybe<AssessmentAdditionalGroupsBoolExp>;
};

/** Ordering options when selecting data from "assessment_additional_groups". */
export type AssessmentAdditionalGroupsOrderBy = {
  assessment?: InputMaybe<AssessmentsOrderBy>;
  assessmentId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: assessment_additional_groups */
export type AssessmentAdditionalGroupsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "assessment_additional_groups" */
export enum AssessmentAdditionalGroupsSelectColumn {
  /** column name */
  ASSESSMENTID = 'assessmentId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "assessment_additional_groups" */
export type AssessmentAdditionalGroupsSetInput = {
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "assessment_additional_groups" */
export enum AssessmentAdditionalGroupsUpdateColumn {
  /** column name */
  ASSESSMENTID = 'assessmentId',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type AssessmentAdditionalGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AssessmentAdditionalGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: AssessmentAdditionalGroupsBoolExp;
};

/** columns and relationships of "assessment_additional_users" */
export type AssessmentAdditionalUsers = {
  __typename?: 'assessment_additional_users';
  /** An object relationship */
  assessment: Assessments;
  assessmentId: Scalars['uuid']['output'];
  created_at: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  updated_at: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "assessment_additional_users" */
export type AssessmentAdditionalUsersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AssessmentAdditionalUsersMaxOrderBy>;
  min?: InputMaybe<AssessmentAdditionalUsersMinOrderBy>;
};

/** input type for inserting array relation for remote table "assessment_additional_users" */
export type AssessmentAdditionalUsersArrRelInsertInput = {
  data: Array<AssessmentAdditionalUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AssessmentAdditionalUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "assessment_additional_users". All fields are combined with a logical 'AND'. */
export type AssessmentAdditionalUsersBoolExp = {
  _and?: InputMaybe<Array<AssessmentAdditionalUsersBoolExp>>;
  _not?: InputMaybe<AssessmentAdditionalUsersBoolExp>;
  _or?: InputMaybe<Array<AssessmentAdditionalUsersBoolExp>>;
  assessment?: InputMaybe<AssessmentsBoolExp>;
  assessmentId?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "assessment_additional_users" */
export enum AssessmentAdditionalUsersConstraint {
  /** unique or primary key constraint on columns "id" */
  ASSESSMENT_ADDITIONAL_USERS_PKEY = 'assessment_additional_users_pkey',
  /** unique or primary key constraint on columns "user_id", "assessment_id" */
  ASSESSMENT_ID_USER_ID_KEY = 'assessment_id_user_id_key'
}

/** input type for inserting data into table "assessment_additional_users" */
export type AssessmentAdditionalUsersInsertInput = {
  assessment?: InputMaybe<AssessmentsObjRelInsertInput>;
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "assessment_additional_users" */
export type AssessmentAdditionalUsersMaxOrderBy = {
  assessmentId?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "assessment_additional_users" */
export type AssessmentAdditionalUsersMinOrderBy = {
  assessmentId?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "assessment_additional_users" */
export type AssessmentAdditionalUsersMutationResponse = {
  __typename?: 'assessment_additional_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AssessmentAdditionalUsers>;
};

/** on_conflict condition type for table "assessment_additional_users" */
export type AssessmentAdditionalUsersOnConflict = {
  constraint: AssessmentAdditionalUsersConstraint;
  update_columns: Array<AssessmentAdditionalUsersUpdateColumn>;
  where?: InputMaybe<AssessmentAdditionalUsersBoolExp>;
};

/** Ordering options when selecting data from "assessment_additional_users". */
export type AssessmentAdditionalUsersOrderBy = {
  assessment?: InputMaybe<AssessmentsOrderBy>;
  assessmentId?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: assessment_additional_users */
export type AssessmentAdditionalUsersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "assessment_additional_users" */
export enum AssessmentAdditionalUsersSelectColumn {
  /** column name */
  ASSESSMENTID = 'assessmentId',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "assessment_additional_users" */
export type AssessmentAdditionalUsersSetInput = {
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "assessment_additional_users" */
export enum AssessmentAdditionalUsersUpdateColumn {
  /** column name */
  ASSESSMENTID = 'assessmentId',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USERID = 'userId'
}

export type AssessmentAdditionalUsersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AssessmentAdditionalUsersSetInput>;
  /** filter the rows which have to be updated */
  where: AssessmentAdditionalUsersBoolExp;
};

/** columns and relationships of "assessment_frequency" */
export type AssessmentFrequency = {
  __typename?: 'assessment_frequency';
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "assessment_frequency". All fields are combined with a logical 'AND'. */
export type AssessmentFrequencyBoolExp = {
  _and?: InputMaybe<Array<AssessmentFrequencyBoolExp>>;
  _not?: InputMaybe<AssessmentFrequencyBoolExp>;
  _or?: InputMaybe<Array<AssessmentFrequencyBoolExp>>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum AssessmentFrequencyEnum {
  ANNUAL = 'ANNUAL',
  EVERY_SIX_MONTHS = 'EVERY_SIX_MONTHS',
  EVERY_THREE_YEARS = 'EVERY_THREE_YEARS',
  EVERY_TWO_YEARS = 'EVERY_TWO_YEARS',
  MONTHLY = 'MONTHLY',
  ONE_OFF = 'ONE_OFF',
  QUARTERLY = 'QUARTERLY'
}

/** Boolean expression to compare columns of type "assessment_frequency_enum". All fields are combined with logical 'AND'. */
export type AssessmentFrequencyEnumComparisonExp = {
  _eq?: InputMaybe<AssessmentFrequencyEnum>;
  _in?: InputMaybe<Array<AssessmentFrequencyEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AssessmentFrequencyEnum>;
  _nin?: InputMaybe<Array<AssessmentFrequencyEnum>>;
};

/** Ordering options when selecting data from "assessment_frequency". */
export type AssessmentFrequencyOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "assessment_frequency" */
export enum AssessmentFrequencySelectColumn {
  /** column name */
  VALUE = 'value'
}

/** columns and relationships of "assessment_tags" */
export type AssessmentTags = {
  __typename?: 'assessment_tags';
  /** An object relationship */
  assessment: Assessments;
  assessmentId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  tag: Tags;
  tagId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "assessment_tags" */
export type AssessmentTagsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AssessmentTagsMaxOrderBy>;
  min?: InputMaybe<AssessmentTagsMinOrderBy>;
};

/** input type for inserting array relation for remote table "assessment_tags" */
export type AssessmentTagsArrRelInsertInput = {
  data: Array<AssessmentTagsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AssessmentTagsOnConflict>;
};

/** Boolean expression to filter rows from the table "assessment_tags". All fields are combined with a logical 'AND'. */
export type AssessmentTagsBoolExp = {
  _and?: InputMaybe<Array<AssessmentTagsBoolExp>>;
  _not?: InputMaybe<AssessmentTagsBoolExp>;
  _or?: InputMaybe<Array<AssessmentTagsBoolExp>>;
  assessment?: InputMaybe<AssessmentsBoolExp>;
  assessmentId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  tag?: InputMaybe<TagsBoolExp>;
  tagId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "assessment_tags" */
export enum AssessmentTagsConstraint {
  /** unique or primary key constraint on columns "tag_id", "assessment_id" */
  ASSESSMENT_TAGS_ASSESSMENT_ID_TAG_ID_KEY = 'assessment_tags_assessment_id_tag_id_key',
  /** unique or primary key constraint on columns "id" */
  ASSESSMENT_TAGS_PKEY = 'assessment_tags_pkey'
}

/** input type for inserting data into table "assessment_tags" */
export type AssessmentTagsInsertInput = {
  assessment?: InputMaybe<AssessmentsObjRelInsertInput>;
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  tag?: InputMaybe<TagsObjRelInsertInput>;
  tagId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "assessment_tags" */
export type AssessmentTagsMaxOrderBy = {
  assessmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "assessment_tags" */
export type AssessmentTagsMinOrderBy = {
  assessmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "assessment_tags" */
export type AssessmentTagsMutationResponse = {
  __typename?: 'assessment_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AssessmentTags>;
};

/** on_conflict condition type for table "assessment_tags" */
export type AssessmentTagsOnConflict = {
  constraint: AssessmentTagsConstraint;
  update_columns: Array<AssessmentTagsUpdateColumn>;
  where?: InputMaybe<AssessmentTagsBoolExp>;
};

/** Ordering options when selecting data from "assessment_tags". */
export type AssessmentTagsOrderBy = {
  assessment?: InputMaybe<AssessmentsOrderBy>;
  assessmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tag?: InputMaybe<TagsOrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** select columns of table "assessment_tags" */
export enum AssessmentTagsSelectColumn {
  /** column name */
  ASSESSMENTID = 'assessmentId',
  /** column name */
  ID = 'id',
  /** column name */
  TAGID = 'tagId'
}

/** placeholder for update columns of table "assessment_tags" (current role has no relevant permissions) */
export enum AssessmentTagsUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "assessments" */
export type Assessments = {
  __typename?: 'assessments';
  /** An array relationship */
  additionalGroups: Array<AssessmentAdditionalGroups>;
  /** An array relationship */
  additionalUsers: Array<AssessmentAdditionalUsers>;
  /** An array relationship */
  assessmentTags: Array<AssessmentTags>;
  /** An object relationship */
  assessment_frequency: AssessmentFrequency;
  autoStartEnabled: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  businessOwnerUser: Users;
  businessOwnerUserId: Scalars['uuid']['output'];
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  externalRespondents: Maybe<Scalars['jsonb']['output']>;
  frequency: AssessmentFrequencyEnum;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_supplier: OrganisationSuppliers;
  /** An object relationship */
  product: Maybe<OrganisationProductsAndServices>;
  /** An object relationship */
  request: Maybe<Requests>;
  requestId: Maybe<Scalars['uuid']['output']>;
  sendDate: Maybe<Scalars['timestamptz']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  workflow: Workflows;
  workflowId: Scalars['uuid']['output'];
};


/** columns and relationships of "assessments" */
export type AssessmentsAdditionalGroupsArgs = {
  distinct_on: InputMaybe<Array<AssessmentAdditionalGroupsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AssessmentAdditionalGroupsOrderBy>>;
  where: InputMaybe<AssessmentAdditionalGroupsBoolExp>;
};


/** columns and relationships of "assessments" */
export type AssessmentsAdditionalUsersArgs = {
  distinct_on: InputMaybe<Array<AssessmentAdditionalUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AssessmentAdditionalUsersOrderBy>>;
  where: InputMaybe<AssessmentAdditionalUsersBoolExp>;
};


/** columns and relationships of "assessments" */
export type AssessmentsAssessmentTagsArgs = {
  distinct_on: InputMaybe<Array<AssessmentTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AssessmentTagsOrderBy>>;
  where: InputMaybe<AssessmentTagsBoolExp>;
};


/** columns and relationships of "assessments" */
export type AssessmentsExternalRespondentsArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "assessments" */
export type AssessmentsAggregate = {
  __typename?: 'assessments_aggregate';
  aggregate: Maybe<AssessmentsAggregateFields>;
  nodes: Array<Assessments>;
};

export type AssessmentsAggregateBoolExp = {
  bool_and?: InputMaybe<AssessmentsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<AssessmentsAggregateBoolExpBoolOr>;
  count?: InputMaybe<AssessmentsAggregateBoolExpCount>;
};

export type AssessmentsAggregateBoolExpBoolAnd = {
  arguments: AssessmentsSelectColumnAssessmentsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AssessmentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AssessmentsAggregateBoolExpBoolOr = {
  arguments: AssessmentsSelectColumnAssessmentsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AssessmentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type AssessmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<AssessmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AssessmentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "assessments" */
export type AssessmentsAggregateFields = {
  __typename?: 'assessments_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<AssessmentsMaxFields>;
  min: Maybe<AssessmentsMinFields>;
};


/** aggregate fields of "assessments" */
export type AssessmentsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<AssessmentsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "assessments" */
export type AssessmentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<AssessmentsMaxOrderBy>;
  min?: InputMaybe<AssessmentsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AssessmentsAppendInput = {
  externalRespondents?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "assessments" */
export type AssessmentsArrRelInsertInput = {
  data: Array<AssessmentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<AssessmentsOnConflict>;
};

/** Boolean expression to filter rows from the table "assessments". All fields are combined with a logical 'AND'. */
export type AssessmentsBoolExp = {
  _and?: InputMaybe<Array<AssessmentsBoolExp>>;
  _not?: InputMaybe<AssessmentsBoolExp>;
  _or?: InputMaybe<Array<AssessmentsBoolExp>>;
  additionalGroups?: InputMaybe<AssessmentAdditionalGroupsBoolExp>;
  additionalUsers?: InputMaybe<AssessmentAdditionalUsersBoolExp>;
  assessmentTags?: InputMaybe<AssessmentTagsBoolExp>;
  assessment_frequency?: InputMaybe<AssessmentFrequencyBoolExp>;
  autoStartEnabled?: InputMaybe<BooleanComparisonExp>;
  businessOwnerUser?: InputMaybe<UsersBoolExp>;
  businessOwnerUserId?: InputMaybe<UuidComparisonExp>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  externalRespondents?: InputMaybe<JsonbComparisonExp>;
  frequency?: InputMaybe<AssessmentFrequencyEnumComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationProductId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  product?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  sendDate?: InputMaybe<TimestamptzComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
  workflowId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "assessments" */
export enum AssessmentsConstraint {
  /** unique or primary key constraint on columns "id" */
  ASSESSMENTS_PKEY = 'assessments_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AssessmentsDeleteAtPathInput = {
  externalRespondents?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AssessmentsDeleteElemInput = {
  externalRespondents?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AssessmentsDeleteKeyInput = {
  externalRespondents?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "assessments" */
export type AssessmentsInsertInput = {
  additionalGroups?: InputMaybe<AssessmentAdditionalGroupsArrRelInsertInput>;
  additionalUsers?: InputMaybe<AssessmentAdditionalUsersArrRelInsertInput>;
  assessmentTags?: InputMaybe<AssessmentTagsArrRelInsertInput>;
  autoStartEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  businessOwnerUser?: InputMaybe<UsersObjRelInsertInput>;
  businessOwnerUserId?: InputMaybe<Scalars['uuid']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  externalRespondents?: InputMaybe<Scalars['jsonb']['input']>;
  frequency?: InputMaybe<AssessmentFrequencyEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationProductId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  product?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  sendDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AssessmentsMaxFields = {
  __typename?: 'assessments_max_fields';
  businessOwnerUserId: Maybe<Scalars['uuid']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  sendDate: Maybe<Scalars['timestamptz']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "assessments" */
export type AssessmentsMaxOrderBy = {
  businessOwnerUserId?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  sendDate?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workflowId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type AssessmentsMinFields = {
  __typename?: 'assessments_min_fields';
  businessOwnerUserId: Maybe<Scalars['uuid']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  sendDate: Maybe<Scalars['timestamptz']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "assessments" */
export type AssessmentsMinOrderBy = {
  businessOwnerUserId?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  sendDate?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workflowId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "assessments" */
export type AssessmentsMutationResponse = {
  __typename?: 'assessments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Assessments>;
};

/** input type for inserting object relation for remote table "assessments" */
export type AssessmentsObjRelInsertInput = {
  data: AssessmentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<AssessmentsOnConflict>;
};

/** on_conflict condition type for table "assessments" */
export type AssessmentsOnConflict = {
  constraint: AssessmentsConstraint;
  update_columns: Array<AssessmentsUpdateColumn>;
  where?: InputMaybe<AssessmentsBoolExp>;
};

/** Ordering options when selecting data from "assessments". */
export type AssessmentsOrderBy = {
  additionalGroups_aggregate?: InputMaybe<AssessmentAdditionalGroupsAggregateOrderBy>;
  additionalUsers_aggregate?: InputMaybe<AssessmentAdditionalUsersAggregateOrderBy>;
  assessmentTags_aggregate?: InputMaybe<AssessmentTagsAggregateOrderBy>;
  assessment_frequency?: InputMaybe<AssessmentFrequencyOrderBy>;
  autoStartEnabled?: InputMaybe<OrderBy>;
  businessOwnerUser?: InputMaybe<UsersOrderBy>;
  businessOwnerUserId?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  externalRespondents?: InputMaybe<OrderBy>;
  frequency?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  product?: InputMaybe<OrganisationProductsAndServicesOrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  sendDate?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workflow?: InputMaybe<WorkflowsOrderBy>;
  workflowId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: assessments */
export type AssessmentsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AssessmentsPrependInput = {
  externalRespondents?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "assessments" */
export enum AssessmentsSelectColumn {
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled',
  /** column name */
  BUSINESSOWNERUSERID = 'businessOwnerUserId',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  EXTERNALRESPONDENTS = 'externalRespondents',
  /** column name */
  FREQUENCY = 'frequency',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  SENDDATE = 'sendDate',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId'
}

/** select "assessments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "assessments" */
export enum AssessmentsSelectColumnAssessmentsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled'
}

/** select "assessments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "assessments" */
export enum AssessmentsSelectColumnAssessmentsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled'
}

/** input type for updating data in table "assessments" */
export type AssessmentsSetInput = {
  autoStartEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  businessOwnerUserId?: InputMaybe<Scalars['uuid']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  externalRespondents?: InputMaybe<Scalars['jsonb']['input']>;
  frequency?: InputMaybe<AssessmentFrequencyEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationProductId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  sendDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "assessments" */
export enum AssessmentsUpdateColumn {
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled',
  /** column name */
  BUSINESSOWNERUSERID = 'businessOwnerUserId',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  EXTERNALRESPONDENTS = 'externalRespondents',
  /** column name */
  FREQUENCY = 'frequency',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  SENDDATE = 'sendDate',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId'
}

export type AssessmentsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AssessmentsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AssessmentsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AssessmentsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AssessmentsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AssessmentsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AssessmentsSetInput>;
  /** filter the rows which have to be updated */
  where: AssessmentsBoolExp;
};

/** columns and relationships of "assignee_type" */
export type AssigneeType = {
  __typename?: 'assignee_type';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "assignee_type". All fields are combined with a logical 'AND'. */
export type AssigneeTypeBoolExp = {
  _and?: InputMaybe<Array<AssigneeTypeBoolExp>>;
  _not?: InputMaybe<AssigneeTypeBoolExp>;
  _or?: InputMaybe<Array<AssigneeTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum AssigneeTypeEnum {
  /** EMAIL */
  EMAIL = 'EMAIL',
  /** GROUP */
  GROUP = 'GROUP',
  /** USER */
  USER = 'USER',
  /** VARIABLE */
  VARIABLE = 'VARIABLE'
}

/** Boolean expression to compare columns of type "assignee_type_enum". All fields are combined with logical 'AND'. */
export type AssigneeTypeEnumComparisonExp = {
  _eq?: InputMaybe<AssigneeTypeEnum>;
  _in?: InputMaybe<Array<AssigneeTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AssigneeTypeEnum>;
  _nin?: InputMaybe<Array<AssigneeTypeEnum>>;
};

/** Ordering options when selecting data from "assignee_type". */
export type AssigneeTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "assignee_type" */
export enum AssigneeTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** columns and relationships of "auth_refresh_tokens" */
export type AuthRefreshTokens = {
  __typename?: 'auth_refresh_tokens';
  expiresAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  redeemedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "auth_refresh_tokens". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokensBoolExp = {
  _and?: InputMaybe<Array<AuthRefreshTokensBoolExp>>;
  _not?: InputMaybe<AuthRefreshTokensBoolExp>;
  _or?: InputMaybe<Array<AuthRefreshTokensBoolExp>>;
  expiresAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  redeemedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "auth_refresh_tokens" */
export enum AuthRefreshTokensConstraint {
  /** unique or primary key constraint on columns "id" */
  AUTH_REFRESH_TOKENS_PKEY = 'auth_refresh_tokens_pkey'
}

/** input type for inserting data into table "auth_refresh_tokens" */
export type AuthRefreshTokensInsertInput = {
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  redeemedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "auth_refresh_tokens" */
export type AuthRefreshTokensMutationResponse = {
  __typename?: 'auth_refresh_tokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokens>;
};

/** on_conflict condition type for table "auth_refresh_tokens" */
export type AuthRefreshTokensOnConflict = {
  constraint: AuthRefreshTokensConstraint;
  update_columns: Array<AuthRefreshTokensUpdateColumn>;
  where?: InputMaybe<AuthRefreshTokensBoolExp>;
};

/** Ordering options when selecting data from "auth_refresh_tokens". */
export type AuthRefreshTokensOrderBy = {
  expiresAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  redeemedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: auth_refresh_tokens */
export type AuthRefreshTokensPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth_refresh_tokens" */
export enum AuthRefreshTokensSelectColumn {
  /** column name */
  EXPIRESAT = 'expiresAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REDEEMEDAT = 'redeemedAt',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "auth_refresh_tokens" */
export type AuthRefreshTokensSetInput = {
  redeemedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "auth_refresh_tokens" */
export enum AuthRefreshTokensUpdateColumn {
  /** column name */
  REDEEMEDAT = 'redeemedAt'
}

export type AuthRefreshTokensUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokensSetInput>;
  /** filter the rows which have to be updated */
  where: AuthRefreshTokensBoolExp;
};

/** columns and relationships of "auto_flagged_score_categories" */
export type AutoFlaggedScoreCategories = {
  __typename?: 'auto_flagged_score_categories';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "auto_flagged_score_categories". All fields are combined with a logical 'AND'. */
export type AutoFlaggedScoreCategoriesBoolExp = {
  _and?: InputMaybe<Array<AutoFlaggedScoreCategoriesBoolExp>>;
  _not?: InputMaybe<AutoFlaggedScoreCategoriesBoolExp>;
  _or?: InputMaybe<Array<AutoFlaggedScoreCategoriesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isDefault?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "auto_flagged_score_categories" */
export enum AutoFlaggedScoreCategoriesConstraint {
  /** unique or primary key constraint on columns "organisation_id" */
  AUTO_FLAGGED_SCORE_CATEGORIES_ORG_DEFAULT_UNIQ = 'auto_flagged_score_categories_org_default_uniq',
  /** unique or primary key constraint on columns "id" */
  AUTO_FLAGGED_SCORE_CATEGORIES_PKEY = 'auto_flagged_score_categories_pkey'
}

/** input type for inserting data into table "auto_flagged_score_categories" */
export type AutoFlaggedScoreCategoriesInsertInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "auto_flagged_score_categories" */
export type AutoFlaggedScoreCategoriesMutationResponse = {
  __typename?: 'auto_flagged_score_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AutoFlaggedScoreCategories>;
};

/** on_conflict condition type for table "auto_flagged_score_categories" */
export type AutoFlaggedScoreCategoriesOnConflict = {
  constraint: AutoFlaggedScoreCategoriesConstraint;
  update_columns: Array<AutoFlaggedScoreCategoriesUpdateColumn>;
  where?: InputMaybe<AutoFlaggedScoreCategoriesBoolExp>;
};

/** Ordering options when selecting data from "auto_flagged_score_categories". */
export type AutoFlaggedScoreCategoriesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isDefault?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: auto_flagged_score_categories */
export type AutoFlaggedScoreCategoriesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auto_flagged_score_categories" */
export enum AutoFlaggedScoreCategoriesSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  ISDEFAULT = 'isDefault',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "auto_flagged_score_categories" */
export type AutoFlaggedScoreCategoriesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "auto_flagged_score_categories" */
export type AutoFlaggedScoreCategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: AutoFlaggedScoreCategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AutoFlaggedScoreCategoriesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "auto_flagged_score_categories" */
export enum AutoFlaggedScoreCategoriesUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ISDEFAULT = 'isDefault',
  /** column name */
  NAME = 'name'
}

export type AutoFlaggedScoreCategoriesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AutoFlaggedScoreCategoriesSetInput>;
  /** filter the rows which have to be updated */
  where: AutoFlaggedScoreCategoriesBoolExp;
};

/** columns and relationships of "bank_details" */
export type BankDetails = {
  __typename?: 'bank_details';
  accountName: Maybe<Scalars['String']['output']>;
  accountNumber: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  address: Maybe<Addresses>;
  addressId: Maybe<Scalars['uuid']['output']>;
  bankName: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  currency: Maybe<OrganisationFxRates>;
  currencyId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  customFieldValues: Array<CustomFieldValues>;
  /** An aggregate relationship */
  customFieldValues_aggregate: CustomFieldValuesAggregate;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  entityBankDetails: Array<EntityBankDetails>;
  /** An aggregate relationship */
  entityBankDetails_aggregate: EntityBankDetailsAggregate;
  iban: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isActive: Scalars['Boolean']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  sortCode: Maybe<Scalars['String']['output']>;
  swiftCode: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "bank_details" */
export type BankDetailsCustomFieldValuesArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** columns and relationships of "bank_details" */
export type BankDetailsCustomFieldValuesAggregateArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** columns and relationships of "bank_details" */
export type BankDetailsEntityBankDetailsArgs = {
  distinct_on: InputMaybe<Array<EntityBankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityBankDetailsOrderBy>>;
  where: InputMaybe<EntityBankDetailsBoolExp>;
};


/** columns and relationships of "bank_details" */
export type BankDetailsEntityBankDetailsAggregateArgs = {
  distinct_on: InputMaybe<Array<EntityBankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityBankDetailsOrderBy>>;
  where: InputMaybe<EntityBankDetailsBoolExp>;
};

/** aggregated selection of "bank_details" */
export type BankDetailsAggregate = {
  __typename?: 'bank_details_aggregate';
  aggregate: Maybe<BankDetailsAggregateFields>;
  nodes: Array<BankDetails>;
};

export type BankDetailsAggregateBoolExp = {
  bool_and?: InputMaybe<BankDetailsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<BankDetailsAggregateBoolExpBoolOr>;
  count?: InputMaybe<BankDetailsAggregateBoolExpCount>;
};

export type BankDetailsAggregateBoolExpBoolAnd = {
  arguments: BankDetailsSelectColumnBankDetailsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BankDetailsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type BankDetailsAggregateBoolExpBoolOr = {
  arguments: BankDetailsSelectColumnBankDetailsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BankDetailsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type BankDetailsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BankDetailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BankDetailsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "bank_details" */
export type BankDetailsAggregateFields = {
  __typename?: 'bank_details_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<BankDetailsMaxFields>;
  min: Maybe<BankDetailsMinFields>;
};


/** aggregate fields of "bank_details" */
export type BankDetailsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<BankDetailsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "bank_details" */
export type BankDetailsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BankDetailsMaxOrderBy>;
  min?: InputMaybe<BankDetailsMinOrderBy>;
};

/** input type for inserting array relation for remote table "bank_details" */
export type BankDetailsArrRelInsertInput = {
  data: Array<BankDetailsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BankDetailsOnConflict>;
};

/** Boolean expression to filter rows from the table "bank_details". All fields are combined with a logical 'AND'. */
export type BankDetailsBoolExp = {
  _and?: InputMaybe<Array<BankDetailsBoolExp>>;
  _not?: InputMaybe<BankDetailsBoolExp>;
  _or?: InputMaybe<Array<BankDetailsBoolExp>>;
  accountName?: InputMaybe<StringComparisonExp>;
  accountNumber?: InputMaybe<StringComparisonExp>;
  address?: InputMaybe<AddressesBoolExp>;
  addressId?: InputMaybe<UuidComparisonExp>;
  bankName?: InputMaybe<StringComparisonExp>;
  code?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<OrganisationFxRatesBoolExp>;
  currencyId?: InputMaybe<UuidComparisonExp>;
  customFieldValues?: InputMaybe<CustomFieldValuesBoolExp>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  entityBankDetails?: InputMaybe<EntityBankDetailsBoolExp>;
  entityBankDetails_aggregate?: InputMaybe<EntityBankDetailsAggregateBoolExp>;
  iban?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isActive?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  sortCode?: InputMaybe<StringComparisonExp>;
  swiftCode?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "bank_details" */
export enum BankDetailsConstraint {
  /** unique or primary key constraint on columns "id" */
  BANK_DETAILS_PKEY = 'bank_details_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  BANK_DETAILS_REMOTE_ID_ORGANISATION_ID_KEY = 'bank_details_remote_id_organisation_id_key'
}

/** input type for inserting data into table "bank_details" */
export type BankDetailsInsertInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressesObjRelInsertInput>;
  addressId?: InputMaybe<Scalars['uuid']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<OrganisationFxRatesObjRelInsertInput>;
  currencyId?: InputMaybe<Scalars['uuid']['input']>;
  customFieldValues?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  entityBankDetails?: InputMaybe<EntityBankDetailsArrRelInsertInput>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type BankDetailsMaxFields = {
  __typename?: 'bank_details_max_fields';
  accountName: Maybe<Scalars['String']['output']>;
  accountNumber: Maybe<Scalars['String']['output']>;
  addressId: Maybe<Scalars['uuid']['output']>;
  bankName: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  currencyId: Maybe<Scalars['uuid']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  iban: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  sortCode: Maybe<Scalars['String']['output']>;
  swiftCode: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "bank_details" */
export type BankDetailsMaxOrderBy = {
  accountName?: InputMaybe<OrderBy>;
  accountNumber?: InputMaybe<OrderBy>;
  addressId?: InputMaybe<OrderBy>;
  bankName?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyId?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  iban?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  sortCode?: InputMaybe<OrderBy>;
  swiftCode?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BankDetailsMinFields = {
  __typename?: 'bank_details_min_fields';
  accountName: Maybe<Scalars['String']['output']>;
  accountNumber: Maybe<Scalars['String']['output']>;
  addressId: Maybe<Scalars['uuid']['output']>;
  bankName: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  currencyId: Maybe<Scalars['uuid']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  iban: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  sortCode: Maybe<Scalars['String']['output']>;
  swiftCode: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "bank_details" */
export type BankDetailsMinOrderBy = {
  accountName?: InputMaybe<OrderBy>;
  accountNumber?: InputMaybe<OrderBy>;
  addressId?: InputMaybe<OrderBy>;
  bankName?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyId?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  iban?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  sortCode?: InputMaybe<OrderBy>;
  swiftCode?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "bank_details" */
export type BankDetailsMutationResponse = {
  __typename?: 'bank_details_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BankDetails>;
};

/** input type for inserting object relation for remote table "bank_details" */
export type BankDetailsObjRelInsertInput = {
  data: BankDetailsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BankDetailsOnConflict>;
};

/** on_conflict condition type for table "bank_details" */
export type BankDetailsOnConflict = {
  constraint: BankDetailsConstraint;
  update_columns: Array<BankDetailsUpdateColumn>;
  where?: InputMaybe<BankDetailsBoolExp>;
};

/** Ordering options when selecting data from "bank_details". */
export type BankDetailsOrderBy = {
  accountName?: InputMaybe<OrderBy>;
  accountNumber?: InputMaybe<OrderBy>;
  address?: InputMaybe<AddressesOrderBy>;
  addressId?: InputMaybe<OrderBy>;
  bankName?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  country?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrganisationFxRatesOrderBy>;
  currencyId?: InputMaybe<OrderBy>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateOrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  entityBankDetails_aggregate?: InputMaybe<EntityBankDetailsAggregateOrderBy>;
  iban?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isActive?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  sortCode?: InputMaybe<OrderBy>;
  swiftCode?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: bank_details */
export type BankDetailsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "bank_details" */
export enum BankDetailsSelectColumn {
  /** column name */
  ACCOUNTNAME = 'accountName',
  /** column name */
  ACCOUNTNUMBER = 'accountNumber',
  /** column name */
  ADDRESSID = 'addressId',
  /** column name */
  BANKNAME = 'bankName',
  /** column name */
  CODE = 'code',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CURRENCYID = 'currencyId',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  IBAN = 'iban',
  /** column name */
  ID = 'id',
  /** column name */
  ISACTIVE = 'isActive',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  SORTCODE = 'sortCode',
  /** column name */
  SWIFTCODE = 'swiftCode',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "bank_details_aggregate_bool_exp_bool_and_arguments_columns" columns of table "bank_details" */
export enum BankDetailsSelectColumnBankDetailsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISACTIVE = 'isActive'
}

/** select "bank_details_aggregate_bool_exp_bool_or_arguments_columns" columns of table "bank_details" */
export enum BankDetailsSelectColumnBankDetailsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISACTIVE = 'isActive'
}

/** input type for updating data in table "bank_details" */
export type BankDetailsSetInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  addressId?: InputMaybe<Scalars['uuid']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currencyId?: InputMaybe<Scalars['uuid']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "bank_details" */
export enum BankDetailsUpdateColumn {
  /** column name */
  ACCOUNTNAME = 'accountName',
  /** column name */
  ACCOUNTNUMBER = 'accountNumber',
  /** column name */
  ADDRESSID = 'addressId',
  /** column name */
  BANKNAME = 'bankName',
  /** column name */
  CODE = 'code',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CURRENCYID = 'currencyId',
  /** column name */
  IBAN = 'iban',
  /** column name */
  ISACTIVE = 'isActive',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  SORTCODE = 'sortCode',
  /** column name */
  SWIFTCODE = 'swiftCode'
}

export type BankDetailsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BankDetailsSetInput>;
  /** filter the rows which have to be updated */
  where: BankDetailsBoolExp;
};

/** columns and relationships of "budget_approval_group" */
export type BudgetApprovalGroup = {
  __typename?: 'budget_approval_group';
  /** An array relationship */
  assignees: Array<BudgetApprovalGroupAssignees>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An array relationship */
  selected_custom_core_data: Array<BudgetApprovalGroupSelectedCustomCoreData>;
};


/** columns and relationships of "budget_approval_group" */
export type BudgetApprovalGroupAssigneesArgs = {
  distinct_on: InputMaybe<Array<BudgetApprovalGroupAssigneesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetApprovalGroupAssigneesOrderBy>>;
  where: InputMaybe<BudgetApprovalGroupAssigneesBoolExp>;
};


/** columns and relationships of "budget_approval_group" */
export type BudgetApprovalGroupSelectedCustomCoreDataArgs = {
  distinct_on: InputMaybe<Array<BudgetApprovalGroupSelectedCustomCoreDataSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetApprovalGroupSelectedCustomCoreDataOrderBy>>;
  where: InputMaybe<BudgetApprovalGroupSelectedCustomCoreDataBoolExp>;
};

/** columns and relationships of "budget_approval_group_assignees" */
export type BudgetApprovalGroupAssignees = {
  __typename?: 'budget_approval_group_assignees';
  /** An array relationship */
  assignees: Array<BudgetApprovalGroupAssigneesAssignees>;
  budgetApprovalGroupId: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  custom_core_data_options: Array<BudgetApprovalGroupAssigneesCustomCoreDataOptions>;
  /** An object relationship */
  department: Maybe<Departments>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lineItem: Maybe<LineItemTypes>;
  lineItemId: Maybe<Scalars['uuid']['output']>;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  subsidiary: Maybe<Subsidiaries>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "budget_approval_group_assignees" */
export type BudgetApprovalGroupAssigneesAssigneesArgs = {
  distinct_on: InputMaybe<Array<BudgetApprovalGroupAssigneesAssigneesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetApprovalGroupAssigneesAssigneesOrderBy>>;
  where: InputMaybe<BudgetApprovalGroupAssigneesAssigneesBoolExp>;
};


/** columns and relationships of "budget_approval_group_assignees" */
export type BudgetApprovalGroupAssigneesCustomCoreDataOptionsArgs = {
  distinct_on: InputMaybe<Array<BudgetApprovalGroupAssigneesCustomCoreDataOptionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetApprovalGroupAssigneesCustomCoreDataOptionsOrderBy>>;
  where: InputMaybe<BudgetApprovalGroupAssigneesCustomCoreDataOptionsBoolExp>;
};

/** order by aggregate values of table "budget_approval_group_assignees" */
export type BudgetApprovalGroupAssigneesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BudgetApprovalGroupAssigneesMaxOrderBy>;
  min?: InputMaybe<BudgetApprovalGroupAssigneesMinOrderBy>;
};

/** input type for inserting array relation for remote table "budget_approval_group_assignees" */
export type BudgetApprovalGroupAssigneesArrRelInsertInput = {
  data: Array<BudgetApprovalGroupAssigneesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BudgetApprovalGroupAssigneesOnConflict>;
};

/** columns and relationships of "budget_approval_group_assignees_assignees" */
export type BudgetApprovalGroupAssigneesAssignees = {
  __typename?: 'budget_approval_group_assignees_assignees';
  budgetApprovalGroupAssigneesId: Scalars['uuid']['output'];
  /** An object relationship */
  group: Maybe<Groups>;
  groupId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** order by aggregate values of table "budget_approval_group_assignees_assignees" */
export type BudgetApprovalGroupAssigneesAssigneesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BudgetApprovalGroupAssigneesAssigneesMaxOrderBy>;
  min?: InputMaybe<BudgetApprovalGroupAssigneesAssigneesMinOrderBy>;
};

/** input type for inserting array relation for remote table "budget_approval_group_assignees_assignees" */
export type BudgetApprovalGroupAssigneesAssigneesArrRelInsertInput = {
  data: Array<BudgetApprovalGroupAssigneesAssigneesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BudgetApprovalGroupAssigneesAssigneesOnConflict>;
};

/** Boolean expression to filter rows from the table "budget_approval_group_assignees_assignees". All fields are combined with a logical 'AND'. */
export type BudgetApprovalGroupAssigneesAssigneesBoolExp = {
  _and?: InputMaybe<Array<BudgetApprovalGroupAssigneesAssigneesBoolExp>>;
  _not?: InputMaybe<BudgetApprovalGroupAssigneesAssigneesBoolExp>;
  _or?: InputMaybe<Array<BudgetApprovalGroupAssigneesAssigneesBoolExp>>;
  budgetApprovalGroupAssigneesId?: InputMaybe<UuidComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "budget_approval_group_assignees_assignees" */
export enum BudgetApprovalGroupAssigneesAssigneesConstraint {
  /** unique or primary key constraint on columns "id" */
  BUDGET_APPROVAL_GROUP_ASSIGNEES_ASSIGNEES_PKEY = 'budget_approval_group_assignees_assignees_pkey'
}

/** input type for inserting data into table "budget_approval_group_assignees_assignees" */
export type BudgetApprovalGroupAssigneesAssigneesInsertInput = {
  budgetApprovalGroupAssigneesId?: InputMaybe<Scalars['uuid']['input']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "budget_approval_group_assignees_assignees" */
export type BudgetApprovalGroupAssigneesAssigneesMaxOrderBy = {
  budgetApprovalGroupAssigneesId?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "budget_approval_group_assignees_assignees" */
export type BudgetApprovalGroupAssigneesAssigneesMinOrderBy = {
  budgetApprovalGroupAssigneesId?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "budget_approval_group_assignees_assignees" */
export type BudgetApprovalGroupAssigneesAssigneesMutationResponse = {
  __typename?: 'budget_approval_group_assignees_assignees_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BudgetApprovalGroupAssigneesAssignees>;
};

/** on_conflict condition type for table "budget_approval_group_assignees_assignees" */
export type BudgetApprovalGroupAssigneesAssigneesOnConflict = {
  constraint: BudgetApprovalGroupAssigneesAssigneesConstraint;
  update_columns: Array<BudgetApprovalGroupAssigneesAssigneesUpdateColumn>;
  where?: InputMaybe<BudgetApprovalGroupAssigneesAssigneesBoolExp>;
};

/** Ordering options when selecting data from "budget_approval_group_assignees_assignees". */
export type BudgetApprovalGroupAssigneesAssigneesOrderBy = {
  budgetApprovalGroupAssigneesId?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: budget_approval_group_assignees_assignees */
export type BudgetApprovalGroupAssigneesAssigneesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "budget_approval_group_assignees_assignees" */
export enum BudgetApprovalGroupAssigneesAssigneesSelectColumn {
  /** column name */
  BUDGETAPPROVALGROUPASSIGNEESID = 'budgetApprovalGroupAssigneesId',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "budget_approval_group_assignees_assignees" */
export type BudgetApprovalGroupAssigneesAssigneesSetInput = {
  budgetApprovalGroupAssigneesId?: InputMaybe<Scalars['uuid']['input']>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "budget_approval_group_assignees_assignees" */
export enum BudgetApprovalGroupAssigneesAssigneesUpdateColumn {
  /** column name */
  BUDGETAPPROVALGROUPASSIGNEESID = 'budgetApprovalGroupAssigneesId',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  USERID = 'userId'
}

export type BudgetApprovalGroupAssigneesAssigneesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BudgetApprovalGroupAssigneesAssigneesSetInput>;
  /** filter the rows which have to be updated */
  where: BudgetApprovalGroupAssigneesAssigneesBoolExp;
};

/** Boolean expression to filter rows from the table "budget_approval_group_assignees". All fields are combined with a logical 'AND'. */
export type BudgetApprovalGroupAssigneesBoolExp = {
  _and?: InputMaybe<Array<BudgetApprovalGroupAssigneesBoolExp>>;
  _not?: InputMaybe<BudgetApprovalGroupAssigneesBoolExp>;
  _or?: InputMaybe<Array<BudgetApprovalGroupAssigneesBoolExp>>;
  assignees?: InputMaybe<BudgetApprovalGroupAssigneesAssigneesBoolExp>;
  budgetApprovalGroupId?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  custom_core_data_options?: InputMaybe<BudgetApprovalGroupAssigneesCustomCoreDataOptionsBoolExp>;
  department?: InputMaybe<DepartmentsBoolExp>;
  departmentId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lineItem?: InputMaybe<LineItemTypesBoolExp>;
  lineItemId?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  subsidiaryId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "budget_approval_group_assignees" */
export enum BudgetApprovalGroupAssigneesConstraint {
  /** unique or primary key constraint on columns "id" */
  BUDGET_APPROVAL_GROUP_ASSIGNEES_PKEY = 'budget_approval_group_assignees_pkey'
}

/** columns and relationships of "budget_approval_group_assignees_custom_core_data_options" */
export type BudgetApprovalGroupAssigneesCustomCoreDataOptions = {
  __typename?: 'budget_approval_group_assignees_custom_core_data_options';
  budget_approval_group_assignees_id: Scalars['uuid']['output'];
  /** An object relationship */
  custom_core_data: CustomCoreData;
  custom_core_data_id: Scalars['uuid']['output'];
  /** An object relationship */
  custom_core_data_option: CustomCoreDataOptions;
  custom_core_data_option_id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "budget_approval_group_assignees_custom_core_data_options" */
export type BudgetApprovalGroupAssigneesCustomCoreDataOptionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BudgetApprovalGroupAssigneesCustomCoreDataOptionsMaxOrderBy>;
  min?: InputMaybe<BudgetApprovalGroupAssigneesCustomCoreDataOptionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "budget_approval_group_assignees_custom_core_data_options" */
export type BudgetApprovalGroupAssigneesCustomCoreDataOptionsArrRelInsertInput = {
  data: Array<BudgetApprovalGroupAssigneesCustomCoreDataOptionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BudgetApprovalGroupAssigneesCustomCoreDataOptionsOnConflict>;
};

/** Boolean expression to filter rows from the table "budget_approval_group_assignees_custom_core_data_options". All fields are combined with a logical 'AND'. */
export type BudgetApprovalGroupAssigneesCustomCoreDataOptionsBoolExp = {
  _and?: InputMaybe<Array<BudgetApprovalGroupAssigneesCustomCoreDataOptionsBoolExp>>;
  _not?: InputMaybe<BudgetApprovalGroupAssigneesCustomCoreDataOptionsBoolExp>;
  _or?: InputMaybe<Array<BudgetApprovalGroupAssigneesCustomCoreDataOptionsBoolExp>>;
  budget_approval_group_assignees_id?: InputMaybe<UuidComparisonExp>;
  custom_core_data?: InputMaybe<CustomCoreDataBoolExp>;
  custom_core_data_id?: InputMaybe<UuidComparisonExp>;
  custom_core_data_option?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  custom_core_data_option_id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "budget_approval_group_assignees_custom_core_data_options" */
export enum BudgetApprovalGroupAssigneesCustomCoreDataOptionsConstraint {
  /** unique or primary key constraint on columns "custom_core_data_id", "budget_approval_group_assignees_id" */
  BUDGET_APPROVAL_GROUP_ASSIGNEES_CUSTOM_CORE_DATA_OPTIONS_PKEY = 'budget_approval_group_assignees_custom_core_data_options_pkey'
}

/** input type for inserting data into table "budget_approval_group_assignees_custom_core_data_options" */
export type BudgetApprovalGroupAssigneesCustomCoreDataOptionsInsertInput = {
  budget_approval_group_assignees_id?: InputMaybe<Scalars['uuid']['input']>;
  custom_core_data?: InputMaybe<CustomCoreDataObjRelInsertInput>;
  custom_core_data_id?: InputMaybe<Scalars['uuid']['input']>;
  custom_core_data_option?: InputMaybe<CustomCoreDataOptionsObjRelInsertInput>;
  custom_core_data_option_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "budget_approval_group_assignees_custom_core_data_options" */
export type BudgetApprovalGroupAssigneesCustomCoreDataOptionsMaxOrderBy = {
  budget_approval_group_assignees_id?: InputMaybe<OrderBy>;
  custom_core_data_id?: InputMaybe<OrderBy>;
  custom_core_data_option_id?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "budget_approval_group_assignees_custom_core_data_options" */
export type BudgetApprovalGroupAssigneesCustomCoreDataOptionsMinOrderBy = {
  budget_approval_group_assignees_id?: InputMaybe<OrderBy>;
  custom_core_data_id?: InputMaybe<OrderBy>;
  custom_core_data_option_id?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "budget_approval_group_assignees_custom_core_data_options" */
export type BudgetApprovalGroupAssigneesCustomCoreDataOptionsMutationResponse = {
  __typename?: 'budget_approval_group_assignees_custom_core_data_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BudgetApprovalGroupAssigneesCustomCoreDataOptions>;
};

/** on_conflict condition type for table "budget_approval_group_assignees_custom_core_data_options" */
export type BudgetApprovalGroupAssigneesCustomCoreDataOptionsOnConflict = {
  constraint: BudgetApprovalGroupAssigneesCustomCoreDataOptionsConstraint;
  update_columns: Array<BudgetApprovalGroupAssigneesCustomCoreDataOptionsUpdateColumn>;
  where?: InputMaybe<BudgetApprovalGroupAssigneesCustomCoreDataOptionsBoolExp>;
};

/** Ordering options when selecting data from "budget_approval_group_assignees_custom_core_data_options". */
export type BudgetApprovalGroupAssigneesCustomCoreDataOptionsOrderBy = {
  budget_approval_group_assignees_id?: InputMaybe<OrderBy>;
  custom_core_data?: InputMaybe<CustomCoreDataOrderBy>;
  custom_core_data_id?: InputMaybe<OrderBy>;
  custom_core_data_option?: InputMaybe<CustomCoreDataOptionsOrderBy>;
  custom_core_data_option_id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
};

/** select columns of table "budget_approval_group_assignees_custom_core_data_options" */
export enum BudgetApprovalGroupAssigneesCustomCoreDataOptionsSelectColumn {
  /** column name */
  BUDGET_APPROVAL_GROUP_ASSIGNEES_ID = 'budget_approval_group_assignees_id',
  /** column name */
  CUSTOM_CORE_DATA_ID = 'custom_core_data_id',
  /** column name */
  CUSTOM_CORE_DATA_OPTION_ID = 'custom_core_data_option_id',
  /** column name */
  ORGANISATION_ID = 'organisation_id'
}

/** placeholder for update columns of table "budget_approval_group_assignees_custom_core_data_options" (current role has no relevant permissions) */
export enum BudgetApprovalGroupAssigneesCustomCoreDataOptionsUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** input type for inserting data into table "budget_approval_group_assignees" */
export type BudgetApprovalGroupAssigneesInsertInput = {
  assignees?: InputMaybe<BudgetApprovalGroupAssigneesAssigneesArrRelInsertInput>;
  budgetApprovalGroupId?: InputMaybe<Scalars['uuid']['input']>;
  custom_core_data_options?: InputMaybe<BudgetApprovalGroupAssigneesCustomCoreDataOptionsArrRelInsertInput>;
  department?: InputMaybe<DepartmentsObjRelInsertInput>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  lineItem?: InputMaybe<LineItemTypesObjRelInsertInput>;
  lineItemId?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary?: InputMaybe<SubsidiariesObjRelInsertInput>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "budget_approval_group_assignees" */
export type BudgetApprovalGroupAssigneesMaxOrderBy = {
  budgetApprovalGroupId?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lineItemId?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "budget_approval_group_assignees" */
export type BudgetApprovalGroupAssigneesMinOrderBy = {
  budgetApprovalGroupId?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lineItemId?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "budget_approval_group_assignees" */
export type BudgetApprovalGroupAssigneesMutationResponse = {
  __typename?: 'budget_approval_group_assignees_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BudgetApprovalGroupAssignees>;
};

/** on_conflict condition type for table "budget_approval_group_assignees" */
export type BudgetApprovalGroupAssigneesOnConflict = {
  constraint: BudgetApprovalGroupAssigneesConstraint;
  update_columns: Array<BudgetApprovalGroupAssigneesUpdateColumn>;
  where?: InputMaybe<BudgetApprovalGroupAssigneesBoolExp>;
};

/** Ordering options when selecting data from "budget_approval_group_assignees". */
export type BudgetApprovalGroupAssigneesOrderBy = {
  assignees_aggregate?: InputMaybe<BudgetApprovalGroupAssigneesAssigneesAggregateOrderBy>;
  budgetApprovalGroupId?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  custom_core_data_options_aggregate?: InputMaybe<BudgetApprovalGroupAssigneesCustomCoreDataOptionsAggregateOrderBy>;
  department?: InputMaybe<DepartmentsOrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lineItem?: InputMaybe<LineItemTypesOrderBy>;
  lineItemId?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  subsidiary?: InputMaybe<SubsidiariesOrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: budget_approval_group_assignees */
export type BudgetApprovalGroupAssigneesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "budget_approval_group_assignees" */
export enum BudgetApprovalGroupAssigneesSelectColumn {
  /** column name */
  BUDGETAPPROVALGROUPID = 'budgetApprovalGroupId',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  ID = 'id',
  /** column name */
  LINEITEMID = 'lineItemId',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId'
}

/** input type for updating data in table "budget_approval_group_assignees" */
export type BudgetApprovalGroupAssigneesSetInput = {
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  lineItemId?: InputMaybe<Scalars['uuid']['input']>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "budget_approval_group_assignees" */
export enum BudgetApprovalGroupAssigneesUpdateColumn {
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  LINEITEMID = 'lineItemId',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId'
}

export type BudgetApprovalGroupAssigneesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BudgetApprovalGroupAssigneesSetInput>;
  /** filter the rows which have to be updated */
  where: BudgetApprovalGroupAssigneesBoolExp;
};

/** Boolean expression to filter rows from the table "budget_approval_group". All fields are combined with a logical 'AND'. */
export type BudgetApprovalGroupBoolExp = {
  _and?: InputMaybe<Array<BudgetApprovalGroupBoolExp>>;
  _not?: InputMaybe<BudgetApprovalGroupBoolExp>;
  _or?: InputMaybe<Array<BudgetApprovalGroupBoolExp>>;
  assignees?: InputMaybe<BudgetApprovalGroupAssigneesBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  selected_custom_core_data?: InputMaybe<BudgetApprovalGroupSelectedCustomCoreDataBoolExp>;
};

/** unique or primary key constraints on table "budget_approval_group" */
export enum BudgetApprovalGroupConstraint {
  /** unique or primary key constraint on columns "id" */
  BUDGET_APPROVAL_GROUP_PKEY = 'budget_approval_group_pkey'
}

/** input type for inserting data into table "budget_approval_group" */
export type BudgetApprovalGroupInsertInput = {
  assignees?: InputMaybe<BudgetApprovalGroupAssigneesArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  selected_custom_core_data?: InputMaybe<BudgetApprovalGroupSelectedCustomCoreDataArrRelInsertInput>;
};

/** response of any mutation on the table "budget_approval_group" */
export type BudgetApprovalGroupMutationResponse = {
  __typename?: 'budget_approval_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BudgetApprovalGroup>;
};

/** input type for inserting object relation for remote table "budget_approval_group" */
export type BudgetApprovalGroupObjRelInsertInput = {
  data: BudgetApprovalGroupInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BudgetApprovalGroupOnConflict>;
};

/** on_conflict condition type for table "budget_approval_group" */
export type BudgetApprovalGroupOnConflict = {
  constraint: BudgetApprovalGroupConstraint;
  update_columns: Array<BudgetApprovalGroupUpdateColumn>;
  where?: InputMaybe<BudgetApprovalGroupBoolExp>;
};

/** Ordering options when selecting data from "budget_approval_group". */
export type BudgetApprovalGroupOrderBy = {
  assignees_aggregate?: InputMaybe<BudgetApprovalGroupAssigneesAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  selected_custom_core_data_aggregate?: InputMaybe<BudgetApprovalGroupSelectedCustomCoreDataAggregateOrderBy>;
};

/** primary key columns input for table: budget_approval_group */
export type BudgetApprovalGroupPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "budget_approval_group" */
export enum BudgetApprovalGroupSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId'
}

/** columns and relationships of "budget_approval_group_selected_custom_core_data" */
export type BudgetApprovalGroupSelectedCustomCoreData = {
  __typename?: 'budget_approval_group_selected_custom_core_data';
  budget_approval_group_id: Scalars['uuid']['output'];
  /** An object relationship */
  custom_core_data: CustomCoreData;
  custom_core_data_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "budget_approval_group_selected_custom_core_data" */
export type BudgetApprovalGroupSelectedCustomCoreDataAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BudgetApprovalGroupSelectedCustomCoreDataMaxOrderBy>;
  min?: InputMaybe<BudgetApprovalGroupSelectedCustomCoreDataMinOrderBy>;
};

/** input type for inserting array relation for remote table "budget_approval_group_selected_custom_core_data" */
export type BudgetApprovalGroupSelectedCustomCoreDataArrRelInsertInput = {
  data: Array<BudgetApprovalGroupSelectedCustomCoreDataInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BudgetApprovalGroupSelectedCustomCoreDataOnConflict>;
};

/** Boolean expression to filter rows from the table "budget_approval_group_selected_custom_core_data". All fields are combined with a logical 'AND'. */
export type BudgetApprovalGroupSelectedCustomCoreDataBoolExp = {
  _and?: InputMaybe<Array<BudgetApprovalGroupSelectedCustomCoreDataBoolExp>>;
  _not?: InputMaybe<BudgetApprovalGroupSelectedCustomCoreDataBoolExp>;
  _or?: InputMaybe<Array<BudgetApprovalGroupSelectedCustomCoreDataBoolExp>>;
  budget_approval_group_id?: InputMaybe<UuidComparisonExp>;
  custom_core_data?: InputMaybe<CustomCoreDataBoolExp>;
  custom_core_data_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "budget_approval_group_selected_custom_core_data" */
export enum BudgetApprovalGroupSelectedCustomCoreDataConstraint {
  /** unique or primary key constraint on columns "custom_core_data_id", "budget_approval_group_id" */
  BUDGET_APPROVAL_GROUP_SELECTED_CUSTOM_CORE_DATA_PKEY = 'budget_approval_group_selected_custom_core_data_pkey'
}

/** input type for inserting data into table "budget_approval_group_selected_custom_core_data" */
export type BudgetApprovalGroupSelectedCustomCoreDataInsertInput = {
  budget_approval_group_id?: InputMaybe<Scalars['uuid']['input']>;
  custom_core_data?: InputMaybe<CustomCoreDataObjRelInsertInput>;
  custom_core_data_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "budget_approval_group_selected_custom_core_data" */
export type BudgetApprovalGroupSelectedCustomCoreDataMaxOrderBy = {
  budget_approval_group_id?: InputMaybe<OrderBy>;
  custom_core_data_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "budget_approval_group_selected_custom_core_data" */
export type BudgetApprovalGroupSelectedCustomCoreDataMinOrderBy = {
  budget_approval_group_id?: InputMaybe<OrderBy>;
  custom_core_data_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "budget_approval_group_selected_custom_core_data" */
export type BudgetApprovalGroupSelectedCustomCoreDataMutationResponse = {
  __typename?: 'budget_approval_group_selected_custom_core_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BudgetApprovalGroupSelectedCustomCoreData>;
};

/** on_conflict condition type for table "budget_approval_group_selected_custom_core_data" */
export type BudgetApprovalGroupSelectedCustomCoreDataOnConflict = {
  constraint: BudgetApprovalGroupSelectedCustomCoreDataConstraint;
  update_columns: Array<BudgetApprovalGroupSelectedCustomCoreDataUpdateColumn>;
  where?: InputMaybe<BudgetApprovalGroupSelectedCustomCoreDataBoolExp>;
};

/** Ordering options when selecting data from "budget_approval_group_selected_custom_core_data". */
export type BudgetApprovalGroupSelectedCustomCoreDataOrderBy = {
  budget_approval_group_id?: InputMaybe<OrderBy>;
  custom_core_data?: InputMaybe<CustomCoreDataOrderBy>;
  custom_core_data_id?: InputMaybe<OrderBy>;
};

/** select columns of table "budget_approval_group_selected_custom_core_data" */
export enum BudgetApprovalGroupSelectedCustomCoreDataSelectColumn {
  /** column name */
  BUDGET_APPROVAL_GROUP_ID = 'budget_approval_group_id',
  /** column name */
  CUSTOM_CORE_DATA_ID = 'custom_core_data_id'
}

/** placeholder for update columns of table "budget_approval_group_selected_custom_core_data" (current role has no relevant permissions) */
export enum BudgetApprovalGroupSelectedCustomCoreDataUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** input type for updating data in table "budget_approval_group" */
export type BudgetApprovalGroupSetInput = {
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "budget_approval_group" */
export enum BudgetApprovalGroupUpdateColumn {
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  NAME = 'name'
}

export type BudgetApprovalGroupUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BudgetApprovalGroupSetInput>;
  /** filter the rows which have to be updated */
  where: BudgetApprovalGroupBoolExp;
};

/** columns and relationships of "budget_approval_threshold" */
export type BudgetApprovalThreshold = {
  __typename?: 'budget_approval_threshold';
  /** An array relationship */
  budget_approval_threshold_groups: Array<BudgetApprovalThresholdGroup>;
  created_at: Scalars['timestamptz']['output'];
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  departments: Array<BudgetApprovalThresholdDepartment>;
  id: Scalars['uuid']['output'];
  inBudget: Maybe<Scalars['Boolean']['output']>;
  maxValue: Maybe<Scalars['float8']['output']>;
  minValue: Scalars['float8']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "budget_approval_threshold" */
export type BudgetApprovalThresholdBudgetApprovalThresholdGroupsArgs = {
  distinct_on: InputMaybe<Array<BudgetApprovalThresholdGroupSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetApprovalThresholdGroupOrderBy>>;
  where: InputMaybe<BudgetApprovalThresholdGroupBoolExp>;
};


/** columns and relationships of "budget_approval_threshold" */
export type BudgetApprovalThresholdDepartmentsArgs = {
  distinct_on: InputMaybe<Array<BudgetApprovalThresholdDepartmentSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetApprovalThresholdDepartmentOrderBy>>;
  where: InputMaybe<BudgetApprovalThresholdDepartmentBoolExp>;
};

/** Boolean expression to filter rows from the table "budget_approval_threshold". All fields are combined with a logical 'AND'. */
export type BudgetApprovalThresholdBoolExp = {
  _and?: InputMaybe<Array<BudgetApprovalThresholdBoolExp>>;
  _not?: InputMaybe<BudgetApprovalThresholdBoolExp>;
  _or?: InputMaybe<Array<BudgetApprovalThresholdBoolExp>>;
  budget_approval_threshold_groups?: InputMaybe<BudgetApprovalThresholdGroupBoolExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  departments?: InputMaybe<BudgetApprovalThresholdDepartmentBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  inBudget?: InputMaybe<BooleanComparisonExp>;
  maxValue?: InputMaybe<Float8ComparisonExp>;
  minValue?: InputMaybe<Float8ComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "budget_approval_threshold" */
export enum BudgetApprovalThresholdConstraint {
  /** unique or primary key constraint on columns "id" */
  BUDGET_APPROVAL_THRESHOLD_PKEY = 'budget_approval_threshold_pkey'
}

/** columns and relationships of "budget_approval_threshold_department" */
export type BudgetApprovalThresholdDepartment = {
  __typename?: 'budget_approval_threshold_department';
  /** An object relationship */
  department: Departments;
  departmentId: Scalars['uuid']['output'];
  /** An object relationship */
  threshold: BudgetApprovalThreshold;
  thresholdId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "budget_approval_threshold_department" */
export type BudgetApprovalThresholdDepartmentAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BudgetApprovalThresholdDepartmentMaxOrderBy>;
  min?: InputMaybe<BudgetApprovalThresholdDepartmentMinOrderBy>;
};

/** input type for inserting array relation for remote table "budget_approval_threshold_department" */
export type BudgetApprovalThresholdDepartmentArrRelInsertInput = {
  data: Array<BudgetApprovalThresholdDepartmentInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BudgetApprovalThresholdDepartmentOnConflict>;
};

/** Boolean expression to filter rows from the table "budget_approval_threshold_department". All fields are combined with a logical 'AND'. */
export type BudgetApprovalThresholdDepartmentBoolExp = {
  _and?: InputMaybe<Array<BudgetApprovalThresholdDepartmentBoolExp>>;
  _not?: InputMaybe<BudgetApprovalThresholdDepartmentBoolExp>;
  _or?: InputMaybe<Array<BudgetApprovalThresholdDepartmentBoolExp>>;
  department?: InputMaybe<DepartmentsBoolExp>;
  departmentId?: InputMaybe<UuidComparisonExp>;
  threshold?: InputMaybe<BudgetApprovalThresholdBoolExp>;
  thresholdId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "budget_approval_threshold_department" */
export enum BudgetApprovalThresholdDepartmentConstraint {
  /** unique or primary key constraint on columns "department_id", "threshold_id" */
  BUDGET_APPROVAL_THRESHOLD_DEPARTMENT_PKEY = 'budget_approval_threshold_department_pkey'
}

/** input type for inserting data into table "budget_approval_threshold_department" */
export type BudgetApprovalThresholdDepartmentInsertInput = {
  department?: InputMaybe<DepartmentsObjRelInsertInput>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  threshold?: InputMaybe<BudgetApprovalThresholdObjRelInsertInput>;
  thresholdId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "budget_approval_threshold_department" */
export type BudgetApprovalThresholdDepartmentMaxOrderBy = {
  departmentId?: InputMaybe<OrderBy>;
  thresholdId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "budget_approval_threshold_department" */
export type BudgetApprovalThresholdDepartmentMinOrderBy = {
  departmentId?: InputMaybe<OrderBy>;
  thresholdId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "budget_approval_threshold_department" */
export type BudgetApprovalThresholdDepartmentMutationResponse = {
  __typename?: 'budget_approval_threshold_department_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BudgetApprovalThresholdDepartment>;
};

/** on_conflict condition type for table "budget_approval_threshold_department" */
export type BudgetApprovalThresholdDepartmentOnConflict = {
  constraint: BudgetApprovalThresholdDepartmentConstraint;
  update_columns: Array<BudgetApprovalThresholdDepartmentUpdateColumn>;
  where?: InputMaybe<BudgetApprovalThresholdDepartmentBoolExp>;
};

/** Ordering options when selecting data from "budget_approval_threshold_department". */
export type BudgetApprovalThresholdDepartmentOrderBy = {
  department?: InputMaybe<DepartmentsOrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  threshold?: InputMaybe<BudgetApprovalThresholdOrderBy>;
  thresholdId?: InputMaybe<OrderBy>;
};

/** select columns of table "budget_approval_threshold_department" */
export enum BudgetApprovalThresholdDepartmentSelectColumn {
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  THRESHOLDID = 'thresholdId'
}

/** placeholder for update columns of table "budget_approval_threshold_department" (current role has no relevant permissions) */
export enum BudgetApprovalThresholdDepartmentUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "budget_approval_threshold_group" */
export type BudgetApprovalThresholdGroup = {
  __typename?: 'budget_approval_threshold_group';
  approvalGroupId: Scalars['uuid']['output'];
  /** An object relationship */
  budget_approval_group: BudgetApprovalGroup;
  id: Scalars['uuid']['output'];
  isApproval: Scalars['Boolean']['output'];
  organisationId: Scalars['uuid']['output'];
  thresholdId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "budget_approval_threshold_group" */
export type BudgetApprovalThresholdGroupAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BudgetApprovalThresholdGroupMaxOrderBy>;
  min?: InputMaybe<BudgetApprovalThresholdGroupMinOrderBy>;
};

/** input type for inserting array relation for remote table "budget_approval_threshold_group" */
export type BudgetApprovalThresholdGroupArrRelInsertInput = {
  data: Array<BudgetApprovalThresholdGroupInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<BudgetApprovalThresholdGroupOnConflict>;
};

/** Boolean expression to filter rows from the table "budget_approval_threshold_group". All fields are combined with a logical 'AND'. */
export type BudgetApprovalThresholdGroupBoolExp = {
  _and?: InputMaybe<Array<BudgetApprovalThresholdGroupBoolExp>>;
  _not?: InputMaybe<BudgetApprovalThresholdGroupBoolExp>;
  _or?: InputMaybe<Array<BudgetApprovalThresholdGroupBoolExp>>;
  approvalGroupId?: InputMaybe<UuidComparisonExp>;
  budget_approval_group?: InputMaybe<BudgetApprovalGroupBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isApproval?: InputMaybe<BooleanComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  thresholdId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "budget_approval_threshold_group" */
export enum BudgetApprovalThresholdGroupConstraint {
  /** unique or primary key constraint on columns "id" */
  BUDGET_APPROVAL_THRESHOLD_GROUP_PKEY = 'budget_approval_threshold_group_pkey'
}

/** input type for inserting data into table "budget_approval_threshold_group" */
export type BudgetApprovalThresholdGroupInsertInput = {
  approvalGroupId?: InputMaybe<Scalars['uuid']['input']>;
  budget_approval_group?: InputMaybe<BudgetApprovalGroupObjRelInsertInput>;
  isApproval?: InputMaybe<Scalars['Boolean']['input']>;
  thresholdId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "budget_approval_threshold_group" */
export type BudgetApprovalThresholdGroupMaxOrderBy = {
  approvalGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  thresholdId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "budget_approval_threshold_group" */
export type BudgetApprovalThresholdGroupMinOrderBy = {
  approvalGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  thresholdId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "budget_approval_threshold_group" */
export type BudgetApprovalThresholdGroupMutationResponse = {
  __typename?: 'budget_approval_threshold_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BudgetApprovalThresholdGroup>;
};

/** on_conflict condition type for table "budget_approval_threshold_group" */
export type BudgetApprovalThresholdGroupOnConflict = {
  constraint: BudgetApprovalThresholdGroupConstraint;
  update_columns: Array<BudgetApprovalThresholdGroupUpdateColumn>;
  where?: InputMaybe<BudgetApprovalThresholdGroupBoolExp>;
};

/** Ordering options when selecting data from "budget_approval_threshold_group". */
export type BudgetApprovalThresholdGroupOrderBy = {
  approvalGroupId?: InputMaybe<OrderBy>;
  budget_approval_group?: InputMaybe<BudgetApprovalGroupOrderBy>;
  id?: InputMaybe<OrderBy>;
  isApproval?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  thresholdId?: InputMaybe<OrderBy>;
};

/** select columns of table "budget_approval_threshold_group" */
export enum BudgetApprovalThresholdGroupSelectColumn {
  /** column name */
  APPROVALGROUPID = 'approvalGroupId',
  /** column name */
  ID = 'id',
  /** column name */
  ISAPPROVAL = 'isApproval',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  THRESHOLDID = 'thresholdId'
}

/** placeholder for update columns of table "budget_approval_threshold_group" (current role has no relevant permissions) */
export enum BudgetApprovalThresholdGroupUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** input type for incrementing numeric columns in table "budget_approval_threshold" */
export type BudgetApprovalThresholdIncInput = {
  maxValue?: InputMaybe<Scalars['float8']['input']>;
  minValue?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "budget_approval_threshold" */
export type BudgetApprovalThresholdInsertInput = {
  budget_approval_threshold_groups?: InputMaybe<BudgetApprovalThresholdGroupArrRelInsertInput>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  departments?: InputMaybe<BudgetApprovalThresholdDepartmentArrRelInsertInput>;
  inBudget?: InputMaybe<Scalars['Boolean']['input']>;
  maxValue?: InputMaybe<Scalars['float8']['input']>;
  minValue?: InputMaybe<Scalars['float8']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "budget_approval_threshold" */
export type BudgetApprovalThresholdMutationResponse = {
  __typename?: 'budget_approval_threshold_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BudgetApprovalThreshold>;
};

/** input type for inserting object relation for remote table "budget_approval_threshold" */
export type BudgetApprovalThresholdObjRelInsertInput = {
  data: BudgetApprovalThresholdInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BudgetApprovalThresholdOnConflict>;
};

/** on_conflict condition type for table "budget_approval_threshold" */
export type BudgetApprovalThresholdOnConflict = {
  constraint: BudgetApprovalThresholdConstraint;
  update_columns: Array<BudgetApprovalThresholdUpdateColumn>;
  where?: InputMaybe<BudgetApprovalThresholdBoolExp>;
};

/** Ordering options when selecting data from "budget_approval_threshold". */
export type BudgetApprovalThresholdOrderBy = {
  budget_approval_threshold_groups_aggregate?: InputMaybe<BudgetApprovalThresholdGroupAggregateOrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  departments_aggregate?: InputMaybe<BudgetApprovalThresholdDepartmentAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  inBudget?: InputMaybe<OrderBy>;
  maxValue?: InputMaybe<OrderBy>;
  minValue?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: budget_approval_threshold */
export type BudgetApprovalThresholdPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "budget_approval_threshold" */
export enum BudgetApprovalThresholdSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  ID = 'id',
  /** column name */
  INBUDGET = 'inBudget',
  /** column name */
  MAXVALUE = 'maxValue',
  /** column name */
  MINVALUE = 'minValue',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "budget_approval_threshold" */
export type BudgetApprovalThresholdSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  inBudget?: InputMaybe<Scalars['Boolean']['input']>;
  maxValue?: InputMaybe<Scalars['float8']['input']>;
  minValue?: InputMaybe<Scalars['float8']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "budget_approval_threshold" */
export enum BudgetApprovalThresholdUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  INBUDGET = 'inBudget',
  /** column name */
  MAXVALUE = 'maxValue',
  /** column name */
  MINVALUE = 'minValue',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type BudgetApprovalThresholdUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BudgetApprovalThresholdIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BudgetApprovalThresholdSetInput>;
  /** filter the rows which have to be updated */
  where: BudgetApprovalThresholdBoolExp;
};

/** columns and relationships of "budgets" */
export type Budgets = {
  __typename?: 'budgets';
  amount: Scalars['numeric']['output'];
  /** An object relationship */
  budgets_organisation_fx_rate: OrganisationFxRates;
  /** An array relationship */
  budgets_requests: Array<Requests>;
  /** An aggregate relationship */
  budgets_requests_aggregate: RequestsAggregate;
  createdAt: Scalars['timestamptz']['output'];
  currency_id: Scalars['uuid']['output'];
  externalId: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  status: Scalars['budgetStatus']['output'];
};


/** columns and relationships of "budgets" */
export type BudgetsBudgetsRequestsArgs = {
  distinct_on: InputMaybe<Array<RequestsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestsOrderBy>>;
  where: InputMaybe<RequestsBoolExp>;
};


/** columns and relationships of "budgets" */
export type BudgetsBudgetsRequestsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestsOrderBy>>;
  where: InputMaybe<RequestsBoolExp>;
};

/** Boolean expression to filter rows from the table "budgets". All fields are combined with a logical 'AND'. */
export type BudgetsBoolExp = {
  _and?: InputMaybe<Array<BudgetsBoolExp>>;
  _not?: InputMaybe<BudgetsBoolExp>;
  _or?: InputMaybe<Array<BudgetsBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  budgets_organisation_fx_rate?: InputMaybe<OrganisationFxRatesBoolExp>;
  budgets_requests?: InputMaybe<RequestsBoolExp>;
  budgets_requests_aggregate?: InputMaybe<RequestsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency_id?: InputMaybe<UuidComparisonExp>;
  externalId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "budgets" */
export enum BudgetsConstraint {
  /** unique or primary key constraint on columns "id" */
  BUDGETS_PKEY = 'budgets_pkey'
}

/** input type for incrementing numeric columns in table "budgets" */
export type BudgetsIncInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "budgets" */
export type BudgetsInsertInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  budgets_organisation_fx_rate?: InputMaybe<OrganisationFxRatesObjRelInsertInput>;
  budgets_requests?: InputMaybe<RequestsArrRelInsertInput>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "budgets" */
export type BudgetsMutationResponse = {
  __typename?: 'budgets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Budgets>;
};

/** input type for inserting object relation for remote table "budgets" */
export type BudgetsObjRelInsertInput = {
  data: BudgetsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<BudgetsOnConflict>;
};

/** on_conflict condition type for table "budgets" */
export type BudgetsOnConflict = {
  constraint: BudgetsConstraint;
  update_columns: Array<BudgetsUpdateColumn>;
  where?: InputMaybe<BudgetsBoolExp>;
};

/** Ordering options when selecting data from "budgets". */
export type BudgetsOrderBy = {
  amount?: InputMaybe<OrderBy>;
  budgets_organisation_fx_rate?: InputMaybe<OrganisationFxRatesOrderBy>;
  budgets_requests_aggregate?: InputMaybe<RequestsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  externalId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: budgets */
export type BudgetsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "budgets" */
export enum BudgetsSelectColumn {
  /** column name */
  AMOUNT = 'amount',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CURRENCY_ID = 'currency_id',
  /** column name */
  EXTERNALID = 'externalId',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  STATUS = 'status'
}

/** input type for updating data in table "budgets" */
export type BudgetsSetInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "budgets" */
export enum BudgetsUpdateColumn {
  /** column name */
  AMOUNT = 'amount',
  /** column name */
  CURRENCY_ID = 'currency_id',
  /** column name */
  EXTERNALID = 'externalId',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  STATUS = 'status'
}

export type BudgetsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BudgetsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BudgetsSetInput>;
  /** filter the rows which have to be updated */
  where: BudgetsBoolExp;
};

/** Stores information and progress about bulk document upload */
export type BulkDocumentsUploads = {
  __typename?: 'bulk_documents_uploads';
  archivePath: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  csvData: Maybe<Scalars['jsonb']['output']>;
  documentsCount: Maybe<Scalars['Int']['output']>;
  failedDocumentsCount: Scalars['Int']['output'];
  failedFileNames: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  processedDocumentsCount: Scalars['Int']['output'];
  rejectedFiles: Maybe<Scalars['jsonb']['output']>;
  scheduledDocumentsCount: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** Stores information and progress about bulk document upload */
export type BulkDocumentsUploadsCsvDataArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** Stores information and progress about bulk document upload */
export type BulkDocumentsUploadsFailedFileNamesArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** Stores information and progress about bulk document upload */
export type BulkDocumentsUploadsRejectedFilesArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BulkDocumentsUploadsAppendInput = {
  csvData?: InputMaybe<Scalars['jsonb']['input']>;
  failedFileNames?: InputMaybe<Scalars['jsonb']['input']>;
  rejectedFiles?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "bulk_documents_uploads". All fields are combined with a logical 'AND'. */
export type BulkDocumentsUploadsBoolExp = {
  _and?: InputMaybe<Array<BulkDocumentsUploadsBoolExp>>;
  _not?: InputMaybe<BulkDocumentsUploadsBoolExp>;
  _or?: InputMaybe<Array<BulkDocumentsUploadsBoolExp>>;
  archivePath?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  csvData?: InputMaybe<JsonbComparisonExp>;
  documentsCount?: InputMaybe<IntComparisonExp>;
  failedDocumentsCount?: InputMaybe<IntComparisonExp>;
  failedFileNames?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  processedDocumentsCount?: InputMaybe<IntComparisonExp>;
  rejectedFiles?: InputMaybe<JsonbComparisonExp>;
  scheduledDocumentsCount?: InputMaybe<IntComparisonExp>;
  state?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "bulk_documents_uploads" */
export enum BulkDocumentsUploadsConstraint {
  /** unique or primary key constraint on columns "id" */
  BULK_DOCUMENTS_UPLOADS_PKEY = 'bulk_documents_uploads_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BulkDocumentsUploadsDeleteAtPathInput = {
  csvData?: InputMaybe<Array<Scalars['String']['input']>>;
  failedFileNames?: InputMaybe<Array<Scalars['String']['input']>>;
  rejectedFiles?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BulkDocumentsUploadsDeleteElemInput = {
  csvData?: InputMaybe<Scalars['Int']['input']>;
  failedFileNames?: InputMaybe<Scalars['Int']['input']>;
  rejectedFiles?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BulkDocumentsUploadsDeleteKeyInput = {
  csvData?: InputMaybe<Scalars['String']['input']>;
  failedFileNames?: InputMaybe<Scalars['String']['input']>;
  rejectedFiles?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "bulk_documents_uploads" */
export type BulkDocumentsUploadsIncInput = {
  documentsCount?: InputMaybe<Scalars['Int']['input']>;
  failedDocumentsCount?: InputMaybe<Scalars['Int']['input']>;
  processedDocumentsCount?: InputMaybe<Scalars['Int']['input']>;
  scheduledDocumentsCount?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "bulk_documents_uploads" */
export type BulkDocumentsUploadsInsertInput = {
  archivePath?: InputMaybe<Scalars['String']['input']>;
  csvData?: InputMaybe<Scalars['jsonb']['input']>;
  documentsCount?: InputMaybe<Scalars['Int']['input']>;
  rejectedFiles?: InputMaybe<Scalars['jsonb']['input']>;
  scheduledDocumentsCount?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "bulk_documents_uploads" */
export type BulkDocumentsUploadsMutationResponse = {
  __typename?: 'bulk_documents_uploads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BulkDocumentsUploads>;
};

/** on_conflict condition type for table "bulk_documents_uploads" */
export type BulkDocumentsUploadsOnConflict = {
  constraint: BulkDocumentsUploadsConstraint;
  update_columns: Array<BulkDocumentsUploadsUpdateColumn>;
  where?: InputMaybe<BulkDocumentsUploadsBoolExp>;
};

/** Ordering options when selecting data from "bulk_documents_uploads". */
export type BulkDocumentsUploadsOrderBy = {
  archivePath?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  csvData?: InputMaybe<OrderBy>;
  documentsCount?: InputMaybe<OrderBy>;
  failedDocumentsCount?: InputMaybe<OrderBy>;
  failedFileNames?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  processedDocumentsCount?: InputMaybe<OrderBy>;
  rejectedFiles?: InputMaybe<OrderBy>;
  scheduledDocumentsCount?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: bulk_documents_uploads */
export type BulkDocumentsUploadsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BulkDocumentsUploadsPrependInput = {
  csvData?: InputMaybe<Scalars['jsonb']['input']>;
  failedFileNames?: InputMaybe<Scalars['jsonb']['input']>;
  rejectedFiles?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "bulk_documents_uploads" */
export enum BulkDocumentsUploadsSelectColumn {
  /** column name */
  ARCHIVEPATH = 'archivePath',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CSVDATA = 'csvData',
  /** column name */
  DOCUMENTSCOUNT = 'documentsCount',
  /** column name */
  FAILEDDOCUMENTSCOUNT = 'failedDocumentsCount',
  /** column name */
  FAILEDFILENAMES = 'failedFileNames',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  PROCESSEDDOCUMENTSCOUNT = 'processedDocumentsCount',
  /** column name */
  REJECTEDFILES = 'rejectedFiles',
  /** column name */
  SCHEDULEDDOCUMENTSCOUNT = 'scheduledDocumentsCount',
  /** column name */
  STATE = 'state',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "bulk_documents_uploads" */
export type BulkDocumentsUploadsSetInput = {
  csvData?: InputMaybe<Scalars['jsonb']['input']>;
  documentsCount?: InputMaybe<Scalars['Int']['input']>;
  failedDocumentsCount?: InputMaybe<Scalars['Int']['input']>;
  failedFileNames?: InputMaybe<Scalars['jsonb']['input']>;
  processedDocumentsCount?: InputMaybe<Scalars['Int']['input']>;
  rejectedFiles?: InputMaybe<Scalars['jsonb']['input']>;
  scheduledDocumentsCount?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "bulk_documents_uploads" */
export type BulkDocumentsUploadsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: BulkDocumentsUploadsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BulkDocumentsUploadsStreamCursorValueInput = {
  archivePath?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  csvData?: InputMaybe<Scalars['jsonb']['input']>;
  documentsCount?: InputMaybe<Scalars['Int']['input']>;
  failedDocumentsCount?: InputMaybe<Scalars['Int']['input']>;
  failedFileNames?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  processedDocumentsCount?: InputMaybe<Scalars['Int']['input']>;
  rejectedFiles?: InputMaybe<Scalars['jsonb']['input']>;
  scheduledDocumentsCount?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "bulk_documents_uploads" */
export enum BulkDocumentsUploadsUpdateColumn {
  /** column name */
  CSVDATA = 'csvData',
  /** column name */
  DOCUMENTSCOUNT = 'documentsCount',
  /** column name */
  FAILEDDOCUMENTSCOUNT = 'failedDocumentsCount',
  /** column name */
  FAILEDFILENAMES = 'failedFileNames',
  /** column name */
  PROCESSEDDOCUMENTSCOUNT = 'processedDocumentsCount',
  /** column name */
  REJECTEDFILES = 'rejectedFiles',
  /** column name */
  SCHEDULEDDOCUMENTSCOUNT = 'scheduledDocumentsCount',
  /** column name */
  STATE = 'state'
}

export type BulkDocumentsUploadsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BulkDocumentsUploadsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<BulkDocumentsUploadsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<BulkDocumentsUploadsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<BulkDocumentsUploadsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BulkDocumentsUploadsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BulkDocumentsUploadsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BulkDocumentsUploadsSetInput>;
  /** filter the rows which have to be updated */
  where: BulkDocumentsUploadsBoolExp;
};

/** columns and relationships of "categories" */
export type Categories = {
  __typename?: 'categories';
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  parent: Maybe<Categories>;
  parentId: Maybe<Scalars['uuid']['output']>;
  pathLevel: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "categories". All fields are combined with a logical 'AND'. */
export type CategoriesBoolExp = {
  _and?: InputMaybe<Array<CategoriesBoolExp>>;
  _not?: InputMaybe<CategoriesBoolExp>;
  _or?: InputMaybe<Array<CategoriesBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  parent?: InputMaybe<CategoriesBoolExp>;
  parentId?: InputMaybe<UuidComparisonExp>;
  pathLevel?: InputMaybe<IntComparisonExp>;
};

/** Ordering options when selecting data from "categories". */
export type CategoriesOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  parent?: InputMaybe<CategoriesOrderBy>;
  parentId?: InputMaybe<OrderBy>;
  pathLevel?: InputMaybe<OrderBy>;
};

/** select columns of table "categories" */
export enum CategoriesSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PARENTID = 'parentId',
  /** column name */
  PATHLEVEL = 'pathLevel'
}

/** Streaming cursor of the table "categories" */
export type CategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CategoriesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  pathLevel?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "category" */
export type Category = {
  __typename?: 'category';
  description: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  engagements: Array<Engagements>;
  /** An aggregate relationship */
  engagements_aggregate: EngagementsAggregate;
  value: Scalars['String']['output'];
};


/** columns and relationships of "category" */
export type CategoryEngagementsArgs = {
  distinct_on: InputMaybe<Array<EngagementsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EngagementsOrderBy>>;
  where: InputMaybe<EngagementsBoolExp>;
};


/** columns and relationships of "category" */
export type CategoryEngagementsAggregateArgs = {
  distinct_on: InputMaybe<Array<EngagementsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EngagementsOrderBy>>;
  where: InputMaybe<EngagementsBoolExp>;
};

/** Boolean expression to filter rows from the table "category". All fields are combined with a logical 'AND'. */
export type CategoryBoolExp = {
  _and?: InputMaybe<Array<CategoryBoolExp>>;
  _not?: InputMaybe<CategoryBoolExp>;
  _or?: InputMaybe<Array<CategoryBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  engagements?: InputMaybe<EngagementsBoolExp>;
  engagements_aggregate?: InputMaybe<EngagementsAggregateBoolExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum CategoryEnum {
  /** Consulting / Professional Services */
  CONSULTING_OR_PROFESSIONAL_SERVICES = 'CONSULTING_OR_PROFESSIONAL_SERVICES',
  /** Hardware / Equipment */
  HARDWARE_OR_EQUIPMENT = 'HARDWARE_OR_EQUIPMENT',
  /** Other */
  OTHER = 'OTHER',
  /** Software */
  SOFTWARE = 'SOFTWARE'
}

/** Boolean expression to compare columns of type "category_enum". All fields are combined with logical 'AND'. */
export type CategoryEnumComparisonExp = {
  _eq?: InputMaybe<CategoryEnum>;
  _in?: InputMaybe<Array<CategoryEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<CategoryEnum>;
  _nin?: InputMaybe<Array<CategoryEnum>>;
};

/** Ordering options when selecting data from "category". */
export type CategoryOrderBy = {
  description?: InputMaybe<OrderBy>;
  engagements_aggregate?: InputMaybe<EngagementsAggregateOrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "category" */
export enum CategorySelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** columns and relationships of "config_translations" */
export type ConfigTranslations = {
  __typename?: 'config_translations';
  createdAt: Scalars['timestamptz']['output'];
  entityId: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  key: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  sourceHash: Maybe<Scalars['String']['output']>;
  translationSource: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "config_translations". All fields are combined with a logical 'AND'. */
export type ConfigTranslationsBoolExp = {
  _and?: InputMaybe<Array<ConfigTranslationsBoolExp>>;
  _not?: InputMaybe<ConfigTranslationsBoolExp>;
  _or?: InputMaybe<Array<ConfigTranslationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  entityId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
  locale?: InputMaybe<StringComparisonExp>;
  namespace?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  sourceHash?: InputMaybe<StringComparisonExp>;
  translationSource?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "config_translations" */
export enum ConfigTranslationsConstraint {
  /** unique or primary key constraint on columns "key", "organisation_id", "locale", "namespace", "entity_id" */
  CONFIG_TRANSLATIONS_LOCALE_NAMESPACE_ENTITY_ID_KEY_KEY = 'config_translations_locale_namespace_entity_id_key_key',
  /** unique or primary key constraint on columns "id" */
  CONFIG_TRANSLATIONS_PKEY = 'config_translations_pkey'
}

/** input type for inserting data into table "config_translations" */
export type ConfigTranslationsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  sourceHash?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "config_translations" */
export type ConfigTranslationsMutationResponse = {
  __typename?: 'config_translations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ConfigTranslations>;
};

/** on_conflict condition type for table "config_translations" */
export type ConfigTranslationsOnConflict = {
  constraint: ConfigTranslationsConstraint;
  update_columns: Array<ConfigTranslationsUpdateColumn>;
  where?: InputMaybe<ConfigTranslationsBoolExp>;
};

/** Ordering options when selecting data from "config_translations". */
export type ConfigTranslationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  entityId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  namespace?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  sourceHash?: InputMaybe<OrderBy>;
  translationSource?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: config_translations */
export type ConfigTranslationsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "config_translations" */
export enum ConfigTranslationsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ENTITYID = 'entityId',
  /** column name */
  ID = 'id',
  /** column name */
  KEY = 'key',
  /** column name */
  LOCALE = 'locale',
  /** column name */
  NAMESPACE = 'namespace',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  SOURCEHASH = 'sourceHash',
  /** column name */
  TRANSLATIONSOURCE = 'translationSource',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "config_translations" */
export type ConfigTranslationsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  sourceHash?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "config_translations" */
export type ConfigTranslationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ConfigTranslationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ConfigTranslationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  sourceHash?: InputMaybe<Scalars['String']['input']>;
  translationSource?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "config_translations" */
export enum ConfigTranslationsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ENTITYID = 'entityId',
  /** column name */
  ID = 'id',
  /** column name */
  KEY = 'key',
  /** column name */
  LOCALE = 'locale',
  /** column name */
  NAMESPACE = 'namespace',
  /** column name */
  SOURCEHASH = 'sourceHash',
  /** column name */
  TRANSLATIONSOURCE = 'translationSource',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  VALUE = 'value'
}

export type ConfigTranslationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ConfigTranslationsSetInput>;
  /** filter the rows which have to be updated */
  where: ConfigTranslationsBoolExp;
};

/** columns and relationships of "core_data" */
export type CoreData = {
  __typename?: 'core_data';
  /** An object relationship */
  address: Maybe<Addresses>;
  /** An array relationship */
  coreDataDependencies: Array<CoreDataDependencies>;
  /** An aggregate relationship */
  coreDataDependencies_aggregate: CoreDataDependenciesAggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  currency: Maybe<OrganisationFxRates>;
  /** An object relationship */
  customCoreDataOption: Maybe<CustomCoreDataOptions>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  department: Maybe<Departments>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lineItemType: Maybe<LineItemTypes>;
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  /** An object relationship */
  paymentTerm: Maybe<PaymentTerms>;
  /** An object relationship */
  subsidiary: Maybe<Subsidiaries>;
  type: Scalars['String']['output'];
};


/** columns and relationships of "core_data" */
export type CoreDataCoreDataDependenciesArgs = {
  distinct_on: InputMaybe<Array<CoreDataDependenciesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CoreDataDependenciesOrderBy>>;
  where: InputMaybe<CoreDataDependenciesBoolExp>;
};


/** columns and relationships of "core_data" */
export type CoreDataCoreDataDependenciesAggregateArgs = {
  distinct_on: InputMaybe<Array<CoreDataDependenciesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CoreDataDependenciesOrderBy>>;
  where: InputMaybe<CoreDataDependenciesBoolExp>;
};

/** Boolean expression to filter rows from the table "core_data". All fields are combined with a logical 'AND'. */
export type CoreDataBoolExp = {
  _and?: InputMaybe<Array<CoreDataBoolExp>>;
  _not?: InputMaybe<CoreDataBoolExp>;
  _or?: InputMaybe<Array<CoreDataBoolExp>>;
  address?: InputMaybe<AddressesBoolExp>;
  coreDataDependencies?: InputMaybe<CoreDataDependenciesBoolExp>;
  coreDataDependencies_aggregate?: InputMaybe<CoreDataDependenciesAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<OrganisationFxRatesBoolExp>;
  customCoreDataOption?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<DepartmentsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lineItemType?: InputMaybe<LineItemTypesBoolExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentTerm?: InputMaybe<PaymentTermsBoolExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** columns and relationships of "core_data_dependencies" */
export type CoreDataDependencies = {
  __typename?: 'core_data_dependencies';
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  coreDataType: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  dependencyCoreData: Maybe<CoreData>;
  dependencyCoreDataId: Maybe<Scalars['uuid']['output']>;
  dependencyCoreDataType: Scalars['String']['output'];
  /** An object relationship */
  dependencySupplierProfile: Maybe<OrganisationSupplierProfiles>;
  dependencySupplierProfileId: Maybe<Scalars['uuid']['output']>;
  dependencyType: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isAll: Maybe<Scalars['Boolean']['output']>;
  organisationCoreDataDependencyId: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
};

/** aggregated selection of "core_data_dependencies" */
export type CoreDataDependenciesAggregate = {
  __typename?: 'core_data_dependencies_aggregate';
  aggregate: Maybe<CoreDataDependenciesAggregateFields>;
  nodes: Array<CoreDataDependencies>;
};

export type CoreDataDependenciesAggregateBoolExp = {
  bool_and?: InputMaybe<CoreDataDependenciesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CoreDataDependenciesAggregateBoolExpBoolOr>;
  count?: InputMaybe<CoreDataDependenciesAggregateBoolExpCount>;
};

export type CoreDataDependenciesAggregateBoolExpBoolAnd = {
  arguments: CoreDataDependenciesSelectColumnCoreDataDependenciesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CoreDataDependenciesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CoreDataDependenciesAggregateBoolExpBoolOr = {
  arguments: CoreDataDependenciesSelectColumnCoreDataDependenciesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CoreDataDependenciesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CoreDataDependenciesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CoreDataDependenciesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CoreDataDependenciesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "core_data_dependencies" */
export type CoreDataDependenciesAggregateFields = {
  __typename?: 'core_data_dependencies_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<CoreDataDependenciesMaxFields>;
  min: Maybe<CoreDataDependenciesMinFields>;
};


/** aggregate fields of "core_data_dependencies" */
export type CoreDataDependenciesAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<CoreDataDependenciesSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "core_data_dependencies" */
export type CoreDataDependenciesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CoreDataDependenciesMaxOrderBy>;
  min?: InputMaybe<CoreDataDependenciesMinOrderBy>;
};

/** input type for inserting array relation for remote table "core_data_dependencies" */
export type CoreDataDependenciesArrRelInsertInput = {
  data: Array<CoreDataDependenciesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CoreDataDependenciesOnConflict>;
};

/** Boolean expression to filter rows from the table "core_data_dependencies". All fields are combined with a logical 'AND'. */
export type CoreDataDependenciesBoolExp = {
  _and?: InputMaybe<Array<CoreDataDependenciesBoolExp>>;
  _not?: InputMaybe<CoreDataDependenciesBoolExp>;
  _or?: InputMaybe<Array<CoreDataDependenciesBoolExp>>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  coreDataType?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  dependencyCoreData?: InputMaybe<CoreDataBoolExp>;
  dependencyCoreDataId?: InputMaybe<UuidComparisonExp>;
  dependencyCoreDataType?: InputMaybe<StringComparisonExp>;
  dependencySupplierProfile?: InputMaybe<OrganisationSupplierProfilesBoolExp>;
  dependencySupplierProfileId?: InputMaybe<UuidComparisonExp>;
  dependencyType?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isAll?: InputMaybe<BooleanComparisonExp>;
  organisationCoreDataDependencyId?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "core_data_dependencies" */
export enum CoreDataDependenciesConstraint {
  /** unique or primary key constraint on columns "core_data_id", "dependency_core_data_id" */
  CORE_DATA_DEPENDENCIES_CORE_DATA_ID_DEPENDENCY_CORE_DATA_ID_KEY = 'core_data_dependencies_core_data_id_dependency_core_data_id_key',
  /** unique or primary key constraint on columns "core_data_id", "dependency_supplier_profile_id" */
  CORE_DATA_DEPENDENCIES_CORE_DATA_ID_DEPENDENCY_SUPPLIER_PROFILE = 'core_data_dependencies_core_data_id_dependency_supplier_profile',
  /** unique or primary key constraint on columns "id" */
  CORE_DATA_DEPENDENCIES_PKEY = 'core_data_dependencies_pkey'
}

/** input type for inserting data into table "core_data_dependencies" */
export type CoreDataDependenciesInsertInput = {
  coreDataId?: InputMaybe<Scalars['uuid']['input']>;
  coreDataType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dependencyCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  dependencyCoreDataType?: InputMaybe<Scalars['String']['input']>;
  dependencySupplierProfile?: InputMaybe<OrganisationSupplierProfilesObjRelInsertInput>;
  dependencySupplierProfileId?: InputMaybe<Scalars['uuid']['input']>;
  dependencyType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAll?: InputMaybe<Scalars['Boolean']['input']>;
  organisationCoreDataDependencyId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type CoreDataDependenciesMaxFields = {
  __typename?: 'core_data_dependencies_max_fields';
  coreDataId: Maybe<Scalars['uuid']['output']>;
  coreDataType: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  dependencyCoreDataId: Maybe<Scalars['uuid']['output']>;
  dependencyCoreDataType: Maybe<Scalars['String']['output']>;
  dependencySupplierProfileId: Maybe<Scalars['uuid']['output']>;
  dependencyType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationCoreDataDependencyId: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "core_data_dependencies" */
export type CoreDataDependenciesMaxOrderBy = {
  coreDataId?: InputMaybe<OrderBy>;
  coreDataType?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  dependencyCoreDataId?: InputMaybe<OrderBy>;
  dependencyCoreDataType?: InputMaybe<OrderBy>;
  dependencySupplierProfileId?: InputMaybe<OrderBy>;
  dependencyType?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationCoreDataDependencyId?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CoreDataDependenciesMinFields = {
  __typename?: 'core_data_dependencies_min_fields';
  coreDataId: Maybe<Scalars['uuid']['output']>;
  coreDataType: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  dependencyCoreDataId: Maybe<Scalars['uuid']['output']>;
  dependencyCoreDataType: Maybe<Scalars['String']['output']>;
  dependencySupplierProfileId: Maybe<Scalars['uuid']['output']>;
  dependencyType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationCoreDataDependencyId: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "core_data_dependencies" */
export type CoreDataDependenciesMinOrderBy = {
  coreDataId?: InputMaybe<OrderBy>;
  coreDataType?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  dependencyCoreDataId?: InputMaybe<OrderBy>;
  dependencyCoreDataType?: InputMaybe<OrderBy>;
  dependencySupplierProfileId?: InputMaybe<OrderBy>;
  dependencyType?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationCoreDataDependencyId?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "core_data_dependencies" */
export type CoreDataDependenciesMutationResponse = {
  __typename?: 'core_data_dependencies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CoreDataDependencies>;
};

/** on_conflict condition type for table "core_data_dependencies" */
export type CoreDataDependenciesOnConflict = {
  constraint: CoreDataDependenciesConstraint;
  update_columns: Array<CoreDataDependenciesUpdateColumn>;
  where?: InputMaybe<CoreDataDependenciesBoolExp>;
};

/** Ordering options when selecting data from "core_data_dependencies". */
export type CoreDataDependenciesOrderBy = {
  coreData?: InputMaybe<CoreDataOrderBy>;
  coreDataId?: InputMaybe<OrderBy>;
  coreDataType?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  dependencyCoreData?: InputMaybe<CoreDataOrderBy>;
  dependencyCoreDataId?: InputMaybe<OrderBy>;
  dependencyCoreDataType?: InputMaybe<OrderBy>;
  dependencySupplierProfile?: InputMaybe<OrganisationSupplierProfilesOrderBy>;
  dependencySupplierProfileId?: InputMaybe<OrderBy>;
  dependencyType?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isAll?: InputMaybe<OrderBy>;
  organisationCoreDataDependencyId?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: core_data_dependencies */
export type CoreDataDependenciesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "core_data_dependencies" */
export enum CoreDataDependenciesSelectColumn {
  /** column name */
  COREDATAID = 'coreDataId',
  /** column name */
  COREDATATYPE = 'coreDataType',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPENDENCYCOREDATAID = 'dependencyCoreDataId',
  /** column name */
  DEPENDENCYCOREDATATYPE = 'dependencyCoreDataType',
  /** column name */
  DEPENDENCYSUPPLIERPROFILEID = 'dependencySupplierProfileId',
  /** column name */
  DEPENDENCYTYPE = 'dependencyType',
  /** column name */
  ID = 'id',
  /** column name */
  ISALL = 'isAll',
  /** column name */
  ORGANISATIONCOREDATADEPENDENCYID = 'organisationCoreDataDependencyId',
  /** column name */
  ORGANISATIONID = 'organisationId'
}

/** select "core_data_dependencies_aggregate_bool_exp_bool_and_arguments_columns" columns of table "core_data_dependencies" */
export enum CoreDataDependenciesSelectColumnCoreDataDependenciesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISALL = 'isAll'
}

/** select "core_data_dependencies_aggregate_bool_exp_bool_or_arguments_columns" columns of table "core_data_dependencies" */
export enum CoreDataDependenciesSelectColumnCoreDataDependenciesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISALL = 'isAll'
}

/** input type for updating data in table "core_data_dependencies" */
export type CoreDataDependenciesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "core_data_dependencies" */
export enum CoreDataDependenciesUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt'
}

export type CoreDataDependenciesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoreDataDependenciesSetInput>;
  /** filter the rows which have to be updated */
  where: CoreDataDependenciesBoolExp;
};

/** columns and relationships of "core_data_external_references" */
export type CoreDataExternalReferences = {
  __typename?: 'core_data_external_references';
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  customCoreData: Maybe<CustomCoreData>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  entityType: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  integration: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationIntegration: Maybe<OrganisationIntegrations>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  referenceId: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
};

/** aggregated selection of "core_data_external_references" */
export type CoreDataExternalReferencesAggregate = {
  __typename?: 'core_data_external_references_aggregate';
  aggregate: Maybe<CoreDataExternalReferencesAggregateFields>;
  nodes: Array<CoreDataExternalReferences>;
};

/** aggregate fields of "core_data_external_references" */
export type CoreDataExternalReferencesAggregateFields = {
  __typename?: 'core_data_external_references_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<CoreDataExternalReferencesMaxFields>;
  min: Maybe<CoreDataExternalReferencesMinFields>;
};


/** aggregate fields of "core_data_external_references" */
export type CoreDataExternalReferencesAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<CoreDataExternalReferencesSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "core_data_external_references". All fields are combined with a logical 'AND'. */
export type CoreDataExternalReferencesBoolExp = {
  _and?: InputMaybe<Array<CoreDataExternalReferencesBoolExp>>;
  _not?: InputMaybe<CoreDataExternalReferencesBoolExp>;
  _or?: InputMaybe<Array<CoreDataExternalReferencesBoolExp>>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customCoreData?: InputMaybe<CustomCoreDataBoolExp>;
  customCoreDataId?: InputMaybe<UuidComparisonExp>;
  entityType?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
  referenceId?: InputMaybe<StringComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "core_data_external_references" */
export enum CoreDataExternalReferencesConstraint {
  /** unique or primary key constraint on columns "core_data_id" */
  CORE_DATA_EXT_REFS_CORE_DATA_ID_NO_INTEGRATION_UNIQ = 'core_data_ext_refs_core_data_id_no_integration_uniq',
  /** unique or primary key constraint on columns "remote_id", "organisation_integration_id", "custom_core_data_id" */
  CORE_DATA_EXT_REFS_ORG_INT_CUSTOM_CD_REMOTE_ID_UNIQ = 'core_data_ext_refs_org_int_custom_cd_remote_id_uniq',
  /** unique or primary key constraint on columns "entity_type", "remote_id", "organisation_integration_id" */
  CORE_DATA_EXT_REFS_ORG_INT_ENTITY_TYPE_REMOTE_ID_UNIQ = 'core_data_ext_refs_org_int_entity_type_remote_id_uniq',
  /** unique or primary key constraint on columns "organisation_integration_id", "core_data_id" */
  CORE_DATA_EXTERNAL_REFERENCES_CORE_DATA_ID_ORGANISATION_INT_KEY = 'core_data_external_references_core_data_id_organisation_int_key',
  /** unique or primary key constraint on columns "entity_type", "organisation_integration_id", "reference_id" */
  CORE_DATA_EXTERNAL_REFERENCES_ORGANISATION_INTEGRATION_ID_E_KEY = 'core_data_external_references_organisation_integration_id_e_key',
  /** unique or primary key constraint on columns "id" */
  CORE_DATA_EXTERNAL_REFERENCES_PKEY = 'core_data_external_references_pkey'
}

/** input type for inserting data into table "core_data_external_references" */
export type CoreDataExternalReferencesInsertInput = {
  coreDataId?: InputMaybe<Scalars['uuid']['input']>;
  customCoreData?: InputMaybe<CustomCoreDataObjRelInsertInput>;
  customCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  integration?: InputMaybe<Scalars['String']['input']>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CoreDataExternalReferencesMaxFields = {
  __typename?: 'core_data_external_references_max_fields';
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  entityType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  integration: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CoreDataExternalReferencesMinFields = {
  __typename?: 'core_data_external_references_min_fields';
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  entityType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  integration: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "core_data_external_references" */
export type CoreDataExternalReferencesMutationResponse = {
  __typename?: 'core_data_external_references_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CoreDataExternalReferences>;
};

/** on_conflict condition type for table "core_data_external_references" */
export type CoreDataExternalReferencesOnConflict = {
  constraint: CoreDataExternalReferencesConstraint;
  update_columns: Array<CoreDataExternalReferencesUpdateColumn>;
  where?: InputMaybe<CoreDataExternalReferencesBoolExp>;
};

/** Ordering options when selecting data from "core_data_external_references". */
export type CoreDataExternalReferencesOrderBy = {
  coreData?: InputMaybe<CoreDataOrderBy>;
  coreDataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customCoreData?: InputMaybe<CustomCoreDataOrderBy>;
  customCoreDataId?: InputMaybe<OrderBy>;
  entityType?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsOrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: core_data_external_references */
export type CoreDataExternalReferencesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "core_data_external_references" */
export enum CoreDataExternalReferencesSelectColumn {
  /** column name */
  COREDATAID = 'coreDataId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CUSTOMCOREDATAID = 'customCoreDataId',
  /** column name */
  ENTITYTYPE = 'entityType',
  /** column name */
  ID = 'id',
  /** column name */
  INTEGRATION = 'integration',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  REFERENCEID = 'referenceId',
  /** column name */
  REMOTEID = 'remoteId'
}

/** input type for updating data in table "core_data_external_references" */
export type CoreDataExternalReferencesSetInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "core_data_external_references" */
export enum CoreDataExternalReferencesUpdateColumn {
  /** column name */
  REFERENCEID = 'referenceId',
  /** column name */
  REMOTEID = 'remoteId'
}

export type CoreDataExternalReferencesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoreDataExternalReferencesSetInput>;
  /** filter the rows which have to be updated */
  where: CoreDataExternalReferencesBoolExp;
};

/** Ordering options when selecting data from "core_data". */
export type CoreDataOrderBy = {
  address?: InputMaybe<AddressesOrderBy>;
  coreDataDependencies_aggregate?: InputMaybe<CoreDataDependenciesAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrganisationFxRatesOrderBy>;
  customCoreDataOption?: InputMaybe<CustomCoreDataOptionsOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<DepartmentsOrderBy>;
  id?: InputMaybe<OrderBy>;
  lineItemType?: InputMaybe<LineItemTypesOrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  paymentMethod?: InputMaybe<PaymentMethodsOrderBy>;
  paymentTerm?: InputMaybe<PaymentTermsOrderBy>;
  subsidiary?: InputMaybe<SubsidiariesOrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** columns and relationships of "core_data_organisation_integrations" */
export type CoreDataOrganisationIntegrations = {
  __typename?: 'core_data_organisation_integrations';
  coreDataType: Scalars['String']['output'];
  /** An object relationship */
  customCoreData: Maybe<CustomCoreData>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisationIntegration: OrganisationIntegrations;
  organisationIntegrationId: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "core_data_organisation_integrations". All fields are combined with a logical 'AND'. */
export type CoreDataOrganisationIntegrationsBoolExp = {
  _and?: InputMaybe<Array<CoreDataOrganisationIntegrationsBoolExp>>;
  _not?: InputMaybe<CoreDataOrganisationIntegrationsBoolExp>;
  _or?: InputMaybe<Array<CoreDataOrganisationIntegrationsBoolExp>>;
  coreDataType?: InputMaybe<StringComparisonExp>;
  customCoreData?: InputMaybe<CustomCoreDataBoolExp>;
  customCoreDataId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "core_data_organisation_integrations" */
export enum CoreDataOrganisationIntegrationsConstraint {
  /** unique or primary key constraint on columns "organisation_id", "organisation_integration_id", "core_data_type", "custom_core_data_id" */
  CORE_DATA_ORG_INTEGRATIONS_CUSTOM_TYPE_KEY = 'core_data_org_integrations_custom_type_key',
  /** unique or primary key constraint on columns "organisation_id", "organisation_integration_id", "core_data_type" */
  CORE_DATA_ORG_INTEGRATIONS_SYSTEM_TYPE_KEY = 'core_data_org_integrations_system_type_key',
  /** unique or primary key constraint on columns "id" */
  CORE_DATA_ORGANISATION_INTEGRATIONS_PKEY = 'core_data_organisation_integrations_pkey'
}

/** input type for inserting data into table "core_data_organisation_integrations" */
export type CoreDataOrganisationIntegrationsInsertInput = {
  coreDataType?: InputMaybe<Scalars['String']['input']>;
  customCoreData?: InputMaybe<CustomCoreDataObjRelInsertInput>;
  customCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "core_data_organisation_integrations" */
export type CoreDataOrganisationIntegrationsMutationResponse = {
  __typename?: 'core_data_organisation_integrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CoreDataOrganisationIntegrations>;
};

/** on_conflict condition type for table "core_data_organisation_integrations" */
export type CoreDataOrganisationIntegrationsOnConflict = {
  constraint: CoreDataOrganisationIntegrationsConstraint;
  update_columns: Array<CoreDataOrganisationIntegrationsUpdateColumn>;
  where?: InputMaybe<CoreDataOrganisationIntegrationsBoolExp>;
};

/** Ordering options when selecting data from "core_data_organisation_integrations". */
export type CoreDataOrganisationIntegrationsOrderBy = {
  coreDataType?: InputMaybe<OrderBy>;
  customCoreData?: InputMaybe<CustomCoreDataOrderBy>;
  customCoreDataId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsOrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: core_data_organisation_integrations */
export type CoreDataOrganisationIntegrationsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "core_data_organisation_integrations" */
export enum CoreDataOrganisationIntegrationsSelectColumn {
  /** column name */
  COREDATATYPE = 'coreDataType',
  /** column name */
  CUSTOMCOREDATAID = 'customCoreDataId',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId'
}

/** input type for updating data in table "core_data_organisation_integrations" */
export type CoreDataOrganisationIntegrationsSetInput = {
  coreDataType?: InputMaybe<Scalars['String']['input']>;
  customCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "core_data_organisation_integrations" */
export type CoreDataOrganisationIntegrationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CoreDataOrganisationIntegrationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CoreDataOrganisationIntegrationsStreamCursorValueInput = {
  coreDataType?: InputMaybe<Scalars['String']['input']>;
  customCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "core_data_organisation_integrations" */
export enum CoreDataOrganisationIntegrationsUpdateColumn {
  /** column name */
  COREDATATYPE = 'coreDataType',
  /** column name */
  CUSTOMCOREDATAID = 'customCoreDataId',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId'
}

export type CoreDataOrganisationIntegrationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CoreDataOrganisationIntegrationsSetInput>;
  /** filter the rows which have to be updated */
  where: CoreDataOrganisationIntegrationsBoolExp;
};

/** select columns of table "core_data" */
export enum CoreDataSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  TYPE = 'type'
}

/** ordering argument of a cursor */
export enum CursorOrdering {
  /** ascending ordering of the cursor */
  ASC = 'ASC',
  /** descending ordering of the cursor */
  DESC = 'DESC'
}

/** columns and relationships of "custom_core_data" */
export type CustomCoreData = {
  __typename?: 'custom_core_data';
  archivedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  custom_core_data_options: Array<CustomCoreDataOptions>;
  /** An aggregate relationship */
  custom_core_data_options_aggregate: CustomCoreDataOptionsAggregate;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationIntegration: Maybe<OrganisationIntegrations>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  pathLevels: Maybe<Array<Scalars['String']['output']>>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "custom_core_data" */
export type CustomCoreDataCustomCoreDataOptionsArgs = {
  distinct_on: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomCoreDataOptionsOrderBy>>;
  where: InputMaybe<CustomCoreDataOptionsBoolExp>;
};


/** columns and relationships of "custom_core_data" */
export type CustomCoreDataCustomCoreDataOptionsAggregateArgs = {
  distinct_on: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomCoreDataOptionsOrderBy>>;
  where: InputMaybe<CustomCoreDataOptionsBoolExp>;
};

/** Boolean expression to filter rows from the table "custom_core_data". All fields are combined with a logical 'AND'. */
export type CustomCoreDataBoolExp = {
  _and?: InputMaybe<Array<CustomCoreDataBoolExp>>;
  _not?: InputMaybe<CustomCoreDataBoolExp>;
  _or?: InputMaybe<Array<CustomCoreDataBoolExp>>;
  archivedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  custom_core_data_options?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  custom_core_data_options_aggregate?: InputMaybe<CustomCoreDataOptionsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
  pathLevels?: InputMaybe<StringArrayComparisonExp>;
  slug?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "custom_core_data" */
export enum CustomCoreDataConstraint {
  /** unique or primary key constraint on columns "archived_at", "organisation_id", "name" */
  CUSTOM_CORE_DATA_NAME_ORGANISATION_ID_KEY = 'custom_core_data_name_organisation_id_key',
  /** unique or primary key constraint on columns "id" */
  CUSTOM_CORE_DATA_PKEY = 'custom_core_data_pkey',
  /** unique or primary key constraint on columns "organisation_id", "slug" */
  CUSTOM_CORE_DATA_SLUG_ORGANISATION_ID_ACTIVE_UNIQUE = 'custom_core_data_slug_organisation_id_active_unique'
}

/** input type for inserting data into table "custom_core_data" */
export type CustomCoreDataInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_core_data_options?: InputMaybe<CustomCoreDataOptionsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  pathLevels?: InputMaybe<Array<Scalars['String']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "custom_core_data" */
export type CustomCoreDataMutationResponse = {
  __typename?: 'custom_core_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomCoreData>;
};

/** input type for inserting object relation for remote table "custom_core_data" */
export type CustomCoreDataObjRelInsertInput = {
  data: CustomCoreDataInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomCoreDataOnConflict>;
};

/** on_conflict condition type for table "custom_core_data" */
export type CustomCoreDataOnConflict = {
  constraint: CustomCoreDataConstraint;
  update_columns: Array<CustomCoreDataUpdateColumn>;
  where?: InputMaybe<CustomCoreDataBoolExp>;
};

/** columns and relationships of "custom_core_data_options" */
export type CustomCoreDataOptions = {
  __typename?: 'custom_core_data_options';
  archivedBy: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  customCoreDataId: Scalars['uuid']['output'];
  /** An object relationship */
  custom_core_data: CustomCoreData;
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  isTerminal: Scalars['Boolean']['output'];
  /** An object relationship */
  parent: Maybe<CustomCoreDataOptions>;
  parentId: Maybe<Scalars['uuid']['output']>;
  path: Scalars['ltree']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "custom_core_data_options" */
export type CustomCoreDataOptionsAggregate = {
  __typename?: 'custom_core_data_options_aggregate';
  aggregate: Maybe<CustomCoreDataOptionsAggregateFields>;
  nodes: Array<CustomCoreDataOptions>;
};

export type CustomCoreDataOptionsAggregateBoolExp = {
  bool_and?: InputMaybe<CustomCoreDataOptionsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CustomCoreDataOptionsAggregateBoolExpBoolOr>;
  count?: InputMaybe<CustomCoreDataOptionsAggregateBoolExpCount>;
};

export type CustomCoreDataOptionsAggregateBoolExpBoolAnd = {
  arguments: CustomCoreDataOptionsSelectColumnCustomCoreDataOptionsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CustomCoreDataOptionsAggregateBoolExpBoolOr = {
  arguments: CustomCoreDataOptionsSelectColumnCustomCoreDataOptionsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CustomCoreDataOptionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "custom_core_data_options" */
export type CustomCoreDataOptionsAggregateFields = {
  __typename?: 'custom_core_data_options_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<CustomCoreDataOptionsMaxFields>;
  min: Maybe<CustomCoreDataOptionsMinFields>;
};


/** aggregate fields of "custom_core_data_options" */
export type CustomCoreDataOptionsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "custom_core_data_options" */
export type CustomCoreDataOptionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CustomCoreDataOptionsMaxOrderBy>;
  min?: InputMaybe<CustomCoreDataOptionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "custom_core_data_options" */
export type CustomCoreDataOptionsArrRelInsertInput = {
  data: Array<CustomCoreDataOptionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomCoreDataOptionsOnConflict>;
};

/** Boolean expression to filter rows from the table "custom_core_data_options". All fields are combined with a logical 'AND'. */
export type CustomCoreDataOptionsBoolExp = {
  _and?: InputMaybe<Array<CustomCoreDataOptionsBoolExp>>;
  _not?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  _or?: InputMaybe<Array<CustomCoreDataOptionsBoolExp>>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customCoreDataId?: InputMaybe<UuidComparisonExp>;
  custom_core_data?: InputMaybe<CustomCoreDataBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  isTerminal?: InputMaybe<BooleanComparisonExp>;
  parent?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  parentId?: InputMaybe<UuidComparisonExp>;
  path?: InputMaybe<LtreeComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "custom_core_data_options" */
export enum CustomCoreDataOptionsConstraint {
  /** unique or primary key constraint on columns "value", "parent_id", "custom_core_data_id" */
  CUSTOM_CORE_DATA_OPTIONS_PARENT_ID_CUSTOM_FIELD_ID_VALUE_KEY = 'custom_core_data_options_parent_id_custom_field_id_value_key',
  /** unique or primary key constraint on columns "id" */
  CUSTOM_CORE_DATA_OPTIONS_PKEY = 'custom_core_data_options_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id", "custom_core_data_id" */
  CUSTOM_CORE_DATA_OPTIONS_REMOTE_CUSTOM_CORE_ORGANISATION_ID_KEY = 'custom_core_data_options_remote_custom_core_organisation_id_key'
}

/** input type for inserting data into table "custom_core_data_options" */
export type CustomCoreDataOptionsInsertInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  coreDataId?: InputMaybe<Scalars['uuid']['input']>;
  customCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  custom_core_data?: InputMaybe<CustomCoreDataObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  parent?: InputMaybe<CustomCoreDataOptionsObjRelInsertInput>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  path?: InputMaybe<Scalars['ltree']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CustomCoreDataOptionsMaxFields = {
  __typename?: 'custom_core_data_options_max_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  parentId: Maybe<Scalars['uuid']['output']>;
  path: Maybe<Scalars['ltree']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "custom_core_data_options" */
export type CustomCoreDataOptionsMaxOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  coreDataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customCoreDataId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CustomCoreDataOptionsMinFields = {
  __typename?: 'custom_core_data_options_min_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  parentId: Maybe<Scalars['uuid']['output']>;
  path: Maybe<Scalars['ltree']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "custom_core_data_options" */
export type CustomCoreDataOptionsMinOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  coreDataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customCoreDataId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "custom_core_data_options" */
export type CustomCoreDataOptionsMutationResponse = {
  __typename?: 'custom_core_data_options_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomCoreDataOptions>;
};

/** input type for inserting object relation for remote table "custom_core_data_options" */
export type CustomCoreDataOptionsObjRelInsertInput = {
  data: CustomCoreDataOptionsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomCoreDataOptionsOnConflict>;
};

/** on_conflict condition type for table "custom_core_data_options" */
export type CustomCoreDataOptionsOnConflict = {
  constraint: CustomCoreDataOptionsConstraint;
  update_columns: Array<CustomCoreDataOptionsUpdateColumn>;
  where?: InputMaybe<CustomCoreDataOptionsBoolExp>;
};

/** Ordering options when selecting data from "custom_core_data_options". */
export type CustomCoreDataOptionsOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  coreData?: InputMaybe<CoreDataOrderBy>;
  coreDataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customCoreDataId?: InputMaybe<OrderBy>;
  custom_core_data?: InputMaybe<CustomCoreDataOrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  isTerminal?: InputMaybe<OrderBy>;
  parent?: InputMaybe<CustomCoreDataOptionsOrderBy>;
  parentId?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: custom_core_data_options */
export type CustomCoreDataOptionsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "custom_core_data_options" */
export enum CustomCoreDataOptionsSelectColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  COREDATAID = 'coreDataId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CUSTOMCOREDATAID = 'customCoreDataId',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISTERMINAL = 'isTerminal',
  /** column name */
  PARENTID = 'parentId',
  /** column name */
  PATH = 'path',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  VALUE = 'value'
}

/** select "custom_core_data_options_aggregate_bool_exp_bool_and_arguments_columns" columns of table "custom_core_data_options" */
export enum CustomCoreDataOptionsSelectColumnCustomCoreDataOptionsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISTERMINAL = 'isTerminal'
}

/** select "custom_core_data_options_aggregate_bool_exp_bool_or_arguments_columns" columns of table "custom_core_data_options" */
export enum CustomCoreDataOptionsSelectColumnCustomCoreDataOptionsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISTERMINAL = 'isTerminal'
}

/** input type for updating data in table "custom_core_data_options" */
export type CustomCoreDataOptionsSetInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  customCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "custom_core_data_options" */
export enum CustomCoreDataOptionsUpdateColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CUSTOMCOREDATAID = 'customCoreDataId',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISTERMINAL = 'isTerminal',
  /** column name */
  PARENTID = 'parentId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  VALUE = 'value'
}

export type CustomCoreDataOptionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomCoreDataOptionsSetInput>;
  /** filter the rows which have to be updated */
  where: CustomCoreDataOptionsBoolExp;
};

/** Ordering options when selecting data from "custom_core_data". */
export type CustomCoreDataOrderBy = {
  archivedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  custom_core_data_options_aggregate?: InputMaybe<CustomCoreDataOptionsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsOrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  pathLevels?: InputMaybe<OrderBy>;
  slug?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: custom_core_data */
export type CustomCoreDataPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "custom_core_data" */
export enum CustomCoreDataSelectColumn {
  /** column name */
  ARCHIVEDAT = 'archivedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  PATHLEVELS = 'pathLevels',
  /** column name */
  SLUG = 'slug',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "custom_core_data" */
export type CustomCoreDataSetInput = {
  archivedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  pathLevels?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** update columns of table "custom_core_data" */
export enum CustomCoreDataUpdateColumn {
  /** column name */
  ARCHIVEDAT = 'archivedAt',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  PATHLEVELS = 'pathLevels'
}

export type CustomCoreDataUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomCoreDataSetInput>;
  /** filter the rows which have to be updated */
  where: CustomCoreDataBoolExp;
};

/** columns and relationships of "custom_document_types" */
export type CustomDocumentTypes = {
  __typename?: 'custom_document_types';
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "custom_document_types". All fields are combined with a logical 'AND'. */
export type CustomDocumentTypesBoolExp = {
  _and?: InputMaybe<Array<CustomDocumentTypesBoolExp>>;
  _not?: InputMaybe<CustomDocumentTypesBoolExp>;
  _or?: InputMaybe<Array<CustomDocumentTypesBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "custom_document_types" */
export enum CustomDocumentTypesConstraint {
  /** unique or primary key constraint on columns "organisation_id", "value" */
  CUSTOM_DOCUMENT_TYPES_ORGANISATION_ID_VALUE_KEY = 'custom_document_types_organisation_id_value_key',
  /** unique or primary key constraint on columns "id" */
  CUSTOM_DOCUMENT_TYPES_PKEY = 'custom_document_types_pkey'
}

/** input type for inserting data into table "custom_document_types" */
export type CustomDocumentTypesInsertInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "custom_document_types" */
export type CustomDocumentTypesMutationResponse = {
  __typename?: 'custom_document_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomDocumentTypes>;
};

/** input type for inserting object relation for remote table "custom_document_types" */
export type CustomDocumentTypesObjRelInsertInput = {
  data: CustomDocumentTypesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomDocumentTypesOnConflict>;
};

/** on_conflict condition type for table "custom_document_types" */
export type CustomDocumentTypesOnConflict = {
  constraint: CustomDocumentTypesConstraint;
  update_columns: Array<CustomDocumentTypesUpdateColumn>;
  where?: InputMaybe<CustomDocumentTypesBoolExp>;
};

/** Ordering options when selecting data from "custom_document_types". */
export type CustomDocumentTypesOrderBy = {
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "custom_document_types" */
export enum CustomDocumentTypesSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  VALUE = 'value'
}

/** placeholder for update columns of table "custom_document_types" (current role has no relevant permissions) */
export enum CustomDocumentTypesUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** Choices of custom fields to be used for select and multi-select types */
export type CustomFieldChoices = {
  __typename?: 'custom_field_choices';
  customFieldId: Scalars['uuid']['output'];
  /** An object relationship */
  custom_field: CustomFields;
  id: Scalars['uuid']['output'];
  label: Scalars['String']['output'];
  organisation_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "custom_field_choices" */
export type CustomFieldChoicesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CustomFieldChoicesMaxOrderBy>;
  min?: InputMaybe<CustomFieldChoicesMinOrderBy>;
};

/** input type for inserting array relation for remote table "custom_field_choices" */
export type CustomFieldChoicesArrRelInsertInput = {
  data: Array<CustomFieldChoicesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldChoicesOnConflict>;
};

/** Boolean expression to filter rows from the table "custom_field_choices". All fields are combined with a logical 'AND'. */
export type CustomFieldChoicesBoolExp = {
  _and?: InputMaybe<Array<CustomFieldChoicesBoolExp>>;
  _not?: InputMaybe<CustomFieldChoicesBoolExp>;
  _or?: InputMaybe<Array<CustomFieldChoicesBoolExp>>;
  customFieldId?: InputMaybe<UuidComparisonExp>;
  custom_field?: InputMaybe<CustomFieldsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  label?: InputMaybe<StringComparisonExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "custom_field_choices" */
export enum CustomFieldChoicesConstraint {
  /** unique or primary key constraint on columns "label", "custom_field_id" */
  CUSTOM_FIELD_CHOICES_LABEL_CUSTOM_FIELD_ID_KEY = 'custom_field_choices_label_custom_field_id_key',
  /** unique or primary key constraint on columns "id" */
  CUSTOM_FIELD_CHOICES_PKEY = 'custom_field_choices_pkey'
}

/** input type for inserting data into table "custom_field_choices" */
export type CustomFieldChoicesInsertInput = {
  customFieldId?: InputMaybe<Scalars['uuid']['input']>;
  custom_field?: InputMaybe<CustomFieldsObjRelInsertInput>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "custom_field_choices" */
export type CustomFieldChoicesMaxOrderBy = {
  customFieldId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "custom_field_choices" */
export type CustomFieldChoicesMinOrderBy = {
  customFieldId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "custom_field_choices" */
export type CustomFieldChoicesMutationResponse = {
  __typename?: 'custom_field_choices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomFieldChoices>;
};

/** input type for inserting object relation for remote table "custom_field_choices" */
export type CustomFieldChoicesObjRelInsertInput = {
  data: CustomFieldChoicesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldChoicesOnConflict>;
};

/** on_conflict condition type for table "custom_field_choices" */
export type CustomFieldChoicesOnConflict = {
  constraint: CustomFieldChoicesConstraint;
  update_columns: Array<CustomFieldChoicesUpdateColumn>;
  where?: InputMaybe<CustomFieldChoicesBoolExp>;
};

/** Ordering options when selecting data from "custom_field_choices". */
export type CustomFieldChoicesOrderBy = {
  customFieldId?: InputMaybe<OrderBy>;
  custom_field?: InputMaybe<CustomFieldsOrderBy>;
  id?: InputMaybe<OrderBy>;
  label?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
};

/** select columns of table "custom_field_choices" */
export enum CustomFieldChoicesSelectColumn {
  /** column name */
  CUSTOMFIELDID = 'customFieldId',
  /** column name */
  ID = 'id',
  /** column name */
  LABEL = 'label',
  /** column name */
  ORGANISATION_ID = 'organisation_id'
}

/** placeholder for update columns of table "custom_field_choices" (current role has no relevant permissions) */
export enum CustomFieldChoicesUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** Linking custom field values to core data */
export type CustomFieldCoreData = {
  __typename?: 'custom_field_core_data';
  /** An object relationship */
  address: Maybe<Addresses>;
  address_id: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  currency: Maybe<OrganisationFxRates>;
  currency_id: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customCoreDataOption: Maybe<CustomCoreDataOptions>;
  custom_core_data_option_id: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  department: Maybe<Departments>;
  department_id: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lineItemType: Maybe<LineItemTypes>;
  line_item_type_id: Maybe<Scalars['uuid']['output']>;
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  /** An object relationship */
  paymentTerm: Maybe<PaymentTerms>;
  payment_method_id: Maybe<Scalars['uuid']['output']>;
  payment_term_id: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  subsidiary: Maybe<Subsidiaries>;
  subsidiary_id: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "custom_field_core_data". All fields are combined with a logical 'AND'. */
export type CustomFieldCoreDataBoolExp = {
  _and?: InputMaybe<Array<CustomFieldCoreDataBoolExp>>;
  _not?: InputMaybe<CustomFieldCoreDataBoolExp>;
  _or?: InputMaybe<Array<CustomFieldCoreDataBoolExp>>;
  address?: InputMaybe<AddressesBoolExp>;
  address_id?: InputMaybe<UuidComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<OrganisationFxRatesBoolExp>;
  currency_id?: InputMaybe<UuidComparisonExp>;
  customCoreDataOption?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  custom_core_data_option_id?: InputMaybe<UuidComparisonExp>;
  department?: InputMaybe<DepartmentsBoolExp>;
  department_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lineItemType?: InputMaybe<LineItemTypesBoolExp>;
  line_item_type_id?: InputMaybe<UuidComparisonExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentTerm?: InputMaybe<PaymentTermsBoolExp>;
  payment_method_id?: InputMaybe<UuidComparisonExp>;
  payment_term_id?: InputMaybe<UuidComparisonExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  subsidiary_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "custom_field_core_data" */
export enum CustomFieldCoreDataConstraint {
  /** unique or primary key constraint on columns "id" */
  CUSTOM_FIELD_CORE_DATA_PKEY = 'custom_field_core_data_pkey'
}

/** input type for inserting data into table "custom_field_core_data" */
export type CustomFieldCoreDataInsertInput = {
  address?: InputMaybe<AddressesObjRelInsertInput>;
  address_id?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<OrganisationFxRatesObjRelInsertInput>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  customCoreDataOption?: InputMaybe<CustomCoreDataOptionsObjRelInsertInput>;
  custom_core_data_option_id?: InputMaybe<Scalars['uuid']['input']>;
  department?: InputMaybe<DepartmentsObjRelInsertInput>;
  department_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lineItemType?: InputMaybe<LineItemTypesObjRelInsertInput>;
  line_item_type_id?: InputMaybe<Scalars['uuid']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodsObjRelInsertInput>;
  paymentTerm?: InputMaybe<PaymentTermsObjRelInsertInput>;
  payment_method_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_term_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary?: InputMaybe<SubsidiariesObjRelInsertInput>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "custom_field_core_data" */
export type CustomFieldCoreDataMutationResponse = {
  __typename?: 'custom_field_core_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomFieldCoreData>;
};

/** input type for inserting object relation for remote table "custom_field_core_data" */
export type CustomFieldCoreDataObjRelInsertInput = {
  data: CustomFieldCoreDataInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldCoreDataOnConflict>;
};

/** on_conflict condition type for table "custom_field_core_data" */
export type CustomFieldCoreDataOnConflict = {
  constraint: CustomFieldCoreDataConstraint;
  update_columns: Array<CustomFieldCoreDataUpdateColumn>;
  where?: InputMaybe<CustomFieldCoreDataBoolExp>;
};

/** Ordering options when selecting data from "custom_field_core_data". */
export type CustomFieldCoreDataOrderBy = {
  address?: InputMaybe<AddressesOrderBy>;
  address_id?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrganisationFxRatesOrderBy>;
  currency_id?: InputMaybe<OrderBy>;
  customCoreDataOption?: InputMaybe<CustomCoreDataOptionsOrderBy>;
  custom_core_data_option_id?: InputMaybe<OrderBy>;
  department?: InputMaybe<DepartmentsOrderBy>;
  department_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lineItemType?: InputMaybe<LineItemTypesOrderBy>;
  line_item_type_id?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  paymentMethod?: InputMaybe<PaymentMethodsOrderBy>;
  paymentTerm?: InputMaybe<PaymentTermsOrderBy>;
  payment_method_id?: InputMaybe<OrderBy>;
  payment_term_id?: InputMaybe<OrderBy>;
  subsidiary?: InputMaybe<SubsidiariesOrderBy>;
  subsidiary_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: custom_field_core_data */
export type CustomFieldCoreDataPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "custom_field_core_data" */
export enum CustomFieldCoreDataSelectColumn {
  /** column name */
  ADDRESS_ID = 'address_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CURRENCY_ID = 'currency_id',
  /** column name */
  CUSTOM_CORE_DATA_OPTION_ID = 'custom_core_data_option_id',
  /** column name */
  DEPARTMENT_ID = 'department_id',
  /** column name */
  ID = 'id',
  /** column name */
  LINE_ITEM_TYPE_ID = 'line_item_type_id',
  /** column name */
  ORGANISATION_ID = 'organisation_id',
  /** column name */
  PAYMENT_METHOD_ID = 'payment_method_id',
  /** column name */
  PAYMENT_TERM_ID = 'payment_term_id',
  /** column name */
  SUBSIDIARY_ID = 'subsidiary_id'
}

/** input type for updating data in table "custom_field_core_data" */
export type CustomFieldCoreDataSetInput = {
  address_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency_id?: InputMaybe<Scalars['uuid']['input']>;
  custom_core_data_option_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  department_id?: InputMaybe<Scalars['uuid']['input']>;
  line_item_type_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_method_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_term_id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "custom_field_core_data" */
export enum CustomFieldCoreDataUpdateColumn {
  /** column name */
  ADDRESS_ID = 'address_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CURRENCY_ID = 'currency_id',
  /** column name */
  CUSTOM_CORE_DATA_OPTION_ID = 'custom_core_data_option_id',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DEPARTMENT_ID = 'department_id',
  /** column name */
  LINE_ITEM_TYPE_ID = 'line_item_type_id',
  /** column name */
  PAYMENT_METHOD_ID = 'payment_method_id',
  /** column name */
  PAYMENT_TERM_ID = 'payment_term_id',
  /** column name */
  SUBSIDIARY_ID = 'subsidiary_id'
}

export type CustomFieldCoreDataUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomFieldCoreDataSetInput>;
  /** filter the rows which have to be updated */
  where: CustomFieldCoreDataBoolExp;
};

/** A value of a custom field. Links to both an entity and a custom field */
export type CustomFieldValues = {
  __typename?: 'custom_field_values';
  booleanValue: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  choice: Maybe<CustomFieldChoices>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  customField: CustomFields;
  customFieldChoiceId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customFieldCoreData: Maybe<CustomFieldCoreData>;
  customFieldCoreDataId: Maybe<Scalars['uuid']['output']>;
  customFieldId: Scalars['uuid']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  entityId: Scalars['uuid']['output'];
  /** An object relationship */
  file: Maybe<RequestDocuments>;
  fileId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  numberValue: Maybe<Scalars['float8']['output']>;
  organisationId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['uuid']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "custom_field_values" */
export type CustomFieldValuesAggregate = {
  __typename?: 'custom_field_values_aggregate';
  aggregate: Maybe<CustomFieldValuesAggregateFields>;
  nodes: Array<CustomFieldValues>;
};

export type CustomFieldValuesAggregateBoolExp = {
  avg?: InputMaybe<CustomFieldValuesAggregateBoolExpAvg>;
  bool_and?: InputMaybe<CustomFieldValuesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<CustomFieldValuesAggregateBoolExpBoolOr>;
  corr?: InputMaybe<CustomFieldValuesAggregateBoolExpCorr>;
  count?: InputMaybe<CustomFieldValuesAggregateBoolExpCount>;
  covar_samp?: InputMaybe<CustomFieldValuesAggregateBoolExpCovarSamp>;
  max?: InputMaybe<CustomFieldValuesAggregateBoolExpMax>;
  min?: InputMaybe<CustomFieldValuesAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<CustomFieldValuesAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<CustomFieldValuesAggregateBoolExpSum>;
  var_samp?: InputMaybe<CustomFieldValuesAggregateBoolExpVarSamp>;
};

export type CustomFieldValuesAggregateBoolExpAvg = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpBoolAnd = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpBoolOr = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpCorr = {
  arguments: CustomFieldValuesAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpCorrArguments = {
  X: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpCorrArgumentsColumns;
  Y: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpCorrArgumentsColumns;
};

export type CustomFieldValuesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: IntComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpCovarSamp = {
  arguments: CustomFieldValuesAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpCovarSampArguments = {
  X: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpCovarSampArgumentsColumns;
  Y: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpCovarSampArgumentsColumns;
};

export type CustomFieldValuesAggregateBoolExpMax = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpMin = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpStddevSamp = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpSum = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

export type CustomFieldValuesAggregateBoolExpVarSamp = {
  arguments: CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CustomFieldValuesBoolExp>;
  predicate: Float8ComparisonExp;
};

/** aggregate fields of "custom_field_values" */
export type CustomFieldValuesAggregateFields = {
  __typename?: 'custom_field_values_aggregate_fields';
  avg: Maybe<CustomFieldValuesAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<CustomFieldValuesMaxFields>;
  min: Maybe<CustomFieldValuesMinFields>;
  stddev: Maybe<CustomFieldValuesStddevFields>;
  stddev_pop: Maybe<CustomFieldValuesStddevPopFields>;
  stddev_samp: Maybe<CustomFieldValuesStddevSampFields>;
  sum: Maybe<CustomFieldValuesSumFields>;
  var_pop: Maybe<CustomFieldValuesVarPopFields>;
  var_samp: Maybe<CustomFieldValuesVarSampFields>;
  variance: Maybe<CustomFieldValuesVarianceFields>;
};


/** aggregate fields of "custom_field_values" */
export type CustomFieldValuesAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "custom_field_values" */
export type CustomFieldValuesAggregateOrderBy = {
  avg?: InputMaybe<CustomFieldValuesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CustomFieldValuesMaxOrderBy>;
  min?: InputMaybe<CustomFieldValuesMinOrderBy>;
  stddev?: InputMaybe<CustomFieldValuesStddevOrderBy>;
  stddev_pop?: InputMaybe<CustomFieldValuesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<CustomFieldValuesStddevSampOrderBy>;
  sum?: InputMaybe<CustomFieldValuesSumOrderBy>;
  var_pop?: InputMaybe<CustomFieldValuesVarPopOrderBy>;
  var_samp?: InputMaybe<CustomFieldValuesVarSampOrderBy>;
  variance?: InputMaybe<CustomFieldValuesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "custom_field_values" */
export type CustomFieldValuesArrRelInsertInput = {
  data: Array<CustomFieldValuesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldValuesOnConflict>;
};

/** aggregate avg on columns */
export type CustomFieldValuesAvgFields = {
  __typename?: 'custom_field_values_avg_fields';
  numberValue: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "custom_field_values" */
export type CustomFieldValuesAvgOrderBy = {
  numberValue?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "custom_field_values". All fields are combined with a logical 'AND'. */
export type CustomFieldValuesBoolExp = {
  _and?: InputMaybe<Array<CustomFieldValuesBoolExp>>;
  _not?: InputMaybe<CustomFieldValuesBoolExp>;
  _or?: InputMaybe<Array<CustomFieldValuesBoolExp>>;
  booleanValue?: InputMaybe<BooleanComparisonExp>;
  choice?: InputMaybe<CustomFieldChoicesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customField?: InputMaybe<CustomFieldsBoolExp>;
  customFieldChoiceId?: InputMaybe<UuidComparisonExp>;
  customFieldCoreData?: InputMaybe<CustomFieldCoreDataBoolExp>;
  customFieldCoreDataId?: InputMaybe<UuidComparisonExp>;
  customFieldId?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  entityId?: InputMaybe<UuidComparisonExp>;
  file?: InputMaybe<RequestDocumentsBoolExp>;
  fileId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  numberValue?: InputMaybe<Float8ComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "custom_field_values" */
export enum CustomFieldValuesConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_CUSTOM_FIELD_VALUES_PKEY = 'organisation_custom_field_values_pkey'
}

/** input type for incrementing numeric columns in table "custom_field_values" */
export type CustomFieldValuesIncInput = {
  numberValue?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "custom_field_values" */
export type CustomFieldValuesInsertInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  choice?: InputMaybe<CustomFieldChoicesObjRelInsertInput>;
  customField?: InputMaybe<CustomFieldsObjRelInsertInput>;
  customFieldChoiceId?: InputMaybe<Scalars['uuid']['input']>;
  customFieldCoreData?: InputMaybe<CustomFieldCoreDataObjRelInsertInput>;
  customFieldCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  customFieldId?: InputMaybe<Scalars['uuid']['input']>;
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<RequestDocumentsObjRelInsertInput>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  numberValue?: InputMaybe<Scalars['float8']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CustomFieldValuesMaxFields = {
  __typename?: 'custom_field_values_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customFieldChoiceId: Maybe<Scalars['uuid']['output']>;
  customFieldCoreDataId: Maybe<Scalars['uuid']['output']>;
  customFieldId: Maybe<Scalars['uuid']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  entityId: Maybe<Scalars['uuid']['output']>;
  fileId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  numberValue: Maybe<Scalars['float8']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "custom_field_values" */
export type CustomFieldValuesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customFieldChoiceId?: InputMaybe<OrderBy>;
  customFieldCoreDataId?: InputMaybe<OrderBy>;
  customFieldId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  entityId?: InputMaybe<OrderBy>;
  fileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  numberValue?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CustomFieldValuesMinFields = {
  __typename?: 'custom_field_values_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customFieldChoiceId: Maybe<Scalars['uuid']['output']>;
  customFieldCoreDataId: Maybe<Scalars['uuid']['output']>;
  customFieldId: Maybe<Scalars['uuid']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  entityId: Maybe<Scalars['uuid']['output']>;
  fileId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  numberValue: Maybe<Scalars['float8']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "custom_field_values" */
export type CustomFieldValuesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customFieldChoiceId?: InputMaybe<OrderBy>;
  customFieldCoreDataId?: InputMaybe<OrderBy>;
  customFieldId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  entityId?: InputMaybe<OrderBy>;
  fileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  numberValue?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "custom_field_values" */
export type CustomFieldValuesMutationResponse = {
  __typename?: 'custom_field_values_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomFieldValues>;
};

/** on_conflict condition type for table "custom_field_values" */
export type CustomFieldValuesOnConflict = {
  constraint: CustomFieldValuesConstraint;
  update_columns: Array<CustomFieldValuesUpdateColumn>;
  where?: InputMaybe<CustomFieldValuesBoolExp>;
};

/** Ordering options when selecting data from "custom_field_values". */
export type CustomFieldValuesOrderBy = {
  booleanValue?: InputMaybe<OrderBy>;
  choice?: InputMaybe<CustomFieldChoicesOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customField?: InputMaybe<CustomFieldsOrderBy>;
  customFieldChoiceId?: InputMaybe<OrderBy>;
  customFieldCoreData?: InputMaybe<CustomFieldCoreDataOrderBy>;
  customFieldCoreDataId?: InputMaybe<OrderBy>;
  customFieldId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  entityId?: InputMaybe<OrderBy>;
  file?: InputMaybe<RequestDocumentsOrderBy>;
  fileId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  numberValue?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: custom_field_values */
export type CustomFieldValuesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumn {
  /** column name */
  BOOLEANVALUE = 'booleanValue',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CUSTOMFIELDCHOICEID = 'customFieldChoiceId',
  /** column name */
  CUSTOMFIELDCOREDATAID = 'customFieldCoreDataId',
  /** column name */
  CUSTOMFIELDID = 'customFieldId',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ENTITYID = 'entityId',
  /** column name */
  FILEID = 'fileId',
  /** column name */
  ID = 'id',
  /** column name */
  NUMBERVALUE = 'numberValue',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId',
  /** column name */
  VALUE = 'value'
}

/** select "custom_field_values_aggregate_bool_exp_avg_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** select "custom_field_values_aggregate_bool_exp_bool_and_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  BOOLEANVALUE = 'booleanValue'
}

/** select "custom_field_values_aggregate_bool_exp_bool_or_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  BOOLEANVALUE = 'booleanValue'
}

/** select "custom_field_values_aggregate_bool_exp_corr_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** select "custom_field_values_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** select "custom_field_values_aggregate_bool_exp_max_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** select "custom_field_values_aggregate_bool_exp_min_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpMinArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** select "custom_field_values_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** select "custom_field_values_aggregate_bool_exp_sum_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpSumArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** select "custom_field_values_aggregate_bool_exp_var_samp_arguments_columns" columns of table "custom_field_values" */
export enum CustomFieldValuesSelectColumnCustomFieldValuesAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  NUMBERVALUE = 'numberValue'
}

/** input type for updating data in table "custom_field_values" */
export type CustomFieldValuesSetInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  customFieldChoiceId?: InputMaybe<Scalars['uuid']['input']>;
  customFieldCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  numberValue?: InputMaybe<Scalars['float8']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type CustomFieldValuesStddevFields = {
  __typename?: 'custom_field_values_stddev_fields';
  numberValue: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "custom_field_values" */
export type CustomFieldValuesStddevOrderBy = {
  numberValue?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type CustomFieldValuesStddevPopFields = {
  __typename?: 'custom_field_values_stddev_pop_fields';
  numberValue: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "custom_field_values" */
export type CustomFieldValuesStddevPopOrderBy = {
  numberValue?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type CustomFieldValuesStddevSampFields = {
  __typename?: 'custom_field_values_stddev_samp_fields';
  numberValue: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "custom_field_values" */
export type CustomFieldValuesStddevSampOrderBy = {
  numberValue?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type CustomFieldValuesSumFields = {
  __typename?: 'custom_field_values_sum_fields';
  numberValue: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "custom_field_values" */
export type CustomFieldValuesSumOrderBy = {
  numberValue?: InputMaybe<OrderBy>;
};

/** update columns of table "custom_field_values" */
export enum CustomFieldValuesUpdateColumn {
  /** column name */
  BOOLEANVALUE = 'booleanValue',
  /** column name */
  CUSTOMFIELDCHOICEID = 'customFieldChoiceId',
  /** column name */
  CUSTOMFIELDCOREDATAID = 'customFieldCoreDataId',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  FILEID = 'fileId',
  /** column name */
  NUMBERVALUE = 'numberValue',
  /** column name */
  USERID = 'userId',
  /** column name */
  VALUE = 'value'
}

export type CustomFieldValuesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CustomFieldValuesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomFieldValuesSetInput>;
  /** filter the rows which have to be updated */
  where: CustomFieldValuesBoolExp;
};

/** aggregate var_pop on columns */
export type CustomFieldValuesVarPopFields = {
  __typename?: 'custom_field_values_var_pop_fields';
  numberValue: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "custom_field_values" */
export type CustomFieldValuesVarPopOrderBy = {
  numberValue?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type CustomFieldValuesVarSampFields = {
  __typename?: 'custom_field_values_var_samp_fields';
  numberValue: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "custom_field_values" */
export type CustomFieldValuesVarSampOrderBy = {
  numberValue?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CustomFieldValuesVarianceFields = {
  __typename?: 'custom_field_values_variance_fields';
  numberValue: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "custom_field_values" */
export type CustomFieldValuesVarianceOrderBy = {
  numberValue?: InputMaybe<OrderBy>;
};

/** Custom fields config that is shared across all suppliers in an organisation */
export type CustomFields = {
  __typename?: 'custom_fields';
  allowUserToAddCustomOptions: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  choices: Array<CustomFieldChoices>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  customCoreData: Maybe<CustomCoreData>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  dependentCustomFields: Array<CustomFields>;
  /** An object relationship */
  dependsOnCustomField: Maybe<CustomFields>;
  dependsOnCustomFieldId: Maybe<Scalars['uuid']['output']>;
  entityType: Scalars['customFieldsEntityType']['output'];
  externalSource: Maybe<Scalars['customFieldsCoreDataExternalSourceType']['output']>;
  id: Scalars['uuid']['output'];
  isRequired: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationIntegration: Maybe<OrganisationIntegrations>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['customFieldsType']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  values: Array<CustomFieldValues>;
  /** An aggregate relationship */
  values_aggregate: CustomFieldValuesAggregate;
};


/** Custom fields config that is shared across all suppliers in an organisation */
export type CustomFieldsChoicesArgs = {
  distinct_on: InputMaybe<Array<CustomFieldChoicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldChoicesOrderBy>>;
  where: InputMaybe<CustomFieldChoicesBoolExp>;
};


/** Custom fields config that is shared across all suppliers in an organisation */
export type CustomFieldsDependentCustomFieldsArgs = {
  distinct_on: InputMaybe<Array<CustomFieldsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldsOrderBy>>;
  where: InputMaybe<CustomFieldsBoolExp>;
};


/** Custom fields config that is shared across all suppliers in an organisation */
export type CustomFieldsValuesArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** Custom fields config that is shared across all suppliers in an organisation */
export type CustomFieldsValuesAggregateArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};

/** order by aggregate values of table "custom_fields" */
export type CustomFieldsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CustomFieldsMaxOrderBy>;
  min?: InputMaybe<CustomFieldsMinOrderBy>;
};

/** input type for inserting array relation for remote table "custom_fields" */
export type CustomFieldsArrRelInsertInput = {
  data: Array<CustomFieldsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldsOnConflict>;
};

/** Boolean expression to filter rows from the table "custom_fields". All fields are combined with a logical 'AND'. */
export type CustomFieldsBoolExp = {
  _and?: InputMaybe<Array<CustomFieldsBoolExp>>;
  _not?: InputMaybe<CustomFieldsBoolExp>;
  _or?: InputMaybe<Array<CustomFieldsBoolExp>>;
  allowUserToAddCustomOptions?: InputMaybe<BooleanComparisonExp>;
  choices?: InputMaybe<CustomFieldChoicesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customCoreData?: InputMaybe<CustomCoreDataBoolExp>;
  customCoreDataId?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  dependentCustomFields?: InputMaybe<CustomFieldsBoolExp>;
  dependsOnCustomField?: InputMaybe<CustomFieldsBoolExp>;
  dependsOnCustomFieldId?: InputMaybe<UuidComparisonExp>;
  entityType?: InputMaybe<StringComparisonExp>;
  externalSource?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isRequired?: InputMaybe<BooleanComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  values?: InputMaybe<CustomFieldValuesBoolExp>;
  values_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
};

/** unique or primary key constraints on table "custom_fields" */
export enum CustomFieldsConstraint {
  /** unique or primary key constraint on columns "entity_type", "deleted_at", "key", "organisation_id" */
  CUSTOM_FIELDS_KEY_ORGANISATION_ID_DELETED_AT_ENTITY_TYPE_KEY = 'custom_fields_key_organisation_id_deleted_at_entity_type_key',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  CUSTOM_FIELDS_REMOTE_ID_ORGANISATION_ID_ACTIVE_UNIQUE = 'custom_fields_remote_id_organisation_id_active_unique',
  /** unique or primary key constraint on columns "remote_id", "organisation_integration_id" */
  CUSTOM_FIELDS_REMOTE_ID_ORGANISATION_INTEGRATION_ID_KEY = 'custom_fields_remote_id_organisation_integration_id_key',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_CUSTOM_FIELDS_PKEY = 'organisation_custom_fields_pkey',
  /** unique or primary key constraint on columns "entity_type", "key", "organisation_id" */
  UNIQUE_CUSTOM_FIELD_KEY_PER_ORGANISATION_AND_DELETED_AT = 'unique_custom_field_key_per_organisation_and_deleted_at',
  /** unique or primary key constraint on columns "entity_type", "deleted_at", "organisation_id", "title" */
  UNIQUE_CUSTOM_FIELD_TITLE_PER_ORGANISATION_AND_DELETED_AT = 'unique_custom_field_title_per_organisation_and_deleted_at'
}

/** input type for inserting data into table "custom_fields" */
export type CustomFieldsInsertInput = {
  allowUserToAddCustomOptions?: InputMaybe<Scalars['Boolean']['input']>;
  choices?: InputMaybe<CustomFieldChoicesArrRelInsertInput>;
  customCoreData?: InputMaybe<CustomCoreDataObjRelInsertInput>;
  customCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  dependentCustomFields?: InputMaybe<CustomFieldsArrRelInsertInput>;
  dependsOnCustomField?: InputMaybe<CustomFieldsObjRelInsertInput>;
  entityType: Scalars['customFieldsEntityType']['input'];
  externalSource?: InputMaybe<Scalars['customFieldsCoreDataExternalSourceType']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['customFieldsType']['input'];
  values?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
};

/** order by max() on columns of table "custom_fields" */
export type CustomFieldsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customCoreDataId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  dependsOnCustomFieldId?: InputMaybe<OrderBy>;
  entityType?: InputMaybe<OrderBy>;
  externalSource?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "custom_fields" */
export type CustomFieldsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customCoreDataId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  dependsOnCustomFieldId?: InputMaybe<OrderBy>;
  entityType?: InputMaybe<OrderBy>;
  externalSource?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "custom_fields" */
export type CustomFieldsMutationResponse = {
  __typename?: 'custom_fields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomFields>;
};

/** input type for inserting object relation for remote table "custom_fields" */
export type CustomFieldsObjRelInsertInput = {
  data: CustomFieldsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomFieldsOnConflict>;
};

/** on_conflict condition type for table "custom_fields" */
export type CustomFieldsOnConflict = {
  constraint: CustomFieldsConstraint;
  update_columns: Array<CustomFieldsUpdateColumn>;
  where?: InputMaybe<CustomFieldsBoolExp>;
};

/** Ordering options when selecting data from "custom_fields". */
export type CustomFieldsOrderBy = {
  allowUserToAddCustomOptions?: InputMaybe<OrderBy>;
  choices_aggregate?: InputMaybe<CustomFieldChoicesAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customCoreData?: InputMaybe<CustomCoreDataOrderBy>;
  customCoreDataId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  dependentCustomFields_aggregate?: InputMaybe<CustomFieldsAggregateOrderBy>;
  dependsOnCustomField?: InputMaybe<CustomFieldsOrderBy>;
  dependsOnCustomFieldId?: InputMaybe<OrderBy>;
  entityType?: InputMaybe<OrderBy>;
  externalSource?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isRequired?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsOrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  values_aggregate?: InputMaybe<CustomFieldValuesAggregateOrderBy>;
};

/** primary key columns input for table: custom_fields */
export type CustomFieldsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "custom_fields" */
export enum CustomFieldsSelectColumn {
  /** column name */
  ALLOWUSERTOADDCUSTOMOPTIONS = 'allowUserToAddCustomOptions',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CUSTOMCOREDATAID = 'customCoreDataId',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPENDSONCUSTOMFIELDID = 'dependsOnCustomFieldId',
  /** column name */
  ENTITYTYPE = 'entityType',
  /** column name */
  EXTERNALSOURCE = 'externalSource',
  /** column name */
  ID = 'id',
  /** column name */
  ISREQUIRED = 'isRequired',
  /** column name */
  KEY = 'key',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "custom_fields" */
export type CustomFieldsSetInput = {
  allowUserToAddCustomOptions?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityType?: InputMaybe<Scalars['customFieldsEntityType']['input']>;
  externalSource?: InputMaybe<Scalars['customFieldsCoreDataExternalSourceType']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['customFieldsType']['input']>;
};

/** update columns of table "custom_fields" */
export enum CustomFieldsUpdateColumn {
  /** column name */
  ALLOWUSERTOADDCUSTOMOPTIONS = 'allowUserToAddCustomOptions',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ISREQUIRED = 'isRequired',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  TITLE = 'title'
}

export type CustomFieldsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomFieldsSetInput>;
  /** filter the rows which have to be updated */
  where: CustomFieldsBoolExp;
};

/** columns and relationships of "custom_reports" */
export type CustomReports = {
  __typename?: 'custom_reports';
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  custom_reports_generations: Array<CustomReportsGenerations>;
  dataFields: Scalars['jsonb']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  filters: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  scheduleEnabled: Scalars['Boolean']['output'];
  scheduleFrequency: Maybe<Scalars['String']['output']>;
  /** Array of user IDs who should receive scheduled reports */
  scheduleRecipients: Maybe<Array<Scalars['uuid']['output']>>;
  scheduleRunOn: Maybe<Scalars['String']['output']>;
  scheduleTime: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
  visibility: Scalars['String']['output'];
};


/** columns and relationships of "custom_reports" */
export type CustomReportsCustomReportsGenerationsArgs = {
  distinct_on: InputMaybe<Array<CustomReportsGenerationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomReportsGenerationsOrderBy>>;
  where: InputMaybe<CustomReportsGenerationsBoolExp>;
};


/** columns and relationships of "custom_reports" */
export type CustomReportsDataFieldsArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "custom_reports" */
export type CustomReportsFiltersArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CustomReportsAppendInput = {
  dataFields?: InputMaybe<Scalars['jsonb']['input']>;
  filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "custom_reports". All fields are combined with a logical 'AND'. */
export type CustomReportsBoolExp = {
  _and?: InputMaybe<Array<CustomReportsBoolExp>>;
  _not?: InputMaybe<CustomReportsBoolExp>;
  _or?: InputMaybe<Array<CustomReportsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  custom_reports_generations?: InputMaybe<CustomReportsGenerationsBoolExp>;
  dataFields?: InputMaybe<JsonbComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  filters?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  scheduleEnabled?: InputMaybe<BooleanComparisonExp>;
  scheduleFrequency?: InputMaybe<StringComparisonExp>;
  scheduleRecipients?: InputMaybe<UuidArrayComparisonExp>;
  scheduleRunOn?: InputMaybe<StringComparisonExp>;
  scheduleTime?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  visibility?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "custom_reports" */
export enum CustomReportsConstraint {
  /** unique or primary key constraint on columns "id" */
  CUSTOM_REPORTS_PKEY = 'custom_reports_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CustomReportsDeleteAtPathInput = {
  dataFields?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CustomReportsDeleteElemInput = {
  dataFields?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CustomReportsDeleteKeyInput = {
  dataFields?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "custom_reports_generations" */
export type CustomReportsGenerations = {
  __typename?: 'custom_reports_generations';
  customReportsId: Scalars['uuid']['output'];
  /** An object relationship */
  custom_report: CustomReports;
  fileName: Scalars['String']['output'];
  fileStoreId: Maybe<Scalars['String']['output']>;
  generatedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  requestedAt: Scalars['timestamptz']['output'];
  status: Scalars['String']['output'];
};

/** order by aggregate values of table "custom_reports_generations" */
export type CustomReportsGenerationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CustomReportsGenerationsMaxOrderBy>;
  min?: InputMaybe<CustomReportsGenerationsMinOrderBy>;
};

/** input type for inserting array relation for remote table "custom_reports_generations" */
export type CustomReportsGenerationsArrRelInsertInput = {
  data: Array<CustomReportsGenerationsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomReportsGenerationsOnConflict>;
};

/** Boolean expression to filter rows from the table "custom_reports_generations". All fields are combined with a logical 'AND'. */
export type CustomReportsGenerationsBoolExp = {
  _and?: InputMaybe<Array<CustomReportsGenerationsBoolExp>>;
  _not?: InputMaybe<CustomReportsGenerationsBoolExp>;
  _or?: InputMaybe<Array<CustomReportsGenerationsBoolExp>>;
  customReportsId?: InputMaybe<UuidComparisonExp>;
  custom_report?: InputMaybe<CustomReportsBoolExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  fileStoreId?: InputMaybe<StringComparisonExp>;
  generatedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  requestedAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "custom_reports_generations" */
export enum CustomReportsGenerationsConstraint {
  /** unique or primary key constraint on columns "id" */
  CUSTOM_REPORTS_GENERATIONS_PKEY = 'custom_reports_generations_pkey'
}

/** input type for inserting data into table "custom_reports_generations" */
export type CustomReportsGenerationsInsertInput = {
  customReportsId?: InputMaybe<Scalars['uuid']['input']>;
  custom_report?: InputMaybe<CustomReportsObjRelInsertInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileStoreId?: InputMaybe<Scalars['String']['input']>;
  generatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "custom_reports_generations" */
export type CustomReportsGenerationsMaxOrderBy = {
  customReportsId?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileStoreId?: InputMaybe<OrderBy>;
  generatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "custom_reports_generations" */
export type CustomReportsGenerationsMinOrderBy = {
  customReportsId?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileStoreId?: InputMaybe<OrderBy>;
  generatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "custom_reports_generations" */
export type CustomReportsGenerationsMutationResponse = {
  __typename?: 'custom_reports_generations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomReportsGenerations>;
};

/** on_conflict condition type for table "custom_reports_generations" */
export type CustomReportsGenerationsOnConflict = {
  constraint: CustomReportsGenerationsConstraint;
  update_columns: Array<CustomReportsGenerationsUpdateColumn>;
  where?: InputMaybe<CustomReportsGenerationsBoolExp>;
};

/** Ordering options when selecting data from "custom_reports_generations". */
export type CustomReportsGenerationsOrderBy = {
  customReportsId?: InputMaybe<OrderBy>;
  custom_report?: InputMaybe<CustomReportsOrderBy>;
  fileName?: InputMaybe<OrderBy>;
  fileStoreId?: InputMaybe<OrderBy>;
  generatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: custom_reports_generations */
export type CustomReportsGenerationsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "custom_reports_generations" */
export enum CustomReportsGenerationsSelectColumn {
  /** column name */
  CUSTOMREPORTSID = 'customReportsId',
  /** column name */
  FILENAME = 'fileName',
  /** column name */
  FILESTOREID = 'fileStoreId',
  /** column name */
  GENERATEDAT = 'generatedAt',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTEDAT = 'requestedAt',
  /** column name */
  STATUS = 'status'
}

/** input type for updating data in table "custom_reports_generations" */
export type CustomReportsGenerationsSetInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileStoreId?: InputMaybe<Scalars['String']['input']>;
  generatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  requestedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "custom_reports_generations" */
export type CustomReportsGenerationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CustomReportsGenerationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CustomReportsGenerationsStreamCursorValueInput = {
  customReportsId?: InputMaybe<Scalars['uuid']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileStoreId?: InputMaybe<Scalars['String']['input']>;
  generatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "custom_reports_generations" */
export enum CustomReportsGenerationsUpdateColumn {
  /** column name */
  FILENAME = 'fileName',
  /** column name */
  FILESTOREID = 'fileStoreId',
  /** column name */
  GENERATEDAT = 'generatedAt',
  /** column name */
  REQUESTEDAT = 'requestedAt',
  /** column name */
  STATUS = 'status'
}

export type CustomReportsGenerationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomReportsGenerationsSetInput>;
  /** filter the rows which have to be updated */
  where: CustomReportsGenerationsBoolExp;
};

/** input type for inserting data into table "custom_reports" */
export type CustomReportsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  custom_reports_generations?: InputMaybe<CustomReportsGenerationsArrRelInsertInput>;
  dataFields?: InputMaybe<Scalars['jsonb']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  filters?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scheduleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Array of user IDs who should receive scheduled reports */
  scheduleRecipients?: InputMaybe<Array<Scalars['uuid']['input']>>;
  scheduleRunOn?: InputMaybe<Scalars['String']['input']>;
  scheduleTime?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "custom_reports" */
export type CustomReportsMutationResponse = {
  __typename?: 'custom_reports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CustomReports>;
};

/** input type for inserting object relation for remote table "custom_reports" */
export type CustomReportsObjRelInsertInput = {
  data: CustomReportsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<CustomReportsOnConflict>;
};

/** on_conflict condition type for table "custom_reports" */
export type CustomReportsOnConflict = {
  constraint: CustomReportsConstraint;
  update_columns: Array<CustomReportsUpdateColumn>;
  where?: InputMaybe<CustomReportsBoolExp>;
};

/** Ordering options when selecting data from "custom_reports". */
export type CustomReportsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  custom_reports_generations_aggregate?: InputMaybe<CustomReportsGenerationsAggregateOrderBy>;
  dataFields?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  filters?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  scheduleEnabled?: InputMaybe<OrderBy>;
  scheduleFrequency?: InputMaybe<OrderBy>;
  scheduleRecipients?: InputMaybe<OrderBy>;
  scheduleRunOn?: InputMaybe<OrderBy>;
  scheduleTime?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  visibility?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: custom_reports */
export type CustomReportsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CustomReportsPrependInput = {
  dataFields?: InputMaybe<Scalars['jsonb']['input']>;
  filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "custom_reports" */
export enum CustomReportsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DATAFIELDS = 'dataFields',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  FILTERS = 'filters',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  SCHEDULEENABLED = 'scheduleEnabled',
  /** column name */
  SCHEDULEFREQUENCY = 'scheduleFrequency',
  /** column name */
  SCHEDULERECIPIENTS = 'scheduleRecipients',
  /** column name */
  SCHEDULERUNON = 'scheduleRunOn',
  /** column name */
  SCHEDULETIME = 'scheduleTime',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId',
  /** column name */
  VISIBILITY = 'visibility'
}

/** input type for updating data in table "custom_reports" */
export type CustomReportsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataFields?: InputMaybe<Scalars['jsonb']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  filters?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scheduleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Array of user IDs who should receive scheduled reports */
  scheduleRecipients?: InputMaybe<Array<Scalars['uuid']['input']>>;
  scheduleRunOn?: InputMaybe<Scalars['String']['input']>;
  scheduleTime?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "custom_reports" */
export type CustomReportsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: CustomReportsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CustomReportsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataFields?: InputMaybe<Scalars['jsonb']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  filters?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  scheduleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Array of user IDs who should receive scheduled reports */
  scheduleRecipients?: InputMaybe<Array<Scalars['uuid']['input']>>;
  scheduleRunOn?: InputMaybe<Scalars['String']['input']>;
  scheduleTime?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "custom_reports" */
export enum CustomReportsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DATAFIELDS = 'dataFields',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  FILTERS = 'filters',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  SCHEDULEENABLED = 'scheduleEnabled',
  /** column name */
  SCHEDULEFREQUENCY = 'scheduleFrequency',
  /** column name */
  SCHEDULERECIPIENTS = 'scheduleRecipients',
  /** column name */
  SCHEDULERUNON = 'scheduleRunOn',
  /** column name */
  SCHEDULETIME = 'scheduleTime',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId',
  /** column name */
  VISIBILITY = 'visibility'
}

export type CustomReportsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CustomReportsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CustomReportsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CustomReportsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CustomReportsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CustomReportsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CustomReportsSetInput>;
  /** filter the rows which have to be updated */
  where: CustomReportsBoolExp;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type DateComparisonExp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "departments" */
export type Departments = {
  __typename?: 'departments';
  archivedBy: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "departments" */
export type DepartmentsAggregate = {
  __typename?: 'departments_aggregate';
  aggregate: Maybe<DepartmentsAggregateFields>;
  nodes: Array<Departments>;
};

/** aggregate fields of "departments" */
export type DepartmentsAggregateFields = {
  __typename?: 'departments_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<DepartmentsMaxFields>;
  min: Maybe<DepartmentsMinFields>;
};


/** aggregate fields of "departments" */
export type DepartmentsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<DepartmentsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "departments". All fields are combined with a logical 'AND'. */
export type DepartmentsBoolExp = {
  _and?: InputMaybe<Array<DepartmentsBoolExp>>;
  _not?: InputMaybe<DepartmentsBoolExp>;
  _or?: InputMaybe<Array<DepartmentsBoolExp>>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "departments" */
export enum DepartmentsConstraint {
  /** unique or primary key constraint on columns "id" */
  DEPARTMENTS_PKEY = 'departments_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  DEPARTMENTS_REMOTE_ID_ORGANISATION_ID_KEY = 'departments_remote_id_organisation_id_key'
}

/** input type for inserting data into table "departments" */
export type DepartmentsInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type DepartmentsMaxFields = {
  __typename?: 'departments_max_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type DepartmentsMinFields = {
  __typename?: 'departments_min_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "departments" */
export type DepartmentsMutationResponse = {
  __typename?: 'departments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Departments>;
};

/** input type for inserting object relation for remote table "departments" */
export type DepartmentsObjRelInsertInput = {
  data: DepartmentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DepartmentsOnConflict>;
};

/** on_conflict condition type for table "departments" */
export type DepartmentsOnConflict = {
  constraint: DepartmentsConstraint;
  update_columns: Array<DepartmentsUpdateColumn>;
  where?: InputMaybe<DepartmentsBoolExp>;
};

/** Ordering options when selecting data from "departments". */
export type DepartmentsOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  coreData?: InputMaybe<CoreDataOrderBy>;
  coreDataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: departments */
export type DepartmentsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "departments" */
export enum DepartmentsSelectColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  COREDATAID = 'coreDataId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "departments" */
export type DepartmentsSetInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "departments" */
export enum DepartmentsUpdateColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type DepartmentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DepartmentsSetInput>;
  /** filter the rows which have to be updated */
  where: DepartmentsBoolExp;
};

/** columns and relationships of "document_types" */
export type DocumentTypes = {
  __typename?: 'document_types';
  attributes: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "document_types" */
export type DocumentTypesAttributesArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DocumentTypesAppendInput = {
  attributes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "document_types". All fields are combined with a logical 'AND'. */
export type DocumentTypesBoolExp = {
  _and?: InputMaybe<Array<DocumentTypesBoolExp>>;
  _not?: InputMaybe<DocumentTypesBoolExp>;
  _or?: InputMaybe<Array<DocumentTypesBoolExp>>;
  attributes?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "document_types" */
export enum DocumentTypesConstraint {
  /** unique or primary key constraint on columns "id" */
  DOCUMENT_TYPES_PKEY = 'document_types_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DocumentTypesDeleteAtPathInput = {
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DocumentTypesDeleteElemInput = {
  attributes?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DocumentTypesDeleteKeyInput = {
  attributes?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "document_types" */
export type DocumentTypesInsertInput = {
  attributes?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "document_types" */
export type DocumentTypesMutationResponse = {
  __typename?: 'document_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DocumentTypes>;
};

/** on_conflict condition type for table "document_types" */
export type DocumentTypesOnConflict = {
  constraint: DocumentTypesConstraint;
  update_columns: Array<DocumentTypesUpdateColumn>;
  where?: InputMaybe<DocumentTypesBoolExp>;
};

/** Ordering options when selecting data from "document_types". */
export type DocumentTypesOrderBy = {
  attributes?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: document_types */
export type DocumentTypesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DocumentTypesPrependInput = {
  attributes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "document_types" */
export enum DocumentTypesSelectColumn {
  /** column name */
  ATTRIBUTES = 'attributes',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "document_types" */
export type DocumentTypesSetInput = {
  attributes?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "document_types" */
export type DocumentTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: DocumentTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DocumentTypesStreamCursorValueInput = {
  attributes?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "document_types" */
export enum DocumentTypesUpdateColumn {
  /** column name */
  ATTRIBUTES = 'attributes',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type DocumentTypesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DocumentTypesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DocumentTypesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DocumentTypesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DocumentTypesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DocumentTypesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DocumentTypesSetInput>;
  /** filter the rows which have to be updated */
  where: DocumentTypesBoolExp;
};

/** columns and relationships of "documents" */
export type Documents = {
  __typename?: 'documents';
  /** An array relationship */
  agreement_documents: Array<AgreementDocuments>;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  customFieldValues: Array<CustomFieldValues>;
  /** An aggregate relationship */
  customFieldValues_aggregate: CustomFieldValuesAggregate;
  customType: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customTypeValue: Maybe<CustomDocumentTypes>;
  fileName: Scalars['String']['output'];
  filestoreId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product: Maybe<OrganisationProductsAndServices>;
  requestDocumentsId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sourceRequestDocument: Maybe<RequestDocuments>;
  staticType: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  supplier: Maybe<OrganisationSuppliers>;
  updatedAt: Scalars['timestamptz']['output'];
  uploadedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  uploadedByUser: Maybe<Users>;
};


/** columns and relationships of "documents" */
export type DocumentsAgreementDocumentsArgs = {
  distinct_on: InputMaybe<Array<AgreementDocumentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementDocumentsOrderBy>>;
  where: InputMaybe<AgreementDocumentsBoolExp>;
};


/** columns and relationships of "documents" */
export type DocumentsCustomFieldValuesArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** columns and relationships of "documents" */
export type DocumentsCustomFieldValuesAggregateArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};

/** aggregated selection of "documents" */
export type DocumentsAggregate = {
  __typename?: 'documents_aggregate';
  aggregate: Maybe<DocumentsAggregateFields>;
  nodes: Array<Documents>;
};

export type DocumentsAggregateBoolExp = {
  count?: InputMaybe<DocumentsAggregateBoolExpCount>;
};

export type DocumentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DocumentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DocumentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "documents" */
export type DocumentsAggregateFields = {
  __typename?: 'documents_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<DocumentsMaxFields>;
  min: Maybe<DocumentsMinFields>;
};


/** aggregate fields of "documents" */
export type DocumentsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<DocumentsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "documents" */
export type DocumentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DocumentsMaxOrderBy>;
  min?: InputMaybe<DocumentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "documents" */
export type DocumentsArrRelInsertInput = {
  data: Array<DocumentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<DocumentsOnConflict>;
};

/** Boolean expression to filter rows from the table "documents". All fields are combined with a logical 'AND'. */
export type DocumentsBoolExp = {
  _and?: InputMaybe<Array<DocumentsBoolExp>>;
  _not?: InputMaybe<DocumentsBoolExp>;
  _or?: InputMaybe<Array<DocumentsBoolExp>>;
  agreement_documents?: InputMaybe<AgreementDocumentsBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customFieldValues?: InputMaybe<CustomFieldValuesBoolExp>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  customType?: InputMaybe<UuidComparisonExp>;
  customTypeValue?: InputMaybe<CustomDocumentTypesBoolExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  filestoreId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationProductId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  product?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  requestDocumentsId?: InputMaybe<UuidComparisonExp>;
  sourceRequestDocument?: InputMaybe<RequestDocumentsBoolExp>;
  staticType?: InputMaybe<StringComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  uploadedBy?: InputMaybe<UuidComparisonExp>;
  uploadedByUser?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "documents" */
export enum DocumentsConstraint {
  /** unique or primary key constraint on columns "filestore_id" */
  DOCUMENTS_FILESTORE_ID_KEY = 'documents_filestore_id_key',
  /** unique or primary key constraint on columns "id" */
  DOCUMENTS_PKEY = 'documents_pkey'
}

/** input type for inserting data into table "documents" */
export type DocumentsInsertInput = {
  agreement_documents?: InputMaybe<AgreementDocumentsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customFieldValues?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  customType?: InputMaybe<Scalars['uuid']['input']>;
  customTypeValue?: InputMaybe<CustomDocumentTypesObjRelInsertInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  filestoreId?: InputMaybe<Scalars['uuid']['input']>;
  organisationProductId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  product?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
  requestDocumentsId?: InputMaybe<Scalars['uuid']['input']>;
  sourceRequestDocument?: InputMaybe<RequestDocumentsObjRelInsertInput>;
  staticType?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedBy?: InputMaybe<Scalars['uuid']['input']>;
  uploadedByUser?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type DocumentsMaxFields = {
  __typename?: 'documents_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customType: Maybe<Scalars['uuid']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  filestoreId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  requestDocumentsId: Maybe<Scalars['uuid']['output']>;
  staticType: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  uploadedBy: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "documents" */
export type DocumentsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customType?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  filestoreId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  requestDocumentsId?: InputMaybe<OrderBy>;
  staticType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  uploadedBy?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DocumentsMinFields = {
  __typename?: 'documents_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customType: Maybe<Scalars['uuid']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  filestoreId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  requestDocumentsId: Maybe<Scalars['uuid']['output']>;
  staticType: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  uploadedBy: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "documents" */
export type DocumentsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customType?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  filestoreId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  requestDocumentsId?: InputMaybe<OrderBy>;
  staticType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  uploadedBy?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "documents" */
export type DocumentsMutationResponse = {
  __typename?: 'documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Documents>;
};

/** input type for inserting object relation for remote table "documents" */
export type DocumentsObjRelInsertInput = {
  data: DocumentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<DocumentsOnConflict>;
};

/** on_conflict condition type for table "documents" */
export type DocumentsOnConflict = {
  constraint: DocumentsConstraint;
  update_columns: Array<DocumentsUpdateColumn>;
  where?: InputMaybe<DocumentsBoolExp>;
};

/** Ordering options when selecting data from "documents". */
export type DocumentsOrderBy = {
  agreement_documents_aggregate?: InputMaybe<AgreementDocumentsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateOrderBy>;
  customType?: InputMaybe<OrderBy>;
  customTypeValue?: InputMaybe<CustomDocumentTypesOrderBy>;
  fileName?: InputMaybe<OrderBy>;
  filestoreId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  product?: InputMaybe<OrganisationProductsAndServicesOrderBy>;
  requestDocumentsId?: InputMaybe<OrderBy>;
  sourceRequestDocument?: InputMaybe<RequestDocumentsOrderBy>;
  staticType?: InputMaybe<OrderBy>;
  supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  uploadedBy?: InputMaybe<OrderBy>;
  uploadedByUser?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: documents */
export type DocumentsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "documents" */
export enum DocumentsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CUSTOMTYPE = 'customType',
  /** column name */
  FILENAME = 'fileName',
  /** column name */
  FILESTOREID = 'filestoreId',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  REQUESTDOCUMENTSID = 'requestDocumentsId',
  /** column name */
  STATICTYPE = 'staticType',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPLOADEDBY = 'uploadedBy'
}

/** input type for updating data in table "documents" */
export type DocumentsSetInput = {
  customType?: InputMaybe<Scalars['uuid']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  staticType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "documents" */
export enum DocumentsUpdateColumn {
  /** column name */
  CUSTOMTYPE = 'customType',
  /** column name */
  FILENAME = 'fileName',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  STATICTYPE = 'staticType',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type DocumentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DocumentsSetInput>;
  /** filter the rows which have to be updated */
  where: DocumentsBoolExp;
};

/** columns and relationships of "draft_intake_submissions" */
export type DraftIntakeSubmissions = {
  __typename?: 'draft_intake_submissions';
  aiGeneratedContext: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  duplicatedFromRequestId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  formTemplate: FormTemplates;
  formTemplateId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  response: Maybe<Scalars['requestFormSubmissionResponse']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
  /** An object relationship */
  workflow: Workflows;
  workflowId: Scalars['uuid']['output'];
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DraftIntakeSubmissionsAppendInput = {
  response?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "draft_intake_submissions". All fields are combined with a logical 'AND'. */
export type DraftIntakeSubmissionsBoolExp = {
  _and?: InputMaybe<Array<DraftIntakeSubmissionsBoolExp>>;
  _not?: InputMaybe<DraftIntakeSubmissionsBoolExp>;
  _or?: InputMaybe<Array<DraftIntakeSubmissionsBoolExp>>;
  aiGeneratedContext?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  duplicatedFromRequestId?: InputMaybe<UuidComparisonExp>;
  formTemplate?: InputMaybe<FormTemplatesBoolExp>;
  formTemplateId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  response?: InputMaybe<JsonbComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
  workflowId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "draft_intake_submissions" */
export enum DraftIntakeSubmissionsConstraint {
  /** unique or primary key constraint on columns "id" */
  DRAFT_INTAKE_SUBMISSIONS_PKEY = 'draft_intake_submissions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DraftIntakeSubmissionsDeleteAtPathInput = {
  response?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DraftIntakeSubmissionsDeleteElemInput = {
  response?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DraftIntakeSubmissionsDeleteKeyInput = {
  response?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "draft_intake_submissions" */
export type DraftIntakeSubmissionsInsertInput = {
  aiGeneratedContext?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  duplicatedFromRequestId?: InputMaybe<Scalars['uuid']['input']>;
  formTemplate?: InputMaybe<FormTemplatesObjRelInsertInput>;
  formTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "draft_intake_submissions" */
export type DraftIntakeSubmissionsMutationResponse = {
  __typename?: 'draft_intake_submissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DraftIntakeSubmissions>;
};

/** on_conflict condition type for table "draft_intake_submissions" */
export type DraftIntakeSubmissionsOnConflict = {
  constraint: DraftIntakeSubmissionsConstraint;
  update_columns: Array<DraftIntakeSubmissionsUpdateColumn>;
  where?: InputMaybe<DraftIntakeSubmissionsBoolExp>;
};

/** Ordering options when selecting data from "draft_intake_submissions". */
export type DraftIntakeSubmissionsOrderBy = {
  aiGeneratedContext?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  duplicatedFromRequestId?: InputMaybe<OrderBy>;
  formTemplate?: InputMaybe<FormTemplatesOrderBy>;
  formTemplateId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  response?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  workflow?: InputMaybe<WorkflowsOrderBy>;
  workflowId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: draft_intake_submissions */
export type DraftIntakeSubmissionsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DraftIntakeSubmissionsPrependInput = {
  response?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "draft_intake_submissions" */
export enum DraftIntakeSubmissionsSelectColumn {
  /** column name */
  AIGENERATEDCONTEXT = 'aiGeneratedContext',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DUPLICATEDFROMREQUESTID = 'duplicatedFromRequestId',
  /** column name */
  FORMTEMPLATEID = 'formTemplateId',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  RESPONSE = 'response',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId',
  /** column name */
  WORKFLOWID = 'workflowId'
}

/** input type for updating data in table "draft_intake_submissions" */
export type DraftIntakeSubmissionsSetInput = {
  aiGeneratedContext?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  duplicatedFromRequestId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "draft_intake_submissions" */
export enum DraftIntakeSubmissionsUpdateColumn {
  /** column name */
  AIGENERATEDCONTEXT = 'aiGeneratedContext',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DUPLICATEDFROMREQUESTID = 'duplicatedFromRequestId',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  RESPONSE = 'response',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type DraftIntakeSubmissionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DraftIntakeSubmissionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DraftIntakeSubmissionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DraftIntakeSubmissionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DraftIntakeSubmissionsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DraftIntakeSubmissionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DraftIntakeSubmissionsSetInput>;
  /** filter the rows which have to be updated */
  where: DraftIntakeSubmissionsBoolExp;
};

/** columns and relationships of "engagements" */
export type Engagements = {
  __typename?: 'engagements';
  buyerLegalEntity: Maybe<Scalars['String']['output']>;
  category: Maybe<CategoryEnum>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  customFields: Maybe<Scalars['jsonb']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  department: Maybe<Scalars['String']['output']>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalLink: Maybe<Scalars['String']['output']>;
  files: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  financial: Maybe<Financials>;
  financialsId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  internal_contacts: Array<InternalContacts>;
  name: Scalars['String']['output'];
  netsuiteExternalId: Maybe<Scalars['Int']['output']>;
  note: Maybe<Scalars['String']['output']>;
  organisationProductOrServiceId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_products_and_service: Maybe<OrganisationProductsAndServices>;
  /** An object relationship */
  organisation_supplier: OrganisationSuppliers;
  purchaseOrderNumber: Maybe<Scalars['String']['output']>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  supplierLegalEntity: Maybe<Scalars['String']['output']>;
  tags: Maybe<Scalars['jsonb']['output']>;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "engagements" */
export type EngagementsCustomFieldsArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "engagements" */
export type EngagementsFilesArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "engagements" */
export type EngagementsInternalContactsArgs = {
  distinct_on: InputMaybe<Array<InternalContactsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<InternalContactsOrderBy>>;
  where: InputMaybe<InternalContactsBoolExp>;
};


/** columns and relationships of "engagements" */
export type EngagementsTagsArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "engagements" */
export type EngagementsAggregate = {
  __typename?: 'engagements_aggregate';
  aggregate: Maybe<EngagementsAggregateFields>;
  nodes: Array<Engagements>;
};

export type EngagementsAggregateBoolExp = {
  count?: InputMaybe<EngagementsAggregateBoolExpCount>;
};

export type EngagementsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EngagementsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EngagementsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "engagements" */
export type EngagementsAggregateFields = {
  __typename?: 'engagements_aggregate_fields';
  avg: Maybe<EngagementsAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<EngagementsMaxFields>;
  min: Maybe<EngagementsMinFields>;
  stddev: Maybe<EngagementsStddevFields>;
  stddev_pop: Maybe<EngagementsStddevPopFields>;
  stddev_samp: Maybe<EngagementsStddevSampFields>;
  sum: Maybe<EngagementsSumFields>;
  var_pop: Maybe<EngagementsVarPopFields>;
  var_samp: Maybe<EngagementsVarSampFields>;
  variance: Maybe<EngagementsVarianceFields>;
};


/** aggregate fields of "engagements" */
export type EngagementsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<EngagementsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "engagements" */
export type EngagementsAggregateOrderBy = {
  avg?: InputMaybe<EngagementsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EngagementsMaxOrderBy>;
  min?: InputMaybe<EngagementsMinOrderBy>;
  stddev?: InputMaybe<EngagementsStddevOrderBy>;
  stddev_pop?: InputMaybe<EngagementsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EngagementsStddevSampOrderBy>;
  sum?: InputMaybe<EngagementsSumOrderBy>;
  var_pop?: InputMaybe<EngagementsVarPopOrderBy>;
  var_samp?: InputMaybe<EngagementsVarSampOrderBy>;
  variance?: InputMaybe<EngagementsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EngagementsAppendInput = {
  customFields?: InputMaybe<Scalars['jsonb']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "engagements" */
export type EngagementsArrRelInsertInput = {
  data: Array<EngagementsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<EngagementsOnConflict>;
};

/** aggregate avg on columns */
export type EngagementsAvgFields = {
  __typename?: 'engagements_avg_fields';
  netsuiteExternalId: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "engagements" */
export type EngagementsAvgOrderBy = {
  netsuiteExternalId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "engagements". All fields are combined with a logical 'AND'. */
export type EngagementsBoolExp = {
  _and?: InputMaybe<Array<EngagementsBoolExp>>;
  _not?: InputMaybe<EngagementsBoolExp>;
  _or?: InputMaybe<Array<EngagementsBoolExp>>;
  buyerLegalEntity?: InputMaybe<StringComparisonExp>;
  category?: InputMaybe<CategoryEnumComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  customFields?: InputMaybe<JsonbComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<StringComparisonExp>;
  departmentId?: InputMaybe<UuidComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  externalLink?: InputMaybe<StringComparisonExp>;
  files?: InputMaybe<JsonbComparisonExp>;
  financial?: InputMaybe<FinancialsBoolExp>;
  financialsId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internal_contacts?: InputMaybe<InternalContactsBoolExp>;
  name?: InputMaybe<StringComparisonExp>;
  netsuiteExternalId?: InputMaybe<IntComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  organisationProductOrServiceId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  purchaseOrderNumber?: InputMaybe<StringComparisonExp>;
  subsidiaryId?: InputMaybe<UuidComparisonExp>;
  supplierLegalEntity?: InputMaybe<StringComparisonExp>;
  tags?: InputMaybe<JsonbComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "engagements" */
export enum EngagementsConstraint {
  /** unique or primary key constraint on columns "financials_id" */
  ENGAGEMENTS_FINANCIALS_ID_KEY = 'engagements_financials_id_key',
  /** unique or primary key constraint on columns "id" */
  ENGAGEMENTS_PKEY = 'engagements_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EngagementsDeleteAtPathInput = {
  customFields?: InputMaybe<Array<Scalars['String']['input']>>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EngagementsDeleteElemInput = {
  customFields?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EngagementsDeleteKeyInput = {
  customFields?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "engagements" */
export type EngagementsIncInput = {
  netsuiteExternalId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "engagements" */
export type EngagementsInsertInput = {
  buyerLegalEntity?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CategoryEnum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customFields?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  financial?: InputMaybe<FinancialsObjRelInsertInput>;
  financialsId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_contacts?: InputMaybe<InternalContactsArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  netsuiteExternalId?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  organisationProductOrServiceId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  supplierLegalEntity?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EngagementsMaxFields = {
  __typename?: 'engagements_max_fields';
  buyerLegalEntity: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  department: Maybe<Scalars['String']['output']>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalLink: Maybe<Scalars['String']['output']>;
  financialsId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  netsuiteExternalId: Maybe<Scalars['Int']['output']>;
  note: Maybe<Scalars['String']['output']>;
  organisationProductOrServiceId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  purchaseOrderNumber: Maybe<Scalars['String']['output']>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  supplierLegalEntity: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "engagements" */
export type EngagementsMaxOrderBy = {
  buyerLegalEntity?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  externalLink?: InputMaybe<OrderBy>;
  financialsId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  netsuiteExternalId?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  organisationProductOrServiceId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  purchaseOrderNumber?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  supplierLegalEntity?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EngagementsMinFields = {
  __typename?: 'engagements_min_fields';
  buyerLegalEntity: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  department: Maybe<Scalars['String']['output']>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalLink: Maybe<Scalars['String']['output']>;
  financialsId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  netsuiteExternalId: Maybe<Scalars['Int']['output']>;
  note: Maybe<Scalars['String']['output']>;
  organisationProductOrServiceId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  purchaseOrderNumber: Maybe<Scalars['String']['output']>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  supplierLegalEntity: Maybe<Scalars['String']['output']>;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "engagements" */
export type EngagementsMinOrderBy = {
  buyerLegalEntity?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  externalLink?: InputMaybe<OrderBy>;
  financialsId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  netsuiteExternalId?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  organisationProductOrServiceId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  purchaseOrderNumber?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  supplierLegalEntity?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "engagements" */
export type EngagementsMutationResponse = {
  __typename?: 'engagements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Engagements>;
};

/** input type for inserting object relation for remote table "engagements" */
export type EngagementsObjRelInsertInput = {
  data: EngagementsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<EngagementsOnConflict>;
};

/** on_conflict condition type for table "engagements" */
export type EngagementsOnConflict = {
  constraint: EngagementsConstraint;
  update_columns: Array<EngagementsUpdateColumn>;
  where?: InputMaybe<EngagementsBoolExp>;
};

/** Ordering options when selecting data from "engagements". */
export type EngagementsOrderBy = {
  buyerLegalEntity?: InputMaybe<OrderBy>;
  category?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  customFields?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  department?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  externalLink?: InputMaybe<OrderBy>;
  files?: InputMaybe<OrderBy>;
  financial?: InputMaybe<FinancialsOrderBy>;
  financialsId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internal_contacts_aggregate?: InputMaybe<InternalContactsAggregateOrderBy>;
  name?: InputMaybe<OrderBy>;
  netsuiteExternalId?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  organisationProductOrServiceId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesOrderBy>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  purchaseOrderNumber?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  supplierLegalEntity?: InputMaybe<OrderBy>;
  tags?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: engagements */
export type EngagementsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EngagementsPrependInput = {
  customFields?: InputMaybe<Scalars['jsonb']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "engagements" */
export enum EngagementsSelectColumn {
  /** column name */
  BUYERLEGALENTITY = 'buyerLegalEntity',
  /** column name */
  CATEGORY = 'category',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CUSTOMFIELDS = 'customFields',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DEPARTMENT = 'department',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EXTERNALLINK = 'externalLink',
  /** column name */
  FILES = 'files',
  /** column name */
  FINANCIALSID = 'financialsId',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  NETSUITEEXTERNALID = 'netsuiteExternalId',
  /** column name */
  NOTE = 'note',
  /** column name */
  ORGANISATIONPRODUCTORSERVICEID = 'organisationProductOrServiceId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  PURCHASEORDERNUMBER = 'purchaseOrderNumber',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  SUPPLIERLEGALENTITY = 'supplierLegalEntity',
  /** column name */
  TAGS = 'tags',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEBSITE = 'website'
}

/** input type for updating data in table "engagements" */
export type EngagementsSetInput = {
  buyerLegalEntity?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CategoryEnum>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  customFields?: InputMaybe<Scalars['jsonb']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  financialsId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  netsuiteExternalId?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  organisationProductOrServiceId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  supplierLegalEntity?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type EngagementsStddevFields = {
  __typename?: 'engagements_stddev_fields';
  netsuiteExternalId: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "engagements" */
export type EngagementsStddevOrderBy = {
  netsuiteExternalId?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type EngagementsStddevPopFields = {
  __typename?: 'engagements_stddev_pop_fields';
  netsuiteExternalId: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "engagements" */
export type EngagementsStddevPopOrderBy = {
  netsuiteExternalId?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type EngagementsStddevSampFields = {
  __typename?: 'engagements_stddev_samp_fields';
  netsuiteExternalId: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "engagements" */
export type EngagementsStddevSampOrderBy = {
  netsuiteExternalId?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type EngagementsSumFields = {
  __typename?: 'engagements_sum_fields';
  netsuiteExternalId: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "engagements" */
export type EngagementsSumOrderBy = {
  netsuiteExternalId?: InputMaybe<OrderBy>;
};

/** update columns of table "engagements" */
export enum EngagementsUpdateColumn {
  /** column name */
  BUYERLEGALENTITY = 'buyerLegalEntity',
  /** column name */
  CATEGORY = 'category',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CUSTOMFIELDS = 'customFields',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DEPARTMENT = 'department',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EXTERNALLINK = 'externalLink',
  /** column name */
  FILES = 'files',
  /** column name */
  FINANCIALSID = 'financialsId',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  NETSUITEEXTERNALID = 'netsuiteExternalId',
  /** column name */
  NOTE = 'note',
  /** column name */
  ORGANISATIONPRODUCTORSERVICEID = 'organisationProductOrServiceId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  PURCHASEORDERNUMBER = 'purchaseOrderNumber',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  SUPPLIERLEGALENTITY = 'supplierLegalEntity',
  /** column name */
  TAGS = 'tags',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEBSITE = 'website'
}

export type EngagementsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EngagementsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EngagementsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EngagementsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EngagementsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EngagementsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EngagementsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EngagementsSetInput>;
  /** filter the rows which have to be updated */
  where: EngagementsBoolExp;
};

/** aggregate var_pop on columns */
export type EngagementsVarPopFields = {
  __typename?: 'engagements_var_pop_fields';
  netsuiteExternalId: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "engagements" */
export type EngagementsVarPopOrderBy = {
  netsuiteExternalId?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type EngagementsVarSampFields = {
  __typename?: 'engagements_var_samp_fields';
  netsuiteExternalId: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "engagements" */
export type EngagementsVarSampOrderBy = {
  netsuiteExternalId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EngagementsVarianceFields = {
  __typename?: 'engagements_variance_fields';
  netsuiteExternalId: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "engagements" */
export type EngagementsVarianceOrderBy = {
  netsuiteExternalId?: InputMaybe<OrderBy>;
};

/** Junction table between bank_details, suppliers, supplier_profiles */
export type EntityBankDetails = {
  __typename?: 'entity_bank_details';
  /** An object relationship */
  bankDetails: BankDetails;
  bankDetailsId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isPrimary: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationSupplier: Maybe<OrganisationSuppliers>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organisationSupplierProfile: Maybe<OrganisationSupplierProfiles>;
  organisationSupplierProfileId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "entity_bank_details" */
export type EntityBankDetailsAggregate = {
  __typename?: 'entity_bank_details_aggregate';
  aggregate: Maybe<EntityBankDetailsAggregateFields>;
  nodes: Array<EntityBankDetails>;
};

export type EntityBankDetailsAggregateBoolExp = {
  bool_and?: InputMaybe<EntityBankDetailsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<EntityBankDetailsAggregateBoolExpBoolOr>;
  count?: InputMaybe<EntityBankDetailsAggregateBoolExpCount>;
};

export type EntityBankDetailsAggregateBoolExpBoolAnd = {
  arguments: EntityBankDetailsSelectColumnEntityBankDetailsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EntityBankDetailsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EntityBankDetailsAggregateBoolExpBoolOr = {
  arguments: EntityBankDetailsSelectColumnEntityBankDetailsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EntityBankDetailsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type EntityBankDetailsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EntityBankDetailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EntityBankDetailsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "entity_bank_details" */
export type EntityBankDetailsAggregateFields = {
  __typename?: 'entity_bank_details_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<EntityBankDetailsMaxFields>;
  min: Maybe<EntityBankDetailsMinFields>;
};


/** aggregate fields of "entity_bank_details" */
export type EntityBankDetailsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<EntityBankDetailsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "entity_bank_details" */
export type EntityBankDetailsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EntityBankDetailsMaxOrderBy>;
  min?: InputMaybe<EntityBankDetailsMinOrderBy>;
};

/** input type for inserting array relation for remote table "entity_bank_details" */
export type EntityBankDetailsArrRelInsertInput = {
  data: Array<EntityBankDetailsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityBankDetailsOnConflict>;
};

/** Boolean expression to filter rows from the table "entity_bank_details". All fields are combined with a logical 'AND'. */
export type EntityBankDetailsBoolExp = {
  _and?: InputMaybe<Array<EntityBankDetailsBoolExp>>;
  _not?: InputMaybe<EntityBankDetailsBoolExp>;
  _or?: InputMaybe<Array<EntityBankDetailsBoolExp>>;
  bankDetails?: InputMaybe<BankDetailsBoolExp>;
  bankDetailsId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPrimary?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierProfile?: InputMaybe<OrganisationSupplierProfilesBoolExp>;
  organisationSupplierProfileId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "entity_bank_details" */
export enum EntityBankDetailsConstraint {
  /** unique or primary key constraint on columns "id" */
  ENTITY_BANK_DETAILS_PKEY = 'entity_bank_details_pkey',
  /** unique or primary key constraint on columns "organisation_supplier_profile_id" */
  IDX_PRIMARY_BANK_ACCOUNT_PER_PROFILE = 'idx_primary_bank_account_per_profile',
  /** unique or primary key constraint on columns "organisation_supplier_id" */
  IDX_PRIMARY_BANK_ACCOUNT_PER_SUPPLIER = 'idx_primary_bank_account_per_supplier',
  /** unique or primary key constraint on columns "bank_details_id", "organisation_supplier_id" */
  UNIQUE_BANK_DETAILS_SUPPLIER = 'unique_bank_details_supplier',
  /** unique or primary key constraint on columns "organisation_supplier_profile_id", "bank_details_id" */
  UNIQUE_BANK_DETAILS_SUPPLIER_PROFILE = 'unique_bank_details_supplier_profile'
}

/** input type for inserting data into table "entity_bank_details" */
export type EntityBankDetailsInsertInput = {
  bankDetails?: InputMaybe<BankDetailsObjRelInsertInput>;
  bankDetailsId?: InputMaybe<Scalars['uuid']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierProfile?: InputMaybe<OrganisationSupplierProfilesObjRelInsertInput>;
  organisationSupplierProfileId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type EntityBankDetailsMaxFields = {
  __typename?: 'entity_bank_details_max_fields';
  bankDetailsId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierProfileId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "entity_bank_details" */
export type EntityBankDetailsMaxOrderBy = {
  bankDetailsId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  organisationSupplierProfileId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EntityBankDetailsMinFields = {
  __typename?: 'entity_bank_details_min_fields';
  bankDetailsId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierProfileId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "entity_bank_details" */
export type EntityBankDetailsMinOrderBy = {
  bankDetailsId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  organisationSupplierProfileId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "entity_bank_details" */
export type EntityBankDetailsMutationResponse = {
  __typename?: 'entity_bank_details_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityBankDetails>;
};

/** on_conflict condition type for table "entity_bank_details" */
export type EntityBankDetailsOnConflict = {
  constraint: EntityBankDetailsConstraint;
  update_columns: Array<EntityBankDetailsUpdateColumn>;
  where?: InputMaybe<EntityBankDetailsBoolExp>;
};

/** Ordering options when selecting data from "entity_bank_details". */
export type EntityBankDetailsOrderBy = {
  bankDetails?: InputMaybe<BankDetailsOrderBy>;
  bankDetailsId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isPrimary?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  organisationSupplierProfile?: InputMaybe<OrganisationSupplierProfilesOrderBy>;
  organisationSupplierProfileId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: entity_bank_details */
export type EntityBankDetailsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "entity_bank_details" */
export enum EntityBankDetailsSelectColumn {
  /** column name */
  BANKDETAILSID = 'bankDetailsId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISPRIMARY = 'isPrimary',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  ORGANISATIONSUPPLIERPROFILEID = 'organisationSupplierProfileId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "entity_bank_details_aggregate_bool_exp_bool_and_arguments_columns" columns of table "entity_bank_details" */
export enum EntityBankDetailsSelectColumnEntityBankDetailsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISPRIMARY = 'isPrimary'
}

/** select "entity_bank_details_aggregate_bool_exp_bool_or_arguments_columns" columns of table "entity_bank_details" */
export enum EntityBankDetailsSelectColumnEntityBankDetailsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISPRIMARY = 'isPrimary'
}

/** input type for updating data in table "entity_bank_details" */
export type EntityBankDetailsSetInput = {
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "entity_bank_details" */
export enum EntityBankDetailsUpdateColumn {
  /** column name */
  ISPRIMARY = 'isPrimary'
}

export type EntityBankDetailsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityBankDetailsSetInput>;
  /** filter the rows which have to be updated */
  where: EntityBankDetailsBoolExp;
};

/** columns and relationships of "entity_field_group_fields" */
export type EntityFieldGroupFields = {
  __typename?: 'entity_field_group_fields';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  customField: Maybe<CustomFields>;
  customFieldId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  entityFieldGroup: EntityFieldGroups;
  entityFieldGroupId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['Int']['output'];
  /** An object relationship */
  organisation: Organisations;
  standardFieldKey: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "entity_field_group_fields" */
export type EntityFieldGroupFieldsAggregate = {
  __typename?: 'entity_field_group_fields_aggregate';
  aggregate: Maybe<EntityFieldGroupFieldsAggregateFields>;
  nodes: Array<EntityFieldGroupFields>;
};

export type EntityFieldGroupFieldsAggregateBoolExp = {
  count?: InputMaybe<EntityFieldGroupFieldsAggregateBoolExpCount>;
};

export type EntityFieldGroupFieldsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EntityFieldGroupFieldsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EntityFieldGroupFieldsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "entity_field_group_fields" */
export type EntityFieldGroupFieldsAggregateFields = {
  __typename?: 'entity_field_group_fields_aggregate_fields';
  avg: Maybe<EntityFieldGroupFieldsAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<EntityFieldGroupFieldsMaxFields>;
  min: Maybe<EntityFieldGroupFieldsMinFields>;
  stddev: Maybe<EntityFieldGroupFieldsStddevFields>;
  stddev_pop: Maybe<EntityFieldGroupFieldsStddevPopFields>;
  stddev_samp: Maybe<EntityFieldGroupFieldsStddevSampFields>;
  sum: Maybe<EntityFieldGroupFieldsSumFields>;
  var_pop: Maybe<EntityFieldGroupFieldsVarPopFields>;
  var_samp: Maybe<EntityFieldGroupFieldsVarSampFields>;
  variance: Maybe<EntityFieldGroupFieldsVarianceFields>;
};


/** aggregate fields of "entity_field_group_fields" */
export type EntityFieldGroupFieldsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<EntityFieldGroupFieldsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "entity_field_group_fields" */
export type EntityFieldGroupFieldsAggregateOrderBy = {
  avg?: InputMaybe<EntityFieldGroupFieldsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EntityFieldGroupFieldsMaxOrderBy>;
  min?: InputMaybe<EntityFieldGroupFieldsMinOrderBy>;
  stddev?: InputMaybe<EntityFieldGroupFieldsStddevOrderBy>;
  stddev_pop?: InputMaybe<EntityFieldGroupFieldsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<EntityFieldGroupFieldsStddevSampOrderBy>;
  sum?: InputMaybe<EntityFieldGroupFieldsSumOrderBy>;
  var_pop?: InputMaybe<EntityFieldGroupFieldsVarPopOrderBy>;
  var_samp?: InputMaybe<EntityFieldGroupFieldsVarSampOrderBy>;
  variance?: InputMaybe<EntityFieldGroupFieldsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "entity_field_group_fields" */
export type EntityFieldGroupFieldsArrRelInsertInput = {
  data: Array<EntityFieldGroupFieldsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityFieldGroupFieldsOnConflict>;
};

/** aggregate avg on columns */
export type EntityFieldGroupFieldsAvgFields = {
  __typename?: 'entity_field_group_fields_avg_fields';
  index: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "entity_field_group_fields" */
export type EntityFieldGroupFieldsAvgOrderBy = {
  index?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "entity_field_group_fields". All fields are combined with a logical 'AND'. */
export type EntityFieldGroupFieldsBoolExp = {
  _and?: InputMaybe<Array<EntityFieldGroupFieldsBoolExp>>;
  _not?: InputMaybe<EntityFieldGroupFieldsBoolExp>;
  _or?: InputMaybe<Array<EntityFieldGroupFieldsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customField?: InputMaybe<CustomFieldsBoolExp>;
  customFieldId?: InputMaybe<UuidComparisonExp>;
  entityFieldGroup?: InputMaybe<EntityFieldGroupsBoolExp>;
  entityFieldGroupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  index?: InputMaybe<IntComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  standardFieldKey?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "entity_field_group_fields" */
export enum EntityFieldGroupFieldsConstraint {
  /** unique or primary key constraint on columns "index", "entity_field_group_id" */
  ENTITY_FIELD_GROUP_FIELDS_ENTITY_FIELD_GROUP_ID_INDEX_KEY = 'entity_field_group_fields_entity_field_group_id_index_key',
  /** unique or primary key constraint on columns "id" */
  ENTITY_FIELD_GROUP_FIELDS_PKEY = 'entity_field_group_fields_pkey'
}

/** input type for incrementing numeric columns in table "entity_field_group_fields" */
export type EntityFieldGroupFieldsIncInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "entity_field_group_fields" */
export type EntityFieldGroupFieldsInsertInput = {
  customField?: InputMaybe<CustomFieldsObjRelInsertInput>;
  customFieldId?: InputMaybe<Scalars['uuid']['input']>;
  entityFieldGroup?: InputMaybe<EntityFieldGroupsObjRelInsertInput>;
  entityFieldGroupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  standardFieldKey?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EntityFieldGroupFieldsMaxFields = {
  __typename?: 'entity_field_group_fields_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customFieldId: Maybe<Scalars['uuid']['output']>;
  entityFieldGroupId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  index: Maybe<Scalars['Int']['output']>;
  standardFieldKey: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "entity_field_group_fields" */
export type EntityFieldGroupFieldsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customFieldId?: InputMaybe<OrderBy>;
  entityFieldGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  index?: InputMaybe<OrderBy>;
  standardFieldKey?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EntityFieldGroupFieldsMinFields = {
  __typename?: 'entity_field_group_fields_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  customFieldId: Maybe<Scalars['uuid']['output']>;
  entityFieldGroupId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  index: Maybe<Scalars['Int']['output']>;
  standardFieldKey: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "entity_field_group_fields" */
export type EntityFieldGroupFieldsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customFieldId?: InputMaybe<OrderBy>;
  entityFieldGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  index?: InputMaybe<OrderBy>;
  standardFieldKey?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "entity_field_group_fields" */
export type EntityFieldGroupFieldsMutationResponse = {
  __typename?: 'entity_field_group_fields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityFieldGroupFields>;
};

/** on_conflict condition type for table "entity_field_group_fields" */
export type EntityFieldGroupFieldsOnConflict = {
  constraint: EntityFieldGroupFieldsConstraint;
  update_columns: Array<EntityFieldGroupFieldsUpdateColumn>;
  where?: InputMaybe<EntityFieldGroupFieldsBoolExp>;
};

/** Ordering options when selecting data from "entity_field_group_fields". */
export type EntityFieldGroupFieldsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customField?: InputMaybe<CustomFieldsOrderBy>;
  customFieldId?: InputMaybe<OrderBy>;
  entityFieldGroup?: InputMaybe<EntityFieldGroupsOrderBy>;
  entityFieldGroupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  index?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  standardFieldKey?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: entity_field_group_fields */
export type EntityFieldGroupFieldsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "entity_field_group_fields" */
export enum EntityFieldGroupFieldsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CUSTOMFIELDID = 'customFieldId',
  /** column name */
  ENTITYFIELDGROUPID = 'entityFieldGroupId',
  /** column name */
  ID = 'id',
  /** column name */
  INDEX = 'index',
  /** column name */
  STANDARDFIELDKEY = 'standardFieldKey',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "entity_field_group_fields" */
export type EntityFieldGroupFieldsSetInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type EntityFieldGroupFieldsStddevFields = {
  __typename?: 'entity_field_group_fields_stddev_fields';
  index: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "entity_field_group_fields" */
export type EntityFieldGroupFieldsStddevOrderBy = {
  index?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type EntityFieldGroupFieldsStddevPopFields = {
  __typename?: 'entity_field_group_fields_stddev_pop_fields';
  index: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "entity_field_group_fields" */
export type EntityFieldGroupFieldsStddevPopOrderBy = {
  index?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type EntityFieldGroupFieldsStddevSampFields = {
  __typename?: 'entity_field_group_fields_stddev_samp_fields';
  index: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "entity_field_group_fields" */
export type EntityFieldGroupFieldsStddevSampOrderBy = {
  index?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type EntityFieldGroupFieldsSumFields = {
  __typename?: 'entity_field_group_fields_sum_fields';
  index: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "entity_field_group_fields" */
export type EntityFieldGroupFieldsSumOrderBy = {
  index?: InputMaybe<OrderBy>;
};

/** update columns of table "entity_field_group_fields" */
export enum EntityFieldGroupFieldsUpdateColumn {
  /** column name */
  INDEX = 'index'
}

export type EntityFieldGroupFieldsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EntityFieldGroupFieldsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityFieldGroupFieldsSetInput>;
  /** filter the rows which have to be updated */
  where: EntityFieldGroupFieldsBoolExp;
};

/** aggregate var_pop on columns */
export type EntityFieldGroupFieldsVarPopFields = {
  __typename?: 'entity_field_group_fields_var_pop_fields';
  index: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "entity_field_group_fields" */
export type EntityFieldGroupFieldsVarPopOrderBy = {
  index?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type EntityFieldGroupFieldsVarSampFields = {
  __typename?: 'entity_field_group_fields_var_samp_fields';
  index: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "entity_field_group_fields" */
export type EntityFieldGroupFieldsVarSampOrderBy = {
  index?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EntityFieldGroupFieldsVarianceFields = {
  __typename?: 'entity_field_group_fields_variance_fields';
  index: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "entity_field_group_fields" */
export type EntityFieldGroupFieldsVarianceOrderBy = {
  index?: InputMaybe<OrderBy>;
};

/** columns and relationships of "entity_field_groups" */
export type EntityFieldGroups = {
  __typename?: 'entity_field_groups';
  createdAt: Scalars['timestamptz']['output'];
  entityType: Scalars['String']['output'];
  /** An array relationship */
  fields: Array<EntityFieldGroupFields>;
  /** An aggregate relationship */
  fields_aggregate: EntityFieldGroupFieldsAggregate;
  id: Scalars['uuid']['output'];
  index: Scalars['Int']['output'];
  isDefaultForCustomFields: Scalars['Boolean']['output'];
  isDefaultForStandardFields: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "entity_field_groups" */
export type EntityFieldGroupsFieldsArgs = {
  distinct_on: InputMaybe<Array<EntityFieldGroupFieldsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityFieldGroupFieldsOrderBy>>;
  where: InputMaybe<EntityFieldGroupFieldsBoolExp>;
};


/** columns and relationships of "entity_field_groups" */
export type EntityFieldGroupsFieldsAggregateArgs = {
  distinct_on: InputMaybe<Array<EntityFieldGroupFieldsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityFieldGroupFieldsOrderBy>>;
  where: InputMaybe<EntityFieldGroupFieldsBoolExp>;
};

/** aggregated selection of "entity_field_groups" */
export type EntityFieldGroupsAggregate = {
  __typename?: 'entity_field_groups_aggregate';
  aggregate: Maybe<EntityFieldGroupsAggregateFields>;
  nodes: Array<EntityFieldGroups>;
};

/** aggregate fields of "entity_field_groups" */
export type EntityFieldGroupsAggregateFields = {
  __typename?: 'entity_field_groups_aggregate_fields';
  avg: Maybe<EntityFieldGroupsAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<EntityFieldGroupsMaxFields>;
  min: Maybe<EntityFieldGroupsMinFields>;
  stddev: Maybe<EntityFieldGroupsStddevFields>;
  stddev_pop: Maybe<EntityFieldGroupsStddevPopFields>;
  stddev_samp: Maybe<EntityFieldGroupsStddevSampFields>;
  sum: Maybe<EntityFieldGroupsSumFields>;
  var_pop: Maybe<EntityFieldGroupsVarPopFields>;
  var_samp: Maybe<EntityFieldGroupsVarSampFields>;
  variance: Maybe<EntityFieldGroupsVarianceFields>;
};


/** aggregate fields of "entity_field_groups" */
export type EntityFieldGroupsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<EntityFieldGroupsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type EntityFieldGroupsAvgFields = {
  __typename?: 'entity_field_groups_avg_fields';
  index: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "entity_field_groups". All fields are combined with a logical 'AND'. */
export type EntityFieldGroupsBoolExp = {
  _and?: InputMaybe<Array<EntityFieldGroupsBoolExp>>;
  _not?: InputMaybe<EntityFieldGroupsBoolExp>;
  _or?: InputMaybe<Array<EntityFieldGroupsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  entityType?: InputMaybe<StringComparisonExp>;
  fields?: InputMaybe<EntityFieldGroupFieldsBoolExp>;
  fields_aggregate?: InputMaybe<EntityFieldGroupFieldsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  index?: InputMaybe<IntComparisonExp>;
  isDefaultForCustomFields?: InputMaybe<BooleanComparisonExp>;
  isDefaultForStandardFields?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "entity_field_groups" */
export enum EntityFieldGroupsConstraint {
  /** unique or primary key constraint on columns "entity_type", "organisation_id", "name" */
  ENTITY_FIELD_GROUPS_ORGANISATION_ID_ENTITY_TYPE_NAME_KEY = 'entity_field_groups_organisation_id_entity_type_name_key',
  /** unique or primary key constraint on columns "id" */
  ENTITY_FIELD_GROUPS_PKEY = 'entity_field_groups_pkey',
  /** unique or primary key constraint on columns "entity_type", "organisation_id" */
  ENTITY_FIELD_GROUPS_UNIQUE_DEFAULT_CUSTOM = 'entity_field_groups_unique_default_custom',
  /** unique or primary key constraint on columns "entity_type", "organisation_id" */
  ENTITY_FIELD_GROUPS_UNIQUE_DEFAULT_STANDARD = 'entity_field_groups_unique_default_standard'
}

/** input type for incrementing numeric columns in table "entity_field_groups" */
export type EntityFieldGroupsIncInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "entity_field_groups" */
export type EntityFieldGroupsInsertInput = {
  entityType?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<EntityFieldGroupFieldsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isDefaultForCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultForStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EntityFieldGroupsMaxFields = {
  __typename?: 'entity_field_groups_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  entityType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  index: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type EntityFieldGroupsMinFields = {
  __typename?: 'entity_field_groups_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  entityType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  index: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "entity_field_groups" */
export type EntityFieldGroupsMutationResponse = {
  __typename?: 'entity_field_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityFieldGroups>;
};

/** input type for inserting object relation for remote table "entity_field_groups" */
export type EntityFieldGroupsObjRelInsertInput = {
  data: EntityFieldGroupsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<EntityFieldGroupsOnConflict>;
};

/** on_conflict condition type for table "entity_field_groups" */
export type EntityFieldGroupsOnConflict = {
  constraint: EntityFieldGroupsConstraint;
  update_columns: Array<EntityFieldGroupsUpdateColumn>;
  where?: InputMaybe<EntityFieldGroupsBoolExp>;
};

/** Ordering options when selecting data from "entity_field_groups". */
export type EntityFieldGroupsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  entityType?: InputMaybe<OrderBy>;
  fields_aggregate?: InputMaybe<EntityFieldGroupFieldsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  index?: InputMaybe<OrderBy>;
  isDefaultForCustomFields?: InputMaybe<OrderBy>;
  isDefaultForStandardFields?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: entity_field_groups */
export type EntityFieldGroupsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "entity_field_groups" */
export enum EntityFieldGroupsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ENTITYTYPE = 'entityType',
  /** column name */
  ID = 'id',
  /** column name */
  INDEX = 'index',
  /** column name */
  ISDEFAULTFORCUSTOMFIELDS = 'isDefaultForCustomFields',
  /** column name */
  ISDEFAULTFORSTANDARDFIELDS = 'isDefaultForStandardFields',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "entity_field_groups" */
export type EntityFieldGroupsSetInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  isDefaultForCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultForStandardFields?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type EntityFieldGroupsStddevFields = {
  __typename?: 'entity_field_groups_stddev_fields';
  index: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type EntityFieldGroupsStddevPopFields = {
  __typename?: 'entity_field_groups_stddev_pop_fields';
  index: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type EntityFieldGroupsStddevSampFields = {
  __typename?: 'entity_field_groups_stddev_samp_fields';
  index: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type EntityFieldGroupsSumFields = {
  __typename?: 'entity_field_groups_sum_fields';
  index: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "entity_field_groups" */
export enum EntityFieldGroupsUpdateColumn {
  /** column name */
  INDEX = 'index',
  /** column name */
  ISDEFAULTFORCUSTOMFIELDS = 'isDefaultForCustomFields',
  /** column name */
  ISDEFAULTFORSTANDARDFIELDS = 'isDefaultForStandardFields',
  /** column name */
  NAME = 'name'
}

export type EntityFieldGroupsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EntityFieldGroupsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityFieldGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: EntityFieldGroupsBoolExp;
};

/** aggregate var_pop on columns */
export type EntityFieldGroupsVarPopFields = {
  __typename?: 'entity_field_groups_var_pop_fields';
  index: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type EntityFieldGroupsVarSampFields = {
  __typename?: 'entity_field_groups_var_samp_fields';
  index: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type EntityFieldGroupsVarianceFields = {
  __typename?: 'entity_field_groups_variance_fields';
  index: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "external_contacts" */
export type ExternalContacts = {
  __typename?: 'external_contacts';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  email: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isPrimary: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_supplier: OrganisationSuppliers;
  phoneNumber: Maybe<Scalars['String']['output']>;
  supplierId: Scalars['uuid']['output'];
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** order by aggregate values of table "external_contacts" */
export type ExternalContactsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ExternalContactsMaxOrderBy>;
  min?: InputMaybe<ExternalContactsMinOrderBy>;
};

/** input type for inserting array relation for remote table "external_contacts" */
export type ExternalContactsArrRelInsertInput = {
  data: Array<ExternalContactsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ExternalContactsOnConflict>;
};

/** Boolean expression to filter rows from the table "external_contacts". All fields are combined with a logical 'AND'. */
export type ExternalContactsBoolExp = {
  _and?: InputMaybe<Array<ExternalContactsBoolExp>>;
  _not?: InputMaybe<ExternalContactsBoolExp>;
  _or?: InputMaybe<Array<ExternalContactsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPrimary?: InputMaybe<BooleanComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  phoneNumber?: InputMaybe<StringComparisonExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "external_contacts" */
export enum ExternalContactsConstraint {
  /** unique or primary key constraint on columns "id" */
  EXTERNAL_CONTACTS_PKEY = 'external_contacts_pkey',
  /** unique or primary key constraint on columns "supplier_id" */
  UNIQUE_NON_DELETED_PRIMARY_CONTACT_PER_SUPPLIER = 'unique_non_deleted_primary_contact_per_supplier'
}

/** input type for inserting data into table "external_contacts" */
export type ExternalContactsInsertInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "external_contacts" */
export type ExternalContactsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "external_contacts" */
export type ExternalContactsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "external_contacts" */
export type ExternalContactsMutationResponse = {
  __typename?: 'external_contacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ExternalContacts>;
};

/** input type for inserting object relation for remote table "external_contacts" */
export type ExternalContactsObjRelInsertInput = {
  data: ExternalContactsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ExternalContactsOnConflict>;
};

/** on_conflict condition type for table "external_contacts" */
export type ExternalContactsOnConflict = {
  constraint: ExternalContactsConstraint;
  update_columns: Array<ExternalContactsUpdateColumn>;
  where?: InputMaybe<ExternalContactsBoolExp>;
};

/** Ordering options when selecting data from "external_contacts". */
export type ExternalContactsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isPrimary?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  phoneNumber?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: external_contacts */
export type ExternalContactsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "external_contacts" */
export enum ExternalContactsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  EMAIL = 'email',
  /** column name */
  FIRSTNAME = 'firstName',
  /** column name */
  ID = 'id',
  /** column name */
  ISPRIMARY = 'isPrimary',
  /** column name */
  LASTNAME = 'lastName',
  /** column name */
  ORGANISATION_ID = 'organisation_id',
  /** column name */
  PHONENUMBER = 'phoneNumber',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "external_contacts" */
export type ExternalContactsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "external_contacts" */
export enum ExternalContactsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  EMAIL = 'email',
  /** column name */
  FIRSTNAME = 'firstName',
  /** column name */
  ISPRIMARY = 'isPrimary',
  /** column name */
  LASTNAME = 'lastName',
  /** column name */
  PHONENUMBER = 'phoneNumber',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  TITLE = 'title',
  /** column name */
  USERID = 'userId'
}

export type ExternalContactsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ExternalContactsSetInput>;
  /** filter the rows which have to be updated */
  where: ExternalContactsBoolExp;
};

/** columns and relationships of "external_entity_sync_statuses" */
export type ExternalEntitySyncStatuses = {
  __typename?: 'external_entity_sync_statuses';
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  customCoreData: Maybe<CustomCoreData>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  error: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisationIntegration: Maybe<OrganisationIntegrations>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['kebabSyncStatusType']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "external_entity_sync_statuses" */
export type ExternalEntitySyncStatusesErrorArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ExternalEntitySyncStatusesAppendInput = {
  error?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "external_entity_sync_statuses". All fields are combined with a logical 'AND'. */
export type ExternalEntitySyncStatusesBoolExp = {
  _and?: InputMaybe<Array<ExternalEntitySyncStatusesBoolExp>>;
  _not?: InputMaybe<ExternalEntitySyncStatusesBoolExp>;
  _or?: InputMaybe<Array<ExternalEntitySyncStatusesBoolExp>>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customCoreData?: InputMaybe<CustomCoreDataBoolExp>;
  customCoreDataId?: InputMaybe<UuidComparisonExp>;
  error?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "external_entity_sync_statuses" */
export enum ExternalEntitySyncStatusesConstraint {
  /** unique or primary key constraint on columns "id" */
  EXTERNAL_ENTITY_SYNC_STATUSES_PKEY = 'external_entity_sync_statuses_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ExternalEntitySyncStatusesDeleteAtPathInput = {
  error?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ExternalEntitySyncStatusesDeleteElemInput = {
  error?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ExternalEntitySyncStatusesDeleteKeyInput = {
  error?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "external_entity_sync_statuses" */
export type ExternalEntitySyncStatusesInsertInput = {
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customCoreData?: InputMaybe<CustomCoreDataObjRelInsertInput>;
  customCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['kebabSyncStatusType']['input'];
};

/** response of any mutation on the table "external_entity_sync_statuses" */
export type ExternalEntitySyncStatusesMutationResponse = {
  __typename?: 'external_entity_sync_statuses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ExternalEntitySyncStatuses>;
};

/** on_conflict condition type for table "external_entity_sync_statuses" */
export type ExternalEntitySyncStatusesOnConflict = {
  constraint: ExternalEntitySyncStatusesConstraint;
  update_columns: Array<ExternalEntitySyncStatusesUpdateColumn>;
  where?: InputMaybe<ExternalEntitySyncStatusesBoolExp>;
};

/** Ordering options when selecting data from "external_entity_sync_statuses". */
export type ExternalEntitySyncStatusesOrderBy = {
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customCoreData?: InputMaybe<CustomCoreDataOrderBy>;
  customCoreDataId?: InputMaybe<OrderBy>;
  error?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsOrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: external_entity_sync_statuses */
export type ExternalEntitySyncStatusesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ExternalEntitySyncStatusesPrependInput = {
  error?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "external_entity_sync_statuses" */
export enum ExternalEntitySyncStatusesSelectColumn {
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CUSTOMCOREDATAID = 'customCoreDataId',
  /** column name */
  ERROR = 'error',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  STATUS = 'status',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "external_entity_sync_statuses" */
export type ExternalEntitySyncStatusesSetInput = {
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "external_entity_sync_statuses" */
export type ExternalEntitySyncStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ExternalEntitySyncStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ExternalEntitySyncStatusesStreamCursorValueInput = {
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  error?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "external_entity_sync_statuses" */
export enum ExternalEntitySyncStatusesUpdateColumn {
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CUSTOMCOREDATAID = 'customCoreDataId',
  /** column name */
  ERROR = 'error',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  STATUS = 'status',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type ExternalEntitySyncStatusesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ExternalEntitySyncStatusesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ExternalEntitySyncStatusesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ExternalEntitySyncStatusesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ExternalEntitySyncStatusesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ExternalEntitySyncStatusesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ExternalEntitySyncStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: ExternalEntitySyncStatusesBoolExp;
};

/** columns and relationships of "external_risk_scores" */
export type ExternalRiskScores = {
  __typename?: 'external_risk_scores';
  date: Scalars['date']['output'];
  externalProvider: Scalars['integration']['output'];
  files: Maybe<Array<Scalars['uploadedFileItem']['output']>>;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  organisationSupplierId: Scalars['uuid']['output'];
  requestId: Scalars['uuid']['output'];
  riskScore: Scalars['numeric']['output'];
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ExternalRiskScoresAppendInput = {
  files?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "external_risk_scores". All fields are combined with a logical 'AND'. */
export type ExternalRiskScoresBoolExp = {
  _and?: InputMaybe<Array<ExternalRiskScoresBoolExp>>;
  _not?: InputMaybe<ExternalRiskScoresBoolExp>;
  _or?: InputMaybe<Array<ExternalRiskScoresBoolExp>>;
  date?: InputMaybe<DateComparisonExp>;
  externalProvider?: InputMaybe<StringComparisonExp>;
  files?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  riskScore?: InputMaybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "external_risk_scores" */
export enum ExternalRiskScoresConstraint {
  /** unique or primary key constraint on columns "organisation_supplier_id" */
  EXTERNAL_RISK_SCORES_ORGANISATION_SUPPLIER_ID_KEY = 'external_risk_scores_organisation_supplier_id_key',
  /** unique or primary key constraint on columns "id" */
  EXTERNAL_RISK_SCORES_PKEY = 'external_risk_scores_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ExternalRiskScoresDeleteAtPathInput = {
  files?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ExternalRiskScoresDeleteElemInput = {
  files?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ExternalRiskScoresDeleteKeyInput = {
  files?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "external_risk_scores" */
export type ExternalRiskScoresIncInput = {
  riskScore?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "external_risk_scores" */
export type ExternalRiskScoresInsertInput = {
  date?: InputMaybe<Scalars['date']['input']>;
  externalProvider: Scalars['integration']['input'];
  files?: InputMaybe<Array<Scalars['uploadedFileItem']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  riskScore?: InputMaybe<Scalars['numeric']['input']>;
};

/** response of any mutation on the table "external_risk_scores" */
export type ExternalRiskScoresMutationResponse = {
  __typename?: 'external_risk_scores_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ExternalRiskScores>;
};

/** input type for inserting object relation for remote table "external_risk_scores" */
export type ExternalRiskScoresObjRelInsertInput = {
  data: ExternalRiskScoresInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ExternalRiskScoresOnConflict>;
};

/** on_conflict condition type for table "external_risk_scores" */
export type ExternalRiskScoresOnConflict = {
  constraint: ExternalRiskScoresConstraint;
  update_columns: Array<ExternalRiskScoresUpdateColumn>;
  where?: InputMaybe<ExternalRiskScoresBoolExp>;
};

/** Ordering options when selecting data from "external_risk_scores". */
export type ExternalRiskScoresOrderBy = {
  date?: InputMaybe<OrderBy>;
  externalProvider?: InputMaybe<OrderBy>;
  files?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  riskScore?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: external_risk_scores */
export type ExternalRiskScoresPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ExternalRiskScoresPrependInput = {
  files?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "external_risk_scores" */
export enum ExternalRiskScoresSelectColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  EXTERNALPROVIDER = 'externalProvider',
  /** column name */
  FILES = 'files',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RISKSCORE = 'riskScore'
}

/** input type for updating data in table "external_risk_scores" */
export type ExternalRiskScoresSetInput = {
  date?: InputMaybe<Scalars['date']['input']>;
  externalProvider?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  riskScore?: InputMaybe<Scalars['numeric']['input']>;
};

/** Streaming cursor of the table "external_risk_scores" */
export type ExternalRiskScoresStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ExternalRiskScoresStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ExternalRiskScoresStreamCursorValueInput = {
  date?: InputMaybe<Scalars['date']['input']>;
  externalProvider?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  riskScore?: InputMaybe<Scalars['numeric']['input']>;
};

/** update columns of table "external_risk_scores" */
export enum ExternalRiskScoresUpdateColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  EXTERNALPROVIDER = 'externalProvider',
  /** column name */
  FILES = 'files',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RISKSCORE = 'riskScore'
}

export type ExternalRiskScoresUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ExternalRiskScoresAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ExternalRiskScoresDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ExternalRiskScoresDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ExternalRiskScoresDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ExternalRiskScoresIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ExternalRiskScoresPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ExternalRiskScoresSetInput>;
  /** filter the rows which have to be updated */
  where: ExternalRiskScoresBoolExp;
};

/** columns and relationships of "favourite_table_filters" */
export type FavouriteTableFilters = {
  __typename?: 'favourite_table_filters';
  /** An object relationship */
  tableFilter: TableFilters;
  table_filter_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "favourite_table_filters" */
export type FavouriteTableFiltersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<FavouriteTableFiltersMaxOrderBy>;
  min?: InputMaybe<FavouriteTableFiltersMinOrderBy>;
};

/** input type for inserting array relation for remote table "favourite_table_filters" */
export type FavouriteTableFiltersArrRelInsertInput = {
  data: Array<FavouriteTableFiltersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<FavouriteTableFiltersOnConflict>;
};

/** Boolean expression to filter rows from the table "favourite_table_filters". All fields are combined with a logical 'AND'. */
export type FavouriteTableFiltersBoolExp = {
  _and?: InputMaybe<Array<FavouriteTableFiltersBoolExp>>;
  _not?: InputMaybe<FavouriteTableFiltersBoolExp>;
  _or?: InputMaybe<Array<FavouriteTableFiltersBoolExp>>;
  tableFilter?: InputMaybe<TableFiltersBoolExp>;
  table_filter_id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "favourite_table_filters" */
export enum FavouriteTableFiltersConstraint {
  /** unique or primary key constraint on columns "user_id", "table_filter_id" */
  FAVOURITE_TABLE_FILTERS_PKEY = 'favourite_table_filters_pkey'
}

/** input type for inserting data into table "favourite_table_filters" */
export type FavouriteTableFiltersInsertInput = {
  tableFilter?: InputMaybe<TableFiltersObjRelInsertInput>;
  table_filter_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "favourite_table_filters" */
export type FavouriteTableFiltersMaxOrderBy = {
  table_filter_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "favourite_table_filters" */
export type FavouriteTableFiltersMinOrderBy = {
  table_filter_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "favourite_table_filters" */
export type FavouriteTableFiltersMutationResponse = {
  __typename?: 'favourite_table_filters_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<FavouriteTableFilters>;
};

/** on_conflict condition type for table "favourite_table_filters" */
export type FavouriteTableFiltersOnConflict = {
  constraint: FavouriteTableFiltersConstraint;
  update_columns: Array<FavouriteTableFiltersUpdateColumn>;
  where?: InputMaybe<FavouriteTableFiltersBoolExp>;
};

/** Ordering options when selecting data from "favourite_table_filters". */
export type FavouriteTableFiltersOrderBy = {
  tableFilter?: InputMaybe<TableFiltersOrderBy>;
  table_filter_id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** select columns of table "favourite_table_filters" */
export enum FavouriteTableFiltersSelectColumn {
  /** column name */
  TABLE_FILTER_ID = 'table_filter_id',
  /** column name */
  USER_ID = 'user_id'
}

/** placeholder for update columns of table "favourite_table_filters" (current role has no relevant permissions) */
export enum FavouriteTableFiltersUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "feature_flags" */
export type FeatureFlags = {
  __typename?: 'feature_flags';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "feature_flags". All fields are combined with a logical 'AND'. */
export type FeatureFlagsBoolExp = {
  _and?: InputMaybe<Array<FeatureFlagsBoolExp>>;
  _not?: InputMaybe<FeatureFlagsBoolExp>;
  _or?: InputMaybe<Array<FeatureFlagsBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum FeatureFlagsEnum {
  /** Should be enabled when Agreement is fully rolled out on an environment */
  AGREEMENT_ROLLED_OUT = 'AGREEMENT_ROLLED_OUT',
  /** Enables configuring a review/approval agent for approval blocks */
  AI_APPROVAL_AGENT = 'AI_APPROVAL_AGENT',
  /** AI Chat Assistant */
  AI_CHAT_ASSISTANT = 'AI_CHAT_ASSISTANT',
  /** Enables admins to explain and create configuration conversationally */
  AI_CONFIG_BUILDER_CHAT = 'AI_CONFIG_BUILDER_CHAT',
  /** Generate Forms using OpenAI ChatGPT */
  AI_FORM_GENERATION = 'AI_FORM_GENERATION',
  /** When enabled, the AI can be used to review form responses before submission */
  AI_FORM_REVIEW = 'AI_FORM_REVIEW',
  /** Summarise form submissions with AI */
  AI_FORM_SUMMARISATION = 'AI_FORM_SUMMARISATION',
  /** When enabled, show suggested product alternatives from the recommendation engine */
  AI_REC_ENGINE_ALTERNATIVES = 'AI_REC_ENGINE_ALTERNATIVES',
  /** When enabled, request names are generated using AI */
  AI_REQUEST_NAME_GENERATION = 'AI_REQUEST_NAME_GENERATION',
  /** Enables the AI scan for supplier online resources feature */
  AI_SCAN_FOR_SUPPLIER_ONLINE_RESOURCES = 'AI_SCAN_FOR_SUPPLIER_ONLINE_RESOURCES',
  /** Enables AI Tone Generator in the form builder */
  AI_TONE_GENERATION = 'AI_TONE_GENERATION',
  /** Show the audit log 'History' tab on the request detail page */
  AUDIT_LOG = 'AUDIT_LOG',
  /** Enable auto-translations for stale config translations */
  AUTO_TRANSLATIONS = 'AUTO_TRANSLATIONS',
  /** Budgets V1 */
  BUDGETS = 'BUDGETS',
  /** When enabled, the UI will display translations for config (workflows, forms etc) in the user's locale if available */
  CONFIG_TRANSLATIONS = 'CONFIG_TRANSLATIONS',
  /** Enable Create Agreement functionality */
  CREATE_AGREEMENT = 'CREATE_AGREEMENT',
  /** Feature flag for customisable request detail sidebar and to hide auto-generated tags */
  CUSTOM_REQUEST_SIDEBAR = 'CUSTOM_REQUEST_SIDEBAR',
  /** When enabled, the daily entity sync from an external service is disabled, apart from for suppliers and currencies */
  DISABLE_DAILY_EXTERNAL_ENTITY_SYNC = 'DISABLE_DAILY_EXTERNAL_ENTITY_SYNC',
  /** When enabled invite email's will not be sent to new users added to the platform */
  DISABLE_INVITE_EMAIL = 'DISABLE_INVITE_EMAIL',
  /** Display the business owner in the request sidebar */
  DISPLAY_BUSINESS_OWNER_IN_REQUEST_SIDEBAR = 'DISPLAY_BUSINESS_OWNER_IN_REQUEST_SIDEBAR',
  /** When enabled, the AI Form Completion block is available in the workflow builder and can auto-fill forms using AI */
  ENABLE_AI_FORM_COMPLETION_BLOCK = 'ENABLE_AI_FORM_COMPLETION_BLOCK',
  /** When enabled, the assessments page will be visible */
  ENABLE_ASSESSMENTS = 'ENABLE_ASSESSMENTS',
  /** When enabled, assignees with user permission of Renewals, Assessments, and suppliers will be able to view / edit the corresponding resource */
  ENABLE_ASSIGNEE_PERMISSIONS = 'ENABLE_ASSIGNEE_PERMISSIONS',
  /** When enabled, bank details capturing and sync to/from ERP is enabled. This flag is mutually exclusive with ENABLE_MULTI_BANK_DETAILS. */
  ENABLE_BANK_DETAILS = 'ENABLE_BANK_DETAILS',
  /** Enables the new document extraction functionality */
  ENABLE_DOCUMENT_EXTRACTION = 'ENABLE_DOCUMENT_EXTRACTION',
  /** Enable ERP-based user attributes configuration, supporting sync from either SSO or accounting integrations. */
  ENABLE_ERP_USER_ATTRIBUTES = 'ENABLE_ERP_USER_ATTRIBUTES',
  /** When enabled, allow the customer to set filtering rules for synced entities (suppliers and core data) */
  ENABLE_FILTERING_SYNCED_ENTITIES = 'ENABLE_FILTERING_SYNCED_ENTITIES',
  /** When enabled, lightweight admins (admins without config permissions) will have the option to receive admin only emails */
  ENABLE_LIGHTWEIGHT_ADMIN_EMAILS = 'ENABLE_LIGHTWEIGHT_ADMIN_EMAILS',
  /** When enabled, allow suppliers and supplier profiles to have several bank details. This flag is mutually exclusive with ENABLE_BANK_DETAILS. */
  ENABLE_MULTI_BANK_DETAILS = 'ENABLE_MULTI_BANK_DETAILS',
  /** When selected will use the new table filter layout and functionality */
  ENABLE_NEW_TABLE_FILTERS = 'ENABLE_NEW_TABLE_FILTERS',
  /** When enabled, profiles from other suppliers will be merged into the existing supplier when processing external supplier updates */
  ENABLE_PROFILE_MERGING_ON_SUPPLIER_UPDATED = 'ENABLE_PROFILE_MERGING_ON_SUPPLIER_UPDATED',
  /** Enables the change of single request owner to multiple request leads */
  ENABLE_REQUEST_LEADS = 'ENABLE_REQUEST_LEADS',
  /** Enables setting a static supplier assignee for the supplier portal */
  ENABLE_STATIC_ASSIGNEE_SUPPLIER_PORTAL = 'ENABLE_STATIC_ASSIGNEE_SUPPLIER_PORTAL',
  /** When enabled, supplier profiles are surfaced on supplier details page */
  ENABLE_SUPPLIER_PROFILES = 'ENABLE_SUPPLIER_PROFILES',
  /** When enabled, will use the new method to fetch form context data where custom core data options are fetched in parallel */
  FORM_CONTEXT_DATA_V2 = 'FORM_CONTEXT_DATA_V2',
  /** When enabled, form question insights using AI will be generated and shown */
  FORM_INSIGHTS_AI = 'FORM_INSIGHTS_AI',
  /** When enabled, amendment request data form insights will be visible */
  FORM_INSIGHTS_AMENDMENT_DATA = 'FORM_INSIGHTS_AMENDMENT_DATA',
  /** When enabled users can upload a document to the top of a form and use it to pre-fill the form */
  FORM_LEVEL_AI_DOC_EXTRACTION = 'FORM_LEVEL_AI_DOC_EXTRACTION',
  /** When enabled, form responses will be translated into the organisation default language. */
  FORM_RESPONSE_TRANSLATION = 'FORM_RESPONSE_TRANSLATION',
  /** Enable Gen AI Features */
  GEN_AI = 'GEN_AI',
  /** Enables Omnea Goods Receipting module */
  GOODS_RECEIPTING = 'GOODS_RECEIPTING',
  /** Allows you to enable Conversational Intake and Rec Engine for Omneans only */
  OMNEANS_ONLY_CONV_INTAKE = 'OMNEANS_ONLY_CONV_INTAKE',
  /** Enables the Pandadoc integration */
  PANDADOC = 'PANDADOC',
  /** Display warning banner for forms in supplier portal */
  PLA_DISPLAY_SUPPLIER_PORTAL_WARNING = 'PLA_DISPLAY_SUPPLIER_PORTAL_WARNING',
  /** Controls whether the price benchmarking agent is enabled in omnea-assist. The price benchmarking agent integrates with Vendr to provide price benchmarking data for a range of suppliers / products */
  PRICE_BENCHMARKING = 'PRICE_BENCHMARKING',
  /** Products and services catalogue functionality  */
  PRODUCTS_AND_SERVICES_CATALOGUE = 'PRODUCTS_AND_SERVICES_CATALOGUE',
  /** Enables public api */
  PUBLIC_API = 'PUBLIC_API',
  /** Enables the Public API settings UI */
  PUBLIC_API_UI = 'PUBLIC_API_UI',
  /** When enabled, allows organisations to use punchout catalogues. */
  PUNCHOUT_CATALOGUES = 'PUNCHOUT_CATALOGUES',
  /** When enabled, shows isPA question and other PA UI changes */
  PURCHASE_AGREEMENTS = 'PURCHASE_AGREEMENTS',
  /** New reporting functionality */
  REPORTING = 'REPORTING',
  /** Enable celebrations when a request is completed */
  REQUEST_COMPLETION_CELEBRATIONS = 'REQUEST_COMPLETION_CELEBRATIONS',
  /** When enabled, users can use RFx functionality */
  RFX = 'RFX',
  /** Enable AI scoring for RFX responses */
  RFX_AI_SCORING = 'RFX_AI_SCORING',
  /** Enable AI pricing analysis for RFX */
  RFX_PRICING_ANALYSIS = 'RFX_PRICING_ANALYSIS',
  /** Enables AI supplier recommendations for RFx */
  RFX_SUPPLIER_RECOMMENDATIONS = 'RFX_SUPPLIER_RECOMMENDATIONS',
  /** Shows beamer */
  SHOW_BEAMER = 'SHOW_BEAMER',
  /** When enabled, the request table will display category paths (e.g., Parent.Child) */
  SHOW_CATEGORY_PATH_IN_REQUEST_TABLE = 'SHOW_CATEGORY_PATH_IN_REQUEST_TABLE',
  /** Show integration steps in My Tasks for fallback assignees */
  SHOW_INTEGRATIONS_IN_MY_TASKS = 'SHOW_INTEGRATIONS_IN_MY_TASKS',
  /** Show Omnea employees in the user search */
  SHOW_OMNEANS_IN_USER_SEARCH = 'SHOW_OMNEANS_IN_USER_SEARCH',
  /** Show subsidiaries in the supplier select components */
  SUPPLIER_AUTOCOMPLETE_SUBSIDIARIES = 'SUPPLIER_AUTOCOMPLETE_SUBSIDIARIES',
  /** When enabled displays supplier categories in supplier detail page, table and new template question */
  SUPPLIER_CATEGORISATION = 'SUPPLIER_CATEGORISATION',
  /** Enable supplier subprocessor management */
  SUPPLIER_SUBPROCESSORS = 'SUPPLIER_SUBPROCESSORS',
  /** Sync core data hourly instead of daily */
  SYNC_CORE_DATA_HOURLY = 'SYNC_CORE_DATA_HOURLY',
  /** Third party risk management feature */
  TPRM = 'TPRM',
  /** AI features for TPRM */
  TPRM_AI = 'TPRM_AI',
  /** This should only be turned on if the customer has PAID for Continuous Monitoring */
  TPRM_CONTINUOUS_MONITORING = 'TPRM_CONTINUOUS_MONITORING',
  /** Enables DORA (Digital Operational Resilience Act) features for TPRM */
  TPRM_DORA = 'TPRM_DORA',
  /** Enable server-side users table functionality */
  USERS_TABLE_PAGINATED = 'USERS_TABLE_PAGINATED',
  /** Allows users to be granted the Viewer role */
  VIEW_ONLY_ROLE = 'VIEW_ONLY_ROLE'
}

/** Boolean expression to compare columns of type "feature_flags_enum". All fields are combined with logical 'AND'. */
export type FeatureFlagsEnumComparisonExp = {
  _eq?: InputMaybe<FeatureFlagsEnum>;
  _in?: InputMaybe<Array<FeatureFlagsEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<FeatureFlagsEnum>;
  _nin?: InputMaybe<Array<FeatureFlagsEnum>>;
};

/** Ordering options when selecting data from "feature_flags". */
export type FeatureFlagsOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "feature_flags" */
export enum FeatureFlagsSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** columns and relationships of "financials" */
export type Financials = {
  __typename?: 'financials';
  amount: Maybe<Scalars['numeric']['output']>;
  autoRenewal: Maybe<Scalars['Boolean']['output']>;
  budgetedValue: Maybe<Scalars['numeric']['output']>;
  cancellationNoticeDays: Maybe<Scalars['Int']['output']>;
  contractEnd: Maybe<Scalars['date']['output']>;
  contractPeriodEnd: Maybe<Scalars['date']['output']>;
  contractPeriodStart: Maybe<Scalars['date']['output']>;
  costCenter: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  engagement: Maybe<Engagements>;
  fxRate: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  note: Maybe<Scalars['String']['output']>;
  paymentInterval: Maybe<PaymentIntervalEnum>;
  /** An object relationship */
  paymentIntervalByPaymentInterval: Maybe<PaymentInterval>;
  paymentMethod: Maybe<Scalars['String']['output']>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  paymentType: Maybe<Scalars['String']['output']>;
  pricingModel: Maybe<Scalars['String']['output']>;
  purchaseDate: Maybe<Scalars['date']['output']>;
  purchaseType: Maybe<PurchaseTypeEnum>;
  /** An object relationship */
  purchaseTypeByPurchaseType: Maybe<PurchaseType>;
  renewalDate: Maybe<Scalars['date']['output']>;
  subscriptionStart: Maybe<Scalars['date']['output']>;
};

/** order by aggregate values of table "financials" */
export type FinancialsAggregateOrderBy = {
  avg?: InputMaybe<FinancialsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<FinancialsMaxOrderBy>;
  min?: InputMaybe<FinancialsMinOrderBy>;
  stddev?: InputMaybe<FinancialsStddevOrderBy>;
  stddev_pop?: InputMaybe<FinancialsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<FinancialsStddevSampOrderBy>;
  sum?: InputMaybe<FinancialsSumOrderBy>;
  var_pop?: InputMaybe<FinancialsVarPopOrderBy>;
  var_samp?: InputMaybe<FinancialsVarSampOrderBy>;
  variance?: InputMaybe<FinancialsVarianceOrderBy>;
};

/** order by avg() on columns of table "financials" */
export type FinancialsAvgOrderBy = {
  amount?: InputMaybe<OrderBy>;
  budgetedValue?: InputMaybe<OrderBy>;
  cancellationNoticeDays?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "financials". All fields are combined with a logical 'AND'. */
export type FinancialsBoolExp = {
  _and?: InputMaybe<Array<FinancialsBoolExp>>;
  _not?: InputMaybe<FinancialsBoolExp>;
  _or?: InputMaybe<Array<FinancialsBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  autoRenewal?: InputMaybe<BooleanComparisonExp>;
  budgetedValue?: InputMaybe<NumericComparisonExp>;
  cancellationNoticeDays?: InputMaybe<IntComparisonExp>;
  contractEnd?: InputMaybe<DateComparisonExp>;
  contractPeriodEnd?: InputMaybe<DateComparisonExp>;
  contractPeriodStart?: InputMaybe<DateComparisonExp>;
  costCenter?: InputMaybe<StringComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  engagement?: InputMaybe<EngagementsBoolExp>;
  fxRate?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  paymentInterval?: InputMaybe<PaymentIntervalEnumComparisonExp>;
  paymentIntervalByPaymentInterval?: InputMaybe<PaymentIntervalBoolExp>;
  paymentMethod?: InputMaybe<StringComparisonExp>;
  paymentMethodId?: InputMaybe<UuidComparisonExp>;
  paymentType?: InputMaybe<StringComparisonExp>;
  pricingModel?: InputMaybe<StringComparisonExp>;
  purchaseDate?: InputMaybe<DateComparisonExp>;
  purchaseType?: InputMaybe<PurchaseTypeEnumComparisonExp>;
  purchaseTypeByPurchaseType?: InputMaybe<PurchaseTypeBoolExp>;
  renewalDate?: InputMaybe<DateComparisonExp>;
  subscriptionStart?: InputMaybe<DateComparisonExp>;
};

/** unique or primary key constraints on table "financials" */
export enum FinancialsConstraint {
  /** unique or primary key constraint on columns "id" */
  FINANCIALS_PKEY = 'financials_pkey'
}

/** input type for incrementing numeric columns in table "financials" */
export type FinancialsIncInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  budgetedValue?: InputMaybe<Scalars['numeric']['input']>;
  cancellationNoticeDays?: InputMaybe<Scalars['Int']['input']>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "financials" */
export type FinancialsInsertInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  autoRenewal?: InputMaybe<Scalars['Boolean']['input']>;
  budgetedValue?: InputMaybe<Scalars['numeric']['input']>;
  cancellationNoticeDays?: InputMaybe<Scalars['Int']['input']>;
  contractEnd?: InputMaybe<Scalars['date']['input']>;
  contractPeriodEnd?: InputMaybe<Scalars['date']['input']>;
  contractPeriodStart?: InputMaybe<Scalars['date']['input']>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  engagement?: InputMaybe<EngagementsObjRelInsertInput>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentInterval?: InputMaybe<PaymentIntervalEnum>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  pricingModel?: InputMaybe<Scalars['String']['input']>;
  purchaseDate?: InputMaybe<Scalars['date']['input']>;
  purchaseType?: InputMaybe<PurchaseTypeEnum>;
  renewalDate?: InputMaybe<Scalars['date']['input']>;
  subscriptionStart?: InputMaybe<Scalars['date']['input']>;
};

/** order by max() on columns of table "financials" */
export type FinancialsMaxOrderBy = {
  amount?: InputMaybe<OrderBy>;
  budgetedValue?: InputMaybe<OrderBy>;
  cancellationNoticeDays?: InputMaybe<OrderBy>;
  contractEnd?: InputMaybe<OrderBy>;
  contractPeriodEnd?: InputMaybe<OrderBy>;
  contractPeriodStart?: InputMaybe<OrderBy>;
  costCenter?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  paymentMethod?: InputMaybe<OrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  paymentType?: InputMaybe<OrderBy>;
  pricingModel?: InputMaybe<OrderBy>;
  purchaseDate?: InputMaybe<OrderBy>;
  renewalDate?: InputMaybe<OrderBy>;
  subscriptionStart?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "financials" */
export type FinancialsMinOrderBy = {
  amount?: InputMaybe<OrderBy>;
  budgetedValue?: InputMaybe<OrderBy>;
  cancellationNoticeDays?: InputMaybe<OrderBy>;
  contractEnd?: InputMaybe<OrderBy>;
  contractPeriodEnd?: InputMaybe<OrderBy>;
  contractPeriodStart?: InputMaybe<OrderBy>;
  costCenter?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  paymentMethod?: InputMaybe<OrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  paymentType?: InputMaybe<OrderBy>;
  pricingModel?: InputMaybe<OrderBy>;
  purchaseDate?: InputMaybe<OrderBy>;
  renewalDate?: InputMaybe<OrderBy>;
  subscriptionStart?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "financials" */
export type FinancialsMutationResponse = {
  __typename?: 'financials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Financials>;
};

/** input type for inserting object relation for remote table "financials" */
export type FinancialsObjRelInsertInput = {
  data: FinancialsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<FinancialsOnConflict>;
};

/** on_conflict condition type for table "financials" */
export type FinancialsOnConflict = {
  constraint: FinancialsConstraint;
  update_columns: Array<FinancialsUpdateColumn>;
  where?: InputMaybe<FinancialsBoolExp>;
};

/** Ordering options when selecting data from "financials". */
export type FinancialsOrderBy = {
  amount?: InputMaybe<OrderBy>;
  autoRenewal?: InputMaybe<OrderBy>;
  budgetedValue?: InputMaybe<OrderBy>;
  cancellationNoticeDays?: InputMaybe<OrderBy>;
  contractEnd?: InputMaybe<OrderBy>;
  contractPeriodEnd?: InputMaybe<OrderBy>;
  contractPeriodStart?: InputMaybe<OrderBy>;
  costCenter?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  engagement?: InputMaybe<EngagementsOrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  paymentInterval?: InputMaybe<OrderBy>;
  paymentIntervalByPaymentInterval?: InputMaybe<PaymentIntervalOrderBy>;
  paymentMethod?: InputMaybe<OrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  paymentType?: InputMaybe<OrderBy>;
  pricingModel?: InputMaybe<OrderBy>;
  purchaseDate?: InputMaybe<OrderBy>;
  purchaseType?: InputMaybe<OrderBy>;
  purchaseTypeByPurchaseType?: InputMaybe<PurchaseTypeOrderBy>;
  renewalDate?: InputMaybe<OrderBy>;
  subscriptionStart?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: financials */
export type FinancialsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "financials" */
export enum FinancialsSelectColumn {
  /** column name */
  AMOUNT = 'amount',
  /** column name */
  AUTORENEWAL = 'autoRenewal',
  /** column name */
  BUDGETEDVALUE = 'budgetedValue',
  /** column name */
  CANCELLATIONNOTICEDAYS = 'cancellationNoticeDays',
  /** column name */
  CONTRACTEND = 'contractEnd',
  /** column name */
  CONTRACTPERIODEND = 'contractPeriodEnd',
  /** column name */
  CONTRACTPERIODSTART = 'contractPeriodStart',
  /** column name */
  COSTCENTER = 'costCenter',
  /** column name */
  CURRENCY = 'currency',
  /** column name */
  FXRATE = 'fxRate',
  /** column name */
  ID = 'id',
  /** column name */
  NOTE = 'note',
  /** column name */
  PAYMENTINTERVAL = 'paymentInterval',
  /** column name */
  PAYMENTMETHOD = 'paymentMethod',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTYPE = 'paymentType',
  /** column name */
  PRICINGMODEL = 'pricingModel',
  /** column name */
  PURCHASEDATE = 'purchaseDate',
  /** column name */
  PURCHASETYPE = 'purchaseType',
  /** column name */
  RENEWALDATE = 'renewalDate',
  /** column name */
  SUBSCRIPTIONSTART = 'subscriptionStart'
}

/** input type for updating data in table "financials" */
export type FinancialsSetInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  autoRenewal?: InputMaybe<Scalars['Boolean']['input']>;
  budgetedValue?: InputMaybe<Scalars['numeric']['input']>;
  cancellationNoticeDays?: InputMaybe<Scalars['Int']['input']>;
  contractEnd?: InputMaybe<Scalars['date']['input']>;
  contractPeriodEnd?: InputMaybe<Scalars['date']['input']>;
  contractPeriodStart?: InputMaybe<Scalars['date']['input']>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentInterval?: InputMaybe<PaymentIntervalEnum>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  pricingModel?: InputMaybe<Scalars['String']['input']>;
  purchaseDate?: InputMaybe<Scalars['date']['input']>;
  purchaseType?: InputMaybe<PurchaseTypeEnum>;
  renewalDate?: InputMaybe<Scalars['date']['input']>;
  subscriptionStart?: InputMaybe<Scalars['date']['input']>;
};

/** order by stddev() on columns of table "financials" */
export type FinancialsStddevOrderBy = {
  amount?: InputMaybe<OrderBy>;
  budgetedValue?: InputMaybe<OrderBy>;
  cancellationNoticeDays?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "financials" */
export type FinancialsStddevPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  budgetedValue?: InputMaybe<OrderBy>;
  cancellationNoticeDays?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "financials" */
export type FinancialsStddevSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  budgetedValue?: InputMaybe<OrderBy>;
  cancellationNoticeDays?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
};

/** order by sum() on columns of table "financials" */
export type FinancialsSumOrderBy = {
  amount?: InputMaybe<OrderBy>;
  budgetedValue?: InputMaybe<OrderBy>;
  cancellationNoticeDays?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
};

/** update columns of table "financials" */
export enum FinancialsUpdateColumn {
  /** column name */
  AMOUNT = 'amount',
  /** column name */
  AUTORENEWAL = 'autoRenewal',
  /** column name */
  BUDGETEDVALUE = 'budgetedValue',
  /** column name */
  CANCELLATIONNOTICEDAYS = 'cancellationNoticeDays',
  /** column name */
  CONTRACTEND = 'contractEnd',
  /** column name */
  CONTRACTPERIODEND = 'contractPeriodEnd',
  /** column name */
  CONTRACTPERIODSTART = 'contractPeriodStart',
  /** column name */
  COSTCENTER = 'costCenter',
  /** column name */
  CURRENCY = 'currency',
  /** column name */
  FXRATE = 'fxRate',
  /** column name */
  ID = 'id',
  /** column name */
  NOTE = 'note',
  /** column name */
  PAYMENTINTERVAL = 'paymentInterval',
  /** column name */
  PAYMENTMETHOD = 'paymentMethod',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTYPE = 'paymentType',
  /** column name */
  PRICINGMODEL = 'pricingModel',
  /** column name */
  PURCHASEDATE = 'purchaseDate',
  /** column name */
  PURCHASETYPE = 'purchaseType',
  /** column name */
  RENEWALDATE = 'renewalDate',
  /** column name */
  SUBSCRIPTIONSTART = 'subscriptionStart'
}

export type FinancialsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<FinancialsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FinancialsSetInput>;
  /** filter the rows which have to be updated */
  where: FinancialsBoolExp;
};

/** order by var_pop() on columns of table "financials" */
export type FinancialsVarPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  budgetedValue?: InputMaybe<OrderBy>;
  cancellationNoticeDays?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "financials" */
export type FinancialsVarSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  budgetedValue?: InputMaybe<OrderBy>;
  cancellationNoticeDays?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "financials" */
export type FinancialsVarianceOrderBy = {
  amount?: InputMaybe<OrderBy>;
  budgetedValue?: InputMaybe<OrderBy>;
  cancellationNoticeDays?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8ComparisonExp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "form_template_question_insights" */
export type FormTemplateQuestionInsights = {
  __typename?: 'form_template_question_insights';
  category: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  /** An object relationship */
  formTemplate: Maybe<FormTemplates>;
  formTemplateId: Maybe<Scalars['uuid']['output']>;
  generationData: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  questionName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  suggestion: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updatedByUser: Maybe<Users>;
};


/** columns and relationships of "form_template_question_insights" */
export type FormTemplateQuestionInsightsGenerationDataArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "form_template_question_insights" */
export type FormTemplateQuestionInsightsAggregate = {
  __typename?: 'form_template_question_insights_aggregate';
  aggregate: Maybe<FormTemplateQuestionInsightsAggregateFields>;
  nodes: Array<FormTemplateQuestionInsights>;
};

export type FormTemplateQuestionInsightsAggregateBoolExp = {
  count?: InputMaybe<FormTemplateQuestionInsightsAggregateBoolExpCount>;
};

export type FormTemplateQuestionInsightsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<FormTemplateQuestionInsightsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "form_template_question_insights" */
export type FormTemplateQuestionInsightsAggregateFields = {
  __typename?: 'form_template_question_insights_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<FormTemplateQuestionInsightsMaxFields>;
  min: Maybe<FormTemplateQuestionInsightsMinFields>;
};


/** aggregate fields of "form_template_question_insights" */
export type FormTemplateQuestionInsightsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<FormTemplateQuestionInsightsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "form_template_question_insights" */
export type FormTemplateQuestionInsightsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<FormTemplateQuestionInsightsMaxOrderBy>;
  min?: InputMaybe<FormTemplateQuestionInsightsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FormTemplateQuestionInsightsAppendInput = {
  generationData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "form_template_question_insights" */
export type FormTemplateQuestionInsightsArrRelInsertInput = {
  data: Array<FormTemplateQuestionInsightsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<FormTemplateQuestionInsightsOnConflict>;
};

/** Boolean expression to filter rows from the table "form_template_question_insights". All fields are combined with a logical 'AND'. */
export type FormTemplateQuestionInsightsBoolExp = {
  _and?: InputMaybe<Array<FormTemplateQuestionInsightsBoolExp>>;
  _not?: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
  _or?: InputMaybe<Array<FormTemplateQuestionInsightsBoolExp>>;
  category?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  formTemplate?: InputMaybe<FormTemplatesBoolExp>;
  formTemplateId?: InputMaybe<UuidComparisonExp>;
  generationData?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  questionName?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  suggestion?: InputMaybe<StringComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updatedByUser?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "form_template_question_insights" */
export enum FormTemplateQuestionInsightsConstraint {
  /** unique or primary key constraint on columns "id" */
  FORM_TEMPLATE_QUESTION_INSIGHTS_PKEY = 'form_template_question_insights_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FormTemplateQuestionInsightsDeleteAtPathInput = {
  generationData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FormTemplateQuestionInsightsDeleteElemInput = {
  generationData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FormTemplateQuestionInsightsDeleteKeyInput = {
  generationData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "form_template_question_insights" */
export type FormTemplateQuestionInsightsInsertInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formTemplate?: InputMaybe<FormTemplatesObjRelInsertInput>;
  formTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  generationData?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  questionName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suggestion?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  updatedByUser?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type FormTemplateQuestionInsightsMaxFields = {
  __typename?: 'form_template_question_insights_max_fields';
  category: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  formTemplateId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  questionName: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  suggestion: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  updatedBy: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "form_template_question_insights" */
export type FormTemplateQuestionInsightsMaxOrderBy = {
  category?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  formTemplateId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  questionName?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  suggestion?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type FormTemplateQuestionInsightsMinFields = {
  __typename?: 'form_template_question_insights_min_fields';
  category: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  formTemplateId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  questionName: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  suggestion: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  updatedBy: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "form_template_question_insights" */
export type FormTemplateQuestionInsightsMinOrderBy = {
  category?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  formTemplateId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  questionName?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  suggestion?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "form_template_question_insights" */
export type FormTemplateQuestionInsightsMutationResponse = {
  __typename?: 'form_template_question_insights_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<FormTemplateQuestionInsights>;
};

/** on_conflict condition type for table "form_template_question_insights" */
export type FormTemplateQuestionInsightsOnConflict = {
  constraint: FormTemplateQuestionInsightsConstraint;
  update_columns: Array<FormTemplateQuestionInsightsUpdateColumn>;
  where?: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
};

/** Ordering options when selecting data from "form_template_question_insights". */
export type FormTemplateQuestionInsightsOrderBy = {
  category?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  formTemplate?: InputMaybe<FormTemplatesOrderBy>;
  formTemplateId?: InputMaybe<OrderBy>;
  generationData?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  questionName?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  suggestion?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  updatedByUser?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: form_template_question_insights */
export type FormTemplateQuestionInsightsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FormTemplateQuestionInsightsPrependInput = {
  generationData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "form_template_question_insights" */
export enum FormTemplateQuestionInsightsSelectColumn {
  /** column name */
  CATEGORY = 'category',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  FORMTEMPLATEID = 'formTemplateId',
  /** column name */
  GENERATIONDATA = 'generationData',
  /** column name */
  ID = 'id',
  /** column name */
  QUESTIONNAME = 'questionName',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUGGESTION = 'suggestion',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

/** input type for updating data in table "form_template_question_insights" */
export type FormTemplateQuestionInsightsSetInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  generationData?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  questionName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suggestion?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "form_template_question_insights" */
export type FormTemplateQuestionInsightsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: FormTemplateQuestionInsightsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FormTemplateQuestionInsightsStreamCursorValueInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  generationData?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  questionName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suggestion?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "form_template_question_insights" */
export enum FormTemplateQuestionInsightsUpdateColumn {
  /** column name */
  CATEGORY = 'category',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  FORMTEMPLATEID = 'formTemplateId',
  /** column name */
  GENERATIONDATA = 'generationData',
  /** column name */
  ID = 'id',
  /** column name */
  QUESTIONNAME = 'questionName',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUGGESTION = 'suggestion',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

export type FormTemplateQuestionInsightsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<FormTemplateQuestionInsightsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<FormTemplateQuestionInsightsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<FormTemplateQuestionInsightsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<FormTemplateQuestionInsightsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<FormTemplateQuestionInsightsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FormTemplateQuestionInsightsSetInput>;
  /** filter the rows which have to be updated */
  where: FormTemplateQuestionInsightsBoolExp;
};

/** columns and relationships of "form_template_state" */
export type FormTemplateState = {
  __typename?: 'form_template_state';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "form_template_state". All fields are combined with a logical 'AND'. */
export type FormTemplateStateBoolExp = {
  _and?: InputMaybe<Array<FormTemplateStateBoolExp>>;
  _not?: InputMaybe<FormTemplateStateBoolExp>;
  _or?: InputMaybe<Array<FormTemplateStateBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum FormTemplateStateEnum {
  /** Archived */
  ARCHIVED = 'ARCHIVED',
  /** Draft */
  DRAFT = 'DRAFT',
  /** Published */
  PUBLISHED = 'PUBLISHED'
}

/** Boolean expression to compare columns of type "form_template_state_enum". All fields are combined with logical 'AND'. */
export type FormTemplateStateEnumComparisonExp = {
  _eq?: InputMaybe<FormTemplateStateEnum>;
  _in?: InputMaybe<Array<FormTemplateStateEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<FormTemplateStateEnum>;
  _nin?: InputMaybe<Array<FormTemplateStateEnum>>;
};

/** Ordering options when selecting data from "form_template_state". */
export type FormTemplateStateOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "form_template_state" */
export enum FormTemplateStateSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** columns and relationships of "form_templates" */
export type FormTemplates = {
  __typename?: 'form_templates';
  config: Scalars['formConfig']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user: Maybe<Users>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  externalTitle: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  integration: Maybe<Scalars['integration']['output']>;
  internalId: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organisation: Maybe<Organisations>;
  organisationId: Scalars['uuid']['output'];
  /** An array relationship */
  questionInsights: Array<FormTemplateQuestionInsights>;
  /** An aggregate relationship */
  questionInsights_aggregate: FormTemplateQuestionInsightsAggregate;
  /** An array relationship */
  request_forms: Array<RequestForms>;
  state: FormTemplateStateEnum;
  title: Scalars['String']['output'];
  type: FormTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
  /** An object relationship */
  user: Maybe<Users>;
};


/** columns and relationships of "form_templates" */
export type FormTemplatesQuestionInsightsArgs = {
  distinct_on: InputMaybe<Array<FormTemplateQuestionInsightsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FormTemplateQuestionInsightsOrderBy>>;
  where: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
};


/** columns and relationships of "form_templates" */
export type FormTemplatesQuestionInsightsAggregateArgs = {
  distinct_on: InputMaybe<Array<FormTemplateQuestionInsightsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FormTemplateQuestionInsightsOrderBy>>;
  where: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
};


/** columns and relationships of "form_templates" */
export type FormTemplatesRequestFormsArgs = {
  distinct_on: InputMaybe<Array<RequestFormsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormsOrderBy>>;
  where: InputMaybe<RequestFormsBoolExp>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type FormTemplatesAppendInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "form_templates". All fields are combined with a logical 'AND'. */
export type FormTemplatesBoolExp = {
  _and?: InputMaybe<Array<FormTemplatesBoolExp>>;
  _not?: InputMaybe<FormTemplatesBoolExp>;
  _or?: InputMaybe<Array<FormTemplatesBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  externalTitle?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<StringComparisonExp>;
  internalId?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  questionInsights?: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
  questionInsights_aggregate?: InputMaybe<FormTemplateQuestionInsightsAggregateBoolExp>;
  request_forms?: InputMaybe<RequestFormsBoolExp>;
  state?: InputMaybe<FormTemplateStateEnumComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<FormTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "form_templates" */
export enum FormTemplatesConstraint {
  /** unique or primary key constraint on columns "organisation_id", "internal_id" */
  FORM_TEMPLATES_INTERNAL_ID_ORGANISATION_ID_KEY = 'form_templates_internal_id_organisation_id_key',
  /** unique or primary key constraint on columns "id" */
  FORM_TEMPLATES_PKEY = 'form_templates_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type FormTemplatesDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type FormTemplatesDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type FormTemplatesDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "form_templates" */
export type FormTemplatesInsertInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<UsersObjRelInsertInput>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  integration?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  questionInsights?: InputMaybe<FormTemplateQuestionInsightsArrRelInsertInput>;
  request_forms?: InputMaybe<RequestFormsArrRelInsertInput>;
  state?: InputMaybe<FormTemplateStateEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FormTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  updated_by_user?: InputMaybe<UsersObjRelInsertInput>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** response of any mutation on the table "form_templates" */
export type FormTemplatesMutationResponse = {
  __typename?: 'form_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<FormTemplates>;
};

/** input type for inserting object relation for remote table "form_templates" */
export type FormTemplatesObjRelInsertInput = {
  data: FormTemplatesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<FormTemplatesOnConflict>;
};

/** on_conflict condition type for table "form_templates" */
export type FormTemplatesOnConflict = {
  constraint: FormTemplatesConstraint;
  update_columns: Array<FormTemplatesUpdateColumn>;
  where?: InputMaybe<FormTemplatesBoolExp>;
};

/** Ordering options when selecting data from "form_templates". */
export type FormTemplatesOrderBy = {
  config?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  externalTitle?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<OrderBy>;
  internalId?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  questionInsights_aggregate?: InputMaybe<FormTemplateQuestionInsightsAggregateOrderBy>;
  request_forms_aggregate?: InputMaybe<RequestFormsAggregateOrderBy>;
  state?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: form_templates */
export type FormTemplatesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type FormTemplatesPrependInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "form_templates" */
export enum FormTemplatesSelectColumn {
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EXTERNALTITLE = 'externalTitle',
  /** column name */
  ID = 'id',
  /** column name */
  INTEGRATION = 'integration',
  /** column name */
  INTERNALID = 'internalId',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  STATE = 'state',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

/** input type for updating data in table "form_templates" */
export type FormTemplatesSetInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<FormTemplateStateEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FormTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "form_templates" */
export enum FormTemplatesUpdateColumn {
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EXTERNALTITLE = 'externalTitle',
  /** column name */
  ID = 'id',
  /** column name */
  STATE = 'state',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

export type FormTemplatesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<FormTemplatesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<FormTemplatesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<FormTemplatesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<FormTemplatesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<FormTemplatesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FormTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: FormTemplatesBoolExp;
};

/** columns and relationships of "form_type" */
export type FormType = {
  __typename?: 'form_type';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "form_type". All fields are combined with a logical 'AND'. */
export type FormTypeBoolExp = {
  _and?: InputMaybe<Array<FormTypeBoolExp>>;
  _not?: InputMaybe<FormTypeBoolExp>;
  _or?: InputMaybe<Array<FormTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum FormTypeEnum {
  /** Access request forms */
  ACCESS_REQUEST = 'ACCESS_REQUEST',
  /** Cancel Agreement Forms */
  CANCEL_AGREEMENT = 'CANCEL_AGREEMENT',
  /** Catalogue purchase forms */
  CATALOGUE_PURCHASE = 'CATALOGUE_PURCHASE',
  /** Details to commit to the supplier  */
  COMMIT_SUPPLIER_DATA = 'COMMIT_SUPPLIER_DATA',
  /** Agreement details  */
  CREATE_AGREEMENT = 'CREATE_AGREEMENT',
  /** Create Assessment Form */
  CREATE_ASSESSMENT = 'CREATE_ASSESSMENT',
  /** CREATE_ENGAGEMENT */
  CREATE_ENGAGEMENT = 'CREATE_ENGAGEMENT',
  /** Details to create a purchase order */
  CREATE_PURCHASE_ORDER = 'CREATE_PURCHASE_ORDER',
  /** Used as a base to create a renewal. Currently a hard coded form we clone when the task needs to be created. */
  CREATE_RENEWAL = 'CREATE_RENEWAL',
  /** External operation output forms */
  EXTERNAL_OPERATION = 'EXTERNAL_OPERATION',
  /** Intake Forms */
  INTAKE = 'INTAKE',
  /** Other */
  OTHER = 'OTHER',
  /** Renewal Assessment */
  RENEWAL_ASSESSMENT = 'RENEWAL_ASSESSMENT',
  /** RFx form */
  RFX = 'RFX',
  /** Supplier Onboarding Form */
  SUPPLIER_ONBOARDING = 'SUPPLIER_ONBOARDING'
}

/** Boolean expression to compare columns of type "form_type_enum". All fields are combined with logical 'AND'. */
export type FormTypeEnumComparisonExp = {
  _eq?: InputMaybe<FormTypeEnum>;
  _in?: InputMaybe<Array<FormTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<FormTypeEnum>;
  _nin?: InputMaybe<Array<FormTypeEnum>>;
};

/** Ordering options when selecting data from "form_type". */
export type FormTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "form_type" */
export enum FormTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

export type GetAllNodesUntilRootForIdsArgs = {
  ids?: InputMaybe<Scalars['_uuid']['input']>;
};

export type GetCustomCoreDataCountsArgs = {
  p_conditions?: InputMaybe<Scalars['jsonb']['input']>;
  p_conjunction?: InputMaybe<Scalars['String']['input']>;
  p_custom_core_data_id?: InputMaybe<Scalars['uuid']['input']>;
  p_dependency_core_data_id?: InputMaybe<Scalars['uuid']['input']>;
  p_dependency_supplier_profile_id?: InputMaybe<Scalars['uuid']['input']>;
  p_depth?: InputMaybe<Scalars['Int']['input']>;
  p_include_archived?: InputMaybe<Scalars['Boolean']['input']>;
  p_search?: InputMaybe<Scalars['String']['input']>;
};

export type GetLatestRequestFormSubmissionsArgs = {
  requestformid?: InputMaybe<Scalars['uuid']['input']>;
};

export type GetLatestRequestFormSubmissionsForRequestArgs = {
  requestid?: InputMaybe<Scalars['uuid']['input']>;
};

/** Keep track of group user assignments for a given request */
export type GroupUserAssignments = {
  __typename?: 'group_user_assignments';
  createdAt: Scalars['timestamptz']['output'];
  groupId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  method: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  requestId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "group_user_assignments" */
export type GroupUserAssignmentsAggregate = {
  __typename?: 'group_user_assignments_aggregate';
  aggregate: Maybe<GroupUserAssignmentsAggregateFields>;
  nodes: Array<GroupUserAssignments>;
};

export type GroupUserAssignmentsAggregateBoolExp = {
  count?: InputMaybe<GroupUserAssignmentsAggregateBoolExpCount>;
};

export type GroupUserAssignmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<GroupUserAssignmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<GroupUserAssignmentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "group_user_assignments" */
export type GroupUserAssignmentsAggregateFields = {
  __typename?: 'group_user_assignments_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<GroupUserAssignmentsMaxFields>;
  min: Maybe<GroupUserAssignmentsMinFields>;
};


/** aggregate fields of "group_user_assignments" */
export type GroupUserAssignmentsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<GroupUserAssignmentsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "group_user_assignments" */
export type GroupUserAssignmentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupUserAssignmentsMaxOrderBy>;
  min?: InputMaybe<GroupUserAssignmentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "group_user_assignments" */
export type GroupUserAssignmentsArrRelInsertInput = {
  data: Array<GroupUserAssignmentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<GroupUserAssignmentsOnConflict>;
};

/** Boolean expression to filter rows from the table "group_user_assignments". All fields are combined with a logical 'AND'. */
export type GroupUserAssignmentsBoolExp = {
  _and?: InputMaybe<Array<GroupUserAssignmentsBoolExp>>;
  _not?: InputMaybe<GroupUserAssignmentsBoolExp>;
  _or?: InputMaybe<Array<GroupUserAssignmentsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  method?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "group_user_assignments" */
export enum GroupUserAssignmentsConstraint {
  /** unique or primary key constraint on columns "id" */
  GROUP_USER_ASSIGNMENTS_PKEY = 'group_user_assignments_pkey'
}

/** input type for inserting data into table "group_user_assignments" */
export type GroupUserAssignmentsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type GroupUserAssignmentsMaxFields = {
  __typename?: 'group_user_assignments_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  groupId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  method: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "group_user_assignments" */
export type GroupUserAssignmentsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  method?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type GroupUserAssignmentsMinFields = {
  __typename?: 'group_user_assignments_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  groupId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  method: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "group_user_assignments" */
export type GroupUserAssignmentsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  method?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "group_user_assignments" */
export type GroupUserAssignmentsMutationResponse = {
  __typename?: 'group_user_assignments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupUserAssignments>;
};

/** on_conflict condition type for table "group_user_assignments" */
export type GroupUserAssignmentsOnConflict = {
  constraint: GroupUserAssignmentsConstraint;
  update_columns: Array<GroupUserAssignmentsUpdateColumn>;
  where?: InputMaybe<GroupUserAssignmentsBoolExp>;
};

/** Ordering options when selecting data from "group_user_assignments". */
export type GroupUserAssignmentsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  method?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: group_user_assignments */
export type GroupUserAssignmentsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "group_user_assignments" */
export enum GroupUserAssignmentsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  METHOD = 'method',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "group_user_assignments" */
export type GroupUserAssignmentsSetInput = {
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "group_user_assignments" */
export enum GroupUserAssignmentsUpdateColumn {
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  METHOD = 'method',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  USERID = 'userId'
}

export type GroupUserAssignmentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupUserAssignmentsSetInput>;
  /** filter the rows which have to be updated */
  where: GroupUserAssignmentsBoolExp;
};

/** columns and relationships of "group_users" */
export type GroupUsers = {
  __typename?: 'group_users';
  /** An array relationship */
  assignments: Array<GroupUserAssignments>;
  /** An aggregate relationship */
  assignments_aggregate: GroupUserAssignmentsAggregate;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "group_users" */
export type GroupUsersAssignmentsArgs = {
  distinct_on: InputMaybe<Array<GroupUserAssignmentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<GroupUserAssignmentsOrderBy>>;
  where: InputMaybe<GroupUserAssignmentsBoolExp>;
};


/** columns and relationships of "group_users" */
export type GroupUsersAssignmentsAggregateArgs = {
  distinct_on: InputMaybe<Array<GroupUserAssignmentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<GroupUserAssignmentsOrderBy>>;
  where: InputMaybe<GroupUserAssignmentsBoolExp>;
};

/** order by aggregate values of table "group_users" */
export type GroupUsersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<GroupUsersMaxOrderBy>;
  min?: InputMaybe<GroupUsersMinOrderBy>;
};

/** input type for inserting array relation for remote table "group_users" */
export type GroupUsersArrRelInsertInput = {
  data: Array<GroupUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<GroupUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "group_users". All fields are combined with a logical 'AND'. */
export type GroupUsersBoolExp = {
  _and?: InputMaybe<Array<GroupUsersBoolExp>>;
  _not?: InputMaybe<GroupUsersBoolExp>;
  _or?: InputMaybe<Array<GroupUsersBoolExp>>;
  assignments?: InputMaybe<GroupUserAssignmentsBoolExp>;
  assignments_aggregate?: InputMaybe<GroupUserAssignmentsAggregateBoolExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "group_users" */
export enum GroupUsersConstraint {
  /** unique or primary key constraint on columns "id" */
  GROUP_USERS_PKEY = 'group_users_pkey',
  /** unique or primary key constraint on columns "user_id", "group_id" */
  GROUP_USERS_USER_ID_GROUP_ID_KEY = 'group_users_user_id_group_id_key'
}

/** input type for inserting data into table "group_users" */
export type GroupUsersInsertInput = {
  assignments?: InputMaybe<GroupUserAssignmentsArrRelInsertInput>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "group_users" */
export type GroupUsersMaxOrderBy = {
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "group_users" */
export type GroupUsersMinOrderBy = {
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "group_users" */
export type GroupUsersMutationResponse = {
  __typename?: 'group_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupUsers>;
};

/** on_conflict condition type for table "group_users" */
export type GroupUsersOnConflict = {
  constraint: GroupUsersConstraint;
  update_columns: Array<GroupUsersUpdateColumn>;
  where?: InputMaybe<GroupUsersBoolExp>;
};

/** Ordering options when selecting data from "group_users". */
export type GroupUsersOrderBy = {
  assignments_aggregate?: InputMaybe<GroupUserAssignmentsAggregateOrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: group_users */
export type GroupUsersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "group_users" */
export enum GroupUsersSelectColumn {
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "group_users" */
export type GroupUsersSetInput = {
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "group_users" */
export enum GroupUsersUpdateColumn {
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  USERID = 'userId'
}

export type GroupUsersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupUsersSetInput>;
  /** filter the rows which have to be updated */
  where: GroupUsersBoolExp;
};

/** columns and relationships of "groups" */
export type Groups = {
  __typename?: 'groups';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  group_users: Array<GroupUsers>;
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  rawAttributes: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  request_groups: Array<RequestGroups>;
  /** An array relationship */
  request_step_groups: Array<RequestStepGroups>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "groups" */
export type GroupsGroupUsersArgs = {
  distinct_on: InputMaybe<Array<GroupUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<GroupUsersOrderBy>>;
  where: InputMaybe<GroupUsersBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsRawAttributesArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "groups" */
export type GroupsRequestGroupsArgs = {
  distinct_on: InputMaybe<Array<RequestGroupsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestGroupsOrderBy>>;
  where: InputMaybe<RequestGroupsBoolExp>;
};


/** columns and relationships of "groups" */
export type GroupsRequestStepGroupsArgs = {
  distinct_on: InputMaybe<Array<RequestStepGroupsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepGroupsOrderBy>>;
  where: InputMaybe<RequestStepGroupsBoolExp>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type GroupsAppendInput = {
  rawAttributes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "groups". All fields are combined with a logical 'AND'. */
export type GroupsBoolExp = {
  _and?: InputMaybe<Array<GroupsBoolExp>>;
  _not?: InputMaybe<GroupsBoolExp>;
  _or?: InputMaybe<Array<GroupsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  group_users?: InputMaybe<GroupUsersBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  rawAttributes?: InputMaybe<JsonbComparisonExp>;
  request_groups?: InputMaybe<RequestGroupsBoolExp>;
  request_step_groups?: InputMaybe<RequestStepGroupsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "groups" */
export enum GroupsConstraint {
  /** unique or primary key constraint on columns "id" */
  GROUPS_PKEY = 'groups_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type GroupsDeleteAtPathInput = {
  rawAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type GroupsDeleteElemInput = {
  rawAttributes?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type GroupsDeleteKeyInput = {
  rawAttributes?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "groups" */
export type GroupsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  group_users?: InputMaybe<GroupUsersArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rawAttributes?: InputMaybe<Scalars['jsonb']['input']>;
  request_groups?: InputMaybe<RequestGroupsArrRelInsertInput>;
  request_step_groups?: InputMaybe<RequestStepGroupsArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "groups" */
export type GroupsMutationResponse = {
  __typename?: 'groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Groups>;
};

/** input type for inserting object relation for remote table "groups" */
export type GroupsObjRelInsertInput = {
  data: GroupsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<GroupsOnConflict>;
};

/** on_conflict condition type for table "groups" */
export type GroupsOnConflict = {
  constraint: GroupsConstraint;
  update_columns: Array<GroupsUpdateColumn>;
  where?: InputMaybe<GroupsBoolExp>;
};

/** Ordering options when selecting data from "groups". */
export type GroupsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  group_users_aggregate?: InputMaybe<GroupUsersAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  rawAttributes?: InputMaybe<OrderBy>;
  request_groups_aggregate?: InputMaybe<RequestGroupsAggregateOrderBy>;
  request_step_groups_aggregate?: InputMaybe<RequestStepGroupsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: groups */
export type GroupsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type GroupsPrependInput = {
  rawAttributes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "groups" */
export enum GroupsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  RAWATTRIBUTES = 'rawAttributes',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "groups" */
export type GroupsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rawAttributes?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "groups" */
export enum GroupsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  RAWATTRIBUTES = 'rawAttributes',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type GroupsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<GroupsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<GroupsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<GroupsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<GroupsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<GroupsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupsSetInput>;
  /** filter the rows which have to be updated */
  where: GroupsBoolExp;
};

/** columns and relationships of "idp_attribute_mappings" */
export type IdpAttributeMappings = {
  __typename?: 'idp_attribute_mappings';
  customFieldId: Scalars['uuid']['output'];
  /** An object relationship */
  custom_field: CustomFields;
  id: Scalars['uuid']['output'];
  idpCustomAttribute: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "idp_attribute_mappings". All fields are combined with a logical 'AND'. */
export type IdpAttributeMappingsBoolExp = {
  _and?: InputMaybe<Array<IdpAttributeMappingsBoolExp>>;
  _not?: InputMaybe<IdpAttributeMappingsBoolExp>;
  _or?: InputMaybe<Array<IdpAttributeMappingsBoolExp>>;
  customFieldId?: InputMaybe<UuidComparisonExp>;
  custom_field?: InputMaybe<CustomFieldsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  idpCustomAttribute?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "idp_attribute_mappings" */
export enum IdpAttributeMappingsConstraint {
  /** unique or primary key constraint on columns "custom_field_id" */
  IPD_ATTRIBUTE_MAPPINGS_CUSTOM_FIELD_ID_KEY = 'ipd_attribute_mappings_custom_field_id_key',
  /** unique or primary key constraint on columns "id" */
  IPD_ATTRIBUTE_MAPPINGS_PKEY = 'ipd_attribute_mappings_pkey'
}

/** input type for inserting data into table "idp_attribute_mappings" */
export type IdpAttributeMappingsInsertInput = {
  customFieldId?: InputMaybe<Scalars['uuid']['input']>;
  custom_field?: InputMaybe<CustomFieldsObjRelInsertInput>;
  idpCustomAttribute?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "idp_attribute_mappings" */
export type IdpAttributeMappingsMutationResponse = {
  __typename?: 'idp_attribute_mappings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<IdpAttributeMappings>;
};

/** on_conflict condition type for table "idp_attribute_mappings" */
export type IdpAttributeMappingsOnConflict = {
  constraint: IdpAttributeMappingsConstraint;
  update_columns: Array<IdpAttributeMappingsUpdateColumn>;
  where?: InputMaybe<IdpAttributeMappingsBoolExp>;
};

/** Ordering options when selecting data from "idp_attribute_mappings". */
export type IdpAttributeMappingsOrderBy = {
  customFieldId?: InputMaybe<OrderBy>;
  custom_field?: InputMaybe<CustomFieldsOrderBy>;
  id?: InputMaybe<OrderBy>;
  idpCustomAttribute?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: idp_attribute_mappings */
export type IdpAttributeMappingsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "idp_attribute_mappings" */
export enum IdpAttributeMappingsSelectColumn {
  /** column name */
  CUSTOMFIELDID = 'customFieldId',
  /** column name */
  ID = 'id',
  /** column name */
  IDPCUSTOMATTRIBUTE = 'idpCustomAttribute'
}

/** input type for updating data in table "idp_attribute_mappings" */
export type IdpAttributeMappingsSetInput = {
  customFieldId?: InputMaybe<Scalars['uuid']['input']>;
  idpCustomAttribute?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "idp_attribute_mappings" */
export type IdpAttributeMappingsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: IdpAttributeMappingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type IdpAttributeMappingsStreamCursorValueInput = {
  customFieldId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idpCustomAttribute?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "idp_attribute_mappings" */
export enum IdpAttributeMappingsUpdateColumn {
  /** column name */
  CUSTOMFIELDID = 'customFieldId',
  /** column name */
  IDPCUSTOMATTRIBUTE = 'idpCustomAttribute'
}

export type IdpAttributeMappingsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IdpAttributeMappingsSetInput>;
  /** filter the rows which have to be updated */
  where: IdpAttributeMappingsBoolExp;
};

/** Supplier contacts that are linked to an org user */
export type InternalContacts = {
  __typename?: 'internal_contacts';
  agreementId: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  engagement: Maybe<Engagements>;
  engagementId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  product: Maybe<OrganisationProductsAndServices>;
  productId: Maybe<Scalars['uuid']['output']>;
  role: Scalars['internalContactsRole']['output'];
  /** An object relationship */
  supplier: OrganisationSuppliers;
  supplierId: Scalars['uuid']['output'];
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "internal_contacts" */
export type InternalContactsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<InternalContactsMaxOrderBy>;
  min?: InputMaybe<InternalContactsMinOrderBy>;
};

/** input type for inserting array relation for remote table "internal_contacts" */
export type InternalContactsArrRelInsertInput = {
  data: Array<InternalContactsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<InternalContactsOnConflict>;
};

/** Boolean expression to filter rows from the table "internal_contacts". All fields are combined with a logical 'AND'. */
export type InternalContactsBoolExp = {
  _and?: InputMaybe<Array<InternalContactsBoolExp>>;
  _not?: InputMaybe<InternalContactsBoolExp>;
  _or?: InputMaybe<Array<InternalContactsBoolExp>>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  engagement?: InputMaybe<EngagementsBoolExp>;
  engagementId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  product?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  productId?: InputMaybe<UuidComparisonExp>;
  role?: InputMaybe<StringComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "internal_contacts" */
export enum InternalContactsConstraint {
  /** unique or primary key constraint on columns "id" */
  INTERNAL_CONTACTS_PKEY = 'internal_contacts_pkey'
}

/** input type for inserting data into table "internal_contacts" */
export type InternalContactsInsertInput = {
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  engagement?: InputMaybe<EngagementsObjRelInsertInput>;
  engagementId?: InputMaybe<Scalars['uuid']['input']>;
  product?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
  productId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "internal_contacts" */
export type InternalContactsMaxOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  engagementId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  productId?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "internal_contacts" */
export type InternalContactsMinOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  engagementId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  productId?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "internal_contacts" */
export type InternalContactsMutationResponse = {
  __typename?: 'internal_contacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<InternalContacts>;
};

/** on_conflict condition type for table "internal_contacts" */
export type InternalContactsOnConflict = {
  constraint: InternalContactsConstraint;
  update_columns: Array<InternalContactsUpdateColumn>;
  where?: InputMaybe<InternalContactsBoolExp>;
};

/** Ordering options when selecting data from "internal_contacts". */
export type InternalContactsOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  engagement?: InputMaybe<EngagementsOrderBy>;
  engagementId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  product?: InputMaybe<OrganisationProductsAndServicesOrderBy>;
  productId?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: internal_contacts */
export type InternalContactsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "internal_contacts" */
export enum InternalContactsSelectColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  ENGAGEMENTID = 'engagementId',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATION_ID = 'organisation_id',
  /** column name */
  PRODUCTID = 'productId',
  /** column name */
  ROLE = 'role',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "internal_contacts" */
export type InternalContactsSetInput = {
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  engagementId?: InputMaybe<Scalars['uuid']['input']>;
  productId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "internal_contacts" */
export enum InternalContactsUpdateColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  ENGAGEMENTID = 'engagementId',
  /** column name */
  PRODUCTID = 'productId',
  /** column name */
  ROLE = 'role',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  TITLE = 'title',
  /** column name */
  USERID = 'userId'
}

export type InternalContactsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InternalContactsSetInput>;
  /** filter the rows which have to be updated */
  where: InternalContactsBoolExp;
};

/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type IntervalComparisonExp = {
  _eq?: InputMaybe<Scalars['interval']['input']>;
  _gt?: InputMaybe<Scalars['interval']['input']>;
  _gte?: InputMaybe<Scalars['interval']['input']>;
  _in?: InputMaybe<Array<Scalars['interval']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['interval']['input']>;
  _lte?: InputMaybe<Scalars['interval']['input']>;
  _neq?: InputMaybe<Scalars['interval']['input']>;
  _nin?: InputMaybe<Array<Scalars['interval']['input']>>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "latest_request_form_submissions" */
export type LatestRequestFormSubmissions = {
  __typename?: 'latest_request_form_submissions';
  detectedLanguage: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Maybe<Organisations>;
  organisationId: Scalars['uuid']['output'];
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  request_form: Maybe<RequestForms>;
  /** An object relationship */
  request_form_submission_ai_summary: Maybe<RequestFormSubmissionAiSummary>;
  /** An object relationship */
  request_step_task: Maybe<RequestStepTasks>;
  response: Scalars['jsonb']['output'];
  timestamp: Scalars['timestamptz']['output'];
  /** An array relationship */
  translations: Array<RequestFormSubmissionTranslations>;
  /** An aggregate relationship */
  translations_aggregate: RequestFormSubmissionTranslationsAggregate;
  /** An object relationship */
  user: Maybe<Users>;
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "latest_request_form_submissions" */
export type LatestRequestFormSubmissionsResponseArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "latest_request_form_submissions" */
export type LatestRequestFormSubmissionsTranslationsArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionTranslationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionTranslationsOrderBy>>;
  where: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
};


/** columns and relationships of "latest_request_form_submissions" */
export type LatestRequestFormSubmissionsTranslationsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionTranslationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionTranslationsOrderBy>>;
  where: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
};

export type LatestRequestFormSubmissionsAggregate = {
  __typename?: 'latest_request_form_submissions_aggregate';
  aggregate: Maybe<LatestRequestFormSubmissionsAggregateFields>;
  nodes: Array<LatestRequestFormSubmissions>;
};

/** aggregate fields of "latest_request_form_submissions" */
export type LatestRequestFormSubmissionsAggregateFields = {
  __typename?: 'latest_request_form_submissions_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<LatestRequestFormSubmissionsMaxFields>;
  min: Maybe<LatestRequestFormSubmissionsMinFields>;
};


/** aggregate fields of "latest_request_form_submissions" */
export type LatestRequestFormSubmissionsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<LatestRequestFormSubmissionsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "latest_request_form_submissions". All fields are combined with a logical 'AND'. */
export type LatestRequestFormSubmissionsBoolExp = {
  _and?: InputMaybe<Array<LatestRequestFormSubmissionsBoolExp>>;
  _not?: InputMaybe<LatestRequestFormSubmissionsBoolExp>;
  _or?: InputMaybe<Array<LatestRequestFormSubmissionsBoolExp>>;
  detectedLanguage?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestFormId?: InputMaybe<UuidComparisonExp>;
  requestStepTaskId?: InputMaybe<UuidComparisonExp>;
  request_form?: InputMaybe<RequestFormsBoolExp>;
  request_form_submission_ai_summary?: InputMaybe<RequestFormSubmissionAiSummaryBoolExp>;
  request_step_task?: InputMaybe<RequestStepTasksBoolExp>;
  response?: InputMaybe<JsonbComparisonExp>;
  timestamp?: InputMaybe<TimestamptzComparisonExp>;
  translations?: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
  translations_aggregate?: InputMaybe<RequestFormSubmissionTranslationsAggregateBoolExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** aggregate max on columns */
export type LatestRequestFormSubmissionsMaxFields = {
  __typename?: 'latest_request_form_submissions_max_fields';
  detectedLanguage: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  timestamp: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type LatestRequestFormSubmissionsMinFields = {
  __typename?: 'latest_request_form_submissions_min_fields';
  detectedLanguage: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  timestamp: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "latest_request_form_submissions". */
export type LatestRequestFormSubmissionsOrderBy = {
  detectedLanguage?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  request_form?: InputMaybe<RequestFormsOrderBy>;
  request_form_submission_ai_summary?: InputMaybe<RequestFormSubmissionAiSummaryOrderBy>;
  request_step_task?: InputMaybe<RequestStepTasksOrderBy>;
  response?: InputMaybe<OrderBy>;
  timestamp?: InputMaybe<OrderBy>;
  translations_aggregate?: InputMaybe<RequestFormSubmissionTranslationsAggregateOrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "latest_request_form_submissions" */
export enum LatestRequestFormSubmissionsSelectColumn {
  /** column name */
  DETECTEDLANGUAGE = 'detectedLanguage',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  RESPONSE = 'response',
  /** column name */
  TIMESTAMP = 'timestamp',
  /** column name */
  USERID = 'userId'
}

/** columns and relationships of "line_item_types" */
export type LineItemTypes = {
  __typename?: 'line_item_types';
  archivedBy: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "line_item_types" */
export type LineItemTypesAggregate = {
  __typename?: 'line_item_types_aggregate';
  aggregate: Maybe<LineItemTypesAggregateFields>;
  nodes: Array<LineItemTypes>;
};

/** aggregate fields of "line_item_types" */
export type LineItemTypesAggregateFields = {
  __typename?: 'line_item_types_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<LineItemTypesMaxFields>;
  min: Maybe<LineItemTypesMinFields>;
};


/** aggregate fields of "line_item_types" */
export type LineItemTypesAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<LineItemTypesSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "line_item_types". All fields are combined with a logical 'AND'. */
export type LineItemTypesBoolExp = {
  _and?: InputMaybe<Array<LineItemTypesBoolExp>>;
  _not?: InputMaybe<LineItemTypesBoolExp>;
  _or?: InputMaybe<Array<LineItemTypesBoolExp>>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "line_item_types" */
export enum LineItemTypesConstraint {
  /** unique or primary key constraint on columns "id" */
  LINE_ITEM_TYPES_PKEY = 'line_item_types_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  LINE_ITEM_TYPES_REMOTE_ID_ORGANISATION_ID_KEY = 'line_item_types_remote_id_organisation_id_key'
}

/** input type for inserting data into table "line_item_types" */
export type LineItemTypesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type LineItemTypesMaxFields = {
  __typename?: 'line_item_types_max_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type LineItemTypesMinFields = {
  __typename?: 'line_item_types_min_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "line_item_types" */
export type LineItemTypesMutationResponse = {
  __typename?: 'line_item_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<LineItemTypes>;
};

/** input type for inserting object relation for remote table "line_item_types" */
export type LineItemTypesObjRelInsertInput = {
  data: LineItemTypesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<LineItemTypesOnConflict>;
};

/** on_conflict condition type for table "line_item_types" */
export type LineItemTypesOnConflict = {
  constraint: LineItemTypesConstraint;
  update_columns: Array<LineItemTypesUpdateColumn>;
  where?: InputMaybe<LineItemTypesBoolExp>;
};

/** Ordering options when selecting data from "line_item_types". */
export type LineItemTypesOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  coreData?: InputMaybe<CoreDataOrderBy>;
  coreDataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: line_item_types */
export type LineItemTypesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "line_item_types" */
export enum LineItemTypesSelectColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  COREDATAID = 'coreDataId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "line_item_types" */
export type LineItemTypesSetInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "line_item_types" */
export enum LineItemTypesUpdateColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type LineItemTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LineItemTypesSetInput>;
  /** filter the rows which have to be updated */
  where: LineItemTypesBoolExp;
};

/** Boolean expression to compare columns of type "ltree". All fields are combined with logical 'AND'. */
export type LtreeComparisonExp = {
  /** is the left argument an ancestor of right (or equal)? */
  _ancestor?: InputMaybe<Scalars['ltree']['input']>;
  /** does array contain an ancestor of `ltree`? */
  _ancestor_any?: InputMaybe<Array<Scalars['ltree']['input']>>;
  /** is the left argument a descendant of right (or equal)? */
  _descendant?: InputMaybe<Scalars['ltree']['input']>;
  /** does array contain a descendant of `ltree`? */
  _descendant_any?: InputMaybe<Array<Scalars['ltree']['input']>>;
  _eq?: InputMaybe<Scalars['ltree']['input']>;
  _gt?: InputMaybe<Scalars['ltree']['input']>;
  _gte?: InputMaybe<Scalars['ltree']['input']>;
  _in?: InputMaybe<Array<Scalars['ltree']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['ltree']['input']>;
  _lte?: InputMaybe<Scalars['ltree']['input']>;
  /** does `ltree` match `lquery`? */
  _matches?: InputMaybe<Scalars['lquery']['input']>;
  /** does `ltree` match any `lquery` in array? */
  _matches_any?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does `ltree` match `ltxtquery`? */
  _matches_fulltext?: InputMaybe<Scalars['ltxtquery']['input']>;
  _neq?: InputMaybe<Scalars['ltree']['input']>;
  _nin?: InputMaybe<Array<Scalars['ltree']['input']>>;
};

/** mutation root */
export type MutationRoot = {
  __typename?: 'mutation_root';
  /** delete data from the table: "addresses" */
  delete_addresses: Maybe<AddressesMutationResponse>;
  /** delete single row from the table: "addresses" */
  delete_addresses_by_pk: Maybe<Addresses>;
  /** delete data from the table: "agreement_additional_owners" */
  delete_agreement_additional_owners: Maybe<AgreementAdditionalOwnersMutationResponse>;
  /** delete single row from the table: "agreement_additional_owners" */
  delete_agreement_additional_owners_by_pk: Maybe<AgreementAdditionalOwners>;
  /** delete data from the table: "agreement_documents" */
  delete_agreement_documents: Maybe<AgreementDocumentsMutationResponse>;
  /** delete single row from the table: "agreement_documents" */
  delete_agreement_documents_by_pk: Maybe<AgreementDocuments>;
  /** delete data from the table: "agreement_tags" */
  delete_agreement_tags: Maybe<AgreementTagsMutationResponse>;
  /** delete single row from the table: "agreement_tags" */
  delete_agreement_tags_by_pk: Maybe<AgreementTags>;
  /** delete data from the table: "assessment_additional_groups" */
  delete_assessment_additional_groups: Maybe<AssessmentAdditionalGroupsMutationResponse>;
  /** delete single row from the table: "assessment_additional_groups" */
  delete_assessment_additional_groups_by_pk: Maybe<AssessmentAdditionalGroups>;
  /** delete data from the table: "assessment_additional_users" */
  delete_assessment_additional_users: Maybe<AssessmentAdditionalUsersMutationResponse>;
  /** delete single row from the table: "assessment_additional_users" */
  delete_assessment_additional_users_by_pk: Maybe<AssessmentAdditionalUsers>;
  /** delete data from the table: "assessment_tags" */
  delete_assessment_tags: Maybe<AssessmentTagsMutationResponse>;
  /** delete single row from the table: "assessment_tags" */
  delete_assessment_tags_by_pk: Maybe<AssessmentTags>;
  /** delete data from the table: "auth_refresh_tokens" */
  delete_auth_refresh_tokens: Maybe<AuthRefreshTokensMutationResponse>;
  /** delete single row from the table: "auth_refresh_tokens" */
  delete_auth_refresh_tokens_by_pk: Maybe<AuthRefreshTokens>;
  /** delete data from the table: "budget_approval_group_assignees" */
  delete_budget_approval_group_assignees: Maybe<BudgetApprovalGroupAssigneesMutationResponse>;
  /** delete data from the table: "budget_approval_group_assignees_assignees" */
  delete_budget_approval_group_assignees_assignees: Maybe<BudgetApprovalGroupAssigneesAssigneesMutationResponse>;
  /** delete single row from the table: "budget_approval_group_assignees_assignees" */
  delete_budget_approval_group_assignees_assignees_by_pk: Maybe<BudgetApprovalGroupAssigneesAssignees>;
  /** delete single row from the table: "budget_approval_group_assignees" */
  delete_budget_approval_group_assignees_by_pk: Maybe<BudgetApprovalGroupAssignees>;
  /** delete data from the table: "budget_approval_group_assignees_custom_core_data_options" */
  delete_budget_approval_group_assignees_custom_core_data_options: Maybe<BudgetApprovalGroupAssigneesCustomCoreDataOptionsMutationResponse>;
  /** delete single row from the table: "budget_approval_group_assignees_custom_core_data_options" */
  delete_budget_approval_group_assignees_custom_core_data_options_by_pk: Maybe<BudgetApprovalGroupAssigneesCustomCoreDataOptions>;
  /** delete data from the table: "budget_approval_group_selected_custom_core_data" */
  delete_budget_approval_group_selected_custom_core_data: Maybe<BudgetApprovalGroupSelectedCustomCoreDataMutationResponse>;
  /** delete single row from the table: "budget_approval_group_selected_custom_core_data" */
  delete_budget_approval_group_selected_custom_core_data_by_pk: Maybe<BudgetApprovalGroupSelectedCustomCoreData>;
  /** delete data from the table: "budget_approval_threshold_department" */
  delete_budget_approval_threshold_department: Maybe<BudgetApprovalThresholdDepartmentMutationResponse>;
  /** delete single row from the table: "budget_approval_threshold_department" */
  delete_budget_approval_threshold_department_by_pk: Maybe<BudgetApprovalThresholdDepartment>;
  /** delete data from the table: "budget_approval_threshold_group" */
  delete_budget_approval_threshold_group: Maybe<BudgetApprovalThresholdGroupMutationResponse>;
  /** delete single row from the table: "budget_approval_threshold_group" */
  delete_budget_approval_threshold_group_by_pk: Maybe<BudgetApprovalThresholdGroup>;
  /** delete data from the table: "config_translations" */
  delete_config_translations: Maybe<ConfigTranslationsMutationResponse>;
  /** delete single row from the table: "config_translations" */
  delete_config_translations_by_pk: Maybe<ConfigTranslations>;
  /** delete data from the table: "core_data_dependencies" */
  delete_core_data_dependencies: Maybe<CoreDataDependenciesMutationResponse>;
  /** delete single row from the table: "core_data_dependencies" */
  delete_core_data_dependencies_by_pk: Maybe<CoreDataDependencies>;
  /** delete data from the table: "core_data_external_references" */
  delete_core_data_external_references: Maybe<CoreDataExternalReferencesMutationResponse>;
  /** delete single row from the table: "core_data_external_references" */
  delete_core_data_external_references_by_pk: Maybe<CoreDataExternalReferences>;
  /** delete data from the table: "core_data_organisation_integrations" */
  delete_core_data_organisation_integrations: Maybe<CoreDataOrganisationIntegrationsMutationResponse>;
  /** delete single row from the table: "core_data_organisation_integrations" */
  delete_core_data_organisation_integrations_by_pk: Maybe<CoreDataOrganisationIntegrations>;
  /** delete data from the table: "custom_core_data" */
  delete_custom_core_data: Maybe<CustomCoreDataMutationResponse>;
  /** delete single row from the table: "custom_core_data" */
  delete_custom_core_data_by_pk: Maybe<CustomCoreData>;
  /** delete data from the table: "custom_core_data_options" */
  delete_custom_core_data_options: Maybe<CustomCoreDataOptionsMutationResponse>;
  /** delete single row from the table: "custom_core_data_options" */
  delete_custom_core_data_options_by_pk: Maybe<CustomCoreDataOptions>;
  /** delete data from the table: "custom_field_choices" */
  delete_custom_field_choices: Maybe<CustomFieldChoicesMutationResponse>;
  /** delete single row from the table: "custom_field_choices" */
  delete_custom_field_choices_by_pk: Maybe<CustomFieldChoices>;
  /** delete data from the table: "custom_field_core_data" */
  delete_custom_field_core_data: Maybe<CustomFieldCoreDataMutationResponse>;
  /** delete single row from the table: "custom_field_core_data" */
  delete_custom_field_core_data_by_pk: Maybe<CustomFieldCoreData>;
  /** delete data from the table: "custom_field_values" */
  delete_custom_field_values: Maybe<CustomFieldValuesMutationResponse>;
  /** delete single row from the table: "custom_field_values" */
  delete_custom_field_values_by_pk: Maybe<CustomFieldValues>;
  /** delete data from the table: "departments" */
  delete_departments: Maybe<DepartmentsMutationResponse>;
  /** delete single row from the table: "departments" */
  delete_departments_by_pk: Maybe<Departments>;
  /** delete data from the table: "document_types" */
  delete_document_types: Maybe<DocumentTypesMutationResponse>;
  /** delete single row from the table: "document_types" */
  delete_document_types_by_pk: Maybe<DocumentTypes>;
  /** delete data from the table: "documents" */
  delete_documents: Maybe<DocumentsMutationResponse>;
  /** delete single row from the table: "documents" */
  delete_documents_by_pk: Maybe<Documents>;
  /** delete data from the table: "entity_bank_details" */
  delete_entity_bank_details: Maybe<EntityBankDetailsMutationResponse>;
  /** delete single row from the table: "entity_bank_details" */
  delete_entity_bank_details_by_pk: Maybe<EntityBankDetails>;
  /** delete data from the table: "entity_field_group_fields" */
  delete_entity_field_group_fields: Maybe<EntityFieldGroupFieldsMutationResponse>;
  /** delete single row from the table: "entity_field_group_fields" */
  delete_entity_field_group_fields_by_pk: Maybe<EntityFieldGroupFields>;
  /** delete data from the table: "entity_field_groups" */
  delete_entity_field_groups: Maybe<EntityFieldGroupsMutationResponse>;
  /** delete single row from the table: "entity_field_groups" */
  delete_entity_field_groups_by_pk: Maybe<EntityFieldGroups>;
  /** delete data from the table: "external_contacts" */
  delete_external_contacts: Maybe<ExternalContactsMutationResponse>;
  /** delete single row from the table: "external_contacts" */
  delete_external_contacts_by_pk: Maybe<ExternalContacts>;
  /** delete data from the table: "external_risk_scores" */
  delete_external_risk_scores: Maybe<ExternalRiskScoresMutationResponse>;
  /** delete single row from the table: "external_risk_scores" */
  delete_external_risk_scores_by_pk: Maybe<ExternalRiskScores>;
  /** delete data from the table: "favourite_table_filters" */
  delete_favourite_table_filters: Maybe<FavouriteTableFiltersMutationResponse>;
  /** delete single row from the table: "favourite_table_filters" */
  delete_favourite_table_filters_by_pk: Maybe<FavouriteTableFilters>;
  /** delete data from the table: "form_template_question_insights" */
  delete_form_template_question_insights: Maybe<FormTemplateQuestionInsightsMutationResponse>;
  /** delete single row from the table: "form_template_question_insights" */
  delete_form_template_question_insights_by_pk: Maybe<FormTemplateQuestionInsights>;
  /** delete data from the table: "group_users" */
  delete_group_users: Maybe<GroupUsersMutationResponse>;
  /** delete single row from the table: "group_users" */
  delete_group_users_by_pk: Maybe<GroupUsers>;
  /** delete data from the table: "idp_attribute_mappings" */
  delete_idp_attribute_mappings: Maybe<IdpAttributeMappingsMutationResponse>;
  /** delete single row from the table: "idp_attribute_mappings" */
  delete_idp_attribute_mappings_by_pk: Maybe<IdpAttributeMappings>;
  /** delete data from the table: "internal_contacts" */
  delete_internal_contacts: Maybe<InternalContactsMutationResponse>;
  /** delete single row from the table: "internal_contacts" */
  delete_internal_contacts_by_pk: Maybe<InternalContacts>;
  /** delete data from the table: "line_item_types" */
  delete_line_item_types: Maybe<LineItemTypesMutationResponse>;
  /** delete single row from the table: "line_item_types" */
  delete_line_item_types_by_pk: Maybe<LineItemTypes>;
  /** delete data from the table: "organisation_feature_flags" */
  delete_organisation_feature_flags: Maybe<OrganisationFeatureFlagsMutationResponse>;
  /** delete data from the table: "organisation_fx_rates" */
  delete_organisation_fx_rates: Maybe<OrganisationFxRatesMutationResponse>;
  /** delete single row from the table: "organisation_fx_rates" */
  delete_organisation_fx_rates_by_pk: Maybe<OrganisationFxRates>;
  /** delete data from the table: "organisation_integration_operations" */
  delete_organisation_integration_operations: Maybe<OrganisationIntegrationOperationsMutationResponse>;
  /** delete single row from the table: "organisation_integration_operations" */
  delete_organisation_integration_operations_by_pk: Maybe<OrganisationIntegrationOperations>;
  /** delete data from the table: "organisation_integrations" */
  delete_organisation_integrations: Maybe<OrganisationIntegrationsMutationResponse>;
  /** delete single row from the table: "organisation_integrations" */
  delete_organisation_integrations_by_pk: Maybe<OrganisationIntegrations>;
  /** delete data from the table: "organisation_product_supplier_categories" */
  delete_organisation_product_supplier_categories: Maybe<OrganisationProductSupplierCategoriesMutationResponse>;
  /** delete single row from the table: "organisation_product_supplier_categories" */
  delete_organisation_product_supplier_categories_by_pk: Maybe<OrganisationProductSupplierCategories>;
  /** delete data from the table: "organisation_products_and_services_categories" */
  delete_organisation_products_and_services_categories: Maybe<OrganisationProductsAndServicesCategoriesMutationResponse>;
  /** delete single row from the table: "organisation_products_and_services_categories" */
  delete_organisation_products_and_services_categories_by_pk: Maybe<OrganisationProductsAndServicesCategories>;
  /** delete data from the table: "organisation_supplier_historic_submissions" */
  delete_organisation_supplier_historic_submissions: Maybe<OrganisationSupplierHistoricSubmissionsMutationResponse>;
  /** delete single row from the table: "organisation_supplier_historic_submissions" */
  delete_organisation_supplier_historic_submissions_by_pk: Maybe<OrganisationSupplierHistoricSubmissions>;
  /** delete data from the table: "organisation_supplier_profile_resources" */
  delete_organisation_supplier_profile_resources: Maybe<OrganisationSupplierProfileResourcesMutationResponse>;
  /** delete single row from the table: "organisation_supplier_profile_resources" */
  delete_organisation_supplier_profile_resources_by_pk: Maybe<OrganisationSupplierProfileResources>;
  /** delete data from the table: "organisation_supplier_profiles" */
  delete_organisation_supplier_profiles: Maybe<OrganisationSupplierProfilesMutationResponse>;
  /** delete single row from the table: "organisation_supplier_profiles" */
  delete_organisation_supplier_profiles_by_pk: Maybe<OrganisationSupplierProfiles>;
  /** delete data from the table: "organisation_supplier_tags" */
  delete_organisation_supplier_tags: Maybe<OrganisationSupplierTagsMutationResponse>;
  /** delete single row from the table: "organisation_supplier_tags" */
  delete_organisation_supplier_tags_by_pk: Maybe<OrganisationSupplierTags>;
  /** delete data from the table: "organisation_suppliers_categories" */
  delete_organisation_suppliers_categories: Maybe<OrganisationSuppliersCategoriesMutationResponse>;
  /** delete single row from the table: "organisation_suppliers_categories" */
  delete_organisation_suppliers_categories_by_pk: Maybe<OrganisationSuppliersCategories>;
  /** delete data from the table: "out_of_office_delegations" */
  delete_out_of_office_delegations: Maybe<OutOfOfficeDelegationsMutationResponse>;
  /** delete single row from the table: "out_of_office_delegations" */
  delete_out_of_office_delegations_by_pk: Maybe<OutOfOfficeDelegations>;
  /** delete data from the table: "payment_methods" */
  delete_payment_methods: Maybe<PaymentMethodsMutationResponse>;
  /** delete single row from the table: "payment_methods" */
  delete_payment_methods_by_pk: Maybe<PaymentMethods>;
  /** delete data from the table: "payment_terms" */
  delete_payment_terms: Maybe<PaymentTermsMutationResponse>;
  /** delete single row from the table: "payment_terms" */
  delete_payment_terms_by_pk: Maybe<PaymentTerms>;
  /** delete data from the table: "product_catalogue_access_approvers" */
  delete_product_catalogue_access_approvers: Maybe<ProductCatalogueAccessApproversMutationResponse>;
  /** delete single row from the table: "product_catalogue_access_approvers" */
  delete_product_catalogue_access_approvers_by_pk: Maybe<ProductCatalogueAccessApprovers>;
  /** delete data from the table: "renewal_additional_users" */
  delete_renewal_additional_users: Maybe<RenewalAdditionalUsersMutationResponse>;
  /** delete single row from the table: "renewal_additional_users" */
  delete_renewal_additional_users_by_pk: Maybe<RenewalAdditionalUsers>;
  /** delete data from the table: "renewal_tags" */
  delete_renewal_tags: Maybe<RenewalTagsMutationResponse>;
  /** delete single row from the table: "renewal_tags" */
  delete_renewal_tags_by_pk: Maybe<RenewalTags>;
  /** delete data from the table: "request_comments_mentions" */
  delete_request_comments_mentions: Maybe<RequestCommentsMentionsMutationResponse>;
  /** delete single row from the table: "request_comments_mentions" */
  delete_request_comments_mentions_by_pk: Maybe<RequestCommentsMentions>;
  /** delete data from the table: "request_documents" */
  delete_request_documents: Maybe<RequestDocumentsMutationResponse>;
  /** delete single row from the table: "request_documents" */
  delete_request_documents_by_pk: Maybe<RequestDocuments>;
  /** delete data from the table: "request_form_question_ai_score" */
  delete_request_form_question_ai_score: Maybe<RequestFormQuestionAiScoreMutationResponse>;
  /** delete single row from the table: "request_form_question_ai_score" */
  delete_request_form_question_ai_score_by_pk: Maybe<RequestFormQuestionAiScore>;
  /** delete data from the table: "request_form_question_score" */
  delete_request_form_question_score: Maybe<RequestFormQuestionScoreMutationResponse>;
  /** delete single row from the table: "request_form_question_score" */
  delete_request_form_question_score_by_pk: Maybe<RequestFormQuestionScore>;
  /** delete data from the table: "request_form_template_reviewers" */
  delete_request_form_template_reviewers: Maybe<RequestFormTemplateReviewersMutationResponse>;
  /** delete single row from the table: "request_form_template_reviewers" */
  delete_request_form_template_reviewers_by_pk: Maybe<RequestFormTemplateReviewers>;
  /** delete data from the table: "request_form_templates" */
  delete_request_form_templates: Maybe<RequestFormTemplatesMutationResponse>;
  /** delete single row from the table: "request_form_templates" */
  delete_request_form_templates_by_pk: Maybe<RequestFormTemplates>;
  /** delete data from the table: "request_leads_config" */
  delete_request_leads_config: Maybe<RequestLeadsConfigMutationResponse>;
  /** delete single row from the table: "request_leads_config" */
  delete_request_leads_config_by_pk: Maybe<RequestLeadsConfig>;
  /** delete data from the table: "request_request_leads" */
  delete_request_request_leads: Maybe<RequestRequestLeadsMutationResponse>;
  /** delete single row from the table: "request_request_leads" */
  delete_request_request_leads_by_pk: Maybe<RequestRequestLeads>;
  /** delete data from the table: "request_step_groups" */
  delete_request_step_groups: Maybe<RequestStepGroupsMutationResponse>;
  /** delete single row from the table: "request_step_groups" */
  delete_request_step_groups_by_pk: Maybe<RequestStepGroups>;
  /** delete data from the table: "request_step_task_errors" */
  delete_request_step_task_errors: Maybe<RequestStepTaskErrorsMutationResponse>;
  /** delete single row from the table: "request_step_task_errors" */
  delete_request_step_task_errors_by_pk: Maybe<RequestStepTaskErrors>;
  /** delete data from the table: "request_step_task_rejections" */
  delete_request_step_task_rejections: Maybe<RequestStepTaskRejectionsMutationResponse>;
  /** delete single row from the table: "request_step_task_rejections" */
  delete_request_step_task_rejections_by_pk: Maybe<RequestStepTaskRejections>;
  /** delete data from the table: "request_step_task_users" */
  delete_request_step_task_users: Maybe<RequestStepTaskUsersMutationResponse>;
  /** delete single row from the table: "request_step_task_users" */
  delete_request_step_task_users_by_pk: Maybe<RequestStepTaskUsers>;
  /** delete data from the table: "request_step_tasks" */
  delete_request_step_tasks: Maybe<RequestStepTasksMutationResponse>;
  /** delete single row from the table: "request_step_tasks" */
  delete_request_step_tasks_by_pk: Maybe<RequestStepTasks>;
  /** delete data from the table: "request_step_users" */
  delete_request_step_users: Maybe<RequestStepUsersMutationResponse>;
  /** delete single row from the table: "request_step_users" */
  delete_request_step_users_by_pk: Maybe<RequestStepUsers>;
  /** delete data from the table: "request_steps" */
  delete_request_steps: Maybe<RequestStepsMutationResponse>;
  /** delete single row from the table: "request_steps" */
  delete_request_steps_by_pk: Maybe<RequestSteps>;
  /** delete data from the table: "request_tags" */
  delete_request_tags: Maybe<RequestTagsMutationResponse>;
  /** delete single row from the table: "request_tags" */
  delete_request_tags_by_pk: Maybe<RequestTags>;
  /** delete data from the table: "rfx" */
  delete_rfx: Maybe<RfxMutationResponse>;
  /** delete single row from the table: "rfx" */
  delete_rfx_by_pk: Maybe<Rfx>;
  /** delete data from the table: "rfx_external_users" */
  delete_rfx_external_users: Maybe<RfxExternalUsersMutationResponse>;
  /** delete single row from the table: "rfx_external_users" */
  delete_rfx_external_users_by_pk: Maybe<RfxExternalUsers>;
  /** delete data from the table: "rfx_owners" */
  delete_rfx_owners: Maybe<RfxOwnersMutationResponse>;
  /** delete single row from the table: "rfx_owners" */
  delete_rfx_owners_by_pk: Maybe<RfxOwners>;
  /** delete data from the table: "rfx_suppliers" */
  delete_rfx_suppliers: Maybe<RfxSuppliersMutationResponse>;
  /** delete single row from the table: "rfx_suppliers" */
  delete_rfx_suppliers_by_pk: Maybe<RfxSuppliers>;
  /** delete data from the table: "risk_attributes" */
  delete_risk_attributes: Maybe<RiskAttributesMutationResponse>;
  /** delete single row from the table: "risk_attributes" */
  delete_risk_attributes_by_pk: Maybe<RiskAttributes>;
  /** delete data from the table: "risk_categories" */
  delete_risk_categories: Maybe<RiskCategoriesMutationResponse>;
  /** delete single row from the table: "risk_categories" */
  delete_risk_categories_by_pk: Maybe<RiskCategories>;
  /** delete data from the table: "risk_levels" */
  delete_risk_levels: Maybe<RiskLevelsMutationResponse>;
  /** delete single row from the table: "risk_levels" */
  delete_risk_levels_by_pk: Maybe<RiskLevels>;
  /** delete data from the table: "risk_matrix_cells" */
  delete_risk_matrix_cells: Maybe<RiskMatrixCellsMutationResponse>;
  /** delete single row from the table: "risk_matrix_cells" */
  delete_risk_matrix_cells_by_pk: Maybe<RiskMatrixCells>;
  /** delete data from the table: "risk_owners" */
  delete_risk_owners: Maybe<RiskOwnersMutationResponse>;
  /** delete single row from the table: "risk_owners" */
  delete_risk_owners_by_pk: Maybe<RiskOwners>;
  /** delete data from the table: "risk_template_categories" */
  delete_risk_template_categories: Maybe<RiskTemplateCategoriesMutationResponse>;
  /** delete single row from the table: "risk_template_categories" */
  delete_risk_template_categories_by_pk: Maybe<RiskTemplateCategories>;
  /** delete data from the table: "risk_template_owners" */
  delete_risk_template_owners: Maybe<RiskTemplateOwnersMutationResponse>;
  /** delete single row from the table: "risk_template_owners" */
  delete_risk_template_owners_by_pk: Maybe<RiskTemplateOwners>;
  /** delete data from the table: "subsidiaries" */
  delete_subsidiaries: Maybe<SubsidiariesMutationResponse>;
  /** delete single row from the table: "subsidiaries" */
  delete_subsidiaries_by_pk: Maybe<Subsidiaries>;
  /** delete data from the table: "user_allowed_subsidiaries" */
  delete_user_allowed_subsidiaries: Maybe<UserAllowedSubsidiariesMutationResponse>;
  /** delete single row from the table: "user_allowed_subsidiaries" */
  delete_user_allowed_subsidiaries_by_pk: Maybe<UserAllowedSubsidiaries>;
  /** delete data from the table: "users" */
  delete_users: Maybe<UsersMutationResponse>;
  /** delete single row from the table: "users" */
  delete_users_by_pk: Maybe<Users>;
  /** delete data from the table: "workflow_form_templates" */
  delete_workflow_form_templates: Maybe<WorkflowFormTemplatesMutationResponse>;
  /** delete single row from the table: "workflow_form_templates" */
  delete_workflow_form_templates_by_pk: Maybe<WorkflowFormTemplates>;
  /** insert data into the table: "addresses" */
  insert_addresses: Maybe<AddressesMutationResponse>;
  /** insert a single row into the table: "addresses" */
  insert_addresses_one: Maybe<Addresses>;
  /** insert data into the table: "agreement_additional_owners" */
  insert_agreement_additional_owners: Maybe<AgreementAdditionalOwnersMutationResponse>;
  /** insert a single row into the table: "agreement_additional_owners" */
  insert_agreement_additional_owners_one: Maybe<AgreementAdditionalOwners>;
  /** insert data into the table: "agreement_documents" */
  insert_agreement_documents: Maybe<AgreementDocumentsMutationResponse>;
  /** insert a single row into the table: "agreement_documents" */
  insert_agreement_documents_one: Maybe<AgreementDocuments>;
  /** insert data into the table: "agreement_tags" */
  insert_agreement_tags: Maybe<AgreementTagsMutationResponse>;
  /** insert a single row into the table: "agreement_tags" */
  insert_agreement_tags_one: Maybe<AgreementTags>;
  /** insert data into the table: "agreement_term_products" */
  insert_agreement_term_products: Maybe<AgreementTermProductsMutationResponse>;
  /** insert a single row into the table: "agreement_term_products" */
  insert_agreement_term_products_one: Maybe<AgreementTermProducts>;
  /** insert data into the table: "agreement_term_revisions" */
  insert_agreement_term_revisions: Maybe<AgreementTermRevisionsMutationResponse>;
  /** insert a single row into the table: "agreement_term_revisions" */
  insert_agreement_term_revisions_one: Maybe<AgreementTermRevisions>;
  /** insert data into the table: "agreement_term_spend_items" */
  insert_agreement_term_spend_items: Maybe<AgreementTermSpendItemsMutationResponse>;
  /** insert a single row into the table: "agreement_term_spend_items" */
  insert_agreement_term_spend_items_one: Maybe<AgreementTermSpendItems>;
  /** insert data into the table: "agreement_terms" */
  insert_agreement_terms: Maybe<AgreementTermsMutationResponse>;
  /** insert a single row into the table: "agreement_terms" */
  insert_agreement_terms_one: Maybe<AgreementTerms>;
  /** insert data into the table: "agreements" */
  insert_agreements: Maybe<AgreementsMutationResponse>;
  /** insert a single row into the table: "agreements" */
  insert_agreements_one: Maybe<Agreements>;
  /** insert data into the table: "assessment_additional_groups" */
  insert_assessment_additional_groups: Maybe<AssessmentAdditionalGroupsMutationResponse>;
  /** insert a single row into the table: "assessment_additional_groups" */
  insert_assessment_additional_groups_one: Maybe<AssessmentAdditionalGroups>;
  /** insert data into the table: "assessment_additional_users" */
  insert_assessment_additional_users: Maybe<AssessmentAdditionalUsersMutationResponse>;
  /** insert a single row into the table: "assessment_additional_users" */
  insert_assessment_additional_users_one: Maybe<AssessmentAdditionalUsers>;
  /** insert data into the table: "assessment_tags" */
  insert_assessment_tags: Maybe<AssessmentTagsMutationResponse>;
  /** insert a single row into the table: "assessment_tags" */
  insert_assessment_tags_one: Maybe<AssessmentTags>;
  /** insert data into the table: "assessments" */
  insert_assessments: Maybe<AssessmentsMutationResponse>;
  /** insert a single row into the table: "assessments" */
  insert_assessments_one: Maybe<Assessments>;
  /** insert data into the table: "auth_refresh_tokens" */
  insert_auth_refresh_tokens: Maybe<AuthRefreshTokensMutationResponse>;
  /** insert a single row into the table: "auth_refresh_tokens" */
  insert_auth_refresh_tokens_one: Maybe<AuthRefreshTokens>;
  /** insert data into the table: "auto_flagged_score_categories" */
  insert_auto_flagged_score_categories: Maybe<AutoFlaggedScoreCategoriesMutationResponse>;
  /** insert a single row into the table: "auto_flagged_score_categories" */
  insert_auto_flagged_score_categories_one: Maybe<AutoFlaggedScoreCategories>;
  /** insert data into the table: "bank_details" */
  insert_bank_details: Maybe<BankDetailsMutationResponse>;
  /** insert a single row into the table: "bank_details" */
  insert_bank_details_one: Maybe<BankDetails>;
  /** insert data into the table: "budget_approval_group" */
  insert_budget_approval_group: Maybe<BudgetApprovalGroupMutationResponse>;
  /** insert data into the table: "budget_approval_group_assignees" */
  insert_budget_approval_group_assignees: Maybe<BudgetApprovalGroupAssigneesMutationResponse>;
  /** insert data into the table: "budget_approval_group_assignees_assignees" */
  insert_budget_approval_group_assignees_assignees: Maybe<BudgetApprovalGroupAssigneesAssigneesMutationResponse>;
  /** insert a single row into the table: "budget_approval_group_assignees_assignees" */
  insert_budget_approval_group_assignees_assignees_one: Maybe<BudgetApprovalGroupAssigneesAssignees>;
  /** insert data into the table: "budget_approval_group_assignees_custom_core_data_options" */
  insert_budget_approval_group_assignees_custom_core_data_options: Maybe<BudgetApprovalGroupAssigneesCustomCoreDataOptionsMutationResponse>;
  /** insert a single row into the table: "budget_approval_group_assignees_custom_core_data_options" */
  insert_budget_approval_group_assignees_custom_core_data_options_one: Maybe<BudgetApprovalGroupAssigneesCustomCoreDataOptions>;
  /** insert a single row into the table: "budget_approval_group_assignees" */
  insert_budget_approval_group_assignees_one: Maybe<BudgetApprovalGroupAssignees>;
  /** insert a single row into the table: "budget_approval_group" */
  insert_budget_approval_group_one: Maybe<BudgetApprovalGroup>;
  /** insert data into the table: "budget_approval_group_selected_custom_core_data" */
  insert_budget_approval_group_selected_custom_core_data: Maybe<BudgetApprovalGroupSelectedCustomCoreDataMutationResponse>;
  /** insert a single row into the table: "budget_approval_group_selected_custom_core_data" */
  insert_budget_approval_group_selected_custom_core_data_one: Maybe<BudgetApprovalGroupSelectedCustomCoreData>;
  /** insert data into the table: "budget_approval_threshold" */
  insert_budget_approval_threshold: Maybe<BudgetApprovalThresholdMutationResponse>;
  /** insert data into the table: "budget_approval_threshold_department" */
  insert_budget_approval_threshold_department: Maybe<BudgetApprovalThresholdDepartmentMutationResponse>;
  /** insert a single row into the table: "budget_approval_threshold_department" */
  insert_budget_approval_threshold_department_one: Maybe<BudgetApprovalThresholdDepartment>;
  /** insert data into the table: "budget_approval_threshold_group" */
  insert_budget_approval_threshold_group: Maybe<BudgetApprovalThresholdGroupMutationResponse>;
  /** insert a single row into the table: "budget_approval_threshold_group" */
  insert_budget_approval_threshold_group_one: Maybe<BudgetApprovalThresholdGroup>;
  /** insert a single row into the table: "budget_approval_threshold" */
  insert_budget_approval_threshold_one: Maybe<BudgetApprovalThreshold>;
  /** insert data into the table: "budgets" */
  insert_budgets: Maybe<BudgetsMutationResponse>;
  /** insert a single row into the table: "budgets" */
  insert_budgets_one: Maybe<Budgets>;
  /** insert data into the table: "bulk_documents_uploads" */
  insert_bulk_documents_uploads: Maybe<BulkDocumentsUploadsMutationResponse>;
  /** insert a single row into the table: "bulk_documents_uploads" */
  insert_bulk_documents_uploads_one: Maybe<BulkDocumentsUploads>;
  /** insert data into the table: "config_translations" */
  insert_config_translations: Maybe<ConfigTranslationsMutationResponse>;
  /** insert a single row into the table: "config_translations" */
  insert_config_translations_one: Maybe<ConfigTranslations>;
  /** insert data into the table: "core_data_dependencies" */
  insert_core_data_dependencies: Maybe<CoreDataDependenciesMutationResponse>;
  /** insert a single row into the table: "core_data_dependencies" */
  insert_core_data_dependencies_one: Maybe<CoreDataDependencies>;
  /** insert data into the table: "core_data_external_references" */
  insert_core_data_external_references: Maybe<CoreDataExternalReferencesMutationResponse>;
  /** insert a single row into the table: "core_data_external_references" */
  insert_core_data_external_references_one: Maybe<CoreDataExternalReferences>;
  /** insert data into the table: "core_data_organisation_integrations" */
  insert_core_data_organisation_integrations: Maybe<CoreDataOrganisationIntegrationsMutationResponse>;
  /** insert a single row into the table: "core_data_organisation_integrations" */
  insert_core_data_organisation_integrations_one: Maybe<CoreDataOrganisationIntegrations>;
  /** insert data into the table: "custom_core_data" */
  insert_custom_core_data: Maybe<CustomCoreDataMutationResponse>;
  /** insert a single row into the table: "custom_core_data" */
  insert_custom_core_data_one: Maybe<CustomCoreData>;
  /** insert data into the table: "custom_core_data_options" */
  insert_custom_core_data_options: Maybe<CustomCoreDataOptionsMutationResponse>;
  /** insert a single row into the table: "custom_core_data_options" */
  insert_custom_core_data_options_one: Maybe<CustomCoreDataOptions>;
  /** insert data into the table: "custom_document_types" */
  insert_custom_document_types: Maybe<CustomDocumentTypesMutationResponse>;
  /** insert a single row into the table: "custom_document_types" */
  insert_custom_document_types_one: Maybe<CustomDocumentTypes>;
  /** insert data into the table: "custom_field_choices" */
  insert_custom_field_choices: Maybe<CustomFieldChoicesMutationResponse>;
  /** insert a single row into the table: "custom_field_choices" */
  insert_custom_field_choices_one: Maybe<CustomFieldChoices>;
  /** insert data into the table: "custom_field_core_data" */
  insert_custom_field_core_data: Maybe<CustomFieldCoreDataMutationResponse>;
  /** insert a single row into the table: "custom_field_core_data" */
  insert_custom_field_core_data_one: Maybe<CustomFieldCoreData>;
  /** insert data into the table: "custom_field_values" */
  insert_custom_field_values: Maybe<CustomFieldValuesMutationResponse>;
  /** insert a single row into the table: "custom_field_values" */
  insert_custom_field_values_one: Maybe<CustomFieldValues>;
  /** insert data into the table: "custom_fields" */
  insert_custom_fields: Maybe<CustomFieldsMutationResponse>;
  /** insert a single row into the table: "custom_fields" */
  insert_custom_fields_one: Maybe<CustomFields>;
  /** insert data into the table: "custom_reports" */
  insert_custom_reports: Maybe<CustomReportsMutationResponse>;
  /** insert data into the table: "custom_reports_generations" */
  insert_custom_reports_generations: Maybe<CustomReportsGenerationsMutationResponse>;
  /** insert a single row into the table: "custom_reports_generations" */
  insert_custom_reports_generations_one: Maybe<CustomReportsGenerations>;
  /** insert a single row into the table: "custom_reports" */
  insert_custom_reports_one: Maybe<CustomReports>;
  /** insert data into the table: "departments" */
  insert_departments: Maybe<DepartmentsMutationResponse>;
  /** insert a single row into the table: "departments" */
  insert_departments_one: Maybe<Departments>;
  /** insert data into the table: "document_types" */
  insert_document_types: Maybe<DocumentTypesMutationResponse>;
  /** insert a single row into the table: "document_types" */
  insert_document_types_one: Maybe<DocumentTypes>;
  /** insert data into the table: "documents" */
  insert_documents: Maybe<DocumentsMutationResponse>;
  /** insert a single row into the table: "documents" */
  insert_documents_one: Maybe<Documents>;
  /** insert data into the table: "draft_intake_submissions" */
  insert_draft_intake_submissions: Maybe<DraftIntakeSubmissionsMutationResponse>;
  /** insert a single row into the table: "draft_intake_submissions" */
  insert_draft_intake_submissions_one: Maybe<DraftIntakeSubmissions>;
  /** insert data into the table: "engagements" */
  insert_engagements: Maybe<EngagementsMutationResponse>;
  /** insert a single row into the table: "engagements" */
  insert_engagements_one: Maybe<Engagements>;
  /** insert data into the table: "entity_bank_details" */
  insert_entity_bank_details: Maybe<EntityBankDetailsMutationResponse>;
  /** insert a single row into the table: "entity_bank_details" */
  insert_entity_bank_details_one: Maybe<EntityBankDetails>;
  /** insert data into the table: "entity_field_group_fields" */
  insert_entity_field_group_fields: Maybe<EntityFieldGroupFieldsMutationResponse>;
  /** insert a single row into the table: "entity_field_group_fields" */
  insert_entity_field_group_fields_one: Maybe<EntityFieldGroupFields>;
  /** insert data into the table: "entity_field_groups" */
  insert_entity_field_groups: Maybe<EntityFieldGroupsMutationResponse>;
  /** insert a single row into the table: "entity_field_groups" */
  insert_entity_field_groups_one: Maybe<EntityFieldGroups>;
  /** insert data into the table: "external_contacts" */
  insert_external_contacts: Maybe<ExternalContactsMutationResponse>;
  /** insert a single row into the table: "external_contacts" */
  insert_external_contacts_one: Maybe<ExternalContacts>;
  /** insert data into the table: "external_entity_sync_statuses" */
  insert_external_entity_sync_statuses: Maybe<ExternalEntitySyncStatusesMutationResponse>;
  /** insert a single row into the table: "external_entity_sync_statuses" */
  insert_external_entity_sync_statuses_one: Maybe<ExternalEntitySyncStatuses>;
  /** insert data into the table: "external_risk_scores" */
  insert_external_risk_scores: Maybe<ExternalRiskScoresMutationResponse>;
  /** insert a single row into the table: "external_risk_scores" */
  insert_external_risk_scores_one: Maybe<ExternalRiskScores>;
  /** insert data into the table: "favourite_table_filters" */
  insert_favourite_table_filters: Maybe<FavouriteTableFiltersMutationResponse>;
  /** insert a single row into the table: "favourite_table_filters" */
  insert_favourite_table_filters_one: Maybe<FavouriteTableFilters>;
  /** insert data into the table: "financials" */
  insert_financials: Maybe<FinancialsMutationResponse>;
  /** insert a single row into the table: "financials" */
  insert_financials_one: Maybe<Financials>;
  /** insert data into the table: "form_template_question_insights" */
  insert_form_template_question_insights: Maybe<FormTemplateQuestionInsightsMutationResponse>;
  /** insert a single row into the table: "form_template_question_insights" */
  insert_form_template_question_insights_one: Maybe<FormTemplateQuestionInsights>;
  /** insert data into the table: "form_templates" */
  insert_form_templates: Maybe<FormTemplatesMutationResponse>;
  /** insert a single row into the table: "form_templates" */
  insert_form_templates_one: Maybe<FormTemplates>;
  /** insert data into the table: "group_user_assignments" */
  insert_group_user_assignments: Maybe<GroupUserAssignmentsMutationResponse>;
  /** insert a single row into the table: "group_user_assignments" */
  insert_group_user_assignments_one: Maybe<GroupUserAssignments>;
  /** insert data into the table: "group_users" */
  insert_group_users: Maybe<GroupUsersMutationResponse>;
  /** insert a single row into the table: "group_users" */
  insert_group_users_one: Maybe<GroupUsers>;
  /** insert data into the table: "groups" */
  insert_groups: Maybe<GroupsMutationResponse>;
  /** insert a single row into the table: "groups" */
  insert_groups_one: Maybe<Groups>;
  /** insert data into the table: "idp_attribute_mappings" */
  insert_idp_attribute_mappings: Maybe<IdpAttributeMappingsMutationResponse>;
  /** insert a single row into the table: "idp_attribute_mappings" */
  insert_idp_attribute_mappings_one: Maybe<IdpAttributeMappings>;
  /** insert data into the table: "internal_contacts" */
  insert_internal_contacts: Maybe<InternalContactsMutationResponse>;
  /** insert a single row into the table: "internal_contacts" */
  insert_internal_contacts_one: Maybe<InternalContacts>;
  /** insert data into the table: "line_item_types" */
  insert_line_item_types: Maybe<LineItemTypesMutationResponse>;
  /** insert a single row into the table: "line_item_types" */
  insert_line_item_types_one: Maybe<LineItemTypes>;
  /** insert data into the table: "organisation_core_data_dependencies" */
  insert_organisation_core_data_dependencies: Maybe<OrganisationCoreDataDependenciesMutationResponse>;
  /** insert a single row into the table: "organisation_core_data_dependencies" */
  insert_organisation_core_data_dependencies_one: Maybe<OrganisationCoreDataDependencies>;
  /** insert data into the table: "organisation_feature_flags" */
  insert_organisation_feature_flags: Maybe<OrganisationFeatureFlagsMutationResponse>;
  /** insert a single row into the table: "organisation_feature_flags" */
  insert_organisation_feature_flags_one: Maybe<OrganisationFeatureFlags>;
  /** insert data into the table: "organisation_fx_rates" */
  insert_organisation_fx_rates: Maybe<OrganisationFxRatesMutationResponse>;
  /** insert a single row into the table: "organisation_fx_rates" */
  insert_organisation_fx_rates_one: Maybe<OrganisationFxRates>;
  /** insert data into the table: "organisation_integration_operations" */
  insert_organisation_integration_operations: Maybe<OrganisationIntegrationOperationsMutationResponse>;
  /** insert a single row into the table: "organisation_integration_operations" */
  insert_organisation_integration_operations_one: Maybe<OrganisationIntegrationOperations>;
  /** insert data into the table: "organisation_integrations" */
  insert_organisation_integrations: Maybe<OrganisationIntegrationsMutationResponse>;
  /** insert a single row into the table: "organisation_integrations" */
  insert_organisation_integrations_one: Maybe<OrganisationIntegrations>;
  /** insert data into the table: "organisation_locales" */
  insert_organisation_locales: Maybe<OrganisationLocalesMutationResponse>;
  /** insert a single row into the table: "organisation_locales" */
  insert_organisation_locales_one: Maybe<OrganisationLocales>;
  /** insert data into the table: "organisation_product_supplier_categories" */
  insert_organisation_product_supplier_categories: Maybe<OrganisationProductSupplierCategoriesMutationResponse>;
  /** insert a single row into the table: "organisation_product_supplier_categories" */
  insert_organisation_product_supplier_categories_one: Maybe<OrganisationProductSupplierCategories>;
  /** insert data into the table: "organisation_products_and_services" */
  insert_organisation_products_and_services: Maybe<OrganisationProductsAndServicesMutationResponse>;
  /** insert data into the table: "organisation_products_and_services_brands" */
  insert_organisation_products_and_services_brands: Maybe<OrganisationProductsAndServicesBrandsMutationResponse>;
  /** insert a single row into the table: "organisation_products_and_services_brands" */
  insert_organisation_products_and_services_brands_one: Maybe<OrganisationProductsAndServicesBrands>;
  /** insert data into the table: "organisation_products_and_services_categories" */
  insert_organisation_products_and_services_categories: Maybe<OrganisationProductsAndServicesCategoriesMutationResponse>;
  /** insert a single row into the table: "organisation_products_and_services_categories" */
  insert_organisation_products_and_services_categories_one: Maybe<OrganisationProductsAndServicesCategories>;
  /** insert a single row into the table: "organisation_products_and_services" */
  insert_organisation_products_and_services_one: Maybe<OrganisationProductsAndServices>;
  /** insert data into the table: "organisation_public_api_clients" */
  insert_organisation_public_api_clients: Maybe<OrganisationPublicApiClientsMutationResponse>;
  /** insert a single row into the table: "organisation_public_api_clients" */
  insert_organisation_public_api_clients_one: Maybe<OrganisationPublicApiClients>;
  /** insert data into the table: "organisation_settings" */
  insert_organisation_settings: Maybe<OrganisationSettingsMutationResponse>;
  /** insert a single row into the table: "organisation_settings" */
  insert_organisation_settings_one: Maybe<OrganisationSettings>;
  /** insert data into the table: "organisation_static_content" */
  insert_organisation_static_content: Maybe<OrganisationStaticContentMutationResponse>;
  /** insert a single row into the table: "organisation_static_content" */
  insert_organisation_static_content_one: Maybe<OrganisationStaticContent>;
  /** insert data into the table: "organisation_supplier_historic_submissions" */
  insert_organisation_supplier_historic_submissions: Maybe<OrganisationSupplierHistoricSubmissionsMutationResponse>;
  /** insert a single row into the table: "organisation_supplier_historic_submissions" */
  insert_organisation_supplier_historic_submissions_one: Maybe<OrganisationSupplierHistoricSubmissions>;
  /** insert data into the table: "organisation_supplier_online_resources" */
  insert_organisation_supplier_online_resources: Maybe<OrganisationSupplierOnlineResourcesMutationResponse>;
  /** insert a single row into the table: "organisation_supplier_online_resources" */
  insert_organisation_supplier_online_resources_one: Maybe<OrganisationSupplierOnlineResources>;
  /** insert data into the table: "organisation_supplier_profile_resources" */
  insert_organisation_supplier_profile_resources: Maybe<OrganisationSupplierProfileResourcesMutationResponse>;
  /** insert a single row into the table: "organisation_supplier_profile_resources" */
  insert_organisation_supplier_profile_resources_one: Maybe<OrganisationSupplierProfileResources>;
  /** insert data into the table: "organisation_supplier_profiles" */
  insert_organisation_supplier_profiles: Maybe<OrganisationSupplierProfilesMutationResponse>;
  /** insert a single row into the table: "organisation_supplier_profiles" */
  insert_organisation_supplier_profiles_one: Maybe<OrganisationSupplierProfiles>;
  /** insert data into the table: "organisation_supplier_tags" */
  insert_organisation_supplier_tags: Maybe<OrganisationSupplierTagsMutationResponse>;
  /** insert a single row into the table: "organisation_supplier_tags" */
  insert_organisation_supplier_tags_one: Maybe<OrganisationSupplierTags>;
  /** insert data into the table: "organisation_suppliers" */
  insert_organisation_suppliers: Maybe<OrganisationSuppliersMutationResponse>;
  /** insert data into the table: "organisation_suppliers_brands" */
  insert_organisation_suppliers_brands: Maybe<OrganisationSuppliersBrandsMutationResponse>;
  /** insert a single row into the table: "organisation_suppliers_brands" */
  insert_organisation_suppliers_brands_one: Maybe<OrganisationSuppliersBrands>;
  /** insert data into the table: "organisation_suppliers_categories" */
  insert_organisation_suppliers_categories: Maybe<OrganisationSuppliersCategoriesMutationResponse>;
  /** insert a single row into the table: "organisation_suppliers_categories" */
  insert_organisation_suppliers_categories_one: Maybe<OrganisationSuppliersCategories>;
  /** insert a single row into the table: "organisation_suppliers" */
  insert_organisation_suppliers_one: Maybe<OrganisationSuppliers>;
  /** insert data into the table: "out_of_office_delegations" */
  insert_out_of_office_delegations: Maybe<OutOfOfficeDelegationsMutationResponse>;
  /** insert a single row into the table: "out_of_office_delegations" */
  insert_out_of_office_delegations_one: Maybe<OutOfOfficeDelegations>;
  /** insert data into the table: "pause_reasons" */
  insert_pause_reasons: Maybe<PauseReasonsMutationResponse>;
  /** insert a single row into the table: "pause_reasons" */
  insert_pause_reasons_one: Maybe<PauseReasons>;
  /** insert data into the table: "payment_methods" */
  insert_payment_methods: Maybe<PaymentMethodsMutationResponse>;
  /** insert a single row into the table: "payment_methods" */
  insert_payment_methods_one: Maybe<PaymentMethods>;
  /** insert data into the table: "payment_terms" */
  insert_payment_terms: Maybe<PaymentTermsMutationResponse>;
  /** insert a single row into the table: "payment_terms" */
  insert_payment_terms_one: Maybe<PaymentTerms>;
  /** insert data into the table: "product_catalogue_access_approvers" */
  insert_product_catalogue_access_approvers: Maybe<ProductCatalogueAccessApproversMutationResponse>;
  /** insert a single row into the table: "product_catalogue_access_approvers" */
  insert_product_catalogue_access_approvers_one: Maybe<ProductCatalogueAccessApprovers>;
  /** insert data into the table: "product_catalogue_entries" */
  insert_product_catalogue_entries: Maybe<ProductCatalogueEntriesMutationResponse>;
  /** insert a single row into the table: "product_catalogue_entries" */
  insert_product_catalogue_entries_one: Maybe<ProductCatalogueEntries>;
  /** insert data into the table: "purchase_order_line_items" */
  insert_purchase_order_line_items: Maybe<PurchaseOrderLineItemsMutationResponse>;
  /** insert a single row into the table: "purchase_order_line_items" */
  insert_purchase_order_line_items_one: Maybe<PurchaseOrderLineItems>;
  /** insert data into the table: "purchase_orders" */
  insert_purchase_orders: Maybe<PurchaseOrdersMutationResponse>;
  /** insert a single row into the table: "purchase_orders" */
  insert_purchase_orders_one: Maybe<PurchaseOrders>;
  /** insert data into the table: "renewal_additional_users" */
  insert_renewal_additional_users: Maybe<RenewalAdditionalUsersMutationResponse>;
  /** insert a single row into the table: "renewal_additional_users" */
  insert_renewal_additional_users_one: Maybe<RenewalAdditionalUsers>;
  /** insert data into the table: "renewal_tags" */
  insert_renewal_tags: Maybe<RenewalTagsMutationResponse>;
  /** insert a single row into the table: "renewal_tags" */
  insert_renewal_tags_one: Maybe<RenewalTags>;
  /** insert data into the table: "renewals" */
  insert_renewals: Maybe<RenewalsMutationResponse>;
  /** insert a single row into the table: "renewals" */
  insert_renewals_one: Maybe<Renewals>;
  /** insert data into the table: "request_comments" */
  insert_request_comments: Maybe<RequestCommentsMutationResponse>;
  /** insert data into the table: "request_comments_mentions" */
  insert_request_comments_mentions: Maybe<RequestCommentsMentionsMutationResponse>;
  /** insert a single row into the table: "request_comments_mentions" */
  insert_request_comments_mentions_one: Maybe<RequestCommentsMentions>;
  /** insert a single row into the table: "request_comments" */
  insert_request_comments_one: Maybe<RequestComments>;
  /** insert data into the table: "request_computed_properties" */
  insert_request_computed_properties: Maybe<RequestComputedPropertiesMutationResponse>;
  /** insert a single row into the table: "request_computed_properties" */
  insert_request_computed_properties_one: Maybe<RequestComputedProperties>;
  /** insert data into the table: "request_documents" */
  insert_request_documents: Maybe<RequestDocumentsMutationResponse>;
  /** insert a single row into the table: "request_documents" */
  insert_request_documents_one: Maybe<RequestDocuments>;
  /** insert data into the table: "request_esign_documents" */
  insert_request_esign_documents: Maybe<RequestEsignDocumentsMutationResponse>;
  /** insert a single row into the table: "request_esign_documents" */
  insert_request_esign_documents_one: Maybe<RequestEsignDocuments>;
  /** insert data into the table: "request_followers" */
  insert_request_followers: Maybe<RequestFollowersMutationResponse>;
  /** insert a single row into the table: "request_followers" */
  insert_request_followers_one: Maybe<RequestFollowers>;
  /** insert data into the table: "request_form_question_ai_score" */
  insert_request_form_question_ai_score: Maybe<RequestFormQuestionAiScoreMutationResponse>;
  /** insert a single row into the table: "request_form_question_ai_score" */
  insert_request_form_question_ai_score_one: Maybe<RequestFormQuestionAiScore>;
  /** insert data into the table: "request_form_question_score" */
  insert_request_form_question_score: Maybe<RequestFormQuestionScoreMutationResponse>;
  /** insert a single row into the table: "request_form_question_score" */
  insert_request_form_question_score_one: Maybe<RequestFormQuestionScore>;
  /** insert data into the table: "request_form_submission_ai_summary" */
  insert_request_form_submission_ai_summary: Maybe<RequestFormSubmissionAiSummaryMutationResponse>;
  /** insert a single row into the table: "request_form_submission_ai_summary" */
  insert_request_form_submission_ai_summary_one: Maybe<RequestFormSubmissionAiSummary>;
  /** insert data into the table: "request_form_submission_translations" */
  insert_request_form_submission_translations: Maybe<RequestFormSubmissionTranslationsMutationResponse>;
  /** insert a single row into the table: "request_form_submission_translations" */
  insert_request_form_submission_translations_one: Maybe<RequestFormSubmissionTranslations>;
  /** insert data into the table: "request_form_submissions" */
  insert_request_form_submissions: Maybe<RequestFormSubmissionsMutationResponse>;
  /** insert data into the table: "request_form_submissions_auto_saves" */
  insert_request_form_submissions_auto_saves: Maybe<RequestFormSubmissionsAutoSavesMutationResponse>;
  /** insert a single row into the table: "request_form_submissions_auto_saves" */
  insert_request_form_submissions_auto_saves_one: Maybe<RequestFormSubmissionsAutoSaves>;
  /** insert a single row into the table: "request_form_submissions" */
  insert_request_form_submissions_one: Maybe<RequestFormSubmissions>;
  /** insert data into the table: "request_form_template_reviewers" */
  insert_request_form_template_reviewers: Maybe<RequestFormTemplateReviewersMutationResponse>;
  /** insert a single row into the table: "request_form_template_reviewers" */
  insert_request_form_template_reviewers_one: Maybe<RequestFormTemplateReviewers>;
  /** insert data into the table: "request_form_templates" */
  insert_request_form_templates: Maybe<RequestFormTemplatesMutationResponse>;
  /** insert a single row into the table: "request_form_templates" */
  insert_request_form_templates_one: Maybe<RequestFormTemplates>;
  /** insert data into the table: "request_forms" */
  insert_request_forms: Maybe<RequestFormsMutationResponse>;
  /** insert a single row into the table: "request_forms" */
  insert_request_forms_one: Maybe<RequestForms>;
  /** insert data into the table: "request_groups" */
  insert_request_groups: Maybe<RequestGroupsMutationResponse>;
  /** insert a single row into the table: "request_groups" */
  insert_request_groups_one: Maybe<RequestGroups>;
  /** insert data into the table: "request_leads_config" */
  insert_request_leads_config: Maybe<RequestLeadsConfigMutationResponse>;
  /** insert a single row into the table: "request_leads_config" */
  insert_request_leads_config_one: Maybe<RequestLeadsConfig>;
  /** insert data into the table: "request_pauses" */
  insert_request_pauses: Maybe<RequestPausesMutationResponse>;
  /** insert a single row into the table: "request_pauses" */
  insert_request_pauses_one: Maybe<RequestPauses>;
  /** insert data into the table: "request_request_leads" */
  insert_request_request_leads: Maybe<RequestRequestLeadsMutationResponse>;
  /** insert a single row into the table: "request_request_leads" */
  insert_request_request_leads_one: Maybe<RequestRequestLeads>;
  /** insert data into the table: "request_step_groups" */
  insert_request_step_groups: Maybe<RequestStepGroupsMutationResponse>;
  /** insert a single row into the table: "request_step_groups" */
  insert_request_step_groups_one: Maybe<RequestStepGroups>;
  /** insert data into the table: "request_step_notification_messages" */
  insert_request_step_notification_messages: Maybe<RequestStepNotificationMessagesMutationResponse>;
  /** insert a single row into the table: "request_step_notification_messages" */
  insert_request_step_notification_messages_one: Maybe<RequestStepNotificationMessages>;
  /** insert data into the table: "request_step_task_errors" */
  insert_request_step_task_errors: Maybe<RequestStepTaskErrorsMutationResponse>;
  /** insert a single row into the table: "request_step_task_errors" */
  insert_request_step_task_errors_one: Maybe<RequestStepTaskErrors>;
  /** insert data into the table: "request_step_task_rejections" */
  insert_request_step_task_rejections: Maybe<RequestStepTaskRejectionsMutationResponse>;
  /** insert a single row into the table: "request_step_task_rejections" */
  insert_request_step_task_rejections_one: Maybe<RequestStepTaskRejections>;
  /** insert data into the table: "request_step_task_users" */
  insert_request_step_task_users: Maybe<RequestStepTaskUsersMutationResponse>;
  /** insert a single row into the table: "request_step_task_users" */
  insert_request_step_task_users_one: Maybe<RequestStepTaskUsers>;
  /** insert data into the table: "request_step_tasks" */
  insert_request_step_tasks: Maybe<RequestStepTasksMutationResponse>;
  /** insert a single row into the table: "request_step_tasks" */
  insert_request_step_tasks_one: Maybe<RequestStepTasks>;
  /** insert data into the table: "request_step_users" */
  insert_request_step_users: Maybe<RequestStepUsersMutationResponse>;
  /** insert a single row into the table: "request_step_users" */
  insert_request_step_users_one: Maybe<RequestStepUsers>;
  /** insert data into the table: "request_steps" */
  insert_request_steps: Maybe<RequestStepsMutationResponse>;
  /** insert a single row into the table: "request_steps" */
  insert_request_steps_one: Maybe<RequestSteps>;
  /** insert data into the table: "request_tags" */
  insert_request_tags: Maybe<RequestTagsMutationResponse>;
  /** insert a single row into the table: "request_tags" */
  insert_request_tags_one: Maybe<RequestTags>;
  /** insert data into the table: "request_users" */
  insert_request_users: Maybe<RequestUsersMutationResponse>;
  /** insert a single row into the table: "request_users" */
  insert_request_users_one: Maybe<RequestUsers>;
  /** insert data into the table: "requests" */
  insert_requests: Maybe<RequestsMutationResponse>;
  /** insert a single row into the table: "requests" */
  insert_requests_one: Maybe<Requests>;
  /** insert data into the table: "rfx" */
  insert_rfx: Maybe<RfxMutationResponse>;
  /** insert data into the table: "rfx_ai_scoring" */
  insert_rfx_ai_scoring: Maybe<RfxAiScoringMutationResponse>;
  /** insert a single row into the table: "rfx_ai_scoring" */
  insert_rfx_ai_scoring_one: Maybe<RfxAiScoring>;
  /** insert data into the table: "rfx_confidentiality_agreement" */
  insert_rfx_confidentiality_agreement: Maybe<RfxConfidentialityAgreementMutationResponse>;
  /** insert a single row into the table: "rfx_confidentiality_agreement" */
  insert_rfx_confidentiality_agreement_one: Maybe<RfxConfidentialityAgreement>;
  /** insert data into the table: "rfx_external_users" */
  insert_rfx_external_users: Maybe<RfxExternalUsersMutationResponse>;
  /** insert a single row into the table: "rfx_external_users" */
  insert_rfx_external_users_one: Maybe<RfxExternalUsers>;
  /** insert a single row into the table: "rfx" */
  insert_rfx_one: Maybe<Rfx>;
  /** insert data into the table: "rfx_owners" */
  insert_rfx_owners: Maybe<RfxOwnersMutationResponse>;
  /** insert a single row into the table: "rfx_owners" */
  insert_rfx_owners_one: Maybe<RfxOwners>;
  /** insert data into the table: "rfx_request_form_template_weighting" */
  insert_rfx_request_form_template_weighting: Maybe<RfxRequestFormTemplateWeightingMutationResponse>;
  /** insert a single row into the table: "rfx_request_form_template_weighting" */
  insert_rfx_request_form_template_weighting_one: Maybe<RfxRequestFormTemplateWeighting>;
  /** insert data into the table: "rfx_request_form_templates_ranks" */
  insert_rfx_request_form_templates_ranks: Maybe<RfxRequestFormTemplatesRanksMutationResponse>;
  /** insert a single row into the table: "rfx_request_form_templates_ranks" */
  insert_rfx_request_form_templates_ranks_one: Maybe<RfxRequestFormTemplatesRanks>;
  /** insert data into the table: "rfx_suppliers" */
  insert_rfx_suppliers: Maybe<RfxSuppliersMutationResponse>;
  /** insert a single row into the table: "rfx_suppliers" */
  insert_rfx_suppliers_one: Maybe<RfxSuppliers>;
  /** insert data into the table: "risk_attributes" */
  insert_risk_attributes: Maybe<RiskAttributesMutationResponse>;
  /** insert a single row into the table: "risk_attributes" */
  insert_risk_attributes_one: Maybe<RiskAttributes>;
  /** insert data into the table: "risk_categories" */
  insert_risk_categories: Maybe<RiskCategoriesMutationResponse>;
  /** insert a single row into the table: "risk_categories" */
  insert_risk_categories_one: Maybe<RiskCategories>;
  /** insert data into the table: "risk_levels" */
  insert_risk_levels: Maybe<RiskLevelsMutationResponse>;
  /** insert a single row into the table: "risk_levels" */
  insert_risk_levels_one: Maybe<RiskLevels>;
  /** insert data into the table: "risk_matrix_cells" */
  insert_risk_matrix_cells: Maybe<RiskMatrixCellsMutationResponse>;
  /** insert a single row into the table: "risk_matrix_cells" */
  insert_risk_matrix_cells_one: Maybe<RiskMatrixCells>;
  /** insert data into the table: "risk_owners" */
  insert_risk_owners: Maybe<RiskOwnersMutationResponse>;
  /** insert a single row into the table: "risk_owners" */
  insert_risk_owners_one: Maybe<RiskOwners>;
  /** insert data into the table: "risk_settings" */
  insert_risk_settings: Maybe<RiskSettingsMutationResponse>;
  /** insert a single row into the table: "risk_settings" */
  insert_risk_settings_one: Maybe<RiskSettings>;
  /** insert data into the table: "risk_template_categories" */
  insert_risk_template_categories: Maybe<RiskTemplateCategoriesMutationResponse>;
  /** insert a single row into the table: "risk_template_categories" */
  insert_risk_template_categories_one: Maybe<RiskTemplateCategories>;
  /** insert data into the table: "risk_template_owners" */
  insert_risk_template_owners: Maybe<RiskTemplateOwnersMutationResponse>;
  /** insert a single row into the table: "risk_template_owners" */
  insert_risk_template_owners_one: Maybe<RiskTemplateOwners>;
  /** insert data into the table: "risk_templates" */
  insert_risk_templates: Maybe<RiskTemplatesMutationResponse>;
  /** insert a single row into the table: "risk_templates" */
  insert_risk_templates_one: Maybe<RiskTemplates>;
  /** insert data into the table: "risk_versions" */
  insert_risk_versions: Maybe<RiskVersionsMutationResponse>;
  /** insert a single row into the table: "risk_versions" */
  insert_risk_versions_one: Maybe<RiskVersions>;
  /** insert data into the table: "risks" */
  insert_risks: Maybe<RisksMutationResponse>;
  /** insert a single row into the table: "risks" */
  insert_risks_one: Maybe<Risks>;
  /** insert data into the table: "subsidiaries" */
  insert_subsidiaries: Maybe<SubsidiariesMutationResponse>;
  /** insert a single row into the table: "subsidiaries" */
  insert_subsidiaries_one: Maybe<Subsidiaries>;
  /** insert data into the table: "table_filters" */
  insert_table_filters: Maybe<TableFiltersMutationResponse>;
  /** insert a single row into the table: "table_filters" */
  insert_table_filters_one: Maybe<TableFilters>;
  /** insert data into the table: "tags" */
  insert_tags: Maybe<TagsMutationResponse>;
  /** insert a single row into the table: "tags" */
  insert_tags_one: Maybe<Tags>;
  /** insert data into the table: "user_allowed_subsidiaries" */
  insert_user_allowed_subsidiaries: Maybe<UserAllowedSubsidiariesMutationResponse>;
  /** insert a single row into the table: "user_allowed_subsidiaries" */
  insert_user_allowed_subsidiaries_one: Maybe<UserAllowedSubsidiaries>;
  /** insert data into the table: "users" */
  insert_users: Maybe<UsersMutationResponse>;
  /** insert a single row into the table: "users" */
  insert_users_one: Maybe<Users>;
  /** insert data into the table: "workflow_condition_groups" */
  insert_workflow_condition_groups: Maybe<WorkflowConditionGroupsMutationResponse>;
  /** insert a single row into the table: "workflow_condition_groups" */
  insert_workflow_condition_groups_one: Maybe<WorkflowConditionGroups>;
  /** insert data into the table: "workflow_form_templates" */
  insert_workflow_form_templates: Maybe<WorkflowFormTemplatesMutationResponse>;
  /** insert a single row into the table: "workflow_form_templates" */
  insert_workflow_form_templates_one: Maybe<WorkflowFormTemplates>;
  /** insert data into the table: "workflow_ranks" */
  insert_workflow_ranks: Maybe<WorkflowRanksMutationResponse>;
  /** insert a single row into the table: "workflow_ranks" */
  insert_workflow_ranks_one: Maybe<WorkflowRanks>;
  /** insert data into the table: "workflows" */
  insert_workflows: Maybe<WorkflowsMutationResponse>;
  /** insert a single row into the table: "workflows" */
  insert_workflows_one: Maybe<Workflows>;
  /** update data of the table: "addresses" */
  update_addresses: Maybe<AddressesMutationResponse>;
  /** update single row of the table: "addresses" */
  update_addresses_by_pk: Maybe<Addresses>;
  /** update multiples rows of table: "addresses" */
  update_addresses_many: Maybe<Array<Maybe<AddressesMutationResponse>>>;
  /** update data of the table: "agreement_additional_owners" */
  update_agreement_additional_owners: Maybe<AgreementAdditionalOwnersMutationResponse>;
  /** update single row of the table: "agreement_additional_owners" */
  update_agreement_additional_owners_by_pk: Maybe<AgreementAdditionalOwners>;
  /** update multiples rows of table: "agreement_additional_owners" */
  update_agreement_additional_owners_many: Maybe<Array<Maybe<AgreementAdditionalOwnersMutationResponse>>>;
  /** update data of the table: "agreement_documents" */
  update_agreement_documents: Maybe<AgreementDocumentsMutationResponse>;
  /** update single row of the table: "agreement_documents" */
  update_agreement_documents_by_pk: Maybe<AgreementDocuments>;
  /** update multiples rows of table: "agreement_documents" */
  update_agreement_documents_many: Maybe<Array<Maybe<AgreementDocumentsMutationResponse>>>;
  /** update data of the table: "agreement_tags" */
  update_agreement_tags: Maybe<AgreementTagsMutationResponse>;
  /** update single row of the table: "agreement_tags" */
  update_agreement_tags_by_pk: Maybe<AgreementTags>;
  /** update multiples rows of table: "agreement_tags" */
  update_agreement_tags_many: Maybe<Array<Maybe<AgreementTagsMutationResponse>>>;
  /** update data of the table: "agreement_term_products" */
  update_agreement_term_products: Maybe<AgreementTermProductsMutationResponse>;
  /** update single row of the table: "agreement_term_products" */
  update_agreement_term_products_by_pk: Maybe<AgreementTermProducts>;
  /** update multiples rows of table: "agreement_term_products" */
  update_agreement_term_products_many: Maybe<Array<Maybe<AgreementTermProductsMutationResponse>>>;
  /** update data of the table: "agreement_term_revisions" */
  update_agreement_term_revisions: Maybe<AgreementTermRevisionsMutationResponse>;
  /** update single row of the table: "agreement_term_revisions" */
  update_agreement_term_revisions_by_pk: Maybe<AgreementTermRevisions>;
  /** update multiples rows of table: "agreement_term_revisions" */
  update_agreement_term_revisions_many: Maybe<Array<Maybe<AgreementTermRevisionsMutationResponse>>>;
  /** update data of the table: "agreement_term_spend_items" */
  update_agreement_term_spend_items: Maybe<AgreementTermSpendItemsMutationResponse>;
  /** update single row of the table: "agreement_term_spend_items" */
  update_agreement_term_spend_items_by_pk: Maybe<AgreementTermSpendItems>;
  /** update multiples rows of table: "agreement_term_spend_items" */
  update_agreement_term_spend_items_many: Maybe<Array<Maybe<AgreementTermSpendItemsMutationResponse>>>;
  /** update data of the table: "agreement_terms" */
  update_agreement_terms: Maybe<AgreementTermsMutationResponse>;
  /** update single row of the table: "agreement_terms" */
  update_agreement_terms_by_pk: Maybe<AgreementTerms>;
  /** update multiples rows of table: "agreement_terms" */
  update_agreement_terms_many: Maybe<Array<Maybe<AgreementTermsMutationResponse>>>;
  /** update data of the table: "agreements" */
  update_agreements: Maybe<AgreementsMutationResponse>;
  /** update single row of the table: "agreements" */
  update_agreements_by_pk: Maybe<Agreements>;
  /** update multiples rows of table: "agreements" */
  update_agreements_many: Maybe<Array<Maybe<AgreementsMutationResponse>>>;
  /** update data of the table: "assessment_additional_groups" */
  update_assessment_additional_groups: Maybe<AssessmentAdditionalGroupsMutationResponse>;
  /** update single row of the table: "assessment_additional_groups" */
  update_assessment_additional_groups_by_pk: Maybe<AssessmentAdditionalGroups>;
  /** update multiples rows of table: "assessment_additional_groups" */
  update_assessment_additional_groups_many: Maybe<Array<Maybe<AssessmentAdditionalGroupsMutationResponse>>>;
  /** update data of the table: "assessment_additional_users" */
  update_assessment_additional_users: Maybe<AssessmentAdditionalUsersMutationResponse>;
  /** update single row of the table: "assessment_additional_users" */
  update_assessment_additional_users_by_pk: Maybe<AssessmentAdditionalUsers>;
  /** update multiples rows of table: "assessment_additional_users" */
  update_assessment_additional_users_many: Maybe<Array<Maybe<AssessmentAdditionalUsersMutationResponse>>>;
  /** update data of the table: "assessments" */
  update_assessments: Maybe<AssessmentsMutationResponse>;
  /** update single row of the table: "assessments" */
  update_assessments_by_pk: Maybe<Assessments>;
  /** update multiples rows of table: "assessments" */
  update_assessments_many: Maybe<Array<Maybe<AssessmentsMutationResponse>>>;
  /** update data of the table: "auth_refresh_tokens" */
  update_auth_refresh_tokens: Maybe<AuthRefreshTokensMutationResponse>;
  /** update single row of the table: "auth_refresh_tokens" */
  update_auth_refresh_tokens_by_pk: Maybe<AuthRefreshTokens>;
  /** update multiples rows of table: "auth_refresh_tokens" */
  update_auth_refresh_tokens_many: Maybe<Array<Maybe<AuthRefreshTokensMutationResponse>>>;
  /** update data of the table: "auto_flagged_score_categories" */
  update_auto_flagged_score_categories: Maybe<AutoFlaggedScoreCategoriesMutationResponse>;
  /** update single row of the table: "auto_flagged_score_categories" */
  update_auto_flagged_score_categories_by_pk: Maybe<AutoFlaggedScoreCategories>;
  /** update multiples rows of table: "auto_flagged_score_categories" */
  update_auto_flagged_score_categories_many: Maybe<Array<Maybe<AutoFlaggedScoreCategoriesMutationResponse>>>;
  /** update data of the table: "bank_details" */
  update_bank_details: Maybe<BankDetailsMutationResponse>;
  /** update single row of the table: "bank_details" */
  update_bank_details_by_pk: Maybe<BankDetails>;
  /** update multiples rows of table: "bank_details" */
  update_bank_details_many: Maybe<Array<Maybe<BankDetailsMutationResponse>>>;
  /** update data of the table: "budget_approval_group" */
  update_budget_approval_group: Maybe<BudgetApprovalGroupMutationResponse>;
  /** update data of the table: "budget_approval_group_assignees" */
  update_budget_approval_group_assignees: Maybe<BudgetApprovalGroupAssigneesMutationResponse>;
  /** update data of the table: "budget_approval_group_assignees_assignees" */
  update_budget_approval_group_assignees_assignees: Maybe<BudgetApprovalGroupAssigneesAssigneesMutationResponse>;
  /** update single row of the table: "budget_approval_group_assignees_assignees" */
  update_budget_approval_group_assignees_assignees_by_pk: Maybe<BudgetApprovalGroupAssigneesAssignees>;
  /** update multiples rows of table: "budget_approval_group_assignees_assignees" */
  update_budget_approval_group_assignees_assignees_many: Maybe<Array<Maybe<BudgetApprovalGroupAssigneesAssigneesMutationResponse>>>;
  /** update single row of the table: "budget_approval_group_assignees" */
  update_budget_approval_group_assignees_by_pk: Maybe<BudgetApprovalGroupAssignees>;
  /** update multiples rows of table: "budget_approval_group_assignees" */
  update_budget_approval_group_assignees_many: Maybe<Array<Maybe<BudgetApprovalGroupAssigneesMutationResponse>>>;
  /** update single row of the table: "budget_approval_group" */
  update_budget_approval_group_by_pk: Maybe<BudgetApprovalGroup>;
  /** update multiples rows of table: "budget_approval_group" */
  update_budget_approval_group_many: Maybe<Array<Maybe<BudgetApprovalGroupMutationResponse>>>;
  /** update data of the table: "budget_approval_threshold" */
  update_budget_approval_threshold: Maybe<BudgetApprovalThresholdMutationResponse>;
  /** update single row of the table: "budget_approval_threshold" */
  update_budget_approval_threshold_by_pk: Maybe<BudgetApprovalThreshold>;
  /** update multiples rows of table: "budget_approval_threshold" */
  update_budget_approval_threshold_many: Maybe<Array<Maybe<BudgetApprovalThresholdMutationResponse>>>;
  /** update data of the table: "budgets" */
  update_budgets: Maybe<BudgetsMutationResponse>;
  /** update single row of the table: "budgets" */
  update_budgets_by_pk: Maybe<Budgets>;
  /** update multiples rows of table: "budgets" */
  update_budgets_many: Maybe<Array<Maybe<BudgetsMutationResponse>>>;
  /** update data of the table: "bulk_documents_uploads" */
  update_bulk_documents_uploads: Maybe<BulkDocumentsUploadsMutationResponse>;
  /** update single row of the table: "bulk_documents_uploads" */
  update_bulk_documents_uploads_by_pk: Maybe<BulkDocumentsUploads>;
  /** update multiples rows of table: "bulk_documents_uploads" */
  update_bulk_documents_uploads_many: Maybe<Array<Maybe<BulkDocumentsUploadsMutationResponse>>>;
  /** update data of the table: "config_translations" */
  update_config_translations: Maybe<ConfigTranslationsMutationResponse>;
  /** update single row of the table: "config_translations" */
  update_config_translations_by_pk: Maybe<ConfigTranslations>;
  /** update multiples rows of table: "config_translations" */
  update_config_translations_many: Maybe<Array<Maybe<ConfigTranslationsMutationResponse>>>;
  /** update data of the table: "core_data_dependencies" */
  update_core_data_dependencies: Maybe<CoreDataDependenciesMutationResponse>;
  /** update single row of the table: "core_data_dependencies" */
  update_core_data_dependencies_by_pk: Maybe<CoreDataDependencies>;
  /** update multiples rows of table: "core_data_dependencies" */
  update_core_data_dependencies_many: Maybe<Array<Maybe<CoreDataDependenciesMutationResponse>>>;
  /** update data of the table: "core_data_external_references" */
  update_core_data_external_references: Maybe<CoreDataExternalReferencesMutationResponse>;
  /** update single row of the table: "core_data_external_references" */
  update_core_data_external_references_by_pk: Maybe<CoreDataExternalReferences>;
  /** update multiples rows of table: "core_data_external_references" */
  update_core_data_external_references_many: Maybe<Array<Maybe<CoreDataExternalReferencesMutationResponse>>>;
  /** update data of the table: "core_data_organisation_integrations" */
  update_core_data_organisation_integrations: Maybe<CoreDataOrganisationIntegrationsMutationResponse>;
  /** update single row of the table: "core_data_organisation_integrations" */
  update_core_data_organisation_integrations_by_pk: Maybe<CoreDataOrganisationIntegrations>;
  /** update multiples rows of table: "core_data_organisation_integrations" */
  update_core_data_organisation_integrations_many: Maybe<Array<Maybe<CoreDataOrganisationIntegrationsMutationResponse>>>;
  /** update data of the table: "custom_core_data" */
  update_custom_core_data: Maybe<CustomCoreDataMutationResponse>;
  /** update single row of the table: "custom_core_data" */
  update_custom_core_data_by_pk: Maybe<CustomCoreData>;
  /** update multiples rows of table: "custom_core_data" */
  update_custom_core_data_many: Maybe<Array<Maybe<CustomCoreDataMutationResponse>>>;
  /** update data of the table: "custom_core_data_options" */
  update_custom_core_data_options: Maybe<CustomCoreDataOptionsMutationResponse>;
  /** update single row of the table: "custom_core_data_options" */
  update_custom_core_data_options_by_pk: Maybe<CustomCoreDataOptions>;
  /** update multiples rows of table: "custom_core_data_options" */
  update_custom_core_data_options_many: Maybe<Array<Maybe<CustomCoreDataOptionsMutationResponse>>>;
  /** update data of the table: "custom_field_core_data" */
  update_custom_field_core_data: Maybe<CustomFieldCoreDataMutationResponse>;
  /** update single row of the table: "custom_field_core_data" */
  update_custom_field_core_data_by_pk: Maybe<CustomFieldCoreData>;
  /** update multiples rows of table: "custom_field_core_data" */
  update_custom_field_core_data_many: Maybe<Array<Maybe<CustomFieldCoreDataMutationResponse>>>;
  /** update data of the table: "custom_field_values" */
  update_custom_field_values: Maybe<CustomFieldValuesMutationResponse>;
  /** update single row of the table: "custom_field_values" */
  update_custom_field_values_by_pk: Maybe<CustomFieldValues>;
  /** update multiples rows of table: "custom_field_values" */
  update_custom_field_values_many: Maybe<Array<Maybe<CustomFieldValuesMutationResponse>>>;
  /** update data of the table: "custom_fields" */
  update_custom_fields: Maybe<CustomFieldsMutationResponse>;
  /** update single row of the table: "custom_fields" */
  update_custom_fields_by_pk: Maybe<CustomFields>;
  /** update multiples rows of table: "custom_fields" */
  update_custom_fields_many: Maybe<Array<Maybe<CustomFieldsMutationResponse>>>;
  /** update data of the table: "custom_reports" */
  update_custom_reports: Maybe<CustomReportsMutationResponse>;
  /** update single row of the table: "custom_reports" */
  update_custom_reports_by_pk: Maybe<CustomReports>;
  /** update data of the table: "custom_reports_generations" */
  update_custom_reports_generations: Maybe<CustomReportsGenerationsMutationResponse>;
  /** update single row of the table: "custom_reports_generations" */
  update_custom_reports_generations_by_pk: Maybe<CustomReportsGenerations>;
  /** update multiples rows of table: "custom_reports_generations" */
  update_custom_reports_generations_many: Maybe<Array<Maybe<CustomReportsGenerationsMutationResponse>>>;
  /** update multiples rows of table: "custom_reports" */
  update_custom_reports_many: Maybe<Array<Maybe<CustomReportsMutationResponse>>>;
  /** update data of the table: "departments" */
  update_departments: Maybe<DepartmentsMutationResponse>;
  /** update single row of the table: "departments" */
  update_departments_by_pk: Maybe<Departments>;
  /** update multiples rows of table: "departments" */
  update_departments_many: Maybe<Array<Maybe<DepartmentsMutationResponse>>>;
  /** update data of the table: "document_types" */
  update_document_types: Maybe<DocumentTypesMutationResponse>;
  /** update single row of the table: "document_types" */
  update_document_types_by_pk: Maybe<DocumentTypes>;
  /** update multiples rows of table: "document_types" */
  update_document_types_many: Maybe<Array<Maybe<DocumentTypesMutationResponse>>>;
  /** update data of the table: "documents" */
  update_documents: Maybe<DocumentsMutationResponse>;
  /** update single row of the table: "documents" */
  update_documents_by_pk: Maybe<Documents>;
  /** update multiples rows of table: "documents" */
  update_documents_many: Maybe<Array<Maybe<DocumentsMutationResponse>>>;
  /** update data of the table: "draft_intake_submissions" */
  update_draft_intake_submissions: Maybe<DraftIntakeSubmissionsMutationResponse>;
  /** update single row of the table: "draft_intake_submissions" */
  update_draft_intake_submissions_by_pk: Maybe<DraftIntakeSubmissions>;
  /** update multiples rows of table: "draft_intake_submissions" */
  update_draft_intake_submissions_many: Maybe<Array<Maybe<DraftIntakeSubmissionsMutationResponse>>>;
  /** update data of the table: "engagements" */
  update_engagements: Maybe<EngagementsMutationResponse>;
  /** update single row of the table: "engagements" */
  update_engagements_by_pk: Maybe<Engagements>;
  /** update multiples rows of table: "engagements" */
  update_engagements_many: Maybe<Array<Maybe<EngagementsMutationResponse>>>;
  /** update data of the table: "entity_bank_details" */
  update_entity_bank_details: Maybe<EntityBankDetailsMutationResponse>;
  /** update single row of the table: "entity_bank_details" */
  update_entity_bank_details_by_pk: Maybe<EntityBankDetails>;
  /** update multiples rows of table: "entity_bank_details" */
  update_entity_bank_details_many: Maybe<Array<Maybe<EntityBankDetailsMutationResponse>>>;
  /** update data of the table: "entity_field_group_fields" */
  update_entity_field_group_fields: Maybe<EntityFieldGroupFieldsMutationResponse>;
  /** update single row of the table: "entity_field_group_fields" */
  update_entity_field_group_fields_by_pk: Maybe<EntityFieldGroupFields>;
  /** update multiples rows of table: "entity_field_group_fields" */
  update_entity_field_group_fields_many: Maybe<Array<Maybe<EntityFieldGroupFieldsMutationResponse>>>;
  /** update data of the table: "entity_field_groups" */
  update_entity_field_groups: Maybe<EntityFieldGroupsMutationResponse>;
  /** update single row of the table: "entity_field_groups" */
  update_entity_field_groups_by_pk: Maybe<EntityFieldGroups>;
  /** update multiples rows of table: "entity_field_groups" */
  update_entity_field_groups_many: Maybe<Array<Maybe<EntityFieldGroupsMutationResponse>>>;
  /** update data of the table: "external_contacts" */
  update_external_contacts: Maybe<ExternalContactsMutationResponse>;
  /** update single row of the table: "external_contacts" */
  update_external_contacts_by_pk: Maybe<ExternalContacts>;
  /** update multiples rows of table: "external_contacts" */
  update_external_contacts_many: Maybe<Array<Maybe<ExternalContactsMutationResponse>>>;
  /** update data of the table: "external_entity_sync_statuses" */
  update_external_entity_sync_statuses: Maybe<ExternalEntitySyncStatusesMutationResponse>;
  /** update single row of the table: "external_entity_sync_statuses" */
  update_external_entity_sync_statuses_by_pk: Maybe<ExternalEntitySyncStatuses>;
  /** update multiples rows of table: "external_entity_sync_statuses" */
  update_external_entity_sync_statuses_many: Maybe<Array<Maybe<ExternalEntitySyncStatusesMutationResponse>>>;
  /** update data of the table: "external_risk_scores" */
  update_external_risk_scores: Maybe<ExternalRiskScoresMutationResponse>;
  /** update single row of the table: "external_risk_scores" */
  update_external_risk_scores_by_pk: Maybe<ExternalRiskScores>;
  /** update multiples rows of table: "external_risk_scores" */
  update_external_risk_scores_many: Maybe<Array<Maybe<ExternalRiskScoresMutationResponse>>>;
  /** update data of the table: "financials" */
  update_financials: Maybe<FinancialsMutationResponse>;
  /** update single row of the table: "financials" */
  update_financials_by_pk: Maybe<Financials>;
  /** update multiples rows of table: "financials" */
  update_financials_many: Maybe<Array<Maybe<FinancialsMutationResponse>>>;
  /** update data of the table: "form_template_question_insights" */
  update_form_template_question_insights: Maybe<FormTemplateQuestionInsightsMutationResponse>;
  /** update single row of the table: "form_template_question_insights" */
  update_form_template_question_insights_by_pk: Maybe<FormTemplateQuestionInsights>;
  /** update multiples rows of table: "form_template_question_insights" */
  update_form_template_question_insights_many: Maybe<Array<Maybe<FormTemplateQuestionInsightsMutationResponse>>>;
  /** update data of the table: "form_templates" */
  update_form_templates: Maybe<FormTemplatesMutationResponse>;
  /** update single row of the table: "form_templates" */
  update_form_templates_by_pk: Maybe<FormTemplates>;
  /** update multiples rows of table: "form_templates" */
  update_form_templates_many: Maybe<Array<Maybe<FormTemplatesMutationResponse>>>;
  /** update data of the table: "group_user_assignments" */
  update_group_user_assignments: Maybe<GroupUserAssignmentsMutationResponse>;
  /** update single row of the table: "group_user_assignments" */
  update_group_user_assignments_by_pk: Maybe<GroupUserAssignments>;
  /** update multiples rows of table: "group_user_assignments" */
  update_group_user_assignments_many: Maybe<Array<Maybe<GroupUserAssignmentsMutationResponse>>>;
  /** update data of the table: "group_users" */
  update_group_users: Maybe<GroupUsersMutationResponse>;
  /** update single row of the table: "group_users" */
  update_group_users_by_pk: Maybe<GroupUsers>;
  /** update multiples rows of table: "group_users" */
  update_group_users_many: Maybe<Array<Maybe<GroupUsersMutationResponse>>>;
  /** update data of the table: "groups" */
  update_groups: Maybe<GroupsMutationResponse>;
  /** update single row of the table: "groups" */
  update_groups_by_pk: Maybe<Groups>;
  /** update multiples rows of table: "groups" */
  update_groups_many: Maybe<Array<Maybe<GroupsMutationResponse>>>;
  /** update data of the table: "idp_attribute_mappings" */
  update_idp_attribute_mappings: Maybe<IdpAttributeMappingsMutationResponse>;
  /** update single row of the table: "idp_attribute_mappings" */
  update_idp_attribute_mappings_by_pk: Maybe<IdpAttributeMappings>;
  /** update multiples rows of table: "idp_attribute_mappings" */
  update_idp_attribute_mappings_many: Maybe<Array<Maybe<IdpAttributeMappingsMutationResponse>>>;
  /** update data of the table: "internal_contacts" */
  update_internal_contacts: Maybe<InternalContactsMutationResponse>;
  /** update single row of the table: "internal_contacts" */
  update_internal_contacts_by_pk: Maybe<InternalContacts>;
  /** update multiples rows of table: "internal_contacts" */
  update_internal_contacts_many: Maybe<Array<Maybe<InternalContactsMutationResponse>>>;
  /** update data of the table: "line_item_types" */
  update_line_item_types: Maybe<LineItemTypesMutationResponse>;
  /** update single row of the table: "line_item_types" */
  update_line_item_types_by_pk: Maybe<LineItemTypes>;
  /** update multiples rows of table: "line_item_types" */
  update_line_item_types_many: Maybe<Array<Maybe<LineItemTypesMutationResponse>>>;
  /** update data of the table: "organisation_core_data_dependencies" */
  update_organisation_core_data_dependencies: Maybe<OrganisationCoreDataDependenciesMutationResponse>;
  /** update single row of the table: "organisation_core_data_dependencies" */
  update_organisation_core_data_dependencies_by_pk: Maybe<OrganisationCoreDataDependencies>;
  /** update multiples rows of table: "organisation_core_data_dependencies" */
  update_organisation_core_data_dependencies_many: Maybe<Array<Maybe<OrganisationCoreDataDependenciesMutationResponse>>>;
  /** update data of the table: "organisation_feature_flags" */
  update_organisation_feature_flags: Maybe<OrganisationFeatureFlagsMutationResponse>;
  /** update multiples rows of table: "organisation_feature_flags" */
  update_organisation_feature_flags_many: Maybe<Array<Maybe<OrganisationFeatureFlagsMutationResponse>>>;
  /** update data of the table: "organisation_fx_rates" */
  update_organisation_fx_rates: Maybe<OrganisationFxRatesMutationResponse>;
  /** update single row of the table: "organisation_fx_rates" */
  update_organisation_fx_rates_by_pk: Maybe<OrganisationFxRates>;
  /** update multiples rows of table: "organisation_fx_rates" */
  update_organisation_fx_rates_many: Maybe<Array<Maybe<OrganisationFxRatesMutationResponse>>>;
  /** update data of the table: "organisation_integrations" */
  update_organisation_integrations: Maybe<OrganisationIntegrationsMutationResponse>;
  /** update single row of the table: "organisation_integrations" */
  update_organisation_integrations_by_pk: Maybe<OrganisationIntegrations>;
  /** update multiples rows of table: "organisation_integrations" */
  update_organisation_integrations_many: Maybe<Array<Maybe<OrganisationIntegrationsMutationResponse>>>;
  /** update data of the table: "organisation_locales" */
  update_organisation_locales: Maybe<OrganisationLocalesMutationResponse>;
  /** update single row of the table: "organisation_locales" */
  update_organisation_locales_by_pk: Maybe<OrganisationLocales>;
  /** update multiples rows of table: "organisation_locales" */
  update_organisation_locales_many: Maybe<Array<Maybe<OrganisationLocalesMutationResponse>>>;
  /** update data of the table: "organisation_product_supplier_categories" */
  update_organisation_product_supplier_categories: Maybe<OrganisationProductSupplierCategoriesMutationResponse>;
  /** update single row of the table: "organisation_product_supplier_categories" */
  update_organisation_product_supplier_categories_by_pk: Maybe<OrganisationProductSupplierCategories>;
  /** update multiples rows of table: "organisation_product_supplier_categories" */
  update_organisation_product_supplier_categories_many: Maybe<Array<Maybe<OrganisationProductSupplierCategoriesMutationResponse>>>;
  /** update data of the table: "organisation_products_and_services" */
  update_organisation_products_and_services: Maybe<OrganisationProductsAndServicesMutationResponse>;
  /** update data of the table: "organisation_products_and_services_brands" */
  update_organisation_products_and_services_brands: Maybe<OrganisationProductsAndServicesBrandsMutationResponse>;
  /** update single row of the table: "organisation_products_and_services_brands" */
  update_organisation_products_and_services_brands_by_pk: Maybe<OrganisationProductsAndServicesBrands>;
  /** update multiples rows of table: "organisation_products_and_services_brands" */
  update_organisation_products_and_services_brands_many: Maybe<Array<Maybe<OrganisationProductsAndServicesBrandsMutationResponse>>>;
  /** update single row of the table: "organisation_products_and_services" */
  update_organisation_products_and_services_by_pk: Maybe<OrganisationProductsAndServices>;
  /** update multiples rows of table: "organisation_products_and_services" */
  update_organisation_products_and_services_many: Maybe<Array<Maybe<OrganisationProductsAndServicesMutationResponse>>>;
  /** update data of the table: "organisation_public_api_clients" */
  update_organisation_public_api_clients: Maybe<OrganisationPublicApiClientsMutationResponse>;
  /** update single row of the table: "organisation_public_api_clients" */
  update_organisation_public_api_clients_by_pk: Maybe<OrganisationPublicApiClients>;
  /** update multiples rows of table: "organisation_public_api_clients" */
  update_organisation_public_api_clients_many: Maybe<Array<Maybe<OrganisationPublicApiClientsMutationResponse>>>;
  /** update data of the table: "organisation_settings" */
  update_organisation_settings: Maybe<OrganisationSettingsMutationResponse>;
  /** update single row of the table: "organisation_settings" */
  update_organisation_settings_by_pk: Maybe<OrganisationSettings>;
  /** update multiples rows of table: "organisation_settings" */
  update_organisation_settings_many: Maybe<Array<Maybe<OrganisationSettingsMutationResponse>>>;
  /** update data of the table: "organisation_static_content" */
  update_organisation_static_content: Maybe<OrganisationStaticContentMutationResponse>;
  /** update single row of the table: "organisation_static_content" */
  update_organisation_static_content_by_pk: Maybe<OrganisationStaticContent>;
  /** update multiples rows of table: "organisation_static_content" */
  update_organisation_static_content_many: Maybe<Array<Maybe<OrganisationStaticContentMutationResponse>>>;
  /** update data of the table: "organisation_supplier_historic_submissions" */
  update_organisation_supplier_historic_submissions: Maybe<OrganisationSupplierHistoricSubmissionsMutationResponse>;
  /** update single row of the table: "organisation_supplier_historic_submissions" */
  update_organisation_supplier_historic_submissions_by_pk: Maybe<OrganisationSupplierHistoricSubmissions>;
  /** update multiples rows of table: "organisation_supplier_historic_submissions" */
  update_organisation_supplier_historic_submissions_many: Maybe<Array<Maybe<OrganisationSupplierHistoricSubmissionsMutationResponse>>>;
  /** update data of the table: "organisation_supplier_online_resources" */
  update_organisation_supplier_online_resources: Maybe<OrganisationSupplierOnlineResourcesMutationResponse>;
  /** update single row of the table: "organisation_supplier_online_resources" */
  update_organisation_supplier_online_resources_by_pk: Maybe<OrganisationSupplierOnlineResources>;
  /** update multiples rows of table: "organisation_supplier_online_resources" */
  update_organisation_supplier_online_resources_many: Maybe<Array<Maybe<OrganisationSupplierOnlineResourcesMutationResponse>>>;
  /** update data of the table: "organisation_supplier_profile_resources" */
  update_organisation_supplier_profile_resources: Maybe<OrganisationSupplierProfileResourcesMutationResponse>;
  /** update single row of the table: "organisation_supplier_profile_resources" */
  update_organisation_supplier_profile_resources_by_pk: Maybe<OrganisationSupplierProfileResources>;
  /** update multiples rows of table: "organisation_supplier_profile_resources" */
  update_organisation_supplier_profile_resources_many: Maybe<Array<Maybe<OrganisationSupplierProfileResourcesMutationResponse>>>;
  /** update data of the table: "organisation_supplier_profiles" */
  update_organisation_supplier_profiles: Maybe<OrganisationSupplierProfilesMutationResponse>;
  /** update single row of the table: "organisation_supplier_profiles" */
  update_organisation_supplier_profiles_by_pk: Maybe<OrganisationSupplierProfiles>;
  /** update multiples rows of table: "organisation_supplier_profiles" */
  update_organisation_supplier_profiles_many: Maybe<Array<Maybe<OrganisationSupplierProfilesMutationResponse>>>;
  /** update data of the table: "organisation_supplier_tags" */
  update_organisation_supplier_tags: Maybe<OrganisationSupplierTagsMutationResponse>;
  /** update single row of the table: "organisation_supplier_tags" */
  update_organisation_supplier_tags_by_pk: Maybe<OrganisationSupplierTags>;
  /** update multiples rows of table: "organisation_supplier_tags" */
  update_organisation_supplier_tags_many: Maybe<Array<Maybe<OrganisationSupplierTagsMutationResponse>>>;
  /** update data of the table: "organisation_suppliers" */
  update_organisation_suppliers: Maybe<OrganisationSuppliersMutationResponse>;
  /** update data of the table: "organisation_suppliers_brands" */
  update_organisation_suppliers_brands: Maybe<OrganisationSuppliersBrandsMutationResponse>;
  /** update single row of the table: "organisation_suppliers_brands" */
  update_organisation_suppliers_brands_by_pk: Maybe<OrganisationSuppliersBrands>;
  /** update multiples rows of table: "organisation_suppliers_brands" */
  update_organisation_suppliers_brands_many: Maybe<Array<Maybe<OrganisationSuppliersBrandsMutationResponse>>>;
  /** update single row of the table: "organisation_suppliers" */
  update_organisation_suppliers_by_pk: Maybe<OrganisationSuppliers>;
  /** update data of the table: "organisation_suppliers_categories" */
  update_organisation_suppliers_categories: Maybe<OrganisationSuppliersCategoriesMutationResponse>;
  /** update single row of the table: "organisation_suppliers_categories" */
  update_organisation_suppliers_categories_by_pk: Maybe<OrganisationSuppliersCategories>;
  /** update multiples rows of table: "organisation_suppliers_categories" */
  update_organisation_suppliers_categories_many: Maybe<Array<Maybe<OrganisationSuppliersCategoriesMutationResponse>>>;
  /** update multiples rows of table: "organisation_suppliers" */
  update_organisation_suppliers_many: Maybe<Array<Maybe<OrganisationSuppliersMutationResponse>>>;
  /** update data of the table: "organisations" */
  update_organisations: Maybe<OrganisationsMutationResponse>;
  /** update single row of the table: "organisations" */
  update_organisations_by_pk: Maybe<Organisations>;
  /** update multiples rows of table: "organisations" */
  update_organisations_many: Maybe<Array<Maybe<OrganisationsMutationResponse>>>;
  /** update data of the table: "payment_methods" */
  update_payment_methods: Maybe<PaymentMethodsMutationResponse>;
  /** update single row of the table: "payment_methods" */
  update_payment_methods_by_pk: Maybe<PaymentMethods>;
  /** update multiples rows of table: "payment_methods" */
  update_payment_methods_many: Maybe<Array<Maybe<PaymentMethodsMutationResponse>>>;
  /** update data of the table: "payment_terms" */
  update_payment_terms: Maybe<PaymentTermsMutationResponse>;
  /** update single row of the table: "payment_terms" */
  update_payment_terms_by_pk: Maybe<PaymentTerms>;
  /** update multiples rows of table: "payment_terms" */
  update_payment_terms_many: Maybe<Array<Maybe<PaymentTermsMutationResponse>>>;
  /** update data of the table: "product_catalogue_entries" */
  update_product_catalogue_entries: Maybe<ProductCatalogueEntriesMutationResponse>;
  /** update single row of the table: "product_catalogue_entries" */
  update_product_catalogue_entries_by_pk: Maybe<ProductCatalogueEntries>;
  /** update multiples rows of table: "product_catalogue_entries" */
  update_product_catalogue_entries_many: Maybe<Array<Maybe<ProductCatalogueEntriesMutationResponse>>>;
  /** update data of the table: "purchase_order_line_items" */
  update_purchase_order_line_items: Maybe<PurchaseOrderLineItemsMutationResponse>;
  /** update single row of the table: "purchase_order_line_items" */
  update_purchase_order_line_items_by_pk: Maybe<PurchaseOrderLineItems>;
  /** update multiples rows of table: "purchase_order_line_items" */
  update_purchase_order_line_items_many: Maybe<Array<Maybe<PurchaseOrderLineItemsMutationResponse>>>;
  /** update data of the table: "purchase_orders" */
  update_purchase_orders: Maybe<PurchaseOrdersMutationResponse>;
  /** update single row of the table: "purchase_orders" */
  update_purchase_orders_by_pk: Maybe<PurchaseOrders>;
  /** update multiples rows of table: "purchase_orders" */
  update_purchase_orders_many: Maybe<Array<Maybe<PurchaseOrdersMutationResponse>>>;
  /** update data of the table: "renewal_additional_users" */
  update_renewal_additional_users: Maybe<RenewalAdditionalUsersMutationResponse>;
  /** update single row of the table: "renewal_additional_users" */
  update_renewal_additional_users_by_pk: Maybe<RenewalAdditionalUsers>;
  /** update multiples rows of table: "renewal_additional_users" */
  update_renewal_additional_users_many: Maybe<Array<Maybe<RenewalAdditionalUsersMutationResponse>>>;
  /** update data of the table: "renewals" */
  update_renewals: Maybe<RenewalsMutationResponse>;
  /** update single row of the table: "renewals" */
  update_renewals_by_pk: Maybe<Renewals>;
  /** update multiples rows of table: "renewals" */
  update_renewals_many: Maybe<Array<Maybe<RenewalsMutationResponse>>>;
  /** update data of the table: "request_comments" */
  update_request_comments: Maybe<RequestCommentsMutationResponse>;
  /** update single row of the table: "request_comments" */
  update_request_comments_by_pk: Maybe<RequestComments>;
  /** update multiples rows of table: "request_comments" */
  update_request_comments_many: Maybe<Array<Maybe<RequestCommentsMutationResponse>>>;
  /** update data of the table: "request_comments_mentions" */
  update_request_comments_mentions: Maybe<RequestCommentsMentionsMutationResponse>;
  /** update single row of the table: "request_comments_mentions" */
  update_request_comments_mentions_by_pk: Maybe<RequestCommentsMentions>;
  /** update multiples rows of table: "request_comments_mentions" */
  update_request_comments_mentions_many: Maybe<Array<Maybe<RequestCommentsMentionsMutationResponse>>>;
  /** update data of the table: "request_computed_properties" */
  update_request_computed_properties: Maybe<RequestComputedPropertiesMutationResponse>;
  /** update single row of the table: "request_computed_properties" */
  update_request_computed_properties_by_pk: Maybe<RequestComputedProperties>;
  /** update multiples rows of table: "request_computed_properties" */
  update_request_computed_properties_many: Maybe<Array<Maybe<RequestComputedPropertiesMutationResponse>>>;
  /** update data of the table: "request_documents" */
  update_request_documents: Maybe<RequestDocumentsMutationResponse>;
  /** update single row of the table: "request_documents" */
  update_request_documents_by_pk: Maybe<RequestDocuments>;
  /** update multiples rows of table: "request_documents" */
  update_request_documents_many: Maybe<Array<Maybe<RequestDocumentsMutationResponse>>>;
  /** update data of the table: "request_esign_documents" */
  update_request_esign_documents: Maybe<RequestEsignDocumentsMutationResponse>;
  /** update single row of the table: "request_esign_documents" */
  update_request_esign_documents_by_pk: Maybe<RequestEsignDocuments>;
  /** update multiples rows of table: "request_esign_documents" */
  update_request_esign_documents_many: Maybe<Array<Maybe<RequestEsignDocumentsMutationResponse>>>;
  /** update data of the table: "request_followers" */
  update_request_followers: Maybe<RequestFollowersMutationResponse>;
  /** update single row of the table: "request_followers" */
  update_request_followers_by_pk: Maybe<RequestFollowers>;
  /** update multiples rows of table: "request_followers" */
  update_request_followers_many: Maybe<Array<Maybe<RequestFollowersMutationResponse>>>;
  /** update data of the table: "request_form_question_ai_score" */
  update_request_form_question_ai_score: Maybe<RequestFormQuestionAiScoreMutationResponse>;
  /** update single row of the table: "request_form_question_ai_score" */
  update_request_form_question_ai_score_by_pk: Maybe<RequestFormQuestionAiScore>;
  /** update multiples rows of table: "request_form_question_ai_score" */
  update_request_form_question_ai_score_many: Maybe<Array<Maybe<RequestFormQuestionAiScoreMutationResponse>>>;
  /** update data of the table: "request_form_question_score" */
  update_request_form_question_score: Maybe<RequestFormQuestionScoreMutationResponse>;
  /** update single row of the table: "request_form_question_score" */
  update_request_form_question_score_by_pk: Maybe<RequestFormQuestionScore>;
  /** update multiples rows of table: "request_form_question_score" */
  update_request_form_question_score_many: Maybe<Array<Maybe<RequestFormQuestionScoreMutationResponse>>>;
  /** update data of the table: "request_form_submissions" */
  update_request_form_submissions: Maybe<RequestFormSubmissionsMutationResponse>;
  /** update data of the table: "request_form_submissions_auto_saves" */
  update_request_form_submissions_auto_saves: Maybe<RequestFormSubmissionsAutoSavesMutationResponse>;
  /** update single row of the table: "request_form_submissions_auto_saves" */
  update_request_form_submissions_auto_saves_by_pk: Maybe<RequestFormSubmissionsAutoSaves>;
  /** update multiples rows of table: "request_form_submissions_auto_saves" */
  update_request_form_submissions_auto_saves_many: Maybe<Array<Maybe<RequestFormSubmissionsAutoSavesMutationResponse>>>;
  /** update single row of the table: "request_form_submissions" */
  update_request_form_submissions_by_pk: Maybe<RequestFormSubmissions>;
  /** update multiples rows of table: "request_form_submissions" */
  update_request_form_submissions_many: Maybe<Array<Maybe<RequestFormSubmissionsMutationResponse>>>;
  /** update data of the table: "request_form_template_reviewers" */
  update_request_form_template_reviewers: Maybe<RequestFormTemplateReviewersMutationResponse>;
  /** update single row of the table: "request_form_template_reviewers" */
  update_request_form_template_reviewers_by_pk: Maybe<RequestFormTemplateReviewers>;
  /** update multiples rows of table: "request_form_template_reviewers" */
  update_request_form_template_reviewers_many: Maybe<Array<Maybe<RequestFormTemplateReviewersMutationResponse>>>;
  /** update data of the table: "request_form_templates" */
  update_request_form_templates: Maybe<RequestFormTemplatesMutationResponse>;
  /** update single row of the table: "request_form_templates" */
  update_request_form_templates_by_pk: Maybe<RequestFormTemplates>;
  /** update multiples rows of table: "request_form_templates" */
  update_request_form_templates_many: Maybe<Array<Maybe<RequestFormTemplatesMutationResponse>>>;
  /** update data of the table: "request_forms" */
  update_request_forms: Maybe<RequestFormsMutationResponse>;
  /** update single row of the table: "request_forms" */
  update_request_forms_by_pk: Maybe<RequestForms>;
  /** update multiples rows of table: "request_forms" */
  update_request_forms_many: Maybe<Array<Maybe<RequestFormsMutationResponse>>>;
  /** update data of the table: "request_groups" */
  update_request_groups: Maybe<RequestGroupsMutationResponse>;
  /** update single row of the table: "request_groups" */
  update_request_groups_by_pk: Maybe<RequestGroups>;
  /** update multiples rows of table: "request_groups" */
  update_request_groups_many: Maybe<Array<Maybe<RequestGroupsMutationResponse>>>;
  /** update data of the table: "request_pauses" */
  update_request_pauses: Maybe<RequestPausesMutationResponse>;
  /** update single row of the table: "request_pauses" */
  update_request_pauses_by_pk: Maybe<RequestPauses>;
  /** update multiples rows of table: "request_pauses" */
  update_request_pauses_many: Maybe<Array<Maybe<RequestPausesMutationResponse>>>;
  /** update data of the table: "request_request_leads" */
  update_request_request_leads: Maybe<RequestRequestLeadsMutationResponse>;
  /** update single row of the table: "request_request_leads" */
  update_request_request_leads_by_pk: Maybe<RequestRequestLeads>;
  /** update multiples rows of table: "request_request_leads" */
  update_request_request_leads_many: Maybe<Array<Maybe<RequestRequestLeadsMutationResponse>>>;
  /** update data of the table: "request_step_groups" */
  update_request_step_groups: Maybe<RequestStepGroupsMutationResponse>;
  /** update single row of the table: "request_step_groups" */
  update_request_step_groups_by_pk: Maybe<RequestStepGroups>;
  /** update multiples rows of table: "request_step_groups" */
  update_request_step_groups_many: Maybe<Array<Maybe<RequestStepGroupsMutationResponse>>>;
  /** update data of the table: "request_step_task_errors" */
  update_request_step_task_errors: Maybe<RequestStepTaskErrorsMutationResponse>;
  /** update single row of the table: "request_step_task_errors" */
  update_request_step_task_errors_by_pk: Maybe<RequestStepTaskErrors>;
  /** update multiples rows of table: "request_step_task_errors" */
  update_request_step_task_errors_many: Maybe<Array<Maybe<RequestStepTaskErrorsMutationResponse>>>;
  /** update data of the table: "request_step_task_rejections" */
  update_request_step_task_rejections: Maybe<RequestStepTaskRejectionsMutationResponse>;
  /** update single row of the table: "request_step_task_rejections" */
  update_request_step_task_rejections_by_pk: Maybe<RequestStepTaskRejections>;
  /** update multiples rows of table: "request_step_task_rejections" */
  update_request_step_task_rejections_many: Maybe<Array<Maybe<RequestStepTaskRejectionsMutationResponse>>>;
  /** update data of the table: "request_step_tasks" */
  update_request_step_tasks: Maybe<RequestStepTasksMutationResponse>;
  /** update single row of the table: "request_step_tasks" */
  update_request_step_tasks_by_pk: Maybe<RequestStepTasks>;
  /** update multiples rows of table: "request_step_tasks" */
  update_request_step_tasks_many: Maybe<Array<Maybe<RequestStepTasksMutationResponse>>>;
  /** update data of the table: "request_step_users" */
  update_request_step_users: Maybe<RequestStepUsersMutationResponse>;
  /** update single row of the table: "request_step_users" */
  update_request_step_users_by_pk: Maybe<RequestStepUsers>;
  /** update multiples rows of table: "request_step_users" */
  update_request_step_users_many: Maybe<Array<Maybe<RequestStepUsersMutationResponse>>>;
  /** update data of the table: "request_steps" */
  update_request_steps: Maybe<RequestStepsMutationResponse>;
  /** update single row of the table: "request_steps" */
  update_request_steps_by_pk: Maybe<RequestSteps>;
  /** update multiples rows of table: "request_steps" */
  update_request_steps_many: Maybe<Array<Maybe<RequestStepsMutationResponse>>>;
  /** update data of the table: "request_users" */
  update_request_users: Maybe<RequestUsersMutationResponse>;
  /** update single row of the table: "request_users" */
  update_request_users_by_pk: Maybe<RequestUsers>;
  /** update multiples rows of table: "request_users" */
  update_request_users_many: Maybe<Array<Maybe<RequestUsersMutationResponse>>>;
  /** update data of the table: "requests" */
  update_requests: Maybe<RequestsMutationResponse>;
  /** update single row of the table: "requests" */
  update_requests_by_pk: Maybe<Requests>;
  /** update multiples rows of table: "requests" */
  update_requests_many: Maybe<Array<Maybe<RequestsMutationResponse>>>;
  /** update data of the table: "rfx" */
  update_rfx: Maybe<RfxMutationResponse>;
  /** update data of the table: "rfx_ai_scoring" */
  update_rfx_ai_scoring: Maybe<RfxAiScoringMutationResponse>;
  /** update single row of the table: "rfx_ai_scoring" */
  update_rfx_ai_scoring_by_pk: Maybe<RfxAiScoring>;
  /** update multiples rows of table: "rfx_ai_scoring" */
  update_rfx_ai_scoring_many: Maybe<Array<Maybe<RfxAiScoringMutationResponse>>>;
  /** update single row of the table: "rfx" */
  update_rfx_by_pk: Maybe<Rfx>;
  /** update data of the table: "rfx_confidentiality_agreement" */
  update_rfx_confidentiality_agreement: Maybe<RfxConfidentialityAgreementMutationResponse>;
  /** update single row of the table: "rfx_confidentiality_agreement" */
  update_rfx_confidentiality_agreement_by_pk: Maybe<RfxConfidentialityAgreement>;
  /** update multiples rows of table: "rfx_confidentiality_agreement" */
  update_rfx_confidentiality_agreement_many: Maybe<Array<Maybe<RfxConfidentialityAgreementMutationResponse>>>;
  /** update multiples rows of table: "rfx" */
  update_rfx_many: Maybe<Array<Maybe<RfxMutationResponse>>>;
  /** update data of the table: "rfx_owners" */
  update_rfx_owners: Maybe<RfxOwnersMutationResponse>;
  /** update single row of the table: "rfx_owners" */
  update_rfx_owners_by_pk: Maybe<RfxOwners>;
  /** update multiples rows of table: "rfx_owners" */
  update_rfx_owners_many: Maybe<Array<Maybe<RfxOwnersMutationResponse>>>;
  /** update data of the table: "rfx_request_form_template_weighting" */
  update_rfx_request_form_template_weighting: Maybe<RfxRequestFormTemplateWeightingMutationResponse>;
  /** update single row of the table: "rfx_request_form_template_weighting" */
  update_rfx_request_form_template_weighting_by_pk: Maybe<RfxRequestFormTemplateWeighting>;
  /** update multiples rows of table: "rfx_request_form_template_weighting" */
  update_rfx_request_form_template_weighting_many: Maybe<Array<Maybe<RfxRequestFormTemplateWeightingMutationResponse>>>;
  /** update data of the table: "rfx_request_form_templates_ranks" */
  update_rfx_request_form_templates_ranks: Maybe<RfxRequestFormTemplatesRanksMutationResponse>;
  /** update single row of the table: "rfx_request_form_templates_ranks" */
  update_rfx_request_form_templates_ranks_by_pk: Maybe<RfxRequestFormTemplatesRanks>;
  /** update multiples rows of table: "rfx_request_form_templates_ranks" */
  update_rfx_request_form_templates_ranks_many: Maybe<Array<Maybe<RfxRequestFormTemplatesRanksMutationResponse>>>;
  /** update data of the table: "rfx_suppliers" */
  update_rfx_suppliers: Maybe<RfxSuppliersMutationResponse>;
  /** update single row of the table: "rfx_suppliers" */
  update_rfx_suppliers_by_pk: Maybe<RfxSuppliers>;
  /** update multiples rows of table: "rfx_suppliers" */
  update_rfx_suppliers_many: Maybe<Array<Maybe<RfxSuppliersMutationResponse>>>;
  /** update data of the table: "risk_attributes" */
  update_risk_attributes: Maybe<RiskAttributesMutationResponse>;
  /** update single row of the table: "risk_attributes" */
  update_risk_attributes_by_pk: Maybe<RiskAttributes>;
  /** update multiples rows of table: "risk_attributes" */
  update_risk_attributes_many: Maybe<Array<Maybe<RiskAttributesMutationResponse>>>;
  /** update data of the table: "risk_categories" */
  update_risk_categories: Maybe<RiskCategoriesMutationResponse>;
  /** update single row of the table: "risk_categories" */
  update_risk_categories_by_pk: Maybe<RiskCategories>;
  /** update multiples rows of table: "risk_categories" */
  update_risk_categories_many: Maybe<Array<Maybe<RiskCategoriesMutationResponse>>>;
  /** update data of the table: "risk_levels" */
  update_risk_levels: Maybe<RiskLevelsMutationResponse>;
  /** update single row of the table: "risk_levels" */
  update_risk_levels_by_pk: Maybe<RiskLevels>;
  /** update multiples rows of table: "risk_levels" */
  update_risk_levels_many: Maybe<Array<Maybe<RiskLevelsMutationResponse>>>;
  /** update data of the table: "risk_matrix_cells" */
  update_risk_matrix_cells: Maybe<RiskMatrixCellsMutationResponse>;
  /** update single row of the table: "risk_matrix_cells" */
  update_risk_matrix_cells_by_pk: Maybe<RiskMatrixCells>;
  /** update multiples rows of table: "risk_matrix_cells" */
  update_risk_matrix_cells_many: Maybe<Array<Maybe<RiskMatrixCellsMutationResponse>>>;
  /** update data of the table: "risk_owners" */
  update_risk_owners: Maybe<RiskOwnersMutationResponse>;
  /** update single row of the table: "risk_owners" */
  update_risk_owners_by_pk: Maybe<RiskOwners>;
  /** update multiples rows of table: "risk_owners" */
  update_risk_owners_many: Maybe<Array<Maybe<RiskOwnersMutationResponse>>>;
  /** update data of the table: "risk_settings" */
  update_risk_settings: Maybe<RiskSettingsMutationResponse>;
  /** update single row of the table: "risk_settings" */
  update_risk_settings_by_pk: Maybe<RiskSettings>;
  /** update multiples rows of table: "risk_settings" */
  update_risk_settings_many: Maybe<Array<Maybe<RiskSettingsMutationResponse>>>;
  /** update data of the table: "risk_template_categories" */
  update_risk_template_categories: Maybe<RiskTemplateCategoriesMutationResponse>;
  /** update single row of the table: "risk_template_categories" */
  update_risk_template_categories_by_pk: Maybe<RiskTemplateCategories>;
  /** update multiples rows of table: "risk_template_categories" */
  update_risk_template_categories_many: Maybe<Array<Maybe<RiskTemplateCategoriesMutationResponse>>>;
  /** update data of the table: "risk_template_owners" */
  update_risk_template_owners: Maybe<RiskTemplateOwnersMutationResponse>;
  /** update single row of the table: "risk_template_owners" */
  update_risk_template_owners_by_pk: Maybe<RiskTemplateOwners>;
  /** update multiples rows of table: "risk_template_owners" */
  update_risk_template_owners_many: Maybe<Array<Maybe<RiskTemplateOwnersMutationResponse>>>;
  /** update data of the table: "risk_templates" */
  update_risk_templates: Maybe<RiskTemplatesMutationResponse>;
  /** update single row of the table: "risk_templates" */
  update_risk_templates_by_pk: Maybe<RiskTemplates>;
  /** update multiples rows of table: "risk_templates" */
  update_risk_templates_many: Maybe<Array<Maybe<RiskTemplatesMutationResponse>>>;
  /** update data of the table: "risk_versions" */
  update_risk_versions: Maybe<RiskVersionsMutationResponse>;
  /** update single row of the table: "risk_versions" */
  update_risk_versions_by_pk: Maybe<RiskVersions>;
  /** update multiples rows of table: "risk_versions" */
  update_risk_versions_many: Maybe<Array<Maybe<RiskVersionsMutationResponse>>>;
  /** update data of the table: "risks" */
  update_risks: Maybe<RisksMutationResponse>;
  /** update single row of the table: "risks" */
  update_risks_by_pk: Maybe<Risks>;
  /** update multiples rows of table: "risks" */
  update_risks_many: Maybe<Array<Maybe<RisksMutationResponse>>>;
  /** update data of the table: "subsidiaries" */
  update_subsidiaries: Maybe<SubsidiariesMutationResponse>;
  /** update single row of the table: "subsidiaries" */
  update_subsidiaries_by_pk: Maybe<Subsidiaries>;
  /** update multiples rows of table: "subsidiaries" */
  update_subsidiaries_many: Maybe<Array<Maybe<SubsidiariesMutationResponse>>>;
  /** update data of the table: "table_filters" */
  update_table_filters: Maybe<TableFiltersMutationResponse>;
  /** update single row of the table: "table_filters" */
  update_table_filters_by_pk: Maybe<TableFilters>;
  /** update multiples rows of table: "table_filters" */
  update_table_filters_many: Maybe<Array<Maybe<TableFiltersMutationResponse>>>;
  /** update data of the table: "tags" */
  update_tags: Maybe<TagsMutationResponse>;
  /** update single row of the table: "tags" */
  update_tags_by_pk: Maybe<Tags>;
  /** update multiples rows of table: "tags" */
  update_tags_many: Maybe<Array<Maybe<TagsMutationResponse>>>;
  /** update data of the table: "user_allowed_subsidiaries" */
  update_user_allowed_subsidiaries: Maybe<UserAllowedSubsidiariesMutationResponse>;
  /** update single row of the table: "user_allowed_subsidiaries" */
  update_user_allowed_subsidiaries_by_pk: Maybe<UserAllowedSubsidiaries>;
  /** update multiples rows of table: "user_allowed_subsidiaries" */
  update_user_allowed_subsidiaries_many: Maybe<Array<Maybe<UserAllowedSubsidiariesMutationResponse>>>;
  /** update data of the table: "users" */
  update_users: Maybe<UsersMutationResponse>;
  /** update single row of the table: "users" */
  update_users_by_pk: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many: Maybe<Array<Maybe<UsersMutationResponse>>>;
  /** update data of the table: "workflow_condition_groups" */
  update_workflow_condition_groups: Maybe<WorkflowConditionGroupsMutationResponse>;
  /** update single row of the table: "workflow_condition_groups" */
  update_workflow_condition_groups_by_pk: Maybe<WorkflowConditionGroups>;
  /** update multiples rows of table: "workflow_condition_groups" */
  update_workflow_condition_groups_many: Maybe<Array<Maybe<WorkflowConditionGroupsMutationResponse>>>;
  /** update data of the table: "workflow_ranks" */
  update_workflow_ranks: Maybe<WorkflowRanksMutationResponse>;
  /** update single row of the table: "workflow_ranks" */
  update_workflow_ranks_by_pk: Maybe<WorkflowRanks>;
  /** update multiples rows of table: "workflow_ranks" */
  update_workflow_ranks_many: Maybe<Array<Maybe<WorkflowRanksMutationResponse>>>;
  /** update data of the table: "workflows" */
  update_workflows: Maybe<WorkflowsMutationResponse>;
  /** update single row of the table: "workflows" */
  update_workflows_by_pk: Maybe<Workflows>;
  /** update multiples rows of table: "workflows" */
  update_workflows_many: Maybe<Array<Maybe<WorkflowsMutationResponse>>>;
};


/** mutation root */
export type MutationRootDeleteAddressesArgs = {
  where: AddressesBoolExp;
};


/** mutation root */
export type MutationRootDeleteAddressesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteAgreementAdditionalOwnersArgs = {
  where: AgreementAdditionalOwnersBoolExp;
};


/** mutation root */
export type MutationRootDeleteAgreementAdditionalOwnersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteAgreementDocumentsArgs = {
  where: AgreementDocumentsBoolExp;
};


/** mutation root */
export type MutationRootDeleteAgreementDocumentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteAgreementTagsArgs = {
  where: AgreementTagsBoolExp;
};


/** mutation root */
export type MutationRootDeleteAgreementTagsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteAssessmentAdditionalGroupsArgs = {
  where: AssessmentAdditionalGroupsBoolExp;
};


/** mutation root */
export type MutationRootDeleteAssessmentAdditionalGroupsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteAssessmentAdditionalUsersArgs = {
  where: AssessmentAdditionalUsersBoolExp;
};


/** mutation root */
export type MutationRootDeleteAssessmentAdditionalUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteAssessmentTagsArgs = {
  where: AssessmentTagsBoolExp;
};


/** mutation root */
export type MutationRootDeleteAssessmentTagsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteAuthRefreshTokensArgs = {
  where: AuthRefreshTokensBoolExp;
};


/** mutation root */
export type MutationRootDeleteAuthRefreshTokensByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteBudgetApprovalGroupAssigneesArgs = {
  where: BudgetApprovalGroupAssigneesBoolExp;
};


/** mutation root */
export type MutationRootDeleteBudgetApprovalGroupAssigneesAssigneesArgs = {
  where: BudgetApprovalGroupAssigneesAssigneesBoolExp;
};


/** mutation root */
export type MutationRootDeleteBudgetApprovalGroupAssigneesAssigneesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteBudgetApprovalGroupAssigneesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteBudgetApprovalGroupAssigneesCustomCoreDataOptionsArgs = {
  where: BudgetApprovalGroupAssigneesCustomCoreDataOptionsBoolExp;
};


/** mutation root */
export type MutationRootDeleteBudgetApprovalGroupAssigneesCustomCoreDataOptionsByPkArgs = {
  budget_approval_group_assignees_id: Scalars['uuid']['input'];
  custom_core_data_id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteBudgetApprovalGroupSelectedCustomCoreDataArgs = {
  where: BudgetApprovalGroupSelectedCustomCoreDataBoolExp;
};


/** mutation root */
export type MutationRootDeleteBudgetApprovalGroupSelectedCustomCoreDataByPkArgs = {
  budget_approval_group_id: Scalars['uuid']['input'];
  custom_core_data_id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteBudgetApprovalThresholdDepartmentArgs = {
  where: BudgetApprovalThresholdDepartmentBoolExp;
};


/** mutation root */
export type MutationRootDeleteBudgetApprovalThresholdDepartmentByPkArgs = {
  departmentId: Scalars['uuid']['input'];
  thresholdId: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteBudgetApprovalThresholdGroupArgs = {
  where: BudgetApprovalThresholdGroupBoolExp;
};


/** mutation root */
export type MutationRootDeleteBudgetApprovalThresholdGroupByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteConfigTranslationsArgs = {
  where: ConfigTranslationsBoolExp;
};


/** mutation root */
export type MutationRootDeleteConfigTranslationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteCoreDataDependenciesArgs = {
  where: CoreDataDependenciesBoolExp;
};


/** mutation root */
export type MutationRootDeleteCoreDataDependenciesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteCoreDataExternalReferencesArgs = {
  where: CoreDataExternalReferencesBoolExp;
};


/** mutation root */
export type MutationRootDeleteCoreDataExternalReferencesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteCoreDataOrganisationIntegrationsArgs = {
  where: CoreDataOrganisationIntegrationsBoolExp;
};


/** mutation root */
export type MutationRootDeleteCoreDataOrganisationIntegrationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteCustomCoreDataArgs = {
  where: CustomCoreDataBoolExp;
};


/** mutation root */
export type MutationRootDeleteCustomCoreDataByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteCustomCoreDataOptionsArgs = {
  where: CustomCoreDataOptionsBoolExp;
};


/** mutation root */
export type MutationRootDeleteCustomCoreDataOptionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteCustomFieldChoicesArgs = {
  where: CustomFieldChoicesBoolExp;
};


/** mutation root */
export type MutationRootDeleteCustomFieldChoicesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteCustomFieldCoreDataArgs = {
  where: CustomFieldCoreDataBoolExp;
};


/** mutation root */
export type MutationRootDeleteCustomFieldCoreDataByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteCustomFieldValuesArgs = {
  where: CustomFieldValuesBoolExp;
};


/** mutation root */
export type MutationRootDeleteCustomFieldValuesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteDepartmentsArgs = {
  where: DepartmentsBoolExp;
};


/** mutation root */
export type MutationRootDeleteDepartmentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteDocumentTypesArgs = {
  where: DocumentTypesBoolExp;
};


/** mutation root */
export type MutationRootDeleteDocumentTypesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteDocumentsArgs = {
  where: DocumentsBoolExp;
};


/** mutation root */
export type MutationRootDeleteDocumentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteEntityBankDetailsArgs = {
  where: EntityBankDetailsBoolExp;
};


/** mutation root */
export type MutationRootDeleteEntityBankDetailsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteEntityFieldGroupFieldsArgs = {
  where: EntityFieldGroupFieldsBoolExp;
};


/** mutation root */
export type MutationRootDeleteEntityFieldGroupFieldsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteEntityFieldGroupsArgs = {
  where: EntityFieldGroupsBoolExp;
};


/** mutation root */
export type MutationRootDeleteEntityFieldGroupsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteExternalContactsArgs = {
  where: ExternalContactsBoolExp;
};


/** mutation root */
export type MutationRootDeleteExternalContactsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteExternalRiskScoresArgs = {
  where: ExternalRiskScoresBoolExp;
};


/** mutation root */
export type MutationRootDeleteExternalRiskScoresByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteFavouriteTableFiltersArgs = {
  where: FavouriteTableFiltersBoolExp;
};


/** mutation root */
export type MutationRootDeleteFavouriteTableFiltersByPkArgs = {
  table_filter_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteFormTemplateQuestionInsightsArgs = {
  where: FormTemplateQuestionInsightsBoolExp;
};


/** mutation root */
export type MutationRootDeleteFormTemplateQuestionInsightsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteGroupUsersArgs = {
  where: GroupUsersBoolExp;
};


/** mutation root */
export type MutationRootDeleteGroupUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteIdpAttributeMappingsArgs = {
  where: IdpAttributeMappingsBoolExp;
};


/** mutation root */
export type MutationRootDeleteIdpAttributeMappingsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteInternalContactsArgs = {
  where: InternalContactsBoolExp;
};


/** mutation root */
export type MutationRootDeleteInternalContactsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteLineItemTypesArgs = {
  where: LineItemTypesBoolExp;
};


/** mutation root */
export type MutationRootDeleteLineItemTypesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteOrganisationFeatureFlagsArgs = {
  where: OrganisationFeatureFlagsBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganisationFxRatesArgs = {
  where: OrganisationFxRatesBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganisationFxRatesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteOrganisationIntegrationOperationsArgs = {
  where: OrganisationIntegrationOperationsBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganisationIntegrationOperationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteOrganisationIntegrationsArgs = {
  where: OrganisationIntegrationsBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganisationIntegrationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteOrganisationProductSupplierCategoriesArgs = {
  where: OrganisationProductSupplierCategoriesBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganisationProductSupplierCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteOrganisationProductsAndServicesCategoriesArgs = {
  where: OrganisationProductsAndServicesCategoriesBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganisationProductsAndServicesCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteOrganisationSupplierHistoricSubmissionsArgs = {
  where: OrganisationSupplierHistoricSubmissionsBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganisationSupplierHistoricSubmissionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteOrganisationSupplierProfileResourcesArgs = {
  where: OrganisationSupplierProfileResourcesBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganisationSupplierProfileResourcesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteOrganisationSupplierProfilesArgs = {
  where: OrganisationSupplierProfilesBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganisationSupplierProfilesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteOrganisationSupplierTagsArgs = {
  where: OrganisationSupplierTagsBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganisationSupplierTagsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteOrganisationSuppliersCategoriesArgs = {
  where: OrganisationSuppliersCategoriesBoolExp;
};


/** mutation root */
export type MutationRootDeleteOrganisationSuppliersCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteOutOfOfficeDelegationsArgs = {
  where: OutOfOfficeDelegationsBoolExp;
};


/** mutation root */
export type MutationRootDeleteOutOfOfficeDelegationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeletePaymentMethodsArgs = {
  where: PaymentMethodsBoolExp;
};


/** mutation root */
export type MutationRootDeletePaymentMethodsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeletePaymentTermsArgs = {
  where: PaymentTermsBoolExp;
};


/** mutation root */
export type MutationRootDeletePaymentTermsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteProductCatalogueAccessApproversArgs = {
  where: ProductCatalogueAccessApproversBoolExp;
};


/** mutation root */
export type MutationRootDeleteProductCatalogueAccessApproversByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRenewalAdditionalUsersArgs = {
  where: RenewalAdditionalUsersBoolExp;
};


/** mutation root */
export type MutationRootDeleteRenewalAdditionalUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRenewalTagsArgs = {
  where: RenewalTagsBoolExp;
};


/** mutation root */
export type MutationRootDeleteRenewalTagsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestCommentsMentionsArgs = {
  where: RequestCommentsMentionsBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestCommentsMentionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestDocumentsArgs = {
  where: RequestDocumentsBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestDocumentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestFormQuestionAiScoreArgs = {
  where: RequestFormQuestionAiScoreBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestFormQuestionAiScoreByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestFormQuestionScoreArgs = {
  where: RequestFormQuestionScoreBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestFormQuestionScoreByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestFormTemplateReviewersArgs = {
  where: RequestFormTemplateReviewersBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestFormTemplateReviewersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestFormTemplatesArgs = {
  where: RequestFormTemplatesBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestFormTemplatesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestLeadsConfigArgs = {
  where: RequestLeadsConfigBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestLeadsConfigByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestRequestLeadsArgs = {
  where: RequestRequestLeadsBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestRequestLeadsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestStepGroupsArgs = {
  where: RequestStepGroupsBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestStepGroupsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestStepTaskErrorsArgs = {
  where: RequestStepTaskErrorsBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestStepTaskErrorsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestStepTaskRejectionsArgs = {
  where: RequestStepTaskRejectionsBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestStepTaskRejectionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestStepTaskUsersArgs = {
  where: RequestStepTaskUsersBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestStepTaskUsersByPkArgs = {
  organisation_id: Scalars['uuid']['input'];
  request_step_task_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestStepTasksArgs = {
  where: RequestStepTasksBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestStepTasksByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestStepUsersArgs = {
  where: RequestStepUsersBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestStepUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestStepsArgs = {
  where: RequestStepsBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestStepsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRequestTagsArgs = {
  where: RequestTagsBoolExp;
};


/** mutation root */
export type MutationRootDeleteRequestTagsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRfxArgs = {
  where: RfxBoolExp;
};


/** mutation root */
export type MutationRootDeleteRfxByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRfxExternalUsersArgs = {
  where: RfxExternalUsersBoolExp;
};


/** mutation root */
export type MutationRootDeleteRfxExternalUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRfxOwnersArgs = {
  where: RfxOwnersBoolExp;
};


/** mutation root */
export type MutationRootDeleteRfxOwnersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRfxSuppliersArgs = {
  where: RfxSuppliersBoolExp;
};


/** mutation root */
export type MutationRootDeleteRfxSuppliersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRiskAttributesArgs = {
  where: RiskAttributesBoolExp;
};


/** mutation root */
export type MutationRootDeleteRiskAttributesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRiskCategoriesArgs = {
  where: RiskCategoriesBoolExp;
};


/** mutation root */
export type MutationRootDeleteRiskCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRiskLevelsArgs = {
  where: RiskLevelsBoolExp;
};


/** mutation root */
export type MutationRootDeleteRiskLevelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRiskMatrixCellsArgs = {
  where: RiskMatrixCellsBoolExp;
};


/** mutation root */
export type MutationRootDeleteRiskMatrixCellsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRiskOwnersArgs = {
  where: RiskOwnersBoolExp;
};


/** mutation root */
export type MutationRootDeleteRiskOwnersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRiskTemplateCategoriesArgs = {
  where: RiskTemplateCategoriesBoolExp;
};


/** mutation root */
export type MutationRootDeleteRiskTemplateCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteRiskTemplateOwnersArgs = {
  where: RiskTemplateOwnersBoolExp;
};


/** mutation root */
export type MutationRootDeleteRiskTemplateOwnersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteSubsidiariesArgs = {
  where: SubsidiariesBoolExp;
};


/** mutation root */
export type MutationRootDeleteSubsidiariesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteUserAllowedSubsidiariesArgs = {
  where: UserAllowedSubsidiariesBoolExp;
};


/** mutation root */
export type MutationRootDeleteUserAllowedSubsidiariesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteUsersArgs = {
  where: UsersBoolExp;
};


/** mutation root */
export type MutationRootDeleteUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootDeleteWorkflowFormTemplatesArgs = {
  where: WorkflowFormTemplatesBoolExp;
};


/** mutation root */
export type MutationRootDeleteWorkflowFormTemplatesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type MutationRootInsertAddressesArgs = {
  objects: Array<AddressesInsertInput>;
  on_conflict: InputMaybe<AddressesOnConflict>;
};


/** mutation root */
export type MutationRootInsertAddressesOneArgs = {
  object: AddressesInsertInput;
  on_conflict: InputMaybe<AddressesOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementAdditionalOwnersArgs = {
  objects: Array<AgreementAdditionalOwnersInsertInput>;
  on_conflict: InputMaybe<AgreementAdditionalOwnersOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementAdditionalOwnersOneArgs = {
  object: AgreementAdditionalOwnersInsertInput;
  on_conflict: InputMaybe<AgreementAdditionalOwnersOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementDocumentsArgs = {
  objects: Array<AgreementDocumentsInsertInput>;
  on_conflict: InputMaybe<AgreementDocumentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementDocumentsOneArgs = {
  object: AgreementDocumentsInsertInput;
  on_conflict: InputMaybe<AgreementDocumentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementTagsArgs = {
  objects: Array<AgreementTagsInsertInput>;
  on_conflict: InputMaybe<AgreementTagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementTagsOneArgs = {
  object: AgreementTagsInsertInput;
  on_conflict: InputMaybe<AgreementTagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementTermProductsArgs = {
  objects: Array<AgreementTermProductsInsertInput>;
  on_conflict: InputMaybe<AgreementTermProductsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementTermProductsOneArgs = {
  object: AgreementTermProductsInsertInput;
  on_conflict: InputMaybe<AgreementTermProductsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementTermRevisionsArgs = {
  objects: Array<AgreementTermRevisionsInsertInput>;
  on_conflict: InputMaybe<AgreementTermRevisionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementTermRevisionsOneArgs = {
  object: AgreementTermRevisionsInsertInput;
  on_conflict: InputMaybe<AgreementTermRevisionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementTermSpendItemsArgs = {
  objects: Array<AgreementTermSpendItemsInsertInput>;
  on_conflict: InputMaybe<AgreementTermSpendItemsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementTermSpendItemsOneArgs = {
  object: AgreementTermSpendItemsInsertInput;
  on_conflict: InputMaybe<AgreementTermSpendItemsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementTermsArgs = {
  objects: Array<AgreementTermsInsertInput>;
  on_conflict: InputMaybe<AgreementTermsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementTermsOneArgs = {
  object: AgreementTermsInsertInput;
  on_conflict: InputMaybe<AgreementTermsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementsArgs = {
  objects: Array<AgreementsInsertInput>;
  on_conflict: InputMaybe<AgreementsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAgreementsOneArgs = {
  object: AgreementsInsertInput;
  on_conflict: InputMaybe<AgreementsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAssessmentAdditionalGroupsArgs = {
  objects: Array<AssessmentAdditionalGroupsInsertInput>;
  on_conflict: InputMaybe<AssessmentAdditionalGroupsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAssessmentAdditionalGroupsOneArgs = {
  object: AssessmentAdditionalGroupsInsertInput;
  on_conflict: InputMaybe<AssessmentAdditionalGroupsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAssessmentAdditionalUsersArgs = {
  objects: Array<AssessmentAdditionalUsersInsertInput>;
  on_conflict: InputMaybe<AssessmentAdditionalUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertAssessmentAdditionalUsersOneArgs = {
  object: AssessmentAdditionalUsersInsertInput;
  on_conflict: InputMaybe<AssessmentAdditionalUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertAssessmentTagsArgs = {
  objects: Array<AssessmentTagsInsertInput>;
  on_conflict: InputMaybe<AssessmentTagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAssessmentTagsOneArgs = {
  object: AssessmentTagsInsertInput;
  on_conflict: InputMaybe<AssessmentTagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAssessmentsArgs = {
  objects: Array<AssessmentsInsertInput>;
  on_conflict: InputMaybe<AssessmentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAssessmentsOneArgs = {
  object: AssessmentsInsertInput;
  on_conflict: InputMaybe<AssessmentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertAuthRefreshTokensArgs = {
  objects: Array<AuthRefreshTokensInsertInput>;
  on_conflict: InputMaybe<AuthRefreshTokensOnConflict>;
};


/** mutation root */
export type MutationRootInsertAuthRefreshTokensOneArgs = {
  object: AuthRefreshTokensInsertInput;
  on_conflict: InputMaybe<AuthRefreshTokensOnConflict>;
};


/** mutation root */
export type MutationRootInsertAutoFlaggedScoreCategoriesArgs = {
  objects: Array<AutoFlaggedScoreCategoriesInsertInput>;
  on_conflict: InputMaybe<AutoFlaggedScoreCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertAutoFlaggedScoreCategoriesOneArgs = {
  object: AutoFlaggedScoreCategoriesInsertInput;
  on_conflict: InputMaybe<AutoFlaggedScoreCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertBankDetailsArgs = {
  objects: Array<BankDetailsInsertInput>;
  on_conflict: InputMaybe<BankDetailsOnConflict>;
};


/** mutation root */
export type MutationRootInsertBankDetailsOneArgs = {
  object: BankDetailsInsertInput;
  on_conflict: InputMaybe<BankDetailsOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalGroupArgs = {
  objects: Array<BudgetApprovalGroupInsertInput>;
  on_conflict: InputMaybe<BudgetApprovalGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalGroupAssigneesArgs = {
  objects: Array<BudgetApprovalGroupAssigneesInsertInput>;
  on_conflict: InputMaybe<BudgetApprovalGroupAssigneesOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalGroupAssigneesAssigneesArgs = {
  objects: Array<BudgetApprovalGroupAssigneesAssigneesInsertInput>;
  on_conflict: InputMaybe<BudgetApprovalGroupAssigneesAssigneesOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalGroupAssigneesAssigneesOneArgs = {
  object: BudgetApprovalGroupAssigneesAssigneesInsertInput;
  on_conflict: InputMaybe<BudgetApprovalGroupAssigneesAssigneesOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalGroupAssigneesCustomCoreDataOptionsArgs = {
  objects: Array<BudgetApprovalGroupAssigneesCustomCoreDataOptionsInsertInput>;
  on_conflict: InputMaybe<BudgetApprovalGroupAssigneesCustomCoreDataOptionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalGroupAssigneesCustomCoreDataOptionsOneArgs = {
  object: BudgetApprovalGroupAssigneesCustomCoreDataOptionsInsertInput;
  on_conflict: InputMaybe<BudgetApprovalGroupAssigneesCustomCoreDataOptionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalGroupAssigneesOneArgs = {
  object: BudgetApprovalGroupAssigneesInsertInput;
  on_conflict: InputMaybe<BudgetApprovalGroupAssigneesOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalGroupOneArgs = {
  object: BudgetApprovalGroupInsertInput;
  on_conflict: InputMaybe<BudgetApprovalGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalGroupSelectedCustomCoreDataArgs = {
  objects: Array<BudgetApprovalGroupSelectedCustomCoreDataInsertInput>;
  on_conflict: InputMaybe<BudgetApprovalGroupSelectedCustomCoreDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalGroupSelectedCustomCoreDataOneArgs = {
  object: BudgetApprovalGroupSelectedCustomCoreDataInsertInput;
  on_conflict: InputMaybe<BudgetApprovalGroupSelectedCustomCoreDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalThresholdArgs = {
  objects: Array<BudgetApprovalThresholdInsertInput>;
  on_conflict: InputMaybe<BudgetApprovalThresholdOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalThresholdDepartmentArgs = {
  objects: Array<BudgetApprovalThresholdDepartmentInsertInput>;
  on_conflict: InputMaybe<BudgetApprovalThresholdDepartmentOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalThresholdDepartmentOneArgs = {
  object: BudgetApprovalThresholdDepartmentInsertInput;
  on_conflict: InputMaybe<BudgetApprovalThresholdDepartmentOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalThresholdGroupArgs = {
  objects: Array<BudgetApprovalThresholdGroupInsertInput>;
  on_conflict: InputMaybe<BudgetApprovalThresholdGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalThresholdGroupOneArgs = {
  object: BudgetApprovalThresholdGroupInsertInput;
  on_conflict: InputMaybe<BudgetApprovalThresholdGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetApprovalThresholdOneArgs = {
  object: BudgetApprovalThresholdInsertInput;
  on_conflict: InputMaybe<BudgetApprovalThresholdOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetsArgs = {
  objects: Array<BudgetsInsertInput>;
  on_conflict: InputMaybe<BudgetsOnConflict>;
};


/** mutation root */
export type MutationRootInsertBudgetsOneArgs = {
  object: BudgetsInsertInput;
  on_conflict: InputMaybe<BudgetsOnConflict>;
};


/** mutation root */
export type MutationRootInsertBulkDocumentsUploadsArgs = {
  objects: Array<BulkDocumentsUploadsInsertInput>;
  on_conflict: InputMaybe<BulkDocumentsUploadsOnConflict>;
};


/** mutation root */
export type MutationRootInsertBulkDocumentsUploadsOneArgs = {
  object: BulkDocumentsUploadsInsertInput;
  on_conflict: InputMaybe<BulkDocumentsUploadsOnConflict>;
};


/** mutation root */
export type MutationRootInsertConfigTranslationsArgs = {
  objects: Array<ConfigTranslationsInsertInput>;
  on_conflict: InputMaybe<ConfigTranslationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertConfigTranslationsOneArgs = {
  object: ConfigTranslationsInsertInput;
  on_conflict: InputMaybe<ConfigTranslationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertCoreDataDependenciesArgs = {
  objects: Array<CoreDataDependenciesInsertInput>;
  on_conflict: InputMaybe<CoreDataDependenciesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCoreDataDependenciesOneArgs = {
  object: CoreDataDependenciesInsertInput;
  on_conflict: InputMaybe<CoreDataDependenciesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCoreDataExternalReferencesArgs = {
  objects: Array<CoreDataExternalReferencesInsertInput>;
  on_conflict: InputMaybe<CoreDataExternalReferencesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCoreDataExternalReferencesOneArgs = {
  object: CoreDataExternalReferencesInsertInput;
  on_conflict: InputMaybe<CoreDataExternalReferencesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCoreDataOrganisationIntegrationsArgs = {
  objects: Array<CoreDataOrganisationIntegrationsInsertInput>;
  on_conflict: InputMaybe<CoreDataOrganisationIntegrationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertCoreDataOrganisationIntegrationsOneArgs = {
  object: CoreDataOrganisationIntegrationsInsertInput;
  on_conflict: InputMaybe<CoreDataOrganisationIntegrationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomCoreDataArgs = {
  objects: Array<CustomCoreDataInsertInput>;
  on_conflict: InputMaybe<CustomCoreDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomCoreDataOneArgs = {
  object: CustomCoreDataInsertInput;
  on_conflict: InputMaybe<CustomCoreDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomCoreDataOptionsArgs = {
  objects: Array<CustomCoreDataOptionsInsertInput>;
  on_conflict: InputMaybe<CustomCoreDataOptionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomCoreDataOptionsOneArgs = {
  object: CustomCoreDataOptionsInsertInput;
  on_conflict: InputMaybe<CustomCoreDataOptionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomDocumentTypesArgs = {
  objects: Array<CustomDocumentTypesInsertInput>;
  on_conflict: InputMaybe<CustomDocumentTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomDocumentTypesOneArgs = {
  object: CustomDocumentTypesInsertInput;
  on_conflict: InputMaybe<CustomDocumentTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomFieldChoicesArgs = {
  objects: Array<CustomFieldChoicesInsertInput>;
  on_conflict: InputMaybe<CustomFieldChoicesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomFieldChoicesOneArgs = {
  object: CustomFieldChoicesInsertInput;
  on_conflict: InputMaybe<CustomFieldChoicesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomFieldCoreDataArgs = {
  objects: Array<CustomFieldCoreDataInsertInput>;
  on_conflict: InputMaybe<CustomFieldCoreDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomFieldCoreDataOneArgs = {
  object: CustomFieldCoreDataInsertInput;
  on_conflict: InputMaybe<CustomFieldCoreDataOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomFieldValuesArgs = {
  objects: Array<CustomFieldValuesInsertInput>;
  on_conflict: InputMaybe<CustomFieldValuesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomFieldValuesOneArgs = {
  object: CustomFieldValuesInsertInput;
  on_conflict: InputMaybe<CustomFieldValuesOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomFieldsArgs = {
  objects: Array<CustomFieldsInsertInput>;
  on_conflict: InputMaybe<CustomFieldsOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomFieldsOneArgs = {
  object: CustomFieldsInsertInput;
  on_conflict: InputMaybe<CustomFieldsOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomReportsArgs = {
  objects: Array<CustomReportsInsertInput>;
  on_conflict: InputMaybe<CustomReportsOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomReportsGenerationsArgs = {
  objects: Array<CustomReportsGenerationsInsertInput>;
  on_conflict: InputMaybe<CustomReportsGenerationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomReportsGenerationsOneArgs = {
  object: CustomReportsGenerationsInsertInput;
  on_conflict: InputMaybe<CustomReportsGenerationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertCustomReportsOneArgs = {
  object: CustomReportsInsertInput;
  on_conflict: InputMaybe<CustomReportsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDepartmentsArgs = {
  objects: Array<DepartmentsInsertInput>;
  on_conflict: InputMaybe<DepartmentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDepartmentsOneArgs = {
  object: DepartmentsInsertInput;
  on_conflict: InputMaybe<DepartmentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDocumentTypesArgs = {
  objects: Array<DocumentTypesInsertInput>;
  on_conflict: InputMaybe<DocumentTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertDocumentTypesOneArgs = {
  object: DocumentTypesInsertInput;
  on_conflict: InputMaybe<DocumentTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertDocumentsArgs = {
  objects: Array<DocumentsInsertInput>;
  on_conflict: InputMaybe<DocumentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDocumentsOneArgs = {
  object: DocumentsInsertInput;
  on_conflict: InputMaybe<DocumentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDraftIntakeSubmissionsArgs = {
  objects: Array<DraftIntakeSubmissionsInsertInput>;
  on_conflict: InputMaybe<DraftIntakeSubmissionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertDraftIntakeSubmissionsOneArgs = {
  object: DraftIntakeSubmissionsInsertInput;
  on_conflict: InputMaybe<DraftIntakeSubmissionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertEngagementsArgs = {
  objects: Array<EngagementsInsertInput>;
  on_conflict: InputMaybe<EngagementsOnConflict>;
};


/** mutation root */
export type MutationRootInsertEngagementsOneArgs = {
  object: EngagementsInsertInput;
  on_conflict: InputMaybe<EngagementsOnConflict>;
};


/** mutation root */
export type MutationRootInsertEntityBankDetailsArgs = {
  objects: Array<EntityBankDetailsInsertInput>;
  on_conflict: InputMaybe<EntityBankDetailsOnConflict>;
};


/** mutation root */
export type MutationRootInsertEntityBankDetailsOneArgs = {
  object: EntityBankDetailsInsertInput;
  on_conflict: InputMaybe<EntityBankDetailsOnConflict>;
};


/** mutation root */
export type MutationRootInsertEntityFieldGroupFieldsArgs = {
  objects: Array<EntityFieldGroupFieldsInsertInput>;
  on_conflict: InputMaybe<EntityFieldGroupFieldsOnConflict>;
};


/** mutation root */
export type MutationRootInsertEntityFieldGroupFieldsOneArgs = {
  object: EntityFieldGroupFieldsInsertInput;
  on_conflict: InputMaybe<EntityFieldGroupFieldsOnConflict>;
};


/** mutation root */
export type MutationRootInsertEntityFieldGroupsArgs = {
  objects: Array<EntityFieldGroupsInsertInput>;
  on_conflict: InputMaybe<EntityFieldGroupsOnConflict>;
};


/** mutation root */
export type MutationRootInsertEntityFieldGroupsOneArgs = {
  object: EntityFieldGroupsInsertInput;
  on_conflict: InputMaybe<EntityFieldGroupsOnConflict>;
};


/** mutation root */
export type MutationRootInsertExternalContactsArgs = {
  objects: Array<ExternalContactsInsertInput>;
  on_conflict: InputMaybe<ExternalContactsOnConflict>;
};


/** mutation root */
export type MutationRootInsertExternalContactsOneArgs = {
  object: ExternalContactsInsertInput;
  on_conflict: InputMaybe<ExternalContactsOnConflict>;
};


/** mutation root */
export type MutationRootInsertExternalEntitySyncStatusesArgs = {
  objects: Array<ExternalEntitySyncStatusesInsertInput>;
  on_conflict: InputMaybe<ExternalEntitySyncStatusesOnConflict>;
};


/** mutation root */
export type MutationRootInsertExternalEntitySyncStatusesOneArgs = {
  object: ExternalEntitySyncStatusesInsertInput;
  on_conflict: InputMaybe<ExternalEntitySyncStatusesOnConflict>;
};


/** mutation root */
export type MutationRootInsertExternalRiskScoresArgs = {
  objects: Array<ExternalRiskScoresInsertInput>;
  on_conflict: InputMaybe<ExternalRiskScoresOnConflict>;
};


/** mutation root */
export type MutationRootInsertExternalRiskScoresOneArgs = {
  object: ExternalRiskScoresInsertInput;
  on_conflict: InputMaybe<ExternalRiskScoresOnConflict>;
};


/** mutation root */
export type MutationRootInsertFavouriteTableFiltersArgs = {
  objects: Array<FavouriteTableFiltersInsertInput>;
  on_conflict: InputMaybe<FavouriteTableFiltersOnConflict>;
};


/** mutation root */
export type MutationRootInsertFavouriteTableFiltersOneArgs = {
  object: FavouriteTableFiltersInsertInput;
  on_conflict: InputMaybe<FavouriteTableFiltersOnConflict>;
};


/** mutation root */
export type MutationRootInsertFinancialsArgs = {
  objects: Array<FinancialsInsertInput>;
  on_conflict: InputMaybe<FinancialsOnConflict>;
};


/** mutation root */
export type MutationRootInsertFinancialsOneArgs = {
  object: FinancialsInsertInput;
  on_conflict: InputMaybe<FinancialsOnConflict>;
};


/** mutation root */
export type MutationRootInsertFormTemplateQuestionInsightsArgs = {
  objects: Array<FormTemplateQuestionInsightsInsertInput>;
  on_conflict: InputMaybe<FormTemplateQuestionInsightsOnConflict>;
};


/** mutation root */
export type MutationRootInsertFormTemplateQuestionInsightsOneArgs = {
  object: FormTemplateQuestionInsightsInsertInput;
  on_conflict: InputMaybe<FormTemplateQuestionInsightsOnConflict>;
};


/** mutation root */
export type MutationRootInsertFormTemplatesArgs = {
  objects: Array<FormTemplatesInsertInput>;
  on_conflict: InputMaybe<FormTemplatesOnConflict>;
};


/** mutation root */
export type MutationRootInsertFormTemplatesOneArgs = {
  object: FormTemplatesInsertInput;
  on_conflict: InputMaybe<FormTemplatesOnConflict>;
};


/** mutation root */
export type MutationRootInsertGroupUserAssignmentsArgs = {
  objects: Array<GroupUserAssignmentsInsertInput>;
  on_conflict: InputMaybe<GroupUserAssignmentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertGroupUserAssignmentsOneArgs = {
  object: GroupUserAssignmentsInsertInput;
  on_conflict: InputMaybe<GroupUserAssignmentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertGroupUsersArgs = {
  objects: Array<GroupUsersInsertInput>;
  on_conflict: InputMaybe<GroupUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertGroupUsersOneArgs = {
  object: GroupUsersInsertInput;
  on_conflict: InputMaybe<GroupUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertGroupsArgs = {
  objects: Array<GroupsInsertInput>;
  on_conflict: InputMaybe<GroupsOnConflict>;
};


/** mutation root */
export type MutationRootInsertGroupsOneArgs = {
  object: GroupsInsertInput;
  on_conflict: InputMaybe<GroupsOnConflict>;
};


/** mutation root */
export type MutationRootInsertIdpAttributeMappingsArgs = {
  objects: Array<IdpAttributeMappingsInsertInput>;
  on_conflict: InputMaybe<IdpAttributeMappingsOnConflict>;
};


/** mutation root */
export type MutationRootInsertIdpAttributeMappingsOneArgs = {
  object: IdpAttributeMappingsInsertInput;
  on_conflict: InputMaybe<IdpAttributeMappingsOnConflict>;
};


/** mutation root */
export type MutationRootInsertInternalContactsArgs = {
  objects: Array<InternalContactsInsertInput>;
  on_conflict: InputMaybe<InternalContactsOnConflict>;
};


/** mutation root */
export type MutationRootInsertInternalContactsOneArgs = {
  object: InternalContactsInsertInput;
  on_conflict: InputMaybe<InternalContactsOnConflict>;
};


/** mutation root */
export type MutationRootInsertLineItemTypesArgs = {
  objects: Array<LineItemTypesInsertInput>;
  on_conflict: InputMaybe<LineItemTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertLineItemTypesOneArgs = {
  object: LineItemTypesInsertInput;
  on_conflict: InputMaybe<LineItemTypesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationCoreDataDependenciesArgs = {
  objects: Array<OrganisationCoreDataDependenciesInsertInput>;
  on_conflict: InputMaybe<OrganisationCoreDataDependenciesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationCoreDataDependenciesOneArgs = {
  object: OrganisationCoreDataDependenciesInsertInput;
  on_conflict: InputMaybe<OrganisationCoreDataDependenciesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationFeatureFlagsArgs = {
  objects: Array<OrganisationFeatureFlagsInsertInput>;
  on_conflict: InputMaybe<OrganisationFeatureFlagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationFeatureFlagsOneArgs = {
  object: OrganisationFeatureFlagsInsertInput;
  on_conflict: InputMaybe<OrganisationFeatureFlagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationFxRatesArgs = {
  objects: Array<OrganisationFxRatesInsertInput>;
  on_conflict: InputMaybe<OrganisationFxRatesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationFxRatesOneArgs = {
  object: OrganisationFxRatesInsertInput;
  on_conflict: InputMaybe<OrganisationFxRatesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationIntegrationOperationsArgs = {
  objects: Array<OrganisationIntegrationOperationsInsertInput>;
  on_conflict: InputMaybe<OrganisationIntegrationOperationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationIntegrationOperationsOneArgs = {
  object: OrganisationIntegrationOperationsInsertInput;
  on_conflict: InputMaybe<OrganisationIntegrationOperationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationIntegrationsArgs = {
  objects: Array<OrganisationIntegrationsInsertInput>;
  on_conflict: InputMaybe<OrganisationIntegrationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationIntegrationsOneArgs = {
  object: OrganisationIntegrationsInsertInput;
  on_conflict: InputMaybe<OrganisationIntegrationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationLocalesArgs = {
  objects: Array<OrganisationLocalesInsertInput>;
  on_conflict: InputMaybe<OrganisationLocalesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationLocalesOneArgs = {
  object: OrganisationLocalesInsertInput;
  on_conflict: InputMaybe<OrganisationLocalesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationProductSupplierCategoriesArgs = {
  objects: Array<OrganisationProductSupplierCategoriesInsertInput>;
  on_conflict: InputMaybe<OrganisationProductSupplierCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationProductSupplierCategoriesOneArgs = {
  object: OrganisationProductSupplierCategoriesInsertInput;
  on_conflict: InputMaybe<OrganisationProductSupplierCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationProductsAndServicesArgs = {
  objects: Array<OrganisationProductsAndServicesInsertInput>;
  on_conflict: InputMaybe<OrganisationProductsAndServicesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationProductsAndServicesBrandsArgs = {
  objects: Array<OrganisationProductsAndServicesBrandsInsertInput>;
  on_conflict: InputMaybe<OrganisationProductsAndServicesBrandsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationProductsAndServicesBrandsOneArgs = {
  object: OrganisationProductsAndServicesBrandsInsertInput;
  on_conflict: InputMaybe<OrganisationProductsAndServicesBrandsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationProductsAndServicesCategoriesArgs = {
  objects: Array<OrganisationProductsAndServicesCategoriesInsertInput>;
  on_conflict: InputMaybe<OrganisationProductsAndServicesCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationProductsAndServicesCategoriesOneArgs = {
  object: OrganisationProductsAndServicesCategoriesInsertInput;
  on_conflict: InputMaybe<OrganisationProductsAndServicesCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationProductsAndServicesOneArgs = {
  object: OrganisationProductsAndServicesInsertInput;
  on_conflict: InputMaybe<OrganisationProductsAndServicesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationPublicApiClientsArgs = {
  objects: Array<OrganisationPublicApiClientsInsertInput>;
  on_conflict: InputMaybe<OrganisationPublicApiClientsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationPublicApiClientsOneArgs = {
  object: OrganisationPublicApiClientsInsertInput;
  on_conflict: InputMaybe<OrganisationPublicApiClientsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSettingsArgs = {
  objects: Array<OrganisationSettingsInsertInput>;
  on_conflict: InputMaybe<OrganisationSettingsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSettingsOneArgs = {
  object: OrganisationSettingsInsertInput;
  on_conflict: InputMaybe<OrganisationSettingsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationStaticContentArgs = {
  objects: Array<OrganisationStaticContentInsertInput>;
  on_conflict: InputMaybe<OrganisationStaticContentOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationStaticContentOneArgs = {
  object: OrganisationStaticContentInsertInput;
  on_conflict: InputMaybe<OrganisationStaticContentOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSupplierHistoricSubmissionsArgs = {
  objects: Array<OrganisationSupplierHistoricSubmissionsInsertInput>;
  on_conflict: InputMaybe<OrganisationSupplierHistoricSubmissionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSupplierHistoricSubmissionsOneArgs = {
  object: OrganisationSupplierHistoricSubmissionsInsertInput;
  on_conflict: InputMaybe<OrganisationSupplierHistoricSubmissionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSupplierOnlineResourcesArgs = {
  objects: Array<OrganisationSupplierOnlineResourcesInsertInput>;
  on_conflict: InputMaybe<OrganisationSupplierOnlineResourcesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSupplierOnlineResourcesOneArgs = {
  object: OrganisationSupplierOnlineResourcesInsertInput;
  on_conflict: InputMaybe<OrganisationSupplierOnlineResourcesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSupplierProfileResourcesArgs = {
  objects: Array<OrganisationSupplierProfileResourcesInsertInput>;
  on_conflict: InputMaybe<OrganisationSupplierProfileResourcesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSupplierProfileResourcesOneArgs = {
  object: OrganisationSupplierProfileResourcesInsertInput;
  on_conflict: InputMaybe<OrganisationSupplierProfileResourcesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSupplierProfilesArgs = {
  objects: Array<OrganisationSupplierProfilesInsertInput>;
  on_conflict: InputMaybe<OrganisationSupplierProfilesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSupplierProfilesOneArgs = {
  object: OrganisationSupplierProfilesInsertInput;
  on_conflict: InputMaybe<OrganisationSupplierProfilesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSupplierTagsArgs = {
  objects: Array<OrganisationSupplierTagsInsertInput>;
  on_conflict: InputMaybe<OrganisationSupplierTagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSupplierTagsOneArgs = {
  object: OrganisationSupplierTagsInsertInput;
  on_conflict: InputMaybe<OrganisationSupplierTagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSuppliersArgs = {
  objects: Array<OrganisationSuppliersInsertInput>;
  on_conflict: InputMaybe<OrganisationSuppliersOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSuppliersBrandsArgs = {
  objects: Array<OrganisationSuppliersBrandsInsertInput>;
  on_conflict: InputMaybe<OrganisationSuppliersBrandsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSuppliersBrandsOneArgs = {
  object: OrganisationSuppliersBrandsInsertInput;
  on_conflict: InputMaybe<OrganisationSuppliersBrandsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSuppliersCategoriesArgs = {
  objects: Array<OrganisationSuppliersCategoriesInsertInput>;
  on_conflict: InputMaybe<OrganisationSuppliersCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSuppliersCategoriesOneArgs = {
  object: OrganisationSuppliersCategoriesInsertInput;
  on_conflict: InputMaybe<OrganisationSuppliersCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertOrganisationSuppliersOneArgs = {
  object: OrganisationSuppliersInsertInput;
  on_conflict: InputMaybe<OrganisationSuppliersOnConflict>;
};


/** mutation root */
export type MutationRootInsertOutOfOfficeDelegationsArgs = {
  objects: Array<OutOfOfficeDelegationsInsertInput>;
  on_conflict: InputMaybe<OutOfOfficeDelegationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertOutOfOfficeDelegationsOneArgs = {
  object: OutOfOfficeDelegationsInsertInput;
  on_conflict: InputMaybe<OutOfOfficeDelegationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertPauseReasonsArgs = {
  objects: Array<PauseReasonsInsertInput>;
  on_conflict: InputMaybe<PauseReasonsOnConflict>;
};


/** mutation root */
export type MutationRootInsertPauseReasonsOneArgs = {
  object: PauseReasonsInsertInput;
  on_conflict: InputMaybe<PauseReasonsOnConflict>;
};


/** mutation root */
export type MutationRootInsertPaymentMethodsArgs = {
  objects: Array<PaymentMethodsInsertInput>;
  on_conflict: InputMaybe<PaymentMethodsOnConflict>;
};


/** mutation root */
export type MutationRootInsertPaymentMethodsOneArgs = {
  object: PaymentMethodsInsertInput;
  on_conflict: InputMaybe<PaymentMethodsOnConflict>;
};


/** mutation root */
export type MutationRootInsertPaymentTermsArgs = {
  objects: Array<PaymentTermsInsertInput>;
  on_conflict: InputMaybe<PaymentTermsOnConflict>;
};


/** mutation root */
export type MutationRootInsertPaymentTermsOneArgs = {
  object: PaymentTermsInsertInput;
  on_conflict: InputMaybe<PaymentTermsOnConflict>;
};


/** mutation root */
export type MutationRootInsertProductCatalogueAccessApproversArgs = {
  objects: Array<ProductCatalogueAccessApproversInsertInput>;
  on_conflict: InputMaybe<ProductCatalogueAccessApproversOnConflict>;
};


/** mutation root */
export type MutationRootInsertProductCatalogueAccessApproversOneArgs = {
  object: ProductCatalogueAccessApproversInsertInput;
  on_conflict: InputMaybe<ProductCatalogueAccessApproversOnConflict>;
};


/** mutation root */
export type MutationRootInsertProductCatalogueEntriesArgs = {
  objects: Array<ProductCatalogueEntriesInsertInput>;
  on_conflict: InputMaybe<ProductCatalogueEntriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertProductCatalogueEntriesOneArgs = {
  object: ProductCatalogueEntriesInsertInput;
  on_conflict: InputMaybe<ProductCatalogueEntriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertPurchaseOrderLineItemsArgs = {
  objects: Array<PurchaseOrderLineItemsInsertInput>;
  on_conflict: InputMaybe<PurchaseOrderLineItemsOnConflict>;
};


/** mutation root */
export type MutationRootInsertPurchaseOrderLineItemsOneArgs = {
  object: PurchaseOrderLineItemsInsertInput;
  on_conflict: InputMaybe<PurchaseOrderLineItemsOnConflict>;
};


/** mutation root */
export type MutationRootInsertPurchaseOrdersArgs = {
  objects: Array<PurchaseOrdersInsertInput>;
  on_conflict: InputMaybe<PurchaseOrdersOnConflict>;
};


/** mutation root */
export type MutationRootInsertPurchaseOrdersOneArgs = {
  object: PurchaseOrdersInsertInput;
  on_conflict: InputMaybe<PurchaseOrdersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRenewalAdditionalUsersArgs = {
  objects: Array<RenewalAdditionalUsersInsertInput>;
  on_conflict: InputMaybe<RenewalAdditionalUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRenewalAdditionalUsersOneArgs = {
  object: RenewalAdditionalUsersInsertInput;
  on_conflict: InputMaybe<RenewalAdditionalUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRenewalTagsArgs = {
  objects: Array<RenewalTagsInsertInput>;
  on_conflict: InputMaybe<RenewalTagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRenewalTagsOneArgs = {
  object: RenewalTagsInsertInput;
  on_conflict: InputMaybe<RenewalTagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRenewalsArgs = {
  objects: Array<RenewalsInsertInput>;
  on_conflict: InputMaybe<RenewalsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRenewalsOneArgs = {
  object: RenewalsInsertInput;
  on_conflict: InputMaybe<RenewalsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestCommentsArgs = {
  objects: Array<RequestCommentsInsertInput>;
  on_conflict: InputMaybe<RequestCommentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestCommentsMentionsArgs = {
  objects: Array<RequestCommentsMentionsInsertInput>;
  on_conflict: InputMaybe<RequestCommentsMentionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestCommentsMentionsOneArgs = {
  object: RequestCommentsMentionsInsertInput;
  on_conflict: InputMaybe<RequestCommentsMentionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestCommentsOneArgs = {
  object: RequestCommentsInsertInput;
  on_conflict: InputMaybe<RequestCommentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestComputedPropertiesArgs = {
  objects: Array<RequestComputedPropertiesInsertInput>;
  on_conflict: InputMaybe<RequestComputedPropertiesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestComputedPropertiesOneArgs = {
  object: RequestComputedPropertiesInsertInput;
  on_conflict: InputMaybe<RequestComputedPropertiesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestDocumentsArgs = {
  objects: Array<RequestDocumentsInsertInput>;
  on_conflict: InputMaybe<RequestDocumentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestDocumentsOneArgs = {
  object: RequestDocumentsInsertInput;
  on_conflict: InputMaybe<RequestDocumentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestEsignDocumentsArgs = {
  objects: Array<RequestEsignDocumentsInsertInput>;
  on_conflict: InputMaybe<RequestEsignDocumentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestEsignDocumentsOneArgs = {
  object: RequestEsignDocumentsInsertInput;
  on_conflict: InputMaybe<RequestEsignDocumentsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFollowersArgs = {
  objects: Array<RequestFollowersInsertInput>;
  on_conflict: InputMaybe<RequestFollowersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFollowersOneArgs = {
  object: RequestFollowersInsertInput;
  on_conflict: InputMaybe<RequestFollowersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormQuestionAiScoreArgs = {
  objects: Array<RequestFormQuestionAiScoreInsertInput>;
  on_conflict: InputMaybe<RequestFormQuestionAiScoreOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormQuestionAiScoreOneArgs = {
  object: RequestFormQuestionAiScoreInsertInput;
  on_conflict: InputMaybe<RequestFormQuestionAiScoreOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormQuestionScoreArgs = {
  objects: Array<RequestFormQuestionScoreInsertInput>;
  on_conflict: InputMaybe<RequestFormQuestionScoreOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormQuestionScoreOneArgs = {
  object: RequestFormQuestionScoreInsertInput;
  on_conflict: InputMaybe<RequestFormQuestionScoreOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormSubmissionAiSummaryArgs = {
  objects: Array<RequestFormSubmissionAiSummaryInsertInput>;
  on_conflict: InputMaybe<RequestFormSubmissionAiSummaryOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormSubmissionAiSummaryOneArgs = {
  object: RequestFormSubmissionAiSummaryInsertInput;
  on_conflict: InputMaybe<RequestFormSubmissionAiSummaryOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormSubmissionTranslationsArgs = {
  objects: Array<RequestFormSubmissionTranslationsInsertInput>;
  on_conflict: InputMaybe<RequestFormSubmissionTranslationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormSubmissionTranslationsOneArgs = {
  object: RequestFormSubmissionTranslationsInsertInput;
  on_conflict: InputMaybe<RequestFormSubmissionTranslationsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormSubmissionsArgs = {
  objects: Array<RequestFormSubmissionsInsertInput>;
  on_conflict: InputMaybe<RequestFormSubmissionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormSubmissionsAutoSavesArgs = {
  objects: Array<RequestFormSubmissionsAutoSavesInsertInput>;
  on_conflict: InputMaybe<RequestFormSubmissionsAutoSavesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormSubmissionsAutoSavesOneArgs = {
  object: RequestFormSubmissionsAutoSavesInsertInput;
  on_conflict: InputMaybe<RequestFormSubmissionsAutoSavesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormSubmissionsOneArgs = {
  object: RequestFormSubmissionsInsertInput;
  on_conflict: InputMaybe<RequestFormSubmissionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormTemplateReviewersArgs = {
  objects: Array<RequestFormTemplateReviewersInsertInput>;
  on_conflict: InputMaybe<RequestFormTemplateReviewersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormTemplateReviewersOneArgs = {
  object: RequestFormTemplateReviewersInsertInput;
  on_conflict: InputMaybe<RequestFormTemplateReviewersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormTemplatesArgs = {
  objects: Array<RequestFormTemplatesInsertInput>;
  on_conflict: InputMaybe<RequestFormTemplatesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormTemplatesOneArgs = {
  object: RequestFormTemplatesInsertInput;
  on_conflict: InputMaybe<RequestFormTemplatesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormsArgs = {
  objects: Array<RequestFormsInsertInput>;
  on_conflict: InputMaybe<RequestFormsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestFormsOneArgs = {
  object: RequestFormsInsertInput;
  on_conflict: InputMaybe<RequestFormsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestGroupsArgs = {
  objects: Array<RequestGroupsInsertInput>;
  on_conflict: InputMaybe<RequestGroupsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestGroupsOneArgs = {
  object: RequestGroupsInsertInput;
  on_conflict: InputMaybe<RequestGroupsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestLeadsConfigArgs = {
  objects: Array<RequestLeadsConfigInsertInput>;
  on_conflict: InputMaybe<RequestLeadsConfigOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestLeadsConfigOneArgs = {
  object: RequestLeadsConfigInsertInput;
  on_conflict: InputMaybe<RequestLeadsConfigOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestPausesArgs = {
  objects: Array<RequestPausesInsertInput>;
  on_conflict: InputMaybe<RequestPausesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestPausesOneArgs = {
  object: RequestPausesInsertInput;
  on_conflict: InputMaybe<RequestPausesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestRequestLeadsArgs = {
  objects: Array<RequestRequestLeadsInsertInput>;
  on_conflict: InputMaybe<RequestRequestLeadsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestRequestLeadsOneArgs = {
  object: RequestRequestLeadsInsertInput;
  on_conflict: InputMaybe<RequestRequestLeadsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepGroupsArgs = {
  objects: Array<RequestStepGroupsInsertInput>;
  on_conflict: InputMaybe<RequestStepGroupsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepGroupsOneArgs = {
  object: RequestStepGroupsInsertInput;
  on_conflict: InputMaybe<RequestStepGroupsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepNotificationMessagesArgs = {
  objects: Array<RequestStepNotificationMessagesInsertInput>;
  on_conflict: InputMaybe<RequestStepNotificationMessagesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepNotificationMessagesOneArgs = {
  object: RequestStepNotificationMessagesInsertInput;
  on_conflict: InputMaybe<RequestStepNotificationMessagesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepTaskErrorsArgs = {
  objects: Array<RequestStepTaskErrorsInsertInput>;
  on_conflict: InputMaybe<RequestStepTaskErrorsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepTaskErrorsOneArgs = {
  object: RequestStepTaskErrorsInsertInput;
  on_conflict: InputMaybe<RequestStepTaskErrorsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepTaskRejectionsArgs = {
  objects: Array<RequestStepTaskRejectionsInsertInput>;
  on_conflict: InputMaybe<RequestStepTaskRejectionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepTaskRejectionsOneArgs = {
  object: RequestStepTaskRejectionsInsertInput;
  on_conflict: InputMaybe<RequestStepTaskRejectionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepTaskUsersArgs = {
  objects: Array<RequestStepTaskUsersInsertInput>;
  on_conflict: InputMaybe<RequestStepTaskUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepTaskUsersOneArgs = {
  object: RequestStepTaskUsersInsertInput;
  on_conflict: InputMaybe<RequestStepTaskUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepTasksArgs = {
  objects: Array<RequestStepTasksInsertInput>;
  on_conflict: InputMaybe<RequestStepTasksOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepTasksOneArgs = {
  object: RequestStepTasksInsertInput;
  on_conflict: InputMaybe<RequestStepTasksOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepUsersArgs = {
  objects: Array<RequestStepUsersInsertInput>;
  on_conflict: InputMaybe<RequestStepUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepUsersOneArgs = {
  object: RequestStepUsersInsertInput;
  on_conflict: InputMaybe<RequestStepUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepsArgs = {
  objects: Array<RequestStepsInsertInput>;
  on_conflict: InputMaybe<RequestStepsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestStepsOneArgs = {
  object: RequestStepsInsertInput;
  on_conflict: InputMaybe<RequestStepsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestTagsArgs = {
  objects: Array<RequestTagsInsertInput>;
  on_conflict: InputMaybe<RequestTagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestTagsOneArgs = {
  object: RequestTagsInsertInput;
  on_conflict: InputMaybe<RequestTagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestUsersArgs = {
  objects: Array<RequestUsersInsertInput>;
  on_conflict: InputMaybe<RequestUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestUsersOneArgs = {
  object: RequestUsersInsertInput;
  on_conflict: InputMaybe<RequestUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestsArgs = {
  objects: Array<RequestsInsertInput>;
  on_conflict: InputMaybe<RequestsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRequestsOneArgs = {
  object: RequestsInsertInput;
  on_conflict: InputMaybe<RequestsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxArgs = {
  objects: Array<RfxInsertInput>;
  on_conflict: InputMaybe<RfxOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxAiScoringArgs = {
  objects: Array<RfxAiScoringInsertInput>;
  on_conflict: InputMaybe<RfxAiScoringOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxAiScoringOneArgs = {
  object: RfxAiScoringInsertInput;
  on_conflict: InputMaybe<RfxAiScoringOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxConfidentialityAgreementArgs = {
  objects: Array<RfxConfidentialityAgreementInsertInput>;
  on_conflict: InputMaybe<RfxConfidentialityAgreementOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxConfidentialityAgreementOneArgs = {
  object: RfxConfidentialityAgreementInsertInput;
  on_conflict: InputMaybe<RfxConfidentialityAgreementOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxExternalUsersArgs = {
  objects: Array<RfxExternalUsersInsertInput>;
  on_conflict: InputMaybe<RfxExternalUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxExternalUsersOneArgs = {
  object: RfxExternalUsersInsertInput;
  on_conflict: InputMaybe<RfxExternalUsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxOneArgs = {
  object: RfxInsertInput;
  on_conflict: InputMaybe<RfxOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxOwnersArgs = {
  objects: Array<RfxOwnersInsertInput>;
  on_conflict: InputMaybe<RfxOwnersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxOwnersOneArgs = {
  object: RfxOwnersInsertInput;
  on_conflict: InputMaybe<RfxOwnersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxRequestFormTemplateWeightingArgs = {
  objects: Array<RfxRequestFormTemplateWeightingInsertInput>;
  on_conflict: InputMaybe<RfxRequestFormTemplateWeightingOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxRequestFormTemplateWeightingOneArgs = {
  object: RfxRequestFormTemplateWeightingInsertInput;
  on_conflict: InputMaybe<RfxRequestFormTemplateWeightingOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxRequestFormTemplatesRanksArgs = {
  objects: Array<RfxRequestFormTemplatesRanksInsertInput>;
  on_conflict: InputMaybe<RfxRequestFormTemplatesRanksOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxRequestFormTemplatesRanksOneArgs = {
  object: RfxRequestFormTemplatesRanksInsertInput;
  on_conflict: InputMaybe<RfxRequestFormTemplatesRanksOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxSuppliersArgs = {
  objects: Array<RfxSuppliersInsertInput>;
  on_conflict: InputMaybe<RfxSuppliersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRfxSuppliersOneArgs = {
  object: RfxSuppliersInsertInput;
  on_conflict: InputMaybe<RfxSuppliersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskAttributesArgs = {
  objects: Array<RiskAttributesInsertInput>;
  on_conflict: InputMaybe<RiskAttributesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskAttributesOneArgs = {
  object: RiskAttributesInsertInput;
  on_conflict: InputMaybe<RiskAttributesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskCategoriesArgs = {
  objects: Array<RiskCategoriesInsertInput>;
  on_conflict: InputMaybe<RiskCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskCategoriesOneArgs = {
  object: RiskCategoriesInsertInput;
  on_conflict: InputMaybe<RiskCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskLevelsArgs = {
  objects: Array<RiskLevelsInsertInput>;
  on_conflict: InputMaybe<RiskLevelsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskLevelsOneArgs = {
  object: RiskLevelsInsertInput;
  on_conflict: InputMaybe<RiskLevelsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskMatrixCellsArgs = {
  objects: Array<RiskMatrixCellsInsertInput>;
  on_conflict: InputMaybe<RiskMatrixCellsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskMatrixCellsOneArgs = {
  object: RiskMatrixCellsInsertInput;
  on_conflict: InputMaybe<RiskMatrixCellsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskOwnersArgs = {
  objects: Array<RiskOwnersInsertInput>;
  on_conflict: InputMaybe<RiskOwnersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskOwnersOneArgs = {
  object: RiskOwnersInsertInput;
  on_conflict: InputMaybe<RiskOwnersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskSettingsArgs = {
  objects: Array<RiskSettingsInsertInput>;
  on_conflict: InputMaybe<RiskSettingsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskSettingsOneArgs = {
  object: RiskSettingsInsertInput;
  on_conflict: InputMaybe<RiskSettingsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskTemplateCategoriesArgs = {
  objects: Array<RiskTemplateCategoriesInsertInput>;
  on_conflict: InputMaybe<RiskTemplateCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskTemplateCategoriesOneArgs = {
  object: RiskTemplateCategoriesInsertInput;
  on_conflict: InputMaybe<RiskTemplateCategoriesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskTemplateOwnersArgs = {
  objects: Array<RiskTemplateOwnersInsertInput>;
  on_conflict: InputMaybe<RiskTemplateOwnersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskTemplateOwnersOneArgs = {
  object: RiskTemplateOwnersInsertInput;
  on_conflict: InputMaybe<RiskTemplateOwnersOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskTemplatesArgs = {
  objects: Array<RiskTemplatesInsertInput>;
  on_conflict: InputMaybe<RiskTemplatesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskTemplatesOneArgs = {
  object: RiskTemplatesInsertInput;
  on_conflict: InputMaybe<RiskTemplatesOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskVersionsArgs = {
  objects: Array<RiskVersionsInsertInput>;
  on_conflict: InputMaybe<RiskVersionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRiskVersionsOneArgs = {
  object: RiskVersionsInsertInput;
  on_conflict: InputMaybe<RiskVersionsOnConflict>;
};


/** mutation root */
export type MutationRootInsertRisksArgs = {
  objects: Array<RisksInsertInput>;
  on_conflict: InputMaybe<RisksOnConflict>;
};


/** mutation root */
export type MutationRootInsertRisksOneArgs = {
  object: RisksInsertInput;
  on_conflict: InputMaybe<RisksOnConflict>;
};


/** mutation root */
export type MutationRootInsertSubsidiariesArgs = {
  objects: Array<SubsidiariesInsertInput>;
  on_conflict: InputMaybe<SubsidiariesOnConflict>;
};


/** mutation root */
export type MutationRootInsertSubsidiariesOneArgs = {
  object: SubsidiariesInsertInput;
  on_conflict: InputMaybe<SubsidiariesOnConflict>;
};


/** mutation root */
export type MutationRootInsertTableFiltersArgs = {
  objects: Array<TableFiltersInsertInput>;
  on_conflict: InputMaybe<TableFiltersOnConflict>;
};


/** mutation root */
export type MutationRootInsertTableFiltersOneArgs = {
  object: TableFiltersInsertInput;
  on_conflict: InputMaybe<TableFiltersOnConflict>;
};


/** mutation root */
export type MutationRootInsertTagsArgs = {
  objects: Array<TagsInsertInput>;
  on_conflict: InputMaybe<TagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertTagsOneArgs = {
  object: TagsInsertInput;
  on_conflict: InputMaybe<TagsOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserAllowedSubsidiariesArgs = {
  objects: Array<UserAllowedSubsidiariesInsertInput>;
  on_conflict: InputMaybe<UserAllowedSubsidiariesOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserAllowedSubsidiariesOneArgs = {
  object: UserAllowedSubsidiariesInsertInput;
  on_conflict: InputMaybe<UserAllowedSubsidiariesOnConflict>;
};


/** mutation root */
export type MutationRootInsertUsersArgs = {
  objects: Array<UsersInsertInput>;
  on_conflict: InputMaybe<UsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertUsersOneArgs = {
  object: UsersInsertInput;
  on_conflict: InputMaybe<UsersOnConflict>;
};


/** mutation root */
export type MutationRootInsertWorkflowConditionGroupsArgs = {
  objects: Array<WorkflowConditionGroupsInsertInput>;
  on_conflict: InputMaybe<WorkflowConditionGroupsOnConflict>;
};


/** mutation root */
export type MutationRootInsertWorkflowConditionGroupsOneArgs = {
  object: WorkflowConditionGroupsInsertInput;
  on_conflict: InputMaybe<WorkflowConditionGroupsOnConflict>;
};


/** mutation root */
export type MutationRootInsertWorkflowFormTemplatesArgs = {
  objects: Array<WorkflowFormTemplatesInsertInput>;
  on_conflict: InputMaybe<WorkflowFormTemplatesOnConflict>;
};


/** mutation root */
export type MutationRootInsertWorkflowFormTemplatesOneArgs = {
  object: WorkflowFormTemplatesInsertInput;
  on_conflict: InputMaybe<WorkflowFormTemplatesOnConflict>;
};


/** mutation root */
export type MutationRootInsertWorkflowRanksArgs = {
  objects: Array<WorkflowRanksInsertInput>;
  on_conflict: InputMaybe<WorkflowRanksOnConflict>;
};


/** mutation root */
export type MutationRootInsertWorkflowRanksOneArgs = {
  object: WorkflowRanksInsertInput;
  on_conflict: InputMaybe<WorkflowRanksOnConflict>;
};


/** mutation root */
export type MutationRootInsertWorkflowsArgs = {
  objects: Array<WorkflowsInsertInput>;
  on_conflict: InputMaybe<WorkflowsOnConflict>;
};


/** mutation root */
export type MutationRootInsertWorkflowsOneArgs = {
  object: WorkflowsInsertInput;
  on_conflict: InputMaybe<WorkflowsOnConflict>;
};


/** mutation root */
export type MutationRootUpdateAddressesArgs = {
  _set: InputMaybe<AddressesSetInput>;
  where: AddressesBoolExp;
};


/** mutation root */
export type MutationRootUpdateAddressesByPkArgs = {
  _set: InputMaybe<AddressesSetInput>;
  pk_columns: AddressesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAddressesManyArgs = {
  updates: Array<AddressesUpdates>;
};


/** mutation root */
export type MutationRootUpdateAgreementAdditionalOwnersArgs = {
  _set: InputMaybe<AgreementAdditionalOwnersSetInput>;
  where: AgreementAdditionalOwnersBoolExp;
};


/** mutation root */
export type MutationRootUpdateAgreementAdditionalOwnersByPkArgs = {
  _set: InputMaybe<AgreementAdditionalOwnersSetInput>;
  pk_columns: AgreementAdditionalOwnersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAgreementAdditionalOwnersManyArgs = {
  updates: Array<AgreementAdditionalOwnersUpdates>;
};


/** mutation root */
export type MutationRootUpdateAgreementDocumentsArgs = {
  _set: InputMaybe<AgreementDocumentsSetInput>;
  where: AgreementDocumentsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAgreementDocumentsByPkArgs = {
  _set: InputMaybe<AgreementDocumentsSetInput>;
  pk_columns: AgreementDocumentsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAgreementDocumentsManyArgs = {
  updates: Array<AgreementDocumentsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAgreementTagsArgs = {
  _set: InputMaybe<AgreementTagsSetInput>;
  where: AgreementTagsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAgreementTagsByPkArgs = {
  _set: InputMaybe<AgreementTagsSetInput>;
  pk_columns: AgreementTagsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAgreementTagsManyArgs = {
  updates: Array<AgreementTagsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAgreementTermProductsArgs = {
  _set: InputMaybe<AgreementTermProductsSetInput>;
  where: AgreementTermProductsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAgreementTermProductsByPkArgs = {
  _set: InputMaybe<AgreementTermProductsSetInput>;
  pk_columns: AgreementTermProductsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAgreementTermProductsManyArgs = {
  updates: Array<AgreementTermProductsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAgreementTermRevisionsArgs = {
  _set: InputMaybe<AgreementTermRevisionsSetInput>;
  where: AgreementTermRevisionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAgreementTermRevisionsByPkArgs = {
  _set: InputMaybe<AgreementTermRevisionsSetInput>;
  pk_columns: AgreementTermRevisionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAgreementTermRevisionsManyArgs = {
  updates: Array<AgreementTermRevisionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAgreementTermSpendItemsArgs = {
  _inc: InputMaybe<AgreementTermSpendItemsIncInput>;
  _set: InputMaybe<AgreementTermSpendItemsSetInput>;
  where: AgreementTermSpendItemsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAgreementTermSpendItemsByPkArgs = {
  _inc: InputMaybe<AgreementTermSpendItemsIncInput>;
  _set: InputMaybe<AgreementTermSpendItemsSetInput>;
  pk_columns: AgreementTermSpendItemsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAgreementTermSpendItemsManyArgs = {
  updates: Array<AgreementTermSpendItemsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAgreementTermsArgs = {
  _inc: InputMaybe<AgreementTermsIncInput>;
  _set: InputMaybe<AgreementTermsSetInput>;
  where: AgreementTermsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAgreementTermsByPkArgs = {
  _inc: InputMaybe<AgreementTermsIncInput>;
  _set: InputMaybe<AgreementTermsSetInput>;
  pk_columns: AgreementTermsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAgreementTermsManyArgs = {
  updates: Array<AgreementTermsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAgreementsArgs = {
  _set: InputMaybe<AgreementsSetInput>;
  where: AgreementsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAgreementsByPkArgs = {
  _set: InputMaybe<AgreementsSetInput>;
  pk_columns: AgreementsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAgreementsManyArgs = {
  updates: Array<AgreementsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAssessmentAdditionalGroupsArgs = {
  _set: InputMaybe<AssessmentAdditionalGroupsSetInput>;
  where: AssessmentAdditionalGroupsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAssessmentAdditionalGroupsByPkArgs = {
  _set: InputMaybe<AssessmentAdditionalGroupsSetInput>;
  pk_columns: AssessmentAdditionalGroupsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAssessmentAdditionalGroupsManyArgs = {
  updates: Array<AssessmentAdditionalGroupsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAssessmentAdditionalUsersArgs = {
  _set: InputMaybe<AssessmentAdditionalUsersSetInput>;
  where: AssessmentAdditionalUsersBoolExp;
};


/** mutation root */
export type MutationRootUpdateAssessmentAdditionalUsersByPkArgs = {
  _set: InputMaybe<AssessmentAdditionalUsersSetInput>;
  pk_columns: AssessmentAdditionalUsersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAssessmentAdditionalUsersManyArgs = {
  updates: Array<AssessmentAdditionalUsersUpdates>;
};


/** mutation root */
export type MutationRootUpdateAssessmentsArgs = {
  _append: InputMaybe<AssessmentsAppendInput>;
  _delete_at_path: InputMaybe<AssessmentsDeleteAtPathInput>;
  _delete_elem: InputMaybe<AssessmentsDeleteElemInput>;
  _delete_key: InputMaybe<AssessmentsDeleteKeyInput>;
  _prepend: InputMaybe<AssessmentsPrependInput>;
  _set: InputMaybe<AssessmentsSetInput>;
  where: AssessmentsBoolExp;
};


/** mutation root */
export type MutationRootUpdateAssessmentsByPkArgs = {
  _append: InputMaybe<AssessmentsAppendInput>;
  _delete_at_path: InputMaybe<AssessmentsDeleteAtPathInput>;
  _delete_elem: InputMaybe<AssessmentsDeleteElemInput>;
  _delete_key: InputMaybe<AssessmentsDeleteKeyInput>;
  _prepend: InputMaybe<AssessmentsPrependInput>;
  _set: InputMaybe<AssessmentsSetInput>;
  pk_columns: AssessmentsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAssessmentsManyArgs = {
  updates: Array<AssessmentsUpdates>;
};


/** mutation root */
export type MutationRootUpdateAuthRefreshTokensArgs = {
  _set: InputMaybe<AuthRefreshTokensSetInput>;
  where: AuthRefreshTokensBoolExp;
};


/** mutation root */
export type MutationRootUpdateAuthRefreshTokensByPkArgs = {
  _set: InputMaybe<AuthRefreshTokensSetInput>;
  pk_columns: AuthRefreshTokensPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAuthRefreshTokensManyArgs = {
  updates: Array<AuthRefreshTokensUpdates>;
};


/** mutation root */
export type MutationRootUpdateAutoFlaggedScoreCategoriesArgs = {
  _set: InputMaybe<AutoFlaggedScoreCategoriesSetInput>;
  where: AutoFlaggedScoreCategoriesBoolExp;
};


/** mutation root */
export type MutationRootUpdateAutoFlaggedScoreCategoriesByPkArgs = {
  _set: InputMaybe<AutoFlaggedScoreCategoriesSetInput>;
  pk_columns: AutoFlaggedScoreCategoriesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAutoFlaggedScoreCategoriesManyArgs = {
  updates: Array<AutoFlaggedScoreCategoriesUpdates>;
};


/** mutation root */
export type MutationRootUpdateBankDetailsArgs = {
  _set: InputMaybe<BankDetailsSetInput>;
  where: BankDetailsBoolExp;
};


/** mutation root */
export type MutationRootUpdateBankDetailsByPkArgs = {
  _set: InputMaybe<BankDetailsSetInput>;
  pk_columns: BankDetailsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBankDetailsManyArgs = {
  updates: Array<BankDetailsUpdates>;
};


/** mutation root */
export type MutationRootUpdateBudgetApprovalGroupArgs = {
  _set: InputMaybe<BudgetApprovalGroupSetInput>;
  where: BudgetApprovalGroupBoolExp;
};


/** mutation root */
export type MutationRootUpdateBudgetApprovalGroupAssigneesArgs = {
  _set: InputMaybe<BudgetApprovalGroupAssigneesSetInput>;
  where: BudgetApprovalGroupAssigneesBoolExp;
};


/** mutation root */
export type MutationRootUpdateBudgetApprovalGroupAssigneesAssigneesArgs = {
  _set: InputMaybe<BudgetApprovalGroupAssigneesAssigneesSetInput>;
  where: BudgetApprovalGroupAssigneesAssigneesBoolExp;
};


/** mutation root */
export type MutationRootUpdateBudgetApprovalGroupAssigneesAssigneesByPkArgs = {
  _set: InputMaybe<BudgetApprovalGroupAssigneesAssigneesSetInput>;
  pk_columns: BudgetApprovalGroupAssigneesAssigneesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBudgetApprovalGroupAssigneesAssigneesManyArgs = {
  updates: Array<BudgetApprovalGroupAssigneesAssigneesUpdates>;
};


/** mutation root */
export type MutationRootUpdateBudgetApprovalGroupAssigneesByPkArgs = {
  _set: InputMaybe<BudgetApprovalGroupAssigneesSetInput>;
  pk_columns: BudgetApprovalGroupAssigneesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBudgetApprovalGroupAssigneesManyArgs = {
  updates: Array<BudgetApprovalGroupAssigneesUpdates>;
};


/** mutation root */
export type MutationRootUpdateBudgetApprovalGroupByPkArgs = {
  _set: InputMaybe<BudgetApprovalGroupSetInput>;
  pk_columns: BudgetApprovalGroupPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBudgetApprovalGroupManyArgs = {
  updates: Array<BudgetApprovalGroupUpdates>;
};


/** mutation root */
export type MutationRootUpdateBudgetApprovalThresholdArgs = {
  _inc: InputMaybe<BudgetApprovalThresholdIncInput>;
  _set: InputMaybe<BudgetApprovalThresholdSetInput>;
  where: BudgetApprovalThresholdBoolExp;
};


/** mutation root */
export type MutationRootUpdateBudgetApprovalThresholdByPkArgs = {
  _inc: InputMaybe<BudgetApprovalThresholdIncInput>;
  _set: InputMaybe<BudgetApprovalThresholdSetInput>;
  pk_columns: BudgetApprovalThresholdPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBudgetApprovalThresholdManyArgs = {
  updates: Array<BudgetApprovalThresholdUpdates>;
};


/** mutation root */
export type MutationRootUpdateBudgetsArgs = {
  _inc: InputMaybe<BudgetsIncInput>;
  _set: InputMaybe<BudgetsSetInput>;
  where: BudgetsBoolExp;
};


/** mutation root */
export type MutationRootUpdateBudgetsByPkArgs = {
  _inc: InputMaybe<BudgetsIncInput>;
  _set: InputMaybe<BudgetsSetInput>;
  pk_columns: BudgetsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBudgetsManyArgs = {
  updates: Array<BudgetsUpdates>;
};


/** mutation root */
export type MutationRootUpdateBulkDocumentsUploadsArgs = {
  _append: InputMaybe<BulkDocumentsUploadsAppendInput>;
  _delete_at_path: InputMaybe<BulkDocumentsUploadsDeleteAtPathInput>;
  _delete_elem: InputMaybe<BulkDocumentsUploadsDeleteElemInput>;
  _delete_key: InputMaybe<BulkDocumentsUploadsDeleteKeyInput>;
  _inc: InputMaybe<BulkDocumentsUploadsIncInput>;
  _prepend: InputMaybe<BulkDocumentsUploadsPrependInput>;
  _set: InputMaybe<BulkDocumentsUploadsSetInput>;
  where: BulkDocumentsUploadsBoolExp;
};


/** mutation root */
export type MutationRootUpdateBulkDocumentsUploadsByPkArgs = {
  _append: InputMaybe<BulkDocumentsUploadsAppendInput>;
  _delete_at_path: InputMaybe<BulkDocumentsUploadsDeleteAtPathInput>;
  _delete_elem: InputMaybe<BulkDocumentsUploadsDeleteElemInput>;
  _delete_key: InputMaybe<BulkDocumentsUploadsDeleteKeyInput>;
  _inc: InputMaybe<BulkDocumentsUploadsIncInput>;
  _prepend: InputMaybe<BulkDocumentsUploadsPrependInput>;
  _set: InputMaybe<BulkDocumentsUploadsSetInput>;
  pk_columns: BulkDocumentsUploadsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateBulkDocumentsUploadsManyArgs = {
  updates: Array<BulkDocumentsUploadsUpdates>;
};


/** mutation root */
export type MutationRootUpdateConfigTranslationsArgs = {
  _set: InputMaybe<ConfigTranslationsSetInput>;
  where: ConfigTranslationsBoolExp;
};


/** mutation root */
export type MutationRootUpdateConfigTranslationsByPkArgs = {
  _set: InputMaybe<ConfigTranslationsSetInput>;
  pk_columns: ConfigTranslationsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateConfigTranslationsManyArgs = {
  updates: Array<ConfigTranslationsUpdates>;
};


/** mutation root */
export type MutationRootUpdateCoreDataDependenciesArgs = {
  _set: InputMaybe<CoreDataDependenciesSetInput>;
  where: CoreDataDependenciesBoolExp;
};


/** mutation root */
export type MutationRootUpdateCoreDataDependenciesByPkArgs = {
  _set: InputMaybe<CoreDataDependenciesSetInput>;
  pk_columns: CoreDataDependenciesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCoreDataDependenciesManyArgs = {
  updates: Array<CoreDataDependenciesUpdates>;
};


/** mutation root */
export type MutationRootUpdateCoreDataExternalReferencesArgs = {
  _set: InputMaybe<CoreDataExternalReferencesSetInput>;
  where: CoreDataExternalReferencesBoolExp;
};


/** mutation root */
export type MutationRootUpdateCoreDataExternalReferencesByPkArgs = {
  _set: InputMaybe<CoreDataExternalReferencesSetInput>;
  pk_columns: CoreDataExternalReferencesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCoreDataExternalReferencesManyArgs = {
  updates: Array<CoreDataExternalReferencesUpdates>;
};


/** mutation root */
export type MutationRootUpdateCoreDataOrganisationIntegrationsArgs = {
  _set: InputMaybe<CoreDataOrganisationIntegrationsSetInput>;
  where: CoreDataOrganisationIntegrationsBoolExp;
};


/** mutation root */
export type MutationRootUpdateCoreDataOrganisationIntegrationsByPkArgs = {
  _set: InputMaybe<CoreDataOrganisationIntegrationsSetInput>;
  pk_columns: CoreDataOrganisationIntegrationsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCoreDataOrganisationIntegrationsManyArgs = {
  updates: Array<CoreDataOrganisationIntegrationsUpdates>;
};


/** mutation root */
export type MutationRootUpdateCustomCoreDataArgs = {
  _set: InputMaybe<CustomCoreDataSetInput>;
  where: CustomCoreDataBoolExp;
};


/** mutation root */
export type MutationRootUpdateCustomCoreDataByPkArgs = {
  _set: InputMaybe<CustomCoreDataSetInput>;
  pk_columns: CustomCoreDataPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCustomCoreDataManyArgs = {
  updates: Array<CustomCoreDataUpdates>;
};


/** mutation root */
export type MutationRootUpdateCustomCoreDataOptionsArgs = {
  _set: InputMaybe<CustomCoreDataOptionsSetInput>;
  where: CustomCoreDataOptionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateCustomCoreDataOptionsByPkArgs = {
  _set: InputMaybe<CustomCoreDataOptionsSetInput>;
  pk_columns: CustomCoreDataOptionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCustomCoreDataOptionsManyArgs = {
  updates: Array<CustomCoreDataOptionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateCustomFieldCoreDataArgs = {
  _set: InputMaybe<CustomFieldCoreDataSetInput>;
  where: CustomFieldCoreDataBoolExp;
};


/** mutation root */
export type MutationRootUpdateCustomFieldCoreDataByPkArgs = {
  _set: InputMaybe<CustomFieldCoreDataSetInput>;
  pk_columns: CustomFieldCoreDataPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCustomFieldCoreDataManyArgs = {
  updates: Array<CustomFieldCoreDataUpdates>;
};


/** mutation root */
export type MutationRootUpdateCustomFieldValuesArgs = {
  _inc: InputMaybe<CustomFieldValuesIncInput>;
  _set: InputMaybe<CustomFieldValuesSetInput>;
  where: CustomFieldValuesBoolExp;
};


/** mutation root */
export type MutationRootUpdateCustomFieldValuesByPkArgs = {
  _inc: InputMaybe<CustomFieldValuesIncInput>;
  _set: InputMaybe<CustomFieldValuesSetInput>;
  pk_columns: CustomFieldValuesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCustomFieldValuesManyArgs = {
  updates: Array<CustomFieldValuesUpdates>;
};


/** mutation root */
export type MutationRootUpdateCustomFieldsArgs = {
  _set: InputMaybe<CustomFieldsSetInput>;
  where: CustomFieldsBoolExp;
};


/** mutation root */
export type MutationRootUpdateCustomFieldsByPkArgs = {
  _set: InputMaybe<CustomFieldsSetInput>;
  pk_columns: CustomFieldsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCustomFieldsManyArgs = {
  updates: Array<CustomFieldsUpdates>;
};


/** mutation root */
export type MutationRootUpdateCustomReportsArgs = {
  _append: InputMaybe<CustomReportsAppendInput>;
  _delete_at_path: InputMaybe<CustomReportsDeleteAtPathInput>;
  _delete_elem: InputMaybe<CustomReportsDeleteElemInput>;
  _delete_key: InputMaybe<CustomReportsDeleteKeyInput>;
  _prepend: InputMaybe<CustomReportsPrependInput>;
  _set: InputMaybe<CustomReportsSetInput>;
  where: CustomReportsBoolExp;
};


/** mutation root */
export type MutationRootUpdateCustomReportsByPkArgs = {
  _append: InputMaybe<CustomReportsAppendInput>;
  _delete_at_path: InputMaybe<CustomReportsDeleteAtPathInput>;
  _delete_elem: InputMaybe<CustomReportsDeleteElemInput>;
  _delete_key: InputMaybe<CustomReportsDeleteKeyInput>;
  _prepend: InputMaybe<CustomReportsPrependInput>;
  _set: InputMaybe<CustomReportsSetInput>;
  pk_columns: CustomReportsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCustomReportsGenerationsArgs = {
  _set: InputMaybe<CustomReportsGenerationsSetInput>;
  where: CustomReportsGenerationsBoolExp;
};


/** mutation root */
export type MutationRootUpdateCustomReportsGenerationsByPkArgs = {
  _set: InputMaybe<CustomReportsGenerationsSetInput>;
  pk_columns: CustomReportsGenerationsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateCustomReportsGenerationsManyArgs = {
  updates: Array<CustomReportsGenerationsUpdates>;
};


/** mutation root */
export type MutationRootUpdateCustomReportsManyArgs = {
  updates: Array<CustomReportsUpdates>;
};


/** mutation root */
export type MutationRootUpdateDepartmentsArgs = {
  _set: InputMaybe<DepartmentsSetInput>;
  where: DepartmentsBoolExp;
};


/** mutation root */
export type MutationRootUpdateDepartmentsByPkArgs = {
  _set: InputMaybe<DepartmentsSetInput>;
  pk_columns: DepartmentsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDepartmentsManyArgs = {
  updates: Array<DepartmentsUpdates>;
};


/** mutation root */
export type MutationRootUpdateDocumentTypesArgs = {
  _append: InputMaybe<DocumentTypesAppendInput>;
  _delete_at_path: InputMaybe<DocumentTypesDeleteAtPathInput>;
  _delete_elem: InputMaybe<DocumentTypesDeleteElemInput>;
  _delete_key: InputMaybe<DocumentTypesDeleteKeyInput>;
  _prepend: InputMaybe<DocumentTypesPrependInput>;
  _set: InputMaybe<DocumentTypesSetInput>;
  where: DocumentTypesBoolExp;
};


/** mutation root */
export type MutationRootUpdateDocumentTypesByPkArgs = {
  _append: InputMaybe<DocumentTypesAppendInput>;
  _delete_at_path: InputMaybe<DocumentTypesDeleteAtPathInput>;
  _delete_elem: InputMaybe<DocumentTypesDeleteElemInput>;
  _delete_key: InputMaybe<DocumentTypesDeleteKeyInput>;
  _prepend: InputMaybe<DocumentTypesPrependInput>;
  _set: InputMaybe<DocumentTypesSetInput>;
  pk_columns: DocumentTypesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDocumentTypesManyArgs = {
  updates: Array<DocumentTypesUpdates>;
};


/** mutation root */
export type MutationRootUpdateDocumentsArgs = {
  _set: InputMaybe<DocumentsSetInput>;
  where: DocumentsBoolExp;
};


/** mutation root */
export type MutationRootUpdateDocumentsByPkArgs = {
  _set: InputMaybe<DocumentsSetInput>;
  pk_columns: DocumentsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDocumentsManyArgs = {
  updates: Array<DocumentsUpdates>;
};


/** mutation root */
export type MutationRootUpdateDraftIntakeSubmissionsArgs = {
  _append: InputMaybe<DraftIntakeSubmissionsAppendInput>;
  _delete_at_path: InputMaybe<DraftIntakeSubmissionsDeleteAtPathInput>;
  _delete_elem: InputMaybe<DraftIntakeSubmissionsDeleteElemInput>;
  _delete_key: InputMaybe<DraftIntakeSubmissionsDeleteKeyInput>;
  _prepend: InputMaybe<DraftIntakeSubmissionsPrependInput>;
  _set: InputMaybe<DraftIntakeSubmissionsSetInput>;
  where: DraftIntakeSubmissionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateDraftIntakeSubmissionsByPkArgs = {
  _append: InputMaybe<DraftIntakeSubmissionsAppendInput>;
  _delete_at_path: InputMaybe<DraftIntakeSubmissionsDeleteAtPathInput>;
  _delete_elem: InputMaybe<DraftIntakeSubmissionsDeleteElemInput>;
  _delete_key: InputMaybe<DraftIntakeSubmissionsDeleteKeyInput>;
  _prepend: InputMaybe<DraftIntakeSubmissionsPrependInput>;
  _set: InputMaybe<DraftIntakeSubmissionsSetInput>;
  pk_columns: DraftIntakeSubmissionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDraftIntakeSubmissionsManyArgs = {
  updates: Array<DraftIntakeSubmissionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateEngagementsArgs = {
  _append: InputMaybe<EngagementsAppendInput>;
  _delete_at_path: InputMaybe<EngagementsDeleteAtPathInput>;
  _delete_elem: InputMaybe<EngagementsDeleteElemInput>;
  _delete_key: InputMaybe<EngagementsDeleteKeyInput>;
  _inc: InputMaybe<EngagementsIncInput>;
  _prepend: InputMaybe<EngagementsPrependInput>;
  _set: InputMaybe<EngagementsSetInput>;
  where: EngagementsBoolExp;
};


/** mutation root */
export type MutationRootUpdateEngagementsByPkArgs = {
  _append: InputMaybe<EngagementsAppendInput>;
  _delete_at_path: InputMaybe<EngagementsDeleteAtPathInput>;
  _delete_elem: InputMaybe<EngagementsDeleteElemInput>;
  _delete_key: InputMaybe<EngagementsDeleteKeyInput>;
  _inc: InputMaybe<EngagementsIncInput>;
  _prepend: InputMaybe<EngagementsPrependInput>;
  _set: InputMaybe<EngagementsSetInput>;
  pk_columns: EngagementsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEngagementsManyArgs = {
  updates: Array<EngagementsUpdates>;
};


/** mutation root */
export type MutationRootUpdateEntityBankDetailsArgs = {
  _set: InputMaybe<EntityBankDetailsSetInput>;
  where: EntityBankDetailsBoolExp;
};


/** mutation root */
export type MutationRootUpdateEntityBankDetailsByPkArgs = {
  _set: InputMaybe<EntityBankDetailsSetInput>;
  pk_columns: EntityBankDetailsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEntityBankDetailsManyArgs = {
  updates: Array<EntityBankDetailsUpdates>;
};


/** mutation root */
export type MutationRootUpdateEntityFieldGroupFieldsArgs = {
  _inc: InputMaybe<EntityFieldGroupFieldsIncInput>;
  _set: InputMaybe<EntityFieldGroupFieldsSetInput>;
  where: EntityFieldGroupFieldsBoolExp;
};


/** mutation root */
export type MutationRootUpdateEntityFieldGroupFieldsByPkArgs = {
  _inc: InputMaybe<EntityFieldGroupFieldsIncInput>;
  _set: InputMaybe<EntityFieldGroupFieldsSetInput>;
  pk_columns: EntityFieldGroupFieldsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEntityFieldGroupFieldsManyArgs = {
  updates: Array<EntityFieldGroupFieldsUpdates>;
};


/** mutation root */
export type MutationRootUpdateEntityFieldGroupsArgs = {
  _inc: InputMaybe<EntityFieldGroupsIncInput>;
  _set: InputMaybe<EntityFieldGroupsSetInput>;
  where: EntityFieldGroupsBoolExp;
};


/** mutation root */
export type MutationRootUpdateEntityFieldGroupsByPkArgs = {
  _inc: InputMaybe<EntityFieldGroupsIncInput>;
  _set: InputMaybe<EntityFieldGroupsSetInput>;
  pk_columns: EntityFieldGroupsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateEntityFieldGroupsManyArgs = {
  updates: Array<EntityFieldGroupsUpdates>;
};


/** mutation root */
export type MutationRootUpdateExternalContactsArgs = {
  _set: InputMaybe<ExternalContactsSetInput>;
  where: ExternalContactsBoolExp;
};


/** mutation root */
export type MutationRootUpdateExternalContactsByPkArgs = {
  _set: InputMaybe<ExternalContactsSetInput>;
  pk_columns: ExternalContactsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateExternalContactsManyArgs = {
  updates: Array<ExternalContactsUpdates>;
};


/** mutation root */
export type MutationRootUpdateExternalEntitySyncStatusesArgs = {
  _append: InputMaybe<ExternalEntitySyncStatusesAppendInput>;
  _delete_at_path: InputMaybe<ExternalEntitySyncStatusesDeleteAtPathInput>;
  _delete_elem: InputMaybe<ExternalEntitySyncStatusesDeleteElemInput>;
  _delete_key: InputMaybe<ExternalEntitySyncStatusesDeleteKeyInput>;
  _prepend: InputMaybe<ExternalEntitySyncStatusesPrependInput>;
  _set: InputMaybe<ExternalEntitySyncStatusesSetInput>;
  where: ExternalEntitySyncStatusesBoolExp;
};


/** mutation root */
export type MutationRootUpdateExternalEntitySyncStatusesByPkArgs = {
  _append: InputMaybe<ExternalEntitySyncStatusesAppendInput>;
  _delete_at_path: InputMaybe<ExternalEntitySyncStatusesDeleteAtPathInput>;
  _delete_elem: InputMaybe<ExternalEntitySyncStatusesDeleteElemInput>;
  _delete_key: InputMaybe<ExternalEntitySyncStatusesDeleteKeyInput>;
  _prepend: InputMaybe<ExternalEntitySyncStatusesPrependInput>;
  _set: InputMaybe<ExternalEntitySyncStatusesSetInput>;
  pk_columns: ExternalEntitySyncStatusesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateExternalEntitySyncStatusesManyArgs = {
  updates: Array<ExternalEntitySyncStatusesUpdates>;
};


/** mutation root */
export type MutationRootUpdateExternalRiskScoresArgs = {
  _append: InputMaybe<ExternalRiskScoresAppendInput>;
  _delete_at_path: InputMaybe<ExternalRiskScoresDeleteAtPathInput>;
  _delete_elem: InputMaybe<ExternalRiskScoresDeleteElemInput>;
  _delete_key: InputMaybe<ExternalRiskScoresDeleteKeyInput>;
  _inc: InputMaybe<ExternalRiskScoresIncInput>;
  _prepend: InputMaybe<ExternalRiskScoresPrependInput>;
  _set: InputMaybe<ExternalRiskScoresSetInput>;
  where: ExternalRiskScoresBoolExp;
};


/** mutation root */
export type MutationRootUpdateExternalRiskScoresByPkArgs = {
  _append: InputMaybe<ExternalRiskScoresAppendInput>;
  _delete_at_path: InputMaybe<ExternalRiskScoresDeleteAtPathInput>;
  _delete_elem: InputMaybe<ExternalRiskScoresDeleteElemInput>;
  _delete_key: InputMaybe<ExternalRiskScoresDeleteKeyInput>;
  _inc: InputMaybe<ExternalRiskScoresIncInput>;
  _prepend: InputMaybe<ExternalRiskScoresPrependInput>;
  _set: InputMaybe<ExternalRiskScoresSetInput>;
  pk_columns: ExternalRiskScoresPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateExternalRiskScoresManyArgs = {
  updates: Array<ExternalRiskScoresUpdates>;
};


/** mutation root */
export type MutationRootUpdateFinancialsArgs = {
  _inc: InputMaybe<FinancialsIncInput>;
  _set: InputMaybe<FinancialsSetInput>;
  where: FinancialsBoolExp;
};


/** mutation root */
export type MutationRootUpdateFinancialsByPkArgs = {
  _inc: InputMaybe<FinancialsIncInput>;
  _set: InputMaybe<FinancialsSetInput>;
  pk_columns: FinancialsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFinancialsManyArgs = {
  updates: Array<FinancialsUpdates>;
};


/** mutation root */
export type MutationRootUpdateFormTemplateQuestionInsightsArgs = {
  _append: InputMaybe<FormTemplateQuestionInsightsAppendInput>;
  _delete_at_path: InputMaybe<FormTemplateQuestionInsightsDeleteAtPathInput>;
  _delete_elem: InputMaybe<FormTemplateQuestionInsightsDeleteElemInput>;
  _delete_key: InputMaybe<FormTemplateQuestionInsightsDeleteKeyInput>;
  _prepend: InputMaybe<FormTemplateQuestionInsightsPrependInput>;
  _set: InputMaybe<FormTemplateQuestionInsightsSetInput>;
  where: FormTemplateQuestionInsightsBoolExp;
};


/** mutation root */
export type MutationRootUpdateFormTemplateQuestionInsightsByPkArgs = {
  _append: InputMaybe<FormTemplateQuestionInsightsAppendInput>;
  _delete_at_path: InputMaybe<FormTemplateQuestionInsightsDeleteAtPathInput>;
  _delete_elem: InputMaybe<FormTemplateQuestionInsightsDeleteElemInput>;
  _delete_key: InputMaybe<FormTemplateQuestionInsightsDeleteKeyInput>;
  _prepend: InputMaybe<FormTemplateQuestionInsightsPrependInput>;
  _set: InputMaybe<FormTemplateQuestionInsightsSetInput>;
  pk_columns: FormTemplateQuestionInsightsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFormTemplateQuestionInsightsManyArgs = {
  updates: Array<FormTemplateQuestionInsightsUpdates>;
};


/** mutation root */
export type MutationRootUpdateFormTemplatesArgs = {
  _append: InputMaybe<FormTemplatesAppendInput>;
  _delete_at_path: InputMaybe<FormTemplatesDeleteAtPathInput>;
  _delete_elem: InputMaybe<FormTemplatesDeleteElemInput>;
  _delete_key: InputMaybe<FormTemplatesDeleteKeyInput>;
  _prepend: InputMaybe<FormTemplatesPrependInput>;
  _set: InputMaybe<FormTemplatesSetInput>;
  where: FormTemplatesBoolExp;
};


/** mutation root */
export type MutationRootUpdateFormTemplatesByPkArgs = {
  _append: InputMaybe<FormTemplatesAppendInput>;
  _delete_at_path: InputMaybe<FormTemplatesDeleteAtPathInput>;
  _delete_elem: InputMaybe<FormTemplatesDeleteElemInput>;
  _delete_key: InputMaybe<FormTemplatesDeleteKeyInput>;
  _prepend: InputMaybe<FormTemplatesPrependInput>;
  _set: InputMaybe<FormTemplatesSetInput>;
  pk_columns: FormTemplatesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateFormTemplatesManyArgs = {
  updates: Array<FormTemplatesUpdates>;
};


/** mutation root */
export type MutationRootUpdateGroupUserAssignmentsArgs = {
  _set: InputMaybe<GroupUserAssignmentsSetInput>;
  where: GroupUserAssignmentsBoolExp;
};


/** mutation root */
export type MutationRootUpdateGroupUserAssignmentsByPkArgs = {
  _set: InputMaybe<GroupUserAssignmentsSetInput>;
  pk_columns: GroupUserAssignmentsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGroupUserAssignmentsManyArgs = {
  updates: Array<GroupUserAssignmentsUpdates>;
};


/** mutation root */
export type MutationRootUpdateGroupUsersArgs = {
  _set: InputMaybe<GroupUsersSetInput>;
  where: GroupUsersBoolExp;
};


/** mutation root */
export type MutationRootUpdateGroupUsersByPkArgs = {
  _set: InputMaybe<GroupUsersSetInput>;
  pk_columns: GroupUsersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGroupUsersManyArgs = {
  updates: Array<GroupUsersUpdates>;
};


/** mutation root */
export type MutationRootUpdateGroupsArgs = {
  _append: InputMaybe<GroupsAppendInput>;
  _delete_at_path: InputMaybe<GroupsDeleteAtPathInput>;
  _delete_elem: InputMaybe<GroupsDeleteElemInput>;
  _delete_key: InputMaybe<GroupsDeleteKeyInput>;
  _prepend: InputMaybe<GroupsPrependInput>;
  _set: InputMaybe<GroupsSetInput>;
  where: GroupsBoolExp;
};


/** mutation root */
export type MutationRootUpdateGroupsByPkArgs = {
  _append: InputMaybe<GroupsAppendInput>;
  _delete_at_path: InputMaybe<GroupsDeleteAtPathInput>;
  _delete_elem: InputMaybe<GroupsDeleteElemInput>;
  _delete_key: InputMaybe<GroupsDeleteKeyInput>;
  _prepend: InputMaybe<GroupsPrependInput>;
  _set: InputMaybe<GroupsSetInput>;
  pk_columns: GroupsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGroupsManyArgs = {
  updates: Array<GroupsUpdates>;
};


/** mutation root */
export type MutationRootUpdateIdpAttributeMappingsArgs = {
  _set: InputMaybe<IdpAttributeMappingsSetInput>;
  where: IdpAttributeMappingsBoolExp;
};


/** mutation root */
export type MutationRootUpdateIdpAttributeMappingsByPkArgs = {
  _set: InputMaybe<IdpAttributeMappingsSetInput>;
  pk_columns: IdpAttributeMappingsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateIdpAttributeMappingsManyArgs = {
  updates: Array<IdpAttributeMappingsUpdates>;
};


/** mutation root */
export type MutationRootUpdateInternalContactsArgs = {
  _set: InputMaybe<InternalContactsSetInput>;
  where: InternalContactsBoolExp;
};


/** mutation root */
export type MutationRootUpdateInternalContactsByPkArgs = {
  _set: InputMaybe<InternalContactsSetInput>;
  pk_columns: InternalContactsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateInternalContactsManyArgs = {
  updates: Array<InternalContactsUpdates>;
};


/** mutation root */
export type MutationRootUpdateLineItemTypesArgs = {
  _set: InputMaybe<LineItemTypesSetInput>;
  where: LineItemTypesBoolExp;
};


/** mutation root */
export type MutationRootUpdateLineItemTypesByPkArgs = {
  _set: InputMaybe<LineItemTypesSetInput>;
  pk_columns: LineItemTypesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateLineItemTypesManyArgs = {
  updates: Array<LineItemTypesUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationCoreDataDependenciesArgs = {
  _set: InputMaybe<OrganisationCoreDataDependenciesSetInput>;
  where: OrganisationCoreDataDependenciesBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationCoreDataDependenciesByPkArgs = {
  _set: InputMaybe<OrganisationCoreDataDependenciesSetInput>;
  pk_columns: OrganisationCoreDataDependenciesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationCoreDataDependenciesManyArgs = {
  updates: Array<OrganisationCoreDataDependenciesUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationFeatureFlagsArgs = {
  _set: InputMaybe<OrganisationFeatureFlagsSetInput>;
  where: OrganisationFeatureFlagsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationFeatureFlagsManyArgs = {
  updates: Array<OrganisationFeatureFlagsUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationFxRatesArgs = {
  _inc: InputMaybe<OrganisationFxRatesIncInput>;
  _set: InputMaybe<OrganisationFxRatesSetInput>;
  where: OrganisationFxRatesBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationFxRatesByPkArgs = {
  _inc: InputMaybe<OrganisationFxRatesIncInput>;
  _set: InputMaybe<OrganisationFxRatesSetInput>;
  pk_columns: OrganisationFxRatesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationFxRatesManyArgs = {
  updates: Array<OrganisationFxRatesUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationIntegrationsArgs = {
  _set: InputMaybe<OrganisationIntegrationsSetInput>;
  where: OrganisationIntegrationsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationIntegrationsByPkArgs = {
  _set: InputMaybe<OrganisationIntegrationsSetInput>;
  pk_columns: OrganisationIntegrationsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationIntegrationsManyArgs = {
  updates: Array<OrganisationIntegrationsUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationLocalesArgs = {
  _set: InputMaybe<OrganisationLocalesSetInput>;
  where: OrganisationLocalesBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationLocalesByPkArgs = {
  _set: InputMaybe<OrganisationLocalesSetInput>;
  pk_columns: OrganisationLocalesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationLocalesManyArgs = {
  updates: Array<OrganisationLocalesUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationProductSupplierCategoriesArgs = {
  _set: InputMaybe<OrganisationProductSupplierCategoriesSetInput>;
  where: OrganisationProductSupplierCategoriesBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationProductSupplierCategoriesByPkArgs = {
  _set: InputMaybe<OrganisationProductSupplierCategoriesSetInput>;
  pk_columns: OrganisationProductSupplierCategoriesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationProductSupplierCategoriesManyArgs = {
  updates: Array<OrganisationProductSupplierCategoriesUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationProductsAndServicesArgs = {
  _set: InputMaybe<OrganisationProductsAndServicesSetInput>;
  where: OrganisationProductsAndServicesBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationProductsAndServicesBrandsArgs = {
  _set: InputMaybe<OrganisationProductsAndServicesBrandsSetInput>;
  where: OrganisationProductsAndServicesBrandsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationProductsAndServicesBrandsByPkArgs = {
  _set: InputMaybe<OrganisationProductsAndServicesBrandsSetInput>;
  pk_columns: OrganisationProductsAndServicesBrandsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationProductsAndServicesBrandsManyArgs = {
  updates: Array<OrganisationProductsAndServicesBrandsUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationProductsAndServicesByPkArgs = {
  _set: InputMaybe<OrganisationProductsAndServicesSetInput>;
  pk_columns: OrganisationProductsAndServicesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationProductsAndServicesManyArgs = {
  updates: Array<OrganisationProductsAndServicesUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationPublicApiClientsArgs = {
  _set: InputMaybe<OrganisationPublicApiClientsSetInput>;
  where: OrganisationPublicApiClientsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationPublicApiClientsByPkArgs = {
  _set: InputMaybe<OrganisationPublicApiClientsSetInput>;
  pk_columns: OrganisationPublicApiClientsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationPublicApiClientsManyArgs = {
  updates: Array<OrganisationPublicApiClientsUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationSettingsArgs = {
  _append: InputMaybe<OrganisationSettingsAppendInput>;
  _delete_at_path: InputMaybe<OrganisationSettingsDeleteAtPathInput>;
  _delete_elem: InputMaybe<OrganisationSettingsDeleteElemInput>;
  _delete_key: InputMaybe<OrganisationSettingsDeleteKeyInput>;
  _prepend: InputMaybe<OrganisationSettingsPrependInput>;
  _set: InputMaybe<OrganisationSettingsSetInput>;
  where: OrganisationSettingsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationSettingsByPkArgs = {
  _append: InputMaybe<OrganisationSettingsAppendInput>;
  _delete_at_path: InputMaybe<OrganisationSettingsDeleteAtPathInput>;
  _delete_elem: InputMaybe<OrganisationSettingsDeleteElemInput>;
  _delete_key: InputMaybe<OrganisationSettingsDeleteKeyInput>;
  _prepend: InputMaybe<OrganisationSettingsPrependInput>;
  _set: InputMaybe<OrganisationSettingsSetInput>;
  pk_columns: OrganisationSettingsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationSettingsManyArgs = {
  updates: Array<OrganisationSettingsUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationStaticContentArgs = {
  _append: InputMaybe<OrganisationStaticContentAppendInput>;
  _delete_at_path: InputMaybe<OrganisationStaticContentDeleteAtPathInput>;
  _delete_elem: InputMaybe<OrganisationStaticContentDeleteElemInput>;
  _delete_key: InputMaybe<OrganisationStaticContentDeleteKeyInput>;
  _prepend: InputMaybe<OrganisationStaticContentPrependInput>;
  _set: InputMaybe<OrganisationStaticContentSetInput>;
  where: OrganisationStaticContentBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationStaticContentByPkArgs = {
  _append: InputMaybe<OrganisationStaticContentAppendInput>;
  _delete_at_path: InputMaybe<OrganisationStaticContentDeleteAtPathInput>;
  _delete_elem: InputMaybe<OrganisationStaticContentDeleteElemInput>;
  _delete_key: InputMaybe<OrganisationStaticContentDeleteKeyInput>;
  _prepend: InputMaybe<OrganisationStaticContentPrependInput>;
  _set: InputMaybe<OrganisationStaticContentSetInput>;
  pk_columns: OrganisationStaticContentPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationStaticContentManyArgs = {
  updates: Array<OrganisationStaticContentUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierHistoricSubmissionsArgs = {
  _append: InputMaybe<OrganisationSupplierHistoricSubmissionsAppendInput>;
  _delete_at_path: InputMaybe<OrganisationSupplierHistoricSubmissionsDeleteAtPathInput>;
  _delete_elem: InputMaybe<OrganisationSupplierHistoricSubmissionsDeleteElemInput>;
  _delete_key: InputMaybe<OrganisationSupplierHistoricSubmissionsDeleteKeyInput>;
  _prepend: InputMaybe<OrganisationSupplierHistoricSubmissionsPrependInput>;
  _set: InputMaybe<OrganisationSupplierHistoricSubmissionsSetInput>;
  where: OrganisationSupplierHistoricSubmissionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierHistoricSubmissionsByPkArgs = {
  _append: InputMaybe<OrganisationSupplierHistoricSubmissionsAppendInput>;
  _delete_at_path: InputMaybe<OrganisationSupplierHistoricSubmissionsDeleteAtPathInput>;
  _delete_elem: InputMaybe<OrganisationSupplierHistoricSubmissionsDeleteElemInput>;
  _delete_key: InputMaybe<OrganisationSupplierHistoricSubmissionsDeleteKeyInput>;
  _prepend: InputMaybe<OrganisationSupplierHistoricSubmissionsPrependInput>;
  _set: InputMaybe<OrganisationSupplierHistoricSubmissionsSetInput>;
  pk_columns: OrganisationSupplierHistoricSubmissionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierHistoricSubmissionsManyArgs = {
  updates: Array<OrganisationSupplierHistoricSubmissionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierOnlineResourcesArgs = {
  _set: InputMaybe<OrganisationSupplierOnlineResourcesSetInput>;
  where: OrganisationSupplierOnlineResourcesBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierOnlineResourcesByPkArgs = {
  _set: InputMaybe<OrganisationSupplierOnlineResourcesSetInput>;
  pk_columns: OrganisationSupplierOnlineResourcesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierOnlineResourcesManyArgs = {
  updates: Array<OrganisationSupplierOnlineResourcesUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierProfileResourcesArgs = {
  _set: InputMaybe<OrganisationSupplierProfileResourcesSetInput>;
  where: OrganisationSupplierProfileResourcesBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierProfileResourcesByPkArgs = {
  _set: InputMaybe<OrganisationSupplierProfileResourcesSetInput>;
  pk_columns: OrganisationSupplierProfileResourcesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierProfileResourcesManyArgs = {
  updates: Array<OrganisationSupplierProfileResourcesUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierProfilesArgs = {
  _set: InputMaybe<OrganisationSupplierProfilesSetInput>;
  where: OrganisationSupplierProfilesBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierProfilesByPkArgs = {
  _set: InputMaybe<OrganisationSupplierProfilesSetInput>;
  pk_columns: OrganisationSupplierProfilesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierProfilesManyArgs = {
  updates: Array<OrganisationSupplierProfilesUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierTagsArgs = {
  _set: InputMaybe<OrganisationSupplierTagsSetInput>;
  where: OrganisationSupplierTagsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierTagsByPkArgs = {
  _set: InputMaybe<OrganisationSupplierTagsSetInput>;
  pk_columns: OrganisationSupplierTagsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationSupplierTagsManyArgs = {
  updates: Array<OrganisationSupplierTagsUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationSuppliersArgs = {
  _append: InputMaybe<OrganisationSuppliersAppendInput>;
  _delete_at_path: InputMaybe<OrganisationSuppliersDeleteAtPathInput>;
  _delete_elem: InputMaybe<OrganisationSuppliersDeleteElemInput>;
  _delete_key: InputMaybe<OrganisationSuppliersDeleteKeyInput>;
  _inc: InputMaybe<OrganisationSuppliersIncInput>;
  _prepend: InputMaybe<OrganisationSuppliersPrependInput>;
  _set: InputMaybe<OrganisationSuppliersSetInput>;
  where: OrganisationSuppliersBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationSuppliersBrandsArgs = {
  _inc: InputMaybe<OrganisationSuppliersBrandsIncInput>;
  _set: InputMaybe<OrganisationSuppliersBrandsSetInput>;
  where: OrganisationSuppliersBrandsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationSuppliersBrandsByPkArgs = {
  _inc: InputMaybe<OrganisationSuppliersBrandsIncInput>;
  _set: InputMaybe<OrganisationSuppliersBrandsSetInput>;
  pk_columns: OrganisationSuppliersBrandsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationSuppliersBrandsManyArgs = {
  updates: Array<OrganisationSuppliersBrandsUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationSuppliersByPkArgs = {
  _append: InputMaybe<OrganisationSuppliersAppendInput>;
  _delete_at_path: InputMaybe<OrganisationSuppliersDeleteAtPathInput>;
  _delete_elem: InputMaybe<OrganisationSuppliersDeleteElemInput>;
  _delete_key: InputMaybe<OrganisationSuppliersDeleteKeyInput>;
  _inc: InputMaybe<OrganisationSuppliersIncInput>;
  _prepend: InputMaybe<OrganisationSuppliersPrependInput>;
  _set: InputMaybe<OrganisationSuppliersSetInput>;
  pk_columns: OrganisationSuppliersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationSuppliersCategoriesArgs = {
  _set: InputMaybe<OrganisationSuppliersCategoriesSetInput>;
  where: OrganisationSuppliersCategoriesBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationSuppliersCategoriesByPkArgs = {
  _set: InputMaybe<OrganisationSuppliersCategoriesSetInput>;
  pk_columns: OrganisationSuppliersCategoriesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationSuppliersCategoriesManyArgs = {
  updates: Array<OrganisationSuppliersCategoriesUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationSuppliersManyArgs = {
  updates: Array<OrganisationSuppliersUpdates>;
};


/** mutation root */
export type MutationRootUpdateOrganisationsArgs = {
  _set: InputMaybe<OrganisationsSetInput>;
  where: OrganisationsBoolExp;
};


/** mutation root */
export type MutationRootUpdateOrganisationsByPkArgs = {
  _set: InputMaybe<OrganisationsSetInput>;
  pk_columns: OrganisationsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateOrganisationsManyArgs = {
  updates: Array<OrganisationsUpdates>;
};


/** mutation root */
export type MutationRootUpdatePaymentMethodsArgs = {
  _set: InputMaybe<PaymentMethodsSetInput>;
  where: PaymentMethodsBoolExp;
};


/** mutation root */
export type MutationRootUpdatePaymentMethodsByPkArgs = {
  _set: InputMaybe<PaymentMethodsSetInput>;
  pk_columns: PaymentMethodsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdatePaymentMethodsManyArgs = {
  updates: Array<PaymentMethodsUpdates>;
};


/** mutation root */
export type MutationRootUpdatePaymentTermsArgs = {
  _set: InputMaybe<PaymentTermsSetInput>;
  where: PaymentTermsBoolExp;
};


/** mutation root */
export type MutationRootUpdatePaymentTermsByPkArgs = {
  _set: InputMaybe<PaymentTermsSetInput>;
  pk_columns: PaymentTermsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdatePaymentTermsManyArgs = {
  updates: Array<PaymentTermsUpdates>;
};


/** mutation root */
export type MutationRootUpdateProductCatalogueEntriesArgs = {
  _set: InputMaybe<ProductCatalogueEntriesSetInput>;
  where: ProductCatalogueEntriesBoolExp;
};


/** mutation root */
export type MutationRootUpdateProductCatalogueEntriesByPkArgs = {
  _set: InputMaybe<ProductCatalogueEntriesSetInput>;
  pk_columns: ProductCatalogueEntriesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateProductCatalogueEntriesManyArgs = {
  updates: Array<ProductCatalogueEntriesUpdates>;
};


/** mutation root */
export type MutationRootUpdatePurchaseOrderLineItemsArgs = {
  _inc: InputMaybe<PurchaseOrderLineItemsIncInput>;
  _set: InputMaybe<PurchaseOrderLineItemsSetInput>;
  where: PurchaseOrderLineItemsBoolExp;
};


/** mutation root */
export type MutationRootUpdatePurchaseOrderLineItemsByPkArgs = {
  _inc: InputMaybe<PurchaseOrderLineItemsIncInput>;
  _set: InputMaybe<PurchaseOrderLineItemsSetInput>;
  pk_columns: PurchaseOrderLineItemsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdatePurchaseOrderLineItemsManyArgs = {
  updates: Array<PurchaseOrderLineItemsUpdates>;
};


/** mutation root */
export type MutationRootUpdatePurchaseOrdersArgs = {
  _inc: InputMaybe<PurchaseOrdersIncInput>;
  _set: InputMaybe<PurchaseOrdersSetInput>;
  where: PurchaseOrdersBoolExp;
};


/** mutation root */
export type MutationRootUpdatePurchaseOrdersByPkArgs = {
  _inc: InputMaybe<PurchaseOrdersIncInput>;
  _set: InputMaybe<PurchaseOrdersSetInput>;
  pk_columns: PurchaseOrdersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdatePurchaseOrdersManyArgs = {
  updates: Array<PurchaseOrdersUpdates>;
};


/** mutation root */
export type MutationRootUpdateRenewalAdditionalUsersArgs = {
  _set: InputMaybe<RenewalAdditionalUsersSetInput>;
  where: RenewalAdditionalUsersBoolExp;
};


/** mutation root */
export type MutationRootUpdateRenewalAdditionalUsersByPkArgs = {
  _set: InputMaybe<RenewalAdditionalUsersSetInput>;
  pk_columns: RenewalAdditionalUsersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRenewalAdditionalUsersManyArgs = {
  updates: Array<RenewalAdditionalUsersUpdates>;
};


/** mutation root */
export type MutationRootUpdateRenewalsArgs = {
  _inc: InputMaybe<RenewalsIncInput>;
  _set: InputMaybe<RenewalsSetInput>;
  where: RenewalsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRenewalsByPkArgs = {
  _inc: InputMaybe<RenewalsIncInput>;
  _set: InputMaybe<RenewalsSetInput>;
  pk_columns: RenewalsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRenewalsManyArgs = {
  updates: Array<RenewalsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestCommentsArgs = {
  _append: InputMaybe<RequestCommentsAppendInput>;
  _delete_at_path: InputMaybe<RequestCommentsDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestCommentsDeleteElemInput>;
  _delete_key: InputMaybe<RequestCommentsDeleteKeyInput>;
  _prepend: InputMaybe<RequestCommentsPrependInput>;
  _set: InputMaybe<RequestCommentsSetInput>;
  where: RequestCommentsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestCommentsByPkArgs = {
  _append: InputMaybe<RequestCommentsAppendInput>;
  _delete_at_path: InputMaybe<RequestCommentsDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestCommentsDeleteElemInput>;
  _delete_key: InputMaybe<RequestCommentsDeleteKeyInput>;
  _prepend: InputMaybe<RequestCommentsPrependInput>;
  _set: InputMaybe<RequestCommentsSetInput>;
  pk_columns: RequestCommentsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestCommentsManyArgs = {
  updates: Array<RequestCommentsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestCommentsMentionsArgs = {
  _set: InputMaybe<RequestCommentsMentionsSetInput>;
  where: RequestCommentsMentionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestCommentsMentionsByPkArgs = {
  _set: InputMaybe<RequestCommentsMentionsSetInput>;
  pk_columns: RequestCommentsMentionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestCommentsMentionsManyArgs = {
  updates: Array<RequestCommentsMentionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestComputedPropertiesArgs = {
  _append: InputMaybe<RequestComputedPropertiesAppendInput>;
  _delete_at_path: InputMaybe<RequestComputedPropertiesDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestComputedPropertiesDeleteElemInput>;
  _delete_key: InputMaybe<RequestComputedPropertiesDeleteKeyInput>;
  _inc: InputMaybe<RequestComputedPropertiesIncInput>;
  _prepend: InputMaybe<RequestComputedPropertiesPrependInput>;
  _set: InputMaybe<RequestComputedPropertiesSetInput>;
  where: RequestComputedPropertiesBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestComputedPropertiesByPkArgs = {
  _append: InputMaybe<RequestComputedPropertiesAppendInput>;
  _delete_at_path: InputMaybe<RequestComputedPropertiesDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestComputedPropertiesDeleteElemInput>;
  _delete_key: InputMaybe<RequestComputedPropertiesDeleteKeyInput>;
  _inc: InputMaybe<RequestComputedPropertiesIncInput>;
  _prepend: InputMaybe<RequestComputedPropertiesPrependInput>;
  _set: InputMaybe<RequestComputedPropertiesSetInput>;
  pk_columns: RequestComputedPropertiesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestComputedPropertiesManyArgs = {
  updates: Array<RequestComputedPropertiesUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestDocumentsArgs = {
  _set: InputMaybe<RequestDocumentsSetInput>;
  where: RequestDocumentsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestDocumentsByPkArgs = {
  _set: InputMaybe<RequestDocumentsSetInput>;
  pk_columns: RequestDocumentsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestDocumentsManyArgs = {
  updates: Array<RequestDocumentsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestEsignDocumentsArgs = {
  _set: InputMaybe<RequestEsignDocumentsSetInput>;
  where: RequestEsignDocumentsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestEsignDocumentsByPkArgs = {
  _set: InputMaybe<RequestEsignDocumentsSetInput>;
  pk_columns: RequestEsignDocumentsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestEsignDocumentsManyArgs = {
  updates: Array<RequestEsignDocumentsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestFollowersArgs = {
  _set: InputMaybe<RequestFollowersSetInput>;
  where: RequestFollowersBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestFollowersByPkArgs = {
  _set: InputMaybe<RequestFollowersSetInput>;
  pk_columns: RequestFollowersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestFollowersManyArgs = {
  updates: Array<RequestFollowersUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestFormQuestionAiScoreArgs = {
  _inc: InputMaybe<RequestFormQuestionAiScoreIncInput>;
  _set: InputMaybe<RequestFormQuestionAiScoreSetInput>;
  where: RequestFormQuestionAiScoreBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestFormQuestionAiScoreByPkArgs = {
  _inc: InputMaybe<RequestFormQuestionAiScoreIncInput>;
  _set: InputMaybe<RequestFormQuestionAiScoreSetInput>;
  pk_columns: RequestFormQuestionAiScorePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestFormQuestionAiScoreManyArgs = {
  updates: Array<RequestFormQuestionAiScoreUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestFormQuestionScoreArgs = {
  _inc: InputMaybe<RequestFormQuestionScoreIncInput>;
  _set: InputMaybe<RequestFormQuestionScoreSetInput>;
  where: RequestFormQuestionScoreBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestFormQuestionScoreByPkArgs = {
  _inc: InputMaybe<RequestFormQuestionScoreIncInput>;
  _set: InputMaybe<RequestFormQuestionScoreSetInput>;
  pk_columns: RequestFormQuestionScorePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestFormQuestionScoreManyArgs = {
  updates: Array<RequestFormQuestionScoreUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestFormSubmissionsArgs = {
  _append: InputMaybe<RequestFormSubmissionsAppendInput>;
  _delete_at_path: InputMaybe<RequestFormSubmissionsDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestFormSubmissionsDeleteElemInput>;
  _delete_key: InputMaybe<RequestFormSubmissionsDeleteKeyInput>;
  _prepend: InputMaybe<RequestFormSubmissionsPrependInput>;
  _set: InputMaybe<RequestFormSubmissionsSetInput>;
  where: RequestFormSubmissionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestFormSubmissionsAutoSavesArgs = {
  _append: InputMaybe<RequestFormSubmissionsAutoSavesAppendInput>;
  _delete_at_path: InputMaybe<RequestFormSubmissionsAutoSavesDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestFormSubmissionsAutoSavesDeleteElemInput>;
  _delete_key: InputMaybe<RequestFormSubmissionsAutoSavesDeleteKeyInput>;
  _prepend: InputMaybe<RequestFormSubmissionsAutoSavesPrependInput>;
  _set: InputMaybe<RequestFormSubmissionsAutoSavesSetInput>;
  where: RequestFormSubmissionsAutoSavesBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestFormSubmissionsAutoSavesByPkArgs = {
  _append: InputMaybe<RequestFormSubmissionsAutoSavesAppendInput>;
  _delete_at_path: InputMaybe<RequestFormSubmissionsAutoSavesDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestFormSubmissionsAutoSavesDeleteElemInput>;
  _delete_key: InputMaybe<RequestFormSubmissionsAutoSavesDeleteKeyInput>;
  _prepend: InputMaybe<RequestFormSubmissionsAutoSavesPrependInput>;
  _set: InputMaybe<RequestFormSubmissionsAutoSavesSetInput>;
  pk_columns: RequestFormSubmissionsAutoSavesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestFormSubmissionsAutoSavesManyArgs = {
  updates: Array<RequestFormSubmissionsAutoSavesUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestFormSubmissionsByPkArgs = {
  _append: InputMaybe<RequestFormSubmissionsAppendInput>;
  _delete_at_path: InputMaybe<RequestFormSubmissionsDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestFormSubmissionsDeleteElemInput>;
  _delete_key: InputMaybe<RequestFormSubmissionsDeleteKeyInput>;
  _prepend: InputMaybe<RequestFormSubmissionsPrependInput>;
  _set: InputMaybe<RequestFormSubmissionsSetInput>;
  pk_columns: RequestFormSubmissionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestFormSubmissionsManyArgs = {
  updates: Array<RequestFormSubmissionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestFormTemplateReviewersArgs = {
  _set: InputMaybe<RequestFormTemplateReviewersSetInput>;
  where: RequestFormTemplateReviewersBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestFormTemplateReviewersByPkArgs = {
  _set: InputMaybe<RequestFormTemplateReviewersSetInput>;
  pk_columns: RequestFormTemplateReviewersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestFormTemplateReviewersManyArgs = {
  updates: Array<RequestFormTemplateReviewersUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestFormTemplatesArgs = {
  _append: InputMaybe<RequestFormTemplatesAppendInput>;
  _delete_at_path: InputMaybe<RequestFormTemplatesDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestFormTemplatesDeleteElemInput>;
  _delete_key: InputMaybe<RequestFormTemplatesDeleteKeyInput>;
  _prepend: InputMaybe<RequestFormTemplatesPrependInput>;
  _set: InputMaybe<RequestFormTemplatesSetInput>;
  where: RequestFormTemplatesBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestFormTemplatesByPkArgs = {
  _append: InputMaybe<RequestFormTemplatesAppendInput>;
  _delete_at_path: InputMaybe<RequestFormTemplatesDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestFormTemplatesDeleteElemInput>;
  _delete_key: InputMaybe<RequestFormTemplatesDeleteKeyInput>;
  _prepend: InputMaybe<RequestFormTemplatesPrependInput>;
  _set: InputMaybe<RequestFormTemplatesSetInput>;
  pk_columns: RequestFormTemplatesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestFormTemplatesManyArgs = {
  updates: Array<RequestFormTemplatesUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestFormsArgs = {
  _append: InputMaybe<RequestFormsAppendInput>;
  _delete_at_path: InputMaybe<RequestFormsDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestFormsDeleteElemInput>;
  _delete_key: InputMaybe<RequestFormsDeleteKeyInput>;
  _prepend: InputMaybe<RequestFormsPrependInput>;
  _set: InputMaybe<RequestFormsSetInput>;
  where: RequestFormsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestFormsByPkArgs = {
  _append: InputMaybe<RequestFormsAppendInput>;
  _delete_at_path: InputMaybe<RequestFormsDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestFormsDeleteElemInput>;
  _delete_key: InputMaybe<RequestFormsDeleteKeyInput>;
  _prepend: InputMaybe<RequestFormsPrependInput>;
  _set: InputMaybe<RequestFormsSetInput>;
  pk_columns: RequestFormsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestFormsManyArgs = {
  updates: Array<RequestFormsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestGroupsArgs = {
  _set: InputMaybe<RequestGroupsSetInput>;
  where: RequestGroupsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestGroupsByPkArgs = {
  _set: InputMaybe<RequestGroupsSetInput>;
  pk_columns: RequestGroupsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestGroupsManyArgs = {
  updates: Array<RequestGroupsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestPausesArgs = {
  _set: InputMaybe<RequestPausesSetInput>;
  where: RequestPausesBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestPausesByPkArgs = {
  _set: InputMaybe<RequestPausesSetInput>;
  pk_columns: RequestPausesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestPausesManyArgs = {
  updates: Array<RequestPausesUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestRequestLeadsArgs = {
  _set: InputMaybe<RequestRequestLeadsSetInput>;
  where: RequestRequestLeadsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestRequestLeadsByPkArgs = {
  _set: InputMaybe<RequestRequestLeadsSetInput>;
  pk_columns: RequestRequestLeadsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestRequestLeadsManyArgs = {
  updates: Array<RequestRequestLeadsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestStepGroupsArgs = {
  _set: InputMaybe<RequestStepGroupsSetInput>;
  where: RequestStepGroupsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestStepGroupsByPkArgs = {
  _set: InputMaybe<RequestStepGroupsSetInput>;
  pk_columns: RequestStepGroupsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestStepGroupsManyArgs = {
  updates: Array<RequestStepGroupsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestStepTaskErrorsArgs = {
  _set: InputMaybe<RequestStepTaskErrorsSetInput>;
  where: RequestStepTaskErrorsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestStepTaskErrorsByPkArgs = {
  _set: InputMaybe<RequestStepTaskErrorsSetInput>;
  pk_columns: RequestStepTaskErrorsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestStepTaskErrorsManyArgs = {
  updates: Array<RequestStepTaskErrorsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestStepTaskRejectionsArgs = {
  _set: InputMaybe<RequestStepTaskRejectionsSetInput>;
  where: RequestStepTaskRejectionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestStepTaskRejectionsByPkArgs = {
  _set: InputMaybe<RequestStepTaskRejectionsSetInput>;
  pk_columns: RequestStepTaskRejectionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestStepTaskRejectionsManyArgs = {
  updates: Array<RequestStepTaskRejectionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestStepTasksArgs = {
  _append: InputMaybe<RequestStepTasksAppendInput>;
  _delete_at_path: InputMaybe<RequestStepTasksDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestStepTasksDeleteElemInput>;
  _delete_key: InputMaybe<RequestStepTasksDeleteKeyInput>;
  _prepend: InputMaybe<RequestStepTasksPrependInput>;
  _set: InputMaybe<RequestStepTasksSetInput>;
  where: RequestStepTasksBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestStepTasksByPkArgs = {
  _append: InputMaybe<RequestStepTasksAppendInput>;
  _delete_at_path: InputMaybe<RequestStepTasksDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestStepTasksDeleteElemInput>;
  _delete_key: InputMaybe<RequestStepTasksDeleteKeyInput>;
  _prepend: InputMaybe<RequestStepTasksPrependInput>;
  _set: InputMaybe<RequestStepTasksSetInput>;
  pk_columns: RequestStepTasksPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestStepTasksManyArgs = {
  updates: Array<RequestStepTasksUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestStepUsersArgs = {
  _set: InputMaybe<RequestStepUsersSetInput>;
  where: RequestStepUsersBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestStepUsersByPkArgs = {
  _set: InputMaybe<RequestStepUsersSetInput>;
  pk_columns: RequestStepUsersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestStepUsersManyArgs = {
  updates: Array<RequestStepUsersUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestStepsArgs = {
  _append: InputMaybe<RequestStepsAppendInput>;
  _delete_at_path: InputMaybe<RequestStepsDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestStepsDeleteElemInput>;
  _delete_key: InputMaybe<RequestStepsDeleteKeyInput>;
  _inc: InputMaybe<RequestStepsIncInput>;
  _prepend: InputMaybe<RequestStepsPrependInput>;
  _set: InputMaybe<RequestStepsSetInput>;
  where: RequestStepsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestStepsByPkArgs = {
  _append: InputMaybe<RequestStepsAppendInput>;
  _delete_at_path: InputMaybe<RequestStepsDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestStepsDeleteElemInput>;
  _delete_key: InputMaybe<RequestStepsDeleteKeyInput>;
  _inc: InputMaybe<RequestStepsIncInput>;
  _prepend: InputMaybe<RequestStepsPrependInput>;
  _set: InputMaybe<RequestStepsSetInput>;
  pk_columns: RequestStepsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestStepsManyArgs = {
  updates: Array<RequestStepsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestUsersArgs = {
  _set: InputMaybe<RequestUsersSetInput>;
  where: RequestUsersBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestUsersByPkArgs = {
  _set: InputMaybe<RequestUsersSetInput>;
  pk_columns: RequestUsersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestUsersManyArgs = {
  updates: Array<RequestUsersUpdates>;
};


/** mutation root */
export type MutationRootUpdateRequestsArgs = {
  _append: InputMaybe<RequestsAppendInput>;
  _delete_at_path: InputMaybe<RequestsDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestsDeleteElemInput>;
  _delete_key: InputMaybe<RequestsDeleteKeyInput>;
  _prepend: InputMaybe<RequestsPrependInput>;
  _set: InputMaybe<RequestsSetInput>;
  where: RequestsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRequestsByPkArgs = {
  _append: InputMaybe<RequestsAppendInput>;
  _delete_at_path: InputMaybe<RequestsDeleteAtPathInput>;
  _delete_elem: InputMaybe<RequestsDeleteElemInput>;
  _delete_key: InputMaybe<RequestsDeleteKeyInput>;
  _prepend: InputMaybe<RequestsPrependInput>;
  _set: InputMaybe<RequestsSetInput>;
  pk_columns: RequestsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRequestsManyArgs = {
  updates: Array<RequestsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRfxArgs = {
  _set: InputMaybe<RfxSetInput>;
  where: RfxBoolExp;
};


/** mutation root */
export type MutationRootUpdateRfxAiScoringArgs = {
  _set: InputMaybe<RfxAiScoringSetInput>;
  where: RfxAiScoringBoolExp;
};


/** mutation root */
export type MutationRootUpdateRfxAiScoringByPkArgs = {
  _set: InputMaybe<RfxAiScoringSetInput>;
  pk_columns: RfxAiScoringPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRfxAiScoringManyArgs = {
  updates: Array<RfxAiScoringUpdates>;
};


/** mutation root */
export type MutationRootUpdateRfxByPkArgs = {
  _set: InputMaybe<RfxSetInput>;
  pk_columns: RfxPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRfxConfidentialityAgreementArgs = {
  _set: InputMaybe<RfxConfidentialityAgreementSetInput>;
  where: RfxConfidentialityAgreementBoolExp;
};


/** mutation root */
export type MutationRootUpdateRfxConfidentialityAgreementByPkArgs = {
  _set: InputMaybe<RfxConfidentialityAgreementSetInput>;
  pk_columns: RfxConfidentialityAgreementPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRfxConfidentialityAgreementManyArgs = {
  updates: Array<RfxConfidentialityAgreementUpdates>;
};


/** mutation root */
export type MutationRootUpdateRfxManyArgs = {
  updates: Array<RfxUpdates>;
};


/** mutation root */
export type MutationRootUpdateRfxOwnersArgs = {
  _set: InputMaybe<RfxOwnersSetInput>;
  where: RfxOwnersBoolExp;
};


/** mutation root */
export type MutationRootUpdateRfxOwnersByPkArgs = {
  _set: InputMaybe<RfxOwnersSetInput>;
  pk_columns: RfxOwnersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRfxOwnersManyArgs = {
  updates: Array<RfxOwnersUpdates>;
};


/** mutation root */
export type MutationRootUpdateRfxRequestFormTemplateWeightingArgs = {
  _inc: InputMaybe<RfxRequestFormTemplateWeightingIncInput>;
  _set: InputMaybe<RfxRequestFormTemplateWeightingSetInput>;
  where: RfxRequestFormTemplateWeightingBoolExp;
};


/** mutation root */
export type MutationRootUpdateRfxRequestFormTemplateWeightingByPkArgs = {
  _inc: InputMaybe<RfxRequestFormTemplateWeightingIncInput>;
  _set: InputMaybe<RfxRequestFormTemplateWeightingSetInput>;
  pk_columns: RfxRequestFormTemplateWeightingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRfxRequestFormTemplateWeightingManyArgs = {
  updates: Array<RfxRequestFormTemplateWeightingUpdates>;
};


/** mutation root */
export type MutationRootUpdateRfxRequestFormTemplatesRanksArgs = {
  _inc: InputMaybe<RfxRequestFormTemplatesRanksIncInput>;
  _set: InputMaybe<RfxRequestFormTemplatesRanksSetInput>;
  where: RfxRequestFormTemplatesRanksBoolExp;
};


/** mutation root */
export type MutationRootUpdateRfxRequestFormTemplatesRanksByPkArgs = {
  _inc: InputMaybe<RfxRequestFormTemplatesRanksIncInput>;
  _set: InputMaybe<RfxRequestFormTemplatesRanksSetInput>;
  pk_columns: RfxRequestFormTemplatesRanksPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRfxRequestFormTemplatesRanksManyArgs = {
  updates: Array<RfxRequestFormTemplatesRanksUpdates>;
};


/** mutation root */
export type MutationRootUpdateRfxSuppliersArgs = {
  _set: InputMaybe<RfxSuppliersSetInput>;
  where: RfxSuppliersBoolExp;
};


/** mutation root */
export type MutationRootUpdateRfxSuppliersByPkArgs = {
  _set: InputMaybe<RfxSuppliersSetInput>;
  pk_columns: RfxSuppliersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRfxSuppliersManyArgs = {
  updates: Array<RfxSuppliersUpdates>;
};


/** mutation root */
export type MutationRootUpdateRiskAttributesArgs = {
  _set: InputMaybe<RiskAttributesSetInput>;
  where: RiskAttributesBoolExp;
};


/** mutation root */
export type MutationRootUpdateRiskAttributesByPkArgs = {
  _set: InputMaybe<RiskAttributesSetInput>;
  pk_columns: RiskAttributesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRiskAttributesManyArgs = {
  updates: Array<RiskAttributesUpdates>;
};


/** mutation root */
export type MutationRootUpdateRiskCategoriesArgs = {
  _set: InputMaybe<RiskCategoriesSetInput>;
  where: RiskCategoriesBoolExp;
};


/** mutation root */
export type MutationRootUpdateRiskCategoriesByPkArgs = {
  _set: InputMaybe<RiskCategoriesSetInput>;
  pk_columns: RiskCategoriesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRiskCategoriesManyArgs = {
  updates: Array<RiskCategoriesUpdates>;
};


/** mutation root */
export type MutationRootUpdateRiskLevelsArgs = {
  _inc: InputMaybe<RiskLevelsIncInput>;
  _set: InputMaybe<RiskLevelsSetInput>;
  where: RiskLevelsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRiskLevelsByPkArgs = {
  _inc: InputMaybe<RiskLevelsIncInput>;
  _set: InputMaybe<RiskLevelsSetInput>;
  pk_columns: RiskLevelsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRiskLevelsManyArgs = {
  updates: Array<RiskLevelsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRiskMatrixCellsArgs = {
  _inc: InputMaybe<RiskMatrixCellsIncInput>;
  _set: InputMaybe<RiskMatrixCellsSetInput>;
  where: RiskMatrixCellsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRiskMatrixCellsByPkArgs = {
  _inc: InputMaybe<RiskMatrixCellsIncInput>;
  _set: InputMaybe<RiskMatrixCellsSetInput>;
  pk_columns: RiskMatrixCellsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRiskMatrixCellsManyArgs = {
  updates: Array<RiskMatrixCellsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRiskOwnersArgs = {
  _set: InputMaybe<RiskOwnersSetInput>;
  where: RiskOwnersBoolExp;
};


/** mutation root */
export type MutationRootUpdateRiskOwnersByPkArgs = {
  _set: InputMaybe<RiskOwnersSetInput>;
  pk_columns: RiskOwnersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRiskOwnersManyArgs = {
  updates: Array<RiskOwnersUpdates>;
};


/** mutation root */
export type MutationRootUpdateRiskSettingsArgs = {
  _set: InputMaybe<RiskSettingsSetInput>;
  where: RiskSettingsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRiskSettingsByPkArgs = {
  _set: InputMaybe<RiskSettingsSetInput>;
  pk_columns: RiskSettingsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRiskSettingsManyArgs = {
  updates: Array<RiskSettingsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRiskTemplateCategoriesArgs = {
  _set: InputMaybe<RiskTemplateCategoriesSetInput>;
  where: RiskTemplateCategoriesBoolExp;
};


/** mutation root */
export type MutationRootUpdateRiskTemplateCategoriesByPkArgs = {
  _set: InputMaybe<RiskTemplateCategoriesSetInput>;
  pk_columns: RiskTemplateCategoriesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRiskTemplateCategoriesManyArgs = {
  updates: Array<RiskTemplateCategoriesUpdates>;
};


/** mutation root */
export type MutationRootUpdateRiskTemplateOwnersArgs = {
  _set: InputMaybe<RiskTemplateOwnersSetInput>;
  where: RiskTemplateOwnersBoolExp;
};


/** mutation root */
export type MutationRootUpdateRiskTemplateOwnersByPkArgs = {
  _set: InputMaybe<RiskTemplateOwnersSetInput>;
  pk_columns: RiskTemplateOwnersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRiskTemplateOwnersManyArgs = {
  updates: Array<RiskTemplateOwnersUpdates>;
};


/** mutation root */
export type MutationRootUpdateRiskTemplatesArgs = {
  _inc: InputMaybe<RiskTemplatesIncInput>;
  _set: InputMaybe<RiskTemplatesSetInput>;
  where: RiskTemplatesBoolExp;
};


/** mutation root */
export type MutationRootUpdateRiskTemplatesByPkArgs = {
  _inc: InputMaybe<RiskTemplatesIncInput>;
  _set: InputMaybe<RiskTemplatesSetInput>;
  pk_columns: RiskTemplatesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRiskTemplatesManyArgs = {
  updates: Array<RiskTemplatesUpdates>;
};


/** mutation root */
export type MutationRootUpdateRiskVersionsArgs = {
  _set: InputMaybe<RiskVersionsSetInput>;
  where: RiskVersionsBoolExp;
};


/** mutation root */
export type MutationRootUpdateRiskVersionsByPkArgs = {
  _set: InputMaybe<RiskVersionsSetInput>;
  pk_columns: RiskVersionsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRiskVersionsManyArgs = {
  updates: Array<RiskVersionsUpdates>;
};


/** mutation root */
export type MutationRootUpdateRisksArgs = {
  _inc: InputMaybe<RisksIncInput>;
  _set: InputMaybe<RisksSetInput>;
  where: RisksBoolExp;
};


/** mutation root */
export type MutationRootUpdateRisksByPkArgs = {
  _inc: InputMaybe<RisksIncInput>;
  _set: InputMaybe<RisksSetInput>;
  pk_columns: RisksPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRisksManyArgs = {
  updates: Array<RisksUpdates>;
};


/** mutation root */
export type MutationRootUpdateSubsidiariesArgs = {
  _append: InputMaybe<SubsidiariesAppendInput>;
  _delete_at_path: InputMaybe<SubsidiariesDeleteAtPathInput>;
  _delete_elem: InputMaybe<SubsidiariesDeleteElemInput>;
  _delete_key: InputMaybe<SubsidiariesDeleteKeyInput>;
  _prepend: InputMaybe<SubsidiariesPrependInput>;
  _set: InputMaybe<SubsidiariesSetInput>;
  where: SubsidiariesBoolExp;
};


/** mutation root */
export type MutationRootUpdateSubsidiariesByPkArgs = {
  _append: InputMaybe<SubsidiariesAppendInput>;
  _delete_at_path: InputMaybe<SubsidiariesDeleteAtPathInput>;
  _delete_elem: InputMaybe<SubsidiariesDeleteElemInput>;
  _delete_key: InputMaybe<SubsidiariesDeleteKeyInput>;
  _prepend: InputMaybe<SubsidiariesPrependInput>;
  _set: InputMaybe<SubsidiariesSetInput>;
  pk_columns: SubsidiariesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateSubsidiariesManyArgs = {
  updates: Array<SubsidiariesUpdates>;
};


/** mutation root */
export type MutationRootUpdateTableFiltersArgs = {
  _append: InputMaybe<TableFiltersAppendInput>;
  _delete_at_path: InputMaybe<TableFiltersDeleteAtPathInput>;
  _delete_elem: InputMaybe<TableFiltersDeleteElemInput>;
  _delete_key: InputMaybe<TableFiltersDeleteKeyInput>;
  _prepend: InputMaybe<TableFiltersPrependInput>;
  _set: InputMaybe<TableFiltersSetInput>;
  where: TableFiltersBoolExp;
};


/** mutation root */
export type MutationRootUpdateTableFiltersByPkArgs = {
  _append: InputMaybe<TableFiltersAppendInput>;
  _delete_at_path: InputMaybe<TableFiltersDeleteAtPathInput>;
  _delete_elem: InputMaybe<TableFiltersDeleteElemInput>;
  _delete_key: InputMaybe<TableFiltersDeleteKeyInput>;
  _prepend: InputMaybe<TableFiltersPrependInput>;
  _set: InputMaybe<TableFiltersSetInput>;
  pk_columns: TableFiltersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTableFiltersManyArgs = {
  updates: Array<TableFiltersUpdates>;
};


/** mutation root */
export type MutationRootUpdateTagsArgs = {
  _set: InputMaybe<TagsSetInput>;
  where: TagsBoolExp;
};


/** mutation root */
export type MutationRootUpdateTagsByPkArgs = {
  _set: InputMaybe<TagsSetInput>;
  pk_columns: TagsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTagsManyArgs = {
  updates: Array<TagsUpdates>;
};


/** mutation root */
export type MutationRootUpdateUserAllowedSubsidiariesArgs = {
  _set: InputMaybe<UserAllowedSubsidiariesSetInput>;
  where: UserAllowedSubsidiariesBoolExp;
};


/** mutation root */
export type MutationRootUpdateUserAllowedSubsidiariesByPkArgs = {
  _set: InputMaybe<UserAllowedSubsidiariesSetInput>;
  pk_columns: UserAllowedSubsidiariesPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUserAllowedSubsidiariesManyArgs = {
  updates: Array<UserAllowedSubsidiariesUpdates>;
};


/** mutation root */
export type MutationRootUpdateUsersArgs = {
  _set: InputMaybe<UsersSetInput>;
  where: UsersBoolExp;
};


/** mutation root */
export type MutationRootUpdateUsersByPkArgs = {
  _set: InputMaybe<UsersSetInput>;
  pk_columns: UsersPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUsersManyArgs = {
  updates: Array<UsersUpdates>;
};


/** mutation root */
export type MutationRootUpdateWorkflowConditionGroupsArgs = {
  _append: InputMaybe<WorkflowConditionGroupsAppendInput>;
  _delete_at_path: InputMaybe<WorkflowConditionGroupsDeleteAtPathInput>;
  _delete_elem: InputMaybe<WorkflowConditionGroupsDeleteElemInput>;
  _delete_key: InputMaybe<WorkflowConditionGroupsDeleteKeyInput>;
  _inc: InputMaybe<WorkflowConditionGroupsIncInput>;
  _prepend: InputMaybe<WorkflowConditionGroupsPrependInput>;
  _set: InputMaybe<WorkflowConditionGroupsSetInput>;
  where: WorkflowConditionGroupsBoolExp;
};


/** mutation root */
export type MutationRootUpdateWorkflowConditionGroupsByPkArgs = {
  _append: InputMaybe<WorkflowConditionGroupsAppendInput>;
  _delete_at_path: InputMaybe<WorkflowConditionGroupsDeleteAtPathInput>;
  _delete_elem: InputMaybe<WorkflowConditionGroupsDeleteElemInput>;
  _delete_key: InputMaybe<WorkflowConditionGroupsDeleteKeyInput>;
  _inc: InputMaybe<WorkflowConditionGroupsIncInput>;
  _prepend: InputMaybe<WorkflowConditionGroupsPrependInput>;
  _set: InputMaybe<WorkflowConditionGroupsSetInput>;
  pk_columns: WorkflowConditionGroupsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWorkflowConditionGroupsManyArgs = {
  updates: Array<WorkflowConditionGroupsUpdates>;
};


/** mutation root */
export type MutationRootUpdateWorkflowRanksArgs = {
  _inc: InputMaybe<WorkflowRanksIncInput>;
  _set: InputMaybe<WorkflowRanksSetInput>;
  where: WorkflowRanksBoolExp;
};


/** mutation root */
export type MutationRootUpdateWorkflowRanksByPkArgs = {
  _inc: InputMaybe<WorkflowRanksIncInput>;
  _set: InputMaybe<WorkflowRanksSetInput>;
  pk_columns: WorkflowRanksPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWorkflowRanksManyArgs = {
  updates: Array<WorkflowRanksUpdates>;
};


/** mutation root */
export type MutationRootUpdateWorkflowsArgs = {
  _append: InputMaybe<WorkflowsAppendInput>;
  _delete_at_path: InputMaybe<WorkflowsDeleteAtPathInput>;
  _delete_elem: InputMaybe<WorkflowsDeleteElemInput>;
  _delete_key: InputMaybe<WorkflowsDeleteKeyInput>;
  _inc: InputMaybe<WorkflowsIncInput>;
  _prepend: InputMaybe<WorkflowsPrependInput>;
  _set: InputMaybe<WorkflowsSetInput>;
  where: WorkflowsBoolExp;
};


/** mutation root */
export type MutationRootUpdateWorkflowsByPkArgs = {
  _append: InputMaybe<WorkflowsAppendInput>;
  _delete_at_path: InputMaybe<WorkflowsDeleteAtPathInput>;
  _delete_elem: InputMaybe<WorkflowsDeleteElemInput>;
  _delete_key: InputMaybe<WorkflowsDeleteKeyInput>;
  _inc: InputMaybe<WorkflowsIncInput>;
  _prepend: InputMaybe<WorkflowsPrependInput>;
  _set: InputMaybe<WorkflowsSetInput>;
  pk_columns: WorkflowsPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWorkflowsManyArgs = {
  updates: Array<WorkflowsUpdates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum OrderBy {
  /** in ascending order, nulls last */
  ASC = 'asc',
  /** in ascending order, nulls first */
  ASC_NULLS_FIRST = 'asc_nulls_first',
  /** in ascending order, nulls last */
  ASC_NULLS_LAST = 'asc_nulls_last',
  /** in descending order, nulls first */
  DESC = 'desc',
  /** in descending order, nulls first */
  DESC_NULLS_FIRST = 'desc_nulls_first',
  /** in descending order, nulls last */
  DESC_NULLS_LAST = 'desc_nulls_last'
}

/** columns and relationships of "organisation_core_data_dependencies" */
export type OrganisationCoreDataDependencies = {
  __typename?: 'organisation_core_data_dependencies';
  coreDataType: Scalars['kebabCoreDataType']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  customCoreData: Maybe<CustomCoreData>;
  customCoreDataId: Maybe<Scalars['uuid']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  dependencies: Array<CoreDataDependencies>;
  /** An aggregate relationship */
  dependencies_aggregate: CoreDataDependenciesAggregate;
  dependencyCoreDataType: Scalars['kebabDependencyType']['output'];
  /** An object relationship */
  dependencyCustomCoreData: Maybe<CustomCoreData>;
  dependencyCustomCoreDataId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
};


/** columns and relationships of "organisation_core_data_dependencies" */
export type OrganisationCoreDataDependenciesDependenciesArgs = {
  distinct_on: InputMaybe<Array<CoreDataDependenciesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CoreDataDependenciesOrderBy>>;
  where: InputMaybe<CoreDataDependenciesBoolExp>;
};


/** columns and relationships of "organisation_core_data_dependencies" */
export type OrganisationCoreDataDependenciesDependenciesAggregateArgs = {
  distinct_on: InputMaybe<Array<CoreDataDependenciesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CoreDataDependenciesOrderBy>>;
  where: InputMaybe<CoreDataDependenciesBoolExp>;
};

/** Boolean expression to filter rows from the table "organisation_core_data_dependencies". All fields are combined with a logical 'AND'. */
export type OrganisationCoreDataDependenciesBoolExp = {
  _and?: InputMaybe<Array<OrganisationCoreDataDependenciesBoolExp>>;
  _not?: InputMaybe<OrganisationCoreDataDependenciesBoolExp>;
  _or?: InputMaybe<Array<OrganisationCoreDataDependenciesBoolExp>>;
  coreDataType?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customCoreData?: InputMaybe<CustomCoreDataBoolExp>;
  customCoreDataId?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  dependencies?: InputMaybe<CoreDataDependenciesBoolExp>;
  dependencies_aggregate?: InputMaybe<CoreDataDependenciesAggregateBoolExp>;
  dependencyCoreDataType?: InputMaybe<StringComparisonExp>;
  dependencyCustomCoreData?: InputMaybe<CustomCoreDataBoolExp>;
  dependencyCustomCoreDataId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "organisation_core_data_dependencies" */
export enum OrganisationCoreDataDependenciesConstraint {
  /** unique or primary key constraint on columns "organisation_id", "core_data_type", "custom_core_data_id" */
  ORGANISATION_CORE_DATA_DEPENDENCIES_ORGANISATION_ID_CORE_DATA_T = 'organisation_core_data_dependencies_organisation_id_core_data_t',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_CORE_DATA_DEPENDENCIES_PKEY = 'organisation_core_data_dependencies_pkey'
}

/** input type for inserting data into table "organisation_core_data_dependencies" */
export type OrganisationCoreDataDependenciesInsertInput = {
  coreDataType: Scalars['kebabCoreDataType']['input'];
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customCoreData?: InputMaybe<CustomCoreDataObjRelInsertInput>;
  customCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dependencies?: InputMaybe<CoreDataDependenciesArrRelInsertInput>;
  dependencyCoreDataType: Scalars['kebabDependencyType']['input'];
  dependencyCustomCoreData?: InputMaybe<CustomCoreDataObjRelInsertInput>;
  dependencyCustomCoreDataId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "organisation_core_data_dependencies" */
export type OrganisationCoreDataDependenciesMutationResponse = {
  __typename?: 'organisation_core_data_dependencies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationCoreDataDependencies>;
};

/** on_conflict condition type for table "organisation_core_data_dependencies" */
export type OrganisationCoreDataDependenciesOnConflict = {
  constraint: OrganisationCoreDataDependenciesConstraint;
  update_columns: Array<OrganisationCoreDataDependenciesUpdateColumn>;
  where?: InputMaybe<OrganisationCoreDataDependenciesBoolExp>;
};

/** Ordering options when selecting data from "organisation_core_data_dependencies". */
export type OrganisationCoreDataDependenciesOrderBy = {
  coreDataType?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customCoreData?: InputMaybe<CustomCoreDataOrderBy>;
  customCoreDataId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  dependencies_aggregate?: InputMaybe<CoreDataDependenciesAggregateOrderBy>;
  dependencyCoreDataType?: InputMaybe<OrderBy>;
  dependencyCustomCoreData?: InputMaybe<CustomCoreDataOrderBy>;
  dependencyCustomCoreDataId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_core_data_dependencies */
export type OrganisationCoreDataDependenciesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_core_data_dependencies" */
export enum OrganisationCoreDataDependenciesSelectColumn {
  /** column name */
  COREDATATYPE = 'coreDataType',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CUSTOMCOREDATAID = 'customCoreDataId',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPENDENCYCOREDATATYPE = 'dependencyCoreDataType',
  /** column name */
  DEPENDENCYCUSTOMCOREDATAID = 'dependencyCustomCoreDataId',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId'
}

/** input type for updating data in table "organisation_core_data_dependencies" */
export type OrganisationCoreDataDependenciesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organisation_core_data_dependencies" */
export enum OrganisationCoreDataDependenciesUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt'
}

export type OrganisationCoreDataDependenciesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationCoreDataDependenciesSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationCoreDataDependenciesBoolExp;
};

/** columns and relationships of "organisation_feature_flags" */
export type OrganisationFeatureFlags = {
  __typename?: 'organisation_feature_flags';
  featureFlag: FeatureFlagsEnum;
  /** An object relationship */
  featureFlagObject: FeatureFlags;
  /** An object relationship */
  organisation: Organisations;
};

/** Boolean expression to filter rows from the table "organisation_feature_flags". All fields are combined with a logical 'AND'. */
export type OrganisationFeatureFlagsBoolExp = {
  _and?: InputMaybe<Array<OrganisationFeatureFlagsBoolExp>>;
  _not?: InputMaybe<OrganisationFeatureFlagsBoolExp>;
  _or?: InputMaybe<Array<OrganisationFeatureFlagsBoolExp>>;
  featureFlag?: InputMaybe<FeatureFlagsEnumComparisonExp>;
  featureFlagObject?: InputMaybe<FeatureFlagsBoolExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
};

/** unique or primary key constraints on table "organisation_feature_flags" */
export enum OrganisationFeatureFlagsConstraint {
  /** unique or primary key constraint on columns "feature_flag", "organisation_id" */
  ORGANISATION_FEATURE_FLAGS_PKEY = 'organisation_feature_flags_pkey'
}

/** input type for inserting data into table "organisation_feature_flags" */
export type OrganisationFeatureFlagsInsertInput = {
  featureFlag?: InputMaybe<FeatureFlagsEnum>;
};

/** response of any mutation on the table "organisation_feature_flags" */
export type OrganisationFeatureFlagsMutationResponse = {
  __typename?: 'organisation_feature_flags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationFeatureFlags>;
};

/** on_conflict condition type for table "organisation_feature_flags" */
export type OrganisationFeatureFlagsOnConflict = {
  constraint: OrganisationFeatureFlagsConstraint;
  update_columns: Array<OrganisationFeatureFlagsUpdateColumn>;
  where?: InputMaybe<OrganisationFeatureFlagsBoolExp>;
};

/** Ordering options when selecting data from "organisation_feature_flags". */
export type OrganisationFeatureFlagsOrderBy = {
  featureFlag?: InputMaybe<OrderBy>;
  featureFlagObject?: InputMaybe<FeatureFlagsOrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
};

/** select columns of table "organisation_feature_flags" */
export enum OrganisationFeatureFlagsSelectColumn {
  /** column name */
  FEATUREFLAG = 'featureFlag'
}

/** input type for updating data in table "organisation_feature_flags" */
export type OrganisationFeatureFlagsSetInput = {
  featureFlag?: InputMaybe<FeatureFlagsEnum>;
};

/** update columns of table "organisation_feature_flags" */
export enum OrganisationFeatureFlagsUpdateColumn {
  /** column name */
  FEATUREFLAG = 'featureFlag'
}

export type OrganisationFeatureFlagsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationFeatureFlagsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationFeatureFlagsBoolExp;
};

/** columns and relationships of "organisation_fx_rates" */
export type OrganisationFxRates = {
  __typename?: 'organisation_fx_rates';
  archivedBy: Maybe<Scalars['String']['output']>;
  code: Scalars['organisationFxRateCode']['output'];
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  displaySymbol: Maybe<Scalars['String']['output']>;
  fxRate: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "organisation_fx_rates" */
export type OrganisationFxRatesAggregate = {
  __typename?: 'organisation_fx_rates_aggregate';
  aggregate: Maybe<OrganisationFxRatesAggregateFields>;
  nodes: Array<OrganisationFxRates>;
};

export type OrganisationFxRatesAggregateBoolExp = {
  bool_and?: InputMaybe<OrganisationFxRatesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<OrganisationFxRatesAggregateBoolExpBoolOr>;
  count?: InputMaybe<OrganisationFxRatesAggregateBoolExpCount>;
};

export type OrganisationFxRatesAggregateBoolExpBoolAnd = {
  arguments: OrganisationFxRatesSelectColumnOrganisationFxRatesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationFxRatesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type OrganisationFxRatesAggregateBoolExpBoolOr = {
  arguments: OrganisationFxRatesSelectColumnOrganisationFxRatesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationFxRatesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type OrganisationFxRatesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OrganisationFxRatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationFxRatesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "organisation_fx_rates" */
export type OrganisationFxRatesAggregateFields = {
  __typename?: 'organisation_fx_rates_aggregate_fields';
  avg: Maybe<OrganisationFxRatesAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<OrganisationFxRatesMaxFields>;
  min: Maybe<OrganisationFxRatesMinFields>;
  stddev: Maybe<OrganisationFxRatesStddevFields>;
  stddev_pop: Maybe<OrganisationFxRatesStddevPopFields>;
  stddev_samp: Maybe<OrganisationFxRatesStddevSampFields>;
  sum: Maybe<OrganisationFxRatesSumFields>;
  var_pop: Maybe<OrganisationFxRatesVarPopFields>;
  var_samp: Maybe<OrganisationFxRatesVarSampFields>;
  variance: Maybe<OrganisationFxRatesVarianceFields>;
};


/** aggregate fields of "organisation_fx_rates" */
export type OrganisationFxRatesAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<OrganisationFxRatesSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organisation_fx_rates" */
export type OrganisationFxRatesAggregateOrderBy = {
  avg?: InputMaybe<OrganisationFxRatesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrganisationFxRatesMaxOrderBy>;
  min?: InputMaybe<OrganisationFxRatesMinOrderBy>;
  stddev?: InputMaybe<OrganisationFxRatesStddevOrderBy>;
  stddev_pop?: InputMaybe<OrganisationFxRatesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<OrganisationFxRatesStddevSampOrderBy>;
  sum?: InputMaybe<OrganisationFxRatesSumOrderBy>;
  var_pop?: InputMaybe<OrganisationFxRatesVarPopOrderBy>;
  var_samp?: InputMaybe<OrganisationFxRatesVarSampOrderBy>;
  variance?: InputMaybe<OrganisationFxRatesVarianceOrderBy>;
};

/** aggregate avg on columns */
export type OrganisationFxRatesAvgFields = {
  __typename?: 'organisation_fx_rates_avg_fields';
  fxRate: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organisation_fx_rates" */
export type OrganisationFxRatesAvgOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "organisation_fx_rates". All fields are combined with a logical 'AND'. */
export type OrganisationFxRatesBoolExp = {
  _and?: InputMaybe<Array<OrganisationFxRatesBoolExp>>;
  _not?: InputMaybe<OrganisationFxRatesBoolExp>;
  _or?: InputMaybe<Array<OrganisationFxRatesBoolExp>>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  code?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  displaySymbol?: InputMaybe<StringComparisonExp>;
  fxRate?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  isVisible?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "organisation_fx_rates" */
export enum OrganisationFxRatesConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_CURRENCIES_PKEY = 'organisation_currencies_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  ORGANISATION_FX_RATES_REMOTE_ID_ORGANISATION_ID_KEY = 'organisation_fx_rates_remote_id_organisation_id_key'
}

/** input type for incrementing numeric columns in table "organisation_fx_rates" */
export type OrganisationFxRatesIncInput = {
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "organisation_fx_rates" */
export type OrganisationFxRatesInsertInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  displaySymbol?: InputMaybe<Scalars['String']['input']>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type OrganisationFxRatesMaxFields = {
  __typename?: 'organisation_fx_rates_max_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  displaySymbol: Maybe<Scalars['String']['output']>;
  fxRate: Maybe<Scalars['numeric']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "organisation_fx_rates" */
export type OrganisationFxRatesMaxOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  coreDataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  displaySymbol?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type OrganisationFxRatesMinFields = {
  __typename?: 'organisation_fx_rates_min_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  displaySymbol: Maybe<Scalars['String']['output']>;
  fxRate: Maybe<Scalars['numeric']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "organisation_fx_rates" */
export type OrganisationFxRatesMinOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  coreDataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  displaySymbol?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "organisation_fx_rates" */
export type OrganisationFxRatesMutationResponse = {
  __typename?: 'organisation_fx_rates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationFxRates>;
};

/** input type for inserting object relation for remote table "organisation_fx_rates" */
export type OrganisationFxRatesObjRelInsertInput = {
  data: OrganisationFxRatesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationFxRatesOnConflict>;
};

/** on_conflict condition type for table "organisation_fx_rates" */
export type OrganisationFxRatesOnConflict = {
  constraint: OrganisationFxRatesConstraint;
  update_columns: Array<OrganisationFxRatesUpdateColumn>;
  where?: InputMaybe<OrganisationFxRatesBoolExp>;
};

/** Ordering options when selecting data from "organisation_fx_rates". */
export type OrganisationFxRatesOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  code?: InputMaybe<OrderBy>;
  coreData?: InputMaybe<CoreDataOrderBy>;
  coreDataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  displaySymbol?: InputMaybe<OrderBy>;
  fxRate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  isVisible?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_fx_rates */
export type OrganisationFxRatesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_fx_rates" */
export enum OrganisationFxRatesSelectColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CODE = 'code',
  /** column name */
  COREDATAID = 'coreDataId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DISPLAYSYMBOL = 'displaySymbol',
  /** column name */
  FXRATE = 'fxRate',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISVISIBLE = 'isVisible',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "organisation_fx_rates_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organisation_fx_rates" */
export enum OrganisationFxRatesSelectColumnOrganisationFxRatesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISVISIBLE = 'isVisible'
}

/** select "organisation_fx_rates_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organisation_fx_rates" */
export enum OrganisationFxRatesSelectColumnOrganisationFxRatesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISVISIBLE = 'isVisible'
}

/** input type for updating data in table "organisation_fx_rates" */
export type OrganisationFxRatesSetInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  displaySymbol?: InputMaybe<Scalars['String']['input']>;
  fxRate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type OrganisationFxRatesStddevFields = {
  __typename?: 'organisation_fx_rates_stddev_fields';
  fxRate: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organisation_fx_rates" */
export type OrganisationFxRatesStddevOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type OrganisationFxRatesStddevPopFields = {
  __typename?: 'organisation_fx_rates_stddev_pop_fields';
  fxRate: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organisation_fx_rates" */
export type OrganisationFxRatesStddevPopOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type OrganisationFxRatesStddevSampFields = {
  __typename?: 'organisation_fx_rates_stddev_samp_fields';
  fxRate: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organisation_fx_rates" */
export type OrganisationFxRatesStddevSampOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type OrganisationFxRatesSumFields = {
  __typename?: 'organisation_fx_rates_sum_fields';
  fxRate: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "organisation_fx_rates" */
export type OrganisationFxRatesSumOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
};

/** update columns of table "organisation_fx_rates" */
export enum OrganisationFxRatesUpdateColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CODE = 'code',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DISPLAYSYMBOL = 'displaySymbol',
  /** column name */
  FXRATE = 'fxRate',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type OrganisationFxRatesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OrganisationFxRatesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationFxRatesSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationFxRatesBoolExp;
};

/** aggregate var_pop on columns */
export type OrganisationFxRatesVarPopFields = {
  __typename?: 'organisation_fx_rates_var_pop_fields';
  fxRate: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organisation_fx_rates" */
export type OrganisationFxRatesVarPopOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type OrganisationFxRatesVarSampFields = {
  __typename?: 'organisation_fx_rates_var_samp_fields';
  fxRate: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organisation_fx_rates" */
export type OrganisationFxRatesVarSampOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type OrganisationFxRatesVarianceFields = {
  __typename?: 'organisation_fx_rates_variance_fields';
  fxRate: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organisation_fx_rates" */
export type OrganisationFxRatesVarianceOrderBy = {
  fxRate?: InputMaybe<OrderBy>;
};

/** Keeps track of which organisations have which ExtOps operations enabled – acts like feature flags to enable using the relative blocks in the workflow builder */
export type OrganisationIntegrationOperations = {
  __typename?: 'organisation_integration_operations';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  integrationId: Scalars['uuid']['output'];
  operation: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationIntegration: OrganisationIntegrations;
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "organisation_integration_operations". All fields are combined with a logical 'AND'. */
export type OrganisationIntegrationOperationsBoolExp = {
  _and?: InputMaybe<Array<OrganisationIntegrationOperationsBoolExp>>;
  _not?: InputMaybe<OrganisationIntegrationOperationsBoolExp>;
  _or?: InputMaybe<Array<OrganisationIntegrationOperationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integrationId?: InputMaybe<UuidComparisonExp>;
  operation?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "organisation_integration_operations" */
export enum OrganisationIntegrationOperationsConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_EXTOPS_OPERATIONS_PKEY = 'organisation_extops_operations_pkey',
  /** unique or primary key constraint on columns "operation", "integration_id", "organisation_id" */
  ORGANISATION_INTEGRATION_OPERATIONS_ORGANISATION_ID_INTEGRATION = 'organisation_integration_operations_organisation_id_integration'
}

/** input type for inserting data into table "organisation_integration_operations" */
export type OrganisationIntegrationOperationsInsertInput = {
  integrationId?: InputMaybe<Scalars['uuid']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
};

/** response of any mutation on the table "organisation_integration_operations" */
export type OrganisationIntegrationOperationsMutationResponse = {
  __typename?: 'organisation_integration_operations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationIntegrationOperations>;
};

/** on_conflict condition type for table "organisation_integration_operations" */
export type OrganisationIntegrationOperationsOnConflict = {
  constraint: OrganisationIntegrationOperationsConstraint;
  update_columns: Array<OrganisationIntegrationOperationsUpdateColumn>;
  where?: InputMaybe<OrganisationIntegrationOperationsBoolExp>;
};

/** Ordering options when selecting data from "organisation_integration_operations". */
export type OrganisationIntegrationOperationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integrationId?: InputMaybe<OrderBy>;
  operation?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** select columns of table "organisation_integration_operations" */
export enum OrganisationIntegrationOperationsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  INTEGRATIONID = 'integrationId',
  /** column name */
  OPERATION = 'operation',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** Streaming cursor of the table "organisation_integration_operations" */
export type OrganisationIntegrationOperationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganisationIntegrationOperationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganisationIntegrationOperationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  integrationId?: InputMaybe<Scalars['uuid']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** placeholder for update columns of table "organisation_integration_operations" (current role has no relevant permissions) */
export enum OrganisationIntegrationOperationsUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** Keeps track of which organisations have which integrations enabled */
export type OrganisationIntegrations = {
  __typename?: 'organisation_integrations';
  createdAt: Scalars['timestamptz']['output'];
  defaultSupplierState: Maybe<OrganisationSupplierStateEnum>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  integration: Scalars['globalIntegration']['output'];
  name: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['uuid']['output'];
  referenceId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "organisation_integrations". All fields are combined with a logical 'AND'. */
export type OrganisationIntegrationsBoolExp = {
  _and?: InputMaybe<Array<OrganisationIntegrationsBoolExp>>;
  _not?: InputMaybe<OrganisationIntegrationsBoolExp>;
  _or?: InputMaybe<Array<OrganisationIntegrationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  defaultSupplierState?: InputMaybe<OrganisationSupplierStateEnumComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  integration?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  referenceId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "organisation_integrations" */
export enum OrganisationIntegrationsConstraint {
  /** unique or primary key constraint on columns "integration", "organisation_id" */
  ORGANISATION_INTEGRATIONS_ORGANISATION_ID_INTEGRATION_KEY = 'organisation_integrations_organisation_id_integration_key',
  /** unique or primary key constraint on columns "integration", "organisation_id", "name" */
  ORGANISATION_INTEGRATIONS_ORGANISATION_ID_INTEGRATION_NAME_KEY = 'organisation_integrations_organisation_id_integration_name_key',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_INTEGRATIONS_PKEY = 'organisation_integrations_pkey'
}

/** input type for inserting data into table "organisation_integrations" */
export type OrganisationIntegrationsInsertInput = {
  defaultSupplierState?: InputMaybe<OrganisationSupplierStateEnum>;
  integration: Scalars['globalIntegration']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "organisation_integrations" */
export type OrganisationIntegrationsMutationResponse = {
  __typename?: 'organisation_integrations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationIntegrations>;
};

/** input type for inserting object relation for remote table "organisation_integrations" */
export type OrganisationIntegrationsObjRelInsertInput = {
  data: OrganisationIntegrationsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationIntegrationsOnConflict>;
};

/** on_conflict condition type for table "organisation_integrations" */
export type OrganisationIntegrationsOnConflict = {
  constraint: OrganisationIntegrationsConstraint;
  update_columns: Array<OrganisationIntegrationsUpdateColumn>;
  where?: InputMaybe<OrganisationIntegrationsBoolExp>;
};

/** Ordering options when selecting data from "organisation_integrations". */
export type OrganisationIntegrationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  defaultSupplierState?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  integration?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_integrations */
export type OrganisationIntegrationsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_integrations" */
export enum OrganisationIntegrationsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DEFAULTSUPPLIERSTATE = 'defaultSupplierState',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  INTEGRATION = 'integration',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REFERENCEID = 'referenceId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "organisation_integrations" */
export type OrganisationIntegrationsSetInput = {
  defaultSupplierState?: InputMaybe<OrganisationSupplierStateEnum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  integration?: InputMaybe<Scalars['globalIntegration']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organisation_integrations" */
export type OrganisationIntegrationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganisationIntegrationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganisationIntegrationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  defaultSupplierState?: InputMaybe<OrganisationSupplierStateEnum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  integration?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organisation_integrations" */
export enum OrganisationIntegrationsUpdateColumn {
  /** column name */
  DEFAULTSUPPLIERSTATE = 'defaultSupplierState',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  NAME = 'name',
  /** column name */
  REFERENCEID = 'referenceId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type OrganisationIntegrationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationIntegrationsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationIntegrationsBoolExp;
};

/** Keep track of supported locales for a given organisation */
export type OrganisationLocales = {
  __typename?: 'organisation_locales';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  locale: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "organisation_locales" */
export type OrganisationLocalesAggregate = {
  __typename?: 'organisation_locales_aggregate';
  aggregate: Maybe<OrganisationLocalesAggregateFields>;
  nodes: Array<OrganisationLocales>;
};

/** aggregate fields of "organisation_locales" */
export type OrganisationLocalesAggregateFields = {
  __typename?: 'organisation_locales_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<OrganisationLocalesMaxFields>;
  min: Maybe<OrganisationLocalesMinFields>;
};


/** aggregate fields of "organisation_locales" */
export type OrganisationLocalesAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<OrganisationLocalesSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organisation_locales". All fields are combined with a logical 'AND'. */
export type OrganisationLocalesBoolExp = {
  _and?: InputMaybe<Array<OrganisationLocalesBoolExp>>;
  _not?: InputMaybe<OrganisationLocalesBoolExp>;
  _or?: InputMaybe<Array<OrganisationLocalesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  locale?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "organisation_locales" */
export enum OrganisationLocalesConstraint {
  /** unique or primary key constraint on columns "organisation_id", "locale" */
  ORGANISATION_LOCALES_LOCALE_ORGANISATION_ID_KEY = 'organisation_locales_locale_organisation_id_key',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_LOCALES_PKEY = 'organisation_locales_pkey'
}

/** input type for inserting data into table "organisation_locales" */
export type OrganisationLocalesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type OrganisationLocalesMaxFields = {
  __typename?: 'organisation_locales_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  locale: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type OrganisationLocalesMinFields = {
  __typename?: 'organisation_locales_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  locale: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "organisation_locales" */
export type OrganisationLocalesMutationResponse = {
  __typename?: 'organisation_locales_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationLocales>;
};

/** on_conflict condition type for table "organisation_locales" */
export type OrganisationLocalesOnConflict = {
  constraint: OrganisationLocalesConstraint;
  update_columns: Array<OrganisationLocalesUpdateColumn>;
  where?: InputMaybe<OrganisationLocalesBoolExp>;
};

/** Ordering options when selecting data from "organisation_locales". */
export type OrganisationLocalesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  locale?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_locales */
export type OrganisationLocalesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_locales" */
export enum OrganisationLocalesSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  LOCALE = 'locale',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "organisation_locales" */
export type OrganisationLocalesSetInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organisation_locales" */
export enum OrganisationLocalesUpdateColumn {
  /** column name */
  LOCALE = 'locale',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type OrganisationLocalesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationLocalesSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationLocalesBoolExp;
};

/** columns and relationships of "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategories = {
  __typename?: 'organisation_product_supplier_categories';
  id: Scalars['uuid']['output'];
  isTerminal: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An array relationship */
  organisation_product_supplier_categories: Array<OrganisationProductSupplierCategories>;
  /** An object relationship */
  organisation_product_supplier_category: Maybe<OrganisationProductSupplierCategories>;
  parentId: Maybe<Scalars['uuid']['output']>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesOrganisationProductSupplierCategoriesArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductSupplierCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductSupplierCategoriesOrderBy>>;
  where: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
};

/** order by aggregate values of table "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrganisationProductSupplierCategoriesMaxOrderBy>;
  min?: InputMaybe<OrganisationProductSupplierCategoriesMinOrderBy>;
};

/** input type for inserting array relation for remote table "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesArrRelInsertInput = {
  data: Array<OrganisationProductSupplierCategoriesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationProductSupplierCategoriesOnConflict>;
};

/** Boolean expression to filter rows from the table "organisation_product_supplier_categories". All fields are combined with a logical 'AND'. */
export type OrganisationProductSupplierCategoriesBoolExp = {
  _and?: InputMaybe<Array<OrganisationProductSupplierCategoriesBoolExp>>;
  _not?: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
  _or?: InputMaybe<Array<OrganisationProductSupplierCategoriesBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  isTerminal?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisation_product_supplier_categories?: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
  parentId?: InputMaybe<UuidComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "organisation_product_supplier_categories" */
export enum OrganisationProductSupplierCategoriesConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_PRODUCT_SUPPLIER_CATEGORIES_PKEY = 'organisation_product_supplier_categories_pkey'
}

/** input type for inserting data into table "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  organisation_product_supplier_categories?: InputMaybe<OrganisationProductSupplierCategoriesArrRelInsertInput>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesObjRelInsertInput>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  parentId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesMutationResponse = {
  __typename?: 'organisation_product_supplier_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationProductSupplierCategories>;
};

/** input type for inserting object relation for remote table "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesObjRelInsertInput = {
  data: OrganisationProductSupplierCategoriesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationProductSupplierCategoriesOnConflict>;
};

/** on_conflict condition type for table "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesOnConflict = {
  constraint: OrganisationProductSupplierCategoriesConstraint;
  update_columns: Array<OrganisationProductSupplierCategoriesUpdateColumn>;
  where?: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
};

/** Ordering options when selecting data from "organisation_product_supplier_categories". */
export type OrganisationProductSupplierCategoriesOrderBy = {
  id?: InputMaybe<OrderBy>;
  isTerminal?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisation_product_supplier_categories_aggregate?: InputMaybe<OrganisationProductSupplierCategoriesAggregateOrderBy>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesOrderBy>;
  parentId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_product_supplier_categories */
export type OrganisationProductSupplierCategoriesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_product_supplier_categories" */
export enum OrganisationProductSupplierCategoriesSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  ISTERMINAL = 'isTerminal',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  PARENTID = 'parentId',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesSetInput = {
  isTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organisation_product_supplier_categories" */
export type OrganisationProductSupplierCategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganisationProductSupplierCategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganisationProductSupplierCategoriesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organisation_product_supplier_categories" */
export enum OrganisationProductSupplierCategoriesUpdateColumn {
  /** column name */
  ISTERMINAL = 'isTerminal',
  /** column name */
  PARENTID = 'parentId',
  /** column name */
  VALUE = 'value'
}

export type OrganisationProductSupplierCategoriesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationProductSupplierCategoriesSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationProductSupplierCategoriesBoolExp;
};

/** Links between an org and products and services */
export type OrganisationProductsAndServices = {
  __typename?: 'organisation_products_and_services';
  /** An array relationship */
  assessments: Array<Assessments>;
  /** An aggregate relationship */
  assessments_aggregate: AssessmentsAggregate;
  /** An object relationship */
  businessOwner: Maybe<Users>;
  businessOwnerId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: DocumentsAggregate;
  embedding: Maybe<Scalars['vector']['output']>;
  /** An array relationship */
  engagements: Array<Engagements>;
  /** An aggregate relationship */
  engagements_aggregate: EngagementsAggregate;
  functionalDescription: Maybe<Scalars['String']['output']>;
  functionalEmbedding: Maybe<Scalars['vector']['output']>;
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Maybe<Organisations>;
  organisationProductsAndServicesBrandId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_products_and_services_brand: Maybe<OrganisationProductsAndServicesBrands>;
  /** An array relationship */
  organisation_products_and_services_requests: Array<Requests>;
  /** An aggregate relationship */
  organisation_products_and_services_requests_aggregate: RequestsAggregate;
  /** An object relationship */
  organisation_supplier: OrganisationSuppliers;
  /** An array relationship */
  renewals: Array<Renewals>;
  /** An aggregate relationship */
  renewals_aggregate: RenewalsAggregate;
  state: OrganisationProductsAndServicesStateEnum;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};


/** Links between an org and products and services */
export type OrganisationProductsAndServicesAssessmentsArgs = {
  distinct_on: InputMaybe<Array<AssessmentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AssessmentsOrderBy>>;
  where: InputMaybe<AssessmentsBoolExp>;
};


/** Links between an org and products and services */
export type OrganisationProductsAndServicesAssessmentsAggregateArgs = {
  distinct_on: InputMaybe<Array<AssessmentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AssessmentsOrderBy>>;
  where: InputMaybe<AssessmentsBoolExp>;
};


/** Links between an org and products and services */
export type OrganisationProductsAndServicesDocumentsArgs = {
  distinct_on: InputMaybe<Array<DocumentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<DocumentsOrderBy>>;
  where: InputMaybe<DocumentsBoolExp>;
};


/** Links between an org and products and services */
export type OrganisationProductsAndServicesDocumentsAggregateArgs = {
  distinct_on: InputMaybe<Array<DocumentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<DocumentsOrderBy>>;
  where: InputMaybe<DocumentsBoolExp>;
};


/** Links between an org and products and services */
export type OrganisationProductsAndServicesEngagementsArgs = {
  distinct_on: InputMaybe<Array<EngagementsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EngagementsOrderBy>>;
  where: InputMaybe<EngagementsBoolExp>;
};


/** Links between an org and products and services */
export type OrganisationProductsAndServicesEngagementsAggregateArgs = {
  distinct_on: InputMaybe<Array<EngagementsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EngagementsOrderBy>>;
  where: InputMaybe<EngagementsBoolExp>;
};


/** Links between an org and products and services */
export type OrganisationProductsAndServicesOrganisationProductsAndServicesRequestsArgs = {
  distinct_on: InputMaybe<Array<RequestsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestsOrderBy>>;
  where: InputMaybe<RequestsBoolExp>;
};


/** Links between an org and products and services */
export type OrganisationProductsAndServicesOrganisationProductsAndServicesRequestsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestsOrderBy>>;
  where: InputMaybe<RequestsBoolExp>;
};


/** Links between an org and products and services */
export type OrganisationProductsAndServicesRenewalsArgs = {
  distinct_on: InputMaybe<Array<RenewalsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalsOrderBy>>;
  where: InputMaybe<RenewalsBoolExp>;
};


/** Links between an org and products and services */
export type OrganisationProductsAndServicesRenewalsAggregateArgs = {
  distinct_on: InputMaybe<Array<RenewalsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalsOrderBy>>;
  where: InputMaybe<RenewalsBoolExp>;
};

/** aggregated selection of "organisation_products_and_services" */
export type OrganisationProductsAndServicesAggregate = {
  __typename?: 'organisation_products_and_services_aggregate';
  aggregate: Maybe<OrganisationProductsAndServicesAggregateFields>;
  nodes: Array<OrganisationProductsAndServices>;
};

export type OrganisationProductsAndServicesAggregateBoolExp = {
  bool_and?: InputMaybe<OrganisationProductsAndServicesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<OrganisationProductsAndServicesAggregateBoolExpBoolOr>;
  count?: InputMaybe<OrganisationProductsAndServicesAggregateBoolExpCount>;
};

export type OrganisationProductsAndServicesAggregateBoolExpBoolAnd = {
  arguments: OrganisationProductsAndServicesSelectColumnOrganisationProductsAndServicesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type OrganisationProductsAndServicesAggregateBoolExpBoolOr = {
  arguments: OrganisationProductsAndServicesSelectColumnOrganisationProductsAndServicesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type OrganisationProductsAndServicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "organisation_products_and_services" */
export type OrganisationProductsAndServicesAggregateFields = {
  __typename?: 'organisation_products_and_services_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<OrganisationProductsAndServicesMaxFields>;
  min: Maybe<OrganisationProductsAndServicesMinFields>;
};


/** aggregate fields of "organisation_products_and_services" */
export type OrganisationProductsAndServicesAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organisation_products_and_services" */
export type OrganisationProductsAndServicesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrganisationProductsAndServicesMaxOrderBy>;
  min?: InputMaybe<OrganisationProductsAndServicesMinOrderBy>;
};

/** input type for inserting array relation for remote table "organisation_products_and_services" */
export type OrganisationProductsAndServicesArrRelInsertInput = {
  data: Array<OrganisationProductsAndServicesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationProductsAndServicesOnConflict>;
};

/** Boolean expression to filter rows from the table "organisation_products_and_services". All fields are combined with a logical 'AND'. */
export type OrganisationProductsAndServicesBoolExp = {
  _and?: InputMaybe<Array<OrganisationProductsAndServicesBoolExp>>;
  _not?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  _or?: InputMaybe<Array<OrganisationProductsAndServicesBoolExp>>;
  assessments?: InputMaybe<AssessmentsBoolExp>;
  assessments_aggregate?: InputMaybe<AssessmentsAggregateBoolExp>;
  businessOwner?: InputMaybe<UsersBoolExp>;
  businessOwnerId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  documents?: InputMaybe<DocumentsBoolExp>;
  documents_aggregate?: InputMaybe<DocumentsAggregateBoolExp>;
  embedding?: InputMaybe<VectorComparisonExp>;
  engagements?: InputMaybe<EngagementsBoolExp>;
  engagements_aggregate?: InputMaybe<EngagementsAggregateBoolExp>;
  functionalDescription?: InputMaybe<StringComparisonExp>;
  functionalEmbedding?: InputMaybe<VectorComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  logoUrl?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationProductsAndServicesBrandId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
  organisation_products_and_services_requests?: InputMaybe<RequestsBoolExp>;
  organisation_products_and_services_requests_aggregate?: InputMaybe<RequestsAggregateBoolExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  renewals?: InputMaybe<RenewalsBoolExp>;
  renewals_aggregate?: InputMaybe<RenewalsAggregateBoolExp>;
  state?: InputMaybe<OrganisationProductsAndServicesStateEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** columns and relationships of "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrands = {
  __typename?: 'organisation_products_and_services_brands';
  /** An array relationship */
  categories: Array<OrganisationProductsAndServicesCategories>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  embedding: Maybe<Scalars['vector']['output']>;
  id: Scalars['uuid']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationSupplierBrandId: Scalars['uuid']['output'];
  /** An array relationship */
  organisation_products_and_services: Array<OrganisationProductsAndServices>;
  /** An aggregate relationship */
  organisation_products_and_services_aggregate: OrganisationProductsAndServicesAggregate;
  /** An object relationship */
  organisation_suppliers_brand: OrganisationSuppliersBrands;
  productAndServiceId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product_catalogue_entry: Maybe<ProductCatalogueEntries>;
  /** An object relationship */
  products_and_service: Maybe<ProductsAndServices>;
  updatedAt: Scalars['timestamptz']['output'];
  website: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsCategoriesArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesCategoriesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesCategoriesBoolExp>;
};


/** columns and relationships of "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsOrganisationProductsAndServicesArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


/** columns and relationships of "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsOrganisationProductsAndServicesAggregateArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};

/** order by aggregate values of table "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrganisationProductsAndServicesBrandsMaxOrderBy>;
  min?: InputMaybe<OrganisationProductsAndServicesBrandsMinOrderBy>;
};

/** input type for inserting array relation for remote table "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsArrRelInsertInput = {
  data: Array<OrganisationProductsAndServicesBrandsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationProductsAndServicesBrandsOnConflict>;
};

/** Boolean expression to filter rows from the table "organisation_products_and_services_brands". All fields are combined with a logical 'AND'. */
export type OrganisationProductsAndServicesBrandsBoolExp = {
  _and?: InputMaybe<Array<OrganisationProductsAndServicesBrandsBoolExp>>;
  _not?: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
  _or?: InputMaybe<Array<OrganisationProductsAndServicesBrandsBoolExp>>;
  categories?: InputMaybe<OrganisationProductsAndServicesCategoriesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  embedding?: InputMaybe<VectorComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  logoUrl?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationSupplierBrandId?: InputMaybe<UuidComparisonExp>;
  organisation_products_and_services?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  organisation_products_and_services_aggregate?: InputMaybe<OrganisationProductsAndServicesAggregateBoolExp>;
  organisation_suppliers_brand?: InputMaybe<OrganisationSuppliersBrandsBoolExp>;
  productAndServiceId?: InputMaybe<UuidComparisonExp>;
  product_catalogue_entry?: InputMaybe<ProductCatalogueEntriesBoolExp>;
  products_and_service?: InputMaybe<ProductsAndServicesBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "organisation_products_and_services_brands" */
export enum OrganisationProductsAndServicesBrandsConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_PRODUCTS_AND_SERVICES_BRANDS_PKEY = 'organisation_products_and_services_brands_pkey',
  /** unique or primary key constraint on columns "organisation_id", "product_and_service_id" */
  ORGANISATION_PRODUCTS_AND_SERVICES_BRANDS_PRODUCT_AND_SERVICE_I = 'organisation_products_and_services_brands_product_and_service_i'
}

/** input type for inserting data into table "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsInsertInput = {
  categories?: InputMaybe<OrganisationProductsAndServicesCategoriesArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationSupplierBrandId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_products_and_services?: InputMaybe<OrganisationProductsAndServicesArrRelInsertInput>;
  organisation_suppliers_brand?: InputMaybe<OrganisationSuppliersBrandsObjRelInsertInput>;
  productAndServiceId?: InputMaybe<Scalars['uuid']['input']>;
  product_catalogue_entry?: InputMaybe<ProductCatalogueEntriesObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationSupplierBrandId?: InputMaybe<OrderBy>;
  productAndServiceId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationSupplierBrandId?: InputMaybe<OrderBy>;
  productAndServiceId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsMutationResponse = {
  __typename?: 'organisation_products_and_services_brands_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationProductsAndServicesBrands>;
};

/** input type for inserting object relation for remote table "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsObjRelInsertInput = {
  data: OrganisationProductsAndServicesBrandsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationProductsAndServicesBrandsOnConflict>;
};

/** on_conflict condition type for table "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsOnConflict = {
  constraint: OrganisationProductsAndServicesBrandsConstraint;
  update_columns: Array<OrganisationProductsAndServicesBrandsUpdateColumn>;
  where?: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
};

/** Ordering options when selecting data from "organisation_products_and_services_brands". */
export type OrganisationProductsAndServicesBrandsOrderBy = {
  categories_aggregate?: InputMaybe<OrganisationProductsAndServicesCategoriesAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  embedding?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationSupplierBrandId?: InputMaybe<OrderBy>;
  organisation_products_and_services_aggregate?: InputMaybe<OrganisationProductsAndServicesAggregateOrderBy>;
  organisation_suppliers_brand?: InputMaybe<OrganisationSuppliersBrandsOrderBy>;
  productAndServiceId?: InputMaybe<OrderBy>;
  product_catalogue_entry?: InputMaybe<ProductCatalogueEntriesOrderBy>;
  products_and_service?: InputMaybe<ProductsAndServicesOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_products_and_services_brands */
export type OrganisationProductsAndServicesBrandsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_products_and_services_brands" */
export enum OrganisationProductsAndServicesBrandsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EMBEDDING = 'embedding',
  /** column name */
  ID = 'id',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONSUPPLIERBRANDID = 'organisationSupplierBrandId',
  /** column name */
  PRODUCTANDSERVICEID = 'productAndServiceId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEBSITE = 'website'
}

/** input type for updating data in table "organisation_products_and_services_brands" */
export type OrganisationProductsAndServicesBrandsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationSupplierBrandId?: InputMaybe<Scalars['uuid']['input']>;
  productAndServiceId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organisation_products_and_services_brands" */
export enum OrganisationProductsAndServicesBrandsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EMBEDDING = 'embedding',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONSUPPLIERBRANDID = 'organisationSupplierBrandId',
  /** column name */
  PRODUCTANDSERVICEID = 'productAndServiceId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEBSITE = 'website'
}

export type OrganisationProductsAndServicesBrandsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationProductsAndServicesBrandsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationProductsAndServicesBrandsBoolExp;
};

/** columns and relationships of "organisation_products_and_services_categories" */
export type OrganisationProductsAndServicesCategories = {
  __typename?: 'organisation_products_and_services_categories';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationProductsAndServicesBrandId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_product_supplier_category: OrganisationProductSupplierCategories;
  /** An object relationship */
  organisation_products_and_services_brand: OrganisationProductsAndServicesBrands;
  productSupplierCategoryId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "organisation_products_and_services_categories" */
export type OrganisationProductsAndServicesCategoriesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrganisationProductsAndServicesCategoriesMaxOrderBy>;
  min?: InputMaybe<OrganisationProductsAndServicesCategoriesMinOrderBy>;
};

/** input type for inserting array relation for remote table "organisation_products_and_services_categories" */
export type OrganisationProductsAndServicesCategoriesArrRelInsertInput = {
  data: Array<OrganisationProductsAndServicesCategoriesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationProductsAndServicesCategoriesOnConflict>;
};

/** Boolean expression to filter rows from the table "organisation_products_and_services_categories". All fields are combined with a logical 'AND'. */
export type OrganisationProductsAndServicesCategoriesBoolExp = {
  _and?: InputMaybe<Array<OrganisationProductsAndServicesCategoriesBoolExp>>;
  _not?: InputMaybe<OrganisationProductsAndServicesCategoriesBoolExp>;
  _or?: InputMaybe<Array<OrganisationProductsAndServicesCategoriesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationProductsAndServicesBrandId?: InputMaybe<UuidComparisonExp>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
  productSupplierCategoryId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "organisation_products_and_services_categories" */
export enum OrganisationProductsAndServicesCategoriesConstraint {
  /** unique or primary key constraint on columns "organisation_products_and_services_brand_id", "product_supplier_category_id" */
  ORGANISATION_PRODUCTS_AND_SERVICES_CATEGORIES_BRAND_PSC_KEY = 'organisation_products_and_services_categories_brand_psc_key',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_PRODUCTS_AND_SERVICES_CATEGORIES_PKEY = 'organisation_products_and_services_categories_pkey'
}

/** input type for inserting data into table "organisation_products_and_services_categories" */
export type OrganisationProductsAndServicesCategoriesInsertInput = {
  organisationProductsAndServicesBrandId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesObjRelInsertInput>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsObjRelInsertInput>;
  productSupplierCategoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "organisation_products_and_services_categories" */
export type OrganisationProductsAndServicesCategoriesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationProductsAndServicesBrandId?: InputMaybe<OrderBy>;
  productSupplierCategoryId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "organisation_products_and_services_categories" */
export type OrganisationProductsAndServicesCategoriesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationProductsAndServicesBrandId?: InputMaybe<OrderBy>;
  productSupplierCategoryId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "organisation_products_and_services_categories" */
export type OrganisationProductsAndServicesCategoriesMutationResponse = {
  __typename?: 'organisation_products_and_services_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationProductsAndServicesCategories>;
};

/** on_conflict condition type for table "organisation_products_and_services_categories" */
export type OrganisationProductsAndServicesCategoriesOnConflict = {
  constraint: OrganisationProductsAndServicesCategoriesConstraint;
  update_columns: Array<OrganisationProductsAndServicesCategoriesUpdateColumn>;
  where?: InputMaybe<OrganisationProductsAndServicesCategoriesBoolExp>;
};

/** Ordering options when selecting data from "organisation_products_and_services_categories". */
export type OrganisationProductsAndServicesCategoriesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationProductsAndServicesBrandId?: InputMaybe<OrderBy>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesOrderBy>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsOrderBy>;
  productSupplierCategoryId?: InputMaybe<OrderBy>;
};

/** select columns of table "organisation_products_and_services_categories" */
export enum OrganisationProductsAndServicesCategoriesSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONPRODUCTSANDSERVICESBRANDID = 'organisationProductsAndServicesBrandId',
  /** column name */
  PRODUCTSUPPLIERCATEGORYID = 'productSupplierCategoryId'
}

/** Streaming cursor of the table "organisation_products_and_services_categories" */
export type OrganisationProductsAndServicesCategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganisationProductsAndServicesCategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganisationProductsAndServicesCategoriesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationProductsAndServicesBrandId?: InputMaybe<Scalars['uuid']['input']>;
  productSupplierCategoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "organisation_products_and_services_categories" (current role has no relevant permissions) */
export enum OrganisationProductsAndServicesCategoriesUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** unique or primary key constraints on table "organisation_products_and_services" */
export enum OrganisationProductsAndServicesConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIERS_PKEY = 'organisation_suppliers_pkey'
}

/** input type for inserting data into table "organisation_products_and_services" */
export type OrganisationProductsAndServicesInsertInput = {
  assessments?: InputMaybe<AssessmentsArrRelInsertInput>;
  businessOwner?: InputMaybe<UsersObjRelInsertInput>;
  businessOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<DocumentsArrRelInsertInput>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  engagements?: InputMaybe<EngagementsArrRelInsertInput>;
  functionalDescription?: InputMaybe<Scalars['String']['input']>;
  functionalEmbedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationProductsAndServicesBrandId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsObjRelInsertInput>;
  organisation_products_and_services_requests?: InputMaybe<RequestsArrRelInsertInput>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  renewals?: InputMaybe<RenewalsArrRelInsertInput>;
  state?: InputMaybe<OrganisationProductsAndServicesStateEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type OrganisationProductsAndServicesMaxFields = {
  __typename?: 'organisation_products_and_services_max_fields';
  businessOwnerId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  functionalDescription: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationProductsAndServicesBrandId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "organisation_products_and_services" */
export type OrganisationProductsAndServicesMaxOrderBy = {
  businessOwnerId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  functionalDescription?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationProductsAndServicesBrandId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type OrganisationProductsAndServicesMinFields = {
  __typename?: 'organisation_products_and_services_min_fields';
  businessOwnerId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  functionalDescription: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationProductsAndServicesBrandId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "organisation_products_and_services" */
export type OrganisationProductsAndServicesMinOrderBy = {
  businessOwnerId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  functionalDescription?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationProductsAndServicesBrandId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "organisation_products_and_services" */
export type OrganisationProductsAndServicesMutationResponse = {
  __typename?: 'organisation_products_and_services_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationProductsAndServices>;
};

/** input type for inserting object relation for remote table "organisation_products_and_services" */
export type OrganisationProductsAndServicesObjRelInsertInput = {
  data: OrganisationProductsAndServicesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationProductsAndServicesOnConflict>;
};

/** on_conflict condition type for table "organisation_products_and_services" */
export type OrganisationProductsAndServicesOnConflict = {
  constraint: OrganisationProductsAndServicesConstraint;
  update_columns: Array<OrganisationProductsAndServicesUpdateColumn>;
  where?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};

/** Ordering options when selecting data from "organisation_products_and_services". */
export type OrganisationProductsAndServicesOrderBy = {
  assessments_aggregate?: InputMaybe<AssessmentsAggregateOrderBy>;
  businessOwner?: InputMaybe<UsersOrderBy>;
  businessOwnerId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  documents_aggregate?: InputMaybe<DocumentsAggregateOrderBy>;
  embedding?: InputMaybe<OrderBy>;
  engagements_aggregate?: InputMaybe<EngagementsAggregateOrderBy>;
  functionalDescription?: InputMaybe<OrderBy>;
  functionalEmbedding?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationProductsAndServicesBrandId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsOrderBy>;
  organisation_products_and_services_requests_aggregate?: InputMaybe<RequestsAggregateOrderBy>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  renewals_aggregate?: InputMaybe<RenewalsAggregateOrderBy>;
  state?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_products_and_services */
export type OrganisationProductsAndServicesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_products_and_services" */
export enum OrganisationProductsAndServicesSelectColumn {
  /** column name */
  BUSINESSOWNERID = 'businessOwnerId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DISPLAYNAME = 'displayName',
  /** column name */
  EMBEDDING = 'embedding',
  /** column name */
  FUNCTIONALDESCRIPTION = 'functionalDescription',
  /** column name */
  FUNCTIONALEMBEDDING = 'functionalEmbedding',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONPRODUCTSANDSERVICESBRANDID = 'organisationProductsAndServicesBrandId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  STATE = 'state',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEBSITE = 'website'
}

/** select "organisation_products_and_services_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organisation_products_and_services" */
export enum OrganisationProductsAndServicesSelectColumnOrganisationProductsAndServicesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISARCHIVED = 'isArchived'
}

/** select "organisation_products_and_services_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organisation_products_and_services" */
export enum OrganisationProductsAndServicesSelectColumnOrganisationProductsAndServicesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISARCHIVED = 'isArchived'
}

/** input type for updating data in table "organisation_products_and_services" */
export type OrganisationProductsAndServicesSetInput = {
  businessOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  functionalDescription?: InputMaybe<Scalars['String']['input']>;
  functionalEmbedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationProductsAndServicesBrandId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<OrganisationProductsAndServicesStateEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "organisation_products_and_services_state" */
export type OrganisationProductsAndServicesState = {
  __typename?: 'organisation_products_and_services_state';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "organisation_products_and_services_state". All fields are combined with a logical 'AND'. */
export type OrganisationProductsAndServicesStateBoolExp = {
  _and?: InputMaybe<Array<OrganisationProductsAndServicesStateBoolExp>>;
  _not?: InputMaybe<OrganisationProductsAndServicesStateBoolExp>;
  _or?: InputMaybe<Array<OrganisationProductsAndServicesStateBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum OrganisationProductsAndServicesStateEnum {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Inactive */
  INACTIVE = 'INACTIVE',
  /** Pending */
  PENDING = 'PENDING'
}

/** Boolean expression to compare columns of type "organisation_products_and_services_state_enum". All fields are combined with logical 'AND'. */
export type OrganisationProductsAndServicesStateEnumComparisonExp = {
  _eq?: InputMaybe<OrganisationProductsAndServicesStateEnum>;
  _in?: InputMaybe<Array<OrganisationProductsAndServicesStateEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<OrganisationProductsAndServicesStateEnum>;
  _nin?: InputMaybe<Array<OrganisationProductsAndServicesStateEnum>>;
};

/** Ordering options when selecting data from "organisation_products_and_services_state". */
export type OrganisationProductsAndServicesStateOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "organisation_products_and_services_state" */
export enum OrganisationProductsAndServicesStateSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** update columns of table "organisation_products_and_services" */
export enum OrganisationProductsAndServicesUpdateColumn {
  /** column name */
  BUSINESSOWNERID = 'businessOwnerId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DISPLAYNAME = 'displayName',
  /** column name */
  EMBEDDING = 'embedding',
  /** column name */
  FUNCTIONALDESCRIPTION = 'functionalDescription',
  /** column name */
  FUNCTIONALEMBEDDING = 'functionalEmbedding',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONPRODUCTSANDSERVICESBRANDID = 'organisationProductsAndServicesBrandId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  STATE = 'state',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEBSITE = 'website'
}

export type OrganisationProductsAndServicesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationProductsAndServicesSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationProductsAndServicesBoolExp;
};

/** AWS cognito user pool clients for Public API access */
export type OrganisationPublicApiClients = {
  __typename?: 'organisation_public_api_clients';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationIntegration: OrganisationIntegrations;
  organisationIntegrationId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userPoolClientId: Scalars['String']['output'];
  userPoolId: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "organisation_public_api_clients". All fields are combined with a logical 'AND'. */
export type OrganisationPublicApiClientsBoolExp = {
  _and?: InputMaybe<Array<OrganisationPublicApiClientsBoolExp>>;
  _not?: InputMaybe<OrganisationPublicApiClientsBoolExp>;
  _or?: InputMaybe<Array<OrganisationPublicApiClientsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userPoolClientId?: InputMaybe<StringComparisonExp>;
  userPoolId?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "organisation_public_api_clients" */
export enum OrganisationPublicApiClientsConstraint {
  /** unique or primary key constraint on columns "organisation_id", "organisation_integration_id", "name" */
  ORGANISATION_PUBLIC_API_CLIENTS_ORGANISATION_ID_INTEGRATION_ID_ = 'organisation_public_api_clients_organisation_id_integration_id_',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_PUBLIC_API_CLIENTS_PKEY = 'organisation_public_api_clients_pkey',
  /** unique or primary key constraint on columns "user_pool_client_id" */
  ORGANISATION_PUBLIC_API_CLIENTS_USER_POOL_CLIENT_ID_KEY = 'organisation_public_api_clients_user_pool_client_id_key'
}

/** input type for inserting data into table "organisation_public_api_clients" */
export type OrganisationPublicApiClientsInsertInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  userPoolClientId?: InputMaybe<Scalars['String']['input']>;
  userPoolId?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "organisation_public_api_clients" */
export type OrganisationPublicApiClientsMutationResponse = {
  __typename?: 'organisation_public_api_clients_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationPublicApiClients>;
};

/** on_conflict condition type for table "organisation_public_api_clients" */
export type OrganisationPublicApiClientsOnConflict = {
  constraint: OrganisationPublicApiClientsConstraint;
  update_columns: Array<OrganisationPublicApiClientsUpdateColumn>;
  where?: InputMaybe<OrganisationPublicApiClientsBoolExp>;
};

/** Ordering options when selecting data from "organisation_public_api_clients". */
export type OrganisationPublicApiClientsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsOrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userPoolClientId?: InputMaybe<OrderBy>;
  userPoolId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_public_api_clients */
export type OrganisationPublicApiClientsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_public_api_clients" */
export enum OrganisationPublicApiClientsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERPOOLCLIENTID = 'userPoolClientId',
  /** column name */
  USERPOOLID = 'userPoolId'
}

/** input type for updating data in table "organisation_public_api_clients" */
export type OrganisationPublicApiClientsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organisation_public_api_clients" */
export type OrganisationPublicApiClientsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganisationPublicApiClientsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganisationPublicApiClientsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userPoolClientId?: InputMaybe<Scalars['String']['input']>;
  userPoolId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organisation_public_api_clients" */
export enum OrganisationPublicApiClientsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  NAME = 'name'
}

export type OrganisationPublicApiClientsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationPublicApiClientsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationPublicApiClientsBoolExp;
};

/** columns and relationships of "organisation_settings" */
export type OrganisationSettings = {
  __typename?: 'organisation_settings';
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  value: Scalars['jsonb']['output'];
};


/** columns and relationships of "organisation_settings" */
export type OrganisationSettingsValueArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type OrganisationSettingsAppendInput = {
  value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "organisation_settings". All fields are combined with a logical 'AND'. */
export type OrganisationSettingsBoolExp = {
  _and?: InputMaybe<Array<OrganisationSettingsBoolExp>>;
  _not?: InputMaybe<OrganisationSettingsBoolExp>;
  _or?: InputMaybe<Array<OrganisationSettingsBoolExp>>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  value?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "organisation_settings" */
export enum OrganisationSettingsConstraint {
  /** unique or primary key constraint on columns "organisation_id", "name" */
  ORGANISATION_SETTINGS_PKEY = 'organisation_settings_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type OrganisationSettingsDeleteAtPathInput = {
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type OrganisationSettingsDeleteElemInput = {
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type OrganisationSettingsDeleteKeyInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "organisation_settings" */
export type OrganisationSettingsInsertInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** response of any mutation on the table "organisation_settings" */
export type OrganisationSettingsMutationResponse = {
  __typename?: 'organisation_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationSettings>;
};

/** on_conflict condition type for table "organisation_settings" */
export type OrganisationSettingsOnConflict = {
  constraint: OrganisationSettingsConstraint;
  update_columns: Array<OrganisationSettingsUpdateColumn>;
  where?: InputMaybe<OrganisationSettingsBoolExp>;
};

/** Ordering options when selecting data from "organisation_settings". */
export type OrganisationSettingsOrderBy = {
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_settings */
export type OrganisationSettingsPkColumnsInput = {
  name: Scalars['String']['input'];
  organisationId: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type OrganisationSettingsPrependInput = {
  value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "organisation_settings" */
export enum OrganisationSettingsSelectColumn {
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  VALUE = 'value'
}

/** input type for updating data in table "organisation_settings" */
export type OrganisationSettingsSetInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "organisation_settings" */
export enum OrganisationSettingsUpdateColumn {
  /** column name */
  NAME = 'name',
  /** column name */
  VALUE = 'value'
}

export type OrganisationSettingsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<OrganisationSettingsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<OrganisationSettingsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<OrganisationSettingsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<OrganisationSettingsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<OrganisationSettingsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationSettingsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationSettingsBoolExp;
};

/** Keep track of static content for a given organisation */
export type OrganisationStaticContent = {
  __typename?: 'organisation_static_content';
  content: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user: Maybe<Users>;
};


/** Keep track of static content for a given organisation */
export type OrganisationStaticContentContentArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "organisation_static_content" */
export type OrganisationStaticContentAggregate = {
  __typename?: 'organisation_static_content_aggregate';
  aggregate: Maybe<OrganisationStaticContentAggregateFields>;
  nodes: Array<OrganisationStaticContent>;
};

/** aggregate fields of "organisation_static_content" */
export type OrganisationStaticContentAggregateFields = {
  __typename?: 'organisation_static_content_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<OrganisationStaticContentMaxFields>;
  min: Maybe<OrganisationStaticContentMinFields>;
};


/** aggregate fields of "organisation_static_content" */
export type OrganisationStaticContentAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<OrganisationStaticContentSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type OrganisationStaticContentAppendInput = {
  content?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "organisation_static_content". All fields are combined with a logical 'AND'. */
export type OrganisationStaticContentBoolExp = {
  _and?: InputMaybe<Array<OrganisationStaticContentBoolExp>>;
  _not?: InputMaybe<OrganisationStaticContentBoolExp>;
  _or?: InputMaybe<Array<OrganisationStaticContentBoolExp>>;
  content?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "organisation_static_content" */
export enum OrganisationStaticContentConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_STATIC_CONTENT_PKEY = 'organisation_static_content_pkey',
  /** unique or primary key constraint on columns "type", "organisation_id" */
  ORGANISATION_STATIC_CONTENT_TYPE_ORGANISATION_ID_KEY = 'organisation_static_content_type_organisation_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type OrganisationStaticContentDeleteAtPathInput = {
  content?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type OrganisationStaticContentDeleteElemInput = {
  content?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type OrganisationStaticContentDeleteKeyInput = {
  content?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "organisation_static_content" */
export type OrganisationStaticContentInsertInput = {
  content?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type OrganisationStaticContentMaxFields = {
  __typename?: 'organisation_static_content_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  updatedBy: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type OrganisationStaticContentMinFields = {
  __typename?: 'organisation_static_content_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  updatedBy: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "organisation_static_content" */
export type OrganisationStaticContentMutationResponse = {
  __typename?: 'organisation_static_content_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationStaticContent>;
};

/** on_conflict condition type for table "organisation_static_content" */
export type OrganisationStaticContentOnConflict = {
  constraint: OrganisationStaticContentConstraint;
  update_columns: Array<OrganisationStaticContentUpdateColumn>;
  where?: InputMaybe<OrganisationStaticContentBoolExp>;
};

/** Ordering options when selecting data from "organisation_static_content". */
export type OrganisationStaticContentOrderBy = {
  content?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: organisation_static_content */
export type OrganisationStaticContentPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type OrganisationStaticContentPrependInput = {
  content?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "organisation_static_content" */
export enum OrganisationStaticContentSelectColumn {
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

/** input type for updating data in table "organisation_static_content" */
export type OrganisationStaticContentSetInput = {
  content?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organisation_static_content" */
export enum OrganisationStaticContentUpdateColumn {
  /** column name */
  CONTENT = 'content',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

export type OrganisationStaticContentUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<OrganisationStaticContentAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<OrganisationStaticContentDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<OrganisationStaticContentDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<OrganisationStaticContentDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<OrganisationStaticContentPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationStaticContentSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationStaticContentBoolExp;
};

/** columns and relationships of "organisation_supplier_historic_submissions" */
export type OrganisationSupplierHistoricSubmissions = {
  __typename?: 'organisation_supplier_historic_submissions';
  config: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  form_template_id: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationSupplier: OrganisationSuppliers;
  organisationSupplierId: Scalars['uuid']['output'];
  response: Scalars['jsonb']['output'];
  submittedAt: Maybe<Scalars['timestamptz']['output']>;
  title: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "organisation_supplier_historic_submissions" */
export type OrganisationSupplierHistoricSubmissionsConfigArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "organisation_supplier_historic_submissions" */
export type OrganisationSupplierHistoricSubmissionsResponseArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type OrganisationSupplierHistoricSubmissionsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "organisation_supplier_historic_submissions". All fields are combined with a logical 'AND'. */
export type OrganisationSupplierHistoricSubmissionsBoolExp = {
  _and?: InputMaybe<Array<OrganisationSupplierHistoricSubmissionsBoolExp>>;
  _not?: InputMaybe<OrganisationSupplierHistoricSubmissionsBoolExp>;
  _or?: InputMaybe<Array<OrganisationSupplierHistoricSubmissionsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  form_template_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  response?: InputMaybe<JsonbComparisonExp>;
  submittedAt?: InputMaybe<TimestamptzComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "organisation_supplier_historic_submissions" */
export enum OrganisationSupplierHistoricSubmissionsConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIER_HISTORIC_SUBMISSIONS_PKEY = 'organisation_supplier_historic_submissions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type OrganisationSupplierHistoricSubmissionsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
  response?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type OrganisationSupplierHistoricSubmissionsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type OrganisationSupplierHistoricSubmissionsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "organisation_supplier_historic_submissions" */
export type OrganisationSupplierHistoricSubmissionsInsertInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
  submittedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "organisation_supplier_historic_submissions" */
export type OrganisationSupplierHistoricSubmissionsMutationResponse = {
  __typename?: 'organisation_supplier_historic_submissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationSupplierHistoricSubmissions>;
};

/** on_conflict condition type for table "organisation_supplier_historic_submissions" */
export type OrganisationSupplierHistoricSubmissionsOnConflict = {
  constraint: OrganisationSupplierHistoricSubmissionsConstraint;
  update_columns: Array<OrganisationSupplierHistoricSubmissionsUpdateColumn>;
  where?: InputMaybe<OrganisationSupplierHistoricSubmissionsBoolExp>;
};

/** Ordering options when selecting data from "organisation_supplier_historic_submissions". */
export type OrganisationSupplierHistoricSubmissionsOrderBy = {
  config?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  form_template_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  response?: InputMaybe<OrderBy>;
  submittedAt?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_supplier_historic_submissions */
export type OrganisationSupplierHistoricSubmissionsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type OrganisationSupplierHistoricSubmissionsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "organisation_supplier_historic_submissions" */
export enum OrganisationSupplierHistoricSubmissionsSelectColumn {
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  FORM_TEMPLATE_ID = 'form_template_id',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  RESPONSE = 'response',
  /** column name */
  SUBMITTEDAT = 'submittedAt',
  /** column name */
  TITLE = 'title'
}

/** input type for updating data in table "organisation_supplier_historic_submissions" */
export type OrganisationSupplierHistoricSubmissionsSetInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
  submittedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "organisation_supplier_historic_submissions" */
export type OrganisationSupplierHistoricSubmissionsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganisationSupplierHistoricSubmissionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganisationSupplierHistoricSubmissionsStreamCursorValueInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  form_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
  submittedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "organisation_supplier_historic_submissions" */
export enum OrganisationSupplierHistoricSubmissionsUpdateColumn {
  /** column name */
  CONFIG = 'config',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  RESPONSE = 'response',
  /** column name */
  SUBMITTEDAT = 'submittedAt',
  /** column name */
  TITLE = 'title'
}

export type OrganisationSupplierHistoricSubmissionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<OrganisationSupplierHistoricSubmissionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<OrganisationSupplierHistoricSubmissionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<OrganisationSupplierHistoricSubmissionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<OrganisationSupplierHistoricSubmissionsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<OrganisationSupplierHistoricSubmissionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationSupplierHistoricSubmissionsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationSupplierHistoricSubmissionsBoolExp;
};

/** Security and compliance resources (e.g. SOC 2, ISO 27001, privacy policies) for suppliers, discovered by AI scanning the web. */
export type OrganisationSupplierOnlineResources = {
  __typename?: 'organisation_supplier_online_resources';
  createdAt: Scalars['timestamptz']['output'];
  datePublished: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  evidenceUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationSupplier: OrganisationSuppliers;
  organisationSupplierId: Scalars['uuid']['output'];
  resourceType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "organisation_supplier_online_resources". All fields are combined with a logical 'AND'. */
export type OrganisationSupplierOnlineResourcesBoolExp = {
  _and?: InputMaybe<Array<OrganisationSupplierOnlineResourcesBoolExp>>;
  _not?: InputMaybe<OrganisationSupplierOnlineResourcesBoolExp>;
  _or?: InputMaybe<Array<OrganisationSupplierOnlineResourcesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  datePublished?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  evidenceUrl?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  resourceType?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "organisation_supplier_online_resources" */
export enum OrganisationSupplierOnlineResourcesConstraint {
  /** unique or primary key constraint on columns "organisation_id", "resource_type", "organisation_supplier_id" */
  ORGANISATION_SUPPLIER_ONLINE__ORGANISATION_ID_ORGANISATION__KEY = 'organisation_supplier_online__organisation_id_organisation__key',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIER_ONLINE_RESOURCES_PKEY = 'organisation_supplier_online_resources_pkey'
}

/** input type for inserting data into table "organisation_supplier_online_resources" */
export type OrganisationSupplierOnlineResourcesInsertInput = {
  datePublished?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  evidenceUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "organisation_supplier_online_resources" */
export type OrganisationSupplierOnlineResourcesMutationResponse = {
  __typename?: 'organisation_supplier_online_resources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationSupplierOnlineResources>;
};

/** on_conflict condition type for table "organisation_supplier_online_resources" */
export type OrganisationSupplierOnlineResourcesOnConflict = {
  constraint: OrganisationSupplierOnlineResourcesConstraint;
  update_columns: Array<OrganisationSupplierOnlineResourcesUpdateColumn>;
  where?: InputMaybe<OrganisationSupplierOnlineResourcesBoolExp>;
};

/** Ordering options when selecting data from "organisation_supplier_online_resources". */
export type OrganisationSupplierOnlineResourcesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  datePublished?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  evidenceUrl?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  resourceType?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_supplier_online_resources */
export type OrganisationSupplierOnlineResourcesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_supplier_online_resources" */
export enum OrganisationSupplierOnlineResourcesSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DATEPUBLISHED = 'datePublished',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EVIDENCEURL = 'evidenceUrl',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  RESOURCETYPE = 'resourceType',
  /** column name */
  STATUS = 'status',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "organisation_supplier_online_resources" */
export type OrganisationSupplierOnlineResourcesSetInput = {
  datePublished?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  evidenceUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organisation_supplier_online_resources" */
export enum OrganisationSupplierOnlineResourcesUpdateColumn {
  /** column name */
  DATEPUBLISHED = 'datePublished',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EVIDENCEURL = 'evidenceUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  RESOURCETYPE = 'resourceType',
  /** column name */
  STATUS = 'status',
  /** column name */
  USERID = 'userId'
}

export type OrganisationSupplierOnlineResourcesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationSupplierOnlineResourcesSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationSupplierOnlineResourcesBoolExp;
};

/** columns and relationships of "organisation_supplier_profile_resources" */
export type OrganisationSupplierProfileResources = {
  __typename?: 'organisation_supplier_profile_resources';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  entityId: Scalars['uuid']['output'];
  entityType: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationSupplierProfile: OrganisationSupplierProfiles;
  organisationSupplierProfileId: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "organisation_supplier_profile_resources". All fields are combined with a logical 'AND'. */
export type OrganisationSupplierProfileResourcesBoolExp = {
  _and?: InputMaybe<Array<OrganisationSupplierProfileResourcesBoolExp>>;
  _not?: InputMaybe<OrganisationSupplierProfileResourcesBoolExp>;
  _or?: InputMaybe<Array<OrganisationSupplierProfileResourcesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  entityId?: InputMaybe<UuidComparisonExp>;
  entityType?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierProfile?: InputMaybe<OrganisationSupplierProfilesBoolExp>;
  organisationSupplierProfileId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "organisation_supplier_profile_resources" */
export enum OrganisationSupplierProfileResourcesConstraint {
  /** unique or primary key constraint on columns "entity_type", "entity_id" */
  IDX_ORG_SUPPLIER_PROFILE_RESOURCES_ENTITY_UNIQUE = 'idx_org_supplier_profile_resources_entity_unique',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIER_PROFILE_RESOURCES_PKEY = 'organisation_supplier_profile_resources_pkey',
  /** unique or primary key constraint on columns "deleted_at", "organisation_supplier_profile_id", "entity_id" */
  UNIQ_ENTITY_ID_ORGANISATION_SUPPLIER_PROFILE_ID_DELETED_AT = 'uniq_entity_id_organisation_supplier_profile_id_deleted_at'
}

/** input type for inserting data into table "organisation_supplier_profile_resources" */
export type OrganisationSupplierProfileResourcesInsertInput = {
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierProfile?: InputMaybe<OrganisationSupplierProfilesObjRelInsertInput>;
  organisationSupplierProfileId?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "organisation_supplier_profile_resources" */
export type OrganisationSupplierProfileResourcesMutationResponse = {
  __typename?: 'organisation_supplier_profile_resources_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationSupplierProfileResources>;
};

/** on_conflict condition type for table "organisation_supplier_profile_resources" */
export type OrganisationSupplierProfileResourcesOnConflict = {
  constraint: OrganisationSupplierProfileResourcesConstraint;
  update_columns: Array<OrganisationSupplierProfileResourcesUpdateColumn>;
  where?: InputMaybe<OrganisationSupplierProfileResourcesBoolExp>;
};

/** Ordering options when selecting data from "organisation_supplier_profile_resources". */
export type OrganisationSupplierProfileResourcesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  entityId?: InputMaybe<OrderBy>;
  entityType?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplierProfile?: InputMaybe<OrganisationSupplierProfilesOrderBy>;
  organisationSupplierProfileId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_supplier_profile_resources */
export type OrganisationSupplierProfileResourcesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_supplier_profile_resources" */
export enum OrganisationSupplierProfileResourcesSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ENTITYID = 'entityId',
  /** column name */
  ENTITYTYPE = 'entityType',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONSUPPLIERPROFILEID = 'organisationSupplierProfileId'
}

/** input type for updating data in table "organisation_supplier_profile_resources" */
export type OrganisationSupplierProfileResourcesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  organisationSupplierProfileId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organisation_supplier_profile_resources" */
export enum OrganisationSupplierProfileResourcesUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ORGANISATIONSUPPLIERPROFILEID = 'organisationSupplierProfileId'
}

export type OrganisationSupplierProfileResourcesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationSupplierProfileResourcesSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationSupplierProfileResourcesBoolExp;
};

/** columns and relationships of "organisation_supplier_profiles" */
export type OrganisationSupplierProfiles = {
  __typename?: 'organisation_supplier_profiles';
  archivedBy: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  customFieldValues: Array<CustomFieldValues>;
  /** An aggregate relationship */
  customFieldValues_aggregate: CustomFieldValuesAggregate;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  entityBankDetails: Array<EntityBankDetails>;
  /** An aggregate relationship */
  entityBankDetails_aggregate: EntityBankDetailsAggregate;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationSupplier: OrganisationSuppliers;
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  /** An object relationship */
  paymentTerm: Maybe<PaymentTerms>;
  payment_method_id: Maybe<Scalars['uuid']['output']>;
  payment_term_id: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  profileState: OrganisationSupplierState;
  remoteId: Maybe<Scalars['String']['output']>;
  remoteLink: Maybe<Scalars['String']['output']>;
  state: OrganisationSupplierStateEnum;
  /** An object relationship */
  subsidiary: Subsidiaries;
  subsidiaryId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesCustomFieldValuesArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** columns and relationships of "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesCustomFieldValuesAggregateArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** columns and relationships of "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesEntityBankDetailsArgs = {
  distinct_on: InputMaybe<Array<EntityBankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityBankDetailsOrderBy>>;
  where: InputMaybe<EntityBankDetailsBoolExp>;
};


/** columns and relationships of "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesEntityBankDetailsAggregateArgs = {
  distinct_on: InputMaybe<Array<EntityBankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityBankDetailsOrderBy>>;
  where: InputMaybe<EntityBankDetailsBoolExp>;
};

/** order by aggregate values of table "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrganisationSupplierProfilesMaxOrderBy>;
  min?: InputMaybe<OrganisationSupplierProfilesMinOrderBy>;
};

/** input type for inserting array relation for remote table "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesArrRelInsertInput = {
  data: Array<OrganisationSupplierProfilesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationSupplierProfilesOnConflict>;
};

/** Boolean expression to filter rows from the table "organisation_supplier_profiles". All fields are combined with a logical 'AND'. */
export type OrganisationSupplierProfilesBoolExp = {
  _and?: InputMaybe<Array<OrganisationSupplierProfilesBoolExp>>;
  _not?: InputMaybe<OrganisationSupplierProfilesBoolExp>;
  _or?: InputMaybe<Array<OrganisationSupplierProfilesBoolExp>>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customFieldValues?: InputMaybe<CustomFieldValuesBoolExp>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  entityBankDetails?: InputMaybe<EntityBankDetailsBoolExp>;
  entityBankDetails_aggregate?: InputMaybe<EntityBankDetailsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentTerm?: InputMaybe<PaymentTermsBoolExp>;
  payment_method_id?: InputMaybe<UuidComparisonExp>;
  payment_term_id?: InputMaybe<UuidComparisonExp>;
  profileState?: InputMaybe<OrganisationSupplierStateBoolExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  remoteLink?: InputMaybe<StringComparisonExp>;
  state?: InputMaybe<OrganisationSupplierStateEnumComparisonExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  subsidiaryId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "organisation_supplier_profiles" */
export enum OrganisationSupplierProfilesConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIER_PROFILES_PKEY = 'organisation_supplier_profiles_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  ORGANISATION_SUPPLIER_PROFILES_REMOTE_ID_ORGANISATION_ID_ACTIVE = 'organisation_supplier_profiles_remote_id_organisation_id_active',
  /** unique or primary key constraint on columns "deleted_at", "subsidiary_id", "organisation_supplier_id" */
  UNIQ_SUBSIDIARY_ID_ORGANISATION_SUPPLIER_ID_DELETED_AT = 'uniq_subsidiary_id_organisation_supplier_id_deleted_at'
}

/** input type for inserting data into table "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesInsertInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customFieldValues?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  entityBankDetails?: InputMaybe<EntityBankDetailsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodsObjRelInsertInput>;
  paymentTerm?: InputMaybe<PaymentTermsObjRelInsertInput>;
  payment_method_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_term_id?: InputMaybe<Scalars['uuid']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  remoteLink?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OrganisationSupplierStateEnum>;
  subsidiary?: InputMaybe<SubsidiariesObjRelInsertInput>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesMaxOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  payment_method_id?: InputMaybe<OrderBy>;
  payment_term_id?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  remoteLink?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesMinOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  payment_method_id?: InputMaybe<OrderBy>;
  payment_term_id?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  remoteLink?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesMutationResponse = {
  __typename?: 'organisation_supplier_profiles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationSupplierProfiles>;
};

/** input type for inserting object relation for remote table "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesObjRelInsertInput = {
  data: OrganisationSupplierProfilesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationSupplierProfilesOnConflict>;
};

/** on_conflict condition type for table "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesOnConflict = {
  constraint: OrganisationSupplierProfilesConstraint;
  update_columns: Array<OrganisationSupplierProfilesUpdateColumn>;
  where?: InputMaybe<OrganisationSupplierProfilesBoolExp>;
};

/** Ordering options when selecting data from "organisation_supplier_profiles". */
export type OrganisationSupplierProfilesOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  entityBankDetails_aggregate?: InputMaybe<EntityBankDetailsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  paymentMethod?: InputMaybe<PaymentMethodsOrderBy>;
  paymentTerm?: InputMaybe<PaymentTermsOrderBy>;
  payment_method_id?: InputMaybe<OrderBy>;
  payment_term_id?: InputMaybe<OrderBy>;
  profileState?: InputMaybe<OrganisationSupplierStateOrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  remoteLink?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  subsidiary?: InputMaybe<SubsidiariesOrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_supplier_profiles */
export type OrganisationSupplierProfilesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_supplier_profiles" */
export enum OrganisationSupplierProfilesSelectColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  PAYMENT_METHOD_ID = 'payment_method_id',
  /** column name */
  PAYMENT_TERM_ID = 'payment_term_id',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  REMOTELINK = 'remoteLink',
  /** column name */
  STATE = 'state',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "organisation_supplier_profiles" */
export type OrganisationSupplierProfilesSetInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  payment_method_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_term_id?: InputMaybe<Scalars['uuid']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  remoteLink?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OrganisationSupplierStateEnum>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organisation_supplier_profiles" */
export enum OrganisationSupplierProfilesUpdateColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  PAYMENT_METHOD_ID = 'payment_method_id',
  /** column name */
  PAYMENT_TERM_ID = 'payment_term_id',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  REMOTELINK = 'remoteLink',
  /** column name */
  STATE = 'state',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId'
}

export type OrganisationSupplierProfilesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationSupplierProfilesSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationSupplierProfilesBoolExp;
};

/** columns and relationships of "organisation_supplier_state" */
export type OrganisationSupplierState = {
  __typename?: 'organisation_supplier_state';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "organisation_supplier_state". All fields are combined with a logical 'AND'. */
export type OrganisationSupplierStateBoolExp = {
  _and?: InputMaybe<Array<OrganisationSupplierStateBoolExp>>;
  _not?: InputMaybe<OrganisationSupplierStateBoolExp>;
  _or?: InputMaybe<Array<OrganisationSupplierStateBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum OrganisationSupplierStateEnum {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Archived */
  ARCHIVED = 'ARCHIVED',
  /** Inactive */
  INACTIVE = 'INACTIVE',
  /** Pending */
  PENDING = 'PENDING'
}

/** Boolean expression to compare columns of type "organisation_supplier_state_enum". All fields are combined with logical 'AND'. */
export type OrganisationSupplierStateEnumComparisonExp = {
  _eq?: InputMaybe<OrganisationSupplierStateEnum>;
  _in?: InputMaybe<Array<OrganisationSupplierStateEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<OrganisationSupplierStateEnum>;
  _nin?: InputMaybe<Array<OrganisationSupplierStateEnum>>;
};

/** Ordering options when selecting data from "organisation_supplier_state". */
export type OrganisationSupplierStateOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "organisation_supplier_state" */
export enum OrganisationSupplierStateSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** columns and relationships of "organisation_supplier_tags" */
export type OrganisationSupplierTags = {
  __typename?: 'organisation_supplier_tags';
  id: Scalars['uuid']['output'];
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_supplier: OrganisationSuppliers;
  /** An object relationship */
  tag: Tags;
  tagId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "organisation_supplier_tags" */
export type OrganisationSupplierTagsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrganisationSupplierTagsMaxOrderBy>;
  min?: InputMaybe<OrganisationSupplierTagsMinOrderBy>;
};

/** input type for inserting array relation for remote table "organisation_supplier_tags" */
export type OrganisationSupplierTagsArrRelInsertInput = {
  data: Array<OrganisationSupplierTagsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationSupplierTagsOnConflict>;
};

/** Boolean expression to filter rows from the table "organisation_supplier_tags". All fields are combined with a logical 'AND'. */
export type OrganisationSupplierTagsBoolExp = {
  _and?: InputMaybe<Array<OrganisationSupplierTagsBoolExp>>;
  _not?: InputMaybe<OrganisationSupplierTagsBoolExp>;
  _or?: InputMaybe<Array<OrganisationSupplierTagsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  tag?: InputMaybe<TagsBoolExp>;
  tagId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "organisation_supplier_tags" */
export enum OrganisationSupplierTagsConstraint {
  /** unique or primary key constraint on columns "tag_id", "organisation_supplier_id" */
  ORGANISATION_SUPPLIER_TAGS_ORGANISATION_SUPPLIER_ID_TAG_ID_KEY = 'organisation_supplier_tags_organisation_supplier_id_tag_id_key',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIER_TAGS_PKEY = 'organisation_supplier_tags_pkey'
}

/** input type for inserting data into table "organisation_supplier_tags" */
export type OrganisationSupplierTagsInsertInput = {
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  tag?: InputMaybe<TagsObjRelInsertInput>;
  tagId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "organisation_supplier_tags" */
export type OrganisationSupplierTagsMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "organisation_supplier_tags" */
export type OrganisationSupplierTagsMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "organisation_supplier_tags" */
export type OrganisationSupplierTagsMutationResponse = {
  __typename?: 'organisation_supplier_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationSupplierTags>;
};

/** on_conflict condition type for table "organisation_supplier_tags" */
export type OrganisationSupplierTagsOnConflict = {
  constraint: OrganisationSupplierTagsConstraint;
  update_columns: Array<OrganisationSupplierTagsUpdateColumn>;
  where?: InputMaybe<OrganisationSupplierTagsBoolExp>;
};

/** Ordering options when selecting data from "organisation_supplier_tags". */
export type OrganisationSupplierTagsOrderBy = {
  id?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  tag?: InputMaybe<TagsOrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_supplier_tags */
export type OrganisationSupplierTagsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_supplier_tags" */
export enum OrganisationSupplierTagsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  TAGID = 'tagId'
}

/** input type for updating data in table "organisation_supplier_tags" */
export type OrganisationSupplierTagsSetInput = {
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organisation_supplier_tags" */
export enum OrganisationSupplierTagsUpdateColumn {
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId'
}

export type OrganisationSupplierTagsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationSupplierTagsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationSupplierTagsBoolExp;
};

/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliers = {
  __typename?: 'organisation_suppliers';
  address: Maybe<Scalars['address']['output']>;
  /** An array relationship */
  agreements: Array<Agreements>;
  /** An aggregate relationship */
  agreements_aggregate: AgreementsAggregate;
  archivedBy: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  customFieldValues: Array<CustomFieldValues>;
  /** An aggregate relationship */
  customFieldValues_aggregate: CustomFieldValuesAggregate;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: DocumentsAggregate;
  embedding: Maybe<Scalars['vector']['output']>;
  /** An array relationship */
  engagements: Array<Engagements>;
  /** An aggregate relationship */
  engagements_aggregate: EngagementsAggregate;
  /** An array relationship */
  entityBankDetails: Array<EntityBankDetails>;
  /** An aggregate relationship */
  entityBankDetails_aggregate: EntityBankDetailsAggregate;
  externalLink: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  externalRiskScore: Maybe<ExternalRiskScores>;
  externalRiskScoreId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  external_contacts: Array<ExternalContacts>;
  files: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  internalContacts: Array<InternalContacts>;
  isContinuousMonitoringEnabled: Scalars['Boolean']['output'];
  isPerson: Maybe<Scalars['Boolean']['output']>;
  isPreferred: Scalars['Boolean']['output'];
  isReseller: Scalars['Boolean']['output'];
  lastAssessmentDate: Maybe<Scalars['timestamptz']['output']>;
  legalName: Maybe<Scalars['String']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  /** An object relationship */
  organisationIntegration: Maybe<OrganisationIntegrations>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierBrandId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  organisationSupplierProfiles: Array<OrganisationSupplierProfiles>;
  /** An array relationship */
  organisation_products_and_services: Array<OrganisationProductsAndServices>;
  /** An aggregate relationship */
  organisation_products_and_services_aggregate: OrganisationProductsAndServicesAggregate;
  /** An object relationship */
  organisation_supplier_brand: Maybe<OrganisationSuppliersBrands>;
  /** An object relationship */
  organisation_supplier_state: OrganisationSupplierState;
  /** An array relationship */
  organisation_supplier_tags: Array<OrganisationSupplierTags>;
  /** An array relationship */
  organisation_suppliers_categories: Array<OrganisationSuppliersCategories>;
  /** An array relationship */
  organisation_suppliers_requests: Array<Requests>;
  /** An aggregate relationship */
  organisation_suppliers_requests_aggregate: RequestsAggregate;
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  paymentTerms: Maybe<PaymentTerms>;
  paymentTermsId: Maybe<Scalars['uuid']['output']>;
  publicId: Scalars['Int']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  remoteLink: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  rfx_suppliers: Array<RfxSuppliers>;
  /** An aggregate relationship */
  rfx_suppliers_aggregate: RfxSuppliersAggregate;
  /** An array relationship */
  risks: Array<Risks>;
  state: OrganisationSupplierStateEnum;
  taxNumber: Maybe<Scalars['String']['output']>;
  terminalCategoryId: Maybe<Scalars['uuid']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  website: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersAgreementsArgs = {
  distinct_on: InputMaybe<Array<AgreementsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementsOrderBy>>;
  where: InputMaybe<AgreementsBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersAgreementsAggregateArgs = {
  distinct_on: InputMaybe<Array<AgreementsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementsOrderBy>>;
  where: InputMaybe<AgreementsBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersCustomFieldValuesArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersCustomFieldValuesAggregateArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersDocumentsArgs = {
  distinct_on: InputMaybe<Array<DocumentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<DocumentsOrderBy>>;
  where: InputMaybe<DocumentsBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersDocumentsAggregateArgs = {
  distinct_on: InputMaybe<Array<DocumentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<DocumentsOrderBy>>;
  where: InputMaybe<DocumentsBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersEngagementsArgs = {
  distinct_on: InputMaybe<Array<EngagementsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EngagementsOrderBy>>;
  where: InputMaybe<EngagementsBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersEngagementsAggregateArgs = {
  distinct_on: InputMaybe<Array<EngagementsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EngagementsOrderBy>>;
  where: InputMaybe<EngagementsBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersEntityBankDetailsArgs = {
  distinct_on: InputMaybe<Array<EntityBankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityBankDetailsOrderBy>>;
  where: InputMaybe<EntityBankDetailsBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersEntityBankDetailsAggregateArgs = {
  distinct_on: InputMaybe<Array<EntityBankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityBankDetailsOrderBy>>;
  where: InputMaybe<EntityBankDetailsBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersExternalContactsArgs = {
  distinct_on: InputMaybe<Array<ExternalContactsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ExternalContactsOrderBy>>;
  where: InputMaybe<ExternalContactsBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersFilesArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersInternalContactsArgs = {
  distinct_on: InputMaybe<Array<InternalContactsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<InternalContactsOrderBy>>;
  where: InputMaybe<InternalContactsBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersOrganisationSupplierProfilesArgs = {
  distinct_on: InputMaybe<Array<OrganisationSupplierProfilesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSupplierProfilesOrderBy>>;
  where: InputMaybe<OrganisationSupplierProfilesBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersOrganisationProductsAndServicesArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersOrganisationProductsAndServicesAggregateArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersOrganisationSupplierTagsArgs = {
  distinct_on: InputMaybe<Array<OrganisationSupplierTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSupplierTagsOrderBy>>;
  where: InputMaybe<OrganisationSupplierTagsBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersOrganisationSuppliersCategoriesArgs = {
  distinct_on: InputMaybe<Array<OrganisationSuppliersCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersCategoriesOrderBy>>;
  where: InputMaybe<OrganisationSuppliersCategoriesBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersOrganisationSuppliersRequestsArgs = {
  distinct_on: InputMaybe<Array<RequestsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestsOrderBy>>;
  where: InputMaybe<RequestsBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersOrganisationSuppliersRequestsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestsOrderBy>>;
  where: InputMaybe<RequestsBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersRfxSuppliersArgs = {
  distinct_on: InputMaybe<Array<RfxSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxSuppliersOrderBy>>;
  where: InputMaybe<RfxSuppliersBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersRfxSuppliersAggregateArgs = {
  distinct_on: InputMaybe<Array<RfxSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxSuppliersOrderBy>>;
  where: InputMaybe<RfxSuppliersBoolExp>;
};


/** columns and relationships of "organisation_suppliers" */
export type OrganisationSuppliersRisksArgs = {
  distinct_on: InputMaybe<Array<RisksSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RisksOrderBy>>;
  where: InputMaybe<RisksBoolExp>;
};

/** aggregated selection of "organisation_suppliers" */
export type OrganisationSuppliersAggregate = {
  __typename?: 'organisation_suppliers_aggregate';
  aggregate: Maybe<OrganisationSuppliersAggregateFields>;
  nodes: Array<OrganisationSuppliers>;
};

export type OrganisationSuppliersAggregateBoolExp = {
  bool_and?: InputMaybe<OrganisationSuppliersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<OrganisationSuppliersAggregateBoolExpBoolOr>;
  count?: InputMaybe<OrganisationSuppliersAggregateBoolExpCount>;
};

export type OrganisationSuppliersAggregateBoolExpBoolAnd = {
  arguments: OrganisationSuppliersSelectColumnOrganisationSuppliersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationSuppliersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type OrganisationSuppliersAggregateBoolExpBoolOr = {
  arguments: OrganisationSuppliersSelectColumnOrganisationSuppliersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationSuppliersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type OrganisationSuppliersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationSuppliersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "organisation_suppliers" */
export type OrganisationSuppliersAggregateFields = {
  __typename?: 'organisation_suppliers_aggregate_fields';
  avg: Maybe<OrganisationSuppliersAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<OrganisationSuppliersMaxFields>;
  min: Maybe<OrganisationSuppliersMinFields>;
  stddev: Maybe<OrganisationSuppliersStddevFields>;
  stddev_pop: Maybe<OrganisationSuppliersStddevPopFields>;
  stddev_samp: Maybe<OrganisationSuppliersStddevSampFields>;
  sum: Maybe<OrganisationSuppliersSumFields>;
  var_pop: Maybe<OrganisationSuppliersVarPopFields>;
  var_samp: Maybe<OrganisationSuppliersVarSampFields>;
  variance: Maybe<OrganisationSuppliersVarianceFields>;
};


/** aggregate fields of "organisation_suppliers" */
export type OrganisationSuppliersAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organisation_suppliers" */
export type OrganisationSuppliersAggregateOrderBy = {
  avg?: InputMaybe<OrganisationSuppliersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrganisationSuppliersMaxOrderBy>;
  min?: InputMaybe<OrganisationSuppliersMinOrderBy>;
  stddev?: InputMaybe<OrganisationSuppliersStddevOrderBy>;
  stddev_pop?: InputMaybe<OrganisationSuppliersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<OrganisationSuppliersStddevSampOrderBy>;
  sum?: InputMaybe<OrganisationSuppliersSumOrderBy>;
  var_pop?: InputMaybe<OrganisationSuppliersVarPopOrderBy>;
  var_samp?: InputMaybe<OrganisationSuppliersVarSampOrderBy>;
  variance?: InputMaybe<OrganisationSuppliersVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type OrganisationSuppliersAppendInput = {
  address?: InputMaybe<Scalars['jsonb']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "organisation_suppliers" */
export type OrganisationSuppliersArrRelInsertInput = {
  data: Array<OrganisationSuppliersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationSuppliersOnConflict>;
};

/** aggregate avg on columns */
export type OrganisationSuppliersAvgFields = {
  __typename?: 'organisation_suppliers_avg_fields';
  publicId: Maybe<Scalars['Float']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** order by avg() on columns of table "organisation_suppliers" */
export type OrganisationSuppliersAvgOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "organisation_suppliers". All fields are combined with a logical 'AND'. */
export type OrganisationSuppliersBoolExp = {
  _and?: InputMaybe<Array<OrganisationSuppliersBoolExp>>;
  _not?: InputMaybe<OrganisationSuppliersBoolExp>;
  _or?: InputMaybe<Array<OrganisationSuppliersBoolExp>>;
  address?: InputMaybe<JsonbComparisonExp>;
  agreements?: InputMaybe<AgreementsBoolExp>;
  agreements_aggregate?: InputMaybe<AgreementsAggregateBoolExp>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customFieldValues?: InputMaybe<CustomFieldValuesBoolExp>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  documents?: InputMaybe<DocumentsBoolExp>;
  documents_aggregate?: InputMaybe<DocumentsAggregateBoolExp>;
  embedding?: InputMaybe<VectorComparisonExp>;
  engagements?: InputMaybe<EngagementsBoolExp>;
  engagements_aggregate?: InputMaybe<EngagementsAggregateBoolExp>;
  entityBankDetails?: InputMaybe<EntityBankDetailsBoolExp>;
  entityBankDetails_aggregate?: InputMaybe<EntityBankDetailsAggregateBoolExp>;
  externalLink?: InputMaybe<StringComparisonExp>;
  externalRiskScore?: InputMaybe<ExternalRiskScoresBoolExp>;
  externalRiskScoreId?: InputMaybe<UuidComparisonExp>;
  external_contacts?: InputMaybe<ExternalContactsBoolExp>;
  files?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  internalContacts?: InputMaybe<InternalContactsBoolExp>;
  isContinuousMonitoringEnabled?: InputMaybe<BooleanComparisonExp>;
  isPerson?: InputMaybe<BooleanComparisonExp>;
  isPreferred?: InputMaybe<BooleanComparisonExp>;
  isReseller?: InputMaybe<BooleanComparisonExp>;
  lastAssessmentDate?: InputMaybe<TimestamptzComparisonExp>;
  legalName?: InputMaybe<StringComparisonExp>;
  logoUrl?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierBrandId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierProfiles?: InputMaybe<OrganisationSupplierProfilesBoolExp>;
  organisation_products_and_services?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  organisation_products_and_services_aggregate?: InputMaybe<OrganisationProductsAndServicesAggregateBoolExp>;
  organisation_supplier_brand?: InputMaybe<OrganisationSuppliersBrandsBoolExp>;
  organisation_supplier_state?: InputMaybe<OrganisationSupplierStateBoolExp>;
  organisation_supplier_tags?: InputMaybe<OrganisationSupplierTagsBoolExp>;
  organisation_suppliers_categories?: InputMaybe<OrganisationSuppliersCategoriesBoolExp>;
  organisation_suppliers_requests?: InputMaybe<RequestsBoolExp>;
  organisation_suppliers_requests_aggregate?: InputMaybe<RequestsAggregateBoolExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentMethodId?: InputMaybe<UuidComparisonExp>;
  paymentTerms?: InputMaybe<PaymentTermsBoolExp>;
  paymentTermsId?: InputMaybe<UuidComparisonExp>;
  publicId?: InputMaybe<IntComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  remoteLink?: InputMaybe<StringComparisonExp>;
  rfx_suppliers?: InputMaybe<RfxSuppliersBoolExp>;
  rfx_suppliers_aggregate?: InputMaybe<RfxSuppliersAggregateBoolExp>;
  risks?: InputMaybe<RisksBoolExp>;
  state?: InputMaybe<OrganisationSupplierStateEnumComparisonExp>;
  taxNumber?: InputMaybe<StringComparisonExp>;
  terminalCategoryId?: InputMaybe<UuidComparisonExp>;
  totalSpend?: InputMaybe<NumericComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** columns and relationships of "organisation_suppliers_brands" */
export type OrganisationSuppliersBrands = {
  __typename?: 'organisation_suppliers_brands';
  createdAt: Scalars['timestamptz']['output'];
  description: Maybe<Scalars['String']['output']>;
  embedding: Maybe<Scalars['vector']['output']>;
  id: Scalars['uuid']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  /** An array relationship */
  organisation_products_and_services_brands: Array<OrganisationProductsAndServicesBrands>;
  /** An array relationship */
  organisation_suppliers: Array<OrganisationSuppliers>;
  /** An aggregate relationship */
  organisation_suppliers_aggregate: OrganisationSuppliersAggregate;
  ranking: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  supplier: Maybe<Suppliers>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  website: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsOrganisationProductsAndServicesBrandsArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesBrandsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesBrandsOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
};


/** columns and relationships of "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsOrganisationSuppliersArgs = {
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


/** columns and relationships of "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsOrganisationSuppliersAggregateArgs = {
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};

/** order by aggregate values of table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsAggregateOrderBy = {
  avg?: InputMaybe<OrganisationSuppliersBrandsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrganisationSuppliersBrandsMaxOrderBy>;
  min?: InputMaybe<OrganisationSuppliersBrandsMinOrderBy>;
  stddev?: InputMaybe<OrganisationSuppliersBrandsStddevOrderBy>;
  stddev_pop?: InputMaybe<OrganisationSuppliersBrandsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<OrganisationSuppliersBrandsStddevSampOrderBy>;
  sum?: InputMaybe<OrganisationSuppliersBrandsSumOrderBy>;
  var_pop?: InputMaybe<OrganisationSuppliersBrandsVarPopOrderBy>;
  var_samp?: InputMaybe<OrganisationSuppliersBrandsVarSampOrderBy>;
  variance?: InputMaybe<OrganisationSuppliersBrandsVarianceOrderBy>;
};

/** order by avg() on columns of table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsAvgOrderBy = {
  ranking?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "organisation_suppliers_brands". All fields are combined with a logical 'AND'. */
export type OrganisationSuppliersBrandsBoolExp = {
  _and?: InputMaybe<Array<OrganisationSuppliersBrandsBoolExp>>;
  _not?: InputMaybe<OrganisationSuppliersBrandsBoolExp>;
  _or?: InputMaybe<Array<OrganisationSuppliersBrandsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  embedding?: InputMaybe<VectorComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  logoUrl?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisation_products_and_services_brands?: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
  organisation_suppliers?: InputMaybe<OrganisationSuppliersBoolExp>;
  organisation_suppliers_aggregate?: InputMaybe<OrganisationSuppliersAggregateBoolExp>;
  ranking?: InputMaybe<IntComparisonExp>;
  supplier?: InputMaybe<SuppliersBoolExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "organisation_suppliers_brands" */
export enum OrganisationSuppliersBrandsConstraint {
  /** unique or primary key constraint on columns "organisation_id", "supplier_id" */
  ORGANISATION_SUPPLIERS_BRANDS_ORGANISATION_ID_SUPPLIER_ID_KEY = 'organisation_suppliers_brands_organisation_id_supplier_id_key',
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIERS_BRANDS_PKEY = 'organisation_suppliers_brands_pkey'
}

/** input type for incrementing numeric columns in table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsIncInput = {
  ranking?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_products_and_services_brands?: InputMaybe<OrganisationProductsAndServicesBrandsArrRelInsertInput>;
  organisation_suppliers?: InputMaybe<OrganisationSuppliersArrRelInsertInput>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  ranking?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  ranking?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsMutationResponse = {
  __typename?: 'organisation_suppliers_brands_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationSuppliersBrands>;
};

/** input type for inserting object relation for remote table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsObjRelInsertInput = {
  data: OrganisationSuppliersBrandsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationSuppliersBrandsOnConflict>;
};

/** on_conflict condition type for table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsOnConflict = {
  constraint: OrganisationSuppliersBrandsConstraint;
  update_columns: Array<OrganisationSuppliersBrandsUpdateColumn>;
  where?: InputMaybe<OrganisationSuppliersBrandsBoolExp>;
};

/** Ordering options when selecting data from "organisation_suppliers_brands". */
export type OrganisationSuppliersBrandsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  embedding?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisation_products_and_services_brands_aggregate?: InputMaybe<OrganisationProductsAndServicesBrandsAggregateOrderBy>;
  organisation_suppliers_aggregate?: InputMaybe<OrganisationSuppliersAggregateOrderBy>;
  ranking?: InputMaybe<OrderBy>;
  supplier?: InputMaybe<SuppliersOrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_suppliers_brands */
export type OrganisationSuppliersBrandsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_suppliers_brands" */
export enum OrganisationSuppliersBrandsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EMBEDDING = 'embedding',
  /** column name */
  ID = 'id',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  RANKING = 'ranking',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEBSITE = 'website'
}

/** input type for updating data in table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsStddevOrderBy = {
  ranking?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsStddevPopOrderBy = {
  ranking?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsStddevSampOrderBy = {
  ranking?: InputMaybe<OrderBy>;
};

/** order by sum() on columns of table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsSumOrderBy = {
  ranking?: InputMaybe<OrderBy>;
};

/** update columns of table "organisation_suppliers_brands" */
export enum OrganisationSuppliersBrandsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EMBEDDING = 'embedding',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  RANKING = 'ranking',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEBSITE = 'website'
}

export type OrganisationSuppliersBrandsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OrganisationSuppliersBrandsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationSuppliersBrandsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationSuppliersBrandsBoolExp;
};

/** order by var_pop() on columns of table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsVarPopOrderBy = {
  ranking?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsVarSampOrderBy = {
  ranking?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "organisation_suppliers_brands" */
export type OrganisationSuppliersBrandsVarianceOrderBy = {
  ranking?: InputMaybe<OrderBy>;
};

/** columns and relationships of "organisation_suppliers_categories" */
export type OrganisationSuppliersCategories = {
  __typename?: 'organisation_suppliers_categories';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_product_supplier_category: OrganisationProductSupplierCategories;
  /** An object relationship */
  organisation_supplier: OrganisationSuppliers;
  productSupplierCategoryId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "organisation_suppliers_categories" */
export type OrganisationSuppliersCategoriesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OrganisationSuppliersCategoriesMaxOrderBy>;
  min?: InputMaybe<OrganisationSuppliersCategoriesMinOrderBy>;
};

/** input type for inserting array relation for remote table "organisation_suppliers_categories" */
export type OrganisationSuppliersCategoriesArrRelInsertInput = {
  data: Array<OrganisationSuppliersCategoriesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationSuppliersCategoriesOnConflict>;
};

/** Boolean expression to filter rows from the table "organisation_suppliers_categories". All fields are combined with a logical 'AND'. */
export type OrganisationSuppliersCategoriesBoolExp = {
  _and?: InputMaybe<Array<OrganisationSuppliersCategoriesBoolExp>>;
  _not?: InputMaybe<OrganisationSuppliersCategoriesBoolExp>;
  _or?: InputMaybe<Array<OrganisationSuppliersCategoriesBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  productSupplierCategoryId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "organisation_suppliers_categories" */
export enum OrganisationSuppliersCategoriesConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIERS_CATEGORIES_PKEY = 'organisation_suppliers_categories_pkey'
}

/** input type for inserting data into table "organisation_suppliers_categories" */
export type OrganisationSuppliersCategoriesInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesObjRelInsertInput>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  productSupplierCategoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "organisation_suppliers_categories" */
export type OrganisationSuppliersCategoriesMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  productSupplierCategoryId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "organisation_suppliers_categories" */
export type OrganisationSuppliersCategoriesMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  productSupplierCategoryId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "organisation_suppliers_categories" */
export type OrganisationSuppliersCategoriesMutationResponse = {
  __typename?: 'organisation_suppliers_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationSuppliersCategories>;
};

/** on_conflict condition type for table "organisation_suppliers_categories" */
export type OrganisationSuppliersCategoriesOnConflict = {
  constraint: OrganisationSuppliersCategoriesConstraint;
  update_columns: Array<OrganisationSuppliersCategoriesUpdateColumn>;
  where?: InputMaybe<OrganisationSuppliersCategoriesBoolExp>;
};

/** Ordering options when selecting data from "organisation_suppliers_categories". */
export type OrganisationSuppliersCategoriesOrderBy = {
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  organisation_product_supplier_category?: InputMaybe<OrganisationProductSupplierCategoriesOrderBy>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  productSupplierCategoryId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_suppliers_categories */
export type OrganisationSuppliersCategoriesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_suppliers_categories" */
export enum OrganisationSuppliersCategoriesSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  PRODUCTSUPPLIERCATEGORYID = 'productSupplierCategoryId'
}

/** input type for updating data in table "organisation_suppliers_categories" */
export type OrganisationSuppliersCategoriesSetInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  productSupplierCategoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "organisation_suppliers_categories" */
export type OrganisationSuppliersCategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OrganisationSuppliersCategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganisationSuppliersCategoriesStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  productSupplierCategoryId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "organisation_suppliers_categories" */
export enum OrganisationSuppliersCategoriesUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  PRODUCTSUPPLIERCATEGORYID = 'productSupplierCategoryId'
}

export type OrganisationSuppliersCategoriesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationSuppliersCategoriesSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationSuppliersCategoriesBoolExp;
};

/** unique or primary key constraints on table "organisation_suppliers" */
export enum OrganisationSuppliersConstraint {
  /** unique or primary key constraint on columns "id" */
  ORGANISATION_SUPPLIERS_PKEY1 = 'organisation_suppliers_pkey1',
  /** unique or primary key constraint on columns "organisation_id", "public_id" */
  ORGANISATION_SUPPLIERS_PUBLIC_ID_ORGANISATION_ID_KEY = 'organisation_suppliers_public_id_organisation_id_key',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  ORGANISATION_SUPPLIERS_REMOTE_ID_ORGANISATION_ID_ACTIVE_UNIQUE = 'organisation_suppliers_remote_id_organisation_id_active_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type OrganisationSuppliersDeleteAtPathInput = {
  address?: InputMaybe<Array<Scalars['String']['input']>>;
  files?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type OrganisationSuppliersDeleteElemInput = {
  address?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type OrganisationSuppliersDeleteKeyInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "organisation_suppliers" */
export type OrganisationSuppliersIncInput = {
  publicId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organisation_suppliers" */
export type OrganisationSuppliersInsertInput = {
  address?: InputMaybe<Scalars['jsonb']['input']>;
  agreements?: InputMaybe<AgreementsArrRelInsertInput>;
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customFieldValues?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<DocumentsArrRelInsertInput>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  engagements?: InputMaybe<EngagementsArrRelInsertInput>;
  entityBankDetails?: InputMaybe<EntityBankDetailsArrRelInsertInput>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalRiskScore?: InputMaybe<ExternalRiskScoresObjRelInsertInput>;
  externalRiskScoreId?: InputMaybe<Scalars['uuid']['input']>;
  external_contacts?: InputMaybe<ExternalContactsArrRelInsertInput>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internalContacts?: InputMaybe<InternalContactsArrRelInsertInput>;
  isContinuousMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPerson?: InputMaybe<Scalars['Boolean']['input']>;
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  isReseller?: InputMaybe<Scalars['Boolean']['input']>;
  lastAssessmentDate?: InputMaybe<Scalars['timestamptz']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierBrandId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierProfiles?: InputMaybe<OrganisationSupplierProfilesArrRelInsertInput>;
  organisation_products_and_services?: InputMaybe<OrganisationProductsAndServicesArrRelInsertInput>;
  organisation_supplier_brand?: InputMaybe<OrganisationSuppliersBrandsObjRelInsertInput>;
  organisation_supplier_tags?: InputMaybe<OrganisationSupplierTagsArrRelInsertInput>;
  organisation_suppliers_categories?: InputMaybe<OrganisationSuppliersCategoriesArrRelInsertInput>;
  organisation_suppliers_requests?: InputMaybe<RequestsArrRelInsertInput>;
  paymentMethod?: InputMaybe<PaymentMethodsObjRelInsertInput>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentTerms?: InputMaybe<PaymentTermsObjRelInsertInput>;
  paymentTermsId?: InputMaybe<Scalars['uuid']['input']>;
  publicId?: InputMaybe<Scalars['Int']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  remoteLink?: InputMaybe<Scalars['String']['input']>;
  rfx_suppliers?: InputMaybe<RfxSuppliersArrRelInsertInput>;
  risks?: InputMaybe<RisksArrRelInsertInput>;
  state?: InputMaybe<OrganisationSupplierStateEnum>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  terminalCategoryId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type OrganisationSuppliersMaxFields = {
  __typename?: 'organisation_suppliers_max_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalLink: Maybe<Scalars['String']['output']>;
  externalRiskScoreId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  lastAssessmentDate: Maybe<Scalars['timestamptz']['output']>;
  legalName: Maybe<Scalars['String']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierBrandId: Maybe<Scalars['uuid']['output']>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  paymentTermsId: Maybe<Scalars['uuid']['output']>;
  publicId: Maybe<Scalars['Int']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  remoteLink: Maybe<Scalars['String']['output']>;
  taxNumber: Maybe<Scalars['String']['output']>;
  terminalCategoryId: Maybe<Scalars['uuid']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "organisation_suppliers" */
export type OrganisationSuppliersMaxOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  externalLink?: InputMaybe<OrderBy>;
  externalRiskScoreId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastAssessmentDate?: InputMaybe<OrderBy>;
  legalName?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  organisationSupplierBrandId?: InputMaybe<OrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  paymentTermsId?: InputMaybe<OrderBy>;
  publicId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  remoteLink?: InputMaybe<OrderBy>;
  taxNumber?: InputMaybe<OrderBy>;
  terminalCategoryId?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type OrganisationSuppliersMinFields = {
  __typename?: 'organisation_suppliers_min_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalLink: Maybe<Scalars['String']['output']>;
  externalRiskScoreId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  lastAssessmentDate: Maybe<Scalars['timestamptz']['output']>;
  legalName: Maybe<Scalars['String']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierBrandId: Maybe<Scalars['uuid']['output']>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  paymentTermsId: Maybe<Scalars['uuid']['output']>;
  publicId: Maybe<Scalars['Int']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  remoteLink: Maybe<Scalars['String']['output']>;
  taxNumber: Maybe<Scalars['String']['output']>;
  terminalCategoryId: Maybe<Scalars['uuid']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "organisation_suppliers" */
export type OrganisationSuppliersMinOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  externalLink?: InputMaybe<OrderBy>;
  externalRiskScoreId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastAssessmentDate?: InputMaybe<OrderBy>;
  legalName?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  organisationSupplierBrandId?: InputMaybe<OrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  paymentTermsId?: InputMaybe<OrderBy>;
  publicId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  remoteLink?: InputMaybe<OrderBy>;
  taxNumber?: InputMaybe<OrderBy>;
  terminalCategoryId?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "organisation_suppliers" */
export type OrganisationSuppliersMutationResponse = {
  __typename?: 'organisation_suppliers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationSuppliers>;
};

/** input type for inserting object relation for remote table "organisation_suppliers" */
export type OrganisationSuppliersObjRelInsertInput = {
  data: OrganisationSuppliersInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationSuppliersOnConflict>;
};

/** on_conflict condition type for table "organisation_suppliers" */
export type OrganisationSuppliersOnConflict = {
  constraint: OrganisationSuppliersConstraint;
  update_columns: Array<OrganisationSuppliersUpdateColumn>;
  where?: InputMaybe<OrganisationSuppliersBoolExp>;
};

/** Ordering options when selecting data from "organisation_suppliers". */
export type OrganisationSuppliersOrderBy = {
  address?: InputMaybe<OrderBy>;
  agreements_aggregate?: InputMaybe<AgreementsAggregateOrderBy>;
  archivedBy?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateOrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  documents_aggregate?: InputMaybe<DocumentsAggregateOrderBy>;
  embedding?: InputMaybe<OrderBy>;
  engagements_aggregate?: InputMaybe<EngagementsAggregateOrderBy>;
  entityBankDetails_aggregate?: InputMaybe<EntityBankDetailsAggregateOrderBy>;
  externalLink?: InputMaybe<OrderBy>;
  externalRiskScore?: InputMaybe<ExternalRiskScoresOrderBy>;
  externalRiskScoreId?: InputMaybe<OrderBy>;
  external_contacts_aggregate?: InputMaybe<ExternalContactsAggregateOrderBy>;
  files?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  internalContacts_aggregate?: InputMaybe<InternalContactsAggregateOrderBy>;
  isContinuousMonitoringEnabled?: InputMaybe<OrderBy>;
  isPerson?: InputMaybe<OrderBy>;
  isPreferred?: InputMaybe<OrderBy>;
  isReseller?: InputMaybe<OrderBy>;
  lastAssessmentDate?: InputMaybe<OrderBy>;
  legalName?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsOrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  organisationSupplierBrandId?: InputMaybe<OrderBy>;
  organisationSupplierProfiles_aggregate?: InputMaybe<OrganisationSupplierProfilesAggregateOrderBy>;
  organisation_products_and_services_aggregate?: InputMaybe<OrganisationProductsAndServicesAggregateOrderBy>;
  organisation_supplier_brand?: InputMaybe<OrganisationSuppliersBrandsOrderBy>;
  organisation_supplier_state?: InputMaybe<OrganisationSupplierStateOrderBy>;
  organisation_supplier_tags_aggregate?: InputMaybe<OrganisationSupplierTagsAggregateOrderBy>;
  organisation_suppliers_categories_aggregate?: InputMaybe<OrganisationSuppliersCategoriesAggregateOrderBy>;
  organisation_suppliers_requests_aggregate?: InputMaybe<RequestsAggregateOrderBy>;
  paymentMethod?: InputMaybe<PaymentMethodsOrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  paymentTerms?: InputMaybe<PaymentTermsOrderBy>;
  paymentTermsId?: InputMaybe<OrderBy>;
  publicId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  remoteLink?: InputMaybe<OrderBy>;
  rfx_suppliers_aggregate?: InputMaybe<RfxSuppliersAggregateOrderBy>;
  risks_aggregate?: InputMaybe<RisksAggregateOrderBy>;
  state?: InputMaybe<OrderBy>;
  taxNumber?: InputMaybe<OrderBy>;
  terminalCategoryId?: InputMaybe<OrderBy>;
  totalSpend?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisation_suppliers */
export type OrganisationSuppliersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type OrganisationSuppliersPrependInput = {
  address?: InputMaybe<Scalars['jsonb']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "organisation_suppliers" */
export enum OrganisationSuppliersSelectColumn {
  /** column name */
  ADDRESS = 'address',
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EMBEDDING = 'embedding',
  /** column name */
  EXTERNALLINK = 'externalLink',
  /** column name */
  EXTERNALRISKSCOREID = 'externalRiskScoreId',
  /** column name */
  FILES = 'files',
  /** column name */
  ID = 'id',
  /** column name */
  ISCONTINUOUSMONITORINGENABLED = 'isContinuousMonitoringEnabled',
  /** column name */
  ISPERSON = 'isPerson',
  /** column name */
  ISPREFERRED = 'isPreferred',
  /** column name */
  ISRESELLER = 'isReseller',
  /** column name */
  LASTASSESSMENTDATE = 'lastAssessmentDate',
  /** column name */
  LEGALNAME = 'legalName',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  ORGANISATIONSUPPLIERBRANDID = 'organisationSupplierBrandId',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTERMSID = 'paymentTermsId',
  /** column name */
  PUBLICID = 'publicId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  REMOTELINK = 'remoteLink',
  /** column name */
  STATE = 'state',
  /** column name */
  TAXNUMBER = 'taxNumber',
  /** column name */
  TERMINALCATEGORYID = 'terminalCategoryId',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEBSITE = 'website'
}

/** select "organisation_suppliers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organisation_suppliers" */
export enum OrganisationSuppliersSelectColumnOrganisationSuppliersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISCONTINUOUSMONITORINGENABLED = 'isContinuousMonitoringEnabled',
  /** column name */
  ISPERSON = 'isPerson',
  /** column name */
  ISPREFERRED = 'isPreferred',
  /** column name */
  ISRESELLER = 'isReseller'
}

/** select "organisation_suppliers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organisation_suppliers" */
export enum OrganisationSuppliersSelectColumnOrganisationSuppliersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISCONTINUOUSMONITORINGENABLED = 'isContinuousMonitoringEnabled',
  /** column name */
  ISPERSON = 'isPerson',
  /** column name */
  ISPREFERRED = 'isPreferred',
  /** column name */
  ISRESELLER = 'isReseller'
}

/** input type for updating data in table "organisation_suppliers" */
export type OrganisationSuppliersSetInput = {
  address?: InputMaybe<Scalars['jsonb']['input']>;
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embedding?: InputMaybe<Scalars['vector']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  externalRiskScoreId?: InputMaybe<Scalars['uuid']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isContinuousMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPerson?: InputMaybe<Scalars['Boolean']['input']>;
  isPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  isReseller?: InputMaybe<Scalars['Boolean']['input']>;
  lastAssessmentDate?: InputMaybe<Scalars['timestamptz']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierBrandId?: InputMaybe<Scalars['uuid']['input']>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentTermsId?: InputMaybe<Scalars['uuid']['input']>;
  publicId?: InputMaybe<Scalars['Int']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  remoteLink?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<OrganisationSupplierStateEnum>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  terminalCategoryId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type OrganisationSuppliersStddevFields = {
  __typename?: 'organisation_suppliers_stddev_fields';
  publicId: Maybe<Scalars['Float']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** order by stddev() on columns of table "organisation_suppliers" */
export type OrganisationSuppliersStddevOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type OrganisationSuppliersStddevPopFields = {
  __typename?: 'organisation_suppliers_stddev_pop_fields';
  publicId: Maybe<Scalars['Float']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** order by stddev_pop() on columns of table "organisation_suppliers" */
export type OrganisationSuppliersStddevPopOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type OrganisationSuppliersStddevSampFields = {
  __typename?: 'organisation_suppliers_stddev_samp_fields';
  publicId: Maybe<Scalars['Float']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** order by stddev_samp() on columns of table "organisation_suppliers" */
export type OrganisationSuppliersStddevSampOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type OrganisationSuppliersSumFields = {
  __typename?: 'organisation_suppliers_sum_fields';
  publicId: Maybe<Scalars['Int']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "organisation_suppliers" */
export type OrganisationSuppliersSumOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** update columns of table "organisation_suppliers" */
export enum OrganisationSuppliersUpdateColumn {
  /** column name */
  ADDRESS = 'address',
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EMBEDDING = 'embedding',
  /** column name */
  EXTERNALLINK = 'externalLink',
  /** column name */
  EXTERNALRISKSCOREID = 'externalRiskScoreId',
  /** column name */
  FILES = 'files',
  /** column name */
  ID = 'id',
  /** column name */
  ISCONTINUOUSMONITORINGENABLED = 'isContinuousMonitoringEnabled',
  /** column name */
  ISPERSON = 'isPerson',
  /** column name */
  ISPREFERRED = 'isPreferred',
  /** column name */
  ISRESELLER = 'isReseller',
  /** column name */
  LASTASSESSMENTDATE = 'lastAssessmentDate',
  /** column name */
  LEGALNAME = 'legalName',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  ORGANISATIONSUPPLIERBRANDID = 'organisationSupplierBrandId',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTERMSID = 'paymentTermsId',
  /** column name */
  PUBLICID = 'publicId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  REMOTELINK = 'remoteLink',
  /** column name */
  STATE = 'state',
  /** column name */
  TAXNUMBER = 'taxNumber',
  /** column name */
  TERMINALCATEGORYID = 'terminalCategoryId',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEBSITE = 'website'
}

export type OrganisationSuppliersUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<OrganisationSuppliersAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<OrganisationSuppliersDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<OrganisationSuppliersDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<OrganisationSuppliersDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OrganisationSuppliersIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<OrganisationSuppliersPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationSuppliersSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationSuppliersBoolExp;
};

/** aggregate var_pop on columns */
export type OrganisationSuppliersVarPopFields = {
  __typename?: 'organisation_suppliers_var_pop_fields';
  publicId: Maybe<Scalars['Float']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** order by var_pop() on columns of table "organisation_suppliers" */
export type OrganisationSuppliersVarPopOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type OrganisationSuppliersVarSampFields = {
  __typename?: 'organisation_suppliers_var_samp_fields';
  publicId: Maybe<Scalars['Float']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** order by var_samp() on columns of table "organisation_suppliers" */
export type OrganisationSuppliersVarSampOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type OrganisationSuppliersVarianceFields = {
  __typename?: 'organisation_suppliers_variance_fields';
  publicId: Maybe<Scalars['Float']['output']>;
  /** Total spend from engagements and agreements (with FX rates and payment interval multipliers) */
  totalSpend: Maybe<Scalars['numeric']['output']>;
};

/** order by variance() on columns of table "organisation_suppliers" */
export type OrganisationSuppliersVarianceOrderBy = {
  publicId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "organisations" */
export type Organisations = {
  __typename?: 'organisations';
  /** An array relationship */
  bank_details: Array<BankDetails>;
  /** An aggregate relationship */
  bank_details_aggregate: BankDetailsAggregate;
  domain: Scalars['String']['output'];
  /** URL of dark logo to be used in the emails. Has to PNG 2x size */
  email_logo_url_dark: Maybe<Scalars['String']['output']>;
  externalDomains: Maybe<Array<Scalars['String']['output']>>;
  hasDirectorySyncEnabled: Maybe<Scalars['Boolean']['output']>;
  hasSsoEnabled: Maybe<Scalars['Boolean']['output']>;
  /** URL to a square icon. To be used on a light background */
  iconUrlLight: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isQa: Scalars['Boolean']['output'];
  languagePreference: Maybe<Scalars['availableLocale']['output']>;
  /** URL to a horizontal logo. To be used on a dark background */
  logoUrlDark: Maybe<Scalars['String']['output']>;
  /** URL to a horizontal logo. To be used on a light background */
  logoUrlLight: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  organisationCurrencies: Array<OrganisationFxRates>;
  /** An aggregate relationship */
  organisationCurrencies_aggregate: OrganisationFxRatesAggregate;
  /** An array relationship */
  organisation_products_and_services: Array<OrganisationProductsAndServices>;
  /** An aggregate relationship */
  organisation_products_and_services_aggregate: OrganisationProductsAndServicesAggregate;
  /** An array relationship */
  organisation_suppliers: Array<OrganisationSuppliers>;
  /** An aggregate relationship */
  organisation_suppliers_aggregate: OrganisationSuppliersAggregate;
  /** An array relationship */
  requests: Array<Requests>;
  /** An aggregate relationship */
  requests_aggregate: RequestsAggregate;
  ssoDomains: Maybe<Array<Scalars['String']['output']>>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: UsersAggregate;
  website: Scalars['String']['output'];
  /** An array relationship */
  workflows: Array<Workflows>;
  workosOrganisationId: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "organisations" */
export type OrganisationsBankDetailsArgs = {
  distinct_on: InputMaybe<Array<BankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BankDetailsOrderBy>>;
  where: InputMaybe<BankDetailsBoolExp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsBankDetailsAggregateArgs = {
  distinct_on: InputMaybe<Array<BankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BankDetailsOrderBy>>;
  where: InputMaybe<BankDetailsBoolExp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsOrganisationCurrenciesArgs = {
  distinct_on: InputMaybe<Array<OrganisationFxRatesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationFxRatesOrderBy>>;
  where: InputMaybe<OrganisationFxRatesBoolExp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsOrganisationCurrenciesAggregateArgs = {
  distinct_on: InputMaybe<Array<OrganisationFxRatesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationFxRatesOrderBy>>;
  where: InputMaybe<OrganisationFxRatesBoolExp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsOrganisationProductsAndServicesArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsOrganisationProductsAndServicesAggregateArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsOrganisationSuppliersArgs = {
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsOrganisationSuppliersAggregateArgs = {
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsRequestsArgs = {
  distinct_on: InputMaybe<Array<RequestsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestsOrderBy>>;
  where: InputMaybe<RequestsBoolExp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsRequestsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestsOrderBy>>;
  where: InputMaybe<RequestsBoolExp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsUsersArgs = {
  distinct_on: InputMaybe<Array<UsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<UsersOrderBy>>;
  where: InputMaybe<UsersBoolExp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsUsersAggregateArgs = {
  distinct_on: InputMaybe<Array<UsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<UsersOrderBy>>;
  where: InputMaybe<UsersBoolExp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsWorkflowsArgs = {
  distinct_on: InputMaybe<Array<WorkflowsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<WorkflowsOrderBy>>;
  where: InputMaybe<WorkflowsBoolExp>;
};

/** Boolean expression to filter rows from the table "organisations". All fields are combined with a logical 'AND'. */
export type OrganisationsBoolExp = {
  _and?: InputMaybe<Array<OrganisationsBoolExp>>;
  _not?: InputMaybe<OrganisationsBoolExp>;
  _or?: InputMaybe<Array<OrganisationsBoolExp>>;
  bank_details?: InputMaybe<BankDetailsBoolExp>;
  bank_details_aggregate?: InputMaybe<BankDetailsAggregateBoolExp>;
  domain?: InputMaybe<StringComparisonExp>;
  email_logo_url_dark?: InputMaybe<StringComparisonExp>;
  externalDomains?: InputMaybe<StringArrayComparisonExp>;
  hasDirectorySyncEnabled?: InputMaybe<BooleanComparisonExp>;
  hasSsoEnabled?: InputMaybe<BooleanComparisonExp>;
  iconUrlLight?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isQa?: InputMaybe<BooleanComparisonExp>;
  languagePreference?: InputMaybe<StringComparisonExp>;
  logoUrlDark?: InputMaybe<StringComparisonExp>;
  logoUrlLight?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationCurrencies?: InputMaybe<OrganisationFxRatesBoolExp>;
  organisationCurrencies_aggregate?: InputMaybe<OrganisationFxRatesAggregateBoolExp>;
  organisation_products_and_services?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  organisation_products_and_services_aggregate?: InputMaybe<OrganisationProductsAndServicesAggregateBoolExp>;
  organisation_suppliers?: InputMaybe<OrganisationSuppliersBoolExp>;
  organisation_suppliers_aggregate?: InputMaybe<OrganisationSuppliersAggregateBoolExp>;
  requests?: InputMaybe<RequestsBoolExp>;
  requests_aggregate?: InputMaybe<RequestsAggregateBoolExp>;
  ssoDomains?: InputMaybe<StringArrayComparisonExp>;
  users?: InputMaybe<UsersBoolExp>;
  users_aggregate?: InputMaybe<UsersAggregateBoolExp>;
  website?: InputMaybe<StringComparisonExp>;
  workflows?: InputMaybe<WorkflowsBoolExp>;
  workosOrganisationId?: InputMaybe<StringComparisonExp>;
};

/** response of any mutation on the table "organisations" */
export type OrganisationsMutationResponse = {
  __typename?: 'organisations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisations>;
};

/** Ordering options when selecting data from "organisations". */
export type OrganisationsOrderBy = {
  bank_details_aggregate?: InputMaybe<BankDetailsAggregateOrderBy>;
  domain?: InputMaybe<OrderBy>;
  email_logo_url_dark?: InputMaybe<OrderBy>;
  externalDomains?: InputMaybe<OrderBy>;
  hasDirectorySyncEnabled?: InputMaybe<OrderBy>;
  hasSsoEnabled?: InputMaybe<OrderBy>;
  iconUrlLight?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isQa?: InputMaybe<OrderBy>;
  languagePreference?: InputMaybe<OrderBy>;
  logoUrlDark?: InputMaybe<OrderBy>;
  logoUrlLight?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationCurrencies_aggregate?: InputMaybe<OrganisationFxRatesAggregateOrderBy>;
  organisation_products_and_services_aggregate?: InputMaybe<OrganisationProductsAndServicesAggregateOrderBy>;
  organisation_suppliers_aggregate?: InputMaybe<OrganisationSuppliersAggregateOrderBy>;
  requests_aggregate?: InputMaybe<RequestsAggregateOrderBy>;
  ssoDomains?: InputMaybe<OrderBy>;
  users_aggregate?: InputMaybe<UsersAggregateOrderBy>;
  website?: InputMaybe<OrderBy>;
  workflows_aggregate?: InputMaybe<WorkflowsAggregateOrderBy>;
  workosOrganisationId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organisations */
export type OrganisationsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisations" */
export enum OrganisationsSelectColumn {
  /** column name */
  DOMAIN = 'domain',
  /** column name */
  EMAIL_LOGO_URL_DARK = 'email_logo_url_dark',
  /** column name */
  EXTERNALDOMAINS = 'externalDomains',
  /** column name */
  HASDIRECTORYSYNCENABLED = 'hasDirectorySyncEnabled',
  /** column name */
  HASSSOENABLED = 'hasSsoEnabled',
  /** column name */
  ICONURLLIGHT = 'iconUrlLight',
  /** column name */
  ID = 'id',
  /** column name */
  ISQA = 'isQa',
  /** column name */
  LANGUAGEPREFERENCE = 'languagePreference',
  /** column name */
  LOGOURLDARK = 'logoUrlDark',
  /** column name */
  LOGOURLLIGHT = 'logoUrlLight',
  /** column name */
  NAME = 'name',
  /** column name */
  SSODOMAINS = 'ssoDomains',
  /** column name */
  WEBSITE = 'website',
  /** column name */
  WORKOSORGANISATIONID = 'workosOrganisationId'
}

/** input type for updating data in table "organisations" */
export type OrganisationsSetInput = {
  /** URL of dark logo to be used in the emails. Has to PNG 2x size */
  email_logo_url_dark?: InputMaybe<Scalars['String']['input']>;
  externalDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  hasDirectorySyncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  hasSsoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL to a square icon. To be used on a light background */
  iconUrlLight?: InputMaybe<Scalars['String']['input']>;
  isQa?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL to a horizontal logo. To be used on a dark background */
  logoUrlDark?: InputMaybe<Scalars['String']['input']>;
  /** URL to a horizontal logo. To be used on a light background */
  logoUrlLight?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ssoDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  workosOrganisationId?: InputMaybe<Scalars['String']['input']>;
};

export type OrganisationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganisationsBoolExp;
};

/** This table holds a users delegates for tasks when the user has marked themselves as out of office */
export type OutOfOfficeDelegations = {
  __typename?: 'out_of_office_delegations';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  delegate: Users;
  delegateId: Scalars['uuid']['output'];
  delegatorId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "out_of_office_delegations". All fields are combined with a logical 'AND'. */
export type OutOfOfficeDelegationsBoolExp = {
  _and?: InputMaybe<Array<OutOfOfficeDelegationsBoolExp>>;
  _not?: InputMaybe<OutOfOfficeDelegationsBoolExp>;
  _or?: InputMaybe<Array<OutOfOfficeDelegationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  delegate?: InputMaybe<UsersBoolExp>;
  delegateId?: InputMaybe<UuidComparisonExp>;
  delegatorId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "out_of_office_delegations" */
export enum OutOfOfficeDelegationsConstraint {
  /** unique or primary key constraint on columns "id" */
  OUT_OF_OFFICE_DELEGATIONS_PKEY = 'out_of_office_delegations_pkey'
}

/** input type for inserting data into table "out_of_office_delegations" */
export type OutOfOfficeDelegationsInsertInput = {
  delegate?: InputMaybe<UsersObjRelInsertInput>;
  delegateId?: InputMaybe<Scalars['uuid']['input']>;
  delegatorId?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "out_of_office_delegations" */
export type OutOfOfficeDelegationsMutationResponse = {
  __typename?: 'out_of_office_delegations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OutOfOfficeDelegations>;
};

/** on_conflict condition type for table "out_of_office_delegations" */
export type OutOfOfficeDelegationsOnConflict = {
  constraint: OutOfOfficeDelegationsConstraint;
  update_columns: Array<OutOfOfficeDelegationsUpdateColumn>;
  where?: InputMaybe<OutOfOfficeDelegationsBoolExp>;
};

/** Ordering options when selecting data from "out_of_office_delegations". */
export type OutOfOfficeDelegationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  delegate?: InputMaybe<UsersOrderBy>;
  delegateId?: InputMaybe<OrderBy>;
  delegatorId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
};

/** select columns of table "out_of_office_delegations" */
export enum OutOfOfficeDelegationsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELEGATEID = 'delegateId',
  /** column name */
  DELEGATORID = 'delegatorId',
  /** column name */
  ID = 'id'
}

/** Streaming cursor of the table "out_of_office_delegations" */
export type OutOfOfficeDelegationsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: OutOfOfficeDelegationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OutOfOfficeDelegationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  delegateId?: InputMaybe<Scalars['uuid']['input']>;
  delegatorId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "out_of_office_delegations" (current role has no relevant permissions) */
export enum OutOfOfficeDelegationsUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

export type PaginateCustomCoreDataOptionsArgs = {
  p_conditions?: InputMaybe<Scalars['jsonb']['input']>;
  p_conjunction?: InputMaybe<Scalars['String']['input']>;
  p_custom_core_data_id?: InputMaybe<Scalars['uuid']['input']>;
  p_dependency_core_data_id?: InputMaybe<Scalars['uuid']['input']>;
  p_dependency_supplier_profile_id?: InputMaybe<Scalars['uuid']['input']>;
  p_depth?: InputMaybe<Scalars['Int']['input']>;
  p_include_archived?: InputMaybe<Scalars['Boolean']['input']>;
  p_limit?: InputMaybe<Scalars['Int']['input']>;
  p_next_cursor?: InputMaybe<Scalars['ltree']['input']>;
  p_prev_cursor?: InputMaybe<Scalars['ltree']['input']>;
  p_search?: InputMaybe<Scalars['String']['input']>;
  p_sort_direction?: InputMaybe<Scalars['String']['input']>;
  p_sort_level?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "pause_reasons" */
export type PauseReasons = {
  __typename?: 'pause_reasons';
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  text: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "pause_reasons". All fields are combined with a logical 'AND'. */
export type PauseReasonsBoolExp = {
  _and?: InputMaybe<Array<PauseReasonsBoolExp>>;
  _not?: InputMaybe<PauseReasonsBoolExp>;
  _or?: InputMaybe<Array<PauseReasonsBoolExp>>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  text?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "pause_reasons" */
export enum PauseReasonsConstraint {
  /** unique or primary key constraint on columns "id" */
  PAUSE_REASONS_PKEY = 'pause_reasons_pkey'
}

/** input type for inserting data into table "pause_reasons" */
export type PauseReasonsInsertInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "pause_reasons" */
export type PauseReasonsMutationResponse = {
  __typename?: 'pause_reasons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PauseReasons>;
};

/** input type for inserting object relation for remote table "pause_reasons" */
export type PauseReasonsObjRelInsertInput = {
  data: PauseReasonsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<PauseReasonsOnConflict>;
};

/** on_conflict condition type for table "pause_reasons" */
export type PauseReasonsOnConflict = {
  constraint: PauseReasonsConstraint;
  update_columns: Array<PauseReasonsUpdateColumn>;
  where?: InputMaybe<PauseReasonsBoolExp>;
};

/** Ordering options when selecting data from "pause_reasons". */
export type PauseReasonsOrderBy = {
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  text?: InputMaybe<OrderBy>;
};

/** select columns of table "pause_reasons" */
export enum PauseReasonsSelectColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  TEXT = 'text'
}

/** Streaming cursor of the table "pause_reasons" */
export type PauseReasonsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PauseReasonsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PauseReasonsStreamCursorValueInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** placeholder for update columns of table "pause_reasons" (current role has no relevant permissions) */
export enum PauseReasonsUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "payment_interval" */
export type PaymentInterval = {
  __typename?: 'payment_interval';
  description: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  financials: Array<Financials>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "payment_interval" */
export type PaymentIntervalFinancialsArgs = {
  distinct_on: InputMaybe<Array<FinancialsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FinancialsOrderBy>>;
  where: InputMaybe<FinancialsBoolExp>;
};

/** Boolean expression to filter rows from the table "payment_interval". All fields are combined with a logical 'AND'. */
export type PaymentIntervalBoolExp = {
  _and?: InputMaybe<Array<PaymentIntervalBoolExp>>;
  _not?: InputMaybe<PaymentIntervalBoolExp>;
  _or?: InputMaybe<Array<PaymentIntervalBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  financials?: InputMaybe<FinancialsBoolExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PaymentIntervalEnum {
  /** Every six months */
  EVERY_SIX_MONTHS = 'EVERY_SIX_MONTHS',
  /** Every two years */
  EVERY_TWO_YEARS = 'EVERY_TWO_YEARS',
  /** Month */
  MONTH = 'MONTH',
  /** Multi year */
  MULTI_YEAR = 'MULTI_YEAR',
  /** One off */
  ONE_OFF = 'ONE_OFF',
  /** Quarter */
  QUARTER = 'QUARTER',
  /** Weekly */
  WEEK = 'WEEK',
  /** Year */
  YEAR = 'YEAR'
}

/** Boolean expression to compare columns of type "payment_interval_enum". All fields are combined with logical 'AND'. */
export type PaymentIntervalEnumComparisonExp = {
  _eq?: InputMaybe<PaymentIntervalEnum>;
  _in?: InputMaybe<Array<PaymentIntervalEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<PaymentIntervalEnum>;
  _nin?: InputMaybe<Array<PaymentIntervalEnum>>;
};

/** Ordering options when selecting data from "payment_interval". */
export type PaymentIntervalOrderBy = {
  description?: InputMaybe<OrderBy>;
  financials_aggregate?: InputMaybe<FinancialsAggregateOrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "payment_interval" */
export enum PaymentIntervalSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** columns and relationships of "payment_methods" */
export type PaymentMethods = {
  __typename?: 'payment_methods';
  archivedBy: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "payment_methods" */
export type PaymentMethodsAggregate = {
  __typename?: 'payment_methods_aggregate';
  aggregate: Maybe<PaymentMethodsAggregateFields>;
  nodes: Array<PaymentMethods>;
};

/** aggregate fields of "payment_methods" */
export type PaymentMethodsAggregateFields = {
  __typename?: 'payment_methods_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<PaymentMethodsMaxFields>;
  min: Maybe<PaymentMethodsMinFields>;
};


/** aggregate fields of "payment_methods" */
export type PaymentMethodsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<PaymentMethodsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "payment_methods". All fields are combined with a logical 'AND'. */
export type PaymentMethodsBoolExp = {
  _and?: InputMaybe<Array<PaymentMethodsBoolExp>>;
  _not?: InputMaybe<PaymentMethodsBoolExp>;
  _or?: InputMaybe<Array<PaymentMethodsBoolExp>>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "payment_methods" */
export enum PaymentMethodsConstraint {
  /** unique or primary key constraint on columns "id" */
  PAYMENT_METHODS_PKEY = 'payment_methods_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  PAYMENT_METHODS_REMOTE_ID_ORGANISATION_ID_KEY = 'payment_methods_remote_id_organisation_id_key'
}

/** input type for inserting data into table "payment_methods" */
export type PaymentMethodsInsertInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PaymentMethodsMaxFields = {
  __typename?: 'payment_methods_max_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type PaymentMethodsMinFields = {
  __typename?: 'payment_methods_min_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "payment_methods" */
export type PaymentMethodsMutationResponse = {
  __typename?: 'payment_methods_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentMethods>;
};

/** input type for inserting object relation for remote table "payment_methods" */
export type PaymentMethodsObjRelInsertInput = {
  data: PaymentMethodsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<PaymentMethodsOnConflict>;
};

/** on_conflict condition type for table "payment_methods" */
export type PaymentMethodsOnConflict = {
  constraint: PaymentMethodsConstraint;
  update_columns: Array<PaymentMethodsUpdateColumn>;
  where?: InputMaybe<PaymentMethodsBoolExp>;
};

/** Ordering options when selecting data from "payment_methods". */
export type PaymentMethodsOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  coreData?: InputMaybe<CoreDataOrderBy>;
  coreDataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_methods */
export type PaymentMethodsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "payment_methods" */
export enum PaymentMethodsSelectColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  COREDATAID = 'coreDataId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "payment_methods" */
export type PaymentMethodsSetInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "payment_methods" */
export enum PaymentMethodsUpdateColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type PaymentMethodsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentMethodsSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentMethodsBoolExp;
};

/** columns and relationships of "payment_terms" */
export type PaymentTerms = {
  __typename?: 'payment_terms';
  archivedBy: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "payment_terms" */
export type PaymentTermsAggregate = {
  __typename?: 'payment_terms_aggregate';
  aggregate: Maybe<PaymentTermsAggregateFields>;
  nodes: Array<PaymentTerms>;
};

/** aggregate fields of "payment_terms" */
export type PaymentTermsAggregateFields = {
  __typename?: 'payment_terms_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<PaymentTermsMaxFields>;
  min: Maybe<PaymentTermsMinFields>;
};


/** aggregate fields of "payment_terms" */
export type PaymentTermsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<PaymentTermsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "payment_terms". All fields are combined with a logical 'AND'. */
export type PaymentTermsBoolExp = {
  _and?: InputMaybe<Array<PaymentTermsBoolExp>>;
  _not?: InputMaybe<PaymentTermsBoolExp>;
  _or?: InputMaybe<Array<PaymentTermsBoolExp>>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "payment_terms" */
export enum PaymentTermsConstraint {
  /** unique or primary key constraint on columns "id" */
  PAYMENT_TERMS_PKEY = 'payment_terms_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  PAYMENT_TERMS_REMOTE_ID_ORGANISATION_ID_KEY = 'payment_terms_remote_id_organisation_id_key'
}

/** input type for inserting data into table "payment_terms" */
export type PaymentTermsInsertInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PaymentTermsMaxFields = {
  __typename?: 'payment_terms_max_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type PaymentTermsMinFields = {
  __typename?: 'payment_terms_min_fields';
  archivedBy: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "payment_terms" */
export type PaymentTermsMutationResponse = {
  __typename?: 'payment_terms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PaymentTerms>;
};

/** input type for inserting object relation for remote table "payment_terms" */
export type PaymentTermsObjRelInsertInput = {
  data: PaymentTermsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<PaymentTermsOnConflict>;
};

/** on_conflict condition type for table "payment_terms" */
export type PaymentTermsOnConflict = {
  constraint: PaymentTermsConstraint;
  update_columns: Array<PaymentTermsUpdateColumn>;
  where?: InputMaybe<PaymentTermsBoolExp>;
};

/** Ordering options when selecting data from "payment_terms". */
export type PaymentTermsOrderBy = {
  archivedBy?: InputMaybe<OrderBy>;
  coreData?: InputMaybe<CoreDataOrderBy>;
  coreDataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: payment_terms */
export type PaymentTermsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "payment_terms" */
export enum PaymentTermsSelectColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  COREDATAID = 'coreDataId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "payment_terms" */
export type PaymentTermsSetInput = {
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "payment_terms" */
export enum PaymentTermsUpdateColumn {
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type PaymentTermsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaymentTermsSetInput>;
  /** filter the rows which have to be updated */
  where: PaymentTermsBoolExp;
};

/** columns and relationships of "product_catalogue_access_approvers" */
export type ProductCatalogueAccessApprovers = {
  __typename?: 'product_catalogue_access_approvers';
  /** An object relationship */
  group: Maybe<Groups>;
  groupId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  productCatalogueEntryId: Scalars['uuid']['output'];
  /** An object relationship */
  product_catalogue_entry: ProductCatalogueEntries;
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** order by aggregate values of table "product_catalogue_access_approvers" */
export type ProductCatalogueAccessApproversAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProductCatalogueAccessApproversMaxOrderBy>;
  min?: InputMaybe<ProductCatalogueAccessApproversMinOrderBy>;
};

/** input type for inserting array relation for remote table "product_catalogue_access_approvers" */
export type ProductCatalogueAccessApproversArrRelInsertInput = {
  data: Array<ProductCatalogueAccessApproversInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductCatalogueAccessApproversOnConflict>;
};

/** Boolean expression to filter rows from the table "product_catalogue_access_approvers". All fields are combined with a logical 'AND'. */
export type ProductCatalogueAccessApproversBoolExp = {
  _and?: InputMaybe<Array<ProductCatalogueAccessApproversBoolExp>>;
  _not?: InputMaybe<ProductCatalogueAccessApproversBoolExp>;
  _or?: InputMaybe<Array<ProductCatalogueAccessApproversBoolExp>>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  productCatalogueEntryId?: InputMaybe<UuidComparisonExp>;
  product_catalogue_entry?: InputMaybe<ProductCatalogueEntriesBoolExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "product_catalogue_access_approvers" */
export enum ProductCatalogueAccessApproversConstraint {
  /** unique or primary key constraint on columns "id" */
  PRODUCT_CATALOGUE_ACCESS_APPROVERS_PKEY = 'product_catalogue_access_approvers_pkey',
  /** unique or primary key constraint on columns "product_catalogue_entry_id", "group_id" */
  UNIQUE_ACCESS_APPROVER_GROUP_ENTRY = 'unique_access_approver_group_entry',
  /** unique or primary key constraint on columns "user_id", "product_catalogue_entry_id" */
  UNIQUE_ACCESS_APPROVER_USER_ENTRY = 'unique_access_approver_user_entry'
}

/** input type for inserting data into table "product_catalogue_access_approvers" */
export type ProductCatalogueAccessApproversInsertInput = {
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  productCatalogueEntryId?: InputMaybe<Scalars['uuid']['input']>;
  product_catalogue_entry?: InputMaybe<ProductCatalogueEntriesObjRelInsertInput>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "product_catalogue_access_approvers" */
export type ProductCatalogueAccessApproversMaxOrderBy = {
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  productCatalogueEntryId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "product_catalogue_access_approvers" */
export type ProductCatalogueAccessApproversMinOrderBy = {
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  productCatalogueEntryId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "product_catalogue_access_approvers" */
export type ProductCatalogueAccessApproversMutationResponse = {
  __typename?: 'product_catalogue_access_approvers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProductCatalogueAccessApprovers>;
};

/** on_conflict condition type for table "product_catalogue_access_approvers" */
export type ProductCatalogueAccessApproversOnConflict = {
  constraint: ProductCatalogueAccessApproversConstraint;
  update_columns: Array<ProductCatalogueAccessApproversUpdateColumn>;
  where?: InputMaybe<ProductCatalogueAccessApproversBoolExp>;
};

/** Ordering options when selecting data from "product_catalogue_access_approvers". */
export type ProductCatalogueAccessApproversOrderBy = {
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  productCatalogueEntryId?: InputMaybe<OrderBy>;
  product_catalogue_entry?: InputMaybe<ProductCatalogueEntriesOrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** select columns of table "product_catalogue_access_approvers" */
export enum ProductCatalogueAccessApproversSelectColumn {
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  PRODUCTCATALOGUEENTRYID = 'productCatalogueEntryId',
  /** column name */
  USERID = 'userId'
}

/** placeholder for update columns of table "product_catalogue_access_approvers" (current role has no relevant permissions) */
export enum ProductCatalogueAccessApproversUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "product_catalogue_entries" */
export type ProductCatalogueEntries = {
  __typename?: 'product_catalogue_entries';
  accessInstructions: Maybe<Scalars['String']['output']>;
  accessType: Scalars['String']['output'];
  accessUrl: Maybe<Scalars['String']['output']>;
  accessWorkflowId: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  externalEmail: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  organisationProductsAndServicesBrandId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_products_and_services_brand: OrganisationProductsAndServicesBrands;
  /** An array relationship */
  product_catalogue_access_approvers: Array<ProductCatalogueAccessApprovers>;
  showInCatalogue: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  workflow: Maybe<Workflows>;
};


/** columns and relationships of "product_catalogue_entries" */
export type ProductCatalogueEntriesProductCatalogueAccessApproversArgs = {
  distinct_on: InputMaybe<Array<ProductCatalogueAccessApproversSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductCatalogueAccessApproversOrderBy>>;
  where: InputMaybe<ProductCatalogueAccessApproversBoolExp>;
};

/** Boolean expression to filter rows from the table "product_catalogue_entries". All fields are combined with a logical 'AND'. */
export type ProductCatalogueEntriesBoolExp = {
  _and?: InputMaybe<Array<ProductCatalogueEntriesBoolExp>>;
  _not?: InputMaybe<ProductCatalogueEntriesBoolExp>;
  _or?: InputMaybe<Array<ProductCatalogueEntriesBoolExp>>;
  accessInstructions?: InputMaybe<StringComparisonExp>;
  accessType?: InputMaybe<StringComparisonExp>;
  accessUrl?: InputMaybe<StringComparisonExp>;
  accessWorkflowId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  externalEmail?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationProductsAndServicesBrandId?: InputMaybe<UuidComparisonExp>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
  product_catalogue_access_approvers?: InputMaybe<ProductCatalogueAccessApproversBoolExp>;
  showInCatalogue?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
};

/** unique or primary key constraints on table "product_catalogue_entries" */
export enum ProductCatalogueEntriesConstraint {
  /** unique or primary key constraint on columns "organisation_products_and_services_brand_id" */
  PRODUCT_CATALOGUE_ENTRIES_ORGANISATION_PRODUCTS_AND_SERVICES_BR = 'product_catalogue_entries_organisation_products_and_services_br',
  /** unique or primary key constraint on columns "id" */
  PRODUCT_CATALOGUE_ENTRIES_PKEY = 'product_catalogue_entries_pkey'
}

/** input type for inserting data into table "product_catalogue_entries" */
export type ProductCatalogueEntriesInsertInput = {
  accessInstructions?: InputMaybe<Scalars['String']['input']>;
  accessType?: InputMaybe<Scalars['String']['input']>;
  accessUrl?: InputMaybe<Scalars['String']['input']>;
  accessWorkflowId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  externalEmail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationProductsAndServicesBrandId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsObjRelInsertInput>;
  product_catalogue_access_approvers?: InputMaybe<ProductCatalogueAccessApproversArrRelInsertInput>;
  showInCatalogue?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
};

/** response of any mutation on the table "product_catalogue_entries" */
export type ProductCatalogueEntriesMutationResponse = {
  __typename?: 'product_catalogue_entries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProductCatalogueEntries>;
};

/** input type for inserting object relation for remote table "product_catalogue_entries" */
export type ProductCatalogueEntriesObjRelInsertInput = {
  data: ProductCatalogueEntriesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<ProductCatalogueEntriesOnConflict>;
};

/** on_conflict condition type for table "product_catalogue_entries" */
export type ProductCatalogueEntriesOnConflict = {
  constraint: ProductCatalogueEntriesConstraint;
  update_columns: Array<ProductCatalogueEntriesUpdateColumn>;
  where?: InputMaybe<ProductCatalogueEntriesBoolExp>;
};

/** Ordering options when selecting data from "product_catalogue_entries". */
export type ProductCatalogueEntriesOrderBy = {
  accessInstructions?: InputMaybe<OrderBy>;
  accessType?: InputMaybe<OrderBy>;
  accessUrl?: InputMaybe<OrderBy>;
  accessWorkflowId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  externalEmail?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationProductsAndServicesBrandId?: InputMaybe<OrderBy>;
  organisation_products_and_services_brand?: InputMaybe<OrganisationProductsAndServicesBrandsOrderBy>;
  product_catalogue_access_approvers_aggregate?: InputMaybe<ProductCatalogueAccessApproversAggregateOrderBy>;
  showInCatalogue?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workflow?: InputMaybe<WorkflowsOrderBy>;
};

/** primary key columns input for table: product_catalogue_entries */
export type ProductCatalogueEntriesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "product_catalogue_entries" */
export enum ProductCatalogueEntriesSelectColumn {
  /** column name */
  ACCESSINSTRUCTIONS = 'accessInstructions',
  /** column name */
  ACCESSTYPE = 'accessType',
  /** column name */
  ACCESSURL = 'accessUrl',
  /** column name */
  ACCESSWORKFLOWID = 'accessWorkflowId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  EXTERNALEMAIL = 'externalEmail',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONPRODUCTSANDSERVICESBRANDID = 'organisationProductsAndServicesBrandId',
  /** column name */
  SHOWINCATALOGUE = 'showInCatalogue',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "product_catalogue_entries" */
export type ProductCatalogueEntriesSetInput = {
  accessInstructions?: InputMaybe<Scalars['String']['input']>;
  accessType?: InputMaybe<Scalars['String']['input']>;
  accessUrl?: InputMaybe<Scalars['String']['input']>;
  accessWorkflowId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  externalEmail?: InputMaybe<Scalars['String']['input']>;
  organisationProductsAndServicesBrandId?: InputMaybe<Scalars['uuid']['input']>;
  showInCatalogue?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "product_catalogue_entries" */
export enum ProductCatalogueEntriesUpdateColumn {
  /** column name */
  ACCESSINSTRUCTIONS = 'accessInstructions',
  /** column name */
  ACCESSTYPE = 'accessType',
  /** column name */
  ACCESSURL = 'accessUrl',
  /** column name */
  ACCESSWORKFLOWID = 'accessWorkflowId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  EXTERNALEMAIL = 'externalEmail',
  /** column name */
  ORGANISATIONPRODUCTSANDSERVICESBRANDID = 'organisationProductsAndServicesBrandId',
  /** column name */
  SHOWINCATALOGUE = 'showInCatalogue',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type ProductCatalogueEntriesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductCatalogueEntriesSetInput>;
  /** filter the rows which have to be updated */
  where: ProductCatalogueEntriesBoolExp;
};

/** columns and relationships of "products_and_services" */
export type ProductsAndServices = {
  __typename?: 'products_and_services';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  functionalDescription: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  organisation_products_and_services_brands: Array<OrganisationProductsAndServicesBrands>;
  /** An array relationship */
  products_and_services_categories: Array<ProductsAndServicesCategories>;
  raw: Maybe<Scalars['jsonb']['output']>;
  source: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  supplier: Maybe<Suppliers>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  website: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "products_and_services" */
export type ProductsAndServicesOrganisationProductsAndServicesBrandsArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesBrandsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesBrandsOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
};


/** columns and relationships of "products_and_services" */
export type ProductsAndServicesProductsAndServicesCategoriesArgs = {
  distinct_on: InputMaybe<Array<ProductsAndServicesCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductsAndServicesCategoriesOrderBy>>;
  where: InputMaybe<ProductsAndServicesCategoriesBoolExp>;
};


/** columns and relationships of "products_and_services" */
export type ProductsAndServicesRawArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "products_and_services" */
export type ProductsAndServicesAggregateOrderBy = {
  avg?: InputMaybe<ProductsAndServicesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProductsAndServicesMaxOrderBy>;
  min?: InputMaybe<ProductsAndServicesMinOrderBy>;
  stddev?: InputMaybe<ProductsAndServicesStddevOrderBy>;
  stddev_pop?: InputMaybe<ProductsAndServicesStddevPopOrderBy>;
  stddev_samp?: InputMaybe<ProductsAndServicesStddevSampOrderBy>;
  sum?: InputMaybe<ProductsAndServicesSumOrderBy>;
  var_pop?: InputMaybe<ProductsAndServicesVarPopOrderBy>;
  var_samp?: InputMaybe<ProductsAndServicesVarSampOrderBy>;
  variance?: InputMaybe<ProductsAndServicesVarianceOrderBy>;
};

/** order by avg() on columns of table "products_and_services" */
export type ProductsAndServicesAvgOrderBy = {
  source?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "products_and_services". All fields are combined with a logical 'AND'. */
export type ProductsAndServicesBoolExp = {
  _and?: InputMaybe<Array<ProductsAndServicesBoolExp>>;
  _not?: InputMaybe<ProductsAndServicesBoolExp>;
  _or?: InputMaybe<Array<ProductsAndServicesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  functionalDescription?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  logoUrl?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation_products_and_services_brands?: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
  products_and_services_categories?: InputMaybe<ProductsAndServicesCategoriesBoolExp>;
  raw?: InputMaybe<JsonbComparisonExp>;
  source?: InputMaybe<IntComparisonExp>;
  supplier?: InputMaybe<SuppliersBoolExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** columns and relationships of "products_and_services_categories" */
export type ProductsAndServicesCategories = {
  __typename?: 'products_and_services_categories';
  /** An object relationship */
  category: Categories;
  categoryId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  productsAndServicesId: Scalars['uuid']['output'];
  /** An object relationship */
  products_and_service: ProductsAndServices;
};

/** order by aggregate values of table "products_and_services_categories" */
export type ProductsAndServicesCategoriesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProductsAndServicesCategoriesMaxOrderBy>;
  min?: InputMaybe<ProductsAndServicesCategoriesMinOrderBy>;
};

/** Boolean expression to filter rows from the table "products_and_services_categories". All fields are combined with a logical 'AND'. */
export type ProductsAndServicesCategoriesBoolExp = {
  _and?: InputMaybe<Array<ProductsAndServicesCategoriesBoolExp>>;
  _not?: InputMaybe<ProductsAndServicesCategoriesBoolExp>;
  _or?: InputMaybe<Array<ProductsAndServicesCategoriesBoolExp>>;
  category?: InputMaybe<CategoriesBoolExp>;
  categoryId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  productsAndServicesId?: InputMaybe<UuidComparisonExp>;
  products_and_service?: InputMaybe<ProductsAndServicesBoolExp>;
};

/** order by max() on columns of table "products_and_services_categories" */
export type ProductsAndServicesCategoriesMaxOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  productsAndServicesId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "products_and_services_categories" */
export type ProductsAndServicesCategoriesMinOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  productsAndServicesId?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "products_and_services_categories". */
export type ProductsAndServicesCategoriesOrderBy = {
  category?: InputMaybe<CategoriesOrderBy>;
  categoryId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  productsAndServicesId?: InputMaybe<OrderBy>;
  products_and_service?: InputMaybe<ProductsAndServicesOrderBy>;
};

/** select columns of table "products_and_services_categories" */
export enum ProductsAndServicesCategoriesSelectColumn {
  /** column name */
  CATEGORYID = 'categoryId',
  /** column name */
  ID = 'id',
  /** column name */
  PRODUCTSANDSERVICESID = 'productsAndServicesId'
}

/** Streaming cursor of the table "products_and_services_categories" */
export type ProductsAndServicesCategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ProductsAndServicesCategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductsAndServicesCategoriesStreamCursorValueInput = {
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  productsAndServicesId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "products_and_services" */
export type ProductsAndServicesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  functionalDescription?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "products_and_services" */
export type ProductsAndServicesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  functionalDescription?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** Ordering options when selecting data from "products_and_services". */
export type ProductsAndServicesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  functionalDescription?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation_products_and_services_brands_aggregate?: InputMaybe<OrganisationProductsAndServicesBrandsAggregateOrderBy>;
  products_and_services_categories_aggregate?: InputMaybe<ProductsAndServicesCategoriesAggregateOrderBy>;
  raw?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  supplier?: InputMaybe<SuppliersOrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** select columns of table "products_and_services" */
export enum ProductsAndServicesSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DISPLAYNAME = 'displayName',
  /** column name */
  FUNCTIONALDESCRIPTION = 'functionalDescription',
  /** column name */
  ID = 'id',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  RAW = 'raw',
  /** column name */
  SOURCE = 'source',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEBSITE = 'website'
}

/** columns and relationships of "products_and_services_similarity_results" */
export type ProductsAndServicesSimilarityResults = {
  __typename?: 'products_and_services_similarity_results';
  /** An object relationship */
  globalProduct: Maybe<ProductsAndServices>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisationProduct: Maybe<OrganisationProductsAndServices>;
  similarity: Scalars['float8']['output'];
};

/** Boolean expression to filter rows from the table "products_and_services_similarity_results". All fields are combined with a logical 'AND'. */
export type ProductsAndServicesSimilarityResultsBoolExp = {
  _and?: InputMaybe<Array<ProductsAndServicesSimilarityResultsBoolExp>>;
  _not?: InputMaybe<ProductsAndServicesSimilarityResultsBoolExp>;
  _or?: InputMaybe<Array<ProductsAndServicesSimilarityResultsBoolExp>>;
  globalProduct?: InputMaybe<ProductsAndServicesBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationProduct?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  similarity?: InputMaybe<Float8ComparisonExp>;
};

/** Ordering options when selecting data from "products_and_services_similarity_results". */
export type ProductsAndServicesSimilarityResultsOrderBy = {
  globalProduct?: InputMaybe<ProductsAndServicesOrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationProduct?: InputMaybe<OrganisationProductsAndServicesOrderBy>;
  similarity?: InputMaybe<OrderBy>;
};

/** select columns of table "products_and_services_similarity_results" */
export enum ProductsAndServicesSimilarityResultsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  SIMILARITY = 'similarity'
}

/** Streaming cursor of the table "products_and_services_similarity_results" */
export type ProductsAndServicesSimilarityResultsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ProductsAndServicesSimilarityResultsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductsAndServicesSimilarityResultsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  similarity?: InputMaybe<Scalars['float8']['input']>;
};

/** order by stddev() on columns of table "products_and_services" */
export type ProductsAndServicesStddevOrderBy = {
  source?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "products_and_services" */
export type ProductsAndServicesStddevPopOrderBy = {
  source?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "products_and_services" */
export type ProductsAndServicesStddevSampOrderBy = {
  source?: InputMaybe<OrderBy>;
};

/** order by sum() on columns of table "products_and_services" */
export type ProductsAndServicesSumOrderBy = {
  source?: InputMaybe<OrderBy>;
};

export type ProductsAndServicesUnifiedSimilaritySearchByProductIdArgs = {
  only_existing_suppliers?: InputMaybe<Scalars['Boolean']['input']>;
  reference_product_id?: InputMaybe<Scalars['uuid']['input']>;
  result_limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductsAndServicesUnifiedSimilaritySearchByQueryArgs = {
  only_existing_suppliers?: InputMaybe<Scalars['Boolean']['input']>;
  result_limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['vector']['input']>;
};

/** order by var_pop() on columns of table "products_and_services" */
export type ProductsAndServicesVarPopOrderBy = {
  source?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "products_and_services" */
export type ProductsAndServicesVarSampOrderBy = {
  source?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "products_and_services" */
export type ProductsAndServicesVarianceOrderBy = {
  source?: InputMaybe<OrderBy>;
};

/** Mapping table purchase_orders to line item custom_field_values */
export type PurchaseOrderLineItems = {
  __typename?: 'purchase_order_line_items';
  amount: Maybe<Scalars['numeric']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  currency: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  customFieldValues: Array<CustomFieldValues>;
  /** An aggregate relationship */
  customFieldValues_aggregate: CustomFieldValuesAggregate;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lineItemCurrency: Maybe<OrganisationFxRates>;
  lineNumber: Scalars['Int']['output'];
  organisationId: Scalars['uuid']['output'];
  purchaseOrderId: Scalars['uuid']['output'];
  quantity: Maybe<Scalars['numeric']['output']>;
  unitPrice: Maybe<Scalars['numeric']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** Mapping table purchase_orders to line item custom_field_values */
export type PurchaseOrderLineItemsCustomFieldValuesArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** Mapping table purchase_orders to line item custom_field_values */
export type PurchaseOrderLineItemsCustomFieldValuesAggregateArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};

/** order by aggregate values of table "purchase_order_line_items" */
export type PurchaseOrderLineItemsAggregateOrderBy = {
  avg?: InputMaybe<PurchaseOrderLineItemsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PurchaseOrderLineItemsMaxOrderBy>;
  min?: InputMaybe<PurchaseOrderLineItemsMinOrderBy>;
  stddev?: InputMaybe<PurchaseOrderLineItemsStddevOrderBy>;
  stddev_pop?: InputMaybe<PurchaseOrderLineItemsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<PurchaseOrderLineItemsStddevSampOrderBy>;
  sum?: InputMaybe<PurchaseOrderLineItemsSumOrderBy>;
  var_pop?: InputMaybe<PurchaseOrderLineItemsVarPopOrderBy>;
  var_samp?: InputMaybe<PurchaseOrderLineItemsVarSampOrderBy>;
  variance?: InputMaybe<PurchaseOrderLineItemsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "purchase_order_line_items" */
export type PurchaseOrderLineItemsArrRelInsertInput = {
  data: Array<PurchaseOrderLineItemsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<PurchaseOrderLineItemsOnConflict>;
};

/** order by avg() on columns of table "purchase_order_line_items" */
export type PurchaseOrderLineItemsAvgOrderBy = {
  amount?: InputMaybe<OrderBy>;
  lineNumber?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  unitPrice?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "purchase_order_line_items". All fields are combined with a logical 'AND'. */
export type PurchaseOrderLineItemsBoolExp = {
  _and?: InputMaybe<Array<PurchaseOrderLineItemsBoolExp>>;
  _not?: InputMaybe<PurchaseOrderLineItemsBoolExp>;
  _or?: InputMaybe<Array<PurchaseOrderLineItemsBoolExp>>;
  amount?: InputMaybe<NumericComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<UuidComparisonExp>;
  customFieldValues?: InputMaybe<CustomFieldValuesBoolExp>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lineItemCurrency?: InputMaybe<OrganisationFxRatesBoolExp>;
  lineNumber?: InputMaybe<IntComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  purchaseOrderId?: InputMaybe<UuidComparisonExp>;
  quantity?: InputMaybe<NumericComparisonExp>;
  unitPrice?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "purchase_order_line_items" */
export enum PurchaseOrderLineItemsConstraint {
  /** unique or primary key constraint on columns "id" */
  PURCHASE_ORDER_LINE_ITEMS_PKEY = 'purchase_order_line_items_pkey'
}

/** input type for incrementing numeric columns in table "purchase_order_line_items" */
export type PurchaseOrderLineItemsIncInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  unitPrice?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "purchase_order_line_items" */
export type PurchaseOrderLineItemsInsertInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  currency?: InputMaybe<Scalars['uuid']['input']>;
  customFieldValues?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  lineItemCurrency?: InputMaybe<OrganisationFxRatesObjRelInsertInput>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrderId?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  unitPrice?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by max() on columns of table "purchase_order_line_items" */
export type PurchaseOrderLineItemsMaxOrderBy = {
  amount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lineNumber?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  purchaseOrderId?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  unitPrice?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "purchase_order_line_items" */
export type PurchaseOrderLineItemsMinOrderBy = {
  amount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lineNumber?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  purchaseOrderId?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  unitPrice?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "purchase_order_line_items" */
export type PurchaseOrderLineItemsMutationResponse = {
  __typename?: 'purchase_order_line_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PurchaseOrderLineItems>;
};

/** on_conflict condition type for table "purchase_order_line_items" */
export type PurchaseOrderLineItemsOnConflict = {
  constraint: PurchaseOrderLineItemsConstraint;
  update_columns: Array<PurchaseOrderLineItemsUpdateColumn>;
  where?: InputMaybe<PurchaseOrderLineItemsBoolExp>;
};

/** Ordering options when selecting data from "purchase_order_line_items". */
export type PurchaseOrderLineItemsOrderBy = {
  amount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lineItemCurrency?: InputMaybe<OrganisationFxRatesOrderBy>;
  lineNumber?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  purchaseOrderId?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  unitPrice?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: purchase_order_line_items */
export type PurchaseOrderLineItemsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "purchase_order_line_items" */
export enum PurchaseOrderLineItemsSelectColumn {
  /** column name */
  AMOUNT = 'amount',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CURRENCY = 'currency',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  LINENUMBER = 'lineNumber',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  PURCHASEORDERID = 'purchaseOrderId',
  /** column name */
  QUANTITY = 'quantity',
  /** column name */
  UNITPRICE = 'unitPrice',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "purchase_order_line_items" */
export type PurchaseOrderLineItemsSetInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  currency?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrderId?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  unitPrice?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "purchase_order_line_items" */
export type PurchaseOrderLineItemsStddevOrderBy = {
  amount?: InputMaybe<OrderBy>;
  lineNumber?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  unitPrice?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "purchase_order_line_items" */
export type PurchaseOrderLineItemsStddevPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  lineNumber?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  unitPrice?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "purchase_order_line_items" */
export type PurchaseOrderLineItemsStddevSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  lineNumber?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  unitPrice?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "purchase_order_line_items" */
export type PurchaseOrderLineItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: PurchaseOrderLineItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PurchaseOrderLineItemsStreamCursorValueInput = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  purchaseOrderId?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['numeric']['input']>;
  unitPrice?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "purchase_order_line_items" */
export type PurchaseOrderLineItemsSumOrderBy = {
  amount?: InputMaybe<OrderBy>;
  lineNumber?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  unitPrice?: InputMaybe<OrderBy>;
};

/** update columns of table "purchase_order_line_items" */
export enum PurchaseOrderLineItemsUpdateColumn {
  /** column name */
  AMOUNT = 'amount',
  /** column name */
  CURRENCY = 'currency',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  LINENUMBER = 'lineNumber',
  /** column name */
  PURCHASEORDERID = 'purchaseOrderId',
  /** column name */
  QUANTITY = 'quantity',
  /** column name */
  UNITPRICE = 'unitPrice',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type PurchaseOrderLineItemsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PurchaseOrderLineItemsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PurchaseOrderLineItemsSetInput>;
  /** filter the rows which have to be updated */
  where: PurchaseOrderLineItemsBoolExp;
};

/** order by var_pop() on columns of table "purchase_order_line_items" */
export type PurchaseOrderLineItemsVarPopOrderBy = {
  amount?: InputMaybe<OrderBy>;
  lineNumber?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  unitPrice?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "purchase_order_line_items" */
export type PurchaseOrderLineItemsVarSampOrderBy = {
  amount?: InputMaybe<OrderBy>;
  lineNumber?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  unitPrice?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "purchase_order_line_items" */
export type PurchaseOrderLineItemsVarianceOrderBy = {
  amount?: InputMaybe<OrderBy>;
  lineNumber?: InputMaybe<OrderBy>;
  quantity?: InputMaybe<OrderBy>;
  unitPrice?: InputMaybe<OrderBy>;
};

/** columns and relationships of "purchase_orders" */
export type PurchaseOrders = {
  __typename?: 'purchase_orders';
  contractEndDate: Maybe<Scalars['timestamptz']['output']>;
  contractStartDate: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  currency: Maybe<OrganisationFxRates>;
  currencyId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  customFieldValues: Array<CustomFieldValues>;
  /** An aggregate relationship */
  customFieldValues_aggregate: CustomFieldValuesAggregate;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  department: Maybe<Departments>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  formSubmissionId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  isPurchaseAgreement: Scalars['Boolean']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationIntegration: Maybe<OrganisationIntegrations>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organisationSupplier: OrganisationSuppliers;
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  paymentTerm: Maybe<PaymentTerms>;
  paymentTermId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  purchaseOrderLineItems: Array<PurchaseOrderLineItems>;
  remoteId: Maybe<Scalars['String']['output']>;
  remoteInvoicedValue: Scalars['numeric']['output'];
  remoteLink: Maybe<Scalars['String']['output']>;
  remoteNumber: Maybe<Scalars['String']['output']>;
  remotePaidValue: Scalars['numeric']['output'];
  remoteStatus: Maybe<Scalars['String']['output']>;
  remoteTotalValue: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  request: Requests;
  /** An object relationship */
  requestFormSubmission: Maybe<RequestFormSubmissions>;
  requestId: Scalars['uuid']['output'];
  /** An object relationship */
  requestor: Maybe<Users>;
  requestorId: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  /** An object relationship */
  subsidiary: Maybe<Subsidiaries>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  supplierId: Scalars['uuid']['output'];
  totalValue: Scalars['numeric']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "purchase_orders" */
export type PurchaseOrdersCustomFieldValuesArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** columns and relationships of "purchase_orders" */
export type PurchaseOrdersCustomFieldValuesAggregateArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** columns and relationships of "purchase_orders" */
export type PurchaseOrdersPurchaseOrderLineItemsArgs = {
  distinct_on: InputMaybe<Array<PurchaseOrderLineItemsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<PurchaseOrderLineItemsOrderBy>>;
  where: InputMaybe<PurchaseOrderLineItemsBoolExp>;
};

/** order by aggregate values of table "purchase_orders" */
export type PurchaseOrdersAggregateOrderBy = {
  avg?: InputMaybe<PurchaseOrdersAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PurchaseOrdersMaxOrderBy>;
  min?: InputMaybe<PurchaseOrdersMinOrderBy>;
  stddev?: InputMaybe<PurchaseOrdersStddevOrderBy>;
  stddev_pop?: InputMaybe<PurchaseOrdersStddevPopOrderBy>;
  stddev_samp?: InputMaybe<PurchaseOrdersStddevSampOrderBy>;
  sum?: InputMaybe<PurchaseOrdersSumOrderBy>;
  var_pop?: InputMaybe<PurchaseOrdersVarPopOrderBy>;
  var_samp?: InputMaybe<PurchaseOrdersVarSampOrderBy>;
  variance?: InputMaybe<PurchaseOrdersVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "purchase_orders" */
export type PurchaseOrdersArrRelInsertInput = {
  data: Array<PurchaseOrdersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<PurchaseOrdersOnConflict>;
};

/** order by avg() on columns of table "purchase_orders" */
export type PurchaseOrdersAvgOrderBy = {
  remoteInvoicedValue?: InputMaybe<OrderBy>;
  remotePaidValue?: InputMaybe<OrderBy>;
  remoteTotalValue?: InputMaybe<OrderBy>;
  totalValue?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "purchase_orders". All fields are combined with a logical 'AND'. */
export type PurchaseOrdersBoolExp = {
  _and?: InputMaybe<Array<PurchaseOrdersBoolExp>>;
  _not?: InputMaybe<PurchaseOrdersBoolExp>;
  _or?: InputMaybe<Array<PurchaseOrdersBoolExp>>;
  contractEndDate?: InputMaybe<TimestamptzComparisonExp>;
  contractStartDate?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<OrganisationFxRatesBoolExp>;
  currencyId?: InputMaybe<UuidComparisonExp>;
  customFieldValues?: InputMaybe<CustomFieldValuesBoolExp>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<DepartmentsBoolExp>;
  departmentId?: InputMaybe<UuidComparisonExp>;
  formSubmissionId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPurchaseAgreement?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentMethodId?: InputMaybe<UuidComparisonExp>;
  paymentTerm?: InputMaybe<PaymentTermsBoolExp>;
  paymentTermId?: InputMaybe<UuidComparisonExp>;
  purchaseOrderLineItems?: InputMaybe<PurchaseOrderLineItemsBoolExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  remoteInvoicedValue?: InputMaybe<NumericComparisonExp>;
  remoteLink?: InputMaybe<StringComparisonExp>;
  remoteNumber?: InputMaybe<StringComparisonExp>;
  remotePaidValue?: InputMaybe<NumericComparisonExp>;
  remoteStatus?: InputMaybe<StringComparisonExp>;
  remoteTotalValue?: InputMaybe<NumericComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestFormSubmission?: InputMaybe<RequestFormSubmissionsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  requestor?: InputMaybe<UsersBoolExp>;
  requestorId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  subsidiaryId?: InputMaybe<UuidComparisonExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  totalValue?: InputMaybe<NumericComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "purchase_orders" */
export enum PurchaseOrdersConstraint {
  /** unique or primary key constraint on columns "id" */
  PURCHASE_ORDERS_PKEY = 'purchase_orders_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  PURCHASE_ORDERS_REMOTE_ID_ORGANISATION_ID_ACTIVE_UNIQUE = 'purchase_orders_remote_id_organisation_id_active_unique'
}

/** input type for incrementing numeric columns in table "purchase_orders" */
export type PurchaseOrdersIncInput = {
  remoteInvoicedValue?: InputMaybe<Scalars['numeric']['input']>;
  remotePaidValue?: InputMaybe<Scalars['numeric']['input']>;
  remoteTotalValue?: InputMaybe<Scalars['numeric']['input']>;
  totalValue?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "purchase_orders" */
export type PurchaseOrdersInsertInput = {
  contractEndDate?: InputMaybe<Scalars['timestamptz']['input']>;
  contractStartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<OrganisationFxRatesObjRelInsertInput>;
  currencyId?: InputMaybe<Scalars['uuid']['input']>;
  customFieldValues?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  department?: InputMaybe<DepartmentsObjRelInsertInput>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  formSubmissionId?: InputMaybe<Scalars['uuid']['input']>;
  isPurchaseAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  paymentMethod?: InputMaybe<PaymentMethodsObjRelInsertInput>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentTerm?: InputMaybe<PaymentTermsObjRelInsertInput>;
  paymentTermId?: InputMaybe<Scalars['uuid']['input']>;
  purchaseOrderLineItems?: InputMaybe<PurchaseOrderLineItemsArrRelInsertInput>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  remoteInvoicedValue?: InputMaybe<Scalars['numeric']['input']>;
  remoteLink?: InputMaybe<Scalars['String']['input']>;
  remoteNumber?: InputMaybe<Scalars['String']['input']>;
  remotePaidValue?: InputMaybe<Scalars['numeric']['input']>;
  remoteStatus?: InputMaybe<Scalars['String']['input']>;
  remoteTotalValue?: InputMaybe<Scalars['numeric']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestFormSubmission?: InputMaybe<RequestFormSubmissionsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  requestor?: InputMaybe<UsersObjRelInsertInput>;
  requestorId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subsidiary?: InputMaybe<SubsidiariesObjRelInsertInput>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  totalValue?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by max() on columns of table "purchase_orders" */
export type PurchaseOrdersMaxOrderBy = {
  contractEndDate?: InputMaybe<OrderBy>;
  contractStartDate?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  formSubmissionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  paymentTermId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  remoteInvoicedValue?: InputMaybe<OrderBy>;
  remoteLink?: InputMaybe<OrderBy>;
  remoteNumber?: InputMaybe<OrderBy>;
  remotePaidValue?: InputMaybe<OrderBy>;
  remoteStatus?: InputMaybe<OrderBy>;
  remoteTotalValue?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  requestorId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  totalValue?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "purchase_orders" */
export type PurchaseOrdersMinOrderBy = {
  contractEndDate?: InputMaybe<OrderBy>;
  contractStartDate?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currencyId?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  formSubmissionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  paymentTermId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  remoteInvoicedValue?: InputMaybe<OrderBy>;
  remoteLink?: InputMaybe<OrderBy>;
  remoteNumber?: InputMaybe<OrderBy>;
  remotePaidValue?: InputMaybe<OrderBy>;
  remoteStatus?: InputMaybe<OrderBy>;
  remoteTotalValue?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  requestorId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  totalValue?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "purchase_orders" */
export type PurchaseOrdersMutationResponse = {
  __typename?: 'purchase_orders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PurchaseOrders>;
};

/** on_conflict condition type for table "purchase_orders" */
export type PurchaseOrdersOnConflict = {
  constraint: PurchaseOrdersConstraint;
  update_columns: Array<PurchaseOrdersUpdateColumn>;
  where?: InputMaybe<PurchaseOrdersBoolExp>;
};

/** Ordering options when selecting data from "purchase_orders". */
export type PurchaseOrdersOrderBy = {
  contractEndDate?: InputMaybe<OrderBy>;
  contractStartDate?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrganisationFxRatesOrderBy>;
  currencyId?: InputMaybe<OrderBy>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<DepartmentsOrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  formSubmissionId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isPurchaseAgreement?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsOrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  organisationSupplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  paymentMethod?: InputMaybe<PaymentMethodsOrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  paymentTerm?: InputMaybe<PaymentTermsOrderBy>;
  paymentTermId?: InputMaybe<OrderBy>;
  purchaseOrderLineItems_aggregate?: InputMaybe<PurchaseOrderLineItemsAggregateOrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  remoteInvoicedValue?: InputMaybe<OrderBy>;
  remoteLink?: InputMaybe<OrderBy>;
  remoteNumber?: InputMaybe<OrderBy>;
  remotePaidValue?: InputMaybe<OrderBy>;
  remoteStatus?: InputMaybe<OrderBy>;
  remoteTotalValue?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestFormSubmission?: InputMaybe<RequestFormSubmissionsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  requestor?: InputMaybe<UsersOrderBy>;
  requestorId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  subsidiary?: InputMaybe<SubsidiariesOrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  totalValue?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: purchase_orders */
export type PurchaseOrdersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "purchase_orders" */
export enum PurchaseOrdersSelectColumn {
  /** column name */
  CONTRACTENDDATE = 'contractEndDate',
  /** column name */
  CONTRACTSTARTDATE = 'contractStartDate',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CURRENCYID = 'currencyId',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  FORMSUBMISSIONID = 'formSubmissionId',
  /** column name */
  ID = 'id',
  /** column name */
  ISPURCHASEAGREEMENT = 'isPurchaseAgreement',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTERMID = 'paymentTermId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  REMOTEINVOICEDVALUE = 'remoteInvoicedValue',
  /** column name */
  REMOTELINK = 'remoteLink',
  /** column name */
  REMOTENUMBER = 'remoteNumber',
  /** column name */
  REMOTEPAIDVALUE = 'remotePaidValue',
  /** column name */
  REMOTESTATUS = 'remoteStatus',
  /** column name */
  REMOTETOTALVALUE = 'remoteTotalValue',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  REQUESTORID = 'requestorId',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  TOTALVALUE = 'totalValue',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "purchase_orders" */
export type PurchaseOrdersSetInput = {
  contractEndDate?: InputMaybe<Scalars['timestamptz']['input']>;
  contractStartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  currencyId?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  formSubmissionId?: InputMaybe<Scalars['uuid']['input']>;
  isPurchaseAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentTermId?: InputMaybe<Scalars['uuid']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  remoteInvoicedValue?: InputMaybe<Scalars['numeric']['input']>;
  remoteLink?: InputMaybe<Scalars['String']['input']>;
  remoteNumber?: InputMaybe<Scalars['String']['input']>;
  remotePaidValue?: InputMaybe<Scalars['numeric']['input']>;
  remoteStatus?: InputMaybe<Scalars['String']['input']>;
  remoteTotalValue?: InputMaybe<Scalars['numeric']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  requestorId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  totalValue?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "purchase_orders" */
export type PurchaseOrdersStddevOrderBy = {
  remoteInvoicedValue?: InputMaybe<OrderBy>;
  remotePaidValue?: InputMaybe<OrderBy>;
  remoteTotalValue?: InputMaybe<OrderBy>;
  totalValue?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "purchase_orders" */
export type PurchaseOrdersStddevPopOrderBy = {
  remoteInvoicedValue?: InputMaybe<OrderBy>;
  remotePaidValue?: InputMaybe<OrderBy>;
  remoteTotalValue?: InputMaybe<OrderBy>;
  totalValue?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "purchase_orders" */
export type PurchaseOrdersStddevSampOrderBy = {
  remoteInvoicedValue?: InputMaybe<OrderBy>;
  remotePaidValue?: InputMaybe<OrderBy>;
  remoteTotalValue?: InputMaybe<OrderBy>;
  totalValue?: InputMaybe<OrderBy>;
};

/** order by sum() on columns of table "purchase_orders" */
export type PurchaseOrdersSumOrderBy = {
  remoteInvoicedValue?: InputMaybe<OrderBy>;
  remotePaidValue?: InputMaybe<OrderBy>;
  remoteTotalValue?: InputMaybe<OrderBy>;
  totalValue?: InputMaybe<OrderBy>;
};

/** update columns of table "purchase_orders" */
export enum PurchaseOrdersUpdateColumn {
  /** column name */
  CONTRACTENDDATE = 'contractEndDate',
  /** column name */
  CONTRACTSTARTDATE = 'contractStartDate',
  /** column name */
  CURRENCYID = 'currencyId',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  FORMSUBMISSIONID = 'formSubmissionId',
  /** column name */
  ISPURCHASEAGREEMENT = 'isPurchaseAgreement',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTERMID = 'paymentTermId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  REMOTEINVOICEDVALUE = 'remoteInvoicedValue',
  /** column name */
  REMOTELINK = 'remoteLink',
  /** column name */
  REMOTENUMBER = 'remoteNumber',
  /** column name */
  REMOTEPAIDVALUE = 'remotePaidValue',
  /** column name */
  REMOTESTATUS = 'remoteStatus',
  /** column name */
  REMOTETOTALVALUE = 'remoteTotalValue',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  REQUESTORID = 'requestorId',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  TOTALVALUE = 'totalValue',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type PurchaseOrdersUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PurchaseOrdersIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PurchaseOrdersSetInput>;
  /** filter the rows which have to be updated */
  where: PurchaseOrdersBoolExp;
};

/** order by var_pop() on columns of table "purchase_orders" */
export type PurchaseOrdersVarPopOrderBy = {
  remoteInvoicedValue?: InputMaybe<OrderBy>;
  remotePaidValue?: InputMaybe<OrderBy>;
  remoteTotalValue?: InputMaybe<OrderBy>;
  totalValue?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "purchase_orders" */
export type PurchaseOrdersVarSampOrderBy = {
  remoteInvoicedValue?: InputMaybe<OrderBy>;
  remotePaidValue?: InputMaybe<OrderBy>;
  remoteTotalValue?: InputMaybe<OrderBy>;
  totalValue?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "purchase_orders" */
export type PurchaseOrdersVarianceOrderBy = {
  remoteInvoicedValue?: InputMaybe<OrderBy>;
  remotePaidValue?: InputMaybe<OrderBy>;
  remoteTotalValue?: InputMaybe<OrderBy>;
  totalValue?: InputMaybe<OrderBy>;
};

/** columns and relationships of "purchase_type" */
export type PurchaseType = {
  __typename?: 'purchase_type';
  description: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  financials: Array<Financials>;
  value: Scalars['String']['output'];
};


/** columns and relationships of "purchase_type" */
export type PurchaseTypeFinancialsArgs = {
  distinct_on: InputMaybe<Array<FinancialsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FinancialsOrderBy>>;
  where: InputMaybe<FinancialsBoolExp>;
};

/** Boolean expression to filter rows from the table "purchase_type". All fields are combined with a logical 'AND'. */
export type PurchaseTypeBoolExp = {
  _and?: InputMaybe<Array<PurchaseTypeBoolExp>>;
  _not?: InputMaybe<PurchaseTypeBoolExp>;
  _or?: InputMaybe<Array<PurchaseTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  financials?: InputMaybe<FinancialsBoolExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum PurchaseTypeEnum {
  /** Fixed Term Contract  */
  FIXED_TERM = 'FIXED_TERM',
  /** One-off */
  ONE_OFF = 'ONE_OFF',
  /** Rolling Contract / Subscription */
  ROLLING = 'ROLLING'
}

/** Boolean expression to compare columns of type "purchase_type_enum". All fields are combined with logical 'AND'. */
export type PurchaseTypeEnumComparisonExp = {
  _eq?: InputMaybe<PurchaseTypeEnum>;
  _in?: InputMaybe<Array<PurchaseTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<PurchaseTypeEnum>;
  _nin?: InputMaybe<Array<PurchaseTypeEnum>>;
};

/** Ordering options when selecting data from "purchase_type". */
export type PurchaseTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  financials_aggregate?: InputMaybe<FinancialsAggregateOrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "purchase_type" */
export enum PurchaseTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

export type QueryRoot = {
  __typename?: 'query_root';
  /** fetch data from the table: "addresses" */
  addresses: Array<Addresses>;
  /** fetch aggregated fields from the table: "addresses" */
  addresses_aggregate: AddressesAggregate;
  /** fetch data from the table: "addresses" using primary key columns */
  addresses_by_pk: Maybe<Addresses>;
  /** fetch data from the table: "agreement_additional_owners" */
  agreement_additional_owners: Array<AgreementAdditionalOwners>;
  /** An array relationship */
  agreement_documents: Array<AgreementDocuments>;
  /** fetch data from the table: "agreement_documents" using primary key columns */
  agreement_documents_by_pk: Maybe<AgreementDocuments>;
  /** fetch data from the table: "agreement_tags" */
  agreement_tags: Array<AgreementTags>;
  /** fetch data from the table: "agreement_tags" using primary key columns */
  agreement_tags_by_pk: Maybe<AgreementTags>;
  /** fetch data from the table: "agreement_term_products" */
  agreement_term_products: Array<AgreementTermProducts>;
  /** fetch data from the table: "agreement_term_products" using primary key columns */
  agreement_term_products_by_pk: Maybe<AgreementTermProducts>;
  /** An array relationship */
  agreement_term_revisions: Array<AgreementTermRevisions>;
  /** fetch data from the table: "agreement_term_revisions" using primary key columns */
  agreement_term_revisions_by_pk: Maybe<AgreementTermRevisions>;
  /** fetch data from the table: "agreement_term_spend_items" */
  agreement_term_spend_items: Array<AgreementTermSpendItems>;
  /** fetch data from the table: "agreement_term_spend_items" using primary key columns */
  agreement_term_spend_items_by_pk: Maybe<AgreementTermSpendItems>;
  /** An array relationship */
  agreement_terms: Array<AgreementTerms>;
  /** An aggregate relationship */
  agreement_terms_aggregate: AgreementTermsAggregate;
  /** fetch data from the table: "agreement_terms" using primary key columns */
  agreement_terms_by_pk: Maybe<AgreementTerms>;
  /** An array relationship */
  agreements: Array<Agreements>;
  /** An aggregate relationship */
  agreements_aggregate: AgreementsAggregate;
  /** fetch data from the table: "agreements" using primary key columns */
  agreements_by_pk: Maybe<Agreements>;
  /** fetch data from the table: "assessment_additional_groups" */
  assessment_additional_groups: Array<AssessmentAdditionalGroups>;
  /** fetch data from the table: "assessment_additional_users" */
  assessment_additional_users: Array<AssessmentAdditionalUsers>;
  /** fetch data from the table: "assessment_frequency" */
  assessment_frequency: Array<AssessmentFrequency>;
  /** fetch data from the table: "assessment_frequency" using primary key columns */
  assessment_frequency_by_pk: Maybe<AssessmentFrequency>;
  /** An array relationship */
  assessment_tags: Array<AssessmentTags>;
  /** fetch data from the table: "assessment_tags" using primary key columns */
  assessment_tags_by_pk: Maybe<AssessmentTags>;
  /** An array relationship */
  assessments: Array<Assessments>;
  /** An aggregate relationship */
  assessments_aggregate: AssessmentsAggregate;
  /** fetch data from the table: "assessments" using primary key columns */
  assessments_by_pk: Maybe<Assessments>;
  /** fetch data from the table: "assignee_type" */
  assignee_type: Array<AssigneeType>;
  /** fetch data from the table: "assignee_type" using primary key columns */
  assignee_type_by_pk: Maybe<AssigneeType>;
  /** fetch data from the table: "auth_refresh_tokens" */
  auth_refresh_tokens: Array<AuthRefreshTokens>;
  /** fetch data from the table: "auth_refresh_tokens" using primary key columns */
  auth_refresh_tokens_by_pk: Maybe<AuthRefreshTokens>;
  /** fetch data from the table: "auto_flagged_score_categories" */
  auto_flagged_score_categories: Array<AutoFlaggedScoreCategories>;
  /** fetch data from the table: "auto_flagged_score_categories" using primary key columns */
  auto_flagged_score_categories_by_pk: Maybe<AutoFlaggedScoreCategories>;
  /** An array relationship */
  bank_details: Array<BankDetails>;
  /** An aggregate relationship */
  bank_details_aggregate: BankDetailsAggregate;
  /** fetch data from the table: "bank_details" using primary key columns */
  bank_details_by_pk: Maybe<BankDetails>;
  /** fetch data from the table: "budget_approval_group" */
  budget_approval_group: Array<BudgetApprovalGroup>;
  /** fetch data from the table: "budget_approval_group_assignees" */
  budget_approval_group_assignees: Array<BudgetApprovalGroupAssignees>;
  /** fetch data from the table: "budget_approval_group_assignees_assignees" */
  budget_approval_group_assignees_assignees: Array<BudgetApprovalGroupAssigneesAssignees>;
  /** fetch data from the table: "budget_approval_group_assignees_assignees" using primary key columns */
  budget_approval_group_assignees_assignees_by_pk: Maybe<BudgetApprovalGroupAssigneesAssignees>;
  /** fetch data from the table: "budget_approval_group_assignees" using primary key columns */
  budget_approval_group_assignees_by_pk: Maybe<BudgetApprovalGroupAssignees>;
  /** fetch data from the table: "budget_approval_group_assignees_custom_core_data_options" */
  budget_approval_group_assignees_custom_core_data_options: Array<BudgetApprovalGroupAssigneesCustomCoreDataOptions>;
  /** fetch data from the table: "budget_approval_group_assignees_custom_core_data_options" using primary key columns */
  budget_approval_group_assignees_custom_core_data_options_by_pk: Maybe<BudgetApprovalGroupAssigneesCustomCoreDataOptions>;
  /** fetch data from the table: "budget_approval_group" using primary key columns */
  budget_approval_group_by_pk: Maybe<BudgetApprovalGroup>;
  /** fetch data from the table: "budget_approval_group_selected_custom_core_data" */
  budget_approval_group_selected_custom_core_data: Array<BudgetApprovalGroupSelectedCustomCoreData>;
  /** fetch data from the table: "budget_approval_group_selected_custom_core_data" using primary key columns */
  budget_approval_group_selected_custom_core_data_by_pk: Maybe<BudgetApprovalGroupSelectedCustomCoreData>;
  /** fetch data from the table: "budget_approval_threshold" */
  budget_approval_threshold: Array<BudgetApprovalThreshold>;
  /** fetch data from the table: "budget_approval_threshold" using primary key columns */
  budget_approval_threshold_by_pk: Maybe<BudgetApprovalThreshold>;
  /** fetch data from the table: "budget_approval_threshold_department" */
  budget_approval_threshold_department: Array<BudgetApprovalThresholdDepartment>;
  /** fetch data from the table: "budget_approval_threshold_department" using primary key columns */
  budget_approval_threshold_department_by_pk: Maybe<BudgetApprovalThresholdDepartment>;
  /** fetch data from the table: "budget_approval_threshold_group" */
  budget_approval_threshold_group: Array<BudgetApprovalThresholdGroup>;
  /** fetch data from the table: "budget_approval_threshold_group" using primary key columns */
  budget_approval_threshold_group_by_pk: Maybe<BudgetApprovalThresholdGroup>;
  /** fetch data from the table: "budgets" */
  budgets: Array<Budgets>;
  /** fetch data from the table: "budgets" using primary key columns */
  budgets_by_pk: Maybe<Budgets>;
  /** fetch data from the table: "bulk_documents_uploads" */
  bulk_documents_uploads: Array<BulkDocumentsUploads>;
  /** fetch data from the table: "bulk_documents_uploads" using primary key columns */
  bulk_documents_uploads_by_pk: Maybe<BulkDocumentsUploads>;
  /** fetch data from the table: "categories" */
  categories: Array<Categories>;
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk: Maybe<Categories>;
  /** fetch data from the table: "category" */
  category: Array<Category>;
  /** fetch data from the table: "category" using primary key columns */
  category_by_pk: Maybe<Category>;
  /** fetch data from the table: "config_translations" */
  config_translations: Array<ConfigTranslations>;
  /** fetch data from the table: "config_translations" using primary key columns */
  config_translations_by_pk: Maybe<ConfigTranslations>;
  /** fetch data from the table: "core_data" */
  core_data: Array<CoreData>;
  /** fetch data from the table: "core_data" using primary key columns */
  core_data_by_pk: Maybe<CoreData>;
  /** fetch data from the table: "core_data_dependencies" */
  core_data_dependencies: Array<CoreDataDependencies>;
  /** fetch aggregated fields from the table: "core_data_dependencies" */
  core_data_dependencies_aggregate: CoreDataDependenciesAggregate;
  /** fetch data from the table: "core_data_dependencies" using primary key columns */
  core_data_dependencies_by_pk: Maybe<CoreDataDependencies>;
  /** fetch data from the table: "core_data_external_references" */
  core_data_external_references: Array<CoreDataExternalReferences>;
  /** fetch aggregated fields from the table: "core_data_external_references" */
  core_data_external_references_aggregate: CoreDataExternalReferencesAggregate;
  /** fetch data from the table: "core_data_external_references" using primary key columns */
  core_data_external_references_by_pk: Maybe<CoreDataExternalReferences>;
  /** fetch data from the table: "core_data_organisation_integrations" */
  core_data_organisation_integrations: Array<CoreDataOrganisationIntegrations>;
  /** fetch data from the table: "core_data_organisation_integrations" using primary key columns */
  core_data_organisation_integrations_by_pk: Maybe<CoreDataOrganisationIntegrations>;
  /** fetch data from the table: "custom_core_data" */
  custom_core_data: Array<CustomCoreData>;
  /** fetch data from the table: "custom_core_data" using primary key columns */
  custom_core_data_by_pk: Maybe<CustomCoreData>;
  /** An array relationship */
  custom_core_data_options: Array<CustomCoreDataOptions>;
  /** An aggregate relationship */
  custom_core_data_options_aggregate: CustomCoreDataOptionsAggregate;
  /** fetch data from the table: "custom_core_data_options" using primary key columns */
  custom_core_data_options_by_pk: Maybe<CustomCoreDataOptions>;
  /** fetch data from the table: "custom_document_types" */
  custom_document_types: Array<CustomDocumentTypes>;
  /** fetch data from the table: "custom_document_types" using primary key columns */
  custom_document_types_by_pk: Maybe<CustomDocumentTypes>;
  /** fetch data from the table: "custom_field_choices" */
  custom_field_choices: Array<CustomFieldChoices>;
  /** fetch data from the table: "custom_field_choices" using primary key columns */
  custom_field_choices_by_pk: Maybe<CustomFieldChoices>;
  /** fetch data from the table: "custom_field_core_data" */
  custom_field_core_data: Array<CustomFieldCoreData>;
  /** fetch data from the table: "custom_field_core_data" using primary key columns */
  custom_field_core_data_by_pk: Maybe<CustomFieldCoreData>;
  /** An array relationship */
  custom_field_values: Array<CustomFieldValues>;
  /** An aggregate relationship */
  custom_field_values_aggregate: CustomFieldValuesAggregate;
  /** fetch data from the table: "custom_field_values" using primary key columns */
  custom_field_values_by_pk: Maybe<CustomFieldValues>;
  /** fetch data from the table: "custom_fields" */
  custom_fields: Array<CustomFields>;
  /** fetch data from the table: "custom_fields" using primary key columns */
  custom_fields_by_pk: Maybe<CustomFields>;
  /** fetch data from the table: "custom_reports" */
  custom_reports: Array<CustomReports>;
  /** fetch data from the table: "custom_reports" using primary key columns */
  custom_reports_by_pk: Maybe<CustomReports>;
  /** An array relationship */
  custom_reports_generations: Array<CustomReportsGenerations>;
  /** fetch data from the table: "custom_reports_generations" using primary key columns */
  custom_reports_generations_by_pk: Maybe<CustomReportsGenerations>;
  /** fetch data from the table: "departments" */
  departments: Array<Departments>;
  /** fetch aggregated fields from the table: "departments" */
  departments_aggregate: DepartmentsAggregate;
  /** fetch data from the table: "departments" using primary key columns */
  departments_by_pk: Maybe<Departments>;
  /** fetch data from the table: "document_types" */
  document_types: Array<DocumentTypes>;
  /** fetch data from the table: "document_types" using primary key columns */
  document_types_by_pk: Maybe<DocumentTypes>;
  /** An array relationship */
  documents: Array<Documents>;
  /** An aggregate relationship */
  documents_aggregate: DocumentsAggregate;
  /** fetch data from the table: "documents" using primary key columns */
  documents_by_pk: Maybe<Documents>;
  /** fetch data from the table: "draft_intake_submissions" */
  draft_intake_submissions: Array<DraftIntakeSubmissions>;
  /** fetch data from the table: "draft_intake_submissions" using primary key columns */
  draft_intake_submissions_by_pk: Maybe<DraftIntakeSubmissions>;
  /** An array relationship */
  engagements: Array<Engagements>;
  /** An aggregate relationship */
  engagements_aggregate: EngagementsAggregate;
  /** fetch data from the table: "engagements" using primary key columns */
  engagements_by_pk: Maybe<Engagements>;
  /** fetch data from the table: "entity_bank_details" */
  entity_bank_details: Array<EntityBankDetails>;
  /** fetch aggregated fields from the table: "entity_bank_details" */
  entity_bank_details_aggregate: EntityBankDetailsAggregate;
  /** fetch data from the table: "entity_bank_details" using primary key columns */
  entity_bank_details_by_pk: Maybe<EntityBankDetails>;
  /** fetch data from the table: "entity_field_group_fields" */
  entity_field_group_fields: Array<EntityFieldGroupFields>;
  /** fetch aggregated fields from the table: "entity_field_group_fields" */
  entity_field_group_fields_aggregate: EntityFieldGroupFieldsAggregate;
  /** fetch data from the table: "entity_field_group_fields" using primary key columns */
  entity_field_group_fields_by_pk: Maybe<EntityFieldGroupFields>;
  /** fetch data from the table: "entity_field_groups" */
  entity_field_groups: Array<EntityFieldGroups>;
  /** fetch aggregated fields from the table: "entity_field_groups" */
  entity_field_groups_aggregate: EntityFieldGroupsAggregate;
  /** fetch data from the table: "entity_field_groups" using primary key columns */
  entity_field_groups_by_pk: Maybe<EntityFieldGroups>;
  /** An array relationship */
  external_contacts: Array<ExternalContacts>;
  /** fetch data from the table: "external_contacts" using primary key columns */
  external_contacts_by_pk: Maybe<ExternalContacts>;
  /** fetch data from the table: "external_entity_sync_statuses" */
  external_entity_sync_statuses: Array<ExternalEntitySyncStatuses>;
  /** fetch data from the table: "external_entity_sync_statuses" using primary key columns */
  external_entity_sync_statuses_by_pk: Maybe<ExternalEntitySyncStatuses>;
  /** fetch data from the table: "external_risk_scores" */
  external_risk_scores: Array<ExternalRiskScores>;
  /** fetch data from the table: "external_risk_scores" using primary key columns */
  external_risk_scores_by_pk: Maybe<ExternalRiskScores>;
  /** fetch data from the table: "favourite_table_filters" */
  favourite_table_filters: Array<FavouriteTableFilters>;
  /** fetch data from the table: "favourite_table_filters" using primary key columns */
  favourite_table_filters_by_pk: Maybe<FavouriteTableFilters>;
  /** fetch data from the table: "feature_flags" */
  feature_flags: Array<FeatureFlags>;
  /** fetch data from the table: "feature_flags" using primary key columns */
  feature_flags_by_pk: Maybe<FeatureFlags>;
  /** An array relationship */
  financials: Array<Financials>;
  /** fetch data from the table: "financials" using primary key columns */
  financials_by_pk: Maybe<Financials>;
  /** fetch data from the table: "form_template_question_insights" */
  form_template_question_insights: Array<FormTemplateQuestionInsights>;
  /** fetch aggregated fields from the table: "form_template_question_insights" */
  form_template_question_insights_aggregate: FormTemplateQuestionInsightsAggregate;
  /** fetch data from the table: "form_template_question_insights" using primary key columns */
  form_template_question_insights_by_pk: Maybe<FormTemplateQuestionInsights>;
  /** fetch data from the table: "form_template_state" */
  form_template_state: Array<FormTemplateState>;
  /** fetch data from the table: "form_template_state" using primary key columns */
  form_template_state_by_pk: Maybe<FormTemplateState>;
  /** fetch data from the table: "form_templates" */
  form_templates: Array<FormTemplates>;
  /** fetch data from the table: "form_templates" using primary key columns */
  form_templates_by_pk: Maybe<FormTemplates>;
  /** fetch data from the table: "form_type" */
  form_type: Array<FormType>;
  /** fetch data from the table: "form_type" using primary key columns */
  form_type_by_pk: Maybe<FormType>;
  /** execute function "get_all_nodes_until_root_for_ids" which returns "custom_core_data_options" */
  get_all_nodes_until_root_for_ids: Array<CustomCoreDataOptions>;
  /** execute function "get_all_nodes_until_root_for_ids" and query aggregates on result of table type "custom_core_data_options" */
  get_all_nodes_until_root_for_ids_aggregate: CustomCoreDataOptionsAggregate;
  /** execute function "get_custom_core_data_counts" which returns "z_workaround_ccdo_count" */
  get_custom_core_data_counts: Array<ZWorkaroundCcdoCount>;
  /** execute function "get_latest_request_form_submissions" which returns "latest_request_form_submissions" */
  get_latest_request_form_submissions: Array<LatestRequestFormSubmissions>;
  /** execute function "get_latest_request_form_submissions" and query aggregates on result of table type "latest_request_form_submissions" */
  get_latest_request_form_submissions_aggregate: LatestRequestFormSubmissionsAggregate;
  /** execute function "get_latest_request_form_submissions_for_request" which returns "latest_request_form_submissions" */
  get_latest_request_form_submissions_for_request: Array<LatestRequestFormSubmissions>;
  /** execute function "get_latest_request_form_submissions_for_request" and query aggregates on result of table type "latest_request_form_submissions" */
  get_latest_request_form_submissions_for_request_aggregate: LatestRequestFormSubmissionsAggregate;
  /** fetch data from the table: "group_user_assignments" */
  group_user_assignments: Array<GroupUserAssignments>;
  /** fetch aggregated fields from the table: "group_user_assignments" */
  group_user_assignments_aggregate: GroupUserAssignmentsAggregate;
  /** fetch data from the table: "group_user_assignments" using primary key columns */
  group_user_assignments_by_pk: Maybe<GroupUserAssignments>;
  /** An array relationship */
  group_users: Array<GroupUsers>;
  /** fetch data from the table: "group_users" using primary key columns */
  group_users_by_pk: Maybe<GroupUsers>;
  /** fetch data from the table: "groups" */
  groups: Array<Groups>;
  /** fetch data from the table: "groups" using primary key columns */
  groups_by_pk: Maybe<Groups>;
  /** fetch data from the table: "idp_attribute_mappings" */
  idp_attribute_mappings: Array<IdpAttributeMappings>;
  /** fetch data from the table: "idp_attribute_mappings" using primary key columns */
  idp_attribute_mappings_by_pk: Maybe<IdpAttributeMappings>;
  /** An array relationship */
  internal_contacts: Array<InternalContacts>;
  /** fetch data from the table: "internal_contacts" using primary key columns */
  internal_contacts_by_pk: Maybe<InternalContacts>;
  /** fetch data from the table: "latest_request_form_submissions" */
  latest_request_form_submissions: Array<LatestRequestFormSubmissions>;
  /** fetch aggregated fields from the table: "latest_request_form_submissions" */
  latest_request_form_submissions_aggregate: LatestRequestFormSubmissionsAggregate;
  /** fetch data from the table: "line_item_types" */
  line_item_types: Array<LineItemTypes>;
  /** fetch aggregated fields from the table: "line_item_types" */
  line_item_types_aggregate: LineItemTypesAggregate;
  /** fetch data from the table: "line_item_types" using primary key columns */
  line_item_types_by_pk: Maybe<LineItemTypes>;
  /** fetch data from the table: "organisation_core_data_dependencies" */
  organisation_core_data_dependencies: Array<OrganisationCoreDataDependencies>;
  /** fetch data from the table: "organisation_core_data_dependencies" using primary key columns */
  organisation_core_data_dependencies_by_pk: Maybe<OrganisationCoreDataDependencies>;
  /** fetch data from the table: "organisation_feature_flags" */
  organisation_feature_flags: Array<OrganisationFeatureFlags>;
  /** fetch data from the table: "organisation_fx_rates" */
  organisation_fx_rates: Array<OrganisationFxRates>;
  /** fetch aggregated fields from the table: "organisation_fx_rates" */
  organisation_fx_rates_aggregate: OrganisationFxRatesAggregate;
  /** fetch data from the table: "organisation_fx_rates" using primary key columns */
  organisation_fx_rates_by_pk: Maybe<OrganisationFxRates>;
  /** fetch data from the table: "organisation_integration_operations" */
  organisation_integration_operations: Array<OrganisationIntegrationOperations>;
  /** fetch data from the table: "organisation_integration_operations" using primary key columns */
  organisation_integration_operations_by_pk: Maybe<OrganisationIntegrationOperations>;
  /** fetch data from the table: "organisation_integrations" */
  organisation_integrations: Array<OrganisationIntegrations>;
  /** fetch data from the table: "organisation_integrations" using primary key columns */
  organisation_integrations_by_pk: Maybe<OrganisationIntegrations>;
  /** fetch data from the table: "organisation_locales" */
  organisation_locales: Array<OrganisationLocales>;
  /** fetch aggregated fields from the table: "organisation_locales" */
  organisation_locales_aggregate: OrganisationLocalesAggregate;
  /** fetch data from the table: "organisation_locales" using primary key columns */
  organisation_locales_by_pk: Maybe<OrganisationLocales>;
  /** An array relationship */
  organisation_product_supplier_categories: Array<OrganisationProductSupplierCategories>;
  /** fetch data from the table: "organisation_product_supplier_categories" using primary key columns */
  organisation_product_supplier_categories_by_pk: Maybe<OrganisationProductSupplierCategories>;
  /** An array relationship */
  organisation_products_and_services: Array<OrganisationProductsAndServices>;
  /** An aggregate relationship */
  organisation_products_and_services_aggregate: OrganisationProductsAndServicesAggregate;
  /** An array relationship */
  organisation_products_and_services_brands: Array<OrganisationProductsAndServicesBrands>;
  /** fetch data from the table: "organisation_products_and_services_brands" using primary key columns */
  organisation_products_and_services_brands_by_pk: Maybe<OrganisationProductsAndServicesBrands>;
  /** fetch data from the table: "organisation_products_and_services" using primary key columns */
  organisation_products_and_services_by_pk: Maybe<OrganisationProductsAndServices>;
  /** fetch data from the table: "organisation_products_and_services_categories" */
  organisation_products_and_services_categories: Array<OrganisationProductsAndServicesCategories>;
  /** fetch data from the table: "organisation_products_and_services_categories" using primary key columns */
  organisation_products_and_services_categories_by_pk: Maybe<OrganisationProductsAndServicesCategories>;
  /** fetch data from the table: "organisation_products_and_services_state" */
  organisation_products_and_services_state: Array<OrganisationProductsAndServicesState>;
  /** fetch data from the table: "organisation_products_and_services_state" using primary key columns */
  organisation_products_and_services_state_by_pk: Maybe<OrganisationProductsAndServicesState>;
  /** fetch data from the table: "organisation_public_api_clients" */
  organisation_public_api_clients: Array<OrganisationPublicApiClients>;
  /** fetch data from the table: "organisation_public_api_clients" using primary key columns */
  organisation_public_api_clients_by_pk: Maybe<OrganisationPublicApiClients>;
  /** fetch data from the table: "organisation_settings" */
  organisation_settings: Array<OrganisationSettings>;
  /** fetch data from the table: "organisation_settings" using primary key columns */
  organisation_settings_by_pk: Maybe<OrganisationSettings>;
  /** fetch data from the table: "organisation_static_content" */
  organisation_static_content: Array<OrganisationStaticContent>;
  /** fetch aggregated fields from the table: "organisation_static_content" */
  organisation_static_content_aggregate: OrganisationStaticContentAggregate;
  /** fetch data from the table: "organisation_static_content" using primary key columns */
  organisation_static_content_by_pk: Maybe<OrganisationStaticContent>;
  /** fetch data from the table: "organisation_supplier_historic_submissions" */
  organisation_supplier_historic_submissions: Array<OrganisationSupplierHistoricSubmissions>;
  /** fetch data from the table: "organisation_supplier_historic_submissions" using primary key columns */
  organisation_supplier_historic_submissions_by_pk: Maybe<OrganisationSupplierHistoricSubmissions>;
  /** fetch data from the table: "organisation_supplier_online_resources" */
  organisation_supplier_online_resources: Array<OrganisationSupplierOnlineResources>;
  /** fetch data from the table: "organisation_supplier_online_resources" using primary key columns */
  organisation_supplier_online_resources_by_pk: Maybe<OrganisationSupplierOnlineResources>;
  /** fetch data from the table: "organisation_supplier_profile_resources" */
  organisation_supplier_profile_resources: Array<OrganisationSupplierProfileResources>;
  /** fetch data from the table: "organisation_supplier_profile_resources" using primary key columns */
  organisation_supplier_profile_resources_by_pk: Maybe<OrganisationSupplierProfileResources>;
  /** fetch data from the table: "organisation_supplier_profiles" */
  organisation_supplier_profiles: Array<OrganisationSupplierProfiles>;
  /** fetch data from the table: "organisation_supplier_profiles" using primary key columns */
  organisation_supplier_profiles_by_pk: Maybe<OrganisationSupplierProfiles>;
  /** fetch data from the table: "organisation_supplier_state" */
  organisation_supplier_state: Array<OrganisationSupplierState>;
  /** fetch data from the table: "organisation_supplier_state" using primary key columns */
  organisation_supplier_state_by_pk: Maybe<OrganisationSupplierState>;
  /** An array relationship */
  organisation_supplier_tags: Array<OrganisationSupplierTags>;
  /** fetch data from the table: "organisation_supplier_tags" using primary key columns */
  organisation_supplier_tags_by_pk: Maybe<OrganisationSupplierTags>;
  /** An array relationship */
  organisation_suppliers: Array<OrganisationSuppliers>;
  /** An aggregate relationship */
  organisation_suppliers_aggregate: OrganisationSuppliersAggregate;
  /** An array relationship */
  organisation_suppliers_brands: Array<OrganisationSuppliersBrands>;
  /** fetch data from the table: "organisation_suppliers_brands" using primary key columns */
  organisation_suppliers_brands_by_pk: Maybe<OrganisationSuppliersBrands>;
  /** fetch data from the table: "organisation_suppliers" using primary key columns */
  organisation_suppliers_by_pk: Maybe<OrganisationSuppliers>;
  /** An array relationship */
  organisation_suppliers_categories: Array<OrganisationSuppliersCategories>;
  /** fetch data from the table: "organisation_suppliers_categories" using primary key columns */
  organisation_suppliers_categories_by_pk: Maybe<OrganisationSuppliersCategories>;
  /** fetch data from the table: "organisations" */
  organisations: Array<Organisations>;
  /** fetch data from the table: "organisations" using primary key columns */
  organisations_by_pk: Maybe<Organisations>;
  /** fetch data from the table: "out_of_office_delegations" */
  out_of_office_delegations: Array<OutOfOfficeDelegations>;
  /** fetch data from the table: "out_of_office_delegations" using primary key columns */
  out_of_office_delegations_by_pk: Maybe<OutOfOfficeDelegations>;
  /** execute function "paginate_custom_core_data_options" which returns "custom_core_data_options" */
  paginate_custom_core_data_options: Array<CustomCoreDataOptions>;
  /** execute function "paginate_custom_core_data_options" and query aggregates on result of table type "custom_core_data_options" */
  paginate_custom_core_data_options_aggregate: CustomCoreDataOptionsAggregate;
  /** fetch data from the table: "pause_reasons" */
  pause_reasons: Array<PauseReasons>;
  /** fetch data from the table: "pause_reasons" using primary key columns */
  pause_reasons_by_pk: Maybe<PauseReasons>;
  /** fetch data from the table: "payment_interval" */
  payment_interval: Array<PaymentInterval>;
  /** fetch data from the table: "payment_interval" using primary key columns */
  payment_interval_by_pk: Maybe<PaymentInterval>;
  /** fetch data from the table: "payment_methods" */
  payment_methods: Array<PaymentMethods>;
  /** fetch aggregated fields from the table: "payment_methods" */
  payment_methods_aggregate: PaymentMethodsAggregate;
  /** fetch data from the table: "payment_methods" using primary key columns */
  payment_methods_by_pk: Maybe<PaymentMethods>;
  /** fetch data from the table: "payment_terms" */
  payment_terms: Array<PaymentTerms>;
  /** fetch aggregated fields from the table: "payment_terms" */
  payment_terms_aggregate: PaymentTermsAggregate;
  /** fetch data from the table: "payment_terms" using primary key columns */
  payment_terms_by_pk: Maybe<PaymentTerms>;
  /** An array relationship */
  product_catalogue_access_approvers: Array<ProductCatalogueAccessApprovers>;
  /** fetch data from the table: "product_catalogue_access_approvers" using primary key columns */
  product_catalogue_access_approvers_by_pk: Maybe<ProductCatalogueAccessApprovers>;
  /** fetch data from the table: "product_catalogue_entries" */
  product_catalogue_entries: Array<ProductCatalogueEntries>;
  /** fetch data from the table: "product_catalogue_entries" using primary key columns */
  product_catalogue_entries_by_pk: Maybe<ProductCatalogueEntries>;
  /** An array relationship */
  products_and_services: Array<ProductsAndServices>;
  /** fetch data from the table: "products_and_services" using primary key columns */
  products_and_services_by_pk: Maybe<ProductsAndServices>;
  /** An array relationship */
  products_and_services_categories: Array<ProductsAndServicesCategories>;
  /** fetch data from the table: "products_and_services_categories" using primary key columns */
  products_and_services_categories_by_pk: Maybe<ProductsAndServicesCategories>;
  /** fetch data from the table: "products_and_services_similarity_results" */
  products_and_services_similarity_results: Array<ProductsAndServicesSimilarityResults>;
  /** fetch data from the table: "products_and_services_similarity_results" using primary key columns */
  products_and_services_similarity_results_by_pk: Maybe<ProductsAndServicesSimilarityResults>;
  /** execute function "products_and_services_unified_similarity_search_by_product_id" which returns "products_and_services_similarity_results" */
  products_and_services_unified_similarity_search_by_product_id: Array<ProductsAndServicesSimilarityResults>;
  /** execute function "products_and_services_unified_similarity_search_by_query" which returns "products_and_services_similarity_results" */
  products_and_services_unified_similarity_search_by_query: Array<ProductsAndServicesSimilarityResults>;
  /** fetch data from the table: "purchase_order_line_items" */
  purchase_order_line_items: Array<PurchaseOrderLineItems>;
  /** fetch data from the table: "purchase_order_line_items" using primary key columns */
  purchase_order_line_items_by_pk: Maybe<PurchaseOrderLineItems>;
  /** An array relationship */
  purchase_orders: Array<PurchaseOrders>;
  /** fetch data from the table: "purchase_orders" using primary key columns */
  purchase_orders_by_pk: Maybe<PurchaseOrders>;
  /** fetch data from the table: "purchase_type" */
  purchase_type: Array<PurchaseType>;
  /** fetch data from the table: "purchase_type" using primary key columns */
  purchase_type_by_pk: Maybe<PurchaseType>;
  /** fetch data from the table: "renewal_additional_users" */
  renewal_additional_users: Array<RenewalAdditionalUsers>;
  /** An array relationship */
  renewal_tags: Array<RenewalTags>;
  /** fetch data from the table: "renewal_tags" using primary key columns */
  renewal_tags_by_pk: Maybe<RenewalTags>;
  /** An array relationship */
  renewals: Array<Renewals>;
  /** An aggregate relationship */
  renewals_aggregate: RenewalsAggregate;
  /** fetch data from the table: "renewals" using primary key columns */
  renewals_by_pk: Maybe<Renewals>;
  /** fetch data from the table: "request_comment_type" */
  request_comment_type: Array<RequestCommentType>;
  /** fetch data from the table: "request_comment_type" using primary key columns */
  request_comment_type_by_pk: Maybe<RequestCommentType>;
  /** An array relationship */
  request_comments: Array<RequestComments>;
  /** An aggregate relationship */
  request_comments_aggregate: RequestCommentsAggregate;
  /** fetch data from the table: "request_comments" using primary key columns */
  request_comments_by_pk: Maybe<RequestComments>;
  /** fetch data from the table: "request_comments_mentions" */
  request_comments_mentions: Array<RequestCommentsMentions>;
  /** fetch aggregated fields from the table: "request_comments_mentions" */
  request_comments_mentions_aggregate: RequestCommentsMentionsAggregate;
  /** fetch data from the table: "request_comments_mentions" using primary key columns */
  request_comments_mentions_by_pk: Maybe<RequestCommentsMentions>;
  /** fetch data from the table: "request_documents" */
  request_documents: Array<RequestDocuments>;
  /** fetch data from the table: "request_documents" using primary key columns */
  request_documents_by_pk: Maybe<RequestDocuments>;
  /** An array relationship */
  request_esign_documents: Array<RequestEsignDocuments>;
  /** fetch data from the table: "request_esign_documents" using primary key columns */
  request_esign_documents_by_pk: Maybe<RequestEsignDocuments>;
  /** fetch data from the table: "request_followers" */
  request_followers: Array<RequestFollowers>;
  /** fetch aggregated fields from the table: "request_followers" */
  request_followers_aggregate: RequestFollowersAggregate;
  /** fetch data from the table: "request_followers" using primary key columns */
  request_followers_by_pk: Maybe<RequestFollowers>;
  /** fetch data from the table: "request_form_question_ai_score" */
  request_form_question_ai_score: Array<RequestFormQuestionAiScore>;
  /** fetch aggregated fields from the table: "request_form_question_ai_score" */
  request_form_question_ai_score_aggregate: RequestFormQuestionAiScoreAggregate;
  /** fetch data from the table: "request_form_question_ai_score" using primary key columns */
  request_form_question_ai_score_by_pk: Maybe<RequestFormQuestionAiScore>;
  /** fetch data from the table: "request_form_question_score" */
  request_form_question_score: Array<RequestFormQuestionScore>;
  /** fetch data from the table: "request_form_question_score" using primary key columns */
  request_form_question_score_by_pk: Maybe<RequestFormQuestionScore>;
  /** fetch data from the table: "request_form_submission_ai_summary" */
  request_form_submission_ai_summary: Array<RequestFormSubmissionAiSummary>;
  /** fetch data from the table: "request_form_submission_ai_summary" using primary key columns */
  request_form_submission_ai_summary_by_pk: Maybe<RequestFormSubmissionAiSummary>;
  /** fetch data from the table: "request_form_submission_translations" */
  request_form_submission_translations: Array<RequestFormSubmissionTranslations>;
  /** fetch aggregated fields from the table: "request_form_submission_translations" */
  request_form_submission_translations_aggregate: RequestFormSubmissionTranslationsAggregate;
  /** fetch data from the table: "request_form_submission_translations" using primary key columns */
  request_form_submission_translations_by_pk: Maybe<RequestFormSubmissionTranslations>;
  /** An array relationship */
  request_form_submissions: Array<RequestFormSubmissions>;
  /** An aggregate relationship */
  request_form_submissions_aggregate: RequestFormSubmissionsAggregate;
  /** An array relationship */
  request_form_submissions_auto_saves: Array<RequestFormSubmissionsAutoSaves>;
  /** An aggregate relationship */
  request_form_submissions_auto_saves_aggregate: RequestFormSubmissionsAutoSavesAggregate;
  /** fetch data from the table: "request_form_submissions_auto_saves" using primary key columns */
  request_form_submissions_auto_saves_by_pk: Maybe<RequestFormSubmissionsAutoSaves>;
  /** fetch data from the table: "request_form_submissions" using primary key columns */
  request_form_submissions_by_pk: Maybe<RequestFormSubmissions>;
  /** An array relationship */
  request_form_template_reviewers: Array<RequestFormTemplateReviewers>;
  /** fetch data from the table: "request_form_template_reviewers" using primary key columns */
  request_form_template_reviewers_by_pk: Maybe<RequestFormTemplateReviewers>;
  /** An array relationship */
  request_form_templates: Array<RequestFormTemplates>;
  /** fetch data from the table: "request_form_templates" using primary key columns */
  request_form_templates_by_pk: Maybe<RequestFormTemplates>;
  /** An array relationship */
  request_forms: Array<RequestForms>;
  /** fetch data from the table: "request_forms" using primary key columns */
  request_forms_by_pk: Maybe<RequestForms>;
  /** An array relationship */
  request_groups: Array<RequestGroups>;
  /** fetch data from the table: "request_groups" using primary key columns */
  request_groups_by_pk: Maybe<RequestGroups>;
  /** fetch data from the table: "request_leads_config" */
  request_leads_config: Array<RequestLeadsConfig>;
  /** fetch data from the table: "request_leads_config" using primary key columns */
  request_leads_config_by_pk: Maybe<RequestLeadsConfig>;
  /** An array relationship */
  request_pauses: Array<RequestPauses>;
  /** fetch data from the table: "request_pauses" using primary key columns */
  request_pauses_by_pk: Maybe<RequestPauses>;
  /** fetch data from the table: "request_priority" */
  request_priority: Array<RequestPriority>;
  /** fetch data from the table: "request_priority" using primary key columns */
  request_priority_by_pk: Maybe<RequestPriority>;
  /** fetch data from the table: "request_request_leads" */
  request_request_leads: Array<RequestRequestLeads>;
  /** fetch data from the table: "request_request_leads" using primary key columns */
  request_request_leads_by_pk: Maybe<RequestRequestLeads>;
  /** An array relationship */
  request_step_groups: Array<RequestStepGroups>;
  /** fetch data from the table: "request_step_groups" using primary key columns */
  request_step_groups_by_pk: Maybe<RequestStepGroups>;
  /** fetch data from the table: "request_step_notification_messages" */
  request_step_notification_messages: Array<RequestStepNotificationMessages>;
  /** fetch data from the table: "request_step_notification_messages" using primary key columns */
  request_step_notification_messages_by_pk: Maybe<RequestStepNotificationMessages>;
  /** fetch data from the table: "request_step_result" */
  request_step_result: Array<RequestStepResult>;
  /** fetch data from the table: "request_step_result" using primary key columns */
  request_step_result_by_pk: Maybe<RequestStepResult>;
  /** fetch data from the table: "request_step_state" */
  request_step_state: Array<RequestStepState>;
  /** fetch data from the table: "request_step_state" using primary key columns */
  request_step_state_by_pk: Maybe<RequestStepState>;
  /** An array relationship */
  request_step_task_errors: Array<RequestStepTaskErrors>;
  /** fetch data from the table: "request_step_task_errors" using primary key columns */
  request_step_task_errors_by_pk: Maybe<RequestStepTaskErrors>;
  /** An array relationship */
  request_step_task_rejections: Array<RequestStepTaskRejections>;
  /** An aggregate relationship */
  request_step_task_rejections_aggregate: RequestStepTaskRejectionsAggregate;
  /** fetch data from the table: "request_step_task_rejections" using primary key columns */
  request_step_task_rejections_by_pk: Maybe<RequestStepTaskRejections>;
  /** fetch data from the table: "request_step_task_type" */
  request_step_task_type: Array<RequestStepTaskType>;
  /** fetch data from the table: "request_step_task_type" using primary key columns */
  request_step_task_type_by_pk: Maybe<RequestStepTaskType>;
  /** An array relationship */
  request_step_task_users: Array<RequestStepTaskUsers>;
  /** fetch data from the table: "request_step_task_users" using primary key columns */
  request_step_task_users_by_pk: Maybe<RequestStepTaskUsers>;
  /** An array relationship */
  request_step_tasks: Array<RequestStepTasks>;
  /** An aggregate relationship */
  request_step_tasks_aggregate: RequestStepTasksAggregate;
  /** fetch data from the table: "request_step_tasks" using primary key columns */
  request_step_tasks_by_pk: Maybe<RequestStepTasks>;
  /** An array relationship */
  request_step_users: Array<RequestStepUsers>;
  /** fetch data from the table: "request_step_users" using primary key columns */
  request_step_users_by_pk: Maybe<RequestStepUsers>;
  /** fetch data from the table: "request_steps" */
  request_steps: Array<RequestSteps>;
  /** fetch aggregated fields from the table: "request_steps" */
  request_steps_aggregate: RequestStepsAggregate;
  /** fetch data from the table: "request_steps" using primary key columns */
  request_steps_by_pk: Maybe<RequestSteps>;
  /** An array relationship */
  request_tags: Array<RequestTags>;
  /** fetch data from the table: "request_tags" using primary key columns */
  request_tags_by_pk: Maybe<RequestTags>;
  /** fetch data from the table: "request_type" */
  request_type: Array<RequestType>;
  /** fetch data from the table: "request_type" using primary key columns */
  request_type_by_pk: Maybe<RequestType>;
  /** An array relationship */
  request_users: Array<RequestUsers>;
  /** fetch data from the table: "request_users" using primary key columns */
  request_users_by_pk: Maybe<RequestUsers>;
  /** An array relationship */
  requests: Array<Requests>;
  /** An aggregate relationship */
  requests_aggregate: RequestsAggregate;
  /** fetch data from the table: "requests" using primary key columns */
  requests_by_pk: Maybe<Requests>;
  /** fetch data from the table: "rfx" */
  rfx: Array<Rfx>;
  /** fetch data from the table: "rfx_ai_scoring" */
  rfx_ai_scoring: Array<RfxAiScoring>;
  /** fetch aggregated fields from the table: "rfx_ai_scoring" */
  rfx_ai_scoring_aggregate: RfxAiScoringAggregate;
  /** fetch data from the table: "rfx_ai_scoring" using primary key columns */
  rfx_ai_scoring_by_pk: Maybe<RfxAiScoring>;
  /** fetch data from the table: "rfx" using primary key columns */
  rfx_by_pk: Maybe<Rfx>;
  /** fetch data from the table: "rfx_confidentiality_agreement" */
  rfx_confidentiality_agreement: Array<RfxConfidentialityAgreement>;
  /** fetch aggregated fields from the table: "rfx_confidentiality_agreement" */
  rfx_confidentiality_agreement_aggregate: RfxConfidentialityAgreementAggregate;
  /** fetch data from the table: "rfx_confidentiality_agreement" using primary key columns */
  rfx_confidentiality_agreement_by_pk: Maybe<RfxConfidentialityAgreement>;
  /** An array relationship */
  rfx_external_users: Array<RfxExternalUsers>;
  /** fetch data from the table: "rfx_external_users" using primary key columns */
  rfx_external_users_by_pk: Maybe<RfxExternalUsers>;
  /** fetch data from the table: "rfx_owners" */
  rfx_owners: Array<RfxOwners>;
  /** fetch data from the table: "rfx_owners" using primary key columns */
  rfx_owners_by_pk: Maybe<RfxOwners>;
  /** fetch data from the table: "rfx_request_form_template_weighting" */
  rfx_request_form_template_weighting: Array<RfxRequestFormTemplateWeighting>;
  /** fetch data from the table: "rfx_request_form_template_weighting" using primary key columns */
  rfx_request_form_template_weighting_by_pk: Maybe<RfxRequestFormTemplateWeighting>;
  /** fetch data from the table: "rfx_request_form_templates_ranks" */
  rfx_request_form_templates_ranks: Array<RfxRequestFormTemplatesRanks>;
  /** fetch data from the table: "rfx_request_form_templates_ranks" using primary key columns */
  rfx_request_form_templates_ranks_by_pk: Maybe<RfxRequestFormTemplatesRanks>;
  /** An array relationship */
  rfx_suppliers: Array<RfxSuppliers>;
  /** fetch data from the table: "rfx_suppliers" using primary key columns */
  rfx_suppliers_by_pk: Maybe<RfxSuppliers>;
  /** fetch data from the table: "risk_attributes" */
  risk_attributes: Array<RiskAttributes>;
  /** fetch data from the table: "risk_attributes" using primary key columns */
  risk_attributes_by_pk: Maybe<RiskAttributes>;
  /** fetch data from the table: "risk_attributes_type" */
  risk_attributes_type: Array<RiskAttributesType>;
  /** fetch data from the table: "risk_attributes_type" using primary key columns */
  risk_attributes_type_by_pk: Maybe<RiskAttributesType>;
  /** fetch data from the table: "risk_categories" */
  risk_categories: Array<RiskCategories>;
  /** fetch data from the table: "risk_categories" using primary key columns */
  risk_categories_by_pk: Maybe<RiskCategories>;
  /** fetch data from the table: "risk_levels" */
  risk_levels: Array<RiskLevels>;
  /** fetch data from the table: "risk_levels" using primary key columns */
  risk_levels_by_pk: Maybe<RiskLevels>;
  /** fetch data from the table: "risk_levels_type" */
  risk_levels_type: Array<RiskLevelsType>;
  /** fetch data from the table: "risk_levels_type" using primary key columns */
  risk_levels_type_by_pk: Maybe<RiskLevelsType>;
  /** fetch data from the table: "risk_matrix_cells" */
  risk_matrix_cells: Array<RiskMatrixCells>;
  /** fetch data from the table: "risk_matrix_cells" using primary key columns */
  risk_matrix_cells_by_pk: Maybe<RiskMatrixCells>;
  /** fetch data from the table: "risk_owners" */
  risk_owners: Array<RiskOwners>;
  /** fetch data from the table: "risk_owners" using primary key columns */
  risk_owners_by_pk: Maybe<RiskOwners>;
  /** fetch data from the table: "risk_settings" */
  risk_settings: Array<RiskSettings>;
  /** fetch data from the table: "risk_settings" using primary key columns */
  risk_settings_by_pk: Maybe<RiskSettings>;
  /** fetch data from the table: "risk_template_categories" */
  risk_template_categories: Array<RiskTemplateCategories>;
  /** fetch data from the table: "risk_template_categories" using primary key columns */
  risk_template_categories_by_pk: Maybe<RiskTemplateCategories>;
  /** fetch data from the table: "risk_template_owners" */
  risk_template_owners: Array<RiskTemplateOwners>;
  /** fetch data from the table: "risk_template_owners" using primary key columns */
  risk_template_owners_by_pk: Maybe<RiskTemplateOwners>;
  /** fetch data from the table: "risk_templates" */
  risk_templates: Array<RiskTemplates>;
  /** fetch data from the table: "risk_templates" using primary key columns */
  risk_templates_by_pk: Maybe<RiskTemplates>;
  /** fetch data from the table: "risk_users_type" */
  risk_users_type: Array<RiskUsersType>;
  /** fetch data from the table: "risk_users_type" using primary key columns */
  risk_users_type_by_pk: Maybe<RiskUsersType>;
  /** fetch data from the table: "risk_versions" */
  risk_versions: Array<RiskVersions>;
  /** fetch data from the table: "risk_versions" using primary key columns */
  risk_versions_by_pk: Maybe<RiskVersions>;
  /** An array relationship */
  risks: Array<Risks>;
  /** fetch data from the table: "risks" using primary key columns */
  risks_by_pk: Maybe<Risks>;
  /** execute function "search_organisation_products_and_services" which returns "organisation_products_and_services" */
  search_organisation_products_and_services: Array<OrganisationProductsAndServices>;
  /** execute function "search_organisation_products_and_services" and query aggregates on result of table type "organisation_products_and_services" */
  search_organisation_products_and_services_aggregate: OrganisationProductsAndServicesAggregate;
  /** execute function "search_organisation_products_and_services_v2" which returns "organisation_products_and_services" */
  search_organisation_products_and_services_v2: Array<OrganisationProductsAndServices>;
  /** execute function "search_organisation_products_and_services_v2" and query aggregates on result of table type "organisation_products_and_services" */
  search_organisation_products_and_services_v2_aggregate: OrganisationProductsAndServicesAggregate;
  /** execute function "search_organisation_suppliers" which returns "organisation_suppliers" */
  search_organisation_suppliers: Array<OrganisationSuppliers>;
  /** execute function "search_organisation_suppliers" and query aggregates on result of table type "organisation_suppliers" */
  search_organisation_suppliers_aggregate: OrganisationSuppliersAggregate;
  /** execute function "search_organisation_suppliers_v2" which returns "organisation_suppliers" */
  search_organisation_suppliers_v2: Array<OrganisationSuppliers>;
  /** execute function "search_organisation_suppliers_v2" and query aggregates on result of table type "organisation_suppliers" */
  search_organisation_suppliers_v2_aggregate: OrganisationSuppliersAggregate;
  /** execute function "search_organisation_suppliers_v3" which returns "organisation_suppliers" */
  search_organisation_suppliers_v3: Array<OrganisationSuppliers>;
  /** execute function "search_organisation_suppliers_v3" and query aggregates on result of table type "organisation_suppliers" */
  search_organisation_suppliers_v3_aggregate: OrganisationSuppliersAggregate;
  /** execute function "search_products" which returns "products_and_services" */
  search_products: Array<ProductsAndServices>;
  /** execute function "search_suppliers" which returns "suppliers" */
  search_suppliers: Array<Suppliers>;
  /** fetch data from the table: "subsidiaries" */
  subsidiaries: Array<Subsidiaries>;
  /** fetch aggregated fields from the table: "subsidiaries" */
  subsidiaries_aggregate: SubsidiariesAggregate;
  /** fetch data from the table: "subsidiaries" using primary key columns */
  subsidiaries_by_pk: Maybe<Subsidiaries>;
  /** fetch data from the table: "suppliers" */
  suppliers: Array<Suppliers>;
  /** fetch data from the table: "suppliers" using primary key columns */
  suppliers_by_pk: Maybe<Suppliers>;
  /** fetch data from the table: "table_filter_reference" */
  table_filter_reference: Array<TableFilterReference>;
  /** fetch data from the table: "table_filter_reference" using primary key columns */
  table_filter_reference_by_pk: Maybe<TableFilterReference>;
  /** fetch data from the table: "table_filters" */
  table_filters: Array<TableFilters>;
  /** fetch data from the table: "table_filters" using primary key columns */
  table_filters_by_pk: Maybe<TableFilters>;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tags_aggregate: TagsAggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk: Maybe<Tags>;
  /** fetch data from the table: "user_allowed_subsidiaries" */
  user_allowed_subsidiaries: Array<UserAllowedSubsidiaries>;
  /** fetch data from the table: "user_allowed_subsidiaries" using primary key columns */
  user_allowed_subsidiaries_by_pk: Maybe<UserAllowedSubsidiaries>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: UsersAggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk: Maybe<Users>;
  /** execute function "vector_search_products_and_services" which returns "vector_search_similarity_results" */
  vector_search_products_and_services: Array<VectorSearchSimilarityResults>;
  /** fetch data from the table: "vector_search_similarity_results" */
  vector_search_similarity_results: Array<VectorSearchSimilarityResults>;
  /** fetch data from the table: "vector_search_similarity_results" using primary key columns */
  vector_search_similarity_results_by_pk: Maybe<VectorSearchSimilarityResults>;
  /** execute function "vector_search_suppliers" which returns "vector_search_similarity_results" */
  vector_search_suppliers: Array<VectorSearchSimilarityResults>;
  /** An array relationship */
  workflow_condition_groups: Array<WorkflowConditionGroups>;
  /** fetch data from the table: "workflow_condition_groups" using primary key columns */
  workflow_condition_groups_by_pk: Maybe<WorkflowConditionGroups>;
  /** fetch data from the table: "workflow_form_templates" */
  workflow_form_templates: Array<WorkflowFormTemplates>;
  /** fetch data from the table: "workflow_form_templates" using primary key columns */
  workflow_form_templates_by_pk: Maybe<WorkflowFormTemplates>;
  /** fetch data from the table: "workflow_ranks" */
  workflow_ranks: Array<WorkflowRanks>;
  /** fetch data from the table: "workflow_ranks" using primary key columns */
  workflow_ranks_by_pk: Maybe<WorkflowRanks>;
  /** fetch data from the table: "workflow_state" */
  workflow_state: Array<WorkflowState>;
  /** fetch data from the table: "workflow_state" using primary key columns */
  workflow_state_by_pk: Maybe<WorkflowState>;
  /** fetch data from the table: "workflow_type" */
  workflow_type: Array<WorkflowType>;
  /** fetch data from the table: "workflow_type" using primary key columns */
  workflow_type_by_pk: Maybe<WorkflowType>;
  /** An array relationship */
  workflows: Array<Workflows>;
  /** fetch data from the table: "workflows" using primary key columns */
  workflows_by_pk: Maybe<Workflows>;
  /** fetch data from the table: "z_workaround_ccdo_count" */
  z_workaround_ccdo_count: Array<ZWorkaroundCcdoCount>;
};


export type QueryRootAddressesArgs = {
  distinct_on: InputMaybe<Array<AddressesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AddressesOrderBy>>;
  where: InputMaybe<AddressesBoolExp>;
};


export type QueryRootAddressesAggregateArgs = {
  distinct_on: InputMaybe<Array<AddressesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AddressesOrderBy>>;
  where: InputMaybe<AddressesBoolExp>;
};


export type QueryRootAddressesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootAgreementAdditionalOwnersArgs = {
  distinct_on: InputMaybe<Array<AgreementAdditionalOwnersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementAdditionalOwnersOrderBy>>;
  where: InputMaybe<AgreementAdditionalOwnersBoolExp>;
};


export type QueryRootAgreementDocumentsArgs = {
  distinct_on: InputMaybe<Array<AgreementDocumentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementDocumentsOrderBy>>;
  where: InputMaybe<AgreementDocumentsBoolExp>;
};


export type QueryRootAgreementDocumentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootAgreementTagsArgs = {
  distinct_on: InputMaybe<Array<AgreementTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTagsOrderBy>>;
  where: InputMaybe<AgreementTagsBoolExp>;
};


export type QueryRootAgreementTagsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootAgreementTermProductsArgs = {
  distinct_on: InputMaybe<Array<AgreementTermProductsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermProductsOrderBy>>;
  where: InputMaybe<AgreementTermProductsBoolExp>;
};


export type QueryRootAgreementTermProductsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootAgreementTermRevisionsArgs = {
  distinct_on: InputMaybe<Array<AgreementTermRevisionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermRevisionsOrderBy>>;
  where: InputMaybe<AgreementTermRevisionsBoolExp>;
};


export type QueryRootAgreementTermRevisionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootAgreementTermSpendItemsArgs = {
  distinct_on: InputMaybe<Array<AgreementTermSpendItemsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermSpendItemsOrderBy>>;
  where: InputMaybe<AgreementTermSpendItemsBoolExp>;
};


export type QueryRootAgreementTermSpendItemsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootAgreementTermsArgs = {
  distinct_on: InputMaybe<Array<AgreementTermsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermsOrderBy>>;
  where: InputMaybe<AgreementTermsBoolExp>;
};


export type QueryRootAgreementTermsAggregateArgs = {
  distinct_on: InputMaybe<Array<AgreementTermsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermsOrderBy>>;
  where: InputMaybe<AgreementTermsBoolExp>;
};


export type QueryRootAgreementTermsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootAgreementsArgs = {
  distinct_on: InputMaybe<Array<AgreementsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementsOrderBy>>;
  where: InputMaybe<AgreementsBoolExp>;
};


export type QueryRootAgreementsAggregateArgs = {
  distinct_on: InputMaybe<Array<AgreementsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementsOrderBy>>;
  where: InputMaybe<AgreementsBoolExp>;
};


export type QueryRootAgreementsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootAssessmentAdditionalGroupsArgs = {
  distinct_on: InputMaybe<Array<AssessmentAdditionalGroupsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AssessmentAdditionalGroupsOrderBy>>;
  where: InputMaybe<AssessmentAdditionalGroupsBoolExp>;
};


export type QueryRootAssessmentAdditionalUsersArgs = {
  distinct_on: InputMaybe<Array<AssessmentAdditionalUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AssessmentAdditionalUsersOrderBy>>;
  where: InputMaybe<AssessmentAdditionalUsersBoolExp>;
};


export type QueryRootAssessmentFrequencyArgs = {
  distinct_on: InputMaybe<Array<AssessmentFrequencySelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AssessmentFrequencyOrderBy>>;
  where: InputMaybe<AssessmentFrequencyBoolExp>;
};


export type QueryRootAssessmentFrequencyByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootAssessmentTagsArgs = {
  distinct_on: InputMaybe<Array<AssessmentTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AssessmentTagsOrderBy>>;
  where: InputMaybe<AssessmentTagsBoolExp>;
};


export type QueryRootAssessmentTagsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootAssessmentsArgs = {
  distinct_on: InputMaybe<Array<AssessmentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AssessmentsOrderBy>>;
  where: InputMaybe<AssessmentsBoolExp>;
};


export type QueryRootAssessmentsAggregateArgs = {
  distinct_on: InputMaybe<Array<AssessmentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AssessmentsOrderBy>>;
  where: InputMaybe<AssessmentsBoolExp>;
};


export type QueryRootAssessmentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootAssigneeTypeArgs = {
  distinct_on: InputMaybe<Array<AssigneeTypeSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AssigneeTypeOrderBy>>;
  where: InputMaybe<AssigneeTypeBoolExp>;
};


export type QueryRootAssigneeTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootAuthRefreshTokensArgs = {
  distinct_on: InputMaybe<Array<AuthRefreshTokensSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AuthRefreshTokensOrderBy>>;
  where: InputMaybe<AuthRefreshTokensBoolExp>;
};


export type QueryRootAuthRefreshTokensByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootAutoFlaggedScoreCategoriesArgs = {
  distinct_on: InputMaybe<Array<AutoFlaggedScoreCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AutoFlaggedScoreCategoriesOrderBy>>;
  where: InputMaybe<AutoFlaggedScoreCategoriesBoolExp>;
};


export type QueryRootAutoFlaggedScoreCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootBankDetailsArgs = {
  distinct_on: InputMaybe<Array<BankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BankDetailsOrderBy>>;
  where: InputMaybe<BankDetailsBoolExp>;
};


export type QueryRootBankDetailsAggregateArgs = {
  distinct_on: InputMaybe<Array<BankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BankDetailsOrderBy>>;
  where: InputMaybe<BankDetailsBoolExp>;
};


export type QueryRootBankDetailsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootBudgetApprovalGroupArgs = {
  distinct_on: InputMaybe<Array<BudgetApprovalGroupSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetApprovalGroupOrderBy>>;
  where: InputMaybe<BudgetApprovalGroupBoolExp>;
};


export type QueryRootBudgetApprovalGroupAssigneesArgs = {
  distinct_on: InputMaybe<Array<BudgetApprovalGroupAssigneesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetApprovalGroupAssigneesOrderBy>>;
  where: InputMaybe<BudgetApprovalGroupAssigneesBoolExp>;
};


export type QueryRootBudgetApprovalGroupAssigneesAssigneesArgs = {
  distinct_on: InputMaybe<Array<BudgetApprovalGroupAssigneesAssigneesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetApprovalGroupAssigneesAssigneesOrderBy>>;
  where: InputMaybe<BudgetApprovalGroupAssigneesAssigneesBoolExp>;
};


export type QueryRootBudgetApprovalGroupAssigneesAssigneesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootBudgetApprovalGroupAssigneesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootBudgetApprovalGroupAssigneesCustomCoreDataOptionsArgs = {
  distinct_on: InputMaybe<Array<BudgetApprovalGroupAssigneesCustomCoreDataOptionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetApprovalGroupAssigneesCustomCoreDataOptionsOrderBy>>;
  where: InputMaybe<BudgetApprovalGroupAssigneesCustomCoreDataOptionsBoolExp>;
};


export type QueryRootBudgetApprovalGroupAssigneesCustomCoreDataOptionsByPkArgs = {
  budget_approval_group_assignees_id: Scalars['uuid']['input'];
  custom_core_data_id: Scalars['uuid']['input'];
};


export type QueryRootBudgetApprovalGroupByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootBudgetApprovalGroupSelectedCustomCoreDataArgs = {
  distinct_on: InputMaybe<Array<BudgetApprovalGroupSelectedCustomCoreDataSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetApprovalGroupSelectedCustomCoreDataOrderBy>>;
  where: InputMaybe<BudgetApprovalGroupSelectedCustomCoreDataBoolExp>;
};


export type QueryRootBudgetApprovalGroupSelectedCustomCoreDataByPkArgs = {
  budget_approval_group_id: Scalars['uuid']['input'];
  custom_core_data_id: Scalars['uuid']['input'];
};


export type QueryRootBudgetApprovalThresholdArgs = {
  distinct_on: InputMaybe<Array<BudgetApprovalThresholdSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetApprovalThresholdOrderBy>>;
  where: InputMaybe<BudgetApprovalThresholdBoolExp>;
};


export type QueryRootBudgetApprovalThresholdByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootBudgetApprovalThresholdDepartmentArgs = {
  distinct_on: InputMaybe<Array<BudgetApprovalThresholdDepartmentSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetApprovalThresholdDepartmentOrderBy>>;
  where: InputMaybe<BudgetApprovalThresholdDepartmentBoolExp>;
};


export type QueryRootBudgetApprovalThresholdDepartmentByPkArgs = {
  departmentId: Scalars['uuid']['input'];
  thresholdId: Scalars['uuid']['input'];
};


export type QueryRootBudgetApprovalThresholdGroupArgs = {
  distinct_on: InputMaybe<Array<BudgetApprovalThresholdGroupSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetApprovalThresholdGroupOrderBy>>;
  where: InputMaybe<BudgetApprovalThresholdGroupBoolExp>;
};


export type QueryRootBudgetApprovalThresholdGroupByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootBudgetsArgs = {
  distinct_on: InputMaybe<Array<BudgetsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BudgetsOrderBy>>;
  where: InputMaybe<BudgetsBoolExp>;
};


export type QueryRootBudgetsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootBulkDocumentsUploadsArgs = {
  distinct_on: InputMaybe<Array<BulkDocumentsUploadsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BulkDocumentsUploadsOrderBy>>;
  where: InputMaybe<BulkDocumentsUploadsBoolExp>;
};


export type QueryRootBulkDocumentsUploadsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCategoriesArgs = {
  distinct_on: InputMaybe<Array<CategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CategoriesOrderBy>>;
  where: InputMaybe<CategoriesBoolExp>;
};


export type QueryRootCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCategoryArgs = {
  distinct_on: InputMaybe<Array<CategorySelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CategoryOrderBy>>;
  where: InputMaybe<CategoryBoolExp>;
};


export type QueryRootCategoryByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootConfigTranslationsArgs = {
  distinct_on: InputMaybe<Array<ConfigTranslationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ConfigTranslationsOrderBy>>;
  where: InputMaybe<ConfigTranslationsBoolExp>;
};


export type QueryRootConfigTranslationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCoreDataArgs = {
  distinct_on: InputMaybe<Array<CoreDataSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CoreDataOrderBy>>;
  where: InputMaybe<CoreDataBoolExp>;
};


export type QueryRootCoreDataByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCoreDataDependenciesArgs = {
  distinct_on: InputMaybe<Array<CoreDataDependenciesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CoreDataDependenciesOrderBy>>;
  where: InputMaybe<CoreDataDependenciesBoolExp>;
};


export type QueryRootCoreDataDependenciesAggregateArgs = {
  distinct_on: InputMaybe<Array<CoreDataDependenciesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CoreDataDependenciesOrderBy>>;
  where: InputMaybe<CoreDataDependenciesBoolExp>;
};


export type QueryRootCoreDataDependenciesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCoreDataExternalReferencesArgs = {
  distinct_on: InputMaybe<Array<CoreDataExternalReferencesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CoreDataExternalReferencesOrderBy>>;
  where: InputMaybe<CoreDataExternalReferencesBoolExp>;
};


export type QueryRootCoreDataExternalReferencesAggregateArgs = {
  distinct_on: InputMaybe<Array<CoreDataExternalReferencesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CoreDataExternalReferencesOrderBy>>;
  where: InputMaybe<CoreDataExternalReferencesBoolExp>;
};


export type QueryRootCoreDataExternalReferencesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCoreDataOrganisationIntegrationsArgs = {
  distinct_on: InputMaybe<Array<CoreDataOrganisationIntegrationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CoreDataOrganisationIntegrationsOrderBy>>;
  where: InputMaybe<CoreDataOrganisationIntegrationsBoolExp>;
};


export type QueryRootCoreDataOrganisationIntegrationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCustomCoreDataArgs = {
  distinct_on: InputMaybe<Array<CustomCoreDataSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomCoreDataOrderBy>>;
  where: InputMaybe<CustomCoreDataBoolExp>;
};


export type QueryRootCustomCoreDataByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCustomCoreDataOptionsArgs = {
  distinct_on: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomCoreDataOptionsOrderBy>>;
  where: InputMaybe<CustomCoreDataOptionsBoolExp>;
};


export type QueryRootCustomCoreDataOptionsAggregateArgs = {
  distinct_on: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomCoreDataOptionsOrderBy>>;
  where: InputMaybe<CustomCoreDataOptionsBoolExp>;
};


export type QueryRootCustomCoreDataOptionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCustomDocumentTypesArgs = {
  distinct_on: InputMaybe<Array<CustomDocumentTypesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomDocumentTypesOrderBy>>;
  where: InputMaybe<CustomDocumentTypesBoolExp>;
};


export type QueryRootCustomDocumentTypesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCustomFieldChoicesArgs = {
  distinct_on: InputMaybe<Array<CustomFieldChoicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldChoicesOrderBy>>;
  where: InputMaybe<CustomFieldChoicesBoolExp>;
};


export type QueryRootCustomFieldChoicesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCustomFieldCoreDataArgs = {
  distinct_on: InputMaybe<Array<CustomFieldCoreDataSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldCoreDataOrderBy>>;
  where: InputMaybe<CustomFieldCoreDataBoolExp>;
};


export type QueryRootCustomFieldCoreDataByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCustomFieldValuesArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


export type QueryRootCustomFieldValuesAggregateArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


export type QueryRootCustomFieldValuesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCustomFieldsArgs = {
  distinct_on: InputMaybe<Array<CustomFieldsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldsOrderBy>>;
  where: InputMaybe<CustomFieldsBoolExp>;
};


export type QueryRootCustomFieldsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCustomReportsArgs = {
  distinct_on: InputMaybe<Array<CustomReportsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomReportsOrderBy>>;
  where: InputMaybe<CustomReportsBoolExp>;
};


export type QueryRootCustomReportsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootCustomReportsGenerationsArgs = {
  distinct_on: InputMaybe<Array<CustomReportsGenerationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomReportsGenerationsOrderBy>>;
  where: InputMaybe<CustomReportsGenerationsBoolExp>;
};


export type QueryRootCustomReportsGenerationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootDepartmentsArgs = {
  distinct_on: InputMaybe<Array<DepartmentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<DepartmentsOrderBy>>;
  where: InputMaybe<DepartmentsBoolExp>;
};


export type QueryRootDepartmentsAggregateArgs = {
  distinct_on: InputMaybe<Array<DepartmentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<DepartmentsOrderBy>>;
  where: InputMaybe<DepartmentsBoolExp>;
};


export type QueryRootDepartmentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootDocumentTypesArgs = {
  distinct_on: InputMaybe<Array<DocumentTypesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<DocumentTypesOrderBy>>;
  where: InputMaybe<DocumentTypesBoolExp>;
};


export type QueryRootDocumentTypesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootDocumentsArgs = {
  distinct_on: InputMaybe<Array<DocumentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<DocumentsOrderBy>>;
  where: InputMaybe<DocumentsBoolExp>;
};


export type QueryRootDocumentsAggregateArgs = {
  distinct_on: InputMaybe<Array<DocumentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<DocumentsOrderBy>>;
  where: InputMaybe<DocumentsBoolExp>;
};


export type QueryRootDocumentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootDraftIntakeSubmissionsArgs = {
  distinct_on: InputMaybe<Array<DraftIntakeSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<DraftIntakeSubmissionsOrderBy>>;
  where: InputMaybe<DraftIntakeSubmissionsBoolExp>;
};


export type QueryRootDraftIntakeSubmissionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootEngagementsArgs = {
  distinct_on: InputMaybe<Array<EngagementsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EngagementsOrderBy>>;
  where: InputMaybe<EngagementsBoolExp>;
};


export type QueryRootEngagementsAggregateArgs = {
  distinct_on: InputMaybe<Array<EngagementsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EngagementsOrderBy>>;
  where: InputMaybe<EngagementsBoolExp>;
};


export type QueryRootEngagementsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootEntityBankDetailsArgs = {
  distinct_on: InputMaybe<Array<EntityBankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityBankDetailsOrderBy>>;
  where: InputMaybe<EntityBankDetailsBoolExp>;
};


export type QueryRootEntityBankDetailsAggregateArgs = {
  distinct_on: InputMaybe<Array<EntityBankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityBankDetailsOrderBy>>;
  where: InputMaybe<EntityBankDetailsBoolExp>;
};


export type QueryRootEntityBankDetailsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootEntityFieldGroupFieldsArgs = {
  distinct_on: InputMaybe<Array<EntityFieldGroupFieldsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityFieldGroupFieldsOrderBy>>;
  where: InputMaybe<EntityFieldGroupFieldsBoolExp>;
};


export type QueryRootEntityFieldGroupFieldsAggregateArgs = {
  distinct_on: InputMaybe<Array<EntityFieldGroupFieldsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityFieldGroupFieldsOrderBy>>;
  where: InputMaybe<EntityFieldGroupFieldsBoolExp>;
};


export type QueryRootEntityFieldGroupFieldsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootEntityFieldGroupsArgs = {
  distinct_on: InputMaybe<Array<EntityFieldGroupsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityFieldGroupsOrderBy>>;
  where: InputMaybe<EntityFieldGroupsBoolExp>;
};


export type QueryRootEntityFieldGroupsAggregateArgs = {
  distinct_on: InputMaybe<Array<EntityFieldGroupsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityFieldGroupsOrderBy>>;
  where: InputMaybe<EntityFieldGroupsBoolExp>;
};


export type QueryRootEntityFieldGroupsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootExternalContactsArgs = {
  distinct_on: InputMaybe<Array<ExternalContactsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ExternalContactsOrderBy>>;
  where: InputMaybe<ExternalContactsBoolExp>;
};


export type QueryRootExternalContactsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootExternalEntitySyncStatusesArgs = {
  distinct_on: InputMaybe<Array<ExternalEntitySyncStatusesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ExternalEntitySyncStatusesOrderBy>>;
  where: InputMaybe<ExternalEntitySyncStatusesBoolExp>;
};


export type QueryRootExternalEntitySyncStatusesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootExternalRiskScoresArgs = {
  distinct_on: InputMaybe<Array<ExternalRiskScoresSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ExternalRiskScoresOrderBy>>;
  where: InputMaybe<ExternalRiskScoresBoolExp>;
};


export type QueryRootExternalRiskScoresByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootFavouriteTableFiltersArgs = {
  distinct_on: InputMaybe<Array<FavouriteTableFiltersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FavouriteTableFiltersOrderBy>>;
  where: InputMaybe<FavouriteTableFiltersBoolExp>;
};


export type QueryRootFavouriteTableFiltersByPkArgs = {
  table_filter_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type QueryRootFeatureFlagsArgs = {
  distinct_on: InputMaybe<Array<FeatureFlagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FeatureFlagsOrderBy>>;
  where: InputMaybe<FeatureFlagsBoolExp>;
};


export type QueryRootFeatureFlagsByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootFinancialsArgs = {
  distinct_on: InputMaybe<Array<FinancialsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FinancialsOrderBy>>;
  where: InputMaybe<FinancialsBoolExp>;
};


export type QueryRootFinancialsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootFormTemplateQuestionInsightsArgs = {
  distinct_on: InputMaybe<Array<FormTemplateQuestionInsightsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FormTemplateQuestionInsightsOrderBy>>;
  where: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
};


export type QueryRootFormTemplateQuestionInsightsAggregateArgs = {
  distinct_on: InputMaybe<Array<FormTemplateQuestionInsightsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FormTemplateQuestionInsightsOrderBy>>;
  where: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
};


export type QueryRootFormTemplateQuestionInsightsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootFormTemplateStateArgs = {
  distinct_on: InputMaybe<Array<FormTemplateStateSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FormTemplateStateOrderBy>>;
  where: InputMaybe<FormTemplateStateBoolExp>;
};


export type QueryRootFormTemplateStateByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootFormTemplatesArgs = {
  distinct_on: InputMaybe<Array<FormTemplatesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FormTemplatesOrderBy>>;
  where: InputMaybe<FormTemplatesBoolExp>;
};


export type QueryRootFormTemplatesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootFormTypeArgs = {
  distinct_on: InputMaybe<Array<FormTypeSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FormTypeOrderBy>>;
  where: InputMaybe<FormTypeBoolExp>;
};


export type QueryRootFormTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootGetAllNodesUntilRootForIdsArgs = {
  args: GetAllNodesUntilRootForIdsArgs;
  distinct_on: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomCoreDataOptionsOrderBy>>;
  where: InputMaybe<CustomCoreDataOptionsBoolExp>;
};


export type QueryRootGetAllNodesUntilRootForIdsAggregateArgs = {
  args: GetAllNodesUntilRootForIdsArgs;
  distinct_on: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomCoreDataOptionsOrderBy>>;
  where: InputMaybe<CustomCoreDataOptionsBoolExp>;
};


export type QueryRootGetCustomCoreDataCountsArgs = {
  args: GetCustomCoreDataCountsArgs;
  distinct_on: InputMaybe<Array<ZWorkaroundCcdoCountSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ZWorkaroundCcdoCountOrderBy>>;
  where: InputMaybe<ZWorkaroundCcdoCountBoolExp>;
};


export type QueryRootGetLatestRequestFormSubmissionsArgs = {
  args: GetLatestRequestFormSubmissionsArgs;
  distinct_on: InputMaybe<Array<LatestRequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<LatestRequestFormSubmissionsOrderBy>>;
  where: InputMaybe<LatestRequestFormSubmissionsBoolExp>;
};


export type QueryRootGetLatestRequestFormSubmissionsAggregateArgs = {
  args: GetLatestRequestFormSubmissionsArgs;
  distinct_on: InputMaybe<Array<LatestRequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<LatestRequestFormSubmissionsOrderBy>>;
  where: InputMaybe<LatestRequestFormSubmissionsBoolExp>;
};


export type QueryRootGetLatestRequestFormSubmissionsForRequestArgs = {
  args: GetLatestRequestFormSubmissionsForRequestArgs;
  distinct_on: InputMaybe<Array<LatestRequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<LatestRequestFormSubmissionsOrderBy>>;
  where: InputMaybe<LatestRequestFormSubmissionsBoolExp>;
};


export type QueryRootGetLatestRequestFormSubmissionsForRequestAggregateArgs = {
  args: GetLatestRequestFormSubmissionsForRequestArgs;
  distinct_on: InputMaybe<Array<LatestRequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<LatestRequestFormSubmissionsOrderBy>>;
  where: InputMaybe<LatestRequestFormSubmissionsBoolExp>;
};


export type QueryRootGroupUserAssignmentsArgs = {
  distinct_on: InputMaybe<Array<GroupUserAssignmentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<GroupUserAssignmentsOrderBy>>;
  where: InputMaybe<GroupUserAssignmentsBoolExp>;
};


export type QueryRootGroupUserAssignmentsAggregateArgs = {
  distinct_on: InputMaybe<Array<GroupUserAssignmentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<GroupUserAssignmentsOrderBy>>;
  where: InputMaybe<GroupUserAssignmentsBoolExp>;
};


export type QueryRootGroupUserAssignmentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootGroupUsersArgs = {
  distinct_on: InputMaybe<Array<GroupUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<GroupUsersOrderBy>>;
  where: InputMaybe<GroupUsersBoolExp>;
};


export type QueryRootGroupUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootGroupsArgs = {
  distinct_on: InputMaybe<Array<GroupsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<GroupsOrderBy>>;
  where: InputMaybe<GroupsBoolExp>;
};


export type QueryRootGroupsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootIdpAttributeMappingsArgs = {
  distinct_on: InputMaybe<Array<IdpAttributeMappingsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<IdpAttributeMappingsOrderBy>>;
  where: InputMaybe<IdpAttributeMappingsBoolExp>;
};


export type QueryRootIdpAttributeMappingsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootInternalContactsArgs = {
  distinct_on: InputMaybe<Array<InternalContactsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<InternalContactsOrderBy>>;
  where: InputMaybe<InternalContactsBoolExp>;
};


export type QueryRootInternalContactsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootLatestRequestFormSubmissionsArgs = {
  distinct_on: InputMaybe<Array<LatestRequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<LatestRequestFormSubmissionsOrderBy>>;
  where: InputMaybe<LatestRequestFormSubmissionsBoolExp>;
};


export type QueryRootLatestRequestFormSubmissionsAggregateArgs = {
  distinct_on: InputMaybe<Array<LatestRequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<LatestRequestFormSubmissionsOrderBy>>;
  where: InputMaybe<LatestRequestFormSubmissionsBoolExp>;
};


export type QueryRootLineItemTypesArgs = {
  distinct_on: InputMaybe<Array<LineItemTypesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<LineItemTypesOrderBy>>;
  where: InputMaybe<LineItemTypesBoolExp>;
};


export type QueryRootLineItemTypesAggregateArgs = {
  distinct_on: InputMaybe<Array<LineItemTypesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<LineItemTypesOrderBy>>;
  where: InputMaybe<LineItemTypesBoolExp>;
};


export type QueryRootLineItemTypesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationCoreDataDependenciesArgs = {
  distinct_on: InputMaybe<Array<OrganisationCoreDataDependenciesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationCoreDataDependenciesOrderBy>>;
  where: InputMaybe<OrganisationCoreDataDependenciesBoolExp>;
};


export type QueryRootOrganisationCoreDataDependenciesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationFeatureFlagsArgs = {
  distinct_on: InputMaybe<Array<OrganisationFeatureFlagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationFeatureFlagsOrderBy>>;
  where: InputMaybe<OrganisationFeatureFlagsBoolExp>;
};


export type QueryRootOrganisationFxRatesArgs = {
  distinct_on: InputMaybe<Array<OrganisationFxRatesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationFxRatesOrderBy>>;
  where: InputMaybe<OrganisationFxRatesBoolExp>;
};


export type QueryRootOrganisationFxRatesAggregateArgs = {
  distinct_on: InputMaybe<Array<OrganisationFxRatesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationFxRatesOrderBy>>;
  where: InputMaybe<OrganisationFxRatesBoolExp>;
};


export type QueryRootOrganisationFxRatesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationIntegrationOperationsArgs = {
  distinct_on: InputMaybe<Array<OrganisationIntegrationOperationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationIntegrationOperationsOrderBy>>;
  where: InputMaybe<OrganisationIntegrationOperationsBoolExp>;
};


export type QueryRootOrganisationIntegrationOperationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationIntegrationsArgs = {
  distinct_on: InputMaybe<Array<OrganisationIntegrationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationIntegrationsOrderBy>>;
  where: InputMaybe<OrganisationIntegrationsBoolExp>;
};


export type QueryRootOrganisationIntegrationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationLocalesArgs = {
  distinct_on: InputMaybe<Array<OrganisationLocalesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationLocalesOrderBy>>;
  where: InputMaybe<OrganisationLocalesBoolExp>;
};


export type QueryRootOrganisationLocalesAggregateArgs = {
  distinct_on: InputMaybe<Array<OrganisationLocalesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationLocalesOrderBy>>;
  where: InputMaybe<OrganisationLocalesBoolExp>;
};


export type QueryRootOrganisationLocalesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationProductSupplierCategoriesArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductSupplierCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductSupplierCategoriesOrderBy>>;
  where: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
};


export type QueryRootOrganisationProductSupplierCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationProductsAndServicesArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


export type QueryRootOrganisationProductsAndServicesAggregateArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


export type QueryRootOrganisationProductsAndServicesBrandsArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesBrandsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesBrandsOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
};


export type QueryRootOrganisationProductsAndServicesBrandsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationProductsAndServicesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationProductsAndServicesCategoriesArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesCategoriesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesCategoriesBoolExp>;
};


export type QueryRootOrganisationProductsAndServicesCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationProductsAndServicesStateArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesStateSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesStateOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesStateBoolExp>;
};


export type QueryRootOrganisationProductsAndServicesStateByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootOrganisationPublicApiClientsArgs = {
  distinct_on: InputMaybe<Array<OrganisationPublicApiClientsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationPublicApiClientsOrderBy>>;
  where: InputMaybe<OrganisationPublicApiClientsBoolExp>;
};


export type QueryRootOrganisationPublicApiClientsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationSettingsArgs = {
  distinct_on: InputMaybe<Array<OrganisationSettingsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSettingsOrderBy>>;
  where: InputMaybe<OrganisationSettingsBoolExp>;
};


export type QueryRootOrganisationSettingsByPkArgs = {
  name: Scalars['String']['input'];
  organisationId: Scalars['uuid']['input'];
};


export type QueryRootOrganisationStaticContentArgs = {
  distinct_on: InputMaybe<Array<OrganisationStaticContentSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationStaticContentOrderBy>>;
  where: InputMaybe<OrganisationStaticContentBoolExp>;
};


export type QueryRootOrganisationStaticContentAggregateArgs = {
  distinct_on: InputMaybe<Array<OrganisationStaticContentSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationStaticContentOrderBy>>;
  where: InputMaybe<OrganisationStaticContentBoolExp>;
};


export type QueryRootOrganisationStaticContentByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationSupplierHistoricSubmissionsArgs = {
  distinct_on: InputMaybe<Array<OrganisationSupplierHistoricSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSupplierHistoricSubmissionsOrderBy>>;
  where: InputMaybe<OrganisationSupplierHistoricSubmissionsBoolExp>;
};


export type QueryRootOrganisationSupplierHistoricSubmissionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationSupplierOnlineResourcesArgs = {
  distinct_on: InputMaybe<Array<OrganisationSupplierOnlineResourcesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSupplierOnlineResourcesOrderBy>>;
  where: InputMaybe<OrganisationSupplierOnlineResourcesBoolExp>;
};


export type QueryRootOrganisationSupplierOnlineResourcesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationSupplierProfileResourcesArgs = {
  distinct_on: InputMaybe<Array<OrganisationSupplierProfileResourcesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSupplierProfileResourcesOrderBy>>;
  where: InputMaybe<OrganisationSupplierProfileResourcesBoolExp>;
};


export type QueryRootOrganisationSupplierProfileResourcesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationSupplierProfilesArgs = {
  distinct_on: InputMaybe<Array<OrganisationSupplierProfilesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSupplierProfilesOrderBy>>;
  where: InputMaybe<OrganisationSupplierProfilesBoolExp>;
};


export type QueryRootOrganisationSupplierProfilesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationSupplierStateArgs = {
  distinct_on: InputMaybe<Array<OrganisationSupplierStateSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSupplierStateOrderBy>>;
  where: InputMaybe<OrganisationSupplierStateBoolExp>;
};


export type QueryRootOrganisationSupplierStateByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootOrganisationSupplierTagsArgs = {
  distinct_on: InputMaybe<Array<OrganisationSupplierTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSupplierTagsOrderBy>>;
  where: InputMaybe<OrganisationSupplierTagsBoolExp>;
};


export type QueryRootOrganisationSupplierTagsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationSuppliersArgs = {
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


export type QueryRootOrganisationSuppliersAggregateArgs = {
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


export type QueryRootOrganisationSuppliersBrandsArgs = {
  distinct_on: InputMaybe<Array<OrganisationSuppliersBrandsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersBrandsOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBrandsBoolExp>;
};


export type QueryRootOrganisationSuppliersBrandsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationSuppliersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationSuppliersCategoriesArgs = {
  distinct_on: InputMaybe<Array<OrganisationSuppliersCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersCategoriesOrderBy>>;
  where: InputMaybe<OrganisationSuppliersCategoriesBoolExp>;
};


export type QueryRootOrganisationSuppliersCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOrganisationsArgs = {
  distinct_on: InputMaybe<Array<OrganisationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationsOrderBy>>;
  where: InputMaybe<OrganisationsBoolExp>;
};


export type QueryRootOrganisationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootOutOfOfficeDelegationsArgs = {
  distinct_on: InputMaybe<Array<OutOfOfficeDelegationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OutOfOfficeDelegationsOrderBy>>;
  where: InputMaybe<OutOfOfficeDelegationsBoolExp>;
};


export type QueryRootOutOfOfficeDelegationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootPaginateCustomCoreDataOptionsArgs = {
  args: PaginateCustomCoreDataOptionsArgs;
  distinct_on: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomCoreDataOptionsOrderBy>>;
  where: InputMaybe<CustomCoreDataOptionsBoolExp>;
};


export type QueryRootPaginateCustomCoreDataOptionsAggregateArgs = {
  args: PaginateCustomCoreDataOptionsArgs;
  distinct_on: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomCoreDataOptionsOrderBy>>;
  where: InputMaybe<CustomCoreDataOptionsBoolExp>;
};


export type QueryRootPauseReasonsArgs = {
  distinct_on: InputMaybe<Array<PauseReasonsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<PauseReasonsOrderBy>>;
  where: InputMaybe<PauseReasonsBoolExp>;
};


export type QueryRootPauseReasonsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootPaymentIntervalArgs = {
  distinct_on: InputMaybe<Array<PaymentIntervalSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<PaymentIntervalOrderBy>>;
  where: InputMaybe<PaymentIntervalBoolExp>;
};


export type QueryRootPaymentIntervalByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootPaymentMethodsArgs = {
  distinct_on: InputMaybe<Array<PaymentMethodsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<PaymentMethodsOrderBy>>;
  where: InputMaybe<PaymentMethodsBoolExp>;
};


export type QueryRootPaymentMethodsAggregateArgs = {
  distinct_on: InputMaybe<Array<PaymentMethodsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<PaymentMethodsOrderBy>>;
  where: InputMaybe<PaymentMethodsBoolExp>;
};


export type QueryRootPaymentMethodsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootPaymentTermsArgs = {
  distinct_on: InputMaybe<Array<PaymentTermsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<PaymentTermsOrderBy>>;
  where: InputMaybe<PaymentTermsBoolExp>;
};


export type QueryRootPaymentTermsAggregateArgs = {
  distinct_on: InputMaybe<Array<PaymentTermsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<PaymentTermsOrderBy>>;
  where: InputMaybe<PaymentTermsBoolExp>;
};


export type QueryRootPaymentTermsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootProductCatalogueAccessApproversArgs = {
  distinct_on: InputMaybe<Array<ProductCatalogueAccessApproversSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductCatalogueAccessApproversOrderBy>>;
  where: InputMaybe<ProductCatalogueAccessApproversBoolExp>;
};


export type QueryRootProductCatalogueAccessApproversByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootProductCatalogueEntriesArgs = {
  distinct_on: InputMaybe<Array<ProductCatalogueEntriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductCatalogueEntriesOrderBy>>;
  where: InputMaybe<ProductCatalogueEntriesBoolExp>;
};


export type QueryRootProductCatalogueEntriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootProductsAndServicesArgs = {
  distinct_on: InputMaybe<Array<ProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductsAndServicesOrderBy>>;
  where: InputMaybe<ProductsAndServicesBoolExp>;
};


export type QueryRootProductsAndServicesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootProductsAndServicesCategoriesArgs = {
  distinct_on: InputMaybe<Array<ProductsAndServicesCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductsAndServicesCategoriesOrderBy>>;
  where: InputMaybe<ProductsAndServicesCategoriesBoolExp>;
};


export type QueryRootProductsAndServicesCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootProductsAndServicesSimilarityResultsArgs = {
  distinct_on: InputMaybe<Array<ProductsAndServicesSimilarityResultsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductsAndServicesSimilarityResultsOrderBy>>;
  where: InputMaybe<ProductsAndServicesSimilarityResultsBoolExp>;
};


export type QueryRootProductsAndServicesSimilarityResultsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootProductsAndServicesUnifiedSimilaritySearchByProductIdArgs = {
  args: ProductsAndServicesUnifiedSimilaritySearchByProductIdArgs;
  distinct_on: InputMaybe<Array<ProductsAndServicesSimilarityResultsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductsAndServicesSimilarityResultsOrderBy>>;
  where: InputMaybe<ProductsAndServicesSimilarityResultsBoolExp>;
};


export type QueryRootProductsAndServicesUnifiedSimilaritySearchByQueryArgs = {
  args: ProductsAndServicesUnifiedSimilaritySearchByQueryArgs;
  distinct_on: InputMaybe<Array<ProductsAndServicesSimilarityResultsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductsAndServicesSimilarityResultsOrderBy>>;
  where: InputMaybe<ProductsAndServicesSimilarityResultsBoolExp>;
};


export type QueryRootPurchaseOrderLineItemsArgs = {
  distinct_on: InputMaybe<Array<PurchaseOrderLineItemsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<PurchaseOrderLineItemsOrderBy>>;
  where: InputMaybe<PurchaseOrderLineItemsBoolExp>;
};


export type QueryRootPurchaseOrderLineItemsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootPurchaseOrdersArgs = {
  distinct_on: InputMaybe<Array<PurchaseOrdersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<PurchaseOrdersOrderBy>>;
  where: InputMaybe<PurchaseOrdersBoolExp>;
};


export type QueryRootPurchaseOrdersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootPurchaseTypeArgs = {
  distinct_on: InputMaybe<Array<PurchaseTypeSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<PurchaseTypeOrderBy>>;
  where: InputMaybe<PurchaseTypeBoolExp>;
};


export type QueryRootPurchaseTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootRenewalAdditionalUsersArgs = {
  distinct_on: InputMaybe<Array<RenewalAdditionalUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalAdditionalUsersOrderBy>>;
  where: InputMaybe<RenewalAdditionalUsersBoolExp>;
};


export type QueryRootRenewalTagsArgs = {
  distinct_on: InputMaybe<Array<RenewalTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalTagsOrderBy>>;
  where: InputMaybe<RenewalTagsBoolExp>;
};


export type QueryRootRenewalTagsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRenewalsArgs = {
  distinct_on: InputMaybe<Array<RenewalsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalsOrderBy>>;
  where: InputMaybe<RenewalsBoolExp>;
};


export type QueryRootRenewalsAggregateArgs = {
  distinct_on: InputMaybe<Array<RenewalsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalsOrderBy>>;
  where: InputMaybe<RenewalsBoolExp>;
};


export type QueryRootRenewalsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestCommentTypeArgs = {
  distinct_on: InputMaybe<Array<RequestCommentTypeSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestCommentTypeOrderBy>>;
  where: InputMaybe<RequestCommentTypeBoolExp>;
};


export type QueryRootRequestCommentTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootRequestCommentsArgs = {
  distinct_on: InputMaybe<Array<RequestCommentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestCommentsOrderBy>>;
  where: InputMaybe<RequestCommentsBoolExp>;
};


export type QueryRootRequestCommentsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestCommentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestCommentsOrderBy>>;
  where: InputMaybe<RequestCommentsBoolExp>;
};


export type QueryRootRequestCommentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestCommentsMentionsArgs = {
  distinct_on: InputMaybe<Array<RequestCommentsMentionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestCommentsMentionsOrderBy>>;
  where: InputMaybe<RequestCommentsMentionsBoolExp>;
};


export type QueryRootRequestCommentsMentionsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestCommentsMentionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestCommentsMentionsOrderBy>>;
  where: InputMaybe<RequestCommentsMentionsBoolExp>;
};


export type QueryRootRequestCommentsMentionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestDocumentsArgs = {
  distinct_on: InputMaybe<Array<RequestDocumentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestDocumentsOrderBy>>;
  where: InputMaybe<RequestDocumentsBoolExp>;
};


export type QueryRootRequestDocumentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestEsignDocumentsArgs = {
  distinct_on: InputMaybe<Array<RequestEsignDocumentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestEsignDocumentsOrderBy>>;
  where: InputMaybe<RequestEsignDocumentsBoolExp>;
};


export type QueryRootRequestEsignDocumentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestFollowersArgs = {
  distinct_on: InputMaybe<Array<RequestFollowersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFollowersOrderBy>>;
  where: InputMaybe<RequestFollowersBoolExp>;
};


export type QueryRootRequestFollowersAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestFollowersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFollowersOrderBy>>;
  where: InputMaybe<RequestFollowersBoolExp>;
};


export type QueryRootRequestFollowersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestFormQuestionAiScoreArgs = {
  distinct_on: InputMaybe<Array<RequestFormQuestionAiScoreSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormQuestionAiScoreOrderBy>>;
  where: InputMaybe<RequestFormQuestionAiScoreBoolExp>;
};


export type QueryRootRequestFormQuestionAiScoreAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestFormQuestionAiScoreSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormQuestionAiScoreOrderBy>>;
  where: InputMaybe<RequestFormQuestionAiScoreBoolExp>;
};


export type QueryRootRequestFormQuestionAiScoreByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestFormQuestionScoreArgs = {
  distinct_on: InputMaybe<Array<RequestFormQuestionScoreSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormQuestionScoreOrderBy>>;
  where: InputMaybe<RequestFormQuestionScoreBoolExp>;
};


export type QueryRootRequestFormQuestionScoreByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestFormSubmissionAiSummaryArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionAiSummarySelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionAiSummaryOrderBy>>;
  where: InputMaybe<RequestFormSubmissionAiSummaryBoolExp>;
};


export type QueryRootRequestFormSubmissionAiSummaryByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestFormSubmissionTranslationsArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionTranslationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionTranslationsOrderBy>>;
  where: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
};


export type QueryRootRequestFormSubmissionTranslationsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionTranslationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionTranslationsOrderBy>>;
  where: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
};


export type QueryRootRequestFormSubmissionTranslationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestFormSubmissionsArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionsOrderBy>>;
  where: InputMaybe<RequestFormSubmissionsBoolExp>;
};


export type QueryRootRequestFormSubmissionsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionsOrderBy>>;
  where: InputMaybe<RequestFormSubmissionsBoolExp>;
};


export type QueryRootRequestFormSubmissionsAutoSavesArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionsAutoSavesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionsAutoSavesOrderBy>>;
  where: InputMaybe<RequestFormSubmissionsAutoSavesBoolExp>;
};


export type QueryRootRequestFormSubmissionsAutoSavesAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionsAutoSavesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionsAutoSavesOrderBy>>;
  where: InputMaybe<RequestFormSubmissionsAutoSavesBoolExp>;
};


export type QueryRootRequestFormSubmissionsAutoSavesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestFormSubmissionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestFormTemplateReviewersArgs = {
  distinct_on: InputMaybe<Array<RequestFormTemplateReviewersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormTemplateReviewersOrderBy>>;
  where: InputMaybe<RequestFormTemplateReviewersBoolExp>;
};


export type QueryRootRequestFormTemplateReviewersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestFormTemplatesArgs = {
  distinct_on: InputMaybe<Array<RequestFormTemplatesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormTemplatesOrderBy>>;
  where: InputMaybe<RequestFormTemplatesBoolExp>;
};


export type QueryRootRequestFormTemplatesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestFormsArgs = {
  distinct_on: InputMaybe<Array<RequestFormsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormsOrderBy>>;
  where: InputMaybe<RequestFormsBoolExp>;
};


export type QueryRootRequestFormsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestGroupsArgs = {
  distinct_on: InputMaybe<Array<RequestGroupsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestGroupsOrderBy>>;
  where: InputMaybe<RequestGroupsBoolExp>;
};


export type QueryRootRequestGroupsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestLeadsConfigArgs = {
  distinct_on: InputMaybe<Array<RequestLeadsConfigSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestLeadsConfigOrderBy>>;
  where: InputMaybe<RequestLeadsConfigBoolExp>;
};


export type QueryRootRequestLeadsConfigByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestPausesArgs = {
  distinct_on: InputMaybe<Array<RequestPausesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestPausesOrderBy>>;
  where: InputMaybe<RequestPausesBoolExp>;
};


export type QueryRootRequestPausesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestPriorityArgs = {
  distinct_on: InputMaybe<Array<RequestPrioritySelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestPriorityOrderBy>>;
  where: InputMaybe<RequestPriorityBoolExp>;
};


export type QueryRootRequestPriorityByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootRequestRequestLeadsArgs = {
  distinct_on: InputMaybe<Array<RequestRequestLeadsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestRequestLeadsOrderBy>>;
  where: InputMaybe<RequestRequestLeadsBoolExp>;
};


export type QueryRootRequestRequestLeadsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestStepGroupsArgs = {
  distinct_on: InputMaybe<Array<RequestStepGroupsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepGroupsOrderBy>>;
  where: InputMaybe<RequestStepGroupsBoolExp>;
};


export type QueryRootRequestStepGroupsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestStepNotificationMessagesArgs = {
  distinct_on: InputMaybe<Array<RequestStepNotificationMessagesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepNotificationMessagesOrderBy>>;
  where: InputMaybe<RequestStepNotificationMessagesBoolExp>;
};


export type QueryRootRequestStepNotificationMessagesByPkArgs = {
  requestStepId: Scalars['uuid']['input'];
};


export type QueryRootRequestStepResultArgs = {
  distinct_on: InputMaybe<Array<RequestStepResultSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepResultOrderBy>>;
  where: InputMaybe<RequestStepResultBoolExp>;
};


export type QueryRootRequestStepResultByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootRequestStepStateArgs = {
  distinct_on: InputMaybe<Array<RequestStepStateSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepStateOrderBy>>;
  where: InputMaybe<RequestStepStateBoolExp>;
};


export type QueryRootRequestStepStateByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootRequestStepTaskErrorsArgs = {
  distinct_on: InputMaybe<Array<RequestStepTaskErrorsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTaskErrorsOrderBy>>;
  where: InputMaybe<RequestStepTaskErrorsBoolExp>;
};


export type QueryRootRequestStepTaskErrorsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestStepTaskRejectionsArgs = {
  distinct_on: InputMaybe<Array<RequestStepTaskRejectionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTaskRejectionsOrderBy>>;
  where: InputMaybe<RequestStepTaskRejectionsBoolExp>;
};


export type QueryRootRequestStepTaskRejectionsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestStepTaskRejectionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTaskRejectionsOrderBy>>;
  where: InputMaybe<RequestStepTaskRejectionsBoolExp>;
};


export type QueryRootRequestStepTaskRejectionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestStepTaskTypeArgs = {
  distinct_on: InputMaybe<Array<RequestStepTaskTypeSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTaskTypeOrderBy>>;
  where: InputMaybe<RequestStepTaskTypeBoolExp>;
};


export type QueryRootRequestStepTaskTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootRequestStepTaskUsersArgs = {
  distinct_on: InputMaybe<Array<RequestStepTaskUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTaskUsersOrderBy>>;
  where: InputMaybe<RequestStepTaskUsersBoolExp>;
};


export type QueryRootRequestStepTaskUsersByPkArgs = {
  organisation_id: Scalars['uuid']['input'];
  request_step_task_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type QueryRootRequestStepTasksArgs = {
  distinct_on: InputMaybe<Array<RequestStepTasksSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTasksOrderBy>>;
  where: InputMaybe<RequestStepTasksBoolExp>;
};


export type QueryRootRequestStepTasksAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestStepTasksSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTasksOrderBy>>;
  where: InputMaybe<RequestStepTasksBoolExp>;
};


export type QueryRootRequestStepTasksByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestStepUsersArgs = {
  distinct_on: InputMaybe<Array<RequestStepUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepUsersOrderBy>>;
  where: InputMaybe<RequestStepUsersBoolExp>;
};


export type QueryRootRequestStepUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestStepsArgs = {
  distinct_on: InputMaybe<Array<RequestStepsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepsOrderBy>>;
  where: InputMaybe<RequestStepsBoolExp>;
};


export type QueryRootRequestStepsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestStepsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepsOrderBy>>;
  where: InputMaybe<RequestStepsBoolExp>;
};


export type QueryRootRequestStepsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestTagsArgs = {
  distinct_on: InputMaybe<Array<RequestTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestTagsOrderBy>>;
  where: InputMaybe<RequestTagsBoolExp>;
};


export type QueryRootRequestTagsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestTypeArgs = {
  distinct_on: InputMaybe<Array<RequestTypeSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestTypeOrderBy>>;
  where: InputMaybe<RequestTypeBoolExp>;
};


export type QueryRootRequestTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootRequestUsersArgs = {
  distinct_on: InputMaybe<Array<RequestUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestUsersOrderBy>>;
  where: InputMaybe<RequestUsersBoolExp>;
};


export type QueryRootRequestUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRequestsArgs = {
  distinct_on: InputMaybe<Array<RequestsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestsOrderBy>>;
  where: InputMaybe<RequestsBoolExp>;
};


export type QueryRootRequestsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestsOrderBy>>;
  where: InputMaybe<RequestsBoolExp>;
};


export type QueryRootRequestsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRfxArgs = {
  distinct_on: InputMaybe<Array<RfxSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxOrderBy>>;
  where: InputMaybe<RfxBoolExp>;
};


export type QueryRootRfxAiScoringArgs = {
  distinct_on: InputMaybe<Array<RfxAiScoringSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxAiScoringOrderBy>>;
  where: InputMaybe<RfxAiScoringBoolExp>;
};


export type QueryRootRfxAiScoringAggregateArgs = {
  distinct_on: InputMaybe<Array<RfxAiScoringSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxAiScoringOrderBy>>;
  where: InputMaybe<RfxAiScoringBoolExp>;
};


export type QueryRootRfxAiScoringByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRfxByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRfxConfidentialityAgreementArgs = {
  distinct_on: InputMaybe<Array<RfxConfidentialityAgreementSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxConfidentialityAgreementOrderBy>>;
  where: InputMaybe<RfxConfidentialityAgreementBoolExp>;
};


export type QueryRootRfxConfidentialityAgreementAggregateArgs = {
  distinct_on: InputMaybe<Array<RfxConfidentialityAgreementSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxConfidentialityAgreementOrderBy>>;
  where: InputMaybe<RfxConfidentialityAgreementBoolExp>;
};


export type QueryRootRfxConfidentialityAgreementByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRfxExternalUsersArgs = {
  distinct_on: InputMaybe<Array<RfxExternalUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxExternalUsersOrderBy>>;
  where: InputMaybe<RfxExternalUsersBoolExp>;
};


export type QueryRootRfxExternalUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRfxOwnersArgs = {
  distinct_on: InputMaybe<Array<RfxOwnersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxOwnersOrderBy>>;
  where: InputMaybe<RfxOwnersBoolExp>;
};


export type QueryRootRfxOwnersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRfxRequestFormTemplateWeightingArgs = {
  distinct_on: InputMaybe<Array<RfxRequestFormTemplateWeightingSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxRequestFormTemplateWeightingOrderBy>>;
  where: InputMaybe<RfxRequestFormTemplateWeightingBoolExp>;
};


export type QueryRootRfxRequestFormTemplateWeightingByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRfxRequestFormTemplatesRanksArgs = {
  distinct_on: InputMaybe<Array<RfxRequestFormTemplatesRanksSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxRequestFormTemplatesRanksOrderBy>>;
  where: InputMaybe<RfxRequestFormTemplatesRanksBoolExp>;
};


export type QueryRootRfxRequestFormTemplatesRanksByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRfxSuppliersArgs = {
  distinct_on: InputMaybe<Array<RfxSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxSuppliersOrderBy>>;
  where: InputMaybe<RfxSuppliersBoolExp>;
};


export type QueryRootRfxSuppliersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRiskAttributesArgs = {
  distinct_on: InputMaybe<Array<RiskAttributesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskAttributesOrderBy>>;
  where: InputMaybe<RiskAttributesBoolExp>;
};


export type QueryRootRiskAttributesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRiskAttributesTypeArgs = {
  distinct_on: InputMaybe<Array<RiskAttributesTypeSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskAttributesTypeOrderBy>>;
  where: InputMaybe<RiskAttributesTypeBoolExp>;
};


export type QueryRootRiskAttributesTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootRiskCategoriesArgs = {
  distinct_on: InputMaybe<Array<RiskCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskCategoriesOrderBy>>;
  where: InputMaybe<RiskCategoriesBoolExp>;
};


export type QueryRootRiskCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRiskLevelsArgs = {
  distinct_on: InputMaybe<Array<RiskLevelsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskLevelsOrderBy>>;
  where: InputMaybe<RiskLevelsBoolExp>;
};


export type QueryRootRiskLevelsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRiskLevelsTypeArgs = {
  distinct_on: InputMaybe<Array<RiskLevelsTypeSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskLevelsTypeOrderBy>>;
  where: InputMaybe<RiskLevelsTypeBoolExp>;
};


export type QueryRootRiskLevelsTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootRiskMatrixCellsArgs = {
  distinct_on: InputMaybe<Array<RiskMatrixCellsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskMatrixCellsOrderBy>>;
  where: InputMaybe<RiskMatrixCellsBoolExp>;
};


export type QueryRootRiskMatrixCellsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRiskOwnersArgs = {
  distinct_on: InputMaybe<Array<RiskOwnersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskOwnersOrderBy>>;
  where: InputMaybe<RiskOwnersBoolExp>;
};


export type QueryRootRiskOwnersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRiskSettingsArgs = {
  distinct_on: InputMaybe<Array<RiskSettingsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskSettingsOrderBy>>;
  where: InputMaybe<RiskSettingsBoolExp>;
};


export type QueryRootRiskSettingsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRiskTemplateCategoriesArgs = {
  distinct_on: InputMaybe<Array<RiskTemplateCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskTemplateCategoriesOrderBy>>;
  where: InputMaybe<RiskTemplateCategoriesBoolExp>;
};


export type QueryRootRiskTemplateCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRiskTemplateOwnersArgs = {
  distinct_on: InputMaybe<Array<RiskTemplateOwnersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskTemplateOwnersOrderBy>>;
  where: InputMaybe<RiskTemplateOwnersBoolExp>;
};


export type QueryRootRiskTemplateOwnersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRiskTemplatesArgs = {
  distinct_on: InputMaybe<Array<RiskTemplatesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskTemplatesOrderBy>>;
  where: InputMaybe<RiskTemplatesBoolExp>;
};


export type QueryRootRiskTemplatesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRiskUsersTypeArgs = {
  distinct_on: InputMaybe<Array<RiskUsersTypeSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskUsersTypeOrderBy>>;
  where: InputMaybe<RiskUsersTypeBoolExp>;
};


export type QueryRootRiskUsersTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootRiskVersionsArgs = {
  distinct_on: InputMaybe<Array<RiskVersionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskVersionsOrderBy>>;
  where: InputMaybe<RiskVersionsBoolExp>;
};


export type QueryRootRiskVersionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootRisksArgs = {
  distinct_on: InputMaybe<Array<RisksSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RisksOrderBy>>;
  where: InputMaybe<RisksBoolExp>;
};


export type QueryRootRisksByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootSearchOrganisationProductsAndServicesArgs = {
  args: SearchOrganisationProductsAndServicesArgs;
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


export type QueryRootSearchOrganisationProductsAndServicesAggregateArgs = {
  args: SearchOrganisationProductsAndServicesArgs;
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


export type QueryRootSearchOrganisationProductsAndServicesV2Args = {
  args: SearchOrganisationProductsAndServicesV2Args;
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


export type QueryRootSearchOrganisationProductsAndServicesV2AggregateArgs = {
  args: SearchOrganisationProductsAndServicesV2Args;
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


export type QueryRootSearchOrganisationSuppliersArgs = {
  args: SearchOrganisationSuppliersArgs;
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


export type QueryRootSearchOrganisationSuppliersAggregateArgs = {
  args: SearchOrganisationSuppliersArgs;
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


export type QueryRootSearchOrganisationSuppliersV2Args = {
  args: SearchOrganisationSuppliersV2Args;
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


export type QueryRootSearchOrganisationSuppliersV2AggregateArgs = {
  args: SearchOrganisationSuppliersV2Args;
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


export type QueryRootSearchOrganisationSuppliersV3Args = {
  args: SearchOrganisationSuppliersV3Args;
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


export type QueryRootSearchOrganisationSuppliersV3AggregateArgs = {
  args: SearchOrganisationSuppliersV3Args;
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


export type QueryRootSearchProductsArgs = {
  args: SearchProductsArgs;
  distinct_on: InputMaybe<Array<ProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductsAndServicesOrderBy>>;
  where: InputMaybe<ProductsAndServicesBoolExp>;
};


export type QueryRootSearchSuppliersArgs = {
  args: SearchSuppliersArgs;
  distinct_on: InputMaybe<Array<SuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<SuppliersOrderBy>>;
  where: InputMaybe<SuppliersBoolExp>;
};


export type QueryRootSubsidiariesArgs = {
  distinct_on: InputMaybe<Array<SubsidiariesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<SubsidiariesOrderBy>>;
  where: InputMaybe<SubsidiariesBoolExp>;
};


export type QueryRootSubsidiariesAggregateArgs = {
  distinct_on: InputMaybe<Array<SubsidiariesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<SubsidiariesOrderBy>>;
  where: InputMaybe<SubsidiariesBoolExp>;
};


export type QueryRootSubsidiariesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootSuppliersArgs = {
  distinct_on: InputMaybe<Array<SuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<SuppliersOrderBy>>;
  where: InputMaybe<SuppliersBoolExp>;
};


export type QueryRootSuppliersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootTableFilterReferenceArgs = {
  distinct_on: InputMaybe<Array<TableFilterReferenceSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<TableFilterReferenceOrderBy>>;
  where: InputMaybe<TableFilterReferenceBoolExp>;
};


export type QueryRootTableFilterReferenceByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootTableFiltersArgs = {
  distinct_on: InputMaybe<Array<TableFiltersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<TableFiltersOrderBy>>;
  where: InputMaybe<TableFiltersBoolExp>;
};


export type QueryRootTableFiltersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootTagsArgs = {
  distinct_on: InputMaybe<Array<TagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<TagsOrderBy>>;
  where: InputMaybe<TagsBoolExp>;
};


export type QueryRootTagsAggregateArgs = {
  distinct_on: InputMaybe<Array<TagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<TagsOrderBy>>;
  where: InputMaybe<TagsBoolExp>;
};


export type QueryRootTagsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootUserAllowedSubsidiariesArgs = {
  distinct_on: InputMaybe<Array<UserAllowedSubsidiariesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<UserAllowedSubsidiariesOrderBy>>;
  where: InputMaybe<UserAllowedSubsidiariesBoolExp>;
};


export type QueryRootUserAllowedSubsidiariesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootUsersArgs = {
  distinct_on: InputMaybe<Array<UsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<UsersOrderBy>>;
  where: InputMaybe<UsersBoolExp>;
};


export type QueryRootUsersAggregateArgs = {
  distinct_on: InputMaybe<Array<UsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<UsersOrderBy>>;
  where: InputMaybe<UsersBoolExp>;
};


export type QueryRootUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootVectorSearchProductsAndServicesArgs = {
  args: VectorSearchProductsAndServicesArgs;
  distinct_on: InputMaybe<Array<VectorSearchSimilarityResultsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<VectorSearchSimilarityResultsOrderBy>>;
  where: InputMaybe<VectorSearchSimilarityResultsBoolExp>;
};


export type QueryRootVectorSearchSimilarityResultsArgs = {
  distinct_on: InputMaybe<Array<VectorSearchSimilarityResultsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<VectorSearchSimilarityResultsOrderBy>>;
  where: InputMaybe<VectorSearchSimilarityResultsBoolExp>;
};


export type QueryRootVectorSearchSimilarityResultsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootVectorSearchSuppliersArgs = {
  args: VectorSearchSuppliersArgs;
  distinct_on: InputMaybe<Array<VectorSearchSimilarityResultsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<VectorSearchSimilarityResultsOrderBy>>;
  where: InputMaybe<VectorSearchSimilarityResultsBoolExp>;
};


export type QueryRootWorkflowConditionGroupsArgs = {
  distinct_on: InputMaybe<Array<WorkflowConditionGroupsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<WorkflowConditionGroupsOrderBy>>;
  where: InputMaybe<WorkflowConditionGroupsBoolExp>;
};


export type QueryRootWorkflowConditionGroupsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootWorkflowFormTemplatesArgs = {
  distinct_on: InputMaybe<Array<WorkflowFormTemplatesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<WorkflowFormTemplatesOrderBy>>;
  where: InputMaybe<WorkflowFormTemplatesBoolExp>;
};


export type QueryRootWorkflowFormTemplatesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootWorkflowRanksArgs = {
  distinct_on: InputMaybe<Array<WorkflowRanksSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<WorkflowRanksOrderBy>>;
  where: InputMaybe<WorkflowRanksBoolExp>;
};


export type QueryRootWorkflowRanksByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootWorkflowStateArgs = {
  distinct_on: InputMaybe<Array<WorkflowStateSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<WorkflowStateOrderBy>>;
  where: InputMaybe<WorkflowStateBoolExp>;
};


export type QueryRootWorkflowStateByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootWorkflowTypeArgs = {
  distinct_on: InputMaybe<Array<WorkflowTypeSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<WorkflowTypeOrderBy>>;
  where: InputMaybe<WorkflowTypeBoolExp>;
};


export type QueryRootWorkflowTypeByPkArgs = {
  value: Scalars['String']['input'];
};


export type QueryRootWorkflowsArgs = {
  distinct_on: InputMaybe<Array<WorkflowsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<WorkflowsOrderBy>>;
  where: InputMaybe<WorkflowsBoolExp>;
};


export type QueryRootWorkflowsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryRootZWorkaroundCcdoCountArgs = {
  distinct_on: InputMaybe<Array<ZWorkaroundCcdoCountSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ZWorkaroundCcdoCountOrderBy>>;
  where: InputMaybe<ZWorkaroundCcdoCountBoolExp>;
};

/** columns and relationships of "renewal_additional_users" */
export type RenewalAdditionalUsers = {
  __typename?: 'renewal_additional_users';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  renewal: Renewals;
  renewalId: Scalars['uuid']['output'];
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "renewal_additional_users" */
export type RenewalAdditionalUsersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RenewalAdditionalUsersMaxOrderBy>;
  min?: InputMaybe<RenewalAdditionalUsersMinOrderBy>;
};

/** input type for inserting array relation for remote table "renewal_additional_users" */
export type RenewalAdditionalUsersArrRelInsertInput = {
  data: Array<RenewalAdditionalUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RenewalAdditionalUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "renewal_additional_users". All fields are combined with a logical 'AND'. */
export type RenewalAdditionalUsersBoolExp = {
  _and?: InputMaybe<Array<RenewalAdditionalUsersBoolExp>>;
  _not?: InputMaybe<RenewalAdditionalUsersBoolExp>;
  _or?: InputMaybe<Array<RenewalAdditionalUsersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  renewal?: InputMaybe<RenewalsBoolExp>;
  renewalId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "renewal_additional_users" */
export enum RenewalAdditionalUsersConstraint {
  /** unique or primary key constraint on columns "id" */
  RENEWAL_ADDITIONAL_USERS_PKEY = 'renewal_additional_users_pkey',
  /** unique or primary key constraint on columns "user_id", "renewal_id" */
  RENEWAL_ID_USER_ID_KEY = 'renewal_id_user_id_key'
}

/** input type for inserting data into table "renewal_additional_users" */
export type RenewalAdditionalUsersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  renewal?: InputMaybe<RenewalsObjRelInsertInput>;
  renewalId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "renewal_additional_users" */
export type RenewalAdditionalUsersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  renewalId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "renewal_additional_users" */
export type RenewalAdditionalUsersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  renewalId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "renewal_additional_users" */
export type RenewalAdditionalUsersMutationResponse = {
  __typename?: 'renewal_additional_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RenewalAdditionalUsers>;
};

/** on_conflict condition type for table "renewal_additional_users" */
export type RenewalAdditionalUsersOnConflict = {
  constraint: RenewalAdditionalUsersConstraint;
  update_columns: Array<RenewalAdditionalUsersUpdateColumn>;
  where?: InputMaybe<RenewalAdditionalUsersBoolExp>;
};

/** Ordering options when selecting data from "renewal_additional_users". */
export type RenewalAdditionalUsersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  renewal?: InputMaybe<RenewalsOrderBy>;
  renewalId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: renewal_additional_users */
export type RenewalAdditionalUsersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "renewal_additional_users" */
export enum RenewalAdditionalUsersSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  RENEWALID = 'renewalId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "renewal_additional_users" */
export type RenewalAdditionalUsersSetInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  renewalId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "renewal_additional_users" */
export enum RenewalAdditionalUsersUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  RENEWALID = 'renewalId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

export type RenewalAdditionalUsersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RenewalAdditionalUsersSetInput>;
  /** filter the rows which have to be updated */
  where: RenewalAdditionalUsersBoolExp;
};

/** columns and relationships of "renewal_tags" */
export type RenewalTags = {
  __typename?: 'renewal_tags';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  renewal: Renewals;
  renewalId: Scalars['uuid']['output'];
  /** An object relationship */
  tag: Tags;
  tagId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "renewal_tags" */
export type RenewalTagsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RenewalTagsMaxOrderBy>;
  min?: InputMaybe<RenewalTagsMinOrderBy>;
};

/** input type for inserting array relation for remote table "renewal_tags" */
export type RenewalTagsArrRelInsertInput = {
  data: Array<RenewalTagsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RenewalTagsOnConflict>;
};

/** Boolean expression to filter rows from the table "renewal_tags". All fields are combined with a logical 'AND'. */
export type RenewalTagsBoolExp = {
  _and?: InputMaybe<Array<RenewalTagsBoolExp>>;
  _not?: InputMaybe<RenewalTagsBoolExp>;
  _or?: InputMaybe<Array<RenewalTagsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  renewal?: InputMaybe<RenewalsBoolExp>;
  renewalId?: InputMaybe<UuidComparisonExp>;
  tag?: InputMaybe<TagsBoolExp>;
  tagId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "renewal_tags" */
export enum RenewalTagsConstraint {
  /** unique or primary key constraint on columns "id" */
  RENEWAL_TAGS_PKEY = 'renewal_tags_pkey',
  /** unique or primary key constraint on columns "renewal_id", "tag_id" */
  RENEWAL_TAGS_RENEWAL_ID_TAG_ID_KEY = 'renewal_tags_renewal_id_tag_id_key'
}

/** input type for inserting data into table "renewal_tags" */
export type RenewalTagsInsertInput = {
  renewal?: InputMaybe<RenewalsObjRelInsertInput>;
  renewalId?: InputMaybe<Scalars['uuid']['input']>;
  tag?: InputMaybe<TagsObjRelInsertInput>;
  tagId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "renewal_tags" */
export type RenewalTagsMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  renewalId?: InputMaybe<OrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "renewal_tags" */
export type RenewalTagsMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  renewalId?: InputMaybe<OrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "renewal_tags" */
export type RenewalTagsMutationResponse = {
  __typename?: 'renewal_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RenewalTags>;
};

/** on_conflict condition type for table "renewal_tags" */
export type RenewalTagsOnConflict = {
  constraint: RenewalTagsConstraint;
  update_columns: Array<RenewalTagsUpdateColumn>;
  where?: InputMaybe<RenewalTagsBoolExp>;
};

/** Ordering options when selecting data from "renewal_tags". */
export type RenewalTagsOrderBy = {
  id?: InputMaybe<OrderBy>;
  renewal?: InputMaybe<RenewalsOrderBy>;
  renewalId?: InputMaybe<OrderBy>;
  tag?: InputMaybe<TagsOrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** select columns of table "renewal_tags" */
export enum RenewalTagsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  RENEWALID = 'renewalId',
  /** column name */
  TAGID = 'tagId'
}

/** placeholder for update columns of table "renewal_tags" (current role has no relevant permissions) */
export enum RenewalTagsUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "renewals" */
export type Renewals = {
  __typename?: 'renewals';
  autoStartEnabled: Scalars['Boolean']['output'];
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  cancelledAt: Maybe<Scalars['timestamptz']['output']>;
  costCurrency: Scalars['currencyCode']['output'];
  costValue: Scalars['numeric']['output'];
  /** An object relationship */
  createdAgreementTerm: Maybe<AgreementTerms>;
  createdAgreementTermId: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  department: Maybe<Departments>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  note: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['uuid']['output'];
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  product: Maybe<OrganisationProductsAndServices>;
  /** An array relationship */
  renewalAdditionalUsers: Array<RenewalAdditionalUsers>;
  renewalDate: Scalars['timestamptz']['output'];
  /** An array relationship */
  renewalTags: Array<RenewalTags>;
  renewedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  request: Maybe<Requests>;
  requestId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sourceAgreementTerm: Maybe<AgreementTerms>;
  sourceAgreementTermId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  sourceRequest: Maybe<Requests>;
  sourceRequestId: Maybe<Scalars['uuid']['output']>;
  status: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  supplier: OrganisationSuppliers;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  workflow: Maybe<Workflows>;
  workflowId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  workflowInitialAssignee: Maybe<Users>;
  workflowInitialAssigneeId: Maybe<Scalars['uuid']['output']>;
  workflowStartDate: Maybe<Scalars['date']['output']>;
  workflowStartDayCount: Scalars['Int']['output'];
};


/** columns and relationships of "renewals" */
export type RenewalsRenewalAdditionalUsersArgs = {
  distinct_on: InputMaybe<Array<RenewalAdditionalUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalAdditionalUsersOrderBy>>;
  where: InputMaybe<RenewalAdditionalUsersBoolExp>;
};


/** columns and relationships of "renewals" */
export type RenewalsRenewalTagsArgs = {
  distinct_on: InputMaybe<Array<RenewalTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalTagsOrderBy>>;
  where: InputMaybe<RenewalTagsBoolExp>;
};

/** aggregated selection of "renewals" */
export type RenewalsAggregate = {
  __typename?: 'renewals_aggregate';
  aggregate: Maybe<RenewalsAggregateFields>;
  nodes: Array<Renewals>;
};

export type RenewalsAggregateBoolExp = {
  bool_and?: InputMaybe<RenewalsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<RenewalsAggregateBoolExpBoolOr>;
  count?: InputMaybe<RenewalsAggregateBoolExpCount>;
};

export type RenewalsAggregateBoolExpBoolAnd = {
  arguments: RenewalsSelectColumnRenewalsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RenewalsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RenewalsAggregateBoolExpBoolOr = {
  arguments: RenewalsSelectColumnRenewalsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RenewalsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RenewalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RenewalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RenewalsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "renewals" */
export type RenewalsAggregateFields = {
  __typename?: 'renewals_aggregate_fields';
  avg: Maybe<RenewalsAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<RenewalsMaxFields>;
  min: Maybe<RenewalsMinFields>;
  stddev: Maybe<RenewalsStddevFields>;
  stddev_pop: Maybe<RenewalsStddevPopFields>;
  stddev_samp: Maybe<RenewalsStddevSampFields>;
  sum: Maybe<RenewalsSumFields>;
  var_pop: Maybe<RenewalsVarPopFields>;
  var_samp: Maybe<RenewalsVarSampFields>;
  variance: Maybe<RenewalsVarianceFields>;
};


/** aggregate fields of "renewals" */
export type RenewalsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RenewalsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "renewals" */
export type RenewalsAggregateOrderBy = {
  avg?: InputMaybe<RenewalsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RenewalsMaxOrderBy>;
  min?: InputMaybe<RenewalsMinOrderBy>;
  stddev?: InputMaybe<RenewalsStddevOrderBy>;
  stddev_pop?: InputMaybe<RenewalsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<RenewalsStddevSampOrderBy>;
  sum?: InputMaybe<RenewalsSumOrderBy>;
  var_pop?: InputMaybe<RenewalsVarPopOrderBy>;
  var_samp?: InputMaybe<RenewalsVarSampOrderBy>;
  variance?: InputMaybe<RenewalsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "renewals" */
export type RenewalsArrRelInsertInput = {
  data: Array<RenewalsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RenewalsOnConflict>;
};

/** aggregate avg on columns */
export type RenewalsAvgFields = {
  __typename?: 'renewals_avg_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  costValue: Maybe<Scalars['Float']['output']>;
  workflowStartDayCount: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "renewals" */
export type RenewalsAvgOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  costValue?: InputMaybe<OrderBy>;
  workflowStartDayCount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "renewals". All fields are combined with a logical 'AND'. */
export type RenewalsBoolExp = {
  _and?: InputMaybe<Array<RenewalsBoolExp>>;
  _not?: InputMaybe<RenewalsBoolExp>;
  _or?: InputMaybe<Array<RenewalsBoolExp>>;
  autoStartEnabled?: InputMaybe<BooleanComparisonExp>;
  cancellationNoticeDayCount?: InputMaybe<IntComparisonExp>;
  cancelledAt?: InputMaybe<TimestamptzComparisonExp>;
  costCurrency?: InputMaybe<StringComparisonExp>;
  costValue?: InputMaybe<NumericComparisonExp>;
  createdAgreementTerm?: InputMaybe<AgreementTermsBoolExp>;
  createdAgreementTermId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<DepartmentsBoolExp>;
  departmentId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationProductId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  product?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  renewalAdditionalUsers?: InputMaybe<RenewalAdditionalUsersBoolExp>;
  renewalDate?: InputMaybe<TimestamptzComparisonExp>;
  renewalTags?: InputMaybe<RenewalTagsBoolExp>;
  renewedAt?: InputMaybe<TimestamptzComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  sourceAgreementTerm?: InputMaybe<AgreementTermsBoolExp>;
  sourceAgreementTermId?: InputMaybe<UuidComparisonExp>;
  sourceRequest?: InputMaybe<RequestsBoolExp>;
  sourceRequestId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
  workflowId?: InputMaybe<UuidComparisonExp>;
  workflowInitialAssignee?: InputMaybe<UsersBoolExp>;
  workflowInitialAssigneeId?: InputMaybe<UuidComparisonExp>;
  workflowStartDate?: InputMaybe<DateComparisonExp>;
  workflowStartDayCount?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "renewals" */
export enum RenewalsConstraint {
  /** unique or primary key constraint on columns "request_id" */
  RENEWALS_BY_REQUEST_ID = 'renewals_by_request_id',
  /** unique or primary key constraint on columns "id" */
  RENEWALS_PKEY = 'renewals_pkey'
}

/** input type for incrementing numeric columns in table "renewals" */
export type RenewalsIncInput = {
  cancellationNoticeDayCount?: InputMaybe<Scalars['Int']['input']>;
  costValue?: InputMaybe<Scalars['numeric']['input']>;
  workflowStartDayCount?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "renewals" */
export type RenewalsInsertInput = {
  autoStartEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationNoticeDayCount?: InputMaybe<Scalars['Int']['input']>;
  costCurrency?: InputMaybe<Scalars['String']['input']>;
  costValue?: InputMaybe<Scalars['numeric']['input']>;
  createdAgreementTerm?: InputMaybe<AgreementTermsObjRelInsertInput>;
  createdAgreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<DepartmentsObjRelInsertInput>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  organisationProductId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  product?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
  renewalAdditionalUsers?: InputMaybe<RenewalAdditionalUsersArrRelInsertInput>;
  renewalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  renewalTags?: InputMaybe<RenewalTagsArrRelInsertInput>;
  renewedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  sourceAgreementTerm?: InputMaybe<AgreementTermsObjRelInsertInput>;
  sourceAgreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  sourceRequest?: InputMaybe<RequestsObjRelInsertInput>;
  sourceRequestId?: InputMaybe<Scalars['uuid']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
  workflowInitialAssignee?: InputMaybe<UsersObjRelInsertInput>;
  workflowInitialAssigneeId?: InputMaybe<Scalars['uuid']['input']>;
  workflowStartDate?: InputMaybe<Scalars['date']['input']>;
  workflowStartDayCount?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type RenewalsMaxFields = {
  __typename?: 'renewals_max_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  cancelledAt: Maybe<Scalars['timestamptz']['output']>;
  costCurrency: Maybe<Scalars['String']['output']>;
  costValue: Maybe<Scalars['numeric']['output']>;
  createdAgreementTermId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  note: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  renewalDate: Maybe<Scalars['timestamptz']['output']>;
  renewedAt: Maybe<Scalars['timestamptz']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  sourceAgreementTermId: Maybe<Scalars['uuid']['output']>;
  sourceRequestId: Maybe<Scalars['uuid']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
  workflowInitialAssigneeId: Maybe<Scalars['uuid']['output']>;
  workflowStartDate: Maybe<Scalars['date']['output']>;
  workflowStartDayCount: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "renewals" */
export type RenewalsMaxOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  cancelledAt?: InputMaybe<OrderBy>;
  costCurrency?: InputMaybe<OrderBy>;
  costValue?: InputMaybe<OrderBy>;
  createdAgreementTermId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  renewalDate?: InputMaybe<OrderBy>;
  renewedAt?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  sourceAgreementTermId?: InputMaybe<OrderBy>;
  sourceRequestId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workflowId?: InputMaybe<OrderBy>;
  workflowInitialAssigneeId?: InputMaybe<OrderBy>;
  workflowStartDate?: InputMaybe<OrderBy>;
  workflowStartDayCount?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RenewalsMinFields = {
  __typename?: 'renewals_min_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  cancelledAt: Maybe<Scalars['timestamptz']['output']>;
  costCurrency: Maybe<Scalars['String']['output']>;
  costValue: Maybe<Scalars['numeric']['output']>;
  createdAgreementTermId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  note: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  renewalDate: Maybe<Scalars['timestamptz']['output']>;
  renewedAt: Maybe<Scalars['timestamptz']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  sourceAgreementTermId: Maybe<Scalars['uuid']['output']>;
  sourceRequestId: Maybe<Scalars['uuid']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
  workflowInitialAssigneeId: Maybe<Scalars['uuid']['output']>;
  workflowStartDate: Maybe<Scalars['date']['output']>;
  workflowStartDayCount: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "renewals" */
export type RenewalsMinOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  cancelledAt?: InputMaybe<OrderBy>;
  costCurrency?: InputMaybe<OrderBy>;
  costValue?: InputMaybe<OrderBy>;
  createdAgreementTermId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  renewalDate?: InputMaybe<OrderBy>;
  renewedAt?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  sourceAgreementTermId?: InputMaybe<OrderBy>;
  sourceRequestId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workflowId?: InputMaybe<OrderBy>;
  workflowInitialAssigneeId?: InputMaybe<OrderBy>;
  workflowStartDate?: InputMaybe<OrderBy>;
  workflowStartDayCount?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "renewals" */
export type RenewalsMutationResponse = {
  __typename?: 'renewals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Renewals>;
};

/** input type for inserting object relation for remote table "renewals" */
export type RenewalsObjRelInsertInput = {
  data: RenewalsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RenewalsOnConflict>;
};

/** on_conflict condition type for table "renewals" */
export type RenewalsOnConflict = {
  constraint: RenewalsConstraint;
  update_columns: Array<RenewalsUpdateColumn>;
  where?: InputMaybe<RenewalsBoolExp>;
};

/** Ordering options when selecting data from "renewals". */
export type RenewalsOrderBy = {
  autoStartEnabled?: InputMaybe<OrderBy>;
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  cancelledAt?: InputMaybe<OrderBy>;
  costCurrency?: InputMaybe<OrderBy>;
  costValue?: InputMaybe<OrderBy>;
  createdAgreementTerm?: InputMaybe<AgreementTermsOrderBy>;
  createdAgreementTermId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<DepartmentsOrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  product?: InputMaybe<OrganisationProductsAndServicesOrderBy>;
  renewalAdditionalUsers_aggregate?: InputMaybe<RenewalAdditionalUsersAggregateOrderBy>;
  renewalDate?: InputMaybe<OrderBy>;
  renewalTags_aggregate?: InputMaybe<RenewalTagsAggregateOrderBy>;
  renewedAt?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  sourceAgreementTerm?: InputMaybe<AgreementTermsOrderBy>;
  sourceAgreementTermId?: InputMaybe<OrderBy>;
  sourceRequest?: InputMaybe<RequestsOrderBy>;
  sourceRequestId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workflow?: InputMaybe<WorkflowsOrderBy>;
  workflowId?: InputMaybe<OrderBy>;
  workflowInitialAssignee?: InputMaybe<UsersOrderBy>;
  workflowInitialAssigneeId?: InputMaybe<OrderBy>;
  workflowStartDate?: InputMaybe<OrderBy>;
  workflowStartDayCount?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: renewals */
export type RenewalsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "renewals" */
export enum RenewalsSelectColumn {
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled',
  /** column name */
  CANCELLATIONNOTICEDAYCOUNT = 'cancellationNoticeDayCount',
  /** column name */
  CANCELLEDAT = 'cancelledAt',
  /** column name */
  COSTCURRENCY = 'costCurrency',
  /** column name */
  COSTVALUE = 'costValue',
  /** column name */
  CREATEDAGREEMENTTERMID = 'createdAgreementTermId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  ID = 'id',
  /** column name */
  NOTE = 'note',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  RENEWALDATE = 'renewalDate',
  /** column name */
  RENEWEDAT = 'renewedAt',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  SOURCEAGREEMENTTERMID = 'sourceAgreementTermId',
  /** column name */
  SOURCEREQUESTID = 'sourceRequestId',
  /** column name */
  STATUS = 'status',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId',
  /** column name */
  WORKFLOWINITIALASSIGNEEID = 'workflowInitialAssigneeId',
  /** column name */
  WORKFLOWSTARTDATE = 'workflowStartDate',
  /** column name */
  WORKFLOWSTARTDAYCOUNT = 'workflowStartDayCount'
}

/** select "renewals_aggregate_bool_exp_bool_and_arguments_columns" columns of table "renewals" */
export enum RenewalsSelectColumnRenewalsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled'
}

/** select "renewals_aggregate_bool_exp_bool_or_arguments_columns" columns of table "renewals" */
export enum RenewalsSelectColumnRenewalsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled'
}

/** input type for updating data in table "renewals" */
export type RenewalsSetInput = {
  autoStartEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationNoticeDayCount?: InputMaybe<Scalars['Int']['input']>;
  cancelledAt?: InputMaybe<Scalars['timestamptz']['input']>;
  costCurrency?: InputMaybe<Scalars['String']['input']>;
  costValue?: InputMaybe<Scalars['numeric']['input']>;
  createdAgreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  organisationProductId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  renewalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  renewedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  sourceAgreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  sourceRequestId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
  workflowInitialAssigneeId?: InputMaybe<Scalars['uuid']['input']>;
  workflowStartDate?: InputMaybe<Scalars['date']['input']>;
  workflowStartDayCount?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type RenewalsStddevFields = {
  __typename?: 'renewals_stddev_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  costValue: Maybe<Scalars['Float']['output']>;
  workflowStartDayCount: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "renewals" */
export type RenewalsStddevOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  costValue?: InputMaybe<OrderBy>;
  workflowStartDayCount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RenewalsStddevPopFields = {
  __typename?: 'renewals_stddev_pop_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  costValue: Maybe<Scalars['Float']['output']>;
  workflowStartDayCount: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "renewals" */
export type RenewalsStddevPopOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  costValue?: InputMaybe<OrderBy>;
  workflowStartDayCount?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RenewalsStddevSampFields = {
  __typename?: 'renewals_stddev_samp_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  costValue: Maybe<Scalars['Float']['output']>;
  workflowStartDayCount: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "renewals" */
export type RenewalsStddevSampOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  costValue?: InputMaybe<OrderBy>;
  workflowStartDayCount?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type RenewalsSumFields = {
  __typename?: 'renewals_sum_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Int']['output']>;
  costValue: Maybe<Scalars['numeric']['output']>;
  workflowStartDayCount: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "renewals" */
export type RenewalsSumOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  costValue?: InputMaybe<OrderBy>;
  workflowStartDayCount?: InputMaybe<OrderBy>;
};

/** update columns of table "renewals" */
export enum RenewalsUpdateColumn {
  /** column name */
  AUTOSTARTENABLED = 'autoStartEnabled',
  /** column name */
  CANCELLATIONNOTICEDAYCOUNT = 'cancellationNoticeDayCount',
  /** column name */
  CANCELLEDAT = 'cancelledAt',
  /** column name */
  COSTCURRENCY = 'costCurrency',
  /** column name */
  COSTVALUE = 'costValue',
  /** column name */
  CREATEDAGREEMENTTERMID = 'createdAgreementTermId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  ID = 'id',
  /** column name */
  NOTE = 'note',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  RENEWALDATE = 'renewalDate',
  /** column name */
  RENEWEDAT = 'renewedAt',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  SOURCEAGREEMENTTERMID = 'sourceAgreementTermId',
  /** column name */
  SOURCEREQUESTID = 'sourceRequestId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId',
  /** column name */
  WORKFLOWINITIALASSIGNEEID = 'workflowInitialAssigneeId',
  /** column name */
  WORKFLOWSTARTDATE = 'workflowStartDate',
  /** column name */
  WORKFLOWSTARTDAYCOUNT = 'workflowStartDayCount'
}

export type RenewalsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RenewalsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RenewalsSetInput>;
  /** filter the rows which have to be updated */
  where: RenewalsBoolExp;
};

/** aggregate var_pop on columns */
export type RenewalsVarPopFields = {
  __typename?: 'renewals_var_pop_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  costValue: Maybe<Scalars['Float']['output']>;
  workflowStartDayCount: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "renewals" */
export type RenewalsVarPopOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  costValue?: InputMaybe<OrderBy>;
  workflowStartDayCount?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RenewalsVarSampFields = {
  __typename?: 'renewals_var_samp_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  costValue: Maybe<Scalars['Float']['output']>;
  workflowStartDayCount: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "renewals" */
export type RenewalsVarSampOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  costValue?: InputMaybe<OrderBy>;
  workflowStartDayCount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type RenewalsVarianceFields = {
  __typename?: 'renewals_variance_fields';
  cancellationNoticeDayCount: Maybe<Scalars['Float']['output']>;
  costValue: Maybe<Scalars['Float']['output']>;
  workflowStartDayCount: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "renewals" */
export type RenewalsVarianceOrderBy = {
  cancellationNoticeDayCount?: InputMaybe<OrderBy>;
  costValue?: InputMaybe<OrderBy>;
  workflowStartDayCount?: InputMaybe<OrderBy>;
};

/** Type of the comment under a request */
export type RequestCommentType = {
  __typename?: 'request_comment_type';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "request_comment_type". All fields are combined with a logical 'AND'. */
export type RequestCommentTypeBoolExp = {
  _and?: InputMaybe<Array<RequestCommentTypeBoolExp>>;
  _not?: InputMaybe<RequestCommentTypeBoolExp>;
  _or?: InputMaybe<Array<RequestCommentTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum RequestCommentTypeEnum {
  /** AGREEMENT */
  AGREEMENT = 'AGREEMENT',
  /** AMENDMENT_REQUEST */
  AMENDMENT_REQUEST = 'AMENDMENT_REQUEST',
  /** PAUSE */
  PAUSE = 'PAUSE',
  /** REJECTION */
  REJECTION = 'REJECTION',
  /** RESUME */
  RESUME = 'RESUME',
  /** RISK */
  RISK = 'RISK',
  /** RISK_ALERT */
  RISK_ALERT = 'RISK_ALERT',
  /** SUPPLIER */
  SUPPLIER = 'SUPPLIER',
  /** SUPPLIER_ANNOUNCEMENT */
  SUPPLIER_ANNOUNCEMENT = 'SUPPLIER_ANNOUNCEMENT',
  /** TEXT */
  TEXT = 'TEXT',
  /** UNREJECTION */
  UNREJECTION = 'UNREJECTION'
}

/** Boolean expression to compare columns of type "request_comment_type_enum". All fields are combined with logical 'AND'. */
export type RequestCommentTypeEnumComparisonExp = {
  _eq?: InputMaybe<RequestCommentTypeEnum>;
  _in?: InputMaybe<Array<RequestCommentTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RequestCommentTypeEnum>;
  _nin?: InputMaybe<Array<RequestCommentTypeEnum>>;
};

/** Ordering options when selecting data from "request_comment_type". */
export type RequestCommentTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "request_comment_type" */
export enum RequestCommentTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** Comments under a request */
export type RequestComments = {
  __typename?: 'request_comments';
  agreementId: Maybe<Scalars['uuid']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  completedBy: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  isInternalComment: Scalars['Boolean']['output'];
  payload: Scalars['jsonb']['output'];
  questionId: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  request: Maybe<Requests>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestFormTemplateId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  request_comment_mentions: Array<RequestCommentsMentions>;
  /** An aggregate relationship */
  request_comment_mentions_aggregate: RequestCommentsMentionsAggregate;
  /** An object relationship */
  request_comment_type: RequestCommentType;
  /** An object relationship */
  request_form: Maybe<RequestForms>;
  /** An object relationship */
  request_form_template: Maybe<RequestFormTemplates>;
  /** An object relationship */
  rfx: Maybe<Rfx>;
  rfxId: Maybe<Scalars['uuid']['output']>;
  rfxSupplierId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  rfx_supplier: Maybe<RfxSuppliers>;
  riskAlertId: Maybe<Scalars['String']['output']>;
  riskId: Maybe<Scalars['uuid']['output']>;
  summaryApprovalId: Maybe<Scalars['uuid']['output']>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  taskId: Maybe<Scalars['uuid']['output']>;
  type: RequestCommentTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};


/** Comments under a request */
export type RequestCommentsPayloadArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** Comments under a request */
export type RequestCommentsRequestCommentMentionsArgs = {
  distinct_on: InputMaybe<Array<RequestCommentsMentionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestCommentsMentionsOrderBy>>;
  where: InputMaybe<RequestCommentsMentionsBoolExp>;
};


/** Comments under a request */
export type RequestCommentsRequestCommentMentionsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestCommentsMentionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestCommentsMentionsOrderBy>>;
  where: InputMaybe<RequestCommentsMentionsBoolExp>;
};

/** aggregated selection of "request_comments" */
export type RequestCommentsAggregate = {
  __typename?: 'request_comments_aggregate';
  aggregate: Maybe<RequestCommentsAggregateFields>;
  nodes: Array<RequestComments>;
};

export type RequestCommentsAggregateBoolExp = {
  bool_and?: InputMaybe<RequestCommentsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<RequestCommentsAggregateBoolExpBoolOr>;
  count?: InputMaybe<RequestCommentsAggregateBoolExpCount>;
};

export type RequestCommentsAggregateBoolExpBoolAnd = {
  arguments: RequestCommentsSelectColumnRequestCommentsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestCommentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RequestCommentsAggregateBoolExpBoolOr = {
  arguments: RequestCommentsSelectColumnRequestCommentsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestCommentsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RequestCommentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestCommentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestCommentsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_comments" */
export type RequestCommentsAggregateFields = {
  __typename?: 'request_comments_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestCommentsMaxFields>;
  min: Maybe<RequestCommentsMinFields>;
};


/** aggregate fields of "request_comments" */
export type RequestCommentsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RequestCommentsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "request_comments" */
export type RequestCommentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestCommentsMaxOrderBy>;
  min?: InputMaybe<RequestCommentsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RequestCommentsAppendInput = {
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "request_comments" */
export type RequestCommentsArrRelInsertInput = {
  data: Array<RequestCommentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestCommentsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_comments". All fields are combined with a logical 'AND'. */
export type RequestCommentsBoolExp = {
  _and?: InputMaybe<Array<RequestCommentsBoolExp>>;
  _not?: InputMaybe<RequestCommentsBoolExp>;
  _or?: InputMaybe<Array<RequestCommentsBoolExp>>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  completedBy?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isInternalComment?: InputMaybe<BooleanComparisonExp>;
  payload?: InputMaybe<JsonbComparisonExp>;
  questionId?: InputMaybe<StringComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestFormId?: InputMaybe<UuidComparisonExp>;
  requestFormTemplateId?: InputMaybe<UuidComparisonExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  request_comment_mentions?: InputMaybe<RequestCommentsMentionsBoolExp>;
  request_comment_mentions_aggregate?: InputMaybe<RequestCommentsMentionsAggregateBoolExp>;
  request_comment_type?: InputMaybe<RequestCommentTypeBoolExp>;
  request_form?: InputMaybe<RequestFormsBoolExp>;
  request_form_template?: InputMaybe<RequestFormTemplatesBoolExp>;
  rfx?: InputMaybe<RfxBoolExp>;
  rfxId?: InputMaybe<UuidComparisonExp>;
  rfxSupplierId?: InputMaybe<UuidComparisonExp>;
  rfx_supplier?: InputMaybe<RfxSuppliersBoolExp>;
  riskAlertId?: InputMaybe<StringComparisonExp>;
  riskId?: InputMaybe<UuidComparisonExp>;
  summaryApprovalId?: InputMaybe<UuidComparisonExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  taskId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<RequestCommentTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_comments" */
export enum RequestCommentsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_COMMENTS_PKEY = 'request_comments_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RequestCommentsDeleteAtPathInput = {
  payload?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RequestCommentsDeleteElemInput = {
  payload?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RequestCommentsDeleteKeyInput = {
  payload?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "request_comments" */
export type RequestCommentsInsertInput = {
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  completedBy?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isInternalComment?: InputMaybe<Scalars['Boolean']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestFormTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  request_comment_mentions?: InputMaybe<RequestCommentsMentionsArrRelInsertInput>;
  request_form?: InputMaybe<RequestFormsObjRelInsertInput>;
  request_form_template?: InputMaybe<RequestFormTemplatesObjRelInsertInput>;
  rfx?: InputMaybe<RfxObjRelInsertInput>;
  rfxId?: InputMaybe<Scalars['uuid']['input']>;
  rfxSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  rfx_supplier?: InputMaybe<RfxSuppliersObjRelInsertInput>;
  riskAlertId?: InputMaybe<Scalars['String']['input']>;
  riskId?: InputMaybe<Scalars['uuid']['input']>;
  summaryApprovalId?: InputMaybe<Scalars['uuid']['input']>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<RequestCommentTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RequestCommentsMaxFields = {
  __typename?: 'request_comments_max_fields';
  agreementId: Maybe<Scalars['uuid']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  completedBy: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  questionId: Maybe<Scalars['String']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestFormTemplateId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  rfxId: Maybe<Scalars['uuid']['output']>;
  rfxSupplierId: Maybe<Scalars['uuid']['output']>;
  riskAlertId: Maybe<Scalars['String']['output']>;
  riskId: Maybe<Scalars['uuid']['output']>;
  summaryApprovalId: Maybe<Scalars['uuid']['output']>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  taskId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "request_comments" */
export type RequestCommentsMaxOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  completedBy?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  questionId?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestFormTemplateId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  rfxId?: InputMaybe<OrderBy>;
  rfxSupplierId?: InputMaybe<OrderBy>;
  riskAlertId?: InputMaybe<OrderBy>;
  riskId?: InputMaybe<OrderBy>;
  summaryApprovalId?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  taskId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** Mentions among all comments */
export type RequestCommentsMentions = {
  __typename?: 'request_comments_mentions';
  /** An object relationship */
  agreement: Maybe<Agreements>;
  agreementId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  comment: RequestComments;
  commentId: Scalars['uuid']['output'];
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  isResolved: Scalars['Boolean']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  request: Maybe<Requests>;
  requestId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  risk: Maybe<Risks>;
  riskAlertId: Maybe<Scalars['String']['output']>;
  riskId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  supplier: Maybe<OrganisationSuppliers>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "request_comments_mentions" */
export type RequestCommentsMentionsAggregate = {
  __typename?: 'request_comments_mentions_aggregate';
  aggregate: Maybe<RequestCommentsMentionsAggregateFields>;
  nodes: Array<RequestCommentsMentions>;
};

export type RequestCommentsMentionsAggregateBoolExp = {
  bool_and?: InputMaybe<RequestCommentsMentionsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<RequestCommentsMentionsAggregateBoolExpBoolOr>;
  count?: InputMaybe<RequestCommentsMentionsAggregateBoolExpCount>;
};

export type RequestCommentsMentionsAggregateBoolExpBoolAnd = {
  arguments: RequestCommentsMentionsSelectColumnRequestCommentsMentionsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestCommentsMentionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RequestCommentsMentionsAggregateBoolExpBoolOr = {
  arguments: RequestCommentsMentionsSelectColumnRequestCommentsMentionsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestCommentsMentionsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RequestCommentsMentionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestCommentsMentionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestCommentsMentionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_comments_mentions" */
export type RequestCommentsMentionsAggregateFields = {
  __typename?: 'request_comments_mentions_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestCommentsMentionsMaxFields>;
  min: Maybe<RequestCommentsMentionsMinFields>;
};


/** aggregate fields of "request_comments_mentions" */
export type RequestCommentsMentionsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RequestCommentsMentionsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "request_comments_mentions" */
export type RequestCommentsMentionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestCommentsMentionsMaxOrderBy>;
  min?: InputMaybe<RequestCommentsMentionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_comments_mentions" */
export type RequestCommentsMentionsArrRelInsertInput = {
  data: Array<RequestCommentsMentionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestCommentsMentionsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_comments_mentions". All fields are combined with a logical 'AND'. */
export type RequestCommentsMentionsBoolExp = {
  _and?: InputMaybe<Array<RequestCommentsMentionsBoolExp>>;
  _not?: InputMaybe<RequestCommentsMentionsBoolExp>;
  _or?: InputMaybe<Array<RequestCommentsMentionsBoolExp>>;
  agreement?: InputMaybe<AgreementsBoolExp>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  comment?: InputMaybe<RequestCommentsBoolExp>;
  commentId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isResolved?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  risk?: InputMaybe<RisksBoolExp>;
  riskAlertId?: InputMaybe<StringComparisonExp>;
  riskId?: InputMaybe<UuidComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  supplierId?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_comments_mentions" */
export enum RequestCommentsMentionsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_COMMENTS_MENTIONS_PKEY = 'request_comments_mentions_pkey'
}

/** input type for inserting data into table "request_comments_mentions" */
export type RequestCommentsMentionsInsertInput = {
  agreement?: InputMaybe<AgreementsObjRelInsertInput>;
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  comment?: InputMaybe<RequestCommentsObjRelInsertInput>;
  commentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  risk?: InputMaybe<RisksObjRelInsertInput>;
  riskAlertId?: InputMaybe<Scalars['String']['input']>;
  riskId?: InputMaybe<Scalars['uuid']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  supplierId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RequestCommentsMentionsMaxFields = {
  __typename?: 'request_comments_mentions_max_fields';
  agreementId: Maybe<Scalars['uuid']['output']>;
  commentId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  riskAlertId: Maybe<Scalars['String']['output']>;
  riskId: Maybe<Scalars['uuid']['output']>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "request_comments_mentions" */
export type RequestCommentsMentionsMaxOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  commentId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  riskAlertId?: InputMaybe<OrderBy>;
  riskId?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RequestCommentsMentionsMinFields = {
  __typename?: 'request_comments_mentions_min_fields';
  agreementId: Maybe<Scalars['uuid']['output']>;
  commentId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  riskAlertId: Maybe<Scalars['String']['output']>;
  riskId: Maybe<Scalars['uuid']['output']>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "request_comments_mentions" */
export type RequestCommentsMentionsMinOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  commentId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  riskAlertId?: InputMaybe<OrderBy>;
  riskId?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_comments_mentions" */
export type RequestCommentsMentionsMutationResponse = {
  __typename?: 'request_comments_mentions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestCommentsMentions>;
};

/** on_conflict condition type for table "request_comments_mentions" */
export type RequestCommentsMentionsOnConflict = {
  constraint: RequestCommentsMentionsConstraint;
  update_columns: Array<RequestCommentsMentionsUpdateColumn>;
  where?: InputMaybe<RequestCommentsMentionsBoolExp>;
};

/** Ordering options when selecting data from "request_comments_mentions". */
export type RequestCommentsMentionsOrderBy = {
  agreement?: InputMaybe<AgreementsOrderBy>;
  agreementId?: InputMaybe<OrderBy>;
  comment?: InputMaybe<RequestCommentsOrderBy>;
  commentId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isResolved?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  risk?: InputMaybe<RisksOrderBy>;
  riskAlertId?: InputMaybe<OrderBy>;
  riskId?: InputMaybe<OrderBy>;
  supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_comments_mentions */
export type RequestCommentsMentionsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_comments_mentions" */
export enum RequestCommentsMentionsSelectColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  COMMENTID = 'commentId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISRESOLVED = 'isResolved',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RISKALERTID = 'riskAlertId',
  /** column name */
  RISKID = 'riskId',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  USERID = 'userId'
}

/** select "request_comments_mentions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "request_comments_mentions" */
export enum RequestCommentsMentionsSelectColumnRequestCommentsMentionsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISRESOLVED = 'isResolved'
}

/** select "request_comments_mentions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "request_comments_mentions" */
export enum RequestCommentsMentionsSelectColumnRequestCommentsMentionsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISRESOLVED = 'isResolved'
}

/** input type for updating data in table "request_comments_mentions" */
export type RequestCommentsMentionsSetInput = {
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "request_comments_mentions" */
export enum RequestCommentsMentionsUpdateColumn {
  /** column name */
  ISRESOLVED = 'isResolved'
}

export type RequestCommentsMentionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestCommentsMentionsSetInput>;
  /** filter the rows which have to be updated */
  where: RequestCommentsMentionsBoolExp;
};

/** aggregate min on columns */
export type RequestCommentsMinFields = {
  __typename?: 'request_comments_min_fields';
  agreementId: Maybe<Scalars['uuid']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  completedBy: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  questionId: Maybe<Scalars['String']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestFormTemplateId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  rfxId: Maybe<Scalars['uuid']['output']>;
  rfxSupplierId: Maybe<Scalars['uuid']['output']>;
  riskAlertId: Maybe<Scalars['String']['output']>;
  riskId: Maybe<Scalars['uuid']['output']>;
  summaryApprovalId: Maybe<Scalars['uuid']['output']>;
  supplierId: Maybe<Scalars['uuid']['output']>;
  taskId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "request_comments" */
export type RequestCommentsMinOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  completedBy?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  questionId?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestFormTemplateId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  rfxId?: InputMaybe<OrderBy>;
  rfxSupplierId?: InputMaybe<OrderBy>;
  riskAlertId?: InputMaybe<OrderBy>;
  riskId?: InputMaybe<OrderBy>;
  summaryApprovalId?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  taskId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_comments" */
export type RequestCommentsMutationResponse = {
  __typename?: 'request_comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestComments>;
};

/** input type for inserting object relation for remote table "request_comments" */
export type RequestCommentsObjRelInsertInput = {
  data: RequestCommentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestCommentsOnConflict>;
};

/** on_conflict condition type for table "request_comments" */
export type RequestCommentsOnConflict = {
  constraint: RequestCommentsConstraint;
  update_columns: Array<RequestCommentsUpdateColumn>;
  where?: InputMaybe<RequestCommentsBoolExp>;
};

/** Ordering options when selecting data from "request_comments". */
export type RequestCommentsOrderBy = {
  agreementId?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  completedBy?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isInternalComment?: InputMaybe<OrderBy>;
  payload?: InputMaybe<OrderBy>;
  questionId?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestFormTemplateId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  request_comment_mentions_aggregate?: InputMaybe<RequestCommentsMentionsAggregateOrderBy>;
  request_comment_type?: InputMaybe<RequestCommentTypeOrderBy>;
  request_form?: InputMaybe<RequestFormsOrderBy>;
  request_form_template?: InputMaybe<RequestFormTemplatesOrderBy>;
  rfx?: InputMaybe<RfxOrderBy>;
  rfxId?: InputMaybe<OrderBy>;
  rfxSupplierId?: InputMaybe<OrderBy>;
  rfx_supplier?: InputMaybe<RfxSuppliersOrderBy>;
  riskAlertId?: InputMaybe<OrderBy>;
  riskId?: InputMaybe<OrderBy>;
  summaryApprovalId?: InputMaybe<OrderBy>;
  supplierId?: InputMaybe<OrderBy>;
  taskId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_comments */
export type RequestCommentsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RequestCommentsPrependInput = {
  payload?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "request_comments" */
export enum RequestCommentsSelectColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  COMPLETEDBY = 'completedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISINTERNALCOMMENT = 'isInternalComment',
  /** column name */
  PAYLOAD = 'payload',
  /** column name */
  QUESTIONID = 'questionId',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTFORMTEMPLATEID = 'requestFormTemplateId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  RFXSUPPLIERID = 'rfxSupplierId',
  /** column name */
  RISKALERTID = 'riskAlertId',
  /** column name */
  RISKID = 'riskId',
  /** column name */
  SUMMARYAPPROVALID = 'summaryApprovalId',
  /** column name */
  SUPPLIERID = 'supplierId',
  /** column name */
  TASKID = 'taskId',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** select "request_comments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "request_comments" */
export enum RequestCommentsSelectColumnRequestCommentsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ISINTERNALCOMMENT = 'isInternalComment'
}

/** select "request_comments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "request_comments" */
export enum RequestCommentsSelectColumnRequestCommentsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ISINTERNALCOMMENT = 'isInternalComment'
}

/** input type for updating data in table "request_comments" */
export type RequestCommentsSetInput = {
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  completedBy?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isInternalComment?: InputMaybe<Scalars['Boolean']['input']>;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  rfxId?: InputMaybe<Scalars['uuid']['input']>;
  rfxSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  summaryApprovalId?: InputMaybe<Scalars['uuid']['input']>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<RequestCommentTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "request_comments" */
export enum RequestCommentsUpdateColumn {
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  COMPLETEDBY = 'completedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISINTERNALCOMMENT = 'isInternalComment',
  /** column name */
  PAYLOAD = 'payload',
  /** column name */
  QUESTIONID = 'questionId',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  RFXSUPPLIERID = 'rfxSupplierId',
  /** column name */
  SUMMARYAPPROVALID = 'summaryApprovalId',
  /** column name */
  TASKID = 'taskId',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

export type RequestCommentsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RequestCommentsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RequestCommentsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RequestCommentsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RequestCommentsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RequestCommentsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestCommentsSetInput>;
  /** filter the rows which have to be updated */
  where: RequestCommentsBoolExp;
};

/** Properties of a request that are computed from other places including form submissions and workflow conditionality */
export type RequestComputedProperties = {
  __typename?: 'request_computed_properties';
  address: Maybe<Scalars['jsonb']['output']>;
  annualValueNumber: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  budgetHolder: Maybe<Users>;
  budgetHolderId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  businessOwner: Maybe<Users>;
  businessOwnerId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  buyerLegalEntity: Maybe<Subsidiaries>;
  buyerLegalEntityId: Maybe<Scalars['uuid']['output']>;
  cancelByDate: Maybe<Scalars['timestamptz']['output']>;
  cancellationNoticeDays: Maybe<Scalars['Int']['output']>;
  cancellationReason: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  category: Maybe<CustomCoreDataOptions>;
  /** Reference to category option in custom core data options */
  categoryId: Maybe<Scalars['uuid']['output']>;
  contractEndDate: Maybe<Scalars['timestamptz']['output']>;
  contractLength: Maybe<Scalars['numeric']['output']>;
  contractStartDate: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  costCenter: Maybe<Departments>;
  costCenterId: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  department: Maybe<Departments>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  goLiveDate: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  inBudget: Maybe<Scalars['Boolean']['output']>;
  isAutoRenewal: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  itOwner: Maybe<Users>;
  itOwnerId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  market: Maybe<CustomCoreDataOptions>;
  /** Reference to market option in custom core data options */
  marketId: Maybe<Scalars['uuid']['output']>;
  note: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  paymentMethod: Maybe<PaymentMethods>;
  paymentMethodId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  paymentTerm: Maybe<PaymentTerms>;
  paymentTermId: Maybe<Scalars['uuid']['output']>;
  poNumber: Maybe<Scalars['String']['output']>;
  pricingObject: Maybe<Scalars['jsonb']['output']>;
  renewalDate: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  shouldRenew: Maybe<Scalars['Boolean']['output']>;
  syncWithAccountingIntegration: Maybe<Scalars['Boolean']['output']>;
  taxNumber: Maybe<Scalars['jsonb']['output']>;
  type: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** This is the value user enters (regardless of the frequency) */
  valueNumber: Maybe<Scalars['numeric']['output']>;
  valueObject: Maybe<Scalars['jsonb']['output']>;
  website: Maybe<Scalars['String']['output']>;
};


/** Properties of a request that are computed from other places including form submissions and workflow conditionality */
export type RequestComputedPropertiesAddressArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** Properties of a request that are computed from other places including form submissions and workflow conditionality */
export type RequestComputedPropertiesPricingObjectArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** Properties of a request that are computed from other places including form submissions and workflow conditionality */
export type RequestComputedPropertiesTaxNumberArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** Properties of a request that are computed from other places including form submissions and workflow conditionality */
export type RequestComputedPropertiesValueObjectArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RequestComputedPropertiesAppendInput = {
  address?: InputMaybe<Scalars['jsonb']['input']>;
  pricingObject?: InputMaybe<Scalars['jsonb']['input']>;
  taxNumber?: InputMaybe<Scalars['jsonb']['input']>;
  valueObject?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "request_computed_properties". All fields are combined with a logical 'AND'. */
export type RequestComputedPropertiesBoolExp = {
  _and?: InputMaybe<Array<RequestComputedPropertiesBoolExp>>;
  _not?: InputMaybe<RequestComputedPropertiesBoolExp>;
  _or?: InputMaybe<Array<RequestComputedPropertiesBoolExp>>;
  address?: InputMaybe<JsonbComparisonExp>;
  annualValueNumber?: InputMaybe<NumericComparisonExp>;
  budgetHolder?: InputMaybe<UsersBoolExp>;
  budgetHolderId?: InputMaybe<UuidComparisonExp>;
  businessOwner?: InputMaybe<UsersBoolExp>;
  businessOwnerId?: InputMaybe<UuidComparisonExp>;
  buyerLegalEntity?: InputMaybe<SubsidiariesBoolExp>;
  buyerLegalEntityId?: InputMaybe<UuidComparisonExp>;
  cancelByDate?: InputMaybe<TimestamptzComparisonExp>;
  cancellationNoticeDays?: InputMaybe<IntComparisonExp>;
  cancellationReason?: InputMaybe<StringComparisonExp>;
  category?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  categoryId?: InputMaybe<UuidComparisonExp>;
  contractEndDate?: InputMaybe<TimestamptzComparisonExp>;
  contractLength?: InputMaybe<NumericComparisonExp>;
  contractStartDate?: InputMaybe<TimestamptzComparisonExp>;
  costCenter?: InputMaybe<DepartmentsBoolExp>;
  costCenterId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<DepartmentsBoolExp>;
  departmentId?: InputMaybe<UuidComparisonExp>;
  goLiveDate?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  inBudget?: InputMaybe<BooleanComparisonExp>;
  isAutoRenewal?: InputMaybe<BooleanComparisonExp>;
  itOwner?: InputMaybe<UsersBoolExp>;
  itOwnerId?: InputMaybe<UuidComparisonExp>;
  market?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  marketId?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  paymentMethod?: InputMaybe<PaymentMethodsBoolExp>;
  paymentMethodId?: InputMaybe<UuidComparisonExp>;
  paymentTerm?: InputMaybe<PaymentTermsBoolExp>;
  paymentTermId?: InputMaybe<UuidComparisonExp>;
  poNumber?: InputMaybe<StringComparisonExp>;
  pricingObject?: InputMaybe<JsonbComparisonExp>;
  renewalDate?: InputMaybe<TimestamptzComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  shouldRenew?: InputMaybe<BooleanComparisonExp>;
  syncWithAccountingIntegration?: InputMaybe<BooleanComparisonExp>;
  taxNumber?: InputMaybe<JsonbComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  valueNumber?: InputMaybe<NumericComparisonExp>;
  valueObject?: InputMaybe<JsonbComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "request_computed_properties" */
export enum RequestComputedPropertiesConstraint {
  /** unique or primary key constraint on columns "request_id" */
  REQUEST_COMPUTED_PROPERTIES_PKEY = 'request_computed_properties_pkey',
  /** unique or primary key constraint on columns "request_id" */
  REQUEST_COMPUTED_PROPERTIES_REQUEST_ID_KEY = 'request_computed_properties_request_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RequestComputedPropertiesDeleteAtPathInput = {
  address?: InputMaybe<Array<Scalars['String']['input']>>;
  pricingObject?: InputMaybe<Array<Scalars['String']['input']>>;
  taxNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  valueObject?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RequestComputedPropertiesDeleteElemInput = {
  address?: InputMaybe<Scalars['Int']['input']>;
  pricingObject?: InputMaybe<Scalars['Int']['input']>;
  taxNumber?: InputMaybe<Scalars['Int']['input']>;
  valueObject?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RequestComputedPropertiesDeleteKeyInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  pricingObject?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  valueObject?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "request_computed_properties" */
export type RequestComputedPropertiesIncInput = {
  annualValueNumber?: InputMaybe<Scalars['numeric']['input']>;
  cancellationNoticeDays?: InputMaybe<Scalars['Int']['input']>;
  contractLength?: InputMaybe<Scalars['numeric']['input']>;
  /** This is the value user enters (regardless of the frequency) */
  valueNumber?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "request_computed_properties" */
export type RequestComputedPropertiesInsertInput = {
  address?: InputMaybe<Scalars['jsonb']['input']>;
  annualValueNumber?: InputMaybe<Scalars['numeric']['input']>;
  budgetHolder?: InputMaybe<UsersObjRelInsertInput>;
  budgetHolderId?: InputMaybe<Scalars['uuid']['input']>;
  businessOwner?: InputMaybe<UsersObjRelInsertInput>;
  businessOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  buyerLegalEntity?: InputMaybe<SubsidiariesObjRelInsertInput>;
  buyerLegalEntityId?: InputMaybe<Scalars['uuid']['input']>;
  cancelByDate?: InputMaybe<Scalars['timestamptz']['input']>;
  cancellationNoticeDays?: InputMaybe<Scalars['Int']['input']>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CustomCoreDataOptionsObjRelInsertInput>;
  /** Reference to category option in custom core data options */
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  contractEndDate?: InputMaybe<Scalars['timestamptz']['input']>;
  contractLength?: InputMaybe<Scalars['numeric']['input']>;
  contractStartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  costCenter?: InputMaybe<DepartmentsObjRelInsertInput>;
  costCenterId?: InputMaybe<Scalars['uuid']['input']>;
  department?: InputMaybe<DepartmentsObjRelInsertInput>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  goLiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inBudget?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoRenewal?: InputMaybe<Scalars['Boolean']['input']>;
  itOwner?: InputMaybe<UsersObjRelInsertInput>;
  itOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  market?: InputMaybe<CustomCoreDataOptionsObjRelInsertInput>;
  /** Reference to market option in custom core data options */
  marketId?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodsObjRelInsertInput>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentTerm?: InputMaybe<PaymentTermsObjRelInsertInput>;
  paymentTermId?: InputMaybe<Scalars['uuid']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  pricingObject?: InputMaybe<Scalars['jsonb']['input']>;
  renewalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  shouldRenew?: InputMaybe<Scalars['Boolean']['input']>;
  syncWithAccountingIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  taxNumber?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** This is the value user enters (regardless of the frequency) */
  valueNumber?: InputMaybe<Scalars['numeric']['input']>;
  valueObject?: InputMaybe<Scalars['jsonb']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "request_computed_properties" */
export type RequestComputedPropertiesMutationResponse = {
  __typename?: 'request_computed_properties_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestComputedProperties>;
};

/** input type for inserting object relation for remote table "request_computed_properties" */
export type RequestComputedPropertiesObjRelInsertInput = {
  data: RequestComputedPropertiesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestComputedPropertiesOnConflict>;
};

/** on_conflict condition type for table "request_computed_properties" */
export type RequestComputedPropertiesOnConflict = {
  constraint: RequestComputedPropertiesConstraint;
  update_columns: Array<RequestComputedPropertiesUpdateColumn>;
  where?: InputMaybe<RequestComputedPropertiesBoolExp>;
};

/** Ordering options when selecting data from "request_computed_properties". */
export type RequestComputedPropertiesOrderBy = {
  address?: InputMaybe<OrderBy>;
  annualValueNumber?: InputMaybe<OrderBy>;
  budgetHolder?: InputMaybe<UsersOrderBy>;
  budgetHolderId?: InputMaybe<OrderBy>;
  businessOwner?: InputMaybe<UsersOrderBy>;
  businessOwnerId?: InputMaybe<OrderBy>;
  buyerLegalEntity?: InputMaybe<SubsidiariesOrderBy>;
  buyerLegalEntityId?: InputMaybe<OrderBy>;
  cancelByDate?: InputMaybe<OrderBy>;
  cancellationNoticeDays?: InputMaybe<OrderBy>;
  cancellationReason?: InputMaybe<OrderBy>;
  category?: InputMaybe<CustomCoreDataOptionsOrderBy>;
  categoryId?: InputMaybe<OrderBy>;
  contractEndDate?: InputMaybe<OrderBy>;
  contractLength?: InputMaybe<OrderBy>;
  contractStartDate?: InputMaybe<OrderBy>;
  costCenter?: InputMaybe<DepartmentsOrderBy>;
  costCenterId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<DepartmentsOrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  goLiveDate?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  inBudget?: InputMaybe<OrderBy>;
  isAutoRenewal?: InputMaybe<OrderBy>;
  itOwner?: InputMaybe<UsersOrderBy>;
  itOwnerId?: InputMaybe<OrderBy>;
  market?: InputMaybe<CustomCoreDataOptionsOrderBy>;
  marketId?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  paymentMethod?: InputMaybe<PaymentMethodsOrderBy>;
  paymentMethodId?: InputMaybe<OrderBy>;
  paymentTerm?: InputMaybe<PaymentTermsOrderBy>;
  paymentTermId?: InputMaybe<OrderBy>;
  poNumber?: InputMaybe<OrderBy>;
  pricingObject?: InputMaybe<OrderBy>;
  renewalDate?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  shouldRenew?: InputMaybe<OrderBy>;
  syncWithAccountingIntegration?: InputMaybe<OrderBy>;
  taxNumber?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  valueNumber?: InputMaybe<OrderBy>;
  valueObject?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_computed_properties */
export type RequestComputedPropertiesPkColumnsInput = {
  requestId: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RequestComputedPropertiesPrependInput = {
  address?: InputMaybe<Scalars['jsonb']['input']>;
  pricingObject?: InputMaybe<Scalars['jsonb']['input']>;
  taxNumber?: InputMaybe<Scalars['jsonb']['input']>;
  valueObject?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for updating data in table "request_computed_properties" */
export type RequestComputedPropertiesSetInput = {
  address?: InputMaybe<Scalars['jsonb']['input']>;
  annualValueNumber?: InputMaybe<Scalars['numeric']['input']>;
  budgetHolderId?: InputMaybe<Scalars['uuid']['input']>;
  businessOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  buyerLegalEntityId?: InputMaybe<Scalars['uuid']['input']>;
  cancelByDate?: InputMaybe<Scalars['timestamptz']['input']>;
  cancellationNoticeDays?: InputMaybe<Scalars['Int']['input']>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  /** Reference to category option in custom core data options */
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  contractEndDate?: InputMaybe<Scalars['timestamptz']['input']>;
  contractLength?: InputMaybe<Scalars['numeric']['input']>;
  contractStartDate?: InputMaybe<Scalars['timestamptz']['input']>;
  costCenterId?: InputMaybe<Scalars['uuid']['input']>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  goLiveDate?: InputMaybe<Scalars['timestamptz']['input']>;
  inBudget?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoRenewal?: InputMaybe<Scalars['Boolean']['input']>;
  itOwnerId?: InputMaybe<Scalars['uuid']['input']>;
  /** Reference to market option in custom core data options */
  marketId?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['uuid']['input']>;
  paymentTermId?: InputMaybe<Scalars['uuid']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  pricingObject?: InputMaybe<Scalars['jsonb']['input']>;
  renewalDate?: InputMaybe<Scalars['timestamptz']['input']>;
  shouldRenew?: InputMaybe<Scalars['Boolean']['input']>;
  syncWithAccountingIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  taxNumber?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** This is the value user enters (regardless of the frequency) */
  valueNumber?: InputMaybe<Scalars['numeric']['input']>;
  valueObject?: InputMaybe<Scalars['jsonb']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "request_computed_properties" */
export enum RequestComputedPropertiesUpdateColumn {
  /** column name */
  ADDRESS = 'address',
  /** column name */
  ANNUALVALUENUMBER = 'annualValueNumber',
  /** column name */
  BUDGETHOLDERID = 'budgetHolderId',
  /** column name */
  BUSINESSOWNERID = 'businessOwnerId',
  /** column name */
  BUYERLEGALENTITYID = 'buyerLegalEntityId',
  /** column name */
  CANCELBYDATE = 'cancelByDate',
  /** column name */
  CANCELLATIONNOTICEDAYS = 'cancellationNoticeDays',
  /** column name */
  CANCELLATIONREASON = 'cancellationReason',
  /** column name */
  CATEGORYID = 'categoryId',
  /** column name */
  CONTRACTENDDATE = 'contractEndDate',
  /** column name */
  CONTRACTLENGTH = 'contractLength',
  /** column name */
  CONTRACTSTARTDATE = 'contractStartDate',
  /** column name */
  COSTCENTERID = 'costCenterId',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  GOLIVEDATE = 'goLiveDate',
  /** column name */
  INBUDGET = 'inBudget',
  /** column name */
  ISAUTORENEWAL = 'isAutoRenewal',
  /** column name */
  ITOWNERID = 'itOwnerId',
  /** column name */
  MARKETID = 'marketId',
  /** column name */
  NOTE = 'note',
  /** column name */
  PAYMENTMETHODID = 'paymentMethodId',
  /** column name */
  PAYMENTTERMID = 'paymentTermId',
  /** column name */
  PONUMBER = 'poNumber',
  /** column name */
  PRICINGOBJECT = 'pricingObject',
  /** column name */
  RENEWALDATE = 'renewalDate',
  /** column name */
  SHOULDRENEW = 'shouldRenew',
  /** column name */
  SYNCWITHACCOUNTINGINTEGRATION = 'syncWithAccountingIntegration',
  /** column name */
  TAXNUMBER = 'taxNumber',
  /** column name */
  TYPE = 'type',
  /** column name */
  VALUENUMBER = 'valueNumber',
  /** column name */
  VALUEOBJECT = 'valueObject',
  /** column name */
  WEBSITE = 'website'
}

export type RequestComputedPropertiesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RequestComputedPropertiesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RequestComputedPropertiesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RequestComputedPropertiesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RequestComputedPropertiesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RequestComputedPropertiesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RequestComputedPropertiesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestComputedPropertiesSetInput>;
  /** filter the rows which have to be updated */
  where: RequestComputedPropertiesBoolExp;
};

/** columns and relationships of "request_documents" */
export type RequestDocuments = {
  __typename?: 'request_documents';
  createdAt: Scalars['timestamptz']['output'];
  customType: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  customTypeValue: Maybe<CustomDocumentTypes>;
  deletedAt: Maybe<Scalars['date']['output']>;
  fileName: Scalars['String']['output'];
  filestoreId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  shouldPromoteToGlobal: Scalars['Boolean']['output'];
  source: Maybe<Scalars['requestDocumentSource']['output']>;
  /** An object relationship */
  sourceRequestForm: Maybe<RequestForms>;
  sourceRequestFormId: Maybe<Scalars['uuid']['output']>;
  staticType: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  uploadedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  uploadedByUser: Maybe<Users>;
};

/** order by aggregate values of table "request_documents" */
export type RequestDocumentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestDocumentsMaxOrderBy>;
  min?: InputMaybe<RequestDocumentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_documents" */
export type RequestDocumentsArrRelInsertInput = {
  data: Array<RequestDocumentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestDocumentsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_documents". All fields are combined with a logical 'AND'. */
export type RequestDocumentsBoolExp = {
  _and?: InputMaybe<Array<RequestDocumentsBoolExp>>;
  _not?: InputMaybe<RequestDocumentsBoolExp>;
  _or?: InputMaybe<Array<RequestDocumentsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customType?: InputMaybe<UuidComparisonExp>;
  customTypeValue?: InputMaybe<CustomDocumentTypesBoolExp>;
  deletedAt?: InputMaybe<DateComparisonExp>;
  fileName?: InputMaybe<StringComparisonExp>;
  filestoreId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  shouldPromoteToGlobal?: InputMaybe<BooleanComparisonExp>;
  source?: InputMaybe<StringComparisonExp>;
  sourceRequestForm?: InputMaybe<RequestFormsBoolExp>;
  sourceRequestFormId?: InputMaybe<UuidComparisonExp>;
  staticType?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  uploadedBy?: InputMaybe<UuidComparisonExp>;
  uploadedByUser?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "request_documents" */
export enum RequestDocumentsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_DOCUMENTS_PKEY = 'request_documents_pkey'
}

/** input type for inserting data into table "request_documents" */
export type RequestDocumentsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customType?: InputMaybe<Scalars['uuid']['input']>;
  customTypeValue?: InputMaybe<CustomDocumentTypesObjRelInsertInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  filestoreId?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  shouldPromoteToGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceRequestForm?: InputMaybe<RequestFormsObjRelInsertInput>;
  sourceRequestFormId?: InputMaybe<Scalars['uuid']['input']>;
  staticType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedBy?: InputMaybe<Scalars['uuid']['input']>;
  uploadedByUser?: InputMaybe<UsersObjRelInsertInput>;
};

/** order by max() on columns of table "request_documents" */
export type RequestDocumentsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customType?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  filestoreId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceRequestFormId?: InputMaybe<OrderBy>;
  staticType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  uploadedBy?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_documents" */
export type RequestDocumentsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customType?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  filestoreId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceRequestFormId?: InputMaybe<OrderBy>;
  staticType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  uploadedBy?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_documents" */
export type RequestDocumentsMutationResponse = {
  __typename?: 'request_documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestDocuments>;
};

/** input type for inserting object relation for remote table "request_documents" */
export type RequestDocumentsObjRelInsertInput = {
  data: RequestDocumentsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestDocumentsOnConflict>;
};

/** on_conflict condition type for table "request_documents" */
export type RequestDocumentsOnConflict = {
  constraint: RequestDocumentsConstraint;
  update_columns: Array<RequestDocumentsUpdateColumn>;
  where?: InputMaybe<RequestDocumentsBoolExp>;
};

/** Ordering options when selecting data from "request_documents". */
export type RequestDocumentsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customType?: InputMaybe<OrderBy>;
  customTypeValue?: InputMaybe<CustomDocumentTypesOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  fileName?: InputMaybe<OrderBy>;
  filestoreId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  shouldPromoteToGlobal?: InputMaybe<OrderBy>;
  source?: InputMaybe<OrderBy>;
  sourceRequestForm?: InputMaybe<RequestFormsOrderBy>;
  sourceRequestFormId?: InputMaybe<OrderBy>;
  staticType?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  uploadedBy?: InputMaybe<OrderBy>;
  uploadedByUser?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: request_documents */
export type RequestDocumentsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_documents" */
export enum RequestDocumentsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CUSTOMTYPE = 'customType',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  FILENAME = 'fileName',
  /** column name */
  FILESTOREID = 'filestoreId',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  SHOULDPROMOTETOGLOBAL = 'shouldPromoteToGlobal',
  /** column name */
  SOURCE = 'source',
  /** column name */
  SOURCEREQUESTFORMID = 'sourceRequestFormId',
  /** column name */
  STATICTYPE = 'staticType',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPLOADEDBY = 'uploadedBy'
}

/** input type for updating data in table "request_documents" */
export type RequestDocumentsSetInput = {
  customType?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['date']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  shouldPromoteToGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  staticType?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "request_documents" */
export enum RequestDocumentsUpdateColumn {
  /** column name */
  CUSTOMTYPE = 'customType',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  FILENAME = 'fileName',
  /** column name */
  SHOULDPROMOTETOGLOBAL = 'shouldPromoteToGlobal',
  /** column name */
  STATICTYPE = 'staticType'
}

export type RequestDocumentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestDocumentsSetInput>;
  /** filter the rows which have to be updated */
  where: RequestDocumentsBoolExp;
};

/** columns and relationships of "request_esign_documents" */
export type RequestEsignDocuments = {
  __typename?: 'request_esign_documents';
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  remoteId: Scalars['String']['output'];
  requestId: Scalars['uuid']['output'];
  status: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** order by aggregate values of table "request_esign_documents" */
export type RequestEsignDocumentsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestEsignDocumentsMaxOrderBy>;
  min?: InputMaybe<RequestEsignDocumentsMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_esign_documents" */
export type RequestEsignDocumentsArrRelInsertInput = {
  data: Array<RequestEsignDocumentsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestEsignDocumentsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_esign_documents". All fields are combined with a logical 'AND'. */
export type RequestEsignDocumentsBoolExp = {
  _and?: InputMaybe<Array<RequestEsignDocumentsBoolExp>>;
  _not?: InputMaybe<RequestEsignDocumentsBoolExp>;
  _or?: InputMaybe<Array<RequestEsignDocumentsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  url?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "request_esign_documents" */
export enum RequestEsignDocumentsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_ESIGN_DOCUMENTS_PKEY = 'request_esign_documents_pkey'
}

/** input type for inserting data into table "request_esign_documents" */
export type RequestEsignDocumentsInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "request_esign_documents" */
export type RequestEsignDocumentsMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_esign_documents" */
export type RequestEsignDocumentsMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_esign_documents" */
export type RequestEsignDocumentsMutationResponse = {
  __typename?: 'request_esign_documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestEsignDocuments>;
};

/** on_conflict condition type for table "request_esign_documents" */
export type RequestEsignDocumentsOnConflict = {
  constraint: RequestEsignDocumentsConstraint;
  update_columns: Array<RequestEsignDocumentsUpdateColumn>;
  where?: InputMaybe<RequestEsignDocumentsBoolExp>;
};

/** Ordering options when selecting data from "request_esign_documents". */
export type RequestEsignDocumentsOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_esign_documents */
export type RequestEsignDocumentsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_esign_documents" */
export enum RequestEsignDocumentsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  STATUS = 'status',
  /** column name */
  URL = 'url'
}

/** input type for updating data in table "request_esign_documents" */
export type RequestEsignDocumentsSetInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "request_esign_documents" */
export enum RequestEsignDocumentsUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  STATUS = 'status',
  /** column name */
  URL = 'url'
}

export type RequestEsignDocumentsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestEsignDocumentsSetInput>;
  /** filter the rows which have to be updated */
  where: RequestEsignDocumentsBoolExp;
};

/** Followers of a request */
export type RequestFollowers = {
  __typename?: 'request_followers';
  assigneeType: AssigneeTypeEnum;
  /** An object relationship */
  assigneeTypeByAssigneeType: AssigneeType;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  group: Maybe<Groups>;
  groupId: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  note: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  /** An object relationship */
  user: Maybe<Users>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "request_followers" */
export type RequestFollowersAggregate = {
  __typename?: 'request_followers_aggregate';
  aggregate: Maybe<RequestFollowersAggregateFields>;
  nodes: Array<RequestFollowers>;
};

export type RequestFollowersAggregateBoolExp = {
  count?: InputMaybe<RequestFollowersAggregateBoolExpCount>;
};

export type RequestFollowersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestFollowersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestFollowersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_followers" */
export type RequestFollowersAggregateFields = {
  __typename?: 'request_followers_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestFollowersMaxFields>;
  min: Maybe<RequestFollowersMinFields>;
};


/** aggregate fields of "request_followers" */
export type RequestFollowersAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RequestFollowersSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "request_followers" */
export type RequestFollowersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestFollowersMaxOrderBy>;
  min?: InputMaybe<RequestFollowersMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_followers" */
export type RequestFollowersArrRelInsertInput = {
  data: Array<RequestFollowersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFollowersOnConflict>;
};

/** Boolean expression to filter rows from the table "request_followers". All fields are combined with a logical 'AND'. */
export type RequestFollowersBoolExp = {
  _and?: InputMaybe<Array<RequestFollowersBoolExp>>;
  _not?: InputMaybe<RequestFollowersBoolExp>;
  _or?: InputMaybe<Array<RequestFollowersBoolExp>>;
  assigneeType?: InputMaybe<AssigneeTypeEnumComparisonExp>;
  assigneeTypeByAssigneeType?: InputMaybe<AssigneeTypeBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_followers" */
export enum RequestFollowersConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_FOLLOWERS_PKEY = 'request_followers_pkey'
}

/** input type for inserting data into table "request_followers" */
export type RequestFollowersInsertInput = {
  assigneeType?: InputMaybe<AssigneeTypeEnum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RequestFollowersMaxFields = {
  __typename?: 'request_followers_max_fields';
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  groupId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  note: Maybe<Scalars['String']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "request_followers" */
export type RequestFollowersMaxOrderBy = {
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RequestFollowersMinFields = {
  __typename?: 'request_followers_min_fields';
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  groupId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  note: Maybe<Scalars['String']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "request_followers" */
export type RequestFollowersMinOrderBy = {
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_followers" */
export type RequestFollowersMutationResponse = {
  __typename?: 'request_followers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestFollowers>;
};

/** on_conflict condition type for table "request_followers" */
export type RequestFollowersOnConflict = {
  constraint: RequestFollowersConstraint;
  update_columns: Array<RequestFollowersUpdateColumn>;
  where?: InputMaybe<RequestFollowersBoolExp>;
};

/** Ordering options when selecting data from "request_followers". */
export type RequestFollowersOrderBy = {
  assigneeType?: InputMaybe<OrderBy>;
  assigneeTypeByAssigneeType?: InputMaybe<AssigneeTypeOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_followers */
export type RequestFollowersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_followers" */
export enum RequestFollowersSelectColumn {
  /** column name */
  ASSIGNEETYPE = 'assigneeType',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  NOTE = 'note',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "request_followers" */
export type RequestFollowersSetInput = {
  assigneeType?: InputMaybe<AssigneeTypeEnum>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "request_followers" */
export enum RequestFollowersUpdateColumn {
  /** column name */
  ASSIGNEETYPE = 'assigneeType',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  NOTE = 'note',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  USERID = 'userId'
}

export type RequestFollowersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestFollowersSetInput>;
  /** filter the rows which have to be updated */
  where: RequestFollowersBoolExp;
};

/** Stores AI-generated scores for RFx question responses, separate from human scoring */
export type RequestFormQuestionAiScore = {
  __typename?: 'request_form_question_ai_score';
  confidence_explanation: Scalars['String']['output'];
  confidence_rating: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  explanation: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars['uuid']['output'];
  question_name: Scalars['String']['output'];
  /** An object relationship */
  requestFormSubmission: RequestFormSubmissions;
  request_form_submission_id: Scalars['uuid']['output'];
  /** An object relationship */
  rfxAiScoring: RfxAiScoring;
  rfx_ai_scoring_id: Scalars['uuid']['output'];
  score: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "request_form_question_ai_score" */
export type RequestFormQuestionAiScoreAggregate = {
  __typename?: 'request_form_question_ai_score_aggregate';
  aggregate: Maybe<RequestFormQuestionAiScoreAggregateFields>;
  nodes: Array<RequestFormQuestionAiScore>;
};

/** aggregate fields of "request_form_question_ai_score" */
export type RequestFormQuestionAiScoreAggregateFields = {
  __typename?: 'request_form_question_ai_score_aggregate_fields';
  avg: Maybe<RequestFormQuestionAiScoreAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<RequestFormQuestionAiScoreMaxFields>;
  min: Maybe<RequestFormQuestionAiScoreMinFields>;
  stddev: Maybe<RequestFormQuestionAiScoreStddevFields>;
  stddev_pop: Maybe<RequestFormQuestionAiScoreStddevPopFields>;
  stddev_samp: Maybe<RequestFormQuestionAiScoreStddevSampFields>;
  sum: Maybe<RequestFormQuestionAiScoreSumFields>;
  var_pop: Maybe<RequestFormQuestionAiScoreVarPopFields>;
  var_samp: Maybe<RequestFormQuestionAiScoreVarSampFields>;
  variance: Maybe<RequestFormQuestionAiScoreVarianceFields>;
};


/** aggregate fields of "request_form_question_ai_score" */
export type RequestFormQuestionAiScoreAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RequestFormQuestionAiScoreSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RequestFormQuestionAiScoreAvgFields = {
  __typename?: 'request_form_question_ai_score_avg_fields';
  score: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "request_form_question_ai_score". All fields are combined with a logical 'AND'. */
export type RequestFormQuestionAiScoreBoolExp = {
  _and?: InputMaybe<Array<RequestFormQuestionAiScoreBoolExp>>;
  _not?: InputMaybe<RequestFormQuestionAiScoreBoolExp>;
  _or?: InputMaybe<Array<RequestFormQuestionAiScoreBoolExp>>;
  confidence_explanation?: InputMaybe<StringComparisonExp>;
  confidence_rating?: InputMaybe<StringComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  explanation?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  question_name?: InputMaybe<StringComparisonExp>;
  requestFormSubmission?: InputMaybe<RequestFormSubmissionsBoolExp>;
  request_form_submission_id?: InputMaybe<UuidComparisonExp>;
  rfxAiScoring?: InputMaybe<RfxAiScoringBoolExp>;
  rfx_ai_scoring_id?: InputMaybe<UuidComparisonExp>;
  score?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "request_form_question_ai_score" */
export enum RequestFormQuestionAiScoreConstraint {
  /** unique or primary key constraint on columns "question_name", "rfx_ai_scoring_id", "request_form_submission_id" */
  REQUEST_FORM_QUESTION_AI_SCOR_REQUEST_FORM_SUBMISSION_ID_QU_KEY = 'request_form_question_ai_scor_request_form_submission_id_qu_key',
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_QUESTION_AI_SCORE_PKEY = 'request_form_question_ai_score_pkey'
}

/** input type for incrementing numeric columns in table "request_form_question_ai_score" */
export type RequestFormQuestionAiScoreIncInput = {
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "request_form_question_ai_score" */
export type RequestFormQuestionAiScoreInsertInput = {
  confidence_explanation?: InputMaybe<Scalars['String']['input']>;
  confidence_rating?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  question_name?: InputMaybe<Scalars['String']['input']>;
  requestFormSubmission?: InputMaybe<RequestFormSubmissionsObjRelInsertInput>;
  request_form_submission_id?: InputMaybe<Scalars['uuid']['input']>;
  rfxAiScoring?: InputMaybe<RfxAiScoringObjRelInsertInput>;
  rfx_ai_scoring_id?: InputMaybe<Scalars['uuid']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type RequestFormQuestionAiScoreMaxFields = {
  __typename?: 'request_form_question_ai_score_max_fields';
  confidence_explanation: Maybe<Scalars['String']['output']>;
  confidence_rating: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  explanation: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisation_id: Maybe<Scalars['uuid']['output']>;
  question_name: Maybe<Scalars['String']['output']>;
  request_form_submission_id: Maybe<Scalars['uuid']['output']>;
  rfx_ai_scoring_id: Maybe<Scalars['uuid']['output']>;
  score: Maybe<Scalars['Int']['output']>;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type RequestFormQuestionAiScoreMinFields = {
  __typename?: 'request_form_question_ai_score_min_fields';
  confidence_explanation: Maybe<Scalars['String']['output']>;
  confidence_rating: Maybe<Scalars['String']['output']>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  explanation: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisation_id: Maybe<Scalars['uuid']['output']>;
  question_name: Maybe<Scalars['String']['output']>;
  request_form_submission_id: Maybe<Scalars['uuid']['output']>;
  rfx_ai_scoring_id: Maybe<Scalars['uuid']['output']>;
  score: Maybe<Scalars['Int']['output']>;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "request_form_question_ai_score" */
export type RequestFormQuestionAiScoreMutationResponse = {
  __typename?: 'request_form_question_ai_score_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestFormQuestionAiScore>;
};

/** on_conflict condition type for table "request_form_question_ai_score" */
export type RequestFormQuestionAiScoreOnConflict = {
  constraint: RequestFormQuestionAiScoreConstraint;
  update_columns: Array<RequestFormQuestionAiScoreUpdateColumn>;
  where?: InputMaybe<RequestFormQuestionAiScoreBoolExp>;
};

/** Ordering options when selecting data from "request_form_question_ai_score". */
export type RequestFormQuestionAiScoreOrderBy = {
  confidence_explanation?: InputMaybe<OrderBy>;
  confidence_rating?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  explanation?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  question_name?: InputMaybe<OrderBy>;
  requestFormSubmission?: InputMaybe<RequestFormSubmissionsOrderBy>;
  request_form_submission_id?: InputMaybe<OrderBy>;
  rfxAiScoring?: InputMaybe<RfxAiScoringOrderBy>;
  rfx_ai_scoring_id?: InputMaybe<OrderBy>;
  score?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_form_question_ai_score */
export type RequestFormQuestionAiScorePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_form_question_ai_score" */
export enum RequestFormQuestionAiScoreSelectColumn {
  /** column name */
  CONFIDENCE_EXPLANATION = 'confidence_explanation',
  /** column name */
  CONFIDENCE_RATING = 'confidence_rating',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXPLANATION = 'explanation',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATION_ID = 'organisation_id',
  /** column name */
  QUESTION_NAME = 'question_name',
  /** column name */
  REQUEST_FORM_SUBMISSION_ID = 'request_form_submission_id',
  /** column name */
  RFX_AI_SCORING_ID = 'rfx_ai_scoring_id',
  /** column name */
  SCORE = 'score',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "request_form_question_ai_score" */
export type RequestFormQuestionAiScoreSetInput = {
  confidence_explanation?: InputMaybe<Scalars['String']['input']>;
  confidence_rating?: InputMaybe<Scalars['String']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  question_name?: InputMaybe<Scalars['String']['input']>;
  request_form_submission_id?: InputMaybe<Scalars['uuid']['input']>;
  rfx_ai_scoring_id?: InputMaybe<Scalars['uuid']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type RequestFormQuestionAiScoreStddevFields = {
  __typename?: 'request_form_question_ai_score_stddev_fields';
  score: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RequestFormQuestionAiScoreStddevPopFields = {
  __typename?: 'request_form_question_ai_score_stddev_pop_fields';
  score: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RequestFormQuestionAiScoreStddevSampFields = {
  __typename?: 'request_form_question_ai_score_stddev_samp_fields';
  score: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type RequestFormQuestionAiScoreSumFields = {
  __typename?: 'request_form_question_ai_score_sum_fields';
  score: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "request_form_question_ai_score" */
export enum RequestFormQuestionAiScoreUpdateColumn {
  /** column name */
  CONFIDENCE_EXPLANATION = 'confidence_explanation',
  /** column name */
  CONFIDENCE_RATING = 'confidence_rating',
  /** column name */
  EXPLANATION = 'explanation',
  /** column name */
  QUESTION_NAME = 'question_name',
  /** column name */
  REQUEST_FORM_SUBMISSION_ID = 'request_form_submission_id',
  /** column name */
  RFX_AI_SCORING_ID = 'rfx_ai_scoring_id',
  /** column name */
  SCORE = 'score',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type RequestFormQuestionAiScoreUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RequestFormQuestionAiScoreIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestFormQuestionAiScoreSetInput>;
  /** filter the rows which have to be updated */
  where: RequestFormQuestionAiScoreBoolExp;
};

/** aggregate var_pop on columns */
export type RequestFormQuestionAiScoreVarPopFields = {
  __typename?: 'request_form_question_ai_score_var_pop_fields';
  score: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RequestFormQuestionAiScoreVarSampFields = {
  __typename?: 'request_form_question_ai_score_var_samp_fields';
  score: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RequestFormQuestionAiScoreVarianceFields = {
  __typename?: 'request_form_question_ai_score_variance_fields';
  score: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "request_form_question_score" */
export type RequestFormQuestionScore = {
  __typename?: 'request_form_question_score';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  questionName: Scalars['String']['output'];
  requestFormId: Scalars['uuid']['output'];
  requestFormSubmission: Scalars['uuid']['output'];
  requestStepTaskId: Scalars['uuid']['output'];
  /** An object relationship */
  request_form: RequestForms;
  /** An object relationship */
  request_form_submission: RequestFormSubmissions;
  /** An object relationship */
  request_step_task: RequestStepTasks;
  score: Scalars['Int']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "request_form_question_score" */
export type RequestFormQuestionScoreAggregateOrderBy = {
  avg?: InputMaybe<RequestFormQuestionScoreAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestFormQuestionScoreMaxOrderBy>;
  min?: InputMaybe<RequestFormQuestionScoreMinOrderBy>;
  stddev?: InputMaybe<RequestFormQuestionScoreStddevOrderBy>;
  stddev_pop?: InputMaybe<RequestFormQuestionScoreStddevPopOrderBy>;
  stddev_samp?: InputMaybe<RequestFormQuestionScoreStddevSampOrderBy>;
  sum?: InputMaybe<RequestFormQuestionScoreSumOrderBy>;
  var_pop?: InputMaybe<RequestFormQuestionScoreVarPopOrderBy>;
  var_samp?: InputMaybe<RequestFormQuestionScoreVarSampOrderBy>;
  variance?: InputMaybe<RequestFormQuestionScoreVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "request_form_question_score" */
export type RequestFormQuestionScoreArrRelInsertInput = {
  data: Array<RequestFormQuestionScoreInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormQuestionScoreOnConflict>;
};

/** order by avg() on columns of table "request_form_question_score" */
export type RequestFormQuestionScoreAvgOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "request_form_question_score". All fields are combined with a logical 'AND'. */
export type RequestFormQuestionScoreBoolExp = {
  _and?: InputMaybe<Array<RequestFormQuestionScoreBoolExp>>;
  _not?: InputMaybe<RequestFormQuestionScoreBoolExp>;
  _or?: InputMaybe<Array<RequestFormQuestionScoreBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  questionName?: InputMaybe<StringComparisonExp>;
  requestFormId?: InputMaybe<UuidComparisonExp>;
  requestFormSubmission?: InputMaybe<UuidComparisonExp>;
  requestStepTaskId?: InputMaybe<UuidComparisonExp>;
  request_form?: InputMaybe<RequestFormsBoolExp>;
  request_form_submission?: InputMaybe<RequestFormSubmissionsBoolExp>;
  request_step_task?: InputMaybe<RequestStepTasksBoolExp>;
  score?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_form_question_score" */
export enum RequestFormQuestionScoreConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_QUESTION_SCORE_PKEY = 'request_form_question_score_pkey',
  /** unique or primary key constraint on columns "user_id", "question_name", "request_form_id" */
  REQUEST_FORM_QUESTION_SCORE_REQUEST_FORM_ID_USER_ID_QUESTIO_KEY = 'request_form_question_score_request_form_id_user_id_questio_key'
}

/** input type for incrementing numeric columns in table "request_form_question_score" */
export type RequestFormQuestionScoreIncInput = {
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "request_form_question_score" */
export type RequestFormQuestionScoreInsertInput = {
  questionName?: InputMaybe<Scalars['String']['input']>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestFormSubmission?: InputMaybe<Scalars['uuid']['input']>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  request_form?: InputMaybe<RequestFormsObjRelInsertInput>;
  request_form_submission?: InputMaybe<RequestFormSubmissionsObjRelInsertInput>;
  request_step_task?: InputMaybe<RequestStepTasksObjRelInsertInput>;
  score?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "request_form_question_score" */
export type RequestFormQuestionScoreMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  questionName?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestFormSubmission?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  score?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_form_question_score" */
export type RequestFormQuestionScoreMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  questionName?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestFormSubmission?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  score?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_form_question_score" */
export type RequestFormQuestionScoreMutationResponse = {
  __typename?: 'request_form_question_score_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestFormQuestionScore>;
};

/** on_conflict condition type for table "request_form_question_score" */
export type RequestFormQuestionScoreOnConflict = {
  constraint: RequestFormQuestionScoreConstraint;
  update_columns: Array<RequestFormQuestionScoreUpdateColumn>;
  where?: InputMaybe<RequestFormQuestionScoreBoolExp>;
};

/** Ordering options when selecting data from "request_form_question_score". */
export type RequestFormQuestionScoreOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  questionName?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestFormSubmission?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  request_form?: InputMaybe<RequestFormsOrderBy>;
  request_form_submission?: InputMaybe<RequestFormSubmissionsOrderBy>;
  request_step_task?: InputMaybe<RequestStepTasksOrderBy>;
  score?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_form_question_score */
export type RequestFormQuestionScorePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_form_question_score" */
export enum RequestFormQuestionScoreSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  QUESTIONNAME = 'questionName',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTFORMSUBMISSION = 'requestFormSubmission',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  SCORE = 'score',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "request_form_question_score" */
export type RequestFormQuestionScoreSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  requestFormSubmission?: InputMaybe<Scalars['uuid']['input']>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by stddev() on columns of table "request_form_question_score" */
export type RequestFormQuestionScoreStddevOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "request_form_question_score" */
export type RequestFormQuestionScoreStddevPopOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "request_form_question_score" */
export type RequestFormQuestionScoreStddevSampOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "request_form_question_score" */
export type RequestFormQuestionScoreStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RequestFormQuestionScoreStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RequestFormQuestionScoreStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  questionName?: InputMaybe<Scalars['String']['input']>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestFormSubmission?: InputMaybe<Scalars['uuid']['input']>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "request_form_question_score" */
export type RequestFormQuestionScoreSumOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** update columns of table "request_form_question_score" */
export enum RequestFormQuestionScoreUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  REQUESTFORMSUBMISSION = 'requestFormSubmission',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  SCORE = 'score',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

export type RequestFormQuestionScoreUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RequestFormQuestionScoreIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestFormQuestionScoreSetInput>;
  /** filter the rows which have to be updated */
  where: RequestFormQuestionScoreBoolExp;
};

/** order by var_pop() on columns of table "request_form_question_score" */
export type RequestFormQuestionScoreVarPopOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "request_form_question_score" */
export type RequestFormQuestionScoreVarSampOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "request_form_question_score" */
export type RequestFormQuestionScoreVarianceOrderBy = {
  score?: InputMaybe<OrderBy>;
};

/** columns and relationships of "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummary = {
  __typename?: 'request_form_submission_ai_summary';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  request_form: RequestForms;
  request_form_id: Scalars['uuid']['output'];
  /** An object relationship */
  request_form_submission: RequestFormSubmissions;
  request_form_submission_id: Scalars['uuid']['output'];
  risks: Maybe<Scalars['jsonb']['output']>;
  summary: Scalars['String']['output'];
};


/** columns and relationships of "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummaryRisksArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummaryAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestFormSubmissionAiSummaryMaxOrderBy>;
  min?: InputMaybe<RequestFormSubmissionAiSummaryMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummaryArrRelInsertInput = {
  data: Array<RequestFormSubmissionAiSummaryInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormSubmissionAiSummaryOnConflict>;
};

/** Boolean expression to filter rows from the table "request_form_submission_ai_summary". All fields are combined with a logical 'AND'. */
export type RequestFormSubmissionAiSummaryBoolExp = {
  _and?: InputMaybe<Array<RequestFormSubmissionAiSummaryBoolExp>>;
  _not?: InputMaybe<RequestFormSubmissionAiSummaryBoolExp>;
  _or?: InputMaybe<Array<RequestFormSubmissionAiSummaryBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  request_form?: InputMaybe<RequestFormsBoolExp>;
  request_form_id?: InputMaybe<UuidComparisonExp>;
  request_form_submission?: InputMaybe<RequestFormSubmissionsBoolExp>;
  request_form_submission_id?: InputMaybe<UuidComparisonExp>;
  risks?: InputMaybe<JsonbComparisonExp>;
  summary?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "request_form_submission_ai_summary" */
export enum RequestFormSubmissionAiSummaryConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_SUBMISSION_AI_SUMMARY_PKEY = 'request_form_submission_ai_summary_pkey',
  /** unique or primary key constraint on columns "request_form_submission_id" */
  REQUEST_FORM_SUBMISSION_AI_SUMMARY_REQUEST_FORM_SUBMISSION_ID_K = 'request_form_submission_ai_summary_request_form_submission_id_k'
}

/** input type for inserting data into table "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummaryInsertInput = {
  request_form?: InputMaybe<RequestFormsObjRelInsertInput>;
  request_form_id?: InputMaybe<Scalars['uuid']['input']>;
  request_form_submission?: InputMaybe<RequestFormSubmissionsObjRelInsertInput>;
  request_form_submission_id?: InputMaybe<Scalars['uuid']['input']>;
  risks?: InputMaybe<Scalars['jsonb']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummaryMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  request_form_id?: InputMaybe<OrderBy>;
  request_form_submission_id?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummaryMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  request_form_id?: InputMaybe<OrderBy>;
  request_form_submission_id?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummaryMutationResponse = {
  __typename?: 'request_form_submission_ai_summary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestFormSubmissionAiSummary>;
};

/** input type for inserting object relation for remote table "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummaryObjRelInsertInput = {
  data: RequestFormSubmissionAiSummaryInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormSubmissionAiSummaryOnConflict>;
};

/** on_conflict condition type for table "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummaryOnConflict = {
  constraint: RequestFormSubmissionAiSummaryConstraint;
  update_columns: Array<RequestFormSubmissionAiSummaryUpdateColumn>;
  where?: InputMaybe<RequestFormSubmissionAiSummaryBoolExp>;
};

/** Ordering options when selecting data from "request_form_submission_ai_summary". */
export type RequestFormSubmissionAiSummaryOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  request_form?: InputMaybe<RequestFormsOrderBy>;
  request_form_id?: InputMaybe<OrderBy>;
  request_form_submission?: InputMaybe<RequestFormSubmissionsOrderBy>;
  request_form_submission_id?: InputMaybe<OrderBy>;
  risks?: InputMaybe<OrderBy>;
  summary?: InputMaybe<OrderBy>;
};

/** select columns of table "request_form_submission_ai_summary" */
export enum RequestFormSubmissionAiSummarySelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATION_ID = 'organisation_id',
  /** column name */
  REQUEST_FORM_ID = 'request_form_id',
  /** column name */
  REQUEST_FORM_SUBMISSION_ID = 'request_form_submission_id',
  /** column name */
  RISKS = 'risks',
  /** column name */
  SUMMARY = 'summary'
}

/** Streaming cursor of the table "request_form_submission_ai_summary" */
export type RequestFormSubmissionAiSummaryStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RequestFormSubmissionAiSummaryStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RequestFormSubmissionAiSummaryStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  request_form_id?: InputMaybe<Scalars['uuid']['input']>;
  request_form_submission_id?: InputMaybe<Scalars['uuid']['input']>;
  risks?: InputMaybe<Scalars['jsonb']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

/** placeholder for update columns of table "request_form_submission_ai_summary" (current role has no relevant permissions) */
export enum RequestFormSubmissionAiSummaryUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "request_form_submission_translations" */
export type RequestFormSubmissionTranslations = {
  __typename?: 'request_form_submission_translations';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  language: Scalars['String']['output'];
  requestFormSubmissionId: Scalars['uuid']['output'];
  translatedResponse: Scalars['jsonb']['output'];
};


/** columns and relationships of "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsTranslatedResponseArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsAggregate = {
  __typename?: 'request_form_submission_translations_aggregate';
  aggregate: Maybe<RequestFormSubmissionTranslationsAggregateFields>;
  nodes: Array<RequestFormSubmissionTranslations>;
};

export type RequestFormSubmissionTranslationsAggregateBoolExp = {
  count?: InputMaybe<RequestFormSubmissionTranslationsAggregateBoolExpCount>;
};

export type RequestFormSubmissionTranslationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestFormSubmissionTranslationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsAggregateFields = {
  __typename?: 'request_form_submission_translations_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestFormSubmissionTranslationsMaxFields>;
  min: Maybe<RequestFormSubmissionTranslationsMinFields>;
};


/** aggregate fields of "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RequestFormSubmissionTranslationsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestFormSubmissionTranslationsMaxOrderBy>;
  min?: InputMaybe<RequestFormSubmissionTranslationsMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsArrRelInsertInput = {
  data: Array<RequestFormSubmissionTranslationsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormSubmissionTranslationsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_form_submission_translations". All fields are combined with a logical 'AND'. */
export type RequestFormSubmissionTranslationsBoolExp = {
  _and?: InputMaybe<Array<RequestFormSubmissionTranslationsBoolExp>>;
  _not?: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
  _or?: InputMaybe<Array<RequestFormSubmissionTranslationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  language?: InputMaybe<StringComparisonExp>;
  requestFormSubmissionId?: InputMaybe<UuidComparisonExp>;
  translatedResponse?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "request_form_submission_translations" */
export enum RequestFormSubmissionTranslationsConstraint {
  /** unique or primary key constraint on columns "language", "request_form_submission_id" */
  REQUEST_FORM_SUBMISSION_TRANS_REQUEST_FORM_SUBMISSION_ID_LA_KEY = 'request_form_submission_trans_request_form_submission_id_la_key',
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_SUBMISSION_TRANSLATIONS_PKEY = 'request_form_submission_translations_pkey'
}

/** input type for inserting data into table "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  requestFormSubmissionId?: InputMaybe<Scalars['uuid']['input']>;
  translatedResponse?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type RequestFormSubmissionTranslationsMaxFields = {
  __typename?: 'request_form_submission_translations_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  language: Maybe<Scalars['String']['output']>;
  requestFormSubmissionId: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  language?: InputMaybe<OrderBy>;
  requestFormSubmissionId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RequestFormSubmissionTranslationsMinFields = {
  __typename?: 'request_form_submission_translations_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  language: Maybe<Scalars['String']['output']>;
  requestFormSubmissionId: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  language?: InputMaybe<OrderBy>;
  requestFormSubmissionId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsMutationResponse = {
  __typename?: 'request_form_submission_translations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestFormSubmissionTranslations>;
};

/** on_conflict condition type for table "request_form_submission_translations" */
export type RequestFormSubmissionTranslationsOnConflict = {
  constraint: RequestFormSubmissionTranslationsConstraint;
  update_columns: Array<RequestFormSubmissionTranslationsUpdateColumn>;
  where?: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
};

/** Ordering options when selecting data from "request_form_submission_translations". */
export type RequestFormSubmissionTranslationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  language?: InputMaybe<OrderBy>;
  requestFormSubmissionId?: InputMaybe<OrderBy>;
  translatedResponse?: InputMaybe<OrderBy>;
};

/** select columns of table "request_form_submission_translations" */
export enum RequestFormSubmissionTranslationsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  LANGUAGE = 'language',
  /** column name */
  REQUESTFORMSUBMISSIONID = 'requestFormSubmissionId',
  /** column name */
  TRANSLATEDRESPONSE = 'translatedResponse'
}

/** placeholder for update columns of table "request_form_submission_translations" (current role has no relevant permissions) */
export enum RequestFormSubmissionTranslationsUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "request_form_submissions" */
export type RequestFormSubmissions = {
  __typename?: 'request_form_submissions';
  detectedLanguage: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  request_form: Maybe<RequestForms>;
  /** An object relationship */
  request_form_submission_ai_summary: Maybe<RequestFormSubmissionAiSummary>;
  /** An object relationship */
  request_step_task: Maybe<RequestStepTasks>;
  response: Maybe<Scalars['requestFormSubmissionResponse']['output']>;
  submittedBy: Maybe<Scalars['uuid']['output']>;
  submittedOn: Scalars['timestamptz']['output'];
  /** An array relationship */
  translations: Array<RequestFormSubmissionTranslations>;
  /** An aggregate relationship */
  translations_aggregate: RequestFormSubmissionTranslationsAggregate;
  /** An object relationship */
  user: Maybe<Users>;
};


/** columns and relationships of "request_form_submissions" */
export type RequestFormSubmissionsTranslationsArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionTranslationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionTranslationsOrderBy>>;
  where: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
};


/** columns and relationships of "request_form_submissions" */
export type RequestFormSubmissionsTranslationsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionTranslationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionTranslationsOrderBy>>;
  where: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
};

/** aggregated selection of "request_form_submissions" */
export type RequestFormSubmissionsAggregate = {
  __typename?: 'request_form_submissions_aggregate';
  aggregate: Maybe<RequestFormSubmissionsAggregateFields>;
  nodes: Array<RequestFormSubmissions>;
};

export type RequestFormSubmissionsAggregateBoolExp = {
  count?: InputMaybe<RequestFormSubmissionsAggregateBoolExpCount>;
};

export type RequestFormSubmissionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestFormSubmissionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestFormSubmissionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_form_submissions" */
export type RequestFormSubmissionsAggregateFields = {
  __typename?: 'request_form_submissions_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestFormSubmissionsMaxFields>;
  min: Maybe<RequestFormSubmissionsMinFields>;
};


/** aggregate fields of "request_form_submissions" */
export type RequestFormSubmissionsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RequestFormSubmissionsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "request_form_submissions" */
export type RequestFormSubmissionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestFormSubmissionsMaxOrderBy>;
  min?: InputMaybe<RequestFormSubmissionsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RequestFormSubmissionsAppendInput = {
  response?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "request_form_submissions" */
export type RequestFormSubmissionsArrRelInsertInput = {
  data: Array<RequestFormSubmissionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormSubmissionsOnConflict>;
};

/** columns and relationships of "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSaves = {
  __typename?: 'request_form_submissions_auto_saves';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  requestFormId: Scalars['uuid']['output'];
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  request_form: RequestForms;
  /** An object relationship */
  request_step_task: Maybe<RequestStepTasks>;
  response: Scalars['jsonb']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesResponseArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesAggregate = {
  __typename?: 'request_form_submissions_auto_saves_aggregate';
  aggregate: Maybe<RequestFormSubmissionsAutoSavesAggregateFields>;
  nodes: Array<RequestFormSubmissionsAutoSaves>;
};

export type RequestFormSubmissionsAutoSavesAggregateBoolExp = {
  count?: InputMaybe<RequestFormSubmissionsAutoSavesAggregateBoolExpCount>;
};

export type RequestFormSubmissionsAutoSavesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestFormSubmissionsAutoSavesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestFormSubmissionsAutoSavesBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesAggregateFields = {
  __typename?: 'request_form_submissions_auto_saves_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestFormSubmissionsAutoSavesMaxFields>;
  min: Maybe<RequestFormSubmissionsAutoSavesMinFields>;
};


/** aggregate fields of "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RequestFormSubmissionsAutoSavesSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestFormSubmissionsAutoSavesMaxOrderBy>;
  min?: InputMaybe<RequestFormSubmissionsAutoSavesMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RequestFormSubmissionsAutoSavesAppendInput = {
  response?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesArrRelInsertInput = {
  data: Array<RequestFormSubmissionsAutoSavesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormSubmissionsAutoSavesOnConflict>;
};

/** Boolean expression to filter rows from the table "request_form_submissions_auto_saves". All fields are combined with a logical 'AND'. */
export type RequestFormSubmissionsAutoSavesBoolExp = {
  _and?: InputMaybe<Array<RequestFormSubmissionsAutoSavesBoolExp>>;
  _not?: InputMaybe<RequestFormSubmissionsAutoSavesBoolExp>;
  _or?: InputMaybe<Array<RequestFormSubmissionsAutoSavesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestFormId?: InputMaybe<UuidComparisonExp>;
  requestStepTaskId?: InputMaybe<UuidComparisonExp>;
  request_form?: InputMaybe<RequestFormsBoolExp>;
  request_step_task?: InputMaybe<RequestStepTasksBoolExp>;
  response?: InputMaybe<JsonbComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_form_submissions_auto_saves" */
export enum RequestFormSubmissionsAutoSavesConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_SUBMISSIONS_AUTO_SAVES_PKEY = 'request_form_submissions_auto_saves_pkey',
  /** unique or primary key constraint on columns "request_step_task_id", "request_form_id" */
  REQUEST_FORM_SUBMISSIONS_AUTO_SAVES_REQUEST_FORM_ID_REQUEST_STE = 'request_form_submissions_auto_saves_request_form_id_request_ste'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RequestFormSubmissionsAutoSavesDeleteAtPathInput = {
  response?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RequestFormSubmissionsAutoSavesDeleteElemInput = {
  response?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RequestFormSubmissionsAutoSavesDeleteKeyInput = {
  response?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesInsertInput = {
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  request_form?: InputMaybe<RequestFormsObjRelInsertInput>;
  request_step_task?: InputMaybe<RequestStepTasksObjRelInsertInput>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RequestFormSubmissionsAutoSavesMaxFields = {
  __typename?: 'request_form_submissions_auto_saves_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RequestFormSubmissionsAutoSavesMinFields = {
  __typename?: 'request_form_submissions_auto_saves_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  userId: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesMutationResponse = {
  __typename?: 'request_form_submissions_auto_saves_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestFormSubmissionsAutoSaves>;
};

/** on_conflict condition type for table "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesOnConflict = {
  constraint: RequestFormSubmissionsAutoSavesConstraint;
  update_columns: Array<RequestFormSubmissionsAutoSavesUpdateColumn>;
  where?: InputMaybe<RequestFormSubmissionsAutoSavesBoolExp>;
};

/** Ordering options when selecting data from "request_form_submissions_auto_saves". */
export type RequestFormSubmissionsAutoSavesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  request_form?: InputMaybe<RequestFormsOrderBy>;
  request_step_task?: InputMaybe<RequestStepTasksOrderBy>;
  response?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_form_submissions_auto_saves */
export type RequestFormSubmissionsAutoSavesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RequestFormSubmissionsAutoSavesPrependInput = {
  response?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "request_form_submissions_auto_saves" */
export enum RequestFormSubmissionsAutoSavesSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  RESPONSE = 'response',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "request_form_submissions_auto_saves" */
export type RequestFormSubmissionsAutoSavesSetInput = {
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "request_form_submissions_auto_saves" */
export enum RequestFormSubmissionsAutoSavesUpdateColumn {
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  RESPONSE = 'response',
  /** column name */
  USERID = 'userId'
}

export type RequestFormSubmissionsAutoSavesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RequestFormSubmissionsAutoSavesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RequestFormSubmissionsAutoSavesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RequestFormSubmissionsAutoSavesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RequestFormSubmissionsAutoSavesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RequestFormSubmissionsAutoSavesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestFormSubmissionsAutoSavesSetInput>;
  /** filter the rows which have to be updated */
  where: RequestFormSubmissionsAutoSavesBoolExp;
};

/** Boolean expression to filter rows from the table "request_form_submissions". All fields are combined with a logical 'AND'. */
export type RequestFormSubmissionsBoolExp = {
  _and?: InputMaybe<Array<RequestFormSubmissionsBoolExp>>;
  _not?: InputMaybe<RequestFormSubmissionsBoolExp>;
  _or?: InputMaybe<Array<RequestFormSubmissionsBoolExp>>;
  detectedLanguage?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestFormId?: InputMaybe<UuidComparisonExp>;
  requestStepTaskId?: InputMaybe<UuidComparisonExp>;
  request_form?: InputMaybe<RequestFormsBoolExp>;
  request_form_submission_ai_summary?: InputMaybe<RequestFormSubmissionAiSummaryBoolExp>;
  request_step_task?: InputMaybe<RequestStepTasksBoolExp>;
  response?: InputMaybe<JsonbComparisonExp>;
  submittedBy?: InputMaybe<UuidComparisonExp>;
  submittedOn?: InputMaybe<TimestamptzComparisonExp>;
  translations?: InputMaybe<RequestFormSubmissionTranslationsBoolExp>;
  translations_aggregate?: InputMaybe<RequestFormSubmissionTranslationsAggregateBoolExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "request_form_submissions" */
export enum RequestFormSubmissionsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_SUBMISSIONS_PKEY = 'request_form_submissions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RequestFormSubmissionsDeleteAtPathInput = {
  response?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RequestFormSubmissionsDeleteElemInput = {
  response?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RequestFormSubmissionsDeleteKeyInput = {
  response?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "request_form_submissions" */
export type RequestFormSubmissionsInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  request_form?: InputMaybe<RequestFormsObjRelInsertInput>;
  request_form_submission_ai_summary?: InputMaybe<RequestFormSubmissionAiSummaryObjRelInsertInput>;
  request_step_task?: InputMaybe<RequestStepTasksObjRelInsertInput>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
  submittedBy?: InputMaybe<Scalars['uuid']['input']>;
  submittedOn?: InputMaybe<Scalars['timestamptz']['input']>;
  translations?: InputMaybe<RequestFormSubmissionTranslationsArrRelInsertInput>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type RequestFormSubmissionsMaxFields = {
  __typename?: 'request_form_submissions_max_fields';
  detectedLanguage: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  submittedBy: Maybe<Scalars['uuid']['output']>;
  submittedOn: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "request_form_submissions" */
export type RequestFormSubmissionsMaxOrderBy = {
  detectedLanguage?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  submittedBy?: InputMaybe<OrderBy>;
  submittedOn?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RequestFormSubmissionsMinFields = {
  __typename?: 'request_form_submissions_min_fields';
  detectedLanguage: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  submittedBy: Maybe<Scalars['uuid']['output']>;
  submittedOn: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "request_form_submissions" */
export type RequestFormSubmissionsMinOrderBy = {
  detectedLanguage?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  submittedBy?: InputMaybe<OrderBy>;
  submittedOn?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_form_submissions" */
export type RequestFormSubmissionsMutationResponse = {
  __typename?: 'request_form_submissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestFormSubmissions>;
};

/** input type for inserting object relation for remote table "request_form_submissions" */
export type RequestFormSubmissionsObjRelInsertInput = {
  data: RequestFormSubmissionsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormSubmissionsOnConflict>;
};

/** on_conflict condition type for table "request_form_submissions" */
export type RequestFormSubmissionsOnConflict = {
  constraint: RequestFormSubmissionsConstraint;
  update_columns: Array<RequestFormSubmissionsUpdateColumn>;
  where?: InputMaybe<RequestFormSubmissionsBoolExp>;
};

/** Ordering options when selecting data from "request_form_submissions". */
export type RequestFormSubmissionsOrderBy = {
  detectedLanguage?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  request_form?: InputMaybe<RequestFormsOrderBy>;
  request_form_submission_ai_summary?: InputMaybe<RequestFormSubmissionAiSummaryOrderBy>;
  request_step_task?: InputMaybe<RequestStepTasksOrderBy>;
  response?: InputMaybe<OrderBy>;
  submittedBy?: InputMaybe<OrderBy>;
  submittedOn?: InputMaybe<OrderBy>;
  translations_aggregate?: InputMaybe<RequestFormSubmissionTranslationsAggregateOrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: request_form_submissions */
export type RequestFormSubmissionsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RequestFormSubmissionsPrependInput = {
  response?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "request_form_submissions" */
export enum RequestFormSubmissionsSelectColumn {
  /** column name */
  DETECTEDLANGUAGE = 'detectedLanguage',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  RESPONSE = 'response',
  /** column name */
  SUBMITTEDBY = 'submittedBy',
  /** column name */
  SUBMITTEDON = 'submittedOn'
}

/** input type for updating data in table "request_form_submissions" */
export type RequestFormSubmissionsSetInput = {
  detectedLanguage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  response?: InputMaybe<Scalars['jsonb']['input']>;
  submittedBy?: InputMaybe<Scalars['uuid']['input']>;
  submittedOn?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "request_form_submissions" */
export enum RequestFormSubmissionsUpdateColumn {
  /** column name */
  DETECTEDLANGUAGE = 'detectedLanguage',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  RESPONSE = 'response',
  /** column name */
  SUBMITTEDBY = 'submittedBy',
  /** column name */
  SUBMITTEDON = 'submittedOn'
}

export type RequestFormSubmissionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RequestFormSubmissionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RequestFormSubmissionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RequestFormSubmissionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RequestFormSubmissionsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RequestFormSubmissionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestFormSubmissionsSetInput>;
  /** filter the rows which have to be updated */
  where: RequestFormSubmissionsBoolExp;
};

/** Assign reviewers to request form templates */
export type RequestFormTemplateReviewers = {
  __typename?: 'request_form_template_reviewers';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  requestFormTemplateId: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "request_form_template_reviewers" */
export type RequestFormTemplateReviewersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestFormTemplateReviewersMaxOrderBy>;
  min?: InputMaybe<RequestFormTemplateReviewersMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_form_template_reviewers" */
export type RequestFormTemplateReviewersArrRelInsertInput = {
  data: Array<RequestFormTemplateReviewersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormTemplateReviewersOnConflict>;
};

/** Boolean expression to filter rows from the table "request_form_template_reviewers". All fields are combined with a logical 'AND'. */
export type RequestFormTemplateReviewersBoolExp = {
  _and?: InputMaybe<Array<RequestFormTemplateReviewersBoolExp>>;
  _not?: InputMaybe<RequestFormTemplateReviewersBoolExp>;
  _or?: InputMaybe<Array<RequestFormTemplateReviewersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestFormTemplateId?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_form_template_reviewers" */
export enum RequestFormTemplateReviewersConstraint {
  /** unique or primary key constraint on columns "user_id", "request_form_template_id" */
  REQUEST_FORM_TEMPLATE_REVIEWE_REQUEST_FORM_TEMPLATE_ID_USER_KEY = 'request_form_template_reviewe_request_form_template_id_user_key',
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_TEMPLATE_REVIEWERS_PKEY = 'request_form_template_reviewers_pkey'
}

/** input type for inserting data into table "request_form_template_reviewers" */
export type RequestFormTemplateReviewersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestFormTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "request_form_template_reviewers" */
export type RequestFormTemplateReviewersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestFormTemplateId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_form_template_reviewers" */
export type RequestFormTemplateReviewersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestFormTemplateId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_form_template_reviewers" */
export type RequestFormTemplateReviewersMutationResponse = {
  __typename?: 'request_form_template_reviewers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestFormTemplateReviewers>;
};

/** on_conflict condition type for table "request_form_template_reviewers" */
export type RequestFormTemplateReviewersOnConflict = {
  constraint: RequestFormTemplateReviewersConstraint;
  update_columns: Array<RequestFormTemplateReviewersUpdateColumn>;
  where?: InputMaybe<RequestFormTemplateReviewersBoolExp>;
};

/** Ordering options when selecting data from "request_form_template_reviewers". */
export type RequestFormTemplateReviewersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestFormTemplateId?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_form_template_reviewers */
export type RequestFormTemplateReviewersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_form_template_reviewers" */
export enum RequestFormTemplateReviewersSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTFORMTEMPLATEID = 'requestFormTemplateId',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "request_form_template_reviewers" */
export type RequestFormTemplateReviewersSetInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestFormTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "request_form_template_reviewers" */
export enum RequestFormTemplateReviewersUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTFORMTEMPLATEID = 'requestFormTemplateId',
  /** column name */
  USERID = 'userId'
}

export type RequestFormTemplateReviewersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestFormTemplateReviewersSetInput>;
  /** filter the rows which have to be updated */
  where: RequestFormTemplateReviewersBoolExp;
};

/** columns and relationships of "request_form_templates" */
export type RequestFormTemplates = {
  __typename?: 'request_form_templates';
  config: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user: Maybe<Users>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  draftConfig: Maybe<Scalars['jsonb']['output']>;
  formTemplateId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  form_template: Maybe<FormTemplates>;
  /** An object relationship */
  form_type: FormType;
  id: Scalars['uuid']['output'];
  isSent: Scalars['Boolean']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  requestStepId: Scalars['uuid']['output'];
  /** An array relationship */
  request_form_template_reviewers: Array<RequestFormTemplateReviewers>;
  /** An array relationship */
  request_forms: Array<RequestForms>;
  /** An object relationship */
  request_step: RequestSteps;
  /** An array relationship */
  request_step_tasks: Array<RequestStepTasks>;
  /** An aggregate relationship */
  request_step_tasks_aggregate: RequestStepTasksAggregate;
  /** An object relationship */
  rfx_request_form_templates_rank: Maybe<RfxRequestFormTemplatesRanks>;
  title: Scalars['String']['output'];
  type: FormTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
};


/** columns and relationships of "request_form_templates" */
export type RequestFormTemplatesConfigArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "request_form_templates" */
export type RequestFormTemplatesDraftConfigArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "request_form_templates" */
export type RequestFormTemplatesRequestFormTemplateReviewersArgs = {
  distinct_on: InputMaybe<Array<RequestFormTemplateReviewersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormTemplateReviewersOrderBy>>;
  where: InputMaybe<RequestFormTemplateReviewersBoolExp>;
};


/** columns and relationships of "request_form_templates" */
export type RequestFormTemplatesRequestFormsArgs = {
  distinct_on: InputMaybe<Array<RequestFormsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormsOrderBy>>;
  where: InputMaybe<RequestFormsBoolExp>;
};


/** columns and relationships of "request_form_templates" */
export type RequestFormTemplatesRequestStepTasksArgs = {
  distinct_on: InputMaybe<Array<RequestStepTasksSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTasksOrderBy>>;
  where: InputMaybe<RequestStepTasksBoolExp>;
};


/** columns and relationships of "request_form_templates" */
export type RequestFormTemplatesRequestStepTasksAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestStepTasksSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTasksOrderBy>>;
  where: InputMaybe<RequestStepTasksBoolExp>;
};

/** order by aggregate values of table "request_form_templates" */
export type RequestFormTemplatesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestFormTemplatesMaxOrderBy>;
  min?: InputMaybe<RequestFormTemplatesMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RequestFormTemplatesAppendInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  draftConfig?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "request_form_templates" */
export type RequestFormTemplatesArrRelInsertInput = {
  data: Array<RequestFormTemplatesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormTemplatesOnConflict>;
};

/** Boolean expression to filter rows from the table "request_form_templates". All fields are combined with a logical 'AND'. */
export type RequestFormTemplatesBoolExp = {
  _and?: InputMaybe<Array<RequestFormTemplatesBoolExp>>;
  _not?: InputMaybe<RequestFormTemplatesBoolExp>;
  _or?: InputMaybe<Array<RequestFormTemplatesBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  draftConfig?: InputMaybe<JsonbComparisonExp>;
  formTemplateId?: InputMaybe<UuidComparisonExp>;
  form_template?: InputMaybe<FormTemplatesBoolExp>;
  form_type?: InputMaybe<FormTypeBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isSent?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestStepId?: InputMaybe<UuidComparisonExp>;
  request_form_template_reviewers?: InputMaybe<RequestFormTemplateReviewersBoolExp>;
  request_forms?: InputMaybe<RequestFormsBoolExp>;
  request_step?: InputMaybe<RequestStepsBoolExp>;
  request_step_tasks?: InputMaybe<RequestStepTasksBoolExp>;
  request_step_tasks_aggregate?: InputMaybe<RequestStepTasksAggregateBoolExp>;
  rfx_request_form_templates_rank?: InputMaybe<RfxRequestFormTemplatesRanksBoolExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<FormTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "request_form_templates" */
export enum RequestFormTemplatesConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORM_TEMPLATES_PKEY = 'request_form_templates_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RequestFormTemplatesDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
  draftConfig?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RequestFormTemplatesDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']['input']>;
  draftConfig?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RequestFormTemplatesDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']['input']>;
  draftConfig?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "request_form_templates" */
export type RequestFormTemplatesInsertInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<UsersObjRelInsertInput>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  draftConfig?: InputMaybe<Scalars['jsonb']['input']>;
  formTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  form_template?: InputMaybe<FormTemplatesObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isSent?: InputMaybe<Scalars['Boolean']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  request_form_template_reviewers?: InputMaybe<RequestFormTemplateReviewersArrRelInsertInput>;
  request_forms?: InputMaybe<RequestFormsArrRelInsertInput>;
  request_step?: InputMaybe<RequestStepsObjRelInsertInput>;
  request_step_tasks?: InputMaybe<RequestStepTasksArrRelInsertInput>;
  rfx_request_form_templates_rank?: InputMaybe<RfxRequestFormTemplatesRanksObjRelInsertInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FormTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  updated_by_user?: InputMaybe<UsersObjRelInsertInput>;
};

/** order by max() on columns of table "request_form_templates" */
export type RequestFormTemplatesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  formTemplateId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_form_templates" */
export type RequestFormTemplatesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  formTemplateId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_form_templates" */
export type RequestFormTemplatesMutationResponse = {
  __typename?: 'request_form_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestFormTemplates>;
};

/** input type for inserting object relation for remote table "request_form_templates" */
export type RequestFormTemplatesObjRelInsertInput = {
  data: RequestFormTemplatesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormTemplatesOnConflict>;
};

/** on_conflict condition type for table "request_form_templates" */
export type RequestFormTemplatesOnConflict = {
  constraint: RequestFormTemplatesConstraint;
  update_columns: Array<RequestFormTemplatesUpdateColumn>;
  where?: InputMaybe<RequestFormTemplatesBoolExp>;
};

/** Ordering options when selecting data from "request_form_templates". */
export type RequestFormTemplatesOrderBy = {
  config?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  draftConfig?: InputMaybe<OrderBy>;
  formTemplateId?: InputMaybe<OrderBy>;
  form_template?: InputMaybe<FormTemplatesOrderBy>;
  form_type?: InputMaybe<FormTypeOrderBy>;
  id?: InputMaybe<OrderBy>;
  isSent?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  request_form_template_reviewers_aggregate?: InputMaybe<RequestFormTemplateReviewersAggregateOrderBy>;
  request_forms_aggregate?: InputMaybe<RequestFormsAggregateOrderBy>;
  request_step?: InputMaybe<RequestStepsOrderBy>;
  request_step_tasks_aggregate?: InputMaybe<RequestStepTasksAggregateOrderBy>;
  rfx_request_form_templates_rank?: InputMaybe<RfxRequestFormTemplatesRanksOrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: request_form_templates */
export type RequestFormTemplatesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RequestFormTemplatesPrependInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  draftConfig?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "request_form_templates" */
export enum RequestFormTemplatesSelectColumn {
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DRAFTCONFIG = 'draftConfig',
  /** column name */
  FORMTEMPLATEID = 'formTemplateId',
  /** column name */
  ID = 'id',
  /** column name */
  ISSENT = 'isSent',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

/** input type for updating data in table "request_form_templates" */
export type RequestFormTemplatesSetInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  draftConfig?: InputMaybe<Scalars['jsonb']['input']>;
  formTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isSent?: InputMaybe<Scalars['Boolean']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FormTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "request_form_templates" */
export enum RequestFormTemplatesUpdateColumn {
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DRAFTCONFIG = 'draftConfig',
  /** column name */
  FORMTEMPLATEID = 'formTemplateId',
  /** column name */
  ID = 'id',
  /** column name */
  ISSENT = 'isSent',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

export type RequestFormTemplatesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RequestFormTemplatesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RequestFormTemplatesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RequestFormTemplatesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RequestFormTemplatesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RequestFormTemplatesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestFormTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: RequestFormTemplatesBoolExp;
};

/** columns and relationships of "request_forms" */
export type RequestForms = {
  __typename?: 'request_forms';
  config: Scalars['formConfig']['output'];
  created_at: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  formTemplateId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  form_template: Maybe<FormTemplates>;
  /** An object relationship */
  form_type: FormType;
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  /** An array relationship */
  request_comments: Array<RequestComments>;
  /** An aggregate relationship */
  request_comments_aggregate: RequestCommentsAggregate;
  /** An array relationship */
  request_form_question_scores: Array<RequestFormQuestionScore>;
  /** An array relationship */
  request_form_submission_ai_summaries: Array<RequestFormSubmissionAiSummary>;
  /** An array relationship */
  request_form_submissions: Array<RequestFormSubmissions>;
  /** An aggregate relationship */
  request_form_submissions_aggregate: RequestFormSubmissionsAggregate;
  /** An array relationship */
  request_form_submissions_auto_saves: Array<RequestFormSubmissionsAutoSaves>;
  /** An aggregate relationship */
  request_form_submissions_auto_saves_aggregate: RequestFormSubmissionsAutoSavesAggregate;
  /** An object relationship */
  request_form_template: Maybe<RequestFormTemplates>;
  request_form_template_id: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  request_step_tasks: Array<RequestStepTasks>;
  /** An aggregate relationship */
  request_step_tasks_aggregate: RequestStepTasksAggregate;
  title: Scalars['String']['output'];
  type: FormTypeEnum;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "request_forms" */
export type RequestFormsRequestCommentsArgs = {
  distinct_on: InputMaybe<Array<RequestCommentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestCommentsOrderBy>>;
  where: InputMaybe<RequestCommentsBoolExp>;
};


/** columns and relationships of "request_forms" */
export type RequestFormsRequestCommentsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestCommentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestCommentsOrderBy>>;
  where: InputMaybe<RequestCommentsBoolExp>;
};


/** columns and relationships of "request_forms" */
export type RequestFormsRequestFormQuestionScoresArgs = {
  distinct_on: InputMaybe<Array<RequestFormQuestionScoreSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormQuestionScoreOrderBy>>;
  where: InputMaybe<RequestFormQuestionScoreBoolExp>;
};


/** columns and relationships of "request_forms" */
export type RequestFormsRequestFormSubmissionAiSummariesArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionAiSummarySelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionAiSummaryOrderBy>>;
  where: InputMaybe<RequestFormSubmissionAiSummaryBoolExp>;
};


/** columns and relationships of "request_forms" */
export type RequestFormsRequestFormSubmissionsArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionsOrderBy>>;
  where: InputMaybe<RequestFormSubmissionsBoolExp>;
};


/** columns and relationships of "request_forms" */
export type RequestFormsRequestFormSubmissionsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionsOrderBy>>;
  where: InputMaybe<RequestFormSubmissionsBoolExp>;
};


/** columns and relationships of "request_forms" */
export type RequestFormsRequestFormSubmissionsAutoSavesArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionsAutoSavesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionsAutoSavesOrderBy>>;
  where: InputMaybe<RequestFormSubmissionsAutoSavesBoolExp>;
};


/** columns and relationships of "request_forms" */
export type RequestFormsRequestFormSubmissionsAutoSavesAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionsAutoSavesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionsAutoSavesOrderBy>>;
  where: InputMaybe<RequestFormSubmissionsAutoSavesBoolExp>;
};


/** columns and relationships of "request_forms" */
export type RequestFormsRequestStepTasksArgs = {
  distinct_on: InputMaybe<Array<RequestStepTasksSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTasksOrderBy>>;
  where: InputMaybe<RequestStepTasksBoolExp>;
};


/** columns and relationships of "request_forms" */
export type RequestFormsRequestStepTasksAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestStepTasksSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTasksOrderBy>>;
  where: InputMaybe<RequestStepTasksBoolExp>;
};

/** order by aggregate values of table "request_forms" */
export type RequestFormsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestFormsMaxOrderBy>;
  min?: InputMaybe<RequestFormsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RequestFormsAppendInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "request_forms" */
export type RequestFormsArrRelInsertInput = {
  data: Array<RequestFormsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_forms". All fields are combined with a logical 'AND'. */
export type RequestFormsBoolExp = {
  _and?: InputMaybe<Array<RequestFormsBoolExp>>;
  _not?: InputMaybe<RequestFormsBoolExp>;
  _or?: InputMaybe<Array<RequestFormsBoolExp>>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  formTemplateId?: InputMaybe<UuidComparisonExp>;
  form_template?: InputMaybe<FormTemplatesBoolExp>;
  form_type?: InputMaybe<FormTypeBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  request_comments?: InputMaybe<RequestCommentsBoolExp>;
  request_comments_aggregate?: InputMaybe<RequestCommentsAggregateBoolExp>;
  request_form_question_scores?: InputMaybe<RequestFormQuestionScoreBoolExp>;
  request_form_submission_ai_summaries?: InputMaybe<RequestFormSubmissionAiSummaryBoolExp>;
  request_form_submissions?: InputMaybe<RequestFormSubmissionsBoolExp>;
  request_form_submissions_aggregate?: InputMaybe<RequestFormSubmissionsAggregateBoolExp>;
  request_form_submissions_auto_saves?: InputMaybe<RequestFormSubmissionsAutoSavesBoolExp>;
  request_form_submissions_auto_saves_aggregate?: InputMaybe<RequestFormSubmissionsAutoSavesAggregateBoolExp>;
  request_form_template?: InputMaybe<RequestFormTemplatesBoolExp>;
  request_form_template_id?: InputMaybe<UuidComparisonExp>;
  request_step_tasks?: InputMaybe<RequestStepTasksBoolExp>;
  request_step_tasks_aggregate?: InputMaybe<RequestStepTasksAggregateBoolExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<FormTypeEnumComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "request_forms" */
export enum RequestFormsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_FORMS_PKEY = 'request_forms_pkey',
  /** unique or primary key constraint on columns "request_id", "form_template_id" */
  REQUEST_FORMS_REQUEST_ID_FORM_TEMPLATE_ID_KEY = 'request_forms_request_id_form_template_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RequestFormsDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RequestFormsDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RequestFormsDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "request_forms" */
export type RequestFormsInsertInput = {
  config: Scalars['formConfig']['input'];
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  form_template?: InputMaybe<FormTemplatesObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  request_comments?: InputMaybe<RequestCommentsArrRelInsertInput>;
  request_form_question_scores?: InputMaybe<RequestFormQuestionScoreArrRelInsertInput>;
  request_form_submission_ai_summaries?: InputMaybe<RequestFormSubmissionAiSummaryArrRelInsertInput>;
  request_form_submissions?: InputMaybe<RequestFormSubmissionsArrRelInsertInput>;
  request_form_submissions_auto_saves?: InputMaybe<RequestFormSubmissionsAutoSavesArrRelInsertInput>;
  request_form_template?: InputMaybe<RequestFormTemplatesObjRelInsertInput>;
  request_form_template_id?: InputMaybe<Scalars['uuid']['input']>;
  request_step_tasks?: InputMaybe<RequestStepTasksArrRelInsertInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FormTypeEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "request_forms" */
export type RequestFormsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  formTemplateId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  request_form_template_id?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_forms" */
export type RequestFormsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  formTemplateId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  request_form_template_id?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_forms" */
export type RequestFormsMutationResponse = {
  __typename?: 'request_forms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestForms>;
};

/** input type for inserting object relation for remote table "request_forms" */
export type RequestFormsObjRelInsertInput = {
  data: RequestFormsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestFormsOnConflict>;
};

/** on_conflict condition type for table "request_forms" */
export type RequestFormsOnConflict = {
  constraint: RequestFormsConstraint;
  update_columns: Array<RequestFormsUpdateColumn>;
  where?: InputMaybe<RequestFormsBoolExp>;
};

/** Ordering options when selecting data from "request_forms". */
export type RequestFormsOrderBy = {
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  formTemplateId?: InputMaybe<OrderBy>;
  form_template?: InputMaybe<FormTemplatesOrderBy>;
  form_type?: InputMaybe<FormTypeOrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  request_comments_aggregate?: InputMaybe<RequestCommentsAggregateOrderBy>;
  request_form_question_scores_aggregate?: InputMaybe<RequestFormQuestionScoreAggregateOrderBy>;
  request_form_submission_ai_summaries_aggregate?: InputMaybe<RequestFormSubmissionAiSummaryAggregateOrderBy>;
  request_form_submissions_aggregate?: InputMaybe<RequestFormSubmissionsAggregateOrderBy>;
  request_form_submissions_auto_saves_aggregate?: InputMaybe<RequestFormSubmissionsAutoSavesAggregateOrderBy>;
  request_form_template?: InputMaybe<RequestFormTemplatesOrderBy>;
  request_form_template_id?: InputMaybe<OrderBy>;
  request_step_tasks_aggregate?: InputMaybe<RequestStepTasksAggregateOrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_forms */
export type RequestFormsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RequestFormsPrependInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "request_forms" */
export enum RequestFormsSelectColumn {
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  FORMTEMPLATEID = 'formTemplateId',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  REQUEST_FORM_TEMPLATE_ID = 'request_form_template_id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "request_forms" */
export type RequestFormsSetInput = {
  config?: InputMaybe<Scalars['formConfig']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  formTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  request_form_template_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FormTypeEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "request_forms" */
export enum RequestFormsUpdateColumn {
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  FORMTEMPLATEID = 'formTemplateId',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  REQUEST_FORM_TEMPLATE_ID = 'request_form_template_id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type RequestFormsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RequestFormsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RequestFormsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RequestFormsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RequestFormsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RequestFormsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestFormsSetInput>;
  /** filter the rows which have to be updated */
  where: RequestFormsBoolExp;
};

/** columns and relationships of "request_groups" */
export type RequestGroups = {
  __typename?: 'request_groups';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "request_groups" */
export type RequestGroupsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestGroupsMaxOrderBy>;
  min?: InputMaybe<RequestGroupsMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_groups" */
export type RequestGroupsArrRelInsertInput = {
  data: Array<RequestGroupsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestGroupsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_groups". All fields are combined with a logical 'AND'. */
export type RequestGroupsBoolExp = {
  _and?: InputMaybe<Array<RequestGroupsBoolExp>>;
  _not?: InputMaybe<RequestGroupsBoolExp>;
  _or?: InputMaybe<Array<RequestGroupsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "request_groups" */
export enum RequestGroupsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_GROUPS_PKEY = 'request_groups_pkey',
  /** unique or primary key constraint on columns "request_id", "group_id" */
  REQUEST_GROUPS_REQUEST_ID_GROUP_ID_KEY = 'request_groups_request_id_group_id_key'
}

/** input type for inserting data into table "request_groups" */
export type RequestGroupsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "request_groups" */
export type RequestGroupsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_groups" */
export type RequestGroupsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_groups" */
export type RequestGroupsMutationResponse = {
  __typename?: 'request_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestGroups>;
};

/** on_conflict condition type for table "request_groups" */
export type RequestGroupsOnConflict = {
  constraint: RequestGroupsConstraint;
  update_columns: Array<RequestGroupsUpdateColumn>;
  where?: InputMaybe<RequestGroupsBoolExp>;
};

/** Ordering options when selecting data from "request_groups". */
export type RequestGroupsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_groups */
export type RequestGroupsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_groups" */
export enum RequestGroupsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "request_groups" */
export type RequestGroupsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "request_groups" */
export enum RequestGroupsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type RequestGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: RequestGroupsBoolExp;
};

/** Maps the Request Leads User ID to their respective market and category */
export type RequestLeadsConfig = {
  __typename?: 'request_leads_config';
  /** An object relationship */
  category: Maybe<CustomCoreDataOptions>;
  category_id: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  market: Maybe<CustomCoreDataOptions>;
  market_id: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "request_leads_config". All fields are combined with a logical 'AND'. */
export type RequestLeadsConfigBoolExp = {
  _and?: InputMaybe<Array<RequestLeadsConfigBoolExp>>;
  _not?: InputMaybe<RequestLeadsConfigBoolExp>;
  _or?: InputMaybe<Array<RequestLeadsConfigBoolExp>>;
  category?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  category_id?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  market?: InputMaybe<CustomCoreDataOptionsBoolExp>;
  market_id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_leads_config" */
export enum RequestLeadsConfigConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_LEADS_CONFIG_PKEY = 'request_leads_config_pkey'
}

/** input type for inserting data into table "request_leads_config" */
export type RequestLeadsConfigInsertInput = {
  category?: InputMaybe<CustomCoreDataOptionsObjRelInsertInput>;
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  market?: InputMaybe<CustomCoreDataOptionsObjRelInsertInput>;
  market_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "request_leads_config" */
export type RequestLeadsConfigMutationResponse = {
  __typename?: 'request_leads_config_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestLeadsConfig>;
};

/** on_conflict condition type for table "request_leads_config" */
export type RequestLeadsConfigOnConflict = {
  constraint: RequestLeadsConfigConstraint;
  update_columns: Array<RequestLeadsConfigUpdateColumn>;
  where?: InputMaybe<RequestLeadsConfigBoolExp>;
};

/** Ordering options when selecting data from "request_leads_config". */
export type RequestLeadsConfigOrderBy = {
  category?: InputMaybe<CustomCoreDataOptionsOrderBy>;
  category_id?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  market?: InputMaybe<CustomCoreDataOptionsOrderBy>;
  market_id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** select columns of table "request_leads_config" */
export enum RequestLeadsConfigSelectColumn {
  /** column name */
  CATEGORY_ID = 'category_id',
  /** column name */
  ID = 'id',
  /** column name */
  MARKET_ID = 'market_id',
  /** column name */
  USER_ID = 'user_id'
}

/** Streaming cursor of the table "request_leads_config" */
export type RequestLeadsConfigStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RequestLeadsConfigStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RequestLeadsConfigStreamCursorValueInput = {
  category_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  market_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "request_leads_config" (current role has no relevant permissions) */
export enum RequestLeadsConfigUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "request_pauses" */
export type RequestPauses = {
  __typename?: 'request_pauses';
  assigneeId: Scalars['uuid']['output'];
  end: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  note: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organisation: Organisations;
  /** An object relationship */
  pause_reason: PauseReasons;
  reasonId: Scalars['uuid']['output'];
  reminderDate: Scalars['date']['output'];
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  start: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};

/** order by aggregate values of table "request_pauses" */
export type RequestPausesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestPausesMaxOrderBy>;
  min?: InputMaybe<RequestPausesMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_pauses" */
export type RequestPausesArrRelInsertInput = {
  data: Array<RequestPausesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestPausesOnConflict>;
};

/** Boolean expression to filter rows from the table "request_pauses". All fields are combined with a logical 'AND'. */
export type RequestPausesBoolExp = {
  _and?: InputMaybe<Array<RequestPausesBoolExp>>;
  _not?: InputMaybe<RequestPausesBoolExp>;
  _or?: InputMaybe<Array<RequestPausesBoolExp>>;
  assigneeId?: InputMaybe<UuidComparisonExp>;
  end?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  pause_reason?: InputMaybe<PauseReasonsBoolExp>;
  reasonId?: InputMaybe<UuidComparisonExp>;
  reminderDate?: InputMaybe<DateComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  start?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "request_pauses" */
export enum RequestPausesConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_PAUSES_PKEY = 'request_pauses_pkey'
}

/** input type for inserting data into table "request_pauses" */
export type RequestPausesInsertInput = {
  assigneeId?: InputMaybe<Scalars['uuid']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pause_reason?: InputMaybe<PauseReasonsObjRelInsertInput>;
  reasonId?: InputMaybe<Scalars['uuid']['input']>;
  reminderDate?: InputMaybe<Scalars['date']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** order by max() on columns of table "request_pauses" */
export type RequestPausesMaxOrderBy = {
  assigneeId?: InputMaybe<OrderBy>;
  end?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  reasonId?: InputMaybe<OrderBy>;
  reminderDate?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  start?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_pauses" */
export type RequestPausesMinOrderBy = {
  assigneeId?: InputMaybe<OrderBy>;
  end?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  reasonId?: InputMaybe<OrderBy>;
  reminderDate?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  start?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_pauses" */
export type RequestPausesMutationResponse = {
  __typename?: 'request_pauses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestPauses>;
};

/** on_conflict condition type for table "request_pauses" */
export type RequestPausesOnConflict = {
  constraint: RequestPausesConstraint;
  update_columns: Array<RequestPausesUpdateColumn>;
  where?: InputMaybe<RequestPausesBoolExp>;
};

/** Ordering options when selecting data from "request_pauses". */
export type RequestPausesOrderBy = {
  assigneeId?: InputMaybe<OrderBy>;
  end?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  pause_reason?: InputMaybe<PauseReasonsOrderBy>;
  reasonId?: InputMaybe<OrderBy>;
  reminderDate?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  start?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: request_pauses */
export type RequestPausesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_pauses" */
export enum RequestPausesSelectColumn {
  /** column name */
  ASSIGNEEID = 'assigneeId',
  /** column name */
  END = 'end',
  /** column name */
  ID = 'id',
  /** column name */
  NOTE = 'note',
  /** column name */
  REASONID = 'reasonId',
  /** column name */
  REMINDERDATE = 'reminderDate',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  START = 'start'
}

/** input type for updating data in table "request_pauses" */
export type RequestPausesSetInput = {
  end?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "request_pauses" */
export type RequestPausesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RequestPausesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RequestPausesStreamCursorValueInput = {
  assigneeId?: InputMaybe<Scalars['uuid']['input']>;
  end?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  reasonId?: InputMaybe<Scalars['uuid']['input']>;
  reminderDate?: InputMaybe<Scalars['date']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  start?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "request_pauses" */
export enum RequestPausesUpdateColumn {
  /** column name */
  END = 'end'
}

export type RequestPausesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestPausesSetInput>;
  /** filter the rows which have to be updated */
  where: RequestPausesBoolExp;
};

/** columns and relationships of "request_priority" */
export type RequestPriority = {
  __typename?: 'request_priority';
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "request_priority". All fields are combined with a logical 'AND'. */
export type RequestPriorityBoolExp = {
  _and?: InputMaybe<Array<RequestPriorityBoolExp>>;
  _not?: InputMaybe<RequestPriorityBoolExp>;
  _or?: InputMaybe<Array<RequestPriorityBoolExp>>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum RequestPriorityEnum {
  HIGH = 'HIGH',
  HIGHEST = 'HIGHEST',
  LOW = 'LOW',
  LOWEST = 'LOWEST',
  MEDIUM = 'MEDIUM'
}

/** Boolean expression to compare columns of type "request_priority_enum". All fields are combined with logical 'AND'. */
export type RequestPriorityEnumComparisonExp = {
  _eq?: InputMaybe<RequestPriorityEnum>;
  _in?: InputMaybe<Array<RequestPriorityEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RequestPriorityEnum>;
  _nin?: InputMaybe<Array<RequestPriorityEnum>>;
};

/** Ordering options when selecting data from "request_priority". */
export type RequestPriorityOrderBy = {
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "request_priority" */
export enum RequestPrioritySelectColumn {
  /** column name */
  VALUE = 'value'
}

/** columns and relationships of "request_request_leads" */
export type RequestRequestLeads = {
  __typename?: 'request_request_leads';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "request_request_leads" */
export type RequestRequestLeadsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestRequestLeadsMaxOrderBy>;
  min?: InputMaybe<RequestRequestLeadsMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_request_leads" */
export type RequestRequestLeadsArrRelInsertInput = {
  data: Array<RequestRequestLeadsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestRequestLeadsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_request_leads". All fields are combined with a logical 'AND'. */
export type RequestRequestLeadsBoolExp = {
  _and?: InputMaybe<Array<RequestRequestLeadsBoolExp>>;
  _not?: InputMaybe<RequestRequestLeadsBoolExp>;
  _or?: InputMaybe<Array<RequestRequestLeadsBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_request_leads" */
export enum RequestRequestLeadsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_REQUEST_LEADS_PKEY = 'request_request_leads_pkey',
  /** unique or primary key constraint on columns "user_id", "request_id" */
  REQUEST_REQUEST_LEADS_REQUEST_ID_USER_ID_KEY = 'request_request_leads_request_id_user_id_key'
}

/** input type for inserting data into table "request_request_leads" */
export type RequestRequestLeadsInsertInput = {
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "request_request_leads" */
export type RequestRequestLeadsMaxOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_request_leads" */
export type RequestRequestLeadsMinOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_request_leads" */
export type RequestRequestLeadsMutationResponse = {
  __typename?: 'request_request_leads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestRequestLeads>;
};

/** on_conflict condition type for table "request_request_leads" */
export type RequestRequestLeadsOnConflict = {
  constraint: RequestRequestLeadsConstraint;
  update_columns: Array<RequestRequestLeadsUpdateColumn>;
  where?: InputMaybe<RequestRequestLeadsBoolExp>;
};

/** Ordering options when selecting data from "request_request_leads". */
export type RequestRequestLeadsOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_request_leads */
export type RequestRequestLeadsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_request_leads" */
export enum RequestRequestLeadsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "request_request_leads" */
export type RequestRequestLeadsSetInput = {
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "request_request_leads" */
export type RequestRequestLeadsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RequestRequestLeadsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RequestRequestLeadsStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "request_request_leads" */
export enum RequestRequestLeadsUpdateColumn {
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  USERID = 'userId'
}

export type RequestRequestLeadsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestRequestLeadsSetInput>;
  /** filter the rows which have to be updated */
  where: RequestRequestLeadsBoolExp;
};

/** columns and relationships of "request_step_groups" */
export type RequestStepGroups = {
  __typename?: 'request_step_groups';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  group: Groups;
  groupId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  requestStepId: Scalars['uuid']['output'];
  /** An object relationship */
  request_step: RequestSteps;
  updatedAt: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "request_step_groups" */
export type RequestStepGroupsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestStepGroupsMaxOrderBy>;
  min?: InputMaybe<RequestStepGroupsMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_step_groups" */
export type RequestStepGroupsArrRelInsertInput = {
  data: Array<RequestStepGroupsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepGroupsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_step_groups". All fields are combined with a logical 'AND'. */
export type RequestStepGroupsBoolExp = {
  _and?: InputMaybe<Array<RequestStepGroupsBoolExp>>;
  _not?: InputMaybe<RequestStepGroupsBoolExp>;
  _or?: InputMaybe<Array<RequestStepGroupsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  group?: InputMaybe<GroupsBoolExp>;
  groupId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  requestStepId?: InputMaybe<UuidComparisonExp>;
  request_step?: InputMaybe<RequestStepsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "request_step_groups" */
export enum RequestStepGroupsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_STEP_ASSIGNED_GROUPS_PKEY = 'request_step_assigned_groups_pkey',
  /** unique or primary key constraint on columns "request_step_id", "group_id" */
  REQUEST_STEP_GROUPS_REQUEST_STEP_ID_GROUP_ID_KEY = 'request_step_groups_request_step_id_group_id_key'
}

/** input type for inserting data into table "request_step_groups" */
export type RequestStepGroupsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  group?: InputMaybe<GroupsObjRelInsertInput>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  request_step?: InputMaybe<RequestStepsObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "request_step_groups" */
export type RequestStepGroupsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_step_groups" */
export type RequestStepGroupsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_step_groups" */
export type RequestStepGroupsMutationResponse = {
  __typename?: 'request_step_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestStepGroups>;
};

/** on_conflict condition type for table "request_step_groups" */
export type RequestStepGroupsOnConflict = {
  constraint: RequestStepGroupsConstraint;
  update_columns: Array<RequestStepGroupsUpdateColumn>;
  where?: InputMaybe<RequestStepGroupsBoolExp>;
};

/** Ordering options when selecting data from "request_step_groups". */
export type RequestStepGroupsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  group?: InputMaybe<GroupsOrderBy>;
  groupId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  request_step?: InputMaybe<RequestStepsOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_step_groups */
export type RequestStepGroupsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_step_groups" */
export enum RequestStepGroupsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "request_step_groups" */
export type RequestStepGroupsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  groupId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "request_step_groups" */
export enum RequestStepGroupsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  GROUPID = 'groupId',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type RequestStepGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestStepGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: RequestStepGroupsBoolExp;
};

/** Saved notifications */
export type RequestStepNotificationMessages = {
  __typename?: 'request_step_notification_messages';
  body: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  requestStepId: Scalars['uuid']['output'];
  subject: Scalars['jsonb']['output'];
};


/** Saved notifications */
export type RequestStepNotificationMessagesBodyArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** Saved notifications */
export type RequestStepNotificationMessagesSubjectArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "request_step_notification_messages". All fields are combined with a logical 'AND'. */
export type RequestStepNotificationMessagesBoolExp = {
  _and?: InputMaybe<Array<RequestStepNotificationMessagesBoolExp>>;
  _not?: InputMaybe<RequestStepNotificationMessagesBoolExp>;
  _or?: InputMaybe<Array<RequestStepNotificationMessagesBoolExp>>;
  body?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  requestStepId?: InputMaybe<UuidComparisonExp>;
  subject?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "request_step_notification_messages" */
export enum RequestStepNotificationMessagesConstraint {
  /** unique or primary key constraint on columns "request_step_id" */
  REQUEST_STEP_NOTIFICATION_MESSAGES_PKEY = 'request_step_notification_messages_pkey'
}

/** input type for inserting data into table "request_step_notification_messages" */
export type RequestStepNotificationMessagesInsertInput = {
  body?: InputMaybe<Scalars['jsonb']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  subject?: InputMaybe<Scalars['jsonb']['input']>;
};

/** response of any mutation on the table "request_step_notification_messages" */
export type RequestStepNotificationMessagesMutationResponse = {
  __typename?: 'request_step_notification_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestStepNotificationMessages>;
};

/** on_conflict condition type for table "request_step_notification_messages" */
export type RequestStepNotificationMessagesOnConflict = {
  constraint: RequestStepNotificationMessagesConstraint;
  update_columns: Array<RequestStepNotificationMessagesUpdateColumn>;
  where?: InputMaybe<RequestStepNotificationMessagesBoolExp>;
};

/** Ordering options when selecting data from "request_step_notification_messages". */
export type RequestStepNotificationMessagesOrderBy = {
  body?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  subject?: InputMaybe<OrderBy>;
};

/** select columns of table "request_step_notification_messages" */
export enum RequestStepNotificationMessagesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  SUBJECT = 'subject'
}

/** Streaming cursor of the table "request_step_notification_messages" */
export type RequestStepNotificationMessagesStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RequestStepNotificationMessagesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RequestStepNotificationMessagesStreamCursorValueInput = {
  body?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  subject?: InputMaybe<Scalars['jsonb']['input']>;
};

/** placeholder for update columns of table "request_step_notification_messages" (current role has no relevant permissions) */
export enum RequestStepNotificationMessagesUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "request_step_result" */
export type RequestStepResult = {
  __typename?: 'request_step_result';
  description: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "request_step_result". All fields are combined with a logical 'AND'. */
export type RequestStepResultBoolExp = {
  _and?: InputMaybe<Array<RequestStepResultBoolExp>>;
  _not?: InputMaybe<RequestStepResultBoolExp>;
  _or?: InputMaybe<Array<RequestStepResultBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum RequestStepResultEnum {
  /** Error */
  ERROR = 'Error',
  /** Fail */
  FAIL = 'FAIL',
  /** Pass */
  PASS = 'PASS'
}

/** Boolean expression to compare columns of type "request_step_result_enum". All fields are combined with logical 'AND'. */
export type RequestStepResultEnumComparisonExp = {
  _eq?: InputMaybe<RequestStepResultEnum>;
  _in?: InputMaybe<Array<RequestStepResultEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RequestStepResultEnum>;
  _nin?: InputMaybe<Array<RequestStepResultEnum>>;
};

/** Ordering options when selecting data from "request_step_result". */
export type RequestStepResultOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "request_step_result" */
export enum RequestStepResultSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** columns and relationships of "request_step_state" */
export type RequestStepState = {
  __typename?: 'request_step_state';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "request_step_state". All fields are combined with a logical 'AND'. */
export type RequestStepStateBoolExp = {
  _and?: InputMaybe<Array<RequestStepStateBoolExp>>;
  _not?: InputMaybe<RequestStepStateBoolExp>;
  _or?: InputMaybe<Array<RequestStepStateBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum RequestStepStateEnum {
  /** COMPLETE */
  COMPLETE = 'COMPLETE',
  /** PAUSED */
  PAUSED = 'PAUSED',
  /** PENDING */
  PENDING = 'PENDING',
  /** RUNNING */
  RUNNING = 'RUNNING'
}

/** Boolean expression to compare columns of type "request_step_state_enum". All fields are combined with logical 'AND'. */
export type RequestStepStateEnumComparisonExp = {
  _eq?: InputMaybe<RequestStepStateEnum>;
  _in?: InputMaybe<Array<RequestStepStateEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RequestStepStateEnum>;
  _nin?: InputMaybe<Array<RequestStepStateEnum>>;
};

/** Ordering options when selecting data from "request_step_state". */
export type RequestStepStateOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "request_step_state" */
export enum RequestStepStateSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** columns and relationships of "request_step_task_errors" */
export type RequestStepTaskErrors = {
  __typename?: 'request_step_task_errors';
  createdAt: Scalars['timestamptz']['output'];
  detail: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  message: Scalars['String']['output'];
  occuredAt: Scalars['timestamptz']['output'];
  organisation_id: Scalars['uuid']['output'];
  requestStepTaskId: Scalars['uuid']['output'];
  /** An object relationship */
  request_step_task: RequestStepTasks;
  resolvedAt: Maybe<Scalars['timestamptz']['output']>;
  suggestion: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};


/** columns and relationships of "request_step_task_errors" */
export type RequestStepTaskErrorsDetailArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "request_step_task_errors" */
export type RequestStepTaskErrorsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestStepTaskErrorsMaxOrderBy>;
  min?: InputMaybe<RequestStepTaskErrorsMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_step_task_errors" */
export type RequestStepTaskErrorsArrRelInsertInput = {
  data: Array<RequestStepTaskErrorsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepTaskErrorsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_step_task_errors". All fields are combined with a logical 'AND'. */
export type RequestStepTaskErrorsBoolExp = {
  _and?: InputMaybe<Array<RequestStepTaskErrorsBoolExp>>;
  _not?: InputMaybe<RequestStepTaskErrorsBoolExp>;
  _or?: InputMaybe<Array<RequestStepTaskErrorsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  detail?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<StringComparisonExp>;
  occuredAt?: InputMaybe<TimestamptzComparisonExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  requestStepTaskId?: InputMaybe<UuidComparisonExp>;
  request_step_task?: InputMaybe<RequestStepTasksBoolExp>;
  resolvedAt?: InputMaybe<TimestamptzComparisonExp>;
  suggestion?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "request_step_task_errors" */
export enum RequestStepTaskErrorsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_STEP_TASK_ERRORS_PKEY = 'request_step_task_errors_pkey'
}

/** input type for inserting data into table "request_step_task_errors" */
export type RequestStepTaskErrorsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  detail?: InputMaybe<Scalars['jsonb']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  occuredAt?: InputMaybe<Scalars['timestamptz']['input']>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  request_step_task?: InputMaybe<RequestStepTasksObjRelInsertInput>;
  suggestion?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "request_step_task_errors" */
export type RequestStepTaskErrorsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  occuredAt?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  resolvedAt?: InputMaybe<OrderBy>;
  suggestion?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_step_task_errors" */
export type RequestStepTaskErrorsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  occuredAt?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  resolvedAt?: InputMaybe<OrderBy>;
  suggestion?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_step_task_errors" */
export type RequestStepTaskErrorsMutationResponse = {
  __typename?: 'request_step_task_errors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestStepTaskErrors>;
};

/** on_conflict condition type for table "request_step_task_errors" */
export type RequestStepTaskErrorsOnConflict = {
  constraint: RequestStepTaskErrorsConstraint;
  update_columns: Array<RequestStepTaskErrorsUpdateColumn>;
  where?: InputMaybe<RequestStepTaskErrorsBoolExp>;
};

/** Ordering options when selecting data from "request_step_task_errors". */
export type RequestStepTaskErrorsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  detail?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  occuredAt?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  request_step_task?: InputMaybe<RequestStepTasksOrderBy>;
  resolvedAt?: InputMaybe<OrderBy>;
  suggestion?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_step_task_errors */
export type RequestStepTaskErrorsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_step_task_errors" */
export enum RequestStepTaskErrorsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DETAIL = 'detail',
  /** column name */
  ID = 'id',
  /** column name */
  MESSAGE = 'message',
  /** column name */
  OCCUREDAT = 'occuredAt',
  /** column name */
  ORGANISATION_ID = 'organisation_id',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  RESOLVEDAT = 'resolvedAt',
  /** column name */
  SUGGESTION = 'suggestion',
  /** column name */
  TYPE = 'type'
}

/** input type for updating data in table "request_step_task_errors" */
export type RequestStepTaskErrorsSetInput = {
  resolvedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "request_step_task_errors" */
export enum RequestStepTaskErrorsUpdateColumn {
  /** column name */
  RESOLVEDAT = 'resolvedAt'
}

export type RequestStepTaskErrorsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestStepTaskErrorsSetInput>;
  /** filter the rows which have to be updated */
  where: RequestStepTaskErrorsBoolExp;
};

/** columns and relationships of "request_step_task_rejections" */
export type RequestStepTaskRejections = {
  __typename?: 'request_step_task_rejections';
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  message: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  requestStepTask: RequestStepTasks;
  requestStepTaskId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "request_step_task_rejections" */
export type RequestStepTaskRejectionsAggregate = {
  __typename?: 'request_step_task_rejections_aggregate';
  aggregate: Maybe<RequestStepTaskRejectionsAggregateFields>;
  nodes: Array<RequestStepTaskRejections>;
};

export type RequestStepTaskRejectionsAggregateBoolExp = {
  count?: InputMaybe<RequestStepTaskRejectionsAggregateBoolExpCount>;
};

export type RequestStepTaskRejectionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestStepTaskRejectionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestStepTaskRejectionsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_step_task_rejections" */
export type RequestStepTaskRejectionsAggregateFields = {
  __typename?: 'request_step_task_rejections_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestStepTaskRejectionsMaxFields>;
  min: Maybe<RequestStepTaskRejectionsMinFields>;
};


/** aggregate fields of "request_step_task_rejections" */
export type RequestStepTaskRejectionsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RequestStepTaskRejectionsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "request_step_task_rejections" */
export type RequestStepTaskRejectionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestStepTaskRejectionsMaxOrderBy>;
  min?: InputMaybe<RequestStepTaskRejectionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_step_task_rejections" */
export type RequestStepTaskRejectionsArrRelInsertInput = {
  data: Array<RequestStepTaskRejectionsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepTaskRejectionsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_step_task_rejections". All fields are combined with a logical 'AND'. */
export type RequestStepTaskRejectionsBoolExp = {
  _and?: InputMaybe<Array<RequestStepTaskRejectionsBoolExp>>;
  _not?: InputMaybe<RequestStepTaskRejectionsBoolExp>;
  _or?: InputMaybe<Array<RequestStepTaskRejectionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  message?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestStepTask?: InputMaybe<RequestStepTasksBoolExp>;
  requestStepTaskId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "request_step_task_rejections" */
export enum RequestStepTaskRejectionsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_STEP_TASK_REJECTIONS_PKEY = 'request_step_task_rejections_pkey'
}

/** input type for inserting data into table "request_step_task_rejections" */
export type RequestStepTaskRejectionsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  requestStepTask?: InputMaybe<RequestStepTasksObjRelInsertInput>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type RequestStepTaskRejectionsMaxFields = {
  __typename?: 'request_step_task_rejections_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  createdBy: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  message: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "request_step_task_rejections" */
export type RequestStepTaskRejectionsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RequestStepTaskRejectionsMinFields = {
  __typename?: 'request_step_task_rejections_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  createdBy: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  message: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestStepTaskId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "request_step_task_rejections" */
export type RequestStepTaskRejectionsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_step_task_rejections" */
export type RequestStepTaskRejectionsMutationResponse = {
  __typename?: 'request_step_task_rejections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestStepTaskRejections>;
};

/** on_conflict condition type for table "request_step_task_rejections" */
export type RequestStepTaskRejectionsOnConflict = {
  constraint: RequestStepTaskRejectionsConstraint;
  update_columns: Array<RequestStepTaskRejectionsUpdateColumn>;
  where?: InputMaybe<RequestStepTaskRejectionsBoolExp>;
};

/** Ordering options when selecting data from "request_step_task_rejections". */
export type RequestStepTaskRejectionsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  message?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestStepTask?: InputMaybe<RequestStepTasksOrderBy>;
  requestStepTaskId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: request_step_task_rejections */
export type RequestStepTaskRejectionsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_step_task_rejections" */
export enum RequestStepTaskRejectionsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  ID = 'id',
  /** column name */
  MESSAGE = 'message',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "request_step_task_rejections" */
export type RequestStepTaskRejectionsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  requestStepTaskId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "request_step_task_rejections" */
export enum RequestStepTaskRejectionsUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  ID = 'id',
  /** column name */
  MESSAGE = 'message',
  /** column name */
  REQUESTSTEPTASKID = 'requestStepTaskId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type RequestStepTaskRejectionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestStepTaskRejectionsSetInput>;
  /** filter the rows which have to be updated */
  where: RequestStepTaskRejectionsBoolExp;
};

/** columns and relationships of "request_step_task_type" */
export type RequestStepTaskType = {
  __typename?: 'request_step_task_type';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "request_step_task_type". All fields are combined with a logical 'AND'. */
export type RequestStepTaskTypeBoolExp = {
  _and?: InputMaybe<Array<RequestStepTaskTypeBoolExp>>;
  _not?: InputMaybe<RequestStepTaskTypeBoolExp>;
  _or?: InputMaybe<Array<RequestStepTaskTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum RequestStepTaskTypeEnum {
  /** Sync supplier data in external accounting software */
  ACCOUNTING_SUPPLIER_DATA_SYNC = 'ACCOUNTING_SUPPLIER_DATA_SYNC',
  /** eSignature task */
  ESIGN_FILL_IN = 'ESIGN_FILL_IN',
  /** External Operation */
  EXTERNAL_OPERATION = 'EXTERNAL_OPERATION',
  /** Create PO in external accounting software */
  EXTERNAL_PO_CREATION = 'EXTERNAL_PO_CREATION',
  /** Fill in */
  FILL_IN = 'FILL_IN',
  /** Review */
  REVIEW = 'REVIEW',
  /** Scoring task for a particular RFX form */
  SCORE_RFX_FORM = 'SCORE_RFX_FORM',
  /** Summary approval */
  SUMMARY_APPROVAL = 'SUMMARY_APPROVAL'
}

/** Boolean expression to compare columns of type "request_step_task_type_enum". All fields are combined with logical 'AND'. */
export type RequestStepTaskTypeEnumComparisonExp = {
  _eq?: InputMaybe<RequestStepTaskTypeEnum>;
  _in?: InputMaybe<Array<RequestStepTaskTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RequestStepTaskTypeEnum>;
  _nin?: InputMaybe<Array<RequestStepTaskTypeEnum>>;
};

/** Ordering options when selecting data from "request_step_task_type". */
export type RequestStepTaskTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "request_step_task_type" */
export enum RequestStepTaskTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** columns and relationships of "request_step_task_users" */
export type RequestStepTaskUsers = {
  __typename?: 'request_step_task_users';
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  request_step_task: RequestStepTasks;
  request_step_task_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "request_step_task_users" */
export type RequestStepTaskUsersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestStepTaskUsersMaxOrderBy>;
  min?: InputMaybe<RequestStepTaskUsersMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_step_task_users" */
export type RequestStepTaskUsersArrRelInsertInput = {
  data: Array<RequestStepTaskUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepTaskUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "request_step_task_users". All fields are combined with a logical 'AND'. */
export type RequestStepTaskUsersBoolExp = {
  _and?: InputMaybe<Array<RequestStepTaskUsersBoolExp>>;
  _not?: InputMaybe<RequestStepTaskUsersBoolExp>;
  _or?: InputMaybe<Array<RequestStepTaskUsersBoolExp>>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  request_step_task?: InputMaybe<RequestStepTasksBoolExp>;
  request_step_task_id?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  user_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_step_task_users" */
export enum RequestStepTaskUsersConstraint {
  /** unique or primary key constraint on columns "user_id", "organisation_id", "request_step_task_id" */
  REQUEST_STEP_TASK_USERS_PKEY = 'request_step_task_users_pkey'
}

/** input type for inserting data into table "request_step_task_users" */
export type RequestStepTaskUsersInsertInput = {
  request_step_task?: InputMaybe<RequestStepTasksObjRelInsertInput>;
  request_step_task_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "request_step_task_users" */
export type RequestStepTaskUsersMaxOrderBy = {
  organisation_id?: InputMaybe<OrderBy>;
  request_step_task_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_step_task_users" */
export type RequestStepTaskUsersMinOrderBy = {
  organisation_id?: InputMaybe<OrderBy>;
  request_step_task_id?: InputMaybe<OrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_step_task_users" */
export type RequestStepTaskUsersMutationResponse = {
  __typename?: 'request_step_task_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestStepTaskUsers>;
};

/** on_conflict condition type for table "request_step_task_users" */
export type RequestStepTaskUsersOnConflict = {
  constraint: RequestStepTaskUsersConstraint;
  update_columns: Array<RequestStepTaskUsersUpdateColumn>;
  where?: InputMaybe<RequestStepTaskUsersBoolExp>;
};

/** Ordering options when selecting data from "request_step_task_users". */
export type RequestStepTaskUsersOrderBy = {
  organisation_id?: InputMaybe<OrderBy>;
  request_step_task?: InputMaybe<RequestStepTasksOrderBy>;
  request_step_task_id?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  user_id?: InputMaybe<OrderBy>;
};

/** select columns of table "request_step_task_users" */
export enum RequestStepTaskUsersSelectColumn {
  /** column name */
  ORGANISATION_ID = 'organisation_id',
  /** column name */
  REQUEST_STEP_TASK_ID = 'request_step_task_id',
  /** column name */
  USER_ID = 'user_id'
}

/** Streaming cursor of the table "request_step_task_users" */
export type RequestStepTaskUsersStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RequestStepTaskUsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RequestStepTaskUsersStreamCursorValueInput = {
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  request_step_task_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "request_step_task_users" (current role has no relevant permissions) */
export enum RequestStepTaskUsersUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "request_step_tasks" */
export type RequestStepTasks = {
  __typename?: 'request_step_tasks';
  completedBy: Maybe<Scalars['uuid']['output']>;
  completedOn: Maybe<Scalars['timestamptz']['output']>;
  config: Maybe<Scalars['jsonb']['output']>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organisation_supplier: Maybe<OrganisationSuppliers>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepId: Scalars['uuid']['output'];
  /** An object relationship */
  request_form: Maybe<RequestForms>;
  /** An array relationship */
  request_form_question_scores: Array<RequestFormQuestionScore>;
  /** An array relationship */
  request_form_submissions: Array<RequestFormSubmissions>;
  /** An aggregate relationship */
  request_form_submissions_aggregate: RequestFormSubmissionsAggregate;
  /** An object relationship */
  request_form_template: Maybe<RequestFormTemplates>;
  request_form_template_id: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  request_step: RequestSteps;
  /** An array relationship */
  request_step_task_errors: Array<RequestStepTaskErrors>;
  /** An array relationship */
  request_step_task_rejections: Array<RequestStepTaskRejections>;
  /** An aggregate relationship */
  request_step_task_rejections_aggregate: RequestStepTaskRejectionsAggregate;
  /** An object relationship */
  request_step_task_type: RequestStepTaskType;
  /** An array relationship */
  request_step_task_users: Array<RequestStepTaskUsers>;
  submissionsClosedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  supplier: Maybe<OrganisationSuppliers>;
  type: RequestStepTaskTypeEnum;
  /** An object relationship */
  user: Maybe<Users>;
};


/** columns and relationships of "request_step_tasks" */
export type RequestStepTasksConfigArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "request_step_tasks" */
export type RequestStepTasksRequestFormQuestionScoresArgs = {
  distinct_on: InputMaybe<Array<RequestFormQuestionScoreSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormQuestionScoreOrderBy>>;
  where: InputMaybe<RequestFormQuestionScoreBoolExp>;
};


/** columns and relationships of "request_step_tasks" */
export type RequestStepTasksRequestFormSubmissionsArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionsOrderBy>>;
  where: InputMaybe<RequestFormSubmissionsBoolExp>;
};


/** columns and relationships of "request_step_tasks" */
export type RequestStepTasksRequestFormSubmissionsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionsOrderBy>>;
  where: InputMaybe<RequestFormSubmissionsBoolExp>;
};


/** columns and relationships of "request_step_tasks" */
export type RequestStepTasksRequestStepTaskErrorsArgs = {
  distinct_on: InputMaybe<Array<RequestStepTaskErrorsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTaskErrorsOrderBy>>;
  where: InputMaybe<RequestStepTaskErrorsBoolExp>;
};


/** columns and relationships of "request_step_tasks" */
export type RequestStepTasksRequestStepTaskRejectionsArgs = {
  distinct_on: InputMaybe<Array<RequestStepTaskRejectionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTaskRejectionsOrderBy>>;
  where: InputMaybe<RequestStepTaskRejectionsBoolExp>;
};


/** columns and relationships of "request_step_tasks" */
export type RequestStepTasksRequestStepTaskRejectionsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestStepTaskRejectionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTaskRejectionsOrderBy>>;
  where: InputMaybe<RequestStepTaskRejectionsBoolExp>;
};


/** columns and relationships of "request_step_tasks" */
export type RequestStepTasksRequestStepTaskUsersArgs = {
  distinct_on: InputMaybe<Array<RequestStepTaskUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTaskUsersOrderBy>>;
  where: InputMaybe<RequestStepTaskUsersBoolExp>;
};

/** aggregated selection of "request_step_tasks" */
export type RequestStepTasksAggregate = {
  __typename?: 'request_step_tasks_aggregate';
  aggregate: Maybe<RequestStepTasksAggregateFields>;
  nodes: Array<RequestStepTasks>;
};

export type RequestStepTasksAggregateBoolExp = {
  count?: InputMaybe<RequestStepTasksAggregateBoolExpCount>;
};

export type RequestStepTasksAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestStepTasksSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestStepTasksBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_step_tasks" */
export type RequestStepTasksAggregateFields = {
  __typename?: 'request_step_tasks_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestStepTasksMaxFields>;
  min: Maybe<RequestStepTasksMinFields>;
};


/** aggregate fields of "request_step_tasks" */
export type RequestStepTasksAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RequestStepTasksSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "request_step_tasks" */
export type RequestStepTasksAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestStepTasksMaxOrderBy>;
  min?: InputMaybe<RequestStepTasksMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RequestStepTasksAppendInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "request_step_tasks" */
export type RequestStepTasksArrRelInsertInput = {
  data: Array<RequestStepTasksInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepTasksOnConflict>;
};

/** Boolean expression to filter rows from the table "request_step_tasks". All fields are combined with a logical 'AND'. */
export type RequestStepTasksBoolExp = {
  _and?: InputMaybe<Array<RequestStepTasksBoolExp>>;
  _not?: InputMaybe<RequestStepTasksBoolExp>;
  _or?: InputMaybe<Array<RequestStepTasksBoolExp>>;
  completedBy?: InputMaybe<UuidComparisonExp>;
  completedOn?: InputMaybe<TimestamptzComparisonExp>;
  config?: InputMaybe<JsonbComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  requestFormId?: InputMaybe<UuidComparisonExp>;
  requestStepId?: InputMaybe<UuidComparisonExp>;
  request_form?: InputMaybe<RequestFormsBoolExp>;
  request_form_question_scores?: InputMaybe<RequestFormQuestionScoreBoolExp>;
  request_form_submissions?: InputMaybe<RequestFormSubmissionsBoolExp>;
  request_form_submissions_aggregate?: InputMaybe<RequestFormSubmissionsAggregateBoolExp>;
  request_form_template?: InputMaybe<RequestFormTemplatesBoolExp>;
  request_form_template_id?: InputMaybe<UuidComparisonExp>;
  request_step?: InputMaybe<RequestStepsBoolExp>;
  request_step_task_errors?: InputMaybe<RequestStepTaskErrorsBoolExp>;
  request_step_task_rejections?: InputMaybe<RequestStepTaskRejectionsBoolExp>;
  request_step_task_rejections_aggregate?: InputMaybe<RequestStepTaskRejectionsAggregateBoolExp>;
  request_step_task_type?: InputMaybe<RequestStepTaskTypeBoolExp>;
  request_step_task_users?: InputMaybe<RequestStepTaskUsersBoolExp>;
  submissionsClosedAt?: InputMaybe<TimestamptzComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  type?: InputMaybe<RequestStepTaskTypeEnumComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "request_step_tasks" */
export enum RequestStepTasksConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_STEP_TASKS_PKEY = 'request_step_tasks_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RequestStepTasksDeleteAtPathInput = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RequestStepTasksDeleteElemInput = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RequestStepTasksDeleteKeyInput = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "request_step_tasks" */
export type RequestStepTasksInsertInput = {
  completedBy?: InputMaybe<Scalars['uuid']['input']>;
  completedOn?: InputMaybe<Scalars['timestamptz']['input']>;
  config?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  request_form?: InputMaybe<RequestFormsObjRelInsertInput>;
  request_form_question_scores?: InputMaybe<RequestFormQuestionScoreArrRelInsertInput>;
  request_form_submissions?: InputMaybe<RequestFormSubmissionsArrRelInsertInput>;
  request_form_template?: InputMaybe<RequestFormTemplatesObjRelInsertInput>;
  request_form_template_id?: InputMaybe<Scalars['uuid']['input']>;
  request_step?: InputMaybe<RequestStepsObjRelInsertInput>;
  request_step_task_errors?: InputMaybe<RequestStepTaskErrorsArrRelInsertInput>;
  request_step_task_rejections?: InputMaybe<RequestStepTaskRejectionsArrRelInsertInput>;
  request_step_task_users?: InputMaybe<RequestStepTaskUsersArrRelInsertInput>;
  submissionsClosedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  type?: InputMaybe<RequestStepTaskTypeEnum>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type RequestStepTasksMaxFields = {
  __typename?: 'request_step_tasks_max_fields';
  completedBy: Maybe<Scalars['uuid']['output']>;
  completedOn: Maybe<Scalars['timestamptz']['output']>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepId: Maybe<Scalars['uuid']['output']>;
  request_form_template_id: Maybe<Scalars['uuid']['output']>;
  submissionsClosedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "request_step_tasks" */
export type RequestStepTasksMaxOrderBy = {
  completedBy?: InputMaybe<OrderBy>;
  completedOn?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  request_form_template_id?: InputMaybe<OrderBy>;
  submissionsClosedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RequestStepTasksMinFields = {
  __typename?: 'request_step_tasks_min_fields';
  completedBy: Maybe<Scalars['uuid']['output']>;
  completedOn: Maybe<Scalars['timestamptz']['output']>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestStepId: Maybe<Scalars['uuid']['output']>;
  request_form_template_id: Maybe<Scalars['uuid']['output']>;
  submissionsClosedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "request_step_tasks" */
export type RequestStepTasksMinOrderBy = {
  completedBy?: InputMaybe<OrderBy>;
  completedOn?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  request_form_template_id?: InputMaybe<OrderBy>;
  submissionsClosedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_step_tasks" */
export type RequestStepTasksMutationResponse = {
  __typename?: 'request_step_tasks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestStepTasks>;
};

/** input type for inserting object relation for remote table "request_step_tasks" */
export type RequestStepTasksObjRelInsertInput = {
  data: RequestStepTasksInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepTasksOnConflict>;
};

/** on_conflict condition type for table "request_step_tasks" */
export type RequestStepTasksOnConflict = {
  constraint: RequestStepTasksConstraint;
  update_columns: Array<RequestStepTasksUpdateColumn>;
  where?: InputMaybe<RequestStepTasksBoolExp>;
};

/** Ordering options when selecting data from "request_step_tasks". */
export type RequestStepTasksOrderBy = {
  completedBy?: InputMaybe<OrderBy>;
  completedOn?: InputMaybe<OrderBy>;
  config?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  request_form?: InputMaybe<RequestFormsOrderBy>;
  request_form_question_scores_aggregate?: InputMaybe<RequestFormQuestionScoreAggregateOrderBy>;
  request_form_submissions_aggregate?: InputMaybe<RequestFormSubmissionsAggregateOrderBy>;
  request_form_template?: InputMaybe<RequestFormTemplatesOrderBy>;
  request_form_template_id?: InputMaybe<OrderBy>;
  request_step?: InputMaybe<RequestStepsOrderBy>;
  request_step_task_errors_aggregate?: InputMaybe<RequestStepTaskErrorsAggregateOrderBy>;
  request_step_task_rejections_aggregate?: InputMaybe<RequestStepTaskRejectionsAggregateOrderBy>;
  request_step_task_type?: InputMaybe<RequestStepTaskTypeOrderBy>;
  request_step_task_users_aggregate?: InputMaybe<RequestStepTaskUsersAggregateOrderBy>;
  submissionsClosedAt?: InputMaybe<OrderBy>;
  supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  type?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: request_step_tasks */
export type RequestStepTasksPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RequestStepTasksPrependInput = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "request_step_tasks" */
export enum RequestStepTasksSelectColumn {
  /** column name */
  COMPLETEDBY = 'completedBy',
  /** column name */
  COMPLETEDON = 'completedOn',
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  REQUEST_FORM_TEMPLATE_ID = 'request_form_template_id',
  /** column name */
  SUBMISSIONSCLOSEDAT = 'submissionsClosedAt',
  /** column name */
  TYPE = 'type'
}

/** input type for updating data in table "request_step_tasks" */
export type RequestStepTasksSetInput = {
  completedBy?: InputMaybe<Scalars['uuid']['input']>;
  completedOn?: InputMaybe<Scalars['timestamptz']['input']>;
  config?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  submissionsClosedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  type?: InputMaybe<RequestStepTaskTypeEnum>;
};

/** update columns of table "request_step_tasks" */
export enum RequestStepTasksUpdateColumn {
  /** column name */
  COMPLETEDBY = 'completedBy',
  /** column name */
  COMPLETEDON = 'completedOn',
  /** column name */
  CONFIG = 'config',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  SUBMISSIONSCLOSEDAT = 'submissionsClosedAt',
  /** column name */
  TYPE = 'type'
}

export type RequestStepTasksUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RequestStepTasksAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RequestStepTasksDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RequestStepTasksDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RequestStepTasksDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RequestStepTasksPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestStepTasksSetInput>;
  /** filter the rows which have to be updated */
  where: RequestStepTasksBoolExp;
};

/** columns and relationships of "request_step_users" */
export type RequestStepUsers = {
  __typename?: 'request_step_users';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  requestStepId: Scalars['uuid']['output'];
  /** An object relationship */
  request_step: RequestSteps;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "request_step_users" */
export type RequestStepUsersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestStepUsersMaxOrderBy>;
  min?: InputMaybe<RequestStepUsersMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_step_users" */
export type RequestStepUsersArrRelInsertInput = {
  data: Array<RequestStepUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "request_step_users". All fields are combined with a logical 'AND'. */
export type RequestStepUsersBoolExp = {
  _and?: InputMaybe<Array<RequestStepUsersBoolExp>>;
  _not?: InputMaybe<RequestStepUsersBoolExp>;
  _or?: InputMaybe<Array<RequestStepUsersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  requestStepId?: InputMaybe<UuidComparisonExp>;
  request_step?: InputMaybe<RequestStepsBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_step_users" */
export enum RequestStepUsersConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_STEP_ASSIGNED_USERS_PKEY = 'request_step_assigned_users_pkey',
  /** unique or primary key constraint on columns "user_id", "request_step_id" */
  REQUEST_STEP_USERS_REQUEST_STEP_ID_USER_ID_KEY = 'request_step_users_request_step_id_user_id_key'
}

/** input type for inserting data into table "request_step_users" */
export type RequestStepUsersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  request_step?: InputMaybe<RequestStepsObjRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "request_step_users" */
export type RequestStepUsersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_step_users" */
export type RequestStepUsersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_step_users" */
export type RequestStepUsersMutationResponse = {
  __typename?: 'request_step_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestStepUsers>;
};

/** on_conflict condition type for table "request_step_users" */
export type RequestStepUsersOnConflict = {
  constraint: RequestStepUsersConstraint;
  update_columns: Array<RequestStepUsersUpdateColumn>;
  where?: InputMaybe<RequestStepUsersBoolExp>;
};

/** Ordering options when selecting data from "request_step_users". */
export type RequestStepUsersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  request_step?: InputMaybe<RequestStepsOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_step_users */
export type RequestStepUsersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_step_users" */
export enum RequestStepUsersSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "request_step_users" */
export type RequestStepUsersSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "request_step_users" */
export enum RequestStepUsersUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

export type RequestStepUsersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestStepUsersSetInput>;
  /** filter the rows which have to be updated */
  where: RequestStepUsersBoolExp;
};

/** columns and relationships of "request_steps" */
export type RequestSteps = {
  __typename?: 'request_steps';
  actionTakenAt: Maybe<Scalars['timestamptz']['output']>;
  canvasModelId: Scalars['String']['output'];
  canvasModelParentIds: Scalars['jsonb']['output'];
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  data: Maybe<Scalars['jsonb']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  input: Scalars['jsonb']['output'];
  output: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  /** An array relationship */
  request_form_templates: Array<RequestFormTemplates>;
  /** An array relationship */
  request_step_groups: Array<RequestStepGroups>;
  /** An object relationship */
  request_step_result: Maybe<RequestStepResult>;
  /** An array relationship */
  request_step_tasks: Array<RequestStepTasks>;
  /** An aggregate relationship */
  request_step_tasks_aggregate: RequestStepTasksAggregate;
  /** An array relationship */
  request_step_users: Array<RequestStepUsers>;
  result: Maybe<RequestStepResultEnum>;
  state: RequestStepStateEnum;
  totalPausedTime: Scalars['interval']['output'];
  totalPausedWorkingHours: Scalars['Int']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  workflow: Workflows;
  workflowId: Scalars['uuid']['output'];
};


/** columns and relationships of "request_steps" */
export type RequestStepsCanvasModelParentIdsArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "request_steps" */
export type RequestStepsDataArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "request_steps" */
export type RequestStepsInputArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "request_steps" */
export type RequestStepsOutputArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "request_steps" */
export type RequestStepsRequestFormTemplatesArgs = {
  distinct_on: InputMaybe<Array<RequestFormTemplatesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormTemplatesOrderBy>>;
  where: InputMaybe<RequestFormTemplatesBoolExp>;
};


/** columns and relationships of "request_steps" */
export type RequestStepsRequestStepGroupsArgs = {
  distinct_on: InputMaybe<Array<RequestStepGroupsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepGroupsOrderBy>>;
  where: InputMaybe<RequestStepGroupsBoolExp>;
};


/** columns and relationships of "request_steps" */
export type RequestStepsRequestStepTasksArgs = {
  distinct_on: InputMaybe<Array<RequestStepTasksSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTasksOrderBy>>;
  where: InputMaybe<RequestStepTasksBoolExp>;
};


/** columns and relationships of "request_steps" */
export type RequestStepsRequestStepTasksAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestStepTasksSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTasksOrderBy>>;
  where: InputMaybe<RequestStepTasksBoolExp>;
};


/** columns and relationships of "request_steps" */
export type RequestStepsRequestStepUsersArgs = {
  distinct_on: InputMaybe<Array<RequestStepUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepUsersOrderBy>>;
  where: InputMaybe<RequestStepUsersBoolExp>;
};

/** aggregated selection of "request_steps" */
export type RequestStepsAggregate = {
  __typename?: 'request_steps_aggregate';
  aggregate: Maybe<RequestStepsAggregateFields>;
  nodes: Array<RequestSteps>;
};

export type RequestStepsAggregateBoolExp = {
  count?: InputMaybe<RequestStepsAggregateBoolExpCount>;
};

export type RequestStepsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestStepsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestStepsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "request_steps" */
export type RequestStepsAggregateFields = {
  __typename?: 'request_steps_aggregate_fields';
  avg: Maybe<RequestStepsAvgFields>;
  count: Scalars['Int']['output'];
  max: Maybe<RequestStepsMaxFields>;
  min: Maybe<RequestStepsMinFields>;
  stddev: Maybe<RequestStepsStddevFields>;
  stddev_pop: Maybe<RequestStepsStddevPopFields>;
  stddev_samp: Maybe<RequestStepsStddevSampFields>;
  sum: Maybe<RequestStepsSumFields>;
  var_pop: Maybe<RequestStepsVarPopFields>;
  var_samp: Maybe<RequestStepsVarSampFields>;
  variance: Maybe<RequestStepsVarianceFields>;
};


/** aggregate fields of "request_steps" */
export type RequestStepsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RequestStepsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "request_steps" */
export type RequestStepsAggregateOrderBy = {
  avg?: InputMaybe<RequestStepsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestStepsMaxOrderBy>;
  min?: InputMaybe<RequestStepsMinOrderBy>;
  stddev?: InputMaybe<RequestStepsStddevOrderBy>;
  stddev_pop?: InputMaybe<RequestStepsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<RequestStepsStddevSampOrderBy>;
  sum?: InputMaybe<RequestStepsSumOrderBy>;
  var_pop?: InputMaybe<RequestStepsVarPopOrderBy>;
  var_samp?: InputMaybe<RequestStepsVarSampOrderBy>;
  variance?: InputMaybe<RequestStepsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RequestStepsAppendInput = {
  canvasModelParentIds?: InputMaybe<Scalars['jsonb']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  input?: InputMaybe<Scalars['jsonb']['input']>;
  output?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "request_steps" */
export type RequestStepsArrRelInsertInput = {
  data: Array<RequestStepsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepsOnConflict>;
};

/** aggregate avg on columns */
export type RequestStepsAvgFields = {
  __typename?: 'request_steps_avg_fields';
  totalPausedWorkingHours: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "request_steps" */
export type RequestStepsAvgOrderBy = {
  totalPausedWorkingHours?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "request_steps". All fields are combined with a logical 'AND'. */
export type RequestStepsBoolExp = {
  _and?: InputMaybe<Array<RequestStepsBoolExp>>;
  _not?: InputMaybe<RequestStepsBoolExp>;
  _or?: InputMaybe<Array<RequestStepsBoolExp>>;
  actionTakenAt?: InputMaybe<TimestamptzComparisonExp>;
  canvasModelId?: InputMaybe<StringComparisonExp>;
  canvasModelParentIds?: InputMaybe<JsonbComparisonExp>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  data?: InputMaybe<JsonbComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  input?: InputMaybe<JsonbComparisonExp>;
  output?: InputMaybe<JsonbComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  request_form_templates?: InputMaybe<RequestFormTemplatesBoolExp>;
  request_step_groups?: InputMaybe<RequestStepGroupsBoolExp>;
  request_step_result?: InputMaybe<RequestStepResultBoolExp>;
  request_step_tasks?: InputMaybe<RequestStepTasksBoolExp>;
  request_step_tasks_aggregate?: InputMaybe<RequestStepTasksAggregateBoolExp>;
  request_step_users?: InputMaybe<RequestStepUsersBoolExp>;
  result?: InputMaybe<RequestStepResultEnumComparisonExp>;
  state?: InputMaybe<RequestStepStateEnumComparisonExp>;
  totalPausedTime?: InputMaybe<IntervalComparisonExp>;
  totalPausedWorkingHours?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
  workflowId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_steps" */
export enum RequestStepsConstraint {
  /** unique or primary key constraint on columns "canvas_model_id", "request_id" */
  REQUEST_ID_CANVAS_ID = 'request_id_canvas_id',
  /** unique or primary key constraint on columns "id" */
  REQUEST_STEPS_PKEY = 'request_steps_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RequestStepsDeleteAtPathInput = {
  canvasModelParentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  data?: InputMaybe<Array<Scalars['String']['input']>>;
  input?: InputMaybe<Array<Scalars['String']['input']>>;
  output?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RequestStepsDeleteElemInput = {
  canvasModelParentIds?: InputMaybe<Scalars['Int']['input']>;
  data?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<Scalars['Int']['input']>;
  output?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RequestStepsDeleteKeyInput = {
  canvasModelParentIds?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<Scalars['String']['input']>;
  output?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "request_steps" */
export type RequestStepsIncInput = {
  totalPausedWorkingHours?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "request_steps" */
export type RequestStepsInsertInput = {
  actionTakenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  canvasModelId?: InputMaybe<Scalars['String']['input']>;
  canvasModelParentIds?: InputMaybe<Scalars['jsonb']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  input: Scalars['requestStepGraphNode']['input'];
  output?: InputMaybe<Scalars['jsonb']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  request_form_templates?: InputMaybe<RequestFormTemplatesArrRelInsertInput>;
  request_step_groups?: InputMaybe<RequestStepGroupsArrRelInsertInput>;
  request_step_tasks?: InputMaybe<RequestStepTasksArrRelInsertInput>;
  request_step_users?: InputMaybe<RequestStepUsersArrRelInsertInput>;
  result?: InputMaybe<RequestStepResultEnum>;
  state?: InputMaybe<RequestStepStateEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RequestStepsMaxFields = {
  __typename?: 'request_steps_max_fields';
  actionTakenAt: Maybe<Scalars['timestamptz']['output']>;
  canvasModelId: Maybe<Scalars['String']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  totalPausedWorkingHours: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "request_steps" */
export type RequestStepsMaxOrderBy = {
  actionTakenAt?: InputMaybe<OrderBy>;
  canvasModelId?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  totalPausedWorkingHours?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workflowId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RequestStepsMinFields = {
  __typename?: 'request_steps_min_fields';
  actionTakenAt: Maybe<Scalars['timestamptz']['output']>;
  canvasModelId: Maybe<Scalars['String']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  totalPausedWorkingHours: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "request_steps" */
export type RequestStepsMinOrderBy = {
  actionTakenAt?: InputMaybe<OrderBy>;
  canvasModelId?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  totalPausedWorkingHours?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workflowId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_steps" */
export type RequestStepsMutationResponse = {
  __typename?: 'request_steps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestSteps>;
};

/** input type for inserting object relation for remote table "request_steps" */
export type RequestStepsObjRelInsertInput = {
  data: RequestStepsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestStepsOnConflict>;
};

/** on_conflict condition type for table "request_steps" */
export type RequestStepsOnConflict = {
  constraint: RequestStepsConstraint;
  update_columns: Array<RequestStepsUpdateColumn>;
  where?: InputMaybe<RequestStepsBoolExp>;
};

/** Ordering options when selecting data from "request_steps". */
export type RequestStepsOrderBy = {
  actionTakenAt?: InputMaybe<OrderBy>;
  canvasModelId?: InputMaybe<OrderBy>;
  canvasModelParentIds?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  data?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  input?: InputMaybe<OrderBy>;
  output?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  request_form_templates_aggregate?: InputMaybe<RequestFormTemplatesAggregateOrderBy>;
  request_step_groups_aggregate?: InputMaybe<RequestStepGroupsAggregateOrderBy>;
  request_step_result?: InputMaybe<RequestStepResultOrderBy>;
  request_step_tasks_aggregate?: InputMaybe<RequestStepTasksAggregateOrderBy>;
  request_step_users_aggregate?: InputMaybe<RequestStepUsersAggregateOrderBy>;
  result?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  totalPausedTime?: InputMaybe<OrderBy>;
  totalPausedWorkingHours?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workflow?: InputMaybe<WorkflowsOrderBy>;
  workflowId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_steps */
export type RequestStepsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RequestStepsPrependInput = {
  canvasModelParentIds?: InputMaybe<Scalars['jsonb']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  input?: InputMaybe<Scalars['jsonb']['input']>;
  output?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "request_steps" */
export enum RequestStepsSelectColumn {
  /** column name */
  ACTIONTAKENAT = 'actionTakenAt',
  /** column name */
  CANVASMODELID = 'canvasModelId',
  /** column name */
  CANVASMODELPARENTIDS = 'canvasModelParentIds',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DATA = 'data',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  INPUT = 'input',
  /** column name */
  OUTPUT = 'output',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RESULT = 'result',
  /** column name */
  STATE = 'state',
  /** column name */
  TOTALPAUSEDTIME = 'totalPausedTime',
  /** column name */
  TOTALPAUSEDWORKINGHOURS = 'totalPausedWorkingHours',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId'
}

/** input type for updating data in table "request_steps" */
export type RequestStepsSetInput = {
  actionTakenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  canvasModelId?: InputMaybe<Scalars['String']['input']>;
  canvasModelParentIds?: InputMaybe<Scalars['jsonb']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  input?: InputMaybe<Scalars['requestStepGraphNode']['input']>;
  output?: InputMaybe<Scalars['jsonb']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  result?: InputMaybe<RequestStepResultEnum>;
  state?: InputMaybe<RequestStepStateEnum>;
  totalPausedTime?: InputMaybe<Scalars['interval']['input']>;
  totalPausedWorkingHours?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type RequestStepsStddevFields = {
  __typename?: 'request_steps_stddev_fields';
  totalPausedWorkingHours: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "request_steps" */
export type RequestStepsStddevOrderBy = {
  totalPausedWorkingHours?: InputMaybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RequestStepsStddevPopFields = {
  __typename?: 'request_steps_stddev_pop_fields';
  totalPausedWorkingHours: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "request_steps" */
export type RequestStepsStddevPopOrderBy = {
  totalPausedWorkingHours?: InputMaybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RequestStepsStddevSampFields = {
  __typename?: 'request_steps_stddev_samp_fields';
  totalPausedWorkingHours: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "request_steps" */
export type RequestStepsStddevSampOrderBy = {
  totalPausedWorkingHours?: InputMaybe<OrderBy>;
};

/** aggregate sum on columns */
export type RequestStepsSumFields = {
  __typename?: 'request_steps_sum_fields';
  totalPausedWorkingHours: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "request_steps" */
export type RequestStepsSumOrderBy = {
  totalPausedWorkingHours?: InputMaybe<OrderBy>;
};

/** update columns of table "request_steps" */
export enum RequestStepsUpdateColumn {
  /** column name */
  ACTIONTAKENAT = 'actionTakenAt',
  /** column name */
  CANVASMODELID = 'canvasModelId',
  /** column name */
  CANVASMODELPARENTIDS = 'canvasModelParentIds',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DATA = 'data',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  INPUT = 'input',
  /** column name */
  OUTPUT = 'output',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RESULT = 'result',
  /** column name */
  STATE = 'state',
  /** column name */
  TOTALPAUSEDTIME = 'totalPausedTime',
  /** column name */
  TOTALPAUSEDWORKINGHOURS = 'totalPausedWorkingHours',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId'
}

export type RequestStepsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RequestStepsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RequestStepsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RequestStepsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RequestStepsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RequestStepsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RequestStepsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestStepsSetInput>;
  /** filter the rows which have to be updated */
  where: RequestStepsBoolExp;
};

/** aggregate var_pop on columns */
export type RequestStepsVarPopFields = {
  __typename?: 'request_steps_var_pop_fields';
  totalPausedWorkingHours: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "request_steps" */
export type RequestStepsVarPopOrderBy = {
  totalPausedWorkingHours?: InputMaybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RequestStepsVarSampFields = {
  __typename?: 'request_steps_var_samp_fields';
  totalPausedWorkingHours: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "request_steps" */
export type RequestStepsVarSampOrderBy = {
  totalPausedWorkingHours?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type RequestStepsVarianceFields = {
  __typename?: 'request_steps_variance_fields';
  totalPausedWorkingHours: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "request_steps" */
export type RequestStepsVarianceOrderBy = {
  totalPausedWorkingHours?: InputMaybe<OrderBy>;
};

/** columns and relationships of "request_tags" */
export type RequestTags = {
  __typename?: 'request_tags';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  /** An object relationship */
  tag: Tags;
  tagId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "request_tags" */
export type RequestTagsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestTagsMaxOrderBy>;
  min?: InputMaybe<RequestTagsMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_tags" */
export type RequestTagsArrRelInsertInput = {
  data: Array<RequestTagsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestTagsOnConflict>;
};

/** Boolean expression to filter rows from the table "request_tags". All fields are combined with a logical 'AND'. */
export type RequestTagsBoolExp = {
  _and?: InputMaybe<Array<RequestTagsBoolExp>>;
  _not?: InputMaybe<RequestTagsBoolExp>;
  _or?: InputMaybe<Array<RequestTagsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  tag?: InputMaybe<TagsBoolExp>;
  tagId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_tags" */
export enum RequestTagsConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_TAGS_PKEY = 'request_tags_pkey',
  /** unique or primary key constraint on columns "request_id", "tag_id" */
  REQUEST_TAGS_TAG_ID_REQUEST_ID_KEY = 'request_tags_tag_id_request_id_key'
}

/** input type for inserting data into table "request_tags" */
export type RequestTagsInsertInput = {
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  tag?: InputMaybe<TagsObjRelInsertInput>;
  tagId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "request_tags" */
export type RequestTagsMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_tags" */
export type RequestTagsMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_tags" */
export type RequestTagsMutationResponse = {
  __typename?: 'request_tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestTags>;
};

/** on_conflict condition type for table "request_tags" */
export type RequestTagsOnConflict = {
  constraint: RequestTagsConstraint;
  update_columns: Array<RequestTagsUpdateColumn>;
  where?: InputMaybe<RequestTagsBoolExp>;
};

/** Ordering options when selecting data from "request_tags". */
export type RequestTagsOrderBy = {
  id?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  tag?: InputMaybe<TagsOrderBy>;
  tagId?: InputMaybe<OrderBy>;
};

/** select columns of table "request_tags" */
export enum RequestTagsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  TAGID = 'tagId'
}

/** placeholder for update columns of table "request_tags" (current role has no relevant permissions) */
export enum RequestTagsUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "request_type" */
export type RequestType = {
  __typename?: 'request_type';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "request_type". All fields are combined with a logical 'AND'. */
export type RequestTypeBoolExp = {
  _and?: InputMaybe<Array<RequestTypeBoolExp>>;
  _not?: InputMaybe<RequestTypeBoolExp>;
  _or?: InputMaybe<Array<RequestTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum RequestTypeEnum {
  /** Access Request */
  ACCESS_REQUEST = 'ACCESS_REQUEST',
  /** Assessment */
  ASSESSMENT = 'ASSESSMENT',
  /** Catalogue Purchase */
  CATALOGUE_PURCHASE = 'CATALOGUE_PURCHASE',
  /** New Purchase */
  NEW_PURCHASE = 'NEW_PURCHASE',
  /** Renewal */
  RENEWAL = 'RENEWAL'
}

/** Boolean expression to compare columns of type "request_type_enum". All fields are combined with logical 'AND'. */
export type RequestTypeEnumComparisonExp = {
  _eq?: InputMaybe<RequestTypeEnum>;
  _in?: InputMaybe<Array<RequestTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RequestTypeEnum>;
  _nin?: InputMaybe<Array<RequestTypeEnum>>;
};

/** Ordering options when selecting data from "request_type". */
export type RequestTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "request_type" */
export enum RequestTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** Connects users to requests */
export type RequestUsers = {
  __typename?: 'request_users';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "request_users" */
export type RequestUsersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestUsersMaxOrderBy>;
  min?: InputMaybe<RequestUsersMinOrderBy>;
};

/** input type for inserting array relation for remote table "request_users" */
export type RequestUsersArrRelInsertInput = {
  data: Array<RequestUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "request_users". All fields are combined with a logical 'AND'. */
export type RequestUsersBoolExp = {
  _and?: InputMaybe<Array<RequestUsersBoolExp>>;
  _not?: InputMaybe<RequestUsersBoolExp>;
  _or?: InputMaybe<Array<RequestUsersBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "request_users" */
export enum RequestUsersConstraint {
  /** unique or primary key constraint on columns "id" */
  REQUEST_USERS_PKEY = 'request_users_pkey',
  /** unique or primary key constraint on columns "user_id", "request_id" */
  REQUEST_USERS_USER_ID_REQUEST_ID_KEY = 'request_users_user_id_request_id_key'
}

/** input type for inserting data into table "request_users" */
export type RequestUsersInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "request_users" */
export type RequestUsersMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "request_users" */
export type RequestUsersMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "request_users" */
export type RequestUsersMutationResponse = {
  __typename?: 'request_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestUsers>;
};

/** on_conflict condition type for table "request_users" */
export type RequestUsersOnConflict = {
  constraint: RequestUsersConstraint;
  update_columns: Array<RequestUsersUpdateColumn>;
  where?: InputMaybe<RequestUsersBoolExp>;
};

/** Ordering options when selecting data from "request_users". */
export type RequestUsersOrderBy = {
  id?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: request_users */
export type RequestUsersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "request_users" */
export enum RequestUsersSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "request_users" */
export type RequestUsersSetInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "request_users" */
export enum RequestUsersUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  USERID = 'userId'
}

export type RequestUsersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestUsersSetInput>;
  /** filter the rows which have to be updated */
  where: RequestUsersBoolExp;
};

/** columns and relationships of "requests" */
export type Requests = {
  __typename?: 'requests';
  /** An object relationship */
  agreement: Maybe<Agreements>;
  /** agreementId */
  agreementId: Maybe<Scalars['uuid']['output']>;
  agreementTermId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  agreement_term: Maybe<AgreementTerms>;
  /** An object relationship */
  assessment: Maybe<Assessments>;
  /** An object relationship */
  budget: Maybe<Budgets>;
  budgetId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  comments: Array<RequestComments>;
  /** An aggregate relationship */
  comments_aggregate: RequestCommentsAggregate;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  computedProperties: Maybe<RequestComputedProperties>;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  createdRenewal: Array<Renewals>;
  /** An aggregate relationship */
  createdRenewal_aggregate: RenewalsAggregate;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  documents: Array<RequestDocuments>;
  /** An object relationship */
  engagement: Maybe<Engagements>;
  engagementId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  followers: Array<RequestFollowers>;
  /** An aggregate relationship */
  followers_aggregate: RequestFollowersAggregate;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  leads: Array<RequestRequestLeads>;
  model: Scalars['requestModel']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  owner: Maybe<Users>;
  ownerId: Maybe<Scalars['uuid']['output']>;
  poNumber: Maybe<Scalars['String']['output']>;
  priority: RequestPriorityEnum;
  /** An object relationship */
  product: Maybe<OrganisationProductsAndServices>;
  publicId: Scalars['String']['output'];
  /** An array relationship */
  purchase_orders: Array<PurchaseOrders>;
  /** An object relationship */
  renewal: Maybe<Renewals>;
  /** An object relationship */
  requestPriority: RequestPriority;
  /** An array relationship */
  request_esign_documents: Array<RequestEsignDocuments>;
  /** An array relationship */
  request_forms: Array<RequestForms>;
  /** An array relationship */
  request_groups: Array<RequestGroups>;
  /** An array relationship */
  request_pauses: Array<RequestPauses>;
  request_product: Maybe<Scalars['uuid']['output']>;
  request_supplier: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  request_tags: Array<RequestTags>;
  /** An array relationship */
  request_users: Array<RequestUsers>;
  requestorUserId: Scalars['uuid']['output'];
  /** An array relationship */
  rfxes: Array<Rfx>;
  /** An aggregate relationship */
  rfxes_aggregate: RfxAggregate;
  /** An array relationship */
  risks: Array<Risks>;
  /** Request detail sidebar configuration */
  sidebarConfig: Maybe<Scalars['jsonb']['output']>;
  state: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  steps: Array<RequestSteps>;
  /** An aggregate relationship */
  steps_aggregate: RequestStepsAggregate;
  /** An object relationship */
  supplier: Maybe<OrganisationSuppliers>;
  tagIds: Maybe<Scalars['jsonb']['output']>;
  totalPausedTime: Scalars['interval']['output'];
  type: RequestTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  /** An object relationship */
  workflow: Workflows;
  workflowId: Scalars['uuid']['output'];
};


/** columns and relationships of "requests" */
export type RequestsCommentsArgs = {
  distinct_on: InputMaybe<Array<RequestCommentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestCommentsOrderBy>>;
  where: InputMaybe<RequestCommentsBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsCommentsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestCommentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestCommentsOrderBy>>;
  where: InputMaybe<RequestCommentsBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsCreatedRenewalArgs = {
  distinct_on: InputMaybe<Array<RenewalsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalsOrderBy>>;
  where: InputMaybe<RenewalsBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsCreatedRenewalAggregateArgs = {
  distinct_on: InputMaybe<Array<RenewalsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalsOrderBy>>;
  where: InputMaybe<RenewalsBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsDocumentsArgs = {
  distinct_on: InputMaybe<Array<RequestDocumentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestDocumentsOrderBy>>;
  where: InputMaybe<RequestDocumentsBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsFollowersArgs = {
  distinct_on: InputMaybe<Array<RequestFollowersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFollowersOrderBy>>;
  where: InputMaybe<RequestFollowersBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsFollowersAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestFollowersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFollowersOrderBy>>;
  where: InputMaybe<RequestFollowersBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsLeadsArgs = {
  distinct_on: InputMaybe<Array<RequestRequestLeadsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestRequestLeadsOrderBy>>;
  where: InputMaybe<RequestRequestLeadsBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsPurchaseOrdersArgs = {
  distinct_on: InputMaybe<Array<PurchaseOrdersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<PurchaseOrdersOrderBy>>;
  where: InputMaybe<PurchaseOrdersBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsRequestEsignDocumentsArgs = {
  distinct_on: InputMaybe<Array<RequestEsignDocumentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestEsignDocumentsOrderBy>>;
  where: InputMaybe<RequestEsignDocumentsBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsRequestFormsArgs = {
  distinct_on: InputMaybe<Array<RequestFormsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormsOrderBy>>;
  where: InputMaybe<RequestFormsBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsRequestGroupsArgs = {
  distinct_on: InputMaybe<Array<RequestGroupsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestGroupsOrderBy>>;
  where: InputMaybe<RequestGroupsBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsRequestPausesArgs = {
  distinct_on: InputMaybe<Array<RequestPausesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestPausesOrderBy>>;
  where: InputMaybe<RequestPausesBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsRequestTagsArgs = {
  distinct_on: InputMaybe<Array<RequestTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestTagsOrderBy>>;
  where: InputMaybe<RequestTagsBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsRequestUsersArgs = {
  distinct_on: InputMaybe<Array<RequestUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestUsersOrderBy>>;
  where: InputMaybe<RequestUsersBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsRfxesArgs = {
  distinct_on: InputMaybe<Array<RfxSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxOrderBy>>;
  where: InputMaybe<RfxBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsRfxesAggregateArgs = {
  distinct_on: InputMaybe<Array<RfxSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxOrderBy>>;
  where: InputMaybe<RfxBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsRisksArgs = {
  distinct_on: InputMaybe<Array<RisksSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RisksOrderBy>>;
  where: InputMaybe<RisksBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsSidebarConfigArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "requests" */
export type RequestsStepsArgs = {
  distinct_on: InputMaybe<Array<RequestStepsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepsOrderBy>>;
  where: InputMaybe<RequestStepsBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsStepsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestStepsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepsOrderBy>>;
  where: InputMaybe<RequestStepsBoolExp>;
};


/** columns and relationships of "requests" */
export type RequestsTagIdsArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "requests" */
export type RequestsAggregate = {
  __typename?: 'requests_aggregate';
  aggregate: Maybe<RequestsAggregateFields>;
  nodes: Array<Requests>;
};

export type RequestsAggregateBoolExp = {
  count?: InputMaybe<RequestsAggregateBoolExpCount>;
};

export type RequestsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RequestsBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "requests" */
export type RequestsAggregateFields = {
  __typename?: 'requests_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RequestsMaxFields>;
  min: Maybe<RequestsMinFields>;
};


/** aggregate fields of "requests" */
export type RequestsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RequestsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "requests" */
export type RequestsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RequestsMaxOrderBy>;
  min?: InputMaybe<RequestsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RequestsAppendInput = {
  model?: InputMaybe<Scalars['jsonb']['input']>;
  /** Request detail sidebar configuration */
  sidebarConfig?: InputMaybe<Scalars['jsonb']['input']>;
  tagIds?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "requests" */
export type RequestsArrRelInsertInput = {
  data: Array<RequestsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestsOnConflict>;
};

/** Boolean expression to filter rows from the table "requests". All fields are combined with a logical 'AND'. */
export type RequestsBoolExp = {
  _and?: InputMaybe<Array<RequestsBoolExp>>;
  _not?: InputMaybe<RequestsBoolExp>;
  _or?: InputMaybe<Array<RequestsBoolExp>>;
  agreement?: InputMaybe<AgreementsBoolExp>;
  agreementId?: InputMaybe<UuidComparisonExp>;
  agreementTermId?: InputMaybe<UuidComparisonExp>;
  agreement_term?: InputMaybe<AgreementTermsBoolExp>;
  assessment?: InputMaybe<AssessmentsBoolExp>;
  budget?: InputMaybe<BudgetsBoolExp>;
  budgetId?: InputMaybe<UuidComparisonExp>;
  comments?: InputMaybe<RequestCommentsBoolExp>;
  comments_aggregate?: InputMaybe<RequestCommentsAggregateBoolExp>;
  completedAt?: InputMaybe<TimestamptzComparisonExp>;
  computedProperties?: InputMaybe<RequestComputedPropertiesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdRenewal?: InputMaybe<RenewalsBoolExp>;
  createdRenewal_aggregate?: InputMaybe<RenewalsAggregateBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  documents?: InputMaybe<RequestDocumentsBoolExp>;
  engagement?: InputMaybe<EngagementsBoolExp>;
  engagementId?: InputMaybe<UuidComparisonExp>;
  followers?: InputMaybe<RequestFollowersBoolExp>;
  followers_aggregate?: InputMaybe<RequestFollowersAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  leads?: InputMaybe<RequestRequestLeadsBoolExp>;
  model?: InputMaybe<JsonbComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  owner?: InputMaybe<UsersBoolExp>;
  ownerId?: InputMaybe<UuidComparisonExp>;
  poNumber?: InputMaybe<StringComparisonExp>;
  priority?: InputMaybe<RequestPriorityEnumComparisonExp>;
  product?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  publicId?: InputMaybe<StringComparisonExp>;
  purchase_orders?: InputMaybe<PurchaseOrdersBoolExp>;
  renewal?: InputMaybe<RenewalsBoolExp>;
  requestPriority?: InputMaybe<RequestPriorityBoolExp>;
  request_esign_documents?: InputMaybe<RequestEsignDocumentsBoolExp>;
  request_forms?: InputMaybe<RequestFormsBoolExp>;
  request_groups?: InputMaybe<RequestGroupsBoolExp>;
  request_pauses?: InputMaybe<RequestPausesBoolExp>;
  request_product?: InputMaybe<UuidComparisonExp>;
  request_supplier?: InputMaybe<UuidComparisonExp>;
  request_tags?: InputMaybe<RequestTagsBoolExp>;
  request_users?: InputMaybe<RequestUsersBoolExp>;
  requestorUserId?: InputMaybe<UuidComparisonExp>;
  rfxes?: InputMaybe<RfxBoolExp>;
  rfxes_aggregate?: InputMaybe<RfxAggregateBoolExp>;
  risks?: InputMaybe<RisksBoolExp>;
  sidebarConfig?: InputMaybe<JsonbComparisonExp>;
  state?: InputMaybe<StringComparisonExp>;
  status?: InputMaybe<StringComparisonExp>;
  steps?: InputMaybe<RequestStepsBoolExp>;
  steps_aggregate?: InputMaybe<RequestStepsAggregateBoolExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  tagIds?: InputMaybe<JsonbComparisonExp>;
  totalPausedTime?: InputMaybe<IntervalComparisonExp>;
  type?: InputMaybe<RequestTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
  workflowId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "requests" */
export enum RequestsConstraint {
  /** unique or primary key constraint on columns "id", "engagement_id" */
  REQUESTS_ENGAGEMENT_ID_ID_KEY = 'requests_engagement_id_id_key',
  /** unique or primary key constraint on columns "organisation_id", "public_id" */
  REQUESTS_ORGANISATION_ID_PUBLIC_ID_KEY = 'requests_organisation_id_public_id_key',
  /** unique or primary key constraint on columns "id" */
  REQUESTS_PKEY = 'requests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RequestsDeleteAtPathInput = {
  model?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Request detail sidebar configuration */
  sidebarConfig?: InputMaybe<Array<Scalars['String']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RequestsDeleteElemInput = {
  model?: InputMaybe<Scalars['Int']['input']>;
  /** Request detail sidebar configuration */
  sidebarConfig?: InputMaybe<Scalars['Int']['input']>;
  tagIds?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RequestsDeleteKeyInput = {
  model?: InputMaybe<Scalars['String']['input']>;
  /** Request detail sidebar configuration */
  sidebarConfig?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "requests" */
export type RequestsInsertInput = {
  agreement?: InputMaybe<AgreementsObjRelInsertInput>;
  /** agreementId */
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  agreement_term?: InputMaybe<AgreementTermsObjRelInsertInput>;
  assessment?: InputMaybe<AssessmentsObjRelInsertInput>;
  budget?: InputMaybe<BudgetsObjRelInsertInput>;
  budgetId?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<RequestCommentsArrRelInsertInput>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  computedProperties?: InputMaybe<RequestComputedPropertiesObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdRenewal?: InputMaybe<RenewalsArrRelInsertInput>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  documents?: InputMaybe<RequestDocumentsArrRelInsertInput>;
  engagement?: InputMaybe<EngagementsObjRelInsertInput>;
  engagementId?: InputMaybe<Scalars['uuid']['input']>;
  followers?: InputMaybe<RequestFollowersArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  leads?: InputMaybe<RequestRequestLeadsArrRelInsertInput>;
  model: Scalars['requestModel']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<UsersObjRelInsertInput>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<RequestPriorityEnum>;
  product?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
  purchase_orders?: InputMaybe<PurchaseOrdersArrRelInsertInput>;
  renewal?: InputMaybe<RenewalsObjRelInsertInput>;
  request_esign_documents?: InputMaybe<RequestEsignDocumentsArrRelInsertInput>;
  request_forms?: InputMaybe<RequestFormsArrRelInsertInput>;
  request_groups?: InputMaybe<RequestGroupsArrRelInsertInput>;
  request_pauses?: InputMaybe<RequestPausesArrRelInsertInput>;
  request_product?: InputMaybe<Scalars['uuid']['input']>;
  request_supplier?: InputMaybe<Scalars['uuid']['input']>;
  request_tags?: InputMaybe<RequestTagsArrRelInsertInput>;
  request_users?: InputMaybe<RequestUsersArrRelInsertInput>;
  requestorUserId?: InputMaybe<Scalars['uuid']['input']>;
  rfxes?: InputMaybe<RfxArrRelInsertInput>;
  risks?: InputMaybe<RisksArrRelInsertInput>;
  /** Request detail sidebar configuration */
  sidebarConfig?: InputMaybe<Scalars['jsonb']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<RequestStepsArrRelInsertInput>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  tagIds?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<RequestTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RequestsMaxFields = {
  __typename?: 'requests_max_fields';
  /** agreementId */
  agreementId: Maybe<Scalars['uuid']['output']>;
  agreementTermId: Maybe<Scalars['uuid']['output']>;
  budgetId: Maybe<Scalars['uuid']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  engagementId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  ownerId: Maybe<Scalars['uuid']['output']>;
  poNumber: Maybe<Scalars['String']['output']>;
  publicId: Maybe<Scalars['String']['output']>;
  request_product: Maybe<Scalars['uuid']['output']>;
  request_supplier: Maybe<Scalars['uuid']['output']>;
  requestorUserId: Maybe<Scalars['uuid']['output']>;
  state: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "requests" */
export type RequestsMaxOrderBy = {
  /** agreementId */
  agreementId?: InputMaybe<OrderBy>;
  agreementTermId?: InputMaybe<OrderBy>;
  budgetId?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  engagementId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  poNumber?: InputMaybe<OrderBy>;
  publicId?: InputMaybe<OrderBy>;
  request_product?: InputMaybe<OrderBy>;
  request_supplier?: InputMaybe<OrderBy>;
  requestorUserId?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workflowId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RequestsMinFields = {
  __typename?: 'requests_min_fields';
  /** agreementId */
  agreementId: Maybe<Scalars['uuid']['output']>;
  agreementTermId: Maybe<Scalars['uuid']['output']>;
  budgetId: Maybe<Scalars['uuid']['output']>;
  completedAt: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  engagementId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  ownerId: Maybe<Scalars['uuid']['output']>;
  poNumber: Maybe<Scalars['String']['output']>;
  publicId: Maybe<Scalars['String']['output']>;
  request_product: Maybe<Scalars['uuid']['output']>;
  request_supplier: Maybe<Scalars['uuid']['output']>;
  requestorUserId: Maybe<Scalars['uuid']['output']>;
  state: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
  workflowId: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "requests" */
export type RequestsMinOrderBy = {
  /** agreementId */
  agreementId?: InputMaybe<OrderBy>;
  agreementTermId?: InputMaybe<OrderBy>;
  budgetId?: InputMaybe<OrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  engagementId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  poNumber?: InputMaybe<OrderBy>;
  publicId?: InputMaybe<OrderBy>;
  request_product?: InputMaybe<OrderBy>;
  request_supplier?: InputMaybe<OrderBy>;
  requestorUserId?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  workflowId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "requests" */
export type RequestsMutationResponse = {
  __typename?: 'requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Requests>;
};

/** input type for inserting object relation for remote table "requests" */
export type RequestsObjRelInsertInput = {
  data: RequestsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RequestsOnConflict>;
};

/** on_conflict condition type for table "requests" */
export type RequestsOnConflict = {
  constraint: RequestsConstraint;
  update_columns: Array<RequestsUpdateColumn>;
  where?: InputMaybe<RequestsBoolExp>;
};

/** Ordering options when selecting data from "requests". */
export type RequestsOrderBy = {
  agreement?: InputMaybe<AgreementsOrderBy>;
  agreementId?: InputMaybe<OrderBy>;
  agreementTermId?: InputMaybe<OrderBy>;
  agreement_term?: InputMaybe<AgreementTermsOrderBy>;
  assessment?: InputMaybe<AssessmentsOrderBy>;
  budget?: InputMaybe<BudgetsOrderBy>;
  budgetId?: InputMaybe<OrderBy>;
  comments_aggregate?: InputMaybe<RequestCommentsAggregateOrderBy>;
  completedAt?: InputMaybe<OrderBy>;
  computedProperties?: InputMaybe<RequestComputedPropertiesOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdRenewal_aggregate?: InputMaybe<RenewalsAggregateOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  documents_aggregate?: InputMaybe<RequestDocumentsAggregateOrderBy>;
  engagement?: InputMaybe<EngagementsOrderBy>;
  engagementId?: InputMaybe<OrderBy>;
  followers_aggregate?: InputMaybe<RequestFollowersAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  leads_aggregate?: InputMaybe<RequestRequestLeadsAggregateOrderBy>;
  model?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  owner?: InputMaybe<UsersOrderBy>;
  ownerId?: InputMaybe<OrderBy>;
  poNumber?: InputMaybe<OrderBy>;
  priority?: InputMaybe<OrderBy>;
  product?: InputMaybe<OrganisationProductsAndServicesOrderBy>;
  publicId?: InputMaybe<OrderBy>;
  purchase_orders_aggregate?: InputMaybe<PurchaseOrdersAggregateOrderBy>;
  renewal?: InputMaybe<RenewalsOrderBy>;
  requestPriority?: InputMaybe<RequestPriorityOrderBy>;
  request_esign_documents_aggregate?: InputMaybe<RequestEsignDocumentsAggregateOrderBy>;
  request_forms_aggregate?: InputMaybe<RequestFormsAggregateOrderBy>;
  request_groups_aggregate?: InputMaybe<RequestGroupsAggregateOrderBy>;
  request_pauses_aggregate?: InputMaybe<RequestPausesAggregateOrderBy>;
  request_product?: InputMaybe<OrderBy>;
  request_supplier?: InputMaybe<OrderBy>;
  request_tags_aggregate?: InputMaybe<RequestTagsAggregateOrderBy>;
  request_users_aggregate?: InputMaybe<RequestUsersAggregateOrderBy>;
  requestorUserId?: InputMaybe<OrderBy>;
  rfxes_aggregate?: InputMaybe<RfxAggregateOrderBy>;
  risks_aggregate?: InputMaybe<RisksAggregateOrderBy>;
  sidebarConfig?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  steps_aggregate?: InputMaybe<RequestStepsAggregateOrderBy>;
  supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  tagIds?: InputMaybe<OrderBy>;
  totalPausedTime?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  workflow?: InputMaybe<WorkflowsOrderBy>;
  workflowId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: requests */
export type RequestsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RequestsPrependInput = {
  model?: InputMaybe<Scalars['jsonb']['input']>;
  /** Request detail sidebar configuration */
  sidebarConfig?: InputMaybe<Scalars['jsonb']['input']>;
  tagIds?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "requests" */
export enum RequestsSelectColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  AGREEMENTTERMID = 'agreementTermId',
  /** column name */
  BUDGETID = 'budgetId',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ENGAGEMENTID = 'engagementId',
  /** column name */
  ID = 'id',
  /** column name */
  MODEL = 'model',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  OWNERID = 'ownerId',
  /** column name */
  PONUMBER = 'poNumber',
  /** column name */
  PRIORITY = 'priority',
  /** column name */
  PUBLICID = 'publicId',
  /** column name */
  REQUEST_PRODUCT = 'request_product',
  /** column name */
  REQUEST_SUPPLIER = 'request_supplier',
  /** column name */
  REQUESTORUSERID = 'requestorUserId',
  /** column name */
  SIDEBARCONFIG = 'sidebarConfig',
  /** column name */
  STATE = 'state',
  /** column name */
  STATUS = 'status',
  /** column name */
  TAGIDS = 'tagIds',
  /** column name */
  TOTALPAUSEDTIME = 'totalPausedTime',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId'
}

/** input type for updating data in table "requests" */
export type RequestsSetInput = {
  /** agreementId */
  agreementId?: InputMaybe<Scalars['uuid']['input']>;
  agreementTermId?: InputMaybe<Scalars['uuid']['input']>;
  budgetId?: InputMaybe<Scalars['uuid']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  engagementId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  model?: InputMaybe<Scalars['requestModel']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<RequestPriorityEnum>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  request_product?: InputMaybe<Scalars['uuid']['input']>;
  request_supplier?: InputMaybe<Scalars['uuid']['input']>;
  requestorUserId?: InputMaybe<Scalars['uuid']['input']>;
  /** Request detail sidebar configuration */
  sidebarConfig?: InputMaybe<Scalars['jsonb']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Scalars['jsonb']['input']>;
  totalPausedTime?: InputMaybe<Scalars['interval']['input']>;
  type?: InputMaybe<RequestTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "requests" */
export enum RequestsUpdateColumn {
  /** column name */
  AGREEMENTID = 'agreementId',
  /** column name */
  AGREEMENTTERMID = 'agreementTermId',
  /** column name */
  BUDGETID = 'budgetId',
  /** column name */
  COMPLETEDAT = 'completedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ENGAGEMENTID = 'engagementId',
  /** column name */
  ID = 'id',
  /** column name */
  MODEL = 'model',
  /** column name */
  NAME = 'name',
  /** column name */
  OWNERID = 'ownerId',
  /** column name */
  PONUMBER = 'poNumber',
  /** column name */
  PRIORITY = 'priority',
  /** column name */
  PUBLICID = 'publicId',
  /** column name */
  REQUEST_PRODUCT = 'request_product',
  /** column name */
  REQUEST_SUPPLIER = 'request_supplier',
  /** column name */
  REQUESTORUSERID = 'requestorUserId',
  /** column name */
  SIDEBARCONFIG = 'sidebarConfig',
  /** column name */
  STATE = 'state',
  /** column name */
  TAGIDS = 'tagIds',
  /** column name */
  TOTALPAUSEDTIME = 'totalPausedTime',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WORKFLOWID = 'workflowId'
}

export type RequestsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RequestsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RequestsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RequestsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RequestsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RequestsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestsSetInput>;
  /** filter the rows which have to be updated */
  where: RequestsBoolExp;
};

/** columns and relationships of "rfx" */
export type Rfx = {
  __typename?: 'rfx';
  aiScoringEnabled: Scalars['Boolean']['output'];
  aiScoringVisible: Scalars['Boolean']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  isReopened: Scalars['Boolean']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An array relationship */
  owners: Array<RfxOwners>;
  /** An object relationship */
  request: Requests;
  requestId: Scalars['uuid']['output'];
  requestStepId: Scalars['uuid']['output'];
  /** An object relationship */
  request_step: RequestSteps;
  /** An array relationship */
  rfx_confidentiality_agreements: Array<RfxConfidentialityAgreement>;
  /** An aggregate relationship */
  rfx_confidentiality_agreements_aggregate: RfxConfidentialityAgreementAggregate;
  /** An array relationship */
  rfx_suppliers: Array<RfxSuppliers>;
  /** An aggregate relationship */
  rfx_suppliers_aggregate: RfxSuppliersAggregate;
  status: Scalars['String']['output'];
  supplierInstructions: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "rfx" */
export type RfxOwnersArgs = {
  distinct_on: InputMaybe<Array<RfxOwnersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxOwnersOrderBy>>;
  where: InputMaybe<RfxOwnersBoolExp>;
};


/** columns and relationships of "rfx" */
export type RfxRfxConfidentialityAgreementsArgs = {
  distinct_on: InputMaybe<Array<RfxConfidentialityAgreementSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxConfidentialityAgreementOrderBy>>;
  where: InputMaybe<RfxConfidentialityAgreementBoolExp>;
};


/** columns and relationships of "rfx" */
export type RfxRfxConfidentialityAgreementsAggregateArgs = {
  distinct_on: InputMaybe<Array<RfxConfidentialityAgreementSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxConfidentialityAgreementOrderBy>>;
  where: InputMaybe<RfxConfidentialityAgreementBoolExp>;
};


/** columns and relationships of "rfx" */
export type RfxRfxSuppliersArgs = {
  distinct_on: InputMaybe<Array<RfxSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxSuppliersOrderBy>>;
  where: InputMaybe<RfxSuppliersBoolExp>;
};


/** columns and relationships of "rfx" */
export type RfxRfxSuppliersAggregateArgs = {
  distinct_on: InputMaybe<Array<RfxSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxSuppliersOrderBy>>;
  where: InputMaybe<RfxSuppliersBoolExp>;
};

/** aggregated selection of "rfx" */
export type RfxAggregate = {
  __typename?: 'rfx_aggregate';
  aggregate: Maybe<RfxAggregateFields>;
  nodes: Array<Rfx>;
};

export type RfxAggregateBoolExp = {
  bool_and?: InputMaybe<RfxAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<RfxAggregateBoolExpBoolOr>;
  count?: InputMaybe<RfxAggregateBoolExpCount>;
};

export type RfxAggregateBoolExpBoolAnd = {
  arguments: RfxSelectColumnRfxAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RfxAggregateBoolExpBoolOr = {
  arguments: RfxSelectColumnRfxAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RfxAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RfxSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "rfx" */
export type RfxAggregateFields = {
  __typename?: 'rfx_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RfxMaxFields>;
  min: Maybe<RfxMinFields>;
};


/** aggregate fields of "rfx" */
export type RfxAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RfxSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "rfx" */
export type RfxAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RfxMaxOrderBy>;
  min?: InputMaybe<RfxMinOrderBy>;
};

/** Tracks AI scoring progress and status for RFx submissions */
export type RfxAiScoring = {
  __typename?: 'rfx_ai_scoring';
  completed_at: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  rfx: Rfx;
  rfx_id: Scalars['uuid']['output'];
  status: RfxAiScoringStatusEnum;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "rfx_ai_scoring" */
export type RfxAiScoringAggregate = {
  __typename?: 'rfx_ai_scoring_aggregate';
  aggregate: Maybe<RfxAiScoringAggregateFields>;
  nodes: Array<RfxAiScoring>;
};

/** aggregate fields of "rfx_ai_scoring" */
export type RfxAiScoringAggregateFields = {
  __typename?: 'rfx_ai_scoring_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RfxAiScoringMaxFields>;
  min: Maybe<RfxAiScoringMinFields>;
};


/** aggregate fields of "rfx_ai_scoring" */
export type RfxAiScoringAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RfxAiScoringSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "rfx_ai_scoring". All fields are combined with a logical 'AND'. */
export type RfxAiScoringBoolExp = {
  _and?: InputMaybe<Array<RfxAiScoringBoolExp>>;
  _not?: InputMaybe<RfxAiScoringBoolExp>;
  _or?: InputMaybe<Array<RfxAiScoringBoolExp>>;
  completed_at?: InputMaybe<TimestamptzComparisonExp>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  rfx?: InputMaybe<RfxBoolExp>;
  rfx_id?: InputMaybe<UuidComparisonExp>;
  status?: InputMaybe<RfxAiScoringStatusEnumComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "rfx_ai_scoring" */
export enum RfxAiScoringConstraint {
  /** unique or primary key constraint on columns "id" */
  RFX_AI_SCORING_PKEY = 'rfx_ai_scoring_pkey'
}

/** input type for inserting data into table "rfx_ai_scoring" */
export type RfxAiScoringInsertInput = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rfx?: InputMaybe<RfxObjRelInsertInput>;
  rfx_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<RfxAiScoringStatusEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type RfxAiScoringMaxFields = {
  __typename?: 'rfx_ai_scoring_max_fields';
  completed_at: Maybe<Scalars['timestamptz']['output']>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisation_id: Maybe<Scalars['uuid']['output']>;
  rfx_id: Maybe<Scalars['uuid']['output']>;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type RfxAiScoringMinFields = {
  __typename?: 'rfx_ai_scoring_min_fields';
  completed_at: Maybe<Scalars['timestamptz']['output']>;
  created_at: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisation_id: Maybe<Scalars['uuid']['output']>;
  rfx_id: Maybe<Scalars['uuid']['output']>;
  updated_at: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "rfx_ai_scoring" */
export type RfxAiScoringMutationResponse = {
  __typename?: 'rfx_ai_scoring_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RfxAiScoring>;
};

/** input type for inserting object relation for remote table "rfx_ai_scoring" */
export type RfxAiScoringObjRelInsertInput = {
  data: RfxAiScoringInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxAiScoringOnConflict>;
};

/** on_conflict condition type for table "rfx_ai_scoring" */
export type RfxAiScoringOnConflict = {
  constraint: RfxAiScoringConstraint;
  update_columns: Array<RfxAiScoringUpdateColumn>;
  where?: InputMaybe<RfxAiScoringBoolExp>;
};

/** Ordering options when selecting data from "rfx_ai_scoring". */
export type RfxAiScoringOrderBy = {
  completed_at?: InputMaybe<OrderBy>;
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  rfx?: InputMaybe<RfxOrderBy>;
  rfx_id?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: rfx_ai_scoring */
export type RfxAiScoringPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rfx_ai_scoring" */
export enum RfxAiScoringSelectColumn {
  /** column name */
  COMPLETED_AT = 'completed_at',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATION_ID = 'organisation_id',
  /** column name */
  RFX_ID = 'rfx_id',
  /** column name */
  STATUS = 'status',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "rfx_ai_scoring" */
export type RfxAiScoringSetInput = {
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  rfx_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<RfxAiScoringStatusEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export enum RfxAiScoringStatusEnum {
  /** AI scoring completed successfully */
  COMPLETE = 'COMPLETE',
  /** AI scoring failed with errors */
  FAILED = 'FAILED',
  /** AI scoring is currently in progress */
  IN_PROGRESS = 'IN_PROGRESS'
}

/** Boolean expression to compare columns of type "rfx_ai_scoring_status_enum". All fields are combined with logical 'AND'. */
export type RfxAiScoringStatusEnumComparisonExp = {
  _eq?: InputMaybe<RfxAiScoringStatusEnum>;
  _in?: InputMaybe<Array<RfxAiScoringStatusEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RfxAiScoringStatusEnum>;
  _nin?: InputMaybe<Array<RfxAiScoringStatusEnum>>;
};

/** update columns of table "rfx_ai_scoring" */
export enum RfxAiScoringUpdateColumn {
  /** column name */
  COMPLETED_AT = 'completed_at',
  /** column name */
  RFX_ID = 'rfx_id',
  /** column name */
  STATUS = 'status',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type RfxAiScoringUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RfxAiScoringSetInput>;
  /** filter the rows which have to be updated */
  where: RfxAiScoringBoolExp;
};

/** input type for inserting array relation for remote table "rfx" */
export type RfxArrRelInsertInput = {
  data: Array<RfxInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxOnConflict>;
};

/** Boolean expression to filter rows from the table "rfx". All fields are combined with a logical 'AND'. */
export type RfxBoolExp = {
  _and?: InputMaybe<Array<RfxBoolExp>>;
  _not?: InputMaybe<RfxBoolExp>;
  _or?: InputMaybe<Array<RfxBoolExp>>;
  aiScoringEnabled?: InputMaybe<BooleanComparisonExp>;
  aiScoringVisible?: InputMaybe<BooleanComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isReopened?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  owners?: InputMaybe<RfxOwnersBoolExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  requestStepId?: InputMaybe<UuidComparisonExp>;
  request_step?: InputMaybe<RequestStepsBoolExp>;
  rfx_confidentiality_agreements?: InputMaybe<RfxConfidentialityAgreementBoolExp>;
  rfx_confidentiality_agreements_aggregate?: InputMaybe<RfxConfidentialityAgreementAggregateBoolExp>;
  rfx_suppliers?: InputMaybe<RfxSuppliersBoolExp>;
  rfx_suppliers_aggregate?: InputMaybe<RfxSuppliersAggregateBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  supplierInstructions?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** Keep track of confidentiality agreement information for a given RFx */
export type RfxConfidentialityAgreement = {
  __typename?: 'rfx_confidentiality_agreement';
  confidentialityAgreement: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  rfx: Rfx;
  rfxId: Scalars['uuid']['output'];
  rfxSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  rfx_supplier: RfxSuppliers;
  signedAt: Maybe<Scalars['timestamptz']['output']>;
  signedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user: Maybe<Users>;
};

/** aggregated selection of "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementAggregate = {
  __typename?: 'rfx_confidentiality_agreement_aggregate';
  aggregate: Maybe<RfxConfidentialityAgreementAggregateFields>;
  nodes: Array<RfxConfidentialityAgreement>;
};

export type RfxConfidentialityAgreementAggregateBoolExp = {
  count?: InputMaybe<RfxConfidentialityAgreementAggregateBoolExpCount>;
};

export type RfxConfidentialityAgreementAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RfxConfidentialityAgreementSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxConfidentialityAgreementBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementAggregateFields = {
  __typename?: 'rfx_confidentiality_agreement_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RfxConfidentialityAgreementMaxFields>;
  min: Maybe<RfxConfidentialityAgreementMinFields>;
};


/** aggregate fields of "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RfxConfidentialityAgreementSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RfxConfidentialityAgreementMaxOrderBy>;
  min?: InputMaybe<RfxConfidentialityAgreementMinOrderBy>;
};

/** input type for inserting array relation for remote table "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementArrRelInsertInput = {
  data: Array<RfxConfidentialityAgreementInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxConfidentialityAgreementOnConflict>;
};

/** Boolean expression to filter rows from the table "rfx_confidentiality_agreement". All fields are combined with a logical 'AND'. */
export type RfxConfidentialityAgreementBoolExp = {
  _and?: InputMaybe<Array<RfxConfidentialityAgreementBoolExp>>;
  _not?: InputMaybe<RfxConfidentialityAgreementBoolExp>;
  _or?: InputMaybe<Array<RfxConfidentialityAgreementBoolExp>>;
  confidentialityAgreement?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  rfx?: InputMaybe<RfxBoolExp>;
  rfxId?: InputMaybe<UuidComparisonExp>;
  rfxSupplierId?: InputMaybe<UuidComparisonExp>;
  rfx_supplier?: InputMaybe<RfxSuppliersBoolExp>;
  signedAt?: InputMaybe<TimestamptzComparisonExp>;
  signedBy?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "rfx_confidentiality_agreement" */
export enum RfxConfidentialityAgreementConstraint {
  /** unique or primary key constraint on columns "id" */
  RFX_CONFIDENTIALITY_AGREEMENT_PKEY = 'rfx_confidentiality_agreement_pkey',
  /** unique or primary key constraint on columns "rfx_supplier_id", "rfx_id" */
  RFX_CONFIDENTIALITY_AGREEMENT_RFX_ID_RFX_SUPPLIER_ID_KEY = 'rfx_confidentiality_agreement_rfx_id_rfx_supplier_id_key'
}

/** input type for inserting data into table "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementInsertInput = {
  confidentialityAgreement?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rfx?: InputMaybe<RfxObjRelInsertInput>;
  rfxId?: InputMaybe<Scalars['uuid']['input']>;
  rfxSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  rfx_supplier?: InputMaybe<RfxSuppliersObjRelInsertInput>;
  signedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  signedBy?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
};

/** aggregate max on columns */
export type RfxConfidentialityAgreementMaxFields = {
  __typename?: 'rfx_confidentiality_agreement_max_fields';
  confidentialityAgreement: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  rfxId: Maybe<Scalars['uuid']['output']>;
  rfxSupplierId: Maybe<Scalars['uuid']['output']>;
  signedAt: Maybe<Scalars['timestamptz']['output']>;
  signedBy: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementMaxOrderBy = {
  confidentialityAgreement?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  rfxId?: InputMaybe<OrderBy>;
  rfxSupplierId?: InputMaybe<OrderBy>;
  signedAt?: InputMaybe<OrderBy>;
  signedBy?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RfxConfidentialityAgreementMinFields = {
  __typename?: 'rfx_confidentiality_agreement_min_fields';
  confidentialityAgreement: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  rfxId: Maybe<Scalars['uuid']['output']>;
  rfxSupplierId: Maybe<Scalars['uuid']['output']>;
  signedAt: Maybe<Scalars['timestamptz']['output']>;
  signedBy: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementMinOrderBy = {
  confidentialityAgreement?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  rfxId?: InputMaybe<OrderBy>;
  rfxSupplierId?: InputMaybe<OrderBy>;
  signedAt?: InputMaybe<OrderBy>;
  signedBy?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementMutationResponse = {
  __typename?: 'rfx_confidentiality_agreement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RfxConfidentialityAgreement>;
};

/** on_conflict condition type for table "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementOnConflict = {
  constraint: RfxConfidentialityAgreementConstraint;
  update_columns: Array<RfxConfidentialityAgreementUpdateColumn>;
  where?: InputMaybe<RfxConfidentialityAgreementBoolExp>;
};

/** Ordering options when selecting data from "rfx_confidentiality_agreement". */
export type RfxConfidentialityAgreementOrderBy = {
  confidentialityAgreement?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  rfx?: InputMaybe<RfxOrderBy>;
  rfxId?: InputMaybe<OrderBy>;
  rfxSupplierId?: InputMaybe<OrderBy>;
  rfx_supplier?: InputMaybe<RfxSuppliersOrderBy>;
  signedAt?: InputMaybe<OrderBy>;
  signedBy?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: rfx_confidentiality_agreement */
export type RfxConfidentialityAgreementPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rfx_confidentiality_agreement" */
export enum RfxConfidentialityAgreementSelectColumn {
  /** column name */
  CONFIDENTIALITYAGREEMENT = 'confidentialityAgreement',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  RFXSUPPLIERID = 'rfxSupplierId',
  /** column name */
  SIGNEDAT = 'signedAt',
  /** column name */
  SIGNEDBY = 'signedBy'
}

/** input type for updating data in table "rfx_confidentiality_agreement" */
export type RfxConfidentialityAgreementSetInput = {
  confidentialityAgreement?: InputMaybe<Scalars['String']['input']>;
  rfxId?: InputMaybe<Scalars['uuid']['input']>;
  rfxSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  signedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  signedBy?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "rfx_confidentiality_agreement" */
export enum RfxConfidentialityAgreementUpdateColumn {
  /** column name */
  CONFIDENTIALITYAGREEMENT = 'confidentialityAgreement',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  RFXSUPPLIERID = 'rfxSupplierId',
  /** column name */
  SIGNEDAT = 'signedAt',
  /** column name */
  SIGNEDBY = 'signedBy',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type RfxConfidentialityAgreementUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RfxConfidentialityAgreementSetInput>;
  /** filter the rows which have to be updated */
  where: RfxConfidentialityAgreementBoolExp;
};

/** unique or primary key constraints on table "rfx" */
export enum RfxConstraint {
  /** unique or primary key constraint on columns "id" */
  RFX_PKEY = 'rfx_pkey'
}

/** columns and relationships of "rfx_external_users" */
export type RfxExternalUsers = {
  __typename?: 'rfx_external_users';
  createdAt: Scalars['timestamptz']['output'];
  externalContactId: Scalars['uuid']['output'];
  /** An object relationship */
  external_contact: ExternalContacts;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  rfxSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  rfx_supplier: RfxSuppliers;
};

/** aggregated selection of "rfx_external_users" */
export type RfxExternalUsersAggregate = {
  __typename?: 'rfx_external_users_aggregate';
  aggregate: Maybe<RfxExternalUsersAggregateFields>;
  nodes: Array<RfxExternalUsers>;
};

export type RfxExternalUsersAggregateBoolExp = {
  count?: InputMaybe<RfxExternalUsersAggregateBoolExpCount>;
};

export type RfxExternalUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RfxExternalUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxExternalUsersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "rfx_external_users" */
export type RfxExternalUsersAggregateFields = {
  __typename?: 'rfx_external_users_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RfxExternalUsersMaxFields>;
  min: Maybe<RfxExternalUsersMinFields>;
};


/** aggregate fields of "rfx_external_users" */
export type RfxExternalUsersAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RfxExternalUsersSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "rfx_external_users" */
export type RfxExternalUsersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RfxExternalUsersMaxOrderBy>;
  min?: InputMaybe<RfxExternalUsersMinOrderBy>;
};

/** input type for inserting array relation for remote table "rfx_external_users" */
export type RfxExternalUsersArrRelInsertInput = {
  data: Array<RfxExternalUsersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxExternalUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "rfx_external_users". All fields are combined with a logical 'AND'. */
export type RfxExternalUsersBoolExp = {
  _and?: InputMaybe<Array<RfxExternalUsersBoolExp>>;
  _not?: InputMaybe<RfxExternalUsersBoolExp>;
  _or?: InputMaybe<Array<RfxExternalUsersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  externalContactId?: InputMaybe<UuidComparisonExp>;
  external_contact?: InputMaybe<ExternalContactsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  rfxSupplierId?: InputMaybe<UuidComparisonExp>;
  rfx_supplier?: InputMaybe<RfxSuppliersBoolExp>;
};

/** unique or primary key constraints on table "rfx_external_users" */
export enum RfxExternalUsersConstraint {
  /** unique or primary key constraint on columns "organisation_id", "rfx_supplier_id", "external_contact_id" */
  RFX_EXTERNAL_USERS_ORGANISATION_ID_RFX_SUPPLIER_ID_EXTERNAL_CON = 'rfx_external_users_organisation_id_rfx_supplier_id_external_con',
  /** unique or primary key constraint on columns "id" */
  RFX_EXTERNAL_USERS_PKEY = 'rfx_external_users_pkey'
}

/** input type for inserting data into table "rfx_external_users" */
export type RfxExternalUsersInsertInput = {
  externalContactId?: InputMaybe<Scalars['uuid']['input']>;
  external_contact?: InputMaybe<ExternalContactsObjRelInsertInput>;
  rfxSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  rfx_supplier?: InputMaybe<RfxSuppliersObjRelInsertInput>;
};

/** aggregate max on columns */
export type RfxExternalUsersMaxFields = {
  __typename?: 'rfx_external_users_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  externalContactId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  rfxSupplierId: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "rfx_external_users" */
export type RfxExternalUsersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  externalContactId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  rfxSupplierId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RfxExternalUsersMinFields = {
  __typename?: 'rfx_external_users_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  externalContactId: Maybe<Scalars['uuid']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  rfxSupplierId: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "rfx_external_users" */
export type RfxExternalUsersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  externalContactId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  rfxSupplierId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "rfx_external_users" */
export type RfxExternalUsersMutationResponse = {
  __typename?: 'rfx_external_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RfxExternalUsers>;
};

/** on_conflict condition type for table "rfx_external_users" */
export type RfxExternalUsersOnConflict = {
  constraint: RfxExternalUsersConstraint;
  update_columns: Array<RfxExternalUsersUpdateColumn>;
  where?: InputMaybe<RfxExternalUsersBoolExp>;
};

/** Ordering options when selecting data from "rfx_external_users". */
export type RfxExternalUsersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  externalContactId?: InputMaybe<OrderBy>;
  external_contact?: InputMaybe<ExternalContactsOrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  rfxSupplierId?: InputMaybe<OrderBy>;
  rfx_supplier?: InputMaybe<RfxSuppliersOrderBy>;
};

/** select columns of table "rfx_external_users" */
export enum RfxExternalUsersSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  EXTERNALCONTACTID = 'externalContactId',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  RFXSUPPLIERID = 'rfxSupplierId'
}

/** placeholder for update columns of table "rfx_external_users" (current role has no relevant permissions) */
export enum RfxExternalUsersUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** input type for inserting data into table "rfx" */
export type RfxInsertInput = {
  aiScoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  aiScoringVisible?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isReopened?: InputMaybe<Scalars['Boolean']['input']>;
  owners?: InputMaybe<RfxOwnersArrRelInsertInput>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  request_step?: InputMaybe<RequestStepsObjRelInsertInput>;
  rfx_confidentiality_agreements?: InputMaybe<RfxConfidentialityAgreementArrRelInsertInput>;
  rfx_suppliers?: InputMaybe<RfxSuppliersArrRelInsertInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplierInstructions?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type RfxMaxFields = {
  __typename?: 'rfx_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  requestStepId: Maybe<Scalars['uuid']['output']>;
  status: Maybe<Scalars['String']['output']>;
  supplierInstructions: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "rfx" */
export type RfxMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  supplierInstructions?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RfxMinFields = {
  __typename?: 'rfx_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  requestStepId: Maybe<Scalars['uuid']['output']>;
  status: Maybe<Scalars['String']['output']>;
  supplierInstructions: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "rfx" */
export type RfxMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  supplierInstructions?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "rfx" */
export type RfxMutationResponse = {
  __typename?: 'rfx_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rfx>;
};

/** input type for inserting object relation for remote table "rfx" */
export type RfxObjRelInsertInput = {
  data: RfxInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxOnConflict>;
};

/** on_conflict condition type for table "rfx" */
export type RfxOnConflict = {
  constraint: RfxConstraint;
  update_columns: Array<RfxUpdateColumn>;
  where?: InputMaybe<RfxBoolExp>;
};

/** Ordering options when selecting data from "rfx". */
export type RfxOrderBy = {
  aiScoringEnabled?: InputMaybe<OrderBy>;
  aiScoringVisible?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isReopened?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  owners_aggregate?: InputMaybe<RfxOwnersAggregateOrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestId?: InputMaybe<OrderBy>;
  requestStepId?: InputMaybe<OrderBy>;
  request_step?: InputMaybe<RequestStepsOrderBy>;
  rfx_confidentiality_agreements_aggregate?: InputMaybe<RfxConfidentialityAgreementAggregateOrderBy>;
  rfx_suppliers_aggregate?: InputMaybe<RfxSuppliersAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  supplierInstructions?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** Keeps track of users assigned as owners for a given RFx */
export type RfxOwners = {
  __typename?: 'rfx_owners';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  rfxId: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "rfx_owners" */
export type RfxOwnersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RfxOwnersMaxOrderBy>;
  min?: InputMaybe<RfxOwnersMinOrderBy>;
};

/** input type for inserting array relation for remote table "rfx_owners" */
export type RfxOwnersArrRelInsertInput = {
  data: Array<RfxOwnersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxOwnersOnConflict>;
};

/** Boolean expression to filter rows from the table "rfx_owners". All fields are combined with a logical 'AND'. */
export type RfxOwnersBoolExp = {
  _and?: InputMaybe<Array<RfxOwnersBoolExp>>;
  _not?: InputMaybe<RfxOwnersBoolExp>;
  _or?: InputMaybe<Array<RfxOwnersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  rfxId?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "rfx_owners" */
export enum RfxOwnersConstraint {
  /** unique or primary key constraint on columns "id" */
  RFX_OWNERS_PKEY = 'rfx_owners_pkey',
  /** unique or primary key constraint on columns "user_id", "rfx_id" */
  RFX_OWNERS_RFX_ID_USER_ID_KEY = 'rfx_owners_rfx_id_user_id_key'
}

/** input type for inserting data into table "rfx_owners" */
export type RfxOwnersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rfxId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "rfx_owners" */
export type RfxOwnersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  rfxId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "rfx_owners" */
export type RfxOwnersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  rfxId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "rfx_owners" */
export type RfxOwnersMutationResponse = {
  __typename?: 'rfx_owners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RfxOwners>;
};

/** on_conflict condition type for table "rfx_owners" */
export type RfxOwnersOnConflict = {
  constraint: RfxOwnersConstraint;
  update_columns: Array<RfxOwnersUpdateColumn>;
  where?: InputMaybe<RfxOwnersBoolExp>;
};

/** Ordering options when selecting data from "rfx_owners". */
export type RfxOwnersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  rfxId?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: rfx_owners */
export type RfxOwnersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rfx_owners" */
export enum RfxOwnersSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "rfx_owners" */
export type RfxOwnersSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  rfxId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "rfx_owners" */
export enum RfxOwnersUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  USERID = 'userId'
}

export type RfxOwnersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RfxOwnersSetInput>;
  /** filter the rows which have to be updated */
  where: RfxOwnersBoolExp;
};

/** primary key columns input for table: rfx */
export type RfxPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** Weightings for RFx request form templates */
export type RfxRequestFormTemplateWeighting = {
  __typename?: 'rfx_request_form_template_weighting';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  requestFormTemplateId: Scalars['uuid']['output'];
  rfxId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  weighting: Scalars['numeric']['output'];
};

/** Boolean expression to filter rows from the table "rfx_request_form_template_weighting". All fields are combined with a logical 'AND'. */
export type RfxRequestFormTemplateWeightingBoolExp = {
  _and?: InputMaybe<Array<RfxRequestFormTemplateWeightingBoolExp>>;
  _not?: InputMaybe<RfxRequestFormTemplateWeightingBoolExp>;
  _or?: InputMaybe<Array<RfxRequestFormTemplateWeightingBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestFormTemplateId?: InputMaybe<UuidComparisonExp>;
  rfxId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  weighting?: InputMaybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "rfx_request_form_template_weighting" */
export enum RfxRequestFormTemplateWeightingConstraint {
  /** unique or primary key constraint on columns "request_form_template_id" */
  RFX_REQUEST_FORM_TEMPLATE_WEIGHTIN_REQUEST_FORM_TEMPLATE_ID_KEY = 'rfx_request_form_template_weightin_request_form_template_id_key',
  /** unique or primary key constraint on columns "id" */
  RFX_REQUEST_FORM_TEMPLATE_WEIGHTING_PKEY = 'rfx_request_form_template_weighting_pkey'
}

/** input type for incrementing numeric columns in table "rfx_request_form_template_weighting" */
export type RfxRequestFormTemplateWeightingIncInput = {
  weighting?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "rfx_request_form_template_weighting" */
export type RfxRequestFormTemplateWeightingInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  requestFormTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  rfxId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  weighting?: InputMaybe<Scalars['numeric']['input']>;
};

/** response of any mutation on the table "rfx_request_form_template_weighting" */
export type RfxRequestFormTemplateWeightingMutationResponse = {
  __typename?: 'rfx_request_form_template_weighting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RfxRequestFormTemplateWeighting>;
};

/** on_conflict condition type for table "rfx_request_form_template_weighting" */
export type RfxRequestFormTemplateWeightingOnConflict = {
  constraint: RfxRequestFormTemplateWeightingConstraint;
  update_columns: Array<RfxRequestFormTemplateWeightingUpdateColumn>;
  where?: InputMaybe<RfxRequestFormTemplateWeightingBoolExp>;
};

/** Ordering options when selecting data from "rfx_request_form_template_weighting". */
export type RfxRequestFormTemplateWeightingOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestFormTemplateId?: InputMaybe<OrderBy>;
  rfxId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  weighting?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: rfx_request_form_template_weighting */
export type RfxRequestFormTemplateWeightingPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rfx_request_form_template_weighting" */
export enum RfxRequestFormTemplateWeightingSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTFORMTEMPLATEID = 'requestFormTemplateId',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEIGHTING = 'weighting'
}

/** input type for updating data in table "rfx_request_form_template_weighting" */
export type RfxRequestFormTemplateWeightingSetInput = {
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  weighting?: InputMaybe<Scalars['numeric']['input']>;
};

/** Streaming cursor of the table "rfx_request_form_template_weighting" */
export type RfxRequestFormTemplateWeightingStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RfxRequestFormTemplateWeightingStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RfxRequestFormTemplateWeightingStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  requestFormTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  rfxId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  weighting?: InputMaybe<Scalars['numeric']['input']>;
};

/** update columns of table "rfx_request_form_template_weighting" */
export enum RfxRequestFormTemplateWeightingUpdateColumn {
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  WEIGHTING = 'weighting'
}

export type RfxRequestFormTemplateWeightingUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RfxRequestFormTemplateWeightingIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RfxRequestFormTemplateWeightingSetInput>;
  /** filter the rows which have to be updated */
  where: RfxRequestFormTemplateWeightingBoolExp;
};

/** columns and relationships of "rfx_request_form_templates_ranks" */
export type RfxRequestFormTemplatesRanks = {
  __typename?: 'rfx_request_form_templates_ranks';
  created_at: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  rank: Scalars['Int']['output'];
  /** An object relationship */
  request_form_template: RequestFormTemplates;
  request_form_template_id: Scalars['uuid']['output'];
  /** An object relationship */
  rfx: Rfx;
  rfx_id: Scalars['uuid']['output'];
  updated_at: Maybe<Scalars['timestamptz']['output']>;
};

/** Boolean expression to filter rows from the table "rfx_request_form_templates_ranks". All fields are combined with a logical 'AND'. */
export type RfxRequestFormTemplatesRanksBoolExp = {
  _and?: InputMaybe<Array<RfxRequestFormTemplatesRanksBoolExp>>;
  _not?: InputMaybe<RfxRequestFormTemplatesRanksBoolExp>;
  _or?: InputMaybe<Array<RfxRequestFormTemplatesRanksBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  rank?: InputMaybe<IntComparisonExp>;
  request_form_template?: InputMaybe<RequestFormTemplatesBoolExp>;
  request_form_template_id?: InputMaybe<UuidComparisonExp>;
  rfx?: InputMaybe<RfxBoolExp>;
  rfx_id?: InputMaybe<UuidComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "rfx_request_form_templates_ranks" */
export enum RfxRequestFormTemplatesRanksConstraint {
  /** unique or primary key constraint on columns "id" */
  RFX_REQUEST_FORM_TEMPLATES_RANKS_PKEY = 'rfx_request_form_templates_ranks_pkey',
  /** unique or primary key constraint on columns "rfx_id", "request_form_template_id" */
  UNIQUE_RFX_REQUEST_FORM_TEMPLATE_RANK = 'unique_rfx_request_form_template_rank'
}

/** input type for incrementing numeric columns in table "rfx_request_form_templates_ranks" */
export type RfxRequestFormTemplatesRanksIncInput = {
  rank?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "rfx_request_form_templates_ranks" */
export type RfxRequestFormTemplatesRanksInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  request_form_template?: InputMaybe<RequestFormTemplatesObjRelInsertInput>;
  request_form_template_id?: InputMaybe<Scalars['uuid']['input']>;
  rfx?: InputMaybe<RfxObjRelInsertInput>;
  rfx_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "rfx_request_form_templates_ranks" */
export type RfxRequestFormTemplatesRanksMutationResponse = {
  __typename?: 'rfx_request_form_templates_ranks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RfxRequestFormTemplatesRanks>;
};

/** input type for inserting object relation for remote table "rfx_request_form_templates_ranks" */
export type RfxRequestFormTemplatesRanksObjRelInsertInput = {
  data: RfxRequestFormTemplatesRanksInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxRequestFormTemplatesRanksOnConflict>;
};

/** on_conflict condition type for table "rfx_request_form_templates_ranks" */
export type RfxRequestFormTemplatesRanksOnConflict = {
  constraint: RfxRequestFormTemplatesRanksConstraint;
  update_columns: Array<RfxRequestFormTemplatesRanksUpdateColumn>;
  where?: InputMaybe<RfxRequestFormTemplatesRanksBoolExp>;
};

/** Ordering options when selecting data from "rfx_request_form_templates_ranks". */
export type RfxRequestFormTemplatesRanksOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  rank?: InputMaybe<OrderBy>;
  request_form_template?: InputMaybe<RequestFormTemplatesOrderBy>;
  request_form_template_id?: InputMaybe<OrderBy>;
  rfx?: InputMaybe<RfxOrderBy>;
  rfx_id?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: rfx_request_form_templates_ranks */
export type RfxRequestFormTemplatesRanksPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rfx_request_form_templates_ranks" */
export enum RfxRequestFormTemplatesRanksSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  RANK = 'rank',
  /** column name */
  REQUEST_FORM_TEMPLATE_ID = 'request_form_template_id',
  /** column name */
  RFX_ID = 'rfx_id',
  /** column name */
  UPDATED_AT = 'updated_at'
}

/** input type for updating data in table "rfx_request_form_templates_ranks" */
export type RfxRequestFormTemplatesRanksSetInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  request_form_template_id?: InputMaybe<Scalars['uuid']['input']>;
  rfx_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "rfx_request_form_templates_ranks" */
export type RfxRequestFormTemplatesRanksStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RfxRequestFormTemplatesRanksStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RfxRequestFormTemplatesRanksStreamCursorValueInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  request_form_template_id?: InputMaybe<Scalars['uuid']['input']>;
  rfx_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "rfx_request_form_templates_ranks" */
export enum RfxRequestFormTemplatesRanksUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  RANK = 'rank',
  /** column name */
  REQUEST_FORM_TEMPLATE_ID = 'request_form_template_id',
  /** column name */
  RFX_ID = 'rfx_id',
  /** column name */
  UPDATED_AT = 'updated_at'
}

export type RfxRequestFormTemplatesRanksUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RfxRequestFormTemplatesRanksIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RfxRequestFormTemplatesRanksSetInput>;
  /** filter the rows which have to be updated */
  where: RfxRequestFormTemplatesRanksBoolExp;
};

/** select columns of table "rfx" */
export enum RfxSelectColumn {
  /** column name */
  AISCORINGENABLED = 'aiScoringEnabled',
  /** column name */
  AISCORINGVISIBLE = 'aiScoringVisible',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISREOPENED = 'isReopened',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUPPLIERINSTRUCTIONS = 'supplierInstructions',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "rfx_aggregate_bool_exp_bool_and_arguments_columns" columns of table "rfx" */
export enum RfxSelectColumnRfxAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  AISCORINGENABLED = 'aiScoringEnabled',
  /** column name */
  AISCORINGVISIBLE = 'aiScoringVisible',
  /** column name */
  ISREOPENED = 'isReopened'
}

/** select "rfx_aggregate_bool_exp_bool_or_arguments_columns" columns of table "rfx" */
export enum RfxSelectColumnRfxAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  AISCORINGENABLED = 'aiScoringEnabled',
  /** column name */
  AISCORINGVISIBLE = 'aiScoringVisible',
  /** column name */
  ISREOPENED = 'isReopened'
}

/** input type for updating data in table "rfx" */
export type RfxSetInput = {
  aiScoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  aiScoringVisible?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isReopened?: InputMaybe<Scalars['Boolean']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  requestStepId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplierInstructions?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "rfx_suppliers" */
export type RfxSuppliers = {
  __typename?: 'rfx_suppliers';
  createdAt: Scalars['timestamptz']['output'];
  /** Indicates if this supplier has participated in the scoring phase of the RFx */
  hasParticipatedInScoring: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Scalars['uuid']['output'];
  /** An object relationship */
  organisation_products_and_service: Maybe<OrganisationProductsAndServices>;
  /** An object relationship */
  organisation_supplier: OrganisationSuppliers;
  /** An object relationship */
  rfx: Rfx;
  rfxId: Scalars['uuid']['output'];
  /** An array relationship */
  rfx_external_users: Array<RfxExternalUsers>;
  /** An aggregate relationship */
  rfx_external_users_aggregate: RfxExternalUsersAggregate;
  status: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "rfx_suppliers" */
export type RfxSuppliersRfxExternalUsersArgs = {
  distinct_on: InputMaybe<Array<RfxExternalUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxExternalUsersOrderBy>>;
  where: InputMaybe<RfxExternalUsersBoolExp>;
};


/** columns and relationships of "rfx_suppliers" */
export type RfxSuppliersRfxExternalUsersAggregateArgs = {
  distinct_on: InputMaybe<Array<RfxExternalUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxExternalUsersOrderBy>>;
  where: InputMaybe<RfxExternalUsersBoolExp>;
};

/** aggregated selection of "rfx_suppliers" */
export type RfxSuppliersAggregate = {
  __typename?: 'rfx_suppliers_aggregate';
  aggregate: Maybe<RfxSuppliersAggregateFields>;
  nodes: Array<RfxSuppliers>;
};

export type RfxSuppliersAggregateBoolExp = {
  bool_and?: InputMaybe<RfxSuppliersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<RfxSuppliersAggregateBoolExpBoolOr>;
  count?: InputMaybe<RfxSuppliersAggregateBoolExpCount>;
};

export type RfxSuppliersAggregateBoolExpBoolAnd = {
  arguments: RfxSuppliersSelectColumnRfxSuppliersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxSuppliersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RfxSuppliersAggregateBoolExpBoolOr = {
  arguments: RfxSuppliersSelectColumnRfxSuppliersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxSuppliersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type RfxSuppliersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RfxSuppliersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RfxSuppliersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "rfx_suppliers" */
export type RfxSuppliersAggregateFields = {
  __typename?: 'rfx_suppliers_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<RfxSuppliersMaxFields>;
  min: Maybe<RfxSuppliersMinFields>;
};


/** aggregate fields of "rfx_suppliers" */
export type RfxSuppliersAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<RfxSuppliersSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "rfx_suppliers" */
export type RfxSuppliersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RfxSuppliersMaxOrderBy>;
  min?: InputMaybe<RfxSuppliersMinOrderBy>;
};

/** input type for inserting array relation for remote table "rfx_suppliers" */
export type RfxSuppliersArrRelInsertInput = {
  data: Array<RfxSuppliersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxSuppliersOnConflict>;
};

/** Boolean expression to filter rows from the table "rfx_suppliers". All fields are combined with a logical 'AND'. */
export type RfxSuppliersBoolExp = {
  _and?: InputMaybe<Array<RfxSuppliersBoolExp>>;
  _not?: InputMaybe<RfxSuppliersBoolExp>;
  _or?: InputMaybe<Array<RfxSuppliersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  hasParticipatedInScoring?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationProductId?: InputMaybe<UuidComparisonExp>;
  organisationSupplierId?: InputMaybe<UuidComparisonExp>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesBoolExp>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  rfx?: InputMaybe<RfxBoolExp>;
  rfxId?: InputMaybe<UuidComparisonExp>;
  rfx_external_users?: InputMaybe<RfxExternalUsersBoolExp>;
  rfx_external_users_aggregate?: InputMaybe<RfxExternalUsersAggregateBoolExp>;
  status?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "rfx_suppliers" */
export enum RfxSuppliersConstraint {
  /** unique or primary key constraint on columns "rfx_id" */
  IDX_RFX_SUPPLIERS_UNIQUE_AWARDED = 'idx_rfx_suppliers_unique_awarded',
  /** unique or primary key constraint on columns "id" */
  RFX_SUPPLIERS_PKEY = 'rfx_suppliers_pkey'
}

/** input type for inserting data into table "rfx_suppliers" */
export type RfxSuppliersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Indicates if this supplier has participated in the scoring phase of the RFx */
  hasParticipatedInScoring?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationProductId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesObjRelInsertInput>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  rfx?: InputMaybe<RfxObjRelInsertInput>;
  rfxId?: InputMaybe<Scalars['uuid']['input']>;
  rfx_external_users?: InputMaybe<RfxExternalUsersArrRelInsertInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type RfxSuppliersMaxFields = {
  __typename?: 'rfx_suppliers_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  rfxId: Maybe<Scalars['uuid']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "rfx_suppliers" */
export type RfxSuppliersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  rfxId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RfxSuppliersMinFields = {
  __typename?: 'rfx_suppliers_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  organisationProductId: Maybe<Scalars['uuid']['output']>;
  organisationSupplierId: Maybe<Scalars['uuid']['output']>;
  rfxId: Maybe<Scalars['uuid']['output']>;
  status: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "rfx_suppliers" */
export type RfxSuppliersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  rfxId?: InputMaybe<OrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "rfx_suppliers" */
export type RfxSuppliersMutationResponse = {
  __typename?: 'rfx_suppliers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RfxSuppliers>;
};

/** input type for inserting object relation for remote table "rfx_suppliers" */
export type RfxSuppliersObjRelInsertInput = {
  data: RfxSuppliersInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RfxSuppliersOnConflict>;
};

/** on_conflict condition type for table "rfx_suppliers" */
export type RfxSuppliersOnConflict = {
  constraint: RfxSuppliersConstraint;
  update_columns: Array<RfxSuppliersUpdateColumn>;
  where?: InputMaybe<RfxSuppliersBoolExp>;
};

/** Ordering options when selecting data from "rfx_suppliers". */
export type RfxSuppliersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  hasParticipatedInScoring?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationProductId?: InputMaybe<OrderBy>;
  organisationSupplierId?: InputMaybe<OrderBy>;
  organisation_products_and_service?: InputMaybe<OrganisationProductsAndServicesOrderBy>;
  organisation_supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  rfx?: InputMaybe<RfxOrderBy>;
  rfxId?: InputMaybe<OrderBy>;
  rfx_external_users_aggregate?: InputMaybe<RfxExternalUsersAggregateOrderBy>;
  status?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: rfx_suppliers */
export type RfxSuppliersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "rfx_suppliers" */
export enum RfxSuppliersSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  HASPARTICIPATEDINSCORING = 'hasParticipatedInScoring',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  STATUS = 'status',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "rfx_suppliers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "rfx_suppliers" */
export enum RfxSuppliersSelectColumnRfxSuppliersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  HASPARTICIPATEDINSCORING = 'hasParticipatedInScoring'
}

/** select "rfx_suppliers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "rfx_suppliers" */
export enum RfxSuppliersSelectColumnRfxSuppliersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  HASPARTICIPATEDINSCORING = 'hasParticipatedInScoring'
}

/** input type for updating data in table "rfx_suppliers" */
export type RfxSuppliersSetInput = {
  /** Indicates if this supplier has participated in the scoring phase of the RFx */
  hasParticipatedInScoring?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationProductId?: InputMaybe<Scalars['uuid']['input']>;
  organisationSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  rfxId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "rfx_suppliers" */
export enum RfxSuppliersUpdateColumn {
  /** column name */
  HASPARTICIPATEDINSCORING = 'hasParticipatedInScoring',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONPRODUCTID = 'organisationProductId',
  /** column name */
  ORGANISATIONSUPPLIERID = 'organisationSupplierId',
  /** column name */
  RFXID = 'rfxId',
  /** column name */
  STATUS = 'status',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type RfxSuppliersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RfxSuppliersSetInput>;
  /** filter the rows which have to be updated */
  where: RfxSuppliersBoolExp;
};

/** update columns of table "rfx" */
export enum RfxUpdateColumn {
  /** column name */
  AISCORINGENABLED = 'aiScoringEnabled',
  /** column name */
  AISCORINGVISIBLE = 'aiScoringVisible',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  ISREOPENED = 'isReopened',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  REQUESTSTEPID = 'requestStepId',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUPPLIERINSTRUCTIONS = 'supplierInstructions',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type RfxUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RfxSetInput>;
  /** filter the rows which have to be updated */
  where: RfxBoolExp;
};

/** columns and relationships of "risk_attributes" */
export type RiskAttributes = {
  __typename?: 'risk_attributes';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  type: RiskAttributesTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "risk_attributes". All fields are combined with a logical 'AND'. */
export type RiskAttributesBoolExp = {
  _and?: InputMaybe<Array<RiskAttributesBoolExp>>;
  _not?: InputMaybe<RiskAttributesBoolExp>;
  _or?: InputMaybe<Array<RiskAttributesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<RiskAttributesTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "risk_attributes" */
export enum RiskAttributesConstraint {
  /** unique or primary key constraint on columns "type", "organisation_id", "name" */
  RISK_ATTRIBUTES_ORGANISATION_ID_TYPE_NAME_KEY = 'risk_attributes_organisation_id_type_name_key',
  /** unique or primary key constraint on columns "id" */
  RISK_ATTRIBUTES_PKEY = 'risk_attributes_pkey'
}

/** input type for inserting data into table "risk_attributes" */
export type RiskAttributesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<RiskAttributesTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "risk_attributes" */
export type RiskAttributesMutationResponse = {
  __typename?: 'risk_attributes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RiskAttributes>;
};

/** input type for inserting object relation for remote table "risk_attributes" */
export type RiskAttributesObjRelInsertInput = {
  data: RiskAttributesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RiskAttributesOnConflict>;
};

/** on_conflict condition type for table "risk_attributes" */
export type RiskAttributesOnConflict = {
  constraint: RiskAttributesConstraint;
  update_columns: Array<RiskAttributesUpdateColumn>;
  where?: InputMaybe<RiskAttributesBoolExp>;
};

/** Ordering options when selecting data from "risk_attributes". */
export type RiskAttributesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: risk_attributes */
export type RiskAttributesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_attributes" */
export enum RiskAttributesSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "risk_attributes" */
export type RiskAttributesSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** an enum list of types for risk attributes */
export type RiskAttributesType = {
  __typename?: 'risk_attributes_type';
  description: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risk_attributes_type". All fields are combined with a logical 'AND'. */
export type RiskAttributesTypeBoolExp = {
  _and?: InputMaybe<Array<RiskAttributesTypeBoolExp>>;
  _not?: InputMaybe<RiskAttributesTypeBoolExp>;
  _or?: InputMaybe<Array<RiskAttributesTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum RiskAttributesTypeEnum {
  /** Risk category, such as IT, financial, availability, geographic, etc */
  CATEGORY = 'CATEGORY',
  /** Risk stage like identification, mitigation, completed */
  STAGE = 'STAGE',
  /** Risk treatment type, like mitigation, acceptance, etc */
  TREATMENT = 'TREATMENT'
}

/** Boolean expression to compare columns of type "risk_attributes_type_enum". All fields are combined with logical 'AND'. */
export type RiskAttributesTypeEnumComparisonExp = {
  _eq?: InputMaybe<RiskAttributesTypeEnum>;
  _in?: InputMaybe<Array<RiskAttributesTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RiskAttributesTypeEnum>;
  _nin?: InputMaybe<Array<RiskAttributesTypeEnum>>;
};

/** Ordering options when selecting data from "risk_attributes_type". */
export type RiskAttributesTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "risk_attributes_type" */
export enum RiskAttributesTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** update columns of table "risk_attributes" */
export enum RiskAttributesUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type RiskAttributesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RiskAttributesSetInput>;
  /** filter the rows which have to be updated */
  where: RiskAttributesBoolExp;
};

/** Stores one-to-many mapping of risk to multiple categories */
export type RiskCategories = {
  __typename?: 'risk_categories';
  /** An object relationship */
  category: RiskAttributes;
  categoryId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  risk: Risks;
  riskId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "risk_categories" */
export type RiskCategoriesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RiskCategoriesMaxOrderBy>;
  min?: InputMaybe<RiskCategoriesMinOrderBy>;
};

/** input type for inserting array relation for remote table "risk_categories" */
export type RiskCategoriesArrRelInsertInput = {
  data: Array<RiskCategoriesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RiskCategoriesOnConflict>;
};

/** Boolean expression to filter rows from the table "risk_categories". All fields are combined with a logical 'AND'. */
export type RiskCategoriesBoolExp = {
  _and?: InputMaybe<Array<RiskCategoriesBoolExp>>;
  _not?: InputMaybe<RiskCategoriesBoolExp>;
  _or?: InputMaybe<Array<RiskCategoriesBoolExp>>;
  category?: InputMaybe<RiskAttributesBoolExp>;
  categoryId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  risk?: InputMaybe<RisksBoolExp>;
  riskId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "risk_categories" */
export enum RiskCategoriesConstraint {
  /** unique or primary key constraint on columns "id" */
  RISK_CATEGORIES_PKEY = 'risk_categories_pkey',
  /** unique or primary key constraint on columns "risk_id", "category_id" */
  RISK_CATEGORIES_RISK_ID_CATEGORY_ID_KEY = 'risk_categories_risk_id_category_id_key'
}

/** input type for inserting data into table "risk_categories" */
export type RiskCategoriesInsertInput = {
  category?: InputMaybe<RiskAttributesObjRelInsertInput>;
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  risk?: InputMaybe<RisksObjRelInsertInput>;
  riskId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "risk_categories" */
export type RiskCategoriesMaxOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  riskId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "risk_categories" */
export type RiskCategoriesMinOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  riskId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "risk_categories" */
export type RiskCategoriesMutationResponse = {
  __typename?: 'risk_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RiskCategories>;
};

/** on_conflict condition type for table "risk_categories" */
export type RiskCategoriesOnConflict = {
  constraint: RiskCategoriesConstraint;
  update_columns: Array<RiskCategoriesUpdateColumn>;
  where?: InputMaybe<RiskCategoriesBoolExp>;
};

/** Ordering options when selecting data from "risk_categories". */
export type RiskCategoriesOrderBy = {
  category?: InputMaybe<RiskAttributesOrderBy>;
  categoryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  risk?: InputMaybe<RisksOrderBy>;
  riskId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: risk_categories */
export type RiskCategoriesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_categories" */
export enum RiskCategoriesSelectColumn {
  /** column name */
  CATEGORYID = 'categoryId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  RISKID = 'riskId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "risk_categories" */
export type RiskCategoriesSetInput = {
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  riskId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "risk_categories" */
export enum RiskCategoriesUpdateColumn {
  /** column name */
  CATEGORYID = 'categoryId',
  /** column name */
  RISKID = 'riskId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type RiskCategoriesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RiskCategoriesSetInput>;
  /** filter the rows which have to be updated */
  where: RiskCategoriesBoolExp;
};

/** Keeps track of impact and probability levels and attributes for risks */
export type RiskLevels = {
  __typename?: 'risk_levels';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  score: Scalars['Int']['output'];
  type: RiskLevelsTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "risk_levels". All fields are combined with a logical 'AND'. */
export type RiskLevelsBoolExp = {
  _and?: InputMaybe<Array<RiskLevelsBoolExp>>;
  _not?: InputMaybe<RiskLevelsBoolExp>;
  _or?: InputMaybe<Array<RiskLevelsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  score?: InputMaybe<IntComparisonExp>;
  type?: InputMaybe<RiskLevelsTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "risk_levels" */
export enum RiskLevelsConstraint {
  /** unique or primary key constraint on columns "score", "type", "organisation_id" */
  RISK_LEVELS_ORGANISATION_ID_TYPE_SCORE_KEY = 'risk_levels_organisation_id_type_score_key',
  /** unique or primary key constraint on columns "id" */
  RISK_LEVELS_PKEY = 'risk_levels_pkey'
}

/** input type for incrementing numeric columns in table "risk_levels" */
export type RiskLevelsIncInput = {
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risk_levels" */
export type RiskLevelsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<RiskLevelsTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "risk_levels" */
export type RiskLevelsMutationResponse = {
  __typename?: 'risk_levels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RiskLevels>;
};

/** input type for inserting object relation for remote table "risk_levels" */
export type RiskLevelsObjRelInsertInput = {
  data: RiskLevelsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RiskLevelsOnConflict>;
};

/** on_conflict condition type for table "risk_levels" */
export type RiskLevelsOnConflict = {
  constraint: RiskLevelsConstraint;
  update_columns: Array<RiskLevelsUpdateColumn>;
  where?: InputMaybe<RiskLevelsBoolExp>;
};

/** Ordering options when selecting data from "risk_levels". */
export type RiskLevelsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  score?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: risk_levels */
export type RiskLevelsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_levels" */
export enum RiskLevelsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  SCORE = 'score',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "risk_levels" */
export type RiskLevelsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Enum to keep track of 'impact' and 'probability', the two types of risk level for inherent and residual risk */
export type RiskLevelsType = {
  __typename?: 'risk_levels_type';
  description: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risk_levels_type". All fields are combined with a logical 'AND'. */
export type RiskLevelsTypeBoolExp = {
  _and?: InputMaybe<Array<RiskLevelsTypeBoolExp>>;
  _not?: InputMaybe<RiskLevelsTypeBoolExp>;
  _or?: InputMaybe<Array<RiskLevelsTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum RiskLevelsTypeEnum {
  /** Inherent or residual risk impact, such as minor, major, critical */
  IMPACT = 'IMPACT',
  /** Name for a given numerical score in the risk matrix */
  MATRIX = 'MATRIX',
  /** Inherent or residual risk probability, e.g. zero, low, medium, high */
  PROBABILITY = 'PROBABILITY'
}

/** Boolean expression to compare columns of type "risk_levels_type_enum". All fields are combined with logical 'AND'. */
export type RiskLevelsTypeEnumComparisonExp = {
  _eq?: InputMaybe<RiskLevelsTypeEnum>;
  _in?: InputMaybe<Array<RiskLevelsTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RiskLevelsTypeEnum>;
  _nin?: InputMaybe<Array<RiskLevelsTypeEnum>>;
};

/** Ordering options when selecting data from "risk_levels_type". */
export type RiskLevelsTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "risk_levels_type" */
export enum RiskLevelsTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** update columns of table "risk_levels" */
export enum RiskLevelsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name',
  /** column name */
  SCORE = 'score',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type RiskLevelsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RiskLevelsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RiskLevelsSetInput>;
  /** filter the rows which have to be updated */
  where: RiskLevelsBoolExp;
};

/** Keeps track of scores for given combinations of risk impact and probability */
export type RiskMatrixCells = {
  __typename?: 'risk_matrix_cells';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  impactId: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  probabilityId: Scalars['uuid']['output'];
  score: Scalars['Int']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "risk_matrix_cells". All fields are combined with a logical 'AND'. */
export type RiskMatrixCellsBoolExp = {
  _and?: InputMaybe<Array<RiskMatrixCellsBoolExp>>;
  _not?: InputMaybe<RiskMatrixCellsBoolExp>;
  _or?: InputMaybe<Array<RiskMatrixCellsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  impactId?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  probabilityId?: InputMaybe<UuidComparisonExp>;
  score?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "risk_matrix_cells" */
export enum RiskMatrixCellsConstraint {
  /** unique or primary key constraint on columns "id" */
  RISK_MATRIX_CELLS_ID_KEY = 'risk_matrix_cells_id_key',
  /** unique or primary key constraint on columns "id" */
  RISK_MATRIX_CELLS_PKEY = 'risk_matrix_cells_pkey',
  /** unique or primary key constraint on columns "organisation_id", "probability_id", "impact_id" */
  RISK_MATRIX_CELLS_PROBABILITY_ID_IMPACT_ID_ORGANISATION_ID_KEY = 'risk_matrix_cells_probability_id_impact_id_organisation_id_key'
}

/** input type for incrementing numeric columns in table "risk_matrix_cells" */
export type RiskMatrixCellsIncInput = {
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risk_matrix_cells" */
export type RiskMatrixCellsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  impactId?: InputMaybe<Scalars['uuid']['input']>;
  probabilityId?: InputMaybe<Scalars['uuid']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "risk_matrix_cells" */
export type RiskMatrixCellsMutationResponse = {
  __typename?: 'risk_matrix_cells_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RiskMatrixCells>;
};

/** input type for inserting object relation for remote table "risk_matrix_cells" */
export type RiskMatrixCellsObjRelInsertInput = {
  data: RiskMatrixCellsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RiskMatrixCellsOnConflict>;
};

/** on_conflict condition type for table "risk_matrix_cells" */
export type RiskMatrixCellsOnConflict = {
  constraint: RiskMatrixCellsConstraint;
  update_columns: Array<RiskMatrixCellsUpdateColumn>;
  where?: InputMaybe<RiskMatrixCellsBoolExp>;
};

/** Ordering options when selecting data from "risk_matrix_cells". */
export type RiskMatrixCellsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  impactId?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  probabilityId?: InputMaybe<OrderBy>;
  score?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: risk_matrix_cells */
export type RiskMatrixCellsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_matrix_cells" */
export enum RiskMatrixCellsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  IMPACTID = 'impactId',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  PROBABILITYID = 'probabilityId',
  /** column name */
  SCORE = 'score',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "risk_matrix_cells" */
export type RiskMatrixCellsSetInput = {
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "risk_matrix_cells" */
export enum RiskMatrixCellsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  SCORE = 'score',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type RiskMatrixCellsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RiskMatrixCellsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RiskMatrixCellsSetInput>;
  /** filter the rows which have to be updated */
  where: RiskMatrixCellsBoolExp;
};

/** Keeps track of users assigned as risk owners for a given risk */
export type RiskOwners = {
  __typename?: 'risk_owners';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  risk: Risks;
  riskId: Scalars['uuid']['output'];
  type: RiskUsersTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "risk_owners" */
export type RiskOwnersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RiskOwnersMaxOrderBy>;
  min?: InputMaybe<RiskOwnersMinOrderBy>;
};

/** input type for inserting array relation for remote table "risk_owners" */
export type RiskOwnersArrRelInsertInput = {
  data: Array<RiskOwnersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RiskOwnersOnConflict>;
};

/** Boolean expression to filter rows from the table "risk_owners". All fields are combined with a logical 'AND'. */
export type RiskOwnersBoolExp = {
  _and?: InputMaybe<Array<RiskOwnersBoolExp>>;
  _not?: InputMaybe<RiskOwnersBoolExp>;
  _or?: InputMaybe<Array<RiskOwnersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  risk?: InputMaybe<RisksBoolExp>;
  riskId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<RiskUsersTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "risk_owners" */
export enum RiskOwnersConstraint {
  /** unique or primary key constraint on columns "id" */
  RISK_OWNERS_PKEY = 'risk_owners_pkey',
  /** unique or primary key constraint on columns "user_id", "type", "risk_id" */
  RISK_OWNERS_USER_ID_RISK_ID_TYPE_KEY = 'risk_owners_user_id_risk_id_type_key'
}

/** input type for inserting data into table "risk_owners" */
export type RiskOwnersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  risk?: InputMaybe<RisksObjRelInsertInput>;
  riskId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<RiskUsersTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "risk_owners" */
export type RiskOwnersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  riskId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "risk_owners" */
export type RiskOwnersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  riskId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "risk_owners" */
export type RiskOwnersMutationResponse = {
  __typename?: 'risk_owners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RiskOwners>;
};

/** on_conflict condition type for table "risk_owners" */
export type RiskOwnersOnConflict = {
  constraint: RiskOwnersConstraint;
  update_columns: Array<RiskOwnersUpdateColumn>;
  where?: InputMaybe<RiskOwnersBoolExp>;
};

/** Ordering options when selecting data from "risk_owners". */
export type RiskOwnersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  risk?: InputMaybe<RisksOrderBy>;
  riskId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: risk_owners */
export type RiskOwnersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_owners" */
export enum RiskOwnersSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  RISKID = 'riskId',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "risk_owners" */
export type RiskOwnersSetInput = {
  riskId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "risk_owners" */
export enum RiskOwnersUpdateColumn {
  /** column name */
  RISKID = 'riskId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

export type RiskOwnersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RiskOwnersSetInput>;
  /** filter the rows which have to be updated */
  where: RiskOwnersBoolExp;
};

/** Stores settings for TPRM */
export type RiskSettings = {
  __typename?: 'risk_settings';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  riskScoreMethodology: Maybe<Scalars['riskScoreMethodology']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "risk_settings". All fields are combined with a logical 'AND'. */
export type RiskSettingsBoolExp = {
  _and?: InputMaybe<Array<RiskSettingsBoolExp>>;
  _not?: InputMaybe<RiskSettingsBoolExp>;
  _or?: InputMaybe<Array<RiskSettingsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  riskScoreMethodology?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "risk_settings" */
export enum RiskSettingsConstraint {
  /** unique or primary key constraint on columns "organisation_id" */
  RISK_SETTINGS_ORGANISATION_ID_KEY = 'risk_settings_organisation_id_key',
  /** unique or primary key constraint on columns "id" */
  RISK_SETTINGS_PKEY = 'risk_settings_pkey'
}

/** input type for inserting data into table "risk_settings" */
export type RiskSettingsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  riskScoreMethodology?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "risk_settings" */
export type RiskSettingsMutationResponse = {
  __typename?: 'risk_settings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RiskSettings>;
};

/** on_conflict condition type for table "risk_settings" */
export type RiskSettingsOnConflict = {
  constraint: RiskSettingsConstraint;
  update_columns: Array<RiskSettingsUpdateColumn>;
  where?: InputMaybe<RiskSettingsBoolExp>;
};

/** Ordering options when selecting data from "risk_settings". */
export type RiskSettingsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  riskScoreMethodology?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: risk_settings */
export type RiskSettingsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_settings" */
export enum RiskSettingsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  RISKSCOREMETHODOLOGY = 'riskScoreMethodology',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "risk_settings" */
export type RiskSettingsSetInput = {
  riskScoreMethodology?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "risk_settings" */
export type RiskSettingsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: RiskSettingsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RiskSettingsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  riskScoreMethodology?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "risk_settings" */
export enum RiskSettingsUpdateColumn {
  /** column name */
  RISKSCOREMETHODOLOGY = 'riskScoreMethodology',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type RiskSettingsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RiskSettingsSetInput>;
  /** filter the rows which have to be updated */
  where: RiskSettingsBoolExp;
};

/** Stores one-to-many mapping of risk templates to multiple categories */
export type RiskTemplateCategories = {
  __typename?: 'risk_template_categories';
  /** An object relationship */
  category: RiskAttributes;
  categoryId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  riskTemplate: RiskTemplates;
  riskTemplateId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "risk_template_categories" */
export type RiskTemplateCategoriesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RiskTemplateCategoriesMaxOrderBy>;
  min?: InputMaybe<RiskTemplateCategoriesMinOrderBy>;
};

/** input type for inserting array relation for remote table "risk_template_categories" */
export type RiskTemplateCategoriesArrRelInsertInput = {
  data: Array<RiskTemplateCategoriesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RiskTemplateCategoriesOnConflict>;
};

/** Boolean expression to filter rows from the table "risk_template_categories". All fields are combined with a logical 'AND'. */
export type RiskTemplateCategoriesBoolExp = {
  _and?: InputMaybe<Array<RiskTemplateCategoriesBoolExp>>;
  _not?: InputMaybe<RiskTemplateCategoriesBoolExp>;
  _or?: InputMaybe<Array<RiskTemplateCategoriesBoolExp>>;
  category?: InputMaybe<RiskAttributesBoolExp>;
  categoryId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  riskTemplate?: InputMaybe<RiskTemplatesBoolExp>;
  riskTemplateId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "risk_template_categories" */
export enum RiskTemplateCategoriesConstraint {
  /** unique or primary key constraint on columns "category_id", "risk_template_id" */
  RISK_TEMPLATE_CATEGORIES_CATEGORY_ID_RISK_TEMPLATE_ID_KEY = 'risk_template_categories_category_id_risk_template_id_key',
  /** unique or primary key constraint on columns "id" */
  RISK_TEMPLATE_CATEGORIES_PKEY = 'risk_template_categories_pkey'
}

/** input type for inserting data into table "risk_template_categories" */
export type RiskTemplateCategoriesInsertInput = {
  category?: InputMaybe<RiskAttributesObjRelInsertInput>;
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  riskTemplate?: InputMaybe<RiskTemplatesObjRelInsertInput>;
  riskTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "risk_template_categories" */
export type RiskTemplateCategoriesMaxOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  riskTemplateId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "risk_template_categories" */
export type RiskTemplateCategoriesMinOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  riskTemplateId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "risk_template_categories" */
export type RiskTemplateCategoriesMutationResponse = {
  __typename?: 'risk_template_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RiskTemplateCategories>;
};

/** on_conflict condition type for table "risk_template_categories" */
export type RiskTemplateCategoriesOnConflict = {
  constraint: RiskTemplateCategoriesConstraint;
  update_columns: Array<RiskTemplateCategoriesUpdateColumn>;
  where?: InputMaybe<RiskTemplateCategoriesBoolExp>;
};

/** Ordering options when selecting data from "risk_template_categories". */
export type RiskTemplateCategoriesOrderBy = {
  category?: InputMaybe<RiskAttributesOrderBy>;
  categoryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  riskTemplate?: InputMaybe<RiskTemplatesOrderBy>;
  riskTemplateId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: risk_template_categories */
export type RiskTemplateCategoriesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_template_categories" */
export enum RiskTemplateCategoriesSelectColumn {
  /** column name */
  CATEGORYID = 'categoryId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  RISKTEMPLATEID = 'riskTemplateId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** input type for updating data in table "risk_template_categories" */
export type RiskTemplateCategoriesSetInput = {
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  riskTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "risk_template_categories" */
export enum RiskTemplateCategoriesUpdateColumn {
  /** column name */
  CATEGORYID = 'categoryId',
  /** column name */
  RISKTEMPLATEID = 'riskTemplateId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type RiskTemplateCategoriesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RiskTemplateCategoriesSetInput>;
  /** filter the rows which have to be updated */
  where: RiskTemplateCategoriesBoolExp;
};

/** Keeps track of the users who own risk templates */
export type RiskTemplateOwners = {
  __typename?: 'risk_template_owners';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  riskTemplateId: Scalars['uuid']['output'];
  type: RiskUsersTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "risk_template_owners" */
export type RiskTemplateOwnersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RiskTemplateOwnersMaxOrderBy>;
  min?: InputMaybe<RiskTemplateOwnersMinOrderBy>;
};

/** input type for inserting array relation for remote table "risk_template_owners" */
export type RiskTemplateOwnersArrRelInsertInput = {
  data: Array<RiskTemplateOwnersInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RiskTemplateOwnersOnConflict>;
};

/** Boolean expression to filter rows from the table "risk_template_owners". All fields are combined with a logical 'AND'. */
export type RiskTemplateOwnersBoolExp = {
  _and?: InputMaybe<Array<RiskTemplateOwnersBoolExp>>;
  _not?: InputMaybe<RiskTemplateOwnersBoolExp>;
  _or?: InputMaybe<Array<RiskTemplateOwnersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  riskTemplateId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<RiskUsersTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "risk_template_owners" */
export enum RiskTemplateOwnersConstraint {
  /** unique or primary key constraint on columns "id" */
  RISK_TEMPLATE_OWNERS_PKEY = 'risk_template_owners_pkey',
  /** unique or primary key constraint on columns "user_id", "type", "risk_template_id" */
  RISK_TEMPLATE_OWNERS_RISK_TEMPLATE_ID_USER_ID_TYPE_KEY = 'risk_template_owners_risk_template_id_user_id_type_key'
}

/** input type for inserting data into table "risk_template_owners" */
export type RiskTemplateOwnersInsertInput = {
  riskTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<RiskUsersTypeEnum>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "risk_template_owners" */
export type RiskTemplateOwnersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  riskTemplateId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "risk_template_owners" */
export type RiskTemplateOwnersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  riskTemplateId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "risk_template_owners" */
export type RiskTemplateOwnersMutationResponse = {
  __typename?: 'risk_template_owners_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RiskTemplateOwners>;
};

/** on_conflict condition type for table "risk_template_owners" */
export type RiskTemplateOwnersOnConflict = {
  constraint: RiskTemplateOwnersConstraint;
  update_columns: Array<RiskTemplateOwnersUpdateColumn>;
  where?: InputMaybe<RiskTemplateOwnersBoolExp>;
};

/** Ordering options when selecting data from "risk_template_owners". */
export type RiskTemplateOwnersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  riskTemplateId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: risk_template_owners */
export type RiskTemplateOwnersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_template_owners" */
export enum RiskTemplateOwnersSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  RISKTEMPLATEID = 'riskTemplateId',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "risk_template_owners" */
export type RiskTemplateOwnersSetInput = {
  riskTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "risk_template_owners" */
export enum RiskTemplateOwnersUpdateColumn {
  /** column name */
  RISKTEMPLATEID = 'riskTemplateId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

export type RiskTemplateOwnersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RiskTemplateOwnersSetInput>;
  /** filter the rows which have to be updated */
  where: RiskTemplateOwnersBoolExp;
};

/** Keep track of risk templates for TPRM feature */
export type RiskTemplates = {
  __typename?: 'risk_templates';
  /** An array relationship */
  categories: Array<RiskTemplateCategories>;
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Scalars['uuid']['output'];
  /** An object relationship */
  createdByUser: Users;
  deadline: Maybe<Scalars['String']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  deletedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  deletedByUser: Maybe<Users>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  inherentRiskImpact: Maybe<RiskLevels>;
  inherentRiskImpactId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  inherentRiskMatrix: Maybe<RiskMatrixCells>;
  /** An object relationship */
  inherentRiskProbability: Maybe<RiskLevels>;
  inherentRiskProbabilityId: Maybe<Scalars['uuid']['output']>;
  name: Scalars['String']['output'];
  orgSupplierId: Maybe<Scalars['uuid']['output']>;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  residualRiskImpact: Maybe<RiskLevels>;
  residualRiskImpactId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  residualRiskMatrix: Maybe<RiskMatrixCells>;
  /** An object relationship */
  residualRiskProbability: Maybe<RiskLevels>;
  residualRiskProbabilityId: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  riskTemplateCategories: Array<RiskTemplateCategories>;
  /** An array relationship */
  riskTemplateOwners: Array<RiskTemplateOwners>;
  sendReminderDaysBefore: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  stage: Maybe<RiskAttributes>;
  stageId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  supplier: Maybe<OrganisationSuppliers>;
  treatment: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  treatmentAssignees: Array<RiskTemplateOwners>;
  /** An object relationship */
  treatmentType: Maybe<RiskAttributes>;
  treatmentTypeId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Scalars['uuid']['output'];
  /** An object relationship */
  updatedByUser: Users;
};


/** Keep track of risk templates for TPRM feature */
export type RiskTemplatesCategoriesArgs = {
  distinct_on: InputMaybe<Array<RiskTemplateCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskTemplateCategoriesOrderBy>>;
  where: InputMaybe<RiskTemplateCategoriesBoolExp>;
};


/** Keep track of risk templates for TPRM feature */
export type RiskTemplatesRiskTemplateCategoriesArgs = {
  distinct_on: InputMaybe<Array<RiskTemplateCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskTemplateCategoriesOrderBy>>;
  where: InputMaybe<RiskTemplateCategoriesBoolExp>;
};


/** Keep track of risk templates for TPRM feature */
export type RiskTemplatesRiskTemplateOwnersArgs = {
  distinct_on: InputMaybe<Array<RiskTemplateOwnersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskTemplateOwnersOrderBy>>;
  where: InputMaybe<RiskTemplateOwnersBoolExp>;
};


/** Keep track of risk templates for TPRM feature */
export type RiskTemplatesTreatmentAssigneesArgs = {
  distinct_on: InputMaybe<Array<RiskTemplateOwnersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskTemplateOwnersOrderBy>>;
  where: InputMaybe<RiskTemplateOwnersBoolExp>;
};

/** Boolean expression to filter rows from the table "risk_templates". All fields are combined with a logical 'AND'. */
export type RiskTemplatesBoolExp = {
  _and?: InputMaybe<Array<RiskTemplatesBoolExp>>;
  _not?: InputMaybe<RiskTemplatesBoolExp>;
  _or?: InputMaybe<Array<RiskTemplatesBoolExp>>;
  categories?: InputMaybe<RiskTemplateCategoriesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  deadline?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedBy?: InputMaybe<UuidComparisonExp>;
  deletedByUser?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  inherentRiskImpact?: InputMaybe<RiskLevelsBoolExp>;
  inherentRiskImpactId?: InputMaybe<UuidComparisonExp>;
  inherentRiskMatrix?: InputMaybe<RiskMatrixCellsBoolExp>;
  inherentRiskProbability?: InputMaybe<RiskLevelsBoolExp>;
  inherentRiskProbabilityId?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  orgSupplierId?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  residualRiskImpact?: InputMaybe<RiskLevelsBoolExp>;
  residualRiskImpactId?: InputMaybe<UuidComparisonExp>;
  residualRiskMatrix?: InputMaybe<RiskMatrixCellsBoolExp>;
  residualRiskProbability?: InputMaybe<RiskLevelsBoolExp>;
  residualRiskProbabilityId?: InputMaybe<UuidComparisonExp>;
  riskTemplateCategories?: InputMaybe<RiskTemplateCategoriesBoolExp>;
  riskTemplateOwners?: InputMaybe<RiskTemplateOwnersBoolExp>;
  sendReminderDaysBefore?: InputMaybe<IntComparisonExp>;
  stage?: InputMaybe<RiskAttributesBoolExp>;
  stageId?: InputMaybe<UuidComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  treatment?: InputMaybe<StringComparisonExp>;
  treatmentAssignees?: InputMaybe<RiskTemplateOwnersBoolExp>;
  treatmentType?: InputMaybe<RiskAttributesBoolExp>;
  treatmentTypeId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updatedByUser?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "risk_templates" */
export enum RiskTemplatesConstraint {
  /** unique or primary key constraint on columns "id" */
  RISK_TEMPLATES_PKEY = 'risk_templates_pkey'
}

/** input type for incrementing numeric columns in table "risk_templates" */
export type RiskTemplatesIncInput = {
  sendReminderDaysBefore?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risk_templates" */
export type RiskTemplatesInsertInput = {
  categories?: InputMaybe<RiskTemplateCategoriesArrRelInsertInput>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  deadline?: InputMaybe<Scalars['String']['input']>;
  deletedByUser?: InputMaybe<UsersObjRelInsertInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  inherentRiskImpact?: InputMaybe<RiskLevelsObjRelInsertInput>;
  inherentRiskImpactId?: InputMaybe<Scalars['uuid']['input']>;
  inherentRiskMatrix?: InputMaybe<RiskMatrixCellsObjRelInsertInput>;
  inherentRiskProbability?: InputMaybe<RiskLevelsObjRelInsertInput>;
  inherentRiskProbabilityId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  residualRiskImpact?: InputMaybe<RiskLevelsObjRelInsertInput>;
  residualRiskImpactId?: InputMaybe<Scalars['uuid']['input']>;
  residualRiskMatrix?: InputMaybe<RiskMatrixCellsObjRelInsertInput>;
  residualRiskProbability?: InputMaybe<RiskLevelsObjRelInsertInput>;
  residualRiskProbabilityId?: InputMaybe<Scalars['uuid']['input']>;
  riskTemplateCategories?: InputMaybe<RiskTemplateCategoriesArrRelInsertInput>;
  riskTemplateOwners?: InputMaybe<RiskTemplateOwnersArrRelInsertInput>;
  sendReminderDaysBefore?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<RiskAttributesObjRelInsertInput>;
  stageId?: InputMaybe<Scalars['uuid']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  treatment?: InputMaybe<Scalars['String']['input']>;
  treatmentAssignees?: InputMaybe<RiskTemplateOwnersArrRelInsertInput>;
  treatmentType?: InputMaybe<RiskAttributesObjRelInsertInput>;
  treatmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  updatedByUser?: InputMaybe<UsersObjRelInsertInput>;
};

/** response of any mutation on the table "risk_templates" */
export type RiskTemplatesMutationResponse = {
  __typename?: 'risk_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RiskTemplates>;
};

/** input type for inserting object relation for remote table "risk_templates" */
export type RiskTemplatesObjRelInsertInput = {
  data: RiskTemplatesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RiskTemplatesOnConflict>;
};

/** on_conflict condition type for table "risk_templates" */
export type RiskTemplatesOnConflict = {
  constraint: RiskTemplatesConstraint;
  update_columns: Array<RiskTemplatesUpdateColumn>;
  where?: InputMaybe<RiskTemplatesBoolExp>;
};

/** Ordering options when selecting data from "risk_templates". */
export type RiskTemplatesOrderBy = {
  categories_aggregate?: InputMaybe<RiskTemplateCategoriesAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  deadline?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  deletedBy?: InputMaybe<OrderBy>;
  deletedByUser?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  inherentRiskImpact?: InputMaybe<RiskLevelsOrderBy>;
  inherentRiskImpactId?: InputMaybe<OrderBy>;
  inherentRiskMatrix?: InputMaybe<RiskMatrixCellsOrderBy>;
  inherentRiskProbability?: InputMaybe<RiskLevelsOrderBy>;
  inherentRiskProbabilityId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  orgSupplierId?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  residualRiskImpact?: InputMaybe<RiskLevelsOrderBy>;
  residualRiskImpactId?: InputMaybe<OrderBy>;
  residualRiskMatrix?: InputMaybe<RiskMatrixCellsOrderBy>;
  residualRiskProbability?: InputMaybe<RiskLevelsOrderBy>;
  residualRiskProbabilityId?: InputMaybe<OrderBy>;
  riskTemplateCategories_aggregate?: InputMaybe<RiskTemplateCategoriesAggregateOrderBy>;
  riskTemplateOwners_aggregate?: InputMaybe<RiskTemplateOwnersAggregateOrderBy>;
  sendReminderDaysBefore?: InputMaybe<OrderBy>;
  stage?: InputMaybe<RiskAttributesOrderBy>;
  stageId?: InputMaybe<OrderBy>;
  supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  treatment?: InputMaybe<OrderBy>;
  treatmentAssignees_aggregate?: InputMaybe<RiskTemplateOwnersAggregateOrderBy>;
  treatmentType?: InputMaybe<RiskAttributesOrderBy>;
  treatmentTypeId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  updatedByUser?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: risk_templates */
export type RiskTemplatesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_templates" */
export enum RiskTemplatesSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  DEADLINE = 'deadline',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DELETEDBY = 'deletedBy',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  INHERENTRISKIMPACTID = 'inherentRiskImpactId',
  /** column name */
  INHERENTRISKPROBABILITYID = 'inherentRiskProbabilityId',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGSUPPLIERID = 'orgSupplierId',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  RESIDUALRISKIMPACTID = 'residualRiskImpactId',
  /** column name */
  RESIDUALRISKPROBABILITYID = 'residualRiskProbabilityId',
  /** column name */
  SENDREMINDERDAYSBEFORE = 'sendReminderDaysBefore',
  /** column name */
  STAGEID = 'stageId',
  /** column name */
  TREATMENT = 'treatment',
  /** column name */
  TREATMENTTYPEID = 'treatmentTypeId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

/** input type for updating data in table "risk_templates" */
export type RiskTemplatesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deadline?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedBy?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inherentRiskImpactId?: InputMaybe<Scalars['uuid']['input']>;
  inherentRiskProbabilityId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  residualRiskImpactId?: InputMaybe<Scalars['uuid']['input']>;
  residualRiskProbabilityId?: InputMaybe<Scalars['uuid']['input']>;
  sendReminderDaysBefore?: InputMaybe<Scalars['Int']['input']>;
  stageId?: InputMaybe<Scalars['uuid']['input']>;
  treatment?: InputMaybe<Scalars['String']['input']>;
  treatmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "risk_templates" */
export enum RiskTemplatesUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DEADLINE = 'deadline',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DELETEDBY = 'deletedBy',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  INHERENTRISKIMPACTID = 'inherentRiskImpactId',
  /** column name */
  INHERENTRISKPROBABILITYID = 'inherentRiskProbabilityId',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGSUPPLIERID = 'orgSupplierId',
  /** column name */
  RESIDUALRISKIMPACTID = 'residualRiskImpactId',
  /** column name */
  RESIDUALRISKPROBABILITYID = 'residualRiskProbabilityId',
  /** column name */
  SENDREMINDERDAYSBEFORE = 'sendReminderDaysBefore',
  /** column name */
  STAGEID = 'stageId',
  /** column name */
  TREATMENT = 'treatment',
  /** column name */
  TREATMENTTYPEID = 'treatmentTypeId',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

export type RiskTemplatesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RiskTemplatesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RiskTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: RiskTemplatesBoolExp;
};

/** Enum to keep track of the different types of users associated with a risk, i.e. risk owners, assignees, etc */
export type RiskUsersType = {
  __typename?: 'risk_users_type';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "risk_users_type". All fields are combined with a logical 'AND'. */
export type RiskUsersTypeBoolExp = {
  _and?: InputMaybe<Array<RiskUsersTypeBoolExp>>;
  _not?: InputMaybe<RiskUsersTypeBoolExp>;
  _or?: InputMaybe<Array<RiskUsersTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum RiskUsersTypeEnum {
  /** Risk owner */
  OWNER = 'OWNER',
  /** A user assigned to treat a risk */
  TREATMENT_ASSIGNEE = 'TREATMENT_ASSIGNEE'
}

/** Boolean expression to compare columns of type "risk_users_type_enum". All fields are combined with logical 'AND'. */
export type RiskUsersTypeEnumComparisonExp = {
  _eq?: InputMaybe<RiskUsersTypeEnum>;
  _in?: InputMaybe<Array<RiskUsersTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<RiskUsersTypeEnum>;
  _nin?: InputMaybe<Array<RiskUsersTypeEnum>>;
};

/** Ordering options when selecting data from "risk_users_type". */
export type RiskUsersTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "risk_users_type" */
export enum RiskUsersTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** Stores immutable snapshots every time a risk is created/updated/deleted for audit and timeline purposes */
export type RiskVersions = {
  __typename?: 'risk_versions';
  categories: Array<Scalars['uuid']['output']>;
  closedAt: Maybe<Scalars['timestamptz']['output']>;
  closedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  closedByUser: Maybe<Users>;
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Scalars['uuid']['output'];
  /** An object relationship */
  createdByUser: Users;
  customValues: Maybe<Scalars['jsonb']['output']>;
  deadline: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  deletedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  deletedByUser: Maybe<Users>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  inherentRiskImpact: RiskLevels;
  inherentRiskImpactId: Scalars['uuid']['output'];
  /** An object relationship */
  inherentRiskMatrix: Maybe<RiskMatrixCells>;
  /** An object relationship */
  inherentRiskProbability: RiskLevels;
  inherentRiskProbabilityId: Scalars['uuid']['output'];
  isOpen: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orgSupplierId: Scalars['uuid']['output'];
  organisationId: Scalars['uuid']['output'];
  questionName: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  request: Maybe<Requests>;
  /** An object relationship */
  requestForm: Maybe<RequestForms>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  residualRiskImpact: RiskLevels;
  residualRiskImpactId: Scalars['uuid']['output'];
  /** An object relationship */
  residualRiskMatrix: Maybe<RiskMatrixCells>;
  /** An object relationship */
  residualRiskProbability: RiskLevels;
  residualRiskProbabilityId: Scalars['uuid']['output'];
  /** An object relationship */
  risk: Risks;
  riskId: Scalars['uuid']['output'];
  riskOwners: Array<Scalars['uuid']['output']>;
  sendReminderDaysBefore: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  stage: RiskAttributes;
  stageId: Scalars['uuid']['output'];
  /** An object relationship */
  supplier: OrganisationSuppliers;
  treatment: Maybe<Scalars['String']['output']>;
  treatmentAssignees: Array<Scalars['uuid']['output']>;
  /** An object relationship */
  treatmentType: Maybe<RiskAttributes>;
  treatmentTypeId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Scalars['uuid']['output'];
  /** An object relationship */
  updatedByUser: Users;
};


/** Stores immutable snapshots every time a risk is created/updated/deleted for audit and timeline purposes */
export type RiskVersionsCustomValuesArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "risk_versions". All fields are combined with a logical 'AND'. */
export type RiskVersionsBoolExp = {
  _and?: InputMaybe<Array<RiskVersionsBoolExp>>;
  _not?: InputMaybe<RiskVersionsBoolExp>;
  _or?: InputMaybe<Array<RiskVersionsBoolExp>>;
  categories?: InputMaybe<UuidArrayComparisonExp>;
  closedAt?: InputMaybe<TimestamptzComparisonExp>;
  closedBy?: InputMaybe<UuidComparisonExp>;
  closedByUser?: InputMaybe<UsersBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  customValues?: InputMaybe<JsonbComparisonExp>;
  deadline?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedBy?: InputMaybe<UuidComparisonExp>;
  deletedByUser?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  inherentRiskImpact?: InputMaybe<RiskLevelsBoolExp>;
  inherentRiskImpactId?: InputMaybe<UuidComparisonExp>;
  inherentRiskMatrix?: InputMaybe<RiskMatrixCellsBoolExp>;
  inherentRiskProbability?: InputMaybe<RiskLevelsBoolExp>;
  inherentRiskProbabilityId?: InputMaybe<UuidComparisonExp>;
  isOpen?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  orgSupplierId?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  questionName?: InputMaybe<StringComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestForm?: InputMaybe<RequestFormsBoolExp>;
  requestFormId?: InputMaybe<UuidComparisonExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  residualRiskImpact?: InputMaybe<RiskLevelsBoolExp>;
  residualRiskImpactId?: InputMaybe<UuidComparisonExp>;
  residualRiskMatrix?: InputMaybe<RiskMatrixCellsBoolExp>;
  residualRiskProbability?: InputMaybe<RiskLevelsBoolExp>;
  residualRiskProbabilityId?: InputMaybe<UuidComparisonExp>;
  risk?: InputMaybe<RisksBoolExp>;
  riskId?: InputMaybe<UuidComparisonExp>;
  riskOwners?: InputMaybe<UuidArrayComparisonExp>;
  sendReminderDaysBefore?: InputMaybe<IntComparisonExp>;
  stage?: InputMaybe<RiskAttributesBoolExp>;
  stageId?: InputMaybe<UuidComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  treatment?: InputMaybe<StringComparisonExp>;
  treatmentAssignees?: InputMaybe<UuidArrayComparisonExp>;
  treatmentType?: InputMaybe<RiskAttributesBoolExp>;
  treatmentTypeId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updatedByUser?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "risk_versions" */
export enum RiskVersionsConstraint {
  /** unique or primary key constraint on columns "id" */
  RISK_VERSIONS_PKEY = 'risk_versions_pkey'
}

/** input type for inserting data into table "risk_versions" */
export type RiskVersionsInsertInput = {
  categories?: InputMaybe<Array<Scalars['uuid']['input']>>;
  closedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  closedBy?: InputMaybe<Scalars['uuid']['input']>;
  closedByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  customValues?: InputMaybe<Scalars['jsonb']['input']>;
  deadline?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedBy?: InputMaybe<Scalars['uuid']['input']>;
  deletedByUser?: InputMaybe<UsersObjRelInsertInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inherentRiskImpact?: InputMaybe<RiskLevelsObjRelInsertInput>;
  inherentRiskImpactId?: InputMaybe<Scalars['uuid']['input']>;
  inherentRiskMatrix?: InputMaybe<RiskMatrixCellsObjRelInsertInput>;
  inherentRiskProbability?: InputMaybe<RiskLevelsObjRelInsertInput>;
  inherentRiskProbabilityId?: InputMaybe<Scalars['uuid']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  questionName?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestForm?: InputMaybe<RequestFormsObjRelInsertInput>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  residualRiskImpact?: InputMaybe<RiskLevelsObjRelInsertInput>;
  residualRiskImpactId?: InputMaybe<Scalars['uuid']['input']>;
  residualRiskMatrix?: InputMaybe<RiskMatrixCellsObjRelInsertInput>;
  residualRiskProbability?: InputMaybe<RiskLevelsObjRelInsertInput>;
  residualRiskProbabilityId?: InputMaybe<Scalars['uuid']['input']>;
  risk?: InputMaybe<RisksObjRelInsertInput>;
  riskId?: InputMaybe<Scalars['uuid']['input']>;
  riskOwners?: InputMaybe<Array<Scalars['uuid']['input']>>;
  sendReminderDaysBefore?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<RiskAttributesObjRelInsertInput>;
  stageId?: InputMaybe<Scalars['uuid']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  treatment?: InputMaybe<Scalars['String']['input']>;
  treatmentAssignees?: InputMaybe<Array<Scalars['uuid']['input']>>;
  treatmentType?: InputMaybe<RiskAttributesObjRelInsertInput>;
  treatmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  updatedByUser?: InputMaybe<UsersObjRelInsertInput>;
};

/** response of any mutation on the table "risk_versions" */
export type RiskVersionsMutationResponse = {
  __typename?: 'risk_versions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RiskVersions>;
};

/** on_conflict condition type for table "risk_versions" */
export type RiskVersionsOnConflict = {
  constraint: RiskVersionsConstraint;
  update_columns: Array<RiskVersionsUpdateColumn>;
  where?: InputMaybe<RiskVersionsBoolExp>;
};

/** Ordering options when selecting data from "risk_versions". */
export type RiskVersionsOrderBy = {
  categories?: InputMaybe<OrderBy>;
  closedAt?: InputMaybe<OrderBy>;
  closedBy?: InputMaybe<OrderBy>;
  closedByUser?: InputMaybe<UsersOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  customValues?: InputMaybe<OrderBy>;
  deadline?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  deletedBy?: InputMaybe<OrderBy>;
  deletedByUser?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  inherentRiskImpact?: InputMaybe<RiskLevelsOrderBy>;
  inherentRiskImpactId?: InputMaybe<OrderBy>;
  inherentRiskMatrix?: InputMaybe<RiskMatrixCellsOrderBy>;
  inherentRiskProbability?: InputMaybe<RiskLevelsOrderBy>;
  inherentRiskProbabilityId?: InputMaybe<OrderBy>;
  isOpen?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  orgSupplierId?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  questionName?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestForm?: InputMaybe<RequestFormsOrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  residualRiskImpact?: InputMaybe<RiskLevelsOrderBy>;
  residualRiskImpactId?: InputMaybe<OrderBy>;
  residualRiskMatrix?: InputMaybe<RiskMatrixCellsOrderBy>;
  residualRiskProbability?: InputMaybe<RiskLevelsOrderBy>;
  residualRiskProbabilityId?: InputMaybe<OrderBy>;
  risk?: InputMaybe<RisksOrderBy>;
  riskId?: InputMaybe<OrderBy>;
  riskOwners?: InputMaybe<OrderBy>;
  sendReminderDaysBefore?: InputMaybe<OrderBy>;
  stage?: InputMaybe<RiskAttributesOrderBy>;
  stageId?: InputMaybe<OrderBy>;
  supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  treatment?: InputMaybe<OrderBy>;
  treatmentAssignees?: InputMaybe<OrderBy>;
  treatmentType?: InputMaybe<RiskAttributesOrderBy>;
  treatmentTypeId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  updatedByUser?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: risk_versions */
export type RiskVersionsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risk_versions" */
export enum RiskVersionsSelectColumn {
  /** column name */
  CATEGORIES = 'categories',
  /** column name */
  CLOSEDAT = 'closedAt',
  /** column name */
  CLOSEDBY = 'closedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  CUSTOMVALUES = 'customValues',
  /** column name */
  DEADLINE = 'deadline',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DELETEDBY = 'deletedBy',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  INHERENTRISKIMPACTID = 'inherentRiskImpactId',
  /** column name */
  INHERENTRISKPROBABILITYID = 'inherentRiskProbabilityId',
  /** column name */
  ISOPEN = 'isOpen',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGSUPPLIERID = 'orgSupplierId',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  QUESTIONNAME = 'questionName',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RESIDUALRISKIMPACTID = 'residualRiskImpactId',
  /** column name */
  RESIDUALRISKPROBABILITYID = 'residualRiskProbabilityId',
  /** column name */
  RISKID = 'riskId',
  /** column name */
  RISKOWNERS = 'riskOwners',
  /** column name */
  SENDREMINDERDAYSBEFORE = 'sendReminderDaysBefore',
  /** column name */
  STAGEID = 'stageId',
  /** column name */
  TREATMENT = 'treatment',
  /** column name */
  TREATMENTASSIGNEES = 'treatmentAssignees',
  /** column name */
  TREATMENTTYPEID = 'treatmentTypeId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

/** input type for updating data in table "risk_versions" */
export type RiskVersionsSetInput = {
  orgSupplierId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "risk_versions" */
export enum RiskVersionsUpdateColumn {
  /** column name */
  ORGSUPPLIERID = 'orgSupplierId'
}

export type RiskVersionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RiskVersionsSetInput>;
  /** filter the rows which have to be updated */
  where: RiskVersionsBoolExp;
};

/** Keep track of risks for TPRM feature */
export type Risks = {
  __typename?: 'risks';
  /** An array relationship */
  categories: Array<RiskCategories>;
  closedAt: Maybe<Scalars['timestamptz']['output']>;
  closedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  closedByUser: Maybe<Users>;
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Scalars['uuid']['output'];
  /** An object relationship */
  createdByUser: Users;
  deadline: Maybe<Scalars['timestamptz']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  deletedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  deletedByUser: Maybe<Users>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  inherentRiskImpact: RiskLevels;
  inherentRiskImpactId: Scalars['uuid']['output'];
  /** An object relationship */
  inherentRiskMatrix: Maybe<RiskMatrixCells>;
  /** An object relationship */
  inherentRiskProbability: RiskLevels;
  inherentRiskProbabilityId: Scalars['uuid']['output'];
  isOpen: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orgSupplierId: Maybe<Scalars['uuid']['output']>;
  organisationId: Scalars['uuid']['output'];
  questionName: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  request: Maybe<Requests>;
  /** An object relationship */
  requestForm: Maybe<RequestForms>;
  requestFormId: Maybe<Scalars['uuid']['output']>;
  requestId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  residualRiskImpact: RiskLevels;
  residualRiskImpactId: Scalars['uuid']['output'];
  /** An object relationship */
  residualRiskMatrix: Maybe<RiskMatrixCells>;
  /** An object relationship */
  residualRiskProbability: RiskLevels;
  residualRiskProbabilityId: Scalars['uuid']['output'];
  /** An array relationship */
  riskOwners: Array<RiskOwners>;
  sendReminderDaysBefore: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  stage: RiskAttributes;
  stageId: Scalars['uuid']['output'];
  /** An object relationship */
  supplier: Maybe<OrganisationSuppliers>;
  treatment: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  treatmentAssignees: Array<RiskOwners>;
  /** An object relationship */
  treatmentType: Maybe<RiskAttributes>;
  treatmentTypeId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Scalars['uuid']['output'];
  /** An object relationship */
  updatedByUser: Users;
};


/** Keep track of risks for TPRM feature */
export type RisksCategoriesArgs = {
  distinct_on: InputMaybe<Array<RiskCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskCategoriesOrderBy>>;
  where: InputMaybe<RiskCategoriesBoolExp>;
};


/** Keep track of risks for TPRM feature */
export type RisksRiskOwnersArgs = {
  distinct_on: InputMaybe<Array<RiskOwnersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskOwnersOrderBy>>;
  where: InputMaybe<RiskOwnersBoolExp>;
};


/** Keep track of risks for TPRM feature */
export type RisksTreatmentAssigneesArgs = {
  distinct_on: InputMaybe<Array<RiskOwnersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskOwnersOrderBy>>;
  where: InputMaybe<RiskOwnersBoolExp>;
};

/** order by aggregate values of table "risks" */
export type RisksAggregateOrderBy = {
  avg?: InputMaybe<RisksAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RisksMaxOrderBy>;
  min?: InputMaybe<RisksMinOrderBy>;
  stddev?: InputMaybe<RisksStddevOrderBy>;
  stddev_pop?: InputMaybe<RisksStddevPopOrderBy>;
  stddev_samp?: InputMaybe<RisksStddevSampOrderBy>;
  sum?: InputMaybe<RisksSumOrderBy>;
  var_pop?: InputMaybe<RisksVarPopOrderBy>;
  var_samp?: InputMaybe<RisksVarSampOrderBy>;
  variance?: InputMaybe<RisksVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "risks" */
export type RisksArrRelInsertInput = {
  data: Array<RisksInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<RisksOnConflict>;
};

/** order by avg() on columns of table "risks" */
export type RisksAvgOrderBy = {
  sendReminderDaysBefore?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "risks". All fields are combined with a logical 'AND'. */
export type RisksBoolExp = {
  _and?: InputMaybe<Array<RisksBoolExp>>;
  _not?: InputMaybe<RisksBoolExp>;
  _or?: InputMaybe<Array<RisksBoolExp>>;
  categories?: InputMaybe<RiskCategoriesBoolExp>;
  closedAt?: InputMaybe<TimestamptzComparisonExp>;
  closedBy?: InputMaybe<UuidComparisonExp>;
  closedByUser?: InputMaybe<UsersBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  createdByUser?: InputMaybe<UsersBoolExp>;
  deadline?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedBy?: InputMaybe<UuidComparisonExp>;
  deletedByUser?: InputMaybe<UsersBoolExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  inherentRiskImpact?: InputMaybe<RiskLevelsBoolExp>;
  inherentRiskImpactId?: InputMaybe<UuidComparisonExp>;
  inherentRiskMatrix?: InputMaybe<RiskMatrixCellsBoolExp>;
  inherentRiskProbability?: InputMaybe<RiskLevelsBoolExp>;
  inherentRiskProbabilityId?: InputMaybe<UuidComparisonExp>;
  isOpen?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  orgSupplierId?: InputMaybe<UuidComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  questionName?: InputMaybe<StringComparisonExp>;
  request?: InputMaybe<RequestsBoolExp>;
  requestForm?: InputMaybe<RequestFormsBoolExp>;
  requestFormId?: InputMaybe<UuidComparisonExp>;
  requestId?: InputMaybe<UuidComparisonExp>;
  residualRiskImpact?: InputMaybe<RiskLevelsBoolExp>;
  residualRiskImpactId?: InputMaybe<UuidComparisonExp>;
  residualRiskMatrix?: InputMaybe<RiskMatrixCellsBoolExp>;
  residualRiskProbability?: InputMaybe<RiskLevelsBoolExp>;
  residualRiskProbabilityId?: InputMaybe<UuidComparisonExp>;
  riskOwners?: InputMaybe<RiskOwnersBoolExp>;
  sendReminderDaysBefore?: InputMaybe<IntComparisonExp>;
  stage?: InputMaybe<RiskAttributesBoolExp>;
  stageId?: InputMaybe<UuidComparisonExp>;
  supplier?: InputMaybe<OrganisationSuppliersBoolExp>;
  treatment?: InputMaybe<StringComparisonExp>;
  treatmentAssignees?: InputMaybe<RiskOwnersBoolExp>;
  treatmentType?: InputMaybe<RiskAttributesBoolExp>;
  treatmentTypeId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updatedByUser?: InputMaybe<UsersBoolExp>;
};

/** unique or primary key constraints on table "risks" */
export enum RisksConstraint {
  /** unique or primary key constraint on columns "id" */
  RISKS_PKEY = 'risks_pkey'
}

/** input type for incrementing numeric columns in table "risks" */
export type RisksIncInput = {
  sendReminderDaysBefore?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "risks" */
export type RisksInsertInput = {
  categories?: InputMaybe<RiskCategoriesArrRelInsertInput>;
  closedByUser?: InputMaybe<UsersObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  createdByUser?: InputMaybe<UsersObjRelInsertInput>;
  deadline?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedByUser?: InputMaybe<UsersObjRelInsertInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inherentRiskImpact?: InputMaybe<RiskLevelsObjRelInsertInput>;
  inherentRiskImpactId?: InputMaybe<Scalars['uuid']['input']>;
  inherentRiskMatrix?: InputMaybe<RiskMatrixCellsObjRelInsertInput>;
  inherentRiskProbability?: InputMaybe<RiskLevelsObjRelInsertInput>;
  inherentRiskProbabilityId?: InputMaybe<Scalars['uuid']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  questionName?: InputMaybe<Scalars['String']['input']>;
  request?: InputMaybe<RequestsObjRelInsertInput>;
  requestForm?: InputMaybe<RequestFormsObjRelInsertInput>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  residualRiskImpact?: InputMaybe<RiskLevelsObjRelInsertInput>;
  residualRiskImpactId?: InputMaybe<Scalars['uuid']['input']>;
  residualRiskMatrix?: InputMaybe<RiskMatrixCellsObjRelInsertInput>;
  residualRiskProbability?: InputMaybe<RiskLevelsObjRelInsertInput>;
  residualRiskProbabilityId?: InputMaybe<Scalars['uuid']['input']>;
  riskOwners?: InputMaybe<RiskOwnersArrRelInsertInput>;
  sendReminderDaysBefore?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<RiskAttributesObjRelInsertInput>;
  stageId?: InputMaybe<Scalars['uuid']['input']>;
  supplier?: InputMaybe<OrganisationSuppliersObjRelInsertInput>;
  treatment?: InputMaybe<Scalars['String']['input']>;
  treatmentAssignees?: InputMaybe<RiskOwnersArrRelInsertInput>;
  treatmentType?: InputMaybe<RiskAttributesObjRelInsertInput>;
  treatmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  updatedByUser?: InputMaybe<UsersObjRelInsertInput>;
};

/** order by max() on columns of table "risks" */
export type RisksMaxOrderBy = {
  closedAt?: InputMaybe<OrderBy>;
  closedBy?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  deadline?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  deletedBy?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  inherentRiskImpactId?: InputMaybe<OrderBy>;
  inherentRiskProbabilityId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  orgSupplierId?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  questionName?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  residualRiskImpactId?: InputMaybe<OrderBy>;
  residualRiskProbabilityId?: InputMaybe<OrderBy>;
  sendReminderDaysBefore?: InputMaybe<OrderBy>;
  stageId?: InputMaybe<OrderBy>;
  treatment?: InputMaybe<OrderBy>;
  treatmentTypeId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "risks" */
export type RisksMinOrderBy = {
  closedAt?: InputMaybe<OrderBy>;
  closedBy?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  deadline?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  deletedBy?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  inherentRiskImpactId?: InputMaybe<OrderBy>;
  inherentRiskProbabilityId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  orgSupplierId?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  questionName?: InputMaybe<OrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  residualRiskImpactId?: InputMaybe<OrderBy>;
  residualRiskProbabilityId?: InputMaybe<OrderBy>;
  sendReminderDaysBefore?: InputMaybe<OrderBy>;
  stageId?: InputMaybe<OrderBy>;
  treatment?: InputMaybe<OrderBy>;
  treatmentTypeId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "risks" */
export type RisksMutationResponse = {
  __typename?: 'risks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Risks>;
};

/** input type for inserting object relation for remote table "risks" */
export type RisksObjRelInsertInput = {
  data: RisksInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<RisksOnConflict>;
};

/** on_conflict condition type for table "risks" */
export type RisksOnConflict = {
  constraint: RisksConstraint;
  update_columns: Array<RisksUpdateColumn>;
  where?: InputMaybe<RisksBoolExp>;
};

/** Ordering options when selecting data from "risks". */
export type RisksOrderBy = {
  categories_aggregate?: InputMaybe<RiskCategoriesAggregateOrderBy>;
  closedAt?: InputMaybe<OrderBy>;
  closedBy?: InputMaybe<OrderBy>;
  closedByUser?: InputMaybe<UsersOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  createdByUser?: InputMaybe<UsersOrderBy>;
  deadline?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  deletedBy?: InputMaybe<OrderBy>;
  deletedByUser?: InputMaybe<UsersOrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  inherentRiskImpact?: InputMaybe<RiskLevelsOrderBy>;
  inherentRiskImpactId?: InputMaybe<OrderBy>;
  inherentRiskMatrix?: InputMaybe<RiskMatrixCellsOrderBy>;
  inherentRiskProbability?: InputMaybe<RiskLevelsOrderBy>;
  inherentRiskProbabilityId?: InputMaybe<OrderBy>;
  isOpen?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  orgSupplierId?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  questionName?: InputMaybe<OrderBy>;
  request?: InputMaybe<RequestsOrderBy>;
  requestForm?: InputMaybe<RequestFormsOrderBy>;
  requestFormId?: InputMaybe<OrderBy>;
  requestId?: InputMaybe<OrderBy>;
  residualRiskImpact?: InputMaybe<RiskLevelsOrderBy>;
  residualRiskImpactId?: InputMaybe<OrderBy>;
  residualRiskMatrix?: InputMaybe<RiskMatrixCellsOrderBy>;
  residualRiskProbability?: InputMaybe<RiskLevelsOrderBy>;
  residualRiskProbabilityId?: InputMaybe<OrderBy>;
  riskOwners_aggregate?: InputMaybe<RiskOwnersAggregateOrderBy>;
  sendReminderDaysBefore?: InputMaybe<OrderBy>;
  stage?: InputMaybe<RiskAttributesOrderBy>;
  stageId?: InputMaybe<OrderBy>;
  supplier?: InputMaybe<OrganisationSuppliersOrderBy>;
  treatment?: InputMaybe<OrderBy>;
  treatmentAssignees_aggregate?: InputMaybe<RiskOwnersAggregateOrderBy>;
  treatmentType?: InputMaybe<RiskAttributesOrderBy>;
  treatmentTypeId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  updatedByUser?: InputMaybe<UsersOrderBy>;
};

/** primary key columns input for table: risks */
export type RisksPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "risks" */
export enum RisksSelectColumn {
  /** column name */
  CLOSEDAT = 'closedAt',
  /** column name */
  CLOSEDBY = 'closedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  DEADLINE = 'deadline',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DELETEDBY = 'deletedBy',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  INHERENTRISKIMPACTID = 'inherentRiskImpactId',
  /** column name */
  INHERENTRISKPROBABILITYID = 'inherentRiskProbabilityId',
  /** column name */
  ISOPEN = 'isOpen',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGSUPPLIERID = 'orgSupplierId',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  QUESTIONNAME = 'questionName',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RESIDUALRISKIMPACTID = 'residualRiskImpactId',
  /** column name */
  RESIDUALRISKPROBABILITYID = 'residualRiskProbabilityId',
  /** column name */
  SENDREMINDERDAYSBEFORE = 'sendReminderDaysBefore',
  /** column name */
  STAGEID = 'stageId',
  /** column name */
  TREATMENT = 'treatment',
  /** column name */
  TREATMENTTYPEID = 'treatmentTypeId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

/** input type for updating data in table "risks" */
export type RisksSetInput = {
  closedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  closedBy?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deadline?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedBy?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inherentRiskImpactId?: InputMaybe<Scalars['uuid']['input']>;
  inherentRiskProbabilityId?: InputMaybe<Scalars['uuid']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgSupplierId?: InputMaybe<Scalars['uuid']['input']>;
  questionName?: InputMaybe<Scalars['String']['input']>;
  requestFormId?: InputMaybe<Scalars['uuid']['input']>;
  requestId?: InputMaybe<Scalars['uuid']['input']>;
  residualRiskImpactId?: InputMaybe<Scalars['uuid']['input']>;
  residualRiskProbabilityId?: InputMaybe<Scalars['uuid']['input']>;
  sendReminderDaysBefore?: InputMaybe<Scalars['Int']['input']>;
  stageId?: InputMaybe<Scalars['uuid']['input']>;
  treatment?: InputMaybe<Scalars['String']['input']>;
  treatmentTypeId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by stddev() on columns of table "risks" */
export type RisksStddevOrderBy = {
  sendReminderDaysBefore?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "risks" */
export type RisksStddevPopOrderBy = {
  sendReminderDaysBefore?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "risks" */
export type RisksStddevSampOrderBy = {
  sendReminderDaysBefore?: InputMaybe<OrderBy>;
};

/** order by sum() on columns of table "risks" */
export type RisksSumOrderBy = {
  sendReminderDaysBefore?: InputMaybe<OrderBy>;
};

/** update columns of table "risks" */
export enum RisksUpdateColumn {
  /** column name */
  CLOSEDAT = 'closedAt',
  /** column name */
  CLOSEDBY = 'closedBy',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DEADLINE = 'deadline',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DELETEDBY = 'deletedBy',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  INHERENTRISKIMPACTID = 'inherentRiskImpactId',
  /** column name */
  INHERENTRISKPROBABILITYID = 'inherentRiskProbabilityId',
  /** column name */
  ISOPEN = 'isOpen',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGSUPPLIERID = 'orgSupplierId',
  /** column name */
  QUESTIONNAME = 'questionName',
  /** column name */
  REQUESTFORMID = 'requestFormId',
  /** column name */
  REQUESTID = 'requestId',
  /** column name */
  RESIDUALRISKIMPACTID = 'residualRiskImpactId',
  /** column name */
  RESIDUALRISKPROBABILITYID = 'residualRiskProbabilityId',
  /** column name */
  SENDREMINDERDAYSBEFORE = 'sendReminderDaysBefore',
  /** column name */
  STAGEID = 'stageId',
  /** column name */
  TREATMENT = 'treatment',
  /** column name */
  TREATMENTTYPEID = 'treatmentTypeId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy'
}

export type RisksUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RisksIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RisksSetInput>;
  /** filter the rows which have to be updated */
  where: RisksBoolExp;
};

/** order by var_pop() on columns of table "risks" */
export type RisksVarPopOrderBy = {
  sendReminderDaysBefore?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "risks" */
export type RisksVarSampOrderBy = {
  sendReminderDaysBefore?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "risks" */
export type RisksVarianceOrderBy = {
  sendReminderDaysBefore?: InputMaybe<OrderBy>;
};

export type SearchOrganisationProductsAndServicesArgs = {
  result_limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SearchOrganisationProductsAndServicesV2Args = {
  org_id?: InputMaybe<Scalars['uuid']['input']>;
  result_limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SearchOrganisationSuppliersArgs = {
  result_limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SearchOrganisationSuppliersV2Args = {
  org_id?: InputMaybe<Scalars['uuid']['input']>;
  result_limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SearchOrganisationSuppliersV3Args = {
  org_id?: InputMaybe<Scalars['uuid']['input']>;
  public_id?: InputMaybe<Scalars['Int']['input']>;
  result_limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SearchProductsArgs = {
  result_limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SearchSuppliersArgs = {
  result_limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionRoot = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "addresses" */
  addresses: Array<Addresses>;
  /** fetch aggregated fields from the table: "addresses" */
  addresses_aggregate: AddressesAggregate;
  /** fetch data from the table: "addresses" using primary key columns */
  addresses_by_pk: Maybe<Addresses>;
  /** fetch data from the table in a streaming manner: "addresses" */
  addresses_stream: Array<Addresses>;
  /** An array relationship */
  agreement_documents: Array<AgreementDocuments>;
  /** fetch data from the table: "agreement_documents" using primary key columns */
  agreement_documents_by_pk: Maybe<AgreementDocuments>;
  /** fetch data from the table in a streaming manner: "agreement_documents" */
  agreement_documents_stream: Array<AgreementDocuments>;
  /** fetch data from the table: "agreement_tags" */
  agreement_tags: Array<AgreementTags>;
  /** fetch data from the table: "agreement_tags" using primary key columns */
  agreement_tags_by_pk: Maybe<AgreementTags>;
  /** fetch data from the table in a streaming manner: "agreement_tags" */
  agreement_tags_stream: Array<AgreementTags>;
  /** fetch data from the table: "agreement_term_products" */
  agreement_term_products: Array<AgreementTermProducts>;
  /** fetch data from the table: "agreement_term_products" using primary key columns */
  agreement_term_products_by_pk: Maybe<AgreementTermProducts>;
  /** fetch data from the table in a streaming manner: "agreement_term_products" */
  agreement_term_products_stream: Array<AgreementTermProducts>;
  /** An array relationship */
  agreement_term_revisions: Array<AgreementTermRevisions>;
  /** fetch data from the table: "agreement_term_revisions" using primary key columns */
  agreement_term_revisions_by_pk: Maybe<AgreementTermRevisions>;
  /** fetch data from the table in a streaming manner: "agreement_term_revisions" */
  agreement_term_revisions_stream: Array<AgreementTermRevisions>;
  /** fetch data from the table: "agreement_term_spend_items" */
  agreement_term_spend_items: Array<AgreementTermSpendItems>;
  /** fetch data from the table: "agreement_term_spend_items" using primary key columns */
  agreement_term_spend_items_by_pk: Maybe<AgreementTermSpendItems>;
  /** fetch data from the table in a streaming manner: "agreement_term_spend_items" */
  agreement_term_spend_items_stream: Array<AgreementTermSpendItems>;
  /** An array relationship */
  agreement_terms: Array<AgreementTerms>;
  /** An aggregate relationship */
  agreement_terms_aggregate: AgreementTermsAggregate;
  /** fetch data from the table: "agreement_terms" using primary key columns */
  agreement_terms_by_pk: Maybe<AgreementTerms>;
  /** fetch data from the table in a streaming manner: "agreement_terms" */
  agreement_terms_stream: Array<AgreementTerms>;
  /** fetch data from the table: "auto_flagged_score_categories" */
  auto_flagged_score_categories: Array<AutoFlaggedScoreCategories>;
  /** fetch data from the table: "auto_flagged_score_categories" using primary key columns */
  auto_flagged_score_categories_by_pk: Maybe<AutoFlaggedScoreCategories>;
  /** fetch data from the table in a streaming manner: "auto_flagged_score_categories" */
  auto_flagged_score_categories_stream: Array<AutoFlaggedScoreCategories>;
  /** fetch data from the table: "bulk_documents_uploads" */
  bulk_documents_uploads: Array<BulkDocumentsUploads>;
  /** fetch data from the table: "bulk_documents_uploads" using primary key columns */
  bulk_documents_uploads_by_pk: Maybe<BulkDocumentsUploads>;
  /** fetch data from the table in a streaming manner: "bulk_documents_uploads" */
  bulk_documents_uploads_stream: Array<BulkDocumentsUploads>;
  /** fetch data from the table: "categories" */
  categories: Array<Categories>;
  /** fetch data from the table: "categories" using primary key columns */
  categories_by_pk: Maybe<Categories>;
  /** fetch data from the table in a streaming manner: "categories" */
  categories_stream: Array<Categories>;
  /** fetch data from the table: "config_translations" */
  config_translations: Array<ConfigTranslations>;
  /** fetch data from the table: "config_translations" using primary key columns */
  config_translations_by_pk: Maybe<ConfigTranslations>;
  /** fetch data from the table in a streaming manner: "config_translations" */
  config_translations_stream: Array<ConfigTranslations>;
  /** fetch data from the table: "core_data_external_references" */
  core_data_external_references: Array<CoreDataExternalReferences>;
  /** fetch aggregated fields from the table: "core_data_external_references" */
  core_data_external_references_aggregate: CoreDataExternalReferencesAggregate;
  /** fetch data from the table: "core_data_external_references" using primary key columns */
  core_data_external_references_by_pk: Maybe<CoreDataExternalReferences>;
  /** fetch data from the table: "core_data_organisation_integrations" */
  core_data_organisation_integrations: Array<CoreDataOrganisationIntegrations>;
  /** fetch data from the table: "core_data_organisation_integrations" using primary key columns */
  core_data_organisation_integrations_by_pk: Maybe<CoreDataOrganisationIntegrations>;
  /** fetch data from the table in a streaming manner: "core_data_organisation_integrations" */
  core_data_organisation_integrations_stream: Array<CoreDataOrganisationIntegrations>;
  /** fetch data from the table: "custom_reports" */
  custom_reports: Array<CustomReports>;
  /** fetch data from the table: "custom_reports" using primary key columns */
  custom_reports_by_pk: Maybe<CustomReports>;
  /** An array relationship */
  custom_reports_generations: Array<CustomReportsGenerations>;
  /** fetch data from the table: "custom_reports_generations" using primary key columns */
  custom_reports_generations_by_pk: Maybe<CustomReportsGenerations>;
  /** fetch data from the table in a streaming manner: "custom_reports_generations" */
  custom_reports_generations_stream: Array<CustomReportsGenerations>;
  /** fetch data from the table in a streaming manner: "custom_reports" */
  custom_reports_stream: Array<CustomReports>;
  /** fetch data from the table: "document_types" */
  document_types: Array<DocumentTypes>;
  /** fetch data from the table: "document_types" using primary key columns */
  document_types_by_pk: Maybe<DocumentTypes>;
  /** fetch data from the table in a streaming manner: "document_types" */
  document_types_stream: Array<DocumentTypes>;
  /** fetch data from the table: "entity_bank_details" */
  entity_bank_details: Array<EntityBankDetails>;
  /** fetch aggregated fields from the table: "entity_bank_details" */
  entity_bank_details_aggregate: EntityBankDetailsAggregate;
  /** fetch data from the table: "entity_bank_details" using primary key columns */
  entity_bank_details_by_pk: Maybe<EntityBankDetails>;
  /** fetch data from the table: "external_entity_sync_statuses" */
  external_entity_sync_statuses: Array<ExternalEntitySyncStatuses>;
  /** fetch data from the table: "external_entity_sync_statuses" using primary key columns */
  external_entity_sync_statuses_by_pk: Maybe<ExternalEntitySyncStatuses>;
  /** fetch data from the table in a streaming manner: "external_entity_sync_statuses" */
  external_entity_sync_statuses_stream: Array<ExternalEntitySyncStatuses>;
  /** fetch data from the table: "external_risk_scores" */
  external_risk_scores: Array<ExternalRiskScores>;
  /** fetch data from the table: "external_risk_scores" using primary key columns */
  external_risk_scores_by_pk: Maybe<ExternalRiskScores>;
  /** fetch data from the table in a streaming manner: "external_risk_scores" */
  external_risk_scores_stream: Array<ExternalRiskScores>;
  /** fetch data from the table: "form_template_question_insights" */
  form_template_question_insights: Array<FormTemplateQuestionInsights>;
  /** fetch aggregated fields from the table: "form_template_question_insights" */
  form_template_question_insights_aggregate: FormTemplateQuestionInsightsAggregate;
  /** fetch data from the table: "form_template_question_insights" using primary key columns */
  form_template_question_insights_by_pk: Maybe<FormTemplateQuestionInsights>;
  /** fetch data from the table in a streaming manner: "form_template_question_insights" */
  form_template_question_insights_stream: Array<FormTemplateQuestionInsights>;
  /** execute function "get_all_nodes_until_root_for_ids" which returns "custom_core_data_options" */
  get_all_nodes_until_root_for_ids: Array<CustomCoreDataOptions>;
  /** execute function "get_all_nodes_until_root_for_ids" and query aggregates on result of table type "custom_core_data_options" */
  get_all_nodes_until_root_for_ids_aggregate: CustomCoreDataOptionsAggregate;
  /** execute function "get_custom_core_data_counts" which returns "z_workaround_ccdo_count" */
  get_custom_core_data_counts: Array<ZWorkaroundCcdoCount>;
  /** execute function "get_latest_request_form_submissions" which returns "latest_request_form_submissions" */
  get_latest_request_form_submissions: Array<LatestRequestFormSubmissions>;
  /** execute function "get_latest_request_form_submissions" and query aggregates on result of table type "latest_request_form_submissions" */
  get_latest_request_form_submissions_aggregate: LatestRequestFormSubmissionsAggregate;
  /** execute function "get_latest_request_form_submissions_for_request" which returns "latest_request_form_submissions" */
  get_latest_request_form_submissions_for_request: Array<LatestRequestFormSubmissions>;
  /** execute function "get_latest_request_form_submissions_for_request" and query aggregates on result of table type "latest_request_form_submissions" */
  get_latest_request_form_submissions_for_request_aggregate: LatestRequestFormSubmissionsAggregate;
  /** fetch data from the table: "idp_attribute_mappings" */
  idp_attribute_mappings: Array<IdpAttributeMappings>;
  /** fetch data from the table: "idp_attribute_mappings" using primary key columns */
  idp_attribute_mappings_by_pk: Maybe<IdpAttributeMappings>;
  /** fetch data from the table in a streaming manner: "idp_attribute_mappings" */
  idp_attribute_mappings_stream: Array<IdpAttributeMappings>;
  /** fetch data from the table: "organisation_integration_operations" */
  organisation_integration_operations: Array<OrganisationIntegrationOperations>;
  /** fetch data from the table: "organisation_integration_operations" using primary key columns */
  organisation_integration_operations_by_pk: Maybe<OrganisationIntegrationOperations>;
  /** fetch data from the table in a streaming manner: "organisation_integration_operations" */
  organisation_integration_operations_stream: Array<OrganisationIntegrationOperations>;
  /** fetch data from the table: "organisation_integrations" */
  organisation_integrations: Array<OrganisationIntegrations>;
  /** fetch data from the table: "organisation_integrations" using primary key columns */
  organisation_integrations_by_pk: Maybe<OrganisationIntegrations>;
  /** fetch data from the table in a streaming manner: "organisation_integrations" */
  organisation_integrations_stream: Array<OrganisationIntegrations>;
  /** An array relationship */
  organisation_product_supplier_categories: Array<OrganisationProductSupplierCategories>;
  /** fetch data from the table: "organisation_product_supplier_categories" using primary key columns */
  organisation_product_supplier_categories_by_pk: Maybe<OrganisationProductSupplierCategories>;
  /** fetch data from the table in a streaming manner: "organisation_product_supplier_categories" */
  organisation_product_supplier_categories_stream: Array<OrganisationProductSupplierCategories>;
  /** An array relationship */
  organisation_products_and_services_brands: Array<OrganisationProductsAndServicesBrands>;
  /** fetch data from the table: "organisation_products_and_services_brands" using primary key columns */
  organisation_products_and_services_brands_by_pk: Maybe<OrganisationProductsAndServicesBrands>;
  /** fetch data from the table: "organisation_products_and_services_categories" */
  organisation_products_and_services_categories: Array<OrganisationProductsAndServicesCategories>;
  /** fetch data from the table: "organisation_products_and_services_categories" using primary key columns */
  organisation_products_and_services_categories_by_pk: Maybe<OrganisationProductsAndServicesCategories>;
  /** fetch data from the table in a streaming manner: "organisation_products_and_services_categories" */
  organisation_products_and_services_categories_stream: Array<OrganisationProductsAndServicesCategories>;
  /** fetch data from the table: "organisation_public_api_clients" */
  organisation_public_api_clients: Array<OrganisationPublicApiClients>;
  /** fetch data from the table: "organisation_public_api_clients" using primary key columns */
  organisation_public_api_clients_by_pk: Maybe<OrganisationPublicApiClients>;
  /** fetch data from the table in a streaming manner: "organisation_public_api_clients" */
  organisation_public_api_clients_stream: Array<OrganisationPublicApiClients>;
  /** fetch data from the table: "organisation_supplier_historic_submissions" */
  organisation_supplier_historic_submissions: Array<OrganisationSupplierHistoricSubmissions>;
  /** fetch data from the table: "organisation_supplier_historic_submissions" using primary key columns */
  organisation_supplier_historic_submissions_by_pk: Maybe<OrganisationSupplierHistoricSubmissions>;
  /** fetch data from the table in a streaming manner: "organisation_supplier_historic_submissions" */
  organisation_supplier_historic_submissions_stream: Array<OrganisationSupplierHistoricSubmissions>;
  /** An array relationship */
  organisation_suppliers_brands: Array<OrganisationSuppliersBrands>;
  /** fetch data from the table: "organisation_suppliers_brands" using primary key columns */
  organisation_suppliers_brands_by_pk: Maybe<OrganisationSuppliersBrands>;
  /** An array relationship */
  organisation_suppliers_categories: Array<OrganisationSuppliersCategories>;
  /** fetch data from the table: "organisation_suppliers_categories" using primary key columns */
  organisation_suppliers_categories_by_pk: Maybe<OrganisationSuppliersCategories>;
  /** fetch data from the table in a streaming manner: "organisation_suppliers_categories" */
  organisation_suppliers_categories_stream: Array<OrganisationSuppliersCategories>;
  /** fetch data from the table: "out_of_office_delegations" */
  out_of_office_delegations: Array<OutOfOfficeDelegations>;
  /** fetch data from the table: "out_of_office_delegations" using primary key columns */
  out_of_office_delegations_by_pk: Maybe<OutOfOfficeDelegations>;
  /** fetch data from the table in a streaming manner: "out_of_office_delegations" */
  out_of_office_delegations_stream: Array<OutOfOfficeDelegations>;
  /** execute function "paginate_custom_core_data_options" which returns "custom_core_data_options" */
  paginate_custom_core_data_options: Array<CustomCoreDataOptions>;
  /** execute function "paginate_custom_core_data_options" and query aggregates on result of table type "custom_core_data_options" */
  paginate_custom_core_data_options_aggregate: CustomCoreDataOptionsAggregate;
  /** fetch data from the table: "pause_reasons" */
  pause_reasons: Array<PauseReasons>;
  /** fetch data from the table: "pause_reasons" using primary key columns */
  pause_reasons_by_pk: Maybe<PauseReasons>;
  /** fetch data from the table in a streaming manner: "pause_reasons" */
  pause_reasons_stream: Array<PauseReasons>;
  /** An array relationship */
  product_catalogue_access_approvers: Array<ProductCatalogueAccessApprovers>;
  /** fetch data from the table: "product_catalogue_access_approvers" using primary key columns */
  product_catalogue_access_approvers_by_pk: Maybe<ProductCatalogueAccessApprovers>;
  /** fetch data from the table: "product_catalogue_entries" */
  product_catalogue_entries: Array<ProductCatalogueEntries>;
  /** fetch data from the table: "product_catalogue_entries" using primary key columns */
  product_catalogue_entries_by_pk: Maybe<ProductCatalogueEntries>;
  /** An array relationship */
  products_and_services_categories: Array<ProductsAndServicesCategories>;
  /** fetch data from the table: "products_and_services_categories" using primary key columns */
  products_and_services_categories_by_pk: Maybe<ProductsAndServicesCategories>;
  /** fetch data from the table in a streaming manner: "products_and_services_categories" */
  products_and_services_categories_stream: Array<ProductsAndServicesCategories>;
  /** fetch data from the table: "products_and_services_similarity_results" */
  products_and_services_similarity_results: Array<ProductsAndServicesSimilarityResults>;
  /** fetch data from the table: "products_and_services_similarity_results" using primary key columns */
  products_and_services_similarity_results_by_pk: Maybe<ProductsAndServicesSimilarityResults>;
  /** fetch data from the table in a streaming manner: "products_and_services_similarity_results" */
  products_and_services_similarity_results_stream: Array<ProductsAndServicesSimilarityResults>;
  /** execute function "products_and_services_unified_similarity_search_by_product_id" which returns "products_and_services_similarity_results" */
  products_and_services_unified_similarity_search_by_product_id: Array<ProductsAndServicesSimilarityResults>;
  /** execute function "products_and_services_unified_similarity_search_by_query" which returns "products_and_services_similarity_results" */
  products_and_services_unified_similarity_search_by_query: Array<ProductsAndServicesSimilarityResults>;
  /** fetch data from the table: "purchase_order_line_items" */
  purchase_order_line_items: Array<PurchaseOrderLineItems>;
  /** fetch data from the table: "purchase_order_line_items" using primary key columns */
  purchase_order_line_items_by_pk: Maybe<PurchaseOrderLineItems>;
  /** fetch data from the table in a streaming manner: "purchase_order_line_items" */
  purchase_order_line_items_stream: Array<PurchaseOrderLineItems>;
  /** fetch data from the table: "request_form_question_score" */
  request_form_question_score: Array<RequestFormQuestionScore>;
  /** fetch data from the table: "request_form_question_score" using primary key columns */
  request_form_question_score_by_pk: Maybe<RequestFormQuestionScore>;
  /** fetch data from the table in a streaming manner: "request_form_question_score" */
  request_form_question_score_stream: Array<RequestFormQuestionScore>;
  /** fetch data from the table: "request_form_submission_ai_summary" */
  request_form_submission_ai_summary: Array<RequestFormSubmissionAiSummary>;
  /** fetch data from the table: "request_form_submission_ai_summary" using primary key columns */
  request_form_submission_ai_summary_by_pk: Maybe<RequestFormSubmissionAiSummary>;
  /** fetch data from the table in a streaming manner: "request_form_submission_ai_summary" */
  request_form_submission_ai_summary_stream: Array<RequestFormSubmissionAiSummary>;
  /** fetch data from the table: "request_leads_config" */
  request_leads_config: Array<RequestLeadsConfig>;
  /** fetch data from the table: "request_leads_config" using primary key columns */
  request_leads_config_by_pk: Maybe<RequestLeadsConfig>;
  /** fetch data from the table in a streaming manner: "request_leads_config" */
  request_leads_config_stream: Array<RequestLeadsConfig>;
  /** An array relationship */
  request_pauses: Array<RequestPauses>;
  /** fetch data from the table: "request_pauses" using primary key columns */
  request_pauses_by_pk: Maybe<RequestPauses>;
  /** fetch data from the table in a streaming manner: "request_pauses" */
  request_pauses_stream: Array<RequestPauses>;
  /** fetch data from the table: "request_request_leads" */
  request_request_leads: Array<RequestRequestLeads>;
  /** fetch data from the table: "request_request_leads" using primary key columns */
  request_request_leads_by_pk: Maybe<RequestRequestLeads>;
  /** fetch data from the table in a streaming manner: "request_request_leads" */
  request_request_leads_stream: Array<RequestRequestLeads>;
  /** fetch data from the table: "request_step_notification_messages" */
  request_step_notification_messages: Array<RequestStepNotificationMessages>;
  /** fetch data from the table: "request_step_notification_messages" using primary key columns */
  request_step_notification_messages_by_pk: Maybe<RequestStepNotificationMessages>;
  /** fetch data from the table in a streaming manner: "request_step_notification_messages" */
  request_step_notification_messages_stream: Array<RequestStepNotificationMessages>;
  /** An array relationship */
  request_step_task_users: Array<RequestStepTaskUsers>;
  /** fetch data from the table: "request_step_task_users" using primary key columns */
  request_step_task_users_by_pk: Maybe<RequestStepTaskUsers>;
  /** fetch data from the table in a streaming manner: "request_step_task_users" */
  request_step_task_users_stream: Array<RequestStepTaskUsers>;
  /** fetch data from the table: "rfx_request_form_template_weighting" */
  rfx_request_form_template_weighting: Array<RfxRequestFormTemplateWeighting>;
  /** fetch data from the table: "rfx_request_form_template_weighting" using primary key columns */
  rfx_request_form_template_weighting_by_pk: Maybe<RfxRequestFormTemplateWeighting>;
  /** fetch data from the table in a streaming manner: "rfx_request_form_template_weighting" */
  rfx_request_form_template_weighting_stream: Array<RfxRequestFormTemplateWeighting>;
  /** fetch data from the table: "rfx_request_form_templates_ranks" */
  rfx_request_form_templates_ranks: Array<RfxRequestFormTemplatesRanks>;
  /** fetch data from the table: "rfx_request_form_templates_ranks" using primary key columns */
  rfx_request_form_templates_ranks_by_pk: Maybe<RfxRequestFormTemplatesRanks>;
  /** fetch data from the table in a streaming manner: "rfx_request_form_templates_ranks" */
  rfx_request_form_templates_ranks_stream: Array<RfxRequestFormTemplatesRanks>;
  /** fetch data from the table: "risk_settings" */
  risk_settings: Array<RiskSettings>;
  /** fetch data from the table: "risk_settings" using primary key columns */
  risk_settings_by_pk: Maybe<RiskSettings>;
  /** fetch data from the table in a streaming manner: "risk_settings" */
  risk_settings_stream: Array<RiskSettings>;
  /** execute function "search_organisation_products_and_services" which returns "organisation_products_and_services" */
  search_organisation_products_and_services: Array<OrganisationProductsAndServices>;
  /** execute function "search_organisation_products_and_services" and query aggregates on result of table type "organisation_products_and_services" */
  search_organisation_products_and_services_aggregate: OrganisationProductsAndServicesAggregate;
  /** execute function "search_organisation_products_and_services_v2" which returns "organisation_products_and_services" */
  search_organisation_products_and_services_v2: Array<OrganisationProductsAndServices>;
  /** execute function "search_organisation_products_and_services_v2" and query aggregates on result of table type "organisation_products_and_services" */
  search_organisation_products_and_services_v2_aggregate: OrganisationProductsAndServicesAggregate;
  /** execute function "search_organisation_suppliers" which returns "organisation_suppliers" */
  search_organisation_suppliers: Array<OrganisationSuppliers>;
  /** execute function "search_organisation_suppliers" and query aggregates on result of table type "organisation_suppliers" */
  search_organisation_suppliers_aggregate: OrganisationSuppliersAggregate;
  /** execute function "search_organisation_suppliers_v2" which returns "organisation_suppliers" */
  search_organisation_suppliers_v2: Array<OrganisationSuppliers>;
  /** execute function "search_organisation_suppliers_v2" and query aggregates on result of table type "organisation_suppliers" */
  search_organisation_suppliers_v2_aggregate: OrganisationSuppliersAggregate;
  /** execute function "search_organisation_suppliers_v3" which returns "organisation_suppliers" */
  search_organisation_suppliers_v3: Array<OrganisationSuppliers>;
  /** execute function "search_organisation_suppliers_v3" and query aggregates on result of table type "organisation_suppliers" */
  search_organisation_suppliers_v3_aggregate: OrganisationSuppliersAggregate;
  /** execute function "search_products" which returns "products_and_services" */
  search_products: Array<ProductsAndServices>;
  /** execute function "search_suppliers" which returns "suppliers" */
  search_suppliers: Array<Suppliers>;
  /** execute function "vector_search_products_and_services" which returns "vector_search_similarity_results" */
  vector_search_products_and_services: Array<VectorSearchSimilarityResults>;
  /** fetch data from the table: "vector_search_similarity_results" */
  vector_search_similarity_results: Array<VectorSearchSimilarityResults>;
  /** fetch data from the table: "vector_search_similarity_results" using primary key columns */
  vector_search_similarity_results_by_pk: Maybe<VectorSearchSimilarityResults>;
  /** fetch data from the table in a streaming manner: "vector_search_similarity_results" */
  vector_search_similarity_results_stream: Array<VectorSearchSimilarityResults>;
  /** execute function "vector_search_suppliers" which returns "vector_search_similarity_results" */
  vector_search_suppliers: Array<VectorSearchSimilarityResults>;
  /** fetch data from the table: "z_workaround_ccdo_count" */
  z_workaround_ccdo_count: Array<ZWorkaroundCcdoCount>;
  /** fetch data from the table in a streaming manner: "z_workaround_ccdo_count" */
  z_workaround_ccdo_count_stream: Array<ZWorkaroundCcdoCount>;
};


export type SubscriptionRootAddressesArgs = {
  distinct_on: InputMaybe<Array<AddressesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AddressesOrderBy>>;
  where: InputMaybe<AddressesBoolExp>;
};


export type SubscriptionRootAddressesAggregateArgs = {
  distinct_on: InputMaybe<Array<AddressesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AddressesOrderBy>>;
  where: InputMaybe<AddressesBoolExp>;
};


export type SubscriptionRootAddressesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootAddressesStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AddressesStreamCursorInput>>;
  where: InputMaybe<AddressesBoolExp>;
};


export type SubscriptionRootAgreementDocumentsArgs = {
  distinct_on: InputMaybe<Array<AgreementDocumentsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementDocumentsOrderBy>>;
  where: InputMaybe<AgreementDocumentsBoolExp>;
};


export type SubscriptionRootAgreementDocumentsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootAgreementDocumentsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AgreementDocumentsStreamCursorInput>>;
  where: InputMaybe<AgreementDocumentsBoolExp>;
};


export type SubscriptionRootAgreementTagsArgs = {
  distinct_on: InputMaybe<Array<AgreementTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTagsOrderBy>>;
  where: InputMaybe<AgreementTagsBoolExp>;
};


export type SubscriptionRootAgreementTagsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootAgreementTagsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AgreementTagsStreamCursorInput>>;
  where: InputMaybe<AgreementTagsBoolExp>;
};


export type SubscriptionRootAgreementTermProductsArgs = {
  distinct_on: InputMaybe<Array<AgreementTermProductsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermProductsOrderBy>>;
  where: InputMaybe<AgreementTermProductsBoolExp>;
};


export type SubscriptionRootAgreementTermProductsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootAgreementTermProductsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AgreementTermProductsStreamCursorInput>>;
  where: InputMaybe<AgreementTermProductsBoolExp>;
};


export type SubscriptionRootAgreementTermRevisionsArgs = {
  distinct_on: InputMaybe<Array<AgreementTermRevisionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermRevisionsOrderBy>>;
  where: InputMaybe<AgreementTermRevisionsBoolExp>;
};


export type SubscriptionRootAgreementTermRevisionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootAgreementTermRevisionsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AgreementTermRevisionsStreamCursorInput>>;
  where: InputMaybe<AgreementTermRevisionsBoolExp>;
};


export type SubscriptionRootAgreementTermSpendItemsArgs = {
  distinct_on: InputMaybe<Array<AgreementTermSpendItemsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermSpendItemsOrderBy>>;
  where: InputMaybe<AgreementTermSpendItemsBoolExp>;
};


export type SubscriptionRootAgreementTermSpendItemsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootAgreementTermSpendItemsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AgreementTermSpendItemsStreamCursorInput>>;
  where: InputMaybe<AgreementTermSpendItemsBoolExp>;
};


export type SubscriptionRootAgreementTermsArgs = {
  distinct_on: InputMaybe<Array<AgreementTermsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermsOrderBy>>;
  where: InputMaybe<AgreementTermsBoolExp>;
};


export type SubscriptionRootAgreementTermsAggregateArgs = {
  distinct_on: InputMaybe<Array<AgreementTermsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AgreementTermsOrderBy>>;
  where: InputMaybe<AgreementTermsBoolExp>;
};


export type SubscriptionRootAgreementTermsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootAgreementTermsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AgreementTermsStreamCursorInput>>;
  where: InputMaybe<AgreementTermsBoolExp>;
};


export type SubscriptionRootAutoFlaggedScoreCategoriesArgs = {
  distinct_on: InputMaybe<Array<AutoFlaggedScoreCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AutoFlaggedScoreCategoriesOrderBy>>;
  where: InputMaybe<AutoFlaggedScoreCategoriesBoolExp>;
};


export type SubscriptionRootAutoFlaggedScoreCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootAutoFlaggedScoreCategoriesStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AutoFlaggedScoreCategoriesStreamCursorInput>>;
  where: InputMaybe<AutoFlaggedScoreCategoriesBoolExp>;
};


export type SubscriptionRootBulkDocumentsUploadsArgs = {
  distinct_on: InputMaybe<Array<BulkDocumentsUploadsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<BulkDocumentsUploadsOrderBy>>;
  where: InputMaybe<BulkDocumentsUploadsBoolExp>;
};


export type SubscriptionRootBulkDocumentsUploadsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootBulkDocumentsUploadsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BulkDocumentsUploadsStreamCursorInput>>;
  where: InputMaybe<BulkDocumentsUploadsBoolExp>;
};


export type SubscriptionRootCategoriesArgs = {
  distinct_on: InputMaybe<Array<CategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CategoriesOrderBy>>;
  where: InputMaybe<CategoriesBoolExp>;
};


export type SubscriptionRootCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootCategoriesStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CategoriesStreamCursorInput>>;
  where: InputMaybe<CategoriesBoolExp>;
};


export type SubscriptionRootConfigTranslationsArgs = {
  distinct_on: InputMaybe<Array<ConfigTranslationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ConfigTranslationsOrderBy>>;
  where: InputMaybe<ConfigTranslationsBoolExp>;
};


export type SubscriptionRootConfigTranslationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootConfigTranslationsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ConfigTranslationsStreamCursorInput>>;
  where: InputMaybe<ConfigTranslationsBoolExp>;
};


export type SubscriptionRootCoreDataExternalReferencesArgs = {
  distinct_on: InputMaybe<Array<CoreDataExternalReferencesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CoreDataExternalReferencesOrderBy>>;
  where: InputMaybe<CoreDataExternalReferencesBoolExp>;
};


export type SubscriptionRootCoreDataExternalReferencesAggregateArgs = {
  distinct_on: InputMaybe<Array<CoreDataExternalReferencesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CoreDataExternalReferencesOrderBy>>;
  where: InputMaybe<CoreDataExternalReferencesBoolExp>;
};


export type SubscriptionRootCoreDataExternalReferencesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootCoreDataOrganisationIntegrationsArgs = {
  distinct_on: InputMaybe<Array<CoreDataOrganisationIntegrationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CoreDataOrganisationIntegrationsOrderBy>>;
  where: InputMaybe<CoreDataOrganisationIntegrationsBoolExp>;
};


export type SubscriptionRootCoreDataOrganisationIntegrationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootCoreDataOrganisationIntegrationsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CoreDataOrganisationIntegrationsStreamCursorInput>>;
  where: InputMaybe<CoreDataOrganisationIntegrationsBoolExp>;
};


export type SubscriptionRootCustomReportsArgs = {
  distinct_on: InputMaybe<Array<CustomReportsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomReportsOrderBy>>;
  where: InputMaybe<CustomReportsBoolExp>;
};


export type SubscriptionRootCustomReportsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootCustomReportsGenerationsArgs = {
  distinct_on: InputMaybe<Array<CustomReportsGenerationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomReportsGenerationsOrderBy>>;
  where: InputMaybe<CustomReportsGenerationsBoolExp>;
};


export type SubscriptionRootCustomReportsGenerationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootCustomReportsGenerationsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CustomReportsGenerationsStreamCursorInput>>;
  where: InputMaybe<CustomReportsGenerationsBoolExp>;
};


export type SubscriptionRootCustomReportsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CustomReportsStreamCursorInput>>;
  where: InputMaybe<CustomReportsBoolExp>;
};


export type SubscriptionRootDocumentTypesArgs = {
  distinct_on: InputMaybe<Array<DocumentTypesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<DocumentTypesOrderBy>>;
  where: InputMaybe<DocumentTypesBoolExp>;
};


export type SubscriptionRootDocumentTypesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootDocumentTypesStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DocumentTypesStreamCursorInput>>;
  where: InputMaybe<DocumentTypesBoolExp>;
};


export type SubscriptionRootEntityBankDetailsArgs = {
  distinct_on: InputMaybe<Array<EntityBankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityBankDetailsOrderBy>>;
  where: InputMaybe<EntityBankDetailsBoolExp>;
};


export type SubscriptionRootEntityBankDetailsAggregateArgs = {
  distinct_on: InputMaybe<Array<EntityBankDetailsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<EntityBankDetailsOrderBy>>;
  where: InputMaybe<EntityBankDetailsBoolExp>;
};


export type SubscriptionRootEntityBankDetailsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootExternalEntitySyncStatusesArgs = {
  distinct_on: InputMaybe<Array<ExternalEntitySyncStatusesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ExternalEntitySyncStatusesOrderBy>>;
  where: InputMaybe<ExternalEntitySyncStatusesBoolExp>;
};


export type SubscriptionRootExternalEntitySyncStatusesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootExternalEntitySyncStatusesStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ExternalEntitySyncStatusesStreamCursorInput>>;
  where: InputMaybe<ExternalEntitySyncStatusesBoolExp>;
};


export type SubscriptionRootExternalRiskScoresArgs = {
  distinct_on: InputMaybe<Array<ExternalRiskScoresSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ExternalRiskScoresOrderBy>>;
  where: InputMaybe<ExternalRiskScoresBoolExp>;
};


export type SubscriptionRootExternalRiskScoresByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootExternalRiskScoresStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ExternalRiskScoresStreamCursorInput>>;
  where: InputMaybe<ExternalRiskScoresBoolExp>;
};


export type SubscriptionRootFormTemplateQuestionInsightsArgs = {
  distinct_on: InputMaybe<Array<FormTemplateQuestionInsightsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FormTemplateQuestionInsightsOrderBy>>;
  where: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
};


export type SubscriptionRootFormTemplateQuestionInsightsAggregateArgs = {
  distinct_on: InputMaybe<Array<FormTemplateQuestionInsightsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FormTemplateQuestionInsightsOrderBy>>;
  where: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
};


export type SubscriptionRootFormTemplateQuestionInsightsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootFormTemplateQuestionInsightsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<FormTemplateQuestionInsightsStreamCursorInput>>;
  where: InputMaybe<FormTemplateQuestionInsightsBoolExp>;
};


export type SubscriptionRootGetAllNodesUntilRootForIdsArgs = {
  args: GetAllNodesUntilRootForIdsArgs;
  distinct_on: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomCoreDataOptionsOrderBy>>;
  where: InputMaybe<CustomCoreDataOptionsBoolExp>;
};


export type SubscriptionRootGetAllNodesUntilRootForIdsAggregateArgs = {
  args: GetAllNodesUntilRootForIdsArgs;
  distinct_on: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomCoreDataOptionsOrderBy>>;
  where: InputMaybe<CustomCoreDataOptionsBoolExp>;
};


export type SubscriptionRootGetCustomCoreDataCountsArgs = {
  args: GetCustomCoreDataCountsArgs;
  distinct_on: InputMaybe<Array<ZWorkaroundCcdoCountSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ZWorkaroundCcdoCountOrderBy>>;
  where: InputMaybe<ZWorkaroundCcdoCountBoolExp>;
};


export type SubscriptionRootGetLatestRequestFormSubmissionsArgs = {
  args: GetLatestRequestFormSubmissionsArgs;
  distinct_on: InputMaybe<Array<LatestRequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<LatestRequestFormSubmissionsOrderBy>>;
  where: InputMaybe<LatestRequestFormSubmissionsBoolExp>;
};


export type SubscriptionRootGetLatestRequestFormSubmissionsAggregateArgs = {
  args: GetLatestRequestFormSubmissionsArgs;
  distinct_on: InputMaybe<Array<LatestRequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<LatestRequestFormSubmissionsOrderBy>>;
  where: InputMaybe<LatestRequestFormSubmissionsBoolExp>;
};


export type SubscriptionRootGetLatestRequestFormSubmissionsForRequestArgs = {
  args: GetLatestRequestFormSubmissionsForRequestArgs;
  distinct_on: InputMaybe<Array<LatestRequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<LatestRequestFormSubmissionsOrderBy>>;
  where: InputMaybe<LatestRequestFormSubmissionsBoolExp>;
};


export type SubscriptionRootGetLatestRequestFormSubmissionsForRequestAggregateArgs = {
  args: GetLatestRequestFormSubmissionsForRequestArgs;
  distinct_on: InputMaybe<Array<LatestRequestFormSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<LatestRequestFormSubmissionsOrderBy>>;
  where: InputMaybe<LatestRequestFormSubmissionsBoolExp>;
};


export type SubscriptionRootIdpAttributeMappingsArgs = {
  distinct_on: InputMaybe<Array<IdpAttributeMappingsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<IdpAttributeMappingsOrderBy>>;
  where: InputMaybe<IdpAttributeMappingsBoolExp>;
};


export type SubscriptionRootIdpAttributeMappingsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootIdpAttributeMappingsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<IdpAttributeMappingsStreamCursorInput>>;
  where: InputMaybe<IdpAttributeMappingsBoolExp>;
};


export type SubscriptionRootOrganisationIntegrationOperationsArgs = {
  distinct_on: InputMaybe<Array<OrganisationIntegrationOperationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationIntegrationOperationsOrderBy>>;
  where: InputMaybe<OrganisationIntegrationOperationsBoolExp>;
};


export type SubscriptionRootOrganisationIntegrationOperationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootOrganisationIntegrationOperationsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrganisationIntegrationOperationsStreamCursorInput>>;
  where: InputMaybe<OrganisationIntegrationOperationsBoolExp>;
};


export type SubscriptionRootOrganisationIntegrationsArgs = {
  distinct_on: InputMaybe<Array<OrganisationIntegrationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationIntegrationsOrderBy>>;
  where: InputMaybe<OrganisationIntegrationsBoolExp>;
};


export type SubscriptionRootOrganisationIntegrationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootOrganisationIntegrationsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrganisationIntegrationsStreamCursorInput>>;
  where: InputMaybe<OrganisationIntegrationsBoolExp>;
};


export type SubscriptionRootOrganisationProductSupplierCategoriesArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductSupplierCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductSupplierCategoriesOrderBy>>;
  where: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
};


export type SubscriptionRootOrganisationProductSupplierCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootOrganisationProductSupplierCategoriesStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrganisationProductSupplierCategoriesStreamCursorInput>>;
  where: InputMaybe<OrganisationProductSupplierCategoriesBoolExp>;
};


export type SubscriptionRootOrganisationProductsAndServicesBrandsArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesBrandsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesBrandsOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBrandsBoolExp>;
};


export type SubscriptionRootOrganisationProductsAndServicesBrandsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootOrganisationProductsAndServicesCategoriesArgs = {
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesCategoriesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesCategoriesBoolExp>;
};


export type SubscriptionRootOrganisationProductsAndServicesCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootOrganisationProductsAndServicesCategoriesStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrganisationProductsAndServicesCategoriesStreamCursorInput>>;
  where: InputMaybe<OrganisationProductsAndServicesCategoriesBoolExp>;
};


export type SubscriptionRootOrganisationPublicApiClientsArgs = {
  distinct_on: InputMaybe<Array<OrganisationPublicApiClientsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationPublicApiClientsOrderBy>>;
  where: InputMaybe<OrganisationPublicApiClientsBoolExp>;
};


export type SubscriptionRootOrganisationPublicApiClientsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootOrganisationPublicApiClientsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrganisationPublicApiClientsStreamCursorInput>>;
  where: InputMaybe<OrganisationPublicApiClientsBoolExp>;
};


export type SubscriptionRootOrganisationSupplierHistoricSubmissionsArgs = {
  distinct_on: InputMaybe<Array<OrganisationSupplierHistoricSubmissionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSupplierHistoricSubmissionsOrderBy>>;
  where: InputMaybe<OrganisationSupplierHistoricSubmissionsBoolExp>;
};


export type SubscriptionRootOrganisationSupplierHistoricSubmissionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootOrganisationSupplierHistoricSubmissionsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrganisationSupplierHistoricSubmissionsStreamCursorInput>>;
  where: InputMaybe<OrganisationSupplierHistoricSubmissionsBoolExp>;
};


export type SubscriptionRootOrganisationSuppliersBrandsArgs = {
  distinct_on: InputMaybe<Array<OrganisationSuppliersBrandsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersBrandsOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBrandsBoolExp>;
};


export type SubscriptionRootOrganisationSuppliersBrandsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootOrganisationSuppliersCategoriesArgs = {
  distinct_on: InputMaybe<Array<OrganisationSuppliersCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersCategoriesOrderBy>>;
  where: InputMaybe<OrganisationSuppliersCategoriesBoolExp>;
};


export type SubscriptionRootOrganisationSuppliersCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootOrganisationSuppliersCategoriesStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrganisationSuppliersCategoriesStreamCursorInput>>;
  where: InputMaybe<OrganisationSuppliersCategoriesBoolExp>;
};


export type SubscriptionRootOutOfOfficeDelegationsArgs = {
  distinct_on: InputMaybe<Array<OutOfOfficeDelegationsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OutOfOfficeDelegationsOrderBy>>;
  where: InputMaybe<OutOfOfficeDelegationsBoolExp>;
};


export type SubscriptionRootOutOfOfficeDelegationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootOutOfOfficeDelegationsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OutOfOfficeDelegationsStreamCursorInput>>;
  where: InputMaybe<OutOfOfficeDelegationsBoolExp>;
};


export type SubscriptionRootPaginateCustomCoreDataOptionsArgs = {
  args: PaginateCustomCoreDataOptionsArgs;
  distinct_on: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomCoreDataOptionsOrderBy>>;
  where: InputMaybe<CustomCoreDataOptionsBoolExp>;
};


export type SubscriptionRootPaginateCustomCoreDataOptionsAggregateArgs = {
  args: PaginateCustomCoreDataOptionsArgs;
  distinct_on: InputMaybe<Array<CustomCoreDataOptionsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomCoreDataOptionsOrderBy>>;
  where: InputMaybe<CustomCoreDataOptionsBoolExp>;
};


export type SubscriptionRootPauseReasonsArgs = {
  distinct_on: InputMaybe<Array<PauseReasonsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<PauseReasonsOrderBy>>;
  where: InputMaybe<PauseReasonsBoolExp>;
};


export type SubscriptionRootPauseReasonsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootPauseReasonsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PauseReasonsStreamCursorInput>>;
  where: InputMaybe<PauseReasonsBoolExp>;
};


export type SubscriptionRootProductCatalogueAccessApproversArgs = {
  distinct_on: InputMaybe<Array<ProductCatalogueAccessApproversSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductCatalogueAccessApproversOrderBy>>;
  where: InputMaybe<ProductCatalogueAccessApproversBoolExp>;
};


export type SubscriptionRootProductCatalogueAccessApproversByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootProductCatalogueEntriesArgs = {
  distinct_on: InputMaybe<Array<ProductCatalogueEntriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductCatalogueEntriesOrderBy>>;
  where: InputMaybe<ProductCatalogueEntriesBoolExp>;
};


export type SubscriptionRootProductCatalogueEntriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootProductsAndServicesCategoriesArgs = {
  distinct_on: InputMaybe<Array<ProductsAndServicesCategoriesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductsAndServicesCategoriesOrderBy>>;
  where: InputMaybe<ProductsAndServicesCategoriesBoolExp>;
};


export type SubscriptionRootProductsAndServicesCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootProductsAndServicesCategoriesStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProductsAndServicesCategoriesStreamCursorInput>>;
  where: InputMaybe<ProductsAndServicesCategoriesBoolExp>;
};


export type SubscriptionRootProductsAndServicesSimilarityResultsArgs = {
  distinct_on: InputMaybe<Array<ProductsAndServicesSimilarityResultsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductsAndServicesSimilarityResultsOrderBy>>;
  where: InputMaybe<ProductsAndServicesSimilarityResultsBoolExp>;
};


export type SubscriptionRootProductsAndServicesSimilarityResultsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootProductsAndServicesSimilarityResultsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProductsAndServicesSimilarityResultsStreamCursorInput>>;
  where: InputMaybe<ProductsAndServicesSimilarityResultsBoolExp>;
};


export type SubscriptionRootProductsAndServicesUnifiedSimilaritySearchByProductIdArgs = {
  args: ProductsAndServicesUnifiedSimilaritySearchByProductIdArgs;
  distinct_on: InputMaybe<Array<ProductsAndServicesSimilarityResultsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductsAndServicesSimilarityResultsOrderBy>>;
  where: InputMaybe<ProductsAndServicesSimilarityResultsBoolExp>;
};


export type SubscriptionRootProductsAndServicesUnifiedSimilaritySearchByQueryArgs = {
  args: ProductsAndServicesUnifiedSimilaritySearchByQueryArgs;
  distinct_on: InputMaybe<Array<ProductsAndServicesSimilarityResultsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductsAndServicesSimilarityResultsOrderBy>>;
  where: InputMaybe<ProductsAndServicesSimilarityResultsBoolExp>;
};


export type SubscriptionRootPurchaseOrderLineItemsArgs = {
  distinct_on: InputMaybe<Array<PurchaseOrderLineItemsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<PurchaseOrderLineItemsOrderBy>>;
  where: InputMaybe<PurchaseOrderLineItemsBoolExp>;
};


export type SubscriptionRootPurchaseOrderLineItemsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootPurchaseOrderLineItemsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PurchaseOrderLineItemsStreamCursorInput>>;
  where: InputMaybe<PurchaseOrderLineItemsBoolExp>;
};


export type SubscriptionRootRequestFormQuestionScoreArgs = {
  distinct_on: InputMaybe<Array<RequestFormQuestionScoreSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormQuestionScoreOrderBy>>;
  where: InputMaybe<RequestFormQuestionScoreBoolExp>;
};


export type SubscriptionRootRequestFormQuestionScoreByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootRequestFormQuestionScoreStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RequestFormQuestionScoreStreamCursorInput>>;
  where: InputMaybe<RequestFormQuestionScoreBoolExp>;
};


export type SubscriptionRootRequestFormSubmissionAiSummaryArgs = {
  distinct_on: InputMaybe<Array<RequestFormSubmissionAiSummarySelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestFormSubmissionAiSummaryOrderBy>>;
  where: InputMaybe<RequestFormSubmissionAiSummaryBoolExp>;
};


export type SubscriptionRootRequestFormSubmissionAiSummaryByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootRequestFormSubmissionAiSummaryStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RequestFormSubmissionAiSummaryStreamCursorInput>>;
  where: InputMaybe<RequestFormSubmissionAiSummaryBoolExp>;
};


export type SubscriptionRootRequestLeadsConfigArgs = {
  distinct_on: InputMaybe<Array<RequestLeadsConfigSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestLeadsConfigOrderBy>>;
  where: InputMaybe<RequestLeadsConfigBoolExp>;
};


export type SubscriptionRootRequestLeadsConfigByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootRequestLeadsConfigStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RequestLeadsConfigStreamCursorInput>>;
  where: InputMaybe<RequestLeadsConfigBoolExp>;
};


export type SubscriptionRootRequestPausesArgs = {
  distinct_on: InputMaybe<Array<RequestPausesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestPausesOrderBy>>;
  where: InputMaybe<RequestPausesBoolExp>;
};


export type SubscriptionRootRequestPausesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootRequestPausesStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RequestPausesStreamCursorInput>>;
  where: InputMaybe<RequestPausesBoolExp>;
};


export type SubscriptionRootRequestRequestLeadsArgs = {
  distinct_on: InputMaybe<Array<RequestRequestLeadsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestRequestLeadsOrderBy>>;
  where: InputMaybe<RequestRequestLeadsBoolExp>;
};


export type SubscriptionRootRequestRequestLeadsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootRequestRequestLeadsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RequestRequestLeadsStreamCursorInput>>;
  where: InputMaybe<RequestRequestLeadsBoolExp>;
};


export type SubscriptionRootRequestStepNotificationMessagesArgs = {
  distinct_on: InputMaybe<Array<RequestStepNotificationMessagesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepNotificationMessagesOrderBy>>;
  where: InputMaybe<RequestStepNotificationMessagesBoolExp>;
};


export type SubscriptionRootRequestStepNotificationMessagesByPkArgs = {
  requestStepId: Scalars['uuid']['input'];
};


export type SubscriptionRootRequestStepNotificationMessagesStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RequestStepNotificationMessagesStreamCursorInput>>;
  where: InputMaybe<RequestStepNotificationMessagesBoolExp>;
};


export type SubscriptionRootRequestStepTaskUsersArgs = {
  distinct_on: InputMaybe<Array<RequestStepTaskUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTaskUsersOrderBy>>;
  where: InputMaybe<RequestStepTaskUsersBoolExp>;
};


export type SubscriptionRootRequestStepTaskUsersByPkArgs = {
  organisation_id: Scalars['uuid']['input'];
  request_step_task_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type SubscriptionRootRequestStepTaskUsersStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RequestStepTaskUsersStreamCursorInput>>;
  where: InputMaybe<RequestStepTaskUsersBoolExp>;
};


export type SubscriptionRootRfxRequestFormTemplateWeightingArgs = {
  distinct_on: InputMaybe<Array<RfxRequestFormTemplateWeightingSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxRequestFormTemplateWeightingOrderBy>>;
  where: InputMaybe<RfxRequestFormTemplateWeightingBoolExp>;
};


export type SubscriptionRootRfxRequestFormTemplateWeightingByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootRfxRequestFormTemplateWeightingStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RfxRequestFormTemplateWeightingStreamCursorInput>>;
  where: InputMaybe<RfxRequestFormTemplateWeightingBoolExp>;
};


export type SubscriptionRootRfxRequestFormTemplatesRanksArgs = {
  distinct_on: InputMaybe<Array<RfxRequestFormTemplatesRanksSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RfxRequestFormTemplatesRanksOrderBy>>;
  where: InputMaybe<RfxRequestFormTemplatesRanksBoolExp>;
};


export type SubscriptionRootRfxRequestFormTemplatesRanksByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootRfxRequestFormTemplatesRanksStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RfxRequestFormTemplatesRanksStreamCursorInput>>;
  where: InputMaybe<RfxRequestFormTemplatesRanksBoolExp>;
};


export type SubscriptionRootRiskSettingsArgs = {
  distinct_on: InputMaybe<Array<RiskSettingsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RiskSettingsOrderBy>>;
  where: InputMaybe<RiskSettingsBoolExp>;
};


export type SubscriptionRootRiskSettingsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootRiskSettingsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RiskSettingsStreamCursorInput>>;
  where: InputMaybe<RiskSettingsBoolExp>;
};


export type SubscriptionRootSearchOrganisationProductsAndServicesArgs = {
  args: SearchOrganisationProductsAndServicesArgs;
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


export type SubscriptionRootSearchOrganisationProductsAndServicesAggregateArgs = {
  args: SearchOrganisationProductsAndServicesArgs;
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


export type SubscriptionRootSearchOrganisationProductsAndServicesV2Args = {
  args: SearchOrganisationProductsAndServicesV2Args;
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


export type SubscriptionRootSearchOrganisationProductsAndServicesV2AggregateArgs = {
  args: SearchOrganisationProductsAndServicesV2Args;
  distinct_on: InputMaybe<Array<OrganisationProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationProductsAndServicesOrderBy>>;
  where: InputMaybe<OrganisationProductsAndServicesBoolExp>;
};


export type SubscriptionRootSearchOrganisationSuppliersArgs = {
  args: SearchOrganisationSuppliersArgs;
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


export type SubscriptionRootSearchOrganisationSuppliersAggregateArgs = {
  args: SearchOrganisationSuppliersArgs;
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


export type SubscriptionRootSearchOrganisationSuppliersV2Args = {
  args: SearchOrganisationSuppliersV2Args;
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


export type SubscriptionRootSearchOrganisationSuppliersV2AggregateArgs = {
  args: SearchOrganisationSuppliersV2Args;
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


export type SubscriptionRootSearchOrganisationSuppliersV3Args = {
  args: SearchOrganisationSuppliersV3Args;
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


export type SubscriptionRootSearchOrganisationSuppliersV3AggregateArgs = {
  args: SearchOrganisationSuppliersV3Args;
  distinct_on: InputMaybe<Array<OrganisationSuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
};


export type SubscriptionRootSearchProductsArgs = {
  args: SearchProductsArgs;
  distinct_on: InputMaybe<Array<ProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductsAndServicesOrderBy>>;
  where: InputMaybe<ProductsAndServicesBoolExp>;
};


export type SubscriptionRootSearchSuppliersArgs = {
  args: SearchSuppliersArgs;
  distinct_on: InputMaybe<Array<SuppliersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<SuppliersOrderBy>>;
  where: InputMaybe<SuppliersBoolExp>;
};


export type SubscriptionRootVectorSearchProductsAndServicesArgs = {
  args: VectorSearchProductsAndServicesArgs;
  distinct_on: InputMaybe<Array<VectorSearchSimilarityResultsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<VectorSearchSimilarityResultsOrderBy>>;
  where: InputMaybe<VectorSearchSimilarityResultsBoolExp>;
};


export type SubscriptionRootVectorSearchSimilarityResultsArgs = {
  distinct_on: InputMaybe<Array<VectorSearchSimilarityResultsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<VectorSearchSimilarityResultsOrderBy>>;
  where: InputMaybe<VectorSearchSimilarityResultsBoolExp>;
};


export type SubscriptionRootVectorSearchSimilarityResultsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type SubscriptionRootVectorSearchSimilarityResultsStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<VectorSearchSimilarityResultsStreamCursorInput>>;
  where: InputMaybe<VectorSearchSimilarityResultsBoolExp>;
};


export type SubscriptionRootVectorSearchSuppliersArgs = {
  args: VectorSearchSuppliersArgs;
  distinct_on: InputMaybe<Array<VectorSearchSimilarityResultsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<VectorSearchSimilarityResultsOrderBy>>;
  where: InputMaybe<VectorSearchSimilarityResultsBoolExp>;
};


export type SubscriptionRootZWorkaroundCcdoCountArgs = {
  distinct_on: InputMaybe<Array<ZWorkaroundCcdoCountSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ZWorkaroundCcdoCountOrderBy>>;
  where: InputMaybe<ZWorkaroundCcdoCountBoolExp>;
};


export type SubscriptionRootZWorkaroundCcdoCountStreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ZWorkaroundCcdoCountStreamCursorInput>>;
  where: InputMaybe<ZWorkaroundCcdoCountBoolExp>;
};

/** The customers legal entities */
export type Subsidiaries = {
  __typename?: 'subsidiaries';
  addresses: Maybe<Scalars['jsonb']['output']>;
  alias: Maybe<Scalars['String']['output']>;
  archivedBy: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  coreData: CoreData;
  coreDataId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  currency: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  legalName: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organisationId: Scalars['uuid']['output'];
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  urls: Maybe<Scalars['jsonb']['output']>;
};


/** The customers legal entities */
export type SubsidiariesAddressesArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** The customers legal entities */
export type SubsidiariesUrlsArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "subsidiaries" */
export type SubsidiariesAggregate = {
  __typename?: 'subsidiaries_aggregate';
  aggregate: Maybe<SubsidiariesAggregateFields>;
  nodes: Array<Subsidiaries>;
};

/** aggregate fields of "subsidiaries" */
export type SubsidiariesAggregateFields = {
  __typename?: 'subsidiaries_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<SubsidiariesMaxFields>;
  min: Maybe<SubsidiariesMinFields>;
};


/** aggregate fields of "subsidiaries" */
export type SubsidiariesAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<SubsidiariesSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SubsidiariesAppendInput = {
  addresses?: InputMaybe<Scalars['jsonb']['input']>;
  urls?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "subsidiaries". All fields are combined with a logical 'AND'. */
export type SubsidiariesBoolExp = {
  _and?: InputMaybe<Array<SubsidiariesBoolExp>>;
  _not?: InputMaybe<SubsidiariesBoolExp>;
  _or?: InputMaybe<Array<SubsidiariesBoolExp>>;
  addresses?: InputMaybe<JsonbComparisonExp>;
  alias?: InputMaybe<StringComparisonExp>;
  archivedBy?: InputMaybe<StringComparisonExp>;
  coreData?: InputMaybe<CoreDataBoolExp>;
  coreDataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  currency?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  isVisible?: InputMaybe<BooleanComparisonExp>;
  legalName?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  remoteId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  urls?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "subsidiaries" */
export enum SubsidiariesConstraint {
  /** unique or primary key constraint on columns "id" */
  SUBSIDIARIES_PKEY = 'subsidiaries_pkey',
  /** unique or primary key constraint on columns "remote_id", "organisation_id" */
  SUBSIDIARIES_REMOTE_ID_ORGANISATION_ID_KEY = 'subsidiaries_remote_id_organisation_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SubsidiariesDeleteAtPathInput = {
  addresses?: InputMaybe<Array<Scalars['String']['input']>>;
  urls?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SubsidiariesDeleteElemInput = {
  addresses?: InputMaybe<Scalars['Int']['input']>;
  urls?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SubsidiariesDeleteKeyInput = {
  addresses?: InputMaybe<Scalars['String']['input']>;
  urls?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "subsidiaries" */
export type SubsidiariesInsertInput = {
  addresses?: InputMaybe<Scalars['jsonb']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  urls?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type SubsidiariesMaxFields = {
  __typename?: 'subsidiaries_max_fields';
  alias: Maybe<Scalars['String']['output']>;
  archivedBy: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  legalName: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type SubsidiariesMinFields = {
  __typename?: 'subsidiaries_min_fields';
  alias: Maybe<Scalars['String']['output']>;
  archivedBy: Maybe<Scalars['String']['output']>;
  coreDataId: Maybe<Scalars['uuid']['output']>;
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  legalName: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  remoteId: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "subsidiaries" */
export type SubsidiariesMutationResponse = {
  __typename?: 'subsidiaries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subsidiaries>;
};

/** input type for inserting object relation for remote table "subsidiaries" */
export type SubsidiariesObjRelInsertInput = {
  data: SubsidiariesInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<SubsidiariesOnConflict>;
};

/** on_conflict condition type for table "subsidiaries" */
export type SubsidiariesOnConflict = {
  constraint: SubsidiariesConstraint;
  update_columns: Array<SubsidiariesUpdateColumn>;
  where?: InputMaybe<SubsidiariesBoolExp>;
};

/** Ordering options when selecting data from "subsidiaries". */
export type SubsidiariesOrderBy = {
  addresses?: InputMaybe<OrderBy>;
  alias?: InputMaybe<OrderBy>;
  archivedBy?: InputMaybe<OrderBy>;
  coreData?: InputMaybe<CoreDataOrderBy>;
  coreDataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  currency?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  isVisible?: InputMaybe<OrderBy>;
  legalName?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  remoteId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  urls?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: subsidiaries */
export type SubsidiariesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SubsidiariesPrependInput = {
  addresses?: InputMaybe<Scalars['jsonb']['input']>;
  urls?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "subsidiaries" */
export enum SubsidiariesSelectColumn {
  /** column name */
  ADDRESSES = 'addresses',
  /** column name */
  ALIAS = 'alias',
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  COREDATAID = 'coreDataId',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CURRENCY = 'currency',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISVISIBLE = 'isVisible',
  /** column name */
  LEGALNAME = 'legalName',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  URLS = 'urls'
}

/** input type for updating data in table "subsidiaries" */
export type SubsidiariesSetInput = {
  addresses?: InputMaybe<Scalars['jsonb']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  archivedBy?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  remoteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  urls?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "subsidiaries" */
export enum SubsidiariesUpdateColumn {
  /** column name */
  ADDRESSES = 'addresses',
  /** column name */
  ALIAS = 'alias',
  /** column name */
  ARCHIVEDBY = 'archivedBy',
  /** column name */
  CURRENCY = 'currency',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  LEGALNAME = 'legalName',
  /** column name */
  NAME = 'name',
  /** column name */
  REMOTEID = 'remoteId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  URLS = 'urls'
}

export type SubsidiariesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SubsidiariesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SubsidiariesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SubsidiariesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SubsidiariesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SubsidiariesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SubsidiariesSetInput>;
  /** filter the rows which have to be updated */
  where: SubsidiariesBoolExp;
};

/** columns and relationships of "suppliers" */
export type Suppliers = {
  __typename?: 'suppliers';
  created_at: Scalars['timestamptz']['output'];
  deleted_at: Maybe<Scalars['timestamptz']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isReseller: Scalars['Boolean']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  organisation_suppliers_brands: Array<OrganisationSuppliersBrands>;
  /** An array relationship */
  products_and_services: Array<ProductsAndServices>;
  ranking: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  website: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "suppliers" */
export type SuppliersOrganisationSuppliersBrandsArgs = {
  distinct_on: InputMaybe<Array<OrganisationSuppliersBrandsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSuppliersBrandsOrderBy>>;
  where: InputMaybe<OrganisationSuppliersBrandsBoolExp>;
};


/** columns and relationships of "suppliers" */
export type SuppliersProductsAndServicesArgs = {
  distinct_on: InputMaybe<Array<ProductsAndServicesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<ProductsAndServicesOrderBy>>;
  where: InputMaybe<ProductsAndServicesBoolExp>;
};

/** Boolean expression to filter rows from the table "suppliers". All fields are combined with a logical 'AND'. */
export type SuppliersBoolExp = {
  _and?: InputMaybe<Array<SuppliersBoolExp>>;
  _not?: InputMaybe<SuppliersBoolExp>;
  _or?: InputMaybe<Array<SuppliersBoolExp>>;
  created_at?: InputMaybe<TimestamptzComparisonExp>;
  deleted_at?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isReseller?: InputMaybe<BooleanComparisonExp>;
  logoUrl?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation_suppliers_brands?: InputMaybe<OrganisationSuppliersBrandsBoolExp>;
  products_and_services?: InputMaybe<ProductsAndServicesBoolExp>;
  ranking?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** Ordering options when selecting data from "suppliers". */
export type SuppliersOrderBy = {
  created_at?: InputMaybe<OrderBy>;
  deleted_at?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isReseller?: InputMaybe<OrderBy>;
  logoUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation_suppliers_brands_aggregate?: InputMaybe<OrganisationSuppliersBrandsAggregateOrderBy>;
  products_and_services_aggregate?: InputMaybe<ProductsAndServicesAggregateOrderBy>;
  ranking?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** select columns of table "suppliers" */
export enum SuppliersSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DELETED_AT = 'deleted_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  ISRESELLER = 'isReseller',
  /** column name */
  LOGOURL = 'logoUrl',
  /** column name */
  NAME = 'name',
  /** column name */
  RANKING = 'ranking',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEBSITE = 'website'
}

/** columns and relationships of "table_filter_reference" */
export type TableFilterReference = {
  __typename?: 'table_filter_reference';
  description: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "table_filter_reference". All fields are combined with a logical 'AND'. */
export type TableFilterReferenceBoolExp = {
  _and?: InputMaybe<Array<TableFilterReferenceBoolExp>>;
  _not?: InputMaybe<TableFilterReferenceBoolExp>;
  _or?: InputMaybe<Array<TableFilterReferenceBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum TableFilterReferenceEnum {
  /** AGREEMENT */
  AGREEMENT = 'AGREEMENT',
  /** ASSESSMENT */
  ASSESSMENT = 'ASSESSMENT',
  /** BUDGET */
  BUDGET = 'BUDGET',
  /** DOCUMENT */
  DOCUMENT = 'DOCUMENT',
  /** PRODUCT_BRANDS */
  PRODUCT_BRANDS = 'PRODUCT_BRANDS',
  /** REMINDER */
  REMINDER = 'REMINDER',
  /** RENEWAL */
  RENEWAL = 'RENEWAL',
  /** REQUEST */
  REQUEST = 'REQUEST',
  /** RISK */
  RISK = 'RISK',
  /** SUPPLIER */
  SUPPLIER = 'SUPPLIER',
  /** TASK */
  TASK = 'TASK',
  /** USER */
  USER = 'USER'
}

/** Boolean expression to compare columns of type "table_filter_reference_enum". All fields are combined with logical 'AND'. */
export type TableFilterReferenceEnumComparisonExp = {
  _eq?: InputMaybe<TableFilterReferenceEnum>;
  _in?: InputMaybe<Array<TableFilterReferenceEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TableFilterReferenceEnum>;
  _nin?: InputMaybe<Array<TableFilterReferenceEnum>>;
};

/** Ordering options when selecting data from "table_filter_reference". */
export type TableFilterReferenceOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "table_filter_reference" */
export enum TableFilterReferenceSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** columns and relationships of "table_filters" */
export type TableFilters = {
  __typename?: 'table_filters';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  favourites: Array<FavouriteTableFilters>;
  filters: Scalars['filterModel']['output'];
  id: Scalars['uuid']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  reference: TableFilterReferenceEnum;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "table_filters" */
export type TableFiltersFavouritesArgs = {
  distinct_on: InputMaybe<Array<FavouriteTableFiltersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FavouriteTableFiltersOrderBy>>;
  where: InputMaybe<FavouriteTableFiltersBoolExp>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TableFiltersAppendInput = {
  filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "table_filters". All fields are combined with a logical 'AND'. */
export type TableFiltersBoolExp = {
  _and?: InputMaybe<Array<TableFiltersBoolExp>>;
  _not?: InputMaybe<TableFiltersBoolExp>;
  _or?: InputMaybe<Array<TableFiltersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  favourites?: InputMaybe<FavouriteTableFiltersBoolExp>;
  filters?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isPublic?: InputMaybe<BooleanComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  reference?: InputMaybe<TableFilterReferenceEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "table_filters" */
export enum TableFiltersConstraint {
  /** unique or primary key constraint on columns "id" */
  USER_CUSTOM_FILTERS_PKEY = 'user_custom_filters_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TableFiltersDeleteAtPathInput = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TableFiltersDeleteElemInput = {
  filters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TableFiltersDeleteKeyInput = {
  filters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "table_filters" */
export type TableFiltersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  favourites?: InputMaybe<FavouriteTableFiltersArrRelInsertInput>;
  filters: Scalars['filterModel']['input'];
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<TableFilterReferenceEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "table_filters" */
export type TableFiltersMutationResponse = {
  __typename?: 'table_filters_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TableFilters>;
};

/** input type for inserting object relation for remote table "table_filters" */
export type TableFiltersObjRelInsertInput = {
  data: TableFiltersInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TableFiltersOnConflict>;
};

/** on_conflict condition type for table "table_filters" */
export type TableFiltersOnConflict = {
  constraint: TableFiltersConstraint;
  update_columns: Array<TableFiltersUpdateColumn>;
  where?: InputMaybe<TableFiltersBoolExp>;
};

/** Ordering options when selecting data from "table_filters". */
export type TableFiltersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  favourites_aggregate?: InputMaybe<FavouriteTableFiltersAggregateOrderBy>;
  filters?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isPublic?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  reference?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: table_filters */
export type TableFiltersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TableFiltersPrependInput = {
  filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "table_filters" */
export enum TableFiltersSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  FILTERS = 'filters',
  /** column name */
  ID = 'id',
  /** column name */
  ISPUBLIC = 'isPublic',
  /** column name */
  NAME = 'name',
  /** column name */
  REFERENCE = 'reference',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "table_filters" */
export type TableFiltersSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  filters?: InputMaybe<Scalars['filterModel']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<TableFilterReferenceEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "table_filters" */
export enum TableFiltersUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  FILTERS = 'filters',
  /** column name */
  ID = 'id',
  /** column name */
  ISPUBLIC = 'isPublic',
  /** column name */
  NAME = 'name',
  /** column name */
  REFERENCE = 'reference',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

export type TableFiltersUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TableFiltersAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<TableFiltersDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<TableFiltersDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<TableFiltersDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TableFiltersPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TableFiltersSetInput>;
  /** filter the rows which have to be updated */
  where: TableFiltersBoolExp;
};

/** columns and relationships of "tags" */
export type Tags = {
  __typename?: 'tags';
  /** An array relationship */
  assessment_tags: Array<AssessmentTags>;
  createdAt: Scalars['date']['output'];
  deletedAt: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An array relationship */
  organisation_supplier_tags: Array<OrganisationSupplierTags>;
  /** An array relationship */
  renewal_tags: Array<RenewalTags>;
  /** An array relationship */
  request_tags: Array<RequestTags>;
};


/** columns and relationships of "tags" */
export type TagsAssessmentTagsArgs = {
  distinct_on: InputMaybe<Array<AssessmentTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<AssessmentTagsOrderBy>>;
  where: InputMaybe<AssessmentTagsBoolExp>;
};


/** columns and relationships of "tags" */
export type TagsOrganisationSupplierTagsArgs = {
  distinct_on: InputMaybe<Array<OrganisationSupplierTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<OrganisationSupplierTagsOrderBy>>;
  where: InputMaybe<OrganisationSupplierTagsBoolExp>;
};


/** columns and relationships of "tags" */
export type TagsRenewalTagsArgs = {
  distinct_on: InputMaybe<Array<RenewalTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RenewalTagsOrderBy>>;
  where: InputMaybe<RenewalTagsBoolExp>;
};


/** columns and relationships of "tags" */
export type TagsRequestTagsArgs = {
  distinct_on: InputMaybe<Array<RequestTagsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestTagsOrderBy>>;
  where: InputMaybe<RequestTagsBoolExp>;
};

/** aggregated selection of "tags" */
export type TagsAggregate = {
  __typename?: 'tags_aggregate';
  aggregate: Maybe<TagsAggregateFields>;
  nodes: Array<Tags>;
};

/** aggregate fields of "tags" */
export type TagsAggregateFields = {
  __typename?: 'tags_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<TagsMaxFields>;
  min: Maybe<TagsMinFields>;
};


/** aggregate fields of "tags" */
export type TagsAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<TagsSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "tags". All fields are combined with a logical 'AND'. */
export type TagsBoolExp = {
  _and?: InputMaybe<Array<TagsBoolExp>>;
  _not?: InputMaybe<TagsBoolExp>;
  _or?: InputMaybe<Array<TagsBoolExp>>;
  assessment_tags?: InputMaybe<AssessmentTagsBoolExp>;
  createdAt?: InputMaybe<DateComparisonExp>;
  deletedAt?: InputMaybe<DateComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisation_supplier_tags?: InputMaybe<OrganisationSupplierTagsBoolExp>;
  renewal_tags?: InputMaybe<RenewalTagsBoolExp>;
  request_tags?: InputMaybe<RequestTagsBoolExp>;
};

/** unique or primary key constraints on table "tags" */
export enum TagsConstraint {
  /** unique or primary key constraint on columns "organisation_id", "name" */
  TAGS_NAME_ORGANISATION_ID_KEY = 'tags_name_organisation_id_key',
  /** unique or primary key constraint on columns "id" */
  TAGS_PKEY = 'tags_pkey'
}

/** input type for inserting data into table "tags" */
export type TagsInsertInput = {
  assessment_tags?: InputMaybe<AssessmentTagsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['date']['input']>;
  deletedAt?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_supplier_tags?: InputMaybe<OrganisationSupplierTagsArrRelInsertInput>;
  renewal_tags?: InputMaybe<RenewalTagsArrRelInsertInput>;
  request_tags?: InputMaybe<RequestTagsArrRelInsertInput>;
};

/** aggregate max on columns */
export type TagsMaxFields = {
  __typename?: 'tags_max_fields';
  createdAt: Maybe<Scalars['date']['output']>;
  deletedAt: Maybe<Scalars['date']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type TagsMinFields = {
  __typename?: 'tags_min_fields';
  createdAt: Maybe<Scalars['date']['output']>;
  deletedAt: Maybe<Scalars['date']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "tags" */
export type TagsMutationResponse = {
  __typename?: 'tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tags>;
};

/** input type for inserting object relation for remote table "tags" */
export type TagsObjRelInsertInput = {
  data: TagsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<TagsOnConflict>;
};

/** on_conflict condition type for table "tags" */
export type TagsOnConflict = {
  constraint: TagsConstraint;
  update_columns: Array<TagsUpdateColumn>;
  where?: InputMaybe<TagsBoolExp>;
};

/** Ordering options when selecting data from "tags". */
export type TagsOrderBy = {
  assessment_tags_aggregate?: InputMaybe<AssessmentTagsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisation_supplier_tags_aggregate?: InputMaybe<OrganisationSupplierTagsAggregateOrderBy>;
  renewal_tags_aggregate?: InputMaybe<RenewalTagsAggregateOrderBy>;
  request_tags_aggregate?: InputMaybe<RequestTagsAggregateOrderBy>;
};

/** primary key columns input for table: tags */
export type TagsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tags" */
export enum TagsSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ORGANISATIONID = 'organisationId'
}

/** input type for updating data in table "tags" */
export type TagsSetInput = {
  deletedAt?: InputMaybe<Scalars['date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tags" */
export enum TagsUpdateColumn {
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  NAME = 'name'
}

export type TagsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TagsSetInput>;
  /** filter the rows which have to be updated */
  where: TagsBoolExp;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Stores the list of valid subsidiaries for each user, driving available options for selection on buyerLegalEntity question */
export type UserAllowedSubsidiaries = {
  __typename?: 'user_allowed_subsidiaries';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An object relationship */
  organisationIntegration: Maybe<OrganisationIntegrations>;
  organisationIntegrationId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  subsidiary: Subsidiaries;
  subsidiaryId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "user_allowed_subsidiaries" */
export type UserAllowedSubsidiariesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserAllowedSubsidiariesMaxOrderBy>;
  min?: InputMaybe<UserAllowedSubsidiariesMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_allowed_subsidiaries" */
export type UserAllowedSubsidiariesArrRelInsertInput = {
  data: Array<UserAllowedSubsidiariesInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserAllowedSubsidiariesOnConflict>;
};

/** Boolean expression to filter rows from the table "user_allowed_subsidiaries". All fields are combined with a logical 'AND'. */
export type UserAllowedSubsidiariesBoolExp = {
  _and?: InputMaybe<Array<UserAllowedSubsidiariesBoolExp>>;
  _not?: InputMaybe<UserAllowedSubsidiariesBoolExp>;
  _or?: InputMaybe<Array<UserAllowedSubsidiariesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsBoolExp>;
  organisationIntegrationId?: InputMaybe<UuidComparisonExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  subsidiaryId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_allowed_subsidiaries" */
export enum UserAllowedSubsidiariesConstraint {
  /** unique or primary key constraint on columns "id" */
  USER_ALLOWED_SUBSIDIARIES_PKEY = 'user_allowed_subsidiaries_pkey'
}

/** input type for inserting data into table "user_allowed_subsidiaries" */
export type UserAllowedSubsidiariesInsertInput = {
  organisationIntegration?: InputMaybe<OrganisationIntegrationsObjRelInsertInput>;
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  subsidiary?: InputMaybe<SubsidiariesObjRelInsertInput>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "user_allowed_subsidiaries" */
export type UserAllowedSubsidiariesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "user_allowed_subsidiaries" */
export type UserAllowedSubsidiariesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_allowed_subsidiaries" */
export type UserAllowedSubsidiariesMutationResponse = {
  __typename?: 'user_allowed_subsidiaries_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserAllowedSubsidiaries>;
};

/** on_conflict condition type for table "user_allowed_subsidiaries" */
export type UserAllowedSubsidiariesOnConflict = {
  constraint: UserAllowedSubsidiariesConstraint;
  update_columns: Array<UserAllowedSubsidiariesUpdateColumn>;
  where?: InputMaybe<UserAllowedSubsidiariesBoolExp>;
};

/** Ordering options when selecting data from "user_allowed_subsidiaries". */
export type UserAllowedSubsidiariesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  organisationIntegration?: InputMaybe<OrganisationIntegrationsOrderBy>;
  organisationIntegrationId?: InputMaybe<OrderBy>;
  subsidiary?: InputMaybe<SubsidiariesOrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_allowed_subsidiaries */
export type UserAllowedSubsidiariesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_allowed_subsidiaries" */
export enum UserAllowedSubsidiariesSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  USERID = 'userId'
}

/** input type for updating data in table "user_allowed_subsidiaries" */
export type UserAllowedSubsidiariesSetInput = {
  organisationIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_allowed_subsidiaries" */
export enum UserAllowedSubsidiariesUpdateColumn {
  /** column name */
  ORGANISATIONINTEGRATIONID = 'organisationIntegrationId',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  USERID = 'userId'
}

export type UserAllowedSubsidiariesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserAllowedSubsidiariesSetInput>;
  /** filter the rows which have to be updated */
  where: UserAllowedSubsidiariesBoolExp;
};

export type UserCustomFilters = {
  __typename?: 'user_custom_filters';
  filter: Scalars['filterModel']['output'];
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  customFieldValues: Array<CustomFieldValues>;
  /** An aggregate relationship */
  customFieldValues_aggregate: CustomFieldValuesAggregate;
  dateFormatPreference: Maybe<Scalars['availableDateFormat']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  department: Maybe<Departments>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** An array relationship */
  group_users: Array<GroupUsers>;
  hasConfigPermissions: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  isOutOfOffice: Scalars['Boolean']['output'];
  isViewOnly: Scalars['Boolean']['output'];
  languagePreference: Maybe<Scalars['availableLocale']['output']>;
  lastName: Scalars['String']['output'];
  lastRefreshedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  managerUser: Maybe<Users>;
  managerUserId: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['uuid']['output'];
  /** An array relationship */
  request_step_task_users: Array<RequestStepTaskUsers>;
  /** An array relationship */
  request_users: Array<RequestUsers>;
  /** An array relationship */
  requests: Array<Requests>;
  /** An aggregate relationship */
  requests_aggregate: RequestsAggregate;
  role: Scalars['String']['output'];
  /** A computed field, executes function "user_searchable_string" */
  searchableString: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  subsidiary: Maybe<Subsidiaries>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userAllowedSubsidiaries: Array<UserAllowedSubsidiaries>;
  /** An array relationship */
  users_favourite_table_filters: Array<FavouriteTableFilters>;
};


/** columns and relationships of "users" */
export type UsersCustomFieldValuesArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersCustomFieldValuesAggregateArgs = {
  distinct_on: InputMaybe<Array<CustomFieldValuesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<CustomFieldValuesOrderBy>>;
  where: InputMaybe<CustomFieldValuesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersGroupUsersArgs = {
  distinct_on: InputMaybe<Array<GroupUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<GroupUsersOrderBy>>;
  where: InputMaybe<GroupUsersBoolExp>;
};


/** columns and relationships of "users" */
export type UsersRequestStepTaskUsersArgs = {
  distinct_on: InputMaybe<Array<RequestStepTaskUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestStepTaskUsersOrderBy>>;
  where: InputMaybe<RequestStepTaskUsersBoolExp>;
};


/** columns and relationships of "users" */
export type UsersRequestUsersArgs = {
  distinct_on: InputMaybe<Array<RequestUsersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestUsersOrderBy>>;
  where: InputMaybe<RequestUsersBoolExp>;
};


/** columns and relationships of "users" */
export type UsersRequestsArgs = {
  distinct_on: InputMaybe<Array<RequestsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestsOrderBy>>;
  where: InputMaybe<RequestsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersRequestsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestsOrderBy>>;
  where: InputMaybe<RequestsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUserAllowedSubsidiariesArgs = {
  distinct_on: InputMaybe<Array<UserAllowedSubsidiariesSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<UserAllowedSubsidiariesOrderBy>>;
  where: InputMaybe<UserAllowedSubsidiariesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUsersFavouriteTableFiltersArgs = {
  distinct_on: InputMaybe<Array<FavouriteTableFiltersSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<FavouriteTableFiltersOrderBy>>;
  where: InputMaybe<FavouriteTableFiltersBoolExp>;
};

/** aggregated selection of "users" */
export type UsersAggregate = {
  __typename?: 'users_aggregate';
  aggregate: Maybe<UsersAggregateFields>;
  nodes: Array<Users>;
};

export type UsersAggregateBoolExp = {
  bool_and?: InputMaybe<UsersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<UsersAggregateBoolExpBoolOr>;
  count?: InputMaybe<UsersAggregateBoolExpCount>;
};

export type UsersAggregateBoolExpBoolAnd = {
  arguments: UsersSelectColumnUsersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UsersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type UsersAggregateBoolExpBoolOr = {
  arguments: UsersSelectColumnUsersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UsersBoolExp>;
  predicate: BooleanComparisonExp;
};

export type UsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UsersBoolExp>;
  predicate: IntComparisonExp;
};

/** aggregate fields of "users" */
export type UsersAggregateFields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int']['output'];
  max: Maybe<UsersMaxFields>;
  min: Maybe<UsersMinFields>;
};


/** aggregate fields of "users" */
export type UsersAggregateFieldsCountArgs = {
  columns: InputMaybe<Array<UsersSelectColumn>>;
  distinct: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users" */
export type UsersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UsersMaxOrderBy>;
  min?: InputMaybe<UsersMinOrderBy>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: InputMaybe<Array<UsersBoolExp>>;
  _not?: InputMaybe<UsersBoolExp>;
  _or?: InputMaybe<Array<UsersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  customFieldValues?: InputMaybe<CustomFieldValuesBoolExp>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateBoolExp>;
  dateFormatPreference?: InputMaybe<StringComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  department?: InputMaybe<DepartmentsBoolExp>;
  departmentId?: InputMaybe<UuidComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  firstName?: InputMaybe<StringComparisonExp>;
  group_users?: InputMaybe<GroupUsersBoolExp>;
  hasConfigPermissions?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  isOutOfOffice?: InputMaybe<BooleanComparisonExp>;
  isViewOnly?: InputMaybe<BooleanComparisonExp>;
  languagePreference?: InputMaybe<StringComparisonExp>;
  lastName?: InputMaybe<StringComparisonExp>;
  lastRefreshedAt?: InputMaybe<TimestamptzComparisonExp>;
  managerUser?: InputMaybe<UsersBoolExp>;
  managerUserId?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  request_step_task_users?: InputMaybe<RequestStepTaskUsersBoolExp>;
  request_users?: InputMaybe<RequestUsersBoolExp>;
  requests?: InputMaybe<RequestsBoolExp>;
  requests_aggregate?: InputMaybe<RequestsAggregateBoolExp>;
  role?: InputMaybe<StringComparisonExp>;
  searchableString?: InputMaybe<StringComparisonExp>;
  subsidiary?: InputMaybe<SubsidiariesBoolExp>;
  subsidiaryId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userAllowedSubsidiaries?: InputMaybe<UserAllowedSubsidiariesBoolExp>;
  users_favourite_table_filters?: InputMaybe<FavouriteTableFiltersBoolExp>;
};

/** unique or primary key constraints on table "users" */
export enum UsersConstraint {
  /** unique or primary key constraint on columns "email", "organisation_id" */
  USERS_EMAIL_ORGANISATION_ID_KEY = 'users_email_organisation_id_key',
  /** unique or primary key constraint on columns "id" */
  USERS_PKEY = 'users_pkey'
}

/** input type for inserting data into table "users" */
export type UsersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  customFieldValues?: InputMaybe<CustomFieldValuesArrRelInsertInput>;
  dateFormatPreference?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  department?: InputMaybe<DepartmentsObjRelInsertInput>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  group_users?: InputMaybe<GroupUsersArrRelInsertInput>;
  hasConfigPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isViewOnly?: InputMaybe<Scalars['Boolean']['input']>;
  languagePreference?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  managerUser?: InputMaybe<UsersObjRelInsertInput>;
  managerUserId?: InputMaybe<Scalars['uuid']['input']>;
  request_step_task_users?: InputMaybe<RequestStepTaskUsersArrRelInsertInput>;
  request_users?: InputMaybe<RequestUsersArrRelInsertInput>;
  requests?: InputMaybe<RequestsArrRelInsertInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  subsidiary?: InputMaybe<SubsidiariesObjRelInsertInput>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userAllowedSubsidiaries?: InputMaybe<UserAllowedSubsidiariesArrRelInsertInput>;
  users_favourite_table_filters?: InputMaybe<FavouriteTableFiltersArrRelInsertInput>;
};

/** aggregate max on columns */
export type UsersMaxFields = {
  __typename?: 'users_max_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  dateFormatPreference: Maybe<Scalars['String']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  languagePreference: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  lastRefreshedAt: Maybe<Scalars['timestamptz']['output']>;
  managerUserId: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  role: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "user_searchable_string" */
  searchableString: Maybe<Scalars['String']['output']>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "users" */
export type UsersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dateFormatPreference?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  languagePreference?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  lastRefreshedAt?: InputMaybe<OrderBy>;
  managerUserId?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UsersMinFields = {
  __typename?: 'users_min_fields';
  createdAt: Maybe<Scalars['timestamptz']['output']>;
  dateFormatPreference: Maybe<Scalars['String']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  departmentId: Maybe<Scalars['uuid']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['uuid']['output']>;
  languagePreference: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  lastRefreshedAt: Maybe<Scalars['timestamptz']['output']>;
  managerUserId: Maybe<Scalars['uuid']['output']>;
  organisationId: Maybe<Scalars['uuid']['output']>;
  role: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "user_searchable_string" */
  searchableString: Maybe<Scalars['String']['output']>;
  subsidiaryId: Maybe<Scalars['uuid']['output']>;
  updatedAt: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "users" */
export type UsersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dateFormatPreference?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  languagePreference?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  lastRefreshedAt?: InputMaybe<OrderBy>;
  managerUserId?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "users" */
export type UsersMutationResponse = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type UsersObjRelInsertInput = {
  data: UsersInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<UsersOnConflict>;
};

/** on_conflict condition type for table "users" */
export type UsersOnConflict = {
  constraint: UsersConstraint;
  update_columns: Array<UsersUpdateColumn>;
  where?: InputMaybe<UsersBoolExp>;
};

/** Ordering options when selecting data from "users". */
export type UsersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  customFieldValues_aggregate?: InputMaybe<CustomFieldValuesAggregateOrderBy>;
  dateFormatPreference?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  department?: InputMaybe<DepartmentsOrderBy>;
  departmentId?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  firstName?: InputMaybe<OrderBy>;
  group_users_aggregate?: InputMaybe<GroupUsersAggregateOrderBy>;
  hasConfigPermissions?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  isOutOfOffice?: InputMaybe<OrderBy>;
  isViewOnly?: InputMaybe<OrderBy>;
  languagePreference?: InputMaybe<OrderBy>;
  lastName?: InputMaybe<OrderBy>;
  lastRefreshedAt?: InputMaybe<OrderBy>;
  managerUser?: InputMaybe<UsersOrderBy>;
  managerUserId?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  request_step_task_users_aggregate?: InputMaybe<RequestStepTaskUsersAggregateOrderBy>;
  request_users_aggregate?: InputMaybe<RequestUsersAggregateOrderBy>;
  requests_aggregate?: InputMaybe<RequestsAggregateOrderBy>;
  role?: InputMaybe<OrderBy>;
  searchableString?: InputMaybe<OrderBy>;
  subsidiary?: InputMaybe<SubsidiariesOrderBy>;
  subsidiaryId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userAllowedSubsidiaries_aggregate?: InputMaybe<UserAllowedSubsidiariesAggregateOrderBy>;
  users_favourite_table_filters_aggregate?: InputMaybe<FavouriteTableFiltersAggregateOrderBy>;
};

/** primary key columns input for table: users */
export type UsersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "users" */
export enum UsersSelectColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DATEFORMATPREFERENCE = 'dateFormatPreference',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  EMAIL = 'email',
  /** column name */
  FIRSTNAME = 'firstName',
  /** column name */
  HASCONFIGPERMISSIONS = 'hasConfigPermissions',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISOUTOFOFFICE = 'isOutOfOffice',
  /** column name */
  ISVIEWONLY = 'isViewOnly',
  /** column name */
  LANGUAGEPREFERENCE = 'languagePreference',
  /** column name */
  LASTNAME = 'lastName',
  /** column name */
  LASTREFRESHEDAT = 'lastRefreshedAt',
  /** column name */
  MANAGERUSERID = 'managerUserId',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  ROLE = 'role',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users" */
export enum UsersSelectColumnUsersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  HASCONFIGPERMISSIONS = 'hasConfigPermissions',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISOUTOFOFFICE = 'isOutOfOffice',
  /** column name */
  ISVIEWONLY = 'isViewOnly'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users" */
export enum UsersSelectColumnUsersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  HASCONFIGPERMISSIONS = 'hasConfigPermissions',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISOUTOFOFFICE = 'isOutOfOffice',
  /** column name */
  ISVIEWONLY = 'isViewOnly'
}

/** input type for updating data in table "users" */
export type UsersSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dateFormatPreference?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  departmentId?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasConfigPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isOutOfOffice?: InputMaybe<Scalars['Boolean']['input']>;
  isViewOnly?: InputMaybe<Scalars['Boolean']['input']>;
  languagePreference?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastRefreshedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  managerUserId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  subsidiaryId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "users" */
export enum UsersUpdateColumn {
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  DATEFORMATPREFERENCE = 'dateFormatPreference',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DEPARTMENTID = 'departmentId',
  /** column name */
  EMAIL = 'email',
  /** column name */
  FIRSTNAME = 'firstName',
  /** column name */
  HASCONFIGPERMISSIONS = 'hasConfigPermissions',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ISOUTOFOFFICE = 'isOutOfOffice',
  /** column name */
  ISVIEWONLY = 'isViewOnly',
  /** column name */
  LANGUAGEPREFERENCE = 'languagePreference',
  /** column name */
  LASTNAME = 'lastName',
  /** column name */
  LASTREFRESHEDAT = 'lastRefreshedAt',
  /** column name */
  MANAGERUSERID = 'managerUserId',
  /** column name */
  ROLE = 'role',
  /** column name */
  SUBSIDIARYID = 'subsidiaryId',
  /** column name */
  UPDATEDAT = 'updatedAt'
}

export type UsersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersSetInput>;
  /** filter the rows which have to be updated */
  where: UsersBoolExp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidArrayComparisonExp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _eq?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _gt?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _gte?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['uuid']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _lte?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _neq?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['uuid']['input']>>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Boolean expression to compare columns of type "vector". All fields are combined with logical 'AND'. */
export type VectorComparisonExp = {
  _eq?: InputMaybe<Scalars['vector']['input']>;
  _gt?: InputMaybe<Scalars['vector']['input']>;
  _gte?: InputMaybe<Scalars['vector']['input']>;
  _in?: InputMaybe<Array<Scalars['vector']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['vector']['input']>;
  _lte?: InputMaybe<Scalars['vector']['input']>;
  _neq?: InputMaybe<Scalars['vector']['input']>;
  _nin?: InputMaybe<Array<Scalars['vector']['input']>>;
};

export type VectorSearchProductsAndServicesArgs = {
  result_limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['vector']['input']>;
};

/** columns and relationships of "vector_search_similarity_results" */
export type VectorSearchSimilarityResults = {
  __typename?: 'vector_search_similarity_results';
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  similarity: Scalars['float8']['output'];
  website: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "vector_search_similarity_results". All fields are combined with a logical 'AND'. */
export type VectorSearchSimilarityResultsBoolExp = {
  _and?: InputMaybe<Array<VectorSearchSimilarityResultsBoolExp>>;
  _not?: InputMaybe<VectorSearchSimilarityResultsBoolExp>;
  _or?: InputMaybe<Array<VectorSearchSimilarityResultsBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  similarity?: InputMaybe<Float8ComparisonExp>;
  website?: InputMaybe<StringComparisonExp>;
};

/** Ordering options when selecting data from "vector_search_similarity_results". */
export type VectorSearchSimilarityResultsOrderBy = {
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  similarity?: InputMaybe<OrderBy>;
  website?: InputMaybe<OrderBy>;
};

/** select columns of table "vector_search_similarity_results" */
export enum VectorSearchSimilarityResultsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  SIMILARITY = 'similarity',
  /** column name */
  WEBSITE = 'website'
}

/** Streaming cursor of the table "vector_search_similarity_results" */
export type VectorSearchSimilarityResultsStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: VectorSearchSimilarityResultsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type VectorSearchSimilarityResultsStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  similarity?: InputMaybe<Scalars['float8']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type VectorSearchSuppliersArgs = {
  result_limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['vector']['input']>;
};

/** columns and relationships of "workflow_condition_groups" */
export type WorkflowConditionGroups = {
  __typename?: 'workflow_condition_groups';
  condition: Maybe<Scalars['workflowConditionGroupsCondition']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user: Maybe<Users>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  precedence: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
  /** An object relationship */
  workflow: Workflows;
  workflowId: Scalars['uuid']['output'];
};

/** order by aggregate values of table "workflow_condition_groups" */
export type WorkflowConditionGroupsAggregateOrderBy = {
  avg?: InputMaybe<WorkflowConditionGroupsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<WorkflowConditionGroupsMaxOrderBy>;
  min?: InputMaybe<WorkflowConditionGroupsMinOrderBy>;
  stddev?: InputMaybe<WorkflowConditionGroupsStddevOrderBy>;
  stddev_pop?: InputMaybe<WorkflowConditionGroupsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<WorkflowConditionGroupsStddevSampOrderBy>;
  sum?: InputMaybe<WorkflowConditionGroupsSumOrderBy>;
  var_pop?: InputMaybe<WorkflowConditionGroupsVarPopOrderBy>;
  var_samp?: InputMaybe<WorkflowConditionGroupsVarSampOrderBy>;
  variance?: InputMaybe<WorkflowConditionGroupsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type WorkflowConditionGroupsAppendInput = {
  condition?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "workflow_condition_groups" */
export type WorkflowConditionGroupsArrRelInsertInput = {
  data: Array<WorkflowConditionGroupsInsertInput>;
  /** upsert condition */
  on_conflict?: InputMaybe<WorkflowConditionGroupsOnConflict>;
};

/** order by avg() on columns of table "workflow_condition_groups" */
export type WorkflowConditionGroupsAvgOrderBy = {
  precedence?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "workflow_condition_groups". All fields are combined with a logical 'AND'. */
export type WorkflowConditionGroupsBoolExp = {
  _and?: InputMaybe<Array<WorkflowConditionGroupsBoolExp>>;
  _not?: InputMaybe<WorkflowConditionGroupsBoolExp>;
  _or?: InputMaybe<Array<WorkflowConditionGroupsBoolExp>>;
  condition?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  created_by_user?: InputMaybe<UsersBoolExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  precedence?: InputMaybe<IntComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
  workflowId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "workflow_condition_groups" */
export enum WorkflowConditionGroupsConstraint {
  /** unique or primary key constraint on columns "id" */
  WORKFLOW_CONDITION_GROUPS_PKEY = 'workflow_condition_groups_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type WorkflowConditionGroupsDeleteAtPathInput = {
  condition?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type WorkflowConditionGroupsDeleteElemInput = {
  condition?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type WorkflowConditionGroupsDeleteKeyInput = {
  condition?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "workflow_condition_groups" */
export type WorkflowConditionGroupsIncInput = {
  precedence?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "workflow_condition_groups" */
export type WorkflowConditionGroupsInsertInput = {
  condition?: InputMaybe<Scalars['workflowConditionGroupsCondition']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<UsersObjRelInsertInput>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  precedence?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  updated_by_user?: InputMaybe<UsersObjRelInsertInput>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "workflow_condition_groups" */
export type WorkflowConditionGroupsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  precedence?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  workflowId?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "workflow_condition_groups" */
export type WorkflowConditionGroupsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  precedence?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  workflowId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "workflow_condition_groups" */
export type WorkflowConditionGroupsMutationResponse = {
  __typename?: 'workflow_condition_groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<WorkflowConditionGroups>;
};

/** on_conflict condition type for table "workflow_condition_groups" */
export type WorkflowConditionGroupsOnConflict = {
  constraint: WorkflowConditionGroupsConstraint;
  update_columns: Array<WorkflowConditionGroupsUpdateColumn>;
  where?: InputMaybe<WorkflowConditionGroupsBoolExp>;
};

/** Ordering options when selecting data from "workflow_condition_groups". */
export type WorkflowConditionGroupsOrderBy = {
  condition?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  created_by_user?: InputMaybe<UsersOrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  precedence?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  workflow?: InputMaybe<WorkflowsOrderBy>;
  workflowId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: workflow_condition_groups */
export type WorkflowConditionGroupsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type WorkflowConditionGroupsPrependInput = {
  condition?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "workflow_condition_groups" */
export enum WorkflowConditionGroupsSelectColumn {
  /** column name */
  CONDITION = 'condition',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PRECEDENCE = 'precedence',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy',
  /** column name */
  USERID = 'userId',
  /** column name */
  WORKFLOWID = 'workflowId'
}

/** input type for updating data in table "workflow_condition_groups" */
export type WorkflowConditionGroupsSetInput = {
  condition?: InputMaybe<Scalars['workflowConditionGroupsCondition']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  precedence?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by stddev() on columns of table "workflow_condition_groups" */
export type WorkflowConditionGroupsStddevOrderBy = {
  precedence?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "workflow_condition_groups" */
export type WorkflowConditionGroupsStddevPopOrderBy = {
  precedence?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "workflow_condition_groups" */
export type WorkflowConditionGroupsStddevSampOrderBy = {
  precedence?: InputMaybe<OrderBy>;
};

/** order by sum() on columns of table "workflow_condition_groups" */
export type WorkflowConditionGroupsSumOrderBy = {
  precedence?: InputMaybe<OrderBy>;
};

/** update columns of table "workflow_condition_groups" */
export enum WorkflowConditionGroupsUpdateColumn {
  /** column name */
  CONDITION = 'condition',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PRECEDENCE = 'precedence',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy',
  /** column name */
  USERID = 'userId',
  /** column name */
  WORKFLOWID = 'workflowId'
}

export type WorkflowConditionGroupsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<WorkflowConditionGroupsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<WorkflowConditionGroupsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<WorkflowConditionGroupsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<WorkflowConditionGroupsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WorkflowConditionGroupsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<WorkflowConditionGroupsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WorkflowConditionGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: WorkflowConditionGroupsBoolExp;
};

/** order by var_pop() on columns of table "workflow_condition_groups" */
export type WorkflowConditionGroupsVarPopOrderBy = {
  precedence?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "workflow_condition_groups" */
export type WorkflowConditionGroupsVarSampOrderBy = {
  precedence?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "workflow_condition_groups" */
export type WorkflowConditionGroupsVarianceOrderBy = {
  precedence?: InputMaybe<OrderBy>;
};

/** columns and relationships of "workflow_form_templates" */
export type WorkflowFormTemplates = {
  __typename?: 'workflow_form_templates';
  /** An object relationship */
  formTemplate: FormTemplates;
  formTemplateId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation: Organisations;
  /** An object relationship */
  workflow: Workflows;
  workflowId: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "workflow_form_templates". All fields are combined with a logical 'AND'. */
export type WorkflowFormTemplatesBoolExp = {
  _and?: InputMaybe<Array<WorkflowFormTemplatesBoolExp>>;
  _not?: InputMaybe<WorkflowFormTemplatesBoolExp>;
  _or?: InputMaybe<Array<WorkflowFormTemplatesBoolExp>>;
  formTemplate?: InputMaybe<FormTemplatesBoolExp>;
  formTemplateId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
  workflowId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "workflow_form_templates" */
export enum WorkflowFormTemplatesConstraint {
  /** unique or primary key constraint on columns "form_template_id", "workflow_id" */
  WORKFLOW_FORM_TEMPLATES_FORM_TEMPLATE_ID_WORKFLOW_ID_KEY = 'workflow_form_templates_form_template_id_workflow_id_key',
  /** unique or primary key constraint on columns "id" */
  WORKFLOW_FORM_TEMPLATES_PKEY = 'workflow_form_templates_pkey'
}

/** input type for inserting data into table "workflow_form_templates" */
export type WorkflowFormTemplatesInsertInput = {
  formTemplate?: InputMaybe<FormTemplatesObjRelInsertInput>;
  formTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
  workflowId?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "workflow_form_templates" */
export type WorkflowFormTemplatesMutationResponse = {
  __typename?: 'workflow_form_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<WorkflowFormTemplates>;
};

/** on_conflict condition type for table "workflow_form_templates" */
export type WorkflowFormTemplatesOnConflict = {
  constraint: WorkflowFormTemplatesConstraint;
  update_columns: Array<WorkflowFormTemplatesUpdateColumn>;
  where?: InputMaybe<WorkflowFormTemplatesBoolExp>;
};

/** Ordering options when selecting data from "workflow_form_templates". */
export type WorkflowFormTemplatesOrderBy = {
  formTemplate?: InputMaybe<FormTemplatesOrderBy>;
  formTemplateId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  workflow?: InputMaybe<WorkflowsOrderBy>;
  workflowId?: InputMaybe<OrderBy>;
};

/** select columns of table "workflow_form_templates" */
export enum WorkflowFormTemplatesSelectColumn {
  /** column name */
  FORMTEMPLATEID = 'formTemplateId',
  /** column name */
  ID = 'id',
  /** column name */
  WORKFLOWID = 'workflowId'
}

/** placeholder for update columns of table "workflow_form_templates" (current role has no relevant permissions) */
export enum WorkflowFormTemplatesUpdateColumn {
  /** placeholder (do not use) */
  _PLACEHOLDER = '_PLACEHOLDER'
}

/** Used to sort workflows without updating the workflow record */
export type WorkflowRanks = {
  __typename?: 'workflow_ranks';
  id: Scalars['uuid']['output'];
  organisation_id: Scalars['uuid']['output'];
  rank: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
  /** An object relationship */
  workflow: Workflows;
  workflow_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "workflow_ranks". All fields are combined with a logical 'AND'. */
export type WorkflowRanksBoolExp = {
  _and?: InputMaybe<Array<WorkflowRanksBoolExp>>;
  _not?: InputMaybe<WorkflowRanksBoolExp>;
  _or?: InputMaybe<Array<WorkflowRanksBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  organisation_id?: InputMaybe<UuidComparisonExp>;
  rank?: InputMaybe<IntComparisonExp>;
  updated_at?: InputMaybe<TimestamptzComparisonExp>;
  updated_by?: InputMaybe<UuidComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  workflow?: InputMaybe<WorkflowsBoolExp>;
  workflow_id?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "workflow_ranks" */
export enum WorkflowRanksConstraint {
  /** unique or primary key constraint on columns "id" */
  WORKFLOW_RANKS_PKEY = 'workflow_ranks_pkey',
  /** unique or primary key constraint on columns "workflow_id" */
  WORKFLOW_RANKS_WORKFLOW_ID_KEY = 'workflow_ranks_workflow_id_key'
}

/** input type for incrementing numeric columns in table "workflow_ranks" */
export type WorkflowRanksIncInput = {
  rank?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "workflow_ranks" */
export type WorkflowRanksInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
  updated_by_user?: InputMaybe<UsersObjRelInsertInput>;
  workflow?: InputMaybe<WorkflowsObjRelInsertInput>;
  workflow_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "workflow_ranks" */
export type WorkflowRanksMutationResponse = {
  __typename?: 'workflow_ranks_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<WorkflowRanks>;
};

/** input type for inserting object relation for remote table "workflow_ranks" */
export type WorkflowRanksObjRelInsertInput = {
  data: WorkflowRanksInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<WorkflowRanksOnConflict>;
};

/** on_conflict condition type for table "workflow_ranks" */
export type WorkflowRanksOnConflict = {
  constraint: WorkflowRanksConstraint;
  update_columns: Array<WorkflowRanksUpdateColumn>;
  where?: InputMaybe<WorkflowRanksBoolExp>;
};

/** Ordering options when selecting data from "workflow_ranks". */
export type WorkflowRanksOrderBy = {
  id?: InputMaybe<OrderBy>;
  organisation_id?: InputMaybe<OrderBy>;
  rank?: InputMaybe<OrderBy>;
  updated_at?: InputMaybe<OrderBy>;
  updated_by?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  workflow?: InputMaybe<WorkflowsOrderBy>;
  workflow_id?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: workflow_ranks */
export type WorkflowRanksPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "workflow_ranks" */
export enum WorkflowRanksSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  ORGANISATION_ID = 'organisation_id',
  /** column name */
  RANK = 'rank',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  WORKFLOW_ID = 'workflow_id'
}

/** input type for updating data in table "workflow_ranks" */
export type WorkflowRanksSetInput = {
  rank?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
  workflow_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "workflow_ranks" */
export enum WorkflowRanksUpdateColumn {
  /** column name */
  RANK = 'rank',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  UPDATED_BY = 'updated_by',
  /** column name */
  WORKFLOW_ID = 'workflow_id'
}

export type WorkflowRanksUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WorkflowRanksIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WorkflowRanksSetInput>;
  /** filter the rows which have to be updated */
  where: WorkflowRanksBoolExp;
};

/** columns and relationships of "workflow_state" */
export type WorkflowState = {
  __typename?: 'workflow_state';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "workflow_state". All fields are combined with a logical 'AND'. */
export type WorkflowStateBoolExp = {
  _and?: InputMaybe<Array<WorkflowStateBoolExp>>;
  _not?: InputMaybe<WorkflowStateBoolExp>;
  _or?: InputMaybe<Array<WorkflowStateBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum WorkflowStateEnum {
  /** DRAFT */
  DRAFT = 'DRAFT',
  /** Published */
  PUBLISHED = 'PUBLISHED',
  /** Workflow has been unpublished due to config errors */
  UNDER_MAINTENANCE = 'UNDER_MAINTENANCE'
}

/** Boolean expression to compare columns of type "workflow_state_enum". All fields are combined with logical 'AND'. */
export type WorkflowStateEnumComparisonExp = {
  _eq?: InputMaybe<WorkflowStateEnum>;
  _in?: InputMaybe<Array<WorkflowStateEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<WorkflowStateEnum>;
  _nin?: InputMaybe<Array<WorkflowStateEnum>>;
};

/** Ordering options when selecting data from "workflow_state". */
export type WorkflowStateOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "workflow_state" */
export enum WorkflowStateSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** columns and relationships of "workflow_type" */
export type WorkflowType = {
  __typename?: 'workflow_type';
  description: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "workflow_type". All fields are combined with a logical 'AND'. */
export type WorkflowTypeBoolExp = {
  _and?: InputMaybe<Array<WorkflowTypeBoolExp>>;
  _not?: InputMaybe<WorkflowTypeBoolExp>;
  _or?: InputMaybe<Array<WorkflowTypeBoolExp>>;
  description?: InputMaybe<StringComparisonExp>;
  value?: InputMaybe<StringComparisonExp>;
};

export enum WorkflowTypeEnum {
  /** Access Request */
  ACCESS_REQUEST = 'ACCESS_REQUEST',
  /** Assessment */
  ASSESSMENT = 'ASSESSMENT',
  /** Catalogue Purchase */
  CATALOGUE_PURCHASE = 'CATALOGUE_PURCHASE',
  /** External Workflow */
  EXTERNAL_WORKFLOW = 'EXTERNAL_WORKFLOW',
  /** New Purchase */
  NEW_PURCHASE = 'NEW_PURCHASE',
  /** Renewal */
  RENEWAL = 'RENEWAL'
}

/** Boolean expression to compare columns of type "workflow_type_enum". All fields are combined with logical 'AND'. */
export type WorkflowTypeEnumComparisonExp = {
  _eq?: InputMaybe<WorkflowTypeEnum>;
  _in?: InputMaybe<Array<WorkflowTypeEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<WorkflowTypeEnum>;
  _nin?: InputMaybe<Array<WorkflowTypeEnum>>;
};

/** Ordering options when selecting data from "workflow_type". */
export type WorkflowTypeOrderBy = {
  description?: InputMaybe<OrderBy>;
  value?: InputMaybe<OrderBy>;
};

/** select columns of table "workflow_type" */
export enum WorkflowTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  VALUE = 'value'
}

/** columns and relationships of "workflows" */
export type Workflows = {
  __typename?: 'workflows';
  canvasModelUpdatedAt: Scalars['timestamptz']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdBy: Maybe<Scalars['uuid']['output']>;
  deletedAt: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  expectedSLA: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  isArchived: Scalars['Boolean']['output'];
  /** An object relationship */
  organisation: Maybe<Organisations>;
  organisationId: Scalars['uuid']['output'];
  /** Configuration for request sidebar display, copied to request upon request creation */
  requestSidebarConfig: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  requests: Array<Requests>;
  /** An aggregate relationship */
  requests_aggregate: RequestsAggregate;
  routingCanvasModel: Scalars['workflowCanvasModel']['output'];
  state: WorkflowStateEnum;
  title: Scalars['String']['output'];
  type: WorkflowTypeEnum;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updated_by_user: Maybe<Users>;
  url: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Maybe<Users>;
  viewModel: Maybe<Scalars['jsonb']['output']>;
  viewModelUpdatedAt: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  workflow_condition_groups: Array<WorkflowConditionGroups>;
  /** An object relationship */
  workflow_rank: Maybe<WorkflowRanks>;
};


/** columns and relationships of "workflows" */
export type WorkflowsRequestSidebarConfigArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "workflows" */
export type WorkflowsRequestsArgs = {
  distinct_on: InputMaybe<Array<RequestsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestsOrderBy>>;
  where: InputMaybe<RequestsBoolExp>;
};


/** columns and relationships of "workflows" */
export type WorkflowsRequestsAggregateArgs = {
  distinct_on: InputMaybe<Array<RequestsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<RequestsOrderBy>>;
  where: InputMaybe<RequestsBoolExp>;
};


/** columns and relationships of "workflows" */
export type WorkflowsViewModelArgs = {
  path: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "workflows" */
export type WorkflowsWorkflowConditionGroupsArgs = {
  distinct_on: InputMaybe<Array<WorkflowConditionGroupsSelectColumn>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  order_by: InputMaybe<Array<WorkflowConditionGroupsOrderBy>>;
  where: InputMaybe<WorkflowConditionGroupsBoolExp>;
};

/** order by aggregate values of table "workflows" */
export type WorkflowsAggregateOrderBy = {
  avg?: InputMaybe<WorkflowsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<WorkflowsMaxOrderBy>;
  min?: InputMaybe<WorkflowsMinOrderBy>;
  stddev?: InputMaybe<WorkflowsStddevOrderBy>;
  stddev_pop?: InputMaybe<WorkflowsStddevPopOrderBy>;
  stddev_samp?: InputMaybe<WorkflowsStddevSampOrderBy>;
  sum?: InputMaybe<WorkflowsSumOrderBy>;
  var_pop?: InputMaybe<WorkflowsVarPopOrderBy>;
  var_samp?: InputMaybe<WorkflowsVarSampOrderBy>;
  variance?: InputMaybe<WorkflowsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type WorkflowsAppendInput = {
  /** Configuration for request sidebar display, copied to request upon request creation */
  requestSidebarConfig?: InputMaybe<Scalars['jsonb']['input']>;
  routingCanvasModel?: InputMaybe<Scalars['jsonb']['input']>;
  viewModel?: InputMaybe<Scalars['jsonb']['input']>;
};

/** order by avg() on columns of table "workflows" */
export type WorkflowsAvgOrderBy = {
  expectedSLA?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "workflows". All fields are combined with a logical 'AND'. */
export type WorkflowsBoolExp = {
  _and?: InputMaybe<Array<WorkflowsBoolExp>>;
  _not?: InputMaybe<WorkflowsBoolExp>;
  _or?: InputMaybe<Array<WorkflowsBoolExp>>;
  canvasModelUpdatedAt?: InputMaybe<TimestamptzComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  deletedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  expectedSLA?: InputMaybe<IntComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  organisation?: InputMaybe<OrganisationsBoolExp>;
  organisationId?: InputMaybe<UuidComparisonExp>;
  requestSidebarConfig?: InputMaybe<JsonbComparisonExp>;
  requests?: InputMaybe<RequestsBoolExp>;
  requests_aggregate?: InputMaybe<RequestsAggregateBoolExp>;
  routingCanvasModel?: InputMaybe<JsonbComparisonExp>;
  state?: InputMaybe<WorkflowStateEnumComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<WorkflowTypeEnumComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  updatedBy?: InputMaybe<UuidComparisonExp>;
  updated_by_user?: InputMaybe<UsersBoolExp>;
  url?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  viewModel?: InputMaybe<JsonbComparisonExp>;
  viewModelUpdatedAt?: InputMaybe<TimestamptzComparisonExp>;
  workflow_condition_groups?: InputMaybe<WorkflowConditionGroupsBoolExp>;
  workflow_rank?: InputMaybe<WorkflowRanksBoolExp>;
};

/** unique or primary key constraints on table "workflows" */
export enum WorkflowsConstraint {
  /** unique or primary key constraint on columns "id" */
  WORKFLOWS_PKEY = 'workflows_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type WorkflowsDeleteAtPathInput = {
  /** Configuration for request sidebar display, copied to request upon request creation */
  requestSidebarConfig?: InputMaybe<Array<Scalars['String']['input']>>;
  routingCanvasModel?: InputMaybe<Array<Scalars['String']['input']>>;
  viewModel?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type WorkflowsDeleteElemInput = {
  /** Configuration for request sidebar display, copied to request upon request creation */
  requestSidebarConfig?: InputMaybe<Scalars['Int']['input']>;
  routingCanvasModel?: InputMaybe<Scalars['Int']['input']>;
  viewModel?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type WorkflowsDeleteKeyInput = {
  /** Configuration for request sidebar display, copied to request upon request creation */
  requestSidebarConfig?: InputMaybe<Scalars['String']['input']>;
  routingCanvasModel?: InputMaybe<Scalars['String']['input']>;
  viewModel?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "workflows" */
export type WorkflowsIncInput = {
  expectedSLA?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "workflows" */
export type WorkflowsInsertInput = {
  canvasModelUpdatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectedSLA?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration for request sidebar display, copied to request upon request creation */
  requestSidebarConfig?: InputMaybe<Scalars['jsonb']['input']>;
  requests?: InputMaybe<RequestsArrRelInsertInput>;
  routingCanvasModel?: InputMaybe<Scalars['jsonb']['input']>;
  state?: InputMaybe<WorkflowStateEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<WorkflowTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  updated_by_user?: InputMaybe<UsersObjRelInsertInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  viewModel?: InputMaybe<Scalars['jsonb']['input']>;
  viewModelUpdatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  workflow_condition_groups?: InputMaybe<WorkflowConditionGroupsArrRelInsertInput>;
  workflow_rank?: InputMaybe<WorkflowRanksObjRelInsertInput>;
};

/** order by max() on columns of table "workflows" */
export type WorkflowsMaxOrderBy = {
  canvasModelUpdatedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  expectedSLA?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  viewModelUpdatedAt?: InputMaybe<OrderBy>;
};

/** order by min() on columns of table "workflows" */
export type WorkflowsMinOrderBy = {
  canvasModelUpdatedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  expectedSLA?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  url?: InputMaybe<OrderBy>;
  viewModelUpdatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "workflows" */
export type WorkflowsMutationResponse = {
  __typename?: 'workflows_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflows>;
};

/** input type for inserting object relation for remote table "workflows" */
export type WorkflowsObjRelInsertInput = {
  data: WorkflowsInsertInput;
  /** upsert condition */
  on_conflict?: InputMaybe<WorkflowsOnConflict>;
};

/** on_conflict condition type for table "workflows" */
export type WorkflowsOnConflict = {
  constraint: WorkflowsConstraint;
  update_columns: Array<WorkflowsUpdateColumn>;
  where?: InputMaybe<WorkflowsBoolExp>;
};

/** Ordering options when selecting data from "workflows". */
export type WorkflowsOrderBy = {
  canvasModelUpdatedAt?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  deletedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  expectedSLA?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  organisation?: InputMaybe<OrganisationsOrderBy>;
  organisationId?: InputMaybe<OrderBy>;
  requestSidebarConfig?: InputMaybe<OrderBy>;
  requests_aggregate?: InputMaybe<RequestsAggregateOrderBy>;
  routingCanvasModel?: InputMaybe<OrderBy>;
  state?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  updatedBy?: InputMaybe<OrderBy>;
  updated_by_user?: InputMaybe<UsersOrderBy>;
  url?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  viewModel?: InputMaybe<OrderBy>;
  viewModelUpdatedAt?: InputMaybe<OrderBy>;
  workflow_condition_groups_aggregate?: InputMaybe<WorkflowConditionGroupsAggregateOrderBy>;
  workflow_rank?: InputMaybe<WorkflowRanksOrderBy>;
};

/** primary key columns input for table: workflows */
export type WorkflowsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type WorkflowsPrependInput = {
  /** Configuration for request sidebar display, copied to request upon request creation */
  requestSidebarConfig?: InputMaybe<Scalars['jsonb']['input']>;
  routingCanvasModel?: InputMaybe<Scalars['jsonb']['input']>;
  viewModel?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "workflows" */
export enum WorkflowsSelectColumn {
  /** column name */
  CANVASMODELUPDATEDAT = 'canvasModelUpdatedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EXPECTEDSLA = 'expectedSLA',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  ORGANISATIONID = 'organisationId',
  /** column name */
  REQUESTSIDEBARCONFIG = 'requestSidebarConfig',
  /** column name */
  ROUTINGCANVASMODEL = 'routingCanvasModel',
  /** column name */
  STATE = 'state',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy',
  /** column name */
  URL = 'url',
  /** column name */
  VIEWMODEL = 'viewModel',
  /** column name */
  VIEWMODELUPDATEDAT = 'viewModelUpdatedAt'
}

/** input type for updating data in table "workflows" */
export type WorkflowsSetInput = {
  canvasModelUpdatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectedSLA?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration for request sidebar display, copied to request upon request creation */
  requestSidebarConfig?: InputMaybe<Scalars['jsonb']['input']>;
  routingCanvasModel?: InputMaybe<Scalars['jsonb']['input']>;
  state?: InputMaybe<WorkflowStateEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<WorkflowTypeEnum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  viewModel?: InputMaybe<Scalars['jsonb']['input']>;
  viewModelUpdatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "workflows" */
export type WorkflowsStddevOrderBy = {
  expectedSLA?: InputMaybe<OrderBy>;
};

/** order by stddev_pop() on columns of table "workflows" */
export type WorkflowsStddevPopOrderBy = {
  expectedSLA?: InputMaybe<OrderBy>;
};

/** order by stddev_samp() on columns of table "workflows" */
export type WorkflowsStddevSampOrderBy = {
  expectedSLA?: InputMaybe<OrderBy>;
};

/** order by sum() on columns of table "workflows" */
export type WorkflowsSumOrderBy = {
  expectedSLA?: InputMaybe<OrderBy>;
};

/** update columns of table "workflows" */
export enum WorkflowsUpdateColumn {
  /** column name */
  CANVASMODELUPDATEDAT = 'canvasModelUpdatedAt',
  /** column name */
  CREATEDAT = 'createdAt',
  /** column name */
  CREATEDBY = 'createdBy',
  /** column name */
  DELETEDAT = 'deletedAt',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  EXPECTEDSLA = 'expectedSLA',
  /** column name */
  ID = 'id',
  /** column name */
  ISARCHIVED = 'isArchived',
  /** column name */
  REQUESTSIDEBARCONFIG = 'requestSidebarConfig',
  /** column name */
  ROUTINGCANVASMODEL = 'routingCanvasModel',
  /** column name */
  STATE = 'state',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATEDAT = 'updatedAt',
  /** column name */
  UPDATEDBY = 'updatedBy',
  /** column name */
  URL = 'url',
  /** column name */
  VIEWMODEL = 'viewModel',
  /** column name */
  VIEWMODELUPDATEDAT = 'viewModelUpdatedAt'
}

export type WorkflowsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<WorkflowsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<WorkflowsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<WorkflowsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<WorkflowsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WorkflowsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<WorkflowsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WorkflowsSetInput>;
  /** filter the rows which have to be updated */
  where: WorkflowsBoolExp;
};

/** order by var_pop() on columns of table "workflows" */
export type WorkflowsVarPopOrderBy = {
  expectedSLA?: InputMaybe<OrderBy>;
};

/** order by var_samp() on columns of table "workflows" */
export type WorkflowsVarSampOrderBy = {
  expectedSLA?: InputMaybe<OrderBy>;
};

/** order by variance() on columns of table "workflows" */
export type WorkflowsVarianceOrderBy = {
  expectedSLA?: InputMaybe<OrderBy>;
};

/** columns and relationships of "z_workaround_ccdo_count" */
export type ZWorkaroundCcdoCount = {
  __typename?: 'z_workaround_ccdo_count';
  filtered_count: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to filter rows from the table "z_workaround_ccdo_count". All fields are combined with a logical 'AND'. */
export type ZWorkaroundCcdoCountBoolExp = {
  _and?: InputMaybe<Array<ZWorkaroundCcdoCountBoolExp>>;
  _not?: InputMaybe<ZWorkaroundCcdoCountBoolExp>;
  _or?: InputMaybe<Array<ZWorkaroundCcdoCountBoolExp>>;
  filtered_count?: InputMaybe<IntComparisonExp>;
};

/** Ordering options when selecting data from "z_workaround_ccdo_count". */
export type ZWorkaroundCcdoCountOrderBy = {
  filtered_count?: InputMaybe<OrderBy>;
};

/** select columns of table "z_workaround_ccdo_count" */
export enum ZWorkaroundCcdoCountSelectColumn {
  /** column name */
  FILTERED_COUNT = 'filtered_count'
}

/** Streaming cursor of the table "z_workaround_ccdo_count" */
export type ZWorkaroundCcdoCountStreamCursorInput = {
  /** Stream column input with initial value */
  initial_value: ZWorkaroundCcdoCountStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ZWorkaroundCcdoCountStreamCursorValueInput = {
  filtered_count?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRefreshTokenMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  expiresAt: Scalars['timestamptz']['input'];
}>;


export type CreateRefreshTokenMutation = { __typename?: 'mutation_root', refreshToken: { __typename?: 'auth_refresh_tokens', id: string, organisationId: string, userId: string, expiresAt: string, redeemedAt: string | null } | null };

export type GetRefreshTokenQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRefreshTokenQuery = { __typename?: 'query_root', refreshToken: { __typename?: 'auth_refresh_tokens', id: string, expiresAt: string, userId: string, organisationId: string, redeemedAt: string | null } | null };

export type RedeemRefreshTokenMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  redeemedAt: Scalars['timestamptz']['input'];
}>;


export type RedeemRefreshTokenMutation = { __typename?: 'mutation_root', update_auth_refresh_tokens_by_pk: { __typename?: 'auth_refresh_tokens', id: string, expiresAt: string, userId: string, organisationId: string, redeemedAt: string | null } | null };

export type UpdateFormTemplateByTitleMutationVariables = Exact<{
  title: Scalars['String']['input'];
  newConfig: Scalars['jsonb']['input'];
}>;


export type UpdateFormTemplateByTitleMutation = { __typename?: 'mutation_root', update_form_templates: { __typename?: 'form_templates_mutation_response', affected_rows: number } | null };

export type InsertMultipleOrganisationSuppliersMutationVariables = Exact<{
  objects: Array<OrganisationSuppliersInsertInput> | OrganisationSuppliersInsertInput;
}>;


export type InsertMultipleOrganisationSuppliersMutation = { __typename?: 'mutation_root', insert_organisation_suppliers: { __typename?: 'organisation_suppliers_mutation_response', returning: Array<{ __typename?: 'organisation_suppliers', id: string, name: string }> } | null };

export type InsertOrgDefaultCurrencyMutationVariables = Exact<{
  object: OrganisationSettingsInsertInput;
}>;


export type InsertOrgDefaultCurrencyMutation = { __typename?: 'mutation_root', insert_organisation_settings_one: { __typename?: 'organisation_settings', name: string } | null };

export type InsertTestBudgetsMutationVariables = Exact<{
  objects: Array<BudgetsInsertInput> | BudgetsInsertInput;
}>;


export type InsertTestBudgetsMutation = { __typename?: 'mutation_root', insert_budgets: { __typename?: 'budgets_mutation_response', returning: Array<{ __typename?: 'budgets', id: string, name: string }> } | null };

export type AddOmneanMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
}>;


export type AddOmneanMutation = { __typename?: 'mutation_root', newUser: { __typename?: 'users', id: string, groupUsers: Array<{ __typename?: 'group_users', id: string, group: { __typename?: 'groups', id: string } }> } | null };

export type GetOmneaSupportGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOmneaSupportGroupsQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'groups', id: string, name: string }> };

export type GetHistoricSubmissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHistoricSubmissionsQuery = { __typename?: 'query_root', organisation_supplier_historic_submissions: Array<{ __typename?: 'organisation_supplier_historic_submissions', id: string, createdAt: string, submittedAt: string | null, title: string | null, response: any, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string } }> };

export type GetReportingRawDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportingRawDataQuery = { __typename?: 'query_root', organisations: Array<{ __typename?: 'organisations', id: string, domain: string }>, organisation_fx_rates: Array<{ __typename?: 'organisation_fx_rates', id: string, fxRate: number, code: OverrideTypes["CurrencyCode"] }>, requests: Array<{ __typename?: 'requests', id: string, name: string, state: string | null, completedAt: string | null, renewal: { __typename?: 'renewals', id: string } | null, request_forms: Array<{ __typename?: 'request_forms', id: string, type: FormTypeEnum, request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }> }>, renewals: Array<{ __typename?: 'renewals', id: string, costValue: number, costCurrency: OverrideTypes["CurrencyCode"], product: { __typename?: 'organisation_products_and_services', id: string, displayName: string } | null, request: { __typename?: 'requests', id: string, name: string, state: string | null, completedAt: string | null, request_forms: Array<{ __typename?: 'request_forms', id: string, request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }> } | null }> };

export type GetRequestBlockDurationRawDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequestBlockDurationRawDataQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'requests', id: string, createdAt: string, deletedAt: string | null, completedAt: string | null, publicId: string, state: string | null, name: string, organisation: { __typename?: 'organisations', id: string, domain: string, name: string }, workflow: { __typename?: 'workflows', title: string, type: WorkflowTypeEnum }, steps: Array<{ __typename?: 'request_steps', createdAt: string, completedAt: string | null, deletedAt: string | null, state: RequestStepStateEnum, output: any | null, id: string, label: any }> }> };

export type GetCustomCoreDataOptionsQueryVariables = Exact<{
  customCoreDataId: Scalars['uuid']['input'];
}>;


export type GetCustomCoreDataOptionsQuery = { __typename?: 'query_root', customCoreDataOptions: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string }> };

export type GetFormTemplateByTitleQueryVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type GetFormTemplateByTitleQuery = { __typename?: 'query_root', form_templates: Array<{ __typename?: 'form_templates', id: string, type: FormTypeEnum }> };

export type GetIntakeAndRenewalAssessmentFormsQueryVariables = Exact<{
  organisationId: Scalars['uuid']['input'];
}>;


export type GetIntakeAndRenewalAssessmentFormsQuery = { __typename?: 'query_root', forms: Array<{ __typename?: 'request_forms', id: string, type: FormTypeEnum, request: { __typename?: 'requests', id: string, publicId: string }, request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null }> }> };

export type UpdateLineItemTypesMutationVariables = Exact<{
  updates: Array<LineItemTypesUpdates> | LineItemTypesUpdates;
}>;


export type UpdateLineItemTypesMutation = { __typename?: 'mutation_root', update_line_item_types_many: Array<{ __typename?: 'line_item_types_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'line_item_types', id: string }> } | null> | null };

export type GetCustomCoreDataByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetCustomCoreDataByNameQuery = { __typename?: 'query_root', custom_core_data: Array<{ __typename?: 'custom_core_data', id: string, organisationId: string }> };

export type InsertCoreDataDependenciesMutationVariables = Exact<{
  objects: Array<CoreDataDependenciesInsertInput> | CoreDataDependenciesInsertInput;
}>;


export type InsertCoreDataDependenciesMutation = { __typename?: 'mutation_root', insert_core_data_dependencies: { __typename?: 'core_data_dependencies_mutation_response', returning: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string }> } | null };

export type GetAllOrganisationsWorkflowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOrganisationsWorkflowsQuery = { __typename?: 'query_root', organisations: Array<{ __typename?: 'organisations', name: string, id: string, workflows: Array<{ __typename?: 'workflows', id: string, title: string, state: WorkflowStateEnum, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"] }> }> };

export type GetFormTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFormTemplatesQuery = { __typename?: 'query_root', form_templates: Array<{ __typename?: 'form_templates', organisationId: string, createdAt: string, createdBy: string | null, updatedBy: string | null, config: OverrideTypes["FormConfig"], description: string, id: string, internalId: string | null, state: FormTemplateStateEnum, title: string, integration: OverrideTypes["Integration"] | null, externalTitle: string | null, type: FormTypeEnum, updatedAt: string, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null }> };

export type DeleteRequestStepTaskMutationVariables = Exact<{
  requestStepTaskIdToDelete: Scalars['uuid']['input'];
}>;


export type DeleteRequestStepTaskMutation = { __typename?: 'mutation_root', delete_request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string } | null };

export type SetupAssigneesMutationVariables = Exact<{
  requestGroupsObjects: Array<RequestGroupsInsertInput> | RequestGroupsInsertInput;
  requestStepGroupsObjects: Array<RequestStepGroupsInsertInput> | RequestStepGroupsInsertInput;
  requestUsersObjects: Array<RequestUsersInsertInput> | RequestUsersInsertInput;
  requestStepUsersObjects: Array<RequestStepUsersInsertInput> | RequestStepUsersInsertInput;
}>;


export type SetupAssigneesMutation = { __typename?: 'mutation_root', insert_request_groups: { __typename?: 'request_groups_mutation_response', returning: Array<{ __typename?: 'request_groups', id: string }> } | null, insert_request_step_groups: { __typename?: 'request_step_groups_mutation_response', returning: Array<{ __typename?: 'request_step_groups', id: string }> } | null, insert_request_users: { __typename?: 'request_users_mutation_response', returning: Array<{ __typename?: 'request_users', id: string }> } | null, insert_request_step_users: { __typename?: 'request_step_users_mutation_response', returning: Array<{ __typename?: 'request_step_users', id: string }> } | null };

export type InsertCustomCoreDataOptionsMutationVariables = Exact<{
  input: Array<CustomCoreDataOptionsInsertInput> | CustomCoreDataOptionsInsertInput;
}>;


export type InsertCustomCoreDataOptionsMutation = { __typename?: 'mutation_root', insert_custom_core_data_options: { __typename?: 'custom_core_data_options_mutation_response', returning: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, coreDataId: string }> } | null };

export type GetCustomFieldValueByEntityIdAndCustomCoreDataOptionIdQueryVariables = Exact<{
  entityId: Scalars['uuid']['input'];
  customCoreDataOptionId: Scalars['uuid']['input'];
}>;


export type GetCustomFieldValueByEntityIdAndCustomCoreDataOptionIdQuery = { __typename?: 'query_root', custom_field_values: Array<{ __typename?: 'custom_field_values', id: string }> };

export type UpdateWorkflowConditionGroupScriptMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  params: WorkflowConditionGroupsSetInput;
}>;


export type UpdateWorkflowConditionGroupScriptMutation = { __typename?: 'mutation_root', update_workflow_condition_groups_by_pk: { __typename?: 'workflow_condition_groups', id: string, name: string } | null };

export type GetOrganisationSuppliersEmbeddingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationSuppliersEmbeddingQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, publicId: number, embedding: string | null }> };

export type GetSuppliersWithExternalContactsQueryVariables = Exact<{
  where: OrganisationSuppliersBoolExp;
}>;


export type GetSuppliersWithExternalContactsQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, isPrimary: boolean, deletedAt: string | null }> }> };

export type DeleteOrganisationProductsAndServicesMutationVariables = Exact<{
  query: OrganisationProductsAndServicesBoolExp;
}>;


export type DeleteOrganisationProductsAndServicesMutation = { __typename?: 'mutation_root', update_organisation_products_and_services: { __typename?: 'organisation_products_and_services_mutation_response', returning: Array<{ __typename?: 'organisation_products_and_services', id: string, name: string, displayName: string, website: string | null, logoUrl: string | null, createdAt: string | null, updatedAt: string | null, description: string | null, isArchived: boolean, state: OrganisationProductsAndServicesStateEnum, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, organisation_supplier: { __typename?: 'organisation_suppliers', state: OrganisationSupplierStateEnum, id: string, website: string | null, logoUrl: string | null, name: string, externalLink: string | null, organisation_supplier_brand: { __typename?: 'organisation_suppliers_brands', id: string, supplierId: string | null } | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, isPrimary: boolean, phoneNumber: string | null, title: string | null }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> }, engagements: Array<{ __typename?: 'engagements', id: string, name: string, department: string | null }> }> } | null };

export type GetAllOrgSupplierAndProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOrgSupplierAndProductsQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, state: OrganisationSupplierStateEnum, organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, state: OrganisationProductsAndServicesStateEnum, isArchived: boolean, displayName: string, logoUrl: string | null, website: string | null, organisationSupplierId: string, organisation_products_and_services_requests: Array<{ __typename?: 'requests', id: string }> }> }> };

export type GetSuppliersWithProductsForProductMergeQueryVariables = Exact<{
  supplierIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  productIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetSuppliersWithProductsForProductMergeQuery = { __typename?: 'query_root', suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, state: OrganisationSupplierStateEnum, products: Array<{ __typename?: 'organisation_products_and_services', id: string, state: OrganisationProductsAndServicesStateEnum, isArchived: boolean, displayName: string, logoUrl: string | null, website: string | null, organisationSupplierId: string, organisation_products_and_services_requests: Array<{ __typename?: 'requests', id: string }>, activeRequests: Array<{ __typename?: 'requests', id: string }>, scheduledRenewals: Array<{ __typename?: 'renewals', id: string }>, scheduledAssessments: Array<{ __typename?: 'assessments', id: string }> }> }> };

export type GetSupplierForDedupingQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSupplierForDedupingQuery = { __typename?: 'query_root', supplier: { __typename?: 'organisation_suppliers', id: string, createdAt: string, updated_at: string, deleted_at: string | null, website: string | null, logoUrl: string | null, name: string, isReseller: boolean, files: any | null, state: OrganisationSupplierStateEnum, description: string | null, externalLink: string | null, address: OverrideTypes["Address"] | null, legalName: string | null, isPerson: boolean | null, remoteId: string | null, remoteLink: string | null, lastAssessmentDate: string | null, organisation_supplier_brand: { __typename?: 'organisation_suppliers_brands', id: string, supplierId: string | null } | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, title: string | null, isPrimary: boolean }>, organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, isArchived: boolean, displayName: string, logoUrl: string | null, website: string | null, organisation_products_and_services_requests: Array<{ __typename?: 'requests', id: string }> }>, organisation_suppliers_requests: Array<{ __typename?: 'requests', id: string, completedAt: string | null, state: string | null, deletedAt: string | null, name: string, engagement: { __typename?: 'engagements', id: string, organisationSupplierId: string, organisationProductOrServiceId: string | null } | null }>, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tagId: string, tag: { __typename?: 'tags', name: string } }>, engagements: Array<{ __typename?: 'engagements', id: string, organisationProductOrServiceId: string | null }> } | null };

export type MoveEngagementSuppliersMutationVariables = Exact<{
  fromSupplier: Scalars['uuid']['input'];
  toSupplier: InputMaybe<Scalars['uuid']['input']>;
}>;


export type MoveEngagementSuppliersMutation = { __typename?: 'mutation_root', update_engagements_many: Array<{ __typename?: 'engagements_mutation_response', affected_rows: number } | null> | null };

export type MoveProductSuppliersMutationVariables = Exact<{
  fromSupplier: Scalars['uuid']['input'];
  toSupplier: InputMaybe<Scalars['uuid']['input']>;
}>;


export type MoveProductSuppliersMutation = { __typename?: 'mutation_root', update_organisation_products_and_services_many: Array<{ __typename?: 'organisation_products_and_services_mutation_response', affected_rows: number } | null> | null };

export type MoveRequestSuppliersMutationVariables = Exact<{
  fromSupplier: Scalars['uuid']['input'];
  toSupplier: InputMaybe<Scalars['uuid']['input']>;
}>;


export type MoveRequestSuppliersMutation = { __typename?: 'mutation_root', update_requests_many: Array<{ __typename?: 'requests_mutation_response', affected_rows: number } | null> | null };

export type SetSupplierDataMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  data: OrganisationSuppliersSetInput;
}>;


export type SetSupplierDataMutation = { __typename?: 'mutation_root', update_organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', id: string } | null };

export type SoftDeleteDupedSupplierMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SoftDeleteDupedSupplierMutation = { __typename?: 'mutation_root', update_organisation_products_and_services: { __typename?: 'organisation_products_and_services_mutation_response', affected_rows: number } | null, update_organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', id: string } | null };

export type GetOrgSuppliersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgSuppliersQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, remoteId: string | null, publicId: number, engagements: Array<{ __typename?: 'engagements', id: string, supplierLegalEntity: string | null }> }> };

export type GetSupplierByRemoteIdQueryVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type GetSupplierByRemoteIdQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string }> };

export type GetSupplierByPublicIdQueryVariables = Exact<{
  publicId: Scalars['Int']['input'];
}>;


export type GetSupplierByPublicIdQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string }> };

export type GetUserByNameQueryVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}>;


export type GetUserByNameQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, isArchived: boolean }> };

export type GetOrgProductsForSupplierQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
}>;


export type GetOrgProductsForSupplierQuery = { __typename?: 'query_root', organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, displayName: string, logoUrl: string | null, website: string | null, description: string | null }> };

export type DeleteArchivedUsersByIdMutationVariables = Exact<{
  ids: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteArchivedUsersByIdMutation = { __typename?: 'mutation_root', delete_users: { __typename?: 'users_mutation_response', affected_rows: number } | null };

export type GetOrganisationUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, email: string, createdAt: string, role: string, isArchived: boolean, managerUserId: string | null }> };

export type UnsetManagerForUsersMutationVariables = Exact<{
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UnsetManagerForUsersMutation = { __typename?: 'mutation_root', update_users: { __typename?: 'users_mutation_response', affected_rows: number } | null };

export type ArchiveUsersMutationVariables = Exact<{
  ids: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type ArchiveUsersMutation = { __typename?: 'mutation_root', update_users: { __typename?: 'users_mutation_response', affected_rows: number } | null };

export type GetOrganisationByDomainQueryVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type GetOrganisationByDomainQuery = { __typename?: 'query_root', organisations: Array<{ __typename?: 'organisations', id: string, domain: string }> };

export type GetActiveCoreDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveCoreDataQuery = { __typename?: 'query_root', departments: Array<{ __typename?: 'departments', id: string, isArchived: boolean, name: string }>, subsidiaries: Array<{ __typename?: 'subsidiaries', id: string, isArchived: boolean, name: string }>, payment_methods: Array<{ __typename?: 'payment_methods', id: string, isArchived: boolean, name: string }>, payment_terms: Array<{ __typename?: 'payment_terms', id: string, isArchived: boolean, name: string }>, organisation_fx_rates: Array<{ __typename?: 'organisation_fx_rates', id: string, isArchived: boolean, name: OverrideTypes["CurrencyCode"] }>, addresses: Array<{ __typename?: 'addresses', id: string, name: string | null, isArchived: boolean }>, line_item_types: Array<{ __typename?: 'line_item_types', id: string, name: string, isArchived: boolean }> };

export type GetPurchaseOrderByRequestIdQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetPurchaseOrderByRequestIdQuery = { __typename?: 'query_root', purchase_orders: Array<{ __typename?: 'purchase_orders', id: string, requestId: string, organisationId: string, remoteNumber: string | null, remoteId: string | null, remoteLink: string | null, remoteStatus: string | null, remoteTotalValue: number | null, remoteInvoicedValue: number, remotePaidValue: number, currencyId: string | null, status: string }> };

export type PurchaseOrderFragmentFragment = { __typename?: 'purchase_orders', id: string, requestId: string, organisationId: string, remoteNumber: string | null, remoteId: string | null, remoteLink: string | null, remoteStatus: string | null, remoteTotalValue: number | null, remoteInvoicedValue: number, remotePaidValue: number, currencyId: string | null, status: string };

export type GetFormTemplatesByTypeQueryVariables = Exact<{
  type: FormTypeEnum;
}>;


export type GetFormTemplatesByTypeQuery = { __typename?: 'query_root', form_templates: Array<{ __typename?: 'form_templates', id: string, title: string, type: FormTypeEnum, config: OverrideTypes["FormConfig"], updatedAt: string }> };

export type CreateAgreementWithTermsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  supplierId: Scalars['uuid']['input'];
  ownerId: InputMaybe<Scalars['uuid']['input']>;
  subsidiaryId: InputMaybe<Scalars['uuid']['input']>;
  paymentMethodId: InputMaybe<Scalars['uuid']['input']>;
  paymentTermId: InputMaybe<Scalars['uuid']['input']>;
  agreementTerms: Array<AgreementTermsInsertInput> | AgreementTermsInsertInput;
}>;


export type CreateAgreementWithTermsMutation = { __typename?: 'mutation_root', insert_agreements_one: { __typename?: 'agreements', id: string, name: string, publicId: number, supplierId: string, agreement_terms: Array<{ __typename?: 'agreement_terms', id: string, totalAmount: number | null, currencyCode: OverrideTypes["CurrencyCode"] | null, fxRate: number | null }> } | null };

export type DeleteAgreementMutationVariables = Exact<{
  agreementId: Scalars['uuid']['input'];
}>;


export type DeleteAgreementMutation = { __typename?: 'mutation_root', delete_renewals: { __typename?: 'renewals_mutation_response', affected_rows: number } | null, delete_agreement: { __typename?: 'agreements', id: string } | null, delete_agreement_terms: { __typename?: 'agreement_terms_mutation_response', affected_rows: number } | null };

export type GetAgreementByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  includeOwners: Scalars['Boolean']['input'];
  includeSubsidiary: Scalars['Boolean']['input'];
  includePaymentTerm: Scalars['Boolean']['input'];
  includePaymentMethod: Scalars['Boolean']['input'];
  includeCustomFields: Scalars['Boolean']['input'];
  includeProducts: Scalars['Boolean']['input'];
  customFields: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  includeTags: Scalars['Boolean']['input'];
  includePrimaryDepartment: Scalars['Boolean']['input'];
  includeRevisions: Scalars['Boolean']['input'];
  includeRevisionsResponse: Scalars['Boolean']['input'];
}>;


export type GetAgreementByIdQuery = { __typename?: 'query_root', agreement: { __typename?: 'agreements', id: string, createdAt: string, deletedAt: string | null, name: string, publicId: number, remoteId: string | null, description: string | null, parentId: string | null, ownerId: string | null, subsidiaryId: string | null, paymentTermId: string | null, paymentMethodId: string | null, refreshPricesAt: string | null, agreement_terms: Array<{ __typename?: 'agreement_terms', createdAt: string, name: string, startDate: any, endDate: any | null, termType: OverrideTypes["AgreementTermType"], cancelledAt: any | null, autoRenew: boolean, id: string, cancelByDate: any | null, totalAmount: number | null, totalAmountInDefaultCurrency: number | null, currencyCode: OverrideTypes["CurrencyCode"] | null, fxRate: number | null, fxTime: string | null, cancellationNoticeDayCount: number | null, primaryDepartmentId: string | null, primaryDepartment?: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, products: Array<{ __typename?: 'agreement_term_products', id: string, organisationProductId: string, organisation_products_and_service?: { __typename?: 'organisation_products_and_services', id: string, name: string } }>, futureRenewal: Array<{ __typename?: 'renewals', id: string, workflowStartDate: any | null, workflowStartDayCount: number, cancellationNoticeDayCount: number | null, workflowInitialAssigneeId: string | null, status: string | null, renewalDate: string, renewedAt: string | null, autoStartEnabled: boolean, sourceRequestId: string | null, organisationProductId: string | null, organisationSupplierId: string, workflow: { __typename?: 'workflows', id: string, title: string } | null, request: { __typename?: 'requests', status: string | null, id: string } | null }>, spend: Array<{ __typename?: 'agreement_term_spend_items', id: string, description: string, totalAmount: number, startDate: any, endDate: any | null, frequency: PaymentIntervalEnum, quantity: number, rate: number, fxRate: number, fxTime: string, currencyCode: OverrideTypes["CurrencyCode"] }>, agreement_term_revisions?: Array<{ __typename?: 'agreement_term_revisions', id: string, createdAt: string, response?: OverrideTypes["FormResponsePayload"] | null, agreementTermId: string, submissionSource: OverrideTypes["SubmissionSource"] | null, submittedBy: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, requestFormSubmission: { __typename?: 'request_form_submissions', id: string, request_form: { __typename?: 'request_forms', id: string, request: { __typename?: 'requests', id: string, name: string, publicId: string } } | null } | null }>, custom_field_values?: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> }>, parent: { __typename?: 'agreements', id: string, name: string, publicId: number } | null, owner?: { __typename?: 'users', firstName: string, lastName: string, id: string, email: string, isArchived: boolean } | null, additionalOwners?: Array<{ __typename?: 'agreement_additional_owners', id: string, userId: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isArchived: boolean } }>, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, state: OrganisationSupplierStateEnum, logoUrl: string | null }, subsidiary?: { __typename?: 'subsidiaries', id: string, name: string } | null, paymentTerm?: { __typename?: 'payment_terms', id: string, name: string } | null, paymentMethod?: { __typename?: 'payment_methods', id: string, name: string } | null, tags?: Array<{ __typename?: 'agreement_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, terms: Array<{ __typename?: 'agreement_terms', createdAt: string, name: string, startDate: any, endDate: any | null, termType: OverrideTypes["AgreementTermType"], cancelledAt: any | null, autoRenew: boolean, id: string, cancelByDate: any | null, totalAmount: number | null, totalAmountInDefaultCurrency: number | null, currencyCode: OverrideTypes["CurrencyCode"] | null, fxRate: number | null, fxTime: string | null, cancellationNoticeDayCount: number | null, primaryDepartmentId: string | null, primaryDepartment?: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, products: Array<{ __typename?: 'agreement_term_products', id: string, organisationProductId: string, organisation_products_and_service?: { __typename?: 'organisation_products_and_services', id: string, name: string } }>, futureRenewal: Array<{ __typename?: 'renewals', id: string, workflowStartDate: any | null, workflowStartDayCount: number, cancellationNoticeDayCount: number | null, workflowInitialAssigneeId: string | null, status: string | null, renewalDate: string, renewedAt: string | null, autoStartEnabled: boolean, sourceRequestId: string | null, organisationProductId: string | null, organisationSupplierId: string, workflow: { __typename?: 'workflows', id: string, title: string } | null, request: { __typename?: 'requests', status: string | null, id: string } | null }>, spend: Array<{ __typename?: 'agreement_term_spend_items', id: string, description: string, totalAmount: number, startDate: any, endDate: any | null, frequency: PaymentIntervalEnum, quantity: number, rate: number, fxRate: number, fxTime: string, currencyCode: OverrideTypes["CurrencyCode"] }>, agreement_term_revisions?: Array<{ __typename?: 'agreement_term_revisions', id: string, createdAt: string, response?: OverrideTypes["FormResponsePayload"] | null, agreementTermId: string, submissionSource: OverrideTypes["SubmissionSource"] | null, submittedBy: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, requestFormSubmission: { __typename?: 'request_form_submissions', id: string, request_form: { __typename?: 'request_forms', id: string, request: { __typename?: 'requests', id: string, name: string, publicId: string } } | null } | null }>, custom_field_values?: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> }>, organisation: { __typename?: 'organisations', id: string, name: string } } | null };

export type GetAgreementDocumentsQueryVariables = Exact<{
  agreementIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetAgreementDocumentsQuery = { __typename?: 'query_root', documents: Array<{ __typename?: 'documents', id: string, filestoreId: string, createdAt: string, updatedAt: string, organisationId: string, fileName: string, staticType: string | null, customType: string | null, uploadedBy: string | null, uploadedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, customTypeValue: { __typename?: 'custom_document_types', id: string, value: string } | null, sourceRequestDocument: { __typename?: 'request_documents', id: string, sourceRequestForm: { __typename?: 'request_forms', id: string, title: string } | null, request: { __typename?: 'requests', id: string, name: string } } | null }> };

export type GetAgreementFormTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementFormTemplatesQuery = { __typename?: 'query_root', createAgreementFormTemplates: Array<{ __typename?: 'form_templates', id: string, title: string, config: OverrideTypes["FormConfig"] }>, cancelAgreementFormTemplates: Array<{ __typename?: 'form_templates', id: string, title: string, config: OverrideTypes["FormConfig"] }> };

export type AgreementLinkForRequestDetailFragment = { __typename?: 'requests', agreement_term: { __typename?: 'agreement_terms', id: string, name: string, agreementId: string } | null, sourceRenewal: { __typename?: 'renewals', sourceAgreementTerm: { __typename?: 'agreement_terms', id: string, name: string, agreementId: string } | null } | null };

export type GetAgreementMinimalQueryVariables = Exact<{
  agreementId: Scalars['uuid']['input'];
}>;


export type GetAgreementMinimalQuery = { __typename?: 'query_root', agreement: { __typename?: 'agreements', id: string, name: string, publicId: number, deletedAt: string | null, ownerId: string | null, additionalOwners: Array<{ __typename?: 'agreement_additional_owners', userId: string }>, supplier: { __typename?: 'organisation_suppliers', id: string, name: string } } | null };

export type GetAgreementTermRevisionQueryVariables = Exact<{
  revisionId: Scalars['uuid']['input'];
}>;


export type GetAgreementTermRevisionQuery = { __typename?: 'query_root', revision: { __typename?: 'agreement_term_revisions', id: string, createdAt: string, response: OverrideTypes["FormResponsePayload"] | null, config: OverrideTypes["FormConfig"] | null, agreementTermId: string, submissionSource: OverrideTypes["SubmissionSource"] | null, submittedBy: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, requestFormSubmission: { __typename?: 'request_form_submissions', id: string, request_form: { __typename?: 'request_forms', id: string, request: { __typename?: 'requests', id: string, name: string, publicId: string } } | null } | null } | null };

export type GetAgreementsCountQueryVariables = Exact<{
  termWhere: AgreementTermsBoolExp;
  agreementWhere: AgreementsBoolExp;
}>;


export type GetAgreementsCountQuery = { __typename?: 'query_root', agreements_aggregate: { __typename?: 'agreements_aggregate', aggregate: { __typename?: 'agreements_aggregate_fields', count: number } | null } };

export type GetAgreementsPaginatedQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy: InputMaybe<Array<AgreementsOrderBy> | AgreementsOrderBy>;
  includeOwners: Scalars['Boolean']['input'];
  includeSubsidiary: Scalars['Boolean']['input'];
  includePaymentTerm: Scalars['Boolean']['input'];
  includePaymentMethod: Scalars['Boolean']['input'];
  includeCustomFields: Scalars['Boolean']['input'];
  includeProducts: Scalars['Boolean']['input'];
  customFields: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  termWhere: AgreementTermsBoolExp;
  agreementWhere: AgreementsBoolExp;
  includeTags: Scalars['Boolean']['input'];
  includePrimaryDepartment: Scalars['Boolean']['input'];
  includeRevisions: Scalars['Boolean']['input'];
  includeRevisionsResponse: Scalars['Boolean']['input'];
}>;


export type GetAgreementsPaginatedQuery = { __typename?: 'query_root', agreements: Array<{ __typename?: 'agreements', id: string, createdAt: string, deletedAt: string | null, name: string, publicId: number, remoteId: string | null, description: string | null, parentId: string | null, ownerId: string | null, subsidiaryId: string | null, paymentTermId: string | null, paymentMethodId: string | null, refreshPricesAt: string | null, parent: { __typename?: 'agreements', id: string, name: string, publicId: number } | null, owner?: { __typename?: 'users', firstName: string, lastName: string, id: string, email: string, isArchived: boolean } | null, additionalOwners?: Array<{ __typename?: 'agreement_additional_owners', id: string, userId: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isArchived: boolean } }>, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, state: OrganisationSupplierStateEnum, logoUrl: string | null }, subsidiary?: { __typename?: 'subsidiaries', id: string, name: string } | null, paymentTerm?: { __typename?: 'payment_terms', id: string, name: string } | null, paymentMethod?: { __typename?: 'payment_methods', id: string, name: string } | null, tags?: Array<{ __typename?: 'agreement_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, terms: Array<{ __typename?: 'agreement_terms', createdAt: string, name: string, startDate: any, endDate: any | null, termType: OverrideTypes["AgreementTermType"], cancelledAt: any | null, autoRenew: boolean, id: string, cancelByDate: any | null, totalAmount: number | null, totalAmountInDefaultCurrency: number | null, currencyCode: OverrideTypes["CurrencyCode"] | null, fxRate: number | null, fxTime: string | null, cancellationNoticeDayCount: number | null, primaryDepartmentId: string | null, primaryDepartment?: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, products: Array<{ __typename?: 'agreement_term_products', id: string, organisationProductId: string, organisation_products_and_service?: { __typename?: 'organisation_products_and_services', id: string, name: string } }>, futureRenewal: Array<{ __typename?: 'renewals', id: string, workflowStartDate: any | null, workflowStartDayCount: number, cancellationNoticeDayCount: number | null, workflowInitialAssigneeId: string | null, status: string | null, renewalDate: string, renewedAt: string | null, autoStartEnabled: boolean, sourceRequestId: string | null, organisationProductId: string | null, organisationSupplierId: string, workflow: { __typename?: 'workflows', id: string, title: string } | null, request: { __typename?: 'requests', status: string | null, id: string } | null }>, spend: Array<{ __typename?: 'agreement_term_spend_items', id: string, description: string, totalAmount: number, startDate: any, endDate: any | null, frequency: PaymentIntervalEnum, quantity: number, rate: number, fxRate: number, fxTime: string, currencyCode: OverrideTypes["CurrencyCode"] }>, agreement_term_revisions?: Array<{ __typename?: 'agreement_term_revisions', id: string, createdAt: string, response?: OverrideTypes["FormResponsePayload"] | null, agreementTermId: string, submissionSource: OverrideTypes["SubmissionSource"] | null, submittedBy: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, requestFormSubmission: { __typename?: 'request_form_submissions', id: string, request_form: { __typename?: 'request_forms', id: string, request: { __typename?: 'requests', id: string, name: string, publicId: string } } | null } | null }>, custom_field_values?: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> }>, organisation: { __typename?: 'organisations', id: string, name: string } }> };

export type GetTermRevisionsForAgreementQueryVariables = Exact<{
  agreementId: Scalars['uuid']['input'];
  termFilter: AgreementTermsBoolExp;
  revisionFilter: AgreementTermRevisionsBoolExp;
}>;


export type GetTermRevisionsForAgreementQuery = { __typename?: 'query_root', agreements_by_pk: { __typename?: 'agreements', agreement_terms: Array<{ __typename?: 'agreement_terms', agreement_term_revisions: Array<{ __typename?: 'agreement_term_revisions', id: string, response: OverrideTypes["FormResponsePayload"] | null, createdAt: string, agreementTermId: string, submissionSource: OverrideTypes["SubmissionSource"] | null, submittedBy: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, requestFormSubmission: { __typename?: 'request_form_submissions', id: string, request_form: { __typename?: 'request_forms', request: { __typename?: 'requests', id: string, name: string, publicId: string } } | null } | null }> }> } | null };

export type ListAgreementsMinimalQueryVariables = Exact<{
  where: AgreementsBoolExp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type ListAgreementsMinimalQuery = { __typename?: 'query_root', agreements: Array<{ __typename?: 'agreements', id: string, name: string, publicId: number, ownerId: string | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string } }> };

export type RenameAgreementMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameAgreementMutation = { __typename?: 'mutation_root', update_agreements_by_pk: { __typename?: 'agreements', id: string, name: string } | null };

export type SupplierAgreementFragment = { __typename?: 'agreements', id: string, agreement_terms: Array<{ __typename?: 'agreement_terms', id: string, totalAmount: number | null, currencyCode: OverrideTypes["CurrencyCode"] | null, fxRate: number | null, primaryDepartment: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null }> };

export type AgreementFragment = { __typename?: 'agreements', id: string, createdAt: string, deletedAt: string | null, name: string, publicId: number, remoteId: string | null, description: string | null, parentId: string | null, ownerId: string | null, subsidiaryId: string | null, paymentTermId: string | null, paymentMethodId: string | null, refreshPricesAt: string | null, parent: { __typename?: 'agreements', id: string, name: string, publicId: number } | null, owner?: { __typename?: 'users', firstName: string, lastName: string, id: string, email: string, isArchived: boolean } | null, additionalOwners?: Array<{ __typename?: 'agreement_additional_owners', id: string, userId: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isArchived: boolean } }>, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, state: OrganisationSupplierStateEnum, logoUrl: string | null }, subsidiary?: { __typename?: 'subsidiaries', id: string, name: string } | null, paymentTerm?: { __typename?: 'payment_terms', id: string, name: string } | null, paymentMethod?: { __typename?: 'payment_methods', id: string, name: string } | null, tags?: Array<{ __typename?: 'agreement_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, terms: Array<{ __typename?: 'agreement_terms', createdAt: string, name: string, startDate: any, endDate: any | null, termType: OverrideTypes["AgreementTermType"], cancelledAt: any | null, autoRenew: boolean, id: string, cancelByDate: any | null, totalAmount: number | null, totalAmountInDefaultCurrency: number | null, currencyCode: OverrideTypes["CurrencyCode"] | null, fxRate: number | null, fxTime: string | null, cancellationNoticeDayCount: number | null, primaryDepartmentId: string | null, primaryDepartment?: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, products: Array<{ __typename?: 'agreement_term_products', id: string, organisationProductId: string, organisation_products_and_service?: { __typename?: 'organisation_products_and_services', id: string, name: string } }>, futureRenewal: Array<{ __typename?: 'renewals', id: string, workflowStartDate: any | null, workflowStartDayCount: number, cancellationNoticeDayCount: number | null, workflowInitialAssigneeId: string | null, status: string | null, renewalDate: string, renewedAt: string | null, autoStartEnabled: boolean, sourceRequestId: string | null, organisationProductId: string | null, organisationSupplierId: string, workflow: { __typename?: 'workflows', id: string, title: string } | null, request: { __typename?: 'requests', status: string | null, id: string } | null }>, spend: Array<{ __typename?: 'agreement_term_spend_items', id: string, description: string, totalAmount: number, startDate: any, endDate: any | null, frequency: PaymentIntervalEnum, quantity: number, rate: number, fxRate: number, fxTime: string, currencyCode: OverrideTypes["CurrencyCode"] }>, agreement_term_revisions?: Array<{ __typename?: 'agreement_term_revisions', id: string, createdAt: string, response?: OverrideTypes["FormResponsePayload"] | null, agreementTermId: string, submissionSource: OverrideTypes["SubmissionSource"] | null, submittedBy: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, requestFormSubmission: { __typename?: 'request_form_submissions', id: string, request_form: { __typename?: 'request_forms', id: string, request: { __typename?: 'requests', id: string, name: string, publicId: string } } | null } | null }>, custom_field_values?: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> }>, organisation: { __typename?: 'organisations', id: string, name: string } };

export type AgreementTermFragment = { __typename?: 'agreement_terms', createdAt: string, name: string, startDate: any, endDate: any | null, termType: OverrideTypes["AgreementTermType"], cancelledAt: any | null, autoRenew: boolean, id: string, cancelByDate: any | null, totalAmount: number | null, totalAmountInDefaultCurrency: number | null, currencyCode: OverrideTypes["CurrencyCode"] | null, fxRate: number | null, fxTime: string | null, cancellationNoticeDayCount: number | null, primaryDepartmentId: string | null, primaryDepartment?: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, products: Array<{ __typename?: 'agreement_term_products', id: string, organisationProductId: string, organisation_products_and_service?: { __typename?: 'organisation_products_and_services', id: string, name: string } }>, futureRenewal: Array<{ __typename?: 'renewals', id: string, workflowStartDate: any | null, workflowStartDayCount: number, cancellationNoticeDayCount: number | null, workflowInitialAssigneeId: string | null, status: string | null, renewalDate: string, renewedAt: string | null, autoStartEnabled: boolean, sourceRequestId: string | null, organisationProductId: string | null, organisationSupplierId: string, workflow: { __typename?: 'workflows', id: string, title: string } | null, request: { __typename?: 'requests', status: string | null, id: string } | null }>, spend: Array<{ __typename?: 'agreement_term_spend_items', id: string, description: string, totalAmount: number, startDate: any, endDate: any | null, frequency: PaymentIntervalEnum, quantity: number, rate: number, fxRate: number, fxTime: string, currencyCode: OverrideTypes["CurrencyCode"] }>, agreement_term_revisions?: Array<{ __typename?: 'agreement_term_revisions', id: string, createdAt: string, response?: OverrideTypes["FormResponsePayload"] | null, agreementTermId: string, submissionSource: OverrideTypes["SubmissionSource"] | null, submittedBy: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, requestFormSubmission: { __typename?: 'request_form_submissions', id: string, request_form: { __typename?: 'request_forms', id: string, request: { __typename?: 'requests', id: string, name: string, publicId: string } } | null } | null }>, custom_field_values?: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> };

export type AgreementTermRevisionFragmentFragment = { __typename?: 'agreement_term_revisions', id: string, createdAt: string, response: OverrideTypes["FormResponsePayload"] | null, config: OverrideTypes["FormConfig"] | null, agreementTermId: string, submissionSource: OverrideTypes["SubmissionSource"] | null, submittedBy: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, requestFormSubmission: { __typename?: 'request_form_submissions', id: string, request_form: { __typename?: 'request_forms', id: string, request: { __typename?: 'requests', id: string, name: string, publicId: string } } | null } | null };

export type GetAgreementCustomFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementCustomFieldsQuery = { __typename?: 'query_root', custom_fields: Array<{ __typename?: 'custom_fields', id: string }> };

export type CommitAgreementMutationVariables = Exact<{
  deleteAgreement: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  upsertAgreement: Array<AgreementsInsertInput> | AgreementsInsertInput;
  upsertAgreementTerms: Array<AgreementTermsInsertInput> | AgreementTermsInsertInput;
  deleteSpend: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  upsertSpend: Array<AgreementTermSpendItemsInsertInput> | AgreementTermSpendItemsInsertInput;
  deleteRenewals: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  upsertRenewals: Array<RenewalsInsertInput> | RenewalsInsertInput;
  insertTermProducts: Array<AgreementTermProductsInsertInput> | AgreementTermProductsInsertInput;
  deleteTermRevisions: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  upsertTermRevisions: Array<AgreementTermRevisionsInsertInput> | AgreementTermRevisionsInsertInput;
  deleteTermProductsTermIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  deleteTermProductsProductIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  deleteAgreementTerms: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  insertAgreementTags: Array<AgreementTagsInsertInput> | AgreementTagsInsertInput;
  deleteAgreementTagIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  insertAdditionalOwners: Array<AgreementAdditionalOwnersInsertInput> | AgreementAdditionalOwnersInsertInput;
  deleteAdditionalOwnerAgreementId: InputMaybe<Scalars['uuid']['input']>;
  deleteAdditionalOwnerUserIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  shouldUpsertAgreement: Scalars['Boolean']['input'];
  shouldUpsertAgreementTerms: Scalars['Boolean']['input'];
  shouldUpsertSpend: Scalars['Boolean']['input'];
  shouldUpsertRenewals: Scalars['Boolean']['input'];
  shouldInsertTermProducts: Scalars['Boolean']['input'];
  shouldUpsertTermRevisions: Scalars['Boolean']['input'];
  shouldInsertAgreementTags: Scalars['Boolean']['input'];
  shouldDeleteAgreementTags: Scalars['Boolean']['input'];
  shouldInsertAdditionalOwners: Scalars['Boolean']['input'];
  shouldDeleteAdditionalOwners: Scalars['Boolean']['input'];
  shouldDeleteRenewals: Scalars['Boolean']['input'];
  shouldDeleteTermProductsTermIds: Scalars['Boolean']['input'];
  shouldDeleteTermRevisions: Scalars['Boolean']['input'];
  shouldDeleteSpend: Scalars['Boolean']['input'];
  shouldDeleteAgreementTerms: Scalars['Boolean']['input'];
  shouldDeleteAgreement: Scalars['Boolean']['input'];
}>;


export type CommitAgreementMutation = { __typename?: 'mutation_root', upsert_agreement?: { __typename?: 'agreements_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'agreements', id: string }> } | null, upsert_terms?: { __typename?: 'agreement_terms_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'agreement_terms', id: string }> } | null, upsert_spend?: { __typename?: 'agreement_term_spend_items_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'agreement_term_spend_items', id: string }> } | null, upsert_renewals?: { __typename?: 'renewals_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'renewals', id: string }> } | null, insert_term_products?: { __typename?: 'agreement_term_products_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'agreement_term_products', agreementTermId: string, organisationProductId: string }> } | null, insert_term_revisions?: { __typename?: 'agreement_term_revisions_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'agreement_term_revisions', id: string }> } | null, insert_agreement_tags?: { __typename?: 'agreement_tags_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'agreement_tags', id: string }> } | null, delete_agreement_tags?: { __typename?: 'agreement_tags_mutation_response', affected_rows: number } | null, delete_agreement_additional_owners?: { __typename?: 'agreement_additional_owners_mutation_response', affected_rows: number } | null, insert_agreement_additional_owners?: { __typename?: 'agreement_additional_owners_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'agreement_additional_owners', id: string }> } | null, delete_renewals?: { __typename?: 'renewals_mutation_response', affected_rows: number } | null, delete_term_products?: { __typename?: 'agreement_term_products_mutation_response', affected_rows: number } | null, delete_term_revisions?: { __typename?: 'agreement_term_revisions_mutation_response', affected_rows: number } | null, delete_spend?: { __typename?: 'agreement_term_spend_items_mutation_response', affected_rows: number } | null, delete_terms?: { __typename?: 'agreement_terms_mutation_response', affected_rows: number } | null, delete_agreement?: { __typename?: 'agreements_mutation_response', affected_rows: number } | null };

export type UpdateUpcomingRenewalMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: RenewalsSetInput;
}>;


export type UpdateUpcomingRenewalMutation = { __typename?: 'mutation_root', update_renewals_by_pk: { __typename?: 'renewals', id: string } | null };

export type UpsertAgreementTagsMutationVariables = Exact<{
  agreementId: Scalars['uuid']['input'];
  tagIdsToDelete: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  tagsToInsert: Array<AgreementTagsInsertInput> | AgreementTagsInsertInput;
}>;


export type UpsertAgreementTagsMutation = { __typename?: 'mutation_root', delete_agreement_tags: { __typename?: 'agreement_tags_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'agreement_tags', id: string }> } | null, insert_agreement_tags: { __typename?: 'agreement_tags_mutation_response', returning: Array<{ __typename?: 'agreement_tags', id: string, tag: { __typename?: 'tags', id: string } }> } | null };

export type AssessmentFragment = { __typename?: 'assessments', id: string, name: string, externalRespondents: any | null, frequency: AssessmentFrequencyEnum, sendDate: string | null, completedAt: string | null, businessOwnerUserId: string, autoStartEnabled: boolean | null, deletedAt: string | null, assessmentTags: Array<{ __typename?: 'assessment_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, additionalUsers: Array<{ __typename?: 'assessment_additional_users', user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string, isArchived: boolean } }>, additionalGroups: Array<{ __typename?: 'assessment_additional_groups', id: string, group: { __typename?: 'groups', id: string, name: string } }>, workflow: { __typename?: 'workflows', id: string, title: string, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"], viewModel: any | null, viewModelUpdatedAt: string | null, canvasModelUpdatedAt: string, type: WorkflowTypeEnum }, request: { __typename?: 'requests', id: string, model: OverrideTypes["RequestModel"], tagIds: any | null, type: RequestTypeEnum, completedAt: string | null, state: string | null, risks: Array<{ __typename?: 'risks', id: string, inherentRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null, residualRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null }>, inProgressStepContext: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, nodeId: string, name: any, assignees: any | null, type: any, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string } }> }>, steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, result: RequestStepResultEnum | null, canvasModelId: string, createdAt: string, completedAt: string | null, totalPausedWorkingHours: number, input: any }>, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }> } | null, organisation: { __typename?: 'organisations', id: string, name: string }, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum, logoUrl: string | null } | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string, state: OrganisationSupplierStateEnum, logoUrl: string | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> } };

export type DeleteAssessmentAdditionalGroupsMutationVariables = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type DeleteAssessmentAdditionalGroupsMutation = { __typename?: 'mutation_root', deletedGroups: { __typename?: 'assessment_additional_groups_mutation_response', affected_rows: number } | null };

export type DeleteAssessmentTagsByAssessmentIdMutationVariables = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type DeleteAssessmentTagsByAssessmentIdMutation = { __typename?: 'mutation_root', deletedAssessmentTags: { __typename?: 'assessment_tags_mutation_response', returning: Array<{ __typename?: 'assessment_tags', id: string }> } | null };

export type DeleteAssessmentTagsByIdMutationVariables = Exact<{
  assessmentTagIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteAssessmentTagsByIdMutation = { __typename?: 'mutation_root', deletedAssessmentTags: { __typename?: 'assessment_tags_mutation_response', returning: Array<{ __typename?: 'assessment_tags', id: string }> } | null };

export type DeleteAssessmentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteAssessmentMutation = { __typename?: 'mutation_root', assessment: { __typename?: 'assessments', id: string } | null };

export type FindAssessmentByAssigneeQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  assessmentId: Scalars['uuid']['input'];
}>;


export type FindAssessmentByAssigneeQuery = { __typename?: 'query_root', additionalAssigneeAssessments: Array<{ __typename?: 'assessment_additional_users', id: string }>, initialAssigneeAssessments: Array<{ __typename?: 'assessments', id: string }> };

export type GetAssessmentAdditionalUsersQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetAssessmentAdditionalUsersQuery = { __typename?: 'query_root', assessment_additional_users: Array<{ __typename?: 'assessment_additional_users', id: string, userId: string }> };

export type GetAssessmentByIdQueryVariables = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetAssessmentByIdQuery = { __typename?: 'query_root', assessment: { __typename?: 'assessments', id: string, name: string, externalRespondents: any | null, frequency: AssessmentFrequencyEnum, sendDate: string | null, completedAt: string | null, businessOwnerUserId: string, autoStartEnabled: boolean | null, deletedAt: string | null, assessmentTags: Array<{ __typename?: 'assessment_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, additionalUsers: Array<{ __typename?: 'assessment_additional_users', user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string, isArchived: boolean } }>, additionalGroups: Array<{ __typename?: 'assessment_additional_groups', id: string, group: { __typename?: 'groups', id: string, name: string } }>, workflow: { __typename?: 'workflows', id: string, title: string, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"], viewModel: any | null, viewModelUpdatedAt: string | null, canvasModelUpdatedAt: string, type: WorkflowTypeEnum }, request: { __typename?: 'requests', id: string, model: OverrideTypes["RequestModel"], tagIds: any | null, type: RequestTypeEnum, completedAt: string | null, state: string | null, risks: Array<{ __typename?: 'risks', id: string, inherentRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null, residualRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null }>, inProgressStepContext: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, nodeId: string, name: any, assignees: any | null, type: any, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string } }> }>, steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, result: RequestStepResultEnum | null, canvasModelId: string, createdAt: string, completedAt: string | null, totalPausedWorkingHours: number, input: any }>, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }> } | null, organisation: { __typename?: 'organisations', id: string, name: string }, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum, logoUrl: string | null } | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string, state: OrganisationSupplierStateEnum, logoUrl: string | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> } } | null };

export type GetAdminAssessmentsForStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminAssessmentsForStatsQuery = { __typename?: 'query_root', assessments: Array<{ __typename?: 'assessments', id: string }> };

export type GetUserAssessmentsForStatsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserAssessmentsForStatsQuery = { __typename?: 'query_root', initialAssigneeAssessments: Array<{ __typename?: 'assessments', id: string }>, additionalAssigneeAssessments: Array<{ __typename?: 'assessment_additional_users', assessment: { __typename?: 'assessments', id: string } }> };

export type GetAssessmentTagsQueryVariables = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetAssessmentTagsQuery = { __typename?: 'query_root', assessmentTags: Array<{ __typename?: 'assessment_tags', id: string, tag: { __typename?: 'tags', id: string, deletedAt: any | null } }> };

export type GetOrgWorkflowsForAssessmentUploadQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgWorkflowsForAssessmentUploadQuery = { __typename?: 'query_root', workflows: Array<{ __typename?: 'workflows', title: string, id: string, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"], viewModel: any | null, viewModelUpdatedAt: string | null, canvasModelUpdatedAt: string }> };

export type GetRequestWithAssessmentQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRequestWithAssessmentQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, assessment: { __typename?: 'assessments', id: string } | null } | null };

export type InsertAssessmentMutationVariables = Exact<{
  assessment: AssessmentsInsertInput;
}>;


export type InsertAssessmentMutation = { __typename?: 'mutation_root', assessment: { __typename?: 'assessments', id: string, name: string } | null };

export type InsertAssessmentAdditionalGroupsMutationVariables = Exact<{
  objects: Array<AssessmentAdditionalGroupsInsertInput> | AssessmentAdditionalGroupsInsertInput;
}>;


export type InsertAssessmentAdditionalGroupsMutation = { __typename?: 'mutation_root', additionalGroups: { __typename?: 'assessment_additional_groups_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'assessment_additional_groups', id: string, assessmentId: string, groupId: string }> } | null };

export type InsertAssessmentTagsMutationVariables = Exact<{
  objects: Array<AssessmentTagsInsertInput> | AssessmentTagsInsertInput;
}>;


export type InsertAssessmentTagsMutation = { __typename?: 'mutation_root', insertedAssessmentTags: { __typename?: 'assessment_tags_mutation_response', returning: Array<{ __typename?: 'assessment_tags', id: string }> } | null };

export type ListAssessmentsForAdminQueryVariables = Exact<{
  gqlFilter: AssessmentsBoolExp;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListAssessmentsForAdminQuery = { __typename?: 'query_root', assessments: Array<{ __typename?: 'assessments', id: string, name: string, externalRespondents: any | null, frequency: AssessmentFrequencyEnum, sendDate: string | null, completedAt: string | null, businessOwnerUserId: string, autoStartEnabled: boolean | null, deletedAt: string | null, assessmentTags: Array<{ __typename?: 'assessment_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, additionalUsers: Array<{ __typename?: 'assessment_additional_users', user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string, isArchived: boolean } }>, additionalGroups: Array<{ __typename?: 'assessment_additional_groups', id: string, group: { __typename?: 'groups', id: string, name: string } }>, workflow: { __typename?: 'workflows', id: string, title: string, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"], viewModel: any | null, viewModelUpdatedAt: string | null, canvasModelUpdatedAt: string, type: WorkflowTypeEnum }, request: { __typename?: 'requests', id: string, model: OverrideTypes["RequestModel"], tagIds: any | null, type: RequestTypeEnum, completedAt: string | null, state: string | null, risks: Array<{ __typename?: 'risks', id: string, inherentRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null, residualRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null }>, inProgressStepContext: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, nodeId: string, name: any, assignees: any | null, type: any, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string } }> }>, steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, result: RequestStepResultEnum | null, canvasModelId: string, createdAt: string, completedAt: string | null, totalPausedWorkingHours: number, input: any }>, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }> } | null, organisation: { __typename?: 'organisations', id: string, name: string }, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum, logoUrl: string | null } | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string, state: OrganisationSupplierStateEnum, logoUrl: string | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> } }>, assessments_aggregate: { __typename?: 'assessments_aggregate', aggregate: { __typename?: 'assessments_aggregate_fields', count: number } | null } };

export type ListAssessmentsForUserQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  gqlFilter: AssessmentsBoolExp;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListAssessmentsForUserQuery = { __typename?: 'query_root', assessments: Array<{ __typename?: 'assessments', id: string, name: string, externalRespondents: any | null, frequency: AssessmentFrequencyEnum, sendDate: string | null, completedAt: string | null, businessOwnerUserId: string, autoStartEnabled: boolean | null, deletedAt: string | null, assessmentTags: Array<{ __typename?: 'assessment_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, additionalUsers: Array<{ __typename?: 'assessment_additional_users', user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string, isArchived: boolean } }>, additionalGroups: Array<{ __typename?: 'assessment_additional_groups', id: string, group: { __typename?: 'groups', id: string, name: string } }>, workflow: { __typename?: 'workflows', id: string, title: string, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"], viewModel: any | null, viewModelUpdatedAt: string | null, canvasModelUpdatedAt: string, type: WorkflowTypeEnum }, request: { __typename?: 'requests', id: string, model: OverrideTypes["RequestModel"], tagIds: any | null, type: RequestTypeEnum, completedAt: string | null, state: string | null, risks: Array<{ __typename?: 'risks', id: string, inherentRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null, residualRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null }>, inProgressStepContext: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, nodeId: string, name: any, assignees: any | null, type: any, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string } }> }>, steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, result: RequestStepResultEnum | null, canvasModelId: string, createdAt: string, completedAt: string | null, totalPausedWorkingHours: number, input: any }>, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }> } | null, organisation: { __typename?: 'organisations', id: string, name: string }, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum, logoUrl: string | null } | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string, state: OrganisationSupplierStateEnum, logoUrl: string | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> } }>, assessments_aggregate: { __typename?: 'assessments_aggregate', aggregate: { __typename?: 'assessments_aggregate_fields', count: number } | null } };

export type UpdateAssessmentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  assessment: AssessmentsSetInput;
}>;


export type UpdateAssessmentMutation = { __typename?: 'mutation_root', assessment: { __typename?: 'assessments', id: string } | null };

export type UpdateAssessmentAssigneesMutationVariables = Exact<{
  assessmentId: Scalars['uuid']['input'];
  userIdsToRemove: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  usersToAdd: Array<AssessmentAdditionalUsersInsertInput> | AssessmentAdditionalUsersInsertInput;
}>;


export type UpdateAssessmentAssigneesMutation = { __typename?: 'mutation_root', delete_assessment_additional_users: { __typename?: 'assessment_additional_users_mutation_response', affected_rows: number } | null, insert_assessment_additional_users: { __typename?: 'assessment_additional_users_mutation_response', affected_rows: number } | null };

export type BankAccountFragment = { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> };

export type EntityBankAccountFragment = { __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } };

export type InsertBankAccountMutationVariables = Exact<{
  bankAccount: BankDetailsInsertInput;
}>;


export type InsertBankAccountMutation = { __typename?: 'mutation_root', insert_bank_details_one: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } | null };

export type LinkBankAccountToSupplierMutationVariables = Exact<{
  bankAccountId: Scalars['uuid']['input'];
  supplierId: Scalars['uuid']['input'];
  isPrimary: InputMaybe<Scalars['Boolean']['input']>;
  shouldDemotePrimary: Scalars['Boolean']['input'];
}>;


export type LinkBankAccountToSupplierMutation = { __typename?: 'mutation_root', demotePrimary?: { __typename?: 'entity_bank_details_mutation_response', affected_rows: number } | null, linkedToSupplier: { __typename?: 'entity_bank_details', id: string, isPrimary: boolean | null } | null };

export type LinkBankAccountToSupplierProfileMutationVariables = Exact<{
  bankAccountId: Scalars['uuid']['input'];
  supplierProfileId: Scalars['uuid']['input'];
  isPrimary: InputMaybe<Scalars['Boolean']['input']>;
  shouldDemotePrimary: Scalars['Boolean']['input'];
}>;


export type LinkBankAccountToSupplierProfileMutation = { __typename?: 'mutation_root', demotePrimary?: { __typename?: 'entity_bank_details_mutation_response', affected_rows: number } | null, linkedToSupplierProfile: { __typename?: 'entity_bank_details', id: string, isPrimary: boolean | null } | null };

export type UnlinkAllBankAccountsFromSupplierMutationVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
}>;


export type UnlinkAllBankAccountsFromSupplierMutation = { __typename?: 'mutation_root', delete_entity_bank_details: { __typename?: 'entity_bank_details_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'entity_bank_details', id: string, bankDetailsId: string }> } | null };

export type UnlinkAllBankAccountsFromSupplierProfileMutationVariables = Exact<{
  supplierProfileId: Scalars['uuid']['input'];
}>;


export type UnlinkAllBankAccountsFromSupplierProfileMutation = { __typename?: 'mutation_root', delete_entity_bank_details: { __typename?: 'entity_bank_details_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'entity_bank_details', id: string, bankDetailsId: string }> } | null };

export type UnlinkBankAccountFromSupplierMutationVariables = Exact<{
  bankAccountId: Scalars['uuid']['input'];
  supplierId: Scalars['uuid']['input'];
}>;


export type UnlinkBankAccountFromSupplierMutation = { __typename?: 'mutation_root', delete_entity_bank_details: { __typename?: 'entity_bank_details_mutation_response', affected_rows: number } | null };

export type UnlinkBankAccountFromSupplierProfileMutationVariables = Exact<{
  bankAccountId: Scalars['uuid']['input'];
  supplierProfileId: Scalars['uuid']['input'];
}>;


export type UnlinkBankAccountFromSupplierProfileMutation = { __typename?: 'mutation_root', delete_entity_bank_details: { __typename?: 'entity_bank_details_mutation_response', affected_rows: number } | null };

export type UpdateBankAccountMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: BankDetailsSetInput;
}>;


export type UpdateBankAccountMutation = { __typename?: 'mutation_root', update_bank_details_by_pk: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } | null };

export type CountAddressesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type CountAddressesByIdsQuery = { __typename?: 'query_root', addresses_aggregate: { __typename?: 'addresses_aggregate', aggregate: { __typename?: 'addresses_aggregate_fields', count: number } | null } };

export type CountBankAccountsForEntitiesQueryVariables = Exact<{
  where: EntityBankDetailsBoolExp;
}>;


export type CountBankAccountsForEntitiesQuery = { __typename?: 'query_root', entity_bank_details: Array<{ __typename?: 'entity_bank_details', organisationSupplierId: string | null, organisationSupplierProfileId: string | null }> };

export type GetAddressByRemoteIdQueryVariables = Exact<{
  remoteId: Scalars['String']['input'];
  organisationId: Scalars['uuid']['input'];
}>;


export type GetAddressByRemoteIdQuery = { __typename?: 'query_root', addresses: Array<{ __typename?: 'addresses', id: string, remoteId: string | null }> };

export type GetBankAccountByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetBankAccountByIdQuery = { __typename?: 'query_root', bank_details_by_pk: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } | null };

export type GetBankAccountByRemoteIdQueryVariables = Exact<{
  remoteId: Scalars['String']['input'];
  organisationId: Scalars['uuid']['input'];
}>;


export type GetBankAccountByRemoteIdQuery = { __typename?: 'query_root', bank_details: Array<{ __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> }> };

export type GetBankAccountOnEntityQueryVariables = Exact<{
  bankAccountId: Scalars['uuid']['input'];
  entityId: Scalars['uuid']['input'];
  isSupplier: Scalars['Boolean']['input'];
  isSupplierProfile: Scalars['Boolean']['input'];
}>;


export type GetBankAccountOnEntityQuery = { __typename?: 'query_root', supplierProfile?: { __typename?: 'organisation_supplier_profiles', id: string, entityBankDetails: Array<{ __typename?: 'entity_bank_details', id: string, bankDetailsId: string }> } | null, supplier?: { __typename?: 'organisation_suppliers', id: string, entityBankDetails: Array<{ __typename?: 'entity_bank_details', id: string, bankDetailsId: string }> } | null, bankAccount: { __typename?: 'bank_details', id: string } | null };

export type GetBankAccountsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetBankAccountsByIdsQuery = { __typename?: 'query_root', bank_details: Array<{ __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> }> };

export type GetCurrencyByRemoteIdQueryVariables = Exact<{
  remoteId: Scalars['String']['input'];
}>;


export type GetCurrencyByRemoteIdQuery = { __typename?: 'query_root', organisation_fx_rates: Array<{ __typename?: 'organisation_fx_rates', id: string, remoteId: string | null }> };

export type GetLinkedEntitiesForBankAccountQueryVariables = Exact<{
  bankAccountId: Scalars['uuid']['input'];
}>;


export type GetLinkedEntitiesForBankAccountQuery = { __typename?: 'query_root', entity_bank_details: Array<{ __typename?: 'entity_bank_details', id: string, organisationSupplierId: string | null, organisationSupplierProfileId: string | null }> };

export type GetLinkedEntitiesForBankAccountInBankAccountsServiceQueryVariables = Exact<{
  bankAccountId: Scalars['uuid']['input'];
}>;


export type GetLinkedEntitiesForBankAccountInBankAccountsServiceQuery = { __typename?: 'query_root', entity_bank_details: Array<{ __typename?: 'entity_bank_details', id: string, organisationSupplierId: string | null, organisationSupplierProfileId: string | null, isPrimary: boolean | null }> };

export type ListBankAccountsForEntityQueryVariables = Exact<{
  where: EntityBankDetailsBoolExp;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityBankDetailsOrderBy> | EntityBankDetailsOrderBy>;
}>;


export type ListBankAccountsForEntityQuery = { __typename?: 'query_root', entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> };

export type BudgetApprovalsThresholdFragment = { __typename?: 'budget_approval_threshold', id: string, name: string, created_at: string, minValue: number, maxValue: number | null, inBudget: boolean | null, departments: Array<{ __typename?: 'budget_approval_threshold_department', department: { __typename?: 'departments', id: string, name: string } }>, groups: Array<{ __typename?: 'budget_approval_threshold_group', id: string, isApproval: boolean, approvalGroupId: string }> };

export type DeleteBudgetApprovalGroupAssigneesMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteBudgetApprovalGroupAssigneesMutation = { __typename?: 'mutation_root', delete_budget_approval_group_assignees_by_pk: { __typename?: 'budget_approval_group_assignees', id: string } | null };

export type DeleteBudgetApprovalGroupAssigneesAssigneesMutationVariables = Exact<{
  groupAssigneesId: Scalars['uuid']['input'];
}>;


export type DeleteBudgetApprovalGroupAssigneesAssigneesMutation = { __typename?: 'mutation_root', delete_budget_approval_group_assignees_assignees: { __typename?: 'budget_approval_group_assignees_assignees_mutation_response', returning: Array<{ __typename?: 'budget_approval_group_assignees_assignees', id: string }> } | null };

export type DeleteBudgetApprovalGroupAssigneesCustomCoreDataMutationVariables = Exact<{
  groupAssigneesId: Scalars['uuid']['input'];
}>;


export type DeleteBudgetApprovalGroupAssigneesCustomCoreDataMutation = { __typename?: 'mutation_root', delete_budget_approval_group_assignees_custom_core_data_options: { __typename?: 'budget_approval_group_assignees_custom_core_data_options_mutation_response', affected_rows: number } | null };

export type DeleteBudgetApprovalsGroupMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteBudgetApprovalsGroupMutation = { __typename?: 'mutation_root', update_budget_approval_group_by_pk: { __typename?: 'budget_approval_group', id: string, name: string } | null };

export type DeleteBudgetApprovalsThresholdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteBudgetApprovalsThresholdMutation = { __typename?: 'mutation_root', update_budget_approval_threshold_by_pk: { __typename?: 'budget_approval_threshold', id: string, name: string } | null };

export type GetBudgetApprovalGroupAssigneeByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetBudgetApprovalGroupAssigneeByIdQuery = { __typename?: 'query_root', budget_approval_group_assignees_by_pk: { __typename?: 'budget_approval_group_assignees', id: string, budgetApprovalGroupId: string, departmentId: string | null, subsidiaryId: string | null, lineItemId: string | null, department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, lineItem: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, assignees: Array<{ __typename?: 'budget_approval_group_assignees_assignees', id: string, group: { __typename?: 'groups', id: string, name: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null }>, customCoreDataOptions: Array<{ __typename?: 'budget_approval_group_assignees_custom_core_data_options', budget_approval_group_assignees_id: string, custom_core_data_id: string, custom_core_data_option: { __typename?: 'custom_core_data_options', id: string, value: string, custom_core_data: { __typename?: 'custom_core_data', id: string } } }> } | null };

export type GetBudgetApprovalGroupConfigQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetBudgetApprovalGroupConfigQuery = { __typename?: 'query_root', budget_approval_group_by_pk: { __typename?: 'budget_approval_group', id: string, organisationId: string, name: string, selected_custom_core_data: Array<{ __typename?: 'budget_approval_group_selected_custom_core_data', custom_core_data: { __typename?: 'custom_core_data', name: string, id: string } }> } | null };

export type GetBudgetApprovalGroupWithAssigneesQueryVariables = Exact<{
  groupId: Scalars['uuid']['input'];
  groupAssigneesQuery: BudgetApprovalGroupAssigneesBoolExp;
}>;


export type GetBudgetApprovalGroupWithAssigneesQuery = { __typename?: 'query_root', budget_approval_group_by_pk: { __typename?: 'budget_approval_group', id: string, name: string, assignees: Array<{ __typename?: 'budget_approval_group_assignees', id: string, departmentId: string | null, subsidiaryId: string | null, lineItemId: string | null, custom_core_data_options: Array<{ __typename?: 'budget_approval_group_assignees_custom_core_data_options', budget_approval_group_assignees_id: string, custom_core_data_id: string, custom_core_data_option_id: string }>, assignees: Array<{ __typename?: 'budget_approval_group_assignees_assignees', id: string, group: { __typename?: 'groups', id: string, name: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null }> }> } | null };

export type GetBudgetApprovalsDynamicAssigneesQueryVariables = Exact<{
  groupId: Scalars['uuid']['input'];
  value: Scalars['float8']['input'];
  groupAssigneesQuery: BudgetApprovalGroupAssigneesBoolExp;
}>;


export type GetBudgetApprovalsDynamicAssigneesQuery = { __typename?: 'query_root', budget_approval_threshold: Array<{ __typename?: 'budget_approval_threshold', id: string, name: string, minValue: number, maxValue: number | null, inBudget: boolean | null, departments: Array<{ __typename?: 'budget_approval_threshold_department', departmentId: string }>, budget_approval_threshold_groups: Array<{ __typename?: 'budget_approval_threshold_group', id: string, isApproval: boolean, approvalGroupId: string, budget_approval_group: { __typename?: 'budget_approval_group', id: string, name: string, assignees: Array<{ __typename?: 'budget_approval_group_assignees', id: string, departmentId: string | null, subsidiaryId: string | null, lineItemId: string | null, custom_core_data_options: Array<{ __typename?: 'budget_approval_group_assignees_custom_core_data_options', budget_approval_group_assignees_id: string, custom_core_data_id: string, custom_core_data_option_id: string }>, assignees: Array<{ __typename?: 'budget_approval_group_assignees_assignees', id: string, group: { __typename?: 'groups', id: string, name: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null }> }> } }> }> };

export type GetBudgetApprovalsGroupAssigneesQueryVariables = Exact<{
  groupId: Scalars['uuid']['input'];
}>;


export type GetBudgetApprovalsGroupAssigneesQuery = { __typename?: 'query_root', budget_approval_group_assignees: Array<{ __typename?: 'budget_approval_group_assignees', id: string, budgetApprovalGroupId: string, departmentId: string | null, subsidiaryId: string | null, lineItemId: string | null, department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, lineItem: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, assignees: Array<{ __typename?: 'budget_approval_group_assignees_assignees', id: string, group: { __typename?: 'groups', id: string, name: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null }>, custom_core_data_options: Array<{ __typename?: 'budget_approval_group_assignees_custom_core_data_options', budget_approval_group_assignees_id: string, custom_core_data_id: string, custom_core_data_option: { __typename?: 'custom_core_data_options', id: string, value: string, custom_core_data: { __typename?: 'custom_core_data', id: string } } }> }> };

export type GetBudgetApprovalsGroupCustomCoreDataQueryVariables = Exact<{
  groupId: Scalars['uuid']['input'];
}>;


export type GetBudgetApprovalsGroupCustomCoreDataQuery = { __typename?: 'query_root', budget_approval_group_by_pk: { __typename?: 'budget_approval_group', id: string, selected_custom_core_data: Array<{ __typename?: 'budget_approval_group_selected_custom_core_data', custom_core_data: { __typename?: 'custom_core_data', id: string, name: string } }> } | null };

export type GetBudgetApprovalsThresholdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBudgetApprovalsThresholdsQuery = { __typename?: 'query_root', budget_approval_threshold: Array<{ __typename?: 'budget_approval_threshold', id: string, name: string, created_at: string, minValue: number, maxValue: number | null, inBudget: boolean | null, departments: Array<{ __typename?: 'budget_approval_threshold_department', department: { __typename?: 'departments', id: string, name: string } }>, groups: Array<{ __typename?: 'budget_approval_threshold_group', id: string, isApproval: boolean, approvalGroupId: string }> }> };

export type GetCustomFieldNameByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCustomFieldNameByIdQuery = { __typename?: 'query_root', custom_fields_by_pk: { __typename?: 'custom_fields', id: string, title: string } | null };

export type InsertBudgetApprovalGroupAssigneesMutationVariables = Exact<{
  input: BudgetApprovalGroupAssigneesInsertInput;
}>;


export type InsertBudgetApprovalGroupAssigneesMutation = { __typename?: 'mutation_root', insert_budget_approval_group_assignees_one: { __typename?: 'budget_approval_group_assignees', id: string } | null };

export type InsertBudgetApprovalGroupAssigneesCustomCoreDataMutationVariables = Exact<{
  input: Array<BudgetApprovalGroupAssigneesCustomCoreDataOptionsInsertInput> | BudgetApprovalGroupAssigneesCustomCoreDataOptionsInsertInput;
}>;


export type InsertBudgetApprovalGroupAssigneesCustomCoreDataMutation = { __typename?: 'mutation_root', insert_budget_approval_group_assignees_custom_core_data_options: { __typename?: 'budget_approval_group_assignees_custom_core_data_options_mutation_response', affected_rows: number } | null };

export type InsertBudgetApprovalsGroupMutationVariables = Exact<{
  input: BudgetApprovalGroupInsertInput;
}>;


export type InsertBudgetApprovalsGroupMutation = { __typename?: 'mutation_root', insert_budget_approval_group_one: { __typename?: 'budget_approval_group', id: string, name: string } | null };

export type InsertBudgetApprovalsGroupAssigneesAssigneesMutationVariables = Exact<{
  input: Array<BudgetApprovalGroupAssigneesAssigneesInsertInput> | BudgetApprovalGroupAssigneesAssigneesInsertInput;
}>;


export type InsertBudgetApprovalsGroupAssigneesAssigneesMutation = { __typename?: 'mutation_root', insert_budget_approval_group_assignees_assignees: { __typename?: 'budget_approval_group_assignees_assignees_mutation_response', returning: Array<{ __typename?: 'budget_approval_group_assignees_assignees', id: string }> } | null };

export type InsertBudgetApprovalsGroupCustomCoreDataMutationVariables = Exact<{
  groupId: Scalars['uuid']['input'];
  customCoreDataId: Scalars['uuid']['input'];
}>;


export type InsertBudgetApprovalsGroupCustomCoreDataMutation = { __typename?: 'mutation_root', insert_budget_approval_group_selected_custom_core_data_one: { __typename?: 'budget_approval_group_selected_custom_core_data', budget_approval_group_id: string } | null };

export type InsertBudgetApprovalsThresholdMutationVariables = Exact<{
  input: BudgetApprovalThresholdInsertInput;
}>;


export type InsertBudgetApprovalsThresholdMutation = { __typename?: 'mutation_root', insert_budget_approval_threshold_one: { __typename?: 'budget_approval_threshold', id: string, name: string, created_at: string, minValue: number, maxValue: number | null, inBudget: boolean | null, departments: Array<{ __typename?: 'budget_approval_threshold_department', department: { __typename?: 'departments', id: string, name: string } }>, groups: Array<{ __typename?: 'budget_approval_threshold_group', id: string, isApproval: boolean, approvalGroupId: string }> } | null };

export type RemoveBudgetApprovalsGroupCustomCoreDataMutationVariables = Exact<{
  groupId: Scalars['uuid']['input'];
  customCoreDataId: Scalars['uuid']['input'];
}>;


export type RemoveBudgetApprovalsGroupCustomCoreDataMutation = { __typename?: 'mutation_root', delete_budget_approval_group_selected_custom_core_data_by_pk: { __typename?: 'budget_approval_group_selected_custom_core_data', budget_approval_group_id: string } | null };

export type UpdateBudgetApprovalGroupAssigneesMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: BudgetApprovalGroupAssigneesSetInput;
}>;


export type UpdateBudgetApprovalGroupAssigneesMutation = { __typename?: 'mutation_root', update_budget_approval_group_assignees_by_pk: { __typename?: 'budget_approval_group_assignees', id: string } | null };

export type UpdateBudgetApprovalsGroupNameMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateBudgetApprovalsGroupNameMutation = { __typename?: 'mutation_root', update_budget_approval_group_by_pk: { __typename?: 'budget_approval_group', id: string, name: string } | null };

export type UpdateBudgetApprovalsThresholdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: BudgetApprovalThresholdSetInput;
  insertDepartmentsInput: Array<BudgetApprovalThresholdDepartmentInsertInput> | BudgetApprovalThresholdDepartmentInsertInput;
  insertGroupsInput: Array<BudgetApprovalThresholdGroupInsertInput> | BudgetApprovalThresholdGroupInsertInput;
}>;


export type UpdateBudgetApprovalsThresholdMutation = { __typename?: 'mutation_root', update_budget_approval_threshold_by_pk: { __typename?: 'budget_approval_threshold', id: string, name: string, created_at: string, minValue: number, maxValue: number | null, inBudget: boolean | null, departments: Array<{ __typename?: 'budget_approval_threshold_department', department: { __typename?: 'departments', id: string, name: string } }>, groups: Array<{ __typename?: 'budget_approval_threshold_group', id: string, isApproval: boolean, approvalGroupId: string }> } | null, delete_budget_approval_threshold_department: { __typename?: 'budget_approval_threshold_department_mutation_response', returning: Array<{ __typename?: 'budget_approval_threshold_department', thresholdId: string }> } | null, insert_budget_approval_threshold_department: { __typename?: 'budget_approval_threshold_department_mutation_response', returning: Array<{ __typename?: 'budget_approval_threshold_department', thresholdId: string }> } | null, delete_budget_approval_threshold_group: { __typename?: 'budget_approval_threshold_group_mutation_response', returning: Array<{ __typename?: 'budget_approval_threshold_group', id: string }> } | null, insert_budget_approval_threshold_group: { __typename?: 'budget_approval_threshold_group_mutation_response', returning: Array<{ __typename?: 'budget_approval_threshold_group', id: string }> } | null };

export type CreateBudgetMutationVariables = Exact<{
  name: Scalars['String']['input'];
  status: Scalars['String']['input'];
  currency_id: Scalars['uuid']['input'];
  amount: Scalars['numeric']['input'];
}>;


export type CreateBudgetMutation = { __typename?: 'mutation_root', insert_budgets_one: { __typename?: 'budgets', id: string } | null };

export type BudgetsWithSpendComputeFragment = { __typename?: 'budgets', id: string, amount: number, externalId: string | null, name: string, status: OverrideTypes["BudgetStatus"], createdAt: string, budgets_organisation_fx_rate: { __typename?: 'organisation_fx_rates', id: string, code: OverrideTypes["CurrencyCode"], displaySymbol: string | null, fxRate: number }, requests: Array<{ __typename?: 'requests', id: string, engagement: { __typename?: 'engagements', id: string, financial: { __typename?: 'financials', id: string, amount: number | null } | null } | null, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null } | null }> };

export type GetBudgetQueryVariables = Exact<{
  budgetId: Scalars['uuid']['input'];
}>;


export type GetBudgetQuery = { __typename?: 'query_root', budgets: Array<{ __typename?: 'budgets', id: string, amount: number, externalId: string | null, name: string, status: OverrideTypes["BudgetStatus"], createdAt: string, budgets_organisation_fx_rate: { __typename?: 'organisation_fx_rates', id: string, code: OverrideTypes["CurrencyCode"], displaySymbol: string | null, fxRate: number }, requests: Array<{ __typename?: 'requests', id: string, engagement: { __typename?: 'engagements', id: string, financial: { __typename?: 'financials', id: string, amount: number | null } | null } | null, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null } | null }> }> };

export type GetBudgetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBudgetsQuery = { __typename?: 'query_root', budgets: Array<{ __typename?: 'budgets', id: string, amount: number, externalId: string | null, name: string, status: OverrideTypes["BudgetStatus"], createdAt: string, budgets_organisation_fx_rate: { __typename?: 'organisation_fx_rates', id: string, code: OverrideTypes["CurrencyCode"], displaySymbol: string | null, fxRate: number }, requests: Array<{ __typename?: 'requests', id: string, engagement: { __typename?: 'engagements', id: string, financial: { __typename?: 'financials', id: string, amount: number | null } | null } | null, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null } | null }> }> };

export type GetAdminsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminsQuery = { __typename?: 'query_root', admins: Array<{ __typename?: 'users', id: string, email: string, firstName: string, lastName: string, isArchived: boolean, hasConfigPermissions: boolean }> };

export type GetInitialInternalUsersAndGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInitialInternalUsersAndGroupsQuery = { __typename?: 'query_root', initialInternalUsers: Array<{ __typename?: 'users', id: string, email: string, firstName: string, lastName: string, isArchived: boolean, hasConfigPermissions: boolean }>, groups: Array<{ __typename?: 'groups', id: string, name: string }> };

export type GetFormTypeAndStepTasksQueryVariables = Exact<{
  requestFormId: Scalars['uuid']['input'];
}>;


export type GetFormTypeAndStepTasksQuery = { __typename?: 'query_root', request_forms_by_pk: { __typename?: 'request_forms', id: string, type: FormTypeEnum, request_form_template_id: string | null, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, request_step_task_users: Array<{ __typename?: 'request_step_task_users', user_id: string }>, request_step: { __typename?: 'request_steps', id: string, state: RequestStepStateEnum, input: any, completedAt: string | null, type: any, request_step_users: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string } }> } }> } | null };

export type GetRfxRequestStepIdQueryVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
}>;


export type GetRfxRequestStepIdQuery = { __typename?: 'query_root', rfx_by_pk: { __typename?: 'rfx', id: string, requestStepId: string, organisation: { __typename?: 'organisations', id: string, name: string } } | null };

export type GetConfigTranslationsWithSourceHashQueryVariables = Exact<{
  locale: Scalars['String']['input'];
}>;


export type GetConfigTranslationsWithSourceHashQuery = { __typename?: 'query_root', config_translations: Array<{ __typename?: 'config_translations', key: string, value: string, entityId: string, namespace: string, sourceHash: string | null }> };

export type CustomFieldsFragmentFragment = { __typename?: 'custom_fields', id: string, title: string, type: OverrideTypes["CustomFieldsType"], entityType: OverrideTypes["CustomFieldsEntityType"], isRequired: boolean, externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, remoteId: string | null, customCoreData: { __typename?: 'custom_core_data', id: string, name: string } | null, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string, customFieldId: string }> };

export type GetAllCustomFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCustomFieldsQuery = { __typename?: 'query_root', customFields: Array<{ __typename?: 'custom_fields', id: string, title: string, type: OverrideTypes["CustomFieldsType"], entityType: OverrideTypes["CustomFieldsEntityType"], isRequired: boolean, externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, remoteId: string | null, customCoreData: { __typename?: 'custom_core_data', id: string, name: string } | null, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string, customFieldId: string }> }> };

export type GetAllCustomFieldsForIntegrationQueryVariables = Exact<{
  integrationId: Scalars['uuid']['input'];
}>;


export type GetAllCustomFieldsForIntegrationQuery = { __typename?: 'query_root', customFields: Array<{ __typename?: 'custom_fields', id: string, title: string, type: OverrideTypes["CustomFieldsType"], entityType: OverrideTypes["CustomFieldsEntityType"], isRequired: boolean, externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, remoteId: string | null, customCoreData: { __typename?: 'custom_core_data', id: string, name: string } | null, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string, customFieldId: string }> }> };

export type GetCoreDataOrganisationIntegrationsForIntegrationIdQueryVariables = Exact<{
  organisationIntegrationId: Scalars['uuid']['input'];
}>;


export type GetCoreDataOrganisationIntegrationsForIntegrationIdQuery = { __typename?: 'query_root', core_data_organisation_integrations: Array<{ __typename?: 'core_data_organisation_integrations', id: string, organisationIntegrationId: string, coreDataType: string }> };

export type GetCustomCoreDataForIntegrationQueryVariables = Exact<{
  integrationId: Scalars['uuid']['input'];
}>;


export type GetCustomCoreDataForIntegrationQuery = { __typename?: 'query_root', custom_core_data: Array<{ __typename?: 'custom_core_data', id: string, name: string, organisationId: string, pathLevels: Array<string> | null, archivedAt: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null, options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string }>, numOptions: { __typename?: 'custom_core_data_options_aggregate', aggregate: { __typename?: 'custom_core_data_options_aggregate_fields', count: number } | null } }> };

export type GetOrganisationIntegrationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrganisationIntegrationQuery = { __typename?: 'query_root', organisation_integrations_by_pk: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"], name: string | null, referenceId: string | null, defaultSupplierState: OrganisationSupplierStateEnum | null, updatedAt: string } | null };

export type ListOrganisationIntegrationsQueryVariables = Exact<{
  query: InputMaybe<OrganisationIntegrationsBoolExp>;
}>;


export type ListOrganisationIntegrationsQuery = { __typename?: 'query_root', organisation_integrations: Array<{ __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"], name: string | null, updatedAt: string, referenceId: string | null, defaultSupplierState: OrganisationSupplierStateEnum | null }> };

export type GetLatestExternalEntitySyncStatusForCustomCoreDataIdQueryVariables = Exact<{
  customCoreDataId: Scalars['uuid']['input'];
  organisationIntegrationId: Scalars['uuid']['input'];
}>;


export type GetLatestExternalEntitySyncStatusForCustomCoreDataIdQuery = { __typename?: 'query_root', external_entity_sync_statuses: Array<{ __typename?: 'external_entity_sync_statuses', id: string, type: OverrideTypes["KebabSyncStatusType"], status: string, completedAt: string | null, createdAt: string, error: any | null, customCoreDataId: string | null }> };

export type GetLatestExternalEntitySyncStatusForTypeQueryVariables = Exact<{
  entityType: Scalars['String']['input'];
  organisationIntegrationId: Scalars['uuid']['input'];
}>;


export type GetLatestExternalEntitySyncStatusForTypeQuery = { __typename?: 'query_root', external_entity_sync_statuses: Array<{ __typename?: 'external_entity_sync_statuses', id: string, type: OverrideTypes["KebabSyncStatusType"], status: string, completedAt: string | null, createdAt: string, error: any | null, customCoreDataId: string | null }> };

export type GetExternalEntitySyncStatusesQueryVariables = Exact<{
  organisationIntegrationId: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetExternalEntitySyncStatusesQuery = { __typename?: 'query_root', external_entity_sync_statuses: Array<{ __typename?: 'external_entity_sync_statuses', id: string, type: OverrideTypes["KebabSyncStatusType"], status: string, completedAt: string | null, createdAt: string, error: any | null, customCoreData: { __typename?: 'custom_core_data', id: string, name: string } | null }> };

export type GetSystemCoreDataCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSystemCoreDataCountsQuery = { __typename?: 'query_root', addresses: { __typename?: 'addresses_aggregate', aggregate: { __typename?: 'addresses_aggregate_fields', count: number } | null }, currencies: { __typename?: 'organisation_fx_rates_aggregate', aggregate: { __typename?: 'organisation_fx_rates_aggregate_fields', count: number } | null }, departments: { __typename?: 'departments_aggregate', aggregate: { __typename?: 'departments_aggregate_fields', count: number } | null }, lineItemTypes: { __typename?: 'line_item_types_aggregate', aggregate: { __typename?: 'line_item_types_aggregate_fields', count: number } | null }, paymentMethods: { __typename?: 'payment_methods_aggregate', aggregate: { __typename?: 'payment_methods_aggregate_fields', count: number } | null }, paymentTerms: { __typename?: 'payment_terms_aggregate', aggregate: { __typename?: 'payment_terms_aggregate_fields', count: number } | null }, subsidiaries: { __typename?: 'subsidiaries_aggregate', aggregate: { __typename?: 'subsidiaries_aggregate_fields', count: number } | null }, suppliers: { __typename?: 'organisation_suppliers_aggregate', aggregate: { __typename?: 'organisation_suppliers_aggregate_fields', count: number } | null } };

export type CompleteExternalEntitySyncMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  status: Scalars['String']['input'];
  error: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type CompleteExternalEntitySyncMutation = { __typename?: 'mutation_root', updatedStatus: { __typename?: 'external_entity_sync_statuses', id: string } | null };

export type FormTemplateFragmentFragment = { __typename?: 'form_templates', config: OverrideTypes["FormConfig"], description: string, id: string, internalId: string | null, state: FormTemplateStateEnum, title: string, integration: OverrideTypes["Integration"] | null, externalTitle: string | null, type: FormTypeEnum, updatedAt: string, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null };

export type GetEngagementFormTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEngagementFormTemplatesQuery = { __typename?: 'query_root', form_templates: Array<{ __typename?: 'form_templates', id: string, config: OverrideTypes["FormConfig"], title: string, type: FormTypeEnum, description: string, internalId: string | null }> };

export type GetFormTemplateConfigsByIdsQueryVariables = Exact<{
  formTemplateIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetFormTemplateConfigsByIdsQuery = { __typename?: 'query_root', form_templates: Array<{ __typename?: 'form_templates', id: string, config: OverrideTypes["FormConfig"], title: string }> };

export type GetFormTemplateOneQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetFormTemplateOneQuery = { __typename?: 'query_root', form_templates_by_pk: { __typename?: 'form_templates', config: OverrideTypes["FormConfig"], title: string, id: string, description: string } | null };

export type GetFormTemplatesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetFormTemplatesByIdsQuery = { __typename?: 'query_root', form_templates: Array<{ __typename?: 'form_templates', config: OverrideTypes["FormConfig"], description: string, id: string, internalId: string | null, state: FormTemplateStateEnum, title: string, integration: OverrideTypes["Integration"] | null, externalTitle: string | null, type: FormTypeEnum, updatedAt: string, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null }> };

export type GetUsersMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersMinimalQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, firstName: string, lastName: string }> };

export type GetGroupsMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupsMinimalQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'groups', id: string, name: string }> };

export type GetWorkflowQueryVariables = Exact<{
  workflowId: Scalars['uuid']['input'];
}>;


export type GetWorkflowQuery = { __typename?: 'query_root', workflow: { __typename?: 'workflows', id: string, type: WorkflowTypeEnum, state: WorkflowStateEnum, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"], title: string, description: string, isArchived: boolean, expectedSLA: number | null } | null };

export type InsertWorkflowFormTemplatesMutationVariables = Exact<{
  objects: Array<WorkflowFormTemplatesInsertInput> | WorkflowFormTemplatesInsertInput;
}>;


export type InsertWorkflowFormTemplatesMutation = { __typename?: 'mutation_root', insert_workflow_form_templates: { __typename?: 'workflow_form_templates_mutation_response', returning: Array<{ __typename?: 'workflow_form_templates', id: string }> } | null };

export type ListWorkflowsQueryVariables = Exact<{
  type: Array<WorkflowTypeEnum> | WorkflowTypeEnum;
  state: InputMaybe<Array<WorkflowStateEnum> | WorkflowStateEnum>;
  isArchived: Scalars['Boolean']['input'];
}>;


export type ListWorkflowsQuery = { __typename?: 'query_root', workflows: Array<{ __typename?: 'workflows', id: string, title: string, description: string, type: WorkflowTypeEnum, url: string | null, state: WorkflowStateEnum, isArchived: boolean, createdAt: string, updatedAt: string, viewModelUpdatedAt: string | null, canvasModelUpdatedAt: string, updated_by_user: { __typename?: 'users', firstName: string, lastName: string } | null, workflow_rank: { __typename?: 'workflow_ranks', rank: number } | null }> };

export type UpdateWorkflowMutationVariables = Exact<{
  workflowId: Scalars['uuid']['input'];
  workflow: WorkflowsSetInput;
}>;


export type UpdateWorkflowMutation = { __typename?: 'mutation_root', workflow: { __typename?: 'workflows', id: string, state: WorkflowStateEnum } | null };

export type DeleteExternalContactMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteExternalContactMutation = { __typename?: 'mutation_root', update_external_contacts_by_pk: { __typename?: 'external_contacts', id: string, title: string | null, supplierId: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, createdAt: string, isPrimary: boolean, userId: string | null } | null };

export type DeleteInternalContactMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteInternalContactMutation = { __typename?: 'mutation_root', update_internal_contacts_by_pk: { __typename?: 'internal_contacts', id: string, role: OverrideTypes["InternalContactRole"], title: string | null, supplierId: string, createdAt: string, product: { __typename?: 'organisation_products_and_services', id: string, logoUrl: string | null, name: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, engagement: { __typename?: 'engagements', id: string, name: string } | null } | null };

export type ExternalContactFragment = { __typename?: 'external_contacts', id: string, title: string | null, supplierId: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, createdAt: string, isPrimary: boolean, userId: string | null };

export type GetAllExternalContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllExternalContactsQuery = { __typename?: 'query_root', external_contacts: Array<{ __typename?: 'external_contacts', id: string, title: string | null, supplierId: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, createdAt: string, isPrimary: boolean, userId: string | null }> };

export type GetSupplierIdOfExternalContactQueryVariables = Exact<{
  contactId: Scalars['uuid']['input'];
}>;


export type GetSupplierIdOfExternalContactQuery = { __typename?: 'query_root', external_contacts_by_pk: { __typename?: 'external_contacts', supplierId: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, title: string | null } | null };

export type GetExternalContactsQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
}>;


export type GetExternalContactsQuery = { __typename?: 'query_root', external_contacts: Array<{ __typename?: 'external_contacts', id: string, title: string | null, supplierId: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, createdAt: string, isPrimary: boolean, userId: string | null }> };

export type GetInternalContactsQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
}>;


export type GetInternalContactsQuery = { __typename?: 'query_root', internal_contacts: Array<{ __typename?: 'internal_contacts', id: string, role: OverrideTypes["InternalContactRole"], title: string | null, supplierId: string, createdAt: string, product: { __typename?: 'organisation_products_and_services', id: string, logoUrl: string | null, name: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, engagement: { __typename?: 'engagements', id: string, name: string } | null }> };

export type InsertExternalContactMutationVariables = Exact<{
  input: ExternalContactsInsertInput;
}>;


export type InsertExternalContactMutation = { __typename?: 'mutation_root', insert_external_contacts_one: { __typename?: 'external_contacts', id: string, title: string | null, supplierId: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, createdAt: string, isPrimary: boolean, userId: string | null } | null };

export type InsertInternalContactMutationVariables = Exact<{
  input: InternalContactsInsertInput;
}>;


export type InsertInternalContactMutation = { __typename?: 'mutation_root', insert_internal_contacts_one: { __typename?: 'internal_contacts', id: string, role: OverrideTypes["InternalContactRole"], title: string | null, supplierId: string, createdAt: string, product: { __typename?: 'organisation_products_and_services', id: string, logoUrl: string | null, name: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, engagement: { __typename?: 'engagements', id: string, name: string } | null } | null };

export type InternalContactFragment = { __typename?: 'internal_contacts', id: string, role: OverrideTypes["InternalContactRole"], title: string | null, supplierId: string, createdAt: string, product: { __typename?: 'organisation_products_and_services', id: string, logoUrl: string | null, name: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, engagement: { __typename?: 'engagements', id: string, name: string } | null };

export type SetPrimaryExternalContactMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  supplierId: Scalars['uuid']['input'];
}>;


export type SetPrimaryExternalContactMutation = { __typename?: 'mutation_root', update_external_contacts: { __typename?: 'external_contacts_mutation_response', returning: Array<{ __typename?: 'external_contacts', id: string, title: string | null, supplierId: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, createdAt: string, isPrimary: boolean, userId: string | null }> } | null, update_external_contacts_by_pk: { __typename?: 'external_contacts', id: string, title: string | null, supplierId: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, createdAt: string, isPrimary: boolean, userId: string | null } | null };

export type UpdateAgreementLinkedInternalContactMutationVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
  agreementId: Scalars['uuid']['input'];
  input: InternalContactsInsertInput;
}>;


export type UpdateAgreementLinkedInternalContactMutation = { __typename?: 'mutation_root', update_internal_contacts: { __typename?: 'internal_contacts_mutation_response', affected_rows: number } | null, internalContact: { __typename?: 'internal_contacts', id: string, role: OverrideTypes["InternalContactRole"], title: string | null, supplierId: string, createdAt: string, product: { __typename?: 'organisation_products_and_services', id: string, logoUrl: string | null, name: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, engagement: { __typename?: 'engagements', id: string, name: string } | null } | null };

export type UpdateExternalContactMutationVariables = Exact<{
  contactId: Scalars['uuid']['input'];
  input: ExternalContactsSetInput;
}>;


export type UpdateExternalContactMutation = { __typename?: 'mutation_root', update_external_contacts_by_pk: { __typename?: 'external_contacts', id: string, title: string | null, supplierId: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, createdAt: string, isPrimary: boolean, userId: string | null } | null };

export type UpdateInternalContactMutationVariables = Exact<{
  contactId: Scalars['uuid']['input'];
  input: InternalContactsSetInput;
}>;


export type UpdateInternalContactMutation = { __typename?: 'mutation_root', update_internal_contacts_by_pk: { __typename?: 'internal_contacts', id: string, role: OverrideTypes["InternalContactRole"], title: string | null, supplierId: string, createdAt: string, product: { __typename?: 'organisation_products_and_services', id: string, logoUrl: string | null, name: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, engagement: { __typename?: 'engagements', id: string, name: string } | null } | null };

export type CoreDataDependenciesFragment = { __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null };

export type GetCoreDataItemsBatchQueryVariables = Exact<{
  addressIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  currencyIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  departmentIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  lineItemTypeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  paymentMethodIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  paymentTermIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  subsidiaryIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  customIds: InputMaybe<Scalars['_uuid']['input']>;
}>;


export type GetCoreDataItemsBatchQuery = { __typename?: 'query_root', addresses: Array<{ __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, isArchived: boolean }>, organisation_fx_rates: Array<{ __typename?: 'organisation_fx_rates', id: string, code: OverrideTypes["CurrencyCode"], isArchived: boolean }>, departments: Array<{ __typename?: 'departments', id: string, name: string, isArchived: boolean }>, line_item_types: Array<{ __typename?: 'line_item_types', id: string, name: string, isArchived: boolean }>, payment_methods: Array<{ __typename?: 'payment_methods', id: string, name: string, isArchived: boolean }>, payment_terms: Array<{ __typename?: 'payment_terms', id: string, name: string, isArchived: boolean }>, subsidiaries: Array<{ __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean }>, get_all_nodes_until_root_for_ids: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, parentId: string | null }> };

export type GetCoreDataOrganisationIntegrationWithTypeQueryVariables = Exact<{
  coreDataType: Scalars['String']['input'];
}>;


export type GetCoreDataOrganisationIntegrationWithTypeQuery = { __typename?: 'query_root', core_data_organisation_integrations: Array<{ __typename?: 'core_data_organisation_integrations', id: string, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } }> };

export type GetCustomCoreDataOptionsByFilterQueryVariables = Exact<{
  filter: CustomCoreDataOptionsBoolExp;
}>;


export type GetCustomCoreDataOptionsByFilterQuery = { __typename?: 'query_root', custom_core_data_options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string }> };

export type GetDependenciesForCoreDataIdQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order_by: InputMaybe<Array<CoreDataDependenciesOrderBy> | CoreDataDependenciesOrderBy>;
  where: InputMaybe<CoreDataDependenciesBoolExp>;
}>;


export type GetDependenciesForCoreDataIdQuery = { __typename?: 'query_root', core_data_dependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, core_data_dependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } };

export type GetOrgCoreDataDependenciesForSystemCoreDataQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type GetOrgCoreDataDependenciesForSystemCoreDataQuery = { __typename?: 'query_root', organisation_core_data_dependencies: Array<{ __typename?: 'organisation_core_data_dependencies', id: string, dependencyCoreDataType: OverrideTypes["KebabDependencyType"], dependencyCustomCoreData: { __typename?: 'custom_core_data', id: string, name: string } | null }> };

export type GetOrgCoreDataDependenciesForCustomCoreDataQueryVariables = Exact<{
  customCoreDataId: Scalars['uuid']['input'];
}>;


export type GetOrgCoreDataDependenciesForCustomCoreDataQuery = { __typename?: 'query_root', organisation_core_data_dependencies: Array<{ __typename?: 'organisation_core_data_dependencies', id: string, dependencyCoreDataType: OverrideTypes["KebabDependencyType"], dependencyCustomCoreData: { __typename?: 'custom_core_data', id: string, name: string } | null }> };

export type UpsertCurrenciesMutationVariables = Exact<{
  objects: Array<OrganisationFxRatesInsertInput> | OrganisationFxRatesInsertInput;
}>;


export type UpsertCurrenciesMutation = { __typename?: 'mutation_root', insertedCurrencies: { __typename?: 'organisation_fx_rates_mutation_response', affected_rows: number } | null };

export type UpsertDepartmentsMutationVariables = Exact<{
  objects: Array<DepartmentsInsertInput> | DepartmentsInsertInput;
}>;


export type UpsertDepartmentsMutation = { __typename?: 'mutation_root', insert_departments: { __typename?: 'departments_mutation_response', affected_rows: number } | null };

export type UpsertLineItemTypesMutationVariables = Exact<{
  objects: Array<LineItemTypesInsertInput> | LineItemTypesInsertInput;
}>;


export type UpsertLineItemTypesMutation = { __typename?: 'mutation_root', insert_line_item_types: { __typename?: 'line_item_types_mutation_response', affected_rows: number } | null };

export type UpsertPaymentMethodsMutationVariables = Exact<{
  objects: Array<PaymentMethodsInsertInput> | PaymentMethodsInsertInput;
}>;


export type UpsertPaymentMethodsMutation = { __typename?: 'mutation_root', insert_payment_methods: { __typename?: 'payment_methods_mutation_response', affected_rows: number } | null };

export type UpsertPaymentTermsMutationVariables = Exact<{
  objects: Array<PaymentTermsInsertInput> | PaymentTermsInsertInput;
}>;


export type UpsertPaymentTermsMutation = { __typename?: 'mutation_root', insert_payment_terms: { __typename?: 'payment_terms_mutation_response', affected_rows: number } | null };

export type UpsertSubsidiariesMutationVariables = Exact<{
  objects: Array<SubsidiariesInsertInput> | SubsidiariesInsertInput;
}>;


export type UpsertSubsidiariesMutation = { __typename?: 'mutation_root', insert_subsidiaries: { __typename?: 'subsidiaries_mutation_response', affected_rows: number } | null };

export type CoreDataFragment = { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null };

export type SupplierProfileFragment = { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } };

export type LabelsPayloadFragment = { __typename?: 'custom_core_data', pathLevels: Array<string> | null, archivedAt: string | null, customCoreDataId: string, label: string, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null };

export type GetAllCustomCoreDataOptionsQueryVariables = Exact<{
  query: InputMaybe<CustomCoreDataOptionsBoolExp>;
}>;


export type GetAllCustomCoreDataOptionsQuery = { __typename?: 'query_root', custom_core_data_options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string }> };

export type GetCustomCoreDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomCoreDataQuery = { __typename?: 'query_root', custom_core_data: Array<{ __typename?: 'custom_core_data', id: string, name: string, organisationId: string, pathLevels: Array<string> | null, archivedAt: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null, options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string }>, numOptions: { __typename?: 'custom_core_data_options_aggregate', aggregate: { __typename?: 'custom_core_data_options_aggregate_fields', count: number } | null } }> };

export type GetCustomCoreDataWithDependenciesMetadataQueryVariables = Exact<{
  depsLimit: Scalars['Int']['input'];
}>;


export type GetCustomCoreDataWithDependenciesMetadataQuery = { __typename?: 'query_root', custom_core_data: Array<{ __typename?: 'custom_core_data', id: string, name: string, organisationId: string, pathLevels: Array<string> | null, archivedAt: string | null, options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } }>, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null, numOptions: { __typename?: 'custom_core_data_options_aggregate', aggregate: { __typename?: 'custom_core_data_options_aggregate_fields', count: number } | null } }> };

export type GetCustomCoreDataWithDependenciesMetadataIncludingArchivedQueryVariables = Exact<{
  depsLimit: Scalars['Int']['input'];
}>;


export type GetCustomCoreDataWithDependenciesMetadataIncludingArchivedQuery = { __typename?: 'query_root', custom_core_data: Array<{ __typename?: 'custom_core_data', id: string, name: string, organisationId: string, pathLevels: Array<string> | null, archivedAt: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null, options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } }>, numOptions: { __typename?: 'custom_core_data_options_aggregate', aggregate: { __typename?: 'custom_core_data_options_aggregate_fields', count: number } | null } }> };

export type GetCustomCoreDataLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomCoreDataLabelsQuery = { __typename?: 'query_root', multiLevel: Array<{ __typename?: 'custom_core_data', pathLevels: Array<string> | null, archivedAt: string | null, customCoreDataId: string, label: string, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null }>, singleLevel: Array<{ __typename?: 'custom_core_data', pathLevels: Array<string> | null, archivedAt: string | null, customCoreDataId: string, label: string, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null }> };

export type GetCustomCoreDataLabelsIncludingArchivedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomCoreDataLabelsIncludingArchivedQuery = { __typename?: 'query_root', multiLevel: Array<{ __typename?: 'custom_core_data', pathLevels: Array<string> | null, archivedAt: string | null, customCoreDataId: string, label: string, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null }>, singleLevel: Array<{ __typename?: 'custom_core_data', pathLevels: Array<string> | null, archivedAt: string | null, customCoreDataId: string, label: string, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null }> };

export type GetCustomFieldsByCustomCoreDataIdQueryVariables = Exact<{
  customCoreDataId: Scalars['uuid']['input'];
}>;


export type GetCustomFieldsByCustomCoreDataIdQuery = { __typename?: 'query_root', customFields: Array<{ __typename?: 'custom_fields', id: string }> };

export type GetCustomCoreDataOptionsWithDependenciesMetadataByIdsQueryVariables = Exact<{
  customCoreDataOptionIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  depsLimit: Scalars['Int']['input'];
}>;


export type GetCustomCoreDataOptionsWithDependenciesMetadataByIdsQuery = { __typename?: 'query_root', custom_core_data_options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } }> };

export type PaginateCustomCoreDataOptionsQueryVariables = Exact<{
  customCoreDataId: Scalars['uuid']['input'];
  dependencyCoreDataId: InputMaybe<Scalars['uuid']['input']>;
  dependencySupplierProfileId: InputMaybe<Scalars['uuid']['input']>;
  prevCursor?: InputMaybe<Scalars['ltree']['input']>;
  nextCursor?: InputMaybe<Scalars['ltree']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  sortLevel?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  conjunction?: InputMaybe<Scalars['String']['input']>;
  conditions?: InputMaybe<Scalars['jsonb']['input']>;
  depsLimit?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  includeCount?: Scalars['Boolean']['input'];
}>;


export type PaginateCustomCoreDataOptionsQuery = { __typename?: 'query_root', paginate_custom_core_data_options: Array<{ __typename?: 'custom_core_data_options', path: string, id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } }>, get_custom_core_data_counts?: Array<{ __typename?: 'z_workaround_ccdo_count', filtered_count: number | null }> };

export type ArchiveCustomCoreDataMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ArchiveCustomCoreDataMutation = { __typename?: 'mutation_root', update_custom_core_data: { __typename?: 'custom_core_data_mutation_response', returning: Array<{ __typename?: 'custom_core_data', id: string }> } | null };

export type InsertCustomCoreDataMutationVariables = Exact<{
  input: CustomCoreDataInsertInput;
}>;


export type InsertCustomCoreDataMutation = { __typename?: 'mutation_root', insert_custom_core_data_one: { __typename?: 'custom_core_data', id: string } | null };

export type InsertCustomCoreDataOptionMutationVariables = Exact<{
  input: CustomCoreDataOptionsInsertInput;
}>;


export type InsertCustomCoreDataOptionMutation = { __typename?: 'mutation_root', insert_custom_core_data_options_one: { __typename?: 'custom_core_data_options', id: string, coreData: { __typename?: 'core_data', id: string } } | null };

export type InsertCustomCoreDataOptionsBulkMutationVariables = Exact<{
  input: Array<CustomCoreDataOptionsInsertInput> | CustomCoreDataOptionsInsertInput;
}>;


export type InsertCustomCoreDataOptionsBulkMutation = { __typename?: 'mutation_root', insert_custom_core_data_options: { __typename?: 'custom_core_data_options_mutation_response', returning: Array<{ __typename?: 'custom_core_data_options', id: string, value: string }> } | null };

export type UpdateCustomCoreDataMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  setInput: CustomCoreDataSetInput;
}>;


export type UpdateCustomCoreDataMutation = { __typename?: 'mutation_root', update_custom_core_data_by_pk: { __typename?: 'custom_core_data', id: string } | null };

export type UpdateCustomCoreDataOptionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: CustomCoreDataOptionsSetInput;
}>;


export type UpdateCustomCoreDataOptionMutation = { __typename?: 'mutation_root', update_custom_core_data_options_by_pk: { __typename?: 'custom_core_data_options', id: string, coreData: { __typename?: 'core_data', id: string } } | null };

export type UpsertCustomCoreDataOptionsMutationVariables = Exact<{
  objects: Array<CustomCoreDataOptionsInsertInput> | CustomCoreDataOptionsInsertInput;
}>;


export type UpsertCustomCoreDataOptionsMutation = { __typename?: 'mutation_root', insert_custom_core_data_options: { __typename?: 'custom_core_data_options_mutation_response', affected_rows: number } | null };

export type GetArchivedCustomCoreDataOptionsByRemoteIdsQueryVariables = Exact<{
  customCoreDataId: Scalars['uuid']['input'];
  remoteIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetArchivedCustomCoreDataOptionsByRemoteIdsQuery = { __typename?: 'query_root', customCoreDataOptions: Array<{ __typename?: 'custom_core_data_options', id: string, remoteId: string | null, isArchived: boolean }> };

export type GetOrganisationSupplierProfileBySupplierAndSubsidiaryQueryVariables = Exact<{
  orgSupplierId: Scalars['uuid']['input'];
  subsidiaryId: Scalars['uuid']['input'];
}>;


export type GetOrganisationSupplierProfileBySupplierAndSubsidiaryQuery = { __typename?: 'query_root', organisation_supplier_profiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string }> };

export type GetAllOrganisationIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOrganisationIdsQuery = { __typename?: 'query_root', organisations: Array<{ __typename?: 'organisations', id: string }> };

export type GetCoreDataDependenciesQueryVariables = Exact<{
  where: InputMaybe<CoreDataDependenciesBoolExp>;
}>;


export type GetCoreDataDependenciesQuery = { __typename?: 'query_root', core_data_dependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> };

export type GetCoreDataForItemIdsQueryVariables = Exact<{
  filter: CoreDataBoolExp;
}>;


export type GetCoreDataForItemIdsQuery = { __typename?: 'query_root', coreDatum: Array<{ __typename?: 'core_data', id: string }> };

export type GetCustomCoreDataIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomCoreDataIdsQuery = { __typename?: 'query_root', custom_core_data: Array<{ __typename?: 'custom_core_data', id: string }> };

export type InsertExternalEntitySyncStatusMutationVariables = Exact<{
  input: ExternalEntitySyncStatusesInsertInput;
}>;


export type InsertExternalEntitySyncStatusMutation = { __typename?: 'mutation_root', syncStatus: { __typename?: 'external_entity_sync_statuses', id: string } | null };

export type InsertExternalEntitySyncStatusesMutationVariables = Exact<{
  input: Array<ExternalEntitySyncStatusesInsertInput> | ExternalEntitySyncStatusesInsertInput;
}>;


export type InsertExternalEntitySyncStatusesMutation = { __typename?: 'mutation_root', syncStatuses: { __typename?: 'external_entity_sync_statuses_mutation_response', returning: Array<{ __typename?: 'external_entity_sync_statuses', id: string }> } | null };

export type UpsertCoreDataDependenciesMutationVariables = Exact<{
  coreDataId: Scalars['uuid']['input'];
  dependenciesToUpsert: Array<CoreDataDependenciesInsertInput> | CoreDataDependenciesInsertInput;
  dependencyCoreDataIdsToKeep: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpsertCoreDataDependenciesMutation = { __typename?: 'mutation_root', upsertedDependencies: { __typename?: 'core_data_dependencies_mutation_response', returning: Array<{ __typename?: 'core_data_dependencies', id: string }> } | null, deletedDependencies: { __typename?: 'core_data_dependencies_mutation_response', returning: Array<{ __typename?: 'core_data_dependencies', id: string }> } | null };

export type UpsertCoreDataDependencyOnAllMutationVariables = Exact<{
  coreDataId: Scalars['uuid']['input'];
  coreDataType: Scalars['String']['input'];
  dependencyCoreDataType: Scalars['String']['input'];
}>;


export type UpsertCoreDataDependencyOnAllMutation = { __typename?: 'mutation_root', deletedDependencies: { __typename?: 'core_data_dependencies_mutation_response', returning: Array<{ __typename?: 'core_data_dependencies', id: string }> } | null, upsertedDependency: { __typename?: 'core_data_dependencies', id: string } | null };

export type UpsertCoreDataSupplierProfileDependenciesMutationVariables = Exact<{
  coreDataId: Scalars['uuid']['input'];
  dependenciesToUpsert: Array<CoreDataDependenciesInsertInput> | CoreDataDependenciesInsertInput;
  dependencySupplierProfileIdsToKeep: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpsertCoreDataSupplierProfileDependenciesMutation = { __typename?: 'mutation_root', upsertedDependencies: { __typename?: 'core_data_dependencies_mutation_response', returning: Array<{ __typename?: 'core_data_dependencies', id: string }> } | null, deletedDependencies: { __typename?: 'core_data_dependencies_mutation_response', returning: Array<{ __typename?: 'core_data_dependencies', id: string }> } | null };

export type UpsertCoreDataSupplierProfileDependencyOnAllMutationVariables = Exact<{
  coreDataId: Scalars['uuid']['input'];
  coreDataType: Scalars['String']['input'];
  dependencyCoreDataType: Scalars['String']['input'];
  organisationCoreDataDependencyId: Scalars['uuid']['input'];
}>;


export type UpsertCoreDataSupplierProfileDependencyOnAllMutation = { __typename?: 'mutation_root', deletedDependencies: { __typename?: 'core_data_dependencies_mutation_response', returning: Array<{ __typename?: 'core_data_dependencies', id: string }> } | null, upsertedDependency: { __typename?: 'core_data_dependencies', id: string } | null };

export type GetMultiLevelCustomCoreDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMultiLevelCustomCoreDataQuery = { __typename?: 'query_root', custom_core_data: Array<{ __typename?: 'custom_core_data', id: string, name: string, pathLevels: Array<string> | null, options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, parentId: string | null, isTerminal: boolean, remoteId: string | null }> }> };

export type GetMultiLevelCustomCoreDataWithCacheQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMultiLevelCustomCoreDataWithCacheQuery = { __typename?: 'query_root', custom_core_data: Array<{ __typename?: 'custom_core_data', id: string, name: string, pathLevels: Array<string> | null, options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, parentId: string | null, isTerminal: boolean }> }> };

export type AddressFragment = { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string };

export type AddressWithDependenciesMetadataFragment = { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } };

export type ArchiveAddressesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  archivedBy: Scalars['String']['input'];
}>;


export type ArchiveAddressesMutation = { __typename?: 'mutation_root', update_addresses: { __typename?: 'addresses_mutation_response', returning: Array<{ __typename?: 'addresses', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type GetAddressByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetAddressByIdQuery = { __typename?: 'query_root', addresses_by_pk: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null };

export type GetAddressWithDependenciesByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetAddressWithDependenciesByIdQuery = { __typename?: 'query_root', addresses_by_pk: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } } | null };

export type GetAddressesQueryVariables = Exact<{
  query: InputMaybe<AddressesBoolExp>;
}>;


export type GetAddressesQuery = { __typename?: 'query_root', addresses: Array<{ __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string }> };

export type GetAddressesWithDependenciesMetadataQueryVariables = Exact<{
  query: InputMaybe<AddressesBoolExp>;
  depsLimit: Scalars['Int']['input'];
}>;


export type GetAddressesWithDependenciesMetadataQuery = { __typename?: 'query_root', addresses: Array<{ __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } }> };

export type GetAddressesPaginatedQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy: Array<AddressesOrderBy> | AddressesOrderBy;
  query: InputMaybe<AddressesBoolExp>;
}>;


export type GetAddressesPaginatedQuery = { __typename?: 'query_root', addresses: Array<{ __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string }>, addresses_aggregate: { __typename?: 'addresses_aggregate', aggregate: { __typename?: 'addresses_aggregate_fields', count: number } | null } };

export type GetAddressesWithDependenciesQueryVariables = Exact<{
  query: InputMaybe<AddressesBoolExp>;
}>;


export type GetAddressesWithDependenciesQuery = { __typename?: 'query_root', addresses: Array<{ __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } }> };

export type InsertAddressMutationVariables = Exact<{
  object: AddressesInsertInput;
}>;


export type InsertAddressMutation = { __typename?: 'mutation_root', insert_addresses_one: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null };

export type UnarchiveAddressesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UnarchiveAddressesMutation = { __typename?: 'mutation_root', update_addresses: { __typename?: 'addresses_mutation_response', returning: Array<{ __typename?: 'addresses', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type UpdateAddressMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: AddressesSetInput;
}>;


export type UpdateAddressMutation = { __typename?: 'mutation_root', update_addresses_by_pk: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null };

export type ArchiveOrganisationFxRatesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  archivedBy: Scalars['String']['input'];
}>;


export type ArchiveOrganisationFxRatesMutation = { __typename?: 'mutation_root', update_organisation_fx_rates: { __typename?: 'organisation_fx_rates_mutation_response', returning: Array<{ __typename?: 'organisation_fx_rates', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type GetOrganisationCurrenciesPaginatedQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy: Array<OrganisationFxRatesOrderBy> | OrganisationFxRatesOrderBy;
  query: InputMaybe<OrganisationFxRatesBoolExp>;
}>;


export type GetOrganisationCurrenciesPaginatedQuery = { __typename?: 'query_root', organisation_fx_rates: Array<{ __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string }>, organisation_fx_rates_aggregate: { __typename?: 'organisation_fx_rates_aggregate', aggregate: { __typename?: 'organisation_fx_rates_aggregate_fields', count: number } | null } };

export type GetOrganisationCurrencyByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrganisationCurrencyByIdQuery = { __typename?: 'query_root', organisation_fx_rates_by_pk: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null };

export type GetOrganisationCurrencyWithDependenciesByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrganisationCurrencyWithDependenciesByIdQuery = { __typename?: 'query_root', organisation_fx_rates_by_pk: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } } | null };

export type GetOrganisationFxRatesQueryVariables = Exact<{
  query: InputMaybe<OrganisationFxRatesBoolExp>;
}>;


export type GetOrganisationFxRatesQuery = { __typename?: 'query_root', organisation_fx_rates: Array<{ __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string }> };

export type InsertOrganisationFxRateMutationVariables = Exact<{
  object: OrganisationFxRatesInsertInput;
}>;


export type InsertOrganisationFxRateMutation = { __typename?: 'mutation_root', insert_organisation_fx_rates_one: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null };

export type OrganisationFxRateFragment = { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string };

export type OrganisationFxRateWithDependenciesMetadataFragment = { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } };

export type UnarchiveOrganisationFxRatesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UnarchiveOrganisationFxRatesMutation = { __typename?: 'mutation_root', update_organisation_fx_rates: { __typename?: 'organisation_fx_rates_mutation_response', returning: Array<{ __typename?: 'organisation_fx_rates', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type UpdateOrganisationFxRateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: OrganisationFxRatesSetInput;
}>;


export type UpdateOrganisationFxRateMutation = { __typename?: 'mutation_root', update_organisation_fx_rates_by_pk: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null };

export type ArchiveCustomCoreDataOptionsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  archivedBy: InputMaybe<Scalars['String']['input']>;
}>;


export type ArchiveCustomCoreDataOptionsMutation = { __typename?: 'mutation_root', update_custom_core_data_options: { __typename?: 'custom_core_data_options_mutation_response', returning: Array<{ __typename?: 'custom_core_data_options', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type ArchiveCustomCoreDataOptionsForCustomCoreDataIdMutationVariables = Exact<{
  customCoreDataId: Scalars['uuid']['input'];
  archivedBy: InputMaybe<Scalars['String']['input']>;
}>;


export type ArchiveCustomCoreDataOptionsForCustomCoreDataIdMutation = { __typename?: 'mutation_root', update_custom_core_data_options: { __typename?: 'custom_core_data_options_mutation_response', returning: Array<{ __typename?: 'custom_core_data_options', id: string }> } | null };

export type GetCustomCoreDataOptionByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCustomCoreDataOptionByIdQuery = { __typename?: 'query_root', custom_core_data_options_by_pk: { __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string } | null };

export type GetCustomCoreDataOptionWithDependenciesByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCustomCoreDataOptionWithDependenciesByIdQuery = { __typename?: 'query_root', custom_core_data_options_by_pk: { __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } } | null };

export type GetCustomCoreDataOptionsPaginatedQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy: Array<CustomCoreDataOptionsOrderBy> | CustomCoreDataOptionsOrderBy;
  query: InputMaybe<CustomCoreDataOptionsBoolExp>;
}>;


export type GetCustomCoreDataOptionsPaginatedQuery = { __typename?: 'query_root', custom_core_data_options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string }>, custom_core_data_options_aggregate: { __typename?: 'custom_core_data_options_aggregate', aggregate: { __typename?: 'custom_core_data_options_aggregate_fields', count: number } | null } };

export type ArchiveDepartmentsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  archivedBy: Scalars['String']['input'];
}>;


export type ArchiveDepartmentsMutation = { __typename?: 'mutation_root', update_departments: { __typename?: 'departments_mutation_response', returning: Array<{ __typename?: 'departments', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type DepartmentFragment = { __typename?: 'departments', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string, organisationId: string, remoteId: string | null, updatedAt: string, coreDataId: string };

export type DepartmentWithDependenciesMetadataFragment = { __typename?: 'departments', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string, organisationId: string, remoteId: string | null, updatedAt: string, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } };

export type GetDepartmentByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDepartmentByIdQuery = { __typename?: 'query_root', departments_by_pk: { __typename?: 'departments', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string, organisationId: string, remoteId: string | null, updatedAt: string, coreDataId: string } | null };

export type GetDepartmentWithDependenciesByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDepartmentWithDependenciesByIdQuery = { __typename?: 'query_root', departments_by_pk: { __typename?: 'departments', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string, organisationId: string, remoteId: string | null, updatedAt: string, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } } | null };

export type GetDepartmentsQueryVariables = Exact<{
  query: InputMaybe<DepartmentsBoolExp>;
}>;


export type GetDepartmentsQuery = { __typename?: 'query_root', departments: Array<{ __typename?: 'departments', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string, organisationId: string, remoteId: string | null, updatedAt: string, coreDataId: string }> };

export type GetDepartmentsWithDependenciesMetadataQueryVariables = Exact<{
  query: InputMaybe<DepartmentsBoolExp>;
  depsLimit: Scalars['Int']['input'];
}>;


export type GetDepartmentsWithDependenciesMetadataQuery = { __typename?: 'query_root', departments: Array<{ __typename?: 'departments', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string, organisationId: string, remoteId: string | null, updatedAt: string, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } }> };

export type GetDepartmentsPaginatedQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy: Array<DepartmentsOrderBy> | DepartmentsOrderBy;
  query: InputMaybe<DepartmentsBoolExp>;
}>;


export type GetDepartmentsPaginatedQuery = { __typename?: 'query_root', departments: Array<{ __typename?: 'departments', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string, organisationId: string, remoteId: string | null, updatedAt: string, coreDataId: string }>, departments_aggregate: { __typename?: 'departments_aggregate', aggregate: { __typename?: 'departments_aggregate_fields', count: number } | null } };

export type GetDepartmentsWithDependenciesQueryVariables = Exact<{
  query: InputMaybe<DepartmentsBoolExp>;
}>;


export type GetDepartmentsWithDependenciesQuery = { __typename?: 'query_root', departments: Array<{ __typename?: 'departments', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string, organisationId: string, remoteId: string | null, updatedAt: string, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } }> };

export type InsertDepartmentMutationVariables = Exact<{
  object: DepartmentsInsertInput;
}>;


export type InsertDepartmentMutation = { __typename?: 'mutation_root', insert_departments_one: { __typename?: 'departments', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string, organisationId: string, remoteId: string | null, updatedAt: string, coreDataId: string } | null };

export type UnarchiveDepartmentsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UnarchiveDepartmentsMutation = { __typename?: 'mutation_root', update_departments: { __typename?: 'departments_mutation_response', returning: Array<{ __typename?: 'departments', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type UpdateDepartmentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: DepartmentsSetInput;
}>;


export type UpdateDepartmentMutation = { __typename?: 'mutation_root', update_departments_by_pk: { __typename?: 'departments', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string, organisationId: string, remoteId: string | null, updatedAt: string, coreDataId: string } | null };

export type ArchiveLineItemTypesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  archivedBy: Scalars['String']['input'];
}>;


export type ArchiveLineItemTypesMutation = { __typename?: 'mutation_root', update_line_item_types: { __typename?: 'line_item_types_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'line_item_types', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type GetLineItemTypeByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetLineItemTypeByIdQuery = { __typename?: 'query_root', line_item_types_by_pk: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string } | null };

export type GetLineItemTypeWithDependenciesByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetLineItemTypeWithDependenciesByIdQuery = { __typename?: 'query_root', line_item_types_by_pk: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } } | null };

export type GetLineItemTypesQueryVariables = Exact<{
  query: InputMaybe<LineItemTypesBoolExp>;
}>;


export type GetLineItemTypesQuery = { __typename?: 'query_root', line_item_types: Array<{ __typename?: 'line_item_types', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string }> };

export type GetLineItemTypesWithDependenciesMetadataQueryVariables = Exact<{
  query: InputMaybe<LineItemTypesBoolExp>;
  depsLimit: Scalars['Int']['input'];
}>;


export type GetLineItemTypesWithDependenciesMetadataQuery = { __typename?: 'query_root', line_item_types: Array<{ __typename?: 'line_item_types', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } }> };

export type GetLineItemTypesPaginatedQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy: Array<LineItemTypesOrderBy> | LineItemTypesOrderBy;
  query: InputMaybe<LineItemTypesBoolExp>;
}>;


export type GetLineItemTypesPaginatedQuery = { __typename?: 'query_root', line_item_types: Array<{ __typename?: 'line_item_types', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string }>, line_item_types_aggregate: { __typename?: 'line_item_types_aggregate', aggregate: { __typename?: 'line_item_types_aggregate_fields', count: number } | null } };

export type GetLineItemTypesWithDependenciesQueryVariables = Exact<{
  query: InputMaybe<LineItemTypesBoolExp>;
}>;


export type GetLineItemTypesWithDependenciesQuery = { __typename?: 'query_root', line_item_types: Array<{ __typename?: 'line_item_types', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } }> };

export type InsertLineItemTypeMutationVariables = Exact<{
  object: LineItemTypesInsertInput;
}>;


export type InsertLineItemTypeMutation = { __typename?: 'mutation_root', insert_line_item_types_one: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string } | null };

export type LineItemTypeFragment = { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string };

export type LineItemTypeWithDependenciesMetadataFragment = { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } };

export type UnarchiveLineItemTypesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UnarchiveLineItemTypesMutation = { __typename?: 'mutation_root', update_line_item_types: { __typename?: 'line_item_types_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'line_item_types', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type UpdateLineItemTypeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: LineItemTypesSetInput;
}>;


export type UpdateLineItemTypeMutation = { __typename?: 'mutation_root', update_line_item_types_by_pk: { __typename?: 'line_item_types', id: string, coreData: { __typename?: 'core_data', id: string } } | null };

export type ArchivePaymentMethodsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  archivedBy: Scalars['String']['input'];
}>;


export type ArchivePaymentMethodsMutation = { __typename?: 'mutation_root', update_payment_methods: { __typename?: 'payment_methods_mutation_response', returning: Array<{ __typename?: 'payment_methods', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type GetPaymentMethodByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPaymentMethodByIdQuery = { __typename?: 'query_root', payment_methods_by_pk: { __typename?: 'payment_methods', id: string, name: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string } | null };

export type GetPaymentMethodWithDependenciesByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPaymentMethodWithDependenciesByIdQuery = { __typename?: 'query_root', payment_methods_by_pk: { __typename?: 'payment_methods', id: string, name: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } } | null };

export type GetPaymentMethodsQueryVariables = Exact<{
  query: InputMaybe<PaymentMethodsBoolExp>;
}>;


export type GetPaymentMethodsQuery = { __typename?: 'query_root', payment_methods: Array<{ __typename?: 'payment_methods', id: string, name: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string }> };

export type GetPaymentMethodsWithDependenciesMetadataQueryVariables = Exact<{
  query: InputMaybe<PaymentMethodsBoolExp>;
  depsLimit: Scalars['Int']['input'];
}>;


export type GetPaymentMethodsWithDependenciesMetadataQuery = { __typename?: 'query_root', payment_methods: Array<{ __typename?: 'payment_methods', id: string, name: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } }> };

export type GetPaymentMethodsPaginatedQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy: Array<PaymentMethodsOrderBy> | PaymentMethodsOrderBy;
  query: InputMaybe<PaymentMethodsBoolExp>;
}>;


export type GetPaymentMethodsPaginatedQuery = { __typename?: 'query_root', payment_methods: Array<{ __typename?: 'payment_methods', id: string, name: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string }>, payment_methods_aggregate: { __typename?: 'payment_methods_aggregate', aggregate: { __typename?: 'payment_methods_aggregate_fields', count: number } | null } };

export type GetPaymentMethodsWithDependenciesQueryVariables = Exact<{
  query: InputMaybe<PaymentMethodsBoolExp>;
}>;


export type GetPaymentMethodsWithDependenciesQuery = { __typename?: 'query_root', payment_methods: Array<{ __typename?: 'payment_methods', id: string, name: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } }> };

export type InsertPaymentMethodMutationVariables = Exact<{
  object: PaymentMethodsInsertInput;
}>;


export type InsertPaymentMethodMutation = { __typename?: 'mutation_root', insert_payment_methods_one: { __typename?: 'payment_methods', id: string, name: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string } | null };

export type PaymentMethodFragment = { __typename?: 'payment_methods', id: string, name: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string };

export type PaymentMethodWithDependenciesMetadataFragment = { __typename?: 'payment_methods', id: string, name: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } };

export type UnarchivePaymentMethodsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UnarchivePaymentMethodsMutation = { __typename?: 'mutation_root', update_payment_methods: { __typename?: 'payment_methods_mutation_response', returning: Array<{ __typename?: 'payment_methods', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type UpdatePaymentMethodMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: PaymentMethodsSetInput;
}>;


export type UpdatePaymentMethodMutation = { __typename?: 'mutation_root', update_payment_methods_by_pk: { __typename?: 'payment_methods', id: string, name: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string } | null };

export type ArchivePaymentTermsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  archivedBy: Scalars['String']['input'];
}>;


export type ArchivePaymentTermsMutation = { __typename?: 'mutation_root', update_payment_terms: { __typename?: 'payment_terms_mutation_response', returning: Array<{ __typename?: 'payment_terms', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type GetPaymentTermByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPaymentTermByIdQuery = { __typename?: 'query_root', payment_terms_by_pk: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string } | null };

export type GetPaymentTermWithDependenciesByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPaymentTermWithDependenciesByIdQuery = { __typename?: 'query_root', payment_terms_by_pk: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } } | null };

export type GetPaymentTermsQueryVariables = Exact<{
  query: InputMaybe<PaymentTermsBoolExp>;
}>;


export type GetPaymentTermsQuery = { __typename?: 'query_root', payment_terms: Array<{ __typename?: 'payment_terms', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string }> };

export type GetPaymentTermsWithDependenciesMetadataQueryVariables = Exact<{
  query: InputMaybe<PaymentTermsBoolExp>;
  depsLimit: Scalars['Int']['input'];
}>;


export type GetPaymentTermsWithDependenciesMetadataQuery = { __typename?: 'query_root', payment_terms: Array<{ __typename?: 'payment_terms', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } }> };

export type GetPaymentTermsPaginatedQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy: Array<PaymentTermsOrderBy> | PaymentTermsOrderBy;
  query: InputMaybe<PaymentTermsBoolExp>;
}>;


export type GetPaymentTermsPaginatedQuery = { __typename?: 'query_root', payment_terms: Array<{ __typename?: 'payment_terms', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string }>, payment_terms_aggregate: { __typename?: 'payment_terms_aggregate', aggregate: { __typename?: 'payment_terms_aggregate_fields', count: number } | null } };

export type GetPaymentTermsWithDependenciesQueryVariables = Exact<{
  query: InputMaybe<PaymentTermsBoolExp>;
}>;


export type GetPaymentTermsWithDependenciesQuery = { __typename?: 'query_root', payment_terms: Array<{ __typename?: 'payment_terms', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } }> };

export type InsertPaymentTermMutationVariables = Exact<{
  object: PaymentTermsInsertInput;
}>;


export type InsertPaymentTermMutation = { __typename?: 'mutation_root', insert_payment_terms_one: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string } | null };

export type PaymentTermFragment = { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string };

export type PaymentTermWithDependenciesMetadataFragment = { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } };

export type UnarchivePaymentTermsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UnarchivePaymentTermsMutation = { __typename?: 'mutation_root', update_payment_terms: { __typename?: 'payment_terms_mutation_response', returning: Array<{ __typename?: 'payment_terms', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type UpdatePaymentTermMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: PaymentTermsSetInput;
}>;


export type UpdatePaymentTermMutation = { __typename?: 'mutation_root', update_payment_terms_by_pk: { __typename?: 'payment_terms', id: string, coreData: { __typename?: 'core_data', id: string } } | null };

export type ArchiveSubsidiariesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  archivedBy: Scalars['String']['input'];
}>;


export type ArchiveSubsidiariesMutation = { __typename?: 'mutation_root', update_subsidiaries: { __typename?: 'subsidiaries_mutation_response', returning: Array<{ __typename?: 'subsidiaries', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type GetSubsidiariesQueryVariables = Exact<{
  query: InputMaybe<SubsidiariesBoolExp>;
}>;


export type GetSubsidiariesQuery = { __typename?: 'query_root', subsidiaries: Array<{ __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string }> };

export type GetSubsidiariesWithDependenciesMetadataQueryVariables = Exact<{
  query: InputMaybe<SubsidiariesBoolExp>;
  depsLimit: Scalars['Int']['input'];
}>;


export type GetSubsidiariesWithDependenciesMetadataQuery = { __typename?: 'query_root', subsidiaries: Array<{ __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } }> };

export type GetSubsidiariesPaginatedQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy: Array<SubsidiariesOrderBy> | SubsidiariesOrderBy;
  query: InputMaybe<SubsidiariesBoolExp>;
}>;


export type GetSubsidiariesPaginatedQuery = { __typename?: 'query_root', subsidiaries: Array<{ __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string }>, subsidiaries_aggregate: { __typename?: 'subsidiaries_aggregate', aggregate: { __typename?: 'subsidiaries_aggregate_fields', count: number } | null } };

export type GetSubsidiariesWithDependenciesQueryVariables = Exact<{
  query: InputMaybe<SubsidiariesBoolExp>;
}>;


export type GetSubsidiariesWithDependenciesQuery = { __typename?: 'query_root', subsidiaries: Array<{ __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } }> };

export type GetSubsidiaryByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSubsidiaryByIdQuery = { __typename?: 'query_root', subsidiaries_by_pk: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string } | null };

export type GetSubsidiaryWithDependenciesByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSubsidiaryWithDependenciesByIdQuery = { __typename?: 'query_root', subsidiaries_by_pk: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } } | null };

export type InsertSubsidiaryMutationVariables = Exact<{
  object: SubsidiariesInsertInput;
}>;


export type InsertSubsidiaryMutation = { __typename?: 'mutation_root', insert_subsidiaries_one: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string } | null };

export type SubsidiaryFragment = { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string };

export type SubsidiaryWithDependenciesMetadataFragment = { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } };

export type UnarchiveSubsidiariesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UnarchiveSubsidiariesMutation = { __typename?: 'mutation_root', update_subsidiaries: { __typename?: 'subsidiaries_mutation_response', returning: Array<{ __typename?: 'subsidiaries', id: string, coreData: { __typename?: 'core_data', id: string } }> } | null };

export type UpdateSubsidiaryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: SubsidiariesSetInput;
}>;


export type UpdateSubsidiaryMutation = { __typename?: 'mutation_root', update_subsidiaries_by_pk: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string } | null };

export type CreateOrganisationCoreDataDependencyMutationVariables = Exact<{
  input: OrganisationCoreDataDependenciesInsertInput;
}>;


export type CreateOrganisationCoreDataDependencyMutation = { __typename?: 'mutation_root', organisationCoreDataDependency: { __typename?: 'organisation_core_data_dependencies', id: string, coreDataType: OverrideTypes["KebabCoreDataType"], dependencyCoreDataType: OverrideTypes["KebabDependencyType"] } | null };

export type GetOrganisationCoreDataDependenciesForCustomEntityTypeQueryVariables = Exact<{
  customCoreDataId: Scalars['uuid']['input'];
}>;


export type GetOrganisationCoreDataDependenciesForCustomEntityTypeQuery = { __typename?: 'query_root', organisationCoreDataDependencies: Array<{ __typename?: 'organisation_core_data_dependencies', id: string, coreDataType: OverrideTypes["KebabCoreDataType"], dependencyCoreDataType: OverrideTypes["KebabDependencyType"] }> };

export type GetOrganisationCoreDataDependenciesForEntityTypeQueryVariables = Exact<{
  entityType: Scalars['String']['input'];
}>;


export type GetOrganisationCoreDataDependenciesForEntityTypeQuery = { __typename?: 'query_root', organisationCoreDataDependencies: Array<{ __typename?: 'organisation_core_data_dependencies', id: string, coreDataType: OverrideTypes["KebabCoreDataType"], dependencyCoreDataType: OverrideTypes["KebabDependencyType"] }> };

export type GetCoreDataDependenciesFromCoreDataQueryVariables = Exact<{
  filters: CoreDataBoolExp;
}>;


export type GetCoreDataDependenciesFromCoreDataQuery = { __typename?: 'query_root', core_data: Array<{ __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> }> };

export type GetUserAllowedSubsidiariesWithDependenciesQueryVariables = Exact<{
  where: UserAllowedSubsidiariesBoolExp;
}>;


export type GetUserAllowedSubsidiariesWithDependenciesQuery = { __typename?: 'query_root', user_allowed_subsidiaries: Array<{ __typename?: 'user_allowed_subsidiaries', userId: string, subsidiaryId: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } } }> };

export type GetOrganisationStaticContentQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type GetOrganisationStaticContentQuery = { __typename?: 'query_root', organisation_static_content: Array<{ __typename?: 'organisation_static_content', id: string, content: any, type: string, updatedAt: string, updatedBy: { __typename?: 'users', id: string, firstName: string, lastName: string } | null }> };

export type InsertRequestStepTaskErrorMutationVariables = Exact<{
  requestStepTaskError: RequestStepTaskErrorsInsertInput;
}>;


export type InsertRequestStepTaskErrorMutation = { __typename?: 'mutation_root', insert_request_step_task_errors_one: { __typename?: 'request_step_task_errors', id: string } | null };

export type GetTaskDetailsWithFpaQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
  taskCompletedOn: Scalars['timestamptz']['input'];
}>;


export type GetTaskDetailsWithFpaQuery = { __typename?: 'query_root', request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string, requestFormId: string | null, completedOn: string | null, request_form: { __typename?: 'request_forms', id: string, type: FormTypeEnum, amendments_aggregate: { __typename?: 'request_comments_aggregate', aggregate: { __typename?: 'request_comments_aggregate_fields', count: number } | null }, comments_aggregate: { __typename?: 'request_comments_aggregate', aggregate: { __typename?: 'request_comments_aggregate_fields', count: number } | null }, request_form_submissions_aggregate: { __typename?: 'request_form_submissions_aggregate', aggregate: { __typename?: 'request_form_submissions_aggregate_fields', count: number } | null }, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, request_step_task_rejections_aggregate: { __typename?: 'request_step_task_rejections_aggregate', aggregate: { __typename?: 'request_step_task_rejections_aggregate_fields', count: number } | null } }>, request: { __typename?: 'requests', id: string, workflowId: string, workflow: { __typename?: 'workflows', id: string, title: string, type: WorkflowTypeEnum } } } | null } | null };

export type GetRequestRequestorQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestRequestorQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, requestorUserId: string } | null };

export type CompleteAccountingTaskMutationVariables = Exact<{
  taskId: Scalars['uuid']['input'];
  config: Scalars['jsonb']['input'];
}>;


export type CompleteAccountingTaskMutation = { __typename?: 'mutation_root', update_request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string } | null };

export type GetAccountingTaskQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type GetAccountingTaskQuery = { __typename?: 'query_root', task: { __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, completedOn: string | null, step: { __typename?: 'request_steps', id: string, requestId: string } } | null };

export type DeleteOrgProductsAndServiceByOrgSupplierIdMutationVariables = Exact<{
  orgSupplierId: Scalars['uuid']['input'];
}>;


export type DeleteOrgProductsAndServiceByOrgSupplierIdMutation = { __typename?: 'mutation_root', update_organisation_products_and_services: { __typename?: 'organisation_products_and_services_mutation_response', returning: Array<{ __typename?: 'organisation_products_and_services', id: string }> } | null };

export type DeleteOrgSupplierMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteOrgSupplierMutation = { __typename?: 'mutation_root', update_organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', id: string } | null };

export type DeleteOrgSupplierProfilesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteOrgSupplierProfilesMutation = { __typename?: 'mutation_root', update_organisation_supplier_profiles: { __typename?: 'organisation_supplier_profiles_mutation_response', returning: Array<{ __typename?: 'organisation_supplier_profiles', id: string }> } | null };

export type GetBankDetailsByRemoteIdQueryVariables = Exact<{
  remoteId: Scalars['String']['input'];
}>;


export type GetBankDetailsByRemoteIdQuery = { __typename?: 'query_root', bank_details: Array<{ __typename?: 'bank_details', id: string, remoteId: string | null, address: { __typename?: 'addresses', id: string } | null }> };

export type AddOrgSupplierContactMutationVariables = Exact<{
  objects: Array<ExternalContactsInsertInput> | ExternalContactsInsertInput;
}>;


export type AddOrgSupplierContactMutation = { __typename?: 'mutation_root', insert_external_contacts: { __typename?: 'external_contacts_mutation_response', affected_rows: number } | null };

export type CreateOrgSupplierMutationVariables = Exact<{
  supplier: OrganisationSuppliersInsertInput;
}>;


export type CreateOrgSupplierMutation = { __typename?: 'mutation_root', supplier: { __typename?: 'organisation_suppliers', id: string } | null };

export type GetOrgSupplierQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrgSupplierQuery = { __typename?: 'query_root', supplier: { __typename?: 'organisation_suppliers', id: string, remoteId: string | null, externalLink: string | null, remoteLink: string | null, organisationIntegrationId: string | null, name: string, legalName: string | null, website: string | null, isPerson: boolean | null, address: OverrideTypes["Address"] | null, description: string | null, state: OrganisationSupplierStateEnum, archivedBy: string | null, paymentMethodId: string | null, paymentTermsId: string | null, taxNumber: string | null, deletedAt: string | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, phoneNumber: string | null, title: string | null, isPrimary: boolean, createdAt: string, deletedAt: string | null }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, state: OrganisationSupplierStateEnum, archivedBy: string | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string }, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }>, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> } | null };

export type GetOrgSupplierByIdOrRemoteIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  remoteId: Scalars['String']['input'];
}>;


export type GetOrgSupplierByIdOrRemoteIdQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, remoteId: string | null, externalLink: string | null, remoteLink: string | null, organisationIntegrationId: string | null, name: string, legalName: string | null, website: string | null, isPerson: boolean | null, address: OverrideTypes["Address"] | null, description: string | null, state: OrganisationSupplierStateEnum, archivedBy: string | null, paymentMethodId: string | null, paymentTermsId: string | null, taxNumber: string | null, deletedAt: string | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, phoneNumber: string | null, title: string | null, isPrimary: boolean, createdAt: string, deletedAt: string | null }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, state: OrganisationSupplierStateEnum, archivedBy: string | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string }, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }>, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }> };

export type GetOrgSupplierByIdOrRemoteIdIncludingDeletedQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  remoteId: Scalars['String']['input'];
}>;


export type GetOrgSupplierByIdOrRemoteIdIncludingDeletedQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, remoteId: string | null, externalLink: string | null, remoteLink: string | null, organisationIntegrationId: string | null, name: string, legalName: string | null, website: string | null, isPerson: boolean | null, address: OverrideTypes["Address"] | null, description: string | null, state: OrganisationSupplierStateEnum, archivedBy: string | null, paymentMethodId: string | null, paymentTermsId: string | null, taxNumber: string | null, deletedAt: string | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, phoneNumber: string | null, title: string | null, isPrimary: boolean, createdAt: string, deletedAt: string | null }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, state: OrganisationSupplierStateEnum, archivedBy: string | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string }, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }>, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }> };

export type GetOrgSuppliersByNameWithoutRemoteIdQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetOrgSuppliersByNameWithoutRemoteIdQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, remoteId: string | null, externalLink: string | null, remoteLink: string | null, organisationIntegrationId: string | null, name: string, legalName: string | null, website: string | null, isPerson: boolean | null, address: OverrideTypes["Address"] | null, description: string | null, state: OrganisationSupplierStateEnum, archivedBy: string | null, paymentMethodId: string | null, paymentTermsId: string | null, taxNumber: string | null, deletedAt: string | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, phoneNumber: string | null, title: string | null, isPrimary: boolean, createdAt: string, deletedAt: string | null }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, state: OrganisationSupplierStateEnum, archivedBy: string | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string }, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }>, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }> };

export type GetOrgSuppliersByNameWithoutRemoteIdIncludingDeletedQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetOrgSuppliersByNameWithoutRemoteIdIncludingDeletedQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, remoteId: string | null, externalLink: string | null, remoteLink: string | null, organisationIntegrationId: string | null, name: string, legalName: string | null, website: string | null, isPerson: boolean | null, address: OverrideTypes["Address"] | null, description: string | null, state: OrganisationSupplierStateEnum, archivedBy: string | null, paymentMethodId: string | null, paymentTermsId: string | null, taxNumber: string | null, deletedAt: string | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, phoneNumber: string | null, title: string | null, isPrimary: boolean, createdAt: string, deletedAt: string | null }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, state: OrganisationSupplierStateEnum, archivedBy: string | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string }, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }>, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }> };

export type GetOrganisationSupplierProfilesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetOrganisationSupplierProfilesByIdsQuery = { __typename?: 'query_root', organisation_supplier_profiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string }> };

export type MoveSupplierProfileAndResourcesMutationVariables = Exact<{
  profileId: Scalars['uuid']['input'];
  newSupplierId: Scalars['uuid']['input'];
  productAndServiceIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  requestIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  engagementIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  internalContactIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  documentIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  agreementIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  historicSubmissionIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  riskIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  riskVersionIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  tagIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  assessmentIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  purchaseOrderIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  externalRiskScoreIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type MoveSupplierProfileAndResourcesMutation = { __typename?: 'mutation_root', update_organisation_supplier_profiles_by_pk: { __typename?: 'organisation_supplier_profiles', id: string } | null, update_organisation_products_and_services: { __typename?: 'organisation_products_and_services_mutation_response', returning: Array<{ __typename?: 'organisation_products_and_services', id: string }> } | null, update_requests: { __typename?: 'requests_mutation_response', returning: Array<{ __typename?: 'requests', id: string }> } | null, update_engagements: { __typename?: 'engagements_mutation_response', returning: Array<{ __typename?: 'engagements', id: string }> } | null, update_internal_contacts: { __typename?: 'internal_contacts_mutation_response', returning: Array<{ __typename?: 'internal_contacts', id: string }> } | null, update_documents: { __typename?: 'documents_mutation_response', returning: Array<{ __typename?: 'documents', id: string }> } | null, update_agreements: { __typename?: 'agreements_mutation_response', returning: Array<{ __typename?: 'agreements', id: string }> } | null, update_organisation_supplier_historic_submissions: { __typename?: 'organisation_supplier_historic_submissions_mutation_response', returning: Array<{ __typename?: 'organisation_supplier_historic_submissions', id: string }> } | null, update_risks: { __typename?: 'risks_mutation_response', returning: Array<{ __typename?: 'risks', id: string }> } | null, update_risk_versions: { __typename?: 'risk_versions_mutation_response', returning: Array<{ __typename?: 'risk_versions', id: string }> } | null, update_organisation_supplier_tags: { __typename?: 'organisation_supplier_tags_mutation_response', returning: Array<{ __typename?: 'organisation_supplier_tags', id: string }> } | null, update_assessments: { __typename?: 'assessments_mutation_response', returning: Array<{ __typename?: 'assessments', id: string }> } | null, update_purchase_orders: { __typename?: 'purchase_orders_mutation_response', returning: Array<{ __typename?: 'purchase_orders', id: string }> } | null, update_external_risk_scores: { __typename?: 'external_risk_scores_mutation_response', returning: Array<{ __typename?: 'external_risk_scores', id: string }> } | null };

export type OrgSupplierFragmentForDiffingFragment = { __typename?: 'organisation_suppliers', id: string, remoteId: string | null, externalLink: string | null, remoteLink: string | null, organisationIntegrationId: string | null, name: string, legalName: string | null, website: string | null, isPerson: boolean | null, address: OverrideTypes["Address"] | null, description: string | null, state: OrganisationSupplierStateEnum, archivedBy: string | null, paymentMethodId: string | null, paymentTermsId: string | null, taxNumber: string | null, deletedAt: string | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, phoneNumber: string | null, title: string | null, isPrimary: boolean, createdAt: string, deletedAt: string | null }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, state: OrganisationSupplierStateEnum, archivedBy: string | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string }, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }>, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> };

export type RemoveOrgSupplierProfilesMutationVariables = Exact<{
  organisationSupplierId: Scalars['uuid']['input'];
  subsidiaries: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type RemoveOrgSupplierProfilesMutation = { __typename?: 'mutation_root', update_organisation_supplier_profiles: { __typename?: 'organisation_supplier_profiles_mutation_response', affected_rows: number } | null };

export type UpdateOrgSupplierMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  supplier: OrganisationSuppliersSetInput;
}>;


export type UpdateOrgSupplierMutation = { __typename?: 'mutation_root', supplier: { __typename?: 'organisation_suppliers', id: string } | null };

export type UpdateOrgSupplierContactMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  contact: ExternalContactsSetInput;
}>;


export type UpdateOrgSupplierContactMutation = { __typename?: 'mutation_root', contact: { __typename?: 'external_contacts', id: string } | null };

export type UpsertOrganisationSupplierProfilesMutationVariables = Exact<{
  objects: Array<OrganisationSupplierProfilesInsertInput> | OrganisationSupplierProfilesInsertInput;
}>;


export type UpsertOrganisationSupplierProfilesMutation = { __typename?: 'mutation_root', insert_organisation_supplier_profiles: { __typename?: 'organisation_supplier_profiles_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string, customFieldValues: Array<{ __typename?: 'custom_field_values', value: string | null, customFieldId: string, entityId: string, booleanValue: boolean | null, numberValue: number | null }> }> } | null };

export type GetCoreDataOrganisationIntegrationsQueryVariables = Exact<{
  organisationIntegrationId: Scalars['uuid']['input'];
  coreDataType: Scalars['String']['input'];
}>;


export type GetCoreDataOrganisationIntegrationsQuery = { __typename?: 'query_root', core_data_organisation_integrations: Array<{ __typename?: 'core_data_organisation_integrations', id: string, organisationIntegrationId: string, coreDataType: string }> };

export type GetCustomCoreIntegrationIdByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCustomCoreIntegrationIdByIdQuery = { __typename?: 'query_root', custom_core_data_by_pk: { __typename?: 'custom_core_data', id: string, organisationIntegrationId: string | null } | null };

export type InsertCoreDataOrganisationIntegrationMutationVariables = Exact<{
  organisationIntegrationId: Scalars['uuid']['input'];
  coreDataType: Scalars['String']['input'];
}>;


export type InsertCoreDataOrganisationIntegrationMutation = { __typename?: 'mutation_root', insert_core_data_organisation_integrations_one: { __typename?: 'core_data_organisation_integrations', id: string } | null };

export type UpdateCustomCoreDataOrganisationIntegrationIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  organisationIntegrationId: Scalars['uuid']['input'];
}>;


export type UpdateCustomCoreDataOrganisationIntegrationIdMutation = { __typename?: 'mutation_root', update_custom_core_data_by_pk: { __typename?: 'custom_core_data', id: string } | null };

export type GetRequestByTaskIdQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type GetRequestByTaskIdQuery = { __typename?: 'query_root', task: { __typename?: 'request_step_tasks', id: string, requestFormId: string | null, type: any | null, requestStep: { __typename?: 'request_steps', id: string, label: any, agentEnabled: any, request: { __typename?: 'requests', id: string, name: string, organisation: { __typename?: 'organisations', id: string, name: string }, leads: Array<{ __typename?: 'request_request_leads', id: string }>, user: { __typename?: 'users', id: string, firstName: string, lastName: string, role: string, email: string } } } } | null };

export type UpsertAccountingUsersByEmailMutationVariables = Exact<{
  users: Array<UsersInsertInput> | UsersInsertInput;
  upsertSubsidiaries: Array<UserAllowedSubsidiariesInsertInput> | UserAllowedSubsidiariesInsertInput;
  deleteUserAllowedSubsidiaries: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type UpsertAccountingUsersByEmailMutation = { __typename?: 'mutation_root', insert_users: { __typename?: 'users_mutation_response', affected_rows: number } | null, delete_user_allowed_subsidiaries: { __typename?: 'user_allowed_subsidiaries_mutation_response', affected_rows: number } | null, insert_user_allowed_subsidiaries: { __typename?: 'user_allowed_subsidiaries_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'user_allowed_subsidiaries', userId: string, subsidiaryId: string }> } | null };

export type GetAllAssigneeUsersQueryVariables = Exact<{
  userIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  groupIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetAllAssigneeUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, firstName: string, lastName: string, email: string }> };

export type GetResourcesLinkedToArchivedUserQueryVariables = Exact<{
  archivedUserId: Scalars['uuid']['input'];
  fallbackUserId: Scalars['uuid']['input'];
}>;


export type GetResourcesLinkedToArchivedUserQuery = { __typename?: 'query_root', renewals: Array<{ __typename?: 'renewals', id: string, renewalDate: string, requestId: string | null, product: { __typename?: 'organisation_products_and_services', name: string } | null }>, renewal_additional_users: Array<{ __typename?: 'renewal_additional_users', id: string, renewalId: string, renewal: { __typename?: 'renewals', id: string, renewalDate: string, product: { __typename?: 'organisation_products_and_services', name: string } | null } }>, requests: Array<{ __typename?: 'requests', id: string, name: string, publicId: string, ownerId: string | null, requestorUserId: string }>, assessments: Array<{ __typename?: 'assessments', id: string, sendDate: string | null, requestId: string | null, product: { __typename?: 'organisation_products_and_services', name: string } | null }>, request_step_users: Array<{ __typename?: 'request_step_users', id: string, requestStepId: string, request_step: { __typename?: 'request_steps', id: string, requestId: string, request: { __typename?: 'requests', id: string, name: string, publicId: string } } }>, request_request_leads: Array<{ __typename?: 'request_request_leads', id: string, requestId: string, request: { __typename?: 'requests', id: string, name: string, publicId: string } }>, request_users: Array<{ __typename?: 'request_users', id: string, requestId: string, request: { __typename?: 'requests', id: string, name: string, publicId: string } }>, workflows: Array<{ __typename?: 'workflows', id: string, title: string, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"] }>, budget_approval_group: Array<{ __typename?: 'budget_approval_group', id: string, name: string, assignees: Array<{ __typename?: 'budget_approval_group_assignees', id: string, department: { __typename?: 'departments', name: string } | null, assignees: Array<{ __typename?: 'budget_approval_group_assignees_assignees', id: string }> }> }>, fallback_renewal_additional_users: Array<{ __typename?: 'renewal_additional_users', renewalId: string }>, fallback_request_step_users: Array<{ __typename?: 'request_step_users', requestStepId: string }>, fallback_request_leads: Array<{ __typename?: 'request_request_leads', requestId: string }>, fallback_request_users: Array<{ __typename?: 'request_users', requestId: string }> };

export type ReassignResourcesToFallbackUserMutationVariables = Exact<{
  fallbackUserId: Scalars['uuid']['input'];
  archivedUserId: Scalars['uuid']['input'];
  assessmentIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  renewalIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  requestIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  budgetApprovalAssigneeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  renewalAdditionalUserIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  requestStepUserIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  requestLeadIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  requestUserIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ReassignResourcesToFallbackUserMutation = { __typename?: 'mutation_root', update_requests: { __typename?: 'requests_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'requests', id: string, publicId: string }> } | null, update_assessments: { __typename?: 'assessments_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'assessments', id: string }> } | null, update_renewals: { __typename?: 'renewals_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'renewals', id: string }> } | null, update_budget_approval_group_assignees_assignees: { __typename?: 'budget_approval_group_assignees_assignees_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'budget_approval_group_assignees_assignees', id: string }> } | null, update_renewal_additional_users: { __typename?: 'renewal_additional_users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'renewal_additional_users', id: string }> } | null, update_request_step_users: { __typename?: 'request_step_users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'request_step_users', id: string }> } | null, update_request_request_leads: { __typename?: 'request_request_leads_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'request_request_leads', id: string }> } | null, update_request_users: { __typename?: 'request_users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'request_users', id: string }> } | null };

export type UpdateWorkflowAssigneesMutationVariables = Exact<{
  workflowUpdates: Array<WorkflowsUpdates> | WorkflowsUpdates;
}>;


export type UpdateWorkflowAssigneesMutation = { __typename?: 'mutation_root', update_workflows_many: Array<{ __typename?: 'workflows_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'workflows', id: string, title: string }> } | null> | null };

export type InsertRequestFormSubmissionTranslationMutationVariables = Exact<{
  translation: RequestFormSubmissionTranslationsInsertInput;
}>;


export type InsertRequestFormSubmissionTranslationMutation = { __typename?: 'mutation_root', insert_request_form_submission_translations_one: { __typename?: 'request_form_submission_translations', id: string } | null };

export type SetRequestFormSubmissionDetectedLanguageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  detectedLanguage: InputMaybe<Scalars['String']['input']>;
}>;


export type SetRequestFormSubmissionDetectedLanguageMutation = { __typename?: 'mutation_root', update_request_form_submissions_by_pk: { __typename?: 'request_form_submissions', id: string } | null };

export type UpdateOrganisationStaticContentByTypeMutationVariables = Exact<{
  type: Scalars['String']['input'];
  content: Scalars['jsonb']['input'];
  updatedBy: Scalars['uuid']['input'];
}>;


export type UpdateOrganisationStaticContentByTypeMutation = { __typename?: 'mutation_root', update_organisation_static_content: { __typename?: 'organisation_static_content_mutation_response', returning: Array<{ __typename?: 'organisation_static_content', id: string, content: any, updatedBy: { __typename?: 'users', id: string, firstName: string, lastName: string } | null }> } | null };

export type GetCustomFieldOptionQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCustomFieldOptionQuery = { __typename?: 'query_root', customFieldOption: { __typename?: 'custom_field_choices', id: string, label: string } | null };

export type CreateExternalUserMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  user: UsersInsertInput;
}>;


export type CreateExternalUserMutation = { __typename?: 'mutation_root', insert_request_users_one: { __typename?: 'request_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string } } | null };

export type GetAssigneesForRequestQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  canvasModelId: Scalars['String']['input'];
}>;


export type GetAssigneesForRequestQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'requests', model: OverrideTypes["RequestModel"], steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, request_step_users: Array<{ __typename?: 'request_step_users', user: { __typename?: 'users', email: string, firstName: string, lastName: string, role: string, id: string, isArchived: boolean, isOutOfOffice: boolean } }>, request_step_groups: Array<{ __typename?: 'request_step_groups', group: { __typename?: 'groups', name: string, id: string, isArchived: boolean } }> }> }> };

export type GetRequestResponsesQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestResponsesQuery = { __typename?: 'query_root', request_forms: Array<{ __typename?: 'request_forms', request_form_submissions: Array<{ __typename?: 'request_form_submissions', response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }> };

export type GetRfxSupplierBySupplierAndStepIdsQueryVariables = Exact<{
  organisationSupplierId: InputMaybe<Scalars['uuid']['input']>;
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetRfxSupplierBySupplierAndStepIdsQuery = { __typename?: 'query_root', rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string }> };

export type CreateEsignDocumentMutationVariables = Exact<{
  input: RequestEsignDocumentsInsertInput;
}>;


export type CreateEsignDocumentMutation = { __typename?: 'mutation_root', insert_request_esign_documents_one: { __typename?: 'request_esign_documents', id: string } | null };

export type GetBlockConfigByTaskIdQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type GetBlockConfigByTaskIdQuery = { __typename?: 'query_root', request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string, request_step: { __typename?: 'request_steps', id: string, input: any } } | null };

export type GetRequestIdByTaskIdQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type GetRequestIdByTaskIdQuery = { __typename?: 'query_root', request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string, request_step: { __typename?: 'request_steps', id: string, requestId: string } } | null };

export type GetTaskConfigByTaskIdQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type GetTaskConfigByTaskIdQuery = { __typename?: 'query_root', request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string, config: any | null } | null };

export type UpdateEsignTaskCompletedOnMutationVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type UpdateEsignTaskCompletedOnMutation = { __typename?: 'mutation_root', update_request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string, request_step: { __typename?: 'request_steps', id: string, requestId: string } } | null };

export type UpdateRequestESignDocumentStatusMutationVariables = Exact<{
  remoteId: Scalars['String']['input'];
  status: Scalars['String']['input'];
}>;


export type UpdateRequestESignDocumentStatusMutation = { __typename?: 'mutation_root', update_request_esign_documents: { __typename?: 'request_esign_documents_mutation_response', affected_rows: number } | null };

export type GetRequestWithStepsForRollbackQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestWithStepsForRollbackQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, completedAt: string | null, steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, input: any, canvasModelParentIds: any, canvasModelId: string, output: any | null, requestId: string, workflowId: string, data: any | null, type: any, assignees: any, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, config: any | null, completedBy: string | null, request_form: { __typename?: 'request_forms', id: string, title: string, type: FormTypeEnum } | null, request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string }>, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string }>, request_step_task_errors: Array<{ __typename?: 'request_step_task_errors', id: string }> }>, request_step_users: Array<{ __typename?: 'request_step_users', id: string }>, request_step_groups: Array<{ __typename?: 'request_step_groups', id: string }> }> } | null };

export type ReopenRequestMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type ReopenRequestMutation = { __typename?: 'mutation_root', update_requests_by_pk: { __typename?: 'requests', id: string } | null };

export type CreateEngagementMutationVariables = Exact<{
  engagement: EngagementsInsertInput;
}>;


export type CreateEngagementMutation = { __typename?: 'mutation_root', insert_engagements_one: { __typename?: 'engagements', id: string, organisationSupplierId: string } | null };

export type DeleteEngagementMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  deleted_at: Scalars['timestamptz']['input'];
}>;


export type DeleteEngagementMutation = { __typename?: 'mutation_root', update_engagements_by_pk: { __typename?: 'engagements', id: string } | null };

export type GetEngagementRequestFormsQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetEngagementRequestFormsQuery = { __typename?: 'query_root', forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], organisationId: string, form_type: { __typename?: 'form_type', value: string } }> };

export type GetGroupUsersQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetGroupUsersQuery = { __typename?: 'query_root', group_users: Array<{ __typename?: 'group_users', id: string, user: { __typename?: 'users', id: string } }> };

export type GetOrganisationSupplierProfilesQueryVariables = Exact<{
  orgSupplierId: Scalars['uuid']['input'];
}>;


export type GetOrganisationSupplierProfilesQuery = { __typename?: 'query_root', organisation_supplier_profiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string }> };

export type GetOrganisationSupplierTagsBySupplierIdQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
}>;


export type GetOrganisationSupplierTagsBySupplierIdQuery = { __typename?: 'query_root', organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tag: { __typename?: 'tags', id: string, name: string } }> };

export type GetRequestSupplierAndProductsQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestSupplierAndProductsQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, product: { __typename?: 'organisation_products_and_services', id: string } | null, supplier: { __typename?: 'organisation_suppliers', id: string } | null } | null };

export type GetTasksByStepIdQueryVariables = Exact<{
  stepId: Scalars['uuid']['input'];
}>;


export type GetTasksByStepIdQuery = { __typename?: 'query_root', tasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, completedOn: string | null, config: any | null }> };

export type InsertOrganisationSupplierProfileMutationVariables = Exact<{
  orgSupplierId: Scalars['uuid']['input'];
  subsidiaryId: Scalars['uuid']['input'];
}>;


export type InsertOrganisationSupplierProfileMutation = { __typename?: 'mutation_root', insert_organisation_supplier_profiles_one: { __typename?: 'organisation_supplier_profiles', id: string } | null };

export type InsertOrganisationSupplierTagsMutationVariables = Exact<{
  objects: Array<OrganisationSupplierTagsInsertInput> | OrganisationSupplierTagsInsertInput;
}>;


export type InsertOrganisationSupplierTagsMutation = { __typename?: 'mutation_root', insert_organisation_supplier_tags: { __typename?: 'organisation_supplier_tags_mutation_response', returning: Array<{ __typename?: 'organisation_supplier_tags', id: string }> } | null };

export type InsertTagsMutationVariables = Exact<{
  objects: Array<TagsInsertInput> | TagsInsertInput;
}>;


export type InsertTagsMutation = { __typename?: 'mutation_root', createdOrgTags: { __typename?: 'tags_mutation_response', returning: Array<{ __typename?: 'tags', id: string, name: string }> } | null };

export type ResolveRequestStepTaskErrorsByRequestStepTaskIdMutationVariables = Exact<{
  requestStepTaskId: Scalars['uuid']['input'];
  resolvedAt: Scalars['timestamptz']['input'];
}>;


export type ResolveRequestStepTaskErrorsByRequestStepTaskIdMutation = { __typename?: 'mutation_root', update_request_step_task_errors: { __typename?: 'request_step_task_errors_mutation_response', returning: Array<{ __typename?: 'request_step_task_errors', id: string }> } | null };

export type UpdateRequestEngagementMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  engagementId: Scalars['uuid']['input'];
}>;


export type UpdateRequestEngagementMutation = { __typename?: 'mutation_root', update_requests: { __typename?: 'requests_mutation_response', returning: Array<{ __typename?: 'requests', id: string }> } | null };

export type UpdateSupplierLastAssessmentDateMutationVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
  lastAssessmentDate: Scalars['timestamptz']['input'];
}>;


export type UpdateSupplierLastAssessmentDateMutation = { __typename?: 'mutation_root', update_organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', id: string } | null };

export type CreatePurchaseOrderMutationVariables = Exact<{
  purchaseOrder: PurchaseOrdersInsertInput;
}>;


export type CreatePurchaseOrderMutation = { __typename?: 'mutation_root', insert_purchase_orders_one: { __typename?: 'purchase_orders', id: string } | null };

export type CreatePurchaseOrderLineItemsMutationVariables = Exact<{
  objects: Array<PurchaseOrderLineItemsInsertInput> | PurchaseOrderLineItemsInsertInput;
}>;


export type CreatePurchaseOrderLineItemsMutation = { __typename?: 'mutation_root', insert_purchase_order_line_items: { __typename?: 'purchase_order_line_items_mutation_response', returning: Array<{ __typename?: 'purchase_order_line_items', id: string, lineNumber: number }> } | null };

export type DeletePurchaseOrderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePurchaseOrderMutation = { __typename?: 'mutation_root', update_purchase_order_line_items_many: Array<{ __typename?: 'purchase_order_line_items_mutation_response', returning: Array<{ __typename?: 'purchase_order_line_items', id: string }> } | null> | null, update_purchase_orders_by_pk: { __typename?: 'purchase_orders', id: string, remoteNumber: string | null, remoteId: string | null } | null };

export type GetRequestStepTaskLatestFormSubmissionQueryVariables = Exact<{
  requestStepTaskId: Scalars['uuid']['input'];
}>;


export type GetRequestStepTaskLatestFormSubmissionQuery = { __typename?: 'query_root', request_step_tasks_by_pk: { __typename?: 'request_step_tasks', request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string }> } | null };

export type UpdatePurchaseOrderStatusByRequestIdMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  status: Scalars['String']['input'];
  remoteLink: InputMaybe<Scalars['String']['input']>;
  remoteId: InputMaybe<Scalars['String']['input']>;
  remoteNumber: InputMaybe<Scalars['String']['input']>;
  formSubmissionId: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpdatePurchaseOrderStatusByRequestIdMutation = { __typename?: 'mutation_root', update_purchase_orders: { __typename?: 'purchase_orders_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'purchase_orders', id: string }> } | null };

export type GetLatestAgreementSubmissionOfRequestQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  formType: FormTypeEnum;
}>;


export type GetLatestAgreementSubmissionOfRequestQuery = { __typename?: 'query_root', latestSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedBy: string | null, request_form: { __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], request: { __typename?: 'requests', request_product: string | null, supplier: { __typename?: 'organisation_suppliers', id: string } | null } } | null }> };

export type GetAgreementTagsByAgreementIdQueryVariables = Exact<{
  agreementId: Scalars['uuid']['input'];
}>;


export type GetAgreementTagsByAgreementIdQuery = { __typename?: 'query_root', agreement_tags: Array<{ __typename?: 'agreement_tags', tag: { __typename?: 'tags', id: string, name: string } }> };

export type GetSupplierBankDetailsAndAddressIdsQueryVariables = Exact<{
  orgSupplierId: Scalars['uuid']['input'];
}>;


export type GetSupplierBankDetailsAndAddressIdsQuery = { __typename?: 'query_root', organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }> } | null };

export type GetEngagementSubsidiaryIdQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetEngagementSubsidiaryIdQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', engagement: { __typename?: 'engagements', subsidiaryId: string | null } | null } | null };

export type GetExternalOperationFormResponsesQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetExternalOperationFormResponsesQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', request_forms: Array<{ __typename?: 'request_forms', request_form_submissions: Array<{ __typename?: 'request_form_submissions', submittedOn: string, response: OverrideTypes["FormResponsePayload"] | null }>, form_template: { __typename?: 'form_templates', integration: OverrideTypes["Integration"] | null } | null }> } | null };

export type GetOrgSupplierByRemoteIdQueryVariables = Exact<{
  remoteId: Scalars['String']['input'];
}>;


export type GetOrgSupplierByRemoteIdQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string }> };

export type BankDetailsWithAddressFragment = { __typename?: 'bank_details', id: string, accountName: string | null, bankName: string | null, country: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, address: { __typename?: 'addresses', addressLine1: string | null, addressLine2: string | null, city: string | null, county: string | null, postalCode: string | null } | null };

export type GetOrgSupplierDataQueryVariables = Exact<{
  orgSupplierId: Scalars['uuid']['input'];
}>;


export type GetOrgSupplierDataQuery = { __typename?: 'query_root', organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', id: string, state: OrganisationSupplierStateEnum, website: string | null, address: OverrideTypes["Address"] | null, taxNumber: string | null, legalName: string | null, remoteLink: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"], defaultSupplierState: OrganisationSupplierStateEnum | null } | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, title: string | null, isPrimary: boolean }>, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerms: { __typename?: 'payment_terms', id: string, name: string } | null, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string }, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }> } | null };

export type GetOrgSupplierDataMinimalQueryVariables = Exact<{
  orgSupplierId: Scalars['uuid']['input'];
}>;


export type GetOrgSupplierDataMinimalQuery = { __typename?: 'query_root', organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', id: string, state: OrganisationSupplierStateEnum, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> } | null };

export type GetOrganisationSupplierProfileResourcesQueryVariables = Exact<{
  where: OrganisationSupplierProfileResourcesBoolExp;
}>;


export type GetOrganisationSupplierProfileResourcesQuery = { __typename?: 'query_root', organisation_supplier_profile_resources: Array<{ __typename?: 'organisation_supplier_profile_resources', id: string, entityType: string, entityId: string, organisationSupplierProfileId: string }> };

export type InsertAgreementTagsMutationVariables = Exact<{
  objects: Array<AgreementTagsInsertInput> | AgreementTagsInsertInput;
}>;


export type InsertAgreementTagsMutation = { __typename?: 'mutation_root', insert_agreement_tags: { __typename?: 'agreement_tags_mutation_response', returning: Array<{ __typename?: 'agreement_tags', id: string }> } | null };

export type InsertOrganisationSupplierProfileResourceMutationVariables = Exact<{
  object: OrganisationSupplierProfileResourcesInsertInput;
}>;


export type InsertOrganisationSupplierProfileResourceMutation = { __typename?: 'mutation_root', insert_organisation_supplier_profile_resources_one: { __typename?: 'organisation_supplier_profile_resources', id: string, entityType: string, entityId: string, organisationSupplierProfileId: string } | null };

export type UpdateOrganisationSupplierMutationVariables = Exact<{
  set: OrganisationSuppliersSetInput;
  id: Scalars['uuid']['input'];
}>;


export type UpdateOrganisationSupplierMutation = { __typename?: 'mutation_root', update_organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', id: string, name: string, website: string | null, logoUrl: string | null, isReseller: boolean, createdAt: string, remoteId: string | null, lastAssessmentDate: string | null, publicId: number, organisationSupplierBrandId: string | null, address: OverrideTypes["Address"] | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } }> } | null };

export type UpdateOrganisationSupplierProfileResourceMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  organisationSupplierProfileId: Scalars['uuid']['input'];
}>;


export type UpdateOrganisationSupplierProfileResourceMutation = { __typename?: 'mutation_root', update_organisation_supplier_profile_resources_by_pk: { __typename?: 'organisation_supplier_profile_resources', id: string, entityType: string, entityId: string, organisationSupplierProfileId: string } | null };

export type UpdateOrganisationSupplierWithNewDataMutationVariables = Exact<{
  orgSupplierId: Scalars['uuid']['input'];
  set: OrganisationSuppliersSetInput;
}>;


export type UpdateOrganisationSupplierWithNewDataMutation = { __typename?: 'mutation_root', updatedSupplier: { __typename?: 'organisation_suppliers', id: string, name: string } | null };

export type InsertBankDetailsMutationVariables = Exact<{
  object: BankDetailsInsertInput;
}>;


export type InsertBankDetailsMutation = { __typename?: 'mutation_root', insert_bank_details_one: { __typename?: 'bank_details', id: string } | null };

export type UpdateBankDetailsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: BankDetailsSetInput;
}>;


export type UpdateBankDetailsMutation = { __typename?: 'mutation_root', update_bank_details_by_pk: { __typename?: 'bank_details', id: string } | null };

export type UpsertExternalRiskScoreMutationVariables = Exact<{
  input: ExternalRiskScoresInsertInput;
}>;


export type UpsertExternalRiskScoreMutation = { __typename?: 'mutation_root', externalRiskScore: { __typename?: 'external_risk_scores', id: string } | null };

export type UpsertOrganisationSupplierProfileMutationVariables = Exact<{
  object: OrganisationSupplierProfilesInsertInput;
  updateColumns: Array<OrganisationSupplierProfilesUpdateColumn> | OrganisationSupplierProfilesUpdateColumn;
}>;


export type UpsertOrganisationSupplierProfileMutation = { __typename?: 'mutation_root', insert_organisation_supplier_profiles_one: { __typename?: 'organisation_supplier_profiles', id: string } | null };

export type GetAllRequestStepTasksForRequestStepQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetAllRequestStepTasksForRequestStepQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, completedOn: string | null }> };

export type GetAllUsersForGroupIdsQueryVariables = Exact<{
  groupIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetAllUsersForGroupIdsQuery = { __typename?: 'query_root', group_users: Array<{ __typename?: 'group_users', userId: string }> };

export type GetAssessmentBusinessOwnerQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetAssessmentBusinessOwnerQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', assessment: { __typename?: 'assessments', id: string, businessOwnerUser: { __typename?: 'users', firstName: string, lastName: string, id: string } } | null } | null };

export type GetDelegatesForOutOfOfficeDelegationQueryVariables = Exact<{
  delegatorId: Scalars['uuid']['input'];
}>;


export type GetDelegatesForOutOfOfficeDelegationQuery = { __typename?: 'query_root', out_of_office_delegations: Array<{ __typename?: 'out_of_office_delegations', id: string, delegateId: string, createdAt: string, delegate: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }> };

export type GetFormSubmissionsQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetFormSubmissionsQuery = { __typename?: 'query_root', request_steps_by_pk: { __typename?: 'request_steps', id: string, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, request_form: { __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], form_template: { __typename?: 'form_templates', id: string, internalId: string | null } | null } | null }> }> } | null };

export type GetInProgressRequestStepsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetInProgressRequestStepsQuery = { __typename?: 'query_root', request_steps: Array<{ __typename?: 'request_steps', id: string, requestId: string, canvasModelId: string }> };

export type GetIntakeRequestFormQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetIntakeRequestFormQuery = { __typename?: 'query_root', request_forms: Array<{ __typename?: 'request_forms', id: string, request: { __typename?: 'requests', id: string, requestorUserId: string }, request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null }> }> };

export type GetLatestRequestFormSubmissionsQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetLatestRequestFormSubmissionsQuery = { __typename?: 'query_root', forms: Array<{ __typename?: 'request_forms', id: string, type: FormTypeEnum, latestSubmissionArray: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string, request_step_task: { __typename?: 'request_step_tasks', organisationSupplierId: string | null } | null }> }>, request: { __typename?: 'requests', id: string, supplier: { __typename?: 'organisation_suppliers', id: string } | null, renewal: { __typename?: 'renewals', id: string, costCurrency: OverrideTypes["CurrencyCode"], costValue: number, renewalDate: string, cancellationNoticeDayCount: number | null, note: string | null, department: { __typename?: 'departments', id: string, name: string } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, remoteLink: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null }, product: { __typename?: 'organisation_products_and_services', id: string, name: string, logoUrl: string | null, description: string | null, displayName: string, updatedAt: string | null, website: string | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, website: string | null, isReseller: boolean } } | null } | null, assessment: { __typename?: 'assessments', id: string, businessOwnerUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } } | null } | null };

export type GetRenewalAssessmentBlockStartedEventDataQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetRenewalAssessmentBlockStartedEventDataQuery = { __typename?: 'query_root', requestStep: { __typename?: 'request_steps', id: string, request: { __typename?: 'requests', id: string, supplier: { __typename?: 'organisation_suppliers', id: string, name: string } | null, renewal: { __typename?: 'renewals', id: string, renewalDate: string, cancellationNoticeDayCount: number | null, costValue: number, costCurrency: OverrideTypes["CurrencyCode"], product: { __typename?: 'organisation_products_and_services', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null } | null, organisation: { __typename?: 'organisations', id: string, name: string } } } | null };

export type GetRequestCompletedSummaryApprovalTasksQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestCompletedSummaryApprovalTasksQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, completedBy: string | null, request_form: { __typename?: 'request_forms', id: string, formTemplateId: string | null } | null }> };

export type GetRequestCompletedTasksQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestCompletedTasksQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, completedBy: string | null, request_form: { __typename?: 'request_forms', id: string, formTemplateId: string | null } | null }> };

export type GetRequestFormSubmissionsQueryVariables = Exact<{
  requestFormIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetRequestFormSubmissionsQuery = { __typename?: 'query_root', request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, requestFormId: string | null }> };

export type GetRequestFormsForTemplateIdsQueryVariables = Exact<{
  formTemplateIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestFormsForTemplateIdsQuery = { __typename?: 'query_root', request_forms: Array<{ __typename?: 'request_forms', id: string, formTemplateId: string | null, type: FormTypeEnum }> };

export type GetRequestOneMinimalQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRequestOneMinimalQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, name: string, state: string | null, workflowId: string, model: OverrideTypes["RequestModel"], requestorUserId: string, tagIds: any | null } | null };

export type GetRequestOneQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRequestOneQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, name: string, state: string | null, workflowId: string, requestorUserId: string, createdAt: string, updatedAt: string, priority: RequestPriorityEnum, completedAt: string | null, model: OverrideTypes["RequestModel"], tagIds: any | null, type: RequestTypeEnum, request_product: string | null, request_supplier: string | null, publicId: string, totalPausedTime: string, product: { __typename?: 'organisation_products_and_services', id: string, name: string, displayName: string, website: string | null, logoUrl: string | null, createdAt: string | null, updatedAt: string | null, description: string | null, isArchived: boolean, state: OrganisationProductsAndServicesStateEnum, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, organisation_supplier: { __typename?: 'organisation_suppliers', state: OrganisationSupplierStateEnum, id: string, website: string | null, logoUrl: string | null, name: string, externalLink: string | null, organisation_supplier_brand: { __typename?: 'organisation_suppliers_brands', id: string, supplierId: string | null } | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, isPrimary: boolean, phoneNumber: string | null, title: string | null }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> }, engagements: Array<{ __typename?: 'engagements', id: string, name: string, department: string | null }> } | null, agreement_term: { __typename?: 'agreement_terms', agreementId: string } | null, owner: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } } | null };

export type GetRequestStartFormQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestStartFormQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, requestorUserId: string, request_forms: Array<{ __typename?: 'request_forms', id: string, formTemplateId: string | null }> } | null };

export type GetRequestStepDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRequestStepDataQuery = { __typename?: 'query_root', request_steps_by_pk: { __typename?: 'request_steps', id: string, data: any | null } | null };

export type GetRequestStepGroupsForRequestStepQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetRequestStepGroupsForRequestStepQuery = { __typename?: 'query_root', request_step_groups: Array<{ __typename?: 'request_step_groups', id: string, groupId: string }> };

export type GetRequestStepUsersQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetRequestStepUsersQuery = { __typename?: 'query_root', request_step_users: Array<{ __typename?: 'request_step_users', id: string, userId: string }> };

export type GetRequestInformationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRequestInformationQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', name: string, id: string, publicId: string, supplier: { __typename?: 'organisation_suppliers', id: string, publicId: number, name: string, state: OrganisationSupplierStateEnum, website: string | null, legalName: string | null, remoteId: string | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, title: string | null, isPrimary: boolean }> } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, website: string | null } | null, workflow: { __typename?: 'workflows', id: string, title: string, type: WorkflowTypeEnum }, organisation: { __typename?: 'organisations', id: string, name: string }, requestor: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, engagement: { __typename?: 'engagements', id: string } | null, purchase_orders: Array<{ __typename?: 'purchase_orders', id: string }>, renewal: { __typename?: 'renewals', id: string, renewalDate: string, product: { __typename?: 'organisation_products_and_services', id: string, name: string } | null } | null } | null };

export type GetRequestorQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestorQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, user: { __typename?: 'users', firstName: string, lastName: string, id: string } } | null };

export type GetStepKeyTimesQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetStepKeyTimesQuery = { __typename?: 'query_root', requestStep: { __typename?: 'request_steps', id: string, createdAt: string, totalPausedWorkingHours: number } | null };

export type GetTaskApprovalInformationQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
  requestId: Scalars['uuid']['input'];
}>;


export type GetTaskApprovalInformationQuery = { __typename?: 'query_root', organisations: Array<{ __typename?: 'organisations', id: string, name: string }>, requests_by_pk: { __typename?: 'requests', id: string, name: string, requestor: { __typename?: 'users', firstName: string, lastName: string, id: string } } | null, request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string, completedBy: string | null, completedOn: string | null, type: RequestStepTaskTypeEnum, request_form: { __typename?: 'request_forms', id: string, type: FormTypeEnum } | null, approver: { __typename?: 'users', firstName: string, lastName: string, id: string } | null } | null };

export type InsertRequestStepTasksMutationVariables = Exact<{
  objects?: InputMaybe<Array<RequestStepTasksInsertInput> | RequestStepTasksInsertInput>;
}>;


export type InsertRequestStepTasksMutation = { __typename?: 'mutation_root', insert_request_step_tasks: { __typename?: 'request_step_tasks_mutation_response', returning: Array<{ __typename?: 'request_step_tasks', id: string, requestStepId: string, requestFormId: string | null, type: RequestStepTaskTypeEnum, config: any | null, created_at: string | null }> } | null };

export type InsertRequestStepUsersMutationVariables = Exact<{
  objects: Array<RequestStepUsersInsertInput> | RequestStepUsersInsertInput;
}>;


export type InsertRequestStepUsersMutation = { __typename?: 'mutation_root', insert_request_step_users: { __typename?: 'request_step_users_mutation_response', returning: Array<{ __typename?: 'request_step_users', id: string }> } | null };

export type ResolveRequestStepTaskErrorsMutationVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
  resolvedAt: Scalars['timestamptz']['input'];
}>;


export type ResolveRequestStepTaskErrorsMutation = { __typename?: 'mutation_root', update_request_step_task_errors: { __typename?: 'request_step_task_errors_mutation_response', returning: Array<{ __typename?: 'request_step_task_errors', id: string }> } | null };

export type SaveNotificationMessageMutationVariables = Exact<{
  object: RequestStepNotificationMessagesInsertInput;
}>;


export type SaveNotificationMessageMutation = { __typename?: 'mutation_root', insert_request_step_notification_messages_one: { __typename?: 'request_step_notification_messages', requestStepId: string } | null };

export type UpdateRenewalRenewedAtMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type UpdateRenewalRenewedAtMutation = { __typename?: 'mutation_root', update_renewals: { __typename?: 'renewals_mutation_response', returning: Array<{ __typename?: 'renewals', renewedAt: string | null, id: string }> } | null };

export type UpsertRequestGroupsMutationVariables = Exact<{
  objects: Array<RequestGroupsInsertInput> | RequestGroupsInsertInput;
}>;


export type UpsertRequestGroupsMutation = { __typename?: 'mutation_root', insert_request_groups: { __typename?: 'request_groups_mutation_response', returning: Array<{ __typename?: 'request_groups', id: string }> } | null };

export type UpsertRequestUsersMutationVariables = Exact<{
  objects: Array<RequestUsersInsertInput> | RequestUsersInsertInput;
}>;


export type UpsertRequestUsersMutation = { __typename?: 'mutation_root', insert_request_users: { __typename?: 'request_users_mutation_response', returning: Array<{ __typename?: 'request_users', id: string }> } | null };

export type AutocompleteRequestStepTaskMutationVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type AutocompleteRequestStepTaskMutation = { __typename?: 'mutation_root', update_request_step_tasks_by_pk: { __typename?: 'request_step_tasks', completedBy: string | null, completedOn: string | null, id: string } | null };

export type GetGroupMembershipsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  groupIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetGroupMembershipsQuery = { __typename?: 'query_root', group_users: Array<{ __typename?: 'group_users', id: string, groupId: string }> };

export type GetGroupsOneQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetGroupsOneQuery = { __typename?: 'query_root', groups_by_pk: { __typename?: 'groups', id: string, name: string, rawAttributes: any | null, organisationId: string, isArchived: boolean, group_users: Array<{ __typename?: 'group_users', id: string, userId: string }> } | null };

export type GetRequestDocumentsByFilestoreIdsQueryVariables = Exact<{
  filestoreIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetRequestDocumentsByFilestoreIdsQuery = { __typename?: 'query_root', request_documents: Array<{ __typename?: 'request_documents', id: string, filestoreId: string }> };

export type GetRfxByRequestIdQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRfxByRequestIdQuery = { __typename?: 'query_root', rfx: Array<{ __typename?: 'rfx', id: string, requestStepId: string, requestId: string, isReopened: boolean }> };

export type GetRfxSupplierQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRfxSupplierQuery = { __typename?: 'query_root', rfx_suppliers_by_pk: { __typename?: 'rfx_suppliers', organisationProductId: string | null, organisationSupplierId: string } | null };

export type InsertRfxOneMutationVariables = Exact<{
  rfx: RfxInsertInput;
}>;


export type InsertRfxOneMutation = { __typename?: 'mutation_root', insert_rfx_one: { __typename?: 'rfx', id: string } | null };

export type SetRequestSupplierAndProductMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  organisationSupplierId: Scalars['uuid']['input'];
  organisationProductId: Scalars['uuid']['input'];
}>;


export type SetRequestSupplierAndProductMutation = { __typename?: 'mutation_root', update_requests_by_pk: { __typename?: 'requests', id: string } | null };

export type GetAssigneeQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetAssigneeQuery = { __typename?: 'query_root', users_by_pk: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string, role: string, isArchived: boolean } | null };

export type GetSupplierPortalAssigneesQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetSupplierPortalAssigneesQuery = { __typename?: 'query_root', request_steps_by_pk: { __typename?: 'request_steps', id: string, canvasModelId: string, targetTimeValue: any, request: { __typename?: 'requests', id: string, model: OverrideTypes["RequestModel"], name: string, workflow: { __typename?: 'workflows', id: string, title: string, type: WorkflowTypeEnum }, user: { __typename?: 'users', id: string, firstName: string, lastName: string }, product: { __typename?: 'organisation_products_and_services', id: string, displayName: string } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string } | null, organisation: { __typename?: 'organisations', id: string, name: string } } } | null };

export type CreateGroupUserAssignmentMutationVariables = Exact<{
  groupId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
  requestId: Scalars['uuid']['input'];
  method: Scalars['String']['input'];
}>;


export type CreateGroupUserAssignmentMutation = { __typename?: 'mutation_root', insert_group_user_assignments_one: { __typename?: 'group_user_assignments', id: string, groupId: string, userId: string, requestId: string, method: string, createdAt: string } | null };

export type GetExistingGroupUserAssignmentOnRequestQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  groupId: Scalars['uuid']['input'];
  method: Scalars['String']['input'];
}>;


export type GetExistingGroupUserAssignmentOnRequestQuery = { __typename?: 'query_root', group_user_assignments: Array<{ __typename?: 'group_user_assignments', userId: string, createdAt: string, requestId: string, method: string, id: string }> };

export type GetGroupMembersWithUserDataQueryVariables = Exact<{
  groupId: Scalars['uuid']['input'];
}>;


export type GetGroupMembersWithUserDataQuery = { __typename?: 'query_root', group_users: Array<{ __typename?: 'group_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isOutOfOffice: boolean }, assignments_aggregate: { __typename?: 'group_user_assignments_aggregate', aggregate: { __typename?: 'group_user_assignments_aggregate_fields', max: { __typename?: 'group_user_assignments_max_fields', createdAt: string | null } | null } | null } }> };

export type DeleteRequestStepGroupsByIdsMutationVariables = Exact<{
  groupIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  requestStepId: Scalars['uuid']['input'];
}>;


export type DeleteRequestStepGroupsByIdsMutation = { __typename?: 'mutation_root', delete_request_step_groups: { __typename?: 'request_step_groups_mutation_response', affected_rows: number } | null };

export type DeleteRequestStepUsersByIdsMutationVariables = Exact<{
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  requestStepId: Scalars['uuid']['input'];
}>;


export type DeleteRequestStepUsersByIdsMutation = { __typename?: 'mutation_root', delete_request_step_users: { __typename?: 'request_step_users_mutation_response', affected_rows: number } | null };

export type InsertRequestStepGroupsMutationVariables = Exact<{
  objects: Array<RequestStepGroupsInsertInput> | RequestStepGroupsInsertInput;
}>;


export type InsertRequestStepGroupsMutation = { __typename?: 'mutation_root', insert_request_step_groups: { __typename?: 'request_step_groups_mutation_response', returning: Array<{ __typename?: 'request_step_groups', id: string }> } | null };

export type CompleteStepMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  state: RequestStepStateEnum;
  result: RequestStepResultEnum;
  output: Scalars['jsonb']['input'];
  data: Scalars['jsonb']['input'];
}>;


export type CompleteStepMutation = { __typename?: 'mutation_root', update_request_steps_by_pk: { __typename?: 'request_steps', id: string } | null };

export type CountUncompletedRequestStepDependenciesQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CountUncompletedRequestStepDependenciesQuery = { __typename?: 'query_root', request_steps: Array<{ __typename?: 'request_steps', id: string, completedAt: string | null }> };

export type GetActiveRequestFollowersQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetActiveRequestFollowersQuery = { __typename?: 'query_root', request_followers: Array<{ __typename?: 'request_followers', id: string, assigneeType: AssigneeTypeEnum, user: { __typename?: 'users', id: string } | null, group: { __typename?: 'groups', id: string, group_users: Array<{ __typename?: 'group_users', id: string, user: { __typename?: 'users', id: string } }> } | null }> };

export type GetConditionDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetConditionDataQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, tagIds: any | null, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, supplier: { __typename?: 'organisation_suppliers', id: string, state: OrganisationSupplierStateEnum, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }>, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }> } | null, product: { __typename?: 'organisation_products_and_services', state: OrganisationProductsAndServicesStateEnum } | null, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"] }> } | null };

export type GetRequestNotificationDetailsQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestNotificationDetailsQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, name: string, requestorUserId: string, ownerId: string | null, type: RequestTypeEnum, publicId: string, assessment: { __typename?: 'assessments', id: string } | null, organisation: { __typename?: 'organisations', id: string, name: string }, followers: Array<{ __typename?: 'request_followers', id: string, assigneeType: AssigneeTypeEnum, user: { __typename?: 'users', id: string } | null, group: { __typename?: 'groups', id: string, group_users: Array<{ __typename?: 'group_users', id: string, user: { __typename?: 'users', id: string } }> } | null }> } | null };

export type GetRequestStepByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRequestStepByIdQuery = { __typename?: 'query_root', request_steps_by_pk: { __typename?: 'request_steps', id: string, canvasModelParentIds: any, input: any, state: RequestStepStateEnum, workflowId: string, data: any | null, requestId: string, canvasModelId: string, result: RequestStepResultEnum | null, output: any | null, actionTakenAt: string | null, type: any, assignees: any, notificationMessage: any, label: any, targetTimeValue: any, tasks: any, request: { __typename?: 'requests', id: string, state: string | null }, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum }> } | null };

export type GetSavedNotificationQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetSavedNotificationQuery = { __typename?: 'query_root', request_step_notification_messages_by_pk: { __typename?: 'request_step_notification_messages', body: any, subject: any } | null };

export type RequestFragmentFragment = { __typename?: 'requests', id: string, name: string, state: string | null, workflowId: string, requestorUserId: string, createdAt: string, updatedAt: string, priority: RequestPriorityEnum, completedAt: string | null, model: OverrideTypes["RequestModel"], tagIds: any | null, type: RequestTypeEnum, request_product: string | null, request_supplier: string | null, publicId: string, totalPausedTime: string, agreement_term: { __typename?: 'agreement_terms', agreementId: string } | null, owner: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } };

export type RequestFragmentMinimalFragment = { __typename?: 'requests', id: string, name: string, state: string | null, workflowId: string, model: OverrideTypes["RequestModel"], requestorUserId: string, tagIds: any | null };

export type UpdateRenewalCancelledMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type UpdateRenewalCancelledMutation = { __typename?: 'mutation_root', update_renewals: { __typename?: 'renewals_mutation_response', returning: Array<{ __typename?: 'renewals', cancelledAt: string | null, id: string }> } | null };

export type UpdateRequestCompletionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpdateRequestCompletionMutation = { __typename?: 'mutation_root', update_requests_by_pk: { __typename?: 'requests', id: string, name: string, state: string | null, workflowId: string, requestorUserId: string, createdAt: string, updatedAt: string, priority: RequestPriorityEnum, completedAt: string | null, model: OverrideTypes["RequestModel"], tagIds: any | null, type: RequestTypeEnum, request_product: string | null, request_supplier: string | null, publicId: string, totalPausedTime: string, product: { __typename?: 'organisation_products_and_services', id: string } | null, agreement_term: { __typename?: 'agreement_terms', agreementId: string } | null, owner: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } } | null };

export type UpdateRequestProductMutationVariables = Exact<{
  productId: InputMaybe<Scalars['uuid']['input']>;
  supplierId: InputMaybe<Scalars['uuid']['input']>;
  id: Scalars['uuid']['input'];
}>;


export type UpdateRequestProductMutation = { __typename?: 'mutation_root', update_requests_by_pk: { __typename?: 'requests', id: string, name: string, state: string | null, workflowId: string, requestorUserId: string, createdAt: string, updatedAt: string, priority: RequestPriorityEnum, completedAt: string | null, model: OverrideTypes["RequestModel"], tagIds: any | null, type: RequestTypeEnum, request_product: string | null, request_supplier: string | null, publicId: string, totalPausedTime: string, agreement_term: { __typename?: 'agreement_terms', agreementId: string } | null, owner: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } } | null };

export type UpdateRequestStepDataMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  setInput: InputMaybe<RequestStepsSetInput>;
}>;


export type UpdateRequestStepDataMutation = { __typename?: 'mutation_root', update_request_steps: { __typename?: 'request_steps_mutation_response', affected_rows: number } | null };

export type GetAllCustomFieldValuesPaginatedQueryVariables = Exact<{
  entityType: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetAllCustomFieldValuesPaginatedQuery = { __typename?: 'query_root', custom_field_values: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, custom_field_values_aggregate: { __typename?: 'custom_field_values_aggregate', aggregate: { __typename?: 'custom_field_values_aggregate_fields', count: number } | null } };

export type CoreDataDependenciesMetadataFragment = { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } };

export type CustomCoreDataFragment = { __typename?: 'custom_core_data', id: string, name: string, organisationId: string, pathLevels: Array<string> | null, archivedAt: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null, options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string }>, numOptions: { __typename?: 'custom_core_data_options_aggregate', aggregate: { __typename?: 'custom_core_data_options_aggregate_fields', count: number } | null } };

export type CustomCoreDataOptionFragment = { __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string };

export type CustomCoreDataOptionWithDependenciesFragment = { __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } };

export type CustomCoreDataOptionWithDependenciesMetadataFragment = { __typename?: 'custom_core_data_options', dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } };

export type CustomCoreDataWithDependenciesFragment = { __typename?: 'custom_core_data', id: string, name: string, organisationId: string, pathLevels: Array<string> | null, archivedAt: string | null, options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } }>, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null, numOptions: { __typename?: 'custom_core_data_options_aggregate', aggregate: { __typename?: 'custom_core_data_options_aggregate_fields', count: number } | null } };

export type CustomCoreDataWithDependenciesMetadataFragment = { __typename?: 'custom_core_data', id: string, name: string, organisationId: string, pathLevels: Array<string> | null, archivedAt: string | null, options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } }>, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null, numOptions: { __typename?: 'custom_core_data_options_aggregate', aggregate: { __typename?: 'custom_core_data_options_aggregate_fields', count: number } | null } };

export type CustomCoreDataWithDependenciesMetadataIncludingArchivedFragment = { __typename?: 'custom_core_data', id: string, name: string, organisationId: string, pathLevels: Array<string> | null, archivedAt: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null, options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } }>, numOptions: { __typename?: 'custom_core_data_options_aggregate', aggregate: { __typename?: 'custom_core_data_options_aggregate_fields', count: number } | null } };

export type CustomFieldValueFragmentFragment = { __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null };

export type DeleteCustomFieldMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteCustomFieldMutation = { __typename?: 'mutation_root', customField: { __typename?: 'custom_fields', id: string, deletedAt: string | null } | null, update_custom_field_values: { __typename?: 'custom_field_values_mutation_response', returning: Array<{ __typename?: 'custom_field_values', id: string, customFieldCoreDataId: string | null }> } | null };

export type DeleteCustomFieldCoreDataMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteCustomFieldCoreDataMutation = { __typename?: 'mutation_root', update_custom_field_core_data: { __typename?: 'custom_field_core_data_mutation_response', affected_rows: number } | null };

export type DeleteCustomFieldCoreDataValuesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteCustomFieldCoreDataValuesMutation = { __typename?: 'mutation_root', update_custom_field_core_data: { __typename?: 'custom_field_core_data_mutation_response', affected_rows: number } | null };

export type DeleteCustomFieldIdpAttributeMappingMutationVariables = Exact<{
  customFieldId: Scalars['uuid']['input'];
}>;


export type DeleteCustomFieldIdpAttributeMappingMutation = { __typename?: 'mutation_root', delete_idp_attribute_mappings: { __typename?: 'idp_attribute_mappings_mutation_response', returning: Array<{ __typename?: 'idp_attribute_mappings', id: string }> } | null };

export type DeleteCustomFieldValuesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteCustomFieldValuesMutation = { __typename?: 'mutation_root', update_custom_field_values: { __typename?: 'custom_field_values_mutation_response', returning: Array<{ __typename?: 'custom_field_values', id: string, value: string | null, entityId: string, customFieldId: string, customFieldChoiceId: string | null, customFieldCoreDataId: string | null }> } | null };

export type GetAllCustomFieldValuesQueryVariables = Exact<{
  entityType: Scalars['String']['input'];
}>;


export type GetAllCustomFieldValuesQuery = { __typename?: 'query_root', custom_field_values: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> };

export type GetChoicesOfCustomFieldQueryVariables = Exact<{
  customFieldId: Scalars['uuid']['input'];
}>;


export type GetChoicesOfCustomFieldQuery = { __typename?: 'query_root', custom_field_choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }> };

export type GetCustomCoreDataByIdQueryVariables = Exact<{
  customCoreDataId: Scalars['uuid']['input'];
}>;


export type GetCustomCoreDataByIdQuery = { __typename?: 'query_root', custom_core_data_by_pk: { __typename?: 'custom_core_data', id: string, name: string, organisationId: string, pathLevels: Array<string> | null, archivedAt: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null, options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string }>, numOptions: { __typename?: 'custom_core_data_options_aggregate', aggregate: { __typename?: 'custom_core_data_options_aggregate_fields', count: number } | null } } | null };

export type GetCustomCoreDataOptionsWithDependenciesByIdQueryVariables = Exact<{
  customCoreDataId: Scalars['uuid']['input'];
}>;


export type GetCustomCoreDataOptionsWithDependenciesByIdQuery = { __typename?: 'query_root', custom_core_data_options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } }> };

export type GetCustomCoreDataOptionsWithDependenciesByIdInclArchivedQueryVariables = Exact<{
  customCoreDataId: Scalars['uuid']['input'];
}>;


export type GetCustomCoreDataOptionsWithDependenciesByIdInclArchivedQuery = { __typename?: 'query_root', custom_core_data_options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } }> };

export type GetCustomCoreDataWithDependenciesByIdQueryVariables = Exact<{
  customCoreDataId: Scalars['uuid']['input'];
}>;


export type GetCustomCoreDataWithDependenciesByIdQuery = { __typename?: 'query_root', custom_core_data_by_pk: { __typename?: 'custom_core_data', id: string, name: string, organisationId: string, pathLevels: Array<string> | null, archivedAt: string | null, options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } }>, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null, numOptions: { __typename?: 'custom_core_data_options_aggregate', aggregate: { __typename?: 'custom_core_data_options_aggregate_fields', count: number } | null } } | null };

export type GetCustomCoreDataWithDependenciesMetadataByIdsQueryVariables = Exact<{
  customCoreDataIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  depsLimit: Scalars['Int']['input'];
}>;


export type GetCustomCoreDataWithDependenciesMetadataByIdsQuery = { __typename?: 'query_root', customCoreDatum: Array<{ __typename?: 'custom_core_data', id: string, name: string, organisationId: string, pathLevels: Array<string> | null, archivedAt: string | null, options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, isArchived: boolean, archivedBy: string | null, customCoreDataId: string, parentId: string | null, isTerminal: boolean, remoteId: string | null, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } }>, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null, numOptions: { __typename?: 'custom_core_data_options_aggregate', aggregate: { __typename?: 'custom_core_data_options_aggregate_fields', count: number } | null } }> };

export type GetCustomFieldValuesByCustomFieldIdQueryVariables = Exact<{
  customFieldId: Scalars['uuid']['input'];
  entityId: Scalars['uuid']['input'];
}>;


export type GetCustomFieldValuesByCustomFieldIdQuery = { __typename?: 'query_root', custom_field_values: Array<{ __typename?: 'custom_field_values', id: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, fileId: string | null, entityId: string, customFieldId: string, customFieldChoiceId: string | null, customFieldCoreDataId: string | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customField: { __typename?: 'custom_fields', id: string, externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null }, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, address: { __typename?: 'addresses', id: string, name: string | null, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> };

export type GetCustomFieldValuesForEntitiesQueryVariables = Exact<{
  entityIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetCustomFieldValuesForEntitiesQuery = { __typename?: 'query_root', custom_field_values: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> };

export type GetCustomFieldValuesOfEntityQueryVariables = Exact<{
  entityId: Scalars['uuid']['input'];
}>;


export type GetCustomFieldValuesOfEntityQuery = { __typename?: 'query_root', custom_field_values: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> };

export type CustomFieldFragment = { __typename?: 'custom_fields', id: string, title: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, isRequired: boolean, updatedAt: string, entityType: OverrideTypes["CustomFieldsEntityType"], dependsOnCustomFieldId: string | null, organisationIntegrationId: string | null, allowUserToAddCustomOptions: boolean | null, remoteId: string | null, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }>, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null };

export type GetCustomFieldsByEntityTypeQueryVariables = Exact<{
  entityType: Scalars['String']['input'];
}>;


export type GetCustomFieldsByEntityTypeQuery = { __typename?: 'query_root', customFields: Array<{ __typename?: 'custom_fields', id: string, title: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, isRequired: boolean, updatedAt: string, entityType: OverrideTypes["CustomFieldsEntityType"], dependsOnCustomFieldId: string | null, organisationIntegrationId: string | null, allowUserToAddCustomOptions: boolean | null, remoteId: string | null, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }>, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }> };

export type GetCustomFieldByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCustomFieldByIdQuery = { __typename?: 'query_root', customField: { __typename?: 'custom_fields', id: string, title: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, isRequired: boolean, updatedAt: string, entityType: OverrideTypes["CustomFieldsEntityType"], dependsOnCustomFieldId: string | null, organisationIntegrationId: string | null, allowUserToAddCustomOptions: boolean | null, remoteId: string | null, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }>, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null } | null };

export type GetCustomFieldsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetCustomFieldsByIdsQuery = { __typename?: 'query_root', customFields: Array<{ __typename?: 'custom_fields', id: string, title: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, isRequired: boolean, updatedAt: string, entityType: OverrideTypes["CustomFieldsEntityType"], dependsOnCustomFieldId: string | null, organisationIntegrationId: string | null, allowUserToAddCustomOptions: boolean | null, remoteId: string | null, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }>, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }> };

export type InsertCustomFieldMutationVariables = Exact<{
  input: CustomFieldsInsertInput;
}>;


export type InsertCustomFieldMutation = { __typename?: 'mutation_root', customField: { __typename?: 'custom_fields', id: string, title: string, isRequired: boolean, updatedAt: string } | null };

export type InsertCustomFieldChoiceMutationVariables = Exact<{
  input: CustomFieldChoicesInsertInput;
}>;


export type InsertCustomFieldChoiceMutation = { __typename?: 'mutation_root', insert_custom_field_choices_one: { __typename?: 'custom_field_choices', id: string } | null };

export type InsertCustomFieldCoreDataMutationVariables = Exact<{
  input: CustomFieldCoreDataInsertInput;
}>;


export type InsertCustomFieldCoreDataMutation = { __typename?: 'mutation_root', insert_custom_field_core_data_one: { __typename?: 'custom_field_core_data', id: string } | null };

export type InsertCustomFieldValuesMutationVariables = Exact<{
  objects: Array<CustomFieldValuesInsertInput> | CustomFieldValuesInsertInput;
}>;


export type InsertCustomFieldValuesMutation = { __typename?: 'mutation_root', customFieldValues: { __typename?: 'custom_field_values_mutation_response', returning: Array<{ __typename?: 'custom_field_values', id: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, entityId: string, customFieldId: string }> } | null };

export type RestoreCustomFieldMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RestoreCustomFieldMutation = { __typename?: 'mutation_root', customField: { __typename?: 'custom_fields', id: string } | null };

export type UpdateCustomFieldMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  title: Scalars['String']['input'];
  isRequired: Scalars['Boolean']['input'];
  allowUserToAddCustomOptions: Scalars['Boolean']['input'];
}>;


export type UpdateCustomFieldMutation = { __typename?: 'mutation_root', customField: { __typename?: 'custom_fields', id: string, title: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, isRequired: boolean, updatedAt: string, entityType: OverrideTypes["CustomFieldsEntityType"], dependsOnCustomFieldId: string | null, organisationIntegrationId: string | null, allowUserToAddCustomOptions: boolean | null, remoteId: string | null, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }>, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null } | null };

export type UpdateCustomFieldChoicesMutationVariables = Exact<{
  newChoices: Array<CustomFieldChoicesInsertInput> | CustomFieldChoicesInsertInput;
  removingChoicesIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpdateCustomFieldChoicesMutation = { __typename?: 'mutation_root', insert_custom_field_choices: { __typename?: 'custom_field_choices_mutation_response', returning: Array<{ __typename?: 'custom_field_choices', id: string }> } | null, delete_custom_field_choices: { __typename?: 'custom_field_choices_mutation_response', returning: Array<{ __typename?: 'custom_field_choices', id: string }> } | null };

export type UpdateCustomFieldCoreDataMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: CustomFieldCoreDataSetInput;
}>;


export type UpdateCustomFieldCoreDataMutation = { __typename?: 'mutation_root', update_custom_field_core_data_by_pk: { __typename?: 'custom_field_core_data', id: string } | null };

export type UpdateCustomFieldValuesMutationVariables = Exact<{
  updates: Array<CustomFieldValuesUpdates> | CustomFieldValuesUpdates;
}>;


export type UpdateCustomFieldValuesMutation = { __typename?: 'mutation_root', customFieldValues: Array<{ __typename?: 'custom_field_values_mutation_response', returning: Array<{ __typename?: 'custom_field_values', id: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, entityId: string, customFieldId: string, customFieldCoreDataId: string | null, userId: string | null }> } | null> | null };

export type DeleteIdpAttributeMappingMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteIdpAttributeMappingMutation = { __typename?: 'mutation_root', delete_idp_attribute_mappings_by_pk: { __typename?: 'idp_attribute_mappings', id: string } | null };

export type GetIdpAttributeMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIdpAttributeMappingsQuery = { __typename?: 'query_root', idp_attribute_mappings: Array<{ __typename?: 'idp_attribute_mappings', id: string, idpCustomAttribute: string, custom_field: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, entityType: OverrideTypes["CustomFieldsEntityType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null } }> };

export type InsertIdpAttributeMappingMutationVariables = Exact<{
  input: IdpAttributeMappingsInsertInput;
}>;


export type InsertIdpAttributeMappingMutation = { __typename?: 'mutation_root', insert_idp_attribute_mappings_one: { __typename?: 'idp_attribute_mappings', id: string, idpCustomAttribute: string, custom_field: { __typename?: 'custom_fields', id: string, title: string } } | null };

export type GetRequestNumberQueryVariables = Exact<{
  requestsFilter: InputMaybe<RequestsBoolExp>;
}>;


export type GetRequestNumberQuery = { __typename?: 'query_root', requests_aggregate: { __typename?: 'requests_aggregate', aggregate: { __typename?: 'requests_aggregate_fields', count: number } | null } };

export type GetHargreavesLansdownBudgetApprovalsDataExportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHargreavesLansdownBudgetApprovalsDataExportQuery = { __typename?: 'query_root', l2CategoryData: Array<{ __typename?: 'budget_approval_group', id: string, name: string, assignees: Array<{ __typename?: 'budget_approval_group_assignees', id: string, custom_core_data_options: Array<{ __typename?: 'budget_approval_group_assignees_custom_core_data_options', budget_approval_group_assignees_id: string, custom_core_data_id: string, custom_core_data_option_id: string }>, assignees: Array<{ __typename?: 'budget_approval_group_assignees_assignees', id: string, group: { __typename?: 'groups', id: string, name: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null }> }> }> };

export type GetHargreavesLansdownRequestsDataExportQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetHargreavesLansdownRequestsDataExportQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'requests', id: string, state: string | null, createdAt: string, completedAt: string | null, publicId: string, name: string, tagIds: any | null, workflow: { __typename?: 'workflows', id: string, title: string, type: WorkflowTypeEnum, workflow_condition_groups: Array<{ __typename?: 'workflow_condition_groups', id: string, name: string, precedence: number | null }> }, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }>, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null }> }>, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, publicId: number, remoteId: string | null } | null, computedProperties: { __typename?: 'request_computed_properties', department: { __typename?: 'departments', id: string, name: string } | null } | null, steps: Array<{ __typename?: 'request_steps', id: string, canvasModelId: string, createdAt: string, completedAt: string | null, output: any | null, data: any | null, input: any, name: any, targetTime: any, type: any }> }> };

export type ProofpointLineItemDetailsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type ProofpointLineItemDetailsQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'requests', id: string, publicId: string, name: string, createdAt: string, completedAt: string | null, deletedAt: string | null, state: string | null, tagIds: any | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string } | null, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string }, steps: Array<{ __typename?: 'request_steps', id: string, name: any }>, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null }> }>, workflow: { __typename?: 'workflows', id: string, title: string, workflow_condition_groups: Array<{ __typename?: 'workflow_condition_groups', id: string, name: string, precedence: number | null }> }, renewal: { __typename?: 'renewals', id: string, renewalDate: string } | null, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }>, owner: { __typename?: 'users', id: string, email: string } | null, inProgressStepContext: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, nodeId: string, name: any, type: any, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string, groupUsers: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }>, engagement: { __typename?: 'engagements', id: string, purchaseOrderNumber: string | null } | null, purchase_orders: Array<{ __typename?: 'purchase_orders', id: string, remoteNumber: string | null }>, computedProperties: { __typename?: 'request_computed_properties', inBudget: boolean | null, valueObject: any | null, renewalDate: string | null, contractStartDate: string | null, contractEndDate: string | null, department: { __typename?: 'departments', id: string, name: string } | null, buyerLegalEntity: { __typename?: 'subsidiaries', id: string, name: string } | null, businessOwner: { __typename?: 'users', id: string, email: string } | null } | null }> };

export type GetCustomFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomFieldsQuery = { __typename?: 'query_root', custom_fields: Array<{ __typename?: 'custom_fields', id: string, title: string, entityType: OverrideTypes["CustomFieldsEntityType"], values: Array<{ __typename?: 'custom_field_values', id: string, value: string | null, createdAt: string, updatedAt: string, entityId: string, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null }> }> };

export type GetSupplierNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSupplierNumberQuery = { __typename?: 'query_root', organisation_suppliers_aggregate: { __typename?: 'organisation_suppliers_aggregate', aggregate: { __typename?: 'organisation_suppliers_aggregate_fields', count: number } | null } };

export type GetWiseSupplierDataQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetWiseSupplierDataQuery = { __typename?: 'query_root', suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, state: OrganisationSupplierStateEnum, updated_at: string, createdAt: string, website: string | null, description: string | null, externalLink: string | null, address: OverrideTypes["Address"] | null, lastAssessmentDate: string | null, isReseller: boolean, products: Array<{ __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum, createdAt: string | null, updatedAt: string | null, description: string | null, isArchived: boolean, businessOwner: { __typename?: 'users', email: string } | null, assessments: Array<{ __typename?: 'assessments', id: string, name: string, updatedAt: string }>, renewals: Array<{ __typename?: 'renewals', id: string, createdAt: string, updatedAt: string, renewalDate: string }> }>, requests: Array<{ __typename?: 'requests', id: string, name: string, state: string | null, updatedAt: string, createdAt: string, product: { __typename?: 'organisation_products_and_services', id: string, name: string } | null, tags: Array<{ __typename?: 'request_tags', tag: { __typename?: 'tags', name: string } }> }>, internalContacts: Array<{ __typename?: 'internal_contacts', id: string, role: OverrideTypes["InternalContactRole"], productId: string | null, user: { __typename?: 'users', email: string } }>, tags: Array<{ __typename?: 'organisation_supplier_tags', tag: { __typename?: 'tags', name: string } }>, externalContacts: Array<{ __typename?: 'external_contacts', id: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, title: string | null }> }> };

export type GetRequestCommentsAndSubmissionsForSupplierQueryVariables = Exact<{
  supplierUserId: Scalars['uuid']['input'];
}>;


export type GetRequestCommentsAndSubmissionsForSupplierQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', request_form_submissions: Array<{ __typename?: 'request_form_submissions', response: OverrideTypes["FormResponsePayload"] | null }>, request_form: { __typename?: 'request_forms', config: OverrideTypes["FormConfig"] } | null, request_step: { __typename?: 'request_steps', request: { __typename?: 'requests', comments: Array<{ __typename?: 'request_comments', rfxSupplierId: string | null, type: RequestCommentTypeEnum, payload: any }>, documents: Array<{ __typename?: 'request_documents', filestoreId: string }>, request_forms: Array<{ __typename?: 'request_forms', latestSubmissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null }> }> } } }>, rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string }> };

export type DocumentTypeFragment = { __typename?: 'document_types', id: string, name: string, description: string, attributes: any, createdAt: string, updatedAt: string };

export type GetCustomDocumentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomDocumentTypesQuery = { __typename?: 'query_root', custom_document_types: Array<{ __typename?: 'custom_document_types', id: string, value: string }> };

export type InsertCustomDocumentTypeMutationVariables = Exact<{
  input: CustomDocumentTypesInsertInput;
}>;


export type InsertCustomDocumentTypeMutation = { __typename?: 'mutation_root', insert_custom_document_types_one: { __typename?: 'custom_document_types', id: string, value: string } | null };

export type InsertDocumentTypeMutationVariables = Exact<{
  input: DocumentTypesInsertInput;
}>;


export type InsertDocumentTypeMutation = { __typename?: 'mutation_root', documentType: { __typename?: 'document_types', id: string, name: string, description: string, attributes: any, createdAt: string, updatedAt: string } | null };

export type DeleteGlobalDocumentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteGlobalDocumentMutation = { __typename?: 'mutation_root', delete_documents_by_pk: { __typename?: 'documents', id: string, filestoreId: string } | null };

export type GetGlobalDocumentsBySupplierQueryVariables = Exact<{
  orgSupplierId: Scalars['uuid']['input'];
}>;


export type GetGlobalDocumentsBySupplierQuery = { __typename?: 'query_root', documents: Array<{ __typename?: 'documents', id: string, fileName: string, createdAt: string, updatedAt: string, filestoreId: string, organisationId: string, staticType: string | null, customType: string | null, organisationSupplierId: string | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, customTypeValue: { __typename?: 'custom_document_types', id: string, value: string } | null, sourceRequestDocument: { __typename?: 'request_documents', id: string, sourceRequestForm: { __typename?: 'request_forms', id: string, title: string } | null, request: { __typename?: 'requests', id: string, name: string } } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, logoUrl: string | null } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null } | null, uploadedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, agreement_documents: Array<{ __typename?: 'agreement_documents', agreement: { __typename?: 'agreements', id: string, name: string } }> }> };

export type GetGlobalDocumentsForUserPaginatedQueryVariables = Exact<{
  orgSupplierIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetGlobalDocumentsForUserPaginatedQuery = { __typename?: 'query_root', documents: Array<{ __typename?: 'documents', id: string, fileName: string, createdAt: string, updatedAt: string, filestoreId: string, organisationId: string, staticType: string | null, customType: string | null, organisationSupplierId: string | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, customTypeValue: { __typename?: 'custom_document_types', id: string, value: string } | null, sourceRequestDocument: { __typename?: 'request_documents', id: string, sourceRequestForm: { __typename?: 'request_forms', id: string, title: string } | null, request: { __typename?: 'requests', id: string, name: string } } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, logoUrl: string | null } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null } | null, uploadedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, agreement_documents: Array<{ __typename?: 'agreement_documents', agreement: { __typename?: 'agreements', id: string, name: string } }> }>, documents_aggregate: { __typename?: 'documents_aggregate', aggregate: { __typename?: 'documents_aggregate_fields', count: number } | null } };

export type GetGlobalDocumentsForUserPaginatedV2QueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order_by: InputMaybe<Array<DocumentsOrderBy> | DocumentsOrderBy>;
  where: InputMaybe<DocumentsBoolExp>;
}>;


export type GetGlobalDocumentsForUserPaginatedV2Query = { __typename?: 'query_root', documents: Array<{ __typename?: 'documents', id: string, fileName: string, createdAt: string, updatedAt: string, filestoreId: string, organisationId: string, staticType: string | null, customType: string | null, organisationSupplierId: string | null, customTypeValue: { __typename?: 'custom_document_types', id: string, value: string } | null, sourceRequestDocument: { __typename?: 'request_documents', id: string, sourceRequestForm: { __typename?: 'request_forms', id: string, title: string } | null, request: { __typename?: 'requests', id: string, name: string } } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, logoUrl: string | null } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null } | null, uploadedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, agreement_documents: Array<{ __typename?: 'agreement_documents', agreement: { __typename?: 'agreements', id: string, name: string } }> }>, documents_aggregate: { __typename?: 'documents_aggregate', aggregate: { __typename?: 'documents_aggregate_fields', count: number } | null } };

export type GetGlobalDocumentsPaginatedQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetGlobalDocumentsPaginatedQuery = { __typename?: 'query_root', documents: Array<{ __typename?: 'documents', id: string, fileName: string, createdAt: string, updatedAt: string, filestoreId: string, organisationId: string, staticType: string | null, customType: string | null, organisationSupplierId: string | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, customTypeValue: { __typename?: 'custom_document_types', id: string, value: string } | null, sourceRequestDocument: { __typename?: 'request_documents', id: string, sourceRequestForm: { __typename?: 'request_forms', id: string, title: string } | null, request: { __typename?: 'requests', id: string, name: string } } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, logoUrl: string | null } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null } | null, uploadedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, agreement_documents: Array<{ __typename?: 'agreement_documents', agreement: { __typename?: 'agreements', id: string, name: string } }> }>, documents_aggregate: { __typename?: 'documents_aggregate', aggregate: { __typename?: 'documents_aggregate_fields', count: number } | null } };

export type GetGlobalDocumentsPaginatedV2QueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order_by: InputMaybe<Array<DocumentsOrderBy> | DocumentsOrderBy>;
  where: InputMaybe<DocumentsBoolExp>;
}>;


export type GetGlobalDocumentsPaginatedV2Query = { __typename?: 'query_root', documents: Array<{ __typename?: 'documents', id: string, fileName: string, createdAt: string, updatedAt: string, filestoreId: string, organisationId: string, staticType: string | null, customType: string | null, organisationSupplierId: string | null, customTypeValue: { __typename?: 'custom_document_types', id: string, value: string } | null, sourceRequestDocument: { __typename?: 'request_documents', id: string, sourceRequestForm: { __typename?: 'request_forms', id: string, title: string } | null, request: { __typename?: 'requests', id: string, name: string } } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, logoUrl: string | null } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null } | null, uploadedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, agreement_documents: Array<{ __typename?: 'agreement_documents', agreement: { __typename?: 'agreements', id: string, name: string } }> }>, documents_aggregate: { __typename?: 'documents_aggregate', aggregate: { __typename?: 'documents_aggregate_fields', count: number } | null } };

export type GlobalDocumentFragment = { __typename?: 'documents', id: string, fileName: string, createdAt: string, updatedAt: string, filestoreId: string, organisationId: string, staticType: string | null, customType: string | null, organisationSupplierId: string | null, customTypeValue: { __typename?: 'custom_document_types', id: string, value: string } | null, sourceRequestDocument: { __typename?: 'request_documents', id: string, sourceRequestForm: { __typename?: 'request_forms', id: string, title: string } | null, request: { __typename?: 'requests', id: string, name: string } } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, logoUrl: string | null } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null } | null, uploadedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, agreement_documents: Array<{ __typename?: 'agreement_documents', agreement: { __typename?: 'agreements', id: string, name: string } }> };

export type InsertGlobalDocumentMutationVariables = Exact<{
  input: DocumentsInsertInput;
}>;


export type InsertGlobalDocumentMutation = { __typename?: 'mutation_root', insert_documents_one: { __typename?: 'documents', id: string, fileName: string, createdAt: string, updatedAt: string, filestoreId: string, organisationId: string, staticType: string | null, customType: string | null, organisationSupplierId: string | null, customTypeValue: { __typename?: 'custom_document_types', id: string, value: string } | null, sourceRequestDocument: { __typename?: 'request_documents', id: string, sourceRequestForm: { __typename?: 'request_forms', id: string, title: string } | null, request: { __typename?: 'requests', id: string, name: string } } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, logoUrl: string | null } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null } | null, uploadedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, agreement_documents: Array<{ __typename?: 'agreement_documents', agreement: { __typename?: 'agreements', id: string, name: string } }> } | null };

export type BatchInsertGlobalDocumentsMutationVariables = Exact<{
  objects: Array<DocumentsInsertInput> | DocumentsInsertInput;
}>;


export type BatchInsertGlobalDocumentsMutation = { __typename?: 'mutation_root', insert_documents: { __typename?: 'documents_mutation_response', returning: Array<{ __typename?: 'documents', id: string, requestDocumentsId: string | null, filestoreId: string, organisationSupplierId: string | null, organisationProductId: string | null, staticType: string | null, customType: string | null, fileName: string, customTypeValue: { __typename?: 'custom_document_types', id: string, value: string } | null }> } | null };

export type DeleteGlobalDocumentsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteGlobalDocumentsMutation = { __typename?: 'mutation_root', delete_documents: { __typename?: 'documents_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'documents', id: string }> } | null };

export type IsRequestCompleteQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type IsRequestCompleteQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, completedAt: string | null } | null };

export type GetRequestDocumentsQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestDocumentsQuery = { __typename?: 'query_root', request_documents: Array<{ __typename?: 'request_documents', id: string, filestoreId: string, createdAt: string, updatedAt: string, organisationId: string, fileName: string, sourceRequestFormId: string | null, requestId: string, shouldPromoteToGlobal: boolean, staticType: string | null, customType: string | null, source: OverrideTypes["RequestDocumentSource"] | null, uploadedBy: string | null, request: { __typename?: 'requests', id: string, name: string, publicId: string, product: { __typename?: 'organisation_products_and_services', id: string, organisation_supplier: { __typename?: 'organisation_suppliers', id: string } } | null }, customTypeValue: { __typename?: 'custom_document_types', id: string, value: string } | null, uploadedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, sourceRequestForm: { __typename?: 'request_forms', id: string, title: string } | null }> };

export type GetRequestDocumentsBySourceQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  source: Scalars['String']['input'];
}>;


export type GetRequestDocumentsBySourceQuery = { __typename?: 'query_root', request_documents: Array<{ __typename?: 'request_documents', id: string, filestoreId: string, createdAt: string, updatedAt: string, organisationId: string, fileName: string, sourceRequestFormId: string | null, requestId: string, shouldPromoteToGlobal: boolean, staticType: string | null, customType: string | null, source: OverrideTypes["RequestDocumentSource"] | null, uploadedBy: string | null, request: { __typename?: 'requests', id: string, name: string, publicId: string, product: { __typename?: 'organisation_products_and_services', id: string, organisation_supplier: { __typename?: 'organisation_suppliers', id: string } } | null }, customTypeValue: { __typename?: 'custom_document_types', id: string, value: string } | null, uploadedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, sourceRequestForm: { __typename?: 'request_forms', id: string, title: string } | null }> };

export type InsertRequestDocumentMutationVariables = Exact<{
  input: RequestDocumentsInsertInput;
}>;


export type InsertRequestDocumentMutation = { __typename?: 'mutation_root', insert_request_documents_one: { __typename?: 'request_documents', id: string, filestoreId: string, createdAt: string, updatedAt: string, organisationId: string, fileName: string, sourceRequestFormId: string | null, requestId: string, shouldPromoteToGlobal: boolean, staticType: string | null, customType: string | null, source: OverrideTypes["RequestDocumentSource"] | null, uploadedBy: string | null, request: { __typename?: 'requests', id: string, name: string, publicId: string, product: { __typename?: 'organisation_products_and_services', id: string, organisation_supplier: { __typename?: 'organisation_suppliers', id: string } } | null }, customTypeValue: { __typename?: 'custom_document_types', id: string, value: string } | null, uploadedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, sourceRequestForm: { __typename?: 'request_forms', id: string, title: string } | null } | null };

export type RequestDocumentFragment = { __typename?: 'request_documents', id: string, filestoreId: string, createdAt: string, updatedAt: string, organisationId: string, fileName: string, sourceRequestFormId: string | null, requestId: string, shouldPromoteToGlobal: boolean, staticType: string | null, customType: string | null, source: OverrideTypes["RequestDocumentSource"] | null, uploadedBy: string | null, request: { __typename?: 'requests', id: string, name: string, publicId: string, product: { __typename?: 'organisation_products_and_services', id: string, organisation_supplier: { __typename?: 'organisation_suppliers', id: string } } | null }, customTypeValue: { __typename?: 'custom_document_types', id: string, value: string } | null, uploadedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, sourceRequestForm: { __typename?: 'request_forms', id: string, title: string } | null };

export type UpdateRequestDocumentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  requestDocument: RequestDocumentsSetInput;
}>;


export type UpdateRequestDocumentMutation = { __typename?: 'mutation_root', update_request_documents_by_pk: { __typename?: 'request_documents', id: string, filestoreId: string, createdAt: string, updatedAt: string, organisationId: string, fileName: string, sourceRequestFormId: string | null, requestId: string, shouldPromoteToGlobal: boolean, staticType: string | null, customType: string | null, source: OverrideTypes["RequestDocumentSource"] | null, uploadedBy: string | null, request: { __typename?: 'requests', id: string, name: string, publicId: string, product: { __typename?: 'organisation_products_and_services', id: string, organisation_supplier: { __typename?: 'organisation_suppliers', id: string } } | null }, customTypeValue: { __typename?: 'custom_document_types', id: string, value: string } | null, uploadedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, sourceRequestForm: { __typename?: 'request_forms', id: string, title: string } | null } | null };

export type GetRequestStepExecutionStatusQueryVariables = Exact<{
  where: RequestStepsBoolExp;
}>;


export type GetRequestStepExecutionStatusQuery = { __typename?: 'query_root', steps: Array<{ __typename?: 'request_steps', data: any | null, input: any, request: { __typename?: 'requests', request_users: Array<{ __typename?: 'request_users', userId: string }>, request_groups: Array<{ __typename?: 'request_groups', group: { __typename?: 'groups', group_users: Array<{ __typename?: 'group_users', userId: string }> } }> } }> };

export type EntityFieldGroupFieldsFragment = { __typename?: 'entity_field_group_fields', id: string, customFieldId: string | null, standardFieldKey: string | null, index: number };

export type EntityFieldGroupFragment = { __typename?: 'entity_field_groups', id: string, name: string, index: number, entityType: string, isDefaultForStandardFields: boolean, isDefaultForCustomFields: boolean, fields: Array<{ __typename?: 'entity_field_group_fields', id: string, customFieldId: string | null, standardFieldKey: string | null, index: number }> };

export type GetEntityFieldGroupsByEntityTypeQueryVariables = Exact<{
  entityType: Scalars['String']['input'];
}>;


export type GetEntityFieldGroupsByEntityTypeQuery = { __typename?: 'query_root', entity_field_groups: Array<{ __typename?: 'entity_field_groups', id: string, name: string, index: number, entityType: string, isDefaultForStandardFields: boolean, isDefaultForCustomFields: boolean, fields: Array<{ __typename?: 'entity_field_group_fields', id: string, customFieldId: string | null, standardFieldKey: string | null, index: number }> }> };

export type GetEntityFieldGroupByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEntityFieldGroupByIdQuery = { __typename?: 'query_root', entity_field_groups_by_pk: { __typename?: 'entity_field_groups', id: string, name: string, index: number, entityType: string, isDefaultForStandardFields: boolean, isDefaultForCustomFields: boolean, fields: Array<{ __typename?: 'entity_field_group_fields', id: string, customFieldId: string | null, standardFieldKey: string | null, index: number }> } | null };

export type InsertEntityFieldGroupMutationVariables = Exact<{
  object: EntityFieldGroupsInsertInput;
}>;


export type InsertEntityFieldGroupMutation = { __typename?: 'mutation_root', insert_entity_field_groups_one: { __typename?: 'entity_field_groups', id: string, name: string, index: number, entityType: string, isDefaultForStandardFields: boolean, isDefaultForCustomFields: boolean, fields: Array<{ __typename?: 'entity_field_group_fields', id: string, customFieldId: string | null, standardFieldKey: string | null, index: number }> } | null };

export type UpdateEntityFieldGroupMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: EntityFieldGroupsSetInput;
}>;


export type UpdateEntityFieldGroupMutation = { __typename?: 'mutation_root', update_entity_field_groups_by_pk: { __typename?: 'entity_field_groups', id: string, name: string, index: number, entityType: string, isDefaultForStandardFields: boolean, isDefaultForCustomFields: boolean, fields: Array<{ __typename?: 'entity_field_group_fields', id: string, customFieldId: string | null, standardFieldKey: string | null, index: number }> } | null };

export type DeleteEntityFieldGroupMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteEntityFieldGroupMutation = { __typename?: 'mutation_root', delete_entity_field_groups_by_pk: { __typename?: 'entity_field_groups', id: string } | null };

export type DeleteAllEntityFieldGroupsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllEntityFieldGroupsMutation = { __typename?: 'mutation_root', delete_entity_field_groups: { __typename?: 'entity_field_groups_mutation_response', affected_rows: number } | null };

export type SetStandardFieldGroupMutationVariables = Exact<{
  standardFieldKey: Scalars['String']['input'];
  targetGroupId: Scalars['uuid']['input'];
  index: Scalars['Int']['input'];
}>;


export type SetStandardFieldGroupMutation = { __typename?: 'mutation_root', delete_entity_field_group_fields: { __typename?: 'entity_field_group_fields_mutation_response', affected_rows: number } | null, insert_entity_field_group_fields_one: { __typename?: 'entity_field_group_fields', id: string, customFieldId: string | null, standardFieldKey: string | null, index: number } | null };

export type SetCustomFieldGroupMutationVariables = Exact<{
  customFieldId: Scalars['uuid']['input'];
  targetGroupId: Scalars['uuid']['input'];
  index: Scalars['Int']['input'];
}>;


export type SetCustomFieldGroupMutation = { __typename?: 'mutation_root', delete_entity_field_group_fields: { __typename?: 'entity_field_group_fields_mutation_response', affected_rows: number } | null, insert_entity_field_group_fields_one: { __typename?: 'entity_field_group_fields', id: string, customFieldId: string | null, standardFieldKey: string | null, index: number } | null };

export type UpdateFieldGroupWithFieldsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  fields: Array<EntityFieldGroupFieldsInsertInput> | EntityFieldGroupFieldsInsertInput;
}>;


export type UpdateFieldGroupWithFieldsMutation = { __typename?: 'mutation_root', delete_entity_field_group_fields: { __typename?: 'entity_field_group_fields_mutation_response', affected_rows: number } | null, update_entity_field_groups_by_pk: { __typename?: 'entity_field_groups', id: string, name: string, index: number, entityType: string, isDefaultForStandardFields: boolean, isDefaultForCustomFields: boolean, fields: Array<{ __typename?: 'entity_field_group_fields', id: string, customFieldId: string | null, standardFieldKey: string | null, index: number }> } | null, insert_entity_field_group_fields: { __typename?: 'entity_field_group_fields_mutation_response', returning: Array<{ __typename?: 'entity_field_group_fields', id: string, customFieldId: string | null, standardFieldKey: string | null, index: number }> } | null };

export type SetFieldGroupsWithFieldsMutationVariables = Exact<{
  groupIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  groupIdsToDelete: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  updates: Array<EntityFieldGroupsUpdates> | EntityFieldGroupsUpdates;
  fields: Array<EntityFieldGroupFieldsInsertInput> | EntityFieldGroupFieldsInsertInput;
}>;


export type SetFieldGroupsWithFieldsMutation = { __typename?: 'mutation_root', delete_entity_field_group_fields: { __typename?: 'entity_field_group_fields_mutation_response', affected_rows: number } | null, delete_entity_field_groups: { __typename?: 'entity_field_groups_mutation_response', affected_rows: number } | null, update_entity_field_groups_many: Array<{ __typename?: 'entity_field_groups_mutation_response', affected_rows: number } | null> | null, insert_entity_field_group_fields: { __typename?: 'entity_field_group_fields_mutation_response', affected_rows: number } | null };

export type GetCustomFieldIdsByEntityTypeQueryVariables = Exact<{
  entityType: Scalars['String']['input'];
}>;


export type GetCustomFieldIdsByEntityTypeQuery = { __typename?: 'query_root', customFields: Array<{ __typename?: 'custom_fields', id: string }> };

export type GetCustomFieldsForEntityMinimalQueryVariables = Exact<{
  entityType: Scalars['String']['input'];
}>;


export type GetCustomFieldsForEntityMinimalQuery = { __typename?: 'query_root', customFields: Array<{ __typename?: 'custom_fields', id: string, title: string }> };

export type GetAllBankAccountCustomFieldsIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllBankAccountCustomFieldsIdsQuery = { __typename?: 'query_root', bankAccountCustomFields: Array<{ __typename?: 'custom_fields', id: string }> };

export type GetAllLineItemCustomFieldsIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLineItemCustomFieldsIdsQuery = { __typename?: 'query_root', lineItemCustomFields: Array<{ __typename?: 'custom_fields', id: string }> };

export type GetAllOrganisationCoreDataDependenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOrganisationCoreDataDependenciesQuery = { __typename?: 'query_root', organisationCoreDataDependencies: Array<{ __typename?: 'organisation_core_data_dependencies', id: string, coreDataType: OverrideTypes["KebabCoreDataType"], dependencyCoreDataType: OverrideTypes["KebabDependencyType"], customCoreData: { __typename?: 'custom_core_data', id: string, name: string } | null, dependencyCustomCoreData: { __typename?: 'custom_core_data', id: string, name: string } | null }> };

export type GetFormTemplateConfigByIdQueryVariables = Exact<{
  formTemplateId: Scalars['uuid']['input'];
}>;


export type GetFormTemplateConfigByIdQuery = { __typename?: 'query_root', formTemplate: { __typename?: 'form_templates', id: string, type: FormTypeEnum, config: OverrideTypes["FormConfig"], title: string } | null };

export type GetOrganisationDefaultCurrencyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationDefaultCurrencyQuery = { __typename?: 'query_root', organisationSettings: Array<{ __typename?: 'organisation_settings', value: any }> };

export type GetRequestFormConfigByIdQueryVariables = Exact<{
  requestFormId: Scalars['uuid']['input'];
}>;


export type GetRequestFormConfigByIdQuery = { __typename?: 'query_root', requestForm: { __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], requestId: string } | null };

export type GetOpenRequestsFormsWithFormTemplateQueryVariables = Exact<{
  formTemplateId: Scalars['uuid']['input'];
}>;


export type GetOpenRequestsFormsWithFormTemplateQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'requests', id: string, completedAt: string | null, deletedAt: string | null, request_forms: Array<{ __typename?: 'request_forms', formTemplateId: string | null, id: string, request_step_tasks: Array<{ __typename?: 'request_step_tasks', completedOn: string | null, type: RequestStepTaskTypeEnum }>, form_template: { __typename?: 'form_templates', config: OverrideTypes["FormConfig"], title: string } | null }> }> };

export type GetWorkflowsUsingFormQueryVariables = Exact<{
  formTemplateId: Scalars['uuid']['input'];
  workflowWhere: InputMaybe<WorkflowsBoolExp>;
}>;


export type GetWorkflowsUsingFormQuery = { __typename?: 'query_root', workflow_form_templates: Array<{ __typename?: 'workflow_form_templates', id: string, workflow: { __typename?: 'workflows', id: string, state: WorkflowStateEnum, title: string, type: WorkflowTypeEnum, isArchived: boolean, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"] } }> };

export type GetWorkflowsUsingFormWithModelsQueryVariables = Exact<{
  formTemplateId: Scalars['uuid']['input'];
  workflowWhere: InputMaybe<WorkflowsBoolExp>;
}>;


export type GetWorkflowsUsingFormWithModelsQuery = { __typename?: 'query_root', workflow_form_templates: Array<{ __typename?: 'workflow_form_templates', id: string, workflow: { __typename?: 'workflows', id: string, state: WorkflowStateEnum, title: string, type: WorkflowTypeEnum, isArchived: boolean, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"], viewModel: any | null, viewModelUpdatedAt: string | null, canvasModelUpdatedAt: string } }> };

export type FormTemplateFragment = { __typename?: 'form_templates', id: string, title: string, description: string, type: FormTypeEnum, state: FormTemplateStateEnum, config: OverrideTypes["FormConfig"], internalId: string | null, integration: OverrideTypes["Integration"] | null, externalTitle: string | null, organisationId: string, createdAt: string, updatedAt: string, createdBy: string | null, updatedBy: string | null, deletedAt: string | null, created_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null };

export type CreateFormTemplateMutationVariables = Exact<{
  formTemplate: FormTemplatesInsertInput;
}>;


export type CreateFormTemplateMutation = { __typename?: 'mutation_root', insert_form_templates_one: { __typename?: 'form_templates', id: string, title: string, description: string, type: FormTypeEnum, state: FormTemplateStateEnum, config: OverrideTypes["FormConfig"], internalId: string | null, integration: OverrideTypes["Integration"] | null, externalTitle: string | null, organisationId: string, createdAt: string, updatedAt: string, createdBy: string | null, updatedBy: string | null, deletedAt: string | null, created_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null } | null };

export type GetFormTemplatesToDownloadCsvQueryVariables = Exact<{
  formTemplateIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetFormTemplatesToDownloadCsvQuery = { __typename?: 'query_root', form_templates: Array<{ __typename?: 'form_templates', config: OverrideTypes["FormConfig"], title: string }> };

export type GetFormTemplateQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetFormTemplateQuery = { __typename?: 'query_root', form_templates_by_pk: { __typename?: 'form_templates', id: string, title: string, description: string, type: FormTypeEnum, state: FormTemplateStateEnum, config: OverrideTypes["FormConfig"], internalId: string | null, integration: OverrideTypes["Integration"] | null, externalTitle: string | null, organisationId: string, createdAt: string, updatedAt: string, createdBy: string | null, updatedBy: string | null, deletedAt: string | null, created_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null } | null };

export type GetFormTemplatesWithFiltersQueryVariables = Exact<{
  where: InputMaybe<FormTemplatesBoolExp>;
}>;


export type GetFormTemplatesWithFiltersQuery = { __typename?: 'query_root', form_templates: Array<{ __typename?: 'form_templates', id: string, title: string, description: string, type: FormTypeEnum, state: FormTemplateStateEnum, config: OverrideTypes["FormConfig"], internalId: string | null, integration: OverrideTypes["Integration"] | null, externalTitle: string | null, organisationId: string, createdAt: string, updatedAt: string, createdBy: string | null, updatedBy: string | null, deletedAt: string | null, created_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null }> };

export type UpdateFormTemplateAndUnpublishWorkflowsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  formTemplateUpdate: FormTemplatesSetInput;
  workflowIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpdateFormTemplateAndUnpublishWorkflowsMutation = { __typename?: 'mutation_root', update_form_templates_by_pk: { __typename?: 'form_templates', id: string, title: string, description: string, type: FormTypeEnum, state: FormTemplateStateEnum, config: OverrideTypes["FormConfig"], internalId: string | null, integration: OverrideTypes["Integration"] | null, externalTitle: string | null, organisationId: string, createdAt: string, updatedAt: string, createdBy: string | null, updatedBy: string | null, deletedAt: string | null, created_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null } | null, update_workflows: { __typename?: 'workflows_mutation_response', returning: Array<{ __typename?: 'workflows', id: string, title: string, organisation: { __typename?: 'organisations', id: string, name: string } | null }> } | null };

export type UpdateRequestFormConfigMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  update: RequestFormsSetInput;
}>;


export type UpdateRequestFormConfigMutation = { __typename?: 'mutation_root', update_request_forms_by_pk: { __typename?: 'request_forms', id: string } | null };

export type UploadFormTemplateMutationVariables = Exact<{
  form: FormTemplatesInsertInput;
}>;


export type UploadFormTemplateMutation = { __typename?: 'mutation_root', insert_form_templates_one: { __typename?: 'form_templates', id: string } | null };

export type DeleteDraftIntakeSubmissionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type DeleteDraftIntakeSubmissionMutation = { __typename?: 'mutation_root', update_draft_intake_submissions: { __typename?: 'draft_intake_submissions_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'draft_intake_submissions', id: string, name: string, workflow: { __typename?: 'workflows', id: string, title: string }, formTemplate: { __typename?: 'form_templates', id: string } }> } | null };

export type GetDraftIntakeSubmissionQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type GetDraftIntakeSubmissionQuery = { __typename?: 'query_root', draft_intake_submissions: Array<{ __typename?: 'draft_intake_submissions', id: string, name: string, userId: string, response: OverrideTypes["FormResponsePayload"] | null, updatedAt: string, workflow: { __typename?: 'workflows', id: string, state: WorkflowStateEnum, deletedAt: string | null, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"] }, formTemplate: { __typename?: 'form_templates', id: string, state: FormTemplateStateEnum, deletedAt: string | null } }> };

export type InsertDraftIntakeSubmissionMutationVariables = Exact<{
  input: DraftIntakeSubmissionsInsertInput;
}>;


export type InsertDraftIntakeSubmissionMutation = { __typename?: 'mutation_root', insert_draft_intake_submissions_one: { __typename?: 'draft_intake_submissions', id: string, updatedAt: string, workflow: { __typename?: 'workflows', title: string } } | null };

export type ListDraftIntakeSubmissionsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type ListDraftIntakeSubmissionsQuery = { __typename?: 'query_root', draft_intake_submissions: Array<{ __typename?: 'draft_intake_submissions', id: string, name: string, updatedAt: string, workflow: { __typename?: 'workflows', id: string, title: string, state: WorkflowStateEnum, deletedAt: string | null, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"] }, formTemplate: { __typename?: 'form_templates', id: string, state: FormTemplateStateEnum, deletedAt: string | null } }> };

export type GetFormTemplateForIntakePrefillQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetFormTemplateForIntakePrefillQuery = { __typename?: 'query_root', formTemplate: { __typename?: 'form_templates', config: OverrideTypes["FormConfig"], id: string, state: FormTemplateStateEnum, type: FormTypeEnum } | null };

export type GetProductCatalogueEntryDataQueryVariables = Exact<{
  productCatalogueEntryId: Scalars['uuid']['input'];
}>;


export type GetProductCatalogueEntryDataQuery = { __typename?: 'query_root', product_catalogue_entries_by_pk: { __typename?: 'product_catalogue_entries', id: string, product_catalogue_access_approvers: Array<{ __typename?: 'product_catalogue_access_approvers', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, group: { __typename?: 'groups', id: string, name: string } | null }>, organisation_products_and_services_brand: { __typename?: 'organisation_products_and_services_brands', id: string, name: string, organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string, publicId: number, state: OrganisationSupplierStateEnum, remoteLink: string | null, isPreferred: boolean, website: string | null, description: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null } }>, products_and_service: { __typename?: 'products_and_services', id: string, name: string, description: string | null, website: string | null, supplier: { __typename?: 'suppliers', id: string, name: string, description: string | null, website: string | null } | null } | null } } | null };

export type RetrieveRequestorPrefillDataQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type RetrieveRequestorPrefillDataQuery = { __typename?: 'query_root', users_by_pk: { __typename?: 'users', managerUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isArchived: boolean } | null, department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, userAllowedSubsidiaries: Array<{ __typename?: 'user_allowed_subsidiaries', subsidiaryId: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string } }> } | null };

export type GetGlobalProductsBySupplierIdsQueryVariables = Exact<{
  supplierIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetGlobalProductsBySupplierIdsQuery = { __typename?: 'query_root', products_and_services: Array<{ __typename?: 'products_and_services', id: string, name: string, supplier: { __typename?: 'suppliers', id: string, name: string } | null }> };

export type GetGlobalSuppliersByNameQueryVariables = Exact<{
  supplierNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetGlobalSuppliersByNameQuery = { __typename?: 'query_root', suppliers: Array<{ __typename?: 'suppliers', id: string, name: string }> };

export type GetMatchingGlobalProductsQueryVariables = Exact<{
  where: ProductsAndServicesBoolExp;
}>;


export type GetMatchingGlobalProductsQuery = { __typename?: 'query_root', products_and_services: Array<{ __typename?: 'products_and_services', id: string, name: string, logoUrl: string | null, website: string | null, description: string | null, supplier: { __typename?: 'suppliers', id: string, name: string } | null }> };

export type GetMatchingGlobalSuppliersQueryVariables = Exact<{
  where: SuppliersBoolExp;
}>;


export type GetMatchingGlobalSuppliersQuery = { __typename?: 'query_root', suppliers: Array<{ __typename?: 'suppliers', id: string, name: string, logoUrl: string | null, website: string | null }> };

export type GetOrganisationSuppliersByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetOrganisationSuppliersByIdsQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, embedding: string | null }> };

export type ListOrganisationSuppliersAndProductsQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type ListOrganisationSuppliersAndProductsQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, organisationSupplierBrandId: string | null }>, organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, name: string, organisationProductsAndServicesBrandId: string | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string, organisation_supplier_brand: { __typename?: 'organisation_suppliers_brands', id: string, name: string } | null } }> };

export type GetAccessRequestWorkflowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccessRequestWorkflowsQuery = { __typename?: 'query_root', workflows: Array<{ __typename?: 'workflows', id: string, title: string }> };

export type GetMatchingOrgSupplierBrandsQueryVariables = Exact<{
  where: OrganisationSuppliersBrandsBoolExp;
}>;


export type GetMatchingOrgSupplierBrandsQuery = { __typename?: 'query_root', organisation_suppliers_brands: Array<{ __typename?: 'organisation_suppliers_brands', id: string, name: string, logoUrl: string | null, website: string | null }> };

export type GetProductBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductBrandsQuery = { __typename?: 'query_root', organisation_products_and_services_brands: Array<{ __typename?: 'organisation_products_and_services_brands', id: string }> };

export type GetSubCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubCategoriesQuery = { __typename?: 'query_root', categories: Array<{ __typename?: 'organisation_product_supplier_categories', id: string, parentId: string | null, isTerminal: boolean | null, name: string }> };

export type InsertMultipleFeatureFlagsMutationVariables = Exact<{
  featureFlags: Array<OrganisationFeatureFlagsInsertInput> | OrganisationFeatureFlagsInsertInput;
}>;


export type InsertMultipleFeatureFlagsMutation = { __typename?: 'mutation_root', featureFlag: { __typename?: 'organisation_feature_flags_mutation_response', returning: Array<{ __typename?: 'organisation_feature_flags', featureFlag: FeatureFlagsEnum }> } | null };

export type GetOrganisationExternalDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationExternalDomainsQuery = { __typename?: 'query_root', organisations: Array<{ __typename?: 'organisations', externalDomains: Array<string> | null }> };

export type UpdateExternalDomainsMutationVariables = Exact<{
  organisationId: Scalars['uuid']['input'];
  externalDomains: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateExternalDomainsMutation = { __typename?: 'mutation_root', update_organisations_by_pk: { __typename?: 'organisations', id: string } | null };

export type GetOrganisationConnectionSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationConnectionSettingsQuery = { __typename?: 'query_root', organisations: Array<{ __typename?: 'organisations', id: string, hasSsoEnabled: boolean | null, hasDirectorySyncEnabled: boolean | null, externalDomains: Array<string> | null }> };

export type GetOrganisationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationSettingsQuery = { __typename?: 'query_root', organisation_settings: Array<{ __typename?: 'organisation_settings', name: string, value: any }> };

export type OrganisationDetailQueryQueryVariables = Exact<{
  organisationId: Scalars['uuid']['input'];
}>;


export type OrganisationDetailQueryQuery = { __typename?: 'query_root', organisations_by_pk: { __typename?: 'organisations', id: string, name: string, isQa: boolean } | null };

export type UpsertOrganisationSettingMutationVariables = Exact<{
  settingName: Scalars['String']['input'];
  value: Scalars['jsonb']['input'];
}>;


export type UpsertOrganisationSettingMutation = { __typename?: 'mutation_root', insert_organisation_settings_one: { __typename?: 'organisation_settings', value: any } | null };

export type DeleteOrganisationProductBrandMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteOrganisationProductBrandMutation = { __typename?: 'mutation_root', deletedProductBrand: { __typename?: 'organisation_products_and_services_brands', id: string } | null };

export type DeleteProductCatalogueAccessApproversMutationVariables = Exact<{
  userIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  groupIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  productCatalogueEntryId: Scalars['uuid']['input'];
}>;


export type DeleteProductCatalogueAccessApproversMutation = { __typename?: 'mutation_root', delete_product_catalogue_access_approvers: { __typename?: 'product_catalogue_access_approvers_mutation_response', returning: Array<{ __typename?: 'product_catalogue_access_approvers', id: string }> } | null };

export type GetAllOrgSupplierBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOrgSupplierBrandsQuery = { __typename?: 'query_root', organisation_suppliers_brands: Array<{ __typename?: 'organisation_suppliers_brands', id: string, name: string, description: string | null, logoUrl: string | null, supplierId: string | null, website: string | null }> };

export type GetGlobalSupplierByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetGlobalSupplierByNameQuery = { __typename?: 'query_root', suppliers: Array<{ __typename?: 'suppliers', id: string, name: string, logoUrl: string | null, description: string | null }> };

export type GetOrganisationProductBrandQueryVariables = Exact<{
  orgProductsAndServicesBrandId: Scalars['uuid']['input'];
}>;


export type GetOrganisationProductBrandQuery = { __typename?: 'query_root', organisation_products_and_services_brands_by_pk: { __typename?: 'organisation_products_and_services_brands', id: string, description: string | null, logoUrl: string | null, website: string | null, product_catalogue_entry: { __typename?: 'product_catalogue_entries', id: string } | null, products_and_service: { __typename?: 'products_and_services', id: string, description: string | null, logoUrl: string | null, website: string | null } | null } | null };

export type GetOrganisationProductsForBrandsQueryVariables = Exact<{
  productsAndServicesBrandIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetOrganisationProductsForBrandsQuery = { __typename?: 'query_root', organisation_products_and_services_brands: Array<{ __typename?: 'organisation_products_and_services_brands', organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string }> }> };

export type GetProductCatalogueEntryAccessApproversQueryVariables = Exact<{
  productCatalogueEntryId: Scalars['uuid']['input'];
}>;


export type GetProductCatalogueEntryAccessApproversQuery = { __typename?: 'query_root', product_catalogue_access_approvers: Array<{ __typename?: 'product_catalogue_access_approvers', id: string, userId: string | null, groupId: string | null }> };

export type ListOrganisationSupplierBrandsQueryVariables = Exact<{
  search: InputMaybe<Scalars['String']['input']>;
}>;


export type ListOrganisationSupplierBrandsQuery = { __typename?: 'query_root', organisation_suppliers_brands: Array<{ __typename?: 'organisation_suppliers_brands', id: string, name: string, description: string | null, logoUrl: string | null, supplierId: string | null }> };

export type ListProductBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListProductBrandsQuery = { __typename?: 'query_root', organisation_products_and_services_brands: Array<{ __typename?: 'organisation_products_and_services_brands', description: string | null, productAndServiceId: string | null, id: string, logoUrl: string | null, name: string, categories: Array<{ __typename?: 'organisation_products_and_services_categories', id: string, organisation_product_supplier_category: { __typename?: 'organisation_product_supplier_categories', id: string, value: string, parentId: string | null, isTerminal: boolean | null } }>, organisation_suppliers_brand: { __typename?: 'organisation_suppliers_brands', id: string, logoUrl: string | null, name: string }, product_catalogue_entry: { __typename?: 'product_catalogue_entries', id: string, accessType: string, accessUrl: string | null, showInCatalogue: boolean, accessInstructions: string | null, externalEmail: string | null, workflow: { __typename?: 'workflows', id: string, title: string } | null, product_catalogue_access_approvers: Array<{ __typename?: 'product_catalogue_access_approvers', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, group: { __typename?: 'groups', id: string, name: string } | null }> } | null, organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string }> }> };

export type ListProductsAndServicesQueryVariables = Exact<{
  search: InputMaybe<Scalars['String']['input']>;
}>;


export type ListProductsAndServicesQuery = { __typename?: 'query_root', products_and_services: Array<{ __typename?: 'products_and_services', id: string, name: string, logoUrl: string | null, description: string | null, products_and_services_categories: Array<{ __typename?: 'products_and_services_categories', category: { __typename?: 'categories', id: string, name: string, parentId: string | null, pathLevel: number } }>, organisation_products_and_services_brands: Array<{ __typename?: 'organisation_products_and_services_brands', id: string }>, supplier: { __typename?: 'suppliers', id: string, name: string, logoUrl: string | null, organisation_suppliers_brands: Array<{ __typename?: 'organisation_suppliers_brands', id: string }> } | null }> };

export type UpdateOrgProductsAndServicesBrandMutationVariables = Exact<{
  input: InputMaybe<OrganisationProductsAndServicesBrandsSetInput>;
  orgProductsAndServicesBrandId: Scalars['uuid']['input'];
}>;


export type UpdateOrgProductsAndServicesBrandMutation = { __typename?: 'mutation_root', update_organisation_products_and_services_brands_by_pk: { __typename?: 'organisation_products_and_services_brands', id: string, name: string, description: string | null, logoUrl: string | null, website: string | null } | null };

export type UpdateProductCatalogueEntryMutationVariables = Exact<{
  productCatalogueEntryId: Scalars['uuid']['input'];
  input?: InputMaybe<ProductCatalogueEntriesSetInput>;
}>;


export type UpdateProductCatalogueEntryMutation = { __typename?: 'mutation_root', update_product_catalogue_entries_by_pk: { __typename?: 'product_catalogue_entries', id: string, accessUrl: string | null, accessType: string, showInCatalogue: boolean, accessWorkflowId: string | null, accessInstructions: string | null, externalEmail: string | null, product_catalogue_access_approvers: Array<{ __typename?: 'product_catalogue_access_approvers', userId: string | null }> } | null };

export type DeleteOrganisationProductsAndServicesCategoriesMutationVariables = Exact<{
  organisationProductsAndServicesBrandId: Scalars['uuid']['input'];
  categoryIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteOrganisationProductsAndServicesCategoriesMutation = { __typename?: 'mutation_root', delete_organisation_products_and_services_categories: { __typename?: 'organisation_products_and_services_categories_mutation_response', affected_rows: number } | null };

export type GetProductBrandCategoriesQueryVariables = Exact<{
  organisationProductsAndServicesBrandId: Scalars['uuid']['input'];
}>;


export type GetProductBrandCategoriesQuery = { __typename?: 'query_root', organisation_products_and_services_categories: Array<{ __typename?: 'organisation_products_and_services_categories', productSupplierCategoryId: string }> };

export type InsertOrganisationProductsAndServicesCategoriesMutationVariables = Exact<{
  objects?: InputMaybe<Array<OrganisationProductsAndServicesCategoriesInsertInput> | OrganisationProductsAndServicesCategoriesInsertInput>;
}>;


export type InsertOrganisationProductsAndServicesCategoriesMutation = { __typename?: 'mutation_root', insert_organisation_products_and_services_categories: { __typename?: 'organisation_products_and_services_categories_mutation_response', returning: Array<{ __typename?: 'organisation_products_and_services_categories', id: string }> } | null };

export type GetProductAndServiceCategoriesQueryVariables = Exact<{
  productAndServiceId: Scalars['uuid']['input'];
}>;


export type GetProductAndServiceCategoriesQuery = { __typename?: 'query_root', products_and_services_by_pk: { __typename?: 'products_and_services', products_and_services_categories: Array<{ __typename?: 'products_and_services_categories', id: string, category: { __typename?: 'categories', id: string } }> } | null };

export type GetProductBrandDetailsQueryVariables = Exact<{
  orgProductsAndServicesBrandId: Scalars['uuid']['input'];
}>;


export type GetProductBrandDetailsQuery = { __typename?: 'query_root', organisation_products_and_services_brands_by_pk: { __typename?: 'organisation_products_and_services_brands', productAndServiceId: string | null, product_catalogue_entry: { __typename?: 'product_catalogue_entries', id: string } | null } | null };

export type GetSupplierByIdQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
}>;


export type GetSupplierByIdQuery = { __typename?: 'query_root', suppliers_by_pk: { __typename?: 'suppliers', id: string, name: string, logoUrl: string | null, website: string | null } | null };

export type InsertOrganisationProductsAndServicesBrandMutationVariables = Exact<{
  input: OrganisationProductsAndServicesBrandsInsertInput;
}>;


export type InsertOrganisationProductsAndServicesBrandMutation = { __typename?: 'mutation_root', insert_organisation_products_and_services_brands_one: { __typename?: 'organisation_products_and_services_brands', id: string, products_and_service: { __typename?: 'products_and_services', products_and_services_categories: Array<{ __typename?: 'products_and_services_categories', category: { __typename?: 'categories', id: string, name: string } }> } | null } | null };

export type InsertOrganisationSupplierBrandMutationVariables = Exact<{
  object?: InputMaybe<OrganisationSuppliersBrandsInsertInput>;
}>;


export type InsertOrganisationSupplierBrandMutation = { __typename?: 'mutation_root', insert_organisation_suppliers_brands_one: { __typename?: 'organisation_suppliers_brands', id: string } | null };

export type InsertProductCatalogueAccessApproversMutationVariables = Exact<{
  input: Array<ProductCatalogueAccessApproversInsertInput> | ProductCatalogueAccessApproversInsertInput;
}>;


export type InsertProductCatalogueAccessApproversMutation = { __typename?: 'mutation_root', insert_product_catalogue_access_approvers: { __typename?: 'product_catalogue_access_approvers_mutation_response', returning: Array<{ __typename?: 'product_catalogue_access_approvers', id: string }> } | null };

export type InsertProductCatalogueEntryMutationVariables = Exact<{
  input?: InputMaybe<ProductCatalogueEntriesInsertInput>;
}>;


export type InsertProductCatalogueEntryMutation = { __typename?: 'mutation_root', insert_product_catalogue_entries_one: { __typename?: 'product_catalogue_entries', id: string, accessUrl: string | null, accessType: string, showInCatalogue: boolean, accessWorkflowId: string | null, accessInstructions: string | null, externalEmail: string | null, product_catalogue_access_approvers: Array<{ __typename?: 'product_catalogue_access_approvers', userId: string | null }> } | null };

export type ListProductCatalogueEntriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListProductCatalogueEntriesQuery = { __typename?: 'query_root', product_catalogue_entries: Array<{ __typename?: 'product_catalogue_entries', id: string, accessType: string, accessUrl: string | null, showInCatalogue: boolean, accessInstructions: string | null, externalEmail: string | null, product_catalogue_access_approvers: Array<{ __typename?: 'product_catalogue_access_approvers', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null }>, organisation_products_and_services_brand: { __typename?: 'organisation_products_and_services_brands', logoUrl: string | null, name: string, description: string | null, id: string, organisation_suppliers_brand: { __typename?: 'organisation_suppliers_brands', id: string, logoUrl: string | null, name: string } } }> };

export type GetOrgSupplierWithNameQueryVariables = Exact<{
  supplierName: Scalars['String']['input'];
}>;


export type GetOrgSupplierWithNameQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, organisationSupplierBrandId: string | null }> };

export type BatchUpdateOrganisationProductsAndServicesMutationVariables = Exact<{
  updates: Array<OrganisationProductsAndServicesUpdates> | OrganisationProductsAndServicesUpdates;
}>;


export type BatchUpdateOrganisationProductsAndServicesMutation = { __typename?: 'mutation_root', update_organisation_products_and_services_many: Array<{ __typename?: 'organisation_products_and_services_mutation_response', affected_rows: number } | null> | null };

export type CategoryNameWithParentFragment = { __typename?: 'categories', name: string, parent: { __typename?: 'categories', name: string } | null };

export type GetOrganisationProductsForFunctionalDescriptionAndEmbeddingQueryVariables = Exact<{
  productIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetOrganisationProductsForFunctionalDescriptionAndEmbeddingQuery = { __typename?: 'query_root', organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, name: string, description: string | null, website: string | null, functionalDescription: string | null, organisation_supplier: { __typename?: 'organisation_suppliers', name: string }, brand: { __typename?: 'organisation_products_and_services_brands', name: string, description: string | null, website: string | null, globalProduct: { __typename?: 'products_and_services', name: string, description: string | null, website: string | null, functionalDescription: string | null, categories: Array<{ __typename?: 'products_and_services_categories', category: { __typename?: 'categories', name: string, parent: { __typename?: 'categories', name: string } | null } }> } | null, categories: Array<{ __typename?: 'organisation_products_and_services_categories', category: { __typename?: 'organisation_product_supplier_categories', name: string, parent: { __typename?: 'organisation_product_supplier_categories', name: string } | null } }>, organisation_suppliers_brand: { __typename?: 'organisation_suppliers_brands', name: string } } | null }> };

export type GetAllOrgProductsOfSupplierByProductIdQueryVariables = Exact<{
  productId: Scalars['uuid']['input'];
}>;


export type GetAllOrgProductsOfSupplierByProductIdQuery = { __typename?: 'query_root', organisation_products_and_services_by_pk: { __typename?: 'organisation_products_and_services', id: string, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, name: string }> } } | null };

export type GetGlobalProductsAndServicesByOrganisationSupplierIdQueryVariables = Exact<{
  organisationSupplierId: Scalars['uuid']['input'];
}>;


export type GetGlobalProductsAndServicesByOrganisationSupplierIdQuery = { __typename?: 'query_root', organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', id: string, organisation_supplier_brand: { __typename?: 'organisation_suppliers_brands', id: string, supplier: { __typename?: 'suppliers', id: string, products_and_services: Array<{ __typename?: 'products_and_services', id: string, name: string, logoUrl: string | null }> } | null } | null } | null };

export type GetOrganisationProductByNameAndOrganisationSupplierIdQueryVariables = Exact<{
  organisationSupplierId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
}>;


export type GetOrganisationProductByNameAndOrganisationSupplierIdQuery = { __typename?: 'query_root', organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string }> };

export type GetOrganisationSupplierByIdQueryVariables = Exact<{
  organisationSupplierId: Scalars['uuid']['input'];
}>;


export type GetOrganisationSupplierByIdQuery = { __typename?: 'query_root', organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', id: string, name: string, description: string | null, organisationSupplierBrandId: string | null } | null };

export type GetProductAchievabilityQueryVariables = Exact<{
  productId: Scalars['uuid']['input'];
}>;


export type GetProductAchievabilityQuery = { __typename?: 'query_root', organisation_products_and_services_by_pk: { __typename?: 'organisation_products_and_services', scheduledRenewals: Array<{ __typename?: 'renewals', id: string }>, scheduledAssessments: Array<{ __typename?: 'assessments', id: string }>, organisation_products_and_services_requests: Array<{ __typename?: 'requests', id: string }> } | null };

export type GetProductAndServiceByIdQueryVariables = Exact<{
  productsAndServicesId: Scalars['uuid']['input'];
}>;


export type GetProductAndServiceByIdQuery = { __typename?: 'query_root', products_and_services_by_pk: { __typename?: 'products_and_services', id: string, name: string, displayName: string, logoUrl: string | null, website: string | null, description: string | null, organisation_products_and_services_brands: Array<{ __typename?: 'organisation_products_and_services_brands', id: string }>, supplier: { __typename?: 'suppliers', id: string, name: string, description: string | null, logoUrl: string | null, website: string | null, organisation_suppliers_brands: Array<{ __typename?: 'organisation_suppliers_brands', id: string }> } | null } | null };

export type GetProductByIdQueryVariables = Exact<{
  productId: Scalars['uuid']['input'];
}>;


export type GetProductByIdQuery = { __typename?: 'query_root', product: { __typename?: 'organisation_products_and_services', id: string, name: string, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null } | null };

export type GetProductEngagementsQueryVariables = Exact<{
  organisationProductId: Scalars['uuid']['input'];
}>;


export type GetProductEngagementsQuery = { __typename?: 'query_root', engagements: Array<{ __typename?: 'engagements', id: string, name: string, departmentId: string | null, note: string | null, financial: { __typename?: 'financials', id: string, amount: number | null, currency: string | null, renewalDate: any | null, contractEnd: any | null, contractPeriodEnd: any | null, autoRenewal: boolean | null, cancellationNoticeDays: number | null } | null }> };

export type ListProductFragmentFragment = { __typename?: 'organisation_products_and_services', id: string, name: string, displayName: string, website: string | null, logoUrl: string | null, createdAt: string | null, updatedAt: string | null, description: string | null, isArchived: boolean, state: OrganisationProductsAndServicesStateEnum, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, engagements: Array<{ __typename?: 'engagements', id: string, name: string, department: string | null }>, earliestActiveRenewal: Array<{ __typename?: 'renewals', id: string, renewalDate: string, cancellationNoticeDayCount: number | null, requestId: string | null, sourceAgreementTerm: { __typename?: 'agreement_terms', id: string, agreement: { __typename?: 'agreements', id: string, name: string } } | null }> };

export type ListProductsQueryVariables = Exact<{
  where: OrganisationProductsAndServicesBoolExp;
}>;


export type ListProductsQuery = { __typename?: 'query_root', products: Array<{ __typename?: 'organisation_products_and_services', id: string, name: string, displayName: string, website: string | null, logoUrl: string | null, createdAt: string | null, updatedAt: string | null, description: string | null, isArchived: boolean, state: OrganisationProductsAndServicesStateEnum, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, engagements: Array<{ __typename?: 'engagements', id: string, name: string, department: string | null }>, earliestActiveRenewal: Array<{ __typename?: 'renewals', id: string, renewalDate: string, cancellationNoticeDayCount: number | null, requestId: string | null, sourceAgreementTerm: { __typename?: 'agreement_terms', id: string, agreement: { __typename?: 'agreements', id: string, name: string } } | null }> }>, aggregate: { __typename?: 'organisation_products_and_services_aggregate', aggregate: { __typename?: 'organisation_products_and_services_aggregate_fields', count: number } | null } };

export type CreateProductsMutationVariables = Exact<{
  objects: Array<OrganisationProductsAndServicesInsertInput> | OrganisationProductsAndServicesInsertInput;
}>;


export type CreateProductsMutation = { __typename?: 'mutation_root', insert_organisation_products_and_services: { __typename?: 'organisation_products_and_services_mutation_response', returning: Array<{ __typename?: 'organisation_products_and_services', id: string, name: string }> } | null };

export type InsertOrganisationProductsAndServiceMutationVariables = Exact<{
  input: OrganisationProductsAndServicesInsertInput;
}>;


export type InsertOrganisationProductsAndServiceMutation = { __typename?: 'mutation_root', insert_organisation_products_and_services_one: { __typename?: 'organisation_products_and_services', id: string, name: string, displayName: string, website: string | null, logoUrl: string | null, createdAt: string | null, updatedAt: string | null, description: string | null, isArchived: boolean, state: OrganisationProductsAndServicesStateEnum, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, organisation_supplier: { __typename?: 'organisation_suppliers', state: OrganisationSupplierStateEnum, id: string, website: string | null, logoUrl: string | null, name: string, externalLink: string | null, organisation_supplier_brand: { __typename?: 'organisation_suppliers_brands', id: string, supplierId: string | null } | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, isPrimary: boolean, phoneNumber: string | null, title: string | null }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> }, engagements: Array<{ __typename?: 'engagements', id: string, name: string, department: string | null }> } | null };

export type OrganisationProductsAndServiceFragmentFragment = { __typename?: 'organisation_products_and_services', id: string, name: string, displayName: string, website: string | null, logoUrl: string | null, createdAt: string | null, updatedAt: string | null, description: string | null, isArchived: boolean, state: OrganisationProductsAndServicesStateEnum, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, organisation_supplier: { __typename?: 'organisation_suppliers', state: OrganisationSupplierStateEnum, id: string, website: string | null, logoUrl: string | null, name: string, externalLink: string | null, organisation_supplier_brand: { __typename?: 'organisation_suppliers_brands', id: string, supplierId: string | null } | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, isPrimary: boolean, phoneNumber: string | null, title: string | null }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> }, engagements: Array<{ __typename?: 'engagements', id: string, name: string, department: string | null }> };

export type UpdateOrganisationProductsAndServiceMutationVariables = Exact<{
  set: OrganisationProductsAndServicesSetInput;
  id: Scalars['uuid']['input'];
}>;


export type UpdateOrganisationProductsAndServiceMutation = { __typename?: 'mutation_root', update_organisation_products_and_services_by_pk: { __typename?: 'organisation_products_and_services', id: string, name: string, displayName: string, website: string | null, logoUrl: string | null, createdAt: string | null, updatedAt: string | null, description: string | null, isArchived: boolean, state: OrganisationProductsAndServicesStateEnum, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, organisation_supplier: { __typename?: 'organisation_suppliers', state: OrganisationSupplierStateEnum, id: string, website: string | null, logoUrl: string | null, name: string, externalLink: string | null, organisation_supplier_brand: { __typename?: 'organisation_suppliers_brands', id: string, supplierId: string | null } | null, external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, isPrimary: boolean, phoneNumber: string | null, title: string | null }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> }, engagements: Array<{ __typename?: 'engagements', id: string, name: string, department: string | null }> } | null };

export type GetProductNamesQueryVariables = Exact<{
  productIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetProductNamesQuery = { __typename?: 'query_root', globalProducts: Array<{ __typename?: 'products_and_services', id: string, name: string }>, organisationProducts: Array<{ __typename?: 'organisation_products_and_services', id: string, name: string }> };

export type DeletePublicApiApplicationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePublicApiApplicationMutation = { __typename?: 'mutation_root', update_organisation_integrations_by_pk: { __typename?: 'organisation_integrations', id: string } | null };

export type UnlinkPublicApiApplicationDataMutationVariables = Exact<{
  appId: Scalars['uuid']['input'];
}>;


export type UnlinkPublicApiApplicationDataMutation = { __typename?: 'mutation_root', suppliers: { __typename?: 'organisation_suppliers_mutation_response', returning: Array<{ __typename?: 'organisation_suppliers', id: string }> } | null, customFields: { __typename?: 'custom_fields_mutation_response', returning: Array<{ __typename?: 'custom_fields', id: string }> } | null, customCoreData: { __typename?: 'custom_core_data_mutation_response', returning: Array<{ __typename?: 'custom_core_data', id: string }> } | null, coreData: { __typename?: 'core_data_organisation_integrations_mutation_response', returning: Array<{ __typename?: 'core_data_organisation_integrations', id: string }> } | null };

export type BatchRestorePublicApiClientsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type BatchRestorePublicApiClientsMutation = { __typename?: 'mutation_root', update_organisation_public_api_clients: { __typename?: 'organisation_public_api_clients_mutation_response', returning: Array<{ __typename?: 'organisation_public_api_clients', id: string, name: string, userPoolId: string, userPoolClientId: string, organisationIntegrationId: string, createdAt: string, updatedAt: string }> } | null };

export type CreatePublicApiClientMutationVariables = Exact<{
  input: OrganisationPublicApiClientsInsertInput;
}>;


export type CreatePublicApiClientMutation = { __typename?: 'mutation_root', insert_organisation_public_api_clients_one: { __typename?: 'organisation_public_api_clients', id: string, name: string, userPoolId: string, userPoolClientId: string, organisationIntegrationId: string, createdAt: string, updatedAt: string } | null };

export type DeletePublicApiClientMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePublicApiClientMutation = { __typename?: 'mutation_root', update_organisation_public_api_clients_by_pk: { __typename?: 'organisation_public_api_clients', id: string, userPoolClientId: string } | null };

export type DeletePublicApiClientsForOrgIntegrationIdMutationVariables = Exact<{
  integrationId: Scalars['uuid']['input'];
}>;


export type DeletePublicApiClientsForOrgIntegrationIdMutation = { __typename?: 'mutation_root', update_organisation_public_api_clients: { __typename?: 'organisation_public_api_clients_mutation_response', returning: Array<{ __typename?: 'organisation_public_api_clients', id: string, name: string, userPoolId: string, userPoolClientId: string, organisationIntegrationId: string, createdAt: string, updatedAt: string }> } | null };

export type GetPublicApiClientsQueryVariables = Exact<{
  query: InputMaybe<OrganisationPublicApiClientsBoolExp>;
}>;


export type GetPublicApiClientsQuery = { __typename?: 'query_root', organisation_public_api_clients: Array<{ __typename?: 'organisation_public_api_clients', id: string, name: string, userPoolId: string, userPoolClientId: string, organisationIntegrationId: string, createdAt: string, updatedAt: string }> };

export type OrganisationPublicApiClientFragment = { __typename?: 'organisation_public_api_clients', id: string, name: string, userPoolId: string, userPoolClientId: string, organisationIntegrationId: string, createdAt: string, updatedAt: string };

export type RestorePublicApiClientMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RestorePublicApiClientMutation = { __typename?: 'mutation_root', update_organisation_public_api_clients_by_pk: { __typename?: 'organisation_public_api_clients', id: string } | null };

export type UpdateOrganisationIntegrationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: OrganisationIntegrationsSetInput;
}>;


export type UpdateOrganisationIntegrationMutation = { __typename?: 'mutation_root', update_organisation_integrations_by_pk: { __typename?: 'organisation_integrations', id: string } | null };

export type UpdatePublicApiClientMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: OrganisationPublicApiClientsSetInput;
}>;


export type UpdatePublicApiClientMutation = { __typename?: 'mutation_root', update_organisation_public_api_clients_by_pk: { __typename?: 'organisation_public_api_clients', id: string, name: string, userPoolId: string, userPoolClientId: string, organisationIntegrationId: string, createdAt: string, updatedAt: string } | null };

export type StoreAddressFragment = { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, county: string | null, state: string | null, postalCode: string | null, country: string | null, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } };

export type BatchCreateAddressesMutationVariables = Exact<{
  objects: Array<AddressesInsertInput> | AddressesInsertInput;
}>;


export type BatchCreateAddressesMutation = { __typename?: 'mutation_root', insert_addresses: { __typename?: 'addresses_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, county: string | null, state: string | null, postalCode: string | null, country: string | null, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> } | null };

export type GetAddressesForPublicApiQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy: Array<AddressesOrderBy> | AddressesOrderBy;
  where: InputMaybe<AddressesBoolExp>;
}>;


export type GetAddressesForPublicApiQuery = { __typename?: 'query_root', addresses: Array<{ __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, county: string | null, state: string | null, postalCode: string | null, country: string | null, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> };

export type UpdateAddressForPublicApiMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: AddressesSetInput;
}>;


export type UpdateAddressForPublicApiMutation = { __typename?: 'mutation_root', update_addresses_by_pk: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, county: string | null, state: string | null, postalCode: string | null, country: string | null, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } } | null };

export type StoreCurrencyFragment = { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } };

export type BatchCreateCurrenciesMutationVariables = Exact<{
  objects: Array<OrganisationFxRatesInsertInput> | OrganisationFxRatesInsertInput;
}>;


export type BatchCreateCurrenciesMutation = { __typename?: 'mutation_root', insert_organisation_fx_rates: { __typename?: 'organisation_fx_rates_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> } | null };

export type GetCurrenciesForPublicApiQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy: Array<OrganisationFxRatesOrderBy> | OrganisationFxRatesOrderBy;
  where: InputMaybe<OrganisationFxRatesBoolExp>;
}>;


export type GetCurrenciesForPublicApiQuery = { __typename?: 'query_root', organisation_fx_rates: Array<{ __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> };

export type UpdateCurrencyForPublicApiMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: OrganisationFxRatesSetInput;
}>;


export type UpdateCurrencyForPublicApiMutation = { __typename?: 'mutation_root', update_organisation_fx_rates_by_pk: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } } | null };

export type StoreCustomDataFragment = { __typename?: 'custom_core_data', id: string, name: string, slug: string, createdAt: string, updatedAt: string, archivedAt: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, name: string | null, integration: OverrideTypes["GlobalIntegration"] } | null };

export type GetCustomDataForPublicApiQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy: Array<CustomCoreDataOrderBy> | CustomCoreDataOrderBy;
  where: InputMaybe<CustomCoreDataBoolExp>;
}>;


export type GetCustomDataForPublicApiQuery = { __typename?: 'query_root', custom_core_data: Array<{ __typename?: 'custom_core_data', id: string, name: string, slug: string, createdAt: string, updatedAt: string, archivedAt: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, name: string | null, integration: OverrideTypes["GlobalIntegration"] } | null }> };

export type UpdateCustomDataForPublicApiMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: CustomCoreDataSetInput;
}>;


export type UpdateCustomDataForPublicApiMutation = { __typename?: 'mutation_root', update_custom_core_data_by_pk: { __typename?: 'custom_core_data', id: string, name: string, slug: string, createdAt: string, updatedAt: string, archivedAt: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, name: string | null, integration: OverrideTypes["GlobalIntegration"] } | null } | null };

export type StoreCustomDataRecordFragment = { __typename?: 'custom_core_data_options', id: string, value: string, remoteId: string | null, updatedAt: string, createdAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, custom_core_data: { __typename?: 'custom_core_data', slug: string, pathLevels: Array<string> | null }, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } };

export type GetCustomDataRecordsForPublicApiQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy: Array<CustomCoreDataOptionsOrderBy> | CustomCoreDataOptionsOrderBy;
  where: InputMaybe<CustomCoreDataOptionsBoolExp>;
}>;


export type GetCustomDataRecordsForPublicApiQuery = { __typename?: 'query_root', custom_core_data_options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, remoteId: string | null, updatedAt: string, createdAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, custom_core_data: { __typename?: 'custom_core_data', slug: string, pathLevels: Array<string> | null }, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> };

export type BatchCreateCustomDataRecordsMutationVariables = Exact<{
  objects: Array<CustomCoreDataOptionsInsertInput> | CustomCoreDataOptionsInsertInput;
}>;


export type BatchCreateCustomDataRecordsMutation = { __typename?: 'mutation_root', insert_custom_core_data_options: { __typename?: 'custom_core_data_options_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'custom_core_data_options', id: string, value: string, remoteId: string | null, updatedAt: string, createdAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, custom_core_data: { __typename?: 'custom_core_data', slug: string, pathLevels: Array<string> | null }, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> } | null };

export type UpdateCustomDataRecordForPublicApiMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: CustomCoreDataOptionsSetInput;
}>;


export type UpdateCustomDataRecordForPublicApiMutation = { __typename?: 'mutation_root', update_custom_core_data_options_by_pk: { __typename?: 'custom_core_data_options', id: string, value: string, remoteId: string | null, updatedAt: string, createdAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, custom_core_data: { __typename?: 'custom_core_data', slug: string, pathLevels: Array<string> | null }, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } } | null };

export type StoreDepartmentFragment = { __typename?: 'departments', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } };

export type BatchCreateDepartmentsMutationVariables = Exact<{
  objects: Array<DepartmentsInsertInput> | DepartmentsInsertInput;
}>;


export type BatchCreateDepartmentsMutation = { __typename?: 'mutation_root', insert_departments: { __typename?: 'departments_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'departments', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> } | null };

export type GetDepartmentsForPublicApiQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy: Array<DepartmentsOrderBy> | DepartmentsOrderBy;
  where: InputMaybe<DepartmentsBoolExp>;
}>;


export type GetDepartmentsForPublicApiQuery = { __typename?: 'query_root', departments: Array<{ __typename?: 'departments', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> };

export type UpdateDepartmentForPublicApiMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: DepartmentsSetInput;
}>;


export type UpdateDepartmentForPublicApiMutation = { __typename?: 'mutation_root', update_departments_by_pk: { __typename?: 'departments', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } } | null };

export type InsertOnConflictCoreDataDependenciesMutationVariables = Exact<{
  dependenciesToInsert: Array<CoreDataDependenciesInsertInput> | CoreDataDependenciesInsertInput;
}>;


export type InsertOnConflictCoreDataDependenciesMutation = { __typename?: 'mutation_root', inserted: { __typename?: 'core_data_dependencies_mutation_response', returning: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, createdAt: string }> } | null };

export type DeleteNonMatchingCoreDataDependenciesMutationVariables = Exact<{
  coreDataIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  idsToKeep: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteNonMatchingCoreDataDependenciesMutation = { __typename?: 'mutation_root', deleted: { __typename?: 'core_data_dependencies_mutation_response', returning: Array<{ __typename?: 'core_data_dependencies', id: string }> } | null };

export type GetCoreDataIdsWithIdAndRemoteIdQueryVariables = Exact<{
  filter: CoreDataBoolExp;
}>;


export type GetCoreDataIdsWithIdAndRemoteIdQuery = { __typename?: 'query_root', coreData: Array<{ __typename?: 'core_data', id: string, subsidiary: { __typename?: 'subsidiaries', id: string, remoteId: string | null } | null, address: { __typename?: 'addresses', id: string, remoteId: string | null } | null, paymentTerm: { __typename?: 'payment_terms', id: string, remoteId: string | null } | null, paymentMethod: { __typename?: 'payment_methods', id: string, remoteId: string | null } | null, department: { __typename?: 'departments', id: string, remoteId: string | null } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, remoteId: string | null } | null, currency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null } | null, lineItemType: { __typename?: 'line_item_types', id: string, remoteId: string | null } | null }> };

export type GetCoreDataDependenciesPaginatedQueryVariables = Exact<{
  where: CoreDataDependenciesBoolExp;
  limit: Scalars['Int']['input'];
  orderBy: Array<CoreDataDependenciesOrderBy> | CoreDataDependenciesOrderBy;
}>;


export type GetCoreDataDependenciesPaginatedQuery = { __typename?: 'query_root', core_data_dependencies: Array<{ __typename?: 'core_data_dependencies', id: string, isAll: boolean | null, dependencyCoreDataType: string, createdAt: string, deletedAt: string | null, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, remoteId: string | null, custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null, subsidiary: { __typename?: 'subsidiaries', id: string, remoteId: string | null } | null, address: { __typename?: 'addresses', id: string, remoteId: string | null } | null, paymentTerm: { __typename?: 'payment_terms', id: string, remoteId: string | null } | null, paymentMethod: { __typename?: 'payment_methods', id: string, remoteId: string | null } | null, department: { __typename?: 'departments', id: string, remoteId: string | null } | null, currency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null } | null, lineItemType: { __typename?: 'line_item_types', id: string, remoteId: string | null } | null } | null }> };

export type GetOrganisationCoreDataDependenciesWithCustomCoreDataQueryVariables = Exact<{
  where: OrganisationCoreDataDependenciesBoolExp;
  limit: Scalars['Int']['input'];
}>;


export type GetOrganisationCoreDataDependenciesWithCustomCoreDataQuery = { __typename?: 'query_root', organisationCoreDataDependencies: Array<{ __typename?: 'organisation_core_data_dependencies', id: string, coreDataType: OverrideTypes["KebabCoreDataType"], dependencyCoreDataType: OverrideTypes["KebabDependencyType"], customCoreData: { __typename?: 'custom_core_data', id: string, slug: string } | null, dependencyCustomCoreData: { __typename?: 'custom_core_data', id: string, slug: string } | null }> };

export type DeleteCoreDataDependencyByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteCoreDataDependencyByIdMutation = { __typename?: 'mutation_root', update_core_data_dependencies_by_pk: { __typename?: 'core_data_dependencies', id: string, deletedAt: string | null } | null };

export type CoreDataDependenciesFragmentFragment = { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> };

export type StoreLineItemTypeFragment = { __typename?: 'line_item_types', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } };

export type BatchCreateLineItemTypesMutationVariables = Exact<{
  objects: Array<LineItemTypesInsertInput> | LineItemTypesInsertInput;
}>;


export type BatchCreateLineItemTypesMutation = { __typename?: 'mutation_root', insert_line_item_types: { __typename?: 'line_item_types_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'line_item_types', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> } | null };

export type GetLineItemTypesForPublicApiQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy: Array<LineItemTypesOrderBy> | LineItemTypesOrderBy;
  where: InputMaybe<LineItemTypesBoolExp>;
}>;


export type GetLineItemTypesForPublicApiQuery = { __typename?: 'query_root', line_item_types: Array<{ __typename?: 'line_item_types', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> };

export type UpdateLineItemTypeForPublicApiMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: LineItemTypesSetInput;
}>;


export type UpdateLineItemTypeForPublicApiMutation = { __typename?: 'mutation_root', update_line_item_types_by_pk: { __typename?: 'line_item_types', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } } | null };

export type StorePaymentMethodFragment = { __typename?: 'payment_methods', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } };

export type BatchCreatePaymentMethodsMutationVariables = Exact<{
  objects: Array<PaymentMethodsInsertInput> | PaymentMethodsInsertInput;
}>;


export type BatchCreatePaymentMethodsMutation = { __typename?: 'mutation_root', insert_payment_methods: { __typename?: 'payment_methods_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'payment_methods', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> } | null };

export type GetPaymentMethodsForPublicApiQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy: Array<PaymentMethodsOrderBy> | PaymentMethodsOrderBy;
  where: InputMaybe<PaymentMethodsBoolExp>;
}>;


export type GetPaymentMethodsForPublicApiQuery = { __typename?: 'query_root', payment_methods: Array<{ __typename?: 'payment_methods', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> };

export type UpdatePaymentMethodForPublicApiMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: PaymentMethodsSetInput;
}>;


export type UpdatePaymentMethodForPublicApiMutation = { __typename?: 'mutation_root', update_payment_methods_by_pk: { __typename?: 'payment_methods', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } } | null };

export type StorePaymentTermFragment = { __typename?: 'payment_terms', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } };

export type BatchCreatePaymentTermsMutationVariables = Exact<{
  objects: Array<PaymentTermsInsertInput> | PaymentTermsInsertInput;
}>;


export type BatchCreatePaymentTermsMutation = { __typename?: 'mutation_root', insert_payment_terms: { __typename?: 'payment_terms_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'payment_terms', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> } | null };

export type GetPaymentTermsForPublicApiQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy: Array<PaymentTermsOrderBy> | PaymentTermsOrderBy;
  where: InputMaybe<PaymentTermsBoolExp>;
}>;


export type GetPaymentTermsForPublicApiQuery = { __typename?: 'query_root', payment_terms: Array<{ __typename?: 'payment_terms', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> };

export type UpdatePaymentTermForPublicApiMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: PaymentTermsSetInput;
}>;


export type UpdatePaymentTermForPublicApiMutation = { __typename?: 'mutation_root', update_payment_terms_by_pk: { __typename?: 'payment_terms', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } } | null };

export type StorePurchaseOrderLineItemFragment = { __typename?: 'purchase_order_line_items', lineNumber: number, quantity: number | null, unitPrice: number | null, amount: number | null, lineItemCurrency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> };

export type StorePurchaseOrderFragment = { __typename?: 'purchase_orders', id: string, remoteId: string | null, remoteNumber: string | null, remoteStatus: string | null, remoteLink: string | null, remoteTotalValue: number | null, remoteInvoicedValue: number, remotePaidValue: number, totalValue: number, contractStartDate: string | null, contractEndDate: string | null, organisationIntegrationId: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, request: { __typename?: 'requests', id: string, publicId: string, name: string }, requestor: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } | null, supplier: { __typename?: 'organisation_suppliers', id: string, remoteId: string | null, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, remoteId: string | null, name: string } | null, department: { __typename?: 'departments', id: string, remoteId: string | null, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, remoteId: string | null, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, remoteId: string | null, name: string } | null, currency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, lineItems: Array<{ __typename?: 'purchase_order_line_items', lineNumber: number, quantity: number | null, unitPrice: number | null, amount: number | null, lineItemCurrency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> }> };

export type GetPurchaseOrdersForPublicApiQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy: Array<PurchaseOrdersOrderBy> | PurchaseOrdersOrderBy;
  where: InputMaybe<PurchaseOrdersBoolExp>;
}>;


export type GetPurchaseOrdersForPublicApiQuery = { __typename?: 'query_root', purchaseOrders: Array<{ __typename?: 'purchase_orders', id: string, remoteId: string | null, remoteNumber: string | null, remoteStatus: string | null, remoteLink: string | null, remoteTotalValue: number | null, remoteInvoicedValue: number, remotePaidValue: number, totalValue: number, contractStartDate: string | null, contractEndDate: string | null, organisationIntegrationId: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, request: { __typename?: 'requests', id: string, publicId: string, name: string }, requestor: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } | null, supplier: { __typename?: 'organisation_suppliers', id: string, remoteId: string | null, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, remoteId: string | null, name: string } | null, department: { __typename?: 'departments', id: string, remoteId: string | null, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, remoteId: string | null, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, remoteId: string | null, name: string } | null, currency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, lineItems: Array<{ __typename?: 'purchase_order_line_items', lineNumber: number, quantity: number | null, unitPrice: number | null, amount: number | null, lineItemCurrency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> }> }>, headerCustomFields: Array<{ __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, remoteId: string | null, key: string, title: string, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }> }>, lineItemCustomFields: Array<{ __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, remoteId: string | null, key: string, title: string, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }> }> };

export type UpdatePurchaseOrderForPublicApiMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  updates: PurchaseOrdersSetInput;
}>;


export type UpdatePurchaseOrderForPublicApiMutation = { __typename?: 'mutation_root', purchaseOrder: { __typename?: 'purchase_orders', id: string, remoteId: string | null, remoteNumber: string | null, remoteStatus: string | null, remoteLink: string | null, remoteTotalValue: number | null, remoteInvoicedValue: number, remotePaidValue: number, totalValue: number, contractStartDate: string | null, contractEndDate: string | null, organisationIntegrationId: string | null, createdAt: string, updatedAt: string, deletedAt: string | null, request: { __typename?: 'requests', id: string, publicId: string, name: string }, requestor: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } | null, supplier: { __typename?: 'organisation_suppliers', id: string, remoteId: string | null, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, remoteId: string | null, name: string } | null, department: { __typename?: 'departments', id: string, remoteId: string | null, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, remoteId: string | null, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, remoteId: string | null, name: string } | null, currency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, lineItems: Array<{ __typename?: 'purchase_order_line_items', lineNumber: number, quantity: number | null, unitPrice: number | null, amount: number | null, lineItemCurrency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> }> } | null };

export type AssignPurchaseOrderOwnershipForPublicApiMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  integrationId: Scalars['uuid']['input'];
}>;


export type AssignPurchaseOrderOwnershipForPublicApiMutation = { __typename?: 'mutation_root', update_purchase_orders: { __typename?: 'purchase_orders_mutation_response', affected_rows: number } | null };

export type SoftDeletePurchaseOrderForPublicApiMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SoftDeletePurchaseOrderForPublicApiMutation = { __typename?: 'mutation_root', update_purchase_orders_by_pk: { __typename?: 'purchase_orders', id: string } | null };

export type StoreSubsidiaryFragment = { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } };

export type BatchCreateSubsidiariesMutationVariables = Exact<{
  objects: Array<SubsidiariesInsertInput> | SubsidiariesInsertInput;
}>;


export type BatchCreateSubsidiariesMutation = { __typename?: 'mutation_root', insert_subsidiaries: { __typename?: 'subsidiaries_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> } | null };

export type GetSubsidiariesForPublicApiQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy: Array<SubsidiariesOrderBy> | SubsidiariesOrderBy;
  where: InputMaybe<SubsidiariesBoolExp>;
}>;


export type GetSubsidiariesForPublicApiQuery = { __typename?: 'query_root', subsidiaries: Array<{ __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } }> };

export type UpdateSubsidiaryForPublicApiMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: SubsidiariesSetInput;
}>;


export type UpdateSubsidiaryForPublicApiMutation = { __typename?: 'mutation_root', update_subsidiaries_by_pk: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null, createdAt: string, updatedAt: string, isArchived: boolean, archivedBy: string | null, coreDataId: string, coreData: { __typename?: 'core_data', coreDataDependencies_aggregate: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null }, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', isAll: boolean | null, dependencyCoreDataType: string, dependencyCoreData: { __typename?: 'core_data', customCoreDataOption: { __typename?: 'custom_core_data_options', custom_core_data: { __typename?: 'custom_core_data', slug: string } } | null } | null }> } } | null };

export type GetActiveUsersForUpdateByIdQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetActiveUsersForUpdateByIdQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, email: string, firstName: string, lastName: string, role: string, createdAt: string, updatedAt: string, department: { __typename?: 'departments', id: string, name: string, remoteId: string | null } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null } | null, managerUser: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, userAllowedSubsidiaries: Array<{ __typename?: 'user_allowed_subsidiaries', subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null } }> }>, userAttributeCustomFields: Array<{ __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, remoteId: string | null, key: string, title: string, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }> }> };

export type GetActiveUsersForUpdateByEmailQueryVariables = Exact<{
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetActiveUsersForUpdateByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, email: string, firstName: string, lastName: string, role: string, createdAt: string, updatedAt: string, department: { __typename?: 'departments', id: string, name: string, remoteId: string | null } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null } | null, managerUser: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, userAllowedSubsidiaries: Array<{ __typename?: 'user_allowed_subsidiaries', subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null } }> }>, userAttributeCustomFields: Array<{ __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, remoteId: string | null, key: string, title: string, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }> }> };

export type PublicApiUserFragment = { __typename?: 'users', id: string, email: string, firstName: string, lastName: string, role: string, createdAt: string, updatedAt: string, department: { __typename?: 'departments', id: string, name: string, remoteId: string | null } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null } | null, managerUser: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, userAllowedSubsidiaries: Array<{ __typename?: 'user_allowed_subsidiaries', subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null } }> };

export type GetUsersForPublicApiQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy: Array<UsersOrderBy> | UsersOrderBy;
  where: InputMaybe<UsersBoolExp>;
}>;


export type GetUsersForPublicApiQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, email: string, firstName: string, lastName: string, role: string, createdAt: string, updatedAt: string, department: { __typename?: 'departments', id: string, name: string, remoteId: string | null } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null } | null, managerUser: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, userAllowedSubsidiaries: Array<{ __typename?: 'user_allowed_subsidiaries', subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null } }> }>, userAttributeCustomFields: Array<{ __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, remoteId: string | null, key: string, title: string, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }> }> };

export type GetCoreDataOrganisationIntegrationsForPublicApiQueryVariables = Exact<{
  organisationIntegrationId: Scalars['uuid']['input'];
  coreDataType: Scalars['String']['input'];
}>;


export type GetCoreDataOrganisationIntegrationsForPublicApiQuery = { __typename?: 'query_root', core_data_organisation_integrations: Array<{ __typename?: 'core_data_organisation_integrations', id: string, organisationIntegrationId: string, coreDataType: string }> };

export type GetCoreDataOrganisationIntegrationsByTypeForPublicApiQueryVariables = Exact<{
  coreDataType: Scalars['String']['input'];
}>;


export type GetCoreDataOrganisationIntegrationsByTypeForPublicApiQuery = { __typename?: 'query_root', core_data_organisation_integrations: Array<{ __typename?: 'core_data_organisation_integrations', id: string, organisationIntegrationId: string, coreDataType: string }> };

export type InsertCoreDataOrganisationIntegrationForPublicApiMutationVariables = Exact<{
  organisationIntegrationId: Scalars['uuid']['input'];
  coreDataType: Scalars['String']['input'];
}>;


export type InsertCoreDataOrganisationIntegrationForPublicApiMutation = { __typename?: 'mutation_root', insert_core_data_organisation_integrations_one: { __typename?: 'core_data_organisation_integrations', id: string, organisationIntegrationId: string, coreDataType: string } | null };

export type GetPurchaseOrderQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPurchaseOrderQuery = { __typename?: 'query_root', purchase_orders: Array<{ __typename?: 'purchase_orders', id: string, remoteNumber: string | null, remoteLink: string | null, requestId: string, createdAt: string, updatedAt: string, deletedAt: string | null, organisationIntegrationId: string | null }> };

export type UpdatePurchaseOrderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: PurchaseOrdersSetInput;
}>;


export type UpdatePurchaseOrderMutation = { __typename?: 'mutation_root', update_purchase_orders_by_pk: { __typename?: 'purchase_orders', id: string, requestId: string, remoteNumber: string | null, remoteLink: string | null, organisationIntegrationId: string | null } | null };

export type CreateOrganisationSuppliersMutationVariables = Exact<{
  objects: Array<OrganisationSuppliersInsertInput> | OrganisationSuppliersInsertInput;
}>;


export type CreateOrganisationSuppliersMutation = { __typename?: 'mutation_root', insert_organisation_suppliers: { __typename?: 'organisation_suppliers_mutation_response', returning: Array<{ __typename?: 'organisation_suppliers', id: string, name: string }> } | null };

export type CreateTagsMutationVariables = Exact<{
  objects: Array<TagsInsertInput> | TagsInsertInput;
}>;


export type CreateTagsMutation = { __typename?: 'mutation_root', insert_tags: { __typename?: 'tags_mutation_response', returning: Array<{ __typename?: 'tags', id: string, name: string }> } | null };

export type DeleteRenewalMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteRenewalMutation = { __typename?: 'mutation_root', renewal: { __typename?: 'renewals', id: string } | null };

export type DeleteRenewalAdditionalUsersMutationVariables = Exact<{
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  renewalId: Scalars['uuid']['input'];
}>;


export type DeleteRenewalAdditionalUsersMutation = { __typename?: 'mutation_root', deletedRenewalAdditionalUsers: { __typename?: 'renewal_additional_users_mutation_response', returning: Array<{ __typename?: 'renewal_additional_users', renewalId: string, userId: string }> } | null };

export type DeleteRenewalTagsByIdMutationVariables = Exact<{
  renewalTagIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteRenewalTagsByIdMutation = { __typename?: 'mutation_root', deletedRenewalTags: { __typename?: 'renewal_tags_mutation_response', returning: Array<{ __typename?: 'renewal_tags', id: string }> } | null };

export type DeleteRenewalTagsByRenewalIdMutationVariables = Exact<{
  renewalId: Scalars['uuid']['input'];
}>;


export type DeleteRenewalTagsByRenewalIdMutation = { __typename?: 'mutation_root', deletedRenewalTags: { __typename?: 'renewal_tags_mutation_response', returning: Array<{ __typename?: 'renewal_tags', id: string }> } | null };

export type GetAdminUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, firstName: string, lastName: string, hasConfigPermissions: boolean }> };

export type GetMatchingOrgProductsQueryVariables = Exact<{
  productName: Scalars['String']['input'];
  organisationSupplierId: Scalars['uuid']['input'];
}>;


export type GetMatchingOrgProductsQuery = { __typename?: 'query_root', organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, name: string, displayName: string, organisationSupplierId: string }> };

export type GetMatchingSupplierQueryVariables = Exact<{
  remoteId: Scalars['String']['input'];
  supplierName: Scalars['String']['input'];
}>;


export type GetMatchingSupplierQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, remoteId: string | null }> };

export type GetMatchingSupplierByNameQueryVariables = Exact<{
  supplierName: Scalars['String']['input'];
}>;


export type GetMatchingSupplierByNameQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, remoteId: string | null }> };

export type GetNonSupplierOrgUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNonSupplierOrgUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, email: string, firstName: string, lastName: string, role: string, isArchived: boolean }> };

export type GetOrgActiveWorkflowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgActiveWorkflowsQuery = { __typename?: 'query_root', workflows: Array<{ __typename?: 'workflows', title: string, id: string, type: WorkflowTypeEnum }> };

export type GetOrgDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgDepartmentsQuery = { __typename?: 'query_root', departments: Array<{ __typename?: 'departments', id: string, name: string }> };

export type GetOrgWorkflowsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgWorkflowsQuery = { __typename?: 'query_root', workflows: Array<{ __typename?: 'workflows', title: string, id: string, type: WorkflowTypeEnum }> };

export type GetOrganisationQueryVariables = Exact<{
  organisationId: Scalars['uuid']['input'];
}>;


export type GetOrganisationQuery = { __typename?: 'query_root', organisation: { __typename?: 'organisations', id: string, name: string } | null };

export type GetRenewalAdditionalUsersQueryVariables = Exact<{
  renewalId: Scalars['uuid']['input'];
}>;


export type GetRenewalAdditionalUsersQuery = { __typename?: 'query_root', renewalAdditionalUsers: Array<{ __typename?: 'renewal_additional_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }> };

export type GetRenewalTagsQueryVariables = Exact<{
  renewalId: Scalars['uuid']['input'];
}>;


export type GetRenewalTagsQuery = { __typename?: 'query_root', renewalTags: Array<{ __typename?: 'renewal_tags', id: string, tag: { __typename?: 'tags', id: string } }> };

export type RenewalFragment = { __typename?: 'renewals', id: string, cancellationNoticeDayCount: number | null, costCurrency: OverrideTypes["CurrencyCode"], costValue: number, note: string | null, renewalDate: string, autoStartEnabled: boolean, deletedAt: string | null, sourceRequestId: string | null, workflowStartDayCount: number, cancelledAt: string | null, renewedAt: string | null, createdAt: string, department: { __typename?: 'departments', id: string, name: string } | null, sourceRequest: { __typename?: 'requests', id: string, name: string, publicId: string } | null, renewalAdditionalUsers: Array<{ __typename?: 'renewal_additional_users', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isArchived: boolean } }>, request: { __typename?: 'requests', id: string, completedAt: string | null, updatedAt: string, state: string | null, model: OverrideTypes["RequestModel"], tagIds: any | null, publicId: string, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }>, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null } | null, steps: Array<{ __typename?: 'request_steps', id: string, canvasModelId: string, state: RequestStepStateEnum, input: any, createdAt: string, completedAt: string | null, totalPausedWorkingHours: number, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, isArchived: boolean } }> }>, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }>, inProgressStepContext: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, nodeId: string, name: any, type: any, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, isArchived: boolean } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string, groupUsers: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }>, supplier: { __typename?: 'organisation_suppliers', id: string, state: OrganisationSupplierStateEnum, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum } | null, request_pauses: Array<{ __typename?: 'request_pauses', start: string, end: string | null }> } | null, workflow: { __typename?: 'workflows', id: string, title: string } | null, workflowInitialAssignee: { __typename?: 'users', id: string, firstName: string, lastName: string, isArchived: boolean } | null, product: { __typename?: 'organisation_products_and_services', id: string, logoUrl: string | null, name: string } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, remoteId: string | null }, renewalTags: Array<{ __typename?: 'renewal_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, sourceAgreementTerm: { __typename?: 'agreement_terms', id: string, agreement: { __typename?: 'agreements', id: string, name: string, ownerId: string | null, additionalOwners: Array<{ __typename?: 'agreement_additional_owners', userId: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }>, tags: Array<{ __typename?: 'agreement_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }> } } | null };

export type GetRenewalByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRenewalByIdQuery = { __typename?: 'query_root', renewal: { __typename?: 'renewals', id: string, cancellationNoticeDayCount: number | null, costCurrency: OverrideTypes["CurrencyCode"], costValue: number, note: string | null, renewalDate: string, autoStartEnabled: boolean, deletedAt: string | null, sourceRequestId: string | null, workflowStartDayCount: number, cancelledAt: string | null, renewedAt: string | null, createdAt: string, department: { __typename?: 'departments', id: string, name: string } | null, sourceRequest: { __typename?: 'requests', id: string, name: string, publicId: string } | null, renewalAdditionalUsers: Array<{ __typename?: 'renewal_additional_users', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isArchived: boolean } }>, request: { __typename?: 'requests', id: string, completedAt: string | null, updatedAt: string, state: string | null, model: OverrideTypes["RequestModel"], tagIds: any | null, publicId: string, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }>, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null } | null, steps: Array<{ __typename?: 'request_steps', id: string, canvasModelId: string, state: RequestStepStateEnum, input: any, createdAt: string, completedAt: string | null, totalPausedWorkingHours: number, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, isArchived: boolean } }> }>, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }>, inProgressStepContext: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, nodeId: string, name: any, type: any, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, isArchived: boolean } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string, groupUsers: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }>, supplier: { __typename?: 'organisation_suppliers', id: string, state: OrganisationSupplierStateEnum, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum } | null, request_pauses: Array<{ __typename?: 'request_pauses', start: string, end: string | null }> } | null, workflow: { __typename?: 'workflows', id: string, title: string } | null, workflowInitialAssignee: { __typename?: 'users', id: string, firstName: string, lastName: string, isArchived: boolean } | null, product: { __typename?: 'organisation_products_and_services', id: string, logoUrl: string | null, name: string } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, remoteId: string | null }, renewalTags: Array<{ __typename?: 'renewal_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, sourceAgreementTerm: { __typename?: 'agreement_terms', id: string, agreement: { __typename?: 'agreements', id: string, name: string, ownerId: string | null, additionalOwners: Array<{ __typename?: 'agreement_additional_owners', userId: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }>, tags: Array<{ __typename?: 'agreement_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }> } } | null } | null };

export type ListRenewalsForAdminUserQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type ListRenewalsForAdminUserQuery = { __typename?: 'query_root', renewals: Array<{ __typename?: 'renewals', id: string, cancellationNoticeDayCount: number | null, costCurrency: OverrideTypes["CurrencyCode"], costValue: number, note: string | null, renewalDate: string, autoStartEnabled: boolean, deletedAt: string | null, sourceRequestId: string | null, workflowStartDayCount: number, cancelledAt: string | null, renewedAt: string | null, createdAt: string, department: { __typename?: 'departments', id: string, name: string } | null, sourceRequest: { __typename?: 'requests', id: string, name: string, publicId: string } | null, renewalAdditionalUsers: Array<{ __typename?: 'renewal_additional_users', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isArchived: boolean } }>, request: { __typename?: 'requests', id: string, completedAt: string | null, updatedAt: string, state: string | null, model: OverrideTypes["RequestModel"], tagIds: any | null, publicId: string, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }>, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null } | null, steps: Array<{ __typename?: 'request_steps', id: string, canvasModelId: string, state: RequestStepStateEnum, input: any, createdAt: string, completedAt: string | null, totalPausedWorkingHours: number, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, isArchived: boolean } }> }>, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }>, inProgressStepContext: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, nodeId: string, name: any, type: any, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, isArchived: boolean } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string, groupUsers: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }>, supplier: { __typename?: 'organisation_suppliers', id: string, state: OrganisationSupplierStateEnum, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum } | null, request_pauses: Array<{ __typename?: 'request_pauses', start: string, end: string | null }> } | null, workflow: { __typename?: 'workflows', id: string, title: string } | null, workflowInitialAssignee: { __typename?: 'users', id: string, firstName: string, lastName: string, isArchived: boolean } | null, product: { __typename?: 'organisation_products_and_services', id: string, logoUrl: string | null, name: string } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, remoteId: string | null }, renewalTags: Array<{ __typename?: 'renewal_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, sourceAgreementTerm: { __typename?: 'agreement_terms', id: string, agreement: { __typename?: 'agreements', id: string, name: string, ownerId: string | null, additionalOwners: Array<{ __typename?: 'agreement_additional_owners', userId: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }>, tags: Array<{ __typename?: 'agreement_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }> } } | null }>, renewals_aggregate: { __typename?: 'renewals_aggregate', aggregate: { __typename?: 'renewals_aggregate_fields', count: number } | null } };

export type GetAdminRenewalsForStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminRenewalsForStatsQuery = { __typename?: 'query_root', renewals: Array<{ __typename?: 'renewals', id: string, renewalDate: string, workflowStartDayCount: number, cancellationNoticeDayCount: number | null }> };

export type GetUserRenewalsForStatsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserRenewalsForStatsQuery = { __typename?: 'query_root', renewals: Array<{ __typename?: 'renewals', id: string, renewalDate: string, workflowStartDayCount: number, cancellationNoticeDayCount: number | null }> };

export type ListRenewalsForUserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type ListRenewalsForUserQuery = { __typename?: 'query_root', renewals: Array<{ __typename?: 'renewals', id: string, cancellationNoticeDayCount: number | null, costCurrency: OverrideTypes["CurrencyCode"], costValue: number, note: string | null, renewalDate: string, autoStartEnabled: boolean, deletedAt: string | null, sourceRequestId: string | null, workflowStartDayCount: number, cancelledAt: string | null, renewedAt: string | null, createdAt: string, department: { __typename?: 'departments', id: string, name: string } | null, sourceRequest: { __typename?: 'requests', id: string, name: string, publicId: string } | null, renewalAdditionalUsers: Array<{ __typename?: 'renewal_additional_users', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isArchived: boolean } }>, request: { __typename?: 'requests', id: string, completedAt: string | null, updatedAt: string, state: string | null, model: OverrideTypes["RequestModel"], tagIds: any | null, publicId: string, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }>, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null } | null, steps: Array<{ __typename?: 'request_steps', id: string, canvasModelId: string, state: RequestStepStateEnum, input: any, createdAt: string, completedAt: string | null, totalPausedWorkingHours: number, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, isArchived: boolean } }> }>, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }>, inProgressStepContext: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, nodeId: string, name: any, type: any, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, isArchived: boolean } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string, groupUsers: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }>, supplier: { __typename?: 'organisation_suppliers', id: string, state: OrganisationSupplierStateEnum, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum } | null, request_pauses: Array<{ __typename?: 'request_pauses', start: string, end: string | null }> } | null, workflow: { __typename?: 'workflows', id: string, title: string } | null, workflowInitialAssignee: { __typename?: 'users', id: string, firstName: string, lastName: string, isArchived: boolean } | null, product: { __typename?: 'organisation_products_and_services', id: string, logoUrl: string | null, name: string } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, remoteId: string | null }, renewalTags: Array<{ __typename?: 'renewal_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, sourceAgreementTerm: { __typename?: 'agreement_terms', id: string, agreement: { __typename?: 'agreements', id: string, name: string, ownerId: string | null, additionalOwners: Array<{ __typename?: 'agreement_additional_owners', userId: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }>, tags: Array<{ __typename?: 'agreement_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }> } } | null }>, renewals_aggregate: { __typename?: 'renewals_aggregate', aggregate: { __typename?: 'renewals_aggregate_fields', count: number } | null } };

export type FindRenewalByAssigneeQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  renewalId: Scalars['uuid']['input'];
}>;


export type FindRenewalByAssigneeQuery = { __typename?: 'query_root', additionalAssigneeRenewals: Array<{ __typename?: 'renewals', id: string }>, initialAssigneeRenewals: Array<{ __typename?: 'renewals', id: string }> };

export type GetRenewalsMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRenewalsMinimalQuery = { __typename?: 'query_root', renewals: Array<{ __typename?: 'renewals', id: string, renewalDate: string, costValue: number, costCurrency: OverrideTypes["CurrencyCode"], product: { __typename?: 'organisation_products_and_services', id: string, name: string, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, remoteId: string | null } } | null }> };

export type GetSuppliersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSuppliersQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, remoteId: string | null, state: OrganisationSupplierStateEnum, organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, name: string }> }> };

export type InsertRenewalMutationVariables = Exact<{
  input: RenewalsInsertInput;
}>;


export type InsertRenewalMutation = { __typename?: 'mutation_root', renewal: { __typename?: 'renewals', id: string } | null };

export type InsertRenewalAdditionalUsersMutationVariables = Exact<{
  objects: Array<RenewalAdditionalUsersInsertInput> | RenewalAdditionalUsersInsertInput;
}>;


export type InsertRenewalAdditionalUsersMutation = { __typename?: 'mutation_root', renewalAdditionalUsers: { __typename?: 'renewal_additional_users_mutation_response', returning: Array<{ __typename?: 'renewal_additional_users', renewalId: string, userId: string }> } | null };

export type InsertRenewalTagsMutationVariables = Exact<{
  objects: Array<RenewalTagsInsertInput> | RenewalTagsInsertInput;
}>;


export type InsertRenewalTagsMutation = { __typename?: 'mutation_root', insertedRenewalTags: { __typename?: 'renewal_tags_mutation_response', returning: Array<{ __typename?: 'renewal_tags', id: string }> } | null };

export type InsertRenewalsMutationVariables = Exact<{
  objects?: InputMaybe<Array<RenewalsInsertInput> | RenewalsInsertInput>;
}>;


export type InsertRenewalsMutation = { __typename?: 'mutation_root', insert_renewals: { __typename?: 'renewals_mutation_response', returning: Array<{ __typename?: 'renewals', id: string, renewalDate: string, workflowStartDayCount: number, autoStartEnabled: boolean, cancellationNoticeDayCount: number | null }> } | null };

export type UpdateRenewalMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: RenewalsSetInput;
}>;


export type UpdateRenewalMutation = { __typename?: 'mutation_root', renewal: { __typename?: 'renewals', id: string, workflowInitialAssigneeId: string | null } | null };

export type UpdateRenewalsMutationVariables = Exact<{
  updates: Array<RenewalsUpdates> | RenewalsUpdates;
}>;


export type UpdateRenewalsMutation = { __typename?: 'mutation_root', update_renewals_many: Array<{ __typename?: 'renewals_mutation_response', returning: Array<{ __typename?: 'renewals', id: string, workflowInitialAssigneeId: string | null, renewalDate: string, workflowStartDayCount: number, autoStartEnabled: boolean, cancellationNoticeDayCount: number | null }> } | null> | null };

export type CreateCustomReportMutationVariables = Exact<{
  customReport: CustomReportsInsertInput;
}>;


export type CreateCustomReportMutation = { __typename?: 'mutation_root', customReport: { __typename?: 'custom_reports', id: string } | null };

export type CreateReportGenerationMutationVariables = Exact<{
  generation: CustomReportsGenerationsInsertInput;
}>;


export type CreateReportGenerationMutation = { __typename?: 'mutation_root', generation: { __typename?: 'custom_reports_generations', id: string } | null };

export type DeleteCustomReportMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type DeleteCustomReportMutation = { __typename?: 'mutation_root', update_custom_reports: { __typename?: 'custom_reports_mutation_response', affected_rows: number } | null };

export type GetActiveWorkflowFormTemplatesQueryVariables = Exact<{
  organisationId: Scalars['uuid']['input'];
}>;


export type GetActiveWorkflowFormTemplatesQuery = { __typename?: 'query_root', workflow_form_templates: Array<{ __typename?: 'workflow_form_templates', formTemplate: { __typename?: 'form_templates', id: string, title: string, config: OverrideTypes["FormConfig"] }, workflow: { __typename?: 'workflows', id: string, title: string } }> };

export type GetAllRequestFormResponsesQueryVariables = Exact<{
  requestsFilter: InputMaybe<RequestsBoolExp>;
  formsFilter: InputMaybe<RequestFormsBoolExp>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllRequestFormResponsesQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'requests', id: string, name: string, publicId: string, createdAt: string, completedAt: string | null, state: string | null, priority: RequestPriorityEnum, model: OverrideTypes["RequestModel"], tagIds: any | null, type: RequestTypeEnum, poNumber: string | null, budget: { __typename?: 'budgets', id: string, name: string } | null, product: { __typename?: 'organisation_products_and_services', id: string, displayName: string, state: OrganisationProductsAndServicesStateEnum } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, state: OrganisationSupplierStateEnum, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> } | null, owner: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null, valueNumber: number | null, cancelByDate: string | null, annualValueNumber: number | null, type: string | null, note: string | null, inBudget: boolean | null, renewalDate: string | null, cancellationNoticeDays: number | null, isAutoRenewal: boolean | null, contractStartDate: string | null, contractEndDate: string | null, renewal: boolean | null, category: { __typename?: 'custom_core_data_options', id: string, value: string } | null, market: { __typename?: 'custom_core_data_options', id: string, value: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, buyerLegalEntity: { __typename?: 'subsidiaries', id: string, legalName: string | null, name: string } | null, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string } | null } | null, steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, result: RequestStepResultEnum | null, canvasModelId: string, createdAt: string, completedAt: string | null, totalPausedWorkingHours: number, input: any }>, engagement: { __typename?: 'engagements', id: string, purchaseOrderNumber: string | null } | null, purchase_orders: Array<{ __typename?: 'purchase_orders', id: string, remoteNumber: string | null }>, workflow: { __typename?: 'workflows', id: string, title: string, workflow_condition_groups: Array<{ __typename?: 'workflow_condition_groups', id: string, name: string, condition: OverrideTypes["WorkflowConditionGroupCondition"] | null, createdAt: string, updatedAt: string, precedence: number | null }> }, user: { __typename?: 'users', id: string, firstName: string, lastName: string }, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }>, forms: Array<{ __typename?: 'request_forms', id: string, title: string, formTemplateId: string | null, type: FormTypeEnum, config: OverrideTypes["FormConfig"], latestSubmissionArray: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string, request_step_task: { __typename?: 'request_step_tasks', organisationSupplierId: string | null } | null }> }>, latestComment: Array<{ __typename?: 'request_comments', id: string, payload: any, createdAt: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, inProgressStepContext: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, nodeId: string, name: any, type: any, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string, groupUsers: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }>, renewal: { __typename?: 'renewals', id: string, costCurrency: OverrideTypes["CurrencyCode"], costValue: number, renewalDate: string, cancellationNoticeDayCount: number | null, note: string | null, department: { __typename?: 'departments', id: string, name: string } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, remoteLink: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null }, product: { __typename?: 'organisation_products_and_services', id: string, name: string, logoUrl: string | null, description: string | null, displayName: string, updatedAt: string | null, website: string | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, website: string | null, isReseller: boolean, remoteLink: string | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null } } | null } | null, assessment: { __typename?: 'assessments', id: string, businessOwnerUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } } | null }>, requests_aggregate: { __typename?: 'requests_aggregate', aggregate: { __typename?: 'requests_aggregate_fields', count: number } | null } };

export type GetCustomReportByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  includeHistory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCustomReportByIdQuery = { __typename?: 'query_root', customReport: { __typename?: 'custom_reports', id: string, name: string, type: string, visibility: string, filters: any, dataFields: any, userId: string, organisationId: string, createdAt: string, updatedAt: string, scheduleEnabled: boolean, scheduleFrequency: string | null, scheduleRunOn: string | null, scheduleTime: string | null, scheduleRecipients: Array<string> | null, owner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, history?: Array<{ __typename?: 'custom_reports_generations', id: string, status: string, fileName: string, fileStoreId: string | null, generatedAt: string | null, requestedAt: string }> } | null };

export type GetCustomReportRecipientsByIdsQueryVariables = Exact<{
  recipientIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetCustomReportRecipientsByIdsQuery = { __typename?: 'query_root', recipients: Array<{ __typename?: 'users', id: string, firstName: string, lastName: string, email: string }> };

export type GetCustomReportWorkflowsByIdsQueryVariables = Exact<{
  workflowIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetCustomReportWorkflowsByIdsQuery = { __typename?: 'query_root', workflows: Array<{ __typename?: 'workflows', id: string, title: string }> };

export type GetLatestGenerationForReportQueryVariables = Exact<{
  customReportId: Scalars['uuid']['input'];
}>;


export type GetLatestGenerationForReportQuery = { __typename?: 'query_root', generation: Array<{ __typename?: 'custom_reports_generations', id: string, status: string, fileName: string, fileStoreId: string | null, generatedAt: string | null, requestedAt: string }> };

export type GetReportGenerationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetReportGenerationQuery = { __typename?: 'query_root', generation: { __typename?: 'custom_reports_generations', id: string, status: string, customReportsId: string, fileStoreId: string | null, fileName: string, requestedAt: string, generatedAt: string | null } | null };

export type GetRequestStepsForReportQueryVariables = Exact<{
  requestsFilter: RequestsBoolExp;
  formsFilter: InputMaybe<RequestFormsBoolExp>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRequestStepsForReportQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'requests', id: string, publicId: string, name: string, state: string | null, createdAt: string, completedAt: string | null, deletedAt: string | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string } | null, workflow: { __typename?: 'workflows', id: string, title: string, type: WorkflowTypeEnum }, forms: Array<{ __typename?: 'request_forms', id: string, title: string, formTemplateId: string | null, type: FormTypeEnum, config: OverrideTypes["FormConfig"], latestSubmissionArray: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string, request_step_task: { __typename?: 'request_step_tasks', organisationSupplierId: string | null } | null }>, request_comments: Array<{ __typename?: 'request_comments', id: string, type: RequestCommentTypeEnum, createdAt: string, completedAt: string | null }> }>, steps: Array<{ __typename?: 'request_steps', id: string, createdAt: string, completedAt: string | null, state: RequestStepStateEnum, result: RequestStepResultEnum | null, input: any, output: any | null, data: any | null, totalPausedWorkingHours: number, name: any, targetTime: any, type: any, request_step_users: Array<{ __typename?: 'request_step_users', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }>, request_step_groups: Array<{ __typename?: 'request_step_groups', group: { __typename?: 'groups', id: string, name: string, group_users: Array<{ __typename?: 'group_users', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }> } }>, request_step_tasks: Array<{ __typename?: 'request_step_tasks', request_form: { __typename?: 'request_forms', request_comments: Array<{ __typename?: 'request_comments', id: string, type: RequestCommentTypeEnum, createdAt: string, completedAt: string | null }> } | null }> }> }>, requests_aggregate: { __typename?: 'requests_aggregate', aggregate: { __typename?: 'requests_aggregate_fields', count: number } | null } };

export type ListCustomReportsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type ListCustomReportsQuery = { __typename?: 'query_root', customReports: Array<{ __typename?: 'custom_reports', id: string, name: string, type: string, visibility: string, filters: any, dataFields: any, userId: string, organisationId: string, createdAt: string, updatedAt: string, scheduleEnabled: boolean, scheduleFrequency: string | null, owner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, history: Array<{ __typename?: 'custom_reports_generations', id: string, status: string, fileName: string, fileStoreId: string | null, generatedAt: string | null, requestedAt: string }> }> };

export type UpdateCustomReportMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  updates: CustomReportsSetInput;
}>;


export type UpdateCustomReportMutation = { __typename?: 'mutation_root', customReport: { __typename?: 'custom_reports', id: string, name: string, type: string, filters: any, visibility: string, dataFields: any, userId: string, organisationId: string, createdAt: string, updatedAt: string, scheduleEnabled: boolean, scheduleFrequency: string | null, scheduleRunOn: string | null, scheduleTime: string | null, scheduleRecipients: Array<string> | null, owner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } } | null };

export type UpdateReportGenerationStatusMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  status: Scalars['String']['input'];
  fileStoreId: InputMaybe<Scalars['String']['input']>;
  generatedAt: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type UpdateReportGenerationStatusMutation = { __typename?: 'mutation_root', update_custom_reports_generations_by_pk: { __typename?: 'custom_reports_generations', id: string } | null };

export type CompleteRequestStepTaskMutationVariables = Exact<{
  taskId: Scalars['uuid']['input'];
  completedBy: Scalars['uuid']['input'];
  completedOn: Scalars['timestamptz']['input'];
}>;


export type CompleteRequestStepTaskMutation = { __typename?: 'mutation_root', update_request_step_tasks_by_pk: { __typename?: 'request_step_tasks', completedBy: string | null, completedOn: string | null, id: string } | null };

export type GetAmendmentRequestsLinkedToRequestFormQueryVariables = Exact<{
  requestFormId: Scalars['uuid']['input'];
}>;


export type GetAmendmentRequestsLinkedToRequestFormQuery = { __typename?: 'query_root', request_comments: Array<{ __typename?: 'request_comments', id: string }> };

export type GetRequestStepTaskQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type GetRequestStepTaskQuery = { __typename?: 'query_root', request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string, completedBy: string | null, completedOn: string | null, requestFormId: string | null, requestStepId: string, request_step: { __typename?: 'request_steps', output: any | null, request: { __typename?: 'requests', id: string, name: string }, request_step_users: Array<{ __typename?: 'request_step_users', userId: string }>, request_step_groups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, group_users: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', message: string, id: string }> } | null };

export type AutoSaveRequestFormSubmissionMutationVariables = Exact<{
  requestFormSubmission: RequestFormSubmissionsAutoSavesInsertInput;
}>;


export type AutoSaveRequestFormSubmissionMutation = { __typename?: 'mutation_root', insert_request_form_submissions_auto_saves_one: { __typename?: 'request_form_submissions_auto_saves', id: string, response: any, updatedAt: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } } | null };

export type CreateComputedPropertiesDbRowMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type CreateComputedPropertiesDbRowMutation = { __typename?: 'mutation_root', insert_request_computed_properties_one: { __typename?: 'request_computed_properties', id: string } | null };

export type GetRequestWithRenewalIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRequestWithRenewalIdQuery = { __typename?: 'query_root', request: { __typename?: 'requests', id: string, renewal: { __typename?: 'renewals', id: string } | null, assessment: { __typename?: 'assessments', id: string } | null } | null };

export type DeleteRequestMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteRequestMutation = { __typename?: 'mutation_root', deletedRequest: { __typename?: 'requests', id: string, renewal: { __typename?: 'renewals', id: string } | null } | null };

export type DeleteRequestTagsByRequestIdMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type DeleteRequestTagsByRequestIdMutation = { __typename?: 'mutation_root', deletedRequestTags: { __typename?: 'request_tags_mutation_response', returning: Array<{ __typename?: 'request_tags', id: string }> } | null };

export type GetDataForNewRequestQueryVariables = Exact<{
  workflowId: Scalars['uuid']['input'];
  requestorUserId: Scalars['uuid']['input'];
}>;


export type GetDataForNewRequestQuery = { __typename?: 'query_root', featureFlags: Array<{ __typename?: 'organisation_feature_flags', featureFlag: FeatureFlagsEnum }>, orgSettings: Array<{ __typename?: 'organisation_settings', name: string, value: any }>, workflow: { __typename?: 'workflows', id: string, title: string, requestSidebarConfig: any | null, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"], viewModel: any | null, viewModelUpdatedAt: string | null, canvasModelUpdatedAt: string, state: WorkflowStateEnum, type: WorkflowTypeEnum, organisationId: string, organisation: { __typename?: 'organisations', name: string } | null } | null, requestor: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, allFormTemplates: Array<{ __typename?: 'form_templates', id: string, config: OverrideTypes["FormConfig"], title: string, type: FormTypeEnum, description: string, internalId: string | null }> };

export type GetDataForRequestComputedPropertiesQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetDataForRequestComputedPropertiesQuery = { __typename?: 'query_root', request: { __typename?: 'requests', id: string, type: RequestTypeEnum, computedProperties: { __typename?: 'request_computed_properties', id: string } | null, forms: Array<{ __typename?: 'request_forms', id: string, type: FormTypeEnum, latestSubmissionArray: Array<{ __typename?: 'request_form_submissions', id: string, submittedOn: string, response: OverrideTypes["FormResponsePayload"] | null, request_step_task: { __typename?: 'request_step_tasks', organisationSupplierId: string | null } | null }> }> } | null };

export type GetExistingProductBrandByProductIdQueryVariables = Exact<{
  productId: Scalars['uuid']['input'];
}>;


export type GetExistingProductBrandByProductIdQuery = { __typename?: 'query_root', organisation_products_and_services_brands: Array<{ __typename?: 'organisation_products_and_services_brands', id: string }> };

export type GetExistingSupplierBrandBySupplierIdQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
}>;


export type GetExistingSupplierBrandBySupplierIdQuery = { __typename?: 'query_root', organisation_suppliers_brands: Array<{ __typename?: 'organisation_suppliers_brands', id: string }> };

export type GetOrgNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgNameQuery = { __typename?: 'query_root', organisations: Array<{ __typename?: 'organisations', id: string, name: string }> };

export type GetOrganisationProductsAndServicesMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationProductsAndServicesMinimalQuery = { __typename?: 'query_root', organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, organisationSupplierId: string, state: OrganisationProductsAndServicesStateEnum, name: string, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string, state: OrganisationSupplierStateEnum, organisation_supplier_brand: { __typename?: 'organisation_suppliers_brands', id: string, supplierId: string | null } | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', subsidiaryId: string }> }, organisation_products_and_services_brand: { __typename?: 'organisation_products_and_services_brands', id: string, productAndServiceId: string | null } | null }> };

export type GetOrganisationSupplierOneQueryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrganisationSupplierOneQueryQuery = { __typename?: 'query_root', organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', id: string, name: string, website: string | null, logoUrl: string | null, isReseller: boolean, createdAt: string, remoteId: string | null, lastAssessmentDate: string | null, publicId: number, organisationSupplierBrandId: string | null, address: OverrideTypes["Address"] | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } }> } | null };

export type GetOrganisationSuppliersQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
}>;


export type GetOrganisationSuppliersQuery = { __typename?: 'query_root', organisation_suppliers_brands: Array<{ __typename?: 'organisation_suppliers_brands', id: string, organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string }> }> };

export type GetProductOneQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetProductOneQuery = { __typename?: 'query_root', products_and_services_by_pk: { __typename?: 'products_and_services', id: string, name: string, displayName: string, website: string | null, logoUrl: string | null, createdAt: string, updatedAt: string, description: string | null, deletedAt: string | null, supplier: { __typename?: 'suppliers', id: string, name: string, website: string | null, description: string | null, logoUrl: string | null, isReseller: boolean } | null, products_and_services_categories: Array<{ __typename?: 'products_and_services_categories', id: string, categoryId: string }> } | null };

export type GetSupplierOneQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSupplierOneQuery = { __typename?: 'query_root', suppliers_by_pk: { __typename?: 'suppliers', id: string, name: string, website: string | null, description: string | null, logoUrl: string | null, isReseller: boolean } | null };

export type InsertOrganisationSupplierMutationVariables = Exact<{
  name: Scalars['String']['input'];
  supplierBrandId: InputMaybe<Scalars['uuid']['input']>;
  logoUrl: InputMaybe<Scalars['String']['input']>;
  isReseller: InputMaybe<Scalars['Boolean']['input']>;
  state: InputMaybe<OrganisationSupplierStateEnum>;
}>;


export type InsertOrganisationSupplierMutation = { __typename?: 'mutation_root', insert_organisation_suppliers_one: { __typename?: 'organisation_suppliers', id: string, name: string, website: string | null, logoUrl: string | null, isReseller: boolean, createdAt: string, remoteId: string | null, lastAssessmentDate: string | null, publicId: number, organisationSupplierBrandId: string | null, address: OverrideTypes["Address"] | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } }> } | null };

export type InsertRequestFormsMutationVariables = Exact<{
  requestForms: Array<RequestFormsInsertInput> | RequestFormsInsertInput;
}>;


export type InsertRequestFormsMutation = { __typename?: 'mutation_root', insert_request_forms: { __typename?: 'request_forms_mutation_response', returning: Array<{ __typename?: 'request_forms', id: string, request_form_template_id: string | null }> } | null };

export type OrganisationSupplierFragmentFragment = { __typename?: 'organisation_suppliers', id: string, name: string, website: string | null, logoUrl: string | null, isReseller: boolean, createdAt: string, remoteId: string | null, lastAssessmentDate: string | null, publicId: number, organisationSupplierBrandId: string | null, address: OverrideTypes["Address"] | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } }> };

export type ProductFragmentFragment = { __typename?: 'products_and_services', id: string, name: string, displayName: string, website: string | null, logoUrl: string | null, createdAt: string, updatedAt: string, description: string | null, deletedAt: string | null };

export type SupplierFragmentFragment = { __typename?: 'suppliers', id: string, name: string, website: string | null, description: string | null, logoUrl: string | null, isReseller: boolean };

export type UpdateMemoisedDepartmentForUserIfAllowedMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  departmentId: Scalars['uuid']['input'];
}>;


export type UpdateMemoisedDepartmentForUserIfAllowedMutation = { __typename?: 'mutation_root', update_users: { __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', id: string, organisation: { __typename?: 'organisations', hasDirectorySyncEnabled: boolean | null } }> } | null };

export type UpdateMemoisedManagerForUserIfAllowedMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  managerUserId: Scalars['uuid']['input'];
}>;


export type UpdateMemoisedManagerForUserIfAllowedMutation = { __typename?: 'mutation_root', update_users: { __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', id: string, organisation: { __typename?: 'organisations', hasDirectorySyncEnabled: boolean | null } }> } | null };

export type UpdateMemoisedSubsidiaryForUserIfAllowedMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  subsidiaryId: Scalars['uuid']['input'];
}>;


export type UpdateMemoisedSubsidiaryForUserIfAllowedMutation = { __typename?: 'mutation_root', update_users: { __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', id: string, organisation: { __typename?: 'organisations', hasDirectorySyncEnabled: boolean | null } }> } | null };

export type UpdateRequestModelMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  update: RequestsSetInput;
}>;


export type UpdateRequestModelMutation = { __typename?: 'mutation_root', update_requests_by_pk: { __typename?: 'requests', id: string, model: OverrideTypes["RequestModel"] } | null };

export type GetRequestStepTaskSubmissionsClosedAtQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type GetRequestStepTaskSubmissionsClosedAtQuery = { __typename?: 'query_root', request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string, submissionsClosedAt: string | null } | null };

export type GetConditionDataForAutogeneratedTagsQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  supplierId: Scalars['uuid']['input'];
  shouldFetchSupplier: Scalars['Boolean']['input'];
}>;


export type GetConditionDataForAutogeneratedTagsQuery = { __typename?: 'query_root', requestContext: { __typename?: 'requests', id: string, workflow: { __typename?: 'workflows', workflow_condition_groups: Array<{ __typename?: 'workflow_condition_groups', id: string, name: string, condition: OverrideTypes["WorkflowConditionGroupCondition"] | null, createdAt: string, updatedAt: string, precedence: number | null }> }, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }> } | null, supplierContext?: { __typename?: 'organisation_suppliers', organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }> } | null };

export type GetRequestFillInTasksQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestFillInTasksQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, organisationSupplierId: string | null, request_step: { __typename?: 'request_steps', id: string, type: any } }> };

export type GetRequestFormQueryVariables = Exact<{
  requestFormId: Scalars['uuid']['input'];
}>;


export type GetRequestFormQuery = { __typename?: 'query_root', requestForm: { __typename?: 'request_forms', id: string, type: FormTypeEnum, config: OverrideTypes["FormConfig"], request: { __typename?: 'requests', id: string, workflowId: string, model: OverrideTypes["RequestModel"], supplier: { __typename?: 'organisation_suppliers', id: string, state: OrganisationSupplierStateEnum, organisation_supplier_brand: { __typename?: 'organisation_suppliers_brands', id: string, supplierId: string | null } | null, subsidiaries: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }> } | null, product: { __typename?: 'organisation_products_and_services', id: string, state: OrganisationProductsAndServicesStateEnum } | null } } | null };

export type GetRequestFormConfigsQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestFormConfigsQuery = { __typename?: 'query_root', forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"] }> };

export type GetRfxSuppliersByRequestIdQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRfxSuppliersByRequestIdQuery = { __typename?: 'query_root', rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, organisationSupplierId: string, status: string }> };

export type InsertRequestFormSubmissionApiUseOnlyMutationVariables = Exact<{
  requestFormSubmission: RequestFormSubmissionsInsertInput;
}>;


export type InsertRequestFormSubmissionApiUseOnlyMutation = { __typename?: 'mutation_root', insert_request_form_submissions_one: { __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null } | null };

export type UpdateRequestTagsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  tagIds: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateRequestTagsMutation = { __typename?: 'mutation_root', update_requests_by_pk: { __typename?: 'requests', id: string, tagIds: any | null } | null };

export type UpdateTaskCompletedMutationVariables = Exact<{
  taskId: Scalars['uuid']['input'];
  completedBy: InputMaybe<Scalars['uuid']['input']>;
  completedOn: Scalars['timestamptz']['input'];
}>;


export type UpdateTaskCompletedMutation = { __typename?: 'mutation_root', update_request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string, completedOn: string | null, completedBy: string | null, user: { __typename?: 'users', id: string } | null } | null };

export type UpdateTaskSupplierIdMutationVariables = Exact<{
  taskId: Scalars['uuid']['input'];
  orgSupplierId: Scalars['uuid']['input'];
}>;


export type UpdateTaskSupplierIdMutation = { __typename?: 'mutation_root', update_request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string, organisationSupplierId: string | null } | null };

export type GetRequestEngagementQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestEngagementQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, name: string, engagement: { __typename?: 'engagements', id: string } | null } | null };

export type UpdateRequestBudgetMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  budgetId: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpdateRequestBudgetMutation = { __typename?: 'mutation_root', update_requests_by_pk: { __typename?: 'requests', id: string, name: string, budget: { __typename?: 'budgets', id: string, name: string } | null } | null };

export type UpdateRequestPoNumberMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  poNumber: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRequestPoNumberMutation = { __typename?: 'mutation_root', update_requests_by_pk: { __typename?: 'requests', id: string } | null };

export type UpdateRequestComputedPropertiesMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  updatedProperties: RequestComputedPropertiesSetInput;
}>;


export type UpdateRequestComputedPropertiesMutation = { __typename?: 'mutation_root', update_request_computed_properties: { __typename?: 'request_computed_properties_mutation_response', returning: Array<{ __typename?: 'request_computed_properties', id: string, requestId: string }> } | null };

export type GetRequestIntakeFormDataQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestIntakeFormDataQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, name: string, workflow: { __typename?: 'workflows', id: string, title: string, type: WorkflowTypeEnum }, request_forms: Array<{ __typename?: 'request_forms', id: string, type: FormTypeEnum, title: string, description: string, formTemplateId: string | null, request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }> } | null };

export type GetPauseDetailQueryVariables = Exact<{
  requestId: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetPauseDetailQuery = { __typename?: 'query_root', request_pauses: Array<{ __typename?: 'request_pauses', assigneeId: string, start: string, end: string | null, id: string, note: string | null, pause_reason: { __typename?: 'pause_reasons', text: string } }> };

export type GetPauseReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPauseReasonsQuery = { __typename?: 'query_root', pause_reasons: Array<{ __typename?: 'pause_reasons', id: string, text: string }> };

export type RequestBudgetApprovalDataFragment = { __typename?: 'requests', id: string, model: OverrideTypes["RequestModel"], computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null, inBudget: boolean | null, department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, buyerLegalEntity: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null } | null, renewal: { __typename?: 'renewals', costValue: number, costCurrency: OverrideTypes["CurrencyCode"], department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null } | null, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }> };

export type GetRequestBudgetApprovalDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRequestBudgetApprovalDataQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, model: OverrideTypes["RequestModel"], computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null, inBudget: boolean | null, department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, buyerLegalEntity: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null } | null, renewal: { __typename?: 'renewals', costValue: number, costCurrency: OverrideTypes["CurrencyCode"], department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null } | null, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }> } | null };

export type RequestDetailDataFragment = { __typename?: 'requests', id: string, name: string, createdAt: string, completedAt: string | null, tagIds: any | null, model: OverrideTypes["RequestModel"], requestorUserId: string, state: string | null, priority: RequestPriorityEnum, type: RequestTypeEnum, publicId: string, poNumber: string | null, workflowId: string, sidebarConfig: any | null, supplierId: string | null, productId: string | null, risks: Array<{ __typename?: 'risks', id: string, inherentRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null, residualRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null }>, budget: { __typename?: 'budgets', id: string, name: string } | null, renewal: { __typename?: 'renewals', renewalDate: string, cancellationNoticeDayCount: number | null, note: string | null, id: string, costValue: number, costCurrency: OverrideTypes["CurrencyCode"], department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, sourceAgreementTerm: { __typename?: 'agreement_terms', id: string, name: string, agreementId: string } | null } | null, assessment: { __typename?: 'assessments', id: string, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } } | null, organisation: { __typename?: 'organisations', id: string, name: string }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean }, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null, goLiveDate: string | null, inBudget: boolean | null, poNumber: string | null, note: string | null, contractStartDate: string | null, contractEndDate: string | null, contractLength: number | null, type: string | null, cancellationNoticeDays: number | null, cancellationReason: string | null, shouldRenew: boolean | null, isAutoRenewal: boolean | null, address: any | null, taxNumber: any | null, website: string | null, renewalDate: string | null, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } | null, budgetHolder: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } | null, department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, costCenter: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, buyerLegalEntity: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, category: { __typename?: 'custom_core_data_options', id: string, value: string } | null, market: { __typename?: 'custom_core_data_options', id: string, value: string } | null } | null, owner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } | null, leads: Array<{ __typename?: 'request_request_leads', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } }>, inProgressStepContext: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, nodeId: string, name: any, type: any, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string, groupUsers: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }>, steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, result: RequestStepResultEnum | null, canvasModelId: string, createdAt: string, completedAt: string | null, input: any, totalPausedWorkingHours: number }>, workflow: { __typename?: 'workflows', id: string, title: string, type: WorkflowTypeEnum, expectedSLA: number | null, workflow_condition_groups: Array<{ __typename?: 'workflow_condition_groups', id: string, name: string, precedence: number | null }> }, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, state: OrganisationSupplierStateEnum, externalLink: string | null, remoteId: string | null, publicId: number, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string, remoteId: string | null, remoteLink: string | null }>, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tagId: string }>, organisation_supplier_brand: { __typename?: 'organisation_suppliers_brands', logoUrl: string | null } | null } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum, logoUrl: string | null, description: string | null, website: string | null, organisation_products_and_services_brand: { __typename?: 'organisation_products_and_services_brands', logoUrl: string | null } | null, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, website: string | null, description: string | null, externalContacts: Array<{ __typename?: 'external_contacts', id: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, title: string | null, isPrimary: boolean }> } } | null, agreementTerm: { __typename?: 'agreement_terms', id: string, name: string, agreementId: string } | null, engagement: { __typename?: 'engagements', id: string, name: string, purchaseOrderNumber: string | null, externalLink: string | null } | null, purchase_orders: Array<{ __typename?: 'purchase_orders', id: string, remoteNumber: string | null, remoteLink: string | null, status: string, remoteStatus: string | null, totalValue: number, remoteTotalValue: number | null, remoteInvoicedValue: number, remotePaidValue: number, currency: { __typename?: 'organisation_fx_rates', id: string, code: OverrideTypes["CurrencyCode"] } | null }>, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }>, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }>, latestComment: Array<{ __typename?: 'request_comments', id: string, payload: any, createdAt: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, followers: Array<{ __typename?: 'request_followers', id: string, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } | null }>, request_pauses: Array<{ __typename?: 'request_pauses', start: string, end: string | null }> };

export type GetRequestDetailQueryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRequestDetailQueryQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, name: string, createdAt: string, completedAt: string | null, tagIds: any | null, model: OverrideTypes["RequestModel"], requestorUserId: string, state: string | null, priority: RequestPriorityEnum, type: RequestTypeEnum, publicId: string, poNumber: string | null, workflowId: string, sidebarConfig: any | null, supplierId: string | null, productId: string | null, risks: Array<{ __typename?: 'risks', id: string, inherentRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null, residualRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null }>, budget: { __typename?: 'budgets', id: string, name: string } | null, renewal: { __typename?: 'renewals', renewalDate: string, cancellationNoticeDayCount: number | null, note: string | null, id: string, costValue: number, costCurrency: OverrideTypes["CurrencyCode"], department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, sourceAgreementTerm: { __typename?: 'agreement_terms', id: string, name: string, agreementId: string } | null } | null, assessment: { __typename?: 'assessments', id: string, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } } | null, organisation: { __typename?: 'organisations', id: string, name: string }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean }, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null, goLiveDate: string | null, inBudget: boolean | null, poNumber: string | null, note: string | null, contractStartDate: string | null, contractEndDate: string | null, contractLength: number | null, type: string | null, cancellationNoticeDays: number | null, cancellationReason: string | null, shouldRenew: boolean | null, isAutoRenewal: boolean | null, address: any | null, taxNumber: any | null, website: string | null, renewalDate: string | null, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } | null, budgetHolder: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } | null, department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, costCenter: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, buyerLegalEntity: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, category: { __typename?: 'custom_core_data_options', id: string, value: string } | null, market: { __typename?: 'custom_core_data_options', id: string, value: string } | null } | null, owner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } | null, leads: Array<{ __typename?: 'request_request_leads', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } }>, inProgressStepContext: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, nodeId: string, name: any, type: any, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string, groupUsers: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }>, steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, result: RequestStepResultEnum | null, canvasModelId: string, createdAt: string, completedAt: string | null, input: any, totalPausedWorkingHours: number }>, workflow: { __typename?: 'workflows', id: string, title: string, type: WorkflowTypeEnum, expectedSLA: number | null, workflow_condition_groups: Array<{ __typename?: 'workflow_condition_groups', id: string, name: string, precedence: number | null }> }, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, state: OrganisationSupplierStateEnum, externalLink: string | null, remoteId: string | null, publicId: number, organisationIntegration: { __typename?: 'organisation_integrations', id: string, integration: OverrideTypes["GlobalIntegration"] } | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string, remoteId: string | null, remoteLink: string | null }>, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tagId: string }>, organisation_supplier_brand: { __typename?: 'organisation_suppliers_brands', logoUrl: string | null } | null } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum, logoUrl: string | null, description: string | null, website: string | null, organisation_products_and_services_brand: { __typename?: 'organisation_products_and_services_brands', logoUrl: string | null } | null, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, website: string | null, description: string | null, externalContacts: Array<{ __typename?: 'external_contacts', id: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, title: string | null, isPrimary: boolean }> } } | null, agreementTerm: { __typename?: 'agreement_terms', id: string, name: string, agreementId: string } | null, engagement: { __typename?: 'engagements', id: string, name: string, purchaseOrderNumber: string | null, externalLink: string | null } | null, purchase_orders: Array<{ __typename?: 'purchase_orders', id: string, remoteNumber: string | null, remoteLink: string | null, status: string, remoteStatus: string | null, totalValue: number, remoteTotalValue: number | null, remoteInvoicedValue: number, remotePaidValue: number, currency: { __typename?: 'organisation_fx_rates', id: string, code: OverrideTypes["CurrencyCode"] } | null }>, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }>, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }>, latestComment: Array<{ __typename?: 'request_comments', id: string, payload: any, createdAt: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, followers: Array<{ __typename?: 'request_followers', id: string, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } | null }>, request_pauses: Array<{ __typename?: 'request_pauses', start: string, end: string | null }> } | null };

export type RequestFormResponsesFragment = { __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> };

export type GetRequestDataForAssigneesQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestDataForAssigneesQuery = { __typename?: 'query_root', request: { __typename?: 'requests', id: string, model: OverrideTypes["RequestModel"], requestorUserId: string, forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }>, steps: Array<{ __typename?: 'request_steps', id: string, canvasModelId: string, users: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, isOutOfOffice: boolean } }>, groupsWithUsers: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string, users: Array<{ __typename?: 'group_users', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, isOutOfOffice: boolean } }> } }> }> } | null };

export type GetUsersAndGroupsWithIdsQueryVariables = Exact<{
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  groupIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetUsersAndGroupsWithIdsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, isOutOfOffice: boolean }>, groups: Array<{ __typename?: 'groups', id: string, name: string, group_users: Array<{ __typename?: 'group_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, isOutOfOffice: boolean } }> }> };

export type RequestBlocksInfoDataFragment = { __typename?: 'requests', id: string, state: string | null, completedAt: string | null, model: OverrideTypes["RequestModel"], tagIds: any | null, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null, inBudget: boolean | null, department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, buyerLegalEntity: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, state: OrganisationSupplierStateEnum, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tagId: string }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', subsidiaryId: string }> } | null, product: { __typename?: 'organisation_products_and_services', state: OrganisationProductsAndServicesStateEnum } | null, budget: { __typename?: 'budgets', id: string } | null, renewal: { __typename?: 'renewals', costValue: number, costCurrency: OverrideTypes["CurrencyCode"], department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null } | null, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }>, request_tags: Array<{ __typename?: 'request_tags', tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }> };

export type GetRequestBlocksInfoDataQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestBlocksInfoDataQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, state: string | null, completedAt: string | null, model: OverrideTypes["RequestModel"], tagIds: any | null, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null, inBudget: boolean | null, department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, buyerLegalEntity: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, state: OrganisationSupplierStateEnum, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tagId: string }>, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', subsidiaryId: string }> } | null, product: { __typename?: 'organisation_products_and_services', state: OrganisationProductsAndServicesStateEnum } | null, budget: { __typename?: 'budgets', id: string } | null, renewal: { __typename?: 'renewals', costValue: number, costCurrency: OverrideTypes["CurrencyCode"], department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null } | null, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }>, request_tags: Array<{ __typename?: 'request_tags', tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }> } | null };

export type GetRequestStepsMinimalQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestStepsMinimalQuery = { __typename?: 'query_root', request_steps: Array<{ __typename?: 'request_steps', id: string, canvasModelId: string, state: RequestStepStateEnum, output: any | null, createdAt: string, completedAt: string | null, totalPausedWorkingHours: number, users: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, isOutOfOffice: boolean } }>, groupsWithUsers: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string, users: Array<{ __typename?: 'group_users', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, isOutOfOffice: boolean } }> } }> }> };

export type GetRequestFormDetailsQueryVariables = Exact<{
  requestFormId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type GetRequestFormDetailsQuery = { __typename?: 'query_root', request_forms_by_pk: { __typename?: 'request_forms', id: string, title: string, description: string, formTemplateId: string | null, type: FormTypeEnum, config: OverrideTypes["FormConfig"], form_template: { __typename?: 'form_templates', id: string, externalTitle: string | null } | null, request: { __typename?: 'requests', id: string, name: string, state: string | null, request_supplier: string | null, request_product: string | null, renewal: { __typename?: 'renewals', id: string } | null, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string }, supplier: { __typename?: 'organisation_suppliers', name: string, internalContacts: Array<{ __typename?: 'internal_contacts', userId: string, productId: string | null }>, organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, businessOwnerId: string | null }> } | null, request_users: Array<{ __typename?: 'request_users', userId: string, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } }>, request_groups: Array<{ __typename?: 'request_groups', group: { __typename?: 'groups', id: string, name: string, group_users: Array<{ __typename?: 'group_users', userId: string }> } }> }, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, completedBy: string | null, completedOn: string | null, request_step_task_users: Array<{ __typename?: 'request_step_task_users', user_id: string, user: { __typename?: 'users', id: string, role: string, email: string, firstName: string, lastName: string } }>, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string }>, request_step: { __typename?: 'request_steps', id: string, state: RequestStepStateEnum, createdAt: string, skipped: any | null, skippedAt: any | null, skippedBy: any | null, forceApprovedAt: any | null, forceApprovedBy: any | null, request_step_users: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, role: string, email: string, firstName: string, lastName: string } }>, request_step_groups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, group_users: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }, request_form: { __typename?: 'request_forms', id: string, type: FormTypeEnum, request_comments: Array<{ __typename?: 'request_comments', id: string, type: RequestCommentTypeEnum, userId: string, completedAt: string | null }> } | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, status: string, rfx: { __typename?: 'rfx', requestId: string } }> } | null }>, openAmendments: Array<{ __typename?: 'request_comments', id: string, type: RequestCommentTypeEnum, userId: string, completedAt: string | null }> } | null };

export type FormDetailsFragmentFragment = { __typename?: 'request_forms', id: string, title: string, description: string, formTemplateId: string | null, type: FormTypeEnum, config: OverrideTypes["FormConfig"], form_template: { __typename?: 'form_templates', id: string, externalTitle: string | null } | null, request: { __typename?: 'requests', id: string, name: string, state: string | null, request_supplier: string | null, request_product: string | null, renewal: { __typename?: 'renewals', id: string } | null, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string }, supplier: { __typename?: 'organisation_suppliers', name: string, internalContacts: Array<{ __typename?: 'internal_contacts', userId: string, productId: string | null }>, organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, businessOwnerId: string | null }> } | null, request_users: Array<{ __typename?: 'request_users', userId: string, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } }>, request_groups: Array<{ __typename?: 'request_groups', group: { __typename?: 'groups', id: string, name: string, group_users: Array<{ __typename?: 'group_users', userId: string }> } }> }, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, completedBy: string | null, completedOn: string | null, request_step_task_users: Array<{ __typename?: 'request_step_task_users', user_id: string, user: { __typename?: 'users', id: string, role: string, email: string, firstName: string, lastName: string } }>, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string }>, request_step: { __typename?: 'request_steps', id: string, state: RequestStepStateEnum, createdAt: string, skipped: any | null, skippedAt: any | null, skippedBy: any | null, forceApprovedAt: any | null, forceApprovedBy: any | null, request_step_users: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, role: string, email: string, firstName: string, lastName: string } }>, request_step_groups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, group_users: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }, request_form: { __typename?: 'request_forms', id: string, type: FormTypeEnum, request_comments: Array<{ __typename?: 'request_comments', id: string, type: RequestCommentTypeEnum, userId: string, completedAt: string | null }> } | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, status: string, rfx: { __typename?: 'rfx', requestId: string } }> } | null }>, openAmendments: Array<{ __typename?: 'request_comments', id: string, type: RequestCommentTypeEnum, userId: string, completedAt: string | null }> };

export type GetRequestFormsParticipantsQueryVariables = Exact<{
  requestFormId: Scalars['uuid']['input'];
}>;


export type GetRequestFormsParticipantsQuery = { __typename?: 'query_root', request_forms_by_pk: { __typename?: 'request_forms', id: string, title: string, request: { __typename?: 'requests', id: string, name: string, type: RequestTypeEnum, owner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isArchived: boolean } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isArchived: boolean }, assessment: { __typename?: 'assessments', id: string, businessOwnerUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isArchived: boolean } } | null }, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, externalTaskUsers: Array<{ __typename?: 'request_step_task_users', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isArchived: boolean } }>, request_step: { __typename?: 'request_steps', id: string, emptyCommentsMessage: any, externalStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isArchived: boolean } }> } }> } | null };

export type GetRequestFormsQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type GetRequestFormsQuery = { __typename?: 'query_root', request_forms: Array<{ __typename?: 'request_forms', id: string, title: string, description: string, formTemplateId: string | null, type: FormTypeEnum, config: OverrideTypes["FormConfig"], form_template: { __typename?: 'form_templates', id: string, externalTitle: string | null } | null, request: { __typename?: 'requests', id: string, name: string, state: string | null, request_supplier: string | null, request_product: string | null, renewal: { __typename?: 'renewals', id: string } | null, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string }, supplier: { __typename?: 'organisation_suppliers', name: string, internalContacts: Array<{ __typename?: 'internal_contacts', userId: string, productId: string | null }>, organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, businessOwnerId: string | null }> } | null, request_users: Array<{ __typename?: 'request_users', userId: string, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } }>, request_groups: Array<{ __typename?: 'request_groups', group: { __typename?: 'groups', id: string, name: string, group_users: Array<{ __typename?: 'group_users', userId: string }> } }> }, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, completedBy: string | null, completedOn: string | null, request_step_task_users: Array<{ __typename?: 'request_step_task_users', user_id: string, user: { __typename?: 'users', id: string, role: string, email: string, firstName: string, lastName: string } }>, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string }>, request_step: { __typename?: 'request_steps', id: string, state: RequestStepStateEnum, createdAt: string, skipped: any | null, skippedAt: any | null, skippedBy: any | null, forceApprovedAt: any | null, forceApprovedBy: any | null, request_step_users: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, role: string, email: string, firstName: string, lastName: string } }>, request_step_groups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, group_users: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }, request_form: { __typename?: 'request_forms', id: string, type: FormTypeEnum, request_comments: Array<{ __typename?: 'request_comments', id: string, type: RequestCommentTypeEnum, userId: string, completedAt: string | null }> } | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, status: string, rfx: { __typename?: 'rfx', requestId: string } }> } | null }>, openAmendments: Array<{ __typename?: 'request_comments', id: string, type: RequestCommentTypeEnum, userId: string, completedAt: string | null }>, currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }>, requests_by_pk: { __typename?: 'requests', id: string, model: OverrideTypes["RequestModel"], tagIds: any | null, completedAt: string | null, budget: { __typename?: 'budgets', id: string } | null, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null } | null, supplier: { __typename?: 'organisation_suppliers', id: string, state: OrganisationSupplierStateEnum, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }>, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tagId: string }> } | null, product: { __typename?: 'organisation_products_and_services', state: OrganisationProductsAndServicesStateEnum } | null, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }> } | null };

export type GetRequestStepsQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestStepsQuery = { __typename?: 'query_root', request_steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, input: any, output: any | null, data: any | null, createdAt: string, completedAt: string | null, requestId: string, canvasModelId: string, result: RequestStepResultEnum | null, canvasModelParentIds: any, totalPausedWorkingHours: number, request_step_users: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string, role: string, isArchived: boolean } }>, request_step_groups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string, isArchived: boolean, group_users: Array<{ __typename?: 'group_users', id: string, userId: string }> } }>, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, completedOn: string | null, request_form: { __typename?: 'request_forms', id: string, title: string, type: FormTypeEnum } | null, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string }>, latestOutstandingAmendmentRequest: { __typename?: 'request_forms', id: string, amendmentRequests: Array<{ __typename?: 'request_comments', id: string, createdAt: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }> } | null }>, request: { __typename?: 'requests', id: string, state: string | null, supplier: { __typename?: 'organisation_suppliers', id: string } | null } }> };

export type GetRequestLeadsConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequestLeadsConfigQuery = { __typename?: 'query_root', requestLeadsConfig: Array<{ __typename?: 'request_leads_config', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, market: { __typename?: 'custom_core_data_options', id: string, value: string, customCoreDataId: string } | null, category: { __typename?: 'custom_core_data_options', id: string, value: string, customCoreDataId: string } | null }> };

export type GetRequestStatisticsQueryVariables = Exact<{
  completedFilter: RequestsBoolExp;
  pendingFilter: RequestsBoolExp;
  delayedFilter: RequestsBoolExp;
}>;


export type GetRequestStatisticsQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'requests', state: string | null, completedAt: string | null, steps: Array<{ __typename?: 'request_steps', state: RequestStepStateEnum, input: any, createdAt: string, completedAt: string | null, totalPausedWorkingHours: number }> }>, completed: { __typename?: 'requests_aggregate', aggregate: { __typename?: 'requests_aggregate_fields', count: number } | null }, pending: { __typename?: 'requests_aggregate', aggregate: { __typename?: 'requests_aggregate_fields', count: number } | null } };

export type GetAssignedTaskQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetAssignedTaskQuery = { __typename?: 'query_root', request_step_task_users: Array<{ __typename?: 'request_step_task_users', request_step_task: { __typename?: 'request_step_tasks', id: string, requestStepId: string, organisationSupplierId: string | null } }> };

export type GetRequestStepAssigneeQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetRequestStepAssigneeQuery = { __typename?: 'query_root', request_steps_by_pk: { __typename?: 'request_steps', id: string, input: any, request_step_users: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', email: string, id: string, firstName: string, lastName: string, role: string, isArchived: boolean, isOutOfOffice: boolean } }>, request_step_groups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', name: string, id: string, isArchived: boolean } }> } | null };

export type GetRfxAssigneesQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type GetRfxAssigneesQuery = { __typename?: 'query_root', request_step_task_users: Array<{ __typename?: 'request_step_task_users', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } }> };

export type GetRequestStepTaskErrorsByRequestIdQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestStepTaskErrorsByRequestIdQuery = { __typename?: 'query_root', request_step_task_errors: Array<{ __typename?: 'request_step_task_errors', id: string, requestStepTaskId: string, createdAt: string, type: string, message: string, suggestion: string | null, resolvedAt: string | null, detail: any | null, request_step_task: { __typename?: 'request_step_tasks', requestStepId: string } }> };

export type GetAllRequestStepsQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetAllRequestStepsQuery = { __typename?: 'query_root', request_steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, canvasModelId: string, input: any, output: any | null, data: any | null, result: RequestStepResultEnum | null, createdAt: string, completedAt: string | null, requestId: string, canvasModelParentIds: any, totalPausedWorkingHours: number, requestStepTasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, completedOn: string | null, completedBy: string | null, title: any | null, requestForm: { __typename?: 'request_forms', id: string, title: string, type: FormTypeEnum } | null, requestStepTaskRejections: Array<{ __typename?: 'request_step_task_rejections', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, latestOutstandingAmendmentRequest: { __typename?: 'request_forms', id: string, amendmentRequests: Array<{ __typename?: 'request_comments', id: string, createdAt: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }> } | null }>, request: { __typename?: 'requests', id: string, state: string | null, supplier: { __typename?: 'organisation_suppliers', id: string } | null }, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string, role: string, isArchived: boolean, isOutOfOffice: boolean } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string, isArchived: boolean, groupUsers: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }> };

export type GetRequestTabsDataQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
  includeRfx: Scalars['Boolean']['input'];
}>;


export type GetRequestTabsDataQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, requestFormId: string | null, type: RequestStepTaskTypeEnum, request_step: { __typename?: 'request_steps', skipped: any | null, skippedAt: any | null, skippedBy: any | null, forceApprovedAt: any | null, forceApprovedBy: any | null, requestStepTasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string }> }> } }>, rfx?: Array<{ __typename?: 'rfx', id: string }> };

export type GetAssigneesQueryVariables = Exact<{
  userAssigneeIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  groupAssigneeIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetAssigneesQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, deletedAt: string | null, isArchived: boolean, groupUsers: Array<{ __typename?: 'group_users', id: string, group: { __typename?: 'groups', id: string, name: string, organisationId: string } }> }>, groups: Array<{ __typename?: 'groups', id: string, name: string, organisationId: string }> };

export type GetRequestModelQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestModelQuery = { __typename?: 'query_root', request: { __typename?: 'requests', id: string, model: OverrideTypes["RequestModel"] } | null };

export type RequestStepFieldsFragment = { __typename?: 'request_steps', id: string, createdAt: string, state: RequestStepStateEnum, input: any, output: any | null, totalPausedWorkingHours: number, request: { __typename?: 'requests', id: string, name: string, type: RequestTypeEnum, product: { __typename?: 'organisation_products_and_services', id: string, logoUrl: string | null } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, role: string, email: string, isArchived: boolean } } };

export type RequestFormFieldsFragment = { __typename?: 'request_forms', id: string, supplierActiveAmendments: Array<{ __typename?: 'request_comments', id: string }> };

export type GetSupplierRequestStepsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetSupplierRequestStepsQuery = { __typename?: 'query_root', request_steps: Array<{ __typename?: 'request_steps', id: string, createdAt: string, state: RequestStepStateEnum, input: any, output: any | null, totalPausedWorkingHours: number, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, submissionsClosedAt: string | null, request_step_task_users: Array<{ __typename?: 'request_step_task_users', user_id: string }>, request_form: { __typename?: 'request_forms', id: string, supplierActiveAmendments: Array<{ __typename?: 'request_comments', id: string }> } | null }>, request: { __typename?: 'requests', id: string, name: string, type: RequestTypeEnum, product: { __typename?: 'organisation_products_and_services', id: string, logoUrl: string | null } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, role: string, email: string, isArchived: boolean } } }> };

export type GetRequestStepDeadlineReminderDataQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetRequestStepDeadlineReminderDataQuery = { __typename?: 'query_root', requestStep: { __typename?: 'request_steps', id: string, input: any, createdAt: string, totalPausedWorkingHours: number, result: RequestStepResultEnum | null, request: { __typename?: 'requests', id: string, publicId: string, name: string, deletedAt: string | null, state: string | null, requestor: { __typename?: 'users', id: string, firstName: string, lastName: string }, organisation: { __typename?: 'organisations', id: string, name: string }, supplier: { __typename?: 'organisation_suppliers', id: string, name: string } | null, leads: Array<{ __typename?: 'request_request_leads', id: string }> }, request_step_users: Array<{ __typename?: 'request_step_users', id: string, userId: string }>, request_step_groups: Array<{ __typename?: 'request_step_groups', id: string, groupId: string }>, workflow: { __typename?: 'workflows', id: string, title: string, type: WorkflowTypeEnum }, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, requestFormId: string | null, type: RequestStepTaskTypeEnum }> } | null };

export type GetExternalOperationTaskQueryVariables = Exact<{
  stepId: Scalars['uuid']['input'];
}>;


export type GetExternalOperationTaskQuery = { __typename?: 'query_root', extOpsTasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, completedOn: string | null, requestForm: { __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], formTemplateId: string | null, formTemplate: { __typename?: 'form_templates', id: string } | null, request: { __typename?: 'requests', supplier: { __typename?: 'organisation_suppliers', id: string } | null } } | null }> };

export type InsertFormTemplatesOneMutationVariables = Exact<{
  formTemplate: FormTemplatesInsertInput;
}>;


export type InsertFormTemplatesOneMutation = { __typename?: 'mutation_root', insert_form_templates_one: { __typename?: 'form_templates', config: OverrideTypes["FormConfig"], description: string, id: string, internalId: string | null, state: FormTemplateStateEnum, title: string, integration: OverrideTypes["Integration"] | null, externalTitle: string | null, type: FormTypeEnum, updatedAt: string, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null } | null };

export type GetFormTemplatesByIntegrationQueryVariables = Exact<{
  integration: Scalars['String']['input'];
}>;


export type GetFormTemplatesByIntegrationQuery = { __typename?: 'query_root', form_templates: Array<{ __typename?: 'form_templates', id: string, title: string, integration: OverrideTypes["Integration"] | null }> };

export type GetRequestPausedReminderDataQueryVariables = Exact<{
  pauseId: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetRequestPausedReminderDataQuery = { __typename?: 'query_root', request_pauses: Array<{ __typename?: 'request_pauses', id: string, assigneeId: string, note: string | null, reminderDate: any, pause_reason: { __typename?: 'pause_reasons', text: string }, organisation: { __typename?: 'organisations', id: string, name: string }, request: { __typename?: 'requests', id: string, name: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } } }> };

export type ResolveRequestStepTaskErrorsByRequestStepIdMutationVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
  resolvedAt: Scalars['timestamptz']['input'];
}>;


export type ResolveRequestStepTaskErrorsByRequestStepIdMutation = { __typename?: 'mutation_root', update_request_step_task_errors: { __typename?: 'request_step_task_errors_mutation_response', returning: Array<{ __typename?: 'request_step_task_errors', id: string, resolvedAt: string | null }> } | null };

export type InsertPauseReasonMutationVariables = Exact<{
  text: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertPauseReasonMutation = { __typename?: 'mutation_root', insert_pause_reasons_one: { __typename?: 'pause_reasons', id: string, text: string } | null };

export type RequestItemDataFragment = { __typename?: 'requests', id: string, name: string, createdAt: string, completedAt: string | null, tagIds: any | null, model: OverrideTypes["RequestModel"], state: string | null, priority: RequestPriorityEnum, type: RequestTypeEnum, publicId: string, poNumber: string | null, workflowId: string, supplierId: string | null, productId: string | null, risks: Array<{ __typename?: 'risks', id: string, inherentRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null, residualRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null }>, budget: { __typename?: 'budgets', id: string, name: string } | null, renewal: { __typename?: 'renewals', renewalDate: string, cancellationNoticeDayCount: number | null, note: string | null, id: string, costValue: number, costCurrency: OverrideTypes["CurrencyCode"], department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null } | null, assessment: { __typename?: 'assessments', id: string, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean }, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null, goLiveDate: string | null, inBudget: boolean | null, poNumber: string | null, note: string | null, contractStartDate: string | null, contractEndDate: string | null, contractLength: number | null, type: string | null, cancellationNoticeDays: number | null, cancellationReason: string | null, shouldRenew: boolean | null, isAutoRenewal: boolean | null, address: any | null, taxNumber: any | null, website: string | null, renewalDate: string | null, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } | null, budgetHolder: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } | null, department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, costCenter: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, buyerLegalEntity: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, category: { __typename?: 'custom_core_data_options', id: string, value: string, parent: { __typename?: 'custom_core_data_options', value: string } | null } | null, market: { __typename?: 'custom_core_data_options', id: string, value: string } | null } | null, owner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } | null, leads: Array<{ __typename?: 'request_request_leads', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } }>, inProgressStepContext: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, nodeId: string, name: any, type: any, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string, groupUsers: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }>, rejectedTasks: Array<{ __typename?: 'request_steps', id: string }>, erroredTasks: Array<{ __typename?: 'request_steps', id: string }>, steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, result: RequestStepResultEnum | null, canvasModelId: string, createdAt: string, completedAt: string | null, input: any, totalPausedWorkingHours: number }>, workflow: { __typename?: 'workflows', title: string, type: WorkflowTypeEnum, workflow_condition_groups: Array<{ __typename?: 'workflow_condition_groups', id: string, name: string, precedence: number | null }> }, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, state: OrganisationSupplierStateEnum, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }>, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tagId: string }>, organisation_supplier_brand: { __typename?: 'organisation_suppliers_brands', logoUrl: string | null } | null } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum } | null, engagement: { __typename?: 'engagements', id: string, purchaseOrderNumber: string | null } | null, purchase_orders: Array<{ __typename?: 'purchase_orders', id: string, remoteNumber: string | null, remoteLink: string | null, status: string, remoteStatus: string | null, totalValue: number, remoteTotalValue: number | null, remoteInvoicedValue: number, remotePaidValue: number, currency: { __typename?: 'organisation_fx_rates', id: string, code: OverrideTypes["CurrencyCode"] } | null }>, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }>, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }>, latestComment: Array<{ __typename?: 'request_comments', id: string, payload: any, createdAt: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string }, mentions: Array<{ __typename?: 'request_comments_mentions', id: string, userId: string | null, isResolved: boolean, user: { __typename?: 'users', firstName: string, lastName: string, email: string, isOutOfOffice: boolean } | null }> }>, followers: Array<{ __typename?: 'request_followers', id: string, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } | null }>, request_pauses: Array<{ __typename?: 'request_pauses', start: string, end: string | null }> };

export type ListRequestsQueryVariables = Exact<{
  where: RequestsBoolExp;
  order_by: InputMaybe<Array<RequestsOrderBy> | RequestsOrderBy>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type ListRequestsQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'requests', id: string, name: string, createdAt: string, completedAt: string | null, tagIds: any | null, model: OverrideTypes["RequestModel"], state: string | null, priority: RequestPriorityEnum, type: RequestTypeEnum, publicId: string, poNumber: string | null, workflowId: string, supplierId: string | null, productId: string | null, risks: Array<{ __typename?: 'risks', id: string, inherentRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null, residualRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null }>, budget: { __typename?: 'budgets', id: string, name: string } | null, renewal: { __typename?: 'renewals', renewalDate: string, cancellationNoticeDayCount: number | null, note: string | null, id: string, costValue: number, costCurrency: OverrideTypes["CurrencyCode"], department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null } | null, assessment: { __typename?: 'assessments', id: string, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean }, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null, goLiveDate: string | null, inBudget: boolean | null, poNumber: string | null, note: string | null, contractStartDate: string | null, contractEndDate: string | null, contractLength: number | null, type: string | null, cancellationNoticeDays: number | null, cancellationReason: string | null, shouldRenew: boolean | null, isAutoRenewal: boolean | null, address: any | null, taxNumber: any | null, website: string | null, renewalDate: string | null, businessOwner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } | null, budgetHolder: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } | null, department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, costCenter: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, buyerLegalEntity: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, category: { __typename?: 'custom_core_data_options', id: string, value: string, parent: { __typename?: 'custom_core_data_options', value: string } | null } | null, market: { __typename?: 'custom_core_data_options', id: string, value: string } | null } | null, owner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } | null, leads: Array<{ __typename?: 'request_request_leads', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } }>, inProgressStepContext: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, nodeId: string, name: any, type: any, requestStepUsers: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, requestStepGroups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, name: string, groupUsers: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }>, rejectedTasks: Array<{ __typename?: 'request_steps', id: string }>, erroredTasks: Array<{ __typename?: 'request_steps', id: string }>, steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, result: RequestStepResultEnum | null, canvasModelId: string, createdAt: string, completedAt: string | null, input: any, totalPausedWorkingHours: number }>, workflow: { __typename?: 'workflows', title: string, type: WorkflowTypeEnum, workflow_condition_groups: Array<{ __typename?: 'workflow_condition_groups', id: string, name: string, precedence: number | null }> }, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, state: OrganisationSupplierStateEnum, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string }>, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tagId: string }>, organisation_supplier_brand: { __typename?: 'organisation_suppliers_brands', logoUrl: string | null } | null } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum } | null, engagement: { __typename?: 'engagements', id: string, purchaseOrderNumber: string | null } | null, purchase_orders: Array<{ __typename?: 'purchase_orders', id: string, remoteNumber: string | null, remoteLink: string | null, status: string, remoteStatus: string | null, totalValue: number, remoteTotalValue: number | null, remoteInvoicedValue: number, remotePaidValue: number, currency: { __typename?: 'organisation_fx_rates', id: string, code: OverrideTypes["CurrencyCode"] } | null }>, request_forms: Array<{ __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], currentSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string }> }>, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }>, latestComment: Array<{ __typename?: 'request_comments', id: string, payload: any, createdAt: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string }, mentions: Array<{ __typename?: 'request_comments_mentions', id: string, userId: string | null, isResolved: boolean, user: { __typename?: 'users', firstName: string, lastName: string, email: string, isOutOfOffice: boolean } | null }> }>, followers: Array<{ __typename?: 'request_followers', id: string, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } | null }>, request_pauses: Array<{ __typename?: 'request_pauses', start: string, end: string | null }> }>, requests_aggregate: { __typename?: 'requests_aggregate', aggregate: { __typename?: 'requests_aggregate_fields', count: number } | null } };

export type ListRequestsPaginatedQueryVariables = Exact<{
  where: RequestsBoolExp;
  order_by: InputMaybe<Array<RequestsOrderBy> | RequestsOrderBy>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type ListRequestsPaginatedQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'requests', id: string, name: string, createdAt: string, completedAt: string | null, publicId: string, state: string | null, priority: RequestPriorityEnum, workflow: { __typename?: 'workflows', title: string }, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, state: OrganisationSupplierStateEnum } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum, logoUrl: string | null, description: string | null } | null, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null } | null, renewal: { __typename?: 'renewals', costValue: number, costCurrency: OverrideTypes["CurrencyCode"] } | null }>, requests_aggregate: { __typename?: 'requests_aggregate', aggregate: { __typename?: 'requests_aggregate_fields', count: number } | null } };

export type RequestItemDataV2Fragment = { __typename?: 'requests', id: string, name: string, createdAt: string, completedAt: string | null, publicId: string, state: string | null, priority: RequestPriorityEnum, workflow: { __typename?: 'workflows', title: string }, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, state: OrganisationSupplierStateEnum } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum, logoUrl: string | null, description: string | null } | null, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null } | null, renewal: { __typename?: 'renewals', costValue: number, costCurrency: OverrideTypes["CurrencyCode"] } | null };

export type GetRunningStepsQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRunningStepsQuery = { __typename?: 'query_root', request_steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, type: any, name: any }> };

export type PauseRequestMutationVariables = Exact<{
  assigneeId: InputMaybe<Scalars['uuid']['input']>;
  note: InputMaybe<Scalars['String']['input']>;
  reasonId: InputMaybe<Scalars['uuid']['input']>;
  requestId: InputMaybe<Scalars['uuid']['input']>;
  reminderDate: InputMaybe<Scalars['date']['input']>;
}>;


export type PauseRequestMutation = { __typename?: 'mutation_root', update_requests: { __typename?: 'requests_mutation_response', affected_rows: number } | null, update_request_steps: { __typename?: 'request_steps_mutation_response', affected_rows: number } | null, insert_request_pauses: { __typename?: 'request_pauses_mutation_response', returning: Array<{ __typename?: 'request_pauses', assigneeId: string, id: string, start: string, note: string | null, pause_reason: { __typename?: 'pause_reasons', id: string, text: string } }> } | null };

export type GetPauseNotificationRecipientsForRequestQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetPauseNotificationRecipientsForRequestQuery = { __typename?: 'query_root', requestSteps: Array<{ __typename?: 'request_steps', request_step_users: Array<{ __typename?: 'request_step_users', id: string, userId: string }> }>, requestLeads: Array<{ __typename?: 'request_request_leads', userId: string }>, request: { __typename?: 'requests', requestorUserId: string } | null };

export type SupplierBankDetailsWithAddressFragment = { __typename?: 'bank_details', id: string, accountName: string | null, bankName: string | null, country: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, isActive: boolean, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, address: { __typename?: 'addresses', addressLine1: string | null, addressLine2: string | null, city: string | null, county: string | null, postalCode: string | null, country: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> };

export type GetFormTemplateIdQueryVariables = Exact<{
  requestFormId: Scalars['uuid']['input'];
}>;


export type GetFormTemplateIdQuery = { __typename?: 'query_root', request_forms_by_pk: { __typename?: 'request_forms', id: string, type: FormTypeEnum, config: OverrideTypes["FormConfig"], request_step_tasks: Array<{ __typename?: 'request_step_tasks', request_step: { __typename?: 'request_steps', input: any } }>, request: { __typename?: 'requests', id: string, tagIds: any | null, name: string, model: OverrideTypes["RequestModel"], renewal: { __typename?: 'renewals', id: string, sourceAgreementTerm: { __typename?: 'agreement_terms', id: string, agreementId: string } | null } | null, agreement_term: { __typename?: 'agreement_terms', agreementId: string } | null, budget: { __typename?: 'budgets', id: string, name: string } | null, computedProperties: { __typename?: 'request_computed_properties', pricingObject: any | null } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, website: string | null, address: OverrideTypes["Address"] | null, taxNumber: string | null, state: OrganisationSupplierStateEnum, external_contacts: Array<{ __typename?: 'external_contacts', id: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, title: string | null, isPrimary: boolean }>, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerms: { __typename?: 'payment_terms', id: string, name: string } | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string }, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> }>, entityBankDetails: Array<{ __typename?: 'entity_bank_details', isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string } | null, address: { __typename?: 'addresses', createdAt: string, isArchived: boolean, archivedBy: string | null, id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null, organisationId: string, updatedAt: string, remoteId: string | null, coreDataId: string } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }> } | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string, state: OrganisationProductsAndServicesStateEnum } | null, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, workflow: { __typename?: 'workflows', id: string, title: string, type: WorkflowTypeEnum, workflow_condition_groups: Array<{ __typename?: 'workflow_condition_groups', id: string, name: string, condition: OverrideTypes["WorkflowConditionGroupCondition"] | null, createdAt: string, updatedAt: string, precedence: number | null }> } }, form_template: { __typename?: 'form_templates', id: string } | null } | null };

export type GetLatestSupplierAndProductSubmissionsQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
  productId: Scalars['uuid']['input'];
}>;


export type GetLatestSupplierAndProductSubmissionsQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, request_form: { __typename?: 'request_forms', id: string, request_form_submissions: Array<{ __typename?: 'request_form_submissions', submittedOn: string, id: string, response: OverrideTypes["FormResponsePayload"] | null }> } | null }> };

export type GetLatestSupplierSubmissionsQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
}>;


export type GetLatestSupplierSubmissionsQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, request_form: { __typename?: 'request_forms', id: string, request_form_submissions: Array<{ __typename?: 'request_form_submissions', submittedOn: string, id: string, response: OverrideTypes["FormResponsePayload"] | null }> } | null }>, organisation_supplier_historic_submissions: Array<{ __typename?: 'organisation_supplier_historic_submissions', id: string, response: any, createdAt: string, submittedAt: string | null }> };

export type OrgSupplierFragmentFragment = { __typename?: 'organisation_suppliers', id: string, name: string, website: string | null, address: OverrideTypes["Address"] | null, taxNumber: string | null, state: OrganisationSupplierStateEnum, external_contacts: Array<{ __typename?: 'external_contacts', id: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, title: string | null, isPrimary: boolean }>, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } }> };

export type GetSupplierByOrgSupplierIdAndNameQueryVariables = Exact<{
  orgSupplierId: Scalars['uuid']['input'];
  orgSupplierName: Scalars['String']['input'];
}>;


export type GetSupplierByOrgSupplierIdAndNameQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, website: string | null, address: OverrideTypes["Address"] | null, taxNumber: string | null, state: OrganisationSupplierStateEnum, external_contacts: Array<{ __typename?: 'external_contacts', id: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, title: string | null, isPrimary: boolean }>, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } }> }> };

export type GetProductLinkedToRequestQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetProductLinkedToRequestQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', product: { __typename?: 'organisation_products_and_services', id: string, name: string } | null } | null };

export type GetRequestStepPrefillDataQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetRequestStepPrefillDataQuery = { __typename?: 'query_root', requestStep: { __typename?: 'request_steps', id: string, canvasModelId: string, prefillFromSupplierRecord: any, prefillFromSupplierRecordOnSupplierProductMatch: any } | null };

export type GetRequestStepTypeByRequestFormIdQueryVariables = Exact<{
  requestFormId: Scalars['uuid']['input'];
}>;


export type GetRequestStepTypeByRequestFormIdQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, request_step: { __typename?: 'request_steps', id: string, type: any } }> };

export type GetSupplierLinkedToRequestQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetSupplierLinkedToRequestQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, supplier: { __typename?: 'organisation_suppliers', id: string, name: string } | null } | null };

export type GetSuppliersLinkedToRequestFormQueryVariables = Exact<{
  requestFormId: Scalars['uuid']['input'];
}>;


export type GetSuppliersLinkedToRequestFormQuery = { __typename?: 'query_root', request_forms_by_pk: { __typename?: 'request_forms', id: string, request_step_tasks: Array<{ __typename?: 'request_step_tasks', organisationSupplierId: string | null }> } | null };

export type GetOrganisationCurrenciesForPrefillQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationCurrenciesForPrefillQuery = { __typename?: 'query_root', organisation_fx_rates: Array<{ __typename?: 'organisation_fx_rates', id: string, code: OverrideTypes["CurrencyCode"], fxRate: number }> };

export type GetLatestSupplierOnboardingAndRfxResponseForStepQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  organisationSupplierId: Scalars['uuid']['input'];
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetLatestSupplierOnboardingAndRfxResponseForStepQuery = { __typename?: 'query_root', request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string, request_form: { __typename?: 'request_forms', id: string, config: OverrideTypes["FormConfig"], type: FormTypeEnum } | null }> };

export type RejectRequestMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type RejectRequestMutation = { __typename?: 'mutation_root', update_requests_by_pk: { __typename?: 'requests', id: string } | null };

export type RejectRequestStepTaskMutationVariables = Exact<{
  taskId: Scalars['uuid']['input'];
  message: Scalars['String']['input'];
  createdAt: Scalars['timestamptz']['input'];
  createdBy: Scalars['uuid']['input'];
}>;


export type RejectRequestStepTaskMutation = { __typename?: 'mutation_root', rejection: { __typename?: 'request_step_task_rejections', id: string } | null };

export type GetPausedRequestStepsQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetPausedRequestStepsQuery = { __typename?: 'query_root', request_steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, totalPausedTime: string, totalPausedWorkingHours: number, input: any }> };

export type ResumeRequestMutationVariables = Exact<{
  requestId: InputMaybe<Scalars['uuid']['input']>;
  end: InputMaybe<Scalars['timestamptz']['input']>;
  stepUpdates: Array<RequestStepsUpdates> | RequestStepsUpdates;
  totalPausedTime: InputMaybe<Scalars['interval']['input']>;
}>;


export type ResumeRequestMutation = { __typename?: 'mutation_root', update_requests: { __typename?: 'requests_mutation_response', affected_rows: number } | null, update_request_pauses: { __typename?: 'request_pauses_mutation_response', affected_rows: number } | null, update_request_steps_many: Array<{ __typename?: 'request_steps_mutation_response', affected_rows: number } | null> | null };

export type GetRequestStepByBlockIdQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  canvasModelId: Scalars['String']['input'];
}>;


export type GetRequestStepByBlockIdQuery = { __typename?: 'query_root', request_steps: Array<{ __typename?: 'request_steps', id: string, state: RequestStepStateEnum, result: RequestStepResultEnum | null }> };

export type UncompleteRequestStepTaskMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UncompleteRequestStepTaskMutation = { __typename?: 'mutation_root', update_request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string } | null };

export type UnrejectRequestMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type UnrejectRequestMutation = { __typename?: 'mutation_root', update_requests_by_pk: { __typename?: 'requests', publicId: string, id: string } | null };

export type UpdateRequestPropertiesMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  requestUpdates?: InputMaybe<RequestsSetInput>;
}>;


export type UpdateRequestPropertiesMutation = { __typename?: 'mutation_root', update_requests_by_pk: { __typename?: 'requests', id: string, name: string, priority: RequestPriorityEnum, poNumber: string | null, owner: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, budget: { __typename?: 'budgets', id: string, name: string } | null } | null };

export type GetRequestAccessInfoQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type GetRequestAccessInfoQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, requestorUserId: string, deletedAt: string | null, request_supplier: string | null, request_product: string | null, request_users: Array<{ __typename?: 'request_users', userId: string }>, request_groups: Array<{ __typename?: 'request_groups', group: { __typename?: 'groups', group_users: Array<{ __typename?: 'group_users', userId: string }> } }>, supplier: { __typename?: 'organisation_suppliers', internalContacts: Array<{ __typename?: 'internal_contacts', id: string, userId: string, productId: string | null }>, organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, businessOwnerId: string | null }> } | null } | null };

export type GetRequestTagsByRequestIdQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestTagsByRequestIdQuery = { __typename?: 'query_root', request_tags: Array<{ __typename?: 'request_tags', tag: { __typename?: 'tags', id: string, name: string } }> };

export type InsertRequestTagsMutationVariables = Exact<{
  objects: Array<RequestTagsInsertInput> | RequestTagsInsertInput;
}>;


export type InsertRequestTagsMutation = { __typename?: 'mutation_root', insert_request_tags: { __typename?: 'request_tags_mutation_response', returning: Array<{ __typename?: 'request_tags', id: string }> } | null };

export type GetRequestFormPausedQueryVariables = Exact<{
  requestFormId: Scalars['uuid']['input'];
}>;


export type GetRequestFormPausedQuery = { __typename?: 'query_root', requestForm: { __typename?: 'request_forms', id: string, request: { __typename?: 'requests', id: string, state: string | null } } | null };

export type GetRequestPausedQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestPausedQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, state: string | null } | null };

export type GetRequestStepTaskPausedQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type GetRequestStepTaskPausedQuery = { __typename?: 'query_root', request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string, request_step: { __typename?: 'request_steps', request: { __typename?: 'requests', id: string, state: string | null } } } | null };

export type GetUserAttributeCustomFieldValueQueryVariables = Exact<{
  customFieldId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type GetUserAttributeCustomFieldValueQuery = { __typename?: 'query_root', custom_field_values: Array<{ __typename?: 'custom_field_values', id: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, entityId: string, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', id: string, department: { __typename?: 'departments', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, currency: { __typename?: 'organisation_fx_rates', id: string, code: OverrideTypes["CurrencyCode"] } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, value: string } | null } | null }> };

export type CreateRequestFollowersMutationVariables = Exact<{
  objects: Array<RequestFollowersInsertInput> | RequestFollowersInsertInput;
}>;


export type CreateRequestFollowersMutation = { __typename?: 'mutation_root', insert_request_followers: { __typename?: 'request_followers_mutation_response', returning: Array<{ __typename?: 'request_followers', id: string, userId: string | null, groupId: string | null, assigneeType: AssigneeTypeEnum, note: string | null }> } | null };

export type DeleteRequestFollowerDataMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteRequestFollowerDataMutation = { __typename?: 'mutation_root', update_request_followers_by_pk: { __typename?: 'request_followers', id: string } | null };

export type GetRequestFollowersQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestFollowersQuery = { __typename?: 'query_root', request_followers: Array<{ __typename?: 'request_followers', id: string, note: string | null, assigneeType: AssigneeTypeEnum, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, isArchived: boolean } | null, group: { __typename?: 'groups', id: string, name: string } | null }> };

export type UpdateRequestFollowerDataMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  note: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRequestFollowerDataMutation = { __typename?: 'mutation_root', update_request_followers_by_pk: { __typename?: 'request_followers', id: string, note: string | null } | null };

export type DeleteRequestLeadMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  requestId: Scalars['uuid']['input'];
}>;


export type DeleteRequestLeadMutation = { __typename?: 'mutation_root', delete_request_request_leads: { __typename?: 'request_request_leads_mutation_response', affected_rows: number } | null };

export type InsertRequestLeadsMutationVariables = Exact<{
  requestLeads: Array<RequestRequestLeadsInsertInput> | RequestRequestLeadsInsertInput;
}>;


export type InsertRequestLeadsMutation = { __typename?: 'mutation_root', insert_request_request_leads: { __typename?: 'request_request_leads_mutation_response', returning: Array<{ __typename?: 'request_request_leads', userId: string, updated_at: string }> } | null };

export type UpdateRequestSupplierAndMoveProductMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  organisationSupplierId: Scalars['uuid']['input'];
  organisationProductAndServiceId: Scalars['uuid']['input'];
}>;


export type UpdateRequestSupplierAndMoveProductMutation = { __typename?: 'mutation_root', update_requests_by_pk: { __typename?: 'requests', id: string } | null, update_organisation_products_and_services_by_pk: { __typename?: 'organisation_products_and_services', id: string } | null };

export type CreateRequestFormTemplateMutationVariables = Exact<{
  form: RequestFormTemplatesInsertInput;
}>;


export type CreateRequestFormTemplateMutation = { __typename?: 'mutation_root', insert_request_form_templates_one: { __typename?: 'request_form_templates', id: string } | null };

export type GetRequestFormTemplatesByStepIdQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetRequestFormTemplatesByStepIdQuery = { __typename?: 'query_root', request_form_templates: Array<{ __typename?: 'request_form_templates', id: string, title: string, draftConfig: any | null, config: any, isSent: boolean, type: FormTypeEnum, createdAt: string, description: string | null, rfx_request_form_templates_rank: { __typename?: 'rfx_request_form_templates_ranks', id: string, rank: number } | null, closedScoringTasks: Array<{ __typename?: 'request_step_tasks', id: string }> }> };

export type InsertRequestFormTemplatesMutationVariables = Exact<{
  requestFormTemplates: Array<RequestFormTemplatesInsertInput> | RequestFormTemplatesInsertInput;
}>;


export type InsertRequestFormTemplatesMutation = { __typename?: 'mutation_root', insert_request_form_templates: { __typename?: 'request_form_templates_mutation_response', returning: Array<{ __typename?: 'request_form_templates', id: string }> } | null };

export type UpdateRequestFormTemplateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  config: Scalars['jsonb']['input'];
  title: Scalars['String']['input'];
}>;


export type UpdateRequestFormTemplateOneMutation = { __typename?: 'mutation_root', update_request_form_templates_by_pk: { __typename?: 'request_form_templates', id: string } | null };

export type DeleteRequestFormTemplateMutationVariables = Exact<{
  requestFormTemplateId: Scalars['uuid']['input'];
}>;


export type DeleteRequestFormTemplateMutation = { __typename?: 'mutation_root', delete_request_form_templates_by_pk: { __typename?: 'request_form_templates', id: string } | null };

export type GetOrgSupplierFromRequestFormQueryVariables = Exact<{
  requestFormId: Scalars['uuid']['input'];
}>;


export type GetOrgSupplierFromRequestFormQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null } | null }> };

export type GetRequestFormTemplateByIdQueryVariables = Exact<{
  requestFormTemplateId: Scalars['uuid']['input'];
}>;


export type GetRequestFormTemplateByIdQuery = { __typename?: 'query_root', request_form_templates_by_pk: { __typename?: 'request_form_templates', id: string, formTemplateId: string | null, config: any, title: string, description: string | null, type: FormTypeEnum, createdAt: string, isSent: boolean, rfx_request_form_templates_rank: { __typename?: 'rfx_request_form_templates_ranks', id: string, rank: number } | null } | null };

export type GetRfxRequestFormTemplateDetailsQueryVariables = Exact<{
  requestFormTemplateId: Scalars['uuid']['input'];
}>;


export type GetRfxRequestFormTemplateDetailsQuery = { __typename?: 'query_root', formTemplate: { __typename?: 'request_form_templates', id: string, title: string, config: any, request_step: { __typename?: 'request_steps', request: { __typename?: 'requests', id: string, rfxes: Array<{ __typename?: 'rfx', id: string, rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, organisationSupplierId: string, status: string }> }> } }, request_forms: Array<{ __typename?: 'request_forms', id: string, latestSubmission: Array<{ __typename?: 'request_form_submissions', response: OverrideTypes["FormResponsePayload"] | null, id: string, request_step_task: { __typename?: 'request_step_tasks', id: string, completedOn: string | null } | null, request_form_submission_ai_summary: { __typename?: 'request_form_submission_ai_summary', id: string, summary: string } | null }> }> } | null };

export type GetRfxStatusQueryVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
}>;


export type GetRfxStatusQuery = { __typename?: 'query_root', rfx_by_pk: { __typename?: 'rfx', id: string, status: string } | null };

export type UpdateRfxRequestFormTemplatesRanksMutationVariables = Exact<{
  objects: Array<RfxRequestFormTemplatesRanksInsertInput> | RfxRequestFormTemplatesRanksInsertInput;
}>;


export type UpdateRfxRequestFormTemplatesRanksMutation = { __typename?: 'mutation_root', insert_rfx_request_form_templates_ranks: { __typename?: 'rfx_request_form_templates_ranks_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'rfx_request_form_templates_ranks', id: string }> } | null };

export type GetAllFormQuestionScoresQueryVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
}>;


export type GetAllFormQuestionScoresQuery = { __typename?: 'query_root', rfx_by_pk: { __typename?: 'rfx', rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, organisationSupplierId: string, status: string }>, request_step: { __typename?: 'request_steps', request_step_tasks: Array<{ __typename?: 'request_step_tasks', request_step_task_users: Array<{ __typename?: 'request_step_task_users', request_step_task: { __typename?: 'request_step_tasks', id: string, request_form_template: { __typename?: 'request_form_templates', id: string } | null, request_form_question_scores: Array<{ __typename?: 'request_form_question_score', id: string, questionName: string, score: number, userId: string, request_form_submission: { __typename?: 'request_form_submissions', id: string }, request_form: { __typename?: 'request_forms', id: string, request_form_template: { __typename?: 'request_form_templates', id: string, title: string, pages: any } | null } }> } }> }> } } | null };

export type GetFormTemplateQuestionScoresQueryVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
  requestFormTemplateId: Scalars['uuid']['input'];
}>;


export type GetFormTemplateQuestionScoresQuery = { __typename?: 'query_root', rfx_by_pk: { __typename?: 'rfx', request_step: { __typename?: 'request_steps', request_step_tasks: Array<{ __typename?: 'request_step_tasks', request_step_task_users: Array<{ __typename?: 'request_step_task_users', request_step_task: { __typename?: 'request_step_tasks', id: string, request_form_template: { __typename?: 'request_form_templates', id: string } | null, request_form_question_scores: Array<{ __typename?: 'request_form_question_score', id: string, questionName: string, score: number, userId: string, request_form_submission: { __typename?: 'request_form_submissions', id: string }, request_form: { __typename?: 'request_forms', id: string, request_form_template: { __typename?: 'request_form_templates', id: string, title: string, pages: any } | null } }> } }> }> } } | null };

export type GetUsersByIdsQueryVariables = Exact<{
  userIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetUsersByIdsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isOutOfOffice: boolean, isArchived: boolean }> };

export type CloseScoringAndUpdateStateMutationVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
  rfxId: Scalars['uuid']['input'];
  rfxStatus: Scalars['String']['input'];
}>;


export type CloseScoringAndUpdateStateMutation = { __typename?: 'mutation_root', update_request_step_tasks: { __typename?: 'request_step_tasks_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'request_step_tasks', id: string }> } | null, update_rfx_by_pk: { __typename?: 'rfx', id: string, status: string } | null };

export type CreateScoringTasksMutationVariables = Exact<{
  tasks: Array<RequestStepTasksInsertInput> | RequestStepTasksInsertInput;
}>;


export type CreateScoringTasksMutation = { __typename?: 'mutation_root', insert_request_step_tasks: { __typename?: 'request_step_tasks_mutation_response', returning: Array<{ __typename?: 'request_step_tasks', id: string, request_step_task_users: Array<{ __typename?: 'request_step_task_users', user_id: string }> }> } | null };

export type DeleteRequestFormTemplatesMutationVariables = Exact<{
  requestFormTemplateIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  requestStepId: Scalars['uuid']['input'];
}>;


export type DeleteRequestFormTemplatesMutation = { __typename?: 'mutation_root', delete_request_form_templates: { __typename?: 'request_form_templates_mutation_response', returning: Array<{ __typename?: 'request_form_templates', id: string }> } | null };

export type GetActiveRfxSuppliersQueryVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
}>;


export type GetActiveRfxSuppliersQuery = { __typename?: 'query_root', rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, organisationSupplierId: string, hasParticipatedInScoring: boolean }> };

export type GetRequestFormTemplateTasksByIdQueryVariables = Exact<{
  requestFormTemplateId: Scalars['uuid']['input'];
}>;


export type GetRequestFormTemplateTasksByIdQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, requestFormId: string | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string } | null }>, request_form_templates_by_pk: { __typename?: 'request_form_templates', id: string, title: string } | null };

export type GetRequestFormTemplatesReviewersQueryVariables = Exact<{
  requestFormTemplateIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetRequestFormTemplatesReviewersQuery = { __typename?: 'query_root', request_form_template_reviewers: Array<{ __typename?: 'request_form_template_reviewers', id: string, userId: string }> };

export type GetRequestStepRequestFormTemplatesQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetRequestStepRequestFormTemplatesQuery = { __typename?: 'query_root', request_form_templates: Array<{ __typename?: 'request_form_templates', id: string }> };

export type GetRequestStepSupplierFillInTasksQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetRequestStepSupplierFillInTasksQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string }> };

export type GetRfxAndSupplierOnboardingRequestFormTemplatesQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetRfxAndSupplierOnboardingRequestFormTemplatesQuery = { __typename?: 'query_root', request_form_templates: Array<{ __typename?: 'request_form_templates', id: string, formTemplateId: string | null, config: any, title: string, description: string | null, type: FormTypeEnum, isSent: boolean, createdAt: string, rfx_request_form_templates_rank: { __typename?: 'rfx_request_form_templates_ranks', id: string, rank: number } | null }> };

export type GetRfxConfidentialityAgreementsQueryVariables = Exact<{
  rfxId: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetRfxConfidentialityAgreementsQuery = { __typename?: 'query_root', rfx_confidentiality_agreement: Array<{ __typename?: 'rfx_confidentiality_agreement', id: string, rfxSupplierId: string }> };

export type GetRfxDetailQueryVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
}>;


export type GetRfxDetailQuery = { __typename?: 'query_root', rfx_by_pk: { __typename?: 'rfx', id: string, aiScoringEnabled: boolean, aiScoringVisible: boolean, isReopened: boolean, status: string, requestId: string, supplierInstructions: string, requestStepId: string, organisation: { __typename?: 'organisations', id: string, name: string }, request: { __typename?: 'requests', id: string, name: string, createdAt: string }, rfx_suppliers_aggregate: { __typename?: 'rfx_suppliers_aggregate', aggregate: { __typename?: 'rfx_suppliers_aggregate_fields', count: number } | null }, owners: Array<{ __typename?: 'rfx_owners', id: string, userId: string }>, rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, status: string, hasParticipatedInScoring: boolean, organisation_supplier: { __typename?: 'organisation_suppliers', name: string, id: string }, rfx_external_users_aggregate: { __typename?: 'rfx_external_users_aggregate', aggregate: { __typename?: 'rfx_external_users_aggregate_fields', count: number } | null } }>, request_step: { __typename?: 'request_steps', result: RequestStepResultEnum | null, createdAt: string, targetTimeValue: any, supplierFillInTasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, submissionsClosedAt: string | null, request_form: { __typename?: 'request_forms', request_form_template_id: string | null } | null, organisation_supplier: { __typename?: 'organisation_suppliers', name: string, id: string } | null }>, scoringTasks: Array<{ __typename?: 'request_step_tasks', completedOn: string | null, submissionsClosedAt: string | null, id: string }>, request_form_templates: Array<{ __typename?: 'request_form_templates', id: string, title: string, type: FormTypeEnum, createdAt: string, isSent: boolean, rfx_request_form_templates_rank: { __typename?: 'rfx_request_form_templates_ranks', id: string, rank: number } | null, request_forms: Array<{ __typename?: 'request_forms', id: string }> }> } } | null };

export type GetRfxScoringProgressDataQueryVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
}>;


export type GetRfxScoringProgressDataQuery = { __typename?: 'query_root', rfx_by_pk: { __typename?: 'rfx', request: { __typename?: 'requests', id: string, request_forms: Array<{ __typename?: 'request_forms', id: string, request_form_template_id: string | null, request_step_tasks: Array<{ __typename?: 'request_step_tasks', type: RequestStepTaskTypeEnum, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, status: string, rfxId: string }> } | null }>, request_form_template: { __typename?: 'request_form_templates', config: any, request_form_template_reviewers: Array<{ __typename?: 'request_form_template_reviewers', id: string, userId: string }> } | null, request_form_question_scores: Array<{ __typename?: 'request_form_question_score', userId: string, questionName: string, score: number }>, latestSubmission: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null }> }> } } | null };

export type GetRfxSupplierSubmissionsQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
  organisationSupplierIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetRfxSupplierSubmissionsQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, request_form: { __typename?: 'request_forms', id: string, request_form_template_id: string | null, request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string }> } | null }> };

export type GetRfxSuppliersTasksQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
  organisationSupplierIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetRfxSuppliersTasksQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, organisationSupplierId: string | null, request_form: { __typename?: 'request_forms', id: string, request_form_template: { __typename?: 'request_form_templates', id: string, type: FormTypeEnum, closedScoringTasks: Array<{ __typename?: 'request_step_tasks', id: string }> } | null } | null }> };

export type GetRfxWithActiveSuppliersQueryVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
}>;


export type GetRfxWithActiveSuppliersQuery = { __typename?: 'query_root', organisations: Array<{ __typename?: 'organisations', id: string, name: string }>, rfx_by_pk: { __typename?: 'rfx', requestStepId: string, status: string, isReopened: boolean, request_step: { __typename?: 'request_steps', requiresConfidentialityAgreement: any }, request: { __typename?: 'requests', id: string, name: string }, owners: Array<{ __typename?: 'rfx_owners', id: string, userId: string }>, rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, hasParticipatedInScoring: boolean, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string }, rfx_external_users: Array<{ __typename?: 'rfx_external_users', id: string, external_contact: { __typename?: 'external_contacts', userId: string | null } }> }> } | null };

export type GetScoringTaskDetailsQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type GetScoringTaskDetailsQuery = { __typename?: 'query_root', request_step_tasks_by_pk: { __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, request_form_template: { __typename?: 'request_form_templates', id: string } | null, request_form_question_scores: Array<{ __typename?: 'request_form_question_score', questionName: string, score: number, request_form: { __typename?: 'request_forms', id: string }, request_form_submission: { __typename?: 'request_form_submissions', id: string } }> } | null };

export type GetScoringTasksQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetScoringTasksQuery = { __typename?: 'query_root', request_step_task_users: Array<{ __typename?: 'request_step_task_users', request_step_task: { __typename?: 'request_step_tasks', id: string, request_form_template_id: string | null, submissionsClosedAt: string | null } }> };

export type GetSentRfxAndSupplierOnboardingRequestFormTemplatesQueryVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetSentRfxAndSupplierOnboardingRequestFormTemplatesQuery = { __typename?: 'query_root', request_form_templates: Array<{ __typename?: 'request_form_templates', id: string, formTemplateId: string | null, config: any, title: string, description: string | null, type: FormTypeEnum, createdAt: string, isSent: boolean, rfx_request_form_templates_rank: { __typename?: 'rfx_request_form_templates_ranks', id: string, rank: number } | null }> };

export type GetRequestFormSubmissionDetailsQueryVariables = Exact<{
  requestFormSubmissionId: Scalars['uuid']['input'];
}>;


export type GetRequestFormSubmissionDetailsQuery = { __typename?: 'query_root', request_form_submissions_by_pk: { __typename?: 'request_form_submissions', requestStepTaskId: string | null, requestFormId: string | null } | null };

export type MarkRequestFormTemplateAsSentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type MarkRequestFormTemplateAsSentMutation = { __typename?: 'mutation_root', update_request_form_templates_by_pk: { __typename?: 'request_form_templates', id: string } | null };

export type MarkRequestFormTemplatesAsSentAndUpdateStateMutationVariables = Exact<{
  templateIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  rfxId: Scalars['uuid']['input'];
  rfxStatus: Scalars['String']['input'];
}>;


export type MarkRequestFormTemplatesAsSentAndUpdateStateMutation = { __typename?: 'mutation_root', updatedRequestFormTemplates: { __typename?: 'request_form_templates_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'request_form_templates', id: string }> } | null, updatedRfx: { __typename?: 'rfx', id: string, status: string } | null };

export type ReopenRequestFormTemplateScoringTasksMutationVariables = Exact<{
  requestStepId: Scalars['uuid']['input'];
  requestFormTemplateIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ReopenRequestFormTemplateScoringTasksMutation = { __typename?: 'mutation_root', update_request_step_tasks: { __typename?: 'request_step_tasks_mutation_response', returning: Array<{ __typename?: 'request_step_tasks', id: string }> } | null };

export type RfxFragmentFragment = { __typename?: 'rfx', id: string, aiScoringEnabled: boolean, aiScoringVisible: boolean, isReopened: boolean, status: string, requestId: string, supplierInstructions: string, requestStepId: string, organisation: { __typename?: 'organisations', id: string, name: string }, request: { __typename?: 'requests', id: string, name: string, createdAt: string }, rfx_suppliers_aggregate: { __typename?: 'rfx_suppliers_aggregate', aggregate: { __typename?: 'rfx_suppliers_aggregate_fields', count: number } | null }, owners: Array<{ __typename?: 'rfx_owners', id: string, userId: string }>, rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, status: string, hasParticipatedInScoring: boolean, organisation_supplier: { __typename?: 'organisation_suppliers', name: string, id: string }, rfx_external_users_aggregate: { __typename?: 'rfx_external_users_aggregate', aggregate: { __typename?: 'rfx_external_users_aggregate_fields', count: number } | null } }>, request_step: { __typename?: 'request_steps', result: RequestStepResultEnum | null, createdAt: string, targetTimeValue: any, supplierFillInTasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, submissionsClosedAt: string | null, request_form: { __typename?: 'request_forms', request_form_template_id: string | null } | null, organisation_supplier: { __typename?: 'organisation_suppliers', name: string, id: string } | null }>, scoringTasks: Array<{ __typename?: 'request_step_tasks', completedOn: string | null, submissionsClosedAt: string | null, id: string }>, request_form_templates: Array<{ __typename?: 'request_form_templates', id: string, title: string, type: FormTypeEnum, createdAt: string, isSent: boolean, rfx_request_form_templates_rank: { __typename?: 'rfx_request_form_templates_ranks', id: string, rank: number } | null, request_forms: Array<{ __typename?: 'request_forms', id: string }> }> } };

export type SetRequestStepTasksSubmissionsClosedAtMutationVariables = Exact<{
  requestStepTaskIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  submissionsClosedAt: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type SetRequestStepTasksSubmissionsClosedAtMutation = { __typename?: 'mutation_root', update_request_step_tasks: { __typename?: 'request_step_tasks_mutation_response', returning: Array<{ __typename?: 'request_step_tasks', id: string, submissionsClosedAt: string | null }> } | null };

export type SetRfxIsReopenedMutationVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
}>;


export type SetRfxIsReopenedMutation = { __typename?: 'mutation_root', updatedRfx: { __typename?: 'rfx', id: string } | null };

export type UpdateRfxStateMutationVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
  rfxStatus: Scalars['String']['input'];
}>;


export type UpdateRfxStateMutation = { __typename?: 'mutation_root', update_rfx_by_pk: { __typename?: 'rfx', id: string, status: string } | null };

export type UpdateRfxSupplierAwardStatusMutationVariables = Exact<{
  rfxSupplierId: Scalars['uuid']['input'];
  status: Scalars['String']['input'];
}>;


export type UpdateRfxSupplierAwardStatusMutation = { __typename?: 'mutation_root', update_rfx_suppliers_by_pk: { __typename?: 'rfx_suppliers', id: string, status: string, rfxId: string } | null };

export type UpdateRfxSupplierHasParticipatedInScoringMutationVariables = Exact<{
  rfxSupplierIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  hasParticipatedInScoring: Scalars['Boolean']['input'];
}>;


export type UpdateRfxSupplierHasParticipatedInScoringMutation = { __typename?: 'mutation_root', update_rfx_suppliers: { __typename?: 'rfx_suppliers_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'rfx_suppliers', id: string }> } | null };

export type UpsertRequestComputedPropertiesMutationVariables = Exact<{
  updatedProperties: RequestComputedPropertiesInsertInput;
}>;


export type UpsertRequestComputedPropertiesMutation = { __typename?: 'mutation_root', insert_request_computed_properties_one: { __typename?: 'request_computed_properties', id: string, requestId: string } | null };

export type UserHasTaskPermissionQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  taskId: Scalars['uuid']['input'];
}>;


export type UserHasTaskPermissionQuery = { __typename?: 'query_root', request_step_task_users: Array<{ __typename?: 'request_step_task_users', userId: string }> };

export type AddRfxSupplierContactsToTaskMutationVariables = Exact<{
  taskUsers: Array<RequestStepTaskUsersInsertInput> | RequestStepTaskUsersInsertInput;
}>;


export type AddRfxSupplierContactsToTaskMutation = { __typename?: 'mutation_root', insert_request_step_task_users: { __typename?: 'request_step_task_users_mutation_response', affected_rows: number } | null };

export type DeleteRfxExternalUsersMutationVariables = Exact<{
  externalUserIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  rfxSupplierId: Scalars['uuid']['input'];
}>;


export type DeleteRfxExternalUsersMutation = { __typename?: 'mutation_root', delete_rfx_external_users: { __typename?: 'rfx_external_users_mutation_response', returning: Array<{ __typename?: 'rfx_external_users', id: string }> } | null };

export type FindExistingContactsAndUsersQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type FindExistingContactsAndUsersQuery = { __typename?: 'query_root', external_contacts: Array<{ __typename?: 'external_contacts', id: string, email: string, userId: string | null }>, users: Array<{ __typename?: 'users', id: string, email: string }> };

export type GetExternalContactsByIdsQueryVariables = Exact<{
  externalContactIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetExternalContactsByIdsQuery = { __typename?: 'query_root', external_contacts: Array<{ __typename?: 'external_contacts', id: string, userId: string | null }> };

export type GetGlobalProductAndSupplierDetailsQueryVariables = Exact<{
  productId: Scalars['uuid']['input'];
}>;


export type GetGlobalProductAndSupplierDetailsQuery = { __typename?: 'query_root', products_and_services_by_pk: { __typename?: 'products_and_services', id: string, name: string, description: string | null, website: string | null, logoUrl: string | null, supplier: { __typename?: 'suppliers', id: string, name: string, website: string | null, logoUrl: string | null, isReseller: boolean, organisation_suppliers_brands: Array<{ __typename?: 'organisation_suppliers_brands', id: string, organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string }> }> } | null } | null };

export type GetGlobalSupplierDetailsQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
}>;


export type GetGlobalSupplierDetailsQuery = { __typename?: 'query_root', suppliers_by_pk: { __typename?: 'suppliers', id: string, name: string, website: string | null, logoUrl: string | null, description: string | null, isReseller: boolean, organisation_suppliers_brands: Array<{ __typename?: 'organisation_suppliers_brands', id: string, organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string }> }> } | null };

export type GetRfxRequestStepsWithAwardedRfxSupplierQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRfxRequestStepsWithAwardedRfxSupplierQuery = { __typename?: 'query_root', request_steps: Array<{ __typename?: 'request_steps', id: string, requestId: string, input: any }>, rfx: Array<{ __typename?: 'rfx', id: string, status: string, requestStepId: string, rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, status: string, organisationSupplierId: string, organisation_supplier: { __typename?: 'organisation_suppliers', name: string } }> }> };

export type GetRfxRequiresConfidentialityAgreementQueryVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
}>;


export type GetRfxRequiresConfidentialityAgreementQuery = { __typename?: 'query_root', rfx_by_pk: { __typename?: 'rfx', id: string, request_step: { __typename?: 'request_steps', id: string, requiresConfidentialityAgreement: any } } | null };

export type GetRfxSuppliersByIdQueryVariables = Exact<{
  rfxSupplierId: Scalars['uuid']['input'];
}>;


export type GetRfxSuppliersByIdQuery = { __typename?: 'query_root', rfx_suppliers_by_pk: { __typename?: 'rfx_suppliers', id: string, rfxId: string, status: string, organisationSupplierId: string, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string } } | null };

export type GetRfxSupplierContactsTasksQueryVariables = Exact<{
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetRfxSupplierContactsTasksQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, request_step_task_users: Array<{ __typename?: 'request_step_task_users', user_id: string }> }> };

export type GetRfxSupplierRfxExternalUsersQueryVariables = Exact<{
  rfxSupplierId: Scalars['uuid']['input'];
}>;


export type GetRfxSupplierRfxExternalUsersQuery = { __typename?: 'query_root', rfx_external_users: Array<{ __typename?: 'rfx_external_users', id: string, external_contact: { __typename?: 'external_contacts', id: string, email: string } }> };

export type GetRfxSupplierTasksQueryVariables = Exact<{
  organisationSupplierId: Scalars['uuid']['input'];
  requestStepId: Scalars['uuid']['input'];
}>;


export type GetRfxSupplierTasksQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, request_step_task_users: Array<{ __typename?: 'request_step_task_users', user_id: string }> }> };

export type GetRfxSuppliersQueryVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
}>;


export type GetRfxSuppliersQuery = { __typename?: 'query_root', rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, organisationProductId: string | null, organisationSupplierId: string, status: string, hasParticipatedInScoring: boolean, product: { __typename?: 'organisation_products_and_services', id: string, displayName: string } | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null }, rfx_external_users: Array<{ __typename?: 'rfx_external_users', id: string, external_contact: { __typename?: 'external_contacts', id: string, firstName: string | null, lastName: string | null, email: string, userId: string | null } }>, rfx: { __typename?: 'rfx', id: string, requestId: string, requestStepId: string } }> };

export type GetRfxSuppliersContactsQueryVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
}>;


export type GetRfxSuppliersContactsQuery = { __typename?: 'query_root', rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', rfx_external_users: Array<{ __typename?: 'rfx_external_users', id: string, external_contact: { __typename?: 'external_contacts', id: string, email: string } }> }> };

export type GetUsersByEmailQueryVariables = Exact<{
  emails: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetUsersByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, email: string, role: string, isArchived: boolean }> };

export type InsertExternalContactsMutationVariables = Exact<{
  input: Array<ExternalContactsInsertInput> | ExternalContactsInsertInput;
}>;


export type InsertExternalContactsMutation = { __typename?: 'mutation_root', insert_external_contacts: { __typename?: 'external_contacts_mutation_response', returning: Array<{ __typename?: 'external_contacts', id: string }> } | null };

export type InsertOrganisationSupplierOneMutationVariables = Exact<{
  input: OrganisationSuppliersInsertInput;
}>;


export type InsertOrganisationSupplierOneMutation = { __typename?: 'mutation_root', insert_organisation_suppliers_one: { __typename?: 'organisation_suppliers', id: string, organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string }> } | null };

export type InsertRfxExternalUsersMutationVariables = Exact<{
  externalUsers: Array<RfxExternalUsersInsertInput> | RfxExternalUsersInsertInput;
}>;


export type InsertRfxExternalUsersMutation = { __typename?: 'mutation_root', insert_rfx_external_users: { __typename?: 'rfx_external_users_mutation_response', returning: Array<{ __typename?: 'rfx_external_users', id: string }> } | null };

export type InsertRfxSuppliersOneMutationVariables = Exact<{
  rfx_supplier: RfxSuppliersInsertInput;
}>;


export type InsertRfxSuppliersOneMutation = { __typename?: 'mutation_root', insert_rfx_suppliers_one: { __typename?: 'rfx_suppliers', id: string } | null };

export type CreateRfxConfidentialityAgreementMutationVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
  rfxSupplierId: Scalars['uuid']['input'];
  confidentialityAgreement: Scalars['String']['input'];
}>;


export type CreateRfxConfidentialityAgreementMutation = { __typename?: 'mutation_root', insert_rfx_confidentiality_agreement: { __typename?: 'rfx_confidentiality_agreement_mutation_response', affected_rows: number } | null };

export type CreateSupplierOnboardingTasksMutationVariables = Exact<{
  tasks: Array<RequestStepTasksInsertInput> | RequestStepTasksInsertInput;
  taskUsers: Array<RequestStepTaskUsersInsertInput> | RequestStepTaskUsersInsertInput;
}>;


export type CreateSupplierOnboardingTasksMutation = { __typename?: 'mutation_root', insert_request_step_tasks: { __typename?: 'request_step_tasks_mutation_response', affected_rows: number } | null, insert_request_step_task_users: { __typename?: 'request_step_task_users_mutation_response', affected_rows: number } | null };

export type CreateUsersMutationVariables = Exact<{
  users: Array<UsersInsertInput> | UsersInsertInput;
}>;


export type CreateUsersMutation = { __typename?: 'mutation_root', insert_users: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', email: string, id: string }> } | null };

export type GetRfxSupplierContactsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRfxSupplierContactsQuery = { __typename?: 'query_root', rfx_suppliers_by_pk: { __typename?: 'rfx_suppliers', id: string, organisationSupplierId: string, rfx_external_users: Array<{ __typename?: 'rfx_external_users', id: string, external_contact: { __typename?: 'external_contacts', id: string, firstName: string | null, lastName: string | null, email: string, user: { __typename?: 'users', id: string, email: string } | null } }> } | null };

export type RfxGetUsersByEmailQueryVariables = Exact<{
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RfxGetUsersByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, email: string, role: string }> };

export type UpdateExternalContactsManyMutationVariables = Exact<{
  updates: Array<ExternalContactsUpdates> | ExternalContactsUpdates;
}>;


export type UpdateExternalContactsManyMutation = { __typename?: 'mutation_root', update_external_contacts_many: Array<{ __typename?: 'external_contacts_mutation_response', returning: Array<{ __typename?: 'external_contacts', id: string }> } | null> | null };

export type ListRfxRequestFormTemplateWeightingsQueryVariables = Exact<{
  requestFormTemplateIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ListRfxRequestFormTemplateWeightingsQuery = { __typename?: 'query_root', rfx_request_form_template_weighting: Array<{ __typename?: 'rfx_request_form_template_weighting', id: string, requestFormTemplateId: string, weighting: number }> };

export type CheckRfxReviewerForRequestFormTemplateQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  requestFormTemplateId: Scalars['uuid']['input'];
}>;


export type CheckRfxReviewerForRequestFormTemplateQuery = { __typename?: 'query_root', request_form_template_reviewers: Array<{ __typename?: 'request_form_template_reviewers', id: string }> };

export type DeleteRfxReviewersMutationVariables = Exact<{
  requestFormTemplateId: Scalars['uuid']['input'];
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteRfxReviewersMutation = { __typename?: 'mutation_root', delete_request_form_template_reviewers: { __typename?: 'request_form_template_reviewers_mutation_response', affected_rows: number } | null };

export type DeleteRfxScoringTasksAndReviewersMutationVariables = Exact<{
  userIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  requestFormTemplateId: Scalars['uuid']['input'];
  requestStepTaskIdsToDelete: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteRfxScoringTasksAndReviewersMutation = { __typename?: 'mutation_root', delete_request_step_task_users: { __typename?: 'request_step_task_users_mutation_response', returning: Array<{ __typename?: 'request_step_task_users', user_id: string }> } | null, delete_request_step_tasks: { __typename?: 'request_step_tasks_mutation_response', returning: Array<{ __typename?: 'request_step_tasks', id: string }> } | null, delete_request_form_template_reviewers: { __typename?: 'request_form_template_reviewers_mutation_response', affected_rows: number } | null };

export type GetRequestStepTasksToDeleteQueryVariables = Exact<{
  requestFormTemplateId: Scalars['uuid']['input'];
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetRequestStepTasksToDeleteQuery = { __typename?: 'query_root', request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string }> };

export type InsertRfxReviewersMutationVariables = Exact<{
  reviewers: Array<RequestFormTemplateReviewersInsertInput> | RequestFormTemplateReviewersInsertInput;
}>;


export type InsertRfxReviewersMutation = { __typename?: 'mutation_root', insert_request_form_template_reviewers: { __typename?: 'request_form_template_reviewers_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'request_form_template_reviewers', id: string, userId: string, requestFormTemplateId: string, organisationId: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, request_step_task_users: Array<{ __typename?: 'request_step_task_users', request_step_task: { __typename?: 'request_step_tasks', id: string } }> } }> } | null };

export type ListAllAndPastRfxReviewersQueryVariables = Exact<{
  requestFormTemplateIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  requestStepId: Scalars['uuid']['input'];
}>;


export type ListAllAndPastRfxReviewersQuery = { __typename?: 'query_root', requestFormTemplateReviewers: Array<{ __typename?: 'request_form_template_reviewers', id: string, requestFormTemplateId: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, request_step_task_users: Array<{ __typename?: 'request_step_task_users', request_step_task: { __typename?: 'request_step_tasks', id: string } }> } }>, closedScoringTaskUsers: Array<{ __typename?: 'request_step_task_users', request_step_task: { __typename?: 'request_step_tasks', id: string, request_form_template_id: string | null }, user: { __typename?: 'users', id: string } }> };

export type ListRfxReviewersQueryVariables = Exact<{
  requestFormTemplateIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  requestStepId: Scalars['uuid']['input'];
}>;


export type ListRfxReviewersQuery = { __typename?: 'query_root', request_form_template_reviewers: Array<{ __typename?: 'request_form_template_reviewers', id: string, requestFormTemplateId: string, userId: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } }> };

export type GetRfxByIdQueryVariables = Exact<{
  rfxId: Scalars['uuid']['input'];
}>;


export type GetRfxByIdQuery = { __typename?: 'query_root', rfx_by_pk: { __typename?: 'rfx', requestStepId: string, requestId: string } | null };

export type ListOrgSuppliersForScreeningQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOrgSuppliersForScreeningQuery = { __typename?: 'query_root', suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, isPerson: boolean | null }> };

export type ListOrgSuppliersForUserOwnerIdQueryVariables = Exact<{
  supplierIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type ListOrgSuppliersForUserOwnerIdQuery = { __typename?: 'query_root', suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null }> };

export type DeleteRiskAttributeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteRiskAttributeMutation = { __typename?: 'mutation_root', deletedRiskAttribute: { __typename?: 'risk_attributes', id: string } | null };

export type DeleteRiskLevelMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteRiskLevelMutation = { __typename?: 'mutation_root', deletedRiskLevel: { __typename?: 'risk_levels', id: string } | null };

export type DeleteRiskMatrixCellMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteRiskMatrixCellMutation = { __typename?: 'mutation_root', deletedRiskMatrixCell: { __typename?: 'risk_matrix_cells', id: string } | null };

export type ListRiskAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListRiskAttributesQuery = { __typename?: 'query_root', riskAttributes: Array<{ __typename?: 'risk_attributes', id: string, name: string, type: RiskAttributesTypeEnum }>, riskLevels: Array<{ __typename?: 'risk_levels', id: string, name: string, description: string, score: number, type: RiskLevelsTypeEnum }>, riskMatrixCells: Array<{ __typename?: 'risk_matrix_cells', id: string, probabilityId: string, impactId: string, score: number }>, suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, state: OrganisationSupplierStateEnum }> };

export type InsertRiskAttributeMutationVariables = Exact<{
  name: Scalars['String']['input'];
  type: RiskAttributesTypeEnum;
}>;


export type InsertRiskAttributeMutation = { __typename?: 'mutation_root', insert_risk_attributes_one: { __typename?: 'risk_attributes', id: string } | null };

export type InsertRiskLevelMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  score: Scalars['Int']['input'];
  type: RiskLevelsTypeEnum;
}>;


export type InsertRiskLevelMutation = { __typename?: 'mutation_root', insert_risk_levels_one: { __typename?: 'risk_levels', id: string } | null };

export type InsertRiskMatrixCellMutationVariables = Exact<{
  probabilityId: Scalars['uuid']['input'];
  impactId: Scalars['uuid']['input'];
  score: Scalars['Int']['input'];
}>;


export type InsertRiskMatrixCellMutation = { __typename?: 'mutation_root', insert_risk_matrix_cells_one: { __typename?: 'risk_matrix_cells', id: string } | null };

export type UpdateRiskAttributeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateRiskAttributeMutation = { __typename?: 'mutation_root', update_risk_attributes_by_pk: { __typename?: 'risk_attributes', id: string } | null };

export type UpdateRiskLevelMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  score: Scalars['Int']['input'];
}>;


export type UpdateRiskLevelMutation = { __typename?: 'mutation_root', update_risk_levels_by_pk: { __typename?: 'risk_levels', id: string } | null };

export type UpdateRiskMatrixCellMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  score: Scalars['Int']['input'];
}>;


export type UpdateRiskMatrixCellMutation = { __typename?: 'mutation_root', update_risk_matrix_cells_by_pk: { __typename?: 'risk_matrix_cells', id: string } | null };

export type CreateRiskMutationVariables = Exact<{
  input: RisksInsertInput;
}>;


export type CreateRiskMutation = { __typename?: 'mutation_root', createdRisk: { __typename?: 'risks', id: string, createdAt: string, updatedAt: string, deletedAt: string | null, organisationId: string, createdBy: string, updatedBy: string, deletedBy: string | null, orgSupplierId: string | null, name: string, description: string | null, treatment: string | null, sendReminderDaysBefore: number | null, deadline: string | null, inherentRiskProbabilityId: string, inherentRiskImpactId: string, residualRiskProbabilityId: string, residualRiskImpactId: string, isOpen: boolean, stageId: string, treatmentTypeId: string | null, requestId: string | null, requestFormId: string | null, questionName: string | null, closedAt: string | null, closedBy: string | null } | null };

export type DeleteRiskMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  deletedBy: Scalars['uuid']['input'];
}>;


export type DeleteRiskMutation = { __typename?: 'mutation_root', deletedRisk: { __typename?: 'risks', id: string, orgSupplierId: string | null, requestId: string | null } | null };

export type GetRiskQueryVariables = Exact<{
  where: RisksBoolExp;
}>;


export type GetRiskQuery = { __typename?: 'query_root', risks: Array<{ __typename?: 'risks', id: string, name: string, description: string | null, treatment: string | null, deadline: string | null, sendReminderDaysBefore: number | null, isOpen: boolean, createdAt: string, updatedAt: string, closedAt: string | null, questionName: string | null, categories: Array<{ __typename?: 'risk_categories', category: { __typename?: 'risk_attributes', id: string, name: string } }>, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, website: string | null, description: string | null, state: OrganisationSupplierStateEnum } | null, riskOwners: Array<{ __typename?: 'risk_owners', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }>, treatmentAssignees: Array<{ __typename?: 'risk_owners', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }>, inherentRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskMatrix: { __typename?: 'risk_matrix_cells', score: number } | null, residualRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskMatrix: { __typename?: 'risk_matrix_cells', score: number } | null, treatmentType: { __typename?: 'risk_attributes', id: string, name: string } | null, stage: { __typename?: 'risk_attributes', id: string, name: string }, createdByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, updatedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, closedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, request: { __typename?: 'requests', id: string, name: string } | null, requestForm: { __typename?: 'request_forms', id: string, title: string } | null }> };

export type ListRisksQueryVariables = Exact<{
  where: InputMaybe<RisksBoolExp>;
}>;


export type ListRisksQuery = { __typename?: 'query_root', risks: Array<{ __typename?: 'risks', id: string, name: string, createdAt: string, updatedAt: string, closedAt: string | null, description: string | null, treatment: string | null, deadline: string | null, sendReminderDaysBefore: number | null, isOpen: boolean, questionName: string | null, createdByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, updatedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, closedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, state: OrganisationSupplierStateEnum } | null, categories: Array<{ __typename?: 'risk_categories', category: { __typename?: 'risk_attributes', name: string } }>, treatmentType: { __typename?: 'risk_attributes', name: string } | null, riskOwners: Array<{ __typename?: 'risk_owners', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }>, treatmentAssignees: Array<{ __typename?: 'risk_owners', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }>, inherentRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskMatrix: { __typename?: 'risk_matrix_cells', score: number } | null, residualRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskMatrix: { __typename?: 'risk_matrix_cells', score: number } | null, stage: { __typename?: 'risk_attributes', name: string }, request: { __typename?: 'requests', id: string, name: string } | null, requestForm: { __typename?: 'request_forms', id: string, title: string } | null }> };

export type GetRequestForUserByIdQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestForUserByIdQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'requests', id: string }> };

export type UpdateRiskMutationVariables = Exact<{
  riskId: Scalars['uuid']['input'];
  input: RisksSetInput;
}>;


export type UpdateRiskMutation = { __typename?: 'mutation_root', updatedRisk: { __typename?: 'risks', id: string, createdAt: string, updatedAt: string, deletedAt: string | null, organisationId: string, createdBy: string, updatedBy: string, deletedBy: string | null, orgSupplierId: string | null, name: string, description: string | null, treatment: string | null, sendReminderDaysBefore: number | null, deadline: string | null, inherentRiskProbabilityId: string, inherentRiskImpactId: string, residualRiskProbabilityId: string, residualRiskImpactId: string, isOpen: boolean, stageId: string, treatmentTypeId: string | null, requestId: string | null, requestFormId: string | null, questionName: string | null, closedAt: string | null, closedBy: string | null } | null };

export type GetRiskBeforeUpdateQueryVariables = Exact<{
  where: RisksBoolExp;
}>;


export type GetRiskBeforeUpdateQuery = { __typename?: 'query_root', risks: Array<{ __typename?: 'risks', id: string, createdAt: string, updatedAt: string, deletedAt: string | null, organisationId: string, createdBy: string, updatedBy: string, deletedBy: string | null, orgSupplierId: string | null, name: string, description: string | null, treatment: string | null, sendReminderDaysBefore: number | null, deadline: string | null, inherentRiskProbabilityId: string, inherentRiskImpactId: string, residualRiskProbabilityId: string, residualRiskImpactId: string, isOpen: boolean, stageId: string, treatmentTypeId: string | null, requestId: string | null, requestFormId: string | null, questionName: string | null, closedAt: string | null, closedBy: string | null, riskOwners: Array<{ __typename?: 'risk_owners', userId: string }>, treatmentAssignees: Array<{ __typename?: 'risk_owners', userId: string }>, categories: Array<{ __typename?: 'risk_categories', id: string }> }> };

export type GetRiskSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRiskSettingsQuery = { __typename?: 'query_root', riskSettings: Array<{ __typename?: 'risk_settings', id: string, riskScoreMethodology: OverrideTypes["RiskScoreMethodology"] | null }> };

export type UpsertRiskSettingsMutationVariables = Exact<{
  input: RiskSettingsInsertInput;
}>;


export type UpsertRiskSettingsMutation = { __typename?: 'mutation_root', insert_risk_settings: { __typename?: 'risk_settings_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'risk_settings', id: string, riskScoreMethodology: OverrideTypes["RiskScoreMethodology"] | null }> } | null };

export type ListOrgSuppliersByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ListOrgSuppliersByIdsQuery = { __typename?: 'query_root', suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null }> };

export type SummaryRiskLevelFragment = { __typename?: 'risks', id: string, inherentRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, inherentRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null, residualRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number }, residualRiskMatrix: { __typename?: 'risk_matrix_cells', id: string, score: number } | null };

export type DeleteRiskCategoriesMutationVariables = Exact<{
  riskId: Scalars['uuid']['input'];
}>;


export type DeleteRiskCategoriesMutation = { __typename?: 'mutation_root', deletedRows: { __typename?: 'risk_categories_mutation_response', affected_rows: number } | null };

export type DeleteRiskTemplateCategoriesMutationVariables = Exact<{
  riskTemplateId: Scalars['uuid']['input'];
}>;


export type DeleteRiskTemplateCategoriesMutation = { __typename?: 'mutation_root', deletedRows: { __typename?: 'risk_template_categories_mutation_response', affected_rows: number } | null };

export type InsertRiskCategoriesMutationVariables = Exact<{
  riskCategories: Array<RiskCategoriesInsertInput> | RiskCategoriesInsertInput;
}>;


export type InsertRiskCategoriesMutation = { __typename?: 'mutation_root', insertedRows: { __typename?: 'risk_categories_mutation_response', affected_rows: number } | null };

export type InsertRiskTemplateCategoriesMutationVariables = Exact<{
  riskCategories: Array<RiskTemplateCategoriesInsertInput> | RiskTemplateCategoriesInsertInput;
}>;


export type InsertRiskTemplateCategoriesMutation = { __typename?: 'mutation_root', insertedRows: { __typename?: 'risk_template_categories_mutation_response', affected_rows: number } | null };

export type DeleteRiskOwnersMutationVariables = Exact<{
  riskId: Scalars['uuid']['input'];
  userType: RiskUsersTypeEnum;
}>;


export type DeleteRiskOwnersMutation = { __typename?: 'mutation_root', deletedRows: { __typename?: 'risk_owners_mutation_response', affected_rows: number } | null };

export type DeleteRiskTemplateOwnersMutationVariables = Exact<{
  riskTemplateId: Scalars['uuid']['input'];
  userType: RiskUsersTypeEnum;
}>;


export type DeleteRiskTemplateOwnersMutation = { __typename?: 'mutation_root', deletedRows: { __typename?: 'risk_template_owners_mutation_response', affected_rows: number } | null };

export type InsertRiskOwnersMutationVariables = Exact<{
  riskOwners: Array<RiskOwnersInsertInput> | RiskOwnersInsertInput;
}>;


export type InsertRiskOwnersMutation = { __typename?: 'mutation_root', insertedRows: { __typename?: 'risk_owners_mutation_response', affected_rows: number } | null };

export type InsertRiskTemplateOwnersMutationVariables = Exact<{
  riskOwners: Array<RiskTemplateOwnersInsertInput> | RiskTemplateOwnersInsertInput;
}>;


export type InsertRiskTemplateOwnersMutation = { __typename?: 'mutation_root', insertedRows: { __typename?: 'risk_template_owners_mutation_response', affected_rows: number } | null };

export type RiskTemplateFieldsFragment = { __typename?: 'risk_templates', id: string, createdAt: string, updatedAt: string, deletedAt: string | null, organisationId: string, createdBy: string, updatedBy: string, deletedBy: string | null, orgSupplierId: string | null, name: string, description: string | null, treatment: string | null, sendReminderDaysBefore: number | null, deadline: string | null, inherentRiskProbabilityId: string | null, inherentRiskImpactId: string | null, residualRiskProbabilityId: string | null, residualRiskImpactId: string | null, stageId: string | null, treatmentTypeId: string | null };

export type CreateRiskTemplateMutationVariables = Exact<{
  input: RiskTemplatesInsertInput;
}>;


export type CreateRiskTemplateMutation = { __typename?: 'mutation_root', createdRiskTemplate: { __typename?: 'risk_templates', id: string, createdAt: string, updatedAt: string, deletedAt: string | null, organisationId: string, createdBy: string, updatedBy: string, deletedBy: string | null, orgSupplierId: string | null, name: string, description: string | null, treatment: string | null, sendReminderDaysBefore: number | null, deadline: string | null, inherentRiskProbabilityId: string | null, inherentRiskImpactId: string | null, residualRiskProbabilityId: string | null, residualRiskImpactId: string | null, stageId: string | null, treatmentTypeId: string | null } | null };

export type DeleteRiskTemplateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  deletedBy: Scalars['uuid']['input'];
}>;


export type DeleteRiskTemplateMutation = { __typename?: 'mutation_root', deletedRiskTemplate: { __typename?: 'risk_templates', id: string } | null };

export type GetRiskTemplateQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRiskTemplateQuery = { __typename?: 'query_root', riskTemplates: Array<{ __typename?: 'risk_templates', id: string, name: string, description: string | null, treatment: string | null, deadline: string | null, sendReminderDaysBefore: number | null, createdAt: string, updatedAt: string, categories: Array<{ __typename?: 'risk_template_categories', category: { __typename?: 'risk_attributes', id: string, name: string } }>, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, website: string | null, description: string | null, state: OrganisationSupplierStateEnum } | null, riskTemplateOwners: Array<{ __typename?: 'risk_template_owners', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }>, treatmentAssignees: Array<{ __typename?: 'risk_template_owners', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }>, inherentRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number } | null, inherentRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number } | null, inherentRiskMatrix: { __typename?: 'risk_matrix_cells', score: number } | null, residualRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number } | null, residualRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number } | null, residualRiskMatrix: { __typename?: 'risk_matrix_cells', score: number } | null, treatmentType: { __typename?: 'risk_attributes', id: string, name: string } | null, stage: { __typename?: 'risk_attributes', id: string, name: string } | null }> };

export type ListRiskTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListRiskTemplatesQuery = { __typename?: 'query_root', riskTemplates: Array<{ __typename?: 'risk_templates', id: string, name: string, createdAt: string, updatedAt: string, description: string | null, treatment: string | null, deadline: string | null, sendReminderDaysBefore: number | null, createdByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, updatedByUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string }, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null, state: OrganisationSupplierStateEnum } | null, categories: Array<{ __typename?: 'risk_template_categories', category: { __typename?: 'risk_attributes', name: string } }>, treatmentType: { __typename?: 'risk_attributes', name: string } | null, riskTemplateOwners: Array<{ __typename?: 'risk_template_owners', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }>, treatmentAssignees: Array<{ __typename?: 'risk_template_owners', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }>, inherentRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number } | null, inherentRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number } | null, inherentRiskMatrix: { __typename?: 'risk_matrix_cells', score: number } | null, residualRiskProbability: { __typename?: 'risk_levels', id: string, name: string, score: number } | null, residualRiskImpact: { __typename?: 'risk_levels', id: string, name: string, score: number } | null, residualRiskMatrix: { __typename?: 'risk_matrix_cells', score: number } | null, stage: { __typename?: 'risk_attributes', name: string } | null }> };

export type UpdateRiskTemplateMutationVariables = Exact<{
  riskTemplateId: Scalars['uuid']['input'];
  input: RiskTemplatesSetInput;
}>;


export type UpdateRiskTemplateMutation = { __typename?: 'mutation_root', updatedRiskTemplate: { __typename?: 'risk_templates', id: string, createdAt: string, updatedAt: string, deletedAt: string | null, organisationId: string, createdBy: string, updatedBy: string, deletedBy: string | null, orgSupplierId: string | null, name: string, description: string | null, treatment: string | null, sendReminderDaysBefore: number | null, deadline: string | null, inherentRiskProbabilityId: string | null, inherentRiskImpactId: string | null, residualRiskProbabilityId: string | null, residualRiskImpactId: string | null, stageId: string | null, treatmentTypeId: string | null } | null };

export type InsertRiskVersionMutationVariables = Exact<{
  input: RiskVersionsInsertInput;
}>;


export type InsertRiskVersionMutation = { __typename?: 'mutation_root', createdRiskVersion: { __typename?: 'risk_versions', id: string } | null };

export type RiskFieldsFragment = { __typename?: 'risks', id: string, createdAt: string, updatedAt: string, deletedAt: string | null, organisationId: string, createdBy: string, updatedBy: string, deletedBy: string | null, orgSupplierId: string | null, name: string, description: string | null, treatment: string | null, sendReminderDaysBefore: number | null, deadline: string | null, inherentRiskProbabilityId: string, inherentRiskImpactId: string, residualRiskProbabilityId: string, residualRiskImpactId: string, isOpen: boolean, stageId: string, treatmentTypeId: string | null, requestId: string | null, requestFormId: string | null, questionName: string | null, closedAt: string | null, closedBy: string | null };

export type CreateSimpleOrganisationSupplierMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  remoteId: Scalars['String']['input'];
}>;


export type CreateSimpleOrganisationSupplierMutation = { __typename?: 'mutation_root', update_organisation_suppliers: { __typename?: 'organisation_suppliers_mutation_response', returning: Array<{ __typename?: 'organisation_suppliers', id: string }> } | null, insert_organisation_suppliers_one: { __typename?: 'organisation_suppliers', id: string } | null };

export type GetOrganisationSuppliersDataToTransferQueryVariables = Exact<{
  organisationSupplierIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  targetOrganisationSupplierId: Scalars['uuid']['input'];
}>;


export type GetOrganisationSuppliersDataToTransferQuery = { __typename?: 'query_root', organisation_products_and_services: Array<{ __typename?: 'organisation_products_and_services', id: string, organisationSupplierId: string }>, requests: Array<{ __typename?: 'requests', id: string, request_supplier: string | null }>, engagements: Array<{ __typename?: 'engagements', id: string, organisationSupplierId: string }>, internal_contacts: Array<{ __typename?: 'internal_contacts', id: string, supplierId: string }>, documents: Array<{ __typename?: 'documents', id: string, organisationSupplierId: string | null }>, agreements: Array<{ __typename?: 'agreements', id: string, supplierId: string }>, organisation_supplier_historic_submissions: Array<{ __typename?: 'organisation_supplier_historic_submissions', id: string, organisationSupplierId: string }>, risks: Array<{ __typename?: 'risks', id: string, orgSupplierId: string | null }>, risk_versions: Array<{ __typename?: 'risk_versions', id: string, orgSupplierId: string }>, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', id: string, organisationSupplierId: string }>, assessments: Array<{ __typename?: 'assessments', id: string, organisationSupplierId: string }>, purchase_orders: Array<{ __typename?: 'purchase_orders', id: string, supplierId: string }>, external_risk_scores: Array<{ __typename?: 'external_risk_scores', id: string, organisationSupplierId: string }>, entity_bank_details: Array<{ __typename?: 'entity_bank_details', id: string, organisationSupplierId: string | null, bankDetailsId: string, isPrimary: boolean | null }> };

export type ListOrganisationSupplierProfilesQueryVariables = Exact<{
  organisationSupplierIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ListOrganisationSupplierProfilesQuery = { __typename?: 'query_root', organisation_supplier_profiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string }> };

export type MergeOrganisationSuppliersMutationVariables = Exact<{
  targetOrganisationSupplierId: Scalars['uuid']['input'];
  targetOrganisationFieldsToApply: InputMaybe<OrganisationSuppliersSetInput>;
  organisationSupplierIdsToArchive: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  profileIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  productAndServiceIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  requestIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  engagementIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  internalContactIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  documentIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  agreementIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  historicSubmissionIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  riskIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  riskVersionIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  tagIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  assessmentIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  purchaseOrderIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  externalRiskScoreIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  bankAccountLinkIdsToDelete: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  bankAccountLinksToInsert: Array<EntityBankDetailsInsertInput> | EntityBankDetailsInsertInput;
}>;


export type MergeOrganisationSuppliersMutation = { __typename?: 'mutation_root', update_organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', id: string } | null, update_organisation_suppliers: { __typename?: 'organisation_suppliers_mutation_response', returning: Array<{ __typename?: 'organisation_suppliers', id: string }> } | null, update_organisation_products_and_services: { __typename?: 'organisation_products_and_services_mutation_response', returning: Array<{ __typename?: 'organisation_products_and_services', id: string }> } | null, update_requests: { __typename?: 'requests_mutation_response', returning: Array<{ __typename?: 'requests', id: string }> } | null, update_organisation_supplier_profiles: { __typename?: 'organisation_supplier_profiles_mutation_response', returning: Array<{ __typename?: 'organisation_supplier_profiles', id: string }> } | null, delete_entity_bank_details: { __typename?: 'entity_bank_details_mutation_response', affected_rows: number } | null, insert_entity_bank_details: { __typename?: 'entity_bank_details_mutation_response', returning: Array<{ __typename?: 'entity_bank_details', id: string, bankDetailsId: string }> } | null, update_engagements: { __typename?: 'engagements_mutation_response', returning: Array<{ __typename?: 'engagements', id: string }> } | null, update_internal_contacts: { __typename?: 'internal_contacts_mutation_response', returning: Array<{ __typename?: 'internal_contacts', id: string }> } | null, update_documents: { __typename?: 'documents_mutation_response', returning: Array<{ __typename?: 'documents', id: string }> } | null, update_agreements: { __typename?: 'agreements_mutation_response', returning: Array<{ __typename?: 'agreements', id: string }> } | null, update_organisation_supplier_historic_submissions: { __typename?: 'organisation_supplier_historic_submissions_mutation_response', returning: Array<{ __typename?: 'organisation_supplier_historic_submissions', id: string }> } | null, update_risks: { __typename?: 'risks_mutation_response', returning: Array<{ __typename?: 'risks', id: string }> } | null, update_risk_versions: { __typename?: 'risk_versions_mutation_response', returning: Array<{ __typename?: 'risk_versions', id: string }> } | null, update_organisation_supplier_tags: { __typename?: 'organisation_supplier_tags_mutation_response', returning: Array<{ __typename?: 'organisation_supplier_tags', id: string }> } | null, update_assessments: { __typename?: 'assessments_mutation_response', returning: Array<{ __typename?: 'assessments', id: string }> } | null, update_purchase_orders: { __typename?: 'purchase_orders_mutation_response', returning: Array<{ __typename?: 'purchase_orders', id: string }> } | null, update_external_risk_scores: { __typename?: 'external_risk_scores_mutation_response', returning: Array<{ __typename?: 'external_risk_scores', id: string }> } | null };

export type UpdateSupplierIdOnSupplierProfilesMutationVariables = Exact<{
  fromSupplierId: Scalars['uuid']['input'];
  toSupplierId: Scalars['uuid']['input'];
  subsidiaryIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpdateSupplierIdOnSupplierProfilesMutation = { __typename?: 'mutation_root', update_organisation_supplier_profiles: { __typename?: 'organisation_supplier_profiles_mutation_response', affected_rows: number } | null };

export type GetSupplierProfilesQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
}>;


export type GetSupplierProfilesQuery = { __typename?: 'query_root', organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', id: string, name: string, organisationSupplierProfiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, remoteId: string | null, remoteLink: string | null, state: OrganisationSupplierStateEnum, subsidiary: { __typename?: 'subsidiaries', id: string, name: string }, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null }> } | null };

export type BulkUpdateOrganisationSuppliersMutationVariables = Exact<{
  updates: Array<OrganisationSuppliersUpdates> | OrganisationSuppliersUpdates;
}>;


export type BulkUpdateOrganisationSuppliersMutation = { __typename?: 'mutation_root', update_organisation_suppliers_many: Array<{ __typename?: 'organisation_suppliers_mutation_response', affected_rows: number } | null> | null };

export type ExternalRiskScoreFragmentFragment = { __typename?: 'external_risk_scores', id: string, requestId: string, riskScore: number, externalProvider: OverrideTypes["Integration"], date: any, files: Array<OverrideTypes["UploadedFileItem"]> | null };

export type GetCustomFieldsAndValuesForSuppliersQueryVariables = Exact<{
  organisationSupplierIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetCustomFieldsAndValuesForSuppliersQuery = { __typename?: 'query_root', custom_fields: Array<{ __typename?: 'custom_fields', id: string, title: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, values: Array<{ __typename?: 'custom_field_values', id: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, organisationSupplierId: string, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, address: { __typename?: 'addresses', id: string, name: string | null, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> }> };

export type EngagementFragmentFragment = { __typename?: 'engagements', id: string, name: string, department: string | null, category: CategoryEnum | null, supplierLegalEntity: string | null, buyerLegalEntity: string | null, description: string | null, website: string | null, created_at: string | null, customFields: any | null, note: string | null, organisationSupplierId: string, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string, external_contacts: Array<{ __typename?: 'external_contacts', id: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, title: string | null, isPrimary: boolean }> }, organisation_products_and_service: { __typename?: 'organisation_products_and_services', id: string, name: string } | null, financial: { __typename?: 'financials', id: string, amount: number | null, contractPeriodStart: any | null, contractPeriodEnd: any | null, contractEnd: any | null, subscriptionStart: any | null, purchaseType: PurchaseTypeEnum | null, paymentType: string | null, paymentMethod: string | null, paymentMethodId: string | null, paymentInterval: PaymentIntervalEnum | null, autoRenewal: boolean | null, costCenter: string | null, cancellationNoticeDays: number | null, note: string | null, fxRate: number | null, currency: string | null, purchaseDate: any | null } | null };

export type GetEngagementQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEngagementQuery = { __typename?: 'query_root', engagements: Array<{ __typename?: 'engagements', id: string, name: string, department: string | null, category: CategoryEnum | null, supplierLegalEntity: string | null, buyerLegalEntity: string | null, description: string | null, website: string | null, created_at: string | null, customFields: any | null, note: string | null, organisationSupplierId: string, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, name: string, external_contacts: Array<{ __typename?: 'external_contacts', id: string, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, title: string | null, isPrimary: boolean }> }, organisation_products_and_service: { __typename?: 'organisation_products_and_services', id: string, name: string } | null, financial: { __typename?: 'financials', id: string, amount: number | null, contractPeriodStart: any | null, contractPeriodEnd: any | null, contractEnd: any | null, subscriptionStart: any | null, purchaseType: PurchaseTypeEnum | null, paymentType: string | null, paymentMethod: string | null, paymentMethodId: string | null, paymentInterval: PaymentIntervalEnum | null, autoRenewal: boolean | null, costCenter: string | null, cancellationNoticeDays: number | null, note: string | null, fxRate: number | null, currency: string | null, purchaseDate: any | null } | null }> };

export type GetEngagementIdsBySupplierIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEngagementIdsBySupplierIdQuery = { __typename?: 'query_root', engagements: Array<{ __typename?: 'engagements', id: string }> };

export type GetEngagementsBySupplierIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEngagementsBySupplierIdQuery = { __typename?: 'query_root', engagements: Array<{ __typename?: 'engagements', id: string, name: string, department: string | null, product: { __typename?: 'organisation_products_and_services', id: string, name: string } | null, financial: { __typename?: 'financials', id: string, purchaseType: PurchaseTypeEnum | null, contractPeriodStart: any | null, contractPeriodEnd: any | null, contractEnd: any | null, subscriptionStart: any | null, purchaseDate: any | null, currency: string | null, amount: number | null, fxRate: number | null } | null }> };

export type GetGlobalSuppliersByDomainsQueryVariables = Exact<{
  domains: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetGlobalSuppliersByDomainsQuery = { __typename?: 'query_root', suppliers: Array<{ __typename?: 'suppliers', id: string, name: string, website: string | null }> };

export type GetOrgSupplierFieldsQueryVariables = Exact<{
  organisationSupplierIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetOrgSupplierFieldsQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, website: string | null, remoteId: string | null, publicId: number, address: OverrideTypes["Address"] | null, legalName: string | null, taxNumber: string | null, description: string | null }> };

export type GetOrgSuppliersForLinkingQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetOrgSuppliersForLinkingQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, orgSupplierBrand: { __typename?: 'organisation_suppliers_brands', id: string, name: string, supplierId: string | null } | null }> };

export type GetRequestFormWithLatestSubmissionQueryVariables = Exact<{
  formId: Scalars['uuid']['input'];
}>;


export type GetRequestFormWithLatestSubmissionQuery = { __typename?: 'query_root', request_forms_by_pk: { __typename?: 'request_forms', id: string, title: string, config: OverrideTypes["FormConfig"], request: { __typename?: 'requests', id: string, publicId: string, name: string }, request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null }> } | null };

export type GetRequestsBySupplierIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetRequestsBySupplierIdQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'requests', id: string }> };

export type GetSupplierHistoricSubmissionQueryVariables = Exact<{
  submissionId: Scalars['uuid']['input'];
}>;


export type GetSupplierHistoricSubmissionQuery = { __typename?: 'query_root', organisation_supplier_historic_submissions_by_pk: { __typename?: 'organisation_supplier_historic_submissions', id: string, config: any, response: any, title: string | null, submittedAt: string | null, createdAt: string, organisationSupplierId: string } | null };

export type GetSupplierHistoricSubmissionsQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
}>;


export type GetSupplierHistoricSubmissionsQuery = { __typename?: 'query_root', organisation_supplier_historic_submissions: Array<{ __typename?: 'organisation_supplier_historic_submissions', id: string, title: string | null, config: any, response: any, createdAt: string, submittedAt: string | null }> };

export type GetSupplierSubmissionsQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
}>;


export type GetSupplierSubmissionsQuery = { __typename?: 'query_root', request_forms: Array<{ __typename?: 'request_forms', id: string, title: string, config: OverrideTypes["FormConfig"], request: { __typename?: 'requests', id: string, publicId: string, name: string }, request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null, submittedOn: string, user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null }> }> };

export type GetSuppliersByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetSuppliersByIdsQuery = { __typename?: 'query_root', suppliers: Array<{ __typename?: 'suppliers', id: string, name: string, logoUrl: string | null, website: string | null }> };

export type GetUnlinkedSuppliersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnlinkedSuppliersQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, website: string | null }> };

export type InsertOrganisationSupplierBrandsMutationVariables = Exact<{
  objects: Array<OrganisationSuppliersBrandsInsertInput> | OrganisationSuppliersBrandsInsertInput;
}>;


export type InsertOrganisationSupplierBrandsMutation = { __typename?: 'mutation_root', insert_organisation_suppliers_brands: { __typename?: 'organisation_suppliers_brands_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'organisation_suppliers_brands', id: string, name: string, supplierId: string | null, website: string | null, logoUrl: string | null, description: string | null }> } | null };

export type ListGlobalAndOrgSupplierBrandsQueryVariables = Exact<{
  search: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type ListGlobalAndOrgSupplierBrandsQuery = { __typename?: 'query_root', organisation_suppliers_brands: Array<{ __typename?: 'organisation_suppliers_brands', id: string, name: string, description: string | null, logoUrl: string | null, supplierId: string | null }>, suppliers: Array<{ __typename?: 'suppliers', id: string, name: string, description: string | null, website: string | null, logoUrl: string | null }> };

export type ListOrganisationSuppliersForUserMinimalQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type ListOrganisationSuppliersForUserMinimalQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', id: string }> };

export type FindSupplierByAssigneeQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  supplierId: Scalars['uuid']['input'];
}>;


export type FindSupplierByAssigneeQuery = { __typename?: 'query_root', internalOwnerSuppliers: Array<{ __typename?: 'organisation_suppliers', id: string }>, businessOwnerSuppliers: Array<{ __typename?: 'organisation_suppliers', id: string }> };

export type GetSupplierIdByEngagementIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSupplierIdByEngagementIdQuery = { __typename?: 'query_root', engagements_by_pk: { __typename?: 'engagements', organisationSupplierId: string } | null };

export type UpdateSupplierFieldsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: OrganisationSuppliersSetInput;
}>;


export type UpdateSupplierFieldsMutation = { __typename?: 'mutation_root', update_organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', name: string } | null };

export type UpdateSupplierCategoriesMutationVariables = Exact<{
  organisationSupplierId: Scalars['uuid']['input'];
  categories: Array<OrganisationSuppliersCategoriesInsertInput> | OrganisationSuppliersCategoriesInsertInput;
}>;


export type UpdateSupplierCategoriesMutation = { __typename?: 'mutation_root', delete_organisation_suppliers_categories: { __typename?: 'organisation_suppliers_categories_mutation_response', affected_rows: number } | null, insert_organisation_suppliers_categories: { __typename?: 'organisation_suppliers_categories_mutation_response', affected_rows: number } | null };

export type VectorSearchSuppliersQueryVariables = Exact<{
  search: Scalars['vector']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
}>;


export type VectorSearchSuppliersQuery = { __typename?: 'query_root', vector_search_suppliers: Array<{ __typename?: 'vector_search_similarity_results', id: string, name: string, similarity: number, website: string | null }> };

export type ListOrgProductsAndServicesMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOrgProductsAndServicesMinimalQuery = { __typename?: 'query_root', products: Array<{ __typename?: 'organisation_products_and_services', id: string, name: string, organisationSupplierId: string }> };

export type ListOrgSuppliersMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOrgSuppliersMinimalQuery = { __typename?: 'query_root', suppliers: Array<{ __typename?: 'organisation_suppliers', id: string, name: string, remoteId: string | null }> };

export type CreateHistoricSubmissionMutationVariables = Exact<{
  submission: OrganisationSupplierHistoricSubmissionsInsertInput;
}>;


export type CreateHistoricSubmissionMutation = { __typename?: 'mutation_root', insert_organisation_supplier_historic_submissions_one: { __typename?: 'organisation_supplier_historic_submissions', id: string } | null };

export type ListDepartmentsMinimalQueryVariables = Exact<{
  query: InputMaybe<DepartmentsBoolExp>;
}>;


export type ListDepartmentsMinimalQuery = { __typename?: 'query_root', departments: Array<{ __typename?: 'departments', id: string, name: string }> };

export type ListEngagementsMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type ListEngagementsMinimalQuery = { __typename?: 'query_root', engagements: Array<{ __typename?: 'engagements', id: string, name: string, organisationSupplierId: string, financial: { __typename?: 'financials', id: string } | null }> };

export type UpdateEngagementMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  update: EngagementsSetInput;
}>;


export type UpdateEngagementMutation = { __typename?: 'mutation_root', updatedEngagement: { __typename?: 'engagements', id: string } | null };

export type UpdateFinancialsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  update: FinancialsSetInput;
}>;


export type UpdateFinancialsMutation = { __typename?: 'mutation_root', updatedFinancials: { __typename?: 'financials', id: string } | null };

export type UpsertExternalContactsMutationVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
  objects: Array<ExternalContactsInsertInput> | ExternalContactsInsertInput;
}>;


export type UpsertExternalContactsMutation = { __typename?: 'mutation_root', deletedContacts: { __typename?: 'external_contacts_mutation_response', returning: Array<{ __typename?: 'external_contacts', id: string }> } | null, insertedContacts: { __typename?: 'external_contacts_mutation_response', returning: Array<{ __typename?: 'external_contacts', id: string }> } | null };

export type UpsertInternalContactsMutationVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
  objects: Array<InternalContactsInsertInput> | InternalContactsInsertInput;
}>;


export type UpsertInternalContactsMutation = { __typename?: 'mutation_root', deletedContacts: { __typename?: 'internal_contacts_mutation_response', returning: Array<{ __typename?: 'internal_contacts', id: string }> } | null, insertedContacts: { __typename?: 'internal_contacts_mutation_response', returning: Array<{ __typename?: 'internal_contacts', id: string }> } | null };

export type GetPaymentMethodsMinimalQueryVariables = Exact<{
  query: InputMaybe<PaymentMethodsBoolExp>;
}>;


export type GetPaymentMethodsMinimalQuery = { __typename?: 'query_root', paymentMethods: Array<{ __typename?: 'payment_methods', id: string, name: string }> };

export type ListSubsidiariesMinimalQueryVariables = Exact<{
  query: InputMaybe<SubsidiariesBoolExp>;
}>;


export type ListSubsidiariesMinimalQuery = { __typename?: 'query_root', subsidiaries: Array<{ __typename?: 'subsidiaries', id: string, name: string }> };

export type UpsertSupplierTagsMutationVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
  objects: Array<OrganisationSupplierTagsInsertInput> | OrganisationSupplierTagsInsertInput;
}>;


export type UpsertSupplierTagsMutation = { __typename?: 'mutation_root', deletedTags: { __typename?: 'organisation_supplier_tags_mutation_response', returning: Array<{ __typename?: 'organisation_supplier_tags', id: string }> } | null, insertedTags: { __typename?: 'organisation_supplier_tags_mutation_response', returning: Array<{ __typename?: 'organisation_supplier_tags', id: string }> } | null };

export type AssignSupplierForOwnershipMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  integrationId: Scalars['uuid']['input'];
}>;


export type AssignSupplierForOwnershipMutation = { __typename?: 'mutation_root', update_organisation_suppliers_by_pk: { __typename?: 'organisation_suppliers', id: string } | null };

export type GetBankAccountForRepositoryQueryVariables = Exact<{
  where: BankDetailsBoolExp;
}>;


export type GetBankAccountForRepositoryQuery = { __typename?: 'query_root', bankAccounts: Array<{ __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, address: { __typename?: 'addresses', id: string, remoteId: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> }>, customFieldSchema: Array<{ __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, remoteId: string | null, key: string, title: string, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }> }> };

export type GetAddressForBankAccountQueryVariables = Exact<{
  addressId: Scalars['uuid']['input'];
}>;


export type GetAddressForBankAccountQuery = { __typename?: 'query_root', addresses: Array<{ __typename?: 'addresses', id: string, country: string | null }> };

export type LinkBankAccountForRepositoryMutationVariables = Exact<{
  bankAccountInput: BankDetailsInsertInput;
  bankAccountId: Scalars['uuid']['input'];
  entityId: Scalars['uuid']['input'];
  shouldInsertBankAccount: Scalars['Boolean']['input'];
  shouldLinkSupplier: Scalars['Boolean']['input'];
  shouldLinkSupplierProfile: Scalars['Boolean']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  shouldDemotePrimaryForSupplier: Scalars['Boolean']['input'];
  shouldDemotePrimaryForProfile: Scalars['Boolean']['input'];
}>;


export type LinkBankAccountForRepositoryMutation = { __typename?: 'mutation_root', demotePrimaryFromSupplier?: { __typename?: 'entity_bank_details_mutation_response', affected_rows: number } | null, demotePrimaryFromProfile?: { __typename?: 'entity_bank_details_mutation_response', affected_rows: number } | null, insertedBankAccount?: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, address: { __typename?: 'addresses', id: string, remoteId: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } | null, insertedEntityBankDetailsFromSupplier?: { __typename?: 'entity_bank_details', id: string, isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, address: { __typename?: 'addresses', id: string, remoteId: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } } | null, insertedEntityBankDetailsFromSupplierProfile?: { __typename?: 'entity_bank_details', id: string, isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, address: { __typename?: 'addresses', id: string, remoteId: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } } | null };

export type ListBankAccountsForRepositoryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  where: EntityBankDetailsBoolExp;
  orderBy: Array<EntityBankDetailsOrderBy> | EntityBankDetailsOrderBy;
}>;


export type ListBankAccountsForRepositoryQuery = { __typename?: 'query_root', entityBankDetails: Array<{ __typename?: 'entity_bank_details', id: string, isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, address: { __typename?: 'addresses', id: string, remoteId: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } }>, customFieldSchema: Array<{ __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, remoteId: string | null, key: string, title: string, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }> }> };

export type BankAccountForRepositoryFragment = { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, address: { __typename?: 'addresses', id: string, remoteId: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> };

export type UnlinkBankAccountFromEntityMutationVariables = Exact<{
  bankAccountId: Scalars['uuid']['input'];
  entityId: Scalars['uuid']['input'];
  shouldUnlinkFromSupplier: Scalars['Boolean']['input'];
  shouldUnlinkFromSupplierProfile: Scalars['Boolean']['input'];
}>;


export type UnlinkBankAccountFromEntityMutation = { __typename?: 'mutation_root', deletedEntitiesBankDetailsFromSupplier?: { __typename?: 'entity_bank_details_mutation_response', affected_rows: number } | null, deletedEntitiesBankDetailsFromSupplierProfile?: { __typename?: 'entity_bank_details_mutation_response', affected_rows: number } | null };

export type UpdateBankAccountForRepositoryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set: BankDetailsSetInput;
}>;


export type UpdateBankAccountForRepositoryMutation = { __typename?: 'mutation_root', bankAccount: { __typename?: 'bank_details', id: string, accountName: string | null, remoteId: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean, createdAt: string, updatedAt: string, deleted_at: string | null, currency: { __typename?: 'organisation_fx_rates', id: string, remoteId: string | null, code: OverrideTypes["CurrencyCode"], name: string | null } | null, address: { __typename?: 'addresses', id: string, remoteId: string | null, addressLine1: string | null, addressLine2: string | null, city: string | null, state: string | null, postalCode: string | null, county: string | null, country: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } | null };

export type CreateOrganisationSuppliersForRepositoryMutationVariables = Exact<{
  suppliers: Array<OrganisationSuppliersInsertInput> | OrganisationSuppliersInsertInput;
  externalContacts: Array<ExternalContactsInsertInput> | ExternalContactsInsertInput;
  shouldInsertExternalContacts: Scalars['Boolean']['input'];
}>;


export type CreateOrganisationSuppliersForRepositoryMutation = { __typename?: 'mutation_root', suppliers: { __typename?: 'organisation_suppliers_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'organisation_suppliers', id: string, deleted_at: string | null, name: string, legalName: string | null, state: OrganisationSupplierStateEnum, website: string | null, description: string | null, isReseller: boolean, isPerson: boolean | null, isPreferred: boolean, taxNumber: string | null, createdAt: string, updated_at: string, remoteId: string | null, remoteLink: string | null, publicId: number, address: OverrideTypes["Address"] | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, remoteId: string | null } | null, paymentTerms: { __typename?: 'payment_terms', id: string, name: string, remoteId: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, organisationIntegration: { __typename?: 'organisation_integrations', name: string | null, id: string, integration: OverrideTypes["GlobalIntegration"] } | null, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tag: { __typename?: 'tags', id: string, name: string } }> }> } | null, insert_external_contacts?: { __typename?: 'external_contacts_mutation_response', affected_rows: number } | null };

export type CustomFieldSchemaForRepositoryFragment = { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, remoteId: string | null, key: string, title: string, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }> };

export type GetCustomFieldSchemaForEntityTypeQueryVariables = Exact<{
  entityType: Scalars['String']['input'];
}>;


export type GetCustomFieldSchemaForEntityTypeQuery = { __typename?: 'query_root', custom_fields: Array<{ __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, remoteId: string | null, key: string, title: string, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }> }> };

export type CreateExternalContactsForRepositoryMutationVariables = Exact<{
  objects: Array<ExternalContactsInsertInput> | ExternalContactsInsertInput;
}>;


export type CreateExternalContactsForRepositoryMutation = { __typename?: 'mutation_root', insert_external_contacts: { __typename?: 'external_contacts_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, title: string | null, userId: string | null, deletedAt: string | null, phoneNumber: string | null, isPrimary: boolean, createdAt: string, updatedAt: string }> } | null };

export type DeleteExternalContactByIdForRepositoryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteExternalContactByIdForRepositoryMutation = { __typename?: 'mutation_root', deleted: { __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, title: string | null, userId: string | null, deletedAt: string | null, phoneNumber: string | null, isPrimary: boolean, createdAt: string, updatedAt: string } | null };

export type ExternalContactForRepositoryFragment = { __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, title: string | null, userId: string | null, deletedAt: string | null, phoneNumber: string | null, isPrimary: boolean, createdAt: string, updatedAt: string };

export type GetExternalContactByIdForRepositoryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetExternalContactByIdForRepositoryQuery = { __typename?: 'query_root', externalContact: { __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, title: string | null, userId: string | null, deletedAt: string | null, phoneNumber: string | null, isPrimary: boolean, createdAt: string, updatedAt: string, supplier: { __typename?: 'organisation_suppliers', id: string, remoteId: string | null, isPerson: boolean | null, deleted_at: string | null } } | null };

export type ListExternalContactsForSupplierForRepositoryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy: Array<ExternalContactsOrderBy> | ExternalContactsOrderBy;
  where: InputMaybe<ExternalContactsBoolExp>;
}>;


export type ListExternalContactsForSupplierForRepositoryQuery = { __typename?: 'query_root', externalContacts: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, title: string | null, userId: string | null, deletedAt: string | null, phoneNumber: string | null, isPrimary: boolean, createdAt: string, updatedAt: string }> };

export type UpdateExternalContactsForRepositoryMutationVariables = Exact<{
  updates: Array<ExternalContactsUpdates> | ExternalContactsUpdates;
}>;


export type UpdateExternalContactsForRepositoryMutation = { __typename?: 'mutation_root', updatedExternalContacts: Array<{ __typename?: 'external_contacts_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'external_contacts', id: string, email: string, firstName: string | null, lastName: string | null, title: string | null, userId: string | null, deletedAt: string | null, phoneNumber: string | null, isPrimary: boolean, createdAt: string, updatedAt: string }> } | null> | null };

export type GetOrgSupplierByIdForRepositoryQueryVariables = Exact<{
  where: OrganisationSuppliersBoolExp;
}>;


export type GetOrgSupplierByIdForRepositoryQuery = { __typename?: 'query_root', organisation_suppliers: Array<{ __typename?: 'organisation_suppliers', totalSpend: number | null, id: string, deleted_at: string | null, name: string, legalName: string | null, state: OrganisationSupplierStateEnum, website: string | null, description: string | null, isReseller: boolean, isPerson: boolean | null, isPreferred: boolean, taxNumber: string | null, createdAt: string, updated_at: string, remoteId: string | null, remoteLink: string | null, publicId: number, address: OverrideTypes["Address"] | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, remoteId: string | null } | null, paymentTerms: { __typename?: 'payment_terms', id: string, name: string, remoteId: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, organisationIntegration: { __typename?: 'organisation_integrations', name: string | null, id: string, integration: OverrideTypes["GlobalIntegration"] } | null, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tag: { __typename?: 'tags', id: string, name: string } }> }>, custom_fields: Array<{ __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, remoteId: string | null, key: string, title: string, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }> }> };

export type GetSupplierOverviewFieldsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSupplierOverviewFieldsQuery = { __typename?: 'query_root', orgSupplier: { __typename?: 'organisation_suppliers', id: string, name: string, legalName: string | null, remoteId: string | null, remoteLink: string | null, website: string | null, description: string | null, isPreferred: boolean, isReseller: boolean, isContinuousMonitoringEnabled: boolean, isPerson: boolean | null, taxNumber: string | null, address: OverrideTypes["Address"] | null, lastAssessmentDate: string | null, totalSpend: number | null, organisationIntegration: { __typename?: 'organisation_integrations', id: string, name: string | null, integration: OverrideTypes["GlobalIntegration"] } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, supplierTags: Array<{ __typename?: 'organisation_supplier_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } }>, engagements: Array<{ __typename?: 'engagements', id: string, department: string | null, financial: { __typename?: 'financials', id: string, costCenter: string | null } | null }>, agreements: Array<{ __typename?: 'agreements', id: string, agreement_terms: Array<{ __typename?: 'agreement_terms', primaryDepartment: { __typename?: 'departments', name: string } | null }> }>, categoryIds: Array<{ __typename?: 'organisation_suppliers_categories', productSupplierCategoryId: string }>, risks: Array<{ __typename?: 'risks', id: string }>, profiles: Array<{ __typename?: 'organisation_supplier_profiles', subsidiary: { __typename?: 'subsidiaries', id: string, name: string } }> } | null };

export type CreateInternalContactsForRepositoryMutationVariables = Exact<{
  objects: Array<InternalContactsInsertInput> | InternalContactsInsertInput;
}>;


export type CreateInternalContactsForRepositoryMutation = { __typename?: 'mutation_root', insert_internal_contacts: { __typename?: 'internal_contacts_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'internal_contacts', id: string, role: OverrideTypes["InternalContactRole"], title: string | null, supplierId: string, deleted_at: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } }> } | null };

export type DeleteInternalContactByIdForRepositoryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  supplierId: Scalars['uuid']['input'];
}>;


export type DeleteInternalContactByIdForRepositoryMutation = { __typename?: 'mutation_root', deleted: { __typename?: 'internal_contacts_mutation_response', affected_rows: number } | null };

export type GetInternalContactByIdForRepositoryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetInternalContactByIdForRepositoryQuery = { __typename?: 'query_root', internalContact: { __typename?: 'internal_contacts', id: string, role: OverrideTypes["InternalContactRole"], title: string | null, supplierId: string, deleted_at: string | null, createdAt: string, updatedAt: string, supplier: { __typename?: 'organisation_suppliers', id: string, remoteId: string | null, deleted_at: string | null }, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } } | null };

export type InternalContactForRepositoryFragment = { __typename?: 'internal_contacts', id: string, role: OverrideTypes["InternalContactRole"], title: string | null, supplierId: string, deleted_at: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } };

export type ListInternalContactsForRepositoryQueryVariables = Exact<{
  where: InternalContactsBoolExp;
  orderBy: Array<InternalContactsOrderBy> | InternalContactsOrderBy;
  limit: Scalars['Int']['input'];
}>;


export type ListInternalContactsForRepositoryQuery = { __typename?: 'query_root', internalContacts: Array<{ __typename?: 'internal_contacts', id: string, role: OverrideTypes["InternalContactRole"], title: string | null, supplierId: string, deleted_at: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } }> };

export type UpdateInternalContactForRepositoryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set: InternalContactsSetInput;
}>;


export type UpdateInternalContactForRepositoryMutation = { __typename?: 'mutation_root', update_internal_contacts_by_pk: { __typename?: 'internal_contacts', id: string, role: OverrideTypes["InternalContactRole"], title: string | null, supplierId: string, deleted_at: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'users', id: string, email: string, firstName: string, lastName: string } } | null };

export type ListOrgSuppliersForRepositoryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  orderBy: Array<OrganisationSuppliersOrderBy> | OrganisationSuppliersOrderBy;
  where: InputMaybe<OrganisationSuppliersBoolExp>;
}>;


export type ListOrgSuppliersForRepositoryQuery = { __typename?: 'query_root', suppliers: Array<{ __typename?: 'organisation_suppliers', totalSpend: number | null, id: string, deleted_at: string | null, name: string, legalName: string | null, state: OrganisationSupplierStateEnum, website: string | null, description: string | null, isReseller: boolean, isPerson: boolean | null, isPreferred: boolean, taxNumber: string | null, createdAt: string, updated_at: string, remoteId: string | null, remoteLink: string | null, publicId: number, address: OverrideTypes["Address"] | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, remoteId: string | null } | null, paymentTerms: { __typename?: 'payment_terms', id: string, name: string, remoteId: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, organisationIntegration: { __typename?: 'organisation_integrations', name: string | null, id: string, integration: OverrideTypes["GlobalIntegration"] } | null, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tag: { __typename?: 'tags', id: string, name: string } }> }>, custom_fields: Array<{ __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, remoteId: string | null, key: string, title: string, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }> }> };

export type CreateSupplierProfilesForRepositoryMutationVariables = Exact<{
  objects: Array<OrganisationSupplierProfilesInsertInput> | OrganisationSupplierProfilesInsertInput;
}>;


export type CreateSupplierProfilesForRepositoryMutation = { __typename?: 'mutation_root', insert_organisation_supplier_profiles: { __typename?: 'organisation_supplier_profiles_mutation_response', returning: Array<{ __typename?: 'organisation_supplier_profiles', id: string, remoteId: string | null, remoteLink: string | null, subsidiaryId: string, state: OrganisationSupplierStateEnum, createdAt: string, updatedAt: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null }, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, remoteId: string | null } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, remoteId: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> }> } | null };

export type DeleteSupplierProfileBySubsidiaryIdForRepositoryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteSupplierProfileBySubsidiaryIdForRepositoryMutation = { __typename?: 'mutation_root', update_organisation_supplier_profiles: { __typename?: 'organisation_supplier_profiles_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'organisation_supplier_profiles', id: string }> } | null };

export type GetSupplierProfileBySubsidiaryIdForRepositoryQueryVariables = Exact<{
  where: OrganisationSupplierProfilesBoolExp;
}>;


export type GetSupplierProfileBySubsidiaryIdForRepositoryQuery = { __typename?: 'query_root', organisation_supplier_profiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, remoteId: string | null, remoteLink: string | null, subsidiaryId: string, state: OrganisationSupplierStateEnum, createdAt: string, updatedAt: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null }, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, remoteId: string | null } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, remoteId: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> }>, custom_fields: Array<{ __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, remoteId: string | null, key: string, title: string, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }> }> };

export type GetSupplierProfilesForRepositoryQueryVariables = Exact<{
  where: OrganisationSupplierProfilesBoolExp;
}>;


export type GetSupplierProfilesForRepositoryQuery = { __typename?: 'query_root', organisation_supplier_profiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, deletedAt: string | null }> };

export type ListSupplierProfilesForRepositoryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  where: OrganisationSupplierProfilesBoolExp;
  orderBy: Array<OrganisationSupplierProfilesOrderBy> | OrganisationSupplierProfilesOrderBy;
}>;


export type ListSupplierProfilesForRepositoryQuery = { __typename?: 'query_root', organisation_supplier_profiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, remoteId: string | null, remoteLink: string | null, subsidiaryId: string, state: OrganisationSupplierStateEnum, createdAt: string, updatedAt: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null }, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, remoteId: string | null } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, remoteId: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> }>, custom_fields: Array<{ __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], externalSource: OverrideTypes["CustomFieldCoreDataSourceType"] | null, customCoreDataId: string | null, remoteId: string | null, key: string, title: string, choices: Array<{ __typename?: 'custom_field_choices', id: string, label: string }> }> };

export type SupplierProfileForRepositoryFragment = { __typename?: 'organisation_supplier_profiles', id: string, remoteId: string | null, remoteLink: string | null, subsidiaryId: string, state: OrganisationSupplierStateEnum, createdAt: string, updatedAt: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null }, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, remoteId: string | null } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, remoteId: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> };

export type UpdateSupplierProfileForRepositoryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: InputMaybe<OrganisationSupplierProfilesSetInput>;
}>;


export type UpdateSupplierProfileForRepositoryMutation = { __typename?: 'mutation_root', updatedProfile: { __typename?: 'organisation_supplier_profiles', id: string, remoteId: string | null, remoteLink: string | null, subsidiaryId: string, state: OrganisationSupplierStateEnum, createdAt: string, updatedAt: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null }, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, remoteId: string | null } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, remoteId: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }> } | null };

export type GetValueReferenceIdsByNonIdsQueryVariables = Exact<{
  paymentMethodRemoteIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  paymentTermsIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  departmentRemoteIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  currencyRemoteIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  lineItemTypeRemoteIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  subsidiaryRemoteIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  addressRemoteIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  customCoreDataOptionRemoteIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  userEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetValueReferenceIdsByNonIdsQuery = { __typename?: 'query_root', paymentMethods: Array<{ __typename?: 'payment_methods', id: string, remoteId: string | null }>, paymentTerms: Array<{ __typename?: 'payment_terms', id: string, remoteId: string | null }>, departments: Array<{ __typename?: 'departments', id: string, remoteId: string | null }>, currencies: Array<{ __typename?: 'organisation_fx_rates', id: string, remoteId: string | null }>, lineItemTypes: Array<{ __typename?: 'line_item_types', id: string, remoteId: string | null }>, subsidiaries: Array<{ __typename?: 'subsidiaries', id: string, remoteId: string | null }>, addresses: Array<{ __typename?: 'addresses', id: string, remoteId: string | null }>, customCoreDataOptions: Array<{ __typename?: 'custom_core_data_options', id: string, remoteId: string | null }>, users: Array<{ __typename?: 'users', id: string, email: string }> };

export type OrgSupplierForRepositoryFragment = { __typename?: 'organisation_suppliers', id: string, deleted_at: string | null, name: string, legalName: string | null, state: OrganisationSupplierStateEnum, website: string | null, description: string | null, isReseller: boolean, isPerson: boolean | null, isPreferred: boolean, taxNumber: string | null, createdAt: string, updated_at: string, remoteId: string | null, remoteLink: string | null, publicId: number, address: OverrideTypes["Address"] | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, remoteId: string | null } | null, paymentTerms: { __typename?: 'payment_terms', id: string, name: string, remoteId: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, organisationIntegration: { __typename?: 'organisation_integrations', name: string | null, id: string, integration: OverrideTypes["GlobalIntegration"] } | null, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tag: { __typename?: 'tags', id: string, name: string } }> };

export type CreateSupplierSubsidiariesForRepositoryMutationVariables = Exact<{
  objects: Array<OrganisationSupplierProfilesInsertInput> | OrganisationSupplierProfilesInsertInput;
}>;


export type CreateSupplierSubsidiariesForRepositoryMutation = { __typename?: 'mutation_root', insert_organisation_supplier_profiles: { __typename?: 'organisation_supplier_profiles_mutation_response', returning: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null } }> } | null };

export type DeleteSupplierSubsidiaryByIdForRepositoryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteSupplierSubsidiaryByIdForRepositoryMutation = { __typename?: 'mutation_root', update_organisation_supplier_profiles: { __typename?: 'organisation_supplier_profiles_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'organisation_supplier_profiles', id: string }> } | null };

export type GetSubsidiaryIdsFromRemoteIdsQueryVariables = Exact<{
  remoteIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetSubsidiaryIdsFromRemoteIdsQuery = { __typename?: 'query_root', subsidiaries: Array<{ __typename?: 'subsidiaries', remoteId: string | null, id: string }> };

export type GetSupplierSubsidiariesForRepositoryQueryVariables = Exact<{
  where: OrganisationSupplierProfilesBoolExp;
}>;


export type GetSupplierSubsidiariesForRepositoryQuery = { __typename?: 'query_root', organisation_supplier_profiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, deletedAt: string | null }> };

export type ListSupplierSubsidiariesForRepositoryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  where: OrganisationSupplierProfilesBoolExp;
  orderBy: Array<OrganisationSupplierProfilesOrderBy> | OrganisationSupplierProfilesOrderBy;
}>;


export type ListSupplierSubsidiariesForRepositoryQuery = { __typename?: 'query_root', organisation_supplier_profiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null } }> };

export type SupplierSubsidiaryForRepositoryFragment = { __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, remoteId: string | null } };

export type GetSupplierProfileForValidationQueryVariables = Exact<{
  profileId: Scalars['uuid']['input'];
  supplierId: Scalars['uuid']['input'];
}>;


export type GetSupplierProfileForValidationQuery = { __typename?: 'query_root', organisation_supplier_profiles: Array<{ __typename?: 'organisation_supplier_profiles', id: string }> };

export type UpdateSupplierForRepositoryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: InputMaybe<OrganisationSuppliersSetInput>;
}>;


export type UpdateSupplierForRepositoryMutation = { __typename?: 'mutation_root', updatedSupplier: { __typename?: 'organisation_suppliers', id: string, deleted_at: string | null, name: string, legalName: string | null, state: OrganisationSupplierStateEnum, website: string | null, description: string | null, isReseller: boolean, isPerson: boolean | null, isPreferred: boolean, taxNumber: string | null, createdAt: string, updated_at: string, remoteId: string | null, remoteLink: string | null, publicId: number, address: OverrideTypes["Address"] | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, remoteId: string | null } | null, paymentTerms: { __typename?: 'payment_terms', id: string, name: string, remoteId: string | null } | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, organisationIntegration: { __typename?: 'organisation_integrations', name: string | null, id: string, integration: OverrideTypes["GlobalIntegration"] } | null, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tag: { __typename?: 'tags', id: string, name: string } }> } | null };

export type GetOrgFxRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgFxRatesQuery = { __typename?: 'query_root', organisation_fx_rates: Array<{ __typename?: 'organisation_fx_rates', id: string, code: OverrideTypes["CurrencyCode"], fxRate: number }> };

export type GetRequestByIdQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestByIdQuery = { __typename?: 'query_root', request: { __typename?: 'requests', id: string, name: string, requestor: { __typename?: 'users', id: string, firstName: string, lastName: string }, organisation: { __typename?: 'organisations', id: string, name: string, logoUrlLight: string | null, isQa: boolean } } | null };

export type GetRequestSupplierQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestSupplierQuery = { __typename?: 'query_root', request: { __typename?: 'requests', id: string, model: OverrideTypes["RequestModel"], name: string, renewal: { __typename?: 'renewals', id: string, renewalDate: string, product: { __typename?: 'organisation_products_and_services', id: string, name: string } | null } | null, user: { __typename?: 'users', id: string, firstName: string, lastName: string }, organisation: { __typename?: 'organisations', id: string, name: string }, workflow: { __typename?: 'workflows', id: string, title: string, type: WorkflowTypeEnum }, supplier: { __typename?: 'organisation_suppliers', id: string, name: string } | null } | null };

export type GetTagsByOrganisationSupplierIdQueryVariables = Exact<{
  organisationSupplierId: Scalars['uuid']['input'];
}>;


export type GetTagsByOrganisationSupplierIdQuery = { __typename?: 'query_root', supplier: { __typename?: 'organisation_suppliers', id: string, organisation_supplier_tags: Array<{ __typename?: 'organisation_supplier_tags', tag: { __typename?: 'tags', id: string, name: string } }> } | null };

export type GetTasksByUserIdQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  gqlFilter: RequestStepsBoolExp;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  includeRows: Scalars['Boolean']['input'];
}>;


export type GetTasksByUserIdQuery = { __typename?: 'query_root', tasks?: Array<{ __typename?: 'request_steps', id: string, createdAt: string, state: RequestStepStateEnum, totalPausedWorkingHours: number, stepLabel: any, stageType: any, targetTimeValue: any, request: { __typename?: 'requests', id: string, name: string, tagIds: any | null, priority: RequestPriorityEnum, publicId: string, state: string | null, organisation: { __typename?: 'organisations', id: string, name: string }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean }, owner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null } | null, workflow: { __typename?: 'workflows', id: string, title: string, workflow_condition_groups: Array<{ __typename?: 'workflow_condition_groups', id: string, name: string, precedence: number | null }> }, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null, buyerLegalEntity: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, department: { __typename?: 'departments', id: string, name: string } | null } | null, request_tags: Array<{ __typename?: 'request_tags', tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }> }, requestStepGroups: Array<{ __typename?: 'request_step_groups', group: { __typename?: 'groups', id: string, name: string, group_users: Array<{ __typename?: 'group_users', id: string, userId: string }> } }>, requestStepUsers: Array<{ __typename?: 'request_step_users', user: { __typename?: 'users', id: string, firstName: string, lastName: string } }>, requestStepTasks: Array<{ __typename?: 'request_step_tasks', id: string, type: RequestStepTaskTypeEnum, completedOn: string | null, request_form: { __typename?: 'request_forms', id: string, type: FormTypeEnum, title: string, request_comments: Array<{ __typename?: 'request_comments', id: string, type: RequestCommentTypeEnum, userId: string, completedAt: string | null }> } | null }>, activeAmendments: Array<{ __typename?: 'request_step_tasks', request_form: { __typename?: 'request_forms', request_comments: Array<{ __typename?: 'request_comments', id: string, type: RequestCommentTypeEnum, userId: string, completedAt: string | null }> } | null }> }>, request_steps_aggregate: { __typename?: 'request_steps_aggregate', aggregate: { __typename?: 'request_steps_aggregate_fields', count: number } | null } };

export type GetUsersByGroupIdQueryVariables = Exact<{
  groupId: Scalars['uuid']['input'];
}>;


export type GetUsersByGroupIdQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string }> };

export type InsertCommentMentionsMutationVariables = Exact<{
  objects: Array<RequestCommentsMentionsInsertInput> | RequestCommentsMentionsInsertInput;
}>;


export type InsertCommentMentionsMutation = { __typename?: 'mutation_root', insert_request_comments_mentions: { __typename?: 'request_comments_mentions_mutation_response', returning: Array<{ __typename?: 'request_comments_mentions', id: string }> } | null };

export type InsertSupplierTagMutationVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
  tagId: Scalars['uuid']['input'];
}>;


export type InsertSupplierTagMutation = { __typename?: 'mutation_root', insert_organisation_supplier_tags_one: { __typename?: 'organisation_supplier_tags', id: string, tag: { __typename?: 'tags', id: string, name: string } } | null };

export type InsertTagMutationVariables = Exact<{
  input: TagsInsertInput;
}>;


export type InsertTagMutation = { __typename?: 'mutation_root', insert_tags_one: { __typename?: 'tags', id: string, name: string } | null };

export type QueryTagByNameQueryVariables = Exact<{
  tagName: Scalars['String']['input'];
}>;


export type QueryTagByNameQuery = { __typename?: 'query_root', tags: Array<{ __typename?: 'tags', id: string, name: string, deletedAt: any | null }> };

export type RestoreDeletedTagMutationVariables = Exact<{
  tagId: Scalars['uuid']['input'];
}>;


export type RestoreDeletedTagMutation = { __typename?: 'mutation_root', update_tags_by_pk: { __typename?: 'tags', id: string, name: string } | null };

export type GetOrganisationTagsQueryVariables = Exact<{
  offset: InputMaybe<Scalars['Int']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagsBoolExp>;
}>;


export type GetOrganisationTagsQuery = { __typename?: 'query_root', tags: Array<{ __typename?: 'tags', id: string, name: string }>, tagsAggregate: { __typename?: 'tags_aggregate', aggregate: { __typename?: 'tags_aggregate_fields', count: number } | null } };

export type AllRequestStepFieldsFragment = { __typename?: 'request_steps', id: string, createdAt: string, state: RequestStepStateEnum, canvasModelId: string, stepLabel: any, type: any, skipped: any | null, skippedAt: any | null, skippedBy: any | null, forceApprovedAt: any | null, forceApprovedBy: any | null };

export type AllRequestStepTaskFieldsFragment = { __typename?: 'request_step_tasks', id: string, completedOn: string | null, completedBy: string | null, submissionsClosedAt: string | null, type: RequestStepTaskTypeEnum, config: any | null, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string, createdBy: string, createdAt: string }> };

export type GetAllRequestTasksQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetAllRequestTasksQuery = { __typename?: 'query_root', taskBasedStepPermission: Array<{ __typename?: 'request_steps', id: string, createdAt: string, state: RequestStepStateEnum, canvasModelId: string, stepLabel: any, type: any, skipped: any | null, skippedAt: any | null, skippedBy: any | null, forceApprovedAt: any | null, forceApprovedBy: any | null, requestStepTasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, completedBy: string | null, submissionsClosedAt: string | null, type: RequestStepTaskTypeEnum, config: any | null, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string, createdBy: string, createdAt: string }> }> }>, fullStepPermission: Array<{ __typename?: 'request_steps', id: string, createdAt: string, state: RequestStepStateEnum, canvasModelId: string, totalPausedWorkingHours: number, stepLabel: any, type: any, targetTimeValue: any, skipped: any | null, skippedAt: any | null, skippedBy: any | null, forceApprovedAt: any | null, forceApprovedBy: any | null, agentEnabled: any, requestStepTasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, completedBy: string | null, submissionsClosedAt: string | null, type: RequestStepTaskTypeEnum, config: any | null, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string, createdBy: string, createdAt: string }> }>, request: { __typename?: 'requests', id: string, user: { __typename?: 'users', id: string } }, request_step_users: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string } }>, request_step_groups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, group_users: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }> };

export type GetIntakeFormsWithRequestAmendmentsByRequestorIdQueryVariables = Exact<{
  requestorId: Scalars['uuid']['input'];
}>;


export type GetIntakeFormsWithRequestAmendmentsByRequestorIdQuery = { __typename?: 'query_root', forms: Array<{ __typename?: 'request_forms', id: string, request: { __typename?: 'requests', id: string, createdAt: string, name: string, tagIds: any | null, priority: RequestPriorityEnum, publicId: string, state: string | null, organisation: { __typename?: 'organisations', id: string, name: string }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean }, owner: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, isArchived: boolean } | null, supplier: { __typename?: 'organisation_suppliers', id: string, name: string, logoUrl: string | null } | null, workflow: { __typename?: 'workflows', id: string, title: string, workflow_condition_groups: Array<{ __typename?: 'workflow_condition_groups', id: string, name: string, precedence: number | null }> }, request_tags: Array<{ __typename?: 'request_tags', id: string, tag: { __typename?: 'tags', id: string, name: string, deletedAt: any | null } }>, computedProperties: { __typename?: 'request_computed_properties', valueObject: any | null, buyerLegalEntity: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, department: { __typename?: 'departments', id: string, name: string } | null } | null }, activeAmendments: Array<{ __typename?: 'request_comments', id: string, type: RequestCommentTypeEnum, userId: string, completedAt: string | null }> }> };

export type StepFieldsFragment = { __typename?: 'request_steps', id: string, createdAt: string, state: RequestStepStateEnum, canvasModelId: string, totalPausedWorkingHours: number, stepLabel: any, type: any, targetTimeValue: any, skipped: any | null, skippedAt: any | null, skippedBy: any | null, forceApprovedAt: any | null, forceApprovedBy: any | null, agentEnabled: any, request: { __typename?: 'requests', id: string, user: { __typename?: 'users', id: string } }, request_step_users: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string } }>, request_step_groups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, group_users: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> };

export type TaskFieldsFragment = { __typename?: 'request_step_tasks', id: string, completedOn: string | null, completedBy: string | null, created_at: string | null, submissionsClosedAt: string | null, type: RequestStepTaskTypeEnum, config: any | null, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string, createdBy: string, createdAt: string }>, request_form: { __typename?: 'request_forms', id: string, title: string, type: FormTypeEnum, config: OverrideTypes["FormConfig"], form_template: { __typename?: 'form_templates', id: string, externalTitle: string | null } | null, request_comments: Array<{ __typename?: 'request_comments', id: string, userId: string, type: RequestCommentTypeEnum, completedAt: string | null }>, request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null }>, request_form_submissions_auto_saves: Array<{ __typename?: 'request_form_submissions_auto_saves', id: string }>, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string }> }> } | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, status: string, rfx: { __typename?: 'rfx', requestId: string } }> } | null };

export type GetMyRequestTasksQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  requestId: Scalars['uuid']['input'];
}>;


export type GetMyRequestTasksQuery = { __typename?: 'query_root', taskBasedStepPermission: Array<{ __typename?: 'request_steps', id: string, createdAt: string, state: RequestStepStateEnum, canvasModelId: string, totalPausedWorkingHours: number, stepLabel: any, type: any, targetTimeValue: any, skipped: any | null, skippedAt: any | null, skippedBy: any | null, forceApprovedAt: any | null, forceApprovedBy: any | null, agentEnabled: any, requestStepTasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, completedBy: string | null, created_at: string | null, submissionsClosedAt: string | null, type: RequestStepTaskTypeEnum, config: any | null, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string, createdBy: string, createdAt: string }>, request_form: { __typename?: 'request_forms', id: string, title: string, type: FormTypeEnum, config: OverrideTypes["FormConfig"], form_template: { __typename?: 'form_templates', id: string, externalTitle: string | null } | null, request_comments: Array<{ __typename?: 'request_comments', id: string, userId: string, type: RequestCommentTypeEnum, completedAt: string | null }>, request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null }>, request_form_submissions_auto_saves: Array<{ __typename?: 'request_form_submissions_auto_saves', id: string }>, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string }> }> } | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, status: string, rfx: { __typename?: 'rfx', requestId: string } }> } | null }>, request: { __typename?: 'requests', id: string, user: { __typename?: 'users', id: string } }, request_step_users: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string } }>, request_step_groups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, group_users: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }>, fullStepPermission: Array<{ __typename?: 'request_steps', id: string, createdAt: string, state: RequestStepStateEnum, canvasModelId: string, totalPausedWorkingHours: number, stepLabel: any, type: any, targetTimeValue: any, skipped: any | null, skippedAt: any | null, skippedBy: any | null, forceApprovedAt: any | null, forceApprovedBy: any | null, agentEnabled: any, requestStepTasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, completedBy: string | null, created_at: string | null, submissionsClosedAt: string | null, type: RequestStepTaskTypeEnum, config: any | null, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string, createdBy: string, createdAt: string }>, request_form: { __typename?: 'request_forms', id: string, title: string, type: FormTypeEnum, config: OverrideTypes["FormConfig"], form_template: { __typename?: 'form_templates', id: string, externalTitle: string | null } | null, request_comments: Array<{ __typename?: 'request_comments', id: string, userId: string, type: RequestCommentTypeEnum, completedAt: string | null }>, request_form_submissions: Array<{ __typename?: 'request_form_submissions', id: string, response: OverrideTypes["FormResponsePayload"] | null }>, request_form_submissions_auto_saves: Array<{ __typename?: 'request_form_submissions_auto_saves', id: string }>, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, request_step_task_rejections: Array<{ __typename?: 'request_step_task_rejections', id: string }> }> } | null, organisation_supplier: { __typename?: 'organisation_suppliers', id: string, rfx_suppliers: Array<{ __typename?: 'rfx_suppliers', id: string, status: string, rfx: { __typename?: 'rfx', requestId: string } }> } | null }>, request: { __typename?: 'requests', id: string, user: { __typename?: 'users', id: string } }, request_step_users: Array<{ __typename?: 'request_step_users', id: string, user: { __typename?: 'users', id: string } }>, request_step_groups: Array<{ __typename?: 'request_step_groups', id: string, group: { __typename?: 'groups', id: string, group_users: Array<{ __typename?: 'group_users', id: string, userId: string }> } }> }> };

export type GetRequestRfxFillInTasksQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestRfxFillInTasksQuery = { __typename?: 'query_root', requests_by_pk: { __typename?: 'requests', id: string, rfxes: Array<{ __typename?: 'rfx', id: string, owners: Array<{ __typename?: 'rfx_owners', userId: string }> }>, request_forms: Array<{ __typename?: 'request_forms', id: string, request_step_tasks: Array<{ __typename?: 'request_step_tasks', id: string, completedOn: string | null, completedBy: string | null, submissionsClosedAt: string | null, request_step_task_users: Array<{ __typename?: 'request_step_task_users', user: { __typename?: 'users', email: string } }> }> }> } | null };

export type GetRfxConfidentialityAgreementByRequestAndUserQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type GetRfxConfidentialityAgreementByRequestAndUserQuery = { __typename?: 'query_root', rfxConfidentialityAgreements: Array<{ __typename?: 'rfx_confidentiality_agreement', id: string, confidentialityAgreement: string, signedAt: string | null, rfxSupplierId: string, rfxId: string, signedBy: { __typename?: 'users', id: string, firstName: string, lastName: string } | null }> };

export type ArchiveGroupByIdMutationVariables = Exact<{
  groupId: Scalars['uuid']['input'];
}>;


export type ArchiveGroupByIdMutation = { __typename?: 'mutation_root', archivedGroup: { __typename?: 'groups', id: string } | null, deletedGroupUsers: { __typename?: 'group_users_mutation_response', returning: Array<{ __typename?: 'group_users', userId: string }> } | null };

export type CreateGroupMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateGroupMutation = { __typename?: 'mutation_root', insert_groups_one: { __typename?: 'groups', id: string, name: string } | null };

export type GetGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupsQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'groups', id: string, name: string, rawAttributes: any | null, organisationId: string, isArchived: boolean, group_users: Array<{ __typename?: 'group_users', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }> }> };

export type GroupFragmentFragment = { __typename?: 'groups', id: string, name: string, rawAttributes: any | null, organisationId: string, isArchived: boolean };

export type GroupUsersFragmentFragment = { __typename?: 'groups', group_users: Array<{ __typename?: 'group_users', user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } }> };

export type GetOrgUsersListQueryVariables = Exact<{
  offset: InputMaybe<Scalars['Int']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOrgUsersListQuery = { __typename?: 'query_root', organisations: Array<{ __typename?: 'organisations', id: string, hasDirectorySyncEnabled: boolean | null, ssoDomains: Array<string> | null, domain: string }>, users: Array<{ __typename?: 'users', isOutOfOffice: boolean, id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, group_users: Array<{ __typename?: 'group_users', id: string, group: { __typename?: 'groups', id: string, name: string, rawAttributes: any | null, organisationId: string, isArchived: boolean } }>, department: { __typename?: 'departments', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, managerUser: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, userAllowedSubsidiaries: Array<{ __typename?: 'user_allowed_subsidiaries', id: string, subsidiaryId: string, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean, archivedBy: string | null, remoteId: string | null, coreDataId: string } }> }>, totalUsers: { __typename?: 'users_aggregate', aggregate: { __typename?: 'users_aggregate_fields', count: number } | null } };

export type GetUserByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetUserByEmailQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, email: string, firstName: string, lastName: string, role: string, hasConfigPermissions: boolean, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, isOutOfOffice: boolean, dateFormatPreference: OverrideTypes["AvailableDateFormat"] | null, organisation: { __typename?: 'organisations', id: string, name: string, email_logo_url_dark: string | null, languagePreference: OverrideTypes["AvailableLocale"] | null } }> };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserByIdQuery = { __typename?: 'query_root', users_by_pk: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, dateFormatPreference: OverrideTypes["AvailableDateFormat"] | null } | null };

export type GetUserOneQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserOneQuery = { __typename?: 'query_root', users_by_pk: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, isOutOfOffice: boolean, organisation: { __typename?: 'organisations', id: string, name: string, isQa: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null } } | null };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, isOutOfOffice: boolean }> };

export type InsertGroupUsersMutationVariables = Exact<{
  objects: Array<GroupUsersInsertInput> | GroupUsersInsertInput;
}>;


export type InsertGroupUsersMutation = { __typename?: 'mutation_root', insert_group_users: { __typename?: 'group_users_mutation_response', returning: Array<{ __typename?: 'group_users', id: string, group: { __typename?: 'groups', id: string, name: string, rawAttributes: any | null, organisationId: string, isArchived: boolean } }> } | null };

export type UnarchiveUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UnarchiveUserMutation = { __typename?: 'mutation_root', update_users_by_pk: { __typename?: 'users', id: string } | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: InputMaybe<UsersSetInput>;
}>;


export type UpdateUserMutation = { __typename?: 'mutation_root', update_users_by_pk: { __typename?: 'users', isOutOfOffice: boolean, id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, group_users: Array<{ __typename?: 'group_users', id: string, group: { __typename?: 'groups', id: string, name: string, rawAttributes: any | null, organisationId: string, isArchived: boolean } }>, department: { __typename?: 'departments', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, managerUser: { __typename?: 'users', id: string, firstName: string, lastName: string } | null } | null };

export type UserDetailsFragmentFragment = { __typename?: 'users', isOutOfOffice: boolean, id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, customFieldValues: Array<{ __typename?: 'custom_field_values', id: string, entityId: string, value: string | null, booleanValue: boolean | null, numberValue: number | null, customFieldId: string, customFieldChoiceId: string | null, choice: { __typename?: 'custom_field_choices', id: string, label: string } | null, customField: { __typename?: 'custom_fields', id: string, type: OverrideTypes["CustomFieldsType"], title: string, customCoreData: { __typename?: 'custom_core_data', id: string, pathLevels: Array<string> | null } | null }, user: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string } | null, file: { __typename?: 'request_documents', id: string, fileName: string, filestoreId: string } | null, customFieldCoreData: { __typename?: 'custom_field_core_data', department: { __typename?: 'departments', id: string, name: string, isArchived: boolean } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string, isArchived: boolean } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string, isArchived: boolean } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string, isArchived: boolean } | null, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], isArchived: boolean } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string, isArchived: boolean } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, customCoreDataId: string, value: string, isArchived: boolean, isTerminal: boolean } | null } | null }>, group_users: Array<{ __typename?: 'group_users', id: string, group: { __typename?: 'groups', id: string, name: string, rawAttributes: any | null, organisationId: string, isArchived: boolean } }>, department: { __typename?: 'departments', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, managerUser: { __typename?: 'users', id: string, firstName: string, lastName: string } | null };

export type UserFragmentFragment = { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, isOutOfOffice: boolean };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  role: Scalars['String']['input'];
  hasConfigPermissions: Scalars['Boolean']['input'];
  isViewOnly: Scalars['Boolean']['input'];
}>;


export type CreateUserMutation = { __typename?: 'mutation_root', newUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, isOutOfOffice: boolean, groupUsers: Array<{ __typename?: 'group_users', id: string, group: { __typename?: 'groups', id: string, name: string, rawAttributes: any | null, organisationId: string, isArchived: boolean } }> } | null };

export type CreateWorkflowMutationVariables = Exact<{
  workflow: WorkflowsInsertInput;
}>;


export type CreateWorkflowMutation = { __typename?: 'mutation_root', insert_workflows_one: { __typename?: 'workflows', id: string, title: string, description: string, state: WorkflowStateEnum, type: WorkflowTypeEnum, url: string | null, isArchived: boolean, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"], viewModel: any | null, viewModelUpdatedAt: string | null, requestSidebarConfig: any | null, createdAt: string, updatedAt: string, canvasModelUpdatedAt: string, expectedSLA: number | null, organisationId: string, organisation: { __typename?: 'organisations', id: string, name: string } | null, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, workflow_rank: { __typename?: 'workflow_ranks', rank: number } | null } | null };

export type DeleteWorkflowConditionGroupOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteWorkflowConditionGroupOneMutation = { __typename?: 'mutation_root', update_workflow_condition_groups_by_pk: { __typename?: 'workflow_condition_groups', id: string, name: string, condition: OverrideTypes["WorkflowConditionGroupCondition"] | null, createdAt: string, updatedAt: string, precedence: number | null } | null };

export type GetWorkflowConditionGroupOneQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetWorkflowConditionGroupOneQuery = { __typename?: 'query_root', workflow_condition_groups_by_pk: { __typename?: 'workflow_condition_groups', id: string, workflowId: string, name: string, deletedAt: string | null } | null };

export type GetWorkflowConditionGroupsQueryVariables = Exact<{
  workflowId: Scalars['uuid']['input'];
}>;


export type GetWorkflowConditionGroupsQuery = { __typename?: 'query_root', workflow_condition_groups: Array<{ __typename?: 'workflow_condition_groups', id: string, name: string, condition: OverrideTypes["WorkflowConditionGroupCondition"] | null, createdAt: string, updatedAt: string, precedence: number | null }> };

export type GetWorkflowForDuplicationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetWorkflowForDuplicationQuery = { __typename?: 'query_root', workflows_by_pk: { __typename?: 'workflows', id: string, title: string, description: string, state: WorkflowStateEnum, type: WorkflowTypeEnum, url: string | null, isArchived: boolean, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"], viewModel: any | null, viewModelUpdatedAt: string | null, requestSidebarConfig: any | null, createdAt: string, updatedAt: string, canvasModelUpdatedAt: string, expectedSLA: number | null, organisationId: string, workflow_condition_groups: Array<{ __typename?: 'workflow_condition_groups', id: string, name: string, condition: OverrideTypes["WorkflowConditionGroupCondition"] | null, createdAt: string, updatedAt: string, precedence: number | null }>, organisation: { __typename?: 'organisations', id: string, name: string } | null, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, workflow_rank: { __typename?: 'workflow_ranks', rank: number } | null } | null };

export type GetWorkflowOneQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetWorkflowOneQuery = { __typename?: 'query_root', workflows_by_pk: { __typename?: 'workflows', id: string, title: string, description: string, state: WorkflowStateEnum, type: WorkflowTypeEnum, url: string | null, isArchived: boolean, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"], viewModel: any | null, viewModelUpdatedAt: string | null, requestSidebarConfig: any | null, createdAt: string, updatedAt: string, canvasModelUpdatedAt: string, expectedSLA: number | null, organisationId: string, organisation: { __typename?: 'organisations', id: string, name: string } | null, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, workflow_rank: { __typename?: 'workflow_ranks', rank: number } | null } | null };

export type InsertWorkflowConditionGroupOneMutationVariables = Exact<{
  object?: InputMaybe<WorkflowConditionGroupsInsertInput>;
}>;


export type InsertWorkflowConditionGroupOneMutation = { __typename?: 'mutation_root', insert_workflow_condition_groups_one: { __typename?: 'workflow_condition_groups', id: string, name: string, condition: OverrideTypes["WorkflowConditionGroupCondition"] | null, createdAt: string, updatedAt: string, precedence: number | null } | null };

export type InsertWorkflowMutationVariables = Exact<{
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  state: WorkflowStateEnum;
  routingCanvasModel: Scalars['jsonb']['input'];
  type: WorkflowTypeEnum;
  url: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertWorkflowMutation = { __typename?: 'mutation_root', insert_workflows: { __typename?: 'workflows_mutation_response', returning: Array<{ __typename?: 'workflows', id: string, title: string, description: string, state: WorkflowStateEnum, type: WorkflowTypeEnum, url: string | null, isArchived: boolean, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"], viewModel: any | null, viewModelUpdatedAt: string | null, requestSidebarConfig: any | null, createdAt: string, updatedAt: string, canvasModelUpdatedAt: string, expectedSLA: number | null, organisationId: string, organisation: { __typename?: 'organisations', id: string, name: string } | null, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, workflow_rank: { __typename?: 'workflow_ranks', rank: number } | null }> } | null };

export type UpdateWorkflowConditionGroupOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  params: WorkflowConditionGroupsSetInput;
}>;


export type UpdateWorkflowConditionGroupOneMutation = { __typename?: 'mutation_root', update_workflow_condition_groups_by_pk: { __typename?: 'workflow_condition_groups', id: string, name: string, condition: OverrideTypes["WorkflowConditionGroupCondition"] | null, createdAt: string, updatedAt: string, precedence: number | null } | null };

export type UpdateWorkflowRoutingCanvasModelMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  routingCanvasModel: Scalars['jsonb']['input'];
}>;


export type UpdateWorkflowRoutingCanvasModelMutation = { __typename?: 'mutation_root', update_workflows_by_pk: { __typename?: 'workflows', id: string, title: string, description: string, state: WorkflowStateEnum, type: WorkflowTypeEnum, url: string | null, isArchived: boolean, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"], viewModel: any | null, viewModelUpdatedAt: string | null, requestSidebarConfig: any | null, createdAt: string, updatedAt: string, canvasModelUpdatedAt: string, expectedSLA: number | null, organisationId: string, organisation: { __typename?: 'organisations', id: string, name: string } | null, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, workflow_rank: { __typename?: 'workflow_ranks', rank: number } | null } | null };

export type WorkflowConditionGroupFragmentFragment = { __typename?: 'workflow_condition_groups', id: string, name: string, condition: OverrideTypes["WorkflowConditionGroupCondition"] | null, createdAt: string, updatedAt: string, precedence: number | null };

export type WorkflowFragmentFragment = { __typename?: 'workflows', id: string, title: string, description: string, state: WorkflowStateEnum, type: WorkflowTypeEnum, url: string | null, isArchived: boolean, routingCanvasModel: OverrideTypes["WorkflowCanvasModel"], viewModel: any | null, viewModelUpdatedAt: string | null, requestSidebarConfig: any | null, createdAt: string, updatedAt: string, canvasModelUpdatedAt: string, expectedSLA: number | null, organisationId: string, organisation: { __typename?: 'organisations', id: string, name: string } | null, updated_by_user: { __typename?: 'users', id: string, firstName: string, lastName: string } | null, workflow_rank: { __typename?: 'workflow_ranks', rank: number } | null };

export type UpdateWorkflowRanksMutationVariables = Exact<{
  objects: Array<WorkflowRanksInsertInput> | WorkflowRanksInsertInput;
}>;


export type UpdateWorkflowRanksMutation = { __typename?: 'mutation_root', insert_workflow_ranks: { __typename?: 'workflow_ranks_mutation_response', affected_rows: number } | null };

export type GetUsersAndRequestsQueryVariables = Exact<{
  userIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  requestIds: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetUsersAndRequestsQuery = { __typename?: 'query_root', requests: Array<{ __typename?: 'requests', id: string, createdAt: string, deletedAt: string | null, updatedAt: string, completedAt: string | null, name: string, publicId: string }>, users: Array<{ __typename?: 'users', id: string, createdAt: string, updatedAt: string, deletedAt: string | null, email: string, firstName: string, lastName: string }> };

export type GetFeatureFlagQueryVariables = Exact<{
  featureFlag: FeatureFlagsEnum;
}>;


export type GetFeatureFlagQuery = { __typename?: 'query_root', featureFlags: Array<{ __typename?: 'organisation_feature_flags', featureFlag: FeatureFlagsEnum }> };

export type GetMultipleFeatureFlagsQueryVariables = Exact<{
  featureFlags: Array<FeatureFlagsEnum> | FeatureFlagsEnum;
}>;


export type GetMultipleFeatureFlagsQuery = { __typename?: 'query_root', featureFlags: Array<{ __typename?: 'organisation_feature_flags', featureFlag: FeatureFlagsEnum }> };

export type ConfigForTranslationQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigForTranslationQuery = { __typename?: 'query_root', workflows: Array<{ __typename?: 'workflows', id: string, title: string, description: string }>, form_templates: Array<{ __typename?: 'form_templates', id: string, title: string, externalTitle: string | null, description: string, config: OverrideTypes["FormConfig"] }>, departments: Array<{ __typename?: 'departments', id: string, name: string, coreData: { __typename?: 'core_data', id: string } }>, subsidiaries: Array<{ __typename?: 'subsidiaries', id: string, name: string, coreData: { __typename?: 'core_data', id: string } }>, payment_terms: Array<{ __typename?: 'payment_terms', id: string, name: string, coreData: { __typename?: 'core_data', id: string } }>, payment_methods: Array<{ __typename?: 'payment_methods', id: string, name: string, coreData: { __typename?: 'core_data', id: string } }>, line_item_types: Array<{ __typename?: 'line_item_types', id: string, name: string, coreData: { __typename?: 'core_data', id: string } }>, custom_core_data: Array<{ __typename?: 'custom_core_data', id: string, name: string, custom_core_data_options: Array<{ __typename?: 'custom_core_data_options', id: string, value: string }> }> };

export type GetLocalePreferencesByUserIdQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetLocalePreferencesByUserIdQuery = { __typename?: 'query_root', users_by_pk: { __typename?: 'users', id: string, languagePreference: OverrideTypes["AvailableLocale"] | null, organisation: { __typename?: 'organisations', languagePreference: OverrideTypes["AvailableLocale"] | null } } | null };

export type GetLocalePreferencesForOrganisationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocalePreferencesForOrganisationQuery = { __typename?: 'query_root', organisations: Array<{ __typename?: 'organisations', id: string, languagePreference: OverrideTypes["AvailableLocale"] | null }> };

export type CreateFormSubmissionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  requestFormId: Scalars['uuid']['input'];
  submittedBy: Scalars['uuid']['input'];
  response: Scalars['jsonb']['input'];
  requestStepTaskId: Scalars['uuid']['input'];
}>;


export type CreateFormSubmissionMutation = { __typename?: 'mutation_root', insert_request_form_submissions_one: { __typename?: 'request_form_submissions', id: string, requestFormId: string | null, submittedBy: string | null, response: OverrideTypes["FormResponsePayload"] | null } | null };

export type CreateMinimalRequestMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  workflowId: Scalars['uuid']['input'];
  requestorUserId: Scalars['uuid']['input'];
  requestSupplierId: InputMaybe<Scalars['uuid']['input']>;
}>;


export type CreateMinimalRequestMutation = { __typename?: 'mutation_root', insert_requests_one: { __typename?: 'requests', id: string, name: string, workflowId: string, requestorUserId: string, publicId: string } | null };

export type CreateMinimalWorkflowMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  state: InputMaybe<WorkflowStateEnum>;
  type: InputMaybe<WorkflowTypeEnum>;
  routingCanvasModel: InputMaybe<Scalars['jsonb']['input']>;
  isArchived: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMinimalWorkflowMutation = { __typename?: 'mutation_root', insert_workflows_one: { __typename?: 'workflows', id: string, title: string, description: string, state: WorkflowStateEnum, type: WorkflowTypeEnum, organisationId: string } | null };

export type CreateNonRfxStepMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  requestId: Scalars['uuid']['input'];
  workflowId: Scalars['uuid']['input'];
  canvasModelId: Scalars['String']['input'];
}>;


export type CreateNonRfxStepMutation = { __typename?: 'mutation_root', insert_request_steps_one: { __typename?: 'request_steps', id: string, requestId: string, input: any, state: RequestStepStateEnum } | null };

export type CreateRequestStepTaskMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  requestStepId: Scalars['uuid']['input'];
  organisationSupplierId: Scalars['uuid']['input'];
  requestFormId: InputMaybe<Scalars['uuid']['input']>;
}>;


export type CreateRequestStepTaskMutation = { __typename?: 'mutation_root', insert_request_step_tasks_one: { __typename?: 'request_step_tasks', id: string, requestStepId: string, organisationSupplierId: string | null } | null };

export type CreateRfxMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  requestStepId: Scalars['uuid']['input'];
  requestId: Scalars['uuid']['input'];
  supplierInstructions: Scalars['String']['input'];
}>;


export type CreateRfxMutation = { __typename?: 'mutation_root', insert_rfx_one: { __typename?: 'rfx', id: string, status: string, requestStepId: string } | null };

export type CreateRfxStepMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  requestId: Scalars['uuid']['input'];
  workflowId: Scalars['uuid']['input'];
  canvasModelId: Scalars['String']['input'];
}>;


export type CreateRfxStepMutation = { __typename?: 'mutation_root', insert_request_steps_one: { __typename?: 'request_steps', id: string, requestId: string, input: any, state: RequestStepStateEnum } | null };

export type CreateSeedUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  role: Scalars['String']['input'];
  hasConfigPermissions: Scalars['Boolean']['input'];
  isViewOnly: Scalars['Boolean']['input'];
  subsidiaryId: InputMaybe<Scalars['uuid']['input']>;
  departmentId: InputMaybe<Scalars['uuid']['input']>;
  managerUserId: InputMaybe<Scalars['uuid']['input']>;
}>;


export type CreateSeedUserMutation = { __typename?: 'mutation_root', newUser: { __typename?: 'users', id: string, firstName: string, lastName: string, email: string, role: string, hasConfigPermissions: boolean, isViewOnly: boolean, deletedAt: string | null, isArchived: boolean, languagePreference: OverrideTypes["AvailableLocale"] | null, isOutOfOffice: boolean, groupUsers: Array<{ __typename?: 'group_users', id: string, group: { __typename?: 'groups', id: string, name: string, rawAttributes: any | null, organisationId: string, isArchived: boolean } }> } | null };

export type CreateSupplierOnboardingFormMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  requestId: Scalars['uuid']['input'];
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type CreateSupplierOnboardingFormMutation = { __typename?: 'mutation_root', insert_request_forms_one: { __typename?: 'request_forms', id: string, type: FormTypeEnum } | null };

export type DeleteAllCoreDataByIdMutationVariables = Exact<{
  addressIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  currencyIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  departmentIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  lineItemTypeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  paymentMethodIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  paymentTermIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  subsidiaryIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  customCoreDataOptionIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  customCoreDataIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteAllCoreDataByIdMutation = { __typename?: 'mutation_root', delete_addresses: { __typename?: 'addresses_mutation_response', affected_rows: number } | null, delete_organisation_fx_rates: { __typename?: 'organisation_fx_rates_mutation_response', affected_rows: number } | null, delete_departments: { __typename?: 'departments_mutation_response', affected_rows: number } | null, delete_line_item_types: { __typename?: 'line_item_types_mutation_response', affected_rows: number } | null, delete_payment_methods: { __typename?: 'payment_methods_mutation_response', affected_rows: number } | null, delete_payment_terms: { __typename?: 'payment_terms_mutation_response', affected_rows: number } | null, delete_subsidiaries: { __typename?: 'subsidiaries_mutation_response', affected_rows: number } | null, delete_custom_core_data_options: { __typename?: 'custom_core_data_options_mutation_response', affected_rows: number } | null, delete_custom_core_data: { __typename?: 'custom_core_data_mutation_response', affected_rows: number } | null };

export type DeleteCoreDataDependenciesForOrgDependencyMutationVariables = Exact<{
  orgCoreDataDependencyId: Scalars['uuid']['input'];
}>;


export type DeleteCoreDataDependenciesForOrgDependencyMutation = { __typename?: 'mutation_root', delete_core_data_dependencies: { __typename?: 'core_data_dependencies_mutation_response', returning: Array<{ __typename?: 'core_data_dependencies', id: string }> } | null };

export type DeleteTestDepartmentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTestDepartmentMutation = { __typename?: 'mutation_root', delete_departments_by_pk: { __typename?: 'departments', id: string } | null };

export type DeleteFeatureFlagMutationVariables = Exact<{
  featureFlag: FeatureFlagsEnum;
}>;


export type DeleteFeatureFlagMutation = { __typename?: 'mutation_root', delete_organisation_feature_flags: { __typename?: 'organisation_feature_flags_mutation_response', affected_rows: number } | null };

export type DeleteRequestFollowerMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteRequestFollowerMutation = { __typename?: 'mutation_root', update_request_followers_by_pk: { __typename?: 'request_followers', id: string } | null };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTagMutation = { __typename?: 'mutation_root', update_tags_by_pk: { __typename?: 'tags', id: string, deletedAt: any | null } | null };

export type DeleteTestUserAllowedSubsidiariesMutationVariables = Exact<{
  where: UserAllowedSubsidiariesBoolExp;
}>;


export type DeleteTestUserAllowedSubsidiariesMutation = { __typename?: 'mutation_root', delete_user_allowed_subsidiaries: { __typename?: 'user_allowed_subsidiaries_mutation_response', affected_rows: number } | null };

export type EnableFeatureFlagMutationVariables = Exact<{
  featureFlag: FeatureFlagsEnum;
}>;


export type EnableFeatureFlagMutation = { __typename?: 'mutation_root', insert_organisation_feature_flags_one: { __typename?: 'organisation_feature_flags', featureFlag: FeatureFlagsEnum } | null };

export type GetAllCoreDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCoreDataQuery = { __typename?: 'query_root', core_data: Array<{ __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null }> };

export type GetBankDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetBankDetailsQuery = { __typename?: 'query_root', bank_details_by_pk: { __typename?: 'bank_details', id: string, remoteId: string | null, accountName: string | null, bankName: string | null, iban: string | null, swiftCode: string | null, sortCode: string | null, accountNumber: string | null, currencyId: string | null, code: string | null, country: string | null, addressId: string | null } | null };

export type GetBankDetailsForSupplierProfileQueryVariables = Exact<{
  supplierProfileId: Scalars['uuid']['input'];
}>;


export type GetBankDetailsForSupplierProfileQuery = { __typename?: 'query_root', entity_bank_details: Array<{ __typename?: 'entity_bank_details', id: string, bankDetailsId: string, isPrimary: boolean | null, bankDetails: { __typename?: 'bank_details', id: string, accountName: string | null, bankName: string | null, accountNumber: string | null, sortCode: string | null, iban: string | null, swiftCode: string | null, code: string | null, country: string | null, isActive: boolean } }> };

export type GetProductsAndServicesForSupplierQueryVariables = Exact<{
  orgSupplierId: Scalars['uuid']['input'];
}>;


export type GetProductsAndServicesForSupplierQuery = { __typename?: 'query_root', productsAndServices: Array<{ __typename?: 'organisation_products_and_services', id: string, deletedAt: string | null }> };

export type GetRequestComputedPropertiesQueryVariables = Exact<{
  requestId: Scalars['uuid']['input'];
}>;


export type GetRequestComputedPropertiesQuery = { __typename?: 'query_root', request: { __typename?: 'requests', id: string, computedProperties: { __typename?: 'request_computed_properties', id: string, requestId: string, website: string | null, valueNumber: number | null, contractStartDate: string | null, contractEndDate: string | null, address: any | null, taxNumber: any | null, createdAt: string, updatedAt: string } | null } | null };

export type GetUserAllowedSubsidiariesQueryVariables = Exact<{
  where: UserAllowedSubsidiariesBoolExp;
}>;


export type GetUserAllowedSubsidiariesQuery = { __typename?: 'query_root', user_allowed_subsidiaries: Array<{ __typename?: 'user_allowed_subsidiaries', userId: string, subsidiaryId: string }> };

export type InsertCustomFieldChoicesMutationVariables = Exact<{
  choices: Array<CustomFieldChoicesInsertInput> | CustomFieldChoicesInsertInput;
}>;


export type InsertCustomFieldChoicesMutation = { __typename?: 'mutation_root', insert_custom_field_choices: { __typename?: 'custom_field_choices_mutation_response', returning: Array<{ __typename?: 'custom_field_choices', id: string, label: string, customFieldId: string }> } | null };

export type SeedDepartmentMutationVariables = Exact<{
  object: DepartmentsInsertInput;
}>;


export type SeedDepartmentMutation = { __typename?: 'mutation_root', insert_departments_one: { __typename?: 'departments', id: string, name: string, createdAt: string, updatedAt: string, isArchived: boolean, organisationId: string } | null };

export type InsertRequestFollowerMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  note: InputMaybe<Scalars['String']['input']>;
  userId: InputMaybe<Scalars['uuid']['input']>;
  groupId: InputMaybe<Scalars['uuid']['input']>;
  assigneeType: AssigneeTypeEnum;
}>;


export type InsertRequestFollowerMutation = { __typename?: 'mutation_root', insert_request_followers_one: { __typename?: 'request_followers', id: string } | null };

export type InsertRequestStepMutationVariables = Exact<{
  requestStep: RequestStepsInsertInput;
}>;


export type InsertRequestStepMutation = { __typename?: 'mutation_root', insert_request_steps_one: { __typename?: 'request_steps', id: string } | null };

export type InsertRequestStepTaskRejectionMutationVariables = Exact<{
  requestStepTaskId: Scalars['uuid']['input'];
  message: Scalars['String']['input'];
  createdBy: Scalars['uuid']['input'];
}>;


export type InsertRequestStepTaskRejectionMutation = { __typename?: 'mutation_root', insert_request_step_task_rejections_one: { __typename?: 'request_step_task_rejections', id: string } | null };

export type InsertTestUserAllowedSubsidiariesMutationVariables = Exact<{
  objects: Array<UserAllowedSubsidiariesInsertInput> | UserAllowedSubsidiariesInsertInput;
}>;


export type InsertTestUserAllowedSubsidiariesMutation = { __typename?: 'mutation_root', insert_user_allowed_subsidiaries: { __typename?: 'user_allowed_subsidiaries_mutation_response', returning: Array<{ __typename?: 'user_allowed_subsidiaries', userId: string, subsidiaryId: string }> } | null };

export type InsertTestUserAllowedSubsidiaryMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  subsidiaryId: Scalars['uuid']['input'];
}>;


export type InsertTestUserAllowedSubsidiaryMutation = { __typename?: 'mutation_root', insert_user_allowed_subsidiaries_one: { __typename?: 'user_allowed_subsidiaries', userId: string, subsidiaryId: string } | null };

export type QueryDepartmentByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type QueryDepartmentByNameQuery = { __typename?: 'query_root', departments: Array<{ __typename?: 'departments', id: string, name: string, createdAt: string, updatedAt: string, isArchived: boolean, organisationId: string }> };

export type SeedBankDetailMutationVariables = Exact<{
  input: BankDetailsInsertInput;
}>;


export type SeedBankDetailMutation = { __typename?: 'mutation_root', insert_bank_details_one: { __typename?: 'bank_details', id: string, createdAt: string } | null };

export type SeedOrganisationSupplierOneMutationVariables = Exact<{
  input: OrganisationSuppliersInsertInput;
}>;


export type SeedOrganisationSupplierOneMutation = { __typename?: 'mutation_root', insert_organisation_suppliers_one: { __typename?: 'organisation_suppliers', id: string, publicId: number, remoteId: string | null } | null };

export type SeedOrganisationSupplierProfileOneMutationVariables = Exact<{
  input: OrganisationSupplierProfilesInsertInput;
}>;


export type SeedOrganisationSupplierProfileOneMutation = { __typename?: 'mutation_root', insert_organisation_supplier_profiles_one: { __typename?: 'organisation_supplier_profiles', id: string, subsidiaryId: string, customFieldValues: Array<{ __typename?: 'custom_field_values', value: string | null, customFieldId: string, entityId: string, booleanValue: boolean | null, numberValue: number | null }> } | null };

export type SeedPurchaseOrderMutationVariables = Exact<{
  input: PurchaseOrdersInsertInput;
}>;


export type SeedPurchaseOrderMutation = { __typename?: 'mutation_root', insert_purchase_orders_one: { __typename?: 'purchase_orders', id: string, requestId: string, organisationId: string } | null };

export type SeedPurchaseOrderLineItemsMutationVariables = Exact<{
  objects: Array<PurchaseOrderLineItemsInsertInput> | PurchaseOrderLineItemsInsertInput;
}>;


export type SeedPurchaseOrderLineItemsMutation = { __typename?: 'mutation_root', insert_purchase_order_line_items: { __typename?: 'purchase_order_line_items_mutation_response', returning: Array<{ __typename?: 'purchase_order_line_items', id: string, purchaseOrderId: string, lineNumber: number }> } | null };

export type SeedTestRiskMutationVariables = Exact<{
  input: RisksInsertInput;
}>;


export type SeedTestRiskMutation = { __typename?: 'mutation_root', insert_risks_one: { __typename?: 'risks', id: string } | null };

export type SeedTestRiskLevelMutationVariables = Exact<{
  input: RiskLevelsInsertInput;
}>;


export type SeedTestRiskLevelMutation = { __typename?: 'mutation_root', insert_risk_levels_one: { __typename?: 'risk_levels', id: string } | null };

export type SoftDeleteOrganisationSupplierProfileOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SoftDeleteOrganisationSupplierProfileOneMutation = { __typename?: 'mutation_root', update_organisation_supplier_profiles: { __typename?: 'organisation_supplier_profiles_mutation_response', affected_rows: number } | null };

export type UpdateRequestStateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  updates: RequestsSetInput;
}>;


export type UpdateRequestStateMutation = { __typename?: 'mutation_root', update_requests_by_pk: { __typename?: 'requests', id: string } | null };

export type GetEntityBankDetailQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEntityBankDetailQuery = { __typename?: 'query_root', entityBankDetails: Array<{ __typename?: 'entity_bank_details', id: string, bankDetailsId: string, organisationSupplierId: string | null, organisationSupplierProfileId: string | null }> };

export type GetEntityBankDetailsBySupplierQueryVariables = Exact<{
  supplierId: Scalars['uuid']['input'];
}>;


export type GetEntityBankDetailsBySupplierQuery = { __typename?: 'query_root', entity_bank_details: Array<{ __typename?: 'entity_bank_details', id: string, bankDetailsId: string, organisationSupplierId: string | null, organisationSupplierProfileId: string | null, isPrimary: boolean | null }> };

export type GetEntityBankDetailsBySupplierProfileQueryVariables = Exact<{
  supplierProfileId: Scalars['uuid']['input'];
}>;


export type GetEntityBankDetailsBySupplierProfileQuery = { __typename?: 'query_root', entity_bank_details: Array<{ __typename?: 'entity_bank_details', id: string, bankDetailsId: string, organisationSupplierId: string | null, organisationSupplierProfileId: string | null }> };

export type SeedEntityBankDetailOneMutationVariables = Exact<{
  input: EntityBankDetailsInsertInput;
}>;


export type SeedEntityBankDetailOneMutation = { __typename?: 'mutation_root', insert_entity_bank_details_one: { __typename?: 'entity_bank_details', id: string, bankDetailsId: string, organisationSupplierId: string | null, organisationSupplierProfileId: string | null, isPrimary: boolean | null } | null };

export type GetOrganisationCurrenciesQueryVariables = Exact<{
  query: InputMaybe<OrganisationFxRatesBoolExp>;
}>;


export type GetOrganisationCurrenciesQuery = { __typename?: 'query_root', organisation_fx_rates: Array<{ __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string }> };

export type GetOrganisationCurrenciesWithDependenciesMetadataQueryVariables = Exact<{
  query: InputMaybe<OrganisationFxRatesBoolExp>;
  depsLimit: Scalars['Int']['input'];
}>;


export type GetOrganisationCurrenciesWithDependenciesMetadataQuery = { __typename?: 'query_root', organisation_fx_rates: Array<{ __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string, dependenciesMetadata: { __typename?: 'core_data', dependenciesPreview: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }>, numDependencies: { __typename?: 'core_data_dependencies_aggregate', aggregate: { __typename?: 'core_data_dependencies_aggregate_fields', count: number } | null } } }> };

export type GetOrganisationCurrenciesWithDependenciesQueryVariables = Exact<{
  query: InputMaybe<OrganisationFxRatesBoolExp>;
}>;


export type GetOrganisationCurrenciesWithDependenciesQuery = { __typename?: 'query_root', organisation_fx_rates: Array<{ __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"], fxRate: number, displaySymbol: string | null, isVisible: boolean, isArchived: boolean, archivedBy: string | null, remoteId: string | null, updatedAt: string, coreDataId: string, coreData: { __typename?: 'core_data', id: string, coreDataDependencies: Array<{ __typename?: 'core_data_dependencies', id: string, coreDataId: string, coreDataType: string, dependencyCoreDataId: string | null, dependencyCoreDataType: string, dependencySupplierProfileId: string | null, dependencyType: string | null, isAll: boolean | null, dependencyCoreData: { __typename?: 'core_data', id: string, currency: { __typename?: 'organisation_fx_rates', id: string, name: string | null, code: OverrideTypes["CurrencyCode"] } | null, customCoreDataOption: { __typename?: 'custom_core_data_options', id: string, name: string } | null, department: { __typename?: 'departments', id: string, name: string } | null, lineItemType: { __typename?: 'line_item_types', id: string, name: string } | null, paymentMethod: { __typename?: 'payment_methods', id: string, name: string } | null, paymentTerm: { __typename?: 'payment_terms', id: string, name: string } | null, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } | null, address: { __typename?: 'addresses', id: string, name: string | null, addressLine1: string | null, addressLine2: string | null, county: string | null, state: string | null, city: string | null, postalCode: string | null, country: string | null } | null } | null, dependencySupplierProfile: { __typename?: 'organisation_supplier_profiles', id: string, organisationSupplierId: string, subsidiaryId: string, organisationSupplier: { __typename?: 'organisation_suppliers', id: string, name: string }, subsidiary: { __typename?: 'subsidiaries', id: string, name: string } } | null }> } }> };

export type GetOrganisationSettingsByNameQueryVariables = Exact<{
  settingName: Scalars['String']['input'];
}>;


export type GetOrganisationSettingsByNameQuery = { __typename?: 'query_root', organisation_settings: Array<{ __typename?: 'organisation_settings', name: string, value: any }> };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const PurchaseOrderFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment PurchaseOrderFragment on purchase_orders {
  id
  requestId
  organisationId
  remoteNumber
  remoteId
  remoteLink
  remoteStatus
  remoteTotalValue
  remoteInvoicedValue
  remotePaidValue
  currencyId
  status
}
    `, {"fragmentName":"PurchaseOrderFragment"}) as unknown as TypedDocumentString<PurchaseOrderFragmentFragment, unknown>;
export const AgreementLinkForRequestDetailFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment AgreementLinkForRequestDetail on requests {
  agreement_term {
    id
    name
    agreementId
  }
  sourceRenewal: renewal {
    sourceAgreementTerm {
      id
      name
      agreementId
    }
  }
}
    `, {"fragmentName":"AgreementLinkForRequestDetail"}) as unknown as TypedDocumentString<AgreementLinkForRequestDetailFragment, unknown>;
export const SupplierAgreementFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment SupplierAgreement on agreements {
  id
  agreement_terms {
    id
    totalAmount
    currencyCode
    fxRate
    primaryDepartment {
      id
      name
      isArchived
    }
  }
}
    `, {"fragmentName":"SupplierAgreement"}) as unknown as TypedDocumentString<SupplierAgreementFragment, unknown>;
export const CustomFieldValueFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
    `, {"fragmentName":"CustomFieldValueFragment"}) as unknown as TypedDocumentString<CustomFieldValueFragmentFragment, unknown>;
export const AgreementTermFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment AgreementTerm on agreement_terms {
  createdAt
  name
  startDate
  endDate
  termType
  cancelledAt
  autoRenew
  id
  cancelByDate
  cancelledAt
  totalAmount
  totalAmountInDefaultCurrency
  currencyCode
  fxRate
  fxTime
  cancellationNoticeDayCount
  primaryDepartmentId
  primaryDepartment @include(if: $includePrimaryDepartment) {
    id
    name
    isArchived
  }
  products {
    id
    organisationProductId
    organisation_products_and_service @include(if: $includeProducts) {
      id
      name
    }
  }
  futureRenewal(where: {deletedAt: {_is_null: true}}) {
    id
    workflowStartDate
    workflowStartDayCount
    cancellationNoticeDayCount
    workflowInitialAssigneeId
    status
    renewalDate
    renewedAt
    autoStartEnabled
    sourceRequestId
    organisationProductId
    organisationSupplierId
    workflow {
      id
      title
    }
    request {
      status
      id
    }
  }
  spend: spendItems {
    id
    description
    totalAmount
    startDate
    endDate
    frequency
    quantity
    rate
    fxRate
    fxTime
    currencyCode
  }
  agreement_term_revisions(order_by: {createdAt: desc_nulls_last}) @include(if: $includeRevisions) {
    id
    createdAt
    submittedBy: user {
      id
      firstName
      lastName
    }
    response @include(if: $includeRevisionsResponse)
    agreementTermId
    submissionSource
    requestFormSubmission {
      id
      request_form {
        id
        request {
          id
          name
          publicId
        }
      }
    }
  }
  custom_field_values(
    where: {customFieldId: {_in: $customFields}, deletedAt: {_is_null: true}}
  ) @include(if: $includeCustomFields) {
    ...CustomFieldValueFragment
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`, {"fragmentName":"AgreementTerm"}) as unknown as TypedDocumentString<AgreementTermFragment, unknown>;
export const AgreementFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment Agreement on agreements {
  id
  createdAt
  deletedAt
  name
  publicId
  remoteId
  description
  parentId
  parent {
    id
    name
    publicId
  }
  ownerId
  owner @include(if: $includeOwners) {
    firstName
    lastName
    id
    email
    isArchived
  }
  additionalOwners @include(if: $includeOwners) {
    id
    userId
    user {
      id
      firstName
      lastName
      email
      isArchived
    }
  }
  supplier {
    id
    name
    state
    logoUrl
  }
  subsidiaryId
  subsidiary @include(if: $includeSubsidiary) {
    id
    name
  }
  paymentTermId
  paymentTerm @include(if: $includePaymentTerm) {
    id
    name
  }
  paymentMethodId
  paymentMethod @include(if: $includePaymentMethod) {
    id
    name
  }
  tags @include(if: $includeTags) {
    id
    tag {
      id
      name
    }
  }
  terms: agreement_terms(order_by: {startDate: asc}) {
    ...AgreementTerm
  }
  organisation {
    id
    name
  }
  refreshPricesAt
}
    fragment AgreementTerm on agreement_terms {
  createdAt
  name
  startDate
  endDate
  termType
  cancelledAt
  autoRenew
  id
  cancelByDate
  cancelledAt
  totalAmount
  totalAmountInDefaultCurrency
  currencyCode
  fxRate
  fxTime
  cancellationNoticeDayCount
  primaryDepartmentId
  primaryDepartment @include(if: $includePrimaryDepartment) {
    id
    name
    isArchived
  }
  products {
    id
    organisationProductId
    organisation_products_and_service @include(if: $includeProducts) {
      id
      name
    }
  }
  futureRenewal(where: {deletedAt: {_is_null: true}}) {
    id
    workflowStartDate
    workflowStartDayCount
    cancellationNoticeDayCount
    workflowInitialAssigneeId
    status
    renewalDate
    renewedAt
    autoStartEnabled
    sourceRequestId
    organisationProductId
    organisationSupplierId
    workflow {
      id
      title
    }
    request {
      status
      id
    }
  }
  spend: spendItems {
    id
    description
    totalAmount
    startDate
    endDate
    frequency
    quantity
    rate
    fxRate
    fxTime
    currencyCode
  }
  agreement_term_revisions(order_by: {createdAt: desc_nulls_last}) @include(if: $includeRevisions) {
    id
    createdAt
    submittedBy: user {
      id
      firstName
      lastName
    }
    response @include(if: $includeRevisionsResponse)
    agreementTermId
    submissionSource
    requestFormSubmission {
      id
      request_form {
        id
        request {
          id
          name
          publicId
        }
      }
    }
  }
  custom_field_values(
    where: {customFieldId: {_in: $customFields}, deletedAt: {_is_null: true}}
  ) @include(if: $includeCustomFields) {
    ...CustomFieldValueFragment
  }
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`, {"fragmentName":"Agreement"}) as unknown as TypedDocumentString<AgreementFragment, unknown>;
export const AgreementTermRevisionFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment AgreementTermRevisionFragment on agreement_term_revisions {
  id
  createdAt
  submittedBy: user {
    id
    firstName
    lastName
  }
  response
  config
  agreementTermId
  submissionSource
  requestFormSubmission {
    id
    request_form {
      id
      request {
        id
        name
        publicId
      }
    }
  }
}
    `, {"fragmentName":"AgreementTermRevisionFragment"}) as unknown as TypedDocumentString<AgreementTermRevisionFragmentFragment, unknown>;
export const SummaryRiskLevelFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment SummaryRiskLevel on risks {
  id
  inherentRiskImpact {
    id
    name
    score
  }
  inherentRiskProbability {
    id
    name
    score
  }
  inherentRiskMatrix {
    id
    score
  }
  residualRiskImpact {
    id
    name
    score
  }
  residualRiskProbability {
    id
    name
    score
  }
  residualRiskMatrix {
    id
    score
  }
}
    `, {"fragmentName":"SummaryRiskLevel"}) as unknown as TypedDocumentString<SummaryRiskLevelFragment, unknown>;
export const AssessmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment Assessment on assessments {
  id
  name
  assessmentTags(where: {tag: {deletedAt: {_is_null: true}}}) {
    id
    tag {
      id
      name
    }
  }
  externalRespondents
  additionalUsers {
    user {
      id
      email
      firstName
      lastName
      isArchived
    }
  }
  additionalGroups {
    id
    group {
      id
      name
    }
  }
  frequency
  sendDate
  workflow {
    id
    title
    routingCanvasModel
    viewModel
    viewModelUpdatedAt
    canvasModelUpdatedAt
    type
  }
  request {
    id
    risks(where: {deletedAt: {_is_null: true}}) {
      ...SummaryRiskLevel
    }
    model
    tagIds
    type
    completedAt
    state
    inProgressStepContext: steps(
      where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
    ) {
      id
      nodeId: canvasModelId
      name: input(path: "$.metadata.config.payload.label")
      assignees: output(path: "$.assignees")
      type: input(path: "$.metadata.type")
      state
      requestStepUsers: request_step_users(where: {deletedAt: {_is_null: true}}) {
        id
        user {
          id
          firstName
          lastName
        }
      }
      requestStepGroups: request_step_groups(where: {deletedAt: {_is_null: true}}) {
        id
        group {
          id
          name
        }
      }
    }
    steps {
      id
      state
      result
      canvasModelId
      createdAt
      completedAt
      totalPausedWorkingHours
      input
    }
    request_forms {
      id
      config
      currentSubmission: request_form_submissions(
        limit: 1
        order_by: {submittedOn: desc_nulls_last}
      ) {
        id
        response
        submittedOn
      }
    }
  }
  completedAt
  businessOwnerUserId
  autoStartEnabled
  organisation {
    id
    name
  }
  deletedAt
  product {
    id
    name
    state
    logoUrl
  }
  organisation_supplier {
    id
    name
    state
    logoUrl
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
    }
  }
}
    fragment SummaryRiskLevel on risks {
  id
  inherentRiskImpact {
    id
    name
    score
  }
  inherentRiskProbability {
    id
    name
    score
  }
  inherentRiskMatrix {
    id
    score
  }
  residualRiskImpact {
    id
    name
    score
  }
  residualRiskProbability {
    id
    name
    score
  }
  residualRiskMatrix {
    id
    score
  }
}`, {"fragmentName":"Assessment"}) as unknown as TypedDocumentString<AssessmentFragment, unknown>;
export const BudgetApprovalsThresholdFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment BudgetApprovalsThreshold on budget_approval_threshold {
  id
  name
  created_at
  minValue
  maxValue
  inBudget
  departments {
    department {
      id
      name
    }
  }
  groups: budget_approval_threshold_groups {
    id
    isApproval
    approvalGroupId
  }
}
    `, {"fragmentName":"BudgetApprovalsThreshold"}) as unknown as TypedDocumentString<BudgetApprovalsThresholdFragment, unknown>;
export const BudgetsWithSpendComputeFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment BudgetsWithSpendCompute on budgets {
  id
  amount
  externalId
  name
  status
  createdAt
  budgets_organisation_fx_rate {
    id
    code
    displaySymbol
    fxRate
  }
  requests: budgets_requests(where: {deletedAt: {_is_null: true}}) {
    id
    engagement {
      id
      financial {
        id
        amount
      }
    }
    computedProperties {
      valueObject
    }
  }
}
    `, {"fragmentName":"BudgetsWithSpendCompute"}) as unknown as TypedDocumentString<BudgetsWithSpendComputeFragment, unknown>;
export const CustomFieldsFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CustomFieldsFragment on custom_fields {
  id
  title
  type
  entityType
  isRequired
  externalSource
  remoteId
  customCoreData {
    id
    name
  }
  choices {
    id
    label
    customFieldId
  }
}
    `, {"fragmentName":"CustomFieldsFragment"}) as unknown as TypedDocumentString<CustomFieldsFragmentFragment, unknown>;
export const FormTemplateFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment FormTemplateFragment on form_templates {
  config
  description
  id
  internalId
  state
  title
  integration
  externalTitle
  type
  updatedAt
  updated_by_user {
    id
    firstName
    lastName
  }
}
    `, {"fragmentName":"FormTemplateFragment"}) as unknown as TypedDocumentString<FormTemplateFragmentFragment, unknown>;
export const ExternalContactFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment ExternalContact on external_contacts {
  id
  title
  supplierId
  firstName
  lastName
  email
  phoneNumber
  createdAt
  isPrimary
  userId
}
    `, {"fragmentName":"ExternalContact"}) as unknown as TypedDocumentString<ExternalContactFragment, unknown>;
export const InternalContactFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment InternalContact on internal_contacts {
  id
  role
  title
  supplierId
  product {
    id
    name: displayName
    logoUrl
  }
  user {
    id
    firstName
    lastName
    email
  }
  engagement {
    id
    name
  }
  createdAt
}
    `, {"fragmentName":"InternalContact"}) as unknown as TypedDocumentString<InternalContactFragment, unknown>;
export const LabelsPayloadFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment LabelsPayload on custom_core_data {
  customCoreDataId: id
  label: name
  pathLevels
  archivedAt
  organisationIntegration {
    id
    integration
  }
}
    `, {"fragmentName":"LabelsPayload"}) as unknown as TypedDocumentString<LabelsPayloadFragment, unknown>;
export const AddressFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
    `, {"fragmentName":"Address"}) as unknown as TypedDocumentString<AddressFragment, unknown>;
export const CoreDataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
    `, {"fragmentName":"CoreData"}) as unknown as TypedDocumentString<CoreDataFragment, unknown>;
export const SupplierProfileFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
    `, {"fragmentName":"SupplierProfile"}) as unknown as TypedDocumentString<SupplierProfileFragment, unknown>;
export const CoreDataDependenciesFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
    fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}`, {"fragmentName":"CoreDataDependencies"}) as unknown as TypedDocumentString<CoreDataDependenciesFragment, unknown>;
export const CoreDataDependenciesMetadataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}`, {"fragmentName":"CoreDataDependenciesMetadata"}) as unknown as TypedDocumentString<CoreDataDependenciesMetadataFragment, unknown>;
export const AddressWithDependenciesMetadataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment AddressWithDependenciesMetadata on addresses {
  ...Address
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`, {"fragmentName":"AddressWithDependenciesMetadata"}) as unknown as TypedDocumentString<AddressWithDependenciesMetadataFragment, unknown>;
export const OrganisationFxRateFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
    `, {"fragmentName":"OrganisationFxRate"}) as unknown as TypedDocumentString<OrganisationFxRateFragment, unknown>;
export const OrganisationFxRateWithDependenciesMetadataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment OrganisationFxRateWithDependenciesMetadata on organisation_fx_rates {
  ...OrganisationFxRate
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`, {"fragmentName":"OrganisationFxRateWithDependenciesMetadata"}) as unknown as TypedDocumentString<OrganisationFxRateWithDependenciesMetadataFragment, unknown>;
export const DepartmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment Department on departments {
  createdAt
  isArchived
  archivedBy
  id
  name
  organisationId
  remoteId
  updatedAt
  coreDataId
}
    `, {"fragmentName":"Department"}) as unknown as TypedDocumentString<DepartmentFragment, unknown>;
export const DepartmentWithDependenciesMetadataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment DepartmentWithDependenciesMetadata on departments {
  ...Department
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment Department on departments {
  createdAt
  isArchived
  archivedBy
  id
  name
  organisationId
  remoteId
  updatedAt
  coreDataId
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`, {"fragmentName":"DepartmentWithDependenciesMetadata"}) as unknown as TypedDocumentString<DepartmentWithDependenciesMetadataFragment, unknown>;
export const LineItemTypeFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment LineItemType on line_item_types {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}
    `, {"fragmentName":"LineItemType"}) as unknown as TypedDocumentString<LineItemTypeFragment, unknown>;
export const LineItemTypeWithDependenciesMetadataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment LineItemTypeWithDependenciesMetadata on line_item_types {
  ...LineItemType
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment LineItemType on line_item_types {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`, {"fragmentName":"LineItemTypeWithDependenciesMetadata"}) as unknown as TypedDocumentString<LineItemTypeWithDependenciesMetadataFragment, unknown>;
export const PaymentMethodFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment PaymentMethod on payment_methods {
  id
  name
  updatedAt
  isArchived
  archivedBy
  remoteId
  coreDataId
}
    `, {"fragmentName":"PaymentMethod"}) as unknown as TypedDocumentString<PaymentMethodFragment, unknown>;
export const PaymentMethodWithDependenciesMetadataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment PaymentMethodWithDependenciesMetadata on payment_methods {
  ...PaymentMethod
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment PaymentMethod on payment_methods {
  id
  name
  updatedAt
  isArchived
  archivedBy
  remoteId
  coreDataId
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`, {"fragmentName":"PaymentMethodWithDependenciesMetadata"}) as unknown as TypedDocumentString<PaymentMethodWithDependenciesMetadataFragment, unknown>;
export const PaymentTermFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment PaymentTerm on payment_terms {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}
    `, {"fragmentName":"PaymentTerm"}) as unknown as TypedDocumentString<PaymentTermFragment, unknown>;
export const PaymentTermWithDependenciesMetadataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment PaymentTermWithDependenciesMetadata on payment_terms {
  ...PaymentTerm
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment PaymentTerm on payment_terms {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`, {"fragmentName":"PaymentTermWithDependenciesMetadata"}) as unknown as TypedDocumentString<PaymentTermWithDependenciesMetadataFragment, unknown>;
export const SubsidiaryFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment Subsidiary on subsidiaries {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}
    `, {"fragmentName":"Subsidiary"}) as unknown as TypedDocumentString<SubsidiaryFragment, unknown>;
export const SubsidiaryWithDependenciesMetadataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment SubsidiaryWithDependenciesMetadata on subsidiaries {
  ...Subsidiary
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment Subsidiary on subsidiaries {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`, {"fragmentName":"SubsidiaryWithDependenciesMetadata"}) as unknown as TypedDocumentString<SubsidiaryWithDependenciesMetadataFragment, unknown>;
export const BankAccountFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
    fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`, {"fragmentName":"BankAccount"}) as unknown as TypedDocumentString<BankAccountFragment, unknown>;
export const EntityBankAccountFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment EntityBankAccount on entity_bank_details {
  isPrimary
  bankDetails {
    ...BankAccount
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`, {"fragmentName":"EntityBankAccount"}) as unknown as TypedDocumentString<EntityBankAccountFragment, unknown>;
export const OrgSupplierFragmentForDiffingFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment OrgSupplierFragmentForDiffing on organisation_suppliers {
  id
  remoteId
  externalLink
  remoteLink
  organisationIntegrationId
  name
  legalName
  website
  isPerson
  address
  description
  state
  archivedBy
  paymentMethodId
  paymentTermsId
  taxNumber
  deletedAt: deleted_at
  external_contacts {
    id
    email
    firstName
    lastName
    phoneNumber
    title
    isPrimary
    createdAt
    deletedAt
  }
  organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
    id
    state
    archivedBy
    subsidiary {
      id
      name
    }
    entityBankDetails {
      ...EntityBankAccount
    }
  }
  entityBankDetails {
    ...EntityBankAccount
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment EntityBankAccount on entity_bank_details {
  isPrimary
  bankDetails {
    ...BankAccount
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`, {"fragmentName":"OrgSupplierFragmentForDiffing"}) as unknown as TypedDocumentString<OrgSupplierFragmentForDiffingFragment, unknown>;
export const BankDetailsWithAddressFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment BankDetailsWithAddress on bank_details {
  id
  accountName
  bankName
  country
  accountNumber
  sortCode
  iban
  swiftCode
  code
  currency {
    id
    name
    code
  }
  address {
    addressLine1
    addressLine2
    city
    county
    postalCode
  }
}
    `, {"fragmentName":"BankDetailsWithAddress"}) as unknown as TypedDocumentString<BankDetailsWithAddressFragment, unknown>;
export const RequestFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment RequestFragment on requests {
  id
  name
  state
  workflowId
  requestorUserId
  createdAt
  updatedAt
  priority
  completedAt
  model
  tagIds
  type
  request_product
  request_supplier
  publicId
  totalPausedTime
  agreement_term {
    agreementId
  }
  owner {
    id
    firstName
    lastName
  }
  user {
    id
    firstName
    lastName
    email
  }
}
    `, {"fragmentName":"RequestFragment"}) as unknown as TypedDocumentString<RequestFragmentFragment, unknown>;
export const RequestFragmentMinimalFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment RequestFragmentMinimal on requests {
  id
  name
  state
  workflowId
  model
  requestorUserId
  tagIds
}
    `, {"fragmentName":"RequestFragmentMinimal"}) as unknown as TypedDocumentString<RequestFragmentMinimalFragment, unknown>;
export const CustomCoreDataOptionFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}
    `, {"fragmentName":"CustomCoreDataOption"}) as unknown as TypedDocumentString<CustomCoreDataOptionFragment, unknown>;
export const CustomCoreDataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CustomCoreData on custom_core_data {
  id
  name
  organisationId
  pathLevels
  archivedAt
  organisationIntegration {
    id
    integration
  }
  options: custom_core_data_options(where: {isArchived: {_eq: false}}) {
    ...CustomCoreDataOption
  }
  numOptions: custom_core_data_options_aggregate(
    where: {isArchived: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
    fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}`, {"fragmentName":"CustomCoreData"}) as unknown as TypedDocumentString<CustomCoreDataFragment, unknown>;
export const CustomCoreDataOptionWithDependenciesFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CustomCoreDataOptionWithDependencies on custom_core_data_options {
  ...CustomCoreDataOption
  coreData {
    id
    coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
      ...CoreDataDependencies
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}`, {"fragmentName":"CustomCoreDataOptionWithDependencies"}) as unknown as TypedDocumentString<CustomCoreDataOptionWithDependenciesFragment, unknown>;
export const CustomCoreDataWithDependenciesFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CustomCoreDataWithDependencies on custom_core_data {
  ...CustomCoreData
  options: custom_core_data_options(where: {isArchived: {_eq: false}}) {
    ...CustomCoreDataOptionWithDependencies
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment CustomCoreData on custom_core_data {
  id
  name
  organisationId
  pathLevels
  archivedAt
  organisationIntegration {
    id
    integration
  }
  options: custom_core_data_options(where: {isArchived: {_eq: false}}) {
    ...CustomCoreDataOption
  }
  numOptions: custom_core_data_options_aggregate(
    where: {isArchived: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}
fragment CustomCoreDataOptionWithDependencies on custom_core_data_options {
  ...CustomCoreDataOption
  coreData {
    id
    coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
      ...CoreDataDependencies
    }
  }
}`, {"fragmentName":"CustomCoreDataWithDependencies"}) as unknown as TypedDocumentString<CustomCoreDataWithDependenciesFragment, unknown>;
export const CustomCoreDataOptionWithDependenciesMetadataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CustomCoreDataOptionWithDependenciesMetadata on custom_core_data_options {
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`, {"fragmentName":"CustomCoreDataOptionWithDependenciesMetadata"}) as unknown as TypedDocumentString<CustomCoreDataOptionWithDependenciesMetadataFragment, unknown>;
export const CustomCoreDataWithDependenciesMetadataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CustomCoreDataWithDependenciesMetadata on custom_core_data {
  ...CustomCoreData
  options: custom_core_data_options(where: {isArchived: {_eq: false}}) {
    ...CustomCoreDataOptionWithDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreData on custom_core_data {
  id
  name
  organisationId
  pathLevels
  archivedAt
  organisationIntegration {
    id
    integration
  }
  options: custom_core_data_options(where: {isArchived: {_eq: false}}) {
    ...CustomCoreDataOption
  }
  numOptions: custom_core_data_options_aggregate(
    where: {isArchived: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}
fragment CustomCoreDataOptionWithDependenciesMetadata on custom_core_data_options {
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}`, {"fragmentName":"CustomCoreDataWithDependenciesMetadata"}) as unknown as TypedDocumentString<CustomCoreDataWithDependenciesMetadataFragment, unknown>;
export const CustomCoreDataWithDependenciesMetadataIncludingArchivedFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CustomCoreDataWithDependenciesMetadataIncludingArchived on custom_core_data {
  id
  name
  organisationId
  pathLevels
  archivedAt
  organisationIntegration {
    id
    integration
  }
  options: custom_core_data_options {
    ...CustomCoreDataOption
    ...CustomCoreDataOptionWithDependenciesMetadata
  }
  numOptions: custom_core_data_options_aggregate {
    aggregate {
      count
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}
fragment CustomCoreDataOptionWithDependenciesMetadata on custom_core_data_options {
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}`, {"fragmentName":"CustomCoreDataWithDependenciesMetadataIncludingArchived"}) as unknown as TypedDocumentString<CustomCoreDataWithDependenciesMetadataIncludingArchivedFragment, unknown>;
export const CustomFieldFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CustomField on custom_fields {
  id
  title
  type
  externalSource
  customCoreDataId
  isRequired
  updatedAt
  entityType
  dependsOnCustomFieldId
  organisationIntegrationId
  choices {
    id
    label
  }
  allowUserToAddCustomOptions
  remoteId
  customCoreData {
    id
    pathLevels
  }
}
    `, {"fragmentName":"CustomField"}) as unknown as TypedDocumentString<CustomFieldFragment, unknown>;
export const DocumentTypeFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment DocumentType on document_types {
  id
  name
  description
  attributes
  createdAt
  updatedAt
}
    `, {"fragmentName":"DocumentType"}) as unknown as TypedDocumentString<DocumentTypeFragment, unknown>;
export const GlobalDocumentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment GlobalDocument on documents {
  id
  fileName
  createdAt
  updatedAt
  filestoreId
  organisationId
  staticType
  customType
  organisationSupplierId
  customTypeValue {
    id
    value
  }
  sourceRequestDocument {
    id
    sourceRequestForm {
      id
      title
    }
    request {
      id
      name
    }
  }
  product {
    id
    name
    logoUrl
  }
  supplier {
    id
    name
    logoUrl
  }
  uploadedByUser {
    id
    firstName
    lastName
    email
  }
  agreement_documents(limit: 1, order_by: {createdAt: desc}) {
    agreement {
      id
      name
    }
  }
}
    `, {"fragmentName":"GlobalDocument"}) as unknown as TypedDocumentString<GlobalDocumentFragment, unknown>;
export const RequestDocumentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment RequestDocument on request_documents {
  id
  filestoreId
  createdAt
  updatedAt
  organisationId
  fileName
  sourceRequestFormId
  requestId
  request {
    id
    name
    publicId
    product {
      id
      organisation_supplier {
        id
      }
    }
  }
  shouldPromoteToGlobal
  staticType
  customType
  source
  customTypeValue {
    id
    value
  }
  uploadedBy
  uploadedByUser {
    id
    firstName
    lastName
    email
  }
  sourceRequestForm {
    id
    title
  }
}
    `, {"fragmentName":"RequestDocument"}) as unknown as TypedDocumentString<RequestDocumentFragment, unknown>;
export const EntityFieldGroupFieldsFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment EntityFieldGroupFields on entity_field_group_fields {
  id
  customFieldId
  standardFieldKey
  index
}
    `, {"fragmentName":"EntityFieldGroupFields"}) as unknown as TypedDocumentString<EntityFieldGroupFieldsFragment, unknown>;
export const EntityFieldGroupFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment EntityFieldGroup on entity_field_groups {
  id
  name
  index
  entityType
  isDefaultForStandardFields
  isDefaultForCustomFields
  fields(order_by: {index: asc}) {
    ...EntityFieldGroupFields
  }
}
    fragment EntityFieldGroupFields on entity_field_group_fields {
  id
  customFieldId
  standardFieldKey
  index
}`, {"fragmentName":"EntityFieldGroup"}) as unknown as TypedDocumentString<EntityFieldGroupFragment, unknown>;
export const FormTemplateFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment FormTemplate on form_templates {
  id
  title
  description
  type
  state
  config
  internalId
  integration
  externalTitle
  organisationId
  createdAt
  updatedAt
  createdBy
  updatedBy
  deletedAt
  created_by_user {
    id
    firstName
    lastName
  }
  updated_by_user {
    id
    firstName
    lastName
  }
}
    `, {"fragmentName":"FormTemplate"}) as unknown as TypedDocumentString<FormTemplateFragment, unknown>;
export const CategoryNameWithParentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CategoryNameWithParent on categories {
  name
  parent {
    name
  }
}
    `, {"fragmentName":"CategoryNameWithParent"}) as unknown as TypedDocumentString<CategoryNameWithParentFragment, unknown>;
export const ListProductFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment ListProductFragment on organisation_products_and_services {
  id
  name
  displayName
  website
  logoUrl
  createdAt
  updatedAt
  description
  isArchived
  state
  businessOwner {
    id
    firstName
    lastName
  }
  engagements {
    id
    name
    department
  }
  earliestActiveRenewal: renewals(
    where: {_and: [{_or: [{request: {_and: [{completedAt: {_is_null: true}}, {state: {_neq: "REJECTED"}}]}}, {requestId: {_is_null: true}}]}, {deletedAt: {_is_null: true}}]}
    order_by: {renewalDate: asc}
    limit: 1
  ) {
    id
    renewalDate
    cancellationNoticeDayCount
    requestId
    sourceAgreementTerm {
      id
      agreement {
        id
        name
      }
    }
  }
}
    `, {"fragmentName":"ListProductFragment"}) as unknown as TypedDocumentString<ListProductFragmentFragment, unknown>;
export const OrganisationProductsAndServiceFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment OrganisationProductsAndServiceFragment on organisation_products_and_services {
  id
  name
  displayName
  website
  logoUrl
  createdAt
  updatedAt
  description
  isArchived
  state
  businessOwner {
    id
    firstName
    lastName
  }
  organisation_supplier {
    state
    id
    website
    logoUrl
    name
    externalLink
    organisation_supplier_brand {
      id
      supplierId
    }
    external_contacts(where: {deletedAt: {_is_null: true}}) {
      id
      email
      firstName
      lastName
      isPrimary
      phoneNumber
      title
    }
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
    }
  }
  engagements {
    id
    name
    department
  }
}
    `, {"fragmentName":"OrganisationProductsAndServiceFragment"}) as unknown as TypedDocumentString<OrganisationProductsAndServiceFragmentFragment, unknown>;
export const OrganisationPublicApiClientFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment OrganisationPublicApiClient on organisation_public_api_clients {
  id
  name
  userPoolId
  userPoolClientId
  organisationIntegrationId
  createdAt
  updatedAt
}
    `, {"fragmentName":"OrganisationPublicApiClient"}) as unknown as TypedDocumentString<OrganisationPublicApiClientFragment, unknown>;
export const CoreDataDependenciesFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}
    `, {"fragmentName":"CoreDataDependenciesFragment"}) as unknown as TypedDocumentString<CoreDataDependenciesFragmentFragment, unknown>;
export const StoreAddressFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment StoreAddress on addresses {
  id
  name
  addressLine1
  addressLine2
  city
  county
  state
  postalCode
  country
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`, {"fragmentName":"StoreAddress"}) as unknown as TypedDocumentString<StoreAddressFragment, unknown>;
export const StoreCurrencyFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment StoreCurrency on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`, {"fragmentName":"StoreCurrency"}) as unknown as TypedDocumentString<StoreCurrencyFragment, unknown>;
export const StoreCustomDataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment StoreCustomData on custom_core_data {
  id
  name
  slug
  organisationIntegration {
    id
    name
    integration
  }
  createdAt
  updatedAt
  archivedAt
}
    `, {"fragmentName":"StoreCustomData"}) as unknown as TypedDocumentString<StoreCustomDataFragment, unknown>;
export const StoreCustomDataRecordFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment StoreCustomDataRecord on custom_core_data_options {
  id
  value
  remoteId
  updatedAt
  createdAt
  isArchived
  archivedBy
  coreDataId
  custom_core_data {
    slug
    pathLevels
  }
  coreData {
    ...CoreDataDependenciesFragment
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`, {"fragmentName":"StoreCustomDataRecord"}) as unknown as TypedDocumentString<StoreCustomDataRecordFragment, unknown>;
export const StoreDepartmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment StoreDepartment on departments {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`, {"fragmentName":"StoreDepartment"}) as unknown as TypedDocumentString<StoreDepartmentFragment, unknown>;
export const StoreLineItemTypeFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment StoreLineItemType on line_item_types {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`, {"fragmentName":"StoreLineItemType"}) as unknown as TypedDocumentString<StoreLineItemTypeFragment, unknown>;
export const StorePaymentMethodFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment StorePaymentMethod on payment_methods {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`, {"fragmentName":"StorePaymentMethod"}) as unknown as TypedDocumentString<StorePaymentMethodFragment, unknown>;
export const StorePaymentTermFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment StorePaymentTerm on payment_terms {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`, {"fragmentName":"StorePaymentTerm"}) as unknown as TypedDocumentString<StorePaymentTermFragment, unknown>;
export const StorePurchaseOrderLineItemFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment StorePurchaseOrderLineItem on purchase_order_line_items {
  lineNumber
  quantity
  unitPrice
  amount
  lineItemCurrency {
    id
    remoteId
    code
    name
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`, {"fragmentName":"StorePurchaseOrderLineItem"}) as unknown as TypedDocumentString<StorePurchaseOrderLineItemFragment, unknown>;
export const StorePurchaseOrderFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment StorePurchaseOrder on purchase_orders {
  id
  remoteId
  remoteNumber
  remoteStatus
  remoteLink
  remoteTotalValue
  remoteInvoicedValue
  remotePaidValue
  totalValue
  contractStartDate
  contractEndDate
  organisationIntegrationId
  request {
    id
    publicId
    name
  }
  requestor {
    id
    email
    firstName
    lastName
  }
  supplier: organisationSupplier {
    id
    remoteId
    name
  }
  subsidiary {
    id
    remoteId
    name
  }
  department {
    id
    remoteId
    name
  }
  paymentTerm {
    id
    remoteId
    name
  }
  paymentMethod {
    id
    remoteId
    name
  }
  currency {
    id
    remoteId
    code
    name
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
  lineItems: purchaseOrderLineItems {
    ...StorePurchaseOrderLineItem
  }
  createdAt
  updatedAt
  deletedAt
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment StorePurchaseOrderLineItem on purchase_order_line_items {
  lineNumber
  quantity
  unitPrice
  amount
  lineItemCurrency {
    id
    remoteId
    code
    name
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}`, {"fragmentName":"StorePurchaseOrder"}) as unknown as TypedDocumentString<StorePurchaseOrderFragment, unknown>;
export const StoreSubsidiaryFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment StoreSubsidiary on subsidiaries {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`, {"fragmentName":"StoreSubsidiary"}) as unknown as TypedDocumentString<StoreSubsidiaryFragment, unknown>;
export const PublicApiUserFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment PublicApiUser on users {
  id
  email
  firstName
  lastName
  role
  createdAt
  updatedAt
  department {
    id
    name
    remoteId
  }
  subsidiary {
    id
    name
    remoteId
  }
  managerUser {
    id
    email
    firstName
    lastName
  }
  customFieldValues(where: {customField: {entityType: {_eq: "user-attribute"}}}) {
    ...CustomFieldValueFragment
  }
  userAllowedSubsidiaries {
    subsidiary {
      id
      name
      remoteId
    }
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`, {"fragmentName":"PublicApiUser"}) as unknown as TypedDocumentString<PublicApiUserFragment, unknown>;
export const RenewalFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment Renewal on renewals {
  id
  cancellationNoticeDayCount
  department {
    id
    name
  }
  costCurrency
  costValue
  note
  renewalDate
  autoStartEnabled
  deletedAt
  sourceRequestId
  sourceRequest {
    id
    name
    publicId
  }
  renewalAdditionalUsers {
    user {
      id
      firstName
      lastName
      email
      isArchived
    }
  }
  request {
    id
    completedAt
    updatedAt
    state
    model
    tagIds
    publicId
    request_tags(where: {tag: {deletedAt: {_is_null: true}}}) {
      id
      tag {
        id
        name
        deletedAt
      }
    }
    computedProperties {
      valueObject
    }
    steps {
      id
      canvasModelId
      state
      input
      createdAt
      completedAt
      totalPausedWorkingHours
      requestStepUsers: request_step_users {
        id
        user {
          id
          firstName
          lastName
          isArchived
        }
      }
    }
    request_forms {
      id
      config
      currentSubmission: request_form_submissions(
        limit: 1
        order_by: {submittedOn: desc_nulls_last}
      ) {
        id
        response
        submittedOn
      }
    }
    inProgressStepContext: steps(
      where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
    ) {
      id
      nodeId: canvasModelId
      name: input(path: "$.metadata.config.payload.label")
      type: input(path: "$.metadata.type")
      state
      requestStepUsers: request_step_users(where: {deletedAt: {_is_null: true}}) {
        id
        user {
          id
          firstName
          lastName
          isArchived
        }
      }
      requestStepGroups: request_step_groups(where: {deletedAt: {_is_null: true}}) {
        id
        group {
          id
          name
          groupUsers: group_users {
            id
            userId
          }
        }
      }
    }
    supplier {
      id
      state
      organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
        id
        subsidiaryId
      }
    }
    product {
      id
      name
      state
    }
    request_pauses {
      start
      end
    }
  }
  workflow {
    id
    title
  }
  workflowInitialAssignee {
    id
    firstName
    lastName
    isArchived
  }
  workflowStartDayCount
  product {
    id
    name: displayName
    logoUrl
  }
  supplier {
    id
    name
    logoUrl
    remoteId
  }
  renewalTags(where: {tag: {deletedAt: {_is_null: true}}}) {
    id
    tag {
      id
      name
    }
  }
  sourceAgreementTerm {
    id
    agreement {
      id
      name
      ownerId
      additionalOwners {
        userId
        user {
          id
          firstName
          lastName
          email
        }
      }
      tags(where: {tag: {deletedAt: {_is_null: true}}}) {
        id
        tag {
          id
          name
        }
      }
    }
  }
  cancelledAt
  renewedAt
  createdAt
}
    `, {"fragmentName":"Renewal"}) as unknown as TypedDocumentString<RenewalFragment, unknown>;
export const OrganisationSupplierFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment OrganisationSupplierFragment on organisation_suppliers {
  id
  name
  website
  logoUrl
  isReseller
  createdAt
  remoteId
  lastAssessmentDate
  publicId
  organisationSupplierBrandId
  paymentMethod {
    id
    name
  }
  organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
    id
    subsidiary {
      id
      name
    }
  }
  address
}
    `, {"fragmentName":"OrganisationSupplierFragment"}) as unknown as TypedDocumentString<OrganisationSupplierFragmentFragment, unknown>;
export const ProductFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment ProductFragment on products_and_services {
  id
  name
  displayName
  website
  logoUrl
  createdAt
  updatedAt
  description
  deletedAt
}
    `, {"fragmentName":"ProductFragment"}) as unknown as TypedDocumentString<ProductFragmentFragment, unknown>;
export const SupplierFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment SupplierFragment on suppliers {
  id
  name
  website
  description
  logoUrl
  isReseller
}
    `, {"fragmentName":"SupplierFragment"}) as unknown as TypedDocumentString<SupplierFragmentFragment, unknown>;
export const RequestFormResponsesFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment RequestFormResponses on request_forms {
  id
  config
  currentSubmission: request_form_submissions(
    limit: 1
    order_by: {submittedOn: desc_nulls_last}
  ) {
    id
    response
    submittedOn
  }
}
    `, {"fragmentName":"RequestFormResponses"}) as unknown as TypedDocumentString<RequestFormResponsesFragment, unknown>;
export const RequestBudgetApprovalDataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment RequestBudgetApprovalData on requests {
  id
  model
  computedProperties {
    valueObject
    inBudget
    department {
      id
      name
      isArchived
    }
    buyerLegalEntity {
      id
      name
      isArchived
    }
  }
  renewal {
    costValue
    costCurrency
    department {
      id
      name
      isArchived
    }
  }
  request_forms {
    ...RequestFormResponses
  }
}
    fragment RequestFormResponses on request_forms {
  id
  config
  currentSubmission: request_form_submissions(
    limit: 1
    order_by: {submittedOn: desc_nulls_last}
  ) {
    id
    response
    submittedOn
  }
}`, {"fragmentName":"RequestBudgetApprovalData"}) as unknown as TypedDocumentString<RequestBudgetApprovalDataFragment, unknown>;
export const RequestDetailDataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment RequestDetailData on requests {
  id
  name
  createdAt
  completedAt
  tagIds
  model
  requestorUserId
  state
  priority
  type
  publicId
  state
  poNumber
  workflowId
  risks(where: {deletedAt: {_is_null: true}}) {
    ...SummaryRiskLevel
  }
  budget {
    id
    name
  }
  renewal {
    renewalDate
    cancellationNoticeDayCount
    note
    id
    department {
      id
      name
      isArchived
    }
    costValue
    costCurrency
    sourceAgreementTerm {
      id
      name
      agreementId
    }
  }
  assessment {
    id
    businessOwner: businessOwnerUser {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
  }
  organisation {
    id
    name
  }
  user {
    id
    firstName
    lastName
    email
    role
    isArchived
  }
  computedProperties {
    valueObject
    businessOwner {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
    budgetHolder {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
    department {
      id
      name
      isArchived
    }
    costCenter {
      id
      name
      isArchived
    }
    buyerLegalEntity {
      id
      name
      isArchived
    }
    goLiveDate
    inBudget
    poNumber
    paymentTerm {
      id
      name
      isArchived
    }
    note
    contractStartDate
    contractEndDate
    contractLength
    paymentMethod {
      id
      name
      isArchived
    }
    type
    cancellationNoticeDays
    cancellationReason
    shouldRenew
    isAutoRenewal
    address
    taxNumber
    website
    renewalDate
    category {
      id
      value
    }
    market {
      id
      value
    }
  }
  owner {
    id
    firstName
    lastName
    email
    role
    isArchived
  }
  leads(where: {user: {id: {_is_null: false}}}) {
    user {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
  }
  inProgressStepContext: steps(
    where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
  ) {
    id
    nodeId: canvasModelId
    name: input(path: "$.metadata.config.payload.label")
    type: input(path: "$.metadata.type")
    state
    requestStepUsers: request_step_users(where: {deletedAt: {_is_null: true}}) {
      id
      user {
        id
        firstName
        lastName
      }
    }
    requestStepGroups: request_step_groups(where: {deletedAt: {_is_null: true}}) {
      id
      group {
        id
        name
        groupUsers: group_users {
          id
          userId
        }
      }
    }
  }
  steps {
    id
    state
    result
    canvasModelId
    createdAt
    completedAt
    input
    totalPausedWorkingHours
  }
  workflow {
    id
    title
    type
    expectedSLA
    workflow_condition_groups {
      id
      name
      precedence
    }
  }
  supplierId: request_supplier
  supplier {
    id
    name
    logoUrl
    state
    externalLink
    remoteId
    publicId
    organisationIntegration {
      id
      integration
    }
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
      remoteId
      remoteLink
    }
    organisation_supplier_tags {
      tagId
    }
    organisation_supplier_brand {
      logoUrl
    }
  }
  productId: request_product
  product {
    id
    name
    state
    logoUrl
    description
    website
    organisation_products_and_services_brand {
      logoUrl
    }
    organisationSupplier: organisation_supplier {
      id
      website
      description
      externalContacts: external_contacts(where: {deletedAt: {_is_null: true}}) {
        id
        firstName
        lastName
        email
        phoneNumber
        title
        isPrimary
      }
    }
  }
  agreementTerm: agreement_term {
    id
    name
    agreementId
  }
  engagement {
    id
    name
    purchaseOrderNumber
    externalLink
  }
  purchase_orders(
    where: {status: {_eq: "ACTIVE"}, deletedAt: {_is_null: true}}
    order_by: {createdAt: desc}
    limit: 1
  ) {
    id
    remoteNumber
    remoteLink
    status
    remoteStatus
    totalValue
    remoteTotalValue
    remoteInvoicedValue
    remotePaidValue
    currency {
      id
      code
    }
  }
  request_forms {
    ...RequestFormResponses
  }
  request_tags {
    id
    tag {
      id
      name
      deletedAt
    }
  }
  latestComment: comments(
    where: {_and: [{requestFormId: {_is_null: true}}, {type: {_eq: TEXT}}]}
    order_by: {createdAt: desc}
    limit: 1
  ) {
    id
    payload
    createdAt
    user {
      id
      firstName
      lastName
    }
  }
  followers {
    id
    user {
      id
      email
      firstName
      lastName
    }
  }
  request_pauses {
    start
    end
  }
  sidebarConfig
}
    fragment RequestFormResponses on request_forms {
  id
  config
  currentSubmission: request_form_submissions(
    limit: 1
    order_by: {submittedOn: desc_nulls_last}
  ) {
    id
    response
    submittedOn
  }
}
fragment SummaryRiskLevel on risks {
  id
  inherentRiskImpact {
    id
    name
    score
  }
  inherentRiskProbability {
    id
    name
    score
  }
  inherentRiskMatrix {
    id
    score
  }
  residualRiskImpact {
    id
    name
    score
  }
  residualRiskProbability {
    id
    name
    score
  }
  residualRiskMatrix {
    id
    score
  }
}`, {"fragmentName":"RequestDetailData"}) as unknown as TypedDocumentString<RequestDetailDataFragment, unknown>;
export const RequestBlocksInfoDataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment RequestBlocksInfoData on requests {
  id
  state
  completedAt
  model
  tagIds
  computedProperties {
    valueObject
    inBudget
    department {
      id
      name
      isArchived
    }
    buyerLegalEntity {
      id
      name
      isArchived
    }
  }
  supplier {
    id
    name
    state
    organisation_supplier_tags {
      tagId
    }
    organisationSupplierProfiles {
      subsidiaryId
    }
  }
  product {
    state
  }
  budget {
    id
  }
  renewal {
    costValue
    costCurrency
    department {
      id
      name
      isArchived
    }
  }
  request_forms {
    ...RequestFormResponses
  }
  request_tags {
    tag {
      id
      name
      deletedAt
    }
  }
}
    fragment RequestFormResponses on request_forms {
  id
  config
  currentSubmission: request_form_submissions(
    limit: 1
    order_by: {submittedOn: desc_nulls_last}
  ) {
    id
    response
    submittedOn
  }
}`, {"fragmentName":"RequestBlocksInfoData"}) as unknown as TypedDocumentString<RequestBlocksInfoDataFragment, unknown>;
export const FormDetailsFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment FormDetailsFragment on request_forms {
  id
  title
  description
  formTemplateId
  type
  config
  form_template {
    id
    externalTitle
  }
  request {
    id
    name
    state
    renewal {
      id
    }
    user {
      id
      email
      firstName
      lastName
    }
    request_supplier
    request_product
    supplier {
      name
      internalContacts(where: {userId: {_eq: $userId}, deleted_at: {_is_null: true}}) {
        userId
        productId
      }
      organisation_products_and_services(
        where: {businessOwnerId: {_eq: $userId}, deleted_at: {_is_null: true}}
      ) {
        id
        businessOwnerId
      }
    }
    request_users {
      userId
      user {
        id
        email
        firstName
        lastName
      }
    }
    request_groups {
      group {
        id
        name
        group_users {
          userId
        }
      }
    }
  }
  request_step_tasks {
    id
    type
    completedBy
    completedOn
    request_step_task_users {
      user_id
      user {
        id
        role
        email
        firstName
        lastName
      }
    }
    request_step_task_rejections {
      id
    }
    request_step {
      id
      state
      createdAt
      skipped: output(path: "$.skipped")
      skippedAt: output(path: "$.skipped_at")
      skippedBy: output(path: "$.skipped_by")
      forceApprovedAt: output(path: "$.force_approved_at")
      forceApprovedBy: output(path: "$.force_approved_by")
      request_step_users {
        id
        user {
          id
          role
          email
          firstName
          lastName
        }
      }
      request_step_groups {
        id
        group {
          id
          group_users {
            id
            userId
          }
        }
      }
    }
    request_form {
      id
      type
      request_comments(
        where: {_and: [{completedAt: {_is_null: true}}, {type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}]}
      ) {
        id
        type
        userId
        completedAt
      }
    }
    organisation_supplier {
      id
      rfx_suppliers {
        id
        status
        rfx {
          requestId
        }
      }
    }
  }
  openAmendments: request_comments(
    where: {_and: [{completedAt: {_is_null: true}}, {type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}]}
  ) {
    id
    type
    userId
    completedAt
  }
}
    `, {"fragmentName":"FormDetailsFragment"}) as unknown as TypedDocumentString<FormDetailsFragmentFragment, unknown>;
export const RequestStepFieldsFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment RequestStepFields on request_steps {
  id
  createdAt
  state
  input
  output
  totalPausedWorkingHours
  request {
    id
    name
    type
    product {
      id
      logoUrl
    }
    user {
      id
      firstName
      lastName
      role
      email
      isArchived
    }
  }
}
    `, {"fragmentName":"RequestStepFields"}) as unknown as TypedDocumentString<RequestStepFieldsFragment, unknown>;
export const RequestFormFieldsFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment RequestFormFields on request_forms {
  id
  supplierActiveAmendments: request_comments(
    where: {completedAt: {_is_null: true}, type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}, isInternalComment: {_eq: false}}
  ) {
    id
  }
}
    `, {"fragmentName":"RequestFormFields"}) as unknown as TypedDocumentString<RequestFormFieldsFragment, unknown>;
export const RequestItemDataFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment RequestItemData on requests {
  id
  name
  createdAt
  completedAt
  tagIds
  model
  state
  priority
  type
  publicId
  state
  poNumber
  workflowId
  risks(where: {deletedAt: {_is_null: true}}) {
    ...SummaryRiskLevel
  }
  budget {
    id
    name
  }
  renewal {
    renewalDate
    cancellationNoticeDayCount
    note
    id
    department {
      id
      name
      isArchived
    }
    costValue
    costCurrency
  }
  assessment {
    id
    businessOwner: businessOwnerUser {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
  }
  user {
    id
    firstName
    lastName
    email
    role
    isArchived
  }
  computedProperties {
    valueObject
    businessOwner {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
    budgetHolder {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
    department {
      id
      name
      isArchived
    }
    costCenter {
      id
      name
      isArchived
    }
    buyerLegalEntity {
      id
      name
      isArchived
    }
    goLiveDate
    inBudget
    poNumber
    paymentTerm {
      id
      name
      isArchived
    }
    note
    contractStartDate
    contractEndDate
    contractLength
    paymentMethod {
      id
      name
      isArchived
    }
    type
    cancellationNoticeDays
    cancellationReason
    shouldRenew
    isAutoRenewal
    address
    taxNumber
    website
    renewalDate
    category {
      id
      value
      parent {
        value
      }
    }
    market {
      id
      value
    }
  }
  owner {
    id
    firstName
    lastName
    email
    role
    isArchived
  }
  leads(where: {user: {id: {_is_null: false}}}) {
    user {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
  }
  inProgressStepContext: steps(
    where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
  ) {
    id
    nodeId: canvasModelId
    name: input(path: "$.metadata.config.payload.label")
    type: input(path: "$.metadata.type")
    state
    requestStepUsers: request_step_users(where: {deletedAt: {_is_null: true}}) {
      id
      user {
        id
        firstName
        lastName
      }
    }
    requestStepGroups: request_step_groups(where: {deletedAt: {_is_null: true}}) {
      id
      group {
        id
        name
        groupUsers: group_users {
          id
          userId
        }
      }
    }
  }
  rejectedTasks: steps(
    where: {_and: [{result: {_is_null: true}}, {deletedAt: {_is_null: true}}, {request_step_tasks: {request_step_task_rejections: {id: {_is_null: false}}, completedOn: {_is_null: true}}}]}
  ) {
    id
  }
  erroredTasks: steps(
    where: {_and: [{result: {_is_null: true}}, {deletedAt: {_is_null: true}}, {request_step_tasks: {request_step_task_errors: {id: {_is_null: false}, resolvedAt: {_is_null: true}}, completedOn: {_is_null: true}}}]}
  ) {
    id
  }
  steps {
    id
    state
    result
    canvasModelId
    createdAt
    completedAt
    input
    totalPausedWorkingHours
  }
  workflow {
    title
    type
    workflow_condition_groups {
      id
      name
      precedence
    }
  }
  supplierId: request_supplier
  supplier {
    id
    name
    logoUrl
    state
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
    }
    organisation_supplier_tags {
      tagId
    }
    organisation_supplier_brand {
      logoUrl
    }
  }
  productId: request_product
  product {
    id
    name
    state
  }
  engagement {
    id
    purchaseOrderNumber
  }
  purchase_orders(
    where: {status: {_eq: "ACTIVE"}, deletedAt: {_is_null: true}}
    order_by: {createdAt: desc}
    limit: 1
  ) {
    id
    remoteNumber
    remoteLink
    status
    remoteStatus
    totalValue
    remoteTotalValue
    remoteInvoicedValue
    remotePaidValue
    currency {
      id
      code
    }
  }
  request_forms {
    ...RequestFormResponses
  }
  request_tags {
    id
    tag {
      id
      name
      deletedAt
    }
  }
  latestComment: comments(
    where: {_and: [{requestFormId: {_is_null: true}}, {type: {_eq: TEXT}}]}
    order_by: {createdAt: desc}
    limit: 1
  ) {
    id
    payload
    createdAt
    user {
      id
      firstName
      lastName
    }
    mentions: request_comment_mentions {
      id
      userId
      isResolved
      user {
        firstName
        lastName
        email
        isOutOfOffice
      }
    }
  }
  followers {
    id
    user {
      id
      email
      firstName
      lastName
    }
  }
  request_pauses {
    start
    end
  }
}
    fragment RequestFormResponses on request_forms {
  id
  config
  currentSubmission: request_form_submissions(
    limit: 1
    order_by: {submittedOn: desc_nulls_last}
  ) {
    id
    response
    submittedOn
  }
}
fragment SummaryRiskLevel on risks {
  id
  inherentRiskImpact {
    id
    name
    score
  }
  inherentRiskProbability {
    id
    name
    score
  }
  inherentRiskMatrix {
    id
    score
  }
  residualRiskImpact {
    id
    name
    score
  }
  residualRiskProbability {
    id
    name
    score
  }
  residualRiskMatrix {
    id
    score
  }
}`, {"fragmentName":"RequestItemData"}) as unknown as TypedDocumentString<RequestItemDataFragment, unknown>;
export const RequestItemDataV2FragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment RequestItemDataV2 on requests {
  id
  name
  createdAt
  completedAt
  publicId
  state
  priority
  workflow {
    title
  }
  supplier {
    id
    name
    logoUrl
    state
  }
  product {
    id
    name
    state
    logoUrl
    description
  }
  computedProperties {
    valueObject
  }
  renewal {
    costValue
    costCurrency
  }
}
    `, {"fragmentName":"RequestItemDataV2"}) as unknown as TypedDocumentString<RequestItemDataV2Fragment, unknown>;
export const SupplierBankDetailsWithAddressFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment SupplierBankDetailsWithAddress on bank_details {
  id
  accountName
  bankName
  country
  accountNumber
  sortCode
  iban
  swiftCode
  code
  isActive
  currency {
    id
    name
    code
  }
  address {
    addressLine1
    addressLine2
    city
    county
    postalCode
    country
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`, {"fragmentName":"SupplierBankDetailsWithAddress"}) as unknown as TypedDocumentString<SupplierBankDetailsWithAddressFragment, unknown>;
export const OrgSupplierFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment OrgSupplierFragment on organisation_suppliers {
  id
  name
  website
  address
  taxNumber
  state
  external_contacts(where: {deletedAt: {_is_null: true}}) {
    id
    firstName
    lastName
    email
    phoneNumber
    title
    isPrimary
  }
  paymentMethod {
    id
    name
  }
  organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
    id
    subsidiary {
      id
      name
    }
  }
}
    `, {"fragmentName":"OrgSupplierFragment"}) as unknown as TypedDocumentString<OrgSupplierFragmentFragment, unknown>;
export const RfxFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment RfxFragment on rfx {
  id
  aiScoringEnabled
  aiScoringVisible
  isReopened
  organisation {
    id
    name
  }
  status
  requestId
  supplierInstructions
  request {
    id
    name
    createdAt
  }
  requestStepId
  rfx_suppliers_aggregate {
    aggregate {
      count
    }
  }
  owners {
    id
    userId
  }
  rfx_suppliers {
    id
    status
    organisation_supplier {
      name
      id
    }
    hasParticipatedInScoring
    rfx_external_users_aggregate {
      aggregate {
        count
      }
    }
  }
  request_step {
    result
    createdAt
    targetTimeValue: input(path: "$.metadata.config.payload.targetTimeValue")
    supplierFillInTasks: request_step_tasks(where: {type: {_eq: FILL_IN}}) {
      request_form {
        request_form_template_id
      }
      organisation_supplier {
        name
        id
      }
      id
      completedOn
      submissionsClosedAt
    }
    scoringTasks: request_step_tasks(where: {type: {_eq: SCORE_RFX_FORM}}) {
      completedOn
      submissionsClosedAt
      id
    }
    request_form_templates(where: {deletedAt: {_is_null: true}}) {
      id
      title
      type
      createdAt
      isSent
      rfx_request_form_templates_rank {
        id
        rank
      }
      request_forms {
        id
      }
    }
  }
}
    `, {"fragmentName":"RfxFragment"}) as unknown as TypedDocumentString<RfxFragmentFragment, unknown>;
export const RiskTemplateFieldsFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment RiskTemplateFields on risk_templates {
  id
  createdAt
  updatedAt
  deletedAt
  organisationId
  createdBy
  updatedBy
  deletedBy
  orgSupplierId
  name
  description
  treatment
  sendReminderDaysBefore
  deadline
  inherentRiskProbabilityId
  inherentRiskImpactId
  residualRiskProbabilityId
  residualRiskImpactId
  stageId
  treatmentTypeId
}
    `, {"fragmentName":"RiskTemplateFields"}) as unknown as TypedDocumentString<RiskTemplateFieldsFragment, unknown>;
export const RiskFieldsFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment RiskFields on risks {
  id
  createdAt
  updatedAt
  deletedAt
  organisationId
  createdBy
  updatedBy
  deletedBy
  orgSupplierId
  name
  description
  treatment
  sendReminderDaysBefore
  deadline
  inherentRiskProbabilityId
  inherentRiskImpactId
  residualRiskProbabilityId
  residualRiskImpactId
  isOpen
  stageId
  treatmentTypeId
  requestId
  requestFormId
  questionName
  closedAt
  closedBy
}
    `, {"fragmentName":"RiskFields"}) as unknown as TypedDocumentString<RiskFieldsFragment, unknown>;
export const ExternalRiskScoreFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment ExternalRiskScoreFragment on external_risk_scores {
  id
  requestId
  riskScore
  externalProvider
  date
  files
}
    `, {"fragmentName":"ExternalRiskScoreFragment"}) as unknown as TypedDocumentString<ExternalRiskScoreFragmentFragment, unknown>;
export const EngagementFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment EngagementFragment on engagements {
  id
  name
  department
  category
  supplierLegalEntity
  buyerLegalEntity
  description
  website
  created_at
  customFields
  note
  organisationSupplierId
  organisation_supplier {
    id
    name
    external_contacts(where: {deletedAt: {_is_null: true}}) {
      id
      firstName
      lastName
      email
      phoneNumber
      title
      isPrimary
    }
  }
  organisation_products_and_service {
    id
    name
  }
  financial {
    id
    amount
    contractPeriodStart
    contractPeriodEnd
    contractEnd
    subscriptionStart
    purchaseType
    paymentType
    paymentMethod
    paymentMethodId
    paymentInterval
    autoRenewal
    costCenter
    cancellationNoticeDays
    note
    fxRate
    currency
    purchaseDate
  }
}
    `, {"fragmentName":"EngagementFragment"}) as unknown as TypedDocumentString<EngagementFragmentFragment, unknown>;
export const BankAccountForRepositoryFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment BankAccountForRepository on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    id
    remoteId
    code
    name
  }
  address {
    id
    remoteId
    addressLine1
    addressLine2
    city
    state
    postalCode
    county
    country
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`, {"fragmentName":"BankAccountForRepository"}) as unknown as TypedDocumentString<BankAccountForRepositoryFragment, unknown>;
export const CustomFieldSchemaForRepositoryFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment CustomFieldSchemaForRepository on custom_fields {
  id
  type
  externalSource
  customCoreDataId
  remoteId
  key
  title
  choices {
    id
    label
  }
}
    `, {"fragmentName":"CustomFieldSchemaForRepository"}) as unknown as TypedDocumentString<CustomFieldSchemaForRepositoryFragment, unknown>;
export const ExternalContactForRepositoryFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment ExternalContactForRepository on external_contacts {
  id
  email
  firstName
  lastName
  title
  userId
  deletedAt
  phoneNumber
  isPrimary
  createdAt
  updatedAt
}
    `, {"fragmentName":"ExternalContactForRepository"}) as unknown as TypedDocumentString<ExternalContactForRepositoryFragment, unknown>;
export const InternalContactForRepositoryFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment InternalContactForRepository on internal_contacts {
  id
  role
  title
  supplierId
  deleted_at
  createdAt
  updatedAt
  user {
    id
    email
    firstName
    lastName
  }
}
    `, {"fragmentName":"InternalContactForRepository"}) as unknown as TypedDocumentString<InternalContactForRepositoryFragment, unknown>;
export const SupplierProfileForRepositoryFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment SupplierProfileForRepository on organisation_supplier_profiles {
  id
  remoteId
  remoteLink
  subsidiaryId
  state
  createdAt
  updatedAt
  subsidiary {
    id
    name
    remoteId
  }
  paymentMethod {
    id
    name
    remoteId
  }
  paymentTerm {
    id
    name
    remoteId
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`, {"fragmentName":"SupplierProfileForRepository"}) as unknown as TypedDocumentString<SupplierProfileForRepositoryFragment, unknown>;
export const OrgSupplierForRepositoryFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment OrgSupplierForRepository on organisation_suppliers {
  id
  deleted_at
  name
  legalName
  state
  website
  description
  isReseller
  isPerson
  isPreferred
  taxNumber
  createdAt
  updated_at
  remoteId
  remoteLink
  publicId
  paymentMethod {
    id
    name
    remoteId
  }
  paymentTerms {
    id
    name
    remoteId
  }
  address
  customFieldValues {
    ...CustomFieldValueFragment
  }
  organisationIntegration {
    name
    id
    integration
  }
  organisation_supplier_tags(where: {tag: {deletedAt: {_is_null: true}}}) {
    tag {
      id
      name
    }
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`, {"fragmentName":"OrgSupplierForRepository"}) as unknown as TypedDocumentString<OrgSupplierForRepositoryFragment, unknown>;
export const SupplierSubsidiaryForRepositoryFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment SupplierSubsidiaryForRepository on organisation_supplier_profiles {
  id
  subsidiaryId
  subsidiary {
    id
    name
    remoteId
  }
}
    `, {"fragmentName":"SupplierSubsidiaryForRepository"}) as unknown as TypedDocumentString<SupplierSubsidiaryForRepositoryFragment, unknown>;
export const AllRequestStepFieldsFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment AllRequestStepFields on request_steps {
  id
  createdAt
  state
  canvasModelId
  stepLabel: input(path: "$.metadata.config.payload.label")
  type: input(path: "$.metadata.type")
  skipped: output(path: "$.skipped")
  skippedAt: output(path: "$.skipped_at")
  skippedBy: output(path: "$.skipped_by")
  forceApprovedAt: output(path: "$.force_approved_at")
  forceApprovedBy: output(path: "$.force_approved_by")
}
    `, {"fragmentName":"AllRequestStepFields"}) as unknown as TypedDocumentString<AllRequestStepFieldsFragment, unknown>;
export const AllRequestStepTaskFieldsFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment AllRequestStepTaskFields on request_step_tasks {
  id
  completedOn
  completedBy
  submissionsClosedAt
  type
  config
  request_step_task_rejections {
    id
    createdBy
    createdAt
  }
}
    `, {"fragmentName":"AllRequestStepTaskFields"}) as unknown as TypedDocumentString<AllRequestStepTaskFieldsFragment, unknown>;
export const StepFieldsFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment StepFields on request_steps {
  id
  createdAt
  state
  canvasModelId
  stepLabel: input(path: "$.metadata.config.payload.label")
  type: input(path: "$.metadata.type")
  targetTimeValue: input(path: "$.metadata.config.payload.targetTimeValue")
  skipped: output(path: "$.skipped")
  skippedAt: output(path: "$.skipped_at")
  skippedBy: output(path: "$.skipped_by")
  forceApprovedAt: output(path: "$.force_approved_at")
  forceApprovedBy: output(path: "$.force_approved_by")
  totalPausedWorkingHours
  agentEnabled: input(path: "$.metadata.config.payload.agentConfig.enabled")
  request {
    id
    user {
      id
    }
  }
  request_step_users {
    id
    user {
      id
    }
  }
  request_step_groups {
    id
    group {
      id
      group_users {
        id
        userId
      }
    }
  }
}
    `, {"fragmentName":"StepFields"}) as unknown as TypedDocumentString<StepFieldsFragment, unknown>;
export const TaskFieldsFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment TaskFields on request_step_tasks {
  id
  completedOn
  completedBy
  created_at
  submissionsClosedAt
  request_step_task_rejections {
    id
    createdBy
    createdAt
  }
  type
  config
  request_form {
    id
    title
    type
    config
    form_template {
      id
      externalTitle
    }
    request_comments(
      where: {_and: [{completedAt: {_is_null: true}}, {type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}]}
    ) {
      id
      userId
      type
      completedAt
    }
    request_form_submissions(limit: 1, order_by: {submittedOn: desc_nulls_last}) {
      id
      response
    }
    request_form_submissions_auto_saves(limit: 1) {
      id
    }
    request_step_tasks {
      id
      completedOn
      request_step_task_rejections {
        id
      }
    }
  }
  organisation_supplier {
    id
    rfx_suppliers {
      id
      status
      rfx {
        requestId
      }
    }
  }
}
    `, {"fragmentName":"TaskFields"}) as unknown as TypedDocumentString<TaskFieldsFragment, unknown>;
export const GroupUsersFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment GroupUsersFragment on groups {
  group_users(
    where: {user: {isArchived: {_eq: false}, deletedAt: {_is_null: true}}}
  ) {
    user {
      id
      firstName
      lastName
      email
    }
  }
}
    `, {"fragmentName":"GroupUsersFragment"}) as unknown as TypedDocumentString<GroupUsersFragmentFragment, unknown>;
export const UserFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment UserFragment on users {
  id
  firstName
  lastName
  email
  role
  hasConfigPermissions
  isViewOnly
  deletedAt
  isArchived
  languagePreference
  isOutOfOffice
}
    `, {"fragmentName":"UserFragment"}) as unknown as TypedDocumentString<UserFragmentFragment, unknown>;
export const GroupFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment GroupFragment on groups {
  id
  name
  rawAttributes
  organisationId
  isArchived
}
    `, {"fragmentName":"GroupFragment"}) as unknown as TypedDocumentString<GroupFragmentFragment, unknown>;
export const UserDetailsFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment UserDetailsFragment on users {
  ...UserFragment
  isOutOfOffice
  customFieldValues {
    ...CustomFieldValueFragment
  }
  group_users {
    id
    group {
      ...GroupFragment
    }
  }
  department {
    id
    name
  }
  subsidiary {
    id
    name
  }
  managerUser {
    id
    firstName
    lastName
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment GroupFragment on groups {
  id
  name
  rawAttributes
  organisationId
  isArchived
}
fragment UserFragment on users {
  id
  firstName
  lastName
  email
  role
  hasConfigPermissions
  isViewOnly
  deletedAt
  isArchived
  languagePreference
  isOutOfOffice
}`, {"fragmentName":"UserDetailsFragment"}) as unknown as TypedDocumentString<UserDetailsFragmentFragment, unknown>;
export const WorkflowConditionGroupFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment WorkflowConditionGroupFragment on workflow_condition_groups {
  id
  name
  condition
  createdAt
  updatedAt
  precedence
}
    `, {"fragmentName":"WorkflowConditionGroupFragment"}) as unknown as TypedDocumentString<WorkflowConditionGroupFragmentFragment, unknown>;
export const WorkflowFragmentFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment WorkflowFragment on workflows {
  id
  title
  description
  state
  type
  url
  isArchived
  routingCanvasModel
  viewModel
  viewModelUpdatedAt
  requestSidebarConfig
  createdAt
  updatedAt
  canvasModelUpdatedAt
  expectedSLA
  organisationId
  organisation {
    id
    name
  }
  updated_by_user {
    id
    firstName
    lastName
  }
  workflow_rank {
    rank
  }
}
    `, {"fragmentName":"WorkflowFragment"}) as unknown as TypedDocumentString<WorkflowFragmentFragment, unknown>;
export const CreateRefreshTokenDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateRefreshToken($userId: uuid!, $expiresAt: timestamptz!) {
  refreshToken: insert_auth_refresh_tokens_one(
    object: {userId: $userId, expiresAt: $expiresAt}
  ) {
    id
    organisationId
    userId
    expiresAt
    redeemedAt
  }
}
    `) as unknown as TypedDocumentString<CreateRefreshTokenMutation, CreateRefreshTokenMutationVariables>;
export const GetRefreshTokenDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRefreshToken($id: uuid!) {
  refreshToken: auth_refresh_tokens_by_pk(id: $id) {
    id
    expiresAt
    userId
    organisationId
    redeemedAt
  }
}
    `) as unknown as TypedDocumentString<GetRefreshTokenQuery, GetRefreshTokenQueryVariables>;
export const RedeemRefreshTokenDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation RedeemRefreshToken($id: uuid!, $redeemedAt: timestamptz!) {
  update_auth_refresh_tokens_by_pk(
    pk_columns: {id: $id}
    _set: {redeemedAt: $redeemedAt}
  ) {
    id
    expiresAt
    userId
    organisationId
    redeemedAt
  }
}
    `) as unknown as TypedDocumentString<RedeemRefreshTokenMutation, RedeemRefreshTokenMutationVariables>;
export const UpdateFormTemplateByTitleDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateFormTemplateByTitle($title: String!, $newConfig: jsonb!) {
  update_form_templates(where: {title: {_eq: $title}}, _set: {config: $newConfig}) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UpdateFormTemplateByTitleMutation, UpdateFormTemplateByTitleMutationVariables>;
export const InsertMultipleOrganisationSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertMultipleOrganisationSuppliers($objects: [organisation_suppliers_insert_input!]!) {
  insert_organisation_suppliers(objects: $objects) {
    returning {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<InsertMultipleOrganisationSuppliersMutation, InsertMultipleOrganisationSuppliersMutationVariables>;
export const InsertOrgDefaultCurrencyDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertOrgDefaultCurrency($object: organisation_settings_insert_input!) {
  insert_organisation_settings_one(object: $object) {
    name
  }
}
    `) as unknown as TypedDocumentString<InsertOrgDefaultCurrencyMutation, InsertOrgDefaultCurrencyMutationVariables>;
export const InsertTestBudgetsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertTestBudgets($objects: [budgets_insert_input!]!) {
  insert_budgets(objects: $objects) {
    returning {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<InsertTestBudgetsMutation, InsertTestBudgetsMutationVariables>;
export const AddOmneanDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation AddOmnean($email: String!, $firstName: String!) {
  newUser: insert_users_one(
    object: {email: $email, firstName: $firstName, lastName: "Omnea Support", role: "editor", hasConfigPermissions: true}
    on_conflict: {constraint: users_email_organisation_id_key, update_columns: [email]}
  ) {
    id
    groupUsers: group_users {
      id
      group {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AddOmneanMutation, AddOmneanMutationVariables>;
export const GetOmneaSupportGroupsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOmneaSupportGroups {
  groups(
    where: {name: {_in: ["Omnea", "Omnea Support", "Omnea Platform Support"]}, isArchived: {_eq: false}}
  ) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<GetOmneaSupportGroupsQuery, GetOmneaSupportGroupsQueryVariables>;
export const GetHistoricSubmissionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetHistoricSubmissions {
  organisation_supplier_historic_submissions(
    where: {form_template_id: {_is_null: true}}
  ) {
    id
    createdAt
    submittedAt
    title
    response
    organisationSupplier {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetHistoricSubmissionsQuery, GetHistoricSubmissionsQueryVariables>;
export const GetReportingRawDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetReportingRawData {
  organisations {
    id
    domain
  }
  organisation_fx_rates {
    id
    fxRate
    code
  }
  requests {
    id
    name
    renewal {
      id
    }
    state
    completedAt
    request_forms {
      id
      type
      request_form_submissions(limit: 1, order_by: {submittedOn: desc_nulls_last}) {
        id
        response
        submittedOn
      }
    }
  }
  renewals {
    id
    costValue
    costCurrency
    product {
      id
      displayName
    }
    request {
      id
      name
      state
      completedAt
      request_forms(where: {type: {_eq: RENEWAL_ASSESSMENT}}) {
        id
        request_form_submissions(limit: 1, order_by: {submittedOn: desc_nulls_last}) {
          id
          response
          submittedOn
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetReportingRawDataQuery, GetReportingRawDataQueryVariables>;
export const GetRequestBlockDurationRawDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestBlockDurationRawData {
  requests(order_by: {createdAt: desc}) {
    organisation {
      id
      domain
      name
    }
    id
    createdAt
    deletedAt
    completedAt
    publicId
    workflow {
      title
      type
    }
    state
    publicId
    name
    steps(order_by: {createdAt: desc}) {
      id: canvasModelId
      label: input(path: "metadata.config.payload.label")
      createdAt
      completedAt
      deletedAt
      state
      output
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestBlockDurationRawDataQuery, GetRequestBlockDurationRawDataQueryVariables>;
export const GetCustomCoreDataOptionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataOptions($customCoreDataId: uuid!) {
  customCoreDataOptions: custom_core_data_options(
    where: {customCoreDataId: {_eq: $customCoreDataId}}
  ) {
    ...CustomCoreDataOption
  }
}
    fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetCustomCoreDataOptionsQuery, GetCustomCoreDataOptionsQueryVariables>;
export const GetFormTemplateByTitleDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTemplateByTitle($title: String!) {
  form_templates(where: {title: {_eq: $title}}) {
    id
    type
  }
}
    `) as unknown as TypedDocumentString<GetFormTemplateByTitleQuery, GetFormTemplateByTitleQueryVariables>;
export const GetIntakeAndRenewalAssessmentFormsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetIntakeAndRenewalAssessmentForms($organisationId: uuid!) {
  forms: request_forms(
    where: {organisationId: {_eq: $organisationId}, _and: {_or: [{type: {_eq: INTAKE}}, {type: {_eq: RENEWAL_ASSESSMENT}}]}}
  ) {
    id
    type
    request {
      id
      publicId
    }
    request_form_submissions(limit: 1, order_by: {submittedOn: asc}) {
      id
      response
    }
  }
}
    `) as unknown as TypedDocumentString<GetIntakeAndRenewalAssessmentFormsQuery, GetIntakeAndRenewalAssessmentFormsQueryVariables>;
export const UpdateLineItemTypesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateLineItemTypes($updates: [line_item_types_updates!]!) {
  update_line_item_types_many(updates: $updates) {
    affected_rows
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateLineItemTypesMutation, UpdateLineItemTypesMutationVariables>;
export const GetCustomCoreDataByNameDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataByName($name: String!) {
  custom_core_data(where: {name: {_eq: $name}}) {
    id
    organisationId
  }
}
    `) as unknown as TypedDocumentString<GetCustomCoreDataByNameQuery, GetCustomCoreDataByNameQueryVariables>;
export const InsertCoreDataDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertCoreDataDependencies($objects: [core_data_dependencies_insert_input!]!) {
  insert_core_data_dependencies(objects: $objects) {
    returning {
      id
      coreDataId
    }
  }
}
    `) as unknown as TypedDocumentString<InsertCoreDataDependenciesMutation, InsertCoreDataDependenciesMutationVariables>;
export const GetAllOrganisationsWorkflowsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllOrganisationsWorkflows {
  organisations {
    name
    id
    workflows(where: {deletedAt: {_is_null: true}}) {
      id
      title
      state
      routingCanvasModel
    }
  }
}
    `) as unknown as TypedDocumentString<GetAllOrganisationsWorkflowsQuery, GetAllOrganisationsWorkflowsQueryVariables>;
export const GetFormTemplatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTemplates {
  form_templates(
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: desc}
  ) {
    ...FormTemplateFragment
    organisationId
    createdAt
    createdBy
    updatedBy
  }
}
    fragment FormTemplateFragment on form_templates {
  config
  description
  id
  internalId
  state
  title
  integration
  externalTitle
  type
  updatedAt
  updated_by_user {
    id
    firstName
    lastName
  }
}`) as unknown as TypedDocumentString<GetFormTemplatesQuery, GetFormTemplatesQueryVariables>;
export const DeleteRequestStepTaskDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRequestStepTask($requestStepTaskIdToDelete: uuid!) {
  delete_request_step_tasks_by_pk(id: $requestStepTaskIdToDelete) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteRequestStepTaskMutation, DeleteRequestStepTaskMutationVariables>;
export const SetupAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SetupAssignees($requestGroupsObjects: [request_groups_insert_input!]!, $requestStepGroupsObjects: [request_step_groups_insert_input!]!, $requestUsersObjects: [request_users_insert_input!]!, $requestStepUsersObjects: [request_step_users_insert_input!]!) {
  insert_request_groups(
    on_conflict: {update_columns: [], constraint: request_groups_request_id_group_id_key}
    objects: $requestGroupsObjects
  ) {
    returning {
      id
    }
  }
  insert_request_step_groups(
    on_conflict: {update_columns: [], constraint: request_step_groups_request_step_id_group_id_key}
    objects: $requestStepGroupsObjects
  ) {
    returning {
      id
    }
  }
  insert_request_users(
    on_conflict: {update_columns: [], constraint: request_users_user_id_request_id_key}
    objects: $requestUsersObjects
  ) {
    returning {
      id
    }
  }
  insert_request_step_users(
    on_conflict: {update_columns: [], constraint: request_step_users_request_step_id_user_id_key}
    objects: $requestStepUsersObjects
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<SetupAssigneesMutation, SetupAssigneesMutationVariables>;
export const InsertCustomCoreDataOptionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertCustomCoreDataOptions($input: [custom_core_data_options_insert_input!]!) {
  insert_custom_core_data_options(objects: $input) {
    returning {
      id
      value
      coreDataId
    }
  }
}
    `) as unknown as TypedDocumentString<InsertCustomCoreDataOptionsMutation, InsertCustomCoreDataOptionsMutationVariables>;
export const GetCustomFieldValueByEntityIdAndCustomCoreDataOptionIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFieldValueByEntityIdAndCustomCoreDataOptionId($entityId: uuid!, $customCoreDataOptionId: uuid!) {
  custom_field_values(
    where: {entityId: {_eq: $entityId}, customFieldCoreData: {custom_core_data_option_id: {_eq: $customCoreDataOptionId}}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetCustomFieldValueByEntityIdAndCustomCoreDataOptionIdQuery, GetCustomFieldValueByEntityIdAndCustomCoreDataOptionIdQueryVariables>;
export const UpdateWorkflowConditionGroupScriptDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateWorkflowConditionGroupScript($id: uuid!, $params: workflow_condition_groups_set_input!) {
  update_workflow_condition_groups_by_pk(pk_columns: {id: $id}, _set: $params) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<UpdateWorkflowConditionGroupScriptMutation, UpdateWorkflowConditionGroupScriptMutationVariables>;
export const GetOrganisationSuppliersEmbeddingDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationSuppliersEmbedding {
  organisation_suppliers(where: {state: {_eq: ACTIVE}}) {
    id
    name
    publicId
    embedding
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationSuppliersEmbeddingQuery, GetOrganisationSuppliersEmbeddingQueryVariables>;
export const GetSuppliersWithExternalContactsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSuppliersWithExternalContacts($where: organisation_suppliers_bool_exp!) {
  organisation_suppliers(where: $where) {
    id
    name
    external_contacts {
      id
      email
      isPrimary
      deletedAt
    }
  }
}
    `) as unknown as TypedDocumentString<GetSuppliersWithExternalContactsQuery, GetSuppliersWithExternalContactsQueryVariables>;
export const DeleteOrganisationProductsAndServicesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteOrganisationProductsAndServices($query: organisation_products_and_services_bool_exp!) {
  update_organisation_products_and_services(
    where: $query
    _set: {isArchived: true}
  ) {
    returning {
      ...OrganisationProductsAndServiceFragment
    }
  }
}
    fragment OrganisationProductsAndServiceFragment on organisation_products_and_services {
  id
  name
  displayName
  website
  logoUrl
  createdAt
  updatedAt
  description
  isArchived
  state
  businessOwner {
    id
    firstName
    lastName
  }
  organisation_supplier {
    state
    id
    website
    logoUrl
    name
    externalLink
    organisation_supplier_brand {
      id
      supplierId
    }
    external_contacts(where: {deletedAt: {_is_null: true}}) {
      id
      email
      firstName
      lastName
      isPrimary
      phoneNumber
      title
    }
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
    }
  }
  engagements {
    id
    name
    department
  }
}`) as unknown as TypedDocumentString<DeleteOrganisationProductsAndServicesMutation, DeleteOrganisationProductsAndServicesMutationVariables>;
export const GetAllOrgSupplierAndProductsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllOrgSupplierAndProducts {
  organisation_suppliers(
    where: {deleted_at: {_is_null: true}, state: {_eq: ACTIVE}}
  ) {
    id
    name
    state
    organisation_products_and_services(where: {isArchived: {_eq: true}}) {
      id
      state
      isArchived
      displayName
      logoUrl
      website
      organisationSupplierId
      organisation_products_and_services_requests {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAllOrgSupplierAndProductsQuery, GetAllOrgSupplierAndProductsQueryVariables>;
export const GetSuppliersWithProductsForProductMergeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSuppliersWithProductsForProductMerge($supplierIds: [uuid!]!, $productIds: [uuid!]!) {
  suppliers: organisation_suppliers(
    where: {deleted_at: {_is_null: true}, state: {_eq: ACTIVE}, id: {_in: $supplierIds}}
  ) {
    id
    name
    state
    products: organisation_products_and_services(
      where: {isArchived: {_eq: false}, id: {_in: $productIds}}
      order_by: {createdAt: asc}
    ) {
      id
      state
      isArchived
      displayName
      logoUrl
      website
      organisationSupplierId
      organisation_products_and_services_requests {
        id
      }
      activeRequests: organisation_products_and_services_requests(
        where: {_and: [{completedAt: {_is_null: true}}, {deletedAt: {_is_null: true}}, {_or: [{state: {_is_null: true}}, {state: {_neq: "REJECTED"}}]}]}
      ) {
        id
      }
      scheduledRenewals: renewals(
        where: {requestId: {_is_null: true}, deletedAt: {_is_null: true}}
      ) {
        id
      }
      scheduledAssessments: assessments(
        where: {requestId: {_is_null: true}, deletedAt: {_is_null: true}}
      ) {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetSuppliersWithProductsForProductMergeQuery, GetSuppliersWithProductsForProductMergeQueryVariables>;
export const GetSupplierForDedupingDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierForDeduping($id: uuid!) {
  supplier: organisation_suppliers_by_pk(id: $id) {
    id
    createdAt
    updated_at
    deleted_at
    website
    logoUrl
    name
    isReseller
    files
    state
    description
    externalLink
    address
    legalName
    isPerson
    remoteId
    remoteLink
    lastAssessmentDate
    organisation_supplier_brand {
      id
      supplierId
    }
    external_contacts(where: {deletedAt: {_is_null: true}}) {
      id
      firstName
      lastName
      email
      phoneNumber
      title
      isPrimary
    }
    organisation_products_and_services {
      id
      isArchived
      displayName
      logoUrl
      website
      organisation_products_and_services_requests {
        id
      }
    }
    organisation_suppliers_requests {
      id
      completedAt
      state
      deletedAt
      name
      engagement {
        id
        organisationSupplierId
        organisationProductOrServiceId
      }
    }
    organisation_supplier_tags {
      tagId
      tag {
        name
      }
    }
    engagements {
      id
      organisationProductOrServiceId
    }
  }
}
    `) as unknown as TypedDocumentString<GetSupplierForDedupingQuery, GetSupplierForDedupingQueryVariables>;
export const MoveEngagementSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation MoveEngagementSuppliers($fromSupplier: uuid!, $toSupplier: uuid) {
  update_engagements_many(
    updates: {where: {organisationSupplierId: {_eq: $fromSupplier}}, _set: {organisationSupplierId: $toSupplier}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<MoveEngagementSuppliersMutation, MoveEngagementSuppliersMutationVariables>;
export const MoveProductSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation MoveProductSuppliers($fromSupplier: uuid!, $toSupplier: uuid) {
  update_organisation_products_and_services_many(
    updates: {where: {organisationSupplierId: {_eq: $fromSupplier}}, _set: {organisationSupplierId: $toSupplier}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<MoveProductSuppliersMutation, MoveProductSuppliersMutationVariables>;
export const MoveRequestSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation MoveRequestSuppliers($fromSupplier: uuid!, $toSupplier: uuid) {
  update_requests_many(
    updates: {where: {request_supplier: {_eq: $fromSupplier}}, _set: {request_supplier: $toSupplier}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<MoveRequestSuppliersMutation, MoveRequestSuppliersMutationVariables>;
export const SetSupplierDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SetSupplierData($id: uuid!, $data: organisation_suppliers_set_input!) {
  update_organisation_suppliers_by_pk(pk_columns: {id: $id}, _set: $data) {
    id
  }
}
    `) as unknown as TypedDocumentString<SetSupplierDataMutation, SetSupplierDataMutationVariables>;
export const SoftDeleteDupedSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SoftDeleteDupedSupplier($id: uuid!) {
  update_organisation_products_and_services(
    where: {organisationSupplierId: {_eq: $id}}
    _set: {isArchived: true}
  ) {
    affected_rows
  }
  update_organisation_suppliers_by_pk(
    pk_columns: {id: $id}
    _set: {deleted_at: "now()"}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<SoftDeleteDupedSupplierMutation, SoftDeleteDupedSupplierMutationVariables>;
export const GetOrgSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgSuppliers {
  organisation_suppliers(
    where: {state: {_eq: ACTIVE}, deleted_at: {_is_null: true}}
  ) {
    id
    name
    remoteId
    publicId
    engagements {
      id
      supplierLegalEntity
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrgSuppliersQuery, GetOrgSuppliersQueryVariables>;
export const GetSupplierByRemoteIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierByRemoteId($externalId: String!) {
  organisation_suppliers(where: {remoteId: {_eq: $externalId}}) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetSupplierByRemoteIdQuery, GetSupplierByRemoteIdQueryVariables>;
export const GetSupplierByPublicIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierByPublicId($publicId: Int!) {
  organisation_suppliers(where: {publicId: {_eq: $publicId}}) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetSupplierByPublicIdQuery, GetSupplierByPublicIdQueryVariables>;
export const GetUserByNameDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUserByName($firstName: String!, $lastName: String!) {
  users(
    where: {firstName: {_eq: $firstName}, lastName: {_eq: $lastName}, deletedAt: {_is_null: true}}
  ) {
    id
    isArchived
  }
}
    `) as unknown as TypedDocumentString<GetUserByNameQuery, GetUserByNameQueryVariables>;
export const GetOrgProductsForSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgProductsForSupplier($supplierId: uuid!) {
  organisation_products_and_services(
    where: {organisationSupplierId: {_eq: $supplierId}}
  ) {
    id
    displayName
    logoUrl
    website
    description
  }
}
    `) as unknown as TypedDocumentString<GetOrgProductsForSupplierQuery, GetOrgProductsForSupplierQueryVariables>;
export const DeleteArchivedUsersByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteArchivedUsersById($ids: [uuid!]) {
  delete_users(where: {id: {_in: $ids}, isArchived: {_eq: true}}) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteArchivedUsersByIdMutation, DeleteArchivedUsersByIdMutationVariables>;
export const GetOrganisationUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationUsers {
  users {
    id
    email
    createdAt
    role
    isArchived
    managerUserId
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationUsersQuery, GetOrganisationUsersQueryVariables>;
export const UnsetManagerForUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnsetManagerForUsers($userIds: [uuid!]!) {
  update_users(where: {id: {_in: $userIds}}, _set: {managerUserId: null}) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UnsetManagerForUsersMutation, UnsetManagerForUsersMutationVariables>;
export const ArchiveUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ArchiveUsers($ids: [uuid!]) {
  update_users(where: {id: {_in: $ids}}, _set: {isArchived: true}) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<ArchiveUsersMutation, ArchiveUsersMutationVariables>;
export const GetOrganisationByDomainDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationByDomain($domain: String!) {
  organisations(where: {domain: {_eq: $domain}}) {
    id
    domain
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationByDomainQuery, GetOrganisationByDomainQueryVariables>;
export const GetActiveCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetActiveCoreData {
  departments(where: {isArchived: {_eq: false}}) {
    id
    isArchived
    name
  }
  subsidiaries(where: {isArchived: {_eq: false}}) {
    id
    isArchived
    name
  }
  payment_methods(where: {isArchived: {_eq: false}}) {
    id
    isArchived
    name
  }
  payment_terms(where: {isArchived: {_eq: false}}) {
    id
    isArchived
    name
  }
  organisation_fx_rates(where: {isArchived: {_eq: false}}) {
    id
    name: code
    isArchived
  }
  addresses(where: {isArchived: {_eq: false}}) {
    id
    name
    isArchived
  }
  line_item_types(where: {isArchived: {_eq: false}}) {
    id
    name
    isArchived
  }
}
    `) as unknown as TypedDocumentString<GetActiveCoreDataQuery, GetActiveCoreDataQueryVariables>;
export const GetPurchaseOrderByRequestIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPurchaseOrderByRequestId($requestId: uuid!) {
  purchase_orders(
    where: {requestId: {_eq: $requestId}, deletedAt: {_is_null: true}}
    order_by: [{status: asc}, {createdAt: desc}]
    limit: 1
  ) {
    ...PurchaseOrderFragment
  }
}
    fragment PurchaseOrderFragment on purchase_orders {
  id
  requestId
  organisationId
  remoteNumber
  remoteId
  remoteLink
  remoteStatus
  remoteTotalValue
  remoteInvoicedValue
  remotePaidValue
  currencyId
  status
}`) as unknown as TypedDocumentString<GetPurchaseOrderByRequestIdQuery, GetPurchaseOrderByRequestIdQueryVariables>;
export const GetFormTemplatesByTypeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTemplatesByType($type: form_type_enum!) {
  form_templates(
    where: {type: {_eq: $type}, state: {_eq: PUBLISHED}}
    order_by: {createdAt: desc_nulls_last}
  ) {
    id
    title
    type
    config
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetFormTemplatesByTypeQuery, GetFormTemplatesByTypeQueryVariables>;
export const CreateAgreementWithTermsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateAgreementWithTerms($id: uuid!, $name: String!, $supplierId: uuid!, $ownerId: uuid, $subsidiaryId: uuid, $paymentMethodId: uuid, $paymentTermId: uuid, $agreementTerms: [agreement_terms_insert_input!]!) {
  insert_agreements_one(
    object: {id: $id, name: $name, supplierId: $supplierId, ownerId: $ownerId, subsidiaryId: $subsidiaryId, paymentMethodId: $paymentMethodId, paymentTermId: $paymentTermId, agreement_terms: {data: $agreementTerms}}
  ) {
    id
    name
    publicId
    supplierId
    agreement_terms {
      id
      totalAmount
      currencyCode
      fxRate
    }
  }
}
    `) as unknown as TypedDocumentString<CreateAgreementWithTermsMutation, CreateAgreementWithTermsMutationVariables>;
export const DeleteAgreementDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteAgreement($agreementId: uuid!) {
  delete_renewals: update_renewals(
    where: {sourceAgreementTerm: {agreementId: {_eq: $agreementId}}}
    _set: {deletedAt: "now()"}
  ) {
    affected_rows
  }
  delete_agreement: update_agreements_by_pk(
    pk_columns: {id: $agreementId}
    _set: {deletedAt: "now()"}
  ) {
    id
  }
  delete_agreement_terms: update_agreement_terms(
    where: {agreementId: {_eq: $agreementId}}
    _set: {deletedAt: "now()"}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteAgreementMutation, DeleteAgreementMutationVariables>;
export const GetAgreementByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAgreementById($id: uuid!, $includeOwners: Boolean!, $includeSubsidiary: Boolean!, $includePaymentTerm: Boolean!, $includePaymentMethod: Boolean!, $includeCustomFields: Boolean!, $includeProducts: Boolean!, $customFields: [uuid!], $includeTags: Boolean!, $includePrimaryDepartment: Boolean!, $includeRevisions: Boolean!, $includeRevisionsResponse: Boolean!) {
  agreement: agreements_by_pk(id: $id) {
    ...Agreement
    agreement_terms {
      ...AgreementTerm
    }
  }
}
    fragment Agreement on agreements {
  id
  createdAt
  deletedAt
  name
  publicId
  remoteId
  description
  parentId
  parent {
    id
    name
    publicId
  }
  ownerId
  owner @include(if: $includeOwners) {
    firstName
    lastName
    id
    email
    isArchived
  }
  additionalOwners @include(if: $includeOwners) {
    id
    userId
    user {
      id
      firstName
      lastName
      email
      isArchived
    }
  }
  supplier {
    id
    name
    state
    logoUrl
  }
  subsidiaryId
  subsidiary @include(if: $includeSubsidiary) {
    id
    name
  }
  paymentTermId
  paymentTerm @include(if: $includePaymentTerm) {
    id
    name
  }
  paymentMethodId
  paymentMethod @include(if: $includePaymentMethod) {
    id
    name
  }
  tags @include(if: $includeTags) {
    id
    tag {
      id
      name
    }
  }
  terms: agreement_terms(order_by: {startDate: asc}) {
    ...AgreementTerm
  }
  organisation {
    id
    name
  }
  refreshPricesAt
}
fragment AgreementTerm on agreement_terms {
  createdAt
  name
  startDate
  endDate
  termType
  cancelledAt
  autoRenew
  id
  cancelByDate
  cancelledAt
  totalAmount
  totalAmountInDefaultCurrency
  currencyCode
  fxRate
  fxTime
  cancellationNoticeDayCount
  primaryDepartmentId
  primaryDepartment @include(if: $includePrimaryDepartment) {
    id
    name
    isArchived
  }
  products {
    id
    organisationProductId
    organisation_products_and_service @include(if: $includeProducts) {
      id
      name
    }
  }
  futureRenewal(where: {deletedAt: {_is_null: true}}) {
    id
    workflowStartDate
    workflowStartDayCount
    cancellationNoticeDayCount
    workflowInitialAssigneeId
    status
    renewalDate
    renewedAt
    autoStartEnabled
    sourceRequestId
    organisationProductId
    organisationSupplierId
    workflow {
      id
      title
    }
    request {
      status
      id
    }
  }
  spend: spendItems {
    id
    description
    totalAmount
    startDate
    endDate
    frequency
    quantity
    rate
    fxRate
    fxTime
    currencyCode
  }
  agreement_term_revisions(order_by: {createdAt: desc_nulls_last}) @include(if: $includeRevisions) {
    id
    createdAt
    submittedBy: user {
      id
      firstName
      lastName
    }
    response @include(if: $includeRevisionsResponse)
    agreementTermId
    submissionSource
    requestFormSubmission {
      id
      request_form {
        id
        request {
          id
          name
          publicId
        }
      }
    }
  }
  custom_field_values(
    where: {customFieldId: {_in: $customFields}, deletedAt: {_is_null: true}}
  ) @include(if: $includeCustomFields) {
    ...CustomFieldValueFragment
  }
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetAgreementByIdQuery, GetAgreementByIdQueryVariables>;
export const GetAgreementDocumentsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAgreementDocuments($agreementIds: [uuid!]!) {
  documents(where: {agreement_documents: {agreementId: {_in: $agreementIds}}}) {
    id
    filestoreId
    createdAt
    updatedAt
    organisationId
    fileName
    staticType
    customType
    uploadedBy
    uploadedByUser {
      id
      firstName
      lastName
      email
    }
    customTypeValue {
      id
      value
    }
    sourceRequestDocument {
      id
      sourceRequestForm {
        id
        title
      }
      request {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAgreementDocumentsQuery, GetAgreementDocumentsQueryVariables>;
export const GetAgreementFormTemplatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAgreementFormTemplates {
  createAgreementFormTemplates: form_templates(
    where: {type: {_eq: CREATE_AGREEMENT}}
    order_by: {updatedAt: desc_nulls_last}
    limit: 1
  ) {
    id
    title
    config
  }
  cancelAgreementFormTemplates: form_templates(
    where: {type: {_eq: CANCEL_AGREEMENT}}
    order_by: {updatedAt: desc_nulls_last}
    limit: 1
  ) {
    id
    title
    config
  }
}
    `) as unknown as TypedDocumentString<GetAgreementFormTemplatesQuery, GetAgreementFormTemplatesQueryVariables>;
export const GetAgreementMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAgreementMinimal($agreementId: uuid!) {
  agreement: agreements_by_pk(id: $agreementId) {
    id
    name
    publicId
    deletedAt
    ownerId
    additionalOwners {
      userId
    }
    supplier {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetAgreementMinimalQuery, GetAgreementMinimalQueryVariables>;
export const GetAgreementTermRevisionDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAgreementTermRevision($revisionId: uuid!) {
  revision: agreement_term_revisions_by_pk(id: $revisionId) {
    ...AgreementTermRevisionFragment
  }
}
    fragment AgreementTermRevisionFragment on agreement_term_revisions {
  id
  createdAt
  submittedBy: user {
    id
    firstName
    lastName
  }
  response
  config
  agreementTermId
  submissionSource
  requestFormSubmission {
    id
    request_form {
      id
      request {
        id
        name
        publicId
      }
    }
  }
}`) as unknown as TypedDocumentString<GetAgreementTermRevisionQuery, GetAgreementTermRevisionQueryVariables>;
export const GetAgreementsCountDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAgreementsCount($termWhere: agreement_terms_bool_exp!, $agreementWhere: agreements_bool_exp!) {
  agreements_aggregate(
    where: {_and: [{deletedAt: {_is_null: true}}, {agreement_terms_aggregate: {count: {predicate: {_gt: 0}, filter: $termWhere}}}, $agreementWhere]}
  ) {
    aggregate {
      count
    }
  }
}
    `) as unknown as TypedDocumentString<GetAgreementsCountQuery, GetAgreementsCountQueryVariables>;
export const GetAgreementsPaginatedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAgreementsPaginated($limit: Int!, $offset: Int!, $orderBy: [agreements_order_by!], $includeOwners: Boolean!, $includeSubsidiary: Boolean!, $includePaymentTerm: Boolean!, $includePaymentMethod: Boolean!, $includeCustomFields: Boolean!, $includeProducts: Boolean!, $customFields: [uuid!]!, $termWhere: agreement_terms_bool_exp!, $agreementWhere: agreements_bool_exp!, $includeTags: Boolean!, $includePrimaryDepartment: Boolean!, $includeRevisions: Boolean!, $includeRevisionsResponse: Boolean!) {
  agreements(
    where: {_and: [{deletedAt: {_is_null: true}}, {agreement_terms_aggregate: {count: {predicate: {_gt: 0}, filter: $termWhere}}}, $agreementWhere]}
    limit: $limit
    offset: $offset
    order_by: $orderBy
  ) {
    ...Agreement
  }
}
    fragment Agreement on agreements {
  id
  createdAt
  deletedAt
  name
  publicId
  remoteId
  description
  parentId
  parent {
    id
    name
    publicId
  }
  ownerId
  owner @include(if: $includeOwners) {
    firstName
    lastName
    id
    email
    isArchived
  }
  additionalOwners @include(if: $includeOwners) {
    id
    userId
    user {
      id
      firstName
      lastName
      email
      isArchived
    }
  }
  supplier {
    id
    name
    state
    logoUrl
  }
  subsidiaryId
  subsidiary @include(if: $includeSubsidiary) {
    id
    name
  }
  paymentTermId
  paymentTerm @include(if: $includePaymentTerm) {
    id
    name
  }
  paymentMethodId
  paymentMethod @include(if: $includePaymentMethod) {
    id
    name
  }
  tags @include(if: $includeTags) {
    id
    tag {
      id
      name
    }
  }
  terms: agreement_terms(order_by: {startDate: asc}) {
    ...AgreementTerm
  }
  organisation {
    id
    name
  }
  refreshPricesAt
}
fragment AgreementTerm on agreement_terms {
  createdAt
  name
  startDate
  endDate
  termType
  cancelledAt
  autoRenew
  id
  cancelByDate
  cancelledAt
  totalAmount
  totalAmountInDefaultCurrency
  currencyCode
  fxRate
  fxTime
  cancellationNoticeDayCount
  primaryDepartmentId
  primaryDepartment @include(if: $includePrimaryDepartment) {
    id
    name
    isArchived
  }
  products {
    id
    organisationProductId
    organisation_products_and_service @include(if: $includeProducts) {
      id
      name
    }
  }
  futureRenewal(where: {deletedAt: {_is_null: true}}) {
    id
    workflowStartDate
    workflowStartDayCount
    cancellationNoticeDayCount
    workflowInitialAssigneeId
    status
    renewalDate
    renewedAt
    autoStartEnabled
    sourceRequestId
    organisationProductId
    organisationSupplierId
    workflow {
      id
      title
    }
    request {
      status
      id
    }
  }
  spend: spendItems {
    id
    description
    totalAmount
    startDate
    endDate
    frequency
    quantity
    rate
    fxRate
    fxTime
    currencyCode
  }
  agreement_term_revisions(order_by: {createdAt: desc_nulls_last}) @include(if: $includeRevisions) {
    id
    createdAt
    submittedBy: user {
      id
      firstName
      lastName
    }
    response @include(if: $includeRevisionsResponse)
    agreementTermId
    submissionSource
    requestFormSubmission {
      id
      request_form {
        id
        request {
          id
          name
          publicId
        }
      }
    }
  }
  custom_field_values(
    where: {customFieldId: {_in: $customFields}, deletedAt: {_is_null: true}}
  ) @include(if: $includeCustomFields) {
    ...CustomFieldValueFragment
  }
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetAgreementsPaginatedQuery, GetAgreementsPaginatedQueryVariables>;
export const GetTermRevisionsForAgreementDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetTermRevisionsForAgreement($agreementId: uuid!, $termFilter: agreement_terms_bool_exp!, $revisionFilter: agreement_term_revisions_bool_exp!) {
  agreements_by_pk(id: $agreementId) {
    agreement_terms(where: $termFilter) {
      agreement_term_revisions(
        where: $revisionFilter
        order_by: {createdAt: desc_nulls_last}
      ) {
        id
        response
        createdAt
        agreementTermId
        submissionSource
        submittedBy: user {
          id
          firstName
          lastName
        }
        requestFormSubmission {
          id
          request_form {
            request {
              id
              name
              publicId
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetTermRevisionsForAgreementQuery, GetTermRevisionsForAgreementQueryVariables>;
export const ListAgreementsMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListAgreementsMinimal($where: agreements_bool_exp!, $limit: Int!, $offset: Int!) {
  agreements(where: $where, limit: $limit, offset: $offset, order_by: {name: asc}) {
    id
    name
    publicId
    ownerId
    supplier {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<ListAgreementsMinimalQuery, ListAgreementsMinimalQueryVariables>;
export const RenameAgreementDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation RenameAgreement($id: uuid!, $name: String!) {
  update_agreements_by_pk(pk_columns: {id: $id}, _set: {name: $name}) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<RenameAgreementMutation, RenameAgreementMutationVariables>;
export const GetAgreementCustomFieldsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAgreementCustomFields {
  custom_fields(
    where: {entityType: {_eq: "agreement-term"}, deletedAt: {_is_null: true}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetAgreementCustomFieldsQuery, GetAgreementCustomFieldsQueryVariables>;
export const CommitAgreementDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CommitAgreement($deleteAgreement: [uuid!]!, $upsertAgreement: [agreements_insert_input!]!, $upsertAgreementTerms: [agreement_terms_insert_input!]!, $deleteSpend: [uuid!]!, $upsertSpend: [agreement_term_spend_items_insert_input!]!, $deleteRenewals: [uuid!]!, $upsertRenewals: [renewals_insert_input!]!, $insertTermProducts: [agreement_term_products_insert_input!]!, $deleteTermRevisions: [uuid!]!, $upsertTermRevisions: [agreement_term_revisions_insert_input!]!, $deleteTermProductsTermIds: [uuid!]!, $deleteTermProductsProductIds: [uuid!]!, $deleteAgreementTerms: [uuid!]!, $insertAgreementTags: [agreement_tags_insert_input!]!, $deleteAgreementTagIds: [uuid!]!, $insertAdditionalOwners: [agreement_additional_owners_insert_input!]!, $deleteAdditionalOwnerAgreementId: uuid, $deleteAdditionalOwnerUserIds: [uuid!]!, $shouldUpsertAgreement: Boolean!, $shouldUpsertAgreementTerms: Boolean!, $shouldUpsertSpend: Boolean!, $shouldUpsertRenewals: Boolean!, $shouldInsertTermProducts: Boolean!, $shouldUpsertTermRevisions: Boolean!, $shouldInsertAgreementTags: Boolean!, $shouldDeleteAgreementTags: Boolean!, $shouldInsertAdditionalOwners: Boolean!, $shouldDeleteAdditionalOwners: Boolean!, $shouldDeleteRenewals: Boolean!, $shouldDeleteTermProductsTermIds: Boolean!, $shouldDeleteTermRevisions: Boolean!, $shouldDeleteSpend: Boolean!, $shouldDeleteAgreementTerms: Boolean!, $shouldDeleteAgreement: Boolean!) {
  upsert_agreement: insert_agreements(
    objects: $upsertAgreement
    on_conflict: {constraint: agreements_pkey, update_columns: [name, ownerId, subsidiaryId, remoteId, description, paymentTermId, paymentMethodId, refreshPricesAt]}
  ) @include(if: $shouldUpsertAgreement) {
    affected_rows
    returning {
      id
    }
  }
  upsert_terms: insert_agreement_terms(
    objects: $upsertAgreementTerms
    on_conflict: {constraint: agreement_terms_pkey, update_columns: [startDate, endDate, termType, autoRenew, cancellationNoticeDayCount, cancelledAt, currencyCode, fxRate, fxTime, primaryDepartmentId, totalAmount]}
  ) @include(if: $shouldUpsertAgreementTerms) {
    affected_rows
    returning {
      id
    }
  }
  upsert_spend: insert_agreement_term_spend_items(
    objects: $upsertSpend
    on_conflict: {constraint: agreement_term_spend_items_pkey, update_columns: [totalAmount, currencyCode, startDate, endDate, description, fxRate, fxTime, rate, quantity]}
  ) @include(if: $shouldUpsertSpend) {
    affected_rows
    returning {
      id
    }
  }
  upsert_renewals: insert_renewals(
    objects: $upsertRenewals
    on_conflict: {constraint: renewals_pkey, update_columns: [workflowStartDate, workflowStartDayCount, autoStartEnabled, createdAgreementTermId, sourceAgreementTermId, workflowInitialAssigneeId, workflowId, renewedAt]}
  ) @include(if: $shouldUpsertRenewals) {
    affected_rows
    returning {
      id
    }
  }
  insert_term_products: insert_agreement_term_products(
    objects: $insertTermProducts
  ) @include(if: $shouldInsertTermProducts) {
    affected_rows
    returning {
      agreementTermId
      organisationProductId
    }
  }
  insert_term_revisions: insert_agreement_term_revisions(
    objects: $upsertTermRevisions
  ) @include(if: $shouldUpsertTermRevisions) {
    affected_rows
    returning {
      id
    }
  }
  insert_agreement_tags(
    objects: $insertAgreementTags
    on_conflict: {constraint: agreement_tags_agreement_id_tag_id_key, update_columns: [tagId]}
  ) @include(if: $shouldInsertAgreementTags) {
    affected_rows
    returning {
      id
    }
  }
  delete_agreement_tags(where: {id: {_in: $deleteAgreementTagIds}}) @include(if: $shouldDeleteAgreementTags) {
    affected_rows
  }
  delete_agreement_additional_owners(
    where: {_and: [{agreementId: {_eq: $deleteAdditionalOwnerAgreementId}}, {userId: {_in: $deleteAdditionalOwnerUserIds}}]}
  ) @include(if: $shouldDeleteAdditionalOwners) {
    affected_rows
  }
  insert_agreement_additional_owners(
    objects: $insertAdditionalOwners
    on_conflict: {constraint: agreement_id_user_id_key, update_columns: [userId]}
  ) @include(if: $shouldInsertAdditionalOwners) {
    affected_rows
    returning {
      id
    }
  }
  delete_renewals: update_renewals(
    where: {id: {_in: $deleteRenewals}}
    _set: {deletedAt: "now()"}
  ) @include(if: $shouldDeleteRenewals) {
    affected_rows
  }
  delete_term_products: update_agreement_term_products(
    where: {_and: [{agreementTermId: {_in: $deleteTermProductsTermIds}}, {organisationProductId: {_in: $deleteTermProductsProductIds}}]}
    _set: {deletedAt: "now()"}
  ) @include(if: $shouldDeleteTermProductsTermIds) {
    affected_rows
  }
  delete_term_revisions: update_agreement_term_revisions(
    where: {id: {_in: $deleteTermRevisions}}
    _set: {deletedAt: "now()"}
  ) @include(if: $shouldDeleteTermRevisions) {
    affected_rows
  }
  delete_spend: update_agreement_term_spend_items(
    where: {id: {_in: $deleteSpend}}
    _set: {deletedAt: "now()"}
  ) @include(if: $shouldDeleteSpend) {
    affected_rows
  }
  delete_terms: update_agreement_terms(
    where: {id: {_in: $deleteAgreementTerms}}
    _set: {deletedAt: "now()"}
  ) @include(if: $shouldDeleteAgreementTerms) {
    affected_rows
  }
  delete_agreement: update_agreements(
    where: {id: {_in: $deleteAgreement}}
    _set: {deletedAt: "now()"}
  ) @include(if: $shouldDeleteAgreement) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<CommitAgreementMutation, CommitAgreementMutationVariables>;
export const UpdateUpcomingRenewalDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateUpcomingRenewal($id: uuid!, $input: renewals_set_input!) {
  update_renewals_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateUpcomingRenewalMutation, UpdateUpcomingRenewalMutationVariables>;
export const UpsertAgreementTagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertAgreementTags($agreementId: uuid!, $tagIdsToDelete: [uuid!]!, $tagsToInsert: [agreement_tags_insert_input!]!) {
  delete_agreement_tags(
    where: {agreementId: {_eq: $agreementId}, tagId: {_in: $tagIdsToDelete}}
  ) {
    affected_rows
    returning {
      id
    }
  }
  insert_agreement_tags(
    objects: $tagsToInsert
    on_conflict: {constraint: agreement_tags_agreement_id_tag_id_key, update_columns: [tagId]}
  ) {
    returning {
      id
      tag {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UpsertAgreementTagsMutation, UpsertAgreementTagsMutationVariables>;
export const DeleteAssessmentAdditionalGroupsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteAssessmentAdditionalGroups($assessmentId: uuid!) {
  deletedGroups: delete_assessment_additional_groups(
    where: {assessmentId: {_eq: $assessmentId}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteAssessmentAdditionalGroupsMutation, DeleteAssessmentAdditionalGroupsMutationVariables>;
export const DeleteAssessmentTagsByAssessmentIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteAssessmentTagsByAssessmentId($assessmentId: uuid!) {
  deletedAssessmentTags: delete_assessment_tags(
    where: {assessmentId: {_eq: $assessmentId}}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteAssessmentTagsByAssessmentIdMutation, DeleteAssessmentTagsByAssessmentIdMutationVariables>;
export const DeleteAssessmentTagsByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteAssessmentTagsById($assessmentTagIds: [uuid!]!) {
  deletedAssessmentTags: delete_assessment_tags(
    where: {id: {_in: $assessmentTagIds}}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteAssessmentTagsByIdMutation, DeleteAssessmentTagsByIdMutationVariables>;
export const DeleteAssessmentDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteAssessment($id: uuid!) {
  assessment: update_assessments_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteAssessmentMutation, DeleteAssessmentMutationVariables>;
export const FindAssessmentByAssigneeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query FindAssessmentByAssignee($userId: uuid!, $assessmentId: uuid!) {
  additionalAssigneeAssessments: assessment_additional_users(
    where: {assessmentId: {_eq: $assessmentId}, userId: {_eq: $userId}}
  ) {
    id
  }
  initialAssigneeAssessments: assessments(
    where: {businessOwnerUserId: {_eq: $userId}, id: {_eq: $assessmentId}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<FindAssessmentByAssigneeQuery, FindAssessmentByAssigneeQueryVariables>;
export const GetAssessmentAdditionalUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAssessmentAdditionalUsers($id: uuid!) {
  assessment_additional_users(where: {assessmentId: {_eq: $id}}) {
    id
    userId
  }
}
    `) as unknown as TypedDocumentString<GetAssessmentAdditionalUsersQuery, GetAssessmentAdditionalUsersQueryVariables>;
export const GetAssessmentByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAssessmentById($assessmentId: uuid!) {
  assessment: assessments_by_pk(id: $assessmentId) {
    ...Assessment
  }
}
    fragment Assessment on assessments {
  id
  name
  assessmentTags(where: {tag: {deletedAt: {_is_null: true}}}) {
    id
    tag {
      id
      name
    }
  }
  externalRespondents
  additionalUsers {
    user {
      id
      email
      firstName
      lastName
      isArchived
    }
  }
  additionalGroups {
    id
    group {
      id
      name
    }
  }
  frequency
  sendDate
  workflow {
    id
    title
    routingCanvasModel
    viewModel
    viewModelUpdatedAt
    canvasModelUpdatedAt
    type
  }
  request {
    id
    risks(where: {deletedAt: {_is_null: true}}) {
      ...SummaryRiskLevel
    }
    model
    tagIds
    type
    completedAt
    state
    inProgressStepContext: steps(
      where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
    ) {
      id
      nodeId: canvasModelId
      name: input(path: "$.metadata.config.payload.label")
      assignees: output(path: "$.assignees")
      type: input(path: "$.metadata.type")
      state
      requestStepUsers: request_step_users(where: {deletedAt: {_is_null: true}}) {
        id
        user {
          id
          firstName
          lastName
        }
      }
      requestStepGroups: request_step_groups(where: {deletedAt: {_is_null: true}}) {
        id
        group {
          id
          name
        }
      }
    }
    steps {
      id
      state
      result
      canvasModelId
      createdAt
      completedAt
      totalPausedWorkingHours
      input
    }
    request_forms {
      id
      config
      currentSubmission: request_form_submissions(
        limit: 1
        order_by: {submittedOn: desc_nulls_last}
      ) {
        id
        response
        submittedOn
      }
    }
  }
  completedAt
  businessOwnerUserId
  autoStartEnabled
  organisation {
    id
    name
  }
  deletedAt
  product {
    id
    name
    state
    logoUrl
  }
  organisation_supplier {
    id
    name
    state
    logoUrl
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
    }
  }
}
fragment SummaryRiskLevel on risks {
  id
  inherentRiskImpact {
    id
    name
    score
  }
  inherentRiskProbability {
    id
    name
    score
  }
  inherentRiskMatrix {
    id
    score
  }
  residualRiskImpact {
    id
    name
    score
  }
  residualRiskProbability {
    id
    name
    score
  }
  residualRiskMatrix {
    id
    score
  }
}`) as unknown as TypedDocumentString<GetAssessmentByIdQuery, GetAssessmentByIdQueryVariables>;
export const GetAdminAssessmentsForStatsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAdminAssessmentsForStats {
  assessments(
    where: {_or: [{sendDate: {_is_null: true}}, {sendDate: {_lte: "now()"}}], requestId: {_is_null: true}, deletedAt: {_is_null: true}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetAdminAssessmentsForStatsQuery, GetAdminAssessmentsForStatsQueryVariables>;
export const GetUserAssessmentsForStatsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUserAssessmentsForStats($id: uuid!) {
  initialAssigneeAssessments: assessments(
    where: {_or: [{sendDate: {_is_null: true}}, {sendDate: {_lte: "now()"}}], requestId: {_is_null: true}, deletedAt: {_is_null: true}, businessOwnerUserId: {_eq: $id}}
  ) {
    id
  }
  additionalAssigneeAssessments: assessment_additional_users(
    where: {userId: {_eq: $id}, assessment: {_or: [{sendDate: {_is_null: true}}, {sendDate: {_lte: "now()"}}], requestId: {_is_null: true}, deletedAt: {_is_null: true}, businessOwnerUserId: {_neq: $id}}}
  ) {
    assessment {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetUserAssessmentsForStatsQuery, GetUserAssessmentsForStatsQueryVariables>;
export const GetAssessmentTagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAssessmentTags($assessmentId: uuid!) {
  assessmentTags: assessment_tags(where: {assessmentId: {_eq: $assessmentId}}) {
    id
    tag {
      id
      deletedAt
    }
  }
}
    `) as unknown as TypedDocumentString<GetAssessmentTagsQuery, GetAssessmentTagsQueryVariables>;
export const GetOrgWorkflowsForAssessmentUploadDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgWorkflowsForAssessmentUpload {
  workflows(where: {deletedAt: {_is_null: true}, type: {_eq: ASSESSMENT}}) {
    title
    id
    routingCanvasModel
    viewModel
    viewModelUpdatedAt
    canvasModelUpdatedAt
  }
}
    `) as unknown as TypedDocumentString<GetOrgWorkflowsForAssessmentUploadQuery, GetOrgWorkflowsForAssessmentUploadQueryVariables>;
export const GetRequestWithAssessmentDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestWithAssessment($id: uuid!) {
  requests_by_pk(id: $id) {
    id
    assessment {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestWithAssessmentQuery, GetRequestWithAssessmentQueryVariables>;
export const InsertAssessmentDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertAssessment($assessment: assessments_insert_input!) {
  assessment: insert_assessments_one(object: $assessment) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<InsertAssessmentMutation, InsertAssessmentMutationVariables>;
export const InsertAssessmentAdditionalGroupsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertAssessmentAdditionalGroups($objects: [assessment_additional_groups_insert_input!]!) {
  additionalGroups: insert_assessment_additional_groups(objects: $objects) {
    affected_rows
    returning {
      id
      assessmentId
      groupId
    }
  }
}
    `) as unknown as TypedDocumentString<InsertAssessmentAdditionalGroupsMutation, InsertAssessmentAdditionalGroupsMutationVariables>;
export const InsertAssessmentTagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertAssessmentTags($objects: [assessment_tags_insert_input!]!) {
  insertedAssessmentTags: insert_assessment_tags(objects: $objects) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertAssessmentTagsMutation, InsertAssessmentTagsMutationVariables>;
export const ListAssessmentsForAdminDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListAssessmentsForAdmin($gqlFilter: assessments_bool_exp!, $limit: Int, $offset: Int) {
  assessments(
    where: {_and: [{deletedAt: {_is_null: true}}, $gqlFilter]}
    offset: $offset
    limit: $limit
  ) {
    ...Assessment
  }
  assessments_aggregate(
    where: {_and: [{deletedAt: {_is_null: true}}, $gqlFilter]}
  ) {
    aggregate {
      count
    }
  }
}
    fragment Assessment on assessments {
  id
  name
  assessmentTags(where: {tag: {deletedAt: {_is_null: true}}}) {
    id
    tag {
      id
      name
    }
  }
  externalRespondents
  additionalUsers {
    user {
      id
      email
      firstName
      lastName
      isArchived
    }
  }
  additionalGroups {
    id
    group {
      id
      name
    }
  }
  frequency
  sendDate
  workflow {
    id
    title
    routingCanvasModel
    viewModel
    viewModelUpdatedAt
    canvasModelUpdatedAt
    type
  }
  request {
    id
    risks(where: {deletedAt: {_is_null: true}}) {
      ...SummaryRiskLevel
    }
    model
    tagIds
    type
    completedAt
    state
    inProgressStepContext: steps(
      where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
    ) {
      id
      nodeId: canvasModelId
      name: input(path: "$.metadata.config.payload.label")
      assignees: output(path: "$.assignees")
      type: input(path: "$.metadata.type")
      state
      requestStepUsers: request_step_users(where: {deletedAt: {_is_null: true}}) {
        id
        user {
          id
          firstName
          lastName
        }
      }
      requestStepGroups: request_step_groups(where: {deletedAt: {_is_null: true}}) {
        id
        group {
          id
          name
        }
      }
    }
    steps {
      id
      state
      result
      canvasModelId
      createdAt
      completedAt
      totalPausedWorkingHours
      input
    }
    request_forms {
      id
      config
      currentSubmission: request_form_submissions(
        limit: 1
        order_by: {submittedOn: desc_nulls_last}
      ) {
        id
        response
        submittedOn
      }
    }
  }
  completedAt
  businessOwnerUserId
  autoStartEnabled
  organisation {
    id
    name
  }
  deletedAt
  product {
    id
    name
    state
    logoUrl
  }
  organisation_supplier {
    id
    name
    state
    logoUrl
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
    }
  }
}
fragment SummaryRiskLevel on risks {
  id
  inherentRiskImpact {
    id
    name
    score
  }
  inherentRiskProbability {
    id
    name
    score
  }
  inherentRiskMatrix {
    id
    score
  }
  residualRiskImpact {
    id
    name
    score
  }
  residualRiskProbability {
    id
    name
    score
  }
  residualRiskMatrix {
    id
    score
  }
}`) as unknown as TypedDocumentString<ListAssessmentsForAdminQuery, ListAssessmentsForAdminQueryVariables>;
export const ListAssessmentsForUserDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListAssessmentsForUser($userId: uuid!, $gqlFilter: assessments_bool_exp!, $limit: Int, $offset: Int) {
  assessments(
    where: {_and: [{deletedAt: {_is_null: true}}, $gqlFilter, {_or: [{businessOwnerUserId: {_eq: $userId}}, {businessOwnerUserId: {_neq: $userId}, additionalUsers: {userId: {_eq: $userId}}}]}]}
    offset: $offset
    limit: $limit
  ) {
    ...Assessment
  }
  assessments_aggregate(
    where: {_and: [{deletedAt: {_is_null: true}}, $gqlFilter, {_or: [{businessOwnerUserId: {_eq: $userId}}, {businessOwnerUserId: {_neq: $userId}, additionalUsers: {userId: {_eq: $userId}}}]}]}
  ) {
    aggregate {
      count
    }
  }
}
    fragment Assessment on assessments {
  id
  name
  assessmentTags(where: {tag: {deletedAt: {_is_null: true}}}) {
    id
    tag {
      id
      name
    }
  }
  externalRespondents
  additionalUsers {
    user {
      id
      email
      firstName
      lastName
      isArchived
    }
  }
  additionalGroups {
    id
    group {
      id
      name
    }
  }
  frequency
  sendDate
  workflow {
    id
    title
    routingCanvasModel
    viewModel
    viewModelUpdatedAt
    canvasModelUpdatedAt
    type
  }
  request {
    id
    risks(where: {deletedAt: {_is_null: true}}) {
      ...SummaryRiskLevel
    }
    model
    tagIds
    type
    completedAt
    state
    inProgressStepContext: steps(
      where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
    ) {
      id
      nodeId: canvasModelId
      name: input(path: "$.metadata.config.payload.label")
      assignees: output(path: "$.assignees")
      type: input(path: "$.metadata.type")
      state
      requestStepUsers: request_step_users(where: {deletedAt: {_is_null: true}}) {
        id
        user {
          id
          firstName
          lastName
        }
      }
      requestStepGroups: request_step_groups(where: {deletedAt: {_is_null: true}}) {
        id
        group {
          id
          name
        }
      }
    }
    steps {
      id
      state
      result
      canvasModelId
      createdAt
      completedAt
      totalPausedWorkingHours
      input
    }
    request_forms {
      id
      config
      currentSubmission: request_form_submissions(
        limit: 1
        order_by: {submittedOn: desc_nulls_last}
      ) {
        id
        response
        submittedOn
      }
    }
  }
  completedAt
  businessOwnerUserId
  autoStartEnabled
  organisation {
    id
    name
  }
  deletedAt
  product {
    id
    name
    state
    logoUrl
  }
  organisation_supplier {
    id
    name
    state
    logoUrl
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
    }
  }
}
fragment SummaryRiskLevel on risks {
  id
  inherentRiskImpact {
    id
    name
    score
  }
  inherentRiskProbability {
    id
    name
    score
  }
  inherentRiskMatrix {
    id
    score
  }
  residualRiskImpact {
    id
    name
    score
  }
  residualRiskProbability {
    id
    name
    score
  }
  residualRiskMatrix {
    id
    score
  }
}`) as unknown as TypedDocumentString<ListAssessmentsForUserQuery, ListAssessmentsForUserQueryVariables>;
export const UpdateAssessmentDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateAssessment($id: uuid!, $assessment: assessments_set_input!) {
  assessment: update_assessments_by_pk(pk_columns: {id: $id}, _set: $assessment) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateAssessmentMutation, UpdateAssessmentMutationVariables>;
export const UpdateAssessmentAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateAssessmentAssignees($assessmentId: uuid!, $userIdsToRemove: [uuid!], $usersToAdd: [assessment_additional_users_insert_input!]!) {
  delete_assessment_additional_users(
    where: {assessmentId: {_eq: $assessmentId}, userId: {_in: $userIdsToRemove}}
  ) {
    affected_rows
  }
  insert_assessment_additional_users(objects: $usersToAdd) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UpdateAssessmentAssigneesMutation, UpdateAssessmentAssigneesMutationVariables>;
export const InsertBankAccountDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertBankAccount($bankAccount: bank_details_insert_input!) {
  insert_bank_details_one(object: $bankAccount) {
    ...BankAccount
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<InsertBankAccountMutation, InsertBankAccountMutationVariables>;
export const LinkBankAccountToSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation LinkBankAccountToSupplier($bankAccountId: uuid!, $supplierId: uuid!, $isPrimary: Boolean, $shouldDemotePrimary: Boolean!) {
  demotePrimary: update_entity_bank_details(
    where: {_and: [{bankDetailsId: {_neq: $bankAccountId}}, {isPrimary: {_eq: true}}, {organisationSupplierId: {_eq: $supplierId}}]}
    _set: {isPrimary: false}
  ) @include(if: $shouldDemotePrimary) {
    affected_rows
  }
  linkedToSupplier: insert_entity_bank_details_one(
    object: {bankDetailsId: $bankAccountId, organisationSupplierId: $supplierId, organisationSupplierProfileId: null, isPrimary: $isPrimary}
    on_conflict: {constraint: unique_bank_details_supplier, update_columns: [isPrimary]}
  ) {
    id
    isPrimary
  }
}
    `) as unknown as TypedDocumentString<LinkBankAccountToSupplierMutation, LinkBankAccountToSupplierMutationVariables>;
export const LinkBankAccountToSupplierProfileDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation LinkBankAccountToSupplierProfile($bankAccountId: uuid!, $supplierProfileId: uuid!, $isPrimary: Boolean, $shouldDemotePrimary: Boolean!) {
  demotePrimary: update_entity_bank_details(
    where: {_and: [{bankDetailsId: {_neq: $bankAccountId}}, {isPrimary: {_eq: true}}, {organisationSupplierProfileId: {_eq: $supplierProfileId}}]}
    _set: {isPrimary: false}
  ) @include(if: $shouldDemotePrimary) {
    affected_rows
  }
  linkedToSupplierProfile: insert_entity_bank_details_one(
    object: {bankDetailsId: $bankAccountId, organisationSupplierId: null, organisationSupplierProfileId: $supplierProfileId, isPrimary: $isPrimary}
    on_conflict: {constraint: unique_bank_details_supplier_profile, update_columns: [isPrimary]}
  ) {
    id
    isPrimary
  }
}
    `) as unknown as TypedDocumentString<LinkBankAccountToSupplierProfileMutation, LinkBankAccountToSupplierProfileMutationVariables>;
export const UnlinkAllBankAccountsFromSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnlinkAllBankAccountsFromSupplier($supplierId: uuid!) {
  delete_entity_bank_details(where: {organisationSupplierId: {_eq: $supplierId}}) {
    affected_rows
    returning {
      id
      bankDetailsId
    }
  }
}
    `) as unknown as TypedDocumentString<UnlinkAllBankAccountsFromSupplierMutation, UnlinkAllBankAccountsFromSupplierMutationVariables>;
export const UnlinkAllBankAccountsFromSupplierProfileDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnlinkAllBankAccountsFromSupplierProfile($supplierProfileId: uuid!) {
  delete_entity_bank_details(
    where: {organisationSupplierProfileId: {_eq: $supplierProfileId}}
  ) {
    affected_rows
    returning {
      id
      bankDetailsId
    }
  }
}
    `) as unknown as TypedDocumentString<UnlinkAllBankAccountsFromSupplierProfileMutation, UnlinkAllBankAccountsFromSupplierProfileMutationVariables>;
export const UnlinkBankAccountFromSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnlinkBankAccountFromSupplier($bankAccountId: uuid!, $supplierId: uuid!) {
  delete_entity_bank_details(
    where: {bankDetailsId: {_eq: $bankAccountId}, organisationSupplierId: {_eq: $supplierId}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UnlinkBankAccountFromSupplierMutation, UnlinkBankAccountFromSupplierMutationVariables>;
export const UnlinkBankAccountFromSupplierProfileDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnlinkBankAccountFromSupplierProfile($bankAccountId: uuid!, $supplierProfileId: uuid!) {
  delete_entity_bank_details(
    where: {bankDetailsId: {_eq: $bankAccountId}, organisationSupplierProfileId: {_eq: $supplierProfileId}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UnlinkBankAccountFromSupplierProfileMutation, UnlinkBankAccountFromSupplierProfileMutationVariables>;
export const UpdateBankAccountDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateBankAccount($id: uuid!, $changes: bank_details_set_input!) {
  update_bank_details_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...BankAccount
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<UpdateBankAccountMutation, UpdateBankAccountMutationVariables>;
export const CountAddressesByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query CountAddressesByIds($ids: [uuid!]!) {
  addresses_aggregate(where: {id: {_in: $ids}}) {
    aggregate {
      count
    }
  }
}
    `) as unknown as TypedDocumentString<CountAddressesByIdsQuery, CountAddressesByIdsQueryVariables>;
export const CountBankAccountsForEntitiesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query CountBankAccountsForEntities($where: entity_bank_details_bool_exp!) {
  entity_bank_details(where: $where) {
    organisationSupplierId
    organisationSupplierProfileId
  }
}
    `) as unknown as TypedDocumentString<CountBankAccountsForEntitiesQuery, CountBankAccountsForEntitiesQueryVariables>;
export const GetAddressByRemoteIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAddressByRemoteId($remoteId: String!, $organisationId: uuid!) {
  addresses(
    where: {remoteId: {_eq: $remoteId}, organisationId: {_eq: $organisationId}, isArchived: {_eq: false}}
    limit: 1
  ) {
    id
    remoteId
  }
}
    `) as unknown as TypedDocumentString<GetAddressByRemoteIdQuery, GetAddressByRemoteIdQueryVariables>;
export const GetBankAccountByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBankAccountById($id: uuid!) {
  bank_details_by_pk(id: $id) {
    ...BankAccount
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetBankAccountByIdQuery, GetBankAccountByIdQueryVariables>;
export const GetBankAccountByRemoteIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBankAccountByRemoteId($remoteId: String!, $organisationId: uuid!) {
  bank_details(
    where: {remoteId: {_eq: $remoteId}, organisationId: {_eq: $organisationId}, deleted_at: {_is_null: true}}
    limit: 1
  ) {
    ...BankAccount
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetBankAccountByRemoteIdQuery, GetBankAccountByRemoteIdQueryVariables>;
export const GetBankAccountOnEntityDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBankAccountOnEntity($bankAccountId: uuid!, $entityId: uuid!, $isSupplier: Boolean!, $isSupplierProfile: Boolean!) {
  supplierProfile: organisation_supplier_profiles_by_pk(id: $entityId) @include(if: $isSupplierProfile) {
    id
    entityBankDetails(where: {bankDetailsId: {_eq: $bankAccountId}}) {
      id
      bankDetailsId
    }
  }
  supplier: organisation_suppliers_by_pk(id: $entityId) @include(if: $isSupplier) {
    id
    entityBankDetails(where: {bankDetailsId: {_eq: $bankAccountId}}) {
      id
      bankDetailsId
    }
  }
  bankAccount: bank_details_by_pk(id: $bankAccountId) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetBankAccountOnEntityQuery, GetBankAccountOnEntityQueryVariables>;
export const GetBankAccountsByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBankAccountsByIds($ids: [uuid!]!) {
  bank_details(where: {id: {_in: $ids}, deleted_at: {_is_null: true}}) {
    ...BankAccount
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetBankAccountsByIdsQuery, GetBankAccountsByIdsQueryVariables>;
export const GetCurrencyByRemoteIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCurrencyByRemoteId($remoteId: String!) {
  organisation_fx_rates(
    where: {remoteId: {_eq: $remoteId}, isArchived: {_eq: false}}
    limit: 1
  ) {
    id
    remoteId
  }
}
    `) as unknown as TypedDocumentString<GetCurrencyByRemoteIdQuery, GetCurrencyByRemoteIdQueryVariables>;
export const GetLinkedEntitiesForBankAccountDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLinkedEntitiesForBankAccount($bankAccountId: uuid!) {
  entity_bank_details(where: {bankDetailsId: {_eq: $bankAccountId}}, limit: 1) {
    id
    organisationSupplierId
    organisationSupplierProfileId
  }
}
    `) as unknown as TypedDocumentString<GetLinkedEntitiesForBankAccountQuery, GetLinkedEntitiesForBankAccountQueryVariables>;
export const GetLinkedEntitiesForBankAccountInBankAccountsServiceDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLinkedEntitiesForBankAccountInBankAccountsService($bankAccountId: uuid!) {
  entity_bank_details(where: {bankDetailsId: {_eq: $bankAccountId}}) {
    id
    organisationSupplierId
    organisationSupplierProfileId
    isPrimary
  }
}
    `) as unknown as TypedDocumentString<GetLinkedEntitiesForBankAccountInBankAccountsServiceQuery, GetLinkedEntitiesForBankAccountInBankAccountsServiceQueryVariables>;
export const ListBankAccountsForEntityDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListBankAccountsForEntity($where: entity_bank_details_bool_exp!, $limit: Int = 100, $orderBy: [entity_bank_details_order_by!] = [{createdAt: desc}]) {
  entityBankDetails: entity_bank_details(
    where: $where
    limit: $limit
    order_by: $orderBy
  ) {
    isPrimary
    bankDetails {
      ...BankAccount
    }
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<ListBankAccountsForEntityQuery, ListBankAccountsForEntityQueryVariables>;
export const DeleteBudgetApprovalGroupAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteBudgetApprovalGroupAssignees($id: uuid!) {
  delete_budget_approval_group_assignees_by_pk(id: $id) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteBudgetApprovalGroupAssigneesMutation, DeleteBudgetApprovalGroupAssigneesMutationVariables>;
export const DeleteBudgetApprovalGroupAssigneesAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteBudgetApprovalGroupAssigneesAssignees($groupAssigneesId: uuid!) {
  delete_budget_approval_group_assignees_assignees(
    where: {budgetApprovalGroupAssigneesId: {_eq: $groupAssigneesId}}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteBudgetApprovalGroupAssigneesAssigneesMutation, DeleteBudgetApprovalGroupAssigneesAssigneesMutationVariables>;
export const DeleteBudgetApprovalGroupAssigneesCustomCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteBudgetApprovalGroupAssigneesCustomCoreData($groupAssigneesId: uuid!) {
  delete_budget_approval_group_assignees_custom_core_data_options(
    where: {budget_approval_group_assignees_id: {_eq: $groupAssigneesId}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteBudgetApprovalGroupAssigneesCustomCoreDataMutation, DeleteBudgetApprovalGroupAssigneesCustomCoreDataMutationVariables>;
export const DeleteBudgetApprovalsGroupDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteBudgetApprovalsGroup($id: uuid!) {
  update_budget_approval_group_by_pk(
    pk_columns: {id: $id}
    _set: {deleted_at: "now()"}
  ) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<DeleteBudgetApprovalsGroupMutation, DeleteBudgetApprovalsGroupMutationVariables>;
export const DeleteBudgetApprovalsThresholdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteBudgetApprovalsThreshold($id: uuid!) {
  update_budget_approval_threshold_by_pk(
    pk_columns: {id: $id}
    _set: {deleted_at: "now()"}
  ) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<DeleteBudgetApprovalsThresholdMutation, DeleteBudgetApprovalsThresholdMutationVariables>;
export const GetBudgetApprovalGroupAssigneeByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBudgetApprovalGroupAssigneeById($id: uuid!) {
  budget_approval_group_assignees_by_pk(id: $id) {
    id
    budgetApprovalGroupId
    departmentId
    department {
      id
      name
      isArchived
    }
    subsidiaryId
    subsidiary {
      id
      name
      isArchived
    }
    lineItemId
    lineItem {
      id
      name
      isArchived
    }
    assignees {
      id
      group {
        id
        name
      }
      user {
        id
        firstName
        lastName
        email
      }
    }
    customCoreDataOptions: custom_core_data_options {
      budget_approval_group_assignees_id
      custom_core_data_id
      custom_core_data_option {
        id
        value
        custom_core_data {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetBudgetApprovalGroupAssigneeByIdQuery, GetBudgetApprovalGroupAssigneeByIdQueryVariables>;
export const GetBudgetApprovalGroupConfigDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBudgetApprovalGroupConfig($id: uuid!) {
  budget_approval_group_by_pk(id: $id) {
    id
    organisationId
    name
    selected_custom_core_data {
      custom_core_data {
        name
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetBudgetApprovalGroupConfigQuery, GetBudgetApprovalGroupConfigQueryVariables>;
export const GetBudgetApprovalGroupWithAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBudgetApprovalGroupWithAssignees($groupId: uuid!, $groupAssigneesQuery: budget_approval_group_assignees_bool_exp!) {
  budget_approval_group_by_pk(id: $groupId) {
    id
    name
    assignees(where: $groupAssigneesQuery) {
      id
      departmentId
      subsidiaryId
      lineItemId
      custom_core_data_options {
        budget_approval_group_assignees_id
        custom_core_data_id
        custom_core_data_option_id
      }
      assignees {
        id
        group {
          id
          name
        }
        user {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetBudgetApprovalGroupWithAssigneesQuery, GetBudgetApprovalGroupWithAssigneesQueryVariables>;
export const GetBudgetApprovalsDynamicAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBudgetApprovalsDynamicAssignees($groupId: uuid!, $value: float8!, $groupAssigneesQuery: budget_approval_group_assignees_bool_exp!) {
  budget_approval_threshold(
    where: {_and: [{_or: [{maxValue: {_gt: $value}}, {maxValue: {_is_null: true}}]}, {minValue: {_lte: $value}}]}
  ) {
    id
    name
    minValue
    maxValue
    inBudget
    departments {
      departmentId
    }
    budget_approval_threshold_groups(where: {approvalGroupId: {_eq: $groupId}}) {
      id
      isApproval
      approvalGroupId
      budget_approval_group {
        id
        name
        assignees(where: $groupAssigneesQuery) {
          id
          departmentId
          subsidiaryId
          lineItemId
          custom_core_data_options {
            budget_approval_group_assignees_id
            custom_core_data_id
            custom_core_data_option_id
          }
          assignees {
            id
            group {
              id
              name
            }
            user {
              id
              firstName
              lastName
              email
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetBudgetApprovalsDynamicAssigneesQuery, GetBudgetApprovalsDynamicAssigneesQueryVariables>;
export const GetBudgetApprovalsGroupAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBudgetApprovalsGroupAssignees($groupId: uuid!) {
  budget_approval_group_assignees(
    where: {budgetApprovalGroupId: {_eq: $groupId}}
    order_by: {created_at: desc}
  ) {
    id
    budgetApprovalGroupId
    departmentId
    department {
      id
      name
      isArchived
    }
    subsidiaryId
    subsidiary {
      id
      name
      isArchived
    }
    lineItemId
    lineItem {
      id
      name
      isArchived
    }
    assignees {
      id
      group {
        id
        name
      }
      user {
        id
        firstName
        lastName
        email
      }
    }
    custom_core_data_options {
      budget_approval_group_assignees_id
      custom_core_data_id
      custom_core_data_option {
        id
        value
        custom_core_data {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetBudgetApprovalsGroupAssigneesQuery, GetBudgetApprovalsGroupAssigneesQueryVariables>;
export const GetBudgetApprovalsGroupCustomCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBudgetApprovalsGroupCustomCoreData($groupId: uuid!) {
  budget_approval_group_by_pk(id: $groupId) {
    id
    selected_custom_core_data {
      custom_core_data {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetBudgetApprovalsGroupCustomCoreDataQuery, GetBudgetApprovalsGroupCustomCoreDataQueryVariables>;
export const GetBudgetApprovalsThresholdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBudgetApprovalsThresholds {
  budget_approval_threshold(order_by: {created_at: desc}) {
    ...BudgetApprovalsThreshold
  }
}
    fragment BudgetApprovalsThreshold on budget_approval_threshold {
  id
  name
  created_at
  minValue
  maxValue
  inBudget
  departments {
    department {
      id
      name
    }
  }
  groups: budget_approval_threshold_groups {
    id
    isApproval
    approvalGroupId
  }
}`) as unknown as TypedDocumentString<GetBudgetApprovalsThresholdsQuery, GetBudgetApprovalsThresholdsQueryVariables>;
export const GetCustomFieldNameByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFieldNameById($id: uuid!) {
  custom_fields_by_pk(id: $id) {
    id
    title
  }
}
    `) as unknown as TypedDocumentString<GetCustomFieldNameByIdQuery, GetCustomFieldNameByIdQueryVariables>;
export const InsertBudgetApprovalGroupAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertBudgetApprovalGroupAssignees($input: budget_approval_group_assignees_insert_input!) {
  insert_budget_approval_group_assignees_one(object: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertBudgetApprovalGroupAssigneesMutation, InsertBudgetApprovalGroupAssigneesMutationVariables>;
export const InsertBudgetApprovalGroupAssigneesCustomCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertBudgetApprovalGroupAssigneesCustomCoreData($input: [budget_approval_group_assignees_custom_core_data_options_insert_input!]!) {
  insert_budget_approval_group_assignees_custom_core_data_options(objects: $input) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<InsertBudgetApprovalGroupAssigneesCustomCoreDataMutation, InsertBudgetApprovalGroupAssigneesCustomCoreDataMutationVariables>;
export const InsertBudgetApprovalsGroupDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertBudgetApprovalsGroup($input: budget_approval_group_insert_input!) {
  insert_budget_approval_group_one(object: $input) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<InsertBudgetApprovalsGroupMutation, InsertBudgetApprovalsGroupMutationVariables>;
export const InsertBudgetApprovalsGroupAssigneesAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertBudgetApprovalsGroupAssigneesAssignees($input: [budget_approval_group_assignees_assignees_insert_input!]!) {
  insert_budget_approval_group_assignees_assignees(objects: $input) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertBudgetApprovalsGroupAssigneesAssigneesMutation, InsertBudgetApprovalsGroupAssigneesAssigneesMutationVariables>;
export const InsertBudgetApprovalsGroupCustomCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertBudgetApprovalsGroupCustomCoreData($groupId: uuid!, $customCoreDataId: uuid!) {
  insert_budget_approval_group_selected_custom_core_data_one(
    object: {budget_approval_group_id: $groupId, custom_core_data_id: $customCoreDataId}
  ) {
    budget_approval_group_id
  }
}
    `) as unknown as TypedDocumentString<InsertBudgetApprovalsGroupCustomCoreDataMutation, InsertBudgetApprovalsGroupCustomCoreDataMutationVariables>;
export const InsertBudgetApprovalsThresholdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertBudgetApprovalsThreshold($input: budget_approval_threshold_insert_input!) {
  insert_budget_approval_threshold_one(object: $input) {
    ...BudgetApprovalsThreshold
  }
}
    fragment BudgetApprovalsThreshold on budget_approval_threshold {
  id
  name
  created_at
  minValue
  maxValue
  inBudget
  departments {
    department {
      id
      name
    }
  }
  groups: budget_approval_threshold_groups {
    id
    isApproval
    approvalGroupId
  }
}`) as unknown as TypedDocumentString<InsertBudgetApprovalsThresholdMutation, InsertBudgetApprovalsThresholdMutationVariables>;
export const RemoveBudgetApprovalsGroupCustomCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation RemoveBudgetApprovalsGroupCustomCoreData($groupId: uuid!, $customCoreDataId: uuid!) {
  delete_budget_approval_group_selected_custom_core_data_by_pk(
    budget_approval_group_id: $groupId
    custom_core_data_id: $customCoreDataId
  ) {
    budget_approval_group_id
  }
}
    `) as unknown as TypedDocumentString<RemoveBudgetApprovalsGroupCustomCoreDataMutation, RemoveBudgetApprovalsGroupCustomCoreDataMutationVariables>;
export const UpdateBudgetApprovalGroupAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateBudgetApprovalGroupAssignees($id: uuid!, $input: budget_approval_group_assignees_set_input!) {
  update_budget_approval_group_assignees_by_pk(
    pk_columns: {id: $id}
    _set: $input
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateBudgetApprovalGroupAssigneesMutation, UpdateBudgetApprovalGroupAssigneesMutationVariables>;
export const UpdateBudgetApprovalsGroupNameDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateBudgetApprovalsGroupName($id: uuid!, $name: String!) {
  update_budget_approval_group_by_pk(pk_columns: {id: $id}, _set: {name: $name}) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<UpdateBudgetApprovalsGroupNameMutation, UpdateBudgetApprovalsGroupNameMutationVariables>;
export const UpdateBudgetApprovalsThresholdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateBudgetApprovalsThreshold($id: uuid!, $input: budget_approval_threshold_set_input!, $insertDepartmentsInput: [budget_approval_threshold_department_insert_input!]!, $insertGroupsInput: [budget_approval_threshold_group_insert_input!]!) {
  update_budget_approval_threshold_by_pk(pk_columns: {id: $id}, _set: $input) {
    ...BudgetApprovalsThreshold
  }
  delete_budget_approval_threshold_department(where: {thresholdId: {_eq: $id}}) {
    returning {
      thresholdId
    }
  }
  insert_budget_approval_threshold_department(objects: $insertDepartmentsInput) {
    returning {
      thresholdId
    }
  }
  delete_budget_approval_threshold_group(where: {thresholdId: {_eq: $id}}) {
    returning {
      id
    }
  }
  insert_budget_approval_threshold_group(objects: $insertGroupsInput) {
    returning {
      id
    }
  }
}
    fragment BudgetApprovalsThreshold on budget_approval_threshold {
  id
  name
  created_at
  minValue
  maxValue
  inBudget
  departments {
    department {
      id
      name
    }
  }
  groups: budget_approval_threshold_groups {
    id
    isApproval
    approvalGroupId
  }
}`) as unknown as TypedDocumentString<UpdateBudgetApprovalsThresholdMutation, UpdateBudgetApprovalsThresholdMutationVariables>;
export const CreateBudgetDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateBudget($name: String!, $status: String!, $currency_id: uuid!, $amount: numeric!) {
  insert_budgets_one(
    object: {amount: $amount, currency_id: $currency_id, name: $name, status: $status}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateBudgetMutation, CreateBudgetMutationVariables>;
export const GetBudgetDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBudget($budgetId: uuid!) {
  budgets(where: {id: {_eq: $budgetId}, isArchived: {_eq: false}}) {
    ...BudgetsWithSpendCompute
  }
}
    fragment BudgetsWithSpendCompute on budgets {
  id
  amount
  externalId
  name
  status
  createdAt
  budgets_organisation_fx_rate {
    id
    code
    displaySymbol
    fxRate
  }
  requests: budgets_requests(where: {deletedAt: {_is_null: true}}) {
    id
    engagement {
      id
      financial {
        id
        amount
      }
    }
    computedProperties {
      valueObject
    }
  }
}`) as unknown as TypedDocumentString<GetBudgetQuery, GetBudgetQueryVariables>;
export const GetBudgetsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBudgets {
  budgets(where: {isArchived: {_eq: false}}) {
    ...BudgetsWithSpendCompute
  }
}
    fragment BudgetsWithSpendCompute on budgets {
  id
  amount
  externalId
  name
  status
  createdAt
  budgets_organisation_fx_rate {
    id
    code
    displaySymbol
    fxRate
  }
  requests: budgets_requests(where: {deletedAt: {_is_null: true}}) {
    id
    engagement {
      id
      financial {
        id
        amount
      }
    }
    computedProperties {
      valueObject
    }
  }
}`) as unknown as TypedDocumentString<GetBudgetsQuery, GetBudgetsQueryVariables>;
export const GetAdminsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAdmins {
  admins: users(where: {role: {_eq: "editor"}, isArchived: {_eq: false}}) {
    id
    email
    firstName
    lastName
    isArchived
    hasConfigPermissions
  }
}
    `) as unknown as TypedDocumentString<GetAdminsQuery, GetAdminsQueryVariables>;
export const GetInitialInternalUsersAndGroupsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetInitialInternalUsersAndGroups {
  initialInternalUsers: users(
    where: {role: {_in: ["editor", "user"]}, isArchived: {_eq: false}}
    limit: 10
  ) {
    id
    email
    firstName
    lastName
    isArchived
    hasConfigPermissions
  }
  groups(where: {isArchived: {_eq: false}}) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<GetInitialInternalUsersAndGroupsQuery, GetInitialInternalUsersAndGroupsQueryVariables>;
export const GetFormTypeAndStepTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTypeAndStepTasks($requestFormId: uuid!) {
  request_forms_by_pk(id: $requestFormId) {
    id
    type
    request_form_template_id
    request_step_tasks {
      id
      type
      request_step_task_users {
        user_id
      }
      request_step {
        id
        state
        type: input(path: "metadata.type")
        input
        completedAt
        request_step_users {
          id
          user {
            id
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetFormTypeAndStepTasksQuery, GetFormTypeAndStepTasksQueryVariables>;
export const GetRfxRequestStepIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxRequestStepId($rfxId: uuid!) {
  rfx_by_pk(id: $rfxId) {
    id
    requestStepId
    organisation {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxRequestStepIdQuery, GetRfxRequestStepIdQueryVariables>;
export const GetConfigTranslationsWithSourceHashDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetConfigTranslationsWithSourceHash($locale: String!) {
  config_translations(where: {locale: {_eq: $locale}}) {
    key
    value
    entityId
    namespace
    sourceHash
  }
}
    `) as unknown as TypedDocumentString<GetConfigTranslationsWithSourceHashQuery, GetConfigTranslationsWithSourceHashQueryVariables>;
export const GetAllCustomFieldsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllCustomFields {
  customFields: custom_fields(where: {deletedAt: {_is_null: true}}) {
    ...CustomFieldsFragment
  }
}
    fragment CustomFieldsFragment on custom_fields {
  id
  title
  type
  entityType
  isRequired
  externalSource
  remoteId
  customCoreData {
    id
    name
  }
  choices {
    id
    label
    customFieldId
  }
}`) as unknown as TypedDocumentString<GetAllCustomFieldsQuery, GetAllCustomFieldsQueryVariables>;
export const GetAllCustomFieldsForIntegrationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllCustomFieldsForIntegration($integrationId: uuid!) {
  customFields: custom_fields(
    where: {deletedAt: {_is_null: true}, organisationIntegrationId: {_eq: $integrationId}}
  ) {
    ...CustomFieldsFragment
  }
}
    fragment CustomFieldsFragment on custom_fields {
  id
  title
  type
  entityType
  isRequired
  externalSource
  remoteId
  customCoreData {
    id
    name
  }
  choices {
    id
    label
    customFieldId
  }
}`) as unknown as TypedDocumentString<GetAllCustomFieldsForIntegrationQuery, GetAllCustomFieldsForIntegrationQueryVariables>;
export const GetCoreDataOrganisationIntegrationsForIntegrationIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCoreDataOrganisationIntegrationsForIntegrationId($organisationIntegrationId: uuid!) {
  core_data_organisation_integrations(
    where: {organisationIntegrationId: {_eq: $organisationIntegrationId}}
  ) {
    id
    organisationIntegrationId
    coreDataType
  }
}
    `) as unknown as TypedDocumentString<GetCoreDataOrganisationIntegrationsForIntegrationIdQuery, GetCoreDataOrganisationIntegrationsForIntegrationIdQueryVariables>;
export const GetCustomCoreDataForIntegrationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataForIntegration($integrationId: uuid!) {
  custom_core_data(
    where: {archivedAt: {_is_null: true}, organisationIntegrationId: {_eq: $integrationId}}
    order_by: {createdAt: asc}
  ) {
    ...CustomCoreData
  }
}
    fragment CustomCoreData on custom_core_data {
  id
  name
  organisationId
  pathLevels
  archivedAt
  organisationIntegration {
    id
    integration
  }
  options: custom_core_data_options(where: {isArchived: {_eq: false}}) {
    ...CustomCoreDataOption
  }
  numOptions: custom_core_data_options_aggregate(
    where: {isArchived: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetCustomCoreDataForIntegrationQuery, GetCustomCoreDataForIntegrationQueryVariables>;
export const GetOrganisationIntegrationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationIntegration($id: uuid!) {
  organisation_integrations_by_pk(id: $id) {
    id
    integration
    name
    referenceId
    defaultSupplierState
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationIntegrationQuery, GetOrganisationIntegrationQueryVariables>;
export const ListOrganisationIntegrationsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListOrganisationIntegrations($query: organisation_integrations_bool_exp) {
  organisation_integrations(where: $query) {
    id
    integration
    name
    updatedAt
    referenceId
    defaultSupplierState
  }
}
    `) as unknown as TypedDocumentString<ListOrganisationIntegrationsQuery, ListOrganisationIntegrationsQueryVariables>;
export const GetLatestExternalEntitySyncStatusForCustomCoreDataIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLatestExternalEntitySyncStatusForCustomCoreDataId($customCoreDataId: uuid!, $organisationIntegrationId: uuid!) {
  external_entity_sync_statuses(
    where: {_and: [{type: {_eq: "custom"}}, {customCoreDataId: {_eq: $customCoreDataId}}, {_or: [{organisationIntegrationId: {_eq: $organisationIntegrationId}}, {organisationIntegrationId: {_is_null: true}}]}]}
    order_by: [{organisationIntegrationId: desc_nulls_last}, {createdAt: desc}]
    limit: 1
  ) {
    id
    type
    status
    completedAt
    createdAt
    error
    customCoreDataId
  }
}
    `) as unknown as TypedDocumentString<GetLatestExternalEntitySyncStatusForCustomCoreDataIdQuery, GetLatestExternalEntitySyncStatusForCustomCoreDataIdQueryVariables>;
export const GetLatestExternalEntitySyncStatusForTypeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLatestExternalEntitySyncStatusForType($entityType: String!, $organisationIntegrationId: uuid!) {
  external_entity_sync_statuses(
    where: {_and: [{type: {_eq: $entityType}}, {_or: [{organisationIntegrationId: {_eq: $organisationIntegrationId}}, {organisationIntegrationId: {_is_null: true}}]}]}
    order_by: [{organisationIntegrationId: desc_nulls_last}, {createdAt: desc}]
    limit: 1
  ) {
    id
    type
    status
    completedAt
    createdAt
    error
    customCoreDataId
  }
}
    `) as unknown as TypedDocumentString<GetLatestExternalEntitySyncStatusForTypeQuery, GetLatestExternalEntitySyncStatusForTypeQueryVariables>;
export const GetExternalEntitySyncStatusesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetExternalEntitySyncStatuses($organisationIntegrationId: uuid) {
  external_entity_sync_statuses(
    where: {organisationIntegrationId: {_eq: $organisationIntegrationId}}
  ) {
    id
    type
    status
    completedAt
    createdAt
    error
    customCoreData {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetExternalEntitySyncStatusesQuery, GetExternalEntitySyncStatusesQueryVariables>;
export const GetSystemCoreDataCountsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSystemCoreDataCounts {
  addresses: addresses_aggregate(where: {isArchived: {_eq: false}}) {
    aggregate {
      count
    }
  }
  currencies: organisation_fx_rates_aggregate(where: {isArchived: {_eq: false}}) {
    aggregate {
      count
    }
  }
  departments: departments_aggregate(where: {isArchived: {_eq: false}}) {
    aggregate {
      count
    }
  }
  lineItemTypes: line_item_types_aggregate(where: {isArchived: {_eq: false}}) {
    aggregate {
      count
    }
  }
  paymentMethods: payment_methods_aggregate(where: {isArchived: {_eq: false}}) {
    aggregate {
      count
    }
  }
  paymentTerms: payment_terms_aggregate(where: {isArchived: {_eq: false}}) {
    aggregate {
      count
    }
  }
  subsidiaries: subsidiaries_aggregate(where: {isArchived: {_eq: false}}) {
    aggregate {
      count
    }
  }
  suppliers: organisation_suppliers_aggregate(
    where: {_and: [{deleted_at: {_is_null: true}}, {state: {_eq: ACTIVE}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `) as unknown as TypedDocumentString<GetSystemCoreDataCountsQuery, GetSystemCoreDataCountsQueryVariables>;
export const CompleteExternalEntitySyncDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CompleteExternalEntitySync($id: uuid!, $status: String!, $error: jsonb) {
  updatedStatus: update_external_entity_sync_statuses_by_pk(
    pk_columns: {id: $id}
    _set: {completedAt: "now()", status: $status, error: $error}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<CompleteExternalEntitySyncMutation, CompleteExternalEntitySyncMutationVariables>;
export const GetEngagementFormTemplatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetEngagementFormTemplates {
  form_templates(
    where: {type: {_eq: CREATE_ENGAGEMENT}, deletedAt: {_is_null: true}}
  ) {
    id
    config
    title
    type
    description
    internalId
  }
}
    `) as unknown as TypedDocumentString<GetEngagementFormTemplatesQuery, GetEngagementFormTemplatesQueryVariables>;
export const GetFormTemplateConfigsByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTemplateConfigsByIds($formTemplateIds: [uuid!]!) {
  form_templates(where: {id: {_in: $formTemplateIds}}) {
    id
    config
    title
  }
}
    `) as unknown as TypedDocumentString<GetFormTemplateConfigsByIdsQuery, GetFormTemplateConfigsByIdsQueryVariables>;
export const GetFormTemplateOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTemplateOne($id: uuid!) {
  form_templates_by_pk(id: $id) {
    config
    title
    id
    description
  }
}
    `) as unknown as TypedDocumentString<GetFormTemplateOneQuery, GetFormTemplateOneQueryVariables>;
export const GetFormTemplatesByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTemplatesByIds($ids: [uuid!]!) {
  form_templates(where: {id: {_in: $ids}}) {
    ...FormTemplateFragment
  }
}
    fragment FormTemplateFragment on form_templates {
  config
  description
  id
  internalId
  state
  title
  integration
  externalTitle
  type
  updatedAt
  updated_by_user {
    id
    firstName
    lastName
  }
}`) as unknown as TypedDocumentString<GetFormTemplatesByIdsQuery, GetFormTemplatesByIdsQueryVariables>;
export const GetUsersMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUsersMinimal {
  users(where: {isArchived: {_eq: false}}) {
    id
    firstName
    lastName
  }
}
    `) as unknown as TypedDocumentString<GetUsersMinimalQuery, GetUsersMinimalQueryVariables>;
export const GetGroupsMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGroupsMinimal {
  groups(where: {isArchived: {_eq: false}}) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<GetGroupsMinimalQuery, GetGroupsMinimalQueryVariables>;
export const GetWorkflowDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetWorkflow($workflowId: uuid!) {
  workflow: workflows_by_pk(id: $workflowId) {
    id
    type
    state
    routingCanvasModel
    title
    description
    isArchived
    expectedSLA
  }
}
    `) as unknown as TypedDocumentString<GetWorkflowQuery, GetWorkflowQueryVariables>;
export const InsertWorkflowFormTemplatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertWorkflowFormTemplates($objects: [workflow_form_templates_insert_input!]!) {
  insert_workflow_form_templates(objects: $objects) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertWorkflowFormTemplatesMutation, InsertWorkflowFormTemplatesMutationVariables>;
export const ListWorkflowsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListWorkflows($type: [workflow_type_enum!]!, $state: [workflow_state_enum!], $isArchived: Boolean!) {
  workflows(
    where: {_and: [{deletedAt: {_is_null: true}}, {type: {_in: $type}}, {isArchived: {_eq: $isArchived}}, {state: {_in: $state}}]}
    order_by: [{workflow_rank: {rank: asc}}, {createdAt: desc}]
  ) {
    id
    title
    description
    type
    url
    state
    isArchived
    createdAt
    updatedAt
    viewModelUpdatedAt
    canvasModelUpdatedAt
    updated_by_user {
      firstName
      lastName
    }
    workflow_rank {
      rank
    }
  }
}
    `) as unknown as TypedDocumentString<ListWorkflowsQuery, ListWorkflowsQueryVariables>;
export const UpdateWorkflowDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateWorkflow($workflowId: uuid!, $workflow: workflows_set_input!) {
  workflow: update_workflows_by_pk(pk_columns: {id: $workflowId}, _set: $workflow) {
    id
    state
  }
}
    `) as unknown as TypedDocumentString<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;
export const DeleteExternalContactDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteExternalContact($id: uuid!) {
  update_external_contacts_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    ...ExternalContact
  }
}
    fragment ExternalContact on external_contacts {
  id
  title
  supplierId
  firstName
  lastName
  email
  phoneNumber
  createdAt
  isPrimary
  userId
}`) as unknown as TypedDocumentString<DeleteExternalContactMutation, DeleteExternalContactMutationVariables>;
export const DeleteInternalContactDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteInternalContact($id: uuid!) {
  update_internal_contacts_by_pk(
    pk_columns: {id: $id}
    _set: {deleted_at: "now()"}
  ) {
    ...InternalContact
  }
}
    fragment InternalContact on internal_contacts {
  id
  role
  title
  supplierId
  product {
    id
    name: displayName
    logoUrl
  }
  user {
    id
    firstName
    lastName
    email
  }
  engagement {
    id
    name
  }
  createdAt
}`) as unknown as TypedDocumentString<DeleteInternalContactMutation, DeleteInternalContactMutationVariables>;
export const GetAllExternalContactsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllExternalContacts {
  external_contacts(
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: desc}
  ) {
    ...ExternalContact
  }
}
    fragment ExternalContact on external_contacts {
  id
  title
  supplierId
  firstName
  lastName
  email
  phoneNumber
  createdAt
  isPrimary
  userId
}`) as unknown as TypedDocumentString<GetAllExternalContactsQuery, GetAllExternalContactsQueryVariables>;
export const GetSupplierIdOfExternalContactDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierIdOfExternalContact($contactId: uuid!) {
  external_contacts_by_pk(id: $contactId) {
    supplierId
    firstName
    lastName
    email
    phoneNumber
    title
  }
}
    `) as unknown as TypedDocumentString<GetSupplierIdOfExternalContactQuery, GetSupplierIdOfExternalContactQueryVariables>;
export const GetExternalContactsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetExternalContacts($supplierId: uuid!) {
  external_contacts(
    where: {supplierId: {_eq: $supplierId}, deletedAt: {_is_null: true}}
    order_by: {createdAt: desc}
  ) {
    ...ExternalContact
  }
}
    fragment ExternalContact on external_contacts {
  id
  title
  supplierId
  firstName
  lastName
  email
  phoneNumber
  createdAt
  isPrimary
  userId
}`) as unknown as TypedDocumentString<GetExternalContactsQuery, GetExternalContactsQueryVariables>;
export const GetInternalContactsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetInternalContacts($supplierId: uuid!) {
  internal_contacts(
    where: {supplierId: {_eq: $supplierId}, deleted_at: {_is_null: true}}
    order_by: {createdAt: desc}
  ) {
    ...InternalContact
  }
}
    fragment InternalContact on internal_contacts {
  id
  role
  title
  supplierId
  product {
    id
    name: displayName
    logoUrl
  }
  user {
    id
    firstName
    lastName
    email
  }
  engagement {
    id
    name
  }
  createdAt
}`) as unknown as TypedDocumentString<GetInternalContactsQuery, GetInternalContactsQueryVariables>;
export const InsertExternalContactDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertExternalContact($input: external_contacts_insert_input!) {
  insert_external_contacts_one(object: $input) {
    ...ExternalContact
  }
}
    fragment ExternalContact on external_contacts {
  id
  title
  supplierId
  firstName
  lastName
  email
  phoneNumber
  createdAt
  isPrimary
  userId
}`) as unknown as TypedDocumentString<InsertExternalContactMutation, InsertExternalContactMutationVariables>;
export const InsertInternalContactDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertInternalContact($input: internal_contacts_insert_input!) {
  insert_internal_contacts_one(object: $input) {
    ...InternalContact
  }
}
    fragment InternalContact on internal_contacts {
  id
  role
  title
  supplierId
  product {
    id
    name: displayName
    logoUrl
  }
  user {
    id
    firstName
    lastName
    email
  }
  engagement {
    id
    name
  }
  createdAt
}`) as unknown as TypedDocumentString<InsertInternalContactMutation, InsertInternalContactMutationVariables>;
export const SetPrimaryExternalContactDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SetPrimaryExternalContact($id: uuid!, $supplierId: uuid!) {
  update_external_contacts(
    where: {supplierId: {_eq: $supplierId}}
    _set: {isPrimary: false}
  ) {
    returning {
      ...ExternalContact
    }
  }
  update_external_contacts_by_pk(pk_columns: {id: $id}, _set: {isPrimary: true}) {
    ...ExternalContact
  }
}
    fragment ExternalContact on external_contacts {
  id
  title
  supplierId
  firstName
  lastName
  email
  phoneNumber
  createdAt
  isPrimary
  userId
}`) as unknown as TypedDocumentString<SetPrimaryExternalContactMutation, SetPrimaryExternalContactMutationVariables>;
export const UpdateAgreementLinkedInternalContactDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateAgreementLinkedInternalContact($supplierId: uuid!, $agreementId: uuid!, $input: internal_contacts_insert_input!) {
  update_internal_contacts(
    where: {supplierId: {_eq: $supplierId}, agreementId: {_eq: $agreementId}}
    _set: {deleted_at: "now()"}
  ) {
    affected_rows
  }
  internalContact: insert_internal_contacts_one(object: $input) {
    ...InternalContact
  }
}
    fragment InternalContact on internal_contacts {
  id
  role
  title
  supplierId
  product {
    id
    name: displayName
    logoUrl
  }
  user {
    id
    firstName
    lastName
    email
  }
  engagement {
    id
    name
  }
  createdAt
}`) as unknown as TypedDocumentString<UpdateAgreementLinkedInternalContactMutation, UpdateAgreementLinkedInternalContactMutationVariables>;
export const UpdateExternalContactDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateExternalContact($contactId: uuid!, $input: external_contacts_set_input!) {
  update_external_contacts_by_pk(pk_columns: {id: $contactId}, _set: $input) {
    ...ExternalContact
  }
}
    fragment ExternalContact on external_contacts {
  id
  title
  supplierId
  firstName
  lastName
  email
  phoneNumber
  createdAt
  isPrimary
  userId
}`) as unknown as TypedDocumentString<UpdateExternalContactMutation, UpdateExternalContactMutationVariables>;
export const UpdateInternalContactDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateInternalContact($contactId: uuid!, $input: internal_contacts_set_input!) {
  update_internal_contacts_by_pk(pk_columns: {id: $contactId}, _set: $input) {
    ...InternalContact
  }
}
    fragment InternalContact on internal_contacts {
  id
  role
  title
  supplierId
  product {
    id
    name: displayName
    logoUrl
  }
  user {
    id
    firstName
    lastName
    email
  }
  engagement {
    id
    name
  }
  createdAt
}`) as unknown as TypedDocumentString<UpdateInternalContactMutation, UpdateInternalContactMutationVariables>;
export const GetCoreDataItemsBatchDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCoreDataItemsBatch($addressIds: [uuid!]!, $currencyIds: [uuid!]!, $departmentIds: [uuid!]!, $lineItemTypeIds: [uuid!]!, $paymentMethodIds: [uuid!]!, $paymentTermIds: [uuid!]!, $subsidiaryIds: [uuid!]!, $customIds: _uuid) {
  addresses(where: {id: {_in: $addressIds}}) {
    id
    name
    addressLine1
    isArchived
  }
  organisation_fx_rates(where: {id: {_in: $currencyIds}}) {
    id
    code
    isArchived
  }
  departments(where: {id: {_in: $departmentIds}}) {
    id
    name
    isArchived
  }
  line_item_types(where: {id: {_in: $lineItemTypeIds}}) {
    id
    name
    isArchived
  }
  payment_methods(where: {id: {_in: $paymentMethodIds}}) {
    id
    name
    isArchived
  }
  payment_terms(where: {id: {_in: $paymentTermIds}}) {
    id
    name
    isArchived
  }
  subsidiaries(where: {id: {_in: $subsidiaryIds}}) {
    id
    name
    isArchived
  }
  get_all_nodes_until_root_for_ids(args: {ids: $customIds}) {
    id
    value
    isArchived
    parentId
  }
}
    `) as unknown as TypedDocumentString<GetCoreDataItemsBatchQuery, GetCoreDataItemsBatchQueryVariables>;
export const GetCoreDataOrganisationIntegrationWithTypeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCoreDataOrganisationIntegrationWithType($coreDataType: String!) {
  core_data_organisation_integrations(where: {coreDataType: {_eq: $coreDataType}}) {
    id
    organisationIntegration {
      id
      integration
    }
  }
}
    `) as unknown as TypedDocumentString<GetCoreDataOrganisationIntegrationWithTypeQuery, GetCoreDataOrganisationIntegrationWithTypeQueryVariables>;
export const GetCustomCoreDataOptionsByFilterDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataOptionsByFilter($filter: custom_core_data_options_bool_exp!) {
  custom_core_data_options(where: $filter) {
    ...CustomCoreDataOption
  }
}
    fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetCustomCoreDataOptionsByFilterQuery, GetCustomCoreDataOptionsByFilterQueryVariables>;
export const GetDependenciesForCoreDataIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetDependenciesForCoreDataId($offset: Int!, $limit: Int!, $order_by: [core_data_dependencies_order_by!], $where: core_data_dependencies_bool_exp) {
  core_data_dependencies(
    where: $where
    offset: $offset
    limit: $limit
    order_by: $order_by
  ) {
    ...CoreDataDependencies
  }
  core_data_dependencies_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}`) as unknown as TypedDocumentString<GetDependenciesForCoreDataIdQuery, GetDependenciesForCoreDataIdQueryVariables>;
export const GetOrgCoreDataDependenciesForSystemCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgCoreDataDependenciesForSystemCoreData($type: String!) {
  organisation_core_data_dependencies(where: {coreDataType: {_eq: $type}}) {
    id
    dependencyCoreDataType
    dependencyCustomCoreData {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrgCoreDataDependenciesForSystemCoreDataQuery, GetOrgCoreDataDependenciesForSystemCoreDataQueryVariables>;
export const GetOrgCoreDataDependenciesForCustomCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgCoreDataDependenciesForCustomCoreData($customCoreDataId: uuid!) {
  organisation_core_data_dependencies(
    where: {coreDataType: {_eq: "custom"}, customCoreDataId: {_eq: $customCoreDataId}}
  ) {
    id
    dependencyCoreDataType
    dependencyCustomCoreData {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrgCoreDataDependenciesForCustomCoreDataQuery, GetOrgCoreDataDependenciesForCustomCoreDataQueryVariables>;
export const UpsertCurrenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertCurrencies($objects: [organisation_fx_rates_insert_input!]!) {
  insertedCurrencies: insert_organisation_fx_rates(
    objects: $objects
    on_conflict: {constraint: organisation_currencies_pkey, update_columns: [name, remoteId]}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UpsertCurrenciesMutation, UpsertCurrenciesMutationVariables>;
export const UpsertDepartmentsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertDepartments($objects: [departments_insert_input!]!) {
  insert_departments(
    objects: $objects
    on_conflict: {constraint: departments_pkey, update_columns: [name, remoteId]}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UpsertDepartmentsMutation, UpsertDepartmentsMutationVariables>;
export const UpsertLineItemTypesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertLineItemTypes($objects: [line_item_types_insert_input!]!) {
  insert_line_item_types(
    objects: $objects
    on_conflict: {constraint: line_item_types_pkey, update_columns: [name, remoteId]}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UpsertLineItemTypesMutation, UpsertLineItemTypesMutationVariables>;
export const UpsertPaymentMethodsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertPaymentMethods($objects: [payment_methods_insert_input!]!) {
  insert_payment_methods(
    objects: $objects
    on_conflict: {constraint: payment_methods_pkey, update_columns: [name, remoteId]}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UpsertPaymentMethodsMutation, UpsertPaymentMethodsMutationVariables>;
export const UpsertPaymentTermsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertPaymentTerms($objects: [payment_terms_insert_input!]!) {
  insert_payment_terms(
    objects: $objects
    on_conflict: {constraint: payment_terms_pkey, update_columns: [name, remoteId]}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UpsertPaymentTermsMutation, UpsertPaymentTermsMutationVariables>;
export const UpsertSubsidiariesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertSubsidiaries($objects: [subsidiaries_insert_input!]!) {
  insert_subsidiaries(
    objects: $objects
    on_conflict: {constraint: subsidiaries_pkey, update_columns: [name, remoteId]}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UpsertSubsidiariesMutation, UpsertSubsidiariesMutationVariables>;
export const GetAllCustomCoreDataOptionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllCustomCoreDataOptions($query: custom_core_data_options_bool_exp) {
  custom_core_data_options(where: $query) {
    ...CustomCoreDataOption
  }
}
    fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetAllCustomCoreDataOptionsQuery, GetAllCustomCoreDataOptionsQueryVariables>;
export const GetCustomCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreData {
  custom_core_data(
    where: {archivedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CustomCoreData
  }
}
    fragment CustomCoreData on custom_core_data {
  id
  name
  organisationId
  pathLevels
  archivedAt
  organisationIntegration {
    id
    integration
  }
  options: custom_core_data_options(where: {isArchived: {_eq: false}}) {
    ...CustomCoreDataOption
  }
  numOptions: custom_core_data_options_aggregate(
    where: {isArchived: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetCustomCoreDataQuery, GetCustomCoreDataQueryVariables>;
export const GetCustomCoreDataWithDependenciesMetadataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataWithDependenciesMetadata($depsLimit: Int!) {
  custom_core_data(
    where: {archivedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CustomCoreDataWithDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreData on custom_core_data {
  id
  name
  organisationId
  pathLevels
  archivedAt
  organisationIntegration {
    id
    integration
  }
  options: custom_core_data_options(where: {isArchived: {_eq: false}}) {
    ...CustomCoreDataOption
  }
  numOptions: custom_core_data_options_aggregate(
    where: {isArchived: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}
fragment CustomCoreDataOptionWithDependenciesMetadata on custom_core_data_options {
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
fragment CustomCoreDataWithDependenciesMetadata on custom_core_data {
  ...CustomCoreData
  options: custom_core_data_options(where: {isArchived: {_eq: false}}) {
    ...CustomCoreDataOptionWithDependenciesMetadata
  }
}`) as unknown as TypedDocumentString<GetCustomCoreDataWithDependenciesMetadataQuery, GetCustomCoreDataWithDependenciesMetadataQueryVariables>;
export const GetCustomCoreDataWithDependenciesMetadataIncludingArchivedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataWithDependenciesMetadataIncludingArchived($depsLimit: Int!) {
  custom_core_data(order_by: {createdAt: asc}) {
    ...CustomCoreDataWithDependenciesMetadataIncludingArchived
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}
fragment CustomCoreDataOptionWithDependenciesMetadata on custom_core_data_options {
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
fragment CustomCoreDataWithDependenciesMetadataIncludingArchived on custom_core_data {
  id
  name
  organisationId
  pathLevels
  archivedAt
  organisationIntegration {
    id
    integration
  }
  options: custom_core_data_options {
    ...CustomCoreDataOption
    ...CustomCoreDataOptionWithDependenciesMetadata
  }
  numOptions: custom_core_data_options_aggregate {
    aggregate {
      count
    }
  }
}`) as unknown as TypedDocumentString<GetCustomCoreDataWithDependenciesMetadataIncludingArchivedQuery, GetCustomCoreDataWithDependenciesMetadataIncludingArchivedQueryVariables>;
export const GetCustomCoreDataLabelsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataLabels {
  multiLevel: custom_core_data(
    where: {archivedAt: {_is_null: true}, pathLevels: {_is_null: false}}
    order_by: {createdAt: desc}
  ) {
    ...LabelsPayload
  }
  singleLevel: custom_core_data(
    where: {archivedAt: {_is_null: true}, pathLevels: {_is_null: true}}
    order_by: {createdAt: desc}
  ) {
    ...LabelsPayload
  }
}
    fragment LabelsPayload on custom_core_data {
  customCoreDataId: id
  label: name
  pathLevels
  archivedAt
  organisationIntegration {
    id
    integration
  }
}`) as unknown as TypedDocumentString<GetCustomCoreDataLabelsQuery, GetCustomCoreDataLabelsQueryVariables>;
export const GetCustomCoreDataLabelsIncludingArchivedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataLabelsIncludingArchived {
  multiLevel: custom_core_data(
    where: {pathLevels: {_is_null: false}}
    order_by: {createdAt: desc}
  ) {
    ...LabelsPayload
  }
  singleLevel: custom_core_data(
    where: {pathLevels: {_is_null: true}}
    order_by: {createdAt: desc}
  ) {
    ...LabelsPayload
  }
}
    fragment LabelsPayload on custom_core_data {
  customCoreDataId: id
  label: name
  pathLevels
  archivedAt
  organisationIntegration {
    id
    integration
  }
}`) as unknown as TypedDocumentString<GetCustomCoreDataLabelsIncludingArchivedQuery, GetCustomCoreDataLabelsIncludingArchivedQueryVariables>;
export const GetCustomFieldsByCustomCoreDataIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFieldsByCustomCoreDataId($customCoreDataId: uuid!) {
  customFields: custom_fields(where: {customCoreDataId: {_eq: $customCoreDataId}}) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetCustomFieldsByCustomCoreDataIdQuery, GetCustomFieldsByCustomCoreDataIdQueryVariables>;
export const GetCustomCoreDataOptionsWithDependenciesMetadataByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataOptionsWithDependenciesMetadataByIds($customCoreDataOptionIds: [uuid!]!, $depsLimit: Int!) {
  custom_core_data_options(
    where: {id: {_in: $customCoreDataOptionIds}, isArchived: {_eq: false}}
  ) {
    ...CustomCoreDataOptionWithDependenciesMetadata
    ...CustomCoreDataOption
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}
fragment CustomCoreDataOptionWithDependenciesMetadata on custom_core_data_options {
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}`) as unknown as TypedDocumentString<GetCustomCoreDataOptionsWithDependenciesMetadataByIdsQuery, GetCustomCoreDataOptionsWithDependenciesMetadataByIdsQueryVariables>;
export const PaginateCustomCoreDataOptionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query PaginateCustomCoreDataOptions($customCoreDataId: uuid!, $dependencyCoreDataId: uuid, $dependencySupplierProfileId: uuid, $prevCursor: ltree = null, $nextCursor: ltree = null, $limit: Int = 10, $depth: Int = null, $sortLevel: Int = null, $sortDirection: String = "ASC", $conjunction: String = "AND", $conditions: jsonb = [], $depsLimit: Int = 0, $includeArchived: Boolean = false, $search: String = null, $includeCount: Boolean! = true) {
  paginate_custom_core_data_options(
    args: {p_custom_core_data_id: $customCoreDataId, p_prev_cursor: $prevCursor, p_next_cursor: $nextCursor, p_limit: $limit, p_depth: $depth, p_sort_level: $sortLevel, p_sort_direction: $sortDirection, p_conjunction: $conjunction, p_conditions: $conditions, p_dependency_core_data_id: $dependencyCoreDataId, p_dependency_supplier_profile_id: $dependencySupplierProfileId, p_search: $search, p_include_archived: $includeArchived}
  ) {
    path
    ...CustomCoreDataOptionWithDependenciesMetadata
    ...CustomCoreDataOption
  }
  get_custom_core_data_counts(
    args: {p_custom_core_data_id: $customCoreDataId, p_depth: $depth, p_conditions: $conditions, p_conjunction: $conjunction, p_dependency_core_data_id: $dependencyCoreDataId, p_dependency_supplier_profile_id: $dependencySupplierProfileId, p_search: $search, p_include_archived: $includeArchived}
  ) @include(if: $includeCount) {
    filtered_count
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}
fragment CustomCoreDataOptionWithDependenciesMetadata on custom_core_data_options {
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}`) as unknown as TypedDocumentString<PaginateCustomCoreDataOptionsQuery, PaginateCustomCoreDataOptionsQueryVariables>;
export const ArchiveCustomCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ArchiveCustomCoreData($id: uuid!) {
  update_custom_core_data(where: {id: {_eq: $id}}, _set: {archivedAt: "now()"}) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<ArchiveCustomCoreDataMutation, ArchiveCustomCoreDataMutationVariables>;
export const InsertCustomCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertCustomCoreData($input: custom_core_data_insert_input!) {
  insert_custom_core_data_one(object: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertCustomCoreDataMutation, InsertCustomCoreDataMutationVariables>;
export const InsertCustomCoreDataOptionDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertCustomCoreDataOption($input: custom_core_data_options_insert_input!) {
  insert_custom_core_data_options_one(
    object: $input
    on_conflict: {constraint: custom_core_data_options_parent_id_custom_field_id_value_key, update_columns: []}
  ) {
    id
    coreData {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertCustomCoreDataOptionMutation, InsertCustomCoreDataOptionMutationVariables>;
export const InsertCustomCoreDataOptionsBulkDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertCustomCoreDataOptionsBulk($input: [custom_core_data_options_insert_input!]!) {
  insert_custom_core_data_options(
    objects: $input
    on_conflict: {constraint: custom_core_data_options_parent_id_custom_field_id_value_key, update_columns: []}
  ) {
    returning {
      id
      value
    }
  }
}
    `) as unknown as TypedDocumentString<InsertCustomCoreDataOptionsBulkMutation, InsertCustomCoreDataOptionsBulkMutationVariables>;
export const UpdateCustomCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateCustomCoreData($id: uuid!, $setInput: custom_core_data_set_input!) {
  update_custom_core_data_by_pk(pk_columns: {id: $id}, _set: $setInput) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateCustomCoreDataMutation, UpdateCustomCoreDataMutationVariables>;
export const UpdateCustomCoreDataOptionDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateCustomCoreDataOption($id: uuid!, $input: custom_core_data_options_set_input!) {
  update_custom_core_data_options_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
    coreData {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateCustomCoreDataOptionMutation, UpdateCustomCoreDataOptionMutationVariables>;
export const UpsertCustomCoreDataOptionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertCustomCoreDataOptions($objects: [custom_core_data_options_insert_input!]!) {
  insert_custom_core_data_options(
    objects: $objects
    on_conflict: {constraint: custom_core_data_options_pkey, update_columns: [value, remoteId, isArchived, archivedBy]}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UpsertCustomCoreDataOptionsMutation, UpsertCustomCoreDataOptionsMutationVariables>;
export const GetArchivedCustomCoreDataOptionsByRemoteIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetArchivedCustomCoreDataOptionsByRemoteIds($customCoreDataId: uuid!, $remoteIds: [String!]!) {
  customCoreDataOptions: custom_core_data_options(
    where: {customCoreDataId: {_eq: $customCoreDataId}, remoteId: {_in: $remoteIds}, isArchived: {_eq: true}}
  ) {
    id
    remoteId
    isArchived
  }
}
    `) as unknown as TypedDocumentString<GetArchivedCustomCoreDataOptionsByRemoteIdsQuery, GetArchivedCustomCoreDataOptionsByRemoteIdsQueryVariables>;
export const GetOrganisationSupplierProfileBySupplierAndSubsidiaryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationSupplierProfileBySupplierAndSubsidiary($orgSupplierId: uuid!, $subsidiaryId: uuid!) {
  organisation_supplier_profiles(
    where: {organisationSupplierId: {_eq: $orgSupplierId}, subsidiaryId: {_eq: $subsidiaryId}, deletedAt: {_is_null: true}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationSupplierProfileBySupplierAndSubsidiaryQuery, GetOrganisationSupplierProfileBySupplierAndSubsidiaryQueryVariables>;
export const GetAllOrganisationIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllOrganisationIds {
  organisations {
    id
  }
}
    `) as unknown as TypedDocumentString<GetAllOrganisationIdsQuery, GetAllOrganisationIdsQueryVariables>;
export const GetCoreDataDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCoreDataDependencies($where: core_data_dependencies_bool_exp) {
  core_data_dependencies(where: $where, order_by: {createdAt: asc}) {
    ...CoreDataDependencies
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}`) as unknown as TypedDocumentString<GetCoreDataDependenciesQuery, GetCoreDataDependenciesQueryVariables>;
export const GetCoreDataForItemIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCoreDataForItemIds($filter: core_data_bool_exp!) {
  coreDatum: core_data(where: $filter) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetCoreDataForItemIdsQuery, GetCoreDataForItemIdsQueryVariables>;
export const GetCustomCoreDataIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataIds {
  custom_core_data(where: {archivedAt: {_is_null: true}}) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetCustomCoreDataIdsQuery, GetCustomCoreDataIdsQueryVariables>;
export const InsertExternalEntitySyncStatusDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertExternalEntitySyncStatus($input: external_entity_sync_statuses_insert_input!) {
  syncStatus: insert_external_entity_sync_statuses_one(object: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertExternalEntitySyncStatusMutation, InsertExternalEntitySyncStatusMutationVariables>;
export const InsertExternalEntitySyncStatusesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertExternalEntitySyncStatuses($input: [external_entity_sync_statuses_insert_input!]!) {
  syncStatuses: insert_external_entity_sync_statuses(objects: $input) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertExternalEntitySyncStatusesMutation, InsertExternalEntitySyncStatusesMutationVariables>;
export const UpsertCoreDataDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertCoreDataDependencies($coreDataId: uuid!, $dependenciesToUpsert: [core_data_dependencies_insert_input!]!, $dependencyCoreDataIdsToKeep: [uuid!]!) {
  upsertedDependencies: insert_core_data_dependencies(
    objects: $dependenciesToUpsert
    on_conflict: {constraint: core_data_dependencies_core_data_id_dependency_core_data_id_key, update_columns: [deletedAt], where: {deletedAt: {_is_null: false}}}
  ) {
    returning {
      id
    }
  }
  deletedDependencies: update_core_data_dependencies(
    where: {coreDataId: {_eq: $coreDataId}, deletedAt: {_is_null: true}, _or: [{isAll: {_eq: true}}, {_and: [{dependencyCoreDataId: {_is_null: false}}, {dependencyCoreDataId: {_nin: $dependencyCoreDataIdsToKeep}}]}]}
    _set: {deletedAt: "now()"}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpsertCoreDataDependenciesMutation, UpsertCoreDataDependenciesMutationVariables>;
export const UpsertCoreDataDependencyOnAllDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertCoreDataDependencyOnAll($coreDataId: uuid!, $coreDataType: String!, $dependencyCoreDataType: String!) {
  deletedDependencies: update_core_data_dependencies(
    where: {coreDataId: {_eq: $coreDataId}, deletedAt: {_is_null: true}}
    _set: {deletedAt: "now()"}
  ) {
    returning {
      id
    }
  }
  upsertedDependency: insert_core_data_dependencies_one(
    object: {coreDataId: $coreDataId, coreDataType: $coreDataType, dependencyCoreDataType: $dependencyCoreDataType, isAll: true, deletedAt: null}
    on_conflict: {constraint: core_data_dependencies_core_data_id_dependency_core_data_id_key, update_columns: [deletedAt], where: {deletedAt: {_is_null: false}}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpsertCoreDataDependencyOnAllMutation, UpsertCoreDataDependencyOnAllMutationVariables>;
export const UpsertCoreDataSupplierProfileDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertCoreDataSupplierProfileDependencies($coreDataId: uuid!, $dependenciesToUpsert: [core_data_dependencies_insert_input!]!, $dependencySupplierProfileIdsToKeep: [uuid!]!) {
  upsertedDependencies: insert_core_data_dependencies(
    objects: $dependenciesToUpsert
    on_conflict: {constraint: core_data_dependencies_core_data_id_dependency_supplier_profile, update_columns: [deletedAt]}
  ) {
    returning {
      id
    }
  }
  deletedDependencies: update_core_data_dependencies(
    where: {coreDataId: {_eq: $coreDataId}, _or: [{isAll: {_eq: true}}, {_and: [{dependencySupplierProfileId: {_is_null: false}}, {dependencySupplierProfileId: {_nin: $dependencySupplierProfileIdsToKeep}}]}]}
    _set: {deletedAt: "now()"}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpsertCoreDataSupplierProfileDependenciesMutation, UpsertCoreDataSupplierProfileDependenciesMutationVariables>;
export const UpsertCoreDataSupplierProfileDependencyOnAllDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertCoreDataSupplierProfileDependencyOnAll($coreDataId: uuid!, $coreDataType: String!, $dependencyCoreDataType: String!, $organisationCoreDataDependencyId: uuid!) {
  deletedDependencies: update_core_data_dependencies(
    where: {coreDataId: {_eq: $coreDataId}, dependencyCoreDataType: {_eq: $dependencyCoreDataType}, deletedAt: {_is_null: true}}
    _set: {deletedAt: "now()"}
  ) {
    returning {
      id
    }
  }
  upsertedDependency: insert_core_data_dependencies_one(
    object: {coreDataId: $coreDataId, coreDataType: $coreDataType, dependencyCoreDataType: $dependencyCoreDataType, organisationCoreDataDependencyId: $organisationCoreDataDependencyId, isAll: true, deletedAt: null}
    on_conflict: {constraint: core_data_dependencies_core_data_id_dependency_supplier_profile, update_columns: [deletedAt], where: {deletedAt: {_is_null: false}}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpsertCoreDataSupplierProfileDependencyOnAllMutation, UpsertCoreDataSupplierProfileDependencyOnAllMutationVariables>;
export const GetMultiLevelCustomCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetMultiLevelCustomCoreData {
  custom_core_data(where: {pathLevels: {_is_null: false}}) {
    id
    name
    pathLevels
    options: custom_core_data_options(
      where: {isArchived: {_eq: false}}
      order_by: {createdAt: desc}
    ) {
      id
      value
      isArchived
      parentId
      isTerminal
      remoteId
    }
  }
}
    `) as unknown as TypedDocumentString<GetMultiLevelCustomCoreDataQuery, GetMultiLevelCustomCoreDataQueryVariables>;
export const GetMultiLevelCustomCoreDataWithCacheDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetMultiLevelCustomCoreDataWithCache @cached(ttl: 30) {
  custom_core_data(where: {pathLevels: {_is_null: false}}) {
    id
    name
    pathLevels
    options: custom_core_data_options(
      where: {isArchived: {_eq: false}}
      order_by: {createdAt: desc}
    ) {
      id
      value
      isArchived
      parentId
      isTerminal
    }
  }
}
    `) as unknown as TypedDocumentString<GetMultiLevelCustomCoreDataWithCacheQuery, GetMultiLevelCustomCoreDataWithCacheQueryVariables>;
export const ArchiveAddressesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ArchiveAddresses($ids: [uuid!]!, $archivedBy: String!) {
  update_addresses(
    where: {id: {_in: $ids}}
    _set: {isArchived: true, archivedBy: $archivedBy}
  ) {
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ArchiveAddressesMutation, ArchiveAddressesMutationVariables>;
export const GetAddressByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAddressById($id: uuid!) {
  addresses_by_pk(id: $id) {
    ...Address
  }
}
    fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetAddressByIdQuery, GetAddressByIdQueryVariables>;
export const GetAddressWithDependenciesByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAddressWithDependenciesById($id: uuid!) {
  addresses_by_pk(id: $id) {
    ...Address
    coreData {
      id
      coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
        ...CoreDataDependencies
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetAddressWithDependenciesByIdQuery, GetAddressWithDependenciesByIdQueryVariables>;
export const GetAddressesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAddresses($query: addresses_bool_exp) {
  addresses(where: $query, order_by: {name: asc}) {
    ...Address
  }
}
    fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetAddressesQuery, GetAddressesQueryVariables>;
export const GetAddressesWithDependenciesMetadataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAddressesWithDependenciesMetadata($query: addresses_bool_exp, $depsLimit: Int!) {
  addresses(where: $query, order_by: {name: asc}) {
    ...AddressWithDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment AddressWithDependenciesMetadata on addresses {
  ...Address
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`) as unknown as TypedDocumentString<GetAddressesWithDependenciesMetadataQuery, GetAddressesWithDependenciesMetadataQueryVariables>;
export const GetAddressesPaginatedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAddressesPaginated($limit: Int!, $offset: Int!, $orderBy: [addresses_order_by!]!, $query: addresses_bool_exp) {
  addresses(limit: $limit, offset: $offset, order_by: $orderBy, where: $query) {
    ...Address
  }
  addresses_aggregate(where: $query) {
    aggregate {
      count
    }
  }
}
    fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetAddressesPaginatedQuery, GetAddressesPaginatedQueryVariables>;
export const GetAddressesWithDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAddressesWithDependencies($query: addresses_bool_exp) {
  addresses(where: $query, order_by: {name: asc}) {
    ...Address
    coreData {
      id
      coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
        ...CoreDataDependencies
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetAddressesWithDependenciesQuery, GetAddressesWithDependenciesQueryVariables>;
export const InsertAddressDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertAddress($object: addresses_insert_input!) {
  insert_addresses_one(object: $object) {
    ...Address
  }
}
    fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<InsertAddressMutation, InsertAddressMutationVariables>;
export const UnarchiveAddressesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnarchiveAddresses($ids: [uuid!]!) {
  update_addresses(
    where: {id: {_in: $ids}}
    _set: {isArchived: false, archivedBy: null}
  ) {
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UnarchiveAddressesMutation, UnarchiveAddressesMutationVariables>;
export const UpdateAddressDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateAddress($id: uuid!, $object: addresses_set_input!) {
  update_addresses_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...Address
  }
}
    fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<UpdateAddressMutation, UpdateAddressMutationVariables>;
export const ArchiveOrganisationFxRatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ArchiveOrganisationFxRates($ids: [uuid!]!, $archivedBy: String!) {
  update_organisation_fx_rates(
    where: {id: {_in: $ids}}
    _set: {isArchived: true, archivedBy: $archivedBy}
  ) {
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ArchiveOrganisationFxRatesMutation, ArchiveOrganisationFxRatesMutationVariables>;
export const GetOrganisationCurrenciesPaginatedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationCurrenciesPaginated($limit: Int!, $offset: Int!, $orderBy: [organisation_fx_rates_order_by!]!, $query: organisation_fx_rates_bool_exp) {
  organisation_fx_rates(
    limit: $limit
    offset: $offset
    order_by: $orderBy
    where: $query
  ) {
    ...OrganisationFxRate
  }
  organisation_fx_rates_aggregate(where: $query) {
    aggregate {
      count
    }
  }
}
    fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<GetOrganisationCurrenciesPaginatedQuery, GetOrganisationCurrenciesPaginatedQueryVariables>;
export const GetOrganisationCurrencyByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationCurrencyById($id: uuid!) {
  organisation_fx_rates_by_pk(id: $id) {
    ...OrganisationFxRate
  }
}
    fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<GetOrganisationCurrencyByIdQuery, GetOrganisationCurrencyByIdQueryVariables>;
export const GetOrganisationCurrencyWithDependenciesByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationCurrencyWithDependenciesById($id: uuid!) {
  organisation_fx_rates_by_pk(id: $id) {
    ...OrganisationFxRate
    coreData {
      id
      coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
        ...CoreDataDependencies
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<GetOrganisationCurrencyWithDependenciesByIdQuery, GetOrganisationCurrencyWithDependenciesByIdQueryVariables>;
export const GetOrganisationFxRatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationFxRates($query: organisation_fx_rates_bool_exp) {
  organisation_fx_rates(where: $query) {
    ...OrganisationFxRate
  }
}
    fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<GetOrganisationFxRatesQuery, GetOrganisationFxRatesQueryVariables>;
export const InsertOrganisationFxRateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertOrganisationFxRate($object: organisation_fx_rates_insert_input!) {
  insert_organisation_fx_rates_one(object: $object) {
    ...OrganisationFxRate
  }
}
    fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<InsertOrganisationFxRateMutation, InsertOrganisationFxRateMutationVariables>;
export const UnarchiveOrganisationFxRatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnarchiveOrganisationFxRates($ids: [uuid!]!) {
  update_organisation_fx_rates(
    where: {id: {_in: $ids}}
    _set: {isArchived: false, archivedBy: null}
  ) {
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UnarchiveOrganisationFxRatesMutation, UnarchiveOrganisationFxRatesMutationVariables>;
export const UpdateOrganisationFxRateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateOrganisationFxRate($id: uuid!, $object: organisation_fx_rates_set_input!) {
  update_organisation_fx_rates_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...OrganisationFxRate
  }
}
    fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<UpdateOrganisationFxRateMutation, UpdateOrganisationFxRateMutationVariables>;
export const ArchiveCustomCoreDataOptionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ArchiveCustomCoreDataOptions($ids: [uuid!]!, $archivedBy: String) {
  update_custom_core_data_options(
    where: {id: {_in: $ids}}
    _set: {isArchived: true, archivedBy: $archivedBy}
  ) {
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ArchiveCustomCoreDataOptionsMutation, ArchiveCustomCoreDataOptionsMutationVariables>;
export const ArchiveCustomCoreDataOptionsForCustomCoreDataIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ArchiveCustomCoreDataOptionsForCustomCoreDataId($customCoreDataId: uuid!, $archivedBy: String) {
  update_custom_core_data_options(
    where: {customCoreDataId: {_eq: $customCoreDataId}}
    _set: {isArchived: true, archivedBy: $archivedBy}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<ArchiveCustomCoreDataOptionsForCustomCoreDataIdMutation, ArchiveCustomCoreDataOptionsForCustomCoreDataIdMutationVariables>;
export const GetCustomCoreDataOptionByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataOptionById($id: uuid!) {
  custom_core_data_options_by_pk(id: $id) {
    ...CustomCoreDataOption
  }
}
    fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetCustomCoreDataOptionByIdQuery, GetCustomCoreDataOptionByIdQueryVariables>;
export const GetCustomCoreDataOptionWithDependenciesByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataOptionWithDependenciesById($id: uuid!) {
  custom_core_data_options_by_pk(id: $id) {
    ...CustomCoreDataOptionWithDependencies
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}
fragment CustomCoreDataOptionWithDependencies on custom_core_data_options {
  ...CustomCoreDataOption
  coreData {
    id
    coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
      ...CoreDataDependencies
    }
  }
}`) as unknown as TypedDocumentString<GetCustomCoreDataOptionWithDependenciesByIdQuery, GetCustomCoreDataOptionWithDependenciesByIdQueryVariables>;
export const GetCustomCoreDataOptionsPaginatedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataOptionsPaginated($limit: Int!, $offset: Int!, $orderBy: [custom_core_data_options_order_by!]!, $query: custom_core_data_options_bool_exp) {
  custom_core_data_options(
    limit: $limit
    offset: $offset
    order_by: $orderBy
    where: $query
  ) {
    ...CustomCoreDataOption
  }
  custom_core_data_options_aggregate(where: $query) {
    aggregate {
      count
    }
  }
}
    fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetCustomCoreDataOptionsPaginatedQuery, GetCustomCoreDataOptionsPaginatedQueryVariables>;
export const ArchiveDepartmentsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ArchiveDepartments($ids: [uuid!]!, $archivedBy: String!) {
  update_departments(
    where: {id: {_in: $ids}}
    _set: {isArchived: true, archivedBy: $archivedBy}
  ) {
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ArchiveDepartmentsMutation, ArchiveDepartmentsMutationVariables>;
export const GetDepartmentByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetDepartmentById($id: uuid!) {
  departments_by_pk(id: $id) {
    ...Department
  }
}
    fragment Department on departments {
  createdAt
  isArchived
  archivedBy
  id
  name
  organisationId
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<GetDepartmentByIdQuery, GetDepartmentByIdQueryVariables>;
export const GetDepartmentWithDependenciesByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetDepartmentWithDependenciesById($id: uuid!) {
  departments_by_pk(id: $id) {
    ...Department
    coreData {
      id
      coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
        ...CoreDataDependencies
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment Department on departments {
  createdAt
  isArchived
  archivedBy
  id
  name
  organisationId
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<GetDepartmentWithDependenciesByIdQuery, GetDepartmentWithDependenciesByIdQueryVariables>;
export const GetDepartmentsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetDepartments($query: departments_bool_exp) {
  departments(where: $query, order_by: {name: asc}) {
    ...Department
  }
}
    fragment Department on departments {
  createdAt
  isArchived
  archivedBy
  id
  name
  organisationId
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<GetDepartmentsQuery, GetDepartmentsQueryVariables>;
export const GetDepartmentsWithDependenciesMetadataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetDepartmentsWithDependenciesMetadata($query: departments_bool_exp, $depsLimit: Int!) {
  departments(where: $query, order_by: {name: asc}) {
    ...DepartmentWithDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment Department on departments {
  createdAt
  isArchived
  archivedBy
  id
  name
  organisationId
  remoteId
  updatedAt
  coreDataId
}
fragment DepartmentWithDependenciesMetadata on departments {
  ...Department
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`) as unknown as TypedDocumentString<GetDepartmentsWithDependenciesMetadataQuery, GetDepartmentsWithDependenciesMetadataQueryVariables>;
export const GetDepartmentsPaginatedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetDepartmentsPaginated($limit: Int!, $offset: Int!, $orderBy: [departments_order_by!]!, $query: departments_bool_exp) {
  departments(limit: $limit, offset: $offset, order_by: $orderBy, where: $query) {
    ...Department
  }
  departments_aggregate(where: $query) {
    aggregate {
      count
    }
  }
}
    fragment Department on departments {
  createdAt
  isArchived
  archivedBy
  id
  name
  organisationId
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<GetDepartmentsPaginatedQuery, GetDepartmentsPaginatedQueryVariables>;
export const GetDepartmentsWithDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetDepartmentsWithDependencies($query: departments_bool_exp) {
  departments(where: $query, order_by: {name: asc}) {
    ...Department
    coreData {
      id
      coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
        ...CoreDataDependencies
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment Department on departments {
  createdAt
  isArchived
  archivedBy
  id
  name
  organisationId
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<GetDepartmentsWithDependenciesQuery, GetDepartmentsWithDependenciesQueryVariables>;
export const InsertDepartmentDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertDepartment($object: departments_insert_input!) {
  insert_departments_one(object: $object) {
    ...Department
  }
}
    fragment Department on departments {
  createdAt
  isArchived
  archivedBy
  id
  name
  organisationId
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<InsertDepartmentMutation, InsertDepartmentMutationVariables>;
export const UnarchiveDepartmentsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnarchiveDepartments($ids: [uuid!]!) {
  update_departments(
    where: {id: {_in: $ids}}
    _set: {isArchived: false, archivedBy: null}
  ) {
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UnarchiveDepartmentsMutation, UnarchiveDepartmentsMutationVariables>;
export const UpdateDepartmentDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateDepartment($id: uuid!, $object: departments_set_input!) {
  update_departments_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...Department
  }
}
    fragment Department on departments {
  createdAt
  isArchived
  archivedBy
  id
  name
  organisationId
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;
export const ArchiveLineItemTypesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ArchiveLineItemTypes($ids: [uuid!]!, $archivedBy: String!) {
  update_line_item_types(
    where: {id: {_in: $ids}}
    _set: {isArchived: true, archivedBy: $archivedBy}
  ) {
    affected_rows
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ArchiveLineItemTypesMutation, ArchiveLineItemTypesMutationVariables>;
export const GetLineItemTypeByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLineItemTypeById($id: uuid!) {
  line_item_types_by_pk(id: $id) {
    ...LineItemType
  }
}
    fragment LineItemType on line_item_types {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetLineItemTypeByIdQuery, GetLineItemTypeByIdQueryVariables>;
export const GetLineItemTypeWithDependenciesByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLineItemTypeWithDependenciesById($id: uuid!) {
  line_item_types_by_pk(id: $id) {
    ...LineItemType
    coreData {
      id
      coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
        ...CoreDataDependencies
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment LineItemType on line_item_types {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetLineItemTypeWithDependenciesByIdQuery, GetLineItemTypeWithDependenciesByIdQueryVariables>;
export const GetLineItemTypesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLineItemTypes($query: line_item_types_bool_exp) {
  line_item_types(where: $query, order_by: {name: asc}) {
    ...LineItemType
  }
}
    fragment LineItemType on line_item_types {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetLineItemTypesQuery, GetLineItemTypesQueryVariables>;
export const GetLineItemTypesWithDependenciesMetadataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLineItemTypesWithDependenciesMetadata($query: line_item_types_bool_exp, $depsLimit: Int!) {
  line_item_types(where: $query, order_by: {name: asc}) {
    ...LineItemTypeWithDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment LineItemType on line_item_types {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}
fragment LineItemTypeWithDependenciesMetadata on line_item_types {
  ...LineItemType
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`) as unknown as TypedDocumentString<GetLineItemTypesWithDependenciesMetadataQuery, GetLineItemTypesWithDependenciesMetadataQueryVariables>;
export const GetLineItemTypesPaginatedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLineItemTypesPaginated($limit: Int!, $offset: Int!, $orderBy: [line_item_types_order_by!]!, $query: line_item_types_bool_exp) {
  line_item_types(
    limit: $limit
    offset: $offset
    order_by: $orderBy
    where: $query
  ) {
    ...LineItemType
  }
  line_item_types_aggregate(where: $query) {
    aggregate {
      count
    }
  }
}
    fragment LineItemType on line_item_types {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetLineItemTypesPaginatedQuery, GetLineItemTypesPaginatedQueryVariables>;
export const GetLineItemTypesWithDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLineItemTypesWithDependencies($query: line_item_types_bool_exp) {
  line_item_types(where: $query, order_by: {name: asc}) {
    ...LineItemType
    coreData {
      id
      coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
        ...CoreDataDependencies
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment LineItemType on line_item_types {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetLineItemTypesWithDependenciesQuery, GetLineItemTypesWithDependenciesQueryVariables>;
export const InsertLineItemTypeDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertLineItemType($object: line_item_types_insert_input!) {
  insert_line_item_types_one(object: $object) {
    ...LineItemType
  }
}
    fragment LineItemType on line_item_types {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<InsertLineItemTypeMutation, InsertLineItemTypeMutationVariables>;
export const UnarchiveLineItemTypesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnarchiveLineItemTypes($ids: [uuid!]!) {
  update_line_item_types(
    where: {id: {_in: $ids}}
    _set: {isArchived: false, archivedBy: null}
  ) {
    affected_rows
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UnarchiveLineItemTypesMutation, UnarchiveLineItemTypesMutationVariables>;
export const UpdateLineItemTypeDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateLineItemType($id: uuid!, $object: line_item_types_set_input!) {
  update_line_item_types_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    coreData {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateLineItemTypeMutation, UpdateLineItemTypeMutationVariables>;
export const ArchivePaymentMethodsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ArchivePaymentMethods($ids: [uuid!]!, $archivedBy: String!) {
  update_payment_methods(
    where: {id: {_in: $ids}}
    _set: {isArchived: true, archivedBy: $archivedBy}
  ) {
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ArchivePaymentMethodsMutation, ArchivePaymentMethodsMutationVariables>;
export const GetPaymentMethodByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentMethodById($id: uuid!) {
  payment_methods_by_pk(id: $id) {
    ...PaymentMethod
  }
}
    fragment PaymentMethod on payment_methods {
  id
  name
  updatedAt
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetPaymentMethodByIdQuery, GetPaymentMethodByIdQueryVariables>;
export const GetPaymentMethodWithDependenciesByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentMethodWithDependenciesById($id: uuid!) {
  payment_methods_by_pk(id: $id) {
    ...PaymentMethod
    coreData {
      id
      coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
        ...CoreDataDependencies
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment PaymentMethod on payment_methods {
  id
  name
  updatedAt
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetPaymentMethodWithDependenciesByIdQuery, GetPaymentMethodWithDependenciesByIdQueryVariables>;
export const GetPaymentMethodsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentMethods($query: payment_methods_bool_exp) {
  payment_methods(where: $query, order_by: {name: asc}) {
    ...PaymentMethod
  }
}
    fragment PaymentMethod on payment_methods {
  id
  name
  updatedAt
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>;
export const GetPaymentMethodsWithDependenciesMetadataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentMethodsWithDependenciesMetadata($query: payment_methods_bool_exp, $depsLimit: Int!) {
  payment_methods(where: $query, order_by: {name: asc}) {
    ...PaymentMethodWithDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment PaymentMethod on payment_methods {
  id
  name
  updatedAt
  isArchived
  archivedBy
  remoteId
  coreDataId
}
fragment PaymentMethodWithDependenciesMetadata on payment_methods {
  ...PaymentMethod
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`) as unknown as TypedDocumentString<GetPaymentMethodsWithDependenciesMetadataQuery, GetPaymentMethodsWithDependenciesMetadataQueryVariables>;
export const GetPaymentMethodsPaginatedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentMethodsPaginated($limit: Int!, $offset: Int!, $orderBy: [payment_methods_order_by!]!, $query: payment_methods_bool_exp) {
  payment_methods(
    limit: $limit
    offset: $offset
    order_by: $orderBy
    where: $query
  ) {
    ...PaymentMethod
  }
  payment_methods_aggregate(where: $query) {
    aggregate {
      count
    }
  }
}
    fragment PaymentMethod on payment_methods {
  id
  name
  updatedAt
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetPaymentMethodsPaginatedQuery, GetPaymentMethodsPaginatedQueryVariables>;
export const GetPaymentMethodsWithDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentMethodsWithDependencies($query: payment_methods_bool_exp) {
  payment_methods(where: $query, order_by: {name: asc}) {
    ...PaymentMethod
    coreData {
      id
      coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
        ...CoreDataDependencies
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment PaymentMethod on payment_methods {
  id
  name
  updatedAt
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetPaymentMethodsWithDependenciesQuery, GetPaymentMethodsWithDependenciesQueryVariables>;
export const InsertPaymentMethodDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertPaymentMethod($object: payment_methods_insert_input!) {
  insert_payment_methods_one(object: $object) {
    ...PaymentMethod
  }
}
    fragment PaymentMethod on payment_methods {
  id
  name
  updatedAt
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<InsertPaymentMethodMutation, InsertPaymentMethodMutationVariables>;
export const UnarchivePaymentMethodsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnarchivePaymentMethods($ids: [uuid!]!) {
  update_payment_methods(where: {id: {_in: $ids}}, _set: {isArchived: false}) {
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UnarchivePaymentMethodsMutation, UnarchivePaymentMethodsMutationVariables>;
export const UpdatePaymentMethodDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdatePaymentMethod($id: uuid!, $object: payment_methods_set_input!) {
  update_payment_methods_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...PaymentMethod
  }
}
    fragment PaymentMethod on payment_methods {
  id
  name
  updatedAt
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<UpdatePaymentMethodMutation, UpdatePaymentMethodMutationVariables>;
export const ArchivePaymentTermsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ArchivePaymentTerms($ids: [uuid!]!, $archivedBy: String!) {
  update_payment_terms(
    where: {id: {_in: $ids}}
    _set: {isArchived: true, archivedBy: $archivedBy}
  ) {
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ArchivePaymentTermsMutation, ArchivePaymentTermsMutationVariables>;
export const GetPaymentTermByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentTermById($id: uuid!) {
  payment_terms_by_pk(id: $id) {
    ...PaymentTerm
  }
}
    fragment PaymentTerm on payment_terms {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetPaymentTermByIdQuery, GetPaymentTermByIdQueryVariables>;
export const GetPaymentTermWithDependenciesByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentTermWithDependenciesById($id: uuid!) {
  payment_terms_by_pk(id: $id) {
    ...PaymentTerm
    coreData {
      id
      coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
        ...CoreDataDependencies
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment PaymentTerm on payment_terms {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetPaymentTermWithDependenciesByIdQuery, GetPaymentTermWithDependenciesByIdQueryVariables>;
export const GetPaymentTermsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentTerms($query: payment_terms_bool_exp) {
  payment_terms(where: $query, order_by: {name: asc}) {
    ...PaymentTerm
  }
}
    fragment PaymentTerm on payment_terms {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetPaymentTermsQuery, GetPaymentTermsQueryVariables>;
export const GetPaymentTermsWithDependenciesMetadataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentTermsWithDependenciesMetadata($query: payment_terms_bool_exp, $depsLimit: Int!) {
  payment_terms(where: $query, order_by: {name: asc}) {
    ...PaymentTermWithDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment PaymentTerm on payment_terms {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}
fragment PaymentTermWithDependenciesMetadata on payment_terms {
  ...PaymentTerm
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`) as unknown as TypedDocumentString<GetPaymentTermsWithDependenciesMetadataQuery, GetPaymentTermsWithDependenciesMetadataQueryVariables>;
export const GetPaymentTermsPaginatedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentTermsPaginated($limit: Int!, $offset: Int!, $orderBy: [payment_terms_order_by!]!, $query: payment_terms_bool_exp) {
  payment_terms(limit: $limit, offset: $offset, order_by: $orderBy, where: $query) {
    ...PaymentTerm
  }
  payment_terms_aggregate(where: $query) {
    aggregate {
      count
    }
  }
}
    fragment PaymentTerm on payment_terms {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetPaymentTermsPaginatedQuery, GetPaymentTermsPaginatedQueryVariables>;
export const GetPaymentTermsWithDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentTermsWithDependencies($query: payment_terms_bool_exp) {
  payment_terms(where: $query, order_by: {name: asc}) {
    ...PaymentTerm
    coreData {
      id
      coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
        ...CoreDataDependencies
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment PaymentTerm on payment_terms {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetPaymentTermsWithDependenciesQuery, GetPaymentTermsWithDependenciesQueryVariables>;
export const InsertPaymentTermDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertPaymentTerm($object: payment_terms_insert_input!) {
  insert_payment_terms_one(object: $object) {
    ...PaymentTerm
  }
}
    fragment PaymentTerm on payment_terms {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<InsertPaymentTermMutation, InsertPaymentTermMutationVariables>;
export const UnarchivePaymentTermsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnarchivePaymentTerms($ids: [uuid!]!) {
  update_payment_terms(
    where: {id: {_in: $ids}}
    _set: {isArchived: false, archivedBy: null}
  ) {
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UnarchivePaymentTermsMutation, UnarchivePaymentTermsMutationVariables>;
export const UpdatePaymentTermDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdatePaymentTerm($id: uuid!, $object: payment_terms_set_input!) {
  update_payment_terms_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    coreData {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdatePaymentTermMutation, UpdatePaymentTermMutationVariables>;
export const ArchiveSubsidiariesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ArchiveSubsidiaries($ids: [uuid!]!, $archivedBy: String!) {
  update_subsidiaries(
    where: {id: {_in: $ids}}
    _set: {isArchived: true, archivedBy: $archivedBy}
  ) {
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ArchiveSubsidiariesMutation, ArchiveSubsidiariesMutationVariables>;
export const GetSubsidiariesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSubsidiaries($query: subsidiaries_bool_exp) {
  subsidiaries(where: $query, order_by: {name: asc}) {
    ...Subsidiary
  }
}
    fragment Subsidiary on subsidiaries {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetSubsidiariesQuery, GetSubsidiariesQueryVariables>;
export const GetSubsidiariesWithDependenciesMetadataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSubsidiariesWithDependenciesMetadata($query: subsidiaries_bool_exp, $depsLimit: Int!) {
  subsidiaries(where: $query, order_by: {name: asc}) {
    ...SubsidiaryWithDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment Subsidiary on subsidiaries {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}
fragment SubsidiaryWithDependenciesMetadata on subsidiaries {
  ...Subsidiary
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`) as unknown as TypedDocumentString<GetSubsidiariesWithDependenciesMetadataQuery, GetSubsidiariesWithDependenciesMetadataQueryVariables>;
export const GetSubsidiariesPaginatedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSubsidiariesPaginated($limit: Int!, $offset: Int!, $orderBy: [subsidiaries_order_by!]!, $query: subsidiaries_bool_exp) {
  subsidiaries(limit: $limit, offset: $offset, order_by: $orderBy, where: $query) {
    ...Subsidiary
  }
  subsidiaries_aggregate(where: $query) {
    aggregate {
      count
    }
  }
}
    fragment Subsidiary on subsidiaries {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetSubsidiariesPaginatedQuery, GetSubsidiariesPaginatedQueryVariables>;
export const GetSubsidiariesWithDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSubsidiariesWithDependencies($query: subsidiaries_bool_exp) {
  subsidiaries(where: $query, order_by: {name: asc}) {
    ...Subsidiary
    coreData {
      id
      coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
        ...CoreDataDependencies
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment Subsidiary on subsidiaries {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetSubsidiariesWithDependenciesQuery, GetSubsidiariesWithDependenciesQueryVariables>;
export const GetSubsidiaryByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSubsidiaryById($id: uuid!) {
  subsidiaries_by_pk(id: $id) {
    ...Subsidiary
  }
}
    fragment Subsidiary on subsidiaries {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetSubsidiaryByIdQuery, GetSubsidiaryByIdQueryVariables>;
export const GetSubsidiaryWithDependenciesByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSubsidiaryWithDependenciesById($id: uuid!) {
  subsidiaries_by_pk(id: $id) {
    ...Subsidiary
    coreData {
      id
      coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
        ...CoreDataDependencies
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment Subsidiary on subsidiaries {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetSubsidiaryWithDependenciesByIdQuery, GetSubsidiaryWithDependenciesByIdQueryVariables>;
export const InsertSubsidiaryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertSubsidiary($object: subsidiaries_insert_input!) {
  insert_subsidiaries_one(object: $object) {
    ...Subsidiary
  }
}
    fragment Subsidiary on subsidiaries {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<InsertSubsidiaryMutation, InsertSubsidiaryMutationVariables>;
export const UnarchiveSubsidiariesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnarchiveSubsidiaries($ids: [uuid!]!) {
  update_subsidiaries(
    where: {id: {_in: $ids}}
    _set: {isArchived: false, archivedBy: null}
  ) {
    returning {
      id
      coreData {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UnarchiveSubsidiariesMutation, UnarchiveSubsidiariesMutationVariables>;
export const UpdateSubsidiaryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateSubsidiary($id: uuid!, $object: subsidiaries_set_input!) {
  update_subsidiaries_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...Subsidiary
  }
}
    fragment Subsidiary on subsidiaries {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<UpdateSubsidiaryMutation, UpdateSubsidiaryMutationVariables>;
export const CreateOrganisationCoreDataDependencyDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateOrganisationCoreDataDependency($input: organisation_core_data_dependencies_insert_input!) {
  organisationCoreDataDependency: insert_organisation_core_data_dependencies_one(
    object: $input
    on_conflict: {constraint: organisation_core_data_dependencies_organisation_id_core_data_t, update_columns: [deletedAt]}
  ) {
    id
    coreDataType
    dependencyCoreDataType
  }
}
    `) as unknown as TypedDocumentString<CreateOrganisationCoreDataDependencyMutation, CreateOrganisationCoreDataDependencyMutationVariables>;
export const GetOrganisationCoreDataDependenciesForCustomEntityTypeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationCoreDataDependenciesForCustomEntityType($customCoreDataId: uuid!) {
  organisationCoreDataDependencies: organisation_core_data_dependencies(
    where: {coreDataType: {_eq: "custom"}, customCoreDataId: {_eq: $customCoreDataId}, deletedAt: {_is_null: true}}
  ) {
    id
    coreDataType
    dependencyCoreDataType
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationCoreDataDependenciesForCustomEntityTypeQuery, GetOrganisationCoreDataDependenciesForCustomEntityTypeQueryVariables>;
export const GetOrganisationCoreDataDependenciesForEntityTypeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationCoreDataDependenciesForEntityType($entityType: String!) {
  organisationCoreDataDependencies: organisation_core_data_dependencies(
    where: {coreDataType: {_eq: $entityType}, deletedAt: {_is_null: true}}
  ) {
    id
    coreDataType
    dependencyCoreDataType
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationCoreDataDependenciesForEntityTypeQuery, GetOrganisationCoreDataDependenciesForEntityTypeQueryVariables>;
export const GetCoreDataDependenciesFromCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCoreDataDependenciesFromCoreData($filters: core_data_bool_exp!) {
  core_data(where: $filters) {
    id
    coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
      ...CoreDataDependencies
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}`) as unknown as TypedDocumentString<GetCoreDataDependenciesFromCoreDataQuery, GetCoreDataDependenciesFromCoreDataQueryVariables>;
export const GetUserAllowedSubsidiariesWithDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUserAllowedSubsidiariesWithDependencies($where: user_allowed_subsidiaries_bool_exp!) {
  user_allowed_subsidiaries(where: $where) {
    userId
    subsidiaryId
    subsidiary {
      ...Subsidiary
      coreData {
        id
        coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
          ...CoreDataDependencies
        }
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment Subsidiary on subsidiaries {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetUserAllowedSubsidiariesWithDependenciesQuery, GetUserAllowedSubsidiariesWithDependenciesQueryVariables>;
export const GetOrganisationStaticContentDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationStaticContent($type: String!) {
  organisation_static_content(where: {type: {_eq: $type}}) {
    id
    content
    type
    updatedAt
    updatedBy: user {
      id
      firstName
      lastName
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationStaticContentQuery, GetOrganisationStaticContentQueryVariables>;
export const InsertRequestStepTaskErrorDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRequestStepTaskError($requestStepTaskError: request_step_task_errors_insert_input!) {
  insert_request_step_task_errors_one(object: $requestStepTaskError) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertRequestStepTaskErrorMutation, InsertRequestStepTaskErrorMutationVariables>;
export const GetTaskDetailsWithFpaDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetTaskDetailsWithFPA($taskId: uuid!, $taskCompletedOn: timestamptz!) {
  request_step_tasks_by_pk(id: $taskId) {
    id
    requestFormId
    completedOn
    request_form {
      id
      type
      amendments_aggregate: request_comments_aggregate(
        where: {type: {_eq: AMENDMENT_REQUEST}, createdAt: {_lt: $taskCompletedOn}, deletedAt: {_is_null: true}}
      ) {
        aggregate {
          count
        }
      }
      comments_aggregate: request_comments_aggregate(
        where: {type: {_eq: TEXT}, createdAt: {_lt: $taskCompletedOn}, deletedAt: {_is_null: true}}
      ) {
        aggregate {
          count
        }
      }
      request_form_submissions_aggregate(
        where: {submittedOn: {_lt: $taskCompletedOn}}
      ) {
        aggregate {
          count
        }
      }
      request_step_tasks {
        id
        request_step_task_rejections_aggregate(
          where: {createdAt: {_lt: $taskCompletedOn}}
        ) {
          aggregate {
            count
          }
        }
      }
      request {
        id
        workflowId
        workflow {
          id
          title
          type
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetTaskDetailsWithFpaQuery, GetTaskDetailsWithFpaQueryVariables>;
export const GetRequestRequestorDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestRequestor($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    id
    requestorUserId
  }
}
    `) as unknown as TypedDocumentString<GetRequestRequestorQuery, GetRequestRequestorQueryVariables>;
export const CompleteAccountingTaskDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CompleteAccountingTask($taskId: uuid!, $config: jsonb!) {
  update_request_step_tasks_by_pk(
    pk_columns: {id: $taskId}
    _set: {completedOn: "now()", config: $config}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<CompleteAccountingTaskMutation, CompleteAccountingTaskMutationVariables>;
export const GetAccountingTaskDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAccountingTask($taskId: uuid!) {
  task: request_step_tasks_by_pk(id: $taskId) {
    id
    type
    completedOn
    step: request_step {
      id
      requestId
    }
  }
}
    `) as unknown as TypedDocumentString<GetAccountingTaskQuery, GetAccountingTaskQueryVariables>;
export const DeleteOrgProductsAndServiceByOrgSupplierIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteOrgProductsAndServiceByOrgSupplierId($orgSupplierId: uuid!) {
  update_organisation_products_and_services(
    where: {organisationSupplierId: {_eq: $orgSupplierId}}
    _set: {deleted_at: "now()"}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteOrgProductsAndServiceByOrgSupplierIdMutation, DeleteOrgProductsAndServiceByOrgSupplierIdMutationVariables>;
export const DeleteOrgSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteOrgSupplier($id: uuid!) {
  update_organisation_suppliers_by_pk(
    pk_columns: {id: $id}
    _set: {deleted_at: "now()"}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteOrgSupplierMutation, DeleteOrgSupplierMutationVariables>;
export const DeleteOrgSupplierProfilesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteOrgSupplierProfiles($ids: [uuid!]!) {
  update_organisation_supplier_profiles(
    where: {id: {_in: $ids}}
    _set: {deletedAt: "now()"}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteOrgSupplierProfilesMutation, DeleteOrgSupplierProfilesMutationVariables>;
export const GetBankDetailsByRemoteIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBankDetailsByRemoteId($remoteId: String!) {
  bank_details(where: {remoteId: {_eq: $remoteId}}, limit: 1) {
    id
    remoteId
    address {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetBankDetailsByRemoteIdQuery, GetBankDetailsByRemoteIdQueryVariables>;
export const AddOrgSupplierContactDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation AddOrgSupplierContact($objects: [external_contacts_insert_input!]!) {
  insert_external_contacts(objects: $objects) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<AddOrgSupplierContactMutation, AddOrgSupplierContactMutationVariables>;
export const CreateOrgSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateOrgSupplier($supplier: organisation_suppliers_insert_input!) {
  supplier: insert_organisation_suppliers_one(object: $supplier) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateOrgSupplierMutation, CreateOrgSupplierMutationVariables>;
export const GetOrgSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgSupplier($id: uuid!) {
  supplier: organisation_suppliers_by_pk(id: $id) {
    ...OrgSupplierFragmentForDiffing
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment EntityBankAccount on entity_bank_details {
  isPrimary
  bankDetails {
    ...BankAccount
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment OrgSupplierFragmentForDiffing on organisation_suppliers {
  id
  remoteId
  externalLink
  remoteLink
  organisationIntegrationId
  name
  legalName
  website
  isPerson
  address
  description
  state
  archivedBy
  paymentMethodId
  paymentTermsId
  taxNumber
  deletedAt: deleted_at
  external_contacts {
    id
    email
    firstName
    lastName
    phoneNumber
    title
    isPrimary
    createdAt
    deletedAt
  }
  organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
    id
    state
    archivedBy
    subsidiary {
      id
      name
    }
    entityBankDetails {
      ...EntityBankAccount
    }
  }
  entityBankDetails {
    ...EntityBankAccount
  }
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetOrgSupplierQuery, GetOrgSupplierQueryVariables>;
export const GetOrgSupplierByIdOrRemoteIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgSupplierByIdOrRemoteId($id: uuid!, $remoteId: String!) {
  organisation_suppliers(
    where: {_or: [{remoteId: {_eq: $remoteId}}, {id: {_eq: $id}}], deleted_at: {_is_null: true}}
  ) {
    ...OrgSupplierFragmentForDiffing
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment EntityBankAccount on entity_bank_details {
  isPrimary
  bankDetails {
    ...BankAccount
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment OrgSupplierFragmentForDiffing on organisation_suppliers {
  id
  remoteId
  externalLink
  remoteLink
  organisationIntegrationId
  name
  legalName
  website
  isPerson
  address
  description
  state
  archivedBy
  paymentMethodId
  paymentTermsId
  taxNumber
  deletedAt: deleted_at
  external_contacts {
    id
    email
    firstName
    lastName
    phoneNumber
    title
    isPrimary
    createdAt
    deletedAt
  }
  organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
    id
    state
    archivedBy
    subsidiary {
      id
      name
    }
    entityBankDetails {
      ...EntityBankAccount
    }
  }
  entityBankDetails {
    ...EntityBankAccount
  }
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetOrgSupplierByIdOrRemoteIdQuery, GetOrgSupplierByIdOrRemoteIdQueryVariables>;
export const GetOrgSupplierByIdOrRemoteIdIncludingDeletedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgSupplierByIdOrRemoteIdIncludingDeleted($id: uuid!, $remoteId: String!) {
  organisation_suppliers(
    where: {_or: [{remoteId: {_eq: $remoteId}}, {id: {_eq: $id}}]}
  ) {
    ...OrgSupplierFragmentForDiffing
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment EntityBankAccount on entity_bank_details {
  isPrimary
  bankDetails {
    ...BankAccount
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment OrgSupplierFragmentForDiffing on organisation_suppliers {
  id
  remoteId
  externalLink
  remoteLink
  organisationIntegrationId
  name
  legalName
  website
  isPerson
  address
  description
  state
  archivedBy
  paymentMethodId
  paymentTermsId
  taxNumber
  deletedAt: deleted_at
  external_contacts {
    id
    email
    firstName
    lastName
    phoneNumber
    title
    isPrimary
    createdAt
    deletedAt
  }
  organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
    id
    state
    archivedBy
    subsidiary {
      id
      name
    }
    entityBankDetails {
      ...EntityBankAccount
    }
  }
  entityBankDetails {
    ...EntityBankAccount
  }
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetOrgSupplierByIdOrRemoteIdIncludingDeletedQuery, GetOrgSupplierByIdOrRemoteIdIncludingDeletedQueryVariables>;
export const GetOrgSuppliersByNameWithoutRemoteIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgSuppliersByNameWithoutRemoteId($name: String!) {
  organisation_suppliers(
    where: {name: {_eq: $name}, deleted_at: {_is_null: true}, _or: [{remoteId: {_is_null: true}}, {remoteId: {_eq: ""}}]}
  ) {
    ...OrgSupplierFragmentForDiffing
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment EntityBankAccount on entity_bank_details {
  isPrimary
  bankDetails {
    ...BankAccount
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment OrgSupplierFragmentForDiffing on organisation_suppliers {
  id
  remoteId
  externalLink
  remoteLink
  organisationIntegrationId
  name
  legalName
  website
  isPerson
  address
  description
  state
  archivedBy
  paymentMethodId
  paymentTermsId
  taxNumber
  deletedAt: deleted_at
  external_contacts {
    id
    email
    firstName
    lastName
    phoneNumber
    title
    isPrimary
    createdAt
    deletedAt
  }
  organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
    id
    state
    archivedBy
    subsidiary {
      id
      name
    }
    entityBankDetails {
      ...EntityBankAccount
    }
  }
  entityBankDetails {
    ...EntityBankAccount
  }
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetOrgSuppliersByNameWithoutRemoteIdQuery, GetOrgSuppliersByNameWithoutRemoteIdQueryVariables>;
export const GetOrgSuppliersByNameWithoutRemoteIdIncludingDeletedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgSuppliersByNameWithoutRemoteIdIncludingDeleted($name: String!) {
  organisation_suppliers(
    where: {name: {_eq: $name}, _or: [{remoteId: {_is_null: true}}, {remoteId: {_eq: ""}}]}
  ) {
    ...OrgSupplierFragmentForDiffing
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment EntityBankAccount on entity_bank_details {
  isPrimary
  bankDetails {
    ...BankAccount
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment OrgSupplierFragmentForDiffing on organisation_suppliers {
  id
  remoteId
  externalLink
  remoteLink
  organisationIntegrationId
  name
  legalName
  website
  isPerson
  address
  description
  state
  archivedBy
  paymentMethodId
  paymentTermsId
  taxNumber
  deletedAt: deleted_at
  external_contacts {
    id
    email
    firstName
    lastName
    phoneNumber
    title
    isPrimary
    createdAt
    deletedAt
  }
  organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
    id
    state
    archivedBy
    subsidiary {
      id
      name
    }
    entityBankDetails {
      ...EntityBankAccount
    }
  }
  entityBankDetails {
    ...EntityBankAccount
  }
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetOrgSuppliersByNameWithoutRemoteIdIncludingDeletedQuery, GetOrgSuppliersByNameWithoutRemoteIdIncludingDeletedQueryVariables>;
export const GetOrganisationSupplierProfilesByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationSupplierProfilesByIds($ids: [uuid!]!) {
  organisation_supplier_profiles(
    where: {id: {_in: $ids}, deletedAt: {_is_null: true}}
  ) {
    id
    organisationSupplierId
    subsidiaryId
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationSupplierProfilesByIdsQuery, GetOrganisationSupplierProfilesByIdsQueryVariables>;
export const MoveSupplierProfileAndResourcesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation MoveSupplierProfileAndResources($profileId: uuid!, $newSupplierId: uuid!, $productAndServiceIds: [uuid!]!, $requestIds: [uuid!]!, $engagementIds: [uuid!]!, $internalContactIds: [uuid!]!, $documentIds: [uuid!]!, $agreementIds: [uuid!]!, $historicSubmissionIds: [uuid!]!, $riskIds: [uuid!]!, $riskVersionIds: [uuid!]!, $tagIds: [uuid!]!, $assessmentIds: [uuid!]!, $purchaseOrderIds: [uuid!]!, $externalRiskScoreIds: [uuid!]!) {
  update_organisation_supplier_profiles_by_pk(
    pk_columns: {id: $profileId}
    _set: {organisationSupplierId: $newSupplierId}
  ) {
    id
  }
  update_organisation_products_and_services(
    where: {id: {_in: $productAndServiceIds}}
    _set: {organisationSupplierId: $newSupplierId}
  ) {
    returning {
      id
    }
  }
  update_requests(
    where: {id: {_in: $requestIds}}
    _set: {request_supplier: $newSupplierId}
  ) {
    returning {
      id
    }
  }
  update_engagements(
    where: {id: {_in: $engagementIds}}
    _set: {organisationSupplierId: $newSupplierId}
  ) {
    returning {
      id
    }
  }
  update_internal_contacts(
    where: {id: {_in: $internalContactIds}}
    _set: {supplierId: $newSupplierId}
  ) {
    returning {
      id
    }
  }
  update_documents(
    where: {id: {_in: $documentIds}}
    _set: {organisationSupplierId: $newSupplierId}
  ) {
    returning {
      id
    }
  }
  update_agreements(
    where: {id: {_in: $agreementIds}}
    _set: {supplierId: $newSupplierId}
  ) {
    returning {
      id
    }
  }
  update_organisation_supplier_historic_submissions(
    where: {id: {_in: $historicSubmissionIds}}
    _set: {organisationSupplierId: $newSupplierId}
  ) {
    returning {
      id
    }
  }
  update_risks(
    where: {id: {_in: $riskIds}}
    _set: {orgSupplierId: $newSupplierId}
  ) {
    returning {
      id
    }
  }
  update_risk_versions(
    where: {id: {_in: $riskVersionIds}}
    _set: {orgSupplierId: $newSupplierId}
  ) {
    returning {
      id
    }
  }
  update_organisation_supplier_tags(
    where: {id: {_in: $tagIds}}
    _set: {organisationSupplierId: $newSupplierId}
  ) {
    returning {
      id
    }
  }
  update_assessments(
    where: {id: {_in: $assessmentIds}}
    _set: {organisationSupplierId: $newSupplierId}
  ) {
    returning {
      id
    }
  }
  update_purchase_orders(
    where: {id: {_in: $purchaseOrderIds}}
    _set: {supplierId: $newSupplierId}
  ) {
    returning {
      id
    }
  }
  update_external_risk_scores(
    where: {id: {_in: $externalRiskScoreIds}}
    _set: {organisationSupplierId: $newSupplierId}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<MoveSupplierProfileAndResourcesMutation, MoveSupplierProfileAndResourcesMutationVariables>;
export const RemoveOrgSupplierProfilesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation RemoveOrgSupplierProfiles($organisationSupplierId: uuid!, $subsidiaries: [uuid!]!) {
  update_organisation_supplier_profiles(
    where: {organisationSupplierId: {_eq: $organisationSupplierId}, subsidiaryId: {_in: $subsidiaries}, deletedAt: {_is_null: true}}
    _set: {deletedAt: "now()"}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<RemoveOrgSupplierProfilesMutation, RemoveOrgSupplierProfilesMutationVariables>;
export const UpdateOrgSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateOrgSupplier($id: uuid!, $supplier: organisation_suppliers_set_input!) {
  supplier: update_organisation_suppliers_by_pk(
    pk_columns: {id: $id}
    _set: $supplier
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateOrgSupplierMutation, UpdateOrgSupplierMutationVariables>;
export const UpdateOrgSupplierContactDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateOrgSupplierContact($id: uuid!, $contact: external_contacts_set_input!) {
  contact: update_external_contacts_by_pk(pk_columns: {id: $id}, _set: $contact) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateOrgSupplierContactMutation, UpdateOrgSupplierContactMutationVariables>;
export const UpsertOrganisationSupplierProfilesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertOrganisationSupplierProfiles($objects: [organisation_supplier_profiles_insert_input!]!) {
  insert_organisation_supplier_profiles(
    objects: $objects
    on_conflict: {constraint: uniq_subsidiary_id_organisation_supplier_id_deleted_at, update_columns: [payment_term_id, payment_method_id, state, remoteId, remoteLink]}
  ) {
    affected_rows
    returning {
      id
      subsidiaryId
      customFieldValues {
        value
        customFieldId
        entityId
        booleanValue
        numberValue
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UpsertOrganisationSupplierProfilesMutation, UpsertOrganisationSupplierProfilesMutationVariables>;
export const GetCoreDataOrganisationIntegrationsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCoreDataOrganisationIntegrations($organisationIntegrationId: uuid!, $coreDataType: String!) {
  core_data_organisation_integrations(
    where: {organisationIntegrationId: {_eq: $organisationIntegrationId}, coreDataType: {_eq: $coreDataType}}
  ) {
    id
    organisationIntegrationId
    coreDataType
  }
}
    `) as unknown as TypedDocumentString<GetCoreDataOrganisationIntegrationsQuery, GetCoreDataOrganisationIntegrationsQueryVariables>;
export const GetCustomCoreIntegrationIdByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreIntegrationIdById($id: uuid!) {
  custom_core_data_by_pk(id: $id) {
    id
    organisationIntegrationId
  }
}
    `) as unknown as TypedDocumentString<GetCustomCoreIntegrationIdByIdQuery, GetCustomCoreIntegrationIdByIdQueryVariables>;
export const InsertCoreDataOrganisationIntegrationDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertCoreDataOrganisationIntegration($organisationIntegrationId: uuid!, $coreDataType: String!) {
  insert_core_data_organisation_integrations_one(
    object: {organisationIntegrationId: $organisationIntegrationId, coreDataType: $coreDataType}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertCoreDataOrganisationIntegrationMutation, InsertCoreDataOrganisationIntegrationMutationVariables>;
export const UpdateCustomCoreDataOrganisationIntegrationIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateCustomCoreDataOrganisationIntegrationId($id: uuid!, $organisationIntegrationId: uuid!) {
  update_custom_core_data_by_pk(
    pk_columns: {id: $id}
    _set: {organisationIntegrationId: $organisationIntegrationId}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateCustomCoreDataOrganisationIntegrationIdMutation, UpdateCustomCoreDataOrganisationIntegrationIdMutationVariables>;
export const GetRequestByTaskIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestByTaskId($taskId: uuid!) {
  task: request_step_tasks_by_pk(id: $taskId) {
    id
    requestFormId
    type: config(path: "type")
    requestStep: request_step {
      id
      label: input(path: "metadata.config.payload.label")
      agentEnabled: input(path: "metadata.config.payload.agentConfig.enabled")
      request {
        id
        name
        organisation {
          id
          name
        }
        leads {
          id
        }
        user {
          id
          firstName
          lastName
          role
          email
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestByTaskIdQuery, GetRequestByTaskIdQueryVariables>;
export const UpsertAccountingUsersByEmailDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertAccountingUsersByEmail($users: [users_insert_input!]!, $upsertSubsidiaries: [user_allowed_subsidiaries_insert_input!]!, $deleteUserAllowedSubsidiaries: [uuid!]) {
  insert_users(
    objects: $users
    on_conflict: {constraint: users_email_organisation_id_key, update_columns: [managerUserId, departmentId, subsidiaryId]}
  ) {
    affected_rows
  }
  delete_user_allowed_subsidiaries(
    where: {id: {_in: $deleteUserAllowedSubsidiaries}}
  ) {
    affected_rows
  }
  insert_user_allowed_subsidiaries(
    objects: $upsertSubsidiaries
    on_conflict: {constraint: user_allowed_subsidiaries_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      userId
      subsidiaryId
    }
  }
}
    `) as unknown as TypedDocumentString<UpsertAccountingUsersByEmailMutation, UpsertAccountingUsersByEmailMutationVariables>;
export const GetAllAssigneeUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllAssigneeUsers($userIds: [uuid!], $groupIds: [uuid!]) {
  users(
    where: {_or: [{id: {_in: $userIds}}, {group_users: {groupId: {_in: $groupIds}}}]}
  ) {
    id
    firstName
    lastName
    email
  }
}
    `) as unknown as TypedDocumentString<GetAllAssigneeUsersQuery, GetAllAssigneeUsersQueryVariables>;
export const GetResourcesLinkedToArchivedUserDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetResourcesLinkedToArchivedUser($archivedUserId: uuid!, $fallbackUserId: uuid!) {
  renewals(
    where: {workflowInitialAssigneeId: {_eq: $archivedUserId}, deletedAt: {_is_null: true}, renewedAt: {_is_null: true}, cancelledAt: {_is_null: true}, _or: [{requestId: {_is_null: true}}, {request: {completedAt: {_is_null: true}}}]}
  ) {
    id
    product {
      name
    }
    renewalDate
    requestId
  }
  renewal_additional_users(
    where: {userId: {_eq: $archivedUserId}, renewal: {renewedAt: {_is_null: true}, cancelledAt: {_is_null: true}, deletedAt: {_is_null: true}, _or: [{requestId: {_is_null: true}}, {request: {completedAt: {_is_null: true}}}]}}
  ) {
    id
    renewalId
    renewal {
      id
      product {
        name
      }
      renewalDate
    }
  }
  requests(
    where: {_or: [{ownerId: {_eq: $archivedUserId}}, {requestorUserId: {_eq: $archivedUserId}}], completedAt: {_is_null: true}, deletedAt: {_is_null: true}}
  ) {
    id
    name
    publicId
    ownerId
    requestorUserId
  }
  assessments(
    where: {businessOwnerUserId: {_eq: $archivedUserId}, deletedAt: {_is_null: true}, completedAt: {_is_null: true}}
  ) {
    id
    product {
      name
    }
    sendDate
    requestId
  }
  request_step_users(
    where: {userId: {_eq: $archivedUserId}, request_step: {request: {completedAt: {_is_null: true}, deletedAt: {_is_null: true}}}}
  ) {
    id
    requestStepId
    request_step {
      id
      requestId
      request {
        id
        name
        publicId
      }
    }
  }
  request_request_leads(
    where: {userId: {_eq: $archivedUserId}, request: {completedAt: {_is_null: true}, deletedAt: {_is_null: true}}}
  ) {
    id
    requestId
    request {
      id
      name
      publicId
    }
  }
  request_users(
    where: {userId: {_eq: $archivedUserId}, request: {completedAt: {_is_null: true}, deletedAt: {_is_null: true}}}
  ) {
    id
    requestId
    request {
      id
      name
      publicId
    }
  }
  workflows(
    where: {type: {_neq: EXTERNAL_WORKFLOW}, state: {_eq: PUBLISHED}, deletedAt: {_is_null: true}}
  ) {
    id
    title
    routingCanvasModel
  }
  budget_approval_group(
    where: {assignees: {assignees: {userId: {_eq: $archivedUserId}}}}
  ) {
    id
    name
    assignees(where: {assignees: {userId: {_eq: $archivedUserId}}}) {
      id
      department {
        name
      }
      assignees(where: {userId: {_eq: $archivedUserId}}) {
        id
      }
    }
  }
  fallback_renewal_additional_users: renewal_additional_users(
    where: {userId: {_eq: $fallbackUserId}, renewal: {renewedAt: {_is_null: true}, cancelledAt: {_is_null: true}, deletedAt: {_is_null: true}, _or: [{requestId: {_is_null: true}}, {request: {completedAt: {_is_null: true}}}]}}
  ) {
    renewalId
  }
  fallback_request_step_users: request_step_users(
    where: {userId: {_eq: $fallbackUserId}, request_step: {request: {completedAt: {_is_null: true}, deletedAt: {_is_null: true}}}}
  ) {
    requestStepId
  }
  fallback_request_leads: request_request_leads(
    where: {userId: {_eq: $fallbackUserId}, request: {completedAt: {_is_null: true}, deletedAt: {_is_null: true}}}
  ) {
    requestId
  }
  fallback_request_users: request_users(
    where: {userId: {_eq: $fallbackUserId}, request: {completedAt: {_is_null: true}, deletedAt: {_is_null: true}}}
  ) {
    requestId
  }
}
    `) as unknown as TypedDocumentString<GetResourcesLinkedToArchivedUserQuery, GetResourcesLinkedToArchivedUserQueryVariables>;
export const ReassignResourcesToFallbackUserDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ReassignResourcesToFallbackUser($fallbackUserId: uuid!, $archivedUserId: uuid!, $assessmentIds: [uuid!]!, $renewalIds: [uuid!]!, $requestIds: [uuid!]!, $budgetApprovalAssigneeIds: [uuid!]!, $renewalAdditionalUserIds: [uuid!]!, $requestStepUserIds: [uuid!]!, $requestLeadIds: [uuid!]!, $requestUserIds: [uuid!]!) {
  update_requests(
    where: {id: {_in: $requestIds}, ownerId: {_eq: $archivedUserId}}
    _set: {ownerId: $fallbackUserId}
  ) {
    affected_rows
    returning {
      id
      publicId
    }
  }
  update_assessments(
    where: {id: {_in: $assessmentIds}}
    _set: {businessOwnerUserId: $fallbackUserId}
  ) {
    affected_rows
    returning {
      id
    }
  }
  update_renewals(
    where: {id: {_in: $renewalIds}}
    _set: {workflowInitialAssigneeId: $fallbackUserId}
  ) {
    affected_rows
    returning {
      id
    }
  }
  update_budget_approval_group_assignees_assignees(
    where: {id: {_in: $budgetApprovalAssigneeIds}}
    _set: {userId: $fallbackUserId}
  ) {
    affected_rows
    returning {
      id
    }
  }
  update_renewal_additional_users(
    where: {id: {_in: $renewalAdditionalUserIds}}
    _set: {userId: $fallbackUserId}
  ) {
    affected_rows
    returning {
      id
    }
  }
  update_request_step_users(
    where: {id: {_in: $requestStepUserIds}}
    _set: {userId: $fallbackUserId}
  ) {
    affected_rows
    returning {
      id
    }
  }
  update_request_request_leads(
    where: {id: {_in: $requestLeadIds}}
    _set: {userId: $fallbackUserId}
  ) {
    affected_rows
    returning {
      id
    }
  }
  update_request_users(
    where: {id: {_in: $requestUserIds}}
    _set: {userId: $fallbackUserId}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<ReassignResourcesToFallbackUserMutation, ReassignResourcesToFallbackUserMutationVariables>;
export const UpdateWorkflowAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateWorkflowAssignees($workflowUpdates: [workflows_updates!]!) {
  update_workflows_many(updates: $workflowUpdates) {
    affected_rows
    returning {
      id
      title
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateWorkflowAssigneesMutation, UpdateWorkflowAssigneesMutationVariables>;
export const InsertRequestFormSubmissionTranslationDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRequestFormSubmissionTranslation($translation: request_form_submission_translations_insert_input!) {
  insert_request_form_submission_translations_one(object: $translation) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertRequestFormSubmissionTranslationMutation, InsertRequestFormSubmissionTranslationMutationVariables>;
export const SetRequestFormSubmissionDetectedLanguageDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SetRequestFormSubmissionDetectedLanguage($id: uuid!, $detectedLanguage: String) {
  update_request_form_submissions_by_pk(
    pk_columns: {id: $id}
    _set: {detectedLanguage: $detectedLanguage}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<SetRequestFormSubmissionDetectedLanguageMutation, SetRequestFormSubmissionDetectedLanguageMutationVariables>;
export const UpdateOrganisationStaticContentByTypeDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateOrganisationStaticContentByType($type: String!, $content: jsonb!, $updatedBy: uuid!) {
  update_organisation_static_content(
    where: {type: {_eq: $type}}
    _set: {content: $content, updatedBy: $updatedBy}
  ) {
    returning {
      id
      content
      updatedBy: user {
        id
        firstName
        lastName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateOrganisationStaticContentByTypeMutation, UpdateOrganisationStaticContentByTypeMutationVariables>;
export const GetCustomFieldOptionDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFieldOption($id: uuid!) {
  customFieldOption: custom_field_choices_by_pk(id: $id) {
    id
    label
  }
}
    `) as unknown as TypedDocumentString<GetCustomFieldOptionQuery, GetCustomFieldOptionQueryVariables>;
export const CreateExternalUserDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateExternalUser($requestId: uuid!, $user: users_insert_input!) {
  insert_request_users_one(
    object: {requestId: $requestId, user: {data: $user, on_conflict: {constraint: users_email_organisation_id_key, update_columns: [email, firstName, lastName]}}}
    on_conflict: {constraint: request_users_user_id_request_id_key, update_columns: [userId]}
  ) {
    id
    user {
      id
      firstName
      lastName
      email
      role
    }
  }
}
    `) as unknown as TypedDocumentString<CreateExternalUserMutation, CreateExternalUserMutationVariables>;
export const GetAssigneesForRequestDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAssigneesForRequest($requestId: uuid!, $canvasModelId: String!) {
  requests(where: {_and: {id: {_eq: $requestId}, deletedAt: {_is_null: true}}}) {
    model
    steps(
      where: {_and: {canvasModelId: {_eq: $canvasModelId}, deletedAt: {_is_null: true}}}
    ) {
      id
      state
      request_step_users {
        user {
          email
          firstName
          lastName
          role
          id
          isArchived
          isOutOfOffice
        }
      }
      request_step_groups {
        group {
          name
          id
          isArchived
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAssigneesForRequestQuery, GetAssigneesForRequestQueryVariables>;
export const GetRequestResponsesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestResponses($requestId: uuid!) {
  request_forms(where: {requestId: {_eq: $requestId}}) {
    request_form_submissions(order_by: {submittedOn: desc_nulls_last}, limit: 1) {
      response
      submittedOn
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestResponsesQuery, GetRequestResponsesQueryVariables>;
export const GetRfxSupplierBySupplierAndStepIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxSupplierBySupplierAndStepIds($organisationSupplierId: uuid, $requestStepId: uuid!) {
  rfx_suppliers(
    where: {organisationSupplierId: {_eq: $organisationSupplierId}, rfx: {requestStepId: {_eq: $requestStepId}}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetRfxSupplierBySupplierAndStepIdsQuery, GetRfxSupplierBySupplierAndStepIdsQueryVariables>;
export const CreateEsignDocumentDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateEsignDocument($input: request_esign_documents_insert_input!) {
  insert_request_esign_documents_one(object: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateEsignDocumentMutation, CreateEsignDocumentMutationVariables>;
export const GetBlockConfigByTaskIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBlockConfigByTaskId($taskId: uuid!) {
  request_step_tasks_by_pk(id: $taskId) {
    id
    request_step {
      id
      input
    }
  }
}
    `) as unknown as TypedDocumentString<GetBlockConfigByTaskIdQuery, GetBlockConfigByTaskIdQueryVariables>;
export const GetRequestIdByTaskIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestIdByTaskId($taskId: uuid!) {
  request_step_tasks_by_pk(id: $taskId) {
    id
    request_step {
      id
      requestId
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestIdByTaskIdQuery, GetRequestIdByTaskIdQueryVariables>;
export const GetTaskConfigByTaskIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetTaskConfigByTaskId($taskId: uuid!) {
  request_step_tasks_by_pk(id: $taskId) {
    id
    config
  }
}
    `) as unknown as TypedDocumentString<GetTaskConfigByTaskIdQuery, GetTaskConfigByTaskIdQueryVariables>;
export const UpdateEsignTaskCompletedOnDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateEsignTaskCompletedOn($taskId: uuid!) {
  update_request_step_tasks_by_pk(
    pk_columns: {id: $taskId}
    _set: {completedOn: "now()"}
  ) {
    id
    request_step {
      id
      requestId
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateEsignTaskCompletedOnMutation, UpdateEsignTaskCompletedOnMutationVariables>;
export const UpdateRequestESignDocumentStatusDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestESignDocumentStatus($remoteId: String!, $status: String!) {
  update_request_esign_documents(
    where: {remoteId: {_eq: $remoteId}}
    _set: {status: $status}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UpdateRequestESignDocumentStatusMutation, UpdateRequestESignDocumentStatusMutationVariables>;
export const GetRequestWithStepsForRollbackDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestWithStepsForRollback($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    id
    completedAt
    steps(where: {deletedAt: {_is_null: true}}) {
      id
      state
      input
      type: input(path: "$.metadata.type")
      assignees: input(path: "$.metadata.config.payload.assignees")
      canvasModelParentIds
      canvasModelId
      output
      requestId
      workflowId
      data
      request_step_tasks {
        id
        type
        config
        request_form {
          id
          title
          type
        }
        request_form_submissions {
          id
        }
        request_step_task_rejections {
          id
        }
        request_step_task_errors {
          id
        }
        completedBy
      }
      request_step_users {
        id
      }
      request_step_groups {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestWithStepsForRollbackQuery, GetRequestWithStepsForRollbackQueryVariables>;
export const ReopenRequestDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ReopenRequest($requestId: uuid!) {
  update_requests_by_pk(pk_columns: {id: $requestId}, _set: {completedAt: null}) {
    id
  }
}
    `) as unknown as TypedDocumentString<ReopenRequestMutation, ReopenRequestMutationVariables>;
export const CreateEngagementDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateEngagement($engagement: engagements_insert_input!) {
  insert_engagements_one(object: $engagement) {
    id
    organisationSupplierId
  }
}
    `) as unknown as TypedDocumentString<CreateEngagementMutation, CreateEngagementMutationVariables>;
export const DeleteEngagementDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteEngagement($id: uuid!, $deleted_at: timestamptz!) {
  update_engagements_by_pk(pk_columns: {id: $id}, _set: {deleted_at: $deleted_at}) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteEngagementMutation, DeleteEngagementMutationVariables>;
export const GetEngagementRequestFormsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetEngagementRequestForms($requestId: uuid!) {
  forms: request_forms(
    where: {_and: {requestId: {_eq: $requestId}, form_type: {value: {_eq: "CREATE_ENGAGEMENT"}}}}
  ) {
    id
    config
    organisationId
    form_type {
      value
    }
  }
}
    `) as unknown as TypedDocumentString<GetEngagementRequestFormsQuery, GetEngagementRequestFormsQueryVariables>;
export const GetGroupUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGroupUsers($ids: [uuid!]!) {
  group_users(where: {groupId: {_in: $ids}}) {
    id
    user {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetGroupUsersQuery, GetGroupUsersQueryVariables>;
export const GetOrganisationSupplierProfilesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationSupplierProfiles($orgSupplierId: uuid!) {
  organisation_supplier_profiles(
    where: {organisationSupplierId: {_eq: $orgSupplierId}, deletedAt: {_is_null: true}}
  ) {
    id
    organisationSupplierId
    subsidiaryId
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationSupplierProfilesQuery, GetOrganisationSupplierProfilesQueryVariables>;
export const GetOrganisationSupplierTagsBySupplierIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationSupplierTagsBySupplierId($supplierId: uuid!) {
  organisation_supplier_tags(
    where: {_and: [{organisationSupplierId: {_eq: $supplierId}}, {tag: {deletedAt: {_is_null: true}}}]}
  ) {
    tag {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationSupplierTagsBySupplierIdQuery, GetOrganisationSupplierTagsBySupplierIdQueryVariables>;
export const GetRequestSupplierAndProductsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestSupplierAndProducts($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    id
    product {
      id
    }
    supplier {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestSupplierAndProductsQuery, GetRequestSupplierAndProductsQueryVariables>;
export const GetTasksByStepIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetTasksByStepId($stepId: uuid!) {
  tasks: request_step_tasks(where: {requestStepId: {_eq: $stepId}}) {
    id
    type
    completedOn
    config
  }
}
    `) as unknown as TypedDocumentString<GetTasksByStepIdQuery, GetTasksByStepIdQueryVariables>;
export const InsertOrganisationSupplierProfileDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertOrganisationSupplierProfile($orgSupplierId: uuid!, $subsidiaryId: uuid!) {
  insert_organisation_supplier_profiles_one(
    object: {organisationSupplierId: $orgSupplierId, subsidiaryId: $subsidiaryId}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertOrganisationSupplierProfileMutation, InsertOrganisationSupplierProfileMutationVariables>;
export const InsertOrganisationSupplierTagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertOrganisationSupplierTags($objects: [organisation_supplier_tags_insert_input!]!) {
  insert_organisation_supplier_tags(objects: $objects) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertOrganisationSupplierTagsMutation, InsertOrganisationSupplierTagsMutationVariables>;
export const InsertTagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertTags($objects: [tags_insert_input!]!) {
  createdOrgTags: insert_tags(
    objects: $objects
    on_conflict: {constraint: tags_name_organisation_id_key, update_columns: [deletedAt]}
  ) {
    returning {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<InsertTagsMutation, InsertTagsMutationVariables>;
export const ResolveRequestStepTaskErrorsByRequestStepTaskIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ResolveRequestStepTaskErrorsByRequestStepTaskId($requestStepTaskId: uuid!, $resolvedAt: timestamptz!) {
  update_request_step_task_errors(
    where: {request_step_task: {id: {_eq: $requestStepTaskId}}, resolvedAt: {_is_null: true}}
    _set: {resolvedAt: $resolvedAt}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<ResolveRequestStepTaskErrorsByRequestStepTaskIdMutation, ResolveRequestStepTaskErrorsByRequestStepTaskIdMutationVariables>;
export const UpdateRequestEngagementDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestEngagement($id: uuid!, $engagementId: uuid!) {
  update_requests(where: {id: {_eq: $id}}, _set: {engagementId: $engagementId}) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateRequestEngagementMutation, UpdateRequestEngagementMutationVariables>;
export const UpdateSupplierLastAssessmentDateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateSupplierLastAssessmentDate($supplierId: uuid!, $lastAssessmentDate: timestamptz!) {
  update_organisation_suppliers_by_pk(
    pk_columns: {id: $supplierId}
    _set: {lastAssessmentDate: $lastAssessmentDate}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateSupplierLastAssessmentDateMutation, UpdateSupplierLastAssessmentDateMutationVariables>;
export const CreatePurchaseOrderDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreatePurchaseOrder($purchaseOrder: purchase_orders_insert_input!) {
  insert_purchase_orders_one(object: $purchaseOrder) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreatePurchaseOrderMutation, CreatePurchaseOrderMutationVariables>;
export const CreatePurchaseOrderLineItemsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreatePurchaseOrderLineItems($objects: [purchase_order_line_items_insert_input!]!) {
  insert_purchase_order_line_items(objects: $objects) {
    returning {
      id
      lineNumber
    }
  }
}
    `) as unknown as TypedDocumentString<CreatePurchaseOrderLineItemsMutation, CreatePurchaseOrderLineItemsMutationVariables>;
export const DeletePurchaseOrderDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeletePurchaseOrder($id: uuid!) {
  update_purchase_order_line_items_many(
    updates: {where: {purchaseOrderId: {_eq: $id}}, _set: {deletedAt: "now()"}}
  ) {
    returning {
      id
    }
  }
  update_purchase_orders_by_pk(pk_columns: {id: $id}, _set: {deletedAt: "now()"}) {
    id
    remoteNumber
    remoteId
  }
}
    `) as unknown as TypedDocumentString<DeletePurchaseOrderMutation, DeletePurchaseOrderMutationVariables>;
export const GetRequestStepTaskLatestFormSubmissionDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepTaskLatestFormSubmission($requestStepTaskId: uuid!) {
  request_step_tasks_by_pk(id: $requestStepTaskId) {
    request_form_submissions(order_by: {submittedOn: desc}, limit: 1) {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepTaskLatestFormSubmissionQuery, GetRequestStepTaskLatestFormSubmissionQueryVariables>;
export const UpdatePurchaseOrderStatusByRequestIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdatePurchaseOrderStatusByRequestId($requestId: uuid!, $status: String!, $remoteLink: String, $remoteId: String, $remoteNumber: String, $formSubmissionId: uuid) {
  update_purchase_orders(
    where: {requestId: {_eq: $requestId}, deletedAt: {_is_null: true}}
    _set: {status: $status, remoteLink: $remoteLink, remoteId: $remoteId, remoteNumber: $remoteNumber, formSubmissionId: $formSubmissionId}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdatePurchaseOrderStatusByRequestIdMutation, UpdatePurchaseOrderStatusByRequestIdMutationVariables>;
export const GetLatestAgreementSubmissionOfRequestDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLatestAgreementSubmissionOfRequest($requestId: uuid!, $formType: form_type_enum!) {
  latestSubmission: request_form_submissions(
    where: {request_form: {requestId: {_eq: $requestId}, type: {_eq: $formType}}}
    limit: 1
    order_by: {submittedOn: desc_nulls_last}
  ) {
    id
    response
    submittedBy
    request_form {
      id
      config
      request {
        supplier {
          id
        }
        request_product
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetLatestAgreementSubmissionOfRequestQuery, GetLatestAgreementSubmissionOfRequestQueryVariables>;
export const GetAgreementTagsByAgreementIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAgreementTagsByAgreementId($agreementId: uuid!) {
  agreement_tags(
    where: {_and: [{agreementId: {_eq: $agreementId}}, {tag: {deletedAt: {_is_null: true}}}]}
  ) {
    tag {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetAgreementTagsByAgreementIdQuery, GetAgreementTagsByAgreementIdQueryVariables>;
export const GetSupplierBankDetailsAndAddressIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierBankDetailsAndAddressIds($orgSupplierId: uuid!) {
  organisation_suppliers_by_pk(id: $orgSupplierId) {
    entityBankDetails {
      ...EntityBankAccount
    }
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
      entityBankDetails {
        ...EntityBankAccount
      }
    }
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment EntityBankAccount on entity_bank_details {
  isPrimary
  bankDetails {
    ...BankAccount
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetSupplierBankDetailsAndAddressIdsQuery, GetSupplierBankDetailsAndAddressIdsQueryVariables>;
export const GetEngagementSubsidiaryIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetEngagementSubsidiaryId($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    engagement {
      subsidiaryId
    }
  }
}
    `) as unknown as TypedDocumentString<GetEngagementSubsidiaryIdQuery, GetEngagementSubsidiaryIdQueryVariables>;
export const GetExternalOperationFormResponsesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetExternalOperationFormResponses($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    request_forms(where: {type: {_eq: EXTERNAL_OPERATION}}) {
      request_form_submissions {
        submittedOn
        response
      }
      form_template {
        integration
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetExternalOperationFormResponsesQuery, GetExternalOperationFormResponsesQueryVariables>;
export const GetOrgSupplierByRemoteIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgSupplierByRemoteId($remoteId: String!) {
  organisation_suppliers(
    where: {remoteId: {_eq: $remoteId}, deleted_at: {_is_null: true}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetOrgSupplierByRemoteIdQuery, GetOrgSupplierByRemoteIdQueryVariables>;
export const GetOrgSupplierDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgSupplierData($orgSupplierId: uuid!) {
  organisation_suppliers_by_pk(id: $orgSupplierId) {
    id
    state
    website
    address
    taxNumber
    legalName
    remoteLink
    organisationIntegration {
      id
      integration
      defaultSupplierState
    }
    external_contacts(where: {deletedAt: {_is_null: true}}) {
      id
      firstName
      lastName
      email
      phoneNumber
      title
      isPrimary
    }
    paymentMethod {
      id
      name
    }
    paymentTerms {
      id
      name
    }
    entityBankDetails {
      ...EntityBankAccount
    }
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      paymentMethod {
        id
        name
      }
      paymentTerm {
        id
        name
      }
      subsidiary {
        id
        name
      }
      entityBankDetails {
        ...EntityBankAccount
      }
    }
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment EntityBankAccount on entity_bank_details {
  isPrimary
  bankDetails {
    ...BankAccount
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetOrgSupplierDataQuery, GetOrgSupplierDataQueryVariables>;
export const GetOrgSupplierDataMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgSupplierDataMinimal($orgSupplierId: uuid!) {
  organisation_suppliers_by_pk(id: $orgSupplierId) {
    id
    state
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrgSupplierDataMinimalQuery, GetOrgSupplierDataMinimalQueryVariables>;
export const GetOrganisationSupplierProfileResourcesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationSupplierProfileResources($where: organisation_supplier_profile_resources_bool_exp!) {
  organisation_supplier_profile_resources(where: $where) {
    id
    entityType
    entityId
    organisationSupplierProfileId
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationSupplierProfileResourcesQuery, GetOrganisationSupplierProfileResourcesQueryVariables>;
export const InsertAgreementTagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertAgreementTags($objects: [agreement_tags_insert_input!]!) {
  insert_agreement_tags(objects: $objects) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertAgreementTagsMutation, InsertAgreementTagsMutationVariables>;
export const InsertOrganisationSupplierProfileResourceDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertOrganisationSupplierProfileResource($object: organisation_supplier_profile_resources_insert_input!) {
  insert_organisation_supplier_profile_resources_one(object: $object) {
    id
    entityType
    entityId
    organisationSupplierProfileId
  }
}
    `) as unknown as TypedDocumentString<InsertOrganisationSupplierProfileResourceMutation, InsertOrganisationSupplierProfileResourceMutationVariables>;
export const UpdateOrganisationSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateOrganisationSupplier($set: organisation_suppliers_set_input!, $id: uuid!) {
  update_organisation_suppliers_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...OrganisationSupplierFragment
  }
}
    fragment OrganisationSupplierFragment on organisation_suppliers {
  id
  name
  website
  logoUrl
  isReseller
  createdAt
  remoteId
  lastAssessmentDate
  publicId
  organisationSupplierBrandId
  paymentMethod {
    id
    name
  }
  organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
    id
    subsidiary {
      id
      name
    }
  }
  address
}`) as unknown as TypedDocumentString<UpdateOrganisationSupplierMutation, UpdateOrganisationSupplierMutationVariables>;
export const UpdateOrganisationSupplierProfileResourceDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateOrganisationSupplierProfileResource($id: uuid!, $organisationSupplierProfileId: uuid!) {
  update_organisation_supplier_profile_resources_by_pk(
    pk_columns: {id: $id}
    _set: {organisationSupplierProfileId: $organisationSupplierProfileId}
  ) {
    id
    entityType
    entityId
    organisationSupplierProfileId
  }
}
    `) as unknown as TypedDocumentString<UpdateOrganisationSupplierProfileResourceMutation, UpdateOrganisationSupplierProfileResourceMutationVariables>;
export const UpdateOrganisationSupplierWithNewDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateOrganisationSupplierWithNewData($orgSupplierId: uuid!, $set: organisation_suppliers_set_input!) {
  updatedSupplier: update_organisation_suppliers_by_pk(
    pk_columns: {id: $orgSupplierId}
    _set: $set
  ) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<UpdateOrganisationSupplierWithNewDataMutation, UpdateOrganisationSupplierWithNewDataMutationVariables>;
export const InsertBankDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertBankDetails($object: bank_details_insert_input!) {
  insert_bank_details_one(object: $object) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertBankDetailsMutation, InsertBankDetailsMutationVariables>;
export const UpdateBankDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateBankDetails($id: uuid!, $object: bank_details_set_input!) {
  update_bank_details_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateBankDetailsMutation, UpdateBankDetailsMutationVariables>;
export const UpsertExternalRiskScoreDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertExternalRiskScore($input: external_risk_scores_insert_input!) {
  externalRiskScore: insert_external_risk_scores_one(
    object: $input
    on_conflict: {constraint: external_risk_scores_organisation_supplier_id_key, update_columns: [requestId, riskScore, date, files]}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpsertExternalRiskScoreMutation, UpsertExternalRiskScoreMutationVariables>;
export const UpsertOrganisationSupplierProfileDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertOrganisationSupplierProfile($object: organisation_supplier_profiles_insert_input!, $updateColumns: [organisation_supplier_profiles_update_column!]!) {
  insert_organisation_supplier_profiles_one(
    object: $object
    on_conflict: {constraint: uniq_subsidiary_id_organisation_supplier_id_deleted_at, update_columns: $updateColumns}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpsertOrganisationSupplierProfileMutation, UpsertOrganisationSupplierProfileMutationVariables>;
export const GetAllRequestStepTasksForRequestStepDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllRequestStepTasksForRequestStep($requestStepId: uuid!) {
  request_step_tasks(where: {requestStepId: {_eq: $requestStepId}}) {
    id
    type
    completedOn
  }
}
    `) as unknown as TypedDocumentString<GetAllRequestStepTasksForRequestStepQuery, GetAllRequestStepTasksForRequestStepQueryVariables>;
export const GetAllUsersForGroupIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllUsersForGroupIds($groupIds: [uuid!]) {
  group_users(where: {groupId: {_in: $groupIds}}, distinct_on: [userId]) {
    userId
  }
}
    `) as unknown as TypedDocumentString<GetAllUsersForGroupIdsQuery, GetAllUsersForGroupIdsQueryVariables>;
export const GetAssessmentBusinessOwnerDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAssessmentBusinessOwner($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    assessment {
      id
      businessOwnerUser {
        firstName
        lastName
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAssessmentBusinessOwnerQuery, GetAssessmentBusinessOwnerQueryVariables>;
export const GetDelegatesForOutOfOfficeDelegationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetDelegatesForOutOfOfficeDelegation($delegatorId: uuid!) {
  out_of_office_delegations(where: {delegatorId: {_eq: $delegatorId}}) {
    id
    delegateId
    createdAt
    delegate {
      id
      firstName
      lastName
      email
    }
  }
}
    `) as unknown as TypedDocumentString<GetDelegatesForOutOfOfficeDelegationQuery, GetDelegatesForOutOfOfficeDelegationQueryVariables>;
export const GetFormSubmissionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormSubmissions($requestStepId: uuid!) {
  request_steps_by_pk(id: $requestStepId) {
    id
    request_step_tasks {
      id
      type
      request_form_submissions(limit: 1, order_by: {submittedOn: desc}) {
        id
        response
        request_form {
          id
          config
          form_template {
            id
            internalId
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetFormSubmissionsQuery, GetFormSubmissionsQueryVariables>;
export const GetInProgressRequestStepsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetInProgressRequestSteps($userId: uuid!) {
  request_steps(
    where: {state: {_eq: RUNNING}, request_step_users: {userId: {_eq: $userId}}}
  ) {
    id
    requestId
    canvasModelId
  }
}
    `) as unknown as TypedDocumentString<GetInProgressRequestStepsQuery, GetInProgressRequestStepsQueryVariables>;
export const GetIntakeRequestFormDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetIntakeRequestForm($requestId: uuid!) {
  request_forms(
    where: {requestId: {_eq: $requestId}, type: {_in: [INTAKE, ACCESS_REQUEST, CATALOGUE_PURCHASE]}}
  ) {
    id
    request {
      id
      requestorUserId
    }
    request_form_submissions(limit: 1, order_by: {submittedOn: desc_nulls_last}) {
      id
      response
    }
  }
}
    `) as unknown as TypedDocumentString<GetIntakeRequestFormQuery, GetIntakeRequestFormQueryVariables>;
export const GetLatestRequestFormSubmissionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLatestRequestFormSubmissions($requestId: uuid!) {
  forms: request_forms(where: {requestId: {_eq: $requestId}}) {
    id
    type
    latestSubmissionArray: request_form_submissions(
      limit: 1
      order_by: {submittedOn: desc_nulls_last}
    ) {
      request_step_task {
        organisationSupplierId
      }
      id
      response
      submittedOn
    }
  }
  request: requests_by_pk(id: $requestId) {
    id
    supplier {
      id
    }
    renewal {
      id
      costCurrency
      costValue
      renewalDate
      cancellationNoticeDayCount
      note
      department {
        id
        name
      }
      supplier {
        id
        name
        remoteLink
        organisationIntegration {
          id
          integration
        }
      }
      product {
        id
        name
        logoUrl
        description
        displayName
        updatedAt
        website
        organisation_supplier {
          id
          name
          logoUrl
          website
          isReseller
        }
      }
    }
    assessment {
      id
      businessOwnerUser {
        id
        firstName
        lastName
        email
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetLatestRequestFormSubmissionsQuery, GetLatestRequestFormSubmissionsQueryVariables>;
export const GetRenewalAssessmentBlockStartedEventDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRenewalAssessmentBlockStartedEventData($requestStepId: uuid!) {
  requestStep: request_steps_by_pk(id: $requestStepId) {
    id
    request {
      id
      supplier {
        id
        name
      }
      renewal {
        id
        renewalDate
        cancellationNoticeDayCount
        product {
          id
          name: displayName
        }
        costValue
        costCurrency
        department {
          id
          name
        }
      }
      organisation {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRenewalAssessmentBlockStartedEventDataQuery, GetRenewalAssessmentBlockStartedEventDataQueryVariables>;
export const GetRequestCompletedSummaryApprovalTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestCompletedSummaryApprovalTasks($requestId: uuid!) {
  request_step_tasks(
    where: {_and: [{request_step: {requestId: {_eq: $requestId}}}, {completedBy: {_is_null: false}}], type: {_eq: SUMMARY_APPROVAL}}
  ) {
    id
    request_form {
      id
      formTemplateId
    }
    type
    completedBy
  }
}
    `) as unknown as TypedDocumentString<GetRequestCompletedSummaryApprovalTasksQuery, GetRequestCompletedSummaryApprovalTasksQueryVariables>;
export const GetRequestCompletedTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestCompletedTasks($requestId: uuid!) {
  request_step_tasks(
    where: {_and: [{request_step: {requestId: {_eq: $requestId}}}, {completedBy: {_is_null: false}}, {_or: [{request_form: {type: {_neq: INTAKE}}}, {type: {_eq: REVIEW}}]}]}
  ) {
    id
    request_form {
      id
      formTemplateId
    }
    type
    completedBy
  }
}
    `) as unknown as TypedDocumentString<GetRequestCompletedTasksQuery, GetRequestCompletedTasksQueryVariables>;
export const GetRequestFormSubmissionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFormSubmissions($requestFormIds: [uuid!]!) {
  request_form_submissions(where: {_and: {requestFormId: {_in: $requestFormIds}}}) {
    id
    requestFormId
  }
}
    `) as unknown as TypedDocumentString<GetRequestFormSubmissionsQuery, GetRequestFormSubmissionsQueryVariables>;
export const GetRequestFormsForTemplateIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFormsForTemplateIds($formTemplateIds: [uuid!]!, $requestId: uuid!) {
  request_forms(
    where: {_and: {formTemplateId: {_in: $formTemplateIds}, requestId: {_eq: $requestId}}}
  ) {
    id
    formTemplateId
    type
  }
}
    `) as unknown as TypedDocumentString<GetRequestFormsForTemplateIdsQuery, GetRequestFormsForTemplateIdsQueryVariables>;
export const GetRequestOneMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestOneMinimal($id: uuid!) {
  requests_by_pk(id: $id) {
    ...RequestFragmentMinimal
  }
}
    fragment RequestFragmentMinimal on requests {
  id
  name
  state
  workflowId
  model
  requestorUserId
  tagIds
}`) as unknown as TypedDocumentString<GetRequestOneMinimalQuery, GetRequestOneMinimalQueryVariables>;
export const GetRequestOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestOne($id: uuid!) {
  requests_by_pk(id: $id) {
    ...RequestFragment
    product {
      ...OrganisationProductsAndServiceFragment
    }
  }
}
    fragment RequestFragment on requests {
  id
  name
  state
  workflowId
  requestorUserId
  createdAt
  updatedAt
  priority
  completedAt
  model
  tagIds
  type
  request_product
  request_supplier
  publicId
  totalPausedTime
  agreement_term {
    agreementId
  }
  owner {
    id
    firstName
    lastName
  }
  user {
    id
    firstName
    lastName
    email
  }
}
fragment OrganisationProductsAndServiceFragment on organisation_products_and_services {
  id
  name
  displayName
  website
  logoUrl
  createdAt
  updatedAt
  description
  isArchived
  state
  businessOwner {
    id
    firstName
    lastName
  }
  organisation_supplier {
    state
    id
    website
    logoUrl
    name
    externalLink
    organisation_supplier_brand {
      id
      supplierId
    }
    external_contacts(where: {deletedAt: {_is_null: true}}) {
      id
      email
      firstName
      lastName
      isPrimary
      phoneNumber
      title
    }
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
    }
  }
  engagements {
    id
    name
    department
  }
}`) as unknown as TypedDocumentString<GetRequestOneQuery, GetRequestOneQueryVariables>;
export const GetRequestStartFormDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStartForm($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    id
    request_forms(where: {type: {_in: [INTAKE, RENEWAL_ASSESSMENT]}}) {
      id
      formTemplateId
    }
    requestorUserId
  }
}
    `) as unknown as TypedDocumentString<GetRequestStartFormQuery, GetRequestStartFormQueryVariables>;
export const GetRequestStepDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepData($id: uuid!) {
  request_steps_by_pk(id: $id) {
    id
    data
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepDataQuery, GetRequestStepDataQueryVariables>;
export const GetRequestStepGroupsForRequestStepDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepGroupsForRequestStep($requestStepId: uuid!) {
  request_step_groups(where: {requestStepId: {_eq: $requestStepId}}) {
    id
    groupId
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepGroupsForRequestStepQuery, GetRequestStepGroupsForRequestStepQueryVariables>;
export const GetRequestStepUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepUsers($requestStepId: uuid!) {
  request_step_users(where: {requestStepId: {_eq: $requestStepId}}) {
    id
    userId
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepUsersQuery, GetRequestStepUsersQueryVariables>;
export const GetRequestInformationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestInformation($id: uuid!) {
  requests_by_pk(id: $id) {
    name
    id
    publicId
    supplier {
      id
      publicId
      name
      state
      website
      legalName
      remoteId
      external_contacts(where: {deletedAt: {_is_null: true}}) {
        id
        firstName
        lastName
        email
        phoneNumber
        title
        isPrimary
      }
    }
    product {
      id
      name
      website
    }
    workflow {
      id
      title
      type
    }
    organisation {
      id
      name
    }
    requestor: user {
      id
      firstName
      lastName
      email
    }
    workflow {
      id
      title
    }
    engagement {
      id
    }
    purchase_orders(
      where: {status: {_eq: "ACTIVE"}, deletedAt: {_is_null: true}}
      order_by: {createdAt: desc}
      limit: 1
    ) {
      id
    }
    renewal {
      id
      renewalDate
      product {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestInformationQuery, GetRequestInformationQueryVariables>;
export const GetRequestorDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestor($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    id
    user {
      firstName
      lastName
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestorQuery, GetRequestorQueryVariables>;
export const GetStepKeyTimesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetStepKeyTimes($requestStepId: uuid!) {
  requestStep: request_steps_by_pk(id: $requestStepId) {
    id
    createdAt
    totalPausedWorkingHours
  }
}
    `) as unknown as TypedDocumentString<GetStepKeyTimesQuery, GetStepKeyTimesQueryVariables>;
export const GetTaskApprovalInformationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetTaskApprovalInformation($taskId: uuid!, $requestId: uuid!) {
  organisations {
    id
    name
  }
  requests_by_pk(id: $requestId) {
    id
    name
    requestor: user {
      firstName
      lastName
      id
    }
  }
  request_step_tasks_by_pk(id: $taskId) {
    id
    completedBy
    completedOn
    type
    request_form {
      id
      type
    }
    approver: user {
      firstName
      lastName
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetTaskApprovalInformationQuery, GetTaskApprovalInformationQueryVariables>;
export const InsertRequestStepTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRequestStepTasks($objects: [request_step_tasks_insert_input!] = {}) {
  insert_request_step_tasks(objects: $objects) {
    returning {
      id
      requestStepId
      requestFormId
      type
      config
      created_at
    }
  }
}
    `) as unknown as TypedDocumentString<InsertRequestStepTasksMutation, InsertRequestStepTasksMutationVariables>;
export const InsertRequestStepUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRequestStepUsers($objects: [request_step_users_insert_input!]!) {
  insert_request_step_users(
    on_conflict: {update_columns: [], constraint: request_step_users_request_step_id_user_id_key}
    objects: $objects
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertRequestStepUsersMutation, InsertRequestStepUsersMutationVariables>;
export const ResolveRequestStepTaskErrorsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ResolveRequestStepTaskErrors($requestStepId: uuid!, $resolvedAt: timestamptz!) {
  update_request_step_task_errors(
    where: {request_step_task: {requestStepId: {_eq: $requestStepId}}, resolvedAt: {_is_null: true}}
    _set: {resolvedAt: $resolvedAt}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<ResolveRequestStepTaskErrorsMutation, ResolveRequestStepTaskErrorsMutationVariables>;
export const SaveNotificationMessageDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SaveNotificationMessage($object: request_step_notification_messages_insert_input!) {
  insert_request_step_notification_messages_one(object: $object) {
    requestStepId
  }
}
    `) as unknown as TypedDocumentString<SaveNotificationMessageMutation, SaveNotificationMessageMutationVariables>;
export const UpdateRenewalRenewedAtDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRenewalRenewedAt($requestId: uuid!) {
  update_renewals(
    _set: {renewedAt: "now()"}
    where: {renewedAt: {_is_null: true}, cancelledAt: {_is_null: true}, requestId: {_eq: $requestId}}
  ) {
    returning {
      renewedAt
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateRenewalRenewedAtMutation, UpdateRenewalRenewedAtMutationVariables>;
export const UpsertRequestGroupsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertRequestGroups($objects: [request_groups_insert_input!]!) {
  insert_request_groups(
    on_conflict: {update_columns: [], constraint: request_groups_request_id_group_id_key}
    objects: $objects
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpsertRequestGroupsMutation, UpsertRequestGroupsMutationVariables>;
export const UpsertRequestUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertRequestUsers($objects: [request_users_insert_input!]!) {
  insert_request_users(
    on_conflict: {update_columns: [], constraint: request_users_user_id_request_id_key}
    objects: $objects
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpsertRequestUsersMutation, UpsertRequestUsersMutationVariables>;
export const AutocompleteRequestStepTaskDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation AutocompleteRequestStepTask($taskId: uuid!) {
  update_request_step_tasks_by_pk(
    pk_columns: {id: $taskId}
    _set: {completedOn: "now()"}
  ) {
    completedBy
    completedOn
    id
  }
}
    `) as unknown as TypedDocumentString<AutocompleteRequestStepTaskMutation, AutocompleteRequestStepTaskMutationVariables>;
export const GetGroupMembershipsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGroupMemberships($userId: uuid!, $groupIds: [uuid!]) {
  group_users(where: {groupId: {_in: $groupIds}, userId: {_eq: $userId}}) {
    id
    groupId
  }
}
    `) as unknown as TypedDocumentString<GetGroupMembershipsQuery, GetGroupMembershipsQueryVariables>;
export const GetGroupsOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGroupsOne($id: uuid!) {
  groups_by_pk(id: $id) {
    ...GroupFragment
    group_users {
      id
      userId
    }
  }
}
    fragment GroupFragment on groups {
  id
  name
  rawAttributes
  organisationId
  isArchived
}`) as unknown as TypedDocumentString<GetGroupsOneQuery, GetGroupsOneQueryVariables>;
export const GetRequestDocumentsByFilestoreIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestDocumentsByFilestoreIds($filestoreIds: [uuid!]!) {
  request_documents(
    where: {filestoreId: {_in: $filestoreIds}, deletedAt: {_is_null: true}}
  ) {
    id
    filestoreId
  }
}
    `) as unknown as TypedDocumentString<GetRequestDocumentsByFilestoreIdsQuery, GetRequestDocumentsByFilestoreIdsQueryVariables>;
export const GetRfxByRequestIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxByRequestId($requestId: uuid!) {
  rfx(where: {requestId: {_eq: $requestId}}, limit: 1) {
    id
    requestStepId
    requestId
    isReopened
  }
}
    `) as unknown as TypedDocumentString<GetRfxByRequestIdQuery, GetRfxByRequestIdQueryVariables>;
export const GetRfxSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxSupplier($id: uuid!) {
  rfx_suppliers_by_pk(id: $id) {
    organisationProductId
    organisationSupplierId
  }
}
    `) as unknown as TypedDocumentString<GetRfxSupplierQuery, GetRfxSupplierQueryVariables>;
export const InsertRfxOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRfxOne($rfx: rfx_insert_input!) {
  insert_rfx_one(object: $rfx) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertRfxOneMutation, InsertRfxOneMutationVariables>;
export const SetRequestSupplierAndProductDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SetRequestSupplierAndProduct($requestId: uuid!, $organisationSupplierId: uuid!, $organisationProductId: uuid!) {
  update_requests_by_pk(
    pk_columns: {id: $requestId}
    _set: {request_supplier: $organisationSupplierId, request_product: $organisationProductId}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<SetRequestSupplierAndProductMutation, SetRequestSupplierAndProductMutationVariables>;
export const GetAssigneeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAssignee($id: uuid!) {
  users_by_pk(id: $id) {
    id
    email
    firstName
    lastName
    role
    isArchived
  }
}
    `) as unknown as TypedDocumentString<GetAssigneeQuery, GetAssigneeQueryVariables>;
export const GetSupplierPortalAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierPortalAssignees($requestStepId: uuid!) {
  request_steps_by_pk(id: $requestStepId) {
    id
    canvasModelId
    targetTimeValue: input(path: "$.metadata.config.payload.targetTimeValue")
    request {
      id
      model
      name
      workflow {
        id
        title
        type
      }
      user {
        id
        firstName
        lastName
      }
      product {
        id
        displayName
      }
      supplier {
        id
        name
      }
      organisation {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetSupplierPortalAssigneesQuery, GetSupplierPortalAssigneesQueryVariables>;
export const CreateGroupUserAssignmentDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateGroupUserAssignment($groupId: uuid!, $userId: uuid!, $requestId: uuid!, $method: String!) {
  insert_group_user_assignments_one(
    object: {groupId: $groupId, userId: $userId, requestId: $requestId, method: $method}
  ) {
    id
    groupId
    userId
    requestId
    method
    createdAt
  }
}
    `) as unknown as TypedDocumentString<CreateGroupUserAssignmentMutation, CreateGroupUserAssignmentMutationVariables>;
export const GetExistingGroupUserAssignmentOnRequestDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetExistingGroupUserAssignmentOnRequest($requestId: uuid!, $groupId: uuid!, $method: String!) {
  group_user_assignments(
    where: {requestId: {_eq: $requestId}, groupId: {_eq: $groupId}, method: {_eq: $method}}
    order_by: [{createdAt: desc}]
  ) {
    userId
    createdAt
    requestId
    method
    id
  }
}
    `) as unknown as TypedDocumentString<GetExistingGroupUserAssignmentOnRequestQuery, GetExistingGroupUserAssignmentOnRequestQueryVariables>;
export const GetGroupMembersWithUserDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGroupMembersWithUserData($groupId: uuid!) {
  group_users(
    where: {groupId: {_eq: $groupId}, user: {isArchived: {_eq: false}}}
    order_by: [{user: {firstName: asc}}, {user: {lastName: asc}}]
  ) {
    id
    user {
      id
      firstName
      lastName
      email
      isOutOfOffice
    }
    assignments_aggregate {
      aggregate {
        max {
          createdAt
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetGroupMembersWithUserDataQuery, GetGroupMembersWithUserDataQueryVariables>;
export const DeleteRequestStepGroupsByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRequestStepGroupsByIds($groupIds: [uuid!]!, $requestStepId: uuid!) {
  delete_request_step_groups(
    where: {groupId: {_in: $groupIds}, requestStepId: {_eq: $requestStepId}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteRequestStepGroupsByIdsMutation, DeleteRequestStepGroupsByIdsMutationVariables>;
export const DeleteRequestStepUsersByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRequestStepUsersByIds($userIds: [uuid!]!, $requestStepId: uuid!) {
  delete_request_step_users(
    where: {userId: {_in: $userIds}, requestStepId: {_eq: $requestStepId}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteRequestStepUsersByIdsMutation, DeleteRequestStepUsersByIdsMutationVariables>;
export const InsertRequestStepGroupsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRequestStepGroups($objects: [request_step_groups_insert_input!]!) {
  insert_request_step_groups(
    on_conflict: {update_columns: [], constraint: request_step_groups_request_step_id_group_id_key}
    objects: $objects
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertRequestStepGroupsMutation, InsertRequestStepGroupsMutationVariables>;
export const CompleteStepDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CompleteStep($id: uuid!, $state: request_step_state_enum!, $result: request_step_result_enum!, $output: jsonb!, $data: jsonb!) {
  update_request_steps_by_pk(
    pk_columns: {id: $id}
    _set: {state: $state, result: $result, output: $output, data: $data, completedAt: "now()"}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<CompleteStepMutation, CompleteStepMutationVariables>;
export const CountUncompletedRequestStepDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query CountUncompletedRequestStepDependencies($requestId: uuid!, $ids: [String!]!) {
  request_steps(where: {requestId: {_eq: $requestId}, canvasModelId: {_in: $ids}}) {
    id
    completedAt
  }
}
    `) as unknown as TypedDocumentString<CountUncompletedRequestStepDependenciesQuery, CountUncompletedRequestStepDependenciesQueryVariables>;
export const GetActiveRequestFollowersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetActiveRequestFollowers($requestId: uuid!) {
  request_followers(
    where: {requestId: {_eq: $requestId}, deletedAt: {_is_null: true}, _or: [{user: {isArchived: {_eq: false}}}, {group: {isArchived: {_eq: false}}}]}
  ) {
    id
    assigneeType
    user {
      id
    }
    group {
      id
      group_users {
        id
        user {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetActiveRequestFollowersQuery, GetActiveRequestFollowersQueryVariables>;
export const GetConditionDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetConditionData($id: uuid!) {
  requests_by_pk(id: $id) {
    id
    tagIds
    request_tags {
      id
      tag {
        id
        name
      }
    }
    supplier {
      id
      state
      organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
        id
        subsidiaryId
      }
      organisation_supplier_tags {
        id
        tag {
          id
          name
        }
      }
    }
    product {
      state
    }
    request_forms {
      id
      config
    }
  }
}
    `) as unknown as TypedDocumentString<GetConditionDataQuery, GetConditionDataQueryVariables>;
export const GetRequestNotificationDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestNotificationDetails($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    id
    name
    requestorUserId
    ownerId
    type
    publicId
    assessment {
      id
    }
    organisation {
      id
      name
    }
    followers {
      id
      assigneeType
      user {
        id
      }
      group {
        id
        group_users {
          id
          user {
            id
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestNotificationDetailsQuery, GetRequestNotificationDetailsQueryVariables>;
export const GetRequestStepByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepById($id: uuid!) {
  request_steps_by_pk(id: $id) {
    id
    canvasModelParentIds
    type: input(path: "$.metadata.type")
    assignees: input(path: "$.metadata.config.payload.assignees")
    notificationMessage: input(
      path: "$.metadata.config.payload.notificationMessage"
    )
    label: input(path: "$.metadata.config.payload.label")
    targetTimeValue: input(path: "$.metadata.config.payload.targetTimeValue")
    tasks: input(path: "$.metadata.config.payload.tasks")
    input
    state
    workflowId
    data
    requestId
    canvasModelId
    result
    output
    actionTakenAt
    request {
      id
      state
    }
    request_step_tasks {
      id
      type
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepByIdQuery, GetRequestStepByIdQueryVariables>;
export const GetSavedNotificationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSavedNotification($requestStepId: uuid!) {
  request_step_notification_messages_by_pk(requestStepId: $requestStepId) {
    body
    subject
  }
}
    `) as unknown as TypedDocumentString<GetSavedNotificationQuery, GetSavedNotificationQueryVariables>;
export const UpdateRenewalCancelledDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRenewalCancelled($requestId: uuid!) {
  update_renewals(
    _set: {cancelledAt: "now()"}
    where: {renewedAt: {_is_null: true}, cancelledAt: {_is_null: true}, requestId: {_eq: $requestId}}
  ) {
    returning {
      cancelledAt
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateRenewalCancelledMutation, UpdateRenewalCancelledMutationVariables>;
export const UpdateRequestCompletionDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestCompletion($id: uuid!) {
  update_requests_by_pk(_set: {completedAt: "now()"}, pk_columns: {id: $id}) {
    ...RequestFragment
    product {
      id
    }
  }
}
    fragment RequestFragment on requests {
  id
  name
  state
  workflowId
  requestorUserId
  createdAt
  updatedAt
  priority
  completedAt
  model
  tagIds
  type
  request_product
  request_supplier
  publicId
  totalPausedTime
  agreement_term {
    agreementId
  }
  owner {
    id
    firstName
    lastName
  }
  user {
    id
    firstName
    lastName
    email
  }
}`) as unknown as TypedDocumentString<UpdateRequestCompletionMutation, UpdateRequestCompletionMutationVariables>;
export const UpdateRequestProductDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestProduct($productId: uuid, $supplierId: uuid, $id: uuid!) {
  update_requests_by_pk(
    pk_columns: {id: $id}
    _set: {request_product: $productId, request_supplier: $supplierId}
  ) {
    ...RequestFragment
  }
}
    fragment RequestFragment on requests {
  id
  name
  state
  workflowId
  requestorUserId
  createdAt
  updatedAt
  priority
  completedAt
  model
  tagIds
  type
  request_product
  request_supplier
  publicId
  totalPausedTime
  agreement_term {
    agreementId
  }
  owner {
    id
    firstName
    lastName
  }
  user {
    id
    firstName
    lastName
    email
  }
}`) as unknown as TypedDocumentString<UpdateRequestProductMutation, UpdateRequestProductMutationVariables>;
export const UpdateRequestStepDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestStepData($id: uuid!, $setInput: request_steps_set_input) {
  update_request_steps(
    where: {id: {_eq: $id}, state: {_nin: [COMPLETE]}}
    _set: $setInput
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UpdateRequestStepDataMutation, UpdateRequestStepDataMutationVariables>;
export const GetAllCustomFieldValuesPaginatedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllCustomFieldValuesPaginated($entityType: String!, $offset: Int!, $limit: Int!) {
  custom_field_values(
    where: {customField: {entityType: {_eq: $entityType}}}
    offset: $offset
    limit: $limit
  ) {
    ...CustomFieldValueFragment
  }
  custom_field_values_aggregate(
    where: {customField: {entityType: {_eq: $entityType}}}
  ) {
    aggregate {
      count
    }
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetAllCustomFieldValuesPaginatedQuery, GetAllCustomFieldValuesPaginatedQueryVariables>;
export const DeleteCustomFieldDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteCustomField($id: uuid!) {
  customField: update_custom_fields_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
    deletedAt
  }
  update_custom_field_values(
    where: {customFieldId: {_eq: $id}}
    _set: {deletedAt: "now()"}
  ) {
    returning {
      id
      customFieldCoreDataId
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteCustomFieldMutation, DeleteCustomFieldMutationVariables>;
export const DeleteCustomFieldCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteCustomFieldCoreData($ids: [uuid!]!) {
  update_custom_field_core_data(
    where: {id: {_in: $ids}}
    _set: {deleted_at: "now()"}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteCustomFieldCoreDataMutation, DeleteCustomFieldCoreDataMutationVariables>;
export const DeleteCustomFieldCoreDataValuesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteCustomFieldCoreDataValues($ids: [uuid!]!) {
  update_custom_field_core_data(
    where: {id: {_in: $ids}}
    _set: {deleted_at: "now()"}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteCustomFieldCoreDataValuesMutation, DeleteCustomFieldCoreDataValuesMutationVariables>;
export const DeleteCustomFieldIdpAttributeMappingDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteCustomFieldIdpAttributeMapping($customFieldId: uuid!) {
  delete_idp_attribute_mappings(where: {customFieldId: {_eq: $customFieldId}}) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteCustomFieldIdpAttributeMappingMutation, DeleteCustomFieldIdpAttributeMappingMutationVariables>;
export const DeleteCustomFieldValuesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteCustomFieldValues($ids: [uuid!]!) {
  update_custom_field_values(where: {id: {_in: $ids}}, _set: {deletedAt: "now()"}) {
    returning {
      id
      value
      entityId
      customFieldId
      customFieldChoiceId
      customFieldCoreDataId
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteCustomFieldValuesMutation, DeleteCustomFieldValuesMutationVariables>;
export const GetAllCustomFieldValuesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllCustomFieldValues($entityType: String!) {
  custom_field_values(where: {customField: {entityType: {_eq: $entityType}}}) {
    ...CustomFieldValueFragment
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetAllCustomFieldValuesQuery, GetAllCustomFieldValuesQueryVariables>;
export const GetChoicesOfCustomFieldDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetChoicesOfCustomField($customFieldId: uuid!) {
  custom_field_choices(where: {customFieldId: {_eq: $customFieldId}}) {
    id
    label
  }
}
    `) as unknown as TypedDocumentString<GetChoicesOfCustomFieldQuery, GetChoicesOfCustomFieldQueryVariables>;
export const GetCustomCoreDataByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataById($customCoreDataId: uuid!) {
  custom_core_data_by_pk(id: $customCoreDataId) {
    ...CustomCoreData
  }
}
    fragment CustomCoreData on custom_core_data {
  id
  name
  organisationId
  pathLevels
  archivedAt
  organisationIntegration {
    id
    integration
  }
  options: custom_core_data_options(where: {isArchived: {_eq: false}}) {
    ...CustomCoreDataOption
  }
  numOptions: custom_core_data_options_aggregate(
    where: {isArchived: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<GetCustomCoreDataByIdQuery, GetCustomCoreDataByIdQueryVariables>;
export const GetCustomCoreDataOptionsWithDependenciesByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataOptionsWithDependenciesById($customCoreDataId: uuid!) {
  custom_core_data_options(
    where: {customCoreDataId: {_eq: $customCoreDataId}, isArchived: {_eq: false}}
  ) {
    ...CustomCoreDataOptionWithDependencies
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}
fragment CustomCoreDataOptionWithDependencies on custom_core_data_options {
  ...CustomCoreDataOption
  coreData {
    id
    coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
      ...CoreDataDependencies
    }
  }
}`) as unknown as TypedDocumentString<GetCustomCoreDataOptionsWithDependenciesByIdQuery, GetCustomCoreDataOptionsWithDependenciesByIdQueryVariables>;
export const GetCustomCoreDataOptionsWithDependenciesByIdInclArchivedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataOptionsWithDependenciesByIdInclArchived($customCoreDataId: uuid!) {
  custom_core_data_options(where: {customCoreDataId: {_eq: $customCoreDataId}}) {
    ...CustomCoreDataOptionWithDependencies
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}
fragment CustomCoreDataOptionWithDependencies on custom_core_data_options {
  ...CustomCoreDataOption
  coreData {
    id
    coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
      ...CoreDataDependencies
    }
  }
}`) as unknown as TypedDocumentString<GetCustomCoreDataOptionsWithDependenciesByIdInclArchivedQuery, GetCustomCoreDataOptionsWithDependenciesByIdInclArchivedQueryVariables>;
export const GetCustomCoreDataWithDependenciesByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataWithDependenciesById($customCoreDataId: uuid!) {
  custom_core_data_by_pk(id: $customCoreDataId) {
    ...CustomCoreDataWithDependencies
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment CustomCoreData on custom_core_data {
  id
  name
  organisationId
  pathLevels
  archivedAt
  organisationIntegration {
    id
    integration
  }
  options: custom_core_data_options(where: {isArchived: {_eq: false}}) {
    ...CustomCoreDataOption
  }
  numOptions: custom_core_data_options_aggregate(
    where: {isArchived: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}
fragment CustomCoreDataOptionWithDependencies on custom_core_data_options {
  ...CustomCoreDataOption
  coreData {
    id
    coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
      ...CoreDataDependencies
    }
  }
}
fragment CustomCoreDataWithDependencies on custom_core_data {
  ...CustomCoreData
  options: custom_core_data_options(where: {isArchived: {_eq: false}}) {
    ...CustomCoreDataOptionWithDependencies
  }
}`) as unknown as TypedDocumentString<GetCustomCoreDataWithDependenciesByIdQuery, GetCustomCoreDataWithDependenciesByIdQueryVariables>;
export const GetCustomCoreDataWithDependenciesMetadataByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomCoreDataWithDependenciesMetadataByIds($customCoreDataIds: [uuid!]!, $depsLimit: Int!) {
  customCoreDatum: custom_core_data(where: {id: {_in: $customCoreDataIds}}) {
    ...CustomCoreDataWithDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreData on custom_core_data {
  id
  name
  organisationId
  pathLevels
  archivedAt
  organisationIntegration {
    id
    integration
  }
  options: custom_core_data_options(where: {isArchived: {_eq: false}}) {
    ...CustomCoreDataOption
  }
  numOptions: custom_core_data_options_aggregate(
    where: {isArchived: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
}
fragment CustomCoreDataOption on custom_core_data_options {
  id
  value
  isArchived
  archivedBy
  customCoreDataId
  parentId
  isTerminal
  remoteId
  coreDataId
}
fragment CustomCoreDataOptionWithDependenciesMetadata on custom_core_data_options {
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
fragment CustomCoreDataWithDependenciesMetadata on custom_core_data {
  ...CustomCoreData
  options: custom_core_data_options(where: {isArchived: {_eq: false}}) {
    ...CustomCoreDataOptionWithDependenciesMetadata
  }
}`) as unknown as TypedDocumentString<GetCustomCoreDataWithDependenciesMetadataByIdsQuery, GetCustomCoreDataWithDependenciesMetadataByIdsQueryVariables>;
export const GetCustomFieldValuesByCustomFieldIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFieldValuesByCustomFieldId($customFieldId: uuid!, $entityId: uuid!) {
  custom_field_values(
    where: {customFieldId: {_eq: $customFieldId}, entityId: {_eq: $entityId}}
  ) {
    id
    value
    booleanValue
    numberValue
    fileId
    file {
      id
      fileName
      filestoreId
    }
    entityId
    customFieldId
    customFieldChoiceId
    customFieldCoreDataId
    customField {
      id
      externalSource
    }
    choice {
      id
      label
    }
    customFieldCoreData {
      department {
        id
        name
        isArchived
      }
      paymentTerm {
        id
        name
        isArchived
      }
      paymentMethod {
        id
        name
        isArchived
      }
      subsidiary {
        id
        name
        isArchived
      }
      currency {
        id
        name
        code
        isArchived
      }
      lineItemType {
        id
        name
        isArchived
      }
      address {
        id
        name
        isArchived
      }
      customCoreDataOption {
        id
        customCoreDataId
        value
        isArchived
        isTerminal
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCustomFieldValuesByCustomFieldIdQuery, GetCustomFieldValuesByCustomFieldIdQueryVariables>;
export const GetCustomFieldValuesForEntitiesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFieldValuesForEntities($entityIds: [uuid!]!) {
  custom_field_values(where: {entityId: {_in: $entityIds}}) {
    ...CustomFieldValueFragment
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetCustomFieldValuesForEntitiesQuery, GetCustomFieldValuesForEntitiesQueryVariables>;
export const GetCustomFieldValuesOfEntityDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFieldValuesOfEntity($entityId: uuid!) {
  custom_field_values(where: {entityId: {_eq: $entityId}}) {
    ...CustomFieldValueFragment
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}`) as unknown as TypedDocumentString<GetCustomFieldValuesOfEntityQuery, GetCustomFieldValuesOfEntityQueryVariables>;
export const GetCustomFieldsByEntityTypeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFieldsByEntityType($entityType: String!) {
  customFields: custom_fields(
    where: {deletedAt: {_is_null: true}, entityType: {_eq: $entityType}}
    order_by: {createdAt: asc}
  ) {
    ...CustomField
  }
}
    fragment CustomField on custom_fields {
  id
  title
  type
  externalSource
  customCoreDataId
  isRequired
  updatedAt
  entityType
  dependsOnCustomFieldId
  organisationIntegrationId
  choices {
    id
    label
  }
  allowUserToAddCustomOptions
  remoteId
  customCoreData {
    id
    pathLevels
  }
}`) as unknown as TypedDocumentString<GetCustomFieldsByEntityTypeQuery, GetCustomFieldsByEntityTypeQueryVariables>;
export const GetCustomFieldByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFieldById($id: uuid!) {
  customField: custom_fields_by_pk(id: $id) {
    ...CustomField
  }
}
    fragment CustomField on custom_fields {
  id
  title
  type
  externalSource
  customCoreDataId
  isRequired
  updatedAt
  entityType
  dependsOnCustomFieldId
  organisationIntegrationId
  choices {
    id
    label
  }
  allowUserToAddCustomOptions
  remoteId
  customCoreData {
    id
    pathLevels
  }
}`) as unknown as TypedDocumentString<GetCustomFieldByIdQuery, GetCustomFieldByIdQueryVariables>;
export const GetCustomFieldsByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFieldsByIds($ids: [uuid!]!) {
  customFields: custom_fields(
    where: {deletedAt: {_is_null: true}, id: {_in: $ids}}
  ) {
    ...CustomField
  }
}
    fragment CustomField on custom_fields {
  id
  title
  type
  externalSource
  customCoreDataId
  isRequired
  updatedAt
  entityType
  dependsOnCustomFieldId
  organisationIntegrationId
  choices {
    id
    label
  }
  allowUserToAddCustomOptions
  remoteId
  customCoreData {
    id
    pathLevels
  }
}`) as unknown as TypedDocumentString<GetCustomFieldsByIdsQuery, GetCustomFieldsByIdsQueryVariables>;
export const InsertCustomFieldDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertCustomField($input: custom_fields_insert_input!) {
  customField: insert_custom_fields_one(object: $input) {
    id
    title
    isRequired
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<InsertCustomFieldMutation, InsertCustomFieldMutationVariables>;
export const InsertCustomFieldChoiceDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertCustomFieldChoice($input: custom_field_choices_insert_input!) {
  insert_custom_field_choices_one(object: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertCustomFieldChoiceMutation, InsertCustomFieldChoiceMutationVariables>;
export const InsertCustomFieldCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertCustomFieldCoreData($input: custom_field_core_data_insert_input!) {
  insert_custom_field_core_data_one(object: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertCustomFieldCoreDataMutation, InsertCustomFieldCoreDataMutationVariables>;
export const InsertCustomFieldValuesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertCustomFieldValues($objects: [custom_field_values_insert_input!]!) {
  customFieldValues: insert_custom_field_values(objects: $objects) {
    returning {
      id
      value
      booleanValue
      numberValue
      entityId
      customFieldId
    }
  }
}
    `) as unknown as TypedDocumentString<InsertCustomFieldValuesMutation, InsertCustomFieldValuesMutationVariables>;
export const RestoreCustomFieldDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation RestoreCustomField($id: uuid!) {
  customField: update_custom_fields_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: null}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<RestoreCustomFieldMutation, RestoreCustomFieldMutationVariables>;
export const UpdateCustomFieldDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateCustomField($id: uuid!, $title: String!, $isRequired: Boolean!, $allowUserToAddCustomOptions: Boolean!) {
  customField: update_custom_fields_by_pk(
    pk_columns: {id: $id}
    _set: {title: $title, isRequired: $isRequired, allowUserToAddCustomOptions: $allowUserToAddCustomOptions}
  ) {
    ...CustomField
  }
}
    fragment CustomField on custom_fields {
  id
  title
  type
  externalSource
  customCoreDataId
  isRequired
  updatedAt
  entityType
  dependsOnCustomFieldId
  organisationIntegrationId
  choices {
    id
    label
  }
  allowUserToAddCustomOptions
  remoteId
  customCoreData {
    id
    pathLevels
  }
}`) as unknown as TypedDocumentString<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>;
export const UpdateCustomFieldChoicesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateCustomFieldChoices($newChoices: [custom_field_choices_insert_input!]!, $removingChoicesIds: [uuid!]!) {
  insert_custom_field_choices(objects: $newChoices) {
    returning {
      id
    }
  }
  delete_custom_field_choices(where: {id: {_in: $removingChoicesIds}}) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateCustomFieldChoicesMutation, UpdateCustomFieldChoicesMutationVariables>;
export const UpdateCustomFieldCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateCustomFieldCoreData($id: uuid!, $input: custom_field_core_data_set_input!) {
  update_custom_field_core_data_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateCustomFieldCoreDataMutation, UpdateCustomFieldCoreDataMutationVariables>;
export const UpdateCustomFieldValuesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateCustomFieldValues($updates: [custom_field_values_updates!]!) {
  customFieldValues: update_custom_field_values_many(updates: $updates) {
    returning {
      id
      value
      booleanValue
      numberValue
      entityId
      customFieldId
      customFieldCoreDataId
      userId
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateCustomFieldValuesMutation, UpdateCustomFieldValuesMutationVariables>;
export const DeleteIdpAttributeMappingDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteIdpAttributeMapping($id: uuid!) {
  delete_idp_attribute_mappings_by_pk(id: $id) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteIdpAttributeMappingMutation, DeleteIdpAttributeMappingMutationVariables>;
export const GetIdpAttributeMappingsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetIdpAttributeMappings {
  idp_attribute_mappings {
    id
    idpCustomAttribute
    custom_field {
      id
      type
      title
      entityType
      externalSource
      customCoreDataId
    }
  }
}
    `) as unknown as TypedDocumentString<GetIdpAttributeMappingsQuery, GetIdpAttributeMappingsQueryVariables>;
export const InsertIdpAttributeMappingDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertIdpAttributeMapping($input: idp_attribute_mappings_insert_input!) {
  insert_idp_attribute_mappings_one(object: $input) {
    id
    idpCustomAttribute
    custom_field {
      id
      title
    }
  }
}
    `) as unknown as TypedDocumentString<InsertIdpAttributeMappingMutation, InsertIdpAttributeMappingMutationVariables>;
export const GetRequestNumberDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestNumber($requestsFilter: requests_bool_exp) {
  requests_aggregate(where: $requestsFilter) {
    aggregate {
      count
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestNumberQuery, GetRequestNumberQueryVariables>;
export const GetHargreavesLansdownBudgetApprovalsDataExportDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetHargreavesLansdownBudgetApprovalsDataExport {
  l2CategoryData: budget_approval_group(
    where: {id: {_eq: "15a0230f-8fac-489b-89d2-a6cd4ed66c44"}}
  ) {
    id
    name
    assignees {
      id
      custom_core_data_options {
        budget_approval_group_assignees_id
        custom_core_data_id
        custom_core_data_option_id
      }
      assignees {
        id
        group {
          id
          name
        }
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetHargreavesLansdownBudgetApprovalsDataExportQuery, GetHargreavesLansdownBudgetApprovalsDataExportQueryVariables>;
export const GetHargreavesLansdownRequestsDataExportDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetHargreavesLansdownRequestsDataExport($limit: Int!, $offset: Int!) {
  requests(where: {deletedAt: {_is_null: true}}, limit: $limit, offset: $offset) {
    id
    state
    createdAt
    completedAt
    publicId
    name
    tagIds
    workflow {
      id
      title
      type
      workflow_condition_groups {
        id
        name
        precedence
      }
    }
    request_tags {
      id
      tag {
        id
        name
        deletedAt
      }
    }
    request_forms {
      id
      request_form_submissions(limit: 1, order_by: {submittedOn: desc_nulls_last}) {
        id
        response
      }
      config
    }
    supplier {
      id
      name
      publicId
      remoteId
    }
    computedProperties {
      department {
        id
        name
      }
    }
    steps(where: {deletedAt: {_is_null: true}}) {
      id
      name: input(path: "$.metadata.config.payload.label")
      canvasModelId
      createdAt
      completedAt
      targetTime: input(path: "$.metadata.config.payload.targetTimeValue")
      type: input(path: "$.metadata.type")
      output
      data
      input
    }
  }
}
    `) as unknown as TypedDocumentString<GetHargreavesLansdownRequestsDataExportQuery, GetHargreavesLansdownRequestsDataExportQueryVariables>;
export const ProofpointLineItemDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ProofpointLineItemDetails($limit: Int!, $offset: Int!) {
  requests(limit: $limit, offset: $offset) {
    id
    publicId
    name
    createdAt
    completedAt
    deletedAt
    state
    tagIds
    supplier {
      id
      name
    }
    product {
      id
      name
    }
    user {
      id
      email
      firstName
      lastName
    }
    steps(
      where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
    ) {
      id
      name: input(path: "$.metadata.config.payload.label")
    }
    request_forms {
      id
      request_form_submissions(limit: 1, order_by: {submittedOn: desc_nulls_last}) {
        id
        response
      }
      config
    }
    workflow {
      id
      title
      workflow_condition_groups {
        id
        name
        precedence
      }
    }
    renewal {
      id
      renewalDate
    }
    request_tags {
      id
      tag {
        id
        name
        deletedAt
      }
    }
    owner {
      id
      email
    }
    inProgressStepContext: steps(
      where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
    ) {
      id
      nodeId: canvasModelId
      name: input(path: "$.metadata.config.payload.label")
      type: input(path: "$.metadata.type")
      state
      requestStepUsers: request_step_users(where: {deletedAt: {_is_null: true}}) {
        id
        user {
          id
          firstName
          lastName
        }
      }
      requestStepGroups: request_step_groups(where: {deletedAt: {_is_null: true}}) {
        id
        group {
          id
          name
          groupUsers: group_users {
            id
            userId
          }
        }
      }
    }
    engagement {
      id
      purchaseOrderNumber
    }
    purchase_orders(
      where: {status: {_eq: "ACTIVE"}, deletedAt: {_is_null: true}}
      order_by: {createdAt: desc}
      limit: 1
    ) {
      id
      remoteNumber
    }
    computedProperties {
      department {
        id
        name
      }
      inBudget
      valueObject
      renewalDate
      buyerLegalEntity {
        id
        name
      }
      contractStartDate
      contractEndDate
      businessOwner {
        id
        email
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ProofpointLineItemDetailsQuery, ProofpointLineItemDetailsQueryVariables>;
export const GetCustomFieldsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFields {
  custom_fields(
    where: {deletedAt: {_is_null: true}, entityType: {_eq: "supplier"}}
  ) {
    id
    title
    entityType
    values {
      id
      value
      choice {
        id
        label
      }
      createdAt
      updatedAt
      entityId
    }
  }
}
    `) as unknown as TypedDocumentString<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>;
export const GetSupplierNumberDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierNumber {
  organisation_suppliers_aggregate {
    aggregate {
      count
    }
  }
}
    `) as unknown as TypedDocumentString<GetSupplierNumberQuery, GetSupplierNumberQueryVariables>;
export const GetWiseSupplierDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetWiseSupplierData($limit: Int!, $offset: Int!) {
  suppliers: organisation_suppliers(
    where: {deleted_at: {_is_null: true}}
    limit: $limit
    offset: $offset
  ) {
    id
    name
    state
    updated_at
    createdAt
    website
    description
    externalLink
    address
    lastAssessmentDate
    isReseller
    products: organisation_products_and_services(where: {isArchived: {_eq: false}}) {
      id
      name
      state
      createdAt
      updatedAt
      description
      isArchived
      businessOwner {
        email
      }
      assessments {
        id
        name
        updatedAt
      }
      renewals {
        id
        createdAt
        updatedAt
        renewalDate
      }
    }
    requests: organisation_suppliers_requests(where: {deletedAt: {_is_null: true}}) {
      id
      name
      state
      updatedAt
      createdAt
      product {
        id
        name
      }
      tags: request_tags {
        tag {
          name
        }
      }
    }
    internalContacts {
      id
      role
      productId
      user {
        email
      }
    }
    tags: organisation_supplier_tags {
      tag {
        name
      }
    }
    externalContacts: external_contacts {
      id
      firstName
      lastName
      email
      phoneNumber
      title
    }
  }
}
    `) as unknown as TypedDocumentString<GetWiseSupplierDataQuery, GetWiseSupplierDataQueryVariables>;
export const GetRequestCommentsAndSubmissionsForSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestCommentsAndSubmissionsForSupplier($supplierUserId: uuid!) {
  request_step_tasks(
    where: {_and: [{request_step: {request: {deletedAt: {_is_null: true}}}}, {_or: [{request_step: {request_step_users: {userId: {_eq: $supplierUserId}}}}, {request_step_task_users: {user_id: {_eq: $supplierUserId}}}]}]}
  ) {
    request_form_submissions {
      response
    }
    request_form {
      config
    }
    request_step {
      request {
        comments(where: {isInternalComment: {_eq: false}}) {
          rfxSupplierId
          type
          payload
        }
        documents(where: {source: {_eq: "RFX_SUPPLIER_INSTRUCTIONS_DOCUMENT_SOURCE"}}) {
          filestoreId
        }
        request_forms {
          latestSubmissions: request_form_submissions(
            limit: 1
            order_by: {submittedOn: desc_nulls_last}
          ) {
            id
            response
          }
        }
      }
    }
  }
  rfx_suppliers(
    where: {rfx_external_users: {external_contact: {userId: {_eq: $supplierUserId}}}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetRequestCommentsAndSubmissionsForSupplierQuery, GetRequestCommentsAndSubmissionsForSupplierQueryVariables>;
export const GetCustomDocumentTypesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomDocumentTypes {
  custom_document_types {
    id
    value
  }
}
    `) as unknown as TypedDocumentString<GetCustomDocumentTypesQuery, GetCustomDocumentTypesQueryVariables>;
export const InsertCustomDocumentTypeDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertCustomDocumentType($input: custom_document_types_insert_input!) {
  insert_custom_document_types_one(object: $input) {
    id
    value
  }
}
    `) as unknown as TypedDocumentString<InsertCustomDocumentTypeMutation, InsertCustomDocumentTypeMutationVariables>;
export const InsertDocumentTypeDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertDocumentType($input: document_types_insert_input!) {
  documentType: insert_document_types_one(object: $input) {
    ...DocumentType
  }
}
    fragment DocumentType on document_types {
  id
  name
  description
  attributes
  createdAt
  updatedAt
}`) as unknown as TypedDocumentString<InsertDocumentTypeMutation, InsertDocumentTypeMutationVariables>;
export const DeleteGlobalDocumentDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteGlobalDocument($id: uuid!) {
  delete_documents_by_pk(id: $id) {
    id
    filestoreId
  }
}
    `) as unknown as TypedDocumentString<DeleteGlobalDocumentMutation, DeleteGlobalDocumentMutationVariables>;
export const GetGlobalDocumentsBySupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGlobalDocumentsBySupplier($orgSupplierId: uuid!) {
  documents(
    where: {_or: [{organisationSupplierId: {_eq: $orgSupplierId}}, {agreement_documents: {agreement: {supplierId: {_eq: $orgSupplierId}, deletedAt: {_is_null: true}}}}]}
  ) {
    ...GlobalDocument
    customFieldValues {
      ...CustomFieldValueFragment
    }
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment GlobalDocument on documents {
  id
  fileName
  createdAt
  updatedAt
  filestoreId
  organisationId
  staticType
  customType
  organisationSupplierId
  customTypeValue {
    id
    value
  }
  sourceRequestDocument {
    id
    sourceRequestForm {
      id
      title
    }
    request {
      id
      name
    }
  }
  product {
    id
    name
    logoUrl
  }
  supplier {
    id
    name
    logoUrl
  }
  uploadedByUser {
    id
    firstName
    lastName
    email
  }
  agreement_documents(limit: 1, order_by: {createdAt: desc}) {
    agreement {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<GetGlobalDocumentsBySupplierQuery, GetGlobalDocumentsBySupplierQueryVariables>;
export const GetGlobalDocumentsForUserPaginatedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGlobalDocumentsForUserPaginated($orgSupplierIds: [uuid!]!, $offset: Int!, $limit: Int!) {
  documents(
    where: {organisationSupplierId: {_in: $orgSupplierIds}}
    offset: $offset
    limit: $limit
  ) {
    ...GlobalDocument
    customFieldValues {
      ...CustomFieldValueFragment
    }
  }
  documents_aggregate(where: {organisationSupplierId: {_in: $orgSupplierIds}}) {
    aggregate {
      count
    }
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment GlobalDocument on documents {
  id
  fileName
  createdAt
  updatedAt
  filestoreId
  organisationId
  staticType
  customType
  organisationSupplierId
  customTypeValue {
    id
    value
  }
  sourceRequestDocument {
    id
    sourceRequestForm {
      id
      title
    }
    request {
      id
      name
    }
  }
  product {
    id
    name
    logoUrl
  }
  supplier {
    id
    name
    logoUrl
  }
  uploadedByUser {
    id
    firstName
    lastName
    email
  }
  agreement_documents(limit: 1, order_by: {createdAt: desc}) {
    agreement {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<GetGlobalDocumentsForUserPaginatedQuery, GetGlobalDocumentsForUserPaginatedQueryVariables>;
export const GetGlobalDocumentsForUserPaginatedV2Document = /*#__PURE__*/ new TypedDocumentString(`
    query GetGlobalDocumentsForUserPaginatedV2($offset: Int!, $limit: Int!, $order_by: [documents_order_by!], $where: documents_bool_exp) {
  documents(where: $where, offset: $offset, limit: $limit, order_by: $order_by) {
    ...GlobalDocument
  }
  documents_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    fragment GlobalDocument on documents {
  id
  fileName
  createdAt
  updatedAt
  filestoreId
  organisationId
  staticType
  customType
  organisationSupplierId
  customTypeValue {
    id
    value
  }
  sourceRequestDocument {
    id
    sourceRequestForm {
      id
      title
    }
    request {
      id
      name
    }
  }
  product {
    id
    name
    logoUrl
  }
  supplier {
    id
    name
    logoUrl
  }
  uploadedByUser {
    id
    firstName
    lastName
    email
  }
  agreement_documents(limit: 1, order_by: {createdAt: desc}) {
    agreement {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<GetGlobalDocumentsForUserPaginatedV2Query, GetGlobalDocumentsForUserPaginatedV2QueryVariables>;
export const GetGlobalDocumentsPaginatedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGlobalDocumentsPaginated($offset: Int!, $limit: Int!) {
  documents(offset: $offset, limit: $limit) {
    ...GlobalDocument
    customFieldValues {
      ...CustomFieldValueFragment
    }
  }
  documents_aggregate {
    aggregate {
      count
    }
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment GlobalDocument on documents {
  id
  fileName
  createdAt
  updatedAt
  filestoreId
  organisationId
  staticType
  customType
  organisationSupplierId
  customTypeValue {
    id
    value
  }
  sourceRequestDocument {
    id
    sourceRequestForm {
      id
      title
    }
    request {
      id
      name
    }
  }
  product {
    id
    name
    logoUrl
  }
  supplier {
    id
    name
    logoUrl
  }
  uploadedByUser {
    id
    firstName
    lastName
    email
  }
  agreement_documents(limit: 1, order_by: {createdAt: desc}) {
    agreement {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<GetGlobalDocumentsPaginatedQuery, GetGlobalDocumentsPaginatedQueryVariables>;
export const GetGlobalDocumentsPaginatedV2Document = /*#__PURE__*/ new TypedDocumentString(`
    query GetGlobalDocumentsPaginatedV2($offset: Int!, $limit: Int!, $order_by: [documents_order_by!], $where: documents_bool_exp) {
  documents(offset: $offset, limit: $limit, order_by: $order_by, where: $where) {
    ...GlobalDocument
  }
  documents_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    fragment GlobalDocument on documents {
  id
  fileName
  createdAt
  updatedAt
  filestoreId
  organisationId
  staticType
  customType
  organisationSupplierId
  customTypeValue {
    id
    value
  }
  sourceRequestDocument {
    id
    sourceRequestForm {
      id
      title
    }
    request {
      id
      name
    }
  }
  product {
    id
    name
    logoUrl
  }
  supplier {
    id
    name
    logoUrl
  }
  uploadedByUser {
    id
    firstName
    lastName
    email
  }
  agreement_documents(limit: 1, order_by: {createdAt: desc}) {
    agreement {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<GetGlobalDocumentsPaginatedV2Query, GetGlobalDocumentsPaginatedV2QueryVariables>;
export const InsertGlobalDocumentDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertGlobalDocument($input: documents_insert_input!) {
  insert_documents_one(object: $input) {
    ...GlobalDocument
  }
}
    fragment GlobalDocument on documents {
  id
  fileName
  createdAt
  updatedAt
  filestoreId
  organisationId
  staticType
  customType
  organisationSupplierId
  customTypeValue {
    id
    value
  }
  sourceRequestDocument {
    id
    sourceRequestForm {
      id
      title
    }
    request {
      id
      name
    }
  }
  product {
    id
    name
    logoUrl
  }
  supplier {
    id
    name
    logoUrl
  }
  uploadedByUser {
    id
    firstName
    lastName
    email
  }
  agreement_documents(limit: 1, order_by: {createdAt: desc}) {
    agreement {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<InsertGlobalDocumentMutation, InsertGlobalDocumentMutationVariables>;
export const BatchInsertGlobalDocumentsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BatchInsertGlobalDocuments($objects: [documents_insert_input!]!) {
  insert_documents(
    objects: $objects
    on_conflict: {update_columns: [updatedAt], constraint: documents_filestore_id_key}
  ) {
    returning {
      id
      requestDocumentsId
      filestoreId
      organisationSupplierId
      organisationProductId
      staticType
      customType
      fileName
      customTypeValue {
        id
        value
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BatchInsertGlobalDocumentsMutation, BatchInsertGlobalDocumentsMutationVariables>;
export const DeleteGlobalDocumentsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteGlobalDocuments($ids: [uuid!]!) {
  delete_documents(where: {requestDocumentsId: {_in: $ids}}) {
    affected_rows
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteGlobalDocumentsMutation, DeleteGlobalDocumentsMutationVariables>;
export const IsRequestCompleteDocument = /*#__PURE__*/ new TypedDocumentString(`
    query IsRequestComplete($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    id
    completedAt
  }
}
    `) as unknown as TypedDocumentString<IsRequestCompleteQuery, IsRequestCompleteQueryVariables>;
export const GetRequestDocumentsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestDocuments($requestId: uuid!) {
  request_documents(
    where: {deletedAt: {_is_null: true}, requestId: {_eq: $requestId}}
  ) {
    ...RequestDocument
  }
}
    fragment RequestDocument on request_documents {
  id
  filestoreId
  createdAt
  updatedAt
  organisationId
  fileName
  sourceRequestFormId
  requestId
  request {
    id
    name
    publicId
    product {
      id
      organisation_supplier {
        id
      }
    }
  }
  shouldPromoteToGlobal
  staticType
  customType
  source
  customTypeValue {
    id
    value
  }
  uploadedBy
  uploadedByUser {
    id
    firstName
    lastName
    email
  }
  sourceRequestForm {
    id
    title
  }
}`) as unknown as TypedDocumentString<GetRequestDocumentsQuery, GetRequestDocumentsQueryVariables>;
export const GetRequestDocumentsBySourceDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestDocumentsBySource($requestId: uuid!, $source: String!) {
  request_documents(
    where: {requestId: {_eq: $requestId}, source: {_eq: $source}, deletedAt: {_is_null: true}}
  ) {
    ...RequestDocument
  }
}
    fragment RequestDocument on request_documents {
  id
  filestoreId
  createdAt
  updatedAt
  organisationId
  fileName
  sourceRequestFormId
  requestId
  request {
    id
    name
    publicId
    product {
      id
      organisation_supplier {
        id
      }
    }
  }
  shouldPromoteToGlobal
  staticType
  customType
  source
  customTypeValue {
    id
    value
  }
  uploadedBy
  uploadedByUser {
    id
    firstName
    lastName
    email
  }
  sourceRequestForm {
    id
    title
  }
}`) as unknown as TypedDocumentString<GetRequestDocumentsBySourceQuery, GetRequestDocumentsBySourceQueryVariables>;
export const InsertRequestDocumentDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRequestDocument($input: request_documents_insert_input!) {
  insert_request_documents_one(object: $input) {
    ...RequestDocument
  }
}
    fragment RequestDocument on request_documents {
  id
  filestoreId
  createdAt
  updatedAt
  organisationId
  fileName
  sourceRequestFormId
  requestId
  request {
    id
    name
    publicId
    product {
      id
      organisation_supplier {
        id
      }
    }
  }
  shouldPromoteToGlobal
  staticType
  customType
  source
  customTypeValue {
    id
    value
  }
  uploadedBy
  uploadedByUser {
    id
    firstName
    lastName
    email
  }
  sourceRequestForm {
    id
    title
  }
}`) as unknown as TypedDocumentString<InsertRequestDocumentMutation, InsertRequestDocumentMutationVariables>;
export const UpdateRequestDocumentDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestDocument($id: uuid!, $requestDocument: request_documents_set_input!) {
  update_request_documents_by_pk(pk_columns: {id: $id}, _set: $requestDocument) {
    ...RequestDocument
  }
}
    fragment RequestDocument on request_documents {
  id
  filestoreId
  createdAt
  updatedAt
  organisationId
  fileName
  sourceRequestFormId
  requestId
  request {
    id
    name
    publicId
    product {
      id
      organisation_supplier {
        id
      }
    }
  }
  shouldPromoteToGlobal
  staticType
  customType
  source
  customTypeValue {
    id
    value
  }
  uploadedBy
  uploadedByUser {
    id
    firstName
    lastName
    email
  }
  sourceRequestForm {
    id
    title
  }
}`) as unknown as TypedDocumentString<UpdateRequestDocumentMutation, UpdateRequestDocumentMutationVariables>;
export const GetRequestStepExecutionStatusDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepExecutionStatus($where: request_steps_bool_exp!) {
  steps: request_steps(where: $where) {
    data
    input
    request {
      request_users {
        userId
      }
      request_groups {
        group {
          group_users {
            userId
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepExecutionStatusQuery, GetRequestStepExecutionStatusQueryVariables>;
export const GetEntityFieldGroupsByEntityTypeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetEntityFieldGroupsByEntityType($entityType: String!) {
  entity_field_groups(
    where: {entityType: {_eq: $entityType}}
    order_by: {index: asc}
  ) {
    ...EntityFieldGroup
  }
}
    fragment EntityFieldGroupFields on entity_field_group_fields {
  id
  customFieldId
  standardFieldKey
  index
}
fragment EntityFieldGroup on entity_field_groups {
  id
  name
  index
  entityType
  isDefaultForStandardFields
  isDefaultForCustomFields
  fields(order_by: {index: asc}) {
    ...EntityFieldGroupFields
  }
}`) as unknown as TypedDocumentString<GetEntityFieldGroupsByEntityTypeQuery, GetEntityFieldGroupsByEntityTypeQueryVariables>;
export const GetEntityFieldGroupByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetEntityFieldGroupById($id: uuid!) {
  entity_field_groups_by_pk(id: $id) {
    ...EntityFieldGroup
  }
}
    fragment EntityFieldGroupFields on entity_field_group_fields {
  id
  customFieldId
  standardFieldKey
  index
}
fragment EntityFieldGroup on entity_field_groups {
  id
  name
  index
  entityType
  isDefaultForStandardFields
  isDefaultForCustomFields
  fields(order_by: {index: asc}) {
    ...EntityFieldGroupFields
  }
}`) as unknown as TypedDocumentString<GetEntityFieldGroupByIdQuery, GetEntityFieldGroupByIdQueryVariables>;
export const InsertEntityFieldGroupDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertEntityFieldGroup($object: entity_field_groups_insert_input!) {
  insert_entity_field_groups_one(object: $object) {
    ...EntityFieldGroup
  }
}
    fragment EntityFieldGroupFields on entity_field_group_fields {
  id
  customFieldId
  standardFieldKey
  index
}
fragment EntityFieldGroup on entity_field_groups {
  id
  name
  index
  entityType
  isDefaultForStandardFields
  isDefaultForCustomFields
  fields(order_by: {index: asc}) {
    ...EntityFieldGroupFields
  }
}`) as unknown as TypedDocumentString<InsertEntityFieldGroupMutation, InsertEntityFieldGroupMutationVariables>;
export const UpdateEntityFieldGroupDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateEntityFieldGroup($id: uuid!, $set: entity_field_groups_set_input!) {
  update_entity_field_groups_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...EntityFieldGroup
  }
}
    fragment EntityFieldGroupFields on entity_field_group_fields {
  id
  customFieldId
  standardFieldKey
  index
}
fragment EntityFieldGroup on entity_field_groups {
  id
  name
  index
  entityType
  isDefaultForStandardFields
  isDefaultForCustomFields
  fields(order_by: {index: asc}) {
    ...EntityFieldGroupFields
  }
}`) as unknown as TypedDocumentString<UpdateEntityFieldGroupMutation, UpdateEntityFieldGroupMutationVariables>;
export const DeleteEntityFieldGroupDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteEntityFieldGroup($id: uuid!) {
  delete_entity_field_groups_by_pk(id: $id) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteEntityFieldGroupMutation, DeleteEntityFieldGroupMutationVariables>;
export const DeleteAllEntityFieldGroupsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteAllEntityFieldGroups {
  delete_entity_field_groups(where: {}) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteAllEntityFieldGroupsMutation, DeleteAllEntityFieldGroupsMutationVariables>;
export const SetStandardFieldGroupDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SetStandardFieldGroup($standardFieldKey: String!, $targetGroupId: uuid!, $index: Int!) {
  delete_entity_field_group_fields(
    where: {standardFieldKey: {_eq: $standardFieldKey}}
  ) {
    affected_rows
  }
  insert_entity_field_group_fields_one(
    object: {entityFieldGroupId: $targetGroupId, standardFieldKey: $standardFieldKey, index: $index}
  ) {
    ...EntityFieldGroupFields
  }
}
    fragment EntityFieldGroupFields on entity_field_group_fields {
  id
  customFieldId
  standardFieldKey
  index
}`) as unknown as TypedDocumentString<SetStandardFieldGroupMutation, SetStandardFieldGroupMutationVariables>;
export const SetCustomFieldGroupDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SetCustomFieldGroup($customFieldId: uuid!, $targetGroupId: uuid!, $index: Int!) {
  delete_entity_field_group_fields(where: {customFieldId: {_eq: $customFieldId}}) {
    affected_rows
  }
  insert_entity_field_group_fields_one(
    object: {entityFieldGroupId: $targetGroupId, customFieldId: $customFieldId, index: $index}
  ) {
    ...EntityFieldGroupFields
  }
}
    fragment EntityFieldGroupFields on entity_field_group_fields {
  id
  customFieldId
  standardFieldKey
  index
}`) as unknown as TypedDocumentString<SetCustomFieldGroupMutation, SetCustomFieldGroupMutationVariables>;
export const UpdateFieldGroupWithFieldsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateFieldGroupWithFields($id: uuid!, $name: String!, $fields: [entity_field_group_fields_insert_input!]!) {
  delete_entity_field_group_fields(where: {entityFieldGroupId: {_eq: $id}}) {
    affected_rows
  }
  update_entity_field_groups_by_pk(pk_columns: {id: $id}, _set: {name: $name}) {
    ...EntityFieldGroup
  }
  insert_entity_field_group_fields(objects: $fields) {
    returning {
      ...EntityFieldGroupFields
    }
  }
}
    fragment EntityFieldGroupFields on entity_field_group_fields {
  id
  customFieldId
  standardFieldKey
  index
}
fragment EntityFieldGroup on entity_field_groups {
  id
  name
  index
  entityType
  isDefaultForStandardFields
  isDefaultForCustomFields
  fields(order_by: {index: asc}) {
    ...EntityFieldGroupFields
  }
}`) as unknown as TypedDocumentString<UpdateFieldGroupWithFieldsMutation, UpdateFieldGroupWithFieldsMutationVariables>;
export const SetFieldGroupsWithFieldsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SetFieldGroupsWithFields($groupIds: [uuid!]!, $groupIdsToDelete: [uuid!]!, $updates: [entity_field_groups_updates!]!, $fields: [entity_field_group_fields_insert_input!]!) {
  delete_entity_field_group_fields(where: {entityFieldGroupId: {_in: $groupIds}}) {
    affected_rows
  }
  delete_entity_field_groups(where: {id: {_in: $groupIdsToDelete}}) {
    affected_rows
  }
  update_entity_field_groups_many(updates: $updates) {
    affected_rows
  }
  insert_entity_field_group_fields(objects: $fields) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<SetFieldGroupsWithFieldsMutation, SetFieldGroupsWithFieldsMutationVariables>;
export const GetCustomFieldIdsByEntityTypeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFieldIdsByEntityType($entityType: String!) {
  customFields: custom_fields(
    where: {deletedAt: {_is_null: true}, entityType: {_eq: $entityType}}
    order_by: {createdAt: asc}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetCustomFieldIdsByEntityTypeQuery, GetCustomFieldIdsByEntityTypeQueryVariables>;
export const GetCustomFieldsForEntityMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFieldsForEntityMinimal($entityType: String!) {
  customFields: custom_fields(
    where: {entityType: {_eq: $entityType}, deletedAt: {_is_null: true}}
  ) {
    id
    title
  }
}
    `) as unknown as TypedDocumentString<GetCustomFieldsForEntityMinimalQuery, GetCustomFieldsForEntityMinimalQueryVariables>;
export const GetAllBankAccountCustomFieldsIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllBankAccountCustomFieldsIds {
  bankAccountCustomFields: custom_fields(
    where: {entityType: {_eq: "bank-account"}, deletedAt: {_is_null: true}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetAllBankAccountCustomFieldsIdsQuery, GetAllBankAccountCustomFieldsIdsQueryVariables>;
export const GetAllLineItemCustomFieldsIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllLineItemCustomFieldsIds {
  lineItemCustomFields: custom_fields(
    where: {entityType: {_eq: "line-item"}, deletedAt: {_is_null: true}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetAllLineItemCustomFieldsIdsQuery, GetAllLineItemCustomFieldsIdsQueryVariables>;
export const GetAllOrganisationCoreDataDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllOrganisationCoreDataDependencies {
  organisationCoreDataDependencies: organisation_core_data_dependencies {
    id
    coreDataType
    customCoreData {
      id
      name
    }
    dependencyCoreDataType
    dependencyCustomCoreData {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetAllOrganisationCoreDataDependenciesQuery, GetAllOrganisationCoreDataDependenciesQueryVariables>;
export const GetFormTemplateConfigByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTemplateConfigById($formTemplateId: uuid!) {
  formTemplate: form_templates_by_pk(id: $formTemplateId) {
    id
    type
    config
    title
  }
}
    `) as unknown as TypedDocumentString<GetFormTemplateConfigByIdQuery, GetFormTemplateConfigByIdQueryVariables>;
export const GetOrganisationDefaultCurrencyDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationDefaultCurrency {
  organisationSettings: organisation_settings(
    where: {name: {_eq: "defaultCurrency"}}
  ) {
    value
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationDefaultCurrencyQuery, GetOrganisationDefaultCurrencyQueryVariables>;
export const GetRequestFormConfigByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFormConfigById($requestFormId: uuid!) {
  requestForm: request_forms_by_pk(id: $requestFormId) {
    id
    config
    requestId
  }
}
    `) as unknown as TypedDocumentString<GetRequestFormConfigByIdQuery, GetRequestFormConfigByIdQueryVariables>;
export const GetOpenRequestsFormsWithFormTemplateDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOpenRequestsFormsWithFormTemplate($formTemplateId: uuid!) {
  requests(
    where: {completedAt: {_is_null: true}, deletedAt: {_is_null: true}, request_forms: {formTemplateId: {_eq: $formTemplateId}}}
  ) {
    id
    completedAt
    deletedAt
    request_forms(where: {formTemplateId: {_eq: $formTemplateId}}) {
      formTemplateId
      id
      request_step_tasks {
        completedOn
        type
      }
      form_template {
        config
        title
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetOpenRequestsFormsWithFormTemplateQuery, GetOpenRequestsFormsWithFormTemplateQueryVariables>;
export const GetWorkflowsUsingFormDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetWorkflowsUsingForm($formTemplateId: uuid!, $workflowWhere: workflows_bool_exp) {
  workflow_form_templates(
    where: {formTemplateId: {_eq: $formTemplateId}, workflow: $workflowWhere}
  ) {
    id
    workflow {
      id
      state
      title
      type
      isArchived
      routingCanvasModel
    }
  }
}
    `) as unknown as TypedDocumentString<GetWorkflowsUsingFormQuery, GetWorkflowsUsingFormQueryVariables>;
export const GetWorkflowsUsingFormWithModelsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetWorkflowsUsingFormWithModels($formTemplateId: uuid!, $workflowWhere: workflows_bool_exp) {
  workflow_form_templates(
    where: {formTemplateId: {_eq: $formTemplateId}, workflow: $workflowWhere}
  ) {
    id
    workflow {
      id
      state
      title
      type
      isArchived
      routingCanvasModel
      viewModel
      viewModelUpdatedAt
      canvasModelUpdatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<GetWorkflowsUsingFormWithModelsQuery, GetWorkflowsUsingFormWithModelsQueryVariables>;
export const CreateFormTemplateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateFormTemplate($formTemplate: form_templates_insert_input!) {
  insert_form_templates_one(object: $formTemplate) {
    ...FormTemplate
  }
}
    fragment FormTemplate on form_templates {
  id
  title
  description
  type
  state
  config
  internalId
  integration
  externalTitle
  organisationId
  createdAt
  updatedAt
  createdBy
  updatedBy
  deletedAt
  created_by_user {
    id
    firstName
    lastName
  }
  updated_by_user {
    id
    firstName
    lastName
  }
}`) as unknown as TypedDocumentString<CreateFormTemplateMutation, CreateFormTemplateMutationVariables>;
export const GetFormTemplatesToDownloadCsvDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTemplatesToDownloadCsv($formTemplateIds: [uuid!] = "") {
  form_templates(where: {id: {_in: $formTemplateIds}}) {
    config
    title
  }
}
    `) as unknown as TypedDocumentString<GetFormTemplatesToDownloadCsvQuery, GetFormTemplatesToDownloadCsvQueryVariables>;
export const GetFormTemplateDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTemplate($id: uuid!) {
  form_templates_by_pk(id: $id) {
    ...FormTemplate
  }
}
    fragment FormTemplate on form_templates {
  id
  title
  description
  type
  state
  config
  internalId
  integration
  externalTitle
  organisationId
  createdAt
  updatedAt
  createdBy
  updatedBy
  deletedAt
  created_by_user {
    id
    firstName
    lastName
  }
  updated_by_user {
    id
    firstName
    lastName
  }
}`) as unknown as TypedDocumentString<GetFormTemplateQuery, GetFormTemplateQueryVariables>;
export const GetFormTemplatesWithFiltersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTemplatesWithFilters($where: form_templates_bool_exp) {
  form_templates(where: $where, order_by: {createdAt: desc}) {
    ...FormTemplate
  }
}
    fragment FormTemplate on form_templates {
  id
  title
  description
  type
  state
  config
  internalId
  integration
  externalTitle
  organisationId
  createdAt
  updatedAt
  createdBy
  updatedBy
  deletedAt
  created_by_user {
    id
    firstName
    lastName
  }
  updated_by_user {
    id
    firstName
    lastName
  }
}`) as unknown as TypedDocumentString<GetFormTemplatesWithFiltersQuery, GetFormTemplatesWithFiltersQueryVariables>;
export const UpdateFormTemplateAndUnpublishWorkflowsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateFormTemplateAndUnpublishWorkflows($id: uuid!, $formTemplateUpdate: form_templates_set_input!, $workflowIds: [uuid!]!) {
  update_form_templates_by_pk(pk_columns: {id: $id}, _set: $formTemplateUpdate) {
    ...FormTemplate
  }
  update_workflows(
    where: {id: {_in: $workflowIds}, state: {_eq: PUBLISHED}}
    _set: {state: UNDER_MAINTENANCE}
  ) {
    returning {
      id
      title
      organisation {
        id
        name
      }
    }
  }
}
    fragment FormTemplate on form_templates {
  id
  title
  description
  type
  state
  config
  internalId
  integration
  externalTitle
  organisationId
  createdAt
  updatedAt
  createdBy
  updatedBy
  deletedAt
  created_by_user {
    id
    firstName
    lastName
  }
  updated_by_user {
    id
    firstName
    lastName
  }
}`) as unknown as TypedDocumentString<UpdateFormTemplateAndUnpublishWorkflowsMutation, UpdateFormTemplateAndUnpublishWorkflowsMutationVariables>;
export const UpdateRequestFormConfigDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestFormConfig($id: uuid!, $update: request_forms_set_input!) {
  update_request_forms_by_pk(pk_columns: {id: $id}, _set: $update) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateRequestFormConfigMutation, UpdateRequestFormConfigMutationVariables>;
export const UploadFormTemplateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UploadFormTemplate($form: form_templates_insert_input!) {
  insert_form_templates_one(object: $form) {
    id
  }
}
    `) as unknown as TypedDocumentString<UploadFormTemplateMutation, UploadFormTemplateMutationVariables>;
export const DeleteDraftIntakeSubmissionDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteDraftIntakeSubmission($id: uuid!, $userId: uuid!) {
  update_draft_intake_submissions(
    where: {id: {_eq: $id}, userId: {_eq: $userId}}
    _set: {deletedAt: "now()"}
  ) {
    affected_rows
    returning {
      id
      name
      workflow {
        id
        title
      }
      formTemplate {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteDraftIntakeSubmissionMutation, DeleteDraftIntakeSubmissionMutationVariables>;
export const GetDraftIntakeSubmissionDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetDraftIntakeSubmission($id: uuid!, $userId: uuid!) {
  draft_intake_submissions(
    where: {userId: {_eq: $userId}, id: {_eq: $id}, deletedAt: {_is_null: true}}
  ) {
    id
    name
    userId
    response
    updatedAt
    workflow {
      id
      state
      deletedAt
      routingCanvasModel
    }
    formTemplate {
      id
      state
      deletedAt
    }
  }
}
    `) as unknown as TypedDocumentString<GetDraftIntakeSubmissionQuery, GetDraftIntakeSubmissionQueryVariables>;
export const InsertDraftIntakeSubmissionDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertDraftIntakeSubmission($input: draft_intake_submissions_insert_input!) {
  insert_draft_intake_submissions_one(object: $input) {
    id
    workflow {
      title
    }
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<InsertDraftIntakeSubmissionMutation, InsertDraftIntakeSubmissionMutationVariables>;
export const ListDraftIntakeSubmissionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListDraftIntakeSubmissions($userId: uuid!) {
  draft_intake_submissions(
    where: {userId: {_eq: $userId}, deletedAt: {_is_null: true}}
  ) {
    id
    name
    workflow {
      id
      title
      state
      deletedAt
      routingCanvasModel
    }
    formTemplate {
      id
      state
      deletedAt
    }
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<ListDraftIntakeSubmissionsQuery, ListDraftIntakeSubmissionsQueryVariables>;
export const GetFormTemplateForIntakePrefillDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTemplateForIntakePrefill($id: uuid!) {
  formTemplate: form_templates_by_pk(id: $id) {
    config
    id
    state
    type
  }
}
    `) as unknown as TypedDocumentString<GetFormTemplateForIntakePrefillQuery, GetFormTemplateForIntakePrefillQueryVariables>;
export const GetProductCatalogueEntryDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetProductCatalogueEntryData($productCatalogueEntryId: uuid!) {
  product_catalogue_entries_by_pk(id: $productCatalogueEntryId) {
    id
    product_catalogue_access_approvers {
      id
      user {
        id
        firstName
        lastName
        email
      }
      group {
        id
        name
      }
    }
    organisation_products_and_services_brand {
      id
      name
      organisation_products_and_services {
        id
        name
        state
        organisation_supplier {
          id
          name
          publicId
          state
          remoteLink
          isPreferred
          website
          description
          organisationIntegration {
            id
            integration
          }
        }
      }
      products_and_service {
        id
        name
        description
        website
        supplier {
          id
          name
          description
          website
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetProductCatalogueEntryDataQuery, GetProductCatalogueEntryDataQueryVariables>;
export const RetrieveRequestorPrefillDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query RetrieveRequestorPrefillData($userId: uuid!) {
  users_by_pk(id: $userId) {
    managerUser {
      id
      firstName
      lastName
      email
      isArchived
    }
    department {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    userAllowedSubsidiaries {
      subsidiaryId
      subsidiary {
        ...Subsidiary
      }
    }
  }
}
    fragment Subsidiary on subsidiaries {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}`) as unknown as TypedDocumentString<RetrieveRequestorPrefillDataQuery, RetrieveRequestorPrefillDataQueryVariables>;
export const GetGlobalProductsBySupplierIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGlobalProductsBySupplierIds($supplierIds: [uuid!]!) {
  products_and_services(where: {supplierId: {_in: $supplierIds}}) {
    id
    name
    supplier {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetGlobalProductsBySupplierIdsQuery, GetGlobalProductsBySupplierIdsQueryVariables>;
export const GetGlobalSuppliersByNameDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGlobalSuppliersByName($supplierNames: [String!]!) {
  suppliers(where: {name: {_in: $supplierNames}}) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<GetGlobalSuppliersByNameQuery, GetGlobalSuppliersByNameQueryVariables>;
export const GetMatchingGlobalProductsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetMatchingGlobalProducts($where: products_and_services_bool_exp!) {
  products_and_services(where: $where) {
    id
    name
    logoUrl
    website
    description
    supplier {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetMatchingGlobalProductsQuery, GetMatchingGlobalProductsQueryVariables>;
export const GetMatchingGlobalSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetMatchingGlobalSuppliers($where: suppliers_bool_exp!) {
  suppliers(where: $where) {
    id
    name
    logoUrl
    website
  }
}
    `) as unknown as TypedDocumentString<GetMatchingGlobalSuppliersQuery, GetMatchingGlobalSuppliersQueryVariables>;
export const GetOrganisationSuppliersByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationSuppliersByIds($ids: [uuid!]!) {
  organisation_suppliers(where: {id: {_in: $ids}}) {
    id
    name
    embedding
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationSuppliersByIdsQuery, GetOrganisationSuppliersByIdsQueryVariables>;
export const ListOrganisationSuppliersAndProductsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListOrganisationSuppliersAndProducts($orgId: uuid!) {
  organisation_suppliers(
    where: {deleted_at: {_is_null: true}, state: {_eq: ACTIVE}, organisation: {id: {_eq: $orgId}}}
  ) {
    id
    name
    organisationSupplierBrandId
  }
  organisation_products_and_services(
    where: {organisation: {id: {_eq: $orgId}}, organisation_supplier: {deleted_at: {_is_null: true}, state: {_eq: ACTIVE}}}
  ) {
    id
    name
    organisation_supplier {
      id
      name
      organisation_supplier_brand {
        id
        name
      }
    }
    organisationProductsAndServicesBrandId
  }
}
    `) as unknown as TypedDocumentString<ListOrganisationSuppliersAndProductsQuery, ListOrganisationSuppliersAndProductsQueryVariables>;
export const GetAccessRequestWorkflowsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAccessRequestWorkflows {
  workflows(
    where: {_and: [{type: {_eq: ACCESS_REQUEST}}, {state: {_eq: PUBLISHED}}, {isArchived: {_eq: false}}, {deletedAt: {_is_null: true}}]}
  ) {
    id
    title
  }
}
    `) as unknown as TypedDocumentString<GetAccessRequestWorkflowsQuery, GetAccessRequestWorkflowsQueryVariables>;
export const GetMatchingOrgSupplierBrandsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetMatchingOrgSupplierBrands($where: organisation_suppliers_brands_bool_exp!) {
  organisation_suppliers_brands(where: $where) {
    id
    name
    logoUrl
    website
  }
}
    `) as unknown as TypedDocumentString<GetMatchingOrgSupplierBrandsQuery, GetMatchingOrgSupplierBrandsQueryVariables>;
export const GetProductBrandsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetProductBrands {
  organisation_products_and_services_brands(where: {deletedAt: {_is_null: true}}) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetProductBrandsQuery, GetProductBrandsQueryVariables>;
export const GetSubCategoriesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSubCategories {
  categories: organisation_product_supplier_categories {
    id
    name: value
    parentId
    isTerminal
  }
}
    `) as unknown as TypedDocumentString<GetSubCategoriesQuery, GetSubCategoriesQueryVariables>;
export const InsertMultipleFeatureFlagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertMultipleFeatureFlags($featureFlags: [organisation_feature_flags_insert_input!]!) {
  featureFlag: insert_organisation_feature_flags(
    objects: $featureFlags
    on_conflict: {constraint: organisation_feature_flags_pkey, update_columns: []}
  ) {
    returning {
      featureFlag
    }
  }
}
    `) as unknown as TypedDocumentString<InsertMultipleFeatureFlagsMutation, InsertMultipleFeatureFlagsMutationVariables>;
export const GetOrganisationExternalDomainsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationExternalDomains {
  organisations {
    externalDomains
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationExternalDomainsQuery, GetOrganisationExternalDomainsQueryVariables>;
export const UpdateExternalDomainsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateExternalDomains($organisationId: uuid!, $externalDomains: [String!]) {
  update_organisations_by_pk(
    pk_columns: {id: $organisationId}
    _set: {externalDomains: $externalDomains}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateExternalDomainsMutation, UpdateExternalDomainsMutationVariables>;
export const GetOrganisationConnectionSettingsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationConnectionSettings {
  organisations {
    id
    hasSsoEnabled
    hasDirectorySyncEnabled
    externalDomains
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationConnectionSettingsQuery, GetOrganisationConnectionSettingsQueryVariables>;
export const GetOrganisationSettingsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationSettings {
  organisation_settings {
    name
    value
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationSettingsQuery, GetOrganisationSettingsQueryVariables>;
export const OrganisationDetailQueryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query OrganisationDetailQuery($organisationId: uuid!) {
  organisations_by_pk(id: $organisationId) {
    id
    name
    isQa
  }
}
    `) as unknown as TypedDocumentString<OrganisationDetailQueryQuery, OrganisationDetailQueryQueryVariables>;
export const UpsertOrganisationSettingDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertOrganisationSetting($settingName: String!, $value: jsonb!) {
  insert_organisation_settings_one(
    object: {name: $settingName, value: $value}
    on_conflict: {constraint: organisation_settings_pkey, update_columns: [value]}
  ) {
    value
  }
}
    `) as unknown as TypedDocumentString<UpsertOrganisationSettingMutation, UpsertOrganisationSettingMutationVariables>;
export const DeleteOrganisationProductBrandDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteOrganisationProductBrand($id: uuid!) {
  deletedProductBrand: update_organisation_products_and_services_brands_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteOrganisationProductBrandMutation, DeleteOrganisationProductBrandMutationVariables>;
export const DeleteProductCatalogueAccessApproversDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteProductCatalogueAccessApprovers($userIds: [uuid!], $groupIds: [uuid!], $productCatalogueEntryId: uuid!) {
  delete_product_catalogue_access_approvers(
    where: {_and: [{productCatalogueEntryId: {_eq: $productCatalogueEntryId}}, {_or: [{userId: {_in: $userIds}}, {groupId: {_in: $groupIds}}]}]}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteProductCatalogueAccessApproversMutation, DeleteProductCatalogueAccessApproversMutationVariables>;
export const GetAllOrgSupplierBrandsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllOrgSupplierBrands {
  organisation_suppliers_brands {
    id
    name
    description
    logoUrl
    supplierId
    website
  }
}
    `) as unknown as TypedDocumentString<GetAllOrgSupplierBrandsQuery, GetAllOrgSupplierBrandsQueryVariables>;
export const GetGlobalSupplierByNameDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGlobalSupplierByName($name: String!) {
  suppliers(where: {name: {_ilike: $name}}) {
    id
    name
    logoUrl
    description
  }
}
    `) as unknown as TypedDocumentString<GetGlobalSupplierByNameQuery, GetGlobalSupplierByNameQueryVariables>;
export const GetOrganisationProductBrandDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationProductBrand($orgProductsAndServicesBrandId: uuid!) {
  organisation_products_and_services_brands_by_pk(
    id: $orgProductsAndServicesBrandId
  ) {
    id
    description
    logoUrl
    website
    product_catalogue_entry {
      id
    }
    products_and_service {
      id
      description
      logoUrl
      website
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationProductBrandQuery, GetOrganisationProductBrandQueryVariables>;
export const GetOrganisationProductsForBrandsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationProductsForBrands($productsAndServicesBrandIds: [uuid!]!) {
  organisation_products_and_services_brands(
    where: {id: {_in: $productsAndServicesBrandIds}}
  ) {
    organisation_products_and_services {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationProductsForBrandsQuery, GetOrganisationProductsForBrandsQueryVariables>;
export const GetProductCatalogueEntryAccessApproversDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetProductCatalogueEntryAccessApprovers($productCatalogueEntryId: uuid!) {
  product_catalogue_access_approvers(
    where: {productCatalogueEntryId: {_eq: $productCatalogueEntryId}}
  ) {
    id
    userId
    groupId
  }
}
    `) as unknown as TypedDocumentString<GetProductCatalogueEntryAccessApproversQuery, GetProductCatalogueEntryAccessApproversQueryVariables>;
export const ListOrganisationSupplierBrandsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListOrganisationSupplierBrands($search: String) {
  organisation_suppliers_brands(where: {name: {_ilike: $search}}) {
    id
    name
    description
    logoUrl
    supplierId
  }
}
    `) as unknown as TypedDocumentString<ListOrganisationSupplierBrandsQuery, ListOrganisationSupplierBrandsQueryVariables>;
export const ListProductBrandsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListProductBrands {
  organisation_products_and_services_brands(where: {deletedAt: {_is_null: true}}) {
    description
    productAndServiceId
    id
    logoUrl
    name
    categories {
      id
      organisation_product_supplier_category {
        id
        value
        parentId
        isTerminal
      }
    }
    organisation_suppliers_brand {
      id
      logoUrl
      name
    }
    product_catalogue_entry {
      id
      accessType
      accessUrl
      showInCatalogue
      workflow {
        id
        title
      }
      accessInstructions
      externalEmail
      product_catalogue_access_approvers {
        id
        user {
          id
          firstName
          lastName
          email
        }
        group {
          id
          name
        }
      }
    }
    organisation_products_and_services {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<ListProductBrandsQuery, ListProductBrandsQueryVariables>;
export const ListProductsAndServicesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListProductsAndServices($search: String) {
  products_and_services(
    where: {_or: [{name: {_ilike: $search}}, {displayName: {_ilike: $search}}]}
    limit: 15
  ) {
    id
    name
    logoUrl
    description
    products_and_services_categories {
      category {
        id
        name
        parentId
        pathLevel
      }
    }
    organisation_products_and_services_brands(where: {deletedAt: {_is_null: true}}) {
      id
    }
    supplier {
      id
      name
      logoUrl
      organisation_suppliers_brands {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListProductsAndServicesQuery, ListProductsAndServicesQueryVariables>;
export const UpdateOrgProductsAndServicesBrandDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateOrgProductsAndServicesBrand($input: organisation_products_and_services_brands_set_input, $orgProductsAndServicesBrandId: uuid!) {
  update_organisation_products_and_services_brands_by_pk(
    pk_columns: {id: $orgProductsAndServicesBrandId}
    _set: $input
  ) {
    id
    name
    description
    logoUrl
    website
  }
}
    `) as unknown as TypedDocumentString<UpdateOrgProductsAndServicesBrandMutation, UpdateOrgProductsAndServicesBrandMutationVariables>;
export const UpdateProductCatalogueEntryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateProductCatalogueEntry($productCatalogueEntryId: uuid!, $input: product_catalogue_entries_set_input = {}) {
  update_product_catalogue_entries_by_pk(
    pk_columns: {id: $productCatalogueEntryId}
    _set: $input
  ) {
    id
    accessUrl
    accessType
    showInCatalogue
    accessWorkflowId
    product_catalogue_access_approvers {
      userId
    }
    accessInstructions
    externalEmail
  }
}
    `) as unknown as TypedDocumentString<UpdateProductCatalogueEntryMutation, UpdateProductCatalogueEntryMutationVariables>;
export const DeleteOrganisationProductsAndServicesCategoriesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteOrganisationProductsAndServicesCategories($organisationProductsAndServicesBrandId: uuid!, $categoryIds: [uuid!]!) {
  delete_organisation_products_and_services_categories(
    where: {organisationProductsAndServicesBrandId: {_eq: $organisationProductsAndServicesBrandId}, productSupplierCategoryId: {_in: $categoryIds}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteOrganisationProductsAndServicesCategoriesMutation, DeleteOrganisationProductsAndServicesCategoriesMutationVariables>;
export const GetProductBrandCategoriesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetProductBrandCategories($organisationProductsAndServicesBrandId: uuid!) {
  organisation_products_and_services_categories(
    where: {organisationProductsAndServicesBrandId: {_eq: $organisationProductsAndServicesBrandId}}
  ) {
    productSupplierCategoryId
  }
}
    `) as unknown as TypedDocumentString<GetProductBrandCategoriesQuery, GetProductBrandCategoriesQueryVariables>;
export const InsertOrganisationProductsAndServicesCategoriesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertOrganisationProductsAndServicesCategories($objects: [organisation_products_and_services_categories_insert_input!] = {}) {
  insert_organisation_products_and_services_categories(objects: $objects) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertOrganisationProductsAndServicesCategoriesMutation, InsertOrganisationProductsAndServicesCategoriesMutationVariables>;
export const GetProductAndServiceCategoriesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetProductAndServiceCategories($productAndServiceId: uuid!) {
  products_and_services_by_pk(id: $productAndServiceId) {
    products_and_services_categories {
      id
      category {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetProductAndServiceCategoriesQuery, GetProductAndServiceCategoriesQueryVariables>;
export const GetProductBrandDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetProductBrandDetails($orgProductsAndServicesBrandId: uuid!) {
  organisation_products_and_services_brands_by_pk(
    id: $orgProductsAndServicesBrandId
  ) {
    productAndServiceId
    product_catalogue_entry {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetProductBrandDetailsQuery, GetProductBrandDetailsQueryVariables>;
export const GetSupplierByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierById($supplierId: uuid!) {
  suppliers_by_pk(id: $supplierId) {
    id
    name
    logoUrl
    website
  }
}
    `) as unknown as TypedDocumentString<GetSupplierByIdQuery, GetSupplierByIdQueryVariables>;
export const InsertOrganisationProductsAndServicesBrandDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertOrganisationProductsAndServicesBrand($input: organisation_products_and_services_brands_insert_input!) {
  insert_organisation_products_and_services_brands_one(object: $input) {
    id
    products_and_service {
      products_and_services_categories {
        category {
          id
          name
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<InsertOrganisationProductsAndServicesBrandMutation, InsertOrganisationProductsAndServicesBrandMutationVariables>;
export const InsertOrganisationSupplierBrandDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertOrganisationSupplierBrand($object: organisation_suppliers_brands_insert_input = {}) {
  insert_organisation_suppliers_brands_one(object: $object) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertOrganisationSupplierBrandMutation, InsertOrganisationSupplierBrandMutationVariables>;
export const InsertProductCatalogueAccessApproversDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertProductCatalogueAccessApprovers($input: [product_catalogue_access_approvers_insert_input!]!) {
  insert_product_catalogue_access_approvers(objects: $input) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertProductCatalogueAccessApproversMutation, InsertProductCatalogueAccessApproversMutationVariables>;
export const InsertProductCatalogueEntryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertProductCatalogueEntry($input: product_catalogue_entries_insert_input = {}) {
  insert_product_catalogue_entries_one(object: $input) {
    id
    accessUrl
    accessType
    showInCatalogue
    accessWorkflowId
    product_catalogue_access_approvers {
      userId
    }
    accessInstructions
    externalEmail
  }
}
    `) as unknown as TypedDocumentString<InsertProductCatalogueEntryMutation, InsertProductCatalogueEntryMutationVariables>;
export const ListProductCatalogueEntriesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListProductCatalogueEntries {
  product_catalogue_entries {
    id
    accessType
    accessUrl
    showInCatalogue
    accessInstructions
    externalEmail
    product_catalogue_access_approvers {
      id
      user {
        id
        firstName
        lastName
        email
      }
    }
    organisation_products_and_services_brand {
      logoUrl
      name
      description
      id
      organisation_suppliers_brand {
        id
        logoUrl
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListProductCatalogueEntriesQuery, ListProductCatalogueEntriesQueryVariables>;
export const GetOrgSupplierWithNameDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgSupplierWithName($supplierName: String!) {
  organisation_suppliers(
    where: {name: {_ilike: $supplierName}, deleted_at: {_is_null: true}}
  ) {
    id
    name
    organisationSupplierBrandId
  }
}
    `) as unknown as TypedDocumentString<GetOrgSupplierWithNameQuery, GetOrgSupplierWithNameQueryVariables>;
export const BatchUpdateOrganisationProductsAndServicesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BatchUpdateOrganisationProductsAndServices($updates: [organisation_products_and_services_updates!]!) {
  update_organisation_products_and_services_many(updates: $updates) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<BatchUpdateOrganisationProductsAndServicesMutation, BatchUpdateOrganisationProductsAndServicesMutationVariables>;
export const GetOrganisationProductsForFunctionalDescriptionAndEmbeddingDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationProductsForFunctionalDescriptionAndEmbedding($productIds: [uuid!]!) {
  organisation_products_and_services(where: {id: {_in: $productIds}}) {
    id
    name
    description
    website
    organisation_supplier {
      name
    }
    functionalDescription
    brand: organisation_products_and_services_brand {
      name
      description
      website
      globalProduct: products_and_service {
        name
        description
        website
        categories: products_and_services_categories {
          category {
            ...CategoryNameWithParent
          }
        }
        functionalDescription
      }
      categories {
        category: organisation_product_supplier_category {
          name: value
          parent: organisation_product_supplier_category {
            name: value
          }
        }
      }
      organisation_suppliers_brand {
        name
      }
    }
  }
}
    fragment CategoryNameWithParent on categories {
  name
  parent {
    name
  }
}`) as unknown as TypedDocumentString<GetOrganisationProductsForFunctionalDescriptionAndEmbeddingQuery, GetOrganisationProductsForFunctionalDescriptionAndEmbeddingQueryVariables>;
export const GetAllOrgProductsOfSupplierByProductIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllOrgProductsOfSupplierByProductId($productId: uuid!) {
  organisation_products_and_services_by_pk(id: $productId) {
    id
    organisation_supplier {
      id
      organisation_products_and_services {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAllOrgProductsOfSupplierByProductIdQuery, GetAllOrgProductsOfSupplierByProductIdQueryVariables>;
export const GetGlobalProductsAndServicesByOrganisationSupplierIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGlobalProductsAndServicesByOrganisationSupplierId($organisationSupplierId: uuid!) {
  organisation_suppliers_by_pk(id: $organisationSupplierId) {
    id
    organisation_supplier_brand {
      id
      supplier {
        id
        products_and_services {
          id
          name
          logoUrl
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetGlobalProductsAndServicesByOrganisationSupplierIdQuery, GetGlobalProductsAndServicesByOrganisationSupplierIdQueryVariables>;
export const GetOrganisationProductByNameAndOrganisationSupplierIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationProductByNameAndOrganisationSupplierId($organisationSupplierId: uuid!, $name: String!) {
  organisation_products_and_services(
    where: {organisationSupplierId: {_eq: $organisationSupplierId}, displayName: {_eq: $name}, isArchived: {_eq: true}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationProductByNameAndOrganisationSupplierIdQuery, GetOrganisationProductByNameAndOrganisationSupplierIdQueryVariables>;
export const GetOrganisationSupplierByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationSupplierById($organisationSupplierId: uuid!) {
  organisation_suppliers_by_pk(id: $organisationSupplierId) {
    id
    name
    description
    organisationSupplierBrandId
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationSupplierByIdQuery, GetOrganisationSupplierByIdQueryVariables>;
export const GetProductAchievabilityDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetProductAchievability($productId: uuid!) {
  organisation_products_and_services_by_pk(id: $productId) {
    scheduledRenewals: renewals(
      where: {requestId: {_is_null: true}, deletedAt: {_is_null: true}}
    ) {
      id
    }
    scheduledAssessments: assessments(
      where: {requestId: {_is_null: true}, deletedAt: {_is_null: true}}
    ) {
      id
    }
    organisation_products_and_services_requests(
      where: {_and: [{completedAt: {_is_null: true}}, {deletedAt: {_is_null: true}}, {_or: [{state: {_is_null: true}}, {state: {_neq: "REJECTED"}}]}]}
    ) {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetProductAchievabilityQuery, GetProductAchievabilityQueryVariables>;
export const GetProductAndServiceByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetProductAndServiceById($productsAndServicesId: uuid!) {
  products_and_services_by_pk(id: $productsAndServicesId) {
    id
    name
    displayName
    logoUrl
    website
    description
    organisation_products_and_services_brands(where: {deletedAt: {_is_null: true}}) {
      id
    }
    supplier {
      id
      name
      description
      logoUrl
      website
      organisation_suppliers_brands {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetProductAndServiceByIdQuery, GetProductAndServiceByIdQueryVariables>;
export const GetProductByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetProductById($productId: uuid!) {
  product: organisation_products_and_services_by_pk(id: $productId) {
    id
    name
    businessOwner {
      id
      firstName
      lastName
      email
    }
  }
}
    `) as unknown as TypedDocumentString<GetProductByIdQuery, GetProductByIdQueryVariables>;
export const GetProductEngagementsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetProductEngagements($organisationProductId: uuid!) {
  engagements(
    where: {organisationProductOrServiceId: {_eq: $organisationProductId}}
  ) {
    id
    name
    departmentId
    note
    financial {
      id
      amount
      currency
      renewalDate
      contractEnd
      contractPeriodEnd
      autoRenewal
      cancellationNoticeDays
    }
  }
}
    `) as unknown as TypedDocumentString<GetProductEngagementsQuery, GetProductEngagementsQueryVariables>;
export const ListProductsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListProducts($where: organisation_products_and_services_bool_exp!) {
  products: organisation_products_and_services(where: $where) {
    ...ListProductFragment
  }
  aggregate: organisation_products_and_services_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    fragment ListProductFragment on organisation_products_and_services {
  id
  name
  displayName
  website
  logoUrl
  createdAt
  updatedAt
  description
  isArchived
  state
  businessOwner {
    id
    firstName
    lastName
  }
  engagements {
    id
    name
    department
  }
  earliestActiveRenewal: renewals(
    where: {_and: [{_or: [{request: {_and: [{completedAt: {_is_null: true}}, {state: {_neq: "REJECTED"}}]}}, {requestId: {_is_null: true}}]}, {deletedAt: {_is_null: true}}]}
    order_by: {renewalDate: asc}
    limit: 1
  ) {
    id
    renewalDate
    cancellationNoticeDayCount
    requestId
    sourceAgreementTerm {
      id
      agreement {
        id
        name
      }
    }
  }
}`) as unknown as TypedDocumentString<ListProductsQuery, ListProductsQueryVariables>;
export const CreateProductsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateProducts($objects: [organisation_products_and_services_insert_input!]!) {
  insert_organisation_products_and_services(objects: $objects) {
    returning {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<CreateProductsMutation, CreateProductsMutationVariables>;
export const InsertOrganisationProductsAndServiceDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertOrganisationProductsAndService($input: organisation_products_and_services_insert_input!) {
  insert_organisation_products_and_services_one(object: $input) {
    ...OrganisationProductsAndServiceFragment
  }
}
    fragment OrganisationProductsAndServiceFragment on organisation_products_and_services {
  id
  name
  displayName
  website
  logoUrl
  createdAt
  updatedAt
  description
  isArchived
  state
  businessOwner {
    id
    firstName
    lastName
  }
  organisation_supplier {
    state
    id
    website
    logoUrl
    name
    externalLink
    organisation_supplier_brand {
      id
      supplierId
    }
    external_contacts(where: {deletedAt: {_is_null: true}}) {
      id
      email
      firstName
      lastName
      isPrimary
      phoneNumber
      title
    }
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
    }
  }
  engagements {
    id
    name
    department
  }
}`) as unknown as TypedDocumentString<InsertOrganisationProductsAndServiceMutation, InsertOrganisationProductsAndServiceMutationVariables>;
export const UpdateOrganisationProductsAndServiceDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateOrganisationProductsAndService($set: organisation_products_and_services_set_input!, $id: uuid!) {
  update_organisation_products_and_services_by_pk(
    pk_columns: {id: $id}
    _set: $set
  ) {
    ...OrganisationProductsAndServiceFragment
  }
}
    fragment OrganisationProductsAndServiceFragment on organisation_products_and_services {
  id
  name
  displayName
  website
  logoUrl
  createdAt
  updatedAt
  description
  isArchived
  state
  businessOwner {
    id
    firstName
    lastName
  }
  organisation_supplier {
    state
    id
    website
    logoUrl
    name
    externalLink
    organisation_supplier_brand {
      id
      supplierId
    }
    external_contacts(where: {deletedAt: {_is_null: true}}) {
      id
      email
      firstName
      lastName
      isPrimary
      phoneNumber
      title
    }
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
    }
  }
  engagements {
    id
    name
    department
  }
}`) as unknown as TypedDocumentString<UpdateOrganisationProductsAndServiceMutation, UpdateOrganisationProductsAndServiceMutationVariables>;
export const GetProductNamesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetProductNames($productIds: [uuid!]!) {
  globalProducts: products_and_services(where: {id: {_in: $productIds}}) {
    id
    name
  }
  organisationProducts: organisation_products_and_services(
    where: {id: {_in: $productIds}}
  ) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<GetProductNamesQuery, GetProductNamesQueryVariables>;
export const DeletePublicApiApplicationDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeletePublicApiApplication($id: uuid!) {
  update_organisation_integrations_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeletePublicApiApplicationMutation, DeletePublicApiApplicationMutationVariables>;
export const UnlinkPublicApiApplicationDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnlinkPublicApiApplicationData($appId: uuid!) {
  suppliers: update_organisation_suppliers(
    where: {organisationIntegrationId: {_eq: $appId}}
    _set: {organisationIntegrationId: null}
  ) {
    returning {
      id
    }
  }
  customFields: update_custom_fields(
    where: {organisationIntegrationId: {_eq: $appId}}
    _set: {organisationIntegrationId: null}
  ) {
    returning {
      id
    }
  }
  customCoreData: update_custom_core_data(
    where: {organisationIntegrationId: {_eq: $appId}}
    _set: {organisationIntegrationId: null}
  ) {
    returning {
      id
    }
  }
  coreData: delete_core_data_organisation_integrations(
    where: {organisationIntegrationId: {_eq: $appId}}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UnlinkPublicApiApplicationDataMutation, UnlinkPublicApiApplicationDataMutationVariables>;
export const BatchRestorePublicApiClientsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BatchRestorePublicApiClients($ids: [uuid!]!) {
  update_organisation_public_api_clients(
    where: {id: {_in: $ids}}
    _set: {deletedAt: null}
  ) {
    returning {
      ...OrganisationPublicApiClient
    }
  }
}
    fragment OrganisationPublicApiClient on organisation_public_api_clients {
  id
  name
  userPoolId
  userPoolClientId
  organisationIntegrationId
  createdAt
  updatedAt
}`) as unknown as TypedDocumentString<BatchRestorePublicApiClientsMutation, BatchRestorePublicApiClientsMutationVariables>;
export const CreatePublicApiClientDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreatePublicApiClient($input: organisation_public_api_clients_insert_input!) {
  insert_organisation_public_api_clients_one(object: $input) {
    ...OrganisationPublicApiClient
  }
}
    fragment OrganisationPublicApiClient on organisation_public_api_clients {
  id
  name
  userPoolId
  userPoolClientId
  organisationIntegrationId
  createdAt
  updatedAt
}`) as unknown as TypedDocumentString<CreatePublicApiClientMutation, CreatePublicApiClientMutationVariables>;
export const DeletePublicApiClientDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeletePublicApiClient($id: uuid!) {
  update_organisation_public_api_clients_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
    userPoolClientId
  }
}
    `) as unknown as TypedDocumentString<DeletePublicApiClientMutation, DeletePublicApiClientMutationVariables>;
export const DeletePublicApiClientsForOrgIntegrationIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeletePublicApiClientsForOrgIntegrationId($integrationId: uuid!) {
  update_organisation_public_api_clients(
    where: {organisationIntegrationId: {_eq: $integrationId}, deletedAt: {_is_null: true}}
    _set: {deletedAt: "now()"}
  ) {
    returning {
      ...OrganisationPublicApiClient
    }
  }
}
    fragment OrganisationPublicApiClient on organisation_public_api_clients {
  id
  name
  userPoolId
  userPoolClientId
  organisationIntegrationId
  createdAt
  updatedAt
}`) as unknown as TypedDocumentString<DeletePublicApiClientsForOrgIntegrationIdMutation, DeletePublicApiClientsForOrgIntegrationIdMutationVariables>;
export const GetPublicApiClientsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPublicApiClients($query: organisation_public_api_clients_bool_exp) {
  organisation_public_api_clients(where: $query) {
    ...OrganisationPublicApiClient
  }
}
    fragment OrganisationPublicApiClient on organisation_public_api_clients {
  id
  name
  userPoolId
  userPoolClientId
  organisationIntegrationId
  createdAt
  updatedAt
}`) as unknown as TypedDocumentString<GetPublicApiClientsQuery, GetPublicApiClientsQueryVariables>;
export const RestorePublicApiClientDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation RestorePublicApiClient($id: uuid!) {
  update_organisation_public_api_clients_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: null}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<RestorePublicApiClientMutation, RestorePublicApiClientMutationVariables>;
export const UpdateOrganisationIntegrationDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateOrganisationIntegration($id: uuid!, $input: organisation_integrations_set_input!) {
  update_organisation_integrations_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateOrganisationIntegrationMutation, UpdateOrganisationIntegrationMutationVariables>;
export const UpdatePublicApiClientDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdatePublicApiClient($id: uuid!, $input: organisation_public_api_clients_set_input!) {
  update_organisation_public_api_clients_by_pk(
    pk_columns: {id: $id}
    _set: $input
  ) {
    ...OrganisationPublicApiClient
  }
}
    fragment OrganisationPublicApiClient on organisation_public_api_clients {
  id
  name
  userPoolId
  userPoolClientId
  organisationIntegrationId
  createdAt
  updatedAt
}`) as unknown as TypedDocumentString<UpdatePublicApiClientMutation, UpdatePublicApiClientMutationVariables>;
export const BatchCreateAddressesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BatchCreateAddresses($objects: [addresses_insert_input!]!) {
  insert_addresses(
    objects: $objects
    on_conflict: {constraint: addresses_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      ...StoreAddress
    }
  }
}
    fragment StoreAddress on addresses {
  id
  name
  addressLine1
  addressLine2
  city
  county
  state
  postalCode
  country
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<BatchCreateAddressesMutation, BatchCreateAddressesMutationVariables>;
export const GetAddressesForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAddressesForPublicApi($limit: Int!, $orderBy: [addresses_order_by!]!, $where: addresses_bool_exp) {
  addresses(where: $where, limit: $limit, order_by: $orderBy) {
    ...StoreAddress
  }
}
    fragment StoreAddress on addresses {
  id
  name
  addressLine1
  addressLine2
  city
  county
  state
  postalCode
  country
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<GetAddressesForPublicApiQuery, GetAddressesForPublicApiQueryVariables>;
export const UpdateAddressForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateAddressForPublicApi($id: uuid!, $object: addresses_set_input!) {
  update_addresses_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...StoreAddress
  }
}
    fragment StoreAddress on addresses {
  id
  name
  addressLine1
  addressLine2
  city
  county
  state
  postalCode
  country
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<UpdateAddressForPublicApiMutation, UpdateAddressForPublicApiMutationVariables>;
export const BatchCreateCurrenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BatchCreateCurrencies($objects: [organisation_fx_rates_insert_input!]!) {
  insert_organisation_fx_rates(
    objects: $objects
    on_conflict: {constraint: organisation_currencies_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      ...StoreCurrency
    }
  }
}
    fragment StoreCurrency on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<BatchCreateCurrenciesMutation, BatchCreateCurrenciesMutationVariables>;
export const GetCurrenciesForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCurrenciesForPublicApi($limit: Int!, $orderBy: [organisation_fx_rates_order_by!]!, $where: organisation_fx_rates_bool_exp) {
  organisation_fx_rates(where: $where, limit: $limit, order_by: $orderBy) {
    ...StoreCurrency
  }
}
    fragment StoreCurrency on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<GetCurrenciesForPublicApiQuery, GetCurrenciesForPublicApiQueryVariables>;
export const UpdateCurrencyForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateCurrencyForPublicApi($id: uuid!, $object: organisation_fx_rates_set_input!) {
  update_organisation_fx_rates_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...StoreCurrency
  }
}
    fragment StoreCurrency on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<UpdateCurrencyForPublicApiMutation, UpdateCurrencyForPublicApiMutationVariables>;
export const GetCustomDataForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomDataForPublicApi($limit: Int!, $orderBy: [custom_core_data_order_by!]!, $where: custom_core_data_bool_exp) {
  custom_core_data(limit: $limit, order_by: $orderBy, where: $where) {
    ...StoreCustomData
  }
}
    fragment StoreCustomData on custom_core_data {
  id
  name
  slug
  organisationIntegration {
    id
    name
    integration
  }
  createdAt
  updatedAt
  archivedAt
}`) as unknown as TypedDocumentString<GetCustomDataForPublicApiQuery, GetCustomDataForPublicApiQueryVariables>;
export const UpdateCustomDataForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateCustomDataForPublicApi($id: uuid!, $object: custom_core_data_set_input!) {
  update_custom_core_data_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...StoreCustomData
  }
}
    fragment StoreCustomData on custom_core_data {
  id
  name
  slug
  organisationIntegration {
    id
    name
    integration
  }
  createdAt
  updatedAt
  archivedAt
}`) as unknown as TypedDocumentString<UpdateCustomDataForPublicApiMutation, UpdateCustomDataForPublicApiMutationVariables>;
export const GetCustomDataRecordsForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomDataRecordsForPublicApi($limit: Int!, $orderBy: [custom_core_data_options_order_by!]!, $where: custom_core_data_options_bool_exp) {
  custom_core_data_options(where: $where, limit: $limit, order_by: $orderBy) {
    ...StoreCustomDataRecord
  }
}
    fragment StoreCustomDataRecord on custom_core_data_options {
  id
  value
  remoteId
  updatedAt
  createdAt
  isArchived
  archivedBy
  coreDataId
  custom_core_data {
    slug
    pathLevels
  }
  coreData {
    ...CoreDataDependenciesFragment
  }
}
fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<GetCustomDataRecordsForPublicApiQuery, GetCustomDataRecordsForPublicApiQueryVariables>;
export const BatchCreateCustomDataRecordsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BatchCreateCustomDataRecords($objects: [custom_core_data_options_insert_input!]!) {
  insert_custom_core_data_options(
    objects: $objects
    on_conflict: {constraint: custom_core_data_options_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      ...StoreCustomDataRecord
    }
  }
}
    fragment StoreCustomDataRecord on custom_core_data_options {
  id
  value
  remoteId
  updatedAt
  createdAt
  isArchived
  archivedBy
  coreDataId
  custom_core_data {
    slug
    pathLevels
  }
  coreData {
    ...CoreDataDependenciesFragment
  }
}
fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<BatchCreateCustomDataRecordsMutation, BatchCreateCustomDataRecordsMutationVariables>;
export const UpdateCustomDataRecordForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateCustomDataRecordForPublicApi($id: uuid!, $object: custom_core_data_options_set_input!) {
  update_custom_core_data_options_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...StoreCustomDataRecord
  }
}
    fragment StoreCustomDataRecord on custom_core_data_options {
  id
  value
  remoteId
  updatedAt
  createdAt
  isArchived
  archivedBy
  coreDataId
  custom_core_data {
    slug
    pathLevels
  }
  coreData {
    ...CoreDataDependenciesFragment
  }
}
fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<UpdateCustomDataRecordForPublicApiMutation, UpdateCustomDataRecordForPublicApiMutationVariables>;
export const BatchCreateDepartmentsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BatchCreateDepartments($objects: [departments_insert_input!]!) {
  insert_departments(
    objects: $objects
    on_conflict: {constraint: departments_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      ...StoreDepartment
    }
  }
}
    fragment StoreDepartment on departments {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<BatchCreateDepartmentsMutation, BatchCreateDepartmentsMutationVariables>;
export const GetDepartmentsForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetDepartmentsForPublicApi($limit: Int!, $orderBy: [departments_order_by!]!, $where: departments_bool_exp) {
  departments(where: $where, limit: $limit, order_by: $orderBy) {
    ...StoreDepartment
  }
}
    fragment StoreDepartment on departments {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<GetDepartmentsForPublicApiQuery, GetDepartmentsForPublicApiQueryVariables>;
export const UpdateDepartmentForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateDepartmentForPublicApi($id: uuid!, $object: departments_set_input!) {
  update_departments_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...StoreDepartment
  }
}
    fragment StoreDepartment on departments {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}
fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<UpdateDepartmentForPublicApiMutation, UpdateDepartmentForPublicApiMutationVariables>;
export const InsertOnConflictCoreDataDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertOnConflictCoreDataDependencies($dependenciesToInsert: [core_data_dependencies_insert_input!]!) {
  inserted: insert_core_data_dependencies(
    objects: $dependenciesToInsert
    on_conflict: {constraint: core_data_dependencies_core_data_id_dependency_core_data_id_key, update_columns: [deletedAt]}
  ) {
    returning {
      id
      coreDataId
      createdAt
    }
  }
}
    `) as unknown as TypedDocumentString<InsertOnConflictCoreDataDependenciesMutation, InsertOnConflictCoreDataDependenciesMutationVariables>;
export const DeleteNonMatchingCoreDataDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteNonMatchingCoreDataDependencies($coreDataIds: [uuid!]!, $idsToKeep: [uuid!]!) {
  deleted: update_core_data_dependencies(
    where: {coreDataId: {_in: $coreDataIds}, id: {_nin: $idsToKeep}, deletedAt: {_is_null: true}}
    _set: {deletedAt: "now()"}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteNonMatchingCoreDataDependenciesMutation, DeleteNonMatchingCoreDataDependenciesMutationVariables>;
export const GetCoreDataIdsWithIdAndRemoteIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCoreDataIdsWithIdAndRemoteId($filter: core_data_bool_exp!) {
  coreData: core_data(where: $filter) {
    id
    subsidiary {
      id
      remoteId
    }
    address {
      id
      remoteId
    }
    paymentTerm {
      id
      remoteId
    }
    paymentMethod {
      id
      remoteId
    }
    department {
      id
      remoteId
    }
    customCoreDataOption {
      id
      remoteId
    }
    currency {
      id
      remoteId
    }
    lineItemType {
      id
      remoteId
    }
  }
}
    `) as unknown as TypedDocumentString<GetCoreDataIdsWithIdAndRemoteIdQuery, GetCoreDataIdsWithIdAndRemoteIdQueryVariables>;
export const GetCoreDataDependenciesPaginatedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCoreDataDependenciesPaginated($where: core_data_dependencies_bool_exp!, $limit: Int!, $orderBy: [core_data_dependencies_order_by!]!) {
  core_data_dependencies(where: $where, order_by: $orderBy, limit: $limit) {
    id
    isAll
    dependencyCoreDataType
    createdAt
    deletedAt
    dependencyCoreData {
      customCoreDataOption {
        id
        remoteId
        custom_core_data {
          slug
        }
      }
      subsidiary {
        id
        remoteId
      }
      address {
        id
        remoteId
      }
      paymentTerm {
        id
        remoteId
      }
      paymentMethod {
        id
        remoteId
      }
      department {
        id
        remoteId
      }
      currency {
        id
        remoteId
      }
      lineItemType {
        id
        remoteId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCoreDataDependenciesPaginatedQuery, GetCoreDataDependenciesPaginatedQueryVariables>;
export const GetOrganisationCoreDataDependenciesWithCustomCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationCoreDataDependenciesWithCustomCoreData($where: organisation_core_data_dependencies_bool_exp!, $limit: Int!) {
  organisationCoreDataDependencies: organisation_core_data_dependencies(
    where: $where
    limit: $limit
  ) {
    id
    coreDataType
    dependencyCoreDataType
    customCoreData {
      id
      slug
    }
    dependencyCustomCoreData {
      id
      slug
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationCoreDataDependenciesWithCustomCoreDataQuery, GetOrganisationCoreDataDependenciesWithCustomCoreDataQueryVariables>;
export const DeleteCoreDataDependencyByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteCoreDataDependencyById($id: uuid!) {
  update_core_data_dependencies_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
    deletedAt
  }
}
    `) as unknown as TypedDocumentString<DeleteCoreDataDependencyByIdMutation, DeleteCoreDataDependencyByIdMutationVariables>;
export const BatchCreateLineItemTypesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BatchCreateLineItemTypes($objects: [line_item_types_insert_input!]!) {
  insert_line_item_types(
    objects: $objects
    on_conflict: {constraint: line_item_types_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      ...StoreLineItemType
    }
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}
fragment StoreLineItemType on line_item_types {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}`) as unknown as TypedDocumentString<BatchCreateLineItemTypesMutation, BatchCreateLineItemTypesMutationVariables>;
export const GetLineItemTypesForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLineItemTypesForPublicApi($limit: Int!, $orderBy: [line_item_types_order_by!]!, $where: line_item_types_bool_exp) {
  line_item_types(where: $where, limit: $limit, order_by: $orderBy) {
    ...StoreLineItemType
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}
fragment StoreLineItemType on line_item_types {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}`) as unknown as TypedDocumentString<GetLineItemTypesForPublicApiQuery, GetLineItemTypesForPublicApiQueryVariables>;
export const UpdateLineItemTypeForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateLineItemTypeForPublicApi($id: uuid!, $object: line_item_types_set_input!) {
  update_line_item_types_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...StoreLineItemType
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}
fragment StoreLineItemType on line_item_types {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}`) as unknown as TypedDocumentString<UpdateLineItemTypeForPublicApiMutation, UpdateLineItemTypeForPublicApiMutationVariables>;
export const BatchCreatePaymentMethodsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BatchCreatePaymentMethods($objects: [payment_methods_insert_input!]!) {
  insert_payment_methods(
    objects: $objects
    on_conflict: {constraint: payment_methods_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      ...StorePaymentMethod
    }
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}
fragment StorePaymentMethod on payment_methods {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}`) as unknown as TypedDocumentString<BatchCreatePaymentMethodsMutation, BatchCreatePaymentMethodsMutationVariables>;
export const GetPaymentMethodsForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentMethodsForPublicApi($limit: Int!, $orderBy: [payment_methods_order_by!]!, $where: payment_methods_bool_exp) {
  payment_methods(where: $where, limit: $limit, order_by: $orderBy) {
    ...StorePaymentMethod
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}
fragment StorePaymentMethod on payment_methods {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}`) as unknown as TypedDocumentString<GetPaymentMethodsForPublicApiQuery, GetPaymentMethodsForPublicApiQueryVariables>;
export const UpdatePaymentMethodForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdatePaymentMethodForPublicApi($id: uuid!, $object: payment_methods_set_input!) {
  update_payment_methods_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...StorePaymentMethod
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}
fragment StorePaymentMethod on payment_methods {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}`) as unknown as TypedDocumentString<UpdatePaymentMethodForPublicApiMutation, UpdatePaymentMethodForPublicApiMutationVariables>;
export const BatchCreatePaymentTermsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BatchCreatePaymentTerms($objects: [payment_terms_insert_input!]!) {
  insert_payment_terms(
    objects: $objects
    on_conflict: {constraint: payment_terms_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      ...StorePaymentTerm
    }
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}
fragment StorePaymentTerm on payment_terms {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}`) as unknown as TypedDocumentString<BatchCreatePaymentTermsMutation, BatchCreatePaymentTermsMutationVariables>;
export const GetPaymentTermsForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentTermsForPublicApi($limit: Int!, $orderBy: [payment_terms_order_by!]!, $where: payment_terms_bool_exp) {
  payment_terms(where: $where, limit: $limit, order_by: $orderBy) {
    ...StorePaymentTerm
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}
fragment StorePaymentTerm on payment_terms {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}`) as unknown as TypedDocumentString<GetPaymentTermsForPublicApiQuery, GetPaymentTermsForPublicApiQueryVariables>;
export const UpdatePaymentTermForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdatePaymentTermForPublicApi($id: uuid!, $object: payment_terms_set_input!) {
  update_payment_terms_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...StorePaymentTerm
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}
fragment StorePaymentTerm on payment_terms {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}`) as unknown as TypedDocumentString<UpdatePaymentTermForPublicApiMutation, UpdatePaymentTermForPublicApiMutationVariables>;
export const GetPurchaseOrdersForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPurchaseOrdersForPublicApi($limit: Int!, $orderBy: [purchase_orders_order_by!]!, $where: purchase_orders_bool_exp) {
  purchaseOrders: purchase_orders(
    limit: $limit
    order_by: $orderBy
    where: $where
  ) {
    ...StorePurchaseOrder
  }
  headerCustomFields: custom_fields(
    where: {entityType: {_eq: "purchase-order"}, deletedAt: {_is_null: true}}
  ) {
    ...CustomFieldSchemaForRepository
  }
  lineItemCustomFields: custom_fields(
    where: {entityType: {_eq: "line-item"}, deletedAt: {_is_null: true}}
  ) {
    ...CustomFieldSchemaForRepository
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment StorePurchaseOrderLineItem on purchase_order_line_items {
  lineNumber
  quantity
  unitPrice
  amount
  lineItemCurrency {
    id
    remoteId
    code
    name
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment StorePurchaseOrder on purchase_orders {
  id
  remoteId
  remoteNumber
  remoteStatus
  remoteLink
  remoteTotalValue
  remoteInvoicedValue
  remotePaidValue
  totalValue
  contractStartDate
  contractEndDate
  organisationIntegrationId
  request {
    id
    publicId
    name
  }
  requestor {
    id
    email
    firstName
    lastName
  }
  supplier: organisationSupplier {
    id
    remoteId
    name
  }
  subsidiary {
    id
    remoteId
    name
  }
  department {
    id
    remoteId
    name
  }
  paymentTerm {
    id
    remoteId
    name
  }
  paymentMethod {
    id
    remoteId
    name
  }
  currency {
    id
    remoteId
    code
    name
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
  lineItems: purchaseOrderLineItems {
    ...StorePurchaseOrderLineItem
  }
  createdAt
  updatedAt
  deletedAt
}
fragment CustomFieldSchemaForRepository on custom_fields {
  id
  type
  externalSource
  customCoreDataId
  remoteId
  key
  title
  choices {
    id
    label
  }
}`) as unknown as TypedDocumentString<GetPurchaseOrdersForPublicApiQuery, GetPurchaseOrdersForPublicApiQueryVariables>;
export const UpdatePurchaseOrderForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdatePurchaseOrderForPublicApi($id: uuid!, $updates: purchase_orders_set_input!) {
  purchaseOrder: update_purchase_orders_by_pk(
    pk_columns: {id: $id}
    _set: $updates
  ) {
    ...StorePurchaseOrder
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment StorePurchaseOrderLineItem on purchase_order_line_items {
  lineNumber
  quantity
  unitPrice
  amount
  lineItemCurrency {
    id
    remoteId
    code
    name
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment StorePurchaseOrder on purchase_orders {
  id
  remoteId
  remoteNumber
  remoteStatus
  remoteLink
  remoteTotalValue
  remoteInvoicedValue
  remotePaidValue
  totalValue
  contractStartDate
  contractEndDate
  organisationIntegrationId
  request {
    id
    publicId
    name
  }
  requestor {
    id
    email
    firstName
    lastName
  }
  supplier: organisationSupplier {
    id
    remoteId
    name
  }
  subsidiary {
    id
    remoteId
    name
  }
  department {
    id
    remoteId
    name
  }
  paymentTerm {
    id
    remoteId
    name
  }
  paymentMethod {
    id
    remoteId
    name
  }
  currency {
    id
    remoteId
    code
    name
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
  lineItems: purchaseOrderLineItems {
    ...StorePurchaseOrderLineItem
  }
  createdAt
  updatedAt
  deletedAt
}`) as unknown as TypedDocumentString<UpdatePurchaseOrderForPublicApiMutation, UpdatePurchaseOrderForPublicApiMutationVariables>;
export const AssignPurchaseOrderOwnershipForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation AssignPurchaseOrderOwnershipForPublicApi($id: uuid!, $integrationId: uuid!) {
  update_purchase_orders(
    where: {id: {_eq: $id}, organisationIntegrationId: {_is_null: true}}
    _set: {organisationIntegrationId: $integrationId}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<AssignPurchaseOrderOwnershipForPublicApiMutation, AssignPurchaseOrderOwnershipForPublicApiMutationVariables>;
export const SoftDeletePurchaseOrderForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SoftDeletePurchaseOrderForPublicApi($id: uuid!) {
  update_purchase_orders_by_pk(pk_columns: {id: $id}, _set: {deletedAt: "now()"}) {
    id
  }
}
    `) as unknown as TypedDocumentString<SoftDeletePurchaseOrderForPublicApiMutation, SoftDeletePurchaseOrderForPublicApiMutationVariables>;
export const BatchCreateSubsidiariesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BatchCreateSubsidiaries($objects: [subsidiaries_insert_input!]!) {
  insert_subsidiaries(
    objects: $objects
    on_conflict: {constraint: subsidiaries_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      ...StoreSubsidiary
    }
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}
fragment StoreSubsidiary on subsidiaries {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}`) as unknown as TypedDocumentString<BatchCreateSubsidiariesMutation, BatchCreateSubsidiariesMutationVariables>;
export const GetSubsidiariesForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSubsidiariesForPublicApi($limit: Int!, $orderBy: [subsidiaries_order_by!]!, $where: subsidiaries_bool_exp) {
  subsidiaries(where: $where, limit: $limit, order_by: $orderBy) {
    ...StoreSubsidiary
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}
fragment StoreSubsidiary on subsidiaries {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}`) as unknown as TypedDocumentString<GetSubsidiariesForPublicApiQuery, GetSubsidiariesForPublicApiQueryVariables>;
export const UpdateSubsidiaryForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateSubsidiaryForPublicApi($id: uuid!, $object: subsidiaries_set_input!) {
  update_subsidiaries_by_pk(pk_columns: {id: $id}, _set: $object) {
    ...StoreSubsidiary
  }
}
    fragment CoreDataDependenciesFragment on core_data {
  coreDataDependencies_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  coreDataDependencies(
    where: {deletedAt: {_is_null: true}}
    order_by: {isAll: asc}
    limit: 1
  ) {
    isAll
    dependencyCoreDataType
    dependencyCoreData {
      customCoreDataOption {
        custom_core_data {
          slug
        }
      }
    }
  }
}
fragment StoreSubsidiary on subsidiaries {
  id
  name
  remoteId
  createdAt
  updatedAt
  isArchived
  archivedBy
  coreDataId
  coreData {
    ...CoreDataDependenciesFragment
  }
}`) as unknown as TypedDocumentString<UpdateSubsidiaryForPublicApiMutation, UpdateSubsidiaryForPublicApiMutationVariables>;
export const GetActiveUsersForUpdateByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetActiveUsersForUpdateById($ids: [uuid!]!) {
  users: users(
    where: {id: {_in: $ids}, isArchived: {_eq: false}, deletedAt: {_is_null: true}}
  ) {
    ...PublicApiUser
  }
  userAttributeCustomFields: custom_fields(
    where: {entityType: {_eq: "user-attribute"}, deletedAt: {_is_null: true}}
  ) {
    ...CustomFieldSchemaForRepository
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment PublicApiUser on users {
  id
  email
  firstName
  lastName
  role
  createdAt
  updatedAt
  department {
    id
    name
    remoteId
  }
  subsidiary {
    id
    name
    remoteId
  }
  managerUser {
    id
    email
    firstName
    lastName
  }
  customFieldValues(where: {customField: {entityType: {_eq: "user-attribute"}}}) {
    ...CustomFieldValueFragment
  }
  userAllowedSubsidiaries {
    subsidiary {
      id
      name
      remoteId
    }
  }
}
fragment CustomFieldSchemaForRepository on custom_fields {
  id
  type
  externalSource
  customCoreDataId
  remoteId
  key
  title
  choices {
    id
    label
  }
}`) as unknown as TypedDocumentString<GetActiveUsersForUpdateByIdQuery, GetActiveUsersForUpdateByIdQueryVariables>;
export const GetActiveUsersForUpdateByEmailDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetActiveUsersForUpdateByEmail($emails: [String!]!) {
  users: users(
    where: {email: {_in: $emails}, isArchived: {_eq: false}, deletedAt: {_is_null: true}}
  ) {
    ...PublicApiUser
  }
  userAttributeCustomFields: custom_fields(
    where: {entityType: {_eq: "user-attribute"}, deletedAt: {_is_null: true}}
  ) {
    ...CustomFieldSchemaForRepository
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment PublicApiUser on users {
  id
  email
  firstName
  lastName
  role
  createdAt
  updatedAt
  department {
    id
    name
    remoteId
  }
  subsidiary {
    id
    name
    remoteId
  }
  managerUser {
    id
    email
    firstName
    lastName
  }
  customFieldValues(where: {customField: {entityType: {_eq: "user-attribute"}}}) {
    ...CustomFieldValueFragment
  }
  userAllowedSubsidiaries {
    subsidiary {
      id
      name
      remoteId
    }
  }
}
fragment CustomFieldSchemaForRepository on custom_fields {
  id
  type
  externalSource
  customCoreDataId
  remoteId
  key
  title
  choices {
    id
    label
  }
}`) as unknown as TypedDocumentString<GetActiveUsersForUpdateByEmailQuery, GetActiveUsersForUpdateByEmailQueryVariables>;
export const GetUsersForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUsersForPublicApi($limit: Int!, $orderBy: [users_order_by!]!, $where: users_bool_exp) {
  users(where: $where, limit: $limit, order_by: $orderBy) {
    ...PublicApiUser
  }
  userAttributeCustomFields: custom_fields(
    where: {entityType: {_eq: "user-attribute"}, deletedAt: {_is_null: true}}
  ) {
    ...CustomFieldSchemaForRepository
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment PublicApiUser on users {
  id
  email
  firstName
  lastName
  role
  createdAt
  updatedAt
  department {
    id
    name
    remoteId
  }
  subsidiary {
    id
    name
    remoteId
  }
  managerUser {
    id
    email
    firstName
    lastName
  }
  customFieldValues(where: {customField: {entityType: {_eq: "user-attribute"}}}) {
    ...CustomFieldValueFragment
  }
  userAllowedSubsidiaries {
    subsidiary {
      id
      name
      remoteId
    }
  }
}
fragment CustomFieldSchemaForRepository on custom_fields {
  id
  type
  externalSource
  customCoreDataId
  remoteId
  key
  title
  choices {
    id
    label
  }
}`) as unknown as TypedDocumentString<GetUsersForPublicApiQuery, GetUsersForPublicApiQueryVariables>;
export const GetCoreDataOrganisationIntegrationsForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCoreDataOrganisationIntegrationsForPublicApi($organisationIntegrationId: uuid!, $coreDataType: String!) {
  core_data_organisation_integrations(
    where: {organisationIntegrationId: {_eq: $organisationIntegrationId}, coreDataType: {_eq: $coreDataType}}
  ) {
    id
    organisationIntegrationId
    coreDataType
  }
}
    `) as unknown as TypedDocumentString<GetCoreDataOrganisationIntegrationsForPublicApiQuery, GetCoreDataOrganisationIntegrationsForPublicApiQueryVariables>;
export const GetCoreDataOrganisationIntegrationsByTypeForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCoreDataOrganisationIntegrationsByTypeForPublicApi($coreDataType: String!) {
  core_data_organisation_integrations(where: {coreDataType: {_eq: $coreDataType}}) {
    id
    organisationIntegrationId
    coreDataType
  }
}
    `) as unknown as TypedDocumentString<GetCoreDataOrganisationIntegrationsByTypeForPublicApiQuery, GetCoreDataOrganisationIntegrationsByTypeForPublicApiQueryVariables>;
export const InsertCoreDataOrganisationIntegrationForPublicApiDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertCoreDataOrganisationIntegrationForPublicApi($organisationIntegrationId: uuid!, $coreDataType: String!) {
  insert_core_data_organisation_integrations_one(
    object: {organisationIntegrationId: $organisationIntegrationId, coreDataType: $coreDataType}
  ) {
    id
    organisationIntegrationId
    coreDataType
  }
}
    `) as unknown as TypedDocumentString<InsertCoreDataOrganisationIntegrationForPublicApiMutation, InsertCoreDataOrganisationIntegrationForPublicApiMutationVariables>;
export const GetPurchaseOrderDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPurchaseOrder($id: uuid!) {
  purchase_orders(where: {id: {_eq: $id}, deletedAt: {_is_null: true}}) {
    id
    remoteNumber
    remoteLink
    requestId
    createdAt
    updatedAt
    deletedAt
    organisationIntegrationId
  }
}
    `) as unknown as TypedDocumentString<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>;
export const UpdatePurchaseOrderDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdatePurchaseOrder($id: uuid!, $input: purchase_orders_set_input!) {
  update_purchase_orders_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
    requestId
    remoteNumber
    remoteLink
    organisationIntegrationId
  }
}
    `) as unknown as TypedDocumentString<UpdatePurchaseOrderMutation, UpdatePurchaseOrderMutationVariables>;
export const CreateOrganisationSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateOrganisationSuppliers($objects: [organisation_suppliers_insert_input!]!) {
  insert_organisation_suppliers(objects: $objects) {
    returning {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<CreateOrganisationSuppliersMutation, CreateOrganisationSuppliersMutationVariables>;
export const CreateTagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateTags($objects: [tags_insert_input!]!) {
  insert_tags(objects: $objects) {
    returning {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<CreateTagsMutation, CreateTagsMutationVariables>;
export const DeleteRenewalDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRenewal($id: uuid!) {
  renewal: update_renewals_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteRenewalMutation, DeleteRenewalMutationVariables>;
export const DeleteRenewalAdditionalUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRenewalAdditionalUsers($userIds: [uuid!]!, $renewalId: uuid!) {
  deletedRenewalAdditionalUsers: delete_renewal_additional_users(
    where: {_and: [{userId: {_in: $userIds}}, {renewalId: {_eq: $renewalId}}]}
  ) {
    returning {
      renewalId
      userId
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteRenewalAdditionalUsersMutation, DeleteRenewalAdditionalUsersMutationVariables>;
export const DeleteRenewalTagsByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRenewalTagsById($renewalTagIds: [uuid!]!) {
  deletedRenewalTags: delete_renewal_tags(where: {id: {_in: $renewalTagIds}}) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteRenewalTagsByIdMutation, DeleteRenewalTagsByIdMutationVariables>;
export const DeleteRenewalTagsByRenewalIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRenewalTagsByRenewalId($renewalId: uuid!) {
  deletedRenewalTags: delete_renewal_tags(where: {renewalId: {_eq: $renewalId}}) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteRenewalTagsByRenewalIdMutation, DeleteRenewalTagsByRenewalIdMutationVariables>;
export const GetAdminUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAdminUsers {
  users(
    where: {_and: {role: {_eq: "editor"}, isArchived: {_eq: false}, deletedAt: {_is_null: true}}}
  ) {
    id
    firstName
    lastName
    hasConfigPermissions
  }
}
    `) as unknown as TypedDocumentString<GetAdminUsersQuery, GetAdminUsersQueryVariables>;
export const GetMatchingOrgProductsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetMatchingOrgProducts($productName: String!, $organisationSupplierId: uuid!) {
  organisation_products_and_services(
    where: {name: {_ilike: $productName}, organisationSupplierId: {_eq: $organisationSupplierId}, deleted_at: {_is_null: true}, isArchived: {_neq: true}}
  ) {
    id
    name
    displayName
    organisationSupplierId
  }
}
    `) as unknown as TypedDocumentString<GetMatchingOrgProductsQuery, GetMatchingOrgProductsQueryVariables>;
export const GetMatchingSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetMatchingSupplier($remoteId: String!, $supplierName: String!) {
  organisation_suppliers(
    where: {_or: [{remoteId: {_eq: $remoteId}, deleted_at: {_is_null: true}}, {name: {_ilike: $supplierName}, deleted_at: {_is_null: true}}]}
  ) {
    id
    name
    remoteId
  }
}
    `) as unknown as TypedDocumentString<GetMatchingSupplierQuery, GetMatchingSupplierQueryVariables>;
export const GetMatchingSupplierByNameDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetMatchingSupplierByName($supplierName: String!) {
  organisation_suppliers(
    where: {name: {_ilike: $supplierName}, deleted_at: {_is_null: true}}
  ) {
    id
    name
    remoteId
  }
}
    `) as unknown as TypedDocumentString<GetMatchingSupplierByNameQuery, GetMatchingSupplierByNameQueryVariables>;
export const GetNonSupplierOrgUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetNonSupplierOrgUsers {
  users(
    where: {_and: [{isArchived: {_eq: false}}, {deletedAt: {_is_null: true}}, {role: {_neq: "supplier"}}]}
  ) {
    id
    email
    firstName
    lastName
    role
    isArchived
  }
}
    `) as unknown as TypedDocumentString<GetNonSupplierOrgUsersQuery, GetNonSupplierOrgUsersQueryVariables>;
export const GetOrgActiveWorkflowsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgActiveWorkflows {
  workflows(
    where: {deletedAt: {_is_null: true}, isArchived: {_eq: false}, state: {_eq: PUBLISHED}}
  ) {
    title
    id
    type
  }
}
    `) as unknown as TypedDocumentString<GetOrgActiveWorkflowsQuery, GetOrgActiveWorkflowsQueryVariables>;
export const GetOrgDepartmentsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgDepartments {
  departments(where: {isArchived: {_eq: false}}) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<GetOrgDepartmentsQuery, GetOrgDepartmentsQueryVariables>;
export const GetOrgWorkflowsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgWorkflows {
  workflows(
    where: {deletedAt: {_is_null: true}, isArchived: {_eq: false}, state: {_eq: PUBLISHED}}
  ) {
    title
    id
    type
  }
}
    `) as unknown as TypedDocumentString<GetOrgWorkflowsQuery, GetOrgWorkflowsQueryVariables>;
export const GetOrganisationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisation($organisationId: uuid!) {
  organisation: organisations_by_pk(id: $organisationId) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationQuery, GetOrganisationQueryVariables>;
export const GetRenewalAdditionalUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRenewalAdditionalUsers($renewalId: uuid!) {
  renewalAdditionalUsers: renewal_additional_users(
    where: {renewalId: {_eq: $renewalId}}
  ) {
    id
    user {
      id
      firstName
      lastName
      email
    }
  }
}
    `) as unknown as TypedDocumentString<GetRenewalAdditionalUsersQuery, GetRenewalAdditionalUsersQueryVariables>;
export const GetRenewalTagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRenewalTags($renewalId: uuid!) {
  renewalTags: renewal_tags(
    where: {_and: [{renewalId: {_eq: $renewalId}}, {tag: {deletedAt: {_is_null: true}}}]}
  ) {
    id
    tag {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetRenewalTagsQuery, GetRenewalTagsQueryVariables>;
export const GetRenewalByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRenewalById($id: uuid!) {
  renewal: renewals_by_pk(id: $id) {
    ...Renewal
  }
}
    fragment Renewal on renewals {
  id
  cancellationNoticeDayCount
  department {
    id
    name
  }
  costCurrency
  costValue
  note
  renewalDate
  autoStartEnabled
  deletedAt
  sourceRequestId
  sourceRequest {
    id
    name
    publicId
  }
  renewalAdditionalUsers {
    user {
      id
      firstName
      lastName
      email
      isArchived
    }
  }
  request {
    id
    completedAt
    updatedAt
    state
    model
    tagIds
    publicId
    request_tags(where: {tag: {deletedAt: {_is_null: true}}}) {
      id
      tag {
        id
        name
        deletedAt
      }
    }
    computedProperties {
      valueObject
    }
    steps {
      id
      canvasModelId
      state
      input
      createdAt
      completedAt
      totalPausedWorkingHours
      requestStepUsers: request_step_users {
        id
        user {
          id
          firstName
          lastName
          isArchived
        }
      }
    }
    request_forms {
      id
      config
      currentSubmission: request_form_submissions(
        limit: 1
        order_by: {submittedOn: desc_nulls_last}
      ) {
        id
        response
        submittedOn
      }
    }
    inProgressStepContext: steps(
      where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
    ) {
      id
      nodeId: canvasModelId
      name: input(path: "$.metadata.config.payload.label")
      type: input(path: "$.metadata.type")
      state
      requestStepUsers: request_step_users(where: {deletedAt: {_is_null: true}}) {
        id
        user {
          id
          firstName
          lastName
          isArchived
        }
      }
      requestStepGroups: request_step_groups(where: {deletedAt: {_is_null: true}}) {
        id
        group {
          id
          name
          groupUsers: group_users {
            id
            userId
          }
        }
      }
    }
    supplier {
      id
      state
      organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
        id
        subsidiaryId
      }
    }
    product {
      id
      name
      state
    }
    request_pauses {
      start
      end
    }
  }
  workflow {
    id
    title
  }
  workflowInitialAssignee {
    id
    firstName
    lastName
    isArchived
  }
  workflowStartDayCount
  product {
    id
    name: displayName
    logoUrl
  }
  supplier {
    id
    name
    logoUrl
    remoteId
  }
  renewalTags(where: {tag: {deletedAt: {_is_null: true}}}) {
    id
    tag {
      id
      name
    }
  }
  sourceAgreementTerm {
    id
    agreement {
      id
      name
      ownerId
      additionalOwners {
        userId
        user {
          id
          firstName
          lastName
          email
        }
      }
      tags(where: {tag: {deletedAt: {_is_null: true}}}) {
        id
        tag {
          id
          name
        }
      }
    }
  }
  cancelledAt
  renewedAt
  createdAt
}`) as unknown as TypedDocumentString<GetRenewalByIdQuery, GetRenewalByIdQueryVariables>;
export const ListRenewalsForAdminUserDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListRenewalsForAdminUser($offset: Int!, $limit: Int!) {
  renewals(where: {deletedAt: {_is_null: true}}, offset: $offset, limit: $limit) {
    ...Renewal
  }
  renewals_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
}
    fragment Renewal on renewals {
  id
  cancellationNoticeDayCount
  department {
    id
    name
  }
  costCurrency
  costValue
  note
  renewalDate
  autoStartEnabled
  deletedAt
  sourceRequestId
  sourceRequest {
    id
    name
    publicId
  }
  renewalAdditionalUsers {
    user {
      id
      firstName
      lastName
      email
      isArchived
    }
  }
  request {
    id
    completedAt
    updatedAt
    state
    model
    tagIds
    publicId
    request_tags(where: {tag: {deletedAt: {_is_null: true}}}) {
      id
      tag {
        id
        name
        deletedAt
      }
    }
    computedProperties {
      valueObject
    }
    steps {
      id
      canvasModelId
      state
      input
      createdAt
      completedAt
      totalPausedWorkingHours
      requestStepUsers: request_step_users {
        id
        user {
          id
          firstName
          lastName
          isArchived
        }
      }
    }
    request_forms {
      id
      config
      currentSubmission: request_form_submissions(
        limit: 1
        order_by: {submittedOn: desc_nulls_last}
      ) {
        id
        response
        submittedOn
      }
    }
    inProgressStepContext: steps(
      where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
    ) {
      id
      nodeId: canvasModelId
      name: input(path: "$.metadata.config.payload.label")
      type: input(path: "$.metadata.type")
      state
      requestStepUsers: request_step_users(where: {deletedAt: {_is_null: true}}) {
        id
        user {
          id
          firstName
          lastName
          isArchived
        }
      }
      requestStepGroups: request_step_groups(where: {deletedAt: {_is_null: true}}) {
        id
        group {
          id
          name
          groupUsers: group_users {
            id
            userId
          }
        }
      }
    }
    supplier {
      id
      state
      organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
        id
        subsidiaryId
      }
    }
    product {
      id
      name
      state
    }
    request_pauses {
      start
      end
    }
  }
  workflow {
    id
    title
  }
  workflowInitialAssignee {
    id
    firstName
    lastName
    isArchived
  }
  workflowStartDayCount
  product {
    id
    name: displayName
    logoUrl
  }
  supplier {
    id
    name
    logoUrl
    remoteId
  }
  renewalTags(where: {tag: {deletedAt: {_is_null: true}}}) {
    id
    tag {
      id
      name
    }
  }
  sourceAgreementTerm {
    id
    agreement {
      id
      name
      ownerId
      additionalOwners {
        userId
        user {
          id
          firstName
          lastName
          email
        }
      }
      tags(where: {tag: {deletedAt: {_is_null: true}}}) {
        id
        tag {
          id
          name
        }
      }
    }
  }
  cancelledAt
  renewedAt
  createdAt
}`) as unknown as TypedDocumentString<ListRenewalsForAdminUserQuery, ListRenewalsForAdminUserQueryVariables>;
export const GetAdminRenewalsForStatsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAdminRenewalsForStats {
  renewals(where: {requestId: {_is_null: true}, deletedAt: {_is_null: true}}) {
    id
    renewalDate
    workflowStartDayCount
    cancellationNoticeDayCount
  }
}
    `) as unknown as TypedDocumentString<GetAdminRenewalsForStatsQuery, GetAdminRenewalsForStatsQueryVariables>;
export const GetUserRenewalsForStatsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUserRenewalsForStats($id: uuid!) {
  renewals(
    where: {requestId: {_is_null: true}, deletedAt: {_is_null: true}, _or: [{workflowInitialAssigneeId: {_eq: $id}}, {renewalAdditionalUsers: {userId: {_eq: $id}}, workflowInitialAssigneeId: {_neq: $id}}]}
  ) {
    id
    renewalDate
    workflowStartDayCount
    cancellationNoticeDayCount
  }
}
    `) as unknown as TypedDocumentString<GetUserRenewalsForStatsQuery, GetUserRenewalsForStatsQueryVariables>;
export const ListRenewalsForUserDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListRenewalsForUser($id: uuid!, $offset: Int!, $limit: Int!) {
  renewals(
    where: {deletedAt: {_is_null: true}, _or: [{workflowInitialAssigneeId: {_eq: $id}}, {renewalAdditionalUsers: {userId: {_eq: $id}}, workflowInitialAssigneeId: {_neq: $id}}]}
    offset: $offset
    limit: $limit
  ) {
    ...Renewal
  }
  renewals_aggregate(
    where: {deletedAt: {_is_null: true}, _or: [{workflowInitialAssigneeId: {_eq: $id}}, {renewalAdditionalUsers: {userId: {_eq: $id}}, workflowInitialAssigneeId: {_neq: $id}}]}
  ) {
    aggregate {
      count
    }
  }
}
    fragment Renewal on renewals {
  id
  cancellationNoticeDayCount
  department {
    id
    name
  }
  costCurrency
  costValue
  note
  renewalDate
  autoStartEnabled
  deletedAt
  sourceRequestId
  sourceRequest {
    id
    name
    publicId
  }
  renewalAdditionalUsers {
    user {
      id
      firstName
      lastName
      email
      isArchived
    }
  }
  request {
    id
    completedAt
    updatedAt
    state
    model
    tagIds
    publicId
    request_tags(where: {tag: {deletedAt: {_is_null: true}}}) {
      id
      tag {
        id
        name
        deletedAt
      }
    }
    computedProperties {
      valueObject
    }
    steps {
      id
      canvasModelId
      state
      input
      createdAt
      completedAt
      totalPausedWorkingHours
      requestStepUsers: request_step_users {
        id
        user {
          id
          firstName
          lastName
          isArchived
        }
      }
    }
    request_forms {
      id
      config
      currentSubmission: request_form_submissions(
        limit: 1
        order_by: {submittedOn: desc_nulls_last}
      ) {
        id
        response
        submittedOn
      }
    }
    inProgressStepContext: steps(
      where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
    ) {
      id
      nodeId: canvasModelId
      name: input(path: "$.metadata.config.payload.label")
      type: input(path: "$.metadata.type")
      state
      requestStepUsers: request_step_users(where: {deletedAt: {_is_null: true}}) {
        id
        user {
          id
          firstName
          lastName
          isArchived
        }
      }
      requestStepGroups: request_step_groups(where: {deletedAt: {_is_null: true}}) {
        id
        group {
          id
          name
          groupUsers: group_users {
            id
            userId
          }
        }
      }
    }
    supplier {
      id
      state
      organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
        id
        subsidiaryId
      }
    }
    product {
      id
      name
      state
    }
    request_pauses {
      start
      end
    }
  }
  workflow {
    id
    title
  }
  workflowInitialAssignee {
    id
    firstName
    lastName
    isArchived
  }
  workflowStartDayCount
  product {
    id
    name: displayName
    logoUrl
  }
  supplier {
    id
    name
    logoUrl
    remoteId
  }
  renewalTags(where: {tag: {deletedAt: {_is_null: true}}}) {
    id
    tag {
      id
      name
    }
  }
  sourceAgreementTerm {
    id
    agreement {
      id
      name
      ownerId
      additionalOwners {
        userId
        user {
          id
          firstName
          lastName
          email
        }
      }
      tags(where: {tag: {deletedAt: {_is_null: true}}}) {
        id
        tag {
          id
          name
        }
      }
    }
  }
  cancelledAt
  renewedAt
  createdAt
}`) as unknown as TypedDocumentString<ListRenewalsForUserQuery, ListRenewalsForUserQueryVariables>;
export const FindRenewalByAssigneeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query FindRenewalByAssignee($userId: uuid!, $renewalId: uuid!) {
  additionalAssigneeRenewals: renewals(
    where: {id: {_eq: $renewalId}, renewalAdditionalUsers: {userId: {_eq: $userId}}}
  ) {
    id
  }
  initialAssigneeRenewals: renewals(
    where: {workflowInitialAssigneeId: {_eq: $userId}, id: {_eq: $renewalId}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<FindRenewalByAssigneeQuery, FindRenewalByAssigneeQueryVariables>;
export const GetRenewalsMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRenewalsMinimal {
  renewals {
    id
    product {
      id
      name
      supplier: organisation_supplier {
        id
        name
        remoteId
      }
    }
    renewalDate
    costValue
    costCurrency
  }
}
    `) as unknown as TypedDocumentString<GetRenewalsMinimalQuery, GetRenewalsMinimalQueryVariables>;
export const GetSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSuppliers {
  organisation_suppliers {
    id
    name
    remoteId
    state
    organisation_products_and_services {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetSuppliersQuery, GetSuppliersQueryVariables>;
export const InsertRenewalDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRenewal($input: renewals_insert_input!) {
  renewal: insert_renewals_one(object: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertRenewalMutation, InsertRenewalMutationVariables>;
export const InsertRenewalAdditionalUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRenewalAdditionalUsers($objects: [renewal_additional_users_insert_input!]!) {
  renewalAdditionalUsers: insert_renewal_additional_users(objects: $objects) {
    returning {
      renewalId
      userId
    }
  }
}
    `) as unknown as TypedDocumentString<InsertRenewalAdditionalUsersMutation, InsertRenewalAdditionalUsersMutationVariables>;
export const InsertRenewalTagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRenewalTags($objects: [renewal_tags_insert_input!]!) {
  insertedRenewalTags: insert_renewal_tags(objects: $objects) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertRenewalTagsMutation, InsertRenewalTagsMutationVariables>;
export const InsertRenewalsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRenewals($objects: [renewals_insert_input!] = {}) {
  insert_renewals(objects: $objects) {
    returning {
      id
      renewalDate
      workflowStartDayCount
      autoStartEnabled
      cancellationNoticeDayCount
    }
  }
}
    `) as unknown as TypedDocumentString<InsertRenewalsMutation, InsertRenewalsMutationVariables>;
export const UpdateRenewalDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRenewal($id: uuid!, $input: renewals_set_input!) {
  renewal: update_renewals_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
    workflowInitialAssigneeId
  }
}
    `) as unknown as TypedDocumentString<UpdateRenewalMutation, UpdateRenewalMutationVariables>;
export const UpdateRenewalsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRenewals($updates: [renewals_updates!]!) {
  update_renewals_many(updates: $updates) {
    returning {
      id
      workflowInitialAssigneeId
      renewalDate
      workflowStartDayCount
      autoStartEnabled
      cancellationNoticeDayCount
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateRenewalsMutation, UpdateRenewalsMutationVariables>;
export const CreateCustomReportDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateCustomReport($customReport: custom_reports_insert_input!) {
  customReport: insert_custom_reports_one(object: $customReport) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateCustomReportMutation, CreateCustomReportMutationVariables>;
export const CreateReportGenerationDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateReportGeneration($generation: custom_reports_generations_insert_input!) {
  generation: insert_custom_reports_generations_one(object: $generation) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateReportGenerationMutation, CreateReportGenerationMutationVariables>;
export const DeleteCustomReportDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteCustomReport($id: uuid!, $userId: uuid!) {
  update_custom_reports(
    where: {id: {_eq: $id}, userId: {_eq: $userId}}
    _set: {deletedAt: "now()"}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteCustomReportMutation, DeleteCustomReportMutationVariables>;
export const GetActiveWorkflowFormTemplatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetActiveWorkflowFormTemplates($organisationId: uuid!) {
  workflow_form_templates(
    where: {_and: {workflow: {isArchived: {_neq: true}, deletedAt: {_is_null: true}, organisationId: {_eq: $organisationId}}, formTemplate: {deletedAt: {_is_null: true}, state: {_eq: PUBLISHED}, organisationId: {_eq: $organisationId}}}}
  ) {
    formTemplate {
      id
      title
      config
    }
    workflow {
      id
      title
    }
  }
}
    `) as unknown as TypedDocumentString<GetActiveWorkflowFormTemplatesQuery, GetActiveWorkflowFormTemplatesQueryVariables>;
export const GetAllRequestFormResponsesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllRequestFormResponses($requestsFilter: requests_bool_exp, $formsFilter: request_forms_bool_exp, $limit: Int, $offset: Int) {
  requests(where: $requestsFilter, limit: $limit, offset: $offset) {
    id
    name
    publicId
    createdAt
    completedAt
    state
    priority
    model
    tagIds
    type
    budget {
      id
      name
    }
    product {
      id
      displayName
      state
    }
    supplier {
      id
      name
      logoUrl
      state
      organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
        id
        subsidiaryId
      }
    }
    owner {
      id
      firstName
      lastName
    }
    poNumber
    computedProperties {
      valueObject
      valueNumber
      cancelByDate
      annualValueNumber
      category {
        id
        value
      }
      market {
        id
        value
      }
      department {
        id
        name
      }
      type
      buyerLegalEntity {
        id
        legalName
        name
      }
      note
      inBudget
      renewal: shouldRenew
      renewalDate
      cancellationNoticeDays
      isAutoRenewal
      contractStartDate
      contractEndDate
      businessOwner {
        id
        firstName
        lastName
      }
    }
    steps {
      id
      state
      result
      canvasModelId
      createdAt
      completedAt
      totalPausedWorkingHours
      input
    }
    engagement {
      id
      purchaseOrderNumber
    }
    purchase_orders(
      where: {status: {_eq: "ACTIVE"}, deletedAt: {_is_null: true}}
      order_by: {createdAt: desc}
      limit: 1
    ) {
      id
      remoteNumber
    }
    workflow {
      id
      title
      workflow_condition_groups {
        ...WorkflowConditionGroupFragment
      }
    }
    user {
      id
      firstName
      lastName
    }
    request_tags {
      id
      tag {
        id
        name
        deletedAt
      }
    }
    forms: request_forms(where: $formsFilter) {
      id
      title
      formTemplateId
      type
      config
      latestSubmissionArray: request_form_submissions(
        limit: 1
        order_by: {submittedOn: desc_nulls_last}
      ) {
        id
        response
        submittedOn
        request_step_task {
          organisationSupplierId
        }
      }
    }
    latestComment: comments(
      where: {_and: [{requestFormId: {_is_null: true}}, {type: {_eq: TEXT}}]}
      order_by: {createdAt: desc}
      limit: 1
    ) {
      id
      payload
      createdAt
      user {
        id
        firstName
        lastName
      }
    }
    inProgressStepContext: steps(
      where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
    ) {
      id
      nodeId: canvasModelId
      name: input(path: "$.metadata.config.payload.label")
      type: input(path: "$.metadata.type")
      state
      requestStepUsers: request_step_users(where: {deletedAt: {_is_null: true}}) {
        id
        user {
          id
          firstName
          lastName
        }
      }
      requestStepGroups: request_step_groups(where: {deletedAt: {_is_null: true}}) {
        id
        group {
          id
          name
          groupUsers: group_users {
            id
            userId
          }
        }
      }
    }
    renewal {
      id
      costCurrency
      costValue
      renewalDate
      cancellationNoticeDayCount
      note
      department {
        id
        name
      }
      supplier {
        id
        name
        remoteLink
        organisationIntegration {
          id
          integration
        }
      }
      product {
        id
        name
        logoUrl
        description
        displayName
        updatedAt
        website
        organisation_supplier {
          id
          name
          logoUrl
          website
          isReseller
          remoteLink
          organisationIntegration {
            id
            integration
          }
        }
      }
    }
    assessment {
      id
      businessOwnerUser {
        id
        firstName
        lastName
        email
      }
    }
  }
  requests_aggregate(where: $requestsFilter) {
    aggregate {
      count
    }
  }
}
    fragment WorkflowConditionGroupFragment on workflow_condition_groups {
  id
  name
  condition
  createdAt
  updatedAt
  precedence
}`) as unknown as TypedDocumentString<GetAllRequestFormResponsesQuery, GetAllRequestFormResponsesQueryVariables>;
export const GetCustomReportByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomReportById($id: uuid!, $includeHistory: Boolean = true) {
  customReport: custom_reports_by_pk(id: $id) {
    id
    name
    type
    visibility
    filters
    dataFields
    userId
    owner: user {
      id
      firstName
      lastName
      email
    }
    organisationId
    createdAt
    updatedAt
    scheduleEnabled
    scheduleFrequency
    scheduleRunOn
    scheduleTime
    scheduleRecipients
    history: custom_reports_generations(order_by: {requestedAt: desc}) @include(if: $includeHistory) {
      id
      status
      fileName
      fileStoreId
      generatedAt
      requestedAt
    }
  }
}
    `) as unknown as TypedDocumentString<GetCustomReportByIdQuery, GetCustomReportByIdQueryVariables>;
export const GetCustomReportRecipientsByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomReportRecipientsByIds($recipientIds: [uuid!] = []) {
  recipients: users(where: {id: {_in: $recipientIds}}) {
    id
    firstName
    lastName
    email
  }
}
    `) as unknown as TypedDocumentString<GetCustomReportRecipientsByIdsQuery, GetCustomReportRecipientsByIdsQueryVariables>;
export const GetCustomReportWorkflowsByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomReportWorkflowsByIds($workflowIds: [uuid!] = []) {
  workflows: workflows(where: {id: {_in: $workflowIds}}) {
    id
    title
  }
}
    `) as unknown as TypedDocumentString<GetCustomReportWorkflowsByIdsQuery, GetCustomReportWorkflowsByIdsQueryVariables>;
export const GetLatestGenerationForReportDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLatestGenerationForReport($customReportId: uuid!) {
  generation: custom_reports_generations(
    where: {customReportsId: {_eq: $customReportId}, status: {_eq: "complete"}}
    order_by: {requestedAt: desc}
    limit: 1
  ) {
    id
    status
    fileName
    fileStoreId
    generatedAt
    requestedAt
  }
}
    `) as unknown as TypedDocumentString<GetLatestGenerationForReportQuery, GetLatestGenerationForReportQueryVariables>;
export const GetReportGenerationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetReportGeneration($id: uuid!) {
  generation: custom_reports_generations_by_pk(id: $id) {
    id
    status
    customReportsId
    fileStoreId
    fileName
    requestedAt
    generatedAt
  }
}
    `) as unknown as TypedDocumentString<GetReportGenerationQuery, GetReportGenerationQueryVariables>;
export const GetRequestStepsForReportDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepsForReport($requestsFilter: requests_bool_exp!, $formsFilter: request_forms_bool_exp, $limit: Int, $offset: Int) {
  requests(where: $requestsFilter, limit: $limit, offset: $offset) {
    id
    publicId
    name
    state
    createdAt
    completedAt
    deletedAt
    supplier {
      id
      name
    }
    workflow {
      id
      title
      type
    }
    forms: request_forms(where: $formsFilter) {
      id
      title
      formTemplateId
      type
      config
      latestSubmissionArray: request_form_submissions(
        limit: 1
        order_by: {submittedOn: desc_nulls_last}
      ) {
        id
        response
        submittedOn
        request_step_task {
          organisationSupplierId
        }
      }
      request_comments(
        where: {type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}
      ) {
        id
        type
        createdAt
        completedAt
      }
    }
    steps {
      id
      name: input(path: "$.metadata.config.payload.label")
      createdAt
      completedAt
      targetTime: input(path: "$.metadata.config.payload.targetTimeValue")
      type: input(path: "$.metadata.type")
      state
      result
      input
      output
      data
      totalPausedWorkingHours
      request_step_users {
        user {
          id
          firstName
          lastName
          email
        }
      }
      request_step_groups {
        group {
          id
          name
          group_users {
            user {
              id
              firstName
              lastName
              email
            }
          }
        }
      }
      request_step_tasks {
        request_form {
          request_comments(
            where: {type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}
          ) {
            id
            type
            createdAt
            completedAt
          }
        }
      }
    }
  }
  requests_aggregate(where: $requestsFilter) {
    aggregate {
      count
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepsForReportQuery, GetRequestStepsForReportQueryVariables>;
export const ListCustomReportsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListCustomReports($userId: uuid!) {
  customReports: custom_reports(
    where: {deletedAt: {_is_null: true}, _or: [{userId: {_eq: $userId}}, {visibility: {_eq: "public"}}]}
    order_by: {createdAt: desc}
  ) {
    id
    name
    type
    visibility
    filters
    dataFields
    userId
    owner: user {
      id
      firstName
      lastName
      email
    }
    organisationId
    createdAt
    updatedAt
    scheduleEnabled
    scheduleFrequency
    history: custom_reports_generations(order_by: {requestedAt: desc}) {
      id
      status
      fileName
      fileStoreId
      generatedAt
      requestedAt
    }
  }
}
    `) as unknown as TypedDocumentString<ListCustomReportsQuery, ListCustomReportsQueryVariables>;
export const UpdateCustomReportDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateCustomReport($id: uuid!, $updates: custom_reports_set_input!) {
  customReport: update_custom_reports_by_pk(pk_columns: {id: $id}, _set: $updates) {
    id
    name
    type
    filters
    visibility
    dataFields
    userId
    owner: user {
      id
      firstName
      lastName
      email
    }
    organisationId
    createdAt
    updatedAt
    scheduleEnabled
    scheduleFrequency
    scheduleRunOn
    scheduleTime
    scheduleRecipients
  }
}
    `) as unknown as TypedDocumentString<UpdateCustomReportMutation, UpdateCustomReportMutationVariables>;
export const UpdateReportGenerationStatusDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateReportGenerationStatus($id: uuid!, $status: String!, $fileStoreId: String, $generatedAt: timestamptz) {
  update_custom_reports_generations_by_pk(
    pk_columns: {id: $id}
    _set: {status: $status, fileStoreId: $fileStoreId, generatedAt: $generatedAt}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateReportGenerationStatusMutation, UpdateReportGenerationStatusMutationVariables>;
export const CompleteRequestStepTaskDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CompleteRequestStepTask($taskId: uuid!, $completedBy: uuid!, $completedOn: timestamptz!) {
  update_request_step_tasks_by_pk(
    pk_columns: {id: $taskId}
    _set: {completedBy: $completedBy, completedOn: $completedOn}
  ) {
    completedBy
    completedOn
    id
  }
}
    `) as unknown as TypedDocumentString<CompleteRequestStepTaskMutation, CompleteRequestStepTaskMutationVariables>;
export const GetAmendmentRequestsLinkedToRequestFormDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAmendmentRequestsLinkedToRequestForm($requestFormId: uuid!) {
  request_comments(
    where: {requestFormId: {_eq: $requestFormId}, type: {_eq: AMENDMENT_REQUEST}, completedAt: {_is_null: true}, completedBy: {_is_null: true}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetAmendmentRequestsLinkedToRequestFormQuery, GetAmendmentRequestsLinkedToRequestFormQueryVariables>;
export const GetRequestStepTaskDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepTask($taskId: uuid!) {
  request_step_tasks_by_pk(id: $taskId) {
    id
    completedBy
    completedOn
    requestFormId
    requestStepId
    request_step {
      request {
        id
        name
      }
      output
      request_step_users {
        userId
      }
      request_step_groups {
        id
        group {
          id
          group_users {
            id
            userId
          }
        }
      }
    }
    request_step_task_rejections {
      message
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepTaskQuery, GetRequestStepTaskQueryVariables>;
export const AutoSaveRequestFormSubmissionDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation AutoSaveRequestFormSubmission($requestFormSubmission: request_form_submissions_auto_saves_insert_input!) {
  insert_request_form_submissions_auto_saves_one(
    object: $requestFormSubmission
    on_conflict: {constraint: request_form_submissions_auto_saves_request_form_id_request_ste, update_columns: [response, userId]}
  ) {
    id
    response
    updatedAt
    user {
      id
      firstName
      lastName
    }
  }
}
    `) as unknown as TypedDocumentString<AutoSaveRequestFormSubmissionMutation, AutoSaveRequestFormSubmissionMutationVariables>;
export const CreateComputedPropertiesDbRowDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateComputedPropertiesDbRow($requestId: uuid!) {
  insert_request_computed_properties_one(object: {requestId: $requestId}) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateComputedPropertiesDbRowMutation, CreateComputedPropertiesDbRowMutationVariables>;
export const GetRequestWithRenewalIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestWithRenewalId($id: uuid!) {
  request: requests_by_pk(id: $id) {
    id
    renewal {
      id
    }
    assessment {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestWithRenewalIdQuery, GetRequestWithRenewalIdQueryVariables>;
export const DeleteRequestDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRequest($id: uuid!) {
  deletedRequest: update_requests_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
    renewal {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteRequestMutation, DeleteRequestMutationVariables>;
export const DeleteRequestTagsByRequestIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRequestTagsByRequestId($requestId: uuid!) {
  deletedRequestTags: delete_request_tags(where: {requestId: {_eq: $requestId}}) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteRequestTagsByRequestIdMutation, DeleteRequestTagsByRequestIdMutationVariables>;
export const GetDataForNewRequestDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetDataForNewRequest($workflowId: uuid!, $requestorUserId: uuid!) {
  featureFlags: organisation_feature_flags(
    where: {featureFlag: {_eq: ENABLE_BANK_DETAILS}}
  ) {
    featureFlag
  }
  orgSettings: organisation_settings {
    name
    value
  }
  workflow: workflows_by_pk(id: $workflowId) {
    id
    title
    requestSidebarConfig
    routingCanvasModel
    viewModel
    viewModelUpdatedAt
    canvasModelUpdatedAt
    state
    type
    organisationId
    organisation {
      name
    }
  }
  requestor: users_by_pk(id: $requestorUserId) {
    id
    firstName
    lastName
    email
  }
  allFormTemplates: form_templates(where: {deletedAt: {_is_null: true}}) {
    id
    config
    title
    type
    description
    internalId
  }
}
    `) as unknown as TypedDocumentString<GetDataForNewRequestQuery, GetDataForNewRequestQueryVariables>;
export const GetDataForRequestComputedPropertiesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetDataForRequestComputedProperties($requestId: uuid!) {
  request: requests_by_pk(id: $requestId) {
    id
    computedProperties {
      id
    }
    type
    forms: request_forms {
      id
      type
      latestSubmissionArray: request_form_submissions(
        limit: 1
        order_by: {submittedOn: desc_nulls_last}
      ) {
        request_step_task {
          organisationSupplierId
        }
        id
        submittedOn
        response
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetDataForRequestComputedPropertiesQuery, GetDataForRequestComputedPropertiesQueryVariables>;
export const GetExistingProductBrandByProductIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetExistingProductBrandByProductId($productId: uuid!) {
  organisation_products_and_services_brands(
    where: {deletedAt: {_is_null: true}, productAndServiceId: {_eq: $productId}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetExistingProductBrandByProductIdQuery, GetExistingProductBrandByProductIdQueryVariables>;
export const GetExistingSupplierBrandBySupplierIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetExistingSupplierBrandBySupplierId($supplierId: uuid!) {
  organisation_suppliers_brands(where: {supplierId: {_eq: $supplierId}}) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetExistingSupplierBrandBySupplierIdQuery, GetExistingSupplierBrandBySupplierIdQueryVariables>;
export const GetOrgNameDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgName {
  organisations {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<GetOrgNameQuery, GetOrgNameQueryVariables>;
export const GetOrganisationProductsAndServicesMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationProductsAndServicesMinimal {
  organisation_products_and_services {
    id
    organisationSupplierId
    state
    name
    organisation_supplier {
      id
      name
      state
      organisation_supplier_brand {
        id
        supplierId
      }
      organisationSupplierProfiles {
        subsidiaryId
      }
    }
    organisation_products_and_services_brand {
      id
      productAndServiceId
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationProductsAndServicesMinimalQuery, GetOrganisationProductsAndServicesMinimalQueryVariables>;
export const GetOrganisationSupplierOneQueryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationSupplierOneQuery($id: uuid!) {
  organisation_suppliers_by_pk(id: $id) {
    ...OrganisationSupplierFragment
  }
}
    fragment OrganisationSupplierFragment on organisation_suppliers {
  id
  name
  website
  logoUrl
  isReseller
  createdAt
  remoteId
  lastAssessmentDate
  publicId
  organisationSupplierBrandId
  paymentMethod {
    id
    name
  }
  organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
    id
    subsidiary {
      id
      name
    }
  }
  address
}`) as unknown as TypedDocumentString<GetOrganisationSupplierOneQueryQuery, GetOrganisationSupplierOneQueryQueryVariables>;
export const GetOrganisationSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationSuppliers($supplierId: uuid!) {
  organisation_suppliers_brands(where: {supplierId: {_eq: $supplierId}}) {
    id
    organisation_suppliers {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationSuppliersQuery, GetOrganisationSuppliersQueryVariables>;
export const GetProductOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetProductOne($id: uuid!) {
  products_and_services_by_pk(id: $id) {
    ...ProductFragment
    supplier {
      ...SupplierFragment
    }
    products_and_services_categories {
      id
      categoryId
    }
  }
}
    fragment ProductFragment on products_and_services {
  id
  name
  displayName
  website
  logoUrl
  createdAt
  updatedAt
  description
  deletedAt
}
fragment SupplierFragment on suppliers {
  id
  name
  website
  description
  logoUrl
  isReseller
}`) as unknown as TypedDocumentString<GetProductOneQuery, GetProductOneQueryVariables>;
export const GetSupplierOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierOne($id: uuid!) {
  suppliers_by_pk(id: $id) {
    ...SupplierFragment
  }
}
    fragment SupplierFragment on suppliers {
  id
  name
  website
  description
  logoUrl
  isReseller
}`) as unknown as TypedDocumentString<GetSupplierOneQuery, GetSupplierOneQueryVariables>;
export const InsertOrganisationSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertOrganisationSupplier($name: String!, $supplierBrandId: uuid, $logoUrl: String, $isReseller: Boolean, $state: organisation_supplier_state_enum) {
  insert_organisation_suppliers_one(
    object: {name: $name, logoUrl: $logoUrl, isReseller: $isReseller, state: $state, organisationSupplierBrandId: $supplierBrandId}
  ) {
    ...OrganisationSupplierFragment
  }
}
    fragment OrganisationSupplierFragment on organisation_suppliers {
  id
  name
  website
  logoUrl
  isReseller
  createdAt
  remoteId
  lastAssessmentDate
  publicId
  organisationSupplierBrandId
  paymentMethod {
    id
    name
  }
  organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
    id
    subsidiary {
      id
      name
    }
  }
  address
}`) as unknown as TypedDocumentString<InsertOrganisationSupplierMutation, InsertOrganisationSupplierMutationVariables>;
export const InsertRequestFormsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRequestForms($requestForms: [request_forms_insert_input!]!) {
  insert_request_forms(objects: $requestForms) {
    returning {
      id
      request_form_template_id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertRequestFormsMutation, InsertRequestFormsMutationVariables>;
export const UpdateMemoisedDepartmentForUserIfAllowedDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateMemoisedDepartmentForUserIfAllowed($userId: uuid!, $departmentId: uuid!) {
  update_users(
    where: {_and: [{id: {_eq: $userId}}, {_or: [{_and: [{departmentId: {_is_null: true}}, {organisation: {hasDirectorySyncEnabled: {_eq: true}}}]}, {organisation: {hasDirectorySyncEnabled: {_eq: false}}}]}]}
    _set: {departmentId: $departmentId}
  ) {
    affected_rows
    returning {
      id
      organisation {
        hasDirectorySyncEnabled
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateMemoisedDepartmentForUserIfAllowedMutation, UpdateMemoisedDepartmentForUserIfAllowedMutationVariables>;
export const UpdateMemoisedManagerForUserIfAllowedDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateMemoisedManagerForUserIfAllowed($userId: uuid!, $managerUserId: uuid!) {
  update_users(
    where: {_and: [{id: {_eq: $userId}}, {_or: [{_and: [{managerUserId: {_is_null: true}}, {organisation: {hasDirectorySyncEnabled: {_eq: true}}}]}, {organisation: {hasDirectorySyncEnabled: {_eq: false}}}]}]}
    _set: {managerUserId: $managerUserId}
  ) {
    affected_rows
    returning {
      id
      organisation {
        hasDirectorySyncEnabled
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateMemoisedManagerForUserIfAllowedMutation, UpdateMemoisedManagerForUserIfAllowedMutationVariables>;
export const UpdateMemoisedSubsidiaryForUserIfAllowedDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateMemoisedSubsidiaryForUserIfAllowed($userId: uuid!, $subsidiaryId: uuid!) {
  update_users(
    where: {_and: [{id: {_eq: $userId}}, {_or: [{_and: [{subsidiaryId: {_is_null: true}}, {organisation: {hasDirectorySyncEnabled: {_eq: true}}}]}, {organisation: {hasDirectorySyncEnabled: {_eq: false}}}]}]}
    _set: {subsidiaryId: $subsidiaryId}
  ) {
    affected_rows
    returning {
      id
      organisation {
        hasDirectorySyncEnabled
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateMemoisedSubsidiaryForUserIfAllowedMutation, UpdateMemoisedSubsidiaryForUserIfAllowedMutationVariables>;
export const UpdateRequestModelDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestModel($requestId: uuid!, $update: requests_set_input!) {
  update_requests_by_pk(pk_columns: {id: $requestId}, _set: $update) {
    id
    model
  }
}
    `) as unknown as TypedDocumentString<UpdateRequestModelMutation, UpdateRequestModelMutationVariables>;
export const GetRequestStepTaskSubmissionsClosedAtDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepTaskSubmissionsClosedAt($taskId: uuid!) {
  request_step_tasks_by_pk(id: $taskId) {
    id
    submissionsClosedAt
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepTaskSubmissionsClosedAtQuery, GetRequestStepTaskSubmissionsClosedAtQueryVariables>;
export const GetConditionDataForAutogeneratedTagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetConditionDataForAutogeneratedTags($requestId: uuid!, $supplierId: uuid!, $shouldFetchSupplier: Boolean!) {
  requestContext: requests_by_pk(id: $requestId) {
    id
    workflow {
      workflow_condition_groups {
        ...WorkflowConditionGroupFragment
      }
    }
    request_tags {
      id
      tag {
        id
        name
      }
    }
  }
  supplierContext: organisation_suppliers_by_pk(id: $supplierId) @include(if: $shouldFetchSupplier) {
    organisation_supplier_tags {
      id
      tag {
        id
        name
      }
    }
  }
}
    fragment WorkflowConditionGroupFragment on workflow_condition_groups {
  id
  name
  condition
  createdAt
  updatedAt
  precedence
}`) as unknown as TypedDocumentString<GetConditionDataForAutogeneratedTagsQuery, GetConditionDataForAutogeneratedTagsQueryVariables>;
export const GetRequestFillInTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFillInTasks($requestId: uuid!) {
  request_step_tasks(
    where: {_and: {type: {_eq: FILL_IN}, request_step: {requestId: {_eq: $requestId}}}}
  ) {
    id
    organisationSupplierId
    request_step {
      id
      type: input(path: "$.metadata.type")
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestFillInTasksQuery, GetRequestFillInTasksQueryVariables>;
export const GetRequestFormDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestForm($requestFormId: uuid!) {
  requestForm: request_forms_by_pk(id: $requestFormId) {
    id
    type
    config
    request {
      id
      workflowId
      model
      supplier {
        id
        state
        organisation_supplier_brand {
          id
          supplierId
        }
        subsidiaries: organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
          id
          subsidiaryId
        }
      }
      product {
        id
        state
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestFormQuery, GetRequestFormQueryVariables>;
export const GetRequestFormConfigsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFormConfigs($requestId: uuid!) {
  forms: request_forms(where: {requestId: {_eq: $requestId}}) {
    id
    config
  }
}
    `) as unknown as TypedDocumentString<GetRequestFormConfigsQuery, GetRequestFormConfigsQueryVariables>;
export const GetRfxSuppliersByRequestIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxSuppliersByRequestId($requestId: uuid!) {
  rfx_suppliers(where: {rfx: {requestId: {_eq: $requestId}}}) {
    id
    organisationSupplierId
    status
  }
}
    `) as unknown as TypedDocumentString<GetRfxSuppliersByRequestIdQuery, GetRfxSuppliersByRequestIdQueryVariables>;
export const InsertRequestFormSubmissionApiUseOnlyDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRequestFormSubmissionApiUseOnly($requestFormSubmission: request_form_submissions_insert_input!) {
  insert_request_form_submissions_one(object: $requestFormSubmission) {
    id
    response
    submittedOn
    user {
      id
      firstName
      lastName
    }
  }
}
    `) as unknown as TypedDocumentString<InsertRequestFormSubmissionApiUseOnlyMutation, InsertRequestFormSubmissionApiUseOnlyMutationVariables>;
export const UpdateRequestTagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestTags($id: uuid!, $tagIds: jsonb) {
  update_requests_by_pk(pk_columns: {id: $id}, _set: {tagIds: $tagIds}) {
    id
    tagIds
  }
}
    `) as unknown as TypedDocumentString<UpdateRequestTagsMutation, UpdateRequestTagsMutationVariables>;
export const UpdateTaskCompletedDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateTaskCompleted($taskId: uuid!, $completedBy: uuid, $completedOn: timestamptz!) {
  update_request_step_tasks_by_pk(
    pk_columns: {id: $taskId}
    _set: {completedBy: $completedBy, completedOn: $completedOn}
  ) {
    id
    completedOn
    completedBy
    user {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateTaskCompletedMutation, UpdateTaskCompletedMutationVariables>;
export const UpdateTaskSupplierIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateTaskSupplierId($taskId: uuid!, $orgSupplierId: uuid!) {
  update_request_step_tasks_by_pk(
    pk_columns: {id: $taskId}
    _set: {organisationSupplierId: $orgSupplierId}
  ) {
    id
    organisationSupplierId
  }
}
    `) as unknown as TypedDocumentString<UpdateTaskSupplierIdMutation, UpdateTaskSupplierIdMutationVariables>;
export const GetRequestEngagementDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestEngagement($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    id
    name
    engagement {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestEngagementQuery, GetRequestEngagementQueryVariables>;
export const UpdateRequestBudgetDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestBudget($requestId: uuid!, $budgetId: uuid) {
  update_requests_by_pk(pk_columns: {id: $requestId}, _set: {budgetId: $budgetId}) {
    id
    name
    budget {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateRequestBudgetMutation, UpdateRequestBudgetMutationVariables>;
export const UpdateRequestPoNumberDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestPoNumber($requestId: uuid!, $poNumber: String) {
  update_requests_by_pk(pk_columns: {id: $requestId}, _set: {poNumber: $poNumber}) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateRequestPoNumberMutation, UpdateRequestPoNumberMutationVariables>;
export const UpdateRequestComputedPropertiesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestComputedProperties($requestId: uuid!, $updatedProperties: request_computed_properties_set_input!) {
  update_request_computed_properties(
    where: {requestId: {_eq: $requestId}}
    _set: $updatedProperties
  ) {
    returning {
      id
      requestId
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateRequestComputedPropertiesMutation, UpdateRequestComputedPropertiesMutationVariables>;
export const GetRequestIntakeFormDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestIntakeFormData($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    id
    name
    workflow {
      id
      title
      type
    }
    request_forms(where: {type: {_eq: INTAKE}}) {
      id
      type
      title
      description
      formTemplateId
      request_form_submissions(order_by: {submittedOn: desc_nulls_last}, limit: 1) {
        id
        response
        submittedOn
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestIntakeFormDataQuery, GetRequestIntakeFormDataQueryVariables>;
export const GetPauseDetailDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPauseDetail($requestId: uuid) {
  request_pauses(where: {requestId: {_eq: $requestId}, end: {_is_null: true}}) {
    assigneeId
    start
    end
    id
    note
    pause_reason {
      text
    }
  }
}
    `) as unknown as TypedDocumentString<GetPauseDetailQuery, GetPauseDetailQueryVariables>;
export const GetPauseReasonsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPauseReasons {
  pause_reasons(where: {deletedAt: {_is_null: true}}) {
    id
    text
  }
}
    `) as unknown as TypedDocumentString<GetPauseReasonsQuery, GetPauseReasonsQueryVariables>;
export const GetRequestBudgetApprovalDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestBudgetApprovalData($id: uuid!) {
  requests_by_pk(id: $id) {
    ...RequestBudgetApprovalData
  }
}
    fragment RequestBudgetApprovalData on requests {
  id
  model
  computedProperties {
    valueObject
    inBudget
    department {
      id
      name
      isArchived
    }
    buyerLegalEntity {
      id
      name
      isArchived
    }
  }
  renewal {
    costValue
    costCurrency
    department {
      id
      name
      isArchived
    }
  }
  request_forms {
    ...RequestFormResponses
  }
}
fragment RequestFormResponses on request_forms {
  id
  config
  currentSubmission: request_form_submissions(
    limit: 1
    order_by: {submittedOn: desc_nulls_last}
  ) {
    id
    response
    submittedOn
  }
}`) as unknown as TypedDocumentString<GetRequestBudgetApprovalDataQuery, GetRequestBudgetApprovalDataQueryVariables>;
export const GetRequestDetailQueryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestDetailQuery($id: uuid!) {
  requests_by_pk(id: $id) {
    ...RequestDetailData
  }
}
    fragment RequestDetailData on requests {
  id
  name
  createdAt
  completedAt
  tagIds
  model
  requestorUserId
  state
  priority
  type
  publicId
  state
  poNumber
  workflowId
  risks(where: {deletedAt: {_is_null: true}}) {
    ...SummaryRiskLevel
  }
  budget {
    id
    name
  }
  renewal {
    renewalDate
    cancellationNoticeDayCount
    note
    id
    department {
      id
      name
      isArchived
    }
    costValue
    costCurrency
    sourceAgreementTerm {
      id
      name
      agreementId
    }
  }
  assessment {
    id
    businessOwner: businessOwnerUser {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
  }
  organisation {
    id
    name
  }
  user {
    id
    firstName
    lastName
    email
    role
    isArchived
  }
  computedProperties {
    valueObject
    businessOwner {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
    budgetHolder {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
    department {
      id
      name
      isArchived
    }
    costCenter {
      id
      name
      isArchived
    }
    buyerLegalEntity {
      id
      name
      isArchived
    }
    goLiveDate
    inBudget
    poNumber
    paymentTerm {
      id
      name
      isArchived
    }
    note
    contractStartDate
    contractEndDate
    contractLength
    paymentMethod {
      id
      name
      isArchived
    }
    type
    cancellationNoticeDays
    cancellationReason
    shouldRenew
    isAutoRenewal
    address
    taxNumber
    website
    renewalDate
    category {
      id
      value
    }
    market {
      id
      value
    }
  }
  owner {
    id
    firstName
    lastName
    email
    role
    isArchived
  }
  leads(where: {user: {id: {_is_null: false}}}) {
    user {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
  }
  inProgressStepContext: steps(
    where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
  ) {
    id
    nodeId: canvasModelId
    name: input(path: "$.metadata.config.payload.label")
    type: input(path: "$.metadata.type")
    state
    requestStepUsers: request_step_users(where: {deletedAt: {_is_null: true}}) {
      id
      user {
        id
        firstName
        lastName
      }
    }
    requestStepGroups: request_step_groups(where: {deletedAt: {_is_null: true}}) {
      id
      group {
        id
        name
        groupUsers: group_users {
          id
          userId
        }
      }
    }
  }
  steps {
    id
    state
    result
    canvasModelId
    createdAt
    completedAt
    input
    totalPausedWorkingHours
  }
  workflow {
    id
    title
    type
    expectedSLA
    workflow_condition_groups {
      id
      name
      precedence
    }
  }
  supplierId: request_supplier
  supplier {
    id
    name
    logoUrl
    state
    externalLink
    remoteId
    publicId
    organisationIntegration {
      id
      integration
    }
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
      remoteId
      remoteLink
    }
    organisation_supplier_tags {
      tagId
    }
    organisation_supplier_brand {
      logoUrl
    }
  }
  productId: request_product
  product {
    id
    name
    state
    logoUrl
    description
    website
    organisation_products_and_services_brand {
      logoUrl
    }
    organisationSupplier: organisation_supplier {
      id
      website
      description
      externalContacts: external_contacts(where: {deletedAt: {_is_null: true}}) {
        id
        firstName
        lastName
        email
        phoneNumber
        title
        isPrimary
      }
    }
  }
  agreementTerm: agreement_term {
    id
    name
    agreementId
  }
  engagement {
    id
    name
    purchaseOrderNumber
    externalLink
  }
  purchase_orders(
    where: {status: {_eq: "ACTIVE"}, deletedAt: {_is_null: true}}
    order_by: {createdAt: desc}
    limit: 1
  ) {
    id
    remoteNumber
    remoteLink
    status
    remoteStatus
    totalValue
    remoteTotalValue
    remoteInvoicedValue
    remotePaidValue
    currency {
      id
      code
    }
  }
  request_forms {
    ...RequestFormResponses
  }
  request_tags {
    id
    tag {
      id
      name
      deletedAt
    }
  }
  latestComment: comments(
    where: {_and: [{requestFormId: {_is_null: true}}, {type: {_eq: TEXT}}]}
    order_by: {createdAt: desc}
    limit: 1
  ) {
    id
    payload
    createdAt
    user {
      id
      firstName
      lastName
    }
  }
  followers {
    id
    user {
      id
      email
      firstName
      lastName
    }
  }
  request_pauses {
    start
    end
  }
  sidebarConfig
}
fragment RequestFormResponses on request_forms {
  id
  config
  currentSubmission: request_form_submissions(
    limit: 1
    order_by: {submittedOn: desc_nulls_last}
  ) {
    id
    response
    submittedOn
  }
}
fragment SummaryRiskLevel on risks {
  id
  inherentRiskImpact {
    id
    name
    score
  }
  inherentRiskProbability {
    id
    name
    score
  }
  inherentRiskMatrix {
    id
    score
  }
  residualRiskImpact {
    id
    name
    score
  }
  residualRiskProbability {
    id
    name
    score
  }
  residualRiskMatrix {
    id
    score
  }
}`) as unknown as TypedDocumentString<GetRequestDetailQueryQuery, GetRequestDetailQueryQueryVariables>;
export const GetRequestDataForAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestDataForAssignees($requestId: uuid!) {
  request: requests_by_pk(id: $requestId) {
    id
    model
    requestorUserId
    forms: request_forms {
      ...RequestFormResponses
    }
    steps {
      id
      canvasModelId
      users: request_step_users {
        id
        user {
          ...UserFragment
        }
      }
      groupsWithUsers: request_step_groups {
        id
        group {
          id
          name
          users: group_users {
            user {
              ...UserFragment
            }
          }
        }
      }
    }
  }
}
    fragment RequestFormResponses on request_forms {
  id
  config
  currentSubmission: request_form_submissions(
    limit: 1
    order_by: {submittedOn: desc_nulls_last}
  ) {
    id
    response
    submittedOn
  }
}
fragment UserFragment on users {
  id
  firstName
  lastName
  email
  role
  hasConfigPermissions
  isViewOnly
  deletedAt
  isArchived
  languagePreference
  isOutOfOffice
}`) as unknown as TypedDocumentString<GetRequestDataForAssigneesQuery, GetRequestDataForAssigneesQueryVariables>;
export const GetUsersAndGroupsWithIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUsersAndGroupsWithIds($userIds: [uuid!]!, $groupIds: [uuid!]) {
  users(where: {id: {_in: $userIds}}) {
    ...UserFragment
  }
  groups(where: {id: {_in: $groupIds}}) {
    id
    name
    group_users {
      id
      user {
        ...UserFragment
      }
    }
  }
}
    fragment UserFragment on users {
  id
  firstName
  lastName
  email
  role
  hasConfigPermissions
  isViewOnly
  deletedAt
  isArchived
  languagePreference
  isOutOfOffice
}`) as unknown as TypedDocumentString<GetUsersAndGroupsWithIdsQuery, GetUsersAndGroupsWithIdsQueryVariables>;
export const GetRequestBlocksInfoDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestBlocksInfoData($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    ...RequestBlocksInfoData
  }
}
    fragment RequestFormResponses on request_forms {
  id
  config
  currentSubmission: request_form_submissions(
    limit: 1
    order_by: {submittedOn: desc_nulls_last}
  ) {
    id
    response
    submittedOn
  }
}
fragment RequestBlocksInfoData on requests {
  id
  state
  completedAt
  model
  tagIds
  computedProperties {
    valueObject
    inBudget
    department {
      id
      name
      isArchived
    }
    buyerLegalEntity {
      id
      name
      isArchived
    }
  }
  supplier {
    id
    name
    state
    organisation_supplier_tags {
      tagId
    }
    organisationSupplierProfiles {
      subsidiaryId
    }
  }
  product {
    state
  }
  budget {
    id
  }
  renewal {
    costValue
    costCurrency
    department {
      id
      name
      isArchived
    }
  }
  request_forms {
    ...RequestFormResponses
  }
  request_tags {
    tag {
      id
      name
      deletedAt
    }
  }
}`) as unknown as TypedDocumentString<GetRequestBlocksInfoDataQuery, GetRequestBlocksInfoDataQueryVariables>;
export const GetRequestStepsMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepsMinimal($requestId: uuid!) {
  request_steps(where: {requestId: {_eq: $requestId}}) {
    id
    canvasModelId
    state
    output
    createdAt
    completedAt
    totalPausedWorkingHours
    users: request_step_users {
      id
      user {
        ...UserFragment
      }
    }
    groupsWithUsers: request_step_groups {
      id
      group {
        id
        name
        users: group_users {
          user {
            ...UserFragment
          }
        }
      }
    }
  }
}
    fragment UserFragment on users {
  id
  firstName
  lastName
  email
  role
  hasConfigPermissions
  isViewOnly
  deletedAt
  isArchived
  languagePreference
  isOutOfOffice
}`) as unknown as TypedDocumentString<GetRequestStepsMinimalQuery, GetRequestStepsMinimalQueryVariables>;
export const GetRequestFormDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFormDetails($requestFormId: uuid!, $userId: uuid!) {
  request_forms_by_pk(id: $requestFormId) {
    ...FormDetailsFragment
  }
}
    fragment FormDetailsFragment on request_forms {
  id
  title
  description
  formTemplateId
  type
  config
  form_template {
    id
    externalTitle
  }
  request {
    id
    name
    state
    renewal {
      id
    }
    user {
      id
      email
      firstName
      lastName
    }
    request_supplier
    request_product
    supplier {
      name
      internalContacts(where: {userId: {_eq: $userId}, deleted_at: {_is_null: true}}) {
        userId
        productId
      }
      organisation_products_and_services(
        where: {businessOwnerId: {_eq: $userId}, deleted_at: {_is_null: true}}
      ) {
        id
        businessOwnerId
      }
    }
    request_users {
      userId
      user {
        id
        email
        firstName
        lastName
      }
    }
    request_groups {
      group {
        id
        name
        group_users {
          userId
        }
      }
    }
  }
  request_step_tasks {
    id
    type
    completedBy
    completedOn
    request_step_task_users {
      user_id
      user {
        id
        role
        email
        firstName
        lastName
      }
    }
    request_step_task_rejections {
      id
    }
    request_step {
      id
      state
      createdAt
      skipped: output(path: "$.skipped")
      skippedAt: output(path: "$.skipped_at")
      skippedBy: output(path: "$.skipped_by")
      forceApprovedAt: output(path: "$.force_approved_at")
      forceApprovedBy: output(path: "$.force_approved_by")
      request_step_users {
        id
        user {
          id
          role
          email
          firstName
          lastName
        }
      }
      request_step_groups {
        id
        group {
          id
          group_users {
            id
            userId
          }
        }
      }
    }
    request_form {
      id
      type
      request_comments(
        where: {_and: [{completedAt: {_is_null: true}}, {type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}]}
      ) {
        id
        type
        userId
        completedAt
      }
    }
    organisation_supplier {
      id
      rfx_suppliers {
        id
        status
        rfx {
          requestId
        }
      }
    }
  }
  openAmendments: request_comments(
    where: {_and: [{completedAt: {_is_null: true}}, {type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}]}
  ) {
    id
    type
    userId
    completedAt
  }
}`) as unknown as TypedDocumentString<GetRequestFormDetailsQuery, GetRequestFormDetailsQueryVariables>;
export const GetRequestFormsParticipantsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFormsParticipants($requestFormId: uuid!) {
  request_forms_by_pk(id: $requestFormId) {
    id
    title
    request {
      id
      name
      type
      owner {
        id
        firstName
        lastName
        email
        isArchived
      }
      user {
        id
        firstName
        lastName
        email
        isArchived
      }
      assessment {
        id
        businessOwnerUser {
          id
          firstName
          lastName
          email
          isArchived
        }
      }
    }
    request_step_tasks {
      id
      externalTaskUsers: request_step_task_users(
        where: {user: {role: {_eq: "supplier"}, isArchived: {_eq: false}, deletedAt: {_is_null: true}}}
      ) {
        user {
          id
          firstName
          lastName
          email
          isArchived
        }
      }
      request_step {
        id
        emptyCommentsMessage: input(
          path: "$.metadata.config.payload.emptyCommentsMessage"
        )
        externalStepUsers: request_step_users(
          where: {user: {role: {_eq: "supplier"}, isArchived: {_eq: false}, deletedAt: {_is_null: true}}}
        ) {
          id
          user {
            id
            firstName
            lastName
            email
            isArchived
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestFormsParticipantsQuery, GetRequestFormsParticipantsQueryVariables>;
export const GetRequestFormsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestForms($requestId: uuid!, $userId: uuid!) {
  request_forms(where: {requestId: {_eq: $requestId}}) {
    ...FormDetailsFragment
    ...RequestFormResponses
  }
  requests_by_pk(id: $requestId) {
    id
    model
    tagIds
    completedAt
    budget {
      id
    }
    computedProperties {
      valueObject
    }
    supplier {
      id
      state
      organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
        id
        subsidiaryId
      }
      organisation_supplier_tags {
        tagId
      }
    }
    product {
      state
    }
    request_tags {
      id
      tag {
        id
        name
        deletedAt
      }
    }
  }
}
    fragment RequestFormResponses on request_forms {
  id
  config
  currentSubmission: request_form_submissions(
    limit: 1
    order_by: {submittedOn: desc_nulls_last}
  ) {
    id
    response
    submittedOn
  }
}
fragment FormDetailsFragment on request_forms {
  id
  title
  description
  formTemplateId
  type
  config
  form_template {
    id
    externalTitle
  }
  request {
    id
    name
    state
    renewal {
      id
    }
    user {
      id
      email
      firstName
      lastName
    }
    request_supplier
    request_product
    supplier {
      name
      internalContacts(where: {userId: {_eq: $userId}, deleted_at: {_is_null: true}}) {
        userId
        productId
      }
      organisation_products_and_services(
        where: {businessOwnerId: {_eq: $userId}, deleted_at: {_is_null: true}}
      ) {
        id
        businessOwnerId
      }
    }
    request_users {
      userId
      user {
        id
        email
        firstName
        lastName
      }
    }
    request_groups {
      group {
        id
        name
        group_users {
          userId
        }
      }
    }
  }
  request_step_tasks {
    id
    type
    completedBy
    completedOn
    request_step_task_users {
      user_id
      user {
        id
        role
        email
        firstName
        lastName
      }
    }
    request_step_task_rejections {
      id
    }
    request_step {
      id
      state
      createdAt
      skipped: output(path: "$.skipped")
      skippedAt: output(path: "$.skipped_at")
      skippedBy: output(path: "$.skipped_by")
      forceApprovedAt: output(path: "$.force_approved_at")
      forceApprovedBy: output(path: "$.force_approved_by")
      request_step_users {
        id
        user {
          id
          role
          email
          firstName
          lastName
        }
      }
      request_step_groups {
        id
        group {
          id
          group_users {
            id
            userId
          }
        }
      }
    }
    request_form {
      id
      type
      request_comments(
        where: {_and: [{completedAt: {_is_null: true}}, {type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}]}
      ) {
        id
        type
        userId
        completedAt
      }
    }
    organisation_supplier {
      id
      rfx_suppliers {
        id
        status
        rfx {
          requestId
        }
      }
    }
  }
  openAmendments: request_comments(
    where: {_and: [{completedAt: {_is_null: true}}, {type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}]}
  ) {
    id
    type
    userId
    completedAt
  }
}`) as unknown as TypedDocumentString<GetRequestFormsQuery, GetRequestFormsQueryVariables>;
export const GetRequestStepsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestSteps($requestId: uuid!) {
  request_steps(where: {requestId: {_eq: $requestId}}) {
    id
    state
    input
    output
    data
    createdAt
    completedAt
    requestId
    canvasModelId
    result
    canvasModelParentIds
    totalPausedWorkingHours
    request_step_users {
      id
      user {
        id
        email
        firstName
        lastName
        role
        isArchived
      }
    }
    request_step_groups {
      id
      group {
        id
        name
        isArchived
        group_users {
          id
          userId
        }
      }
    }
    request_step_tasks {
      id
      type
      request_form {
        id
        title
        type
      }
      completedOn
      request_step_task_rejections {
        id
      }
      latestOutstandingAmendmentRequest: request_form {
        id
        amendmentRequests: request_comments(
          limit: 1
          order_by: {createdAt: desc_nulls_last}
          where: {_and: [{completedAt: {_is_null: true}, type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}]}
        ) {
          id
          createdAt
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
    request {
      id
      state
      supplier {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepsQuery, GetRequestStepsQueryVariables>;
export const GetRequestLeadsConfigDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestLeadsConfig {
  requestLeadsConfig: request_leads_config {
    id
    user {
      id
      firstName
      lastName
      email
    }
    market {
      id
      value
      customCoreDataId
    }
    category {
      id
      value
      customCoreDataId
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestLeadsConfigQuery, GetRequestLeadsConfigQueryVariables>;
export const GetRequestStatisticsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStatistics($completedFilter: requests_bool_exp!, $pendingFilter: requests_bool_exp!, $delayedFilter: requests_bool_exp!) {
  requests(where: $delayedFilter) {
    state
    completedAt
    steps(where: {state: {_eq: RUNNING}}) {
      state
      input
      createdAt
      completedAt
      totalPausedWorkingHours
    }
  }
  completed: requests_aggregate(where: $completedFilter) {
    aggregate {
      count
    }
  }
  pending: requests_aggregate(where: $pendingFilter) {
    aggregate {
      count
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestStatisticsQuery, GetRequestStatisticsQueryVariables>;
export const GetAssignedTaskDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAssignedTask($userId: uuid!, $requestStepId: uuid!) {
  request_step_task_users(
    where: {user_id: {_eq: $userId}, request_step_task: {request_step: {id: {_eq: $requestStepId}, request: {deletedAt: {_is_null: true}}}}}
  ) {
    request_step_task {
      id
      requestStepId
      organisationSupplierId
    }
  }
}
    `) as unknown as TypedDocumentString<GetAssignedTaskQuery, GetAssignedTaskQueryVariables>;
export const GetRequestStepAssigneeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepAssignee($requestStepId: uuid!) {
  request_steps_by_pk(id: $requestStepId) {
    id
    input
    request_step_users {
      id
      user {
        email
        id
        firstName
        lastName
        role
        isArchived
        isOutOfOffice
      }
    }
    request_step_groups {
      id
      group {
        name
        id
        isArchived
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepAssigneeQuery, GetRequestStepAssigneeQueryVariables>;
export const GetRfxAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxAssignees($taskId: uuid!) {
  request_step_task_users(where: {request_step_task_id: {_eq: $taskId}}) {
    user {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxAssigneesQuery, GetRfxAssigneesQueryVariables>;
export const GetRequestStepTaskErrorsByRequestIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepTaskErrorsByRequestId($requestId: uuid!) {
  request_step_task_errors(
    where: {request_step_task: {request_step: {requestId: {_eq: $requestId}}}}
    order_by: {occuredAt: desc}
  ) {
    id
    requestStepTaskId
    createdAt
    type
    message
    suggestion
    resolvedAt
    detail
    request_step_task {
      requestStepId
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepTaskErrorsByRequestIdQuery, GetRequestStepTaskErrorsByRequestIdQueryVariables>;
export const GetAllRequestStepsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllRequestSteps($requestId: uuid!) {
  request_steps(where: {requestId: {_eq: $requestId}}) {
    id
    state
    canvasModelId
    input
    output
    data
    result
    createdAt
    completedAt
    requestId
    canvasModelParentIds
    totalPausedWorkingHours
    requestStepTasks: request_step_tasks {
      id
      type
      title: config(path: "$.title")
      completedOn
      completedBy
      requestForm: request_form {
        id
        title
        type
      }
      requestStepTaskRejections: request_step_task_rejections {
        id
        user {
          id
          firstName
          lastName
        }
      }
      latestOutstandingAmendmentRequest: request_form {
        id
        amendmentRequests: request_comments(
          limit: 1
          order_by: {createdAt: desc_nulls_last}
          where: {_and: [{completedAt: {_is_null: true}, type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}]}
        ) {
          id
          createdAt
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
    request {
      id
      state
      supplier {
        id
      }
    }
    requestStepUsers: request_step_users {
      id
      user {
        id
        email
        firstName
        lastName
        role
        isArchived
        isOutOfOffice
      }
    }
    requestStepGroups: request_step_groups {
      id
      group {
        id
        name
        isArchived
        groupUsers: group_users {
          id
          userId
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAllRequestStepsQuery, GetAllRequestStepsQueryVariables>;
export const GetRequestTabsDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestTabsData($requestId: uuid!, $userId: uuid!, $includeRfx: Boolean!) {
  request_step_tasks(
    where: {_or: [{request_step: {request_step_groups: {group: {group_users: {userId: {_eq: $userId}}}}}}, {request_step: {request_step_users: {userId: {_eq: $userId}}}}], request_step: {requestId: {_eq: $requestId}}}
  ) {
    id
    completedOn
    requestFormId
    type
    request_step {
      skipped: output(path: "$.skipped")
      skippedAt: output(path: "$.skipped_at")
      skippedBy: output(path: "$.skipped_by")
      forceApprovedAt: output(path: "$.force_approved_at")
      forceApprovedBy: output(path: "$.force_approved_by")
      requestStepTasks: request_step_tasks {
        id
        request_step_task_rejections {
          id
        }
        completedOn
      }
    }
  }
  rfx(where: {requestId: {_eq: $requestId}}, limit: 1) @include(if: $includeRfx) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetRequestTabsDataQuery, GetRequestTabsDataQueryVariables>;
export const GetAssigneesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAssignees($userAssigneeIds: [uuid!], $groupAssigneeIds: [uuid!]) {
  users(where: {id: {_in: $userAssigneeIds}}) {
    id
    firstName
    lastName
    email
    role
    deletedAt
    isArchived
    groupUsers: group_users {
      id
      group {
        id
        name
        organisationId
      }
    }
  }
  groups(where: {id: {_in: $groupAssigneeIds}}) {
    id
    name
    organisationId
  }
}
    `) as unknown as TypedDocumentString<GetAssigneesQuery, GetAssigneesQueryVariables>;
export const GetRequestModelDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestModel($requestId: uuid!) {
  request: requests_by_pk(id: $requestId) {
    id
    model
  }
}
    `) as unknown as TypedDocumentString<GetRequestModelQuery, GetRequestModelQueryVariables>;
export const GetSupplierRequestStepsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierRequestSteps($userId: uuid!) {
  request_steps(
    where: {request: {deletedAt: {_is_null: true}}, _or: [{request_step_users: {userId: {_eq: $userId}}}, {request_step_tasks: {request_step_task_users: {user_id: {_eq: $userId}}}}]}
    order_by: {createdAt: desc_nulls_last}
  ) {
    ...RequestStepFields
    request_step_tasks {
      id
      completedOn
      submissionsClosedAt
      request_step_task_users {
        user_id
      }
      request_form {
        ...RequestFormFields
      }
    }
  }
}
    fragment RequestStepFields on request_steps {
  id
  createdAt
  state
  input
  output
  totalPausedWorkingHours
  request {
    id
    name
    type
    product {
      id
      logoUrl
    }
    user {
      id
      firstName
      lastName
      role
      email
      isArchived
    }
  }
}
fragment RequestFormFields on request_forms {
  id
  supplierActiveAmendments: request_comments(
    where: {completedAt: {_is_null: true}, type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}, isInternalComment: {_eq: false}}
  ) {
    id
  }
}`) as unknown as TypedDocumentString<GetSupplierRequestStepsQuery, GetSupplierRequestStepsQueryVariables>;
export const GetRequestStepDeadlineReminderDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepDeadlineReminderData($requestStepId: uuid!) {
  requestStep: request_steps_by_pk(id: $requestStepId) {
    id
    input
    createdAt
    totalPausedWorkingHours
    result
    request {
      id
      publicId
      name
      deletedAt
      state
      requestor: user {
        id
        firstName
        lastName
      }
      organisation {
        id
        name
      }
      supplier {
        id
        name
      }
      leads {
        id
      }
    }
    request_step_users {
      id
      userId
    }
    request_step_groups {
      id
      groupId
    }
    workflow {
      id
      title
      type
    }
    request_step_tasks {
      id
      completedOn
      requestFormId
      type
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepDeadlineReminderDataQuery, GetRequestStepDeadlineReminderDataQueryVariables>;
export const GetExternalOperationTaskDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetExternalOperationTask($stepId: uuid!) {
  extOpsTasks: request_step_tasks(where: {requestStepId: {_eq: $stepId}}) {
    id
    type
    completedOn
    requestForm: request_form {
      id
      config
      formTemplate: form_template {
        id
      }
      formTemplateId
      request {
        supplier {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetExternalOperationTaskQuery, GetExternalOperationTaskQueryVariables>;
export const InsertFormTemplatesOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertFormTemplatesOne($formTemplate: form_templates_insert_input!) {
  insert_form_templates_one(object: $formTemplate) {
    ...FormTemplateFragment
  }
}
    fragment FormTemplateFragment on form_templates {
  config
  description
  id
  internalId
  state
  title
  integration
  externalTitle
  type
  updatedAt
  updated_by_user {
    id
    firstName
    lastName
  }
}`) as unknown as TypedDocumentString<InsertFormTemplatesOneMutation, InsertFormTemplatesOneMutationVariables>;
export const GetFormTemplatesByIntegrationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTemplatesByIntegration($integration: String!) {
  form_templates(
    where: {integration: {_eq: $integration}, state: {_eq: PUBLISHED}}
  ) {
    id
    title
    integration
  }
}
    `) as unknown as TypedDocumentString<GetFormTemplatesByIntegrationQuery, GetFormTemplatesByIntegrationQueryVariables>;
export const GetRequestPausedReminderDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestPausedReminderData($pauseId: uuid) {
  request_pauses(where: {id: {_eq: $pauseId}}) {
    id
    assigneeId
    note
    reminderDate
    pause_reason {
      text
    }
    organisation {
      id
      name
    }
    request {
      id
      name
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestPausedReminderDataQuery, GetRequestPausedReminderDataQueryVariables>;
export const ResolveRequestStepTaskErrorsByRequestStepIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ResolveRequestStepTaskErrorsByRequestStepId($requestStepId: uuid!, $resolvedAt: timestamptz!) {
  update_request_step_task_errors(
    where: {request_step_task: {request_step: {id: {_eq: $requestStepId}}}}
    _set: {resolvedAt: $resolvedAt}
  ) {
    returning {
      id
      resolvedAt
    }
  }
}
    `) as unknown as TypedDocumentString<ResolveRequestStepTaskErrorsByRequestStepIdMutation, ResolveRequestStepTaskErrorsByRequestStepIdMutationVariables>;
export const InsertPauseReasonDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertPauseReason($text: String) {
  insert_pause_reasons_one(object: {text: $text}) {
    id
    text
  }
}
    `) as unknown as TypedDocumentString<InsertPauseReasonMutation, InsertPauseReasonMutationVariables>;
export const ListRequestsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListRequests($where: requests_bool_exp!, $order_by: [requests_order_by!], $offset: Int!, $limit: Int!) {
  requests(where: $where, order_by: $order_by, offset: $offset, limit: $limit) {
    ...RequestItemData
  }
  requests_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    fragment RequestFormResponses on request_forms {
  id
  config
  currentSubmission: request_form_submissions(
    limit: 1
    order_by: {submittedOn: desc_nulls_last}
  ) {
    id
    response
    submittedOn
  }
}
fragment RequestItemData on requests {
  id
  name
  createdAt
  completedAt
  tagIds
  model
  state
  priority
  type
  publicId
  state
  poNumber
  workflowId
  risks(where: {deletedAt: {_is_null: true}}) {
    ...SummaryRiskLevel
  }
  budget {
    id
    name
  }
  renewal {
    renewalDate
    cancellationNoticeDayCount
    note
    id
    department {
      id
      name
      isArchived
    }
    costValue
    costCurrency
  }
  assessment {
    id
    businessOwner: businessOwnerUser {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
  }
  user {
    id
    firstName
    lastName
    email
    role
    isArchived
  }
  computedProperties {
    valueObject
    businessOwner {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
    budgetHolder {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
    department {
      id
      name
      isArchived
    }
    costCenter {
      id
      name
      isArchived
    }
    buyerLegalEntity {
      id
      name
      isArchived
    }
    goLiveDate
    inBudget
    poNumber
    paymentTerm {
      id
      name
      isArchived
    }
    note
    contractStartDate
    contractEndDate
    contractLength
    paymentMethod {
      id
      name
      isArchived
    }
    type
    cancellationNoticeDays
    cancellationReason
    shouldRenew
    isAutoRenewal
    address
    taxNumber
    website
    renewalDate
    category {
      id
      value
      parent {
        value
      }
    }
    market {
      id
      value
    }
  }
  owner {
    id
    firstName
    lastName
    email
    role
    isArchived
  }
  leads(where: {user: {id: {_is_null: false}}}) {
    user {
      id
      firstName
      lastName
      email
      role
      isArchived
    }
  }
  inProgressStepContext: steps(
    where: {_and: [{state: {_in: [PENDING, RUNNING]}}, {deletedAt: {_is_null: true}}]}
  ) {
    id
    nodeId: canvasModelId
    name: input(path: "$.metadata.config.payload.label")
    type: input(path: "$.metadata.type")
    state
    requestStepUsers: request_step_users(where: {deletedAt: {_is_null: true}}) {
      id
      user {
        id
        firstName
        lastName
      }
    }
    requestStepGroups: request_step_groups(where: {deletedAt: {_is_null: true}}) {
      id
      group {
        id
        name
        groupUsers: group_users {
          id
          userId
        }
      }
    }
  }
  rejectedTasks: steps(
    where: {_and: [{result: {_is_null: true}}, {deletedAt: {_is_null: true}}, {request_step_tasks: {request_step_task_rejections: {id: {_is_null: false}}, completedOn: {_is_null: true}}}]}
  ) {
    id
  }
  erroredTasks: steps(
    where: {_and: [{result: {_is_null: true}}, {deletedAt: {_is_null: true}}, {request_step_tasks: {request_step_task_errors: {id: {_is_null: false}, resolvedAt: {_is_null: true}}, completedOn: {_is_null: true}}}]}
  ) {
    id
  }
  steps {
    id
    state
    result
    canvasModelId
    createdAt
    completedAt
    input
    totalPausedWorkingHours
  }
  workflow {
    title
    type
    workflow_condition_groups {
      id
      name
      precedence
    }
  }
  supplierId: request_supplier
  supplier {
    id
    name
    logoUrl
    state
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      subsidiaryId
    }
    organisation_supplier_tags {
      tagId
    }
    organisation_supplier_brand {
      logoUrl
    }
  }
  productId: request_product
  product {
    id
    name
    state
  }
  engagement {
    id
    purchaseOrderNumber
  }
  purchase_orders(
    where: {status: {_eq: "ACTIVE"}, deletedAt: {_is_null: true}}
    order_by: {createdAt: desc}
    limit: 1
  ) {
    id
    remoteNumber
    remoteLink
    status
    remoteStatus
    totalValue
    remoteTotalValue
    remoteInvoicedValue
    remotePaidValue
    currency {
      id
      code
    }
  }
  request_forms {
    ...RequestFormResponses
  }
  request_tags {
    id
    tag {
      id
      name
      deletedAt
    }
  }
  latestComment: comments(
    where: {_and: [{requestFormId: {_is_null: true}}, {type: {_eq: TEXT}}]}
    order_by: {createdAt: desc}
    limit: 1
  ) {
    id
    payload
    createdAt
    user {
      id
      firstName
      lastName
    }
    mentions: request_comment_mentions {
      id
      userId
      isResolved
      user {
        firstName
        lastName
        email
        isOutOfOffice
      }
    }
  }
  followers {
    id
    user {
      id
      email
      firstName
      lastName
    }
  }
  request_pauses {
    start
    end
  }
}
fragment SummaryRiskLevel on risks {
  id
  inherentRiskImpact {
    id
    name
    score
  }
  inherentRiskProbability {
    id
    name
    score
  }
  inherentRiskMatrix {
    id
    score
  }
  residualRiskImpact {
    id
    name
    score
  }
  residualRiskProbability {
    id
    name
    score
  }
  residualRiskMatrix {
    id
    score
  }
}`) as unknown as TypedDocumentString<ListRequestsQuery, ListRequestsQueryVariables>;
export const ListRequestsPaginatedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListRequestsPaginated($where: requests_bool_exp!, $order_by: [requests_order_by!], $offset: Int!, $limit: Int!) {
  requests(where: $where, order_by: $order_by, offset: $offset, limit: $limit) {
    ...RequestItemDataV2
  }
  requests_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    fragment RequestItemDataV2 on requests {
  id
  name
  createdAt
  completedAt
  publicId
  state
  priority
  workflow {
    title
  }
  supplier {
    id
    name
    logoUrl
    state
  }
  product {
    id
    name
    state
    logoUrl
    description
  }
  computedProperties {
    valueObject
  }
  renewal {
    costValue
    costCurrency
  }
}`) as unknown as TypedDocumentString<ListRequestsPaginatedQuery, ListRequestsPaginatedQueryVariables>;
export const GetRunningStepsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRunningSteps($requestId: uuid!) {
  request_steps(
    where: {_and: {state: {_eq: RUNNING}, requestId: {_eq: $requestId}}}
  ) {
    id
    state
    type: input(path: "$.metadata.type")
    name: input(path: "$.metadata.config.payload.label")
  }
}
    `) as unknown as TypedDocumentString<GetRunningStepsQuery, GetRunningStepsQueryVariables>;
export const PauseRequestDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation PauseRequest($assigneeId: uuid, $note: String, $reasonId: uuid, $requestId: uuid, $reminderDate: date) {
  update_requests(where: {id: {_eq: $requestId}}, _set: {state: "PAUSED"}) {
    affected_rows
  }
  update_request_steps(
    where: {requestId: {_eq: $requestId}, state: {_eq: RUNNING}}
    _set: {state: PAUSED}
  ) {
    affected_rows
  }
  insert_request_pauses(
    objects: {assigneeId: $assigneeId, note: $note, reasonId: $reasonId, requestId: $requestId, reminderDate: $reminderDate}
  ) {
    returning {
      assigneeId
      id
      start
      pause_reason {
        id
        text
      }
      note
    }
  }
}
    `) as unknown as TypedDocumentString<PauseRequestMutation, PauseRequestMutationVariables>;
export const GetPauseNotificationRecipientsForRequestDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPauseNotificationRecipientsForRequest($requestId: uuid!) {
  requestSteps: request_steps(
    where: {requestId: {_eq: $requestId}, state: {_eq: RUNNING}}
  ) {
    request_step_users {
      id
      userId
    }
  }
  requestLeads: request_request_leads(where: {requestId: {_eq: $requestId}}) {
    userId
  }
  request: requests_by_pk(id: $requestId) {
    requestorUserId
  }
}
    `) as unknown as TypedDocumentString<GetPauseNotificationRecipientsForRequestQuery, GetPauseNotificationRecipientsForRequestQueryVariables>;
export const GetFormTemplateIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTemplateId($requestFormId: uuid!) {
  request_forms_by_pk(id: $requestFormId) {
    id
    request_step_tasks {
      request_step {
        input
      }
    }
    request {
      id
      tagIds
      name
      model
      renewal {
        id
        sourceAgreementTerm {
          id
          agreementId
        }
      }
      agreement_term {
        agreementId
      }
      budget {
        id
        name
      }
      computedProperties {
        pricingObject
      }
      supplier {
        id
        name
        website
        address
        taxNumber
        state
        external_contacts(where: {deletedAt: {_is_null: true}}) {
          id
          firstName
          lastName
          email
          phoneNumber
          title
          isPrimary
        }
        paymentMethod {
          id
          name
        }
        paymentTerms {
          id
          name
        }
        organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
          id
          paymentMethod {
            id
            name
          }
          paymentTerm {
            id
            name
          }
          subsidiary {
            id
            name
          }
          entityBankDetails {
            ...EntityBankAccount
          }
        }
        entityBankDetails {
          ...EntityBankAccount
        }
      }
      product {
        id
        name
        state
      }
      request_tags {
        id
        tag {
          id
          name
        }
      }
      workflow {
        id
        title
        type
        workflow_condition_groups {
          ...WorkflowConditionGroupFragment
        }
      }
    }
    form_template {
      id
    }
    type
    config
  }
}
    fragment BankAccount on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    ...OrganisationFxRate
  }
  address {
    ...Address
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment EntityBankAccount on entity_bank_details {
  isPrimary
  bankDetails {
    ...BankAccount
  }
}
fragment Address on addresses {
  createdAt
  isArchived
  archivedBy
  id
  name
  addressLine1
  addressLine2
  city
  state
  postalCode
  county
  country
  organisationId
  updatedAt
  remoteId
  coreDataId
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment WorkflowConditionGroupFragment on workflow_condition_groups {
  id
  name
  condition
  createdAt
  updatedAt
  precedence
}`) as unknown as TypedDocumentString<GetFormTemplateIdQuery, GetFormTemplateIdQueryVariables>;
export const GetLatestSupplierAndProductSubmissionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLatestSupplierAndProductSubmissions($supplierId: uuid!, $productId: uuid!) {
  request_step_tasks(
    where: {type: {_eq: FILL_IN}, request_step: {request: {request_product: {_eq: $productId}, deletedAt: {_is_null: true}}}, _or: [{organisationSupplierId: {_is_null: true}, request_step: {request: {request_supplier: {_eq: $supplierId}}}}, {organisationSupplierId: {_eq: $supplierId}}]}
  ) {
    id
    request_form {
      id
      request_form_submissions(order_by: {submittedOn: desc}, limit: 1) {
        submittedOn
        id
        response
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetLatestSupplierAndProductSubmissionsQuery, GetLatestSupplierAndProductSubmissionsQueryVariables>;
export const GetLatestSupplierSubmissionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLatestSupplierSubmissions($supplierId: uuid!) {
  request_step_tasks(
    where: {type: {_eq: FILL_IN}, request_step: {request: {deletedAt: {_is_null: true}}}, _or: [{organisationSupplierId: {_is_null: true}, request_step: {request: {request_supplier: {_eq: $supplierId}}}}, {organisationSupplierId: {_eq: $supplierId}}]}
  ) {
    id
    request_form {
      id
      request_form_submissions(order_by: {submittedOn: desc}, limit: 1) {
        submittedOn
        id
        response
      }
    }
  }
  organisation_supplier_historic_submissions(
    where: {organisationSupplierId: {_eq: $supplierId}}
  ) {
    id
    response
    createdAt
    submittedAt
  }
}
    `) as unknown as TypedDocumentString<GetLatestSupplierSubmissionsQuery, GetLatestSupplierSubmissionsQueryVariables>;
export const GetSupplierByOrgSupplierIdAndNameDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierByOrgSupplierIdAndName($orgSupplierId: uuid!, $orgSupplierName: String!) {
  organisation_suppliers(
    where: {id: {_eq: $orgSupplierId}, name: {_eq: $orgSupplierName}, state: {_in: [ACTIVE, INACTIVE]}}
  ) {
    ...OrgSupplierFragment
  }
}
    fragment OrgSupplierFragment on organisation_suppliers {
  id
  name
  website
  address
  taxNumber
  state
  external_contacts(where: {deletedAt: {_is_null: true}}) {
    id
    firstName
    lastName
    email
    phoneNumber
    title
    isPrimary
  }
  paymentMethod {
    id
    name
  }
  organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
    id
    subsidiary {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<GetSupplierByOrgSupplierIdAndNameQuery, GetSupplierByOrgSupplierIdAndNameQueryVariables>;
export const GetProductLinkedToRequestDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetProductLinkedToRequest($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    product {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetProductLinkedToRequestQuery, GetProductLinkedToRequestQueryVariables>;
export const GetRequestStepPrefillDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepPrefillData($requestStepId: uuid!) {
  requestStep: request_steps_by_pk(id: $requestStepId) {
    id
    canvasModelId
    prefillFromSupplierRecord: input(
      path: "$.metadata.config.payload.prefillFromSupplierRecord"
    )
    prefillFromSupplierRecordOnSupplierProductMatch: input(
      path: "$.metadata.config.payload.prefillFromSupplierRecordOnSupplierProductMatch"
    )
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepPrefillDataQuery, GetRequestStepPrefillDataQueryVariables>;
export const GetRequestStepTypeByRequestFormIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepTypeByRequestFormId($requestFormId: uuid!) {
  request_step_tasks(where: {request_form: {id: {_eq: $requestFormId}}}) {
    id
    request_step {
      id
      type: input(path: "$.metadata.type")
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepTypeByRequestFormIdQuery, GetRequestStepTypeByRequestFormIdQueryVariables>;
export const GetSupplierLinkedToRequestDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierLinkedToRequest($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    id
    supplier {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetSupplierLinkedToRequestQuery, GetSupplierLinkedToRequestQueryVariables>;
export const GetSuppliersLinkedToRequestFormDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSuppliersLinkedToRequestForm($requestFormId: uuid!) {
  request_forms_by_pk(id: $requestFormId) {
    request_step_tasks {
      organisationSupplierId
    }
    id
  }
}
    `) as unknown as TypedDocumentString<GetSuppliersLinkedToRequestFormQuery, GetSuppliersLinkedToRequestFormQueryVariables>;
export const GetOrganisationCurrenciesForPrefillDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationCurrenciesForPrefill {
  organisation_fx_rates(where: {isArchived: {_eq: false}}) {
    id
    code
    fxRate
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationCurrenciesForPrefillQuery, GetOrganisationCurrenciesForPrefillQueryVariables>;
export const GetLatestSupplierOnboardingAndRfxResponseForStepDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLatestSupplierOnboardingAndRfxResponseForStep($requestId: uuid!, $organisationSupplierId: uuid!, $requestStepId: uuid!) {
  request_form_submissions(
    where: {request_form: {requestId: {_eq: $requestId}, type: {_in: [SUPPLIER_ONBOARDING, RFX]}}, request_step_task: {organisationSupplierId: {_eq: $organisationSupplierId}, requestStepId: {_eq: $requestStepId}}}
    order_by: {submittedOn: desc_nulls_last}
    limit: 1
  ) {
    id
    response
    request_form {
      id
      config
      type
    }
    submittedOn
  }
}
    `) as unknown as TypedDocumentString<GetLatestSupplierOnboardingAndRfxResponseForStepQuery, GetLatestSupplierOnboardingAndRfxResponseForStepQueryVariables>;
export const RejectRequestDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation RejectRequest($requestId: uuid!) {
  update_requests_by_pk(pk_columns: {id: $requestId}, _set: {state: "REJECTED"}) {
    id
  }
}
    `) as unknown as TypedDocumentString<RejectRequestMutation, RejectRequestMutationVariables>;
export const RejectRequestStepTaskDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation RejectRequestStepTask($taskId: uuid!, $message: String!, $createdAt: timestamptz!, $createdBy: uuid!) {
  rejection: insert_request_step_task_rejections_one(
    object: {requestStepTaskId: $taskId, message: $message, createdAt: $createdAt, createdBy: $createdBy}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<RejectRequestStepTaskMutation, RejectRequestStepTaskMutationVariables>;
export const GetPausedRequestStepsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPausedRequestSteps($requestId: uuid!) {
  request_steps(
    where: {_and: {state: {_eq: PAUSED}, requestId: {_eq: $requestId}}}
  ) {
    id
    state
    totalPausedTime
    totalPausedWorkingHours
    input
  }
}
    `) as unknown as TypedDocumentString<GetPausedRequestStepsQuery, GetPausedRequestStepsQueryVariables>;
export const ResumeRequestDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ResumeRequest($requestId: uuid, $end: timestamptz, $stepUpdates: [request_steps_updates!]!, $totalPausedTime: interval) {
  update_requests(
    where: {id: {_eq: $requestId}}
    _set: {state: null, totalPausedTime: $totalPausedTime}
  ) {
    affected_rows
  }
  update_request_pauses(
    where: {requestId: {_eq: $requestId}, end: {_is_null: true}}
    _set: {end: $end}
  ) {
    affected_rows
  }
  update_request_steps_many(updates: $stepUpdates) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<ResumeRequestMutation, ResumeRequestMutationVariables>;
export const GetRequestStepByBlockIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepByBlockId($requestId: uuid!, $canvasModelId: String!) {
  request_steps(
    where: {requestId: {_eq: $requestId}, canvasModelId: {_eq: $canvasModelId}}
    order_by: {createdAt: desc}
    limit: 1
  ) {
    id
    state
    result
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepByBlockIdQuery, GetRequestStepByBlockIdQueryVariables>;
export const UncompleteRequestStepTaskDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UncompleteRequestStepTask($id: uuid!) {
  update_request_step_tasks_by_pk(
    pk_columns: {id: $id}
    _set: {completedBy: null, completedOn: null}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UncompleteRequestStepTaskMutation, UncompleteRequestStepTaskMutationVariables>;
export const UnrejectRequestDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnrejectRequest($requestId: uuid!) {
  update_requests_by_pk(pk_columns: {id: $requestId}, _set: {state: null}) {
    publicId
    id
  }
}
    `) as unknown as TypedDocumentString<UnrejectRequestMutation, UnrejectRequestMutationVariables>;
export const UpdateRequestPropertiesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestProperties($requestId: uuid!, $requestUpdates: requests_set_input = {}) {
  update_requests_by_pk(pk_columns: {id: $requestId}, _set: $requestUpdates) {
    id
    name
    priority
    poNumber
    owner {
      id
      firstName
      lastName
    }
    budget {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateRequestPropertiesMutation, UpdateRequestPropertiesMutationVariables>;
export const GetRequestAccessInfoDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestAccessInfo($requestId: uuid!, $userId: uuid!) {
  requests_by_pk(id: $requestId) {
    id
    requestorUserId
    deletedAt
    request_supplier
    request_product
    request_users {
      userId
    }
    request_groups {
      group {
        group_users {
          userId
        }
      }
    }
    supplier {
      internalContacts(where: {userId: {_eq: $userId}, deleted_at: {_is_null: true}}) {
        id
        userId
        productId
      }
      organisation_products_and_services(
        where: {businessOwnerId: {_eq: $userId}, deleted_at: {_is_null: true}}
      ) {
        id
        businessOwnerId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestAccessInfoQuery, GetRequestAccessInfoQueryVariables>;
export const GetRequestTagsByRequestIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestTagsByRequestId($requestId: uuid!) {
  request_tags(
    where: {requestId: {_eq: $requestId}, tag: {deletedAt: {_is_null: true}}}
  ) {
    tag {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestTagsByRequestIdQuery, GetRequestTagsByRequestIdQueryVariables>;
export const InsertRequestTagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRequestTags($objects: [request_tags_insert_input!]!) {
  insert_request_tags(
    objects: $objects
    on_conflict: {constraint: request_tags_tag_id_request_id_key, update_columns: []}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertRequestTagsMutation, InsertRequestTagsMutationVariables>;
export const GetRequestFormPausedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFormPaused($requestFormId: uuid!) {
  requestForm: request_forms_by_pk(id: $requestFormId) {
    id
    request {
      id
      state
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestFormPausedQuery, GetRequestFormPausedQueryVariables>;
export const GetRequestPausedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestPaused($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    id
    state
  }
}
    `) as unknown as TypedDocumentString<GetRequestPausedQuery, GetRequestPausedQueryVariables>;
export const GetRequestStepTaskPausedDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepTaskPaused($taskId: uuid!) {
  request_step_tasks_by_pk(id: $taskId) {
    id
    request_step {
      request {
        id
        state
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepTaskPausedQuery, GetRequestStepTaskPausedQueryVariables>;
export const GetUserAttributeCustomFieldValueDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUserAttributeCustomFieldValue($customFieldId: uuid!, $userId: uuid!) {
  custom_field_values(
    where: {customFieldId: {_eq: $customFieldId}, entityId: {_eq: $userId}}
  ) {
    id
    value
    booleanValue
    numberValue
    entityId
    choice {
      id
      label
    }
    user {
      id
      firstName
      lastName
    }
    customFieldCoreData {
      id
      department {
        id
        name
      }
      paymentTerm {
        id
        name
      }
      paymentMethod {
        id
        name
      }
      subsidiary {
        id
        name
      }
      currency {
        id
        code
      }
      lineItemType {
        id
        name
      }
      address {
        id
        name
        addressLine1
      }
      customCoreDataOption {
        id
        value
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetUserAttributeCustomFieldValueQuery, GetUserAttributeCustomFieldValueQueryVariables>;
export const CreateRequestFollowersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateRequestFollowers($objects: [request_followers_insert_input!]!) {
  insert_request_followers(objects: $objects) {
    returning {
      id
      userId
      groupId
      assigneeType
      note
    }
  }
}
    `) as unknown as TypedDocumentString<CreateRequestFollowersMutation, CreateRequestFollowersMutationVariables>;
export const DeleteRequestFollowerDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRequestFollowerData($id: uuid!) {
  update_request_followers_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteRequestFollowerDataMutation, DeleteRequestFollowerDataMutationVariables>;
export const GetRequestFollowersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFollowers($requestId: uuid!) {
  request_followers(
    where: {requestId: {_eq: $requestId}, deletedAt: {_is_null: true}, _or: [{user: {deletedAt: {_is_null: true}}}, {group: {id: {_is_null: false}}}]}
  ) {
    id
    note
    assigneeType
    user {
      id
      firstName
      lastName
      email
      isArchived
    }
    group {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestFollowersQuery, GetRequestFollowersQueryVariables>;
export const UpdateRequestFollowerDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestFollowerData($id: uuid!, $note: String) {
  update_request_followers_by_pk(pk_columns: {id: $id}, _set: {note: $note}) {
    id
    note
  }
}
    `) as unknown as TypedDocumentString<UpdateRequestFollowerDataMutation, UpdateRequestFollowerDataMutationVariables>;
export const DeleteRequestLeadDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRequestLead($userId: uuid!, $requestId: uuid!) {
  delete_request_request_leads(
    where: {userId: {_eq: $userId}, requestId: {_eq: $requestId}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteRequestLeadMutation, DeleteRequestLeadMutationVariables>;
export const InsertRequestLeadsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRequestLeads($requestLeads: [request_request_leads_insert_input!]!) {
  insert_request_request_leads(
    objects: $requestLeads
    on_conflict: {constraint: request_request_leads_request_id_user_id_key, update_columns: []}
  ) {
    returning {
      userId
      updated_at
    }
  }
}
    `) as unknown as TypedDocumentString<InsertRequestLeadsMutation, InsertRequestLeadsMutationVariables>;
export const UpdateRequestSupplierAndMoveProductDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestSupplierAndMoveProduct($requestId: uuid!, $organisationSupplierId: uuid!, $organisationProductAndServiceId: uuid!) {
  update_requests_by_pk(
    pk_columns: {id: $requestId}
    _set: {request_supplier: $organisationSupplierId, request_product: $organisationProductAndServiceId}
  ) {
    id
  }
  update_organisation_products_and_services_by_pk(
    pk_columns: {id: $organisationProductAndServiceId}
    _set: {organisationSupplierId: $organisationSupplierId}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateRequestSupplierAndMoveProductMutation, UpdateRequestSupplierAndMoveProductMutationVariables>;
export const CreateRequestFormTemplateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateRequestFormTemplate($form: request_form_templates_insert_input!) {
  insert_request_form_templates_one(object: $form) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateRequestFormTemplateMutation, CreateRequestFormTemplateMutationVariables>;
export const GetRequestFormTemplatesByStepIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFormTemplatesByStepId($requestStepId: uuid!) {
  request_form_templates(
    where: {requestStepId: {_eq: $requestStepId}, deletedAt: {_is_null: true}}
  ) {
    id
    title
    draftConfig
    config
    isSent
    type
    createdAt
    description
    rfx_request_form_templates_rank {
      id
      rank
    }
    closedScoringTasks: request_step_tasks(
      where: {requestStepId: {_eq: $requestStepId}, type: {_eq: SCORE_RFX_FORM}, submissionsClosedAt: {_is_null: false}}
    ) {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestFormTemplatesByStepIdQuery, GetRequestFormTemplatesByStepIdQueryVariables>;
export const InsertRequestFormTemplatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRequestFormTemplates($requestFormTemplates: [request_form_templates_insert_input!]!) {
  insert_request_form_templates(objects: $requestFormTemplates) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertRequestFormTemplatesMutation, InsertRequestFormTemplatesMutationVariables>;
export const UpdateRequestFormTemplateOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestFormTemplateOne($id: uuid!, $config: jsonb!, $title: String!) {
  update_request_form_templates_by_pk(
    pk_columns: {id: $id}
    _set: {config: $config, title: $title}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateRequestFormTemplateOneMutation, UpdateRequestFormTemplateOneMutationVariables>;
export const DeleteRequestFormTemplateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRequestFormTemplate($requestFormTemplateId: uuid!) {
  delete_request_form_templates_by_pk(id: $requestFormTemplateId) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteRequestFormTemplateMutation, DeleteRequestFormTemplateMutationVariables>;
export const GetOrgSupplierFromRequestFormDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgSupplierFromRequestForm($requestFormId: uuid!) {
  request_step_tasks(
    where: {requestFormId: {_eq: $requestFormId}, type: {_eq: FILL_IN}}
  ) {
    id
    organisation_supplier {
      id
      name
      logoUrl
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrgSupplierFromRequestFormQuery, GetOrgSupplierFromRequestFormQueryVariables>;
export const GetRequestFormTemplateByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFormTemplateById($requestFormTemplateId: uuid!) {
  request_form_templates_by_pk(id: $requestFormTemplateId) {
    id
    formTemplateId
    config
    title
    description
    type
    createdAt
    isSent
    rfx_request_form_templates_rank {
      id
      rank
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestFormTemplateByIdQuery, GetRequestFormTemplateByIdQueryVariables>;
export const GetRfxRequestFormTemplateDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxRequestFormTemplateDetails($requestFormTemplateId: uuid!) {
  formTemplate: request_form_templates_by_pk(id: $requestFormTemplateId) {
    id
    title
    config
    request_step {
      request {
        id
        rfxes {
          id
          rfx_suppliers {
            id
            organisationSupplierId
            status
          }
        }
      }
    }
    request_forms {
      id
      latestSubmission: request_form_submissions(
        limit: 1
        order_by: {submittedOn: desc_nulls_last}
      ) {
        response
        id
        request_step_task {
          id
          completedOn
        }
        request_form_submission_ai_summary {
          id
          summary
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxRequestFormTemplateDetailsQuery, GetRfxRequestFormTemplateDetailsQueryVariables>;
export const GetRfxStatusDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxStatus($rfxId: uuid!) {
  rfx_by_pk(id: $rfxId) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<GetRfxStatusQuery, GetRfxStatusQueryVariables>;
export const UpdateRfxRequestFormTemplatesRanksDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRfxRequestFormTemplatesRanks($objects: [rfx_request_form_templates_ranks_insert_input!]!) {
  insert_rfx_request_form_templates_ranks(
    objects: $objects
    on_conflict: {constraint: unique_rfx_request_form_template_rank, update_columns: [rank, updated_at]}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateRfxRequestFormTemplatesRanksMutation, UpdateRfxRequestFormTemplatesRanksMutationVariables>;
export const GetAllFormQuestionScoresDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllFormQuestionScores($rfxId: uuid!) {
  rfx_by_pk(id: $rfxId) {
    rfx_suppliers {
      id
      organisationSupplierId
      status
    }
    request_step {
      request_step_tasks(
        where: {_and: {type: {_eq: SCORE_RFX_FORM}, completedOn: {_is_null: false}}}
      ) {
        request_step_task_users(
          where: {request_step_task: {_and: {completedOn: {_is_null: false}, type: {_eq: SCORE_RFX_FORM}}}}
        ) {
          request_step_task {
            id
            request_form_template {
              id
            }
            request_form_question_scores {
              id
              questionName
              score
              userId
              request_form_submission {
                id
              }
              request_form {
                id
                request_form_template {
                  id
                  title
                  pages: config(path: "$.pages")
                }
              }
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAllFormQuestionScoresQuery, GetAllFormQuestionScoresQueryVariables>;
export const GetFormTemplateQuestionScoresDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFormTemplateQuestionScores($rfxId: uuid!, $requestFormTemplateId: uuid!) {
  rfx_by_pk(id: $rfxId) {
    request_step {
      request_step_tasks(
        where: {type: {_eq: SCORE_RFX_FORM}, completedOn: {_is_null: false}, request_form_template: {id: {_eq: $requestFormTemplateId}}}
      ) {
        request_step_task_users(
          where: {request_step_task: {completedOn: {_is_null: false}, type: {_eq: SCORE_RFX_FORM}, request_form_template: {id: {_eq: $requestFormTemplateId}}}}
        ) {
          request_step_task {
            id
            request_form_template {
              id
            }
            request_form_question_scores {
              id
              questionName
              score
              userId
              request_form_submission {
                id
              }
              request_form {
                id
                request_form_template {
                  id
                  title
                  pages: config(path: "$.pages")
                }
              }
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetFormTemplateQuestionScoresQuery, GetFormTemplateQuestionScoresQueryVariables>;
export const GetUsersByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUsersByIds($userIds: [uuid!]) {
  users(where: {id: {_in: $userIds}}) {
    id
    firstName
    lastName
    email
    role
    isOutOfOffice
    isArchived
  }
}
    `) as unknown as TypedDocumentString<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>;
export const CloseScoringAndUpdateStateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CloseScoringAndUpdateState($requestStepId: uuid!, $rfxId: uuid!, $rfxStatus: String!) {
  update_request_step_tasks(
    where: {type: {_eq: SCORE_RFX_FORM}, request_step: {id: {_eq: $requestStepId}}}
    _set: {completedOn: "now()", submissionsClosedAt: "now()"}
  ) {
    affected_rows
    returning {
      id
    }
  }
  update_rfx_by_pk(pk_columns: {id: $rfxId}, _set: {status: $rfxStatus}) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<CloseScoringAndUpdateStateMutation, CloseScoringAndUpdateStateMutationVariables>;
export const CreateScoringTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateScoringTasks($tasks: [request_step_tasks_insert_input!]!) {
  insert_request_step_tasks(objects: $tasks) {
    returning {
      id
      request_step_task_users {
        user_id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CreateScoringTasksMutation, CreateScoringTasksMutationVariables>;
export const DeleteRequestFormTemplatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRequestFormTemplates($requestFormTemplateIds: [uuid!]!, $requestStepId: uuid!) {
  delete_request_form_templates(
    where: {id: {_in: $requestFormTemplateIds}, isSent: {_eq: false}, requestStepId: {_eq: $requestStepId}}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteRequestFormTemplatesMutation, DeleteRequestFormTemplatesMutationVariables>;
export const GetActiveRfxSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetActiveRfxSuppliers($rfxId: uuid!) {
  rfx_suppliers(
    where: {status: {_nin: ["REJECTED", "WITHDRAWN"]}, rfxId: {_eq: $rfxId}}
  ) {
    id
    organisationSupplierId
    hasParticipatedInScoring
  }
}
    `) as unknown as TypedDocumentString<GetActiveRfxSuppliersQuery, GetActiveRfxSuppliersQueryVariables>;
export const GetRequestFormTemplateTasksByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFormTemplateTasksById($requestFormTemplateId: uuid!) {
  request_step_tasks(
    where: {request_form: {request_form_template_id: {_eq: $requestFormTemplateId}}}
  ) {
    id
    requestFormId
    organisation_supplier {
      id
      name
    }
  }
  request_form_templates_by_pk(id: $requestFormTemplateId) {
    id
    title
  }
}
    `) as unknown as TypedDocumentString<GetRequestFormTemplateTasksByIdQuery, GetRequestFormTemplateTasksByIdQueryVariables>;
export const GetRequestFormTemplatesReviewersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFormTemplatesReviewers($requestFormTemplateIds: [uuid!]!) {
  request_form_template_reviewers(
    where: {requestFormTemplateId: {_in: $requestFormTemplateIds}}
  ) {
    id
    userId
  }
}
    `) as unknown as TypedDocumentString<GetRequestFormTemplatesReviewersQuery, GetRequestFormTemplatesReviewersQueryVariables>;
export const GetRequestStepRequestFormTemplatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepRequestFormTemplates($requestStepId: uuid!) {
  request_form_templates(
    where: {request_step: {id: {_eq: $requestStepId}}, deletedAt: {_is_null: true}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepRequestFormTemplatesQuery, GetRequestStepRequestFormTemplatesQueryVariables>;
export const GetRequestStepSupplierFillInTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepSupplierFillInTasks($requestStepId: uuid!) {
  request_step_tasks(
    where: {type: {_eq: FILL_IN}, requestStepId: {_eq: $requestStepId}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepSupplierFillInTasksQuery, GetRequestStepSupplierFillInTasksQueryVariables>;
export const GetRfxAndSupplierOnboardingRequestFormTemplatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxAndSupplierOnboardingRequestFormTemplates($requestStepId: uuid!) {
  request_form_templates(
    where: {requestStepId: {_eq: $requestStepId}, type: {_in: [RFX, SUPPLIER_ONBOARDING]}, deletedAt: {_is_null: true}}
  ) {
    id
    formTemplateId
    config
    title
    description
    type
    isSent
    createdAt
    rfx_request_form_templates_rank {
      id
      rank
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxAndSupplierOnboardingRequestFormTemplatesQuery, GetRfxAndSupplierOnboardingRequestFormTemplatesQueryVariables>;
export const GetRfxConfidentialityAgreementsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxConfidentialityAgreements($rfxId: uuid) {
  rfx_confidentiality_agreement(where: {rfxId: {_eq: $rfxId}}) {
    id
    rfxSupplierId
  }
}
    `) as unknown as TypedDocumentString<GetRfxConfidentialityAgreementsQuery, GetRfxConfidentialityAgreementsQueryVariables>;
export const GetRfxDetailDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxDetail($rfxId: uuid!) {
  rfx_by_pk(id: $rfxId) {
    ...RfxFragment
  }
}
    fragment RfxFragment on rfx {
  id
  aiScoringEnabled
  aiScoringVisible
  isReopened
  organisation {
    id
    name
  }
  status
  requestId
  supplierInstructions
  request {
    id
    name
    createdAt
  }
  requestStepId
  rfx_suppliers_aggregate {
    aggregate {
      count
    }
  }
  owners {
    id
    userId
  }
  rfx_suppliers {
    id
    status
    organisation_supplier {
      name
      id
    }
    hasParticipatedInScoring
    rfx_external_users_aggregate {
      aggregate {
        count
      }
    }
  }
  request_step {
    result
    createdAt
    targetTimeValue: input(path: "$.metadata.config.payload.targetTimeValue")
    supplierFillInTasks: request_step_tasks(where: {type: {_eq: FILL_IN}}) {
      request_form {
        request_form_template_id
      }
      organisation_supplier {
        name
        id
      }
      id
      completedOn
      submissionsClosedAt
    }
    scoringTasks: request_step_tasks(where: {type: {_eq: SCORE_RFX_FORM}}) {
      completedOn
      submissionsClosedAt
      id
    }
    request_form_templates(where: {deletedAt: {_is_null: true}}) {
      id
      title
      type
      createdAt
      isSent
      rfx_request_form_templates_rank {
        id
        rank
      }
      request_forms {
        id
      }
    }
  }
}`) as unknown as TypedDocumentString<GetRfxDetailQuery, GetRfxDetailQueryVariables>;
export const GetRfxScoringProgressDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxScoringProgressData($rfxId: uuid!) {
  rfx_by_pk(id: $rfxId) {
    request {
      id
      request_forms(where: {type: {_eq: RFX}}) {
        id
        request_step_tasks {
          type
          organisation_supplier {
            id
            rfx_suppliers {
              id
              status
              rfxId
            }
          }
        }
        request_form_template_id
        request_form_template {
          config
          request_form_template_reviewers {
            id
            userId
          }
        }
        request_form_question_scores {
          userId
          questionName
          score
        }
        latestSubmission: request_form_submissions(
          order_by: {submittedOn: desc_nulls_last}
          limit: 1
        ) {
          id
          response
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxScoringProgressDataQuery, GetRfxScoringProgressDataQueryVariables>;
export const GetRfxSupplierSubmissionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxSupplierSubmissions($requestStepId: uuid!, $organisationSupplierIds: [uuid!]!) {
  request_step_tasks(
    where: {type: {_eq: FILL_IN}, organisationSupplierId: {_in: $organisationSupplierIds}, requestStepId: {_eq: $requestStepId}}
  ) {
    id
    request_form {
      id
      request_form_submissions {
        id
      }
      request_form_template_id
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxSupplierSubmissionsQuery, GetRfxSupplierSubmissionsQueryVariables>;
export const GetRfxSuppliersTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxSuppliersTasks($requestStepId: uuid!, $organisationSupplierIds: [uuid!]!) {
  request_step_tasks(
    where: {_and: {requestStepId: {_eq: $requestStepId}, organisationSupplierId: {_in: $organisationSupplierIds}}}
  ) {
    id
    completedOn
    organisationSupplierId
    request_form {
      id
      request_form_template {
        id
        type
        closedScoringTasks: request_step_tasks(
          where: {requestStepId: {_eq: $requestStepId}, type: {_eq: SCORE_RFX_FORM}, submissionsClosedAt: {_is_null: false}}
        ) {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxSuppliersTasksQuery, GetRfxSuppliersTasksQueryVariables>;
export const GetRfxWithActiveSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxWithActiveSuppliers($rfxId: uuid!) {
  organisations {
    id
    name
  }
  rfx_by_pk(id: $rfxId) {
    requestStepId
    request_step {
      requiresConfidentialityAgreement: input(
        path: "$.metadata.config.payload.requiresConfidentialityAgreement"
      )
    }
    status
    isReopened
    request {
      id
      name
    }
    owners {
      id
      userId
    }
    rfx_suppliers(where: {status: {_nin: ["REJECTED", "WITHDRAWN"]}}) {
      id
      organisation_supplier {
        id
        name
      }
      hasParticipatedInScoring
      rfx_external_users {
        id
        external_contact {
          userId
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxWithActiveSuppliersQuery, GetRfxWithActiveSuppliersQueryVariables>;
export const GetScoringTaskDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetScoringTaskDetails($taskId: uuid!) {
  request_step_tasks_by_pk(id: $taskId) {
    id
    type
    request_form_template {
      id
    }
    request_form_question_scores {
      questionName
      score
      request_form {
        id
      }
      request_form_submission {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetScoringTaskDetailsQuery, GetScoringTaskDetailsQueryVariables>;
export const GetScoringTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetScoringTasks($userId: uuid!, $requestStepId: uuid!) {
  request_step_task_users(
    where: {user_id: {_eq: $userId}, request_step_task: {request_step: {id: {_eq: $requestStepId}}}}
  ) {
    request_step_task {
      id
      request_form_template_id
      submissionsClosedAt
    }
  }
}
    `) as unknown as TypedDocumentString<GetScoringTasksQuery, GetScoringTasksQueryVariables>;
export const GetSentRfxAndSupplierOnboardingRequestFormTemplatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSentRfxAndSupplierOnboardingRequestFormTemplates($requestStepId: uuid!) {
  request_form_templates(
    where: {requestStepId: {_eq: $requestStepId}, type: {_in: [RFX, SUPPLIER_ONBOARDING]}, isSent: {_eq: true}, deletedAt: {_is_null: true}}
  ) {
    id
    formTemplateId
    config
    title
    description
    type
    createdAt
    isSent
    rfx_request_form_templates_rank {
      id
      rank
    }
  }
}
    `) as unknown as TypedDocumentString<GetSentRfxAndSupplierOnboardingRequestFormTemplatesQuery, GetSentRfxAndSupplierOnboardingRequestFormTemplatesQueryVariables>;
export const GetRequestFormSubmissionDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFormSubmissionDetails($requestFormSubmissionId: uuid!) {
  request_form_submissions_by_pk(id: $requestFormSubmissionId) {
    requestStepTaskId
    requestFormId
  }
}
    `) as unknown as TypedDocumentString<GetRequestFormSubmissionDetailsQuery, GetRequestFormSubmissionDetailsQueryVariables>;
export const MarkRequestFormTemplateAsSentDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation MarkRequestFormTemplateAsSent($id: uuid!) {
  update_request_form_templates_by_pk(pk_columns: {id: $id}, _set: {isSent: true}) {
    id
  }
}
    `) as unknown as TypedDocumentString<MarkRequestFormTemplateAsSentMutation, MarkRequestFormTemplateAsSentMutationVariables>;
export const MarkRequestFormTemplatesAsSentAndUpdateStateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation MarkRequestFormTemplatesAsSentAndUpdateState($templateIds: [uuid!]!, $rfxId: uuid!, $rfxStatus: String!) {
  updatedRequestFormTemplates: update_request_form_templates(
    where: {id: {_in: $templateIds}}
    _set: {isSent: true}
  ) {
    affected_rows
    returning {
      id
    }
  }
  updatedRfx: update_rfx_by_pk(
    pk_columns: {id: $rfxId}
    _set: {status: $rfxStatus}
  ) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<MarkRequestFormTemplatesAsSentAndUpdateStateMutation, MarkRequestFormTemplatesAsSentAndUpdateStateMutationVariables>;
export const ReopenRequestFormTemplateScoringTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ReopenRequestFormTemplateScoringTasks($requestStepId: uuid!, $requestFormTemplateIds: [uuid!]!) {
  update_request_step_tasks(
    where: {requestStepId: {_eq: $requestStepId}, request_form_template_id: {_in: $requestFormTemplateIds}, type: {_eq: SCORE_RFX_FORM}}
    _set: {completedBy: null, completedOn: null, submissionsClosedAt: null}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<ReopenRequestFormTemplateScoringTasksMutation, ReopenRequestFormTemplateScoringTasksMutationVariables>;
export const SetRequestStepTasksSubmissionsClosedAtDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SetRequestStepTasksSubmissionsClosedAt($requestStepTaskIds: [uuid!]!, $submissionsClosedAt: timestamptz) {
  update_request_step_tasks(
    where: {id: {_in: $requestStepTaskIds}}
    _set: {submissionsClosedAt: $submissionsClosedAt}
  ) {
    returning {
      id
      submissionsClosedAt
    }
  }
}
    `) as unknown as TypedDocumentString<SetRequestStepTasksSubmissionsClosedAtMutation, SetRequestStepTasksSubmissionsClosedAtMutationVariables>;
export const SetRfxIsReopenedDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SetRfxIsReopened($rfxId: uuid!) {
  updatedRfx: update_rfx_by_pk(pk_columns: {id: $rfxId}, _set: {isReopened: true}) {
    id
  }
}
    `) as unknown as TypedDocumentString<SetRfxIsReopenedMutation, SetRfxIsReopenedMutationVariables>;
export const UpdateRfxStateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRfxState($rfxId: uuid!, $rfxStatus: String!) {
  update_rfx_by_pk(pk_columns: {id: $rfxId}, _set: {status: $rfxStatus}) {
    id
    status
  }
}
    `) as unknown as TypedDocumentString<UpdateRfxStateMutation, UpdateRfxStateMutationVariables>;
export const UpdateRfxSupplierAwardStatusDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRfxSupplierAwardStatus($rfxSupplierId: uuid!, $status: String!) {
  update_rfx_suppliers_by_pk(
    pk_columns: {id: $rfxSupplierId}
    _set: {status: $status}
  ) {
    id
    status
    rfxId
  }
}
    `) as unknown as TypedDocumentString<UpdateRfxSupplierAwardStatusMutation, UpdateRfxSupplierAwardStatusMutationVariables>;
export const UpdateRfxSupplierHasParticipatedInScoringDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRfxSupplierHasParticipatedInScoring($rfxSupplierIds: [uuid!]!, $hasParticipatedInScoring: Boolean!) {
  update_rfx_suppliers(
    _set: {hasParticipatedInScoring: $hasParticipatedInScoring}
    where: {id: {_in: $rfxSupplierIds}}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateRfxSupplierHasParticipatedInScoringMutation, UpdateRfxSupplierHasParticipatedInScoringMutationVariables>;
export const UpsertRequestComputedPropertiesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertRequestComputedProperties($updatedProperties: request_computed_properties_insert_input!) {
  insert_request_computed_properties_one(
    object: $updatedProperties
    on_conflict: {constraint: request_computed_properties_pkey, update_columns: [address, annualValueNumber, budgetHolderId, businessOwnerId, buyerLegalEntityId, cancelByDate, cancellationNoticeDays, cancellationReason, categoryId, contractEndDate, contractLength, contractStartDate, costCenterId, departmentId, goLiveDate, inBudget, isAutoRenewal, itOwnerId, marketId, note, paymentMethodId, paymentTermId, renewalDate, shouldRenew, syncWithAccountingIntegration, taxNumber, type, valueNumber, valueObject, website]}
  ) {
    id
    requestId
  }
}
    `) as unknown as TypedDocumentString<UpsertRequestComputedPropertiesMutation, UpsertRequestComputedPropertiesMutationVariables>;
export const UserHasTaskPermissionDocument = /*#__PURE__*/ new TypedDocumentString(`
    query UserHasTaskPermission($userId: uuid!, $taskId: uuid!) {
  request_step_task_users(
    where: {user_id: {_eq: $userId}, request_step_task_id: {_eq: $taskId}}
  ) {
    userId: user_id
  }
}
    `) as unknown as TypedDocumentString<UserHasTaskPermissionQuery, UserHasTaskPermissionQueryVariables>;
export const AddRfxSupplierContactsToTaskDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation AddRfxSupplierContactsToTask($taskUsers: [request_step_task_users_insert_input!]!) {
  insert_request_step_task_users(objects: $taskUsers) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<AddRfxSupplierContactsToTaskMutation, AddRfxSupplierContactsToTaskMutationVariables>;
export const DeleteRfxExternalUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRfxExternalUsers($externalUserIds: [uuid!], $rfxSupplierId: uuid!) {
  delete_rfx_external_users(
    where: {id: {_in: $externalUserIds}, rfxSupplierId: {_eq: $rfxSupplierId}}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteRfxExternalUsersMutation, DeleteRfxExternalUsersMutationVariables>;
export const FindExistingContactsAndUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query FindExistingContactsAndUsers($supplierId: uuid!, $emails: [String!]!) {
  external_contacts(
    where: {email: {_in: $emails}, supplierId: {_eq: $supplierId}}
  ) {
    id
    email
    userId
  }
  users(where: {email: {_in: $emails}}) {
    id
    email
  }
}
    `) as unknown as TypedDocumentString<FindExistingContactsAndUsersQuery, FindExistingContactsAndUsersQueryVariables>;
export const GetExternalContactsByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetExternalContactsByIds($externalContactIds: [uuid!]!) {
  external_contacts(where: {id: {_in: $externalContactIds}}) {
    id
    userId
  }
}
    `) as unknown as TypedDocumentString<GetExternalContactsByIdsQuery, GetExternalContactsByIdsQueryVariables>;
export const GetGlobalProductAndSupplierDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGlobalProductAndSupplierDetails($productId: uuid!) {
  products_and_services_by_pk(id: $productId) {
    id
    name
    description
    website
    logoUrl
    supplier {
      id
      name
      website
      logoUrl
      isReseller
      organisation_suppliers_brands {
        id
        organisation_suppliers {
          id
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetGlobalProductAndSupplierDetailsQuery, GetGlobalProductAndSupplierDetailsQueryVariables>;
export const GetGlobalSupplierDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGlobalSupplierDetails($supplierId: uuid!) {
  suppliers_by_pk(id: $supplierId) {
    organisation_suppliers_brands {
      id
      organisation_suppliers {
        id
      }
    }
    id
    name
    website
    logoUrl
    description
    isReseller
  }
}
    `) as unknown as TypedDocumentString<GetGlobalSupplierDetailsQuery, GetGlobalSupplierDetailsQueryVariables>;
export const GetRfxRequestStepsWithAwardedRfxSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxRequestStepsWithAwardedRfxSupplier($requestId: uuid!) {
  request_steps(
    where: {requestId: {_eq: $requestId}, input: {_contains: {metadata: {type: "RFX"}}}}
  ) {
    id
    requestId
    input
  }
  rfx(where: {requestId: {_eq: $requestId}}) {
    id
    status
    requestStepId
    rfx_suppliers(where: {status: {_eq: "AWARDED"}}) {
      id
      status
      organisationSupplierId
      organisation_supplier {
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxRequestStepsWithAwardedRfxSupplierQuery, GetRfxRequestStepsWithAwardedRfxSupplierQueryVariables>;
export const GetRfxRequiresConfidentialityAgreementDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxRequiresConfidentialityAgreement($rfxId: uuid!) {
  rfx_by_pk(id: $rfxId) {
    id
    request_step {
      id
      requiresConfidentialityAgreement: input(
        path: "$.metadata.config.payload.requiresConfidentialityAgreement"
      )
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxRequiresConfidentialityAgreementQuery, GetRfxRequiresConfidentialityAgreementQueryVariables>;
export const GetRfxSuppliersByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxSuppliersById($rfxSupplierId: uuid!) {
  rfx_suppliers_by_pk(id: $rfxSupplierId) {
    id
    rfxId
    status
    organisationSupplierId
    organisation_supplier {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxSuppliersByIdQuery, GetRfxSuppliersByIdQueryVariables>;
export const GetRfxSupplierContactsTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxSupplierContactsTasks($userIds: [uuid!]!, $requestStepId: uuid!) {
  request_step_tasks(
    where: {request_step_task_users: {user_id: {_in: $userIds}}, type: {_eq: FILL_IN}, requestStepId: {_eq: $requestStepId}}
  ) {
    id
    request_step_task_users {
      user_id
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxSupplierContactsTasksQuery, GetRfxSupplierContactsTasksQueryVariables>;
export const GetRfxSupplierRfxExternalUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxSupplierRfxExternalUsers($rfxSupplierId: uuid!) {
  rfx_external_users(where: {rfxSupplierId: {_eq: $rfxSupplierId}}) {
    id
    external_contact {
      id
      email
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxSupplierRfxExternalUsersQuery, GetRfxSupplierRfxExternalUsersQueryVariables>;
export const GetRfxSupplierTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxSupplierTasks($organisationSupplierId: uuid!, $requestStepId: uuid!) {
  request_step_tasks(
    where: {_and: {requestStepId: {_eq: $requestStepId}, organisationSupplierId: {_eq: $organisationSupplierId}}}
  ) {
    id
    request_step_task_users {
      user_id
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxSupplierTasksQuery, GetRfxSupplierTasksQueryVariables>;
export const GetRfxSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxSuppliers($rfxId: uuid!) {
  rfx_suppliers(where: {rfxId: {_eq: $rfxId}}, order_by: {createdAt: desc}) {
    id
    organisationProductId
    organisationSupplierId
    status
    hasParticipatedInScoring
    product: organisation_products_and_service {
      id
      displayName
    }
    organisation_supplier {
      id
      name
      logoUrl
    }
    rfx_external_users {
      id
      external_contact {
        id
        firstName
        lastName
        email
        userId
      }
    }
    rfx {
      id
      requestId
      requestStepId
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxSuppliersQuery, GetRfxSuppliersQueryVariables>;
export const GetRfxSuppliersContactsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxSuppliersContacts($rfxId: uuid!) {
  rfx_suppliers(where: {rfxId: {_eq: $rfxId}}) {
    rfx_external_users {
      id
      external_contact {
        id
        email
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxSuppliersContactsQuery, GetRfxSuppliersContactsQueryVariables>;
export const GetUsersByEmailDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUsersByEmail($emails: [String!]) {
  users(where: {email: {_in: $emails}, deletedAt: {_is_null: true}}) {
    id
    email
    role
    isArchived
  }
}
    `) as unknown as TypedDocumentString<GetUsersByEmailQuery, GetUsersByEmailQueryVariables>;
export const InsertExternalContactsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertExternalContacts($input: [external_contacts_insert_input!]!) {
  insert_external_contacts(objects: $input) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertExternalContactsMutation, InsertExternalContactsMutationVariables>;
export const InsertOrganisationSupplierOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertOrganisationSupplierOne($input: organisation_suppliers_insert_input!) {
  insert_organisation_suppliers_one(object: $input) {
    id
    organisation_products_and_services {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertOrganisationSupplierOneMutation, InsertOrganisationSupplierOneMutationVariables>;
export const InsertRfxExternalUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRfxExternalUsers($externalUsers: [rfx_external_users_insert_input!]!) {
  insert_rfx_external_users(objects: $externalUsers) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertRfxExternalUsersMutation, InsertRfxExternalUsersMutationVariables>;
export const InsertRfxSuppliersOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRfxSuppliersOne($rfx_supplier: rfx_suppliers_insert_input!) {
  insert_rfx_suppliers_one(object: $rfx_supplier) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertRfxSuppliersOneMutation, InsertRfxSuppliersOneMutationVariables>;
export const CreateRfxConfidentialityAgreementDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateRfxConfidentialityAgreement($rfxId: uuid!, $rfxSupplierId: uuid!, $confidentialityAgreement: String!) {
  insert_rfx_confidentiality_agreement(
    objects: {rfxId: $rfxId, rfxSupplierId: $rfxSupplierId, confidentialityAgreement: $confidentialityAgreement}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<CreateRfxConfidentialityAgreementMutation, CreateRfxConfidentialityAgreementMutationVariables>;
export const CreateSupplierOnboardingTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateSupplierOnboardingTasks($tasks: [request_step_tasks_insert_input!]!, $taskUsers: [request_step_task_users_insert_input!]!) {
  insert_request_step_tasks(objects: $tasks) {
    affected_rows
  }
  insert_request_step_task_users(objects: $taskUsers) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<CreateSupplierOnboardingTasksMutation, CreateSupplierOnboardingTasksMutationVariables>;
export const CreateUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateUsers($users: [users_insert_input!]!) {
  insert_users(objects: $users) {
    returning {
      email
      id
    }
  }
}
    `) as unknown as TypedDocumentString<CreateUsersMutation, CreateUsersMutationVariables>;
export const GetRfxSupplierContactsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxSupplierContacts($id: uuid!) {
  rfx_suppliers_by_pk(id: $id) {
    id
    organisationSupplierId
    rfx_external_users {
      id
      external_contact {
        id
        firstName
        lastName
        email
        user {
          id
          email
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRfxSupplierContactsQuery, GetRfxSupplierContactsQueryVariables>;
export const RfxGetUsersByEmailDocument = /*#__PURE__*/ new TypedDocumentString(`
    query RfxGetUsersByEmail($emails: [String!]!) {
  users(
    where: {_and: {email: {_in: $emails}, deletedAt: {_is_null: true}, isArchived: {_eq: false}}}
  ) {
    id
    email
    role
  }
}
    `) as unknown as TypedDocumentString<RfxGetUsersByEmailQuery, RfxGetUsersByEmailQueryVariables>;
export const UpdateExternalContactsManyDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateExternalContactsMany($updates: [external_contacts_updates!]!) {
  update_external_contacts_many(updates: $updates) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpdateExternalContactsManyMutation, UpdateExternalContactsManyMutationVariables>;
export const ListRfxRequestFormTemplateWeightingsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListRfxRequestFormTemplateWeightings($requestFormTemplateIds: [uuid!]!) {
  rfx_request_form_template_weighting(
    where: {requestFormTemplateId: {_in: $requestFormTemplateIds}}
  ) {
    id
    requestFormTemplateId
    weighting
  }
}
    `) as unknown as TypedDocumentString<ListRfxRequestFormTemplateWeightingsQuery, ListRfxRequestFormTemplateWeightingsQueryVariables>;
export const CheckRfxReviewerForRequestFormTemplateDocument = /*#__PURE__*/ new TypedDocumentString(`
    query CheckRfxReviewerForRequestFormTemplate($userId: uuid!, $requestFormTemplateId: uuid!) {
  request_form_template_reviewers(
    where: {userId: {_eq: $userId}, requestFormTemplateId: {_eq: $requestFormTemplateId}}
    limit: 1
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<CheckRfxReviewerForRequestFormTemplateQuery, CheckRfxReviewerForRequestFormTemplateQueryVariables>;
export const DeleteRfxReviewersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRfxReviewers($requestFormTemplateId: uuid!, $userIds: [uuid!]!) {
  delete_request_form_template_reviewers(
    where: {requestFormTemplateId: {_eq: $requestFormTemplateId}, userId: {_in: $userIds}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteRfxReviewersMutation, DeleteRfxReviewersMutationVariables>;
export const DeleteRfxScoringTasksAndReviewersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRfxScoringTasksAndReviewers($userIds: [uuid!], $requestFormTemplateId: uuid!, $requestStepTaskIdsToDelete: [uuid!]) {
  delete_request_step_task_users(
    where: {request_step_task_id: {_in: $requestStepTaskIdsToDelete}}
  ) {
    returning {
      user_id
    }
  }
  delete_request_step_tasks(
    where: {_and: {type: {_eq: SCORE_RFX_FORM}, id: {_in: $requestStepTaskIdsToDelete}}}
  ) {
    returning {
      id
    }
  }
  delete_request_form_template_reviewers(
    where: {userId: {_in: $userIds}, requestFormTemplateId: {_eq: $requestFormTemplateId}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteRfxScoringTasksAndReviewersMutation, DeleteRfxScoringTasksAndReviewersMutationVariables>;
export const GetRequestStepTasksToDeleteDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestStepTasksToDelete($requestFormTemplateId: uuid!, $userIds: [uuid!]!) {
  request_step_tasks(
    where: {_and: {type: {_eq: SCORE_RFX_FORM}, request_form_template_id: {_eq: $requestFormTemplateId}, request_step_task_users: {user_id: {_in: $userIds}}}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetRequestStepTasksToDeleteQuery, GetRequestStepTasksToDeleteQueryVariables>;
export const InsertRfxReviewersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRfxReviewers($reviewers: [request_form_template_reviewers_insert_input!]!) {
  insert_request_form_template_reviewers(
    objects: $reviewers
    on_conflict: {constraint: request_form_template_reviewe_request_form_template_id_user_key, update_columns: []}
  ) {
    affected_rows
    returning {
      id
      userId
      requestFormTemplateId
      organisationId
      user {
        id
        firstName
        lastName
        email
        request_step_task_users {
          request_step_task {
            id
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<InsertRfxReviewersMutation, InsertRfxReviewersMutationVariables>;
export const ListAllAndPastRfxReviewersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListAllAndPastRfxReviewers($requestFormTemplateIds: [uuid!]!, $requestStepId: uuid!) {
  requestFormTemplateReviewers: request_form_template_reviewers(
    where: {requestFormTemplateId: {_in: $requestFormTemplateIds}}
  ) {
    id
    requestFormTemplateId
    user {
      id
      firstName
      lastName
      email
      request_step_task_users(
        where: {request_step_task: {requestStepId: {_eq: $requestStepId}, type: {_eq: SCORE_RFX_FORM}}}
      ) {
        request_step_task {
          id
        }
      }
    }
  }
  closedScoringTaskUsers: request_step_task_users(
    where: {request_step_task: {request_form_template_id: {_in: $requestFormTemplateIds}, type: {_eq: SCORE_RFX_FORM}, requestStepId: {_eq: $requestStepId}, submissionsClosedAt: {_is_null: false}}}
  ) {
    request_step_task {
      id
      request_form_template_id
    }
    user {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<ListAllAndPastRfxReviewersQuery, ListAllAndPastRfxReviewersQueryVariables>;
export const ListRfxReviewersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListRfxReviewers($requestFormTemplateIds: [uuid!]!, $requestStepId: uuid!) {
  request_form_template_reviewers(
    where: {requestFormTemplateId: {_in: $requestFormTemplateIds}}
  ) {
    id
    requestFormTemplateId
    userId
    user {
      id
      firstName
      lastName
    }
  }
}
    `) as unknown as TypedDocumentString<ListRfxReviewersQuery, ListRfxReviewersQueryVariables>;
export const GetRfxByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxById($rfxId: uuid!) {
  rfx_by_pk(id: $rfxId) {
    requestStepId
    requestId
  }
}
    `) as unknown as TypedDocumentString<GetRfxByIdQuery, GetRfxByIdQueryVariables>;
export const ListOrgSuppliersForScreeningDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListOrgSuppliersForScreening {
  suppliers: organisation_suppliers(
    where: {deleted_at: {_is_null: true}, state: {_eq: ACTIVE}, isContinuousMonitoringEnabled: {_eq: true}}
  ) {
    id
    name
    isPerson
  }
}
    `) as unknown as TypedDocumentString<ListOrgSuppliersForScreeningQuery, ListOrgSuppliersForScreeningQueryVariables>;
export const ListOrgSuppliersForUserOwnerIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListOrgSuppliersForUserOwnerId($supplierIds: [uuid!]!, $userId: uuid!) {
  suppliers: organisation_suppliers(
    where: {id: {_in: $supplierIds}, _or: [{internalContacts: {userId: {_eq: $userId}}}, {organisation_products_and_services: {businessOwnerId: {_eq: $userId}}}]}
  ) {
    id
    name
    logoUrl
  }
}
    `) as unknown as TypedDocumentString<ListOrgSuppliersForUserOwnerIdQuery, ListOrgSuppliersForUserOwnerIdQueryVariables>;
export const DeleteRiskAttributeDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRiskAttribute($id: uuid!) {
  deletedRiskAttribute: update_risk_attributes_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteRiskAttributeMutation, DeleteRiskAttributeMutationVariables>;
export const DeleteRiskLevelDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRiskLevel($id: uuid!) {
  deletedRiskLevel: update_risk_levels_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteRiskLevelMutation, DeleteRiskLevelMutationVariables>;
export const DeleteRiskMatrixCellDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRiskMatrixCell($id: uuid!) {
  deletedRiskMatrixCell: delete_risk_matrix_cells_by_pk(id: $id) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteRiskMatrixCellMutation, DeleteRiskMatrixCellMutationVariables>;
export const ListRiskAttributesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListRiskAttributes {
  riskAttributes: risk_attributes(where: {deletedAt: {_is_null: true}}) {
    id
    name
    type
  }
  riskLevels: risk_levels(where: {deletedAt: {_is_null: true}}) {
    id
    name
    description
    score
    type
  }
  riskMatrixCells: risk_matrix_cells {
    id
    probabilityId
    impactId
    score
  }
  suppliers: organisation_suppliers(where: {deleted_at: {_is_null: true}}) {
    id
    name
    state
  }
}
    `) as unknown as TypedDocumentString<ListRiskAttributesQuery, ListRiskAttributesQueryVariables>;
export const InsertRiskAttributeDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRiskAttribute($name: String!, $type: risk_attributes_type_enum!) {
  insert_risk_attributes_one(object: {name: $name, type: $type}) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertRiskAttributeMutation, InsertRiskAttributeMutationVariables>;
export const InsertRiskLevelDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRiskLevel($name: String!, $description: String!, $score: Int!, $type: risk_levels_type_enum!) {
  insert_risk_levels_one(
    object: {name: $name, description: $description, score: $score, type: $type}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertRiskLevelMutation, InsertRiskLevelMutationVariables>;
export const InsertRiskMatrixCellDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRiskMatrixCell($probabilityId: uuid!, $impactId: uuid!, $score: Int!) {
  insert_risk_matrix_cells_one(
    object: {probabilityId: $probabilityId, impactId: $impactId, score: $score}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertRiskMatrixCellMutation, InsertRiskMatrixCellMutationVariables>;
export const UpdateRiskAttributeDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRiskAttribute($id: uuid!, $name: String!) {
  update_risk_attributes_by_pk(pk_columns: {id: $id}, _set: {name: $name}) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateRiskAttributeMutation, UpdateRiskAttributeMutationVariables>;
export const UpdateRiskLevelDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRiskLevel($id: uuid!, $name: String!, $description: String!, $score: Int!) {
  update_risk_levels_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, description: $description, score: $score}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateRiskLevelMutation, UpdateRiskLevelMutationVariables>;
export const UpdateRiskMatrixCellDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRiskMatrixCell($id: uuid!, $score: Int!) {
  update_risk_matrix_cells_by_pk(pk_columns: {id: $id}, _set: {score: $score}) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateRiskMatrixCellMutation, UpdateRiskMatrixCellMutationVariables>;
export const CreateRiskDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateRisk($input: risks_insert_input!) {
  createdRisk: insert_risks_one(object: $input) {
    ...RiskFields
  }
}
    fragment RiskFields on risks {
  id
  createdAt
  updatedAt
  deletedAt
  organisationId
  createdBy
  updatedBy
  deletedBy
  orgSupplierId
  name
  description
  treatment
  sendReminderDaysBefore
  deadline
  inherentRiskProbabilityId
  inherentRiskImpactId
  residualRiskProbabilityId
  residualRiskImpactId
  isOpen
  stageId
  treatmentTypeId
  requestId
  requestFormId
  questionName
  closedAt
  closedBy
}`) as unknown as TypedDocumentString<CreateRiskMutation, CreateRiskMutationVariables>;
export const DeleteRiskDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRisk($id: uuid!, $deletedBy: uuid!) {
  deletedRisk: update_risks_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()", deletedBy: $deletedBy}
  ) {
    id
    orgSupplierId
    requestId
  }
}
    `) as unknown as TypedDocumentString<DeleteRiskMutation, DeleteRiskMutationVariables>;
export const GetRiskDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRisk($where: risks_bool_exp!) {
  risks(where: $where) {
    id
    name
    categories {
      category {
        id
        name
      }
    }
    supplier {
      id
      name
      logoUrl
      website
      description
      state
    }
    riskOwners(where: {type: {_eq: OWNER}}) {
      user {
        id
        firstName
        lastName
        email
      }
    }
    treatmentAssignees(where: {type: {_eq: TREATMENT_ASSIGNEE}}) {
      user {
        id
        firstName
        lastName
        email
      }
    }
    inherentRiskProbability {
      id
      name
      score
    }
    inherentRiskImpact {
      id
      name
      score
    }
    inherentRiskMatrix {
      score
    }
    residualRiskProbability {
      id
      name
      score
    }
    residualRiskImpact {
      id
      name
      score
    }
    residualRiskMatrix {
      score
    }
    description
    treatmentType {
      id
      name
    }
    treatment
    deadline
    sendReminderDaysBefore
    isOpen
    stage {
      id
      name
    }
    createdAt
    createdByUser {
      id
      firstName
      lastName
      email
    }
    updatedAt
    updatedByUser {
      id
      firstName
      lastName
      email
    }
    closedAt
    closedByUser {
      id
      firstName
      lastName
      email
    }
    request {
      id
      name
    }
    requestForm {
      id
      title
    }
    questionName
  }
}
    `) as unknown as TypedDocumentString<GetRiskQuery, GetRiskQueryVariables>;
export const ListRisksDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListRisks($where: risks_bool_exp) {
  risks(where: $where) {
    id
    name
    createdAt
    createdByUser {
      id
      firstName
      lastName
      email
    }
    updatedAt
    updatedByUser {
      id
      firstName
      lastName
      email
    }
    closedAt
    closedByUser {
      id
      firstName
      lastName
      email
    }
    supplier {
      id
      name
      logoUrl
      state
    }
    categories {
      category {
        name
      }
    }
    treatmentType {
      name
    }
    riskOwners(where: {type: {_eq: OWNER}}) {
      user {
        id
        firstName
        lastName
        email
      }
    }
    treatmentAssignees(where: {type: {_eq: TREATMENT_ASSIGNEE}}) {
      user {
        id
        firstName
        lastName
        email
      }
    }
    inherentRiskProbability {
      id
      name
      score
    }
    inherentRiskImpact {
      id
      name
      score
    }
    inherentRiskMatrix {
      score
    }
    residualRiskProbability {
      id
      name
      score
    }
    residualRiskImpact {
      id
      name
      score
    }
    residualRiskMatrix {
      score
    }
    description
    treatment
    deadline
    sendReminderDaysBefore
    isOpen
    stage {
      name
    }
    request {
      id
      name
    }
    requestForm {
      id
      title
    }
    questionName
  }
}
    `) as unknown as TypedDocumentString<ListRisksQuery, ListRisksQueryVariables>;
export const GetRequestForUserByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestForUserById($userId: uuid!, $requestId: uuid!) {
  requests(
    where: {id: {_eq: $requestId}, _or: [{request_users: {userId: {_eq: $userId}}}, {request_groups: {group: {group_users: {userId: {_eq: $userId}}}}}]}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetRequestForUserByIdQuery, GetRequestForUserByIdQueryVariables>;
export const UpdateRiskDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRisk($riskId: uuid!, $input: risks_set_input!) {
  updatedRisk: update_risks_by_pk(pk_columns: {id: $riskId}, _set: $input) {
    ...RiskFields
  }
}
    fragment RiskFields on risks {
  id
  createdAt
  updatedAt
  deletedAt
  organisationId
  createdBy
  updatedBy
  deletedBy
  orgSupplierId
  name
  description
  treatment
  sendReminderDaysBefore
  deadline
  inherentRiskProbabilityId
  inherentRiskImpactId
  residualRiskProbabilityId
  residualRiskImpactId
  isOpen
  stageId
  treatmentTypeId
  requestId
  requestFormId
  questionName
  closedAt
  closedBy
}`) as unknown as TypedDocumentString<UpdateRiskMutation, UpdateRiskMutationVariables>;
export const GetRiskBeforeUpdateDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRiskBeforeUpdate($where: risks_bool_exp!) {
  risks(where: $where) {
    ...RiskFields
    riskOwners(where: {type: {_eq: OWNER}}) {
      userId
    }
    treatmentAssignees(where: {type: {_eq: TREATMENT_ASSIGNEE}}) {
      userId
    }
    categories {
      id
    }
  }
}
    fragment RiskFields on risks {
  id
  createdAt
  updatedAt
  deletedAt
  organisationId
  createdBy
  updatedBy
  deletedBy
  orgSupplierId
  name
  description
  treatment
  sendReminderDaysBefore
  deadline
  inherentRiskProbabilityId
  inherentRiskImpactId
  residualRiskProbabilityId
  residualRiskImpactId
  isOpen
  stageId
  treatmentTypeId
  requestId
  requestFormId
  questionName
  closedAt
  closedBy
}`) as unknown as TypedDocumentString<GetRiskBeforeUpdateQuery, GetRiskBeforeUpdateQueryVariables>;
export const GetRiskSettingsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRiskSettings {
  riskSettings: risk_settings {
    id
    riskScoreMethodology
  }
}
    `) as unknown as TypedDocumentString<GetRiskSettingsQuery, GetRiskSettingsQueryVariables>;
export const UpsertRiskSettingsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertRiskSettings($input: risk_settings_insert_input!) {
  insert_risk_settings(
    objects: [$input]
    on_conflict: {constraint: risk_settings_organisation_id_key, update_columns: [riskScoreMethodology]}
  ) {
    affected_rows
    returning {
      id
      riskScoreMethodology
    }
  }
}
    `) as unknown as TypedDocumentString<UpsertRiskSettingsMutation, UpsertRiskSettingsMutationVariables>;
export const ListOrgSuppliersByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListOrgSuppliersByIds($ids: [uuid!]!) {
  suppliers: organisation_suppliers(where: {id: {_in: $ids}}) {
    id
    name
    logoUrl
  }
}
    `) as unknown as TypedDocumentString<ListOrgSuppliersByIdsQuery, ListOrgSuppliersByIdsQueryVariables>;
export const DeleteRiskCategoriesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRiskCategories($riskId: uuid!) {
  deletedRows: delete_risk_categories(where: {riskId: {_eq: $riskId}}) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteRiskCategoriesMutation, DeleteRiskCategoriesMutationVariables>;
export const DeleteRiskTemplateCategoriesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRiskTemplateCategories($riskTemplateId: uuid!) {
  deletedRows: delete_risk_template_categories(
    where: {riskTemplateId: {_eq: $riskTemplateId}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteRiskTemplateCategoriesMutation, DeleteRiskTemplateCategoriesMutationVariables>;
export const InsertRiskCategoriesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRiskCategories($riskCategories: [risk_categories_insert_input!]!) {
  insertedRows: insert_risk_categories(objects: $riskCategories) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<InsertRiskCategoriesMutation, InsertRiskCategoriesMutationVariables>;
export const InsertRiskTemplateCategoriesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRiskTemplateCategories($riskCategories: [risk_template_categories_insert_input!]!) {
  insertedRows: insert_risk_template_categories(objects: $riskCategories) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<InsertRiskTemplateCategoriesMutation, InsertRiskTemplateCategoriesMutationVariables>;
export const DeleteRiskOwnersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRiskOwners($riskId: uuid!, $userType: risk_users_type_enum!) {
  deletedRows: delete_risk_owners(
    where: {riskId: {_eq: $riskId}, type: {_eq: $userType}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteRiskOwnersMutation, DeleteRiskOwnersMutationVariables>;
export const DeleteRiskTemplateOwnersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRiskTemplateOwners($riskTemplateId: uuid!, $userType: risk_users_type_enum!) {
  deletedRows: delete_risk_template_owners(
    where: {riskTemplateId: {_eq: $riskTemplateId}, type: {_eq: $userType}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteRiskTemplateOwnersMutation, DeleteRiskTemplateOwnersMutationVariables>;
export const InsertRiskOwnersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRiskOwners($riskOwners: [risk_owners_insert_input!]!) {
  insertedRows: insert_risk_owners(objects: $riskOwners) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<InsertRiskOwnersMutation, InsertRiskOwnersMutationVariables>;
export const InsertRiskTemplateOwnersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRiskTemplateOwners($riskOwners: [risk_template_owners_insert_input!]!) {
  insertedRows: insert_risk_template_owners(objects: $riskOwners) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<InsertRiskTemplateOwnersMutation, InsertRiskTemplateOwnersMutationVariables>;
export const CreateRiskTemplateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateRiskTemplate($input: risk_templates_insert_input!) {
  createdRiskTemplate: insert_risk_templates_one(object: $input) {
    ...RiskTemplateFields
  }
}
    fragment RiskTemplateFields on risk_templates {
  id
  createdAt
  updatedAt
  deletedAt
  organisationId
  createdBy
  updatedBy
  deletedBy
  orgSupplierId
  name
  description
  treatment
  sendReminderDaysBefore
  deadline
  inherentRiskProbabilityId
  inherentRiskImpactId
  residualRiskProbabilityId
  residualRiskImpactId
  stageId
  treatmentTypeId
}`) as unknown as TypedDocumentString<CreateRiskTemplateMutation, CreateRiskTemplateMutationVariables>;
export const DeleteRiskTemplateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRiskTemplate($id: uuid!, $deletedBy: uuid!) {
  deletedRiskTemplate: update_risk_templates_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()", deletedBy: $deletedBy}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteRiskTemplateMutation, DeleteRiskTemplateMutationVariables>;
export const GetRiskTemplateDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRiskTemplate($id: uuid!) {
  riskTemplates: risk_templates(
    where: {id: {_eq: $id}, deletedAt: {_is_null: true}}
  ) {
    id
    name
    categories {
      category {
        id
        name
      }
    }
    supplier {
      id
      name
      logoUrl
      website
      description
      state
    }
    riskTemplateOwners(where: {type: {_eq: OWNER}}) {
      user {
        id
        firstName
        lastName
        email
      }
    }
    treatmentAssignees(where: {type: {_eq: TREATMENT_ASSIGNEE}}) {
      user {
        id
        firstName
        lastName
        email
      }
    }
    inherentRiskProbability {
      id
      name
      score
    }
    inherentRiskImpact {
      id
      name
      score
    }
    inherentRiskMatrix {
      score
    }
    residualRiskProbability {
      id
      name
      score
    }
    residualRiskImpact {
      id
      name
      score
    }
    residualRiskMatrix {
      score
    }
    description
    treatmentType {
      id
      name
    }
    treatment
    deadline
    sendReminderDaysBefore
    stage {
      id
      name
    }
    createdAt
    updatedAt
  }
}
    `) as unknown as TypedDocumentString<GetRiskTemplateQuery, GetRiskTemplateQueryVariables>;
export const ListRiskTemplatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListRiskTemplates {
  riskTemplates: risk_templates(where: {deletedAt: {_is_null: true}}) {
    id
    name
    createdAt
    createdByUser {
      id
      firstName
      lastName
      email
    }
    updatedAt
    updatedByUser {
      id
      firstName
      lastName
      email
    }
    supplier {
      id
      name
      logoUrl
      state
    }
    categories {
      category {
        name
      }
    }
    treatmentType {
      name
    }
    riskTemplateOwners(where: {type: {_eq: OWNER}}) {
      user {
        id
        firstName
        lastName
        email
      }
    }
    treatmentAssignees(where: {type: {_eq: TREATMENT_ASSIGNEE}}) {
      user {
        id
        firstName
        lastName
        email
      }
    }
    inherentRiskProbability {
      id
      name
      score
    }
    inherentRiskImpact {
      id
      name
      score
    }
    inherentRiskMatrix {
      score
    }
    residualRiskProbability {
      id
      name
      score
    }
    residualRiskImpact {
      id
      name
      score
    }
    residualRiskMatrix {
      score
    }
    description
    treatment
    deadline
    sendReminderDaysBefore
    stage {
      name
    }
  }
}
    `) as unknown as TypedDocumentString<ListRiskTemplatesQuery, ListRiskTemplatesQueryVariables>;
export const UpdateRiskTemplateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRiskTemplate($riskTemplateId: uuid!, $input: risk_templates_set_input!) {
  updatedRiskTemplate: update_risk_templates_by_pk(
    pk_columns: {id: $riskTemplateId}
    _set: $input
  ) {
    ...RiskTemplateFields
  }
}
    fragment RiskTemplateFields on risk_templates {
  id
  createdAt
  updatedAt
  deletedAt
  organisationId
  createdBy
  updatedBy
  deletedBy
  orgSupplierId
  name
  description
  treatment
  sendReminderDaysBefore
  deadline
  inherentRiskProbabilityId
  inherentRiskImpactId
  residualRiskProbabilityId
  residualRiskImpactId
  stageId
  treatmentTypeId
}`) as unknown as TypedDocumentString<UpdateRiskTemplateMutation, UpdateRiskTemplateMutationVariables>;
export const InsertRiskVersionDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRiskVersion($input: risk_versions_insert_input!) {
  createdRiskVersion: insert_risk_versions_one(object: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertRiskVersionMutation, InsertRiskVersionMutationVariables>;
export const CreateSimpleOrganisationSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateSimpleOrganisationSupplier($id: uuid!, $name: String!, $remoteId: String!) {
  update_organisation_suppliers(
    where: {remoteId: {_eq: $remoteId}, state: {_eq: ARCHIVED}, deleted_at: {_is_null: true}}
    _set: {deleted_at: "now()"}
  ) {
    returning {
      id
    }
  }
  insert_organisation_suppliers_one(
    object: {id: $id, name: $name, remoteId: $remoteId}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateSimpleOrganisationSupplierMutation, CreateSimpleOrganisationSupplierMutationVariables>;
export const GetOrganisationSuppliersDataToTransferDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationSuppliersDataToTransfer($organisationSupplierIds: [uuid!]!, $targetOrganisationSupplierId: uuid!) {
  organisation_products_and_services(
    where: {organisationSupplierId: {_in: $organisationSupplierIds}}
  ) {
    id
    organisationSupplierId
  }
  requests(where: {request_supplier: {_in: $organisationSupplierIds}}) {
    id
    request_supplier
  }
  engagements(where: {organisationSupplierId: {_in: $organisationSupplierIds}}) {
    id
    organisationSupplierId
  }
  internal_contacts(where: {supplierId: {_in: $organisationSupplierIds}}) {
    id
    supplierId
  }
  documents(where: {organisationSupplierId: {_in: $organisationSupplierIds}}) {
    id
    organisationSupplierId
  }
  agreements(where: {supplierId: {_in: $organisationSupplierIds}}) {
    id
    supplierId
  }
  organisation_supplier_historic_submissions(
    where: {organisationSupplierId: {_in: $organisationSupplierIds}}
  ) {
    id
    organisationSupplierId
  }
  risks(where: {orgSupplierId: {_in: $organisationSupplierIds}}) {
    id
    orgSupplierId
  }
  risk_versions(where: {orgSupplierId: {_in: $organisationSupplierIds}}) {
    id
    orgSupplierId
  }
  organisation_supplier_tags(
    where: {organisationSupplierId: {_in: $organisationSupplierIds}, _not: {tag: {organisation_supplier_tags: {organisationSupplierId: {_eq: $targetOrganisationSupplierId}}}}}
  ) {
    id
    organisationSupplierId
  }
  assessments(where: {organisationSupplierId: {_in: $organisationSupplierIds}}) {
    id
    organisationSupplierId
  }
  purchase_orders(where: {supplierId: {_in: $organisationSupplierIds}}) {
    id
    supplierId
  }
  external_risk_scores(
    where: {organisationSupplierId: {_in: $organisationSupplierIds}}
  ) {
    id
    organisationSupplierId
  }
  entity_bank_details(
    where: {organisationSupplierId: {_in: $organisationSupplierIds}, bankDetails: {deleted_at: {_is_null: true}}}
  ) {
    id
    organisationSupplierId
    bankDetailsId
    isPrimary
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationSuppliersDataToTransferQuery, GetOrganisationSuppliersDataToTransferQueryVariables>;
export const ListOrganisationSupplierProfilesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListOrganisationSupplierProfiles($organisationSupplierIds: [uuid!]!) {
  organisation_supplier_profiles(
    where: {organisationSupplierId: {_in: $organisationSupplierIds}, deletedAt: {_is_null: true}}
  ) {
    id
    organisationSupplierId
    subsidiaryId
  }
}
    `) as unknown as TypedDocumentString<ListOrganisationSupplierProfilesQuery, ListOrganisationSupplierProfilesQueryVariables>;
export const MergeOrganisationSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation MergeOrganisationSuppliers($targetOrganisationSupplierId: uuid!, $targetOrganisationFieldsToApply: organisation_suppliers_set_input, $organisationSupplierIdsToArchive: [uuid!]!, $profileIds: [uuid!]!, $productAndServiceIds: [uuid!]!, $requestIds: [uuid!]!, $engagementIds: [uuid!]!, $internalContactIds: [uuid!]!, $documentIds: [uuid!]!, $agreementIds: [uuid!]!, $historicSubmissionIds: [uuid!]!, $riskIds: [uuid!]!, $riskVersionIds: [uuid!]!, $tagIds: [uuid!]!, $assessmentIds: [uuid!]!, $purchaseOrderIds: [uuid!]!, $externalRiskScoreIds: [uuid!], $bankAccountLinkIdsToDelete: [uuid!]!, $bankAccountLinksToInsert: [entity_bank_details_insert_input!]!) {
  update_organisation_suppliers_by_pk(
    pk_columns: {id: $targetOrganisationSupplierId}
    _set: $targetOrganisationFieldsToApply
  ) {
    id
  }
  update_organisation_suppliers(
    where: {id: {_in: $organisationSupplierIdsToArchive}}
    _set: {state: ARCHIVED}
  ) {
    returning {
      id
    }
  }
  update_organisation_products_and_services(
    where: {id: {_in: $productAndServiceIds}}
    _set: {organisationSupplierId: $targetOrganisationSupplierId}
  ) {
    returning {
      id
    }
  }
  update_requests(
    where: {id: {_in: $requestIds}}
    _set: {request_supplier: $targetOrganisationSupplierId}
  ) {
    returning {
      id
    }
  }
  update_organisation_supplier_profiles(
    where: {id: {_in: $profileIds}}
    _set: {organisationSupplierId: $targetOrganisationSupplierId}
  ) {
    returning {
      id
    }
  }
  delete_entity_bank_details(where: {id: {_in: $bankAccountLinkIdsToDelete}}) {
    affected_rows
  }
  insert_entity_bank_details(
    objects: $bankAccountLinksToInsert
    on_conflict: {constraint: unique_bank_details_supplier, update_columns: [isPrimary]}
  ) {
    returning {
      id
      bankDetailsId
    }
  }
  update_engagements(
    where: {id: {_in: $engagementIds}}
    _set: {organisationSupplierId: $targetOrganisationSupplierId}
  ) {
    returning {
      id
    }
  }
  update_internal_contacts(
    where: {id: {_in: $internalContactIds}}
    _set: {supplierId: $targetOrganisationSupplierId}
  ) {
    returning {
      id
    }
  }
  update_documents(
    where: {id: {_in: $documentIds}}
    _set: {organisationSupplierId: $targetOrganisationSupplierId}
  ) {
    returning {
      id
    }
  }
  update_agreements(
    where: {id: {_in: $agreementIds}}
    _set: {supplierId: $targetOrganisationSupplierId}
  ) {
    returning {
      id
    }
  }
  update_organisation_supplier_historic_submissions(
    where: {id: {_in: $historicSubmissionIds}}
    _set: {organisationSupplierId: $targetOrganisationSupplierId}
  ) {
    returning {
      id
    }
  }
  update_risks(
    where: {id: {_in: $riskIds}}
    _set: {orgSupplierId: $targetOrganisationSupplierId}
  ) {
    returning {
      id
    }
  }
  update_risk_versions(
    where: {id: {_in: $riskVersionIds}}
    _set: {orgSupplierId: $targetOrganisationSupplierId}
  ) {
    returning {
      id
    }
  }
  update_organisation_supplier_tags(
    where: {id: {_in: $tagIds}}
    _set: {organisationSupplierId: $targetOrganisationSupplierId}
  ) {
    returning {
      id
    }
  }
  update_assessments(
    where: {id: {_in: $assessmentIds}}
    _set: {organisationSupplierId: $targetOrganisationSupplierId}
  ) {
    returning {
      id
    }
  }
  update_purchase_orders(
    where: {id: {_in: $purchaseOrderIds}}
    _set: {supplierId: $targetOrganisationSupplierId}
  ) {
    returning {
      id
    }
  }
  update_external_risk_scores(
    where: {id: {_in: $externalRiskScoreIds}}
    _set: {organisationSupplierId: $targetOrganisationSupplierId}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<MergeOrganisationSuppliersMutation, MergeOrganisationSuppliersMutationVariables>;
export const UpdateSupplierIdOnSupplierProfilesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateSupplierIdOnSupplierProfiles($fromSupplierId: uuid!, $toSupplierId: uuid!, $subsidiaryIds: [uuid!]!) {
  update_organisation_supplier_profiles(
    _set: {organisationSupplierId: $toSupplierId}
    where: {organisationSupplierId: {_eq: $fromSupplierId}, subsidiaryId: {_in: $subsidiaryIds}}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UpdateSupplierIdOnSupplierProfilesMutation, UpdateSupplierIdOnSupplierProfilesMutationVariables>;
export const GetSupplierProfilesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierProfiles($supplierId: uuid!) {
  organisation_suppliers_by_pk(id: $supplierId) {
    id
    name
    organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      id
      remoteId
      remoteLink
      subsidiary {
        id
        name
      }
      state
      paymentMethod {
        id
        name
      }
      paymentTerm {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetSupplierProfilesQuery, GetSupplierProfilesQueryVariables>;
export const BulkUpdateOrganisationSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation BulkUpdateOrganisationSuppliers($updates: [organisation_suppliers_updates!]!) {
  update_organisation_suppliers_many(updates: $updates) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<BulkUpdateOrganisationSuppliersMutation, BulkUpdateOrganisationSuppliersMutationVariables>;
export const GetCustomFieldsAndValuesForSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFieldsAndValuesForSuppliers($organisationSupplierIds: [uuid!]!) {
  custom_fields(where: {entityType: {_eq: "supplier"}}) {
    id
    title
    type
    externalSource
    values(where: {entityId: {_in: $organisationSupplierIds}}) {
      id
      value
      booleanValue
      numberValue
      choice {
        id
        label
      }
      user {
        id
        firstName
        lastName
        email
      }
      customFieldCoreData {
        department {
          id
          name
          isArchived
        }
        paymentTerm {
          id
          name
          isArchived
        }
        paymentMethod {
          id
          name
          isArchived
        }
        subsidiary {
          id
          name
          isArchived
        }
        currency {
          id
          name
          code
          isArchived
        }
        lineItemType {
          id
          name
          isArchived
        }
        address {
          id
          name
          isArchived
        }
        customCoreDataOption {
          id
          customCoreDataId
          value
          isArchived
          isTerminal
        }
      }
      organisationSupplierId: entityId
    }
  }
}
    `) as unknown as TypedDocumentString<GetCustomFieldsAndValuesForSuppliersQuery, GetCustomFieldsAndValuesForSuppliersQueryVariables>;
export const GetEngagementDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetEngagement($id: uuid!) {
  engagements(where: {id: {_eq: $id}, deleted_at: {_is_null: true}}) {
    ...EngagementFragment
  }
}
    fragment EngagementFragment on engagements {
  id
  name
  department
  category
  supplierLegalEntity
  buyerLegalEntity
  description
  website
  created_at
  customFields
  note
  organisationSupplierId
  organisation_supplier {
    id
    name
    external_contacts(where: {deletedAt: {_is_null: true}}) {
      id
      firstName
      lastName
      email
      phoneNumber
      title
      isPrimary
    }
  }
  organisation_products_and_service {
    id
    name
  }
  financial {
    id
    amount
    contractPeriodStart
    contractPeriodEnd
    contractEnd
    subscriptionStart
    purchaseType
    paymentType
    paymentMethod
    paymentMethodId
    paymentInterval
    autoRenewal
    costCenter
    cancellationNoticeDays
    note
    fxRate
    currency
    purchaseDate
  }
}`) as unknown as TypedDocumentString<GetEngagementQuery, GetEngagementQueryVariables>;
export const GetEngagementIdsBySupplierIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetEngagementIdsBySupplierId($id: uuid!) {
  engagements(
    where: {organisationSupplierId: {_eq: $id}, deleted_at: {_is_null: true}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetEngagementIdsBySupplierIdQuery, GetEngagementIdsBySupplierIdQueryVariables>;
export const GetEngagementsBySupplierIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetEngagementsBySupplierId($id: uuid!) {
  engagements(
    where: {organisationSupplierId: {_eq: $id}, deleted_at: {_is_null: true}}
  ) {
    id
    name
    department
    product: organisation_products_and_service {
      id
      name
    }
    financial {
      id
      purchaseType
      contractPeriodStart
      contractPeriodEnd
      contractEnd
      subscriptionStart
      purchaseDate
      currency
      amount
      fxRate
    }
  }
}
    `) as unknown as TypedDocumentString<GetEngagementsBySupplierIdQuery, GetEngagementsBySupplierIdQueryVariables>;
export const GetGlobalSuppliersByDomainsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGlobalSuppliersByDomains($domains: [String!]!) {
  suppliers(where: {website: {_in: $domains}}) {
    id
    name
    website
  }
}
    `) as unknown as TypedDocumentString<GetGlobalSuppliersByDomainsQuery, GetGlobalSuppliersByDomainsQueryVariables>;
export const GetOrgSupplierFieldsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgSupplierFields($organisationSupplierIds: [uuid!]!) {
  organisation_suppliers(where: {id: {_in: $organisationSupplierIds}}) {
    id
    name
    website
    remoteId
    publicId
    address
    legalName
    taxNumber
    description
  }
}
    `) as unknown as TypedDocumentString<GetOrgSupplierFieldsQuery, GetOrgSupplierFieldsQueryVariables>;
export const GetOrgSuppliersForLinkingDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgSuppliersForLinking($ids: [uuid!]!) {
  organisation_suppliers(where: {id: {_in: $ids}}) {
    id
    name
    orgSupplierBrand: organisation_supplier_brand {
      id
      name
      supplierId
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrgSuppliersForLinkingQuery, GetOrgSuppliersForLinkingQueryVariables>;
export const GetRequestFormWithLatestSubmissionDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestFormWithLatestSubmission($formId: uuid!) {
  request_forms_by_pk(id: $formId) {
    id
    title
    config
    request {
      id
      publicId
      name
    }
    request_form_submissions(limit: 1, order_by: {submittedOn: desc_nulls_last}) {
      id
      response
      submittedOn
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestFormWithLatestSubmissionQuery, GetRequestFormWithLatestSubmissionQueryVariables>;
export const GetRequestsBySupplierIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestsBySupplierId($id: uuid!) {
  requests(where: {request_supplier: {_eq: $id}, deletedAt: {_is_null: true}}) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetRequestsBySupplierIdQuery, GetRequestsBySupplierIdQueryVariables>;
export const GetSupplierHistoricSubmissionDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierHistoricSubmission($submissionId: uuid!) {
  organisation_supplier_historic_submissions_by_pk(id: $submissionId) {
    id
    config
    response
    title
    submittedAt
    createdAt
    organisationSupplierId
  }
}
    `) as unknown as TypedDocumentString<GetSupplierHistoricSubmissionQuery, GetSupplierHistoricSubmissionQueryVariables>;
export const GetSupplierHistoricSubmissionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierHistoricSubmissions($supplierId: uuid!) {
  organisation_supplier_historic_submissions(
    where: {organisationSupplierId: {_eq: $supplierId}}
  ) {
    id
    title
    config
    response
    createdAt
    submittedAt
  }
}
    `) as unknown as TypedDocumentString<GetSupplierHistoricSubmissionsQuery, GetSupplierHistoricSubmissionsQueryVariables>;
export const GetSupplierSubmissionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierSubmissions($supplierId: uuid!) {
  request_forms(
    where: {request: {request_supplier: {_eq: $supplierId}}, type: {_eq: SUPPLIER_ONBOARDING}}
  ) {
    id
    title
    config
    request {
      id
      publicId
      name
    }
    request_form_submissions(limit: 1, order_by: {submittedOn: desc_nulls_last}) {
      id
      response
      submittedOn
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetSupplierSubmissionsQuery, GetSupplierSubmissionsQueryVariables>;
export const GetSuppliersByIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSuppliersByIds($ids: [uuid!]!) {
  suppliers(where: {id: {_in: $ids}}) {
    id
    name
    logoUrl
    website
  }
}
    `) as unknown as TypedDocumentString<GetSuppliersByIdsQuery, GetSuppliersByIdsQueryVariables>;
export const GetUnlinkedSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUnlinkedSuppliers {
  organisation_suppliers(
    where: {_or: [{organisationSupplierBrandId: {_is_null: true}}, {organisation_supplier_brand: {supplierId: {_is_null: true}}}]}
  ) {
    id
    name
    website
  }
}
    `) as unknown as TypedDocumentString<GetUnlinkedSuppliersQuery, GetUnlinkedSuppliersQueryVariables>;
export const InsertOrganisationSupplierBrandsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertOrganisationSupplierBrands($objects: [organisation_suppliers_brands_insert_input!]!) {
  insert_organisation_suppliers_brands(objects: $objects) {
    affected_rows
    returning {
      id
      name
      supplierId
      website
      logoUrl
      description
    }
  }
}
    `) as unknown as TypedDocumentString<InsertOrganisationSupplierBrandsMutation, InsertOrganisationSupplierBrandsMutationVariables>;
export const ListGlobalAndOrgSupplierBrandsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListGlobalAndOrgSupplierBrands($search: String, $limit: Int!) {
  organisation_suppliers_brands(where: {name: {_ilike: $search}}, limit: $limit) {
    id
    name
    description
    logoUrl
    supplierId
  }
  suppliers(
    where: {name: {_ilike: $search}, _not: {organisation_suppliers_brands: {}}}
    limit: $limit
  ) {
    id
    name
    description
    website
    logoUrl
  }
}
    `) as unknown as TypedDocumentString<ListGlobalAndOrgSupplierBrandsQuery, ListGlobalAndOrgSupplierBrandsQueryVariables>;
export const ListOrganisationSuppliersForUserMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListOrganisationSuppliersForUserMinimal($userId: uuid!) {
  organisation_suppliers(
    where: {deleted_at: {_is_null: true}, _or: [{internalContacts: {userId: {_eq: $userId}}}, {organisation_products_and_services: {businessOwnerId: {_eq: $userId}}}]}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<ListOrganisationSuppliersForUserMinimalQuery, ListOrganisationSuppliersForUserMinimalQueryVariables>;
export const FindSupplierByAssigneeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query FindSupplierByAssignee($userId: uuid!, $supplierId: uuid!) {
  internalOwnerSuppliers: organisation_suppliers(
    where: {id: {_eq: $supplierId}, deleted_at: {_is_null: true}, internalContacts: {userId: {_eq: $userId}}}
  ) {
    id
  }
  businessOwnerSuppliers: organisation_suppliers(
    where: {id: {_eq: $supplierId}, deleted_at: {_is_null: true}, organisation_products_and_services: {businessOwnerId: {_eq: $userId}}}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<FindSupplierByAssigneeQuery, FindSupplierByAssigneeQueryVariables>;
export const GetSupplierIdByEngagementIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierIdByEngagementId($id: uuid!) {
  engagements_by_pk(id: $id) {
    organisationSupplierId
  }
}
    `) as unknown as TypedDocumentString<GetSupplierIdByEngagementIdQuery, GetSupplierIdByEngagementIdQueryVariables>;
export const UpdateSupplierFieldsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateSupplierFields($id: uuid!, $input: organisation_suppliers_set_input!) {
  update_organisation_suppliers_by_pk(pk_columns: {id: $id}, _set: $input) {
    name
  }
}
    `) as unknown as TypedDocumentString<UpdateSupplierFieldsMutation, UpdateSupplierFieldsMutationVariables>;
export const UpdateSupplierCategoriesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateSupplierCategories($organisationSupplierId: uuid!, $categories: [organisation_suppliers_categories_insert_input!]!) {
  delete_organisation_suppliers_categories(
    where: {organisationSupplierId: {_eq: $organisationSupplierId}}
  ) {
    affected_rows
  }
  insert_organisation_suppliers_categories(objects: $categories) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UpdateSupplierCategoriesMutation, UpdateSupplierCategoriesMutationVariables>;
export const VectorSearchSuppliersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query VectorSearchSuppliers($search: vector!, $limit: Int) {
  vector_search_suppliers(args: {search: $search, result_limit: $limit}) {
    id
    name
    similarity
    website
  }
}
    `) as unknown as TypedDocumentString<VectorSearchSuppliersQuery, VectorSearchSuppliersQueryVariables>;
export const ListOrgProductsAndServicesMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListOrgProductsAndServicesMinimal {
  products: organisation_products_and_services(
    where: {isArchived: {_eq: false}, deleted_at: {_is_null: true}}
  ) {
    id
    name
    organisationSupplierId
  }
}
    `) as unknown as TypedDocumentString<ListOrgProductsAndServicesMinimalQuery, ListOrgProductsAndServicesMinimalQueryVariables>;
export const ListOrgSuppliersMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListOrgSuppliersMinimal {
  suppliers: organisation_suppliers(where: {deleted_at: {_is_null: true}}) {
    id
    name
    remoteId
  }
}
    `) as unknown as TypedDocumentString<ListOrgSuppliersMinimalQuery, ListOrgSuppliersMinimalQueryVariables>;
export const CreateHistoricSubmissionDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateHistoricSubmission($submission: organisation_supplier_historic_submissions_insert_input!) {
  insert_organisation_supplier_historic_submissions_one(object: $submission) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateHistoricSubmissionMutation, CreateHistoricSubmissionMutationVariables>;
export const ListDepartmentsMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListDepartmentsMinimal($query: departments_bool_exp) {
  departments(where: $query, order_by: {name: asc}) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<ListDepartmentsMinimalQuery, ListDepartmentsMinimalQueryVariables>;
export const ListEngagementsMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListEngagementsMinimal {
  engagements(where: {deleted_at: {_is_null: true}}) {
    id
    name
    organisationSupplierId
    financial {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<ListEngagementsMinimalQuery, ListEngagementsMinimalQueryVariables>;
export const UpdateEngagementDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateEngagement($id: uuid!, $update: engagements_set_input!) {
  updatedEngagement: update_engagements_by_pk(
    pk_columns: {id: $id}
    _set: $update
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateEngagementMutation, UpdateEngagementMutationVariables>;
export const UpdateFinancialsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateFinancials($id: uuid!, $update: financials_set_input!) {
  updatedFinancials: update_financials_by_pk(pk_columns: {id: $id}, _set: $update) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateFinancialsMutation, UpdateFinancialsMutationVariables>;
export const UpsertExternalContactsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertExternalContacts($supplierId: uuid!, $objects: [external_contacts_insert_input!]!) {
  deletedContacts: delete_external_contacts(
    where: {supplierId: {_eq: $supplierId}}
  ) {
    returning {
      id
    }
  }
  insertedContacts: insert_external_contacts(objects: $objects) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpsertExternalContactsMutation, UpsertExternalContactsMutationVariables>;
export const UpsertInternalContactsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertInternalContacts($supplierId: uuid!, $objects: [internal_contacts_insert_input!]!) {
  deletedContacts: delete_internal_contacts(
    where: {supplierId: {_eq: $supplierId}}
  ) {
    returning {
      id
    }
  }
  insertedContacts: insert_internal_contacts(objects: $objects) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpsertInternalContactsMutation, UpsertInternalContactsMutationVariables>;
export const GetPaymentMethodsMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetPaymentMethodsMinimal($query: payment_methods_bool_exp) {
  paymentMethods: payment_methods(where: $query, order_by: {name: asc}) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<GetPaymentMethodsMinimalQuery, GetPaymentMethodsMinimalQueryVariables>;
export const ListSubsidiariesMinimalDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListSubsidiariesMinimal($query: subsidiaries_bool_exp) {
  subsidiaries(where: $query, order_by: {name: asc}) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<ListSubsidiariesMinimalQuery, ListSubsidiariesMinimalQueryVariables>;
export const UpsertSupplierTagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpsertSupplierTags($supplierId: uuid!, $objects: [organisation_supplier_tags_insert_input!]!) {
  deletedTags: delete_organisation_supplier_tags(
    where: {organisationSupplierId: {_eq: $supplierId}}
  ) {
    returning {
      id
    }
  }
  insertedTags: insert_organisation_supplier_tags(objects: $objects) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<UpsertSupplierTagsMutation, UpsertSupplierTagsMutationVariables>;
export const AssignSupplierForOwnershipDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation AssignSupplierForOwnership($id: uuid!, $integrationId: uuid!) {
  update_organisation_suppliers_by_pk(
    pk_columns: {id: $id}
    _set: {organisationIntegrationId: $integrationId}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<AssignSupplierForOwnershipMutation, AssignSupplierForOwnershipMutationVariables>;
export const GetBankAccountForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBankAccountForRepository($where: bank_details_bool_exp!) {
  bankAccounts: bank_details(where: $where, limit: 1) {
    ...BankAccountForRepository
  }
  customFieldSchema: custom_fields(where: {entityType: {_eq: "bank-account"}}) {
    ...CustomFieldSchemaForRepository
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment BankAccountForRepository on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    id
    remoteId
    code
    name
  }
  address {
    id
    remoteId
    addressLine1
    addressLine2
    city
    state
    postalCode
    county
    country
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment CustomFieldSchemaForRepository on custom_fields {
  id
  type
  externalSource
  customCoreDataId
  remoteId
  key
  title
  choices {
    id
    label
  }
}`) as unknown as TypedDocumentString<GetBankAccountForRepositoryQuery, GetBankAccountForRepositoryQueryVariables>;
export const GetAddressForBankAccountDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAddressForBankAccount($addressId: uuid!) {
  addresses(where: {isArchived: {_eq: false}, id: {_eq: $addressId}}) {
    id
    country
  }
}
    `) as unknown as TypedDocumentString<GetAddressForBankAccountQuery, GetAddressForBankAccountQueryVariables>;
export const LinkBankAccountForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation LinkBankAccountForRepository($bankAccountInput: bank_details_insert_input!, $bankAccountId: uuid!, $entityId: uuid!, $shouldInsertBankAccount: Boolean!, $shouldLinkSupplier: Boolean!, $shouldLinkSupplierProfile: Boolean!, $isPrimary: Boolean = null, $shouldDemotePrimaryForSupplier: Boolean!, $shouldDemotePrimaryForProfile: Boolean!) {
  demotePrimaryFromSupplier: update_entity_bank_details(
    where: {_and: [{bankDetailsId: {_neq: $bankAccountId}}, {isPrimary: {_eq: true}}, {organisationSupplierId: {_eq: $entityId}}]}
    _set: {isPrimary: false}
  ) @include(if: $shouldDemotePrimaryForSupplier) {
    affected_rows
  }
  demotePrimaryFromProfile: update_entity_bank_details(
    where: {_and: [{bankDetailsId: {_neq: $bankAccountId}}, {isPrimary: {_eq: true}}, {organisationSupplierProfileId: {_eq: $entityId}}]}
    _set: {isPrimary: false}
  ) @include(if: $shouldDemotePrimaryForProfile) {
    affected_rows
  }
  insertedBankAccount: insert_bank_details_one(object: $bankAccountInput) @include(if: $shouldInsertBankAccount) {
    ...BankAccountForRepository
  }
  insertedEntityBankDetailsFromSupplier: insert_entity_bank_details_one(
    object: {bankDetailsId: $bankAccountId, organisationSupplierId: $entityId, organisationSupplierProfileId: null, isPrimary: $isPrimary}
    on_conflict: {constraint: unique_bank_details_supplier, update_columns: [isPrimary]}
  ) @include(if: $shouldLinkSupplier) {
    id
    isPrimary
    bankDetails {
      ...BankAccountForRepository
    }
  }
  insertedEntityBankDetailsFromSupplierProfile: insert_entity_bank_details_one(
    object: {bankDetailsId: $bankAccountId, organisationSupplierId: null, organisationSupplierProfileId: $entityId, isPrimary: $isPrimary}
    on_conflict: {constraint: unique_bank_details_supplier_profile, update_columns: [isPrimary]}
  ) @include(if: $shouldLinkSupplierProfile) {
    id
    isPrimary
    bankDetails {
      ...BankAccountForRepository
    }
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment BankAccountForRepository on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    id
    remoteId
    code
    name
  }
  address {
    id
    remoteId
    addressLine1
    addressLine2
    city
    state
    postalCode
    county
    country
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}`) as unknown as TypedDocumentString<LinkBankAccountForRepositoryMutation, LinkBankAccountForRepositoryMutationVariables>;
export const ListBankAccountsForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListBankAccountsForRepository($limit: Int!, $where: entity_bank_details_bool_exp!, $orderBy: [entity_bank_details_order_by!]!) {
  entityBankDetails: entity_bank_details(
    where: $where
    limit: $limit
    order_by: $orderBy
  ) {
    id
    isPrimary
    bankDetails {
      ...BankAccountForRepository
    }
  }
  customFieldSchema: custom_fields(where: {entityType: {_eq: "bank-details"}}) {
    ...CustomFieldSchemaForRepository
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment BankAccountForRepository on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    id
    remoteId
    code
    name
  }
  address {
    id
    remoteId
    addressLine1
    addressLine2
    city
    state
    postalCode
    county
    country
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}
fragment CustomFieldSchemaForRepository on custom_fields {
  id
  type
  externalSource
  customCoreDataId
  remoteId
  key
  title
  choices {
    id
    label
  }
}`) as unknown as TypedDocumentString<ListBankAccountsForRepositoryQuery, ListBankAccountsForRepositoryQueryVariables>;
export const UnlinkBankAccountFromEntityDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnlinkBankAccountFromEntity($bankAccountId: uuid!, $entityId: uuid!, $shouldUnlinkFromSupplier: Boolean!, $shouldUnlinkFromSupplierProfile: Boolean!) {
  deletedEntitiesBankDetailsFromSupplier: delete_entity_bank_details(
    where: {bankDetailsId: {_eq: $bankAccountId}, organisationSupplierId: {_eq: $entityId}}
  ) @include(if: $shouldUnlinkFromSupplier) {
    affected_rows
  }
  deletedEntitiesBankDetailsFromSupplierProfile: delete_entity_bank_details(
    where: {bankDetailsId: {_eq: $bankAccountId}, organisationSupplierProfileId: {_eq: $entityId}}
  ) @include(if: $shouldUnlinkFromSupplierProfile) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UnlinkBankAccountFromEntityMutation, UnlinkBankAccountFromEntityMutationVariables>;
export const UpdateBankAccountForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateBankAccountForRepository($id: uuid!, $_set: bank_details_set_input!) {
  bankAccount: update_bank_details_by_pk(pk_columns: {id: $id}, _set: $_set) {
    ...BankAccountForRepository
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment BankAccountForRepository on bank_details {
  id
  accountName
  remoteId
  bankName
  accountNumber
  sortCode
  iban
  swiftCode
  code
  country
  isActive
  createdAt
  updatedAt
  deleted_at
  currency {
    id
    remoteId
    code
    name
  }
  address {
    id
    remoteId
    addressLine1
    addressLine2
    city
    state
    postalCode
    county
    country
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}`) as unknown as TypedDocumentString<UpdateBankAccountForRepositoryMutation, UpdateBankAccountForRepositoryMutationVariables>;
export const CreateOrganisationSuppliersForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateOrganisationSuppliersForRepository($suppliers: [organisation_suppliers_insert_input!]!, $externalContacts: [external_contacts_insert_input!]!, $shouldInsertExternalContacts: Boolean!) {
  suppliers: insert_organisation_suppliers(
    objects: $suppliers
    on_conflict: {constraint: organisation_suppliers_pkey1, update_columns: []}
  ) {
    affected_rows
    returning {
      ...OrgSupplierForRepository
    }
  }
  insert_external_contacts(
    objects: $externalContacts
    on_conflict: {constraint: external_contacts_pkey, update_columns: []}
  ) @include(if: $shouldInsertExternalContacts) {
    affected_rows
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment OrgSupplierForRepository on organisation_suppliers {
  id
  deleted_at
  name
  legalName
  state
  website
  description
  isReseller
  isPerson
  isPreferred
  taxNumber
  createdAt
  updated_at
  remoteId
  remoteLink
  publicId
  paymentMethod {
    id
    name
    remoteId
  }
  paymentTerms {
    id
    name
    remoteId
  }
  address
  customFieldValues {
    ...CustomFieldValueFragment
  }
  organisationIntegration {
    name
    id
    integration
  }
  organisation_supplier_tags(where: {tag: {deletedAt: {_is_null: true}}}) {
    tag {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<CreateOrganisationSuppliersForRepositoryMutation, CreateOrganisationSuppliersForRepositoryMutationVariables>;
export const GetCustomFieldSchemaForEntityTypeDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetCustomFieldSchemaForEntityType($entityType: String!) {
  custom_fields(where: {entityType: {_eq: $entityType}}) {
    ...CustomFieldSchemaForRepository
  }
}
    fragment CustomFieldSchemaForRepository on custom_fields {
  id
  type
  externalSource
  customCoreDataId
  remoteId
  key
  title
  choices {
    id
    label
  }
}`) as unknown as TypedDocumentString<GetCustomFieldSchemaForEntityTypeQuery, GetCustomFieldSchemaForEntityTypeQueryVariables>;
export const CreateExternalContactsForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateExternalContactsForRepository($objects: [external_contacts_insert_input!]!) {
  insert_external_contacts(objects: $objects) {
    affected_rows
    returning {
      ...ExternalContactForRepository
    }
  }
}
    fragment ExternalContactForRepository on external_contacts {
  id
  email
  firstName
  lastName
  title
  userId
  deletedAt
  phoneNumber
  isPrimary
  createdAt
  updatedAt
}`) as unknown as TypedDocumentString<CreateExternalContactsForRepositoryMutation, CreateExternalContactsForRepositoryMutationVariables>;
export const DeleteExternalContactByIdForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteExternalContactByIdForRepository($id: uuid!) {
  deleted: update_external_contacts_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()", isPrimary: false}
  ) {
    ...ExternalContactForRepository
  }
}
    fragment ExternalContactForRepository on external_contacts {
  id
  email
  firstName
  lastName
  title
  userId
  deletedAt
  phoneNumber
  isPrimary
  createdAt
  updatedAt
}`) as unknown as TypedDocumentString<DeleteExternalContactByIdForRepositoryMutation, DeleteExternalContactByIdForRepositoryMutationVariables>;
export const GetExternalContactByIdForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetExternalContactByIdForRepository($id: uuid!) {
  externalContact: external_contacts_by_pk(id: $id) {
    ...ExternalContactForRepository
    supplier: organisation_supplier {
      id
      remoteId
      isPerson
      deleted_at
    }
  }
}
    fragment ExternalContactForRepository on external_contacts {
  id
  email
  firstName
  lastName
  title
  userId
  deletedAt
  phoneNumber
  isPrimary
  createdAt
  updatedAt
}`) as unknown as TypedDocumentString<GetExternalContactByIdForRepositoryQuery, GetExternalContactByIdForRepositoryQueryVariables>;
export const ListExternalContactsForSupplierForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListExternalContactsForSupplierForRepository($limit: Int!, $orderBy: [external_contacts_order_by!]!, $where: external_contacts_bool_exp) {
  externalContacts: external_contacts(
    where: $where
    limit: $limit
    order_by: $orderBy
  ) {
    ...ExternalContactForRepository
  }
}
    fragment ExternalContactForRepository on external_contacts {
  id
  email
  firstName
  lastName
  title
  userId
  deletedAt
  phoneNumber
  isPrimary
  createdAt
  updatedAt
}`) as unknown as TypedDocumentString<ListExternalContactsForSupplierForRepositoryQuery, ListExternalContactsForSupplierForRepositoryQueryVariables>;
export const UpdateExternalContactsForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateExternalContactsForRepository($updates: [external_contacts_updates!]!) {
  updatedExternalContacts: update_external_contacts_many(updates: $updates) {
    affected_rows
    returning {
      ...ExternalContactForRepository
    }
  }
}
    fragment ExternalContactForRepository on external_contacts {
  id
  email
  firstName
  lastName
  title
  userId
  deletedAt
  phoneNumber
  isPrimary
  createdAt
  updatedAt
}`) as unknown as TypedDocumentString<UpdateExternalContactsForRepositoryMutation, UpdateExternalContactsForRepositoryMutationVariables>;
export const GetOrgSupplierByIdForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgSupplierByIdForRepository($where: organisation_suppliers_bool_exp!) {
  organisation_suppliers(where: $where, limit: 1) {
    ...OrgSupplierForRepository
    totalSpend
  }
  custom_fields(where: {entityType: {_eq: "supplier"}}) {
    ...CustomFieldSchemaForRepository
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment CustomFieldSchemaForRepository on custom_fields {
  id
  type
  externalSource
  customCoreDataId
  remoteId
  key
  title
  choices {
    id
    label
  }
}
fragment OrgSupplierForRepository on organisation_suppliers {
  id
  deleted_at
  name
  legalName
  state
  website
  description
  isReseller
  isPerson
  isPreferred
  taxNumber
  createdAt
  updated_at
  remoteId
  remoteLink
  publicId
  paymentMethod {
    id
    name
    remoteId
  }
  paymentTerms {
    id
    name
    remoteId
  }
  address
  customFieldValues {
    ...CustomFieldValueFragment
  }
  organisationIntegration {
    name
    id
    integration
  }
  organisation_supplier_tags(where: {tag: {deletedAt: {_is_null: true}}}) {
    tag {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<GetOrgSupplierByIdForRepositoryQuery, GetOrgSupplierByIdForRepositoryQueryVariables>;
export const GetSupplierOverviewFieldsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierOverviewFields($id: uuid!) {
  orgSupplier: organisation_suppliers_by_pk(id: $id) {
    id
    organisationIntegration {
      id
      name
      integration
    }
    name
    legalName
    remoteId
    remoteLink
    website
    description
    legalName
    isPreferred
    isReseller
    isContinuousMonitoringEnabled
    isPerson
    taxNumber
    address
    paymentMethod {
      id
      name
    }
    lastAssessmentDate
    totalSpend
    supplierTags: organisation_supplier_tags(
      where: {tag: {deletedAt: {_is_null: true}}}
    ) {
      id
      tag {
        id
        name
      }
    }
    engagements(where: {deleted_at: {_is_null: true}}) {
      id
      department
      financial {
        id
        costCenter
      }
    }
    agreements(where: {deletedAt: {_is_null: true}}) {
      id
      agreement_terms {
        primaryDepartment {
          name
        }
      }
    }
    categoryIds: organisation_suppliers_categories {
      productSupplierCategoryId
    }
    risks(where: {deletedAt: {_is_null: true}}, limit: 1) {
      id
    }
    profiles: organisationSupplierProfiles(where: {deletedAt: {_is_null: true}}) {
      subsidiary {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetSupplierOverviewFieldsQuery, GetSupplierOverviewFieldsQueryVariables>;
export const CreateInternalContactsForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateInternalContactsForRepository($objects: [internal_contacts_insert_input!]!) {
  insert_internal_contacts(objects: $objects) {
    affected_rows
    returning {
      ...InternalContactForRepository
    }
  }
}
    fragment InternalContactForRepository on internal_contacts {
  id
  role
  title
  supplierId
  deleted_at
  createdAt
  updatedAt
  user {
    id
    email
    firstName
    lastName
  }
}`) as unknown as TypedDocumentString<CreateInternalContactsForRepositoryMutation, CreateInternalContactsForRepositoryMutationVariables>;
export const DeleteInternalContactByIdForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteInternalContactByIdForRepository($id: uuid!, $supplierId: uuid!) {
  deleted: update_internal_contacts(
    where: {id: {_eq: $id}, supplierId: {_eq: $supplierId}}
    _set: {deleted_at: "now()"}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteInternalContactByIdForRepositoryMutation, DeleteInternalContactByIdForRepositoryMutationVariables>;
export const GetInternalContactByIdForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetInternalContactByIdForRepository($id: uuid!) {
  internalContact: internal_contacts_by_pk(id: $id) {
    ...InternalContactForRepository
    supplier {
      id
      remoteId
      deleted_at
    }
  }
}
    fragment InternalContactForRepository on internal_contacts {
  id
  role
  title
  supplierId
  deleted_at
  createdAt
  updatedAt
  user {
    id
    email
    firstName
    lastName
  }
}`) as unknown as TypedDocumentString<GetInternalContactByIdForRepositoryQuery, GetInternalContactByIdForRepositoryQueryVariables>;
export const ListInternalContactsForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListInternalContactsForRepository($where: internal_contacts_bool_exp!, $orderBy: [internal_contacts_order_by!]!, $limit: Int!) {
  internalContacts: internal_contacts(
    where: $where
    order_by: $orderBy
    limit: $limit
  ) {
    ...InternalContactForRepository
  }
}
    fragment InternalContactForRepository on internal_contacts {
  id
  role
  title
  supplierId
  deleted_at
  createdAt
  updatedAt
  user {
    id
    email
    firstName
    lastName
  }
}`) as unknown as TypedDocumentString<ListInternalContactsForRepositoryQuery, ListInternalContactsForRepositoryQueryVariables>;
export const UpdateInternalContactForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateInternalContactForRepository($id: uuid!, $_set: internal_contacts_set_input!) {
  update_internal_contacts_by_pk(pk_columns: {id: $id}, _set: $_set) {
    ...InternalContactForRepository
  }
}
    fragment InternalContactForRepository on internal_contacts {
  id
  role
  title
  supplierId
  deleted_at
  createdAt
  updatedAt
  user {
    id
    email
    firstName
    lastName
  }
}`) as unknown as TypedDocumentString<UpdateInternalContactForRepositoryMutation, UpdateInternalContactForRepositoryMutationVariables>;
export const ListOrgSuppliersForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListOrgSuppliersForRepository($limit: Int!, $orderBy: [organisation_suppliers_order_by!]!, $where: organisation_suppliers_bool_exp) {
  suppliers: organisation_suppliers(
    where: $where
    limit: $limit
    order_by: $orderBy
  ) {
    ...OrgSupplierForRepository
    totalSpend
  }
  custom_fields(where: {entityType: {_eq: "supplier"}}) {
    ...CustomFieldSchemaForRepository
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment CustomFieldSchemaForRepository on custom_fields {
  id
  type
  externalSource
  customCoreDataId
  remoteId
  key
  title
  choices {
    id
    label
  }
}
fragment OrgSupplierForRepository on organisation_suppliers {
  id
  deleted_at
  name
  legalName
  state
  website
  description
  isReseller
  isPerson
  isPreferred
  taxNumber
  createdAt
  updated_at
  remoteId
  remoteLink
  publicId
  paymentMethod {
    id
    name
    remoteId
  }
  paymentTerms {
    id
    name
    remoteId
  }
  address
  customFieldValues {
    ...CustomFieldValueFragment
  }
  organisationIntegration {
    name
    id
    integration
  }
  organisation_supplier_tags(where: {tag: {deletedAt: {_is_null: true}}}) {
    tag {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<ListOrgSuppliersForRepositoryQuery, ListOrgSuppliersForRepositoryQueryVariables>;
export const CreateSupplierProfilesForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateSupplierProfilesForRepository($objects: [organisation_supplier_profiles_insert_input!]!) {
  insert_organisation_supplier_profiles(
    objects: $objects
    on_conflict: {constraint: uniq_subsidiary_id_organisation_supplier_id_deleted_at, update_columns: []}
  ) {
    returning {
      ...SupplierProfileForRepository
    }
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment SupplierProfileForRepository on organisation_supplier_profiles {
  id
  remoteId
  remoteLink
  subsidiaryId
  state
  createdAt
  updatedAt
  subsidiary {
    id
    name
    remoteId
  }
  paymentMethod {
    id
    name
    remoteId
  }
  paymentTerm {
    id
    name
    remoteId
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}`) as unknown as TypedDocumentString<CreateSupplierProfilesForRepositoryMutation, CreateSupplierProfilesForRepositoryMutationVariables>;
export const DeleteSupplierProfileBySubsidiaryIdForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteSupplierProfileBySubsidiaryIdForRepository($id: uuid!) {
  update_organisation_supplier_profiles(
    where: {id: {_eq: $id}}
    _set: {deletedAt: "now()"}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteSupplierProfileBySubsidiaryIdForRepositoryMutation, DeleteSupplierProfileBySubsidiaryIdForRepositoryMutationVariables>;
export const GetSupplierProfileBySubsidiaryIdForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierProfileBySubsidiaryIdForRepository($where: organisation_supplier_profiles_bool_exp!) {
  organisation_supplier_profiles(where: $where, limit: 1) {
    ...SupplierProfileForRepository
  }
  custom_fields(where: {entityType: {_eq: "supplier-profile"}}) {
    ...CustomFieldSchemaForRepository
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment CustomFieldSchemaForRepository on custom_fields {
  id
  type
  externalSource
  customCoreDataId
  remoteId
  key
  title
  choices {
    id
    label
  }
}
fragment SupplierProfileForRepository on organisation_supplier_profiles {
  id
  remoteId
  remoteLink
  subsidiaryId
  state
  createdAt
  updatedAt
  subsidiary {
    id
    name
    remoteId
  }
  paymentMethod {
    id
    name
    remoteId
  }
  paymentTerm {
    id
    name
    remoteId
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}`) as unknown as TypedDocumentString<GetSupplierProfileBySubsidiaryIdForRepositoryQuery, GetSupplierProfileBySubsidiaryIdForRepositoryQueryVariables>;
export const GetSupplierProfilesForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierProfilesForRepository($where: organisation_supplier_profiles_bool_exp!) {
  organisation_supplier_profiles(where: $where) {
    id
    deletedAt
  }
}
    `) as unknown as TypedDocumentString<GetSupplierProfilesForRepositoryQuery, GetSupplierProfilesForRepositoryQueryVariables>;
export const ListSupplierProfilesForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListSupplierProfilesForRepository($limit: Int!, $where: organisation_supplier_profiles_bool_exp!, $orderBy: [organisation_supplier_profiles_order_by!]!) {
  organisation_supplier_profiles(where: $where, limit: $limit, order_by: $orderBy) {
    ...SupplierProfileForRepository
  }
  custom_fields(where: {entityType: {_eq: "supplier-profile"}}) {
    ...CustomFieldSchemaForRepository
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment CustomFieldSchemaForRepository on custom_fields {
  id
  type
  externalSource
  customCoreDataId
  remoteId
  key
  title
  choices {
    id
    label
  }
}
fragment SupplierProfileForRepository on organisation_supplier_profiles {
  id
  remoteId
  remoteLink
  subsidiaryId
  state
  createdAt
  updatedAt
  subsidiary {
    id
    name
    remoteId
  }
  paymentMethod {
    id
    name
    remoteId
  }
  paymentTerm {
    id
    name
    remoteId
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}`) as unknown as TypedDocumentString<ListSupplierProfilesForRepositoryQuery, ListSupplierProfilesForRepositoryQueryVariables>;
export const UpdateSupplierProfileForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateSupplierProfileForRepository($id: uuid!, $object: organisation_supplier_profiles_set_input) {
  updatedProfile: update_organisation_supplier_profiles_by_pk(
    pk_columns: {id: $id}
    _set: $object
  ) {
    ...SupplierProfileForRepository
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment SupplierProfileForRepository on organisation_supplier_profiles {
  id
  remoteId
  remoteLink
  subsidiaryId
  state
  createdAt
  updatedAt
  subsidiary {
    id
    name
    remoteId
  }
  paymentMethod {
    id
    name
    remoteId
  }
  paymentTerm {
    id
    name
    remoteId
  }
  customFieldValues {
    ...CustomFieldValueFragment
  }
}`) as unknown as TypedDocumentString<UpdateSupplierProfileForRepositoryMutation, UpdateSupplierProfileForRepositoryMutationVariables>;
export const GetValueReferenceIdsByNonIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetValueReferenceIdsByNonIds($paymentMethodRemoteIds: [String!]!, $paymentTermsIds: [String!]!, $departmentRemoteIds: [String!]!, $currencyRemoteIds: [String!]!, $lineItemTypeRemoteIds: [String!]!, $subsidiaryRemoteIds: [String!]!, $addressRemoteIds: [String!]!, $customCoreDataOptionRemoteIds: [String!]!, $userEmails: [String!]!) {
  paymentMethods: payment_methods(
    where: {remoteId: {_in: $paymentMethodRemoteIds}, isArchived: {_eq: false}}
  ) {
    id
    remoteId
  }
  paymentTerms: payment_terms(
    where: {remoteId: {_in: $paymentTermsIds}, isArchived: {_eq: false}}
  ) {
    id
    remoteId
  }
  departments: departments(
    where: {remoteId: {_in: $departmentRemoteIds}, isArchived: {_eq: false}}
  ) {
    id
    remoteId
  }
  currencies: organisation_fx_rates(
    where: {remoteId: {_in: $currencyRemoteIds}, isArchived: {_eq: false}}
  ) {
    id
    remoteId
  }
  lineItemTypes: line_item_types(
    where: {remoteId: {_in: $lineItemTypeRemoteIds}, isArchived: {_eq: false}}
  ) {
    id
    remoteId
  }
  subsidiaries: subsidiaries(
    where: {remoteId: {_in: $subsidiaryRemoteIds}, isArchived: {_eq: false}}
  ) {
    id
    remoteId
  }
  addresses: addresses(
    where: {remoteId: {_in: $addressRemoteIds}, isArchived: {_eq: false}}
  ) {
    id
    remoteId
  }
  customCoreDataOptions: custom_core_data_options(
    where: {remoteId: {_in: $customCoreDataOptionRemoteIds}, isArchived: {_eq: false}}
  ) {
    id
    remoteId
  }
  users: users(where: {email: {_in: $userEmails}, deletedAt: {_is_null: true}}) {
    id
    email
  }
}
    `) as unknown as TypedDocumentString<GetValueReferenceIdsByNonIdsQuery, GetValueReferenceIdsByNonIdsQueryVariables>;
export const CreateSupplierSubsidiariesForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateSupplierSubsidiariesForRepository($objects: [organisation_supplier_profiles_insert_input!]!) {
  insert_organisation_supplier_profiles(objects: $objects) {
    returning {
      ...SupplierSubsidiaryForRepository
    }
  }
}
    fragment SupplierSubsidiaryForRepository on organisation_supplier_profiles {
  id
  subsidiaryId
  subsidiary {
    id
    name
    remoteId
  }
}`) as unknown as TypedDocumentString<CreateSupplierSubsidiariesForRepositoryMutation, CreateSupplierSubsidiariesForRepositoryMutationVariables>;
export const DeleteSupplierSubsidiaryByIdForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteSupplierSubsidiaryByIdForRepository($id: uuid!) {
  update_organisation_supplier_profiles(
    where: {id: {_eq: $id}}
    _set: {deletedAt: "now()"}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteSupplierSubsidiaryByIdForRepositoryMutation, DeleteSupplierSubsidiaryByIdForRepositoryMutationVariables>;
export const GetSubsidiaryIdsFromRemoteIdsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSubsidiaryIdsFromRemoteIds($remoteIds: [String!]!) {
  subsidiaries(where: {remoteId: {_in: $remoteIds}, isArchived: {_eq: false}}) {
    remoteId
    id
  }
}
    `) as unknown as TypedDocumentString<GetSubsidiaryIdsFromRemoteIdsQuery, GetSubsidiaryIdsFromRemoteIdsQueryVariables>;
export const GetSupplierSubsidiariesForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierSubsidiariesForRepository($where: organisation_supplier_profiles_bool_exp!) {
  organisation_supplier_profiles(where: $where) {
    id
    deletedAt
  }
}
    `) as unknown as TypedDocumentString<GetSupplierSubsidiariesForRepositoryQuery, GetSupplierSubsidiariesForRepositoryQueryVariables>;
export const ListSupplierSubsidiariesForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ListSupplierSubsidiariesForRepository($limit: Int!, $where: organisation_supplier_profiles_bool_exp!, $orderBy: [organisation_supplier_profiles_order_by!]!) {
  organisation_supplier_profiles(where: $where, limit: $limit, order_by: $orderBy) {
    ...SupplierSubsidiaryForRepository
  }
}
    fragment SupplierSubsidiaryForRepository on organisation_supplier_profiles {
  id
  subsidiaryId
  subsidiary {
    id
    name
    remoteId
  }
}`) as unknown as TypedDocumentString<ListSupplierSubsidiariesForRepositoryQuery, ListSupplierSubsidiariesForRepositoryQueryVariables>;
export const GetSupplierProfileForValidationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetSupplierProfileForValidation($profileId: uuid!, $supplierId: uuid!) {
  organisation_supplier_profiles(
    where: {id: {_eq: $profileId}, organisationSupplierId: {_eq: $supplierId}}
    limit: 1
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetSupplierProfileForValidationQuery, GetSupplierProfileForValidationQueryVariables>;
export const UpdateSupplierForRepositoryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateSupplierForRepository($id: uuid!, $object: organisation_suppliers_set_input) {
  updatedSupplier: update_organisation_suppliers_by_pk(
    pk_columns: {id: $id}
    _set: $object
  ) {
    ...OrgSupplierForRepository
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment OrgSupplierForRepository on organisation_suppliers {
  id
  deleted_at
  name
  legalName
  state
  website
  description
  isReseller
  isPerson
  isPreferred
  taxNumber
  createdAt
  updated_at
  remoteId
  remoteLink
  publicId
  paymentMethod {
    id
    name
    remoteId
  }
  paymentTerms {
    id
    name
    remoteId
  }
  address
  customFieldValues {
    ...CustomFieldValueFragment
  }
  organisationIntegration {
    name
    id
    integration
  }
  organisation_supplier_tags(where: {tag: {deletedAt: {_is_null: true}}}) {
    tag {
      id
      name
    }
  }
}`) as unknown as TypedDocumentString<UpdateSupplierForRepositoryMutation, UpdateSupplierForRepositoryMutationVariables>;
export const GetOrgFxRatesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgFxRates {
  organisation_fx_rates(where: {isArchived: {_eq: false}}) {
    id
    code
    fxRate
  }
}
    `) as unknown as TypedDocumentString<GetOrgFxRatesQuery, GetOrgFxRatesQueryVariables>;
export const GetRequestByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestById($requestId: uuid!) {
  request: requests_by_pk(id: $requestId) {
    id
    name
    requestor: user {
      id
      firstName
      lastName
    }
    organisation {
      id
      name
      logoUrlLight
      isQa
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestByIdQuery, GetRequestByIdQueryVariables>;
export const GetRequestSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestSupplier($requestId: uuid!) {
  request: requests_by_pk(id: $requestId) {
    id
    renewal {
      id
      renewalDate
      product {
        id
        name: displayName
      }
    }
    model
    name
    user {
      id
      firstName
      lastName
    }
    organisation {
      id
      name
    }
    workflow {
      id
      title
      type
    }
    supplier {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestSupplierQuery, GetRequestSupplierQueryVariables>;
export const GetTagsByOrganisationSupplierIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetTagsByOrganisationSupplierId($organisationSupplierId: uuid!) {
  supplier: organisation_suppliers_by_pk(id: $organisationSupplierId) {
    id
    organisation_supplier_tags(where: {tag: {deletedAt: {_is_null: true}}}) {
      tag {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetTagsByOrganisationSupplierIdQuery, GetTagsByOrganisationSupplierIdQueryVariables>;
export const GetTasksByUserIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetTasksByUserId($userId: uuid!, $gqlFilter: request_steps_bool_exp!, $offset: Int!, $limit: Int!, $includeRows: Boolean!) {
  tasks: request_steps(
    where: {_and: [{request: {deletedAt: {_is_null: true}}}, {state: {_neq: PENDING}}, {_or: [{request_step_groups: {group: {group_users: {userId: {_eq: $userId}}}}}, {request_step_users: {userId: {_eq: $userId}}}, {request_step_tasks: {completedOn: {_is_null: true}, request_step_task_users: {user_id: {_eq: $userId}}}}]}, $gqlFilter]}
    order_by: {createdAt: desc_nulls_last}
    offset: $offset
    limit: $limit
  ) @include(if: $includeRows) {
    id
    createdAt
    state
    stepLabel: input(path: "$.metadata.config.payload.label")
    stageType: input(path: "$.metadata.type")
    targetTimeValue: input(path: "$.metadata.config.payload.targetTimeValue")
    totalPausedWorkingHours
    request {
      id
      organisation {
        id
        name
      }
      id
      name
      user {
        id
        firstName
        lastName
        email
        role
        isArchived
      }
      owner {
        id
        firstName
        lastName
        email
        role
        isArchived
      }
      supplier {
        id
        name
        logoUrl
      }
      workflow {
        id
        title
        workflow_condition_groups {
          id
          name
          precedence
        }
      }
      tagIds
      computedProperties {
        valueObject
        buyerLegalEntity {
          id
          name
          isArchived
        }
        department {
          id
          name
        }
      }
      request_tags {
        tag {
          id
          name
          deletedAt
        }
      }
      priority
      publicId
      state
    }
    requestStepGroups: request_step_groups {
      group {
        id
        name
        group_users {
          id
          userId
        }
      }
    }
    requestStepUsers: request_step_users {
      user {
        id
        firstName
        lastName
      }
    }
    requestStepTasks: request_step_tasks {
      id
      type
      completedOn
      request_form {
        id
        type
        title
        request_comments(
          where: {completedAt: {_is_null: true}, type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}
        ) {
          id
          type
          userId
          completedAt
        }
      }
    }
    activeAmendments: request_step_tasks(
      where: {request_form: {request_comments: {completedAt: {_is_null: true}, type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}}}
    ) {
      request_form {
        request_comments(
          where: {completedAt: {_is_null: true}, type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}
        ) {
          id
          type
          userId
          completedAt
        }
      }
    }
  }
  request_steps_aggregate(
    where: {_and: [{request: {deletedAt: {_is_null: true}}}, {state: {_neq: PENDING}}, {_or: [{request_step_groups: {group: {group_users: {userId: {_eq: $userId}}}}}, {request_step_users: {userId: {_eq: $userId}}}, {request_step_tasks: {completedOn: {_is_null: true}, request_step_task_users: {user_id: {_eq: $userId}}}}]}, $gqlFilter]}
  ) {
    aggregate {
      count
    }
  }
}
    `) as unknown as TypedDocumentString<GetTasksByUserIdQuery, GetTasksByUserIdQueryVariables>;
export const GetUsersByGroupIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUsersByGroupId($groupId: uuid!) {
  users(where: {group_users: {groupId: {_eq: $groupId}}}) {
    id
  }
}
    `) as unknown as TypedDocumentString<GetUsersByGroupIdQuery, GetUsersByGroupIdQueryVariables>;
export const InsertCommentMentionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertCommentMentions($objects: [request_comments_mentions_insert_input!]!) {
  insert_request_comments_mentions(objects: $objects) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<InsertCommentMentionsMutation, InsertCommentMentionsMutationVariables>;
export const InsertSupplierTagDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertSupplierTag($supplierId: uuid!, $tagId: uuid!) {
  insert_organisation_supplier_tags_one(
    object: {organisationSupplierId: $supplierId, tagId: $tagId}
  ) {
    id
    tag {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<InsertSupplierTagMutation, InsertSupplierTagMutationVariables>;
export const InsertTagDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertTag($input: tags_insert_input!) {
  insert_tags_one(object: $input) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<InsertTagMutation, InsertTagMutationVariables>;
export const QueryTagByNameDocument = /*#__PURE__*/ new TypedDocumentString(`
    query QueryTagByName($tagName: String!) {
  tags(where: {name: {_eq: $tagName}}) {
    id
    name
    deletedAt
  }
}
    `) as unknown as TypedDocumentString<QueryTagByNameQuery, QueryTagByNameQueryVariables>;
export const RestoreDeletedTagDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation RestoreDeletedTag($tagId: uuid!) {
  update_tags_by_pk(pk_columns: {id: $tagId}, _set: {deletedAt: null}) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<RestoreDeletedTagMutation, RestoreDeletedTagMutationVariables>;
export const GetOrganisationTagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationTags($offset: Int, $limit: Int, $where: tags_bool_exp = {}) {
  tags(
    where: {_and: [{deletedAt: {_is_null: true}}, $where]}
    offset: $offset
    limit: $limit
    order_by: {name: asc}
  ) {
    id
    name
  }
  tagsAggregate: tags_aggregate(
    where: {_and: [{deletedAt: {_is_null: true}}, $where]}
  ) {
    aggregate {
      count
    }
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationTagsQuery, GetOrganisationTagsQueryVariables>;
export const GetAllRequestTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllRequestTasks($requestId: uuid!) {
  taskBasedStepPermission: request_steps(
    where: {requestId: {_eq: $requestId}}
    order_by: {createdAt: desc}
  ) {
    ...AllRequestStepFields
    requestStepTasks: request_step_tasks {
      ...AllRequestStepTaskFields
    }
  }
  fullStepPermission: request_steps(
    where: {requestId: {_eq: $requestId}}
    order_by: {createdAt: desc}
  ) {
    ...StepFields
    requestStepTasks: request_step_tasks {
      ...AllRequestStepTaskFields
    }
  }
}
    fragment AllRequestStepFields on request_steps {
  id
  createdAt
  state
  canvasModelId
  stepLabel: input(path: "$.metadata.config.payload.label")
  type: input(path: "$.metadata.type")
  skipped: output(path: "$.skipped")
  skippedAt: output(path: "$.skipped_at")
  skippedBy: output(path: "$.skipped_by")
  forceApprovedAt: output(path: "$.force_approved_at")
  forceApprovedBy: output(path: "$.force_approved_by")
}
fragment AllRequestStepTaskFields on request_step_tasks {
  id
  completedOn
  completedBy
  submissionsClosedAt
  type
  config
  request_step_task_rejections {
    id
    createdBy
    createdAt
  }
}
fragment StepFields on request_steps {
  id
  createdAt
  state
  canvasModelId
  stepLabel: input(path: "$.metadata.config.payload.label")
  type: input(path: "$.metadata.type")
  targetTimeValue: input(path: "$.metadata.config.payload.targetTimeValue")
  skipped: output(path: "$.skipped")
  skippedAt: output(path: "$.skipped_at")
  skippedBy: output(path: "$.skipped_by")
  forceApprovedAt: output(path: "$.force_approved_at")
  forceApprovedBy: output(path: "$.force_approved_by")
  totalPausedWorkingHours
  agentEnabled: input(path: "$.metadata.config.payload.agentConfig.enabled")
  request {
    id
    user {
      id
    }
  }
  request_step_users {
    id
    user {
      id
    }
  }
  request_step_groups {
    id
    group {
      id
      group_users {
        id
        userId
      }
    }
  }
}`) as unknown as TypedDocumentString<GetAllRequestTasksQuery, GetAllRequestTasksQueryVariables>;
export const GetIntakeFormsWithRequestAmendmentsByRequestorIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetIntakeFormsWithRequestAmendmentsByRequestorId($requestorId: uuid!) {
  forms: request_forms(
    where: {_and: [{type: {_eq: INTAKE}}, {request_comments: {completedAt: {_is_null: true}, type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}}, {request: {requestorUserId: {_eq: $requestorId}, deletedAt: {_is_null: true}}}]}
  ) {
    id
    request {
      id
      createdAt
      organisation {
        id
        name
      }
      id
      name
      user {
        id
        firstName
        lastName
        email
        role
        isArchived
      }
      owner {
        id
        firstName
        lastName
        email
        role
        isArchived
      }
      supplier {
        id
        name
        logoUrl
      }
      workflow {
        id
        title
        workflow_condition_groups {
          id
          name
          precedence
        }
      }
      tagIds
      request_tags {
        id
        tag {
          id
          name
          deletedAt
        }
      }
      computedProperties {
        valueObject
        buyerLegalEntity {
          id
          name
          isArchived
        }
        department {
          id
          name
        }
      }
      priority
      publicId
      state
    }
    activeAmendments: request_comments(
      where: {_and: [{completedAt: {_is_null: true}}, {type: {_eq: AMENDMENT_REQUEST}}, {deletedAt: {_is_null: true}}]}
    ) {
      id
      type
      userId
      completedAt
    }
  }
}
    `) as unknown as TypedDocumentString<GetIntakeFormsWithRequestAmendmentsByRequestorIdQuery, GetIntakeFormsWithRequestAmendmentsByRequestorIdQueryVariables>;
export const GetMyRequestTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetMyRequestTasks($userId: uuid!, $requestId: uuid!) {
  taskBasedStepPermission: request_steps(
    where: {requestId: {_eq: $requestId}, request_step_tasks: {request_step_task_users: {user_id: {_eq: $userId}}}}
    order_by: {createdAt: desc}
  ) {
    ...StepFields
    requestStepTasks: request_step_tasks(
      where: {request_step_task_users: {user_id: {_eq: $userId}}}
      order_by: {created_at: asc}
    ) {
      ...TaskFields
    }
  }
  fullStepPermission: request_steps(
    where: {_or: [{request_step_groups: {group: {group_users: {userId: {_eq: $userId}}}}}, {request_step_users: {userId: {_eq: $userId}}}], requestId: {_eq: $requestId}}
    order_by: {createdAt: desc}
  ) {
    ...StepFields
    requestStepTasks: request_step_tasks(order_by: {created_at: asc}) {
      ...TaskFields
    }
  }
}
    fragment StepFields on request_steps {
  id
  createdAt
  state
  canvasModelId
  stepLabel: input(path: "$.metadata.config.payload.label")
  type: input(path: "$.metadata.type")
  targetTimeValue: input(path: "$.metadata.config.payload.targetTimeValue")
  skipped: output(path: "$.skipped")
  skippedAt: output(path: "$.skipped_at")
  skippedBy: output(path: "$.skipped_by")
  forceApprovedAt: output(path: "$.force_approved_at")
  forceApprovedBy: output(path: "$.force_approved_by")
  totalPausedWorkingHours
  agentEnabled: input(path: "$.metadata.config.payload.agentConfig.enabled")
  request {
    id
    user {
      id
    }
  }
  request_step_users {
    id
    user {
      id
    }
  }
  request_step_groups {
    id
    group {
      id
      group_users {
        id
        userId
      }
    }
  }
}
fragment TaskFields on request_step_tasks {
  id
  completedOn
  completedBy
  created_at
  submissionsClosedAt
  request_step_task_rejections {
    id
    createdBy
    createdAt
  }
  type
  config
  request_form {
    id
    title
    type
    config
    form_template {
      id
      externalTitle
    }
    request_comments(
      where: {_and: [{completedAt: {_is_null: true}}, {type: {_eq: AMENDMENT_REQUEST}, deletedAt: {_is_null: true}}]}
    ) {
      id
      userId
      type
      completedAt
    }
    request_form_submissions(limit: 1, order_by: {submittedOn: desc_nulls_last}) {
      id
      response
    }
    request_form_submissions_auto_saves(limit: 1) {
      id
    }
    request_step_tasks {
      id
      completedOn
      request_step_task_rejections {
        id
      }
    }
  }
  organisation_supplier {
    id
    rfx_suppliers {
      id
      status
      rfx {
        requestId
      }
    }
  }
}`) as unknown as TypedDocumentString<GetMyRequestTasksQuery, GetMyRequestTasksQueryVariables>;
export const GetRequestRfxFillInTasksDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestRfxFillInTasks($requestId: uuid!) {
  requests_by_pk(id: $requestId) {
    id
    rfxes {
      id
      owners {
        userId
      }
    }
    request_forms(where: {type: {_eq: RFX}}) {
      id
      request_step_tasks(where: {type: {_eq: FILL_IN}}) {
        id
        completedOn
        completedBy
        submissionsClosedAt
        request_step_task_users {
          user {
            email
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestRfxFillInTasksQuery, GetRequestRfxFillInTasksQueryVariables>;
export const GetRfxConfidentialityAgreementByRequestAndUserDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRfxConfidentialityAgreementByRequestAndUser($requestId: uuid!, $userId: uuid!) {
  rfxConfidentialityAgreements: rfx_confidentiality_agreement(
    where: {rfx: {requestId: {_eq: $requestId}}, rfx_supplier: {rfx_external_users: {external_contact: {userId: {_eq: $userId}}}}}
  ) {
    id
    confidentialityAgreement
    signedAt
    signedBy: user {
      id
      firstName
      lastName
    }
    rfxSupplierId
    rfxId
  }
}
    `) as unknown as TypedDocumentString<GetRfxConfidentialityAgreementByRequestAndUserQuery, GetRfxConfidentialityAgreementByRequestAndUserQueryVariables>;
export const ArchiveGroupByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation ArchiveGroupById($groupId: uuid!) {
  archivedGroup: update_groups_by_pk(
    pk_columns: {id: $groupId}
    _set: {isArchived: true}
  ) {
    id
  }
  deletedGroupUsers: delete_group_users(where: {groupId: {_eq: $groupId}}) {
    returning {
      userId
    }
  }
}
    `) as unknown as TypedDocumentString<ArchiveGroupByIdMutation, ArchiveGroupByIdMutationVariables>;
export const CreateGroupDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateGroup($name: String!) {
  insert_groups_one(object: {name: $name}) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<CreateGroupMutation, CreateGroupMutationVariables>;
export const GetGroupsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetGroups {
  groups(where: {isArchived: {_eq: false}}) {
    ...GroupFragment
    ...GroupUsersFragment
  }
}
    fragment GroupFragment on groups {
  id
  name
  rawAttributes
  organisationId
  isArchived
}
fragment GroupUsersFragment on groups {
  group_users(
    where: {user: {isArchived: {_eq: false}, deletedAt: {_is_null: true}}}
  ) {
    user {
      id
      firstName
      lastName
      email
    }
  }
}`) as unknown as TypedDocumentString<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetOrgUsersListDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrgUsersList($offset: Int, $limit: Int) {
  organisations {
    id
    hasDirectorySyncEnabled
    ssoDomains
    domain
  }
  users(offset: $offset, limit: $limit) {
    ...UserFragment
    isOutOfOffice
    customFieldValues {
      ...CustomFieldValueFragment
    }
    group_users {
      id
      group {
        ...GroupFragment
      }
    }
    department {
      id
      name
    }
    subsidiary {
      id
      name
    }
    managerUser {
      id
      firstName
      lastName
    }
    userAllowedSubsidiaries {
      id
      subsidiaryId
      subsidiary {
        ...Subsidiary
      }
    }
  }
  totalUsers: users_aggregate {
    aggregate {
      count
    }
  }
}
    fragment Subsidiary on subsidiaries {
  id
  name
  isArchived
  archivedBy
  remoteId
  coreDataId
}
fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment GroupFragment on groups {
  id
  name
  rawAttributes
  organisationId
  isArchived
}
fragment UserFragment on users {
  id
  firstName
  lastName
  email
  role
  hasConfigPermissions
  isViewOnly
  deletedAt
  isArchived
  languagePreference
  isOutOfOffice
}`) as unknown as TypedDocumentString<GetOrgUsersListQuery, GetOrgUsersListQueryVariables>;
export const GetUserByEmailDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUserByEmail($email: String!) {
  users(where: {email: {_eq: $email}, deletedAt: {_is_null: true}}) {
    id
    email
    firstName
    lastName
    role
    hasConfigPermissions
    organisation {
      id
      name
      email_logo_url_dark
      languagePreference
    }
    isArchived
    languagePreference
    isOutOfOffice
    dateFormatPreference
  }
}
    `) as unknown as TypedDocumentString<GetUserByEmailQuery, GetUserByEmailQueryVariables>;
export const GetUserByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUserById($id: uuid!) {
  users_by_pk(id: $id) {
    id
    firstName
    lastName
    email
    role
    deletedAt
    isArchived
    languagePreference
    dateFormatPreference
  }
}
    `) as unknown as TypedDocumentString<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const GetUserOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUserOne($id: uuid!) {
  users_by_pk(id: $id) {
    ...UserFragment
    organisation {
      id
      name
      isQa
      languagePreference
    }
  }
}
    fragment UserFragment on users {
  id
  firstName
  lastName
  email
  role
  hasConfigPermissions
  isViewOnly
  deletedAt
  isArchived
  languagePreference
  isOutOfOffice
}`) as unknown as TypedDocumentString<GetUserOneQuery, GetUserOneQueryVariables>;
export const GetUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUsers {
  users {
    ...UserFragment
  }
}
    fragment UserFragment on users {
  id
  firstName
  lastName
  email
  role
  hasConfigPermissions
  isViewOnly
  deletedAt
  isArchived
  languagePreference
  isOutOfOffice
}`) as unknown as TypedDocumentString<GetUsersQuery, GetUsersQueryVariables>;
export const InsertGroupUsersDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertGroupUsers($objects: [group_users_insert_input!]!) {
  insert_group_users(objects: $objects) {
    returning {
      id
      group {
        ...GroupFragment
      }
    }
  }
}
    fragment GroupFragment on groups {
  id
  name
  rawAttributes
  organisationId
  isArchived
}`) as unknown as TypedDocumentString<InsertGroupUsersMutation, InsertGroupUsersMutationVariables>;
export const UnarchiveUserDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UnarchiveUser($id: uuid!) {
  update_users_by_pk(
    pk_columns: {id: $id}
    _set: {isArchived: false, isOutOfOffice: false}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<UnarchiveUserMutation, UnarchiveUserMutationVariables>;
export const UpdateUserDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateUser($id: uuid!, $input: users_set_input) {
  update_users_by_pk(pk_columns: {id: $id}, _set: $input) {
    ...UserDetailsFragment
  }
}
    fragment CustomFieldValueFragment on custom_field_values {
  id
  entityId
  choice {
    id
    label
  }
  value
  booleanValue
  numberValue
  customFieldId
  customFieldChoiceId
  customField {
    id
    type
    title
    customCoreData {
      id
      pathLevels
    }
  }
  user {
    id
    firstName
    lastName
    email
  }
  file {
    id
    fileName
    filestoreId
  }
  customFieldCoreData {
    department {
      id
      name
      isArchived
    }
    paymentTerm {
      id
      name
      isArchived
    }
    paymentMethod {
      id
      name
      isArchived
    }
    subsidiary {
      id
      name
      isArchived
    }
    currency {
      id
      name
      code
      isArchived
    }
    lineItemType {
      id
      name
      isArchived
    }
    customCoreDataOption {
      id
      customCoreDataId
      value
      isArchived
      isTerminal
    }
  }
}
fragment GroupFragment on groups {
  id
  name
  rawAttributes
  organisationId
  isArchived
}
fragment UserDetailsFragment on users {
  ...UserFragment
  isOutOfOffice
  customFieldValues {
    ...CustomFieldValueFragment
  }
  group_users {
    id
    group {
      ...GroupFragment
    }
  }
  department {
    id
    name
  }
  subsidiary {
    id
    name
  }
  managerUser {
    id
    firstName
    lastName
  }
}
fragment UserFragment on users {
  id
  firstName
  lastName
  email
  role
  hasConfigPermissions
  isViewOnly
  deletedAt
  isArchived
  languagePreference
  isOutOfOffice
}`) as unknown as TypedDocumentString<UpdateUserMutation, UpdateUserMutationVariables>;
export const CreateUserDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateUser($email: String!, $firstName: String!, $lastName: String!, $role: String!, $hasConfigPermissions: Boolean!, $isViewOnly: Boolean!) {
  newUser: insert_users_one(
    object: {email: $email, firstName: $firstName, lastName: $lastName, role: $role, hasConfigPermissions: $hasConfigPermissions, isViewOnly: $isViewOnly}
    on_conflict: {constraint: users_email_organisation_id_key, update_columns: []}
  ) {
    ...UserFragment
    groupUsers: group_users {
      id
      group {
        ...GroupFragment
      }
    }
  }
}
    fragment GroupFragment on groups {
  id
  name
  rawAttributes
  organisationId
  isArchived
}
fragment UserFragment on users {
  id
  firstName
  lastName
  email
  role
  hasConfigPermissions
  isViewOnly
  deletedAt
  isArchived
  languagePreference
  isOutOfOffice
}`) as unknown as TypedDocumentString<CreateUserMutation, CreateUserMutationVariables>;
export const CreateWorkflowDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateWorkflow($workflow: workflows_insert_input!) {
  insert_workflows_one(object: $workflow) {
    ...WorkflowFragment
  }
}
    fragment WorkflowFragment on workflows {
  id
  title
  description
  state
  type
  url
  isArchived
  routingCanvasModel
  viewModel
  viewModelUpdatedAt
  requestSidebarConfig
  createdAt
  updatedAt
  canvasModelUpdatedAt
  expectedSLA
  organisationId
  organisation {
    id
    name
  }
  updated_by_user {
    id
    firstName
    lastName
  }
  workflow_rank {
    rank
  }
}`) as unknown as TypedDocumentString<CreateWorkflowMutation, CreateWorkflowMutationVariables>;
export const DeleteWorkflowConditionGroupOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteWorkflowConditionGroupOne($id: uuid!) {
  update_workflow_condition_groups_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    ...WorkflowConditionGroupFragment
  }
}
    fragment WorkflowConditionGroupFragment on workflow_condition_groups {
  id
  name
  condition
  createdAt
  updatedAt
  precedence
}`) as unknown as TypedDocumentString<DeleteWorkflowConditionGroupOneMutation, DeleteWorkflowConditionGroupOneMutationVariables>;
export const GetWorkflowConditionGroupOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetWorkflowConditionGroupOne($id: uuid!) {
  workflow_condition_groups_by_pk(id: $id) {
    id
    workflowId
    name
    deletedAt
  }
}
    `) as unknown as TypedDocumentString<GetWorkflowConditionGroupOneQuery, GetWorkflowConditionGroupOneQueryVariables>;
export const GetWorkflowConditionGroupsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetWorkflowConditionGroups($workflowId: uuid!) {
  workflow_condition_groups(
    where: {workflowId: {_eq: $workflowId}, deletedAt: {_is_null: true}}
  ) {
    ...WorkflowConditionGroupFragment
  }
}
    fragment WorkflowConditionGroupFragment on workflow_condition_groups {
  id
  name
  condition
  createdAt
  updatedAt
  precedence
}`) as unknown as TypedDocumentString<GetWorkflowConditionGroupsQuery, GetWorkflowConditionGroupsQueryVariables>;
export const GetWorkflowForDuplicationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetWorkflowForDuplication($id: uuid!) {
  workflows_by_pk(id: $id) {
    ...WorkflowFragment
    workflow_condition_groups {
      ...WorkflowConditionGroupFragment
    }
  }
}
    fragment WorkflowConditionGroupFragment on workflow_condition_groups {
  id
  name
  condition
  createdAt
  updatedAt
  precedence
}
fragment WorkflowFragment on workflows {
  id
  title
  description
  state
  type
  url
  isArchived
  routingCanvasModel
  viewModel
  viewModelUpdatedAt
  requestSidebarConfig
  createdAt
  updatedAt
  canvasModelUpdatedAt
  expectedSLA
  organisationId
  organisation {
    id
    name
  }
  updated_by_user {
    id
    firstName
    lastName
  }
  workflow_rank {
    rank
  }
}`) as unknown as TypedDocumentString<GetWorkflowForDuplicationQuery, GetWorkflowForDuplicationQueryVariables>;
export const GetWorkflowOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetWorkflowOne($id: uuid!) {
  workflows_by_pk(id: $id) {
    ...WorkflowFragment
  }
}
    fragment WorkflowFragment on workflows {
  id
  title
  description
  state
  type
  url
  isArchived
  routingCanvasModel
  viewModel
  viewModelUpdatedAt
  requestSidebarConfig
  createdAt
  updatedAt
  canvasModelUpdatedAt
  expectedSLA
  organisationId
  organisation {
    id
    name
  }
  updated_by_user {
    id
    firstName
    lastName
  }
  workflow_rank {
    rank
  }
}`) as unknown as TypedDocumentString<GetWorkflowOneQuery, GetWorkflowOneQueryVariables>;
export const InsertWorkflowConditionGroupOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertWorkflowConditionGroupOne($object: workflow_condition_groups_insert_input = {}) {
  insert_workflow_condition_groups_one(object: $object) {
    ...WorkflowConditionGroupFragment
  }
}
    fragment WorkflowConditionGroupFragment on workflow_condition_groups {
  id
  name
  condition
  createdAt
  updatedAt
  precedence
}`) as unknown as TypedDocumentString<InsertWorkflowConditionGroupOneMutation, InsertWorkflowConditionGroupOneMutationVariables>;
export const InsertWorkflowDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertWorkflow($title: String!, $description: String!, $state: workflow_state_enum!, $routingCanvasModel: jsonb!, $type: workflow_type_enum!, $url: String) {
  insert_workflows(
    objects: [{title: $title, description: $description, state: $state, routingCanvasModel: $routingCanvasModel, type: $type, url: $url}]
  ) {
    returning {
      ...WorkflowFragment
    }
  }
}
    fragment WorkflowFragment on workflows {
  id
  title
  description
  state
  type
  url
  isArchived
  routingCanvasModel
  viewModel
  viewModelUpdatedAt
  requestSidebarConfig
  createdAt
  updatedAt
  canvasModelUpdatedAt
  expectedSLA
  organisationId
  organisation {
    id
    name
  }
  updated_by_user {
    id
    firstName
    lastName
  }
  workflow_rank {
    rank
  }
}`) as unknown as TypedDocumentString<InsertWorkflowMutation, InsertWorkflowMutationVariables>;
export const UpdateWorkflowConditionGroupOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateWorkflowConditionGroupOne($id: uuid!, $params: workflow_condition_groups_set_input!) {
  update_workflow_condition_groups_by_pk(pk_columns: {id: $id}, _set: $params) {
    ...WorkflowConditionGroupFragment
  }
}
    fragment WorkflowConditionGroupFragment on workflow_condition_groups {
  id
  name
  condition
  createdAt
  updatedAt
  precedence
}`) as unknown as TypedDocumentString<UpdateWorkflowConditionGroupOneMutation, UpdateWorkflowConditionGroupOneMutationVariables>;
export const UpdateWorkflowRoutingCanvasModelDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateWorkflowRoutingCanvasModel($id: uuid!, $routingCanvasModel: jsonb!) {
  update_workflows_by_pk(
    pk_columns: {id: $id}
    _set: {routingCanvasModel: $routingCanvasModel, canvasModelUpdatedAt: "now()"}
  ) {
    ...WorkflowFragment
  }
}
    fragment WorkflowFragment on workflows {
  id
  title
  description
  state
  type
  url
  isArchived
  routingCanvasModel
  viewModel
  viewModelUpdatedAt
  requestSidebarConfig
  createdAt
  updatedAt
  canvasModelUpdatedAt
  expectedSLA
  organisationId
  organisation {
    id
    name
  }
  updated_by_user {
    id
    firstName
    lastName
  }
  workflow_rank {
    rank
  }
}`) as unknown as TypedDocumentString<UpdateWorkflowRoutingCanvasModelMutation, UpdateWorkflowRoutingCanvasModelMutationVariables>;
export const UpdateWorkflowRanksDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateWorkflowRanks($objects: [workflow_ranks_insert_input!]!) {
  insert_workflow_ranks(
    objects: $objects
    on_conflict: {constraint: workflow_ranks_workflow_id_key, update_columns: [rank]}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<UpdateWorkflowRanksMutation, UpdateWorkflowRanksMutationVariables>;
export const GetUsersAndRequestsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUsersAndRequests($userIds: [uuid!], $requestIds: [uuid!]) {
  requests(where: {id: {_in: $requestIds}}) {
    id
    createdAt
    deletedAt
    updatedAt
    completedAt
    name
    publicId
  }
  users(where: {id: {_in: $userIds}}) {
    id
    createdAt
    updatedAt
    deletedAt
    email
    firstName
    lastName
  }
}
    `) as unknown as TypedDocumentString<GetUsersAndRequestsQuery, GetUsersAndRequestsQueryVariables>;
export const GetFeatureFlagDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetFeatureFlag($featureFlag: feature_flags_enum!) {
  featureFlags: organisation_feature_flags(
    where: {featureFlag: {_eq: $featureFlag}}
  ) {
    featureFlag
  }
}
    `) as unknown as TypedDocumentString<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>;
export const GetMultipleFeatureFlagsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetMultipleFeatureFlags($featureFlags: [feature_flags_enum!]!) {
  featureFlags: organisation_feature_flags(
    where: {featureFlag: {_in: $featureFlags}}
  ) {
    featureFlag
  }
}
    `) as unknown as TypedDocumentString<GetMultipleFeatureFlagsQuery, GetMultipleFeatureFlagsQueryVariables>;
export const ConfigForTranslationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query ConfigForTranslation {
  workflows(
    where: {type: {_eq: NEW_PURCHASE}, deletedAt: {_is_null: true}, isArchived: {_eq: false}}
  ) {
    id
    title
    description
  }
  form_templates(
    where: {type: {_eq: INTAKE}, deletedAt: {_is_null: true}, state: {_neq: ARCHIVED}}
  ) {
    id
    title
    externalTitle
    description
    config
  }
  departments(where: {isArchived: {_eq: false}}) {
    coreData {
      id
    }
    id
    name
  }
  subsidiaries(where: {isArchived: {_eq: false}}) {
    coreData {
      id
    }
    id
    name
  }
  payment_terms(where: {isArchived: {_eq: false}}) {
    coreData {
      id
    }
    id
    name
  }
  payment_methods(where: {isArchived: {_eq: false}}) {
    coreData {
      id
    }
    id
    name
  }
  line_item_types(where: {isArchived: {_eq: false}}) {
    coreData {
      id
    }
    id
    name
  }
  custom_core_data(where: {archivedAt: {_is_null: true}}) {
    id
    name
    custom_core_data_options(where: {isArchived: {_eq: false}}) {
      id
      value
    }
  }
}
    `) as unknown as TypedDocumentString<ConfigForTranslationQuery, ConfigForTranslationQueryVariables>;
export const GetLocalePreferencesByUserIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLocalePreferencesByUserId($userId: uuid!) {
  users_by_pk(id: $userId) {
    id
    organisation {
      languagePreference
    }
    languagePreference
  }
}
    `) as unknown as TypedDocumentString<GetLocalePreferencesByUserIdQuery, GetLocalePreferencesByUserIdQueryVariables>;
export const GetLocalePreferencesForOrganisationDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetLocalePreferencesForOrganisation {
  organisations {
    id
    languagePreference
  }
}
    `) as unknown as TypedDocumentString<GetLocalePreferencesForOrganisationQuery, GetLocalePreferencesForOrganisationQueryVariables>;
export const CreateFormSubmissionDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateFormSubmission($id: uuid!, $requestFormId: uuid!, $submittedBy: uuid!, $response: jsonb!, $requestStepTaskId: uuid!) {
  insert_request_form_submissions_one(
    object: {id: $id, requestFormId: $requestFormId, submittedBy: $submittedBy, response: $response, submittedOn: "now()", requestStepTaskId: $requestStepTaskId}
  ) {
    id
    requestFormId
    submittedBy
    response
  }
}
    `) as unknown as TypedDocumentString<CreateFormSubmissionMutation, CreateFormSubmissionMutationVariables>;
export const CreateMinimalRequestDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateMinimalRequest($id: uuid!, $name: String!, $workflowId: uuid!, $requestorUserId: uuid!, $requestSupplierId: uuid) {
  insert_requests_one(
    object: {id: $id, name: $name, workflowId: $workflowId, model: {}, requestorUserId: $requestorUserId, type: NEW_PURCHASE, request_supplier: $requestSupplierId}
  ) {
    id
    name
    workflowId
    requestorUserId
    publicId
  }
}
    `) as unknown as TypedDocumentString<CreateMinimalRequestMutation, CreateMinimalRequestMutationVariables>;
export const CreateMinimalWorkflowDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateMinimalWorkflow($id: uuid!, $title: String!, $description: String!, $state: workflow_state_enum, $type: workflow_type_enum, $routingCanvasModel: jsonb, $isArchived: Boolean) {
  insert_workflows_one(
    object: {id: $id, title: $title, description: $description, state: $state, type: $type, routingCanvasModel: $routingCanvasModel, isArchived: $isArchived}
  ) {
    id
    title
    description
    state
    type
    organisationId
  }
}
    `) as unknown as TypedDocumentString<CreateMinimalWorkflowMutation, CreateMinimalWorkflowMutationVariables>;
export const CreateNonRfxStepDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateNonRfxStep($id: uuid!, $requestId: uuid!, $workflowId: uuid!, $canvasModelId: String!) {
  insert_request_steps_one(
    object: {id: $id, requestId: $requestId, workflowId: $workflowId, canvasModelId: $canvasModelId, state: COMPLETE, input: {metadata: {type: "APPROVAL"}, name: "Approval Process"}}
  ) {
    id
    requestId
    input
    state
  }
}
    `) as unknown as TypedDocumentString<CreateNonRfxStepMutation, CreateNonRfxStepMutationVariables>;
export const CreateRequestStepTaskDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateRequestStepTask($id: uuid!, $requestStepId: uuid!, $organisationSupplierId: uuid!, $requestFormId: uuid) {
  insert_request_step_tasks_one(
    object: {id: $id, requestStepId: $requestStepId, organisationSupplierId: $organisationSupplierId, type: FILL_IN, requestFormId: $requestFormId}
  ) {
    id
    requestStepId
    organisationSupplierId
  }
}
    `) as unknown as TypedDocumentString<CreateRequestStepTaskMutation, CreateRequestStepTaskMutationVariables>;
export const CreateRfxDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateRfx($id: uuid!, $requestStepId: uuid!, $requestId: uuid!, $supplierInstructions: String!) {
  insert_rfx_one(
    object: {id: $id, requestStepId: $requestStepId, requestId: $requestId, status: "COMPLETE", supplierInstructions: $supplierInstructions}
  ) {
    id
    status
    requestStepId
  }
}
    `) as unknown as TypedDocumentString<CreateRfxMutation, CreateRfxMutationVariables>;
export const CreateRfxStepDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateRfxStep($id: uuid!, $requestId: uuid!, $workflowId: uuid!, $canvasModelId: String!) {
  insert_request_steps_one(
    object: {id: $id, requestId: $requestId, workflowId: $workflowId, canvasModelId: $canvasModelId, state: COMPLETE, input: {metadata: {type: "RFX"}, name: "RFx Process"}}
  ) {
    id
    requestId
    input
    state
  }
}
    `) as unknown as TypedDocumentString<CreateRfxStepMutation, CreateRfxStepMutationVariables>;
export const CreateSeedUserDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateSeedUser($email: String!, $firstName: String!, $lastName: String!, $role: String!, $hasConfigPermissions: Boolean!, $isViewOnly: Boolean!, $subsidiaryId: uuid, $departmentId: uuid, $managerUserId: uuid) {
  newUser: insert_users_one(
    object: {email: $email, firstName: $firstName, lastName: $lastName, role: $role, hasConfigPermissions: $hasConfigPermissions, isViewOnly: $isViewOnly, subsidiaryId: $subsidiaryId, departmentId: $departmentId, managerUserId: $managerUserId}
    on_conflict: {constraint: users_email_organisation_id_key, update_columns: []}
  ) {
    ...UserFragment
    groupUsers: group_users {
      id
      group {
        ...GroupFragment
      }
    }
  }
}
    fragment GroupFragment on groups {
  id
  name
  rawAttributes
  organisationId
  isArchived
}
fragment UserFragment on users {
  id
  firstName
  lastName
  email
  role
  hasConfigPermissions
  isViewOnly
  deletedAt
  isArchived
  languagePreference
  isOutOfOffice
}`) as unknown as TypedDocumentString<CreateSeedUserMutation, CreateSeedUserMutationVariables>;
export const CreateSupplierOnboardingFormDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreateSupplierOnboardingForm($id: uuid!, $requestId: uuid!, $title: String!, $description: String!) {
  insert_request_forms_one(
    object: {id: $id, requestId: $requestId, type: SUPPLIER_ONBOARDING, title: $title, description: $description, config: {pages: [], logic: {}, enableAiAutoFill: false}}
  ) {
    id
    type
  }
}
    `) as unknown as TypedDocumentString<CreateSupplierOnboardingFormMutation, CreateSupplierOnboardingFormMutationVariables>;
export const DeleteAllCoreDataByIdDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteAllCoreDataById($addressIds: [uuid!]!, $currencyIds: [uuid!]!, $departmentIds: [uuid!]!, $lineItemTypeIds: [uuid!]!, $paymentMethodIds: [uuid!]!, $paymentTermIds: [uuid!]!, $subsidiaryIds: [uuid!]!, $customCoreDataOptionIds: [uuid!]!, $customCoreDataIds: [uuid!]!) {
  delete_addresses(where: {id: {_in: $addressIds}}) {
    affected_rows
  }
  delete_organisation_fx_rates(where: {id: {_in: $currencyIds}}) {
    affected_rows
  }
  delete_departments(where: {id: {_in: $departmentIds}}) {
    affected_rows
  }
  delete_line_item_types(where: {id: {_in: $lineItemTypeIds}}) {
    affected_rows
  }
  delete_payment_methods(where: {id: {_in: $paymentMethodIds}}) {
    affected_rows
  }
  delete_payment_terms(where: {id: {_in: $paymentTermIds}}) {
    affected_rows
  }
  delete_subsidiaries(where: {id: {_in: $subsidiaryIds}}) {
    affected_rows
  }
  delete_custom_core_data_options(where: {id: {_in: $customCoreDataOptionIds}}) {
    affected_rows
  }
  delete_custom_core_data(where: {id: {_in: $customCoreDataIds}}) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteAllCoreDataByIdMutation, DeleteAllCoreDataByIdMutationVariables>;
export const DeleteCoreDataDependenciesForOrgDependencyDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteCoreDataDependenciesForOrgDependency($orgCoreDataDependencyId: uuid!) {
  delete_core_data_dependencies(
    where: {organisationCoreDataDependencyId: {_eq: $orgCoreDataDependencyId}}
  ) {
    returning {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DeleteCoreDataDependenciesForOrgDependencyMutation, DeleteCoreDataDependenciesForOrgDependencyMutationVariables>;
export const DeleteTestDepartmentDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteTestDepartment($id: uuid!) {
  delete_departments_by_pk(id: $id) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteTestDepartmentMutation, DeleteTestDepartmentMutationVariables>;
export const DeleteFeatureFlagDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteFeatureFlag($featureFlag: feature_flags_enum!) {
  delete_organisation_feature_flags(where: {featureFlag: {_eq: $featureFlag}}) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteFeatureFlagMutation, DeleteFeatureFlagMutationVariables>;
export const DeleteRequestFollowerDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteRequestFollower($id: uuid!) {
  update_request_followers_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<DeleteRequestFollowerMutation, DeleteRequestFollowerMutationVariables>;
export const DeleteTagDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteTag($id: uuid!) {
  update_tags_by_pk(pk_columns: {id: $id}, _set: {deletedAt: "now()"}) {
    id
    deletedAt
  }
}
    `) as unknown as TypedDocumentString<DeleteTagMutation, DeleteTagMutationVariables>;
export const DeleteTestUserAllowedSubsidiariesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation DeleteTestUserAllowedSubsidiaries($where: user_allowed_subsidiaries_bool_exp!) {
  delete_user_allowed_subsidiaries(where: $where) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<DeleteTestUserAllowedSubsidiariesMutation, DeleteTestUserAllowedSubsidiariesMutationVariables>;
export const EnableFeatureFlagDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation EnableFeatureFlag($featureFlag: feature_flags_enum!) {
  insert_organisation_feature_flags_one(
    object: {featureFlag: $featureFlag}
    on_conflict: {constraint: organisation_feature_flags_pkey, update_columns: []}
  ) {
    featureFlag
  }
}
    `) as unknown as TypedDocumentString<EnableFeatureFlagMutation, EnableFeatureFlagMutationVariables>;
export const GetAllCoreDataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetAllCoreData {
  core_data {
    ...CoreData
  }
}
    fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}`) as unknown as TypedDocumentString<GetAllCoreDataQuery, GetAllCoreDataQueryVariables>;
export const GetBankDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBankDetails($id: uuid!) {
  bank_details_by_pk(id: $id) {
    id
    remoteId
    accountName
    bankName
    iban
    swiftCode
    sortCode
    accountNumber
    currencyId
    code
    country
    addressId
  }
}
    `) as unknown as TypedDocumentString<GetBankDetailsQuery, GetBankDetailsQueryVariables>;
export const GetBankDetailsForSupplierProfileDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetBankDetailsForSupplierProfile($supplierProfileId: uuid!) {
  entity_bank_details(
    where: {organisationSupplierProfileId: {_eq: $supplierProfileId}}
  ) {
    id
    bankDetailsId
    isPrimary
    bankDetails {
      id
      accountName
      bankName
      accountNumber
      sortCode
      iban
      swiftCode
      code
      country
      isActive
    }
  }
}
    `) as unknown as TypedDocumentString<GetBankDetailsForSupplierProfileQuery, GetBankDetailsForSupplierProfileQueryVariables>;
export const GetProductsAndServicesForSupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetProductsAndServicesForSupplier($orgSupplierId: uuid!) {
  productsAndServices: organisation_products_and_services(
    where: {organisationSupplierId: {_eq: $orgSupplierId}}
  ) {
    id
    deletedAt: deleted_at
  }
}
    `) as unknown as TypedDocumentString<GetProductsAndServicesForSupplierQuery, GetProductsAndServicesForSupplierQueryVariables>;
export const GetRequestComputedPropertiesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetRequestComputedProperties($requestId: uuid!) {
  request: requests_by_pk(id: $requestId) {
    id
    computedProperties {
      id
      requestId
      website
      valueNumber
      contractStartDate
      contractEndDate
      address
      taxNumber
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<GetRequestComputedPropertiesQuery, GetRequestComputedPropertiesQueryVariables>;
export const GetUserAllowedSubsidiariesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetUserAllowedSubsidiaries($where: user_allowed_subsidiaries_bool_exp!) {
  user_allowed_subsidiaries(where: $where) {
    userId
    subsidiaryId
  }
}
    `) as unknown as TypedDocumentString<GetUserAllowedSubsidiariesQuery, GetUserAllowedSubsidiariesQueryVariables>;
export const InsertCustomFieldChoicesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertCustomFieldChoices($choices: [custom_field_choices_insert_input!]!) {
  insert_custom_field_choices(objects: $choices) {
    returning {
      id
      label
      customFieldId
    }
  }
}
    `) as unknown as TypedDocumentString<InsertCustomFieldChoicesMutation, InsertCustomFieldChoicesMutationVariables>;
export const SeedDepartmentDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SeedDepartment($object: departments_insert_input!) {
  insert_departments_one(object: $object) {
    id
    name
    createdAt
    updatedAt
    isArchived
    organisationId
  }
}
    `) as unknown as TypedDocumentString<SeedDepartmentMutation, SeedDepartmentMutationVariables>;
export const InsertRequestFollowerDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRequestFollower($requestId: uuid!, $note: String, $userId: uuid, $groupId: uuid, $assigneeType: assignee_type_enum!) {
  insert_request_followers_one(
    object: {note: $note, assigneeType: $assigneeType, requestId: $requestId, userId: $userId, groupId: $groupId}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertRequestFollowerMutation, InsertRequestFollowerMutationVariables>;
export const InsertRequestStepDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRequestStep($requestStep: request_steps_insert_input!) {
  insert_request_steps_one(object: $requestStep) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertRequestStepMutation, InsertRequestStepMutationVariables>;
export const InsertRequestStepTaskRejectionDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertRequestStepTaskRejection($requestStepTaskId: uuid!, $message: String!, $createdBy: uuid!) {
  insert_request_step_task_rejections_one(
    object: {requestStepTaskId: $requestStepTaskId, message: $message, createdBy: $createdBy}
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<InsertRequestStepTaskRejectionMutation, InsertRequestStepTaskRejectionMutationVariables>;
export const InsertTestUserAllowedSubsidiariesDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertTestUserAllowedSubsidiaries($objects: [user_allowed_subsidiaries_insert_input!]!) {
  insert_user_allowed_subsidiaries(objects: $objects) {
    returning {
      userId
      subsidiaryId
    }
  }
}
    `) as unknown as TypedDocumentString<InsertTestUserAllowedSubsidiariesMutation, InsertTestUserAllowedSubsidiariesMutationVariables>;
export const InsertTestUserAllowedSubsidiaryDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation InsertTestUserAllowedSubsidiary($userId: uuid!, $subsidiaryId: uuid!) {
  insert_user_allowed_subsidiaries_one(
    object: {userId: $userId, subsidiaryId: $subsidiaryId}
  ) {
    userId
    subsidiaryId
  }
}
    `) as unknown as TypedDocumentString<InsertTestUserAllowedSubsidiaryMutation, InsertTestUserAllowedSubsidiaryMutationVariables>;
export const QueryDepartmentByNameDocument = /*#__PURE__*/ new TypedDocumentString(`
    query QueryDepartmentByName($name: String!) {
  departments(where: {name: {_eq: $name}}) {
    id
    name
    createdAt
    updatedAt
    isArchived
    organisationId
  }
}
    `) as unknown as TypedDocumentString<QueryDepartmentByNameQuery, QueryDepartmentByNameQueryVariables>;
export const SeedBankDetailDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SeedBankDetail($input: bank_details_insert_input!) {
  insert_bank_details_one(object: $input) {
    id
    createdAt
  }
}
    `) as unknown as TypedDocumentString<SeedBankDetailMutation, SeedBankDetailMutationVariables>;
export const SeedOrganisationSupplierOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SeedOrganisationSupplierOne($input: organisation_suppliers_insert_input!) {
  insert_organisation_suppliers_one(object: $input) {
    id
    publicId
    remoteId
  }
}
    `) as unknown as TypedDocumentString<SeedOrganisationSupplierOneMutation, SeedOrganisationSupplierOneMutationVariables>;
export const SeedOrganisationSupplierProfileOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SeedOrganisationSupplierProfileOne($input: organisation_supplier_profiles_insert_input!) {
  insert_organisation_supplier_profiles_one(object: $input) {
    id
    subsidiaryId
    customFieldValues {
      value
      customFieldId
      entityId
      booleanValue
      numberValue
    }
  }
}
    `) as unknown as TypedDocumentString<SeedOrganisationSupplierProfileOneMutation, SeedOrganisationSupplierProfileOneMutationVariables>;
export const SeedPurchaseOrderDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SeedPurchaseOrder($input: purchase_orders_insert_input!) {
  insert_purchase_orders_one(object: $input) {
    id
    requestId
    organisationId
  }
}
    `) as unknown as TypedDocumentString<SeedPurchaseOrderMutation, SeedPurchaseOrderMutationVariables>;
export const SeedPurchaseOrderLineItemsDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SeedPurchaseOrderLineItems($objects: [purchase_order_line_items_insert_input!]!) {
  insert_purchase_order_line_items(objects: $objects) {
    returning {
      id
      purchaseOrderId
      lineNumber
    }
  }
}
    `) as unknown as TypedDocumentString<SeedPurchaseOrderLineItemsMutation, SeedPurchaseOrderLineItemsMutationVariables>;
export const SeedTestRiskDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SeedTestRisk($input: risks_insert_input!) {
  insert_risks_one(object: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<SeedTestRiskMutation, SeedTestRiskMutationVariables>;
export const SeedTestRiskLevelDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SeedTestRiskLevel($input: risk_levels_insert_input!) {
  insert_risk_levels_one(object: $input) {
    id
  }
}
    `) as unknown as TypedDocumentString<SeedTestRiskLevelMutation, SeedTestRiskLevelMutationVariables>;
export const SoftDeleteOrganisationSupplierProfileOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SoftDeleteOrganisationSupplierProfileOne($id: uuid!) {
  update_organisation_supplier_profiles(
    where: {id: {_eq: $id}}
    _set: {deletedAt: "now()"}
  ) {
    affected_rows
  }
}
    `) as unknown as TypedDocumentString<SoftDeleteOrganisationSupplierProfileOneMutation, SoftDeleteOrganisationSupplierProfileOneMutationVariables>;
export const UpdateRequestStateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation UpdateRequestState($id: uuid!, $updates: requests_set_input!) {
  update_requests_by_pk(pk_columns: {id: $id}, _set: $updates) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateRequestStateMutation, UpdateRequestStateMutationVariables>;
export const GetEntityBankDetailDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetEntityBankDetail($id: uuid!) {
  entityBankDetails: entity_bank_details(where: {id: {_eq: $id}}) {
    id
    bankDetailsId
    organisationSupplierId
    organisationSupplierProfileId
  }
}
    `) as unknown as TypedDocumentString<GetEntityBankDetailQuery, GetEntityBankDetailQueryVariables>;
export const GetEntityBankDetailsBySupplierDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetEntityBankDetailsBySupplier($supplierId: uuid!) {
  entity_bank_details(where: {organisationSupplierId: {_eq: $supplierId}}) {
    id
    bankDetailsId
    organisationSupplierId
    organisationSupplierProfileId
    isPrimary
  }
}
    `) as unknown as TypedDocumentString<GetEntityBankDetailsBySupplierQuery, GetEntityBankDetailsBySupplierQueryVariables>;
export const GetEntityBankDetailsBySupplierProfileDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetEntityBankDetailsBySupplierProfile($supplierProfileId: uuid!) {
  entity_bank_details(
    where: {organisationSupplierProfileId: {_eq: $supplierProfileId}}
  ) {
    id
    bankDetailsId
    organisationSupplierId
    organisationSupplierProfileId
  }
}
    `) as unknown as TypedDocumentString<GetEntityBankDetailsBySupplierProfileQuery, GetEntityBankDetailsBySupplierProfileQueryVariables>;
export const SeedEntityBankDetailOneDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SeedEntityBankDetailOne($input: entity_bank_details_insert_input!) {
  insert_entity_bank_details_one(object: $input) {
    id
    bankDetailsId
    organisationSupplierId
    organisationSupplierProfileId
    isPrimary
  }
}
    `) as unknown as TypedDocumentString<SeedEntityBankDetailOneMutation, SeedEntityBankDetailOneMutationVariables>;
export const GetOrganisationCurrenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationCurrencies($query: organisation_fx_rates_bool_exp) {
  organisation_fx_rates(where: $query) {
    ...OrganisationFxRate
  }
}
    fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<GetOrganisationCurrenciesQuery, GetOrganisationCurrenciesQueryVariables>;
export const GetOrganisationCurrenciesWithDependenciesMetadataDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationCurrenciesWithDependenciesMetadata($query: organisation_fx_rates_bool_exp, $depsLimit: Int!) {
  organisation_fx_rates(where: $query) {
    ...OrganisationFxRateWithDependenciesMetadata
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}
fragment OrganisationFxRateWithDependenciesMetadata on organisation_fx_rates {
  ...OrganisationFxRate
  dependenciesMetadata: coreData {
    ...CoreDataDependenciesMetadata
  }
}
fragment CoreDataDependenciesMetadata on core_data {
  dependenciesPreview: coreDataDependencies(
    limit: $depsLimit
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...CoreDataDependencies
  }
  numDependencies: coreDataDependencies_aggregate(
    where: {deletedAt: {_is_null: true}}
  ) {
    aggregate {
      count
    }
  }
}`) as unknown as TypedDocumentString<GetOrganisationCurrenciesWithDependenciesMetadataQuery, GetOrganisationCurrenciesWithDependenciesMetadataQueryVariables>;
export const GetOrganisationCurrenciesWithDependenciesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationCurrenciesWithDependencies($query: organisation_fx_rates_bool_exp) {
  organisation_fx_rates(where: $query) {
    ...OrganisationFxRate
    coreData {
      id
      coreDataDependencies(where: {deletedAt: {_is_null: true}}) {
        ...CoreDataDependencies
      }
    }
  }
}
    fragment CoreDataDependencies on core_data_dependencies {
  id
  coreDataId
  coreDataType
  dependencyCoreData {
    ...CoreData
  }
  dependencyCoreDataId
  dependencyCoreDataType
  dependencySupplierProfileId
  dependencySupplierProfile {
    ...SupplierProfile
  }
  dependencyType
  isAll
}
fragment CoreData on core_data {
  id
  currency {
    id
    name
    code
  }
  customCoreDataOption {
    id
    name: value
  }
  department {
    id
    name
  }
  lineItemType {
    id
    name
  }
  paymentMethod {
    id
    name
  }
  paymentTerm {
    id
    name
  }
  subsidiary {
    id
    name
  }
  address {
    id
    name
    addressLine1
    addressLine2
    county
    state
    city
    postalCode
    country
  }
}
fragment SupplierProfile on organisation_supplier_profiles {
  id
  organisationSupplierId
  organisationSupplier {
    id
    name
  }
  subsidiaryId
  subsidiary {
    id
    name
  }
}
fragment OrganisationFxRate on organisation_fx_rates {
  id
  name
  code
  fxRate
  displaySymbol
  isVisible
  isArchived
  archivedBy
  remoteId
  updatedAt
  coreDataId
}`) as unknown as TypedDocumentString<GetOrganisationCurrenciesWithDependenciesQuery, GetOrganisationCurrenciesWithDependenciesQueryVariables>;
export const GetOrganisationSettingsByNameDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetOrganisationSettingsByName($settingName: String!) {
  organisation_settings(where: {name: {_eq: $settingName}}) {
    name
    value
  }
}
    `) as unknown as TypedDocumentString<GetOrganisationSettingsByNameQuery, GetOrganisationSettingsByNameQueryVariables>;